<template>
    <Attr :widget_id="widget_id" :attr_id="attr_id">
        <!-- IE 2026 09 07 / ODOO-337259: подсказка титула грида «ленивая» — контент при показе (Alt / Show tooltips) -->
        <div class="label-grid" 
            v-if="attr.title && !attr.hideTitle" 
            v-wjTooltipFn="tooltip"
            :for="attr.html_id"
        >
            {{ attr.title }}
        </div>

        <!-- IE 2026 10 13 / ODOO-5800 (Igor: правка ленивых списков вкладки с кнопкой Save над ними): грид ленивой вкладки с saveMethod и правками — полоса «Save (N)» / «Discard» (utils/gridSaveBar.js, флаг fe.ux.gridSaveBar) -->
        <div class="grid-save-bar" v-if="gridSave_showBar" role="status" @mousedown.stop @dblclick.stop>
            <span class="gsb-text"><i class="pi pi-pencil"></i> {{ tn(gridSave_count, '{n} unsaved row change', '{n} unsaved row changes') }}</span>
            <button type="button" class="gsb-btn gsb-save" :disabled="gridSave_saving || !gridSave_count" :title="t('Save the changed rows of this list')" @click.stop="gridSave_save"><i :class="gridSave_saving ? 'pi pi-spin pi-spinner' : 'pi pi-save'"></i> {{ t('Save ({n})', { n: gridSave_count }) }}</button>
            <button type="button" class="gsb-btn gsb-discard" :disabled="gridSave_saving" :title="t('Discard the changes and restore the loaded rows')" @click.stop="gridSave_discard">{{ t('Discard') }}</button>
        </div>

        <div class="grid-top-line" ref="attr_top_line" v-if="!attr?.hideCommandPanel"
        >
            <div class="commandPanel-area" ref="commandPanelArea"
                 :style="commandPanelAreaWidth != null ? { flex: '0 1 ' + commandPanelAreaWidth + 'px' } : (!commandPanel.length && !commandPanelOverflow.length ? { flex: '0 0 0', minWidth: '0', overflow: 'hidden' } : {})"
            >
                <div class="commandPanel-menu" v-if="commandPanel.length && commandPanelMaxVisible" ref="commandPanelMenu"
                    :style="commandPanelMenuWidth != null ? { flex: '0 0 ' + commandPanelMenuWidth + 'px' } : {}"
                >
                    <span v-for="(attrM, index) in commandPanel"
                        :key="attrM.html_id"
                        class="cp-item-wrap"
                        :class="[optionSeg_cls(index), sigPie_slot(attrM) ? 'sig-pie-slot' : null]"
                        v-show="index < commandPanelMaxVisible"
                    >
                        <component
                            :widget_id="widget_id"
                            :is="attrM.component"
                            :attr_id="attrM.id"
                            :initialAttr="attrM"
                        />
                        <!-- IE 2026 11 03 / ODOO-350449 (заказ Игоря: агрегат сигналов кругом в кнопке; проблемы подсказки в одну строку, клик — форма ячейки): круговая диаграмма-агрегат сигналов отчёта в кнопке «Сигнали» (вид «Сигнали» + форма «Кола»); место зарезервировано классом sig-pie-slot, подсказка — по Alt / Show tooltips -->
                        <span v-if="sigPie && sigPie_slot(attrM)" class="sig-pie" :style="{ background: sigPie.conic }" v-wjTooltipFn="sigPie_tip" @click.stop="sigPie_click($event)"></span>
                    </span>
                </div>
                <div class="widget_menu commandPanel-overflow-btn" v-if="commandPanelOverflow.length" v-uiHelp="'grid.commandPanel.overflow'">
                    <wj-menu
                        class="commandPanel-overflow-menu"
                        :header="''"
                        :displayMemberPath="'titleAction'"
                        :subItemsPath="'attrs'"
                        :showDropDownButton="false"
                        :openOnHover="true"
                        :isAnimated="false"
                        :itemsSource="commandPanelOverflow"
                        :itemClicked="menuNodeClicked"
                        :formatItem="store.formatMenuItem"
                    >
                        <i class="pi pi-ellipsis-v"></i>
                    </wj-menu>
                </div>
            </div>
            <!-- IE 2026 11 01 / ODOO-350449 (заказ Игоря: форма Стовпчики та Запас площею — T15): переключатель формы вида ячеек рядом с кнопками вида (Кола · Стовпчики · Площа); память виджета WIDGET._cellShape, в запись не пишется -->
            <!-- IE 2026 11 02 / ODOO-350449 (заказ Игоря: p189 єдиний вигляд полос перемикачів — заголовки, відступи, Alt-підказки пунктів): «Форма» — общим SegSwitch (размер sm для строки команд): заголовок полужирный по центру кнопок, Alt-подсказка у каждого пункта -->
            <SegSwitch v-if="cellShape_ui" class="cell-shape-switch" size="sm" :label="t('Shape')" label-help="grid.cellShape" :items="cellShape_ui" @pick="cellShape_click" />
            <!-- IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p183: перемикач «Рядки: Компактні / Високі» у таблиці REPORT2, як у Heatmap (grid)): высота строк рядом с «Форма» — там, где есть панель видов ячеек; память виджета WIDGET._gridRows, в запись не пишется (utils/gridRows.js, флаг fe.ux.gridRowsSwitch) -->
            <!-- IE 2026 11 02 / ODOO-350449 (заказ Игоря: p189 — «Рядки» одной квадратной кнопкой: нажата = високі, отжата = компактні): высота строк — одна квадратная кнопка-иконка (SegSwitch toggle) без заголовка; нажата = Tall, отжата = Compact; память та же (WIDGET._gridRows) -->
            <SegSwitch v-if="gridRows_ui" class="cell-shape-switch grid-rows-switch" size="sm" label-help="grid.gridRows" :items="gridRows_ui" :model-value="gridRows_tall" toggle
                @pick="gridRows_click(gridRows_tall ? 'compact' : 'tall')" />

            <!-- IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение) (слово Igor #104825): место хоста в строке команд — между панелью кнопок и чипсами (шахматка: «Показувати ▾»); без хоста — пусто -->
            <slot name="topLine"></slot>
            <div class="grid-chips" v-if="!get_viewParam('hideCHIPS')" v-uiHelp="'grid.chips'">
                <span class="p-float-label">
                    <!-- IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска): @live-search — набранный, ещё не оформленный текст полосы ищется живьём (onLiveSearch) -->
                    <AttrChips ref="chips"
                        :widget_id="widget_id"
                        :attr_id="attr_id"
                        :initialAttr="attr_id == null ? attr : null"
                        @update:modelValue="apply_CHIPS"
                        @chip-search-nav="onChipSearchNav"
                        @chip-metric-hover="onChipMetricHover"
                        @live-search="onLiveSearch"
                        :mode="'Embedded'"
                    ></AttrChips>
                </span>
            </div>

            <!-- IE 2026 08 19 / ODOO-5512 (заказ Игоря): панель ТЕГОВ под командной
                 панелью — словарь тегов сегмента (attr.tags_panel с бэка / хоста);
                 клик кладёт/снимает чипс CHIP-Tag, отбор — в списке чипсов -->
            <div class="grid-tags-panel" v-if="(attr.tags_panel || []).length && !get_viewParam('hideCHIPS')">
                <i class="pi pi-tag grid-tags-panel-icon"></i>
                <span v-for="tag in attr.tags_panel" :key="tag"
                    :class="['grid-tag', { 'grid-tag-active': tagsPanel_isActive(tag) }]"
                    @click.stop="tagsPanel_toggle(tag)" v-uiHelp="{ key: 'grid.tagsPanel.tag', state: () => (tagsPanel_isActive(tag) ? 'active' : '') }"
                >{{ tag }}</span>
            </div>

            <div class="grid-summary-line" v-if="get_viewParam('showGridSummaryLine')">
                <p v-html="currentSelectionHTML_base" v-wjTooltip="currentSelectionHTML" v-uiHelp="{ key: 'grid.summaryLine', after: () => summaryLine_helpTail() }"></p>
            </div>

            <div v-if="showFmTestDialog" style="position:absolute; inset:0; background:rgba(0,0,0,.25); z-index:1200; display:flex; align-items:flex-start; justify-content:center;" @click.self="showFmTestDialog=false">
                <!-- IE 2026 09 23 / ODOO-341407: i18n -->
                <div style="margin-top:60px; background:#fff; border-radius:6px; box-shadow:0 4px 24px rgba(0,0,0,.3); padding:16px 18px; min-width:360px;">
                    <div style="font-weight:600; margin-bottom:6px;">{{ t('Test fields mapping') }}</div>
                    <div style="font-size:12px; color:#667; margin-bottom:10px;">
                        {{ t('Evaluates and applies the values with the same algorithm as on widget open (rows flagged "On START" included), relative to the date below') }}
                    </div>
                    <div style="font-size:12px; margin-bottom:2px;">{{ t('Current date (UTC)') }}</div>
                    <input v-model="fmTestNow" spellcheck="false" style="width:100%; padding:4px 6px; font-family:monospace; border:1px solid #ccd; border-radius:4px;" />
                    <div style="font-size:13px; margin-top:4px;" v-html="store.formatDateHTML(fmTestNow)"></div>
                    <div style="display:flex; gap:8px; justify-content:flex-end; margin-top:14px;">
                        <button class="p-button p-component p-button-text" style="padding:4px 12px;" @click="showFmTestDialog=false">{{ t('Cancel') }}</button>
                        <button class="p-button p-component" style="padding:4px 12px;" @click="testFieldsMapping_Run">{{ t('Run test') }}</button>
                    </div>
                </div>
            </div>

            <!-- история Undo/Redo: список последних действий, клик = откат/повтор ДО выбранной точки -->
            <template v-if="historyMenu.show">
                <div class="history-menu-overlay" @click="historyMenu.show=false" @contextmenu.prevent="historyMenu.show=false"></div>
                <!-- IE 2026 09 23 / ODOO-341407: i18n -->
                <div class="history-menu" :style="historyMenu.style" @mouseleave="historyMenu.hover=-1">
                    <div class="history-menu-title">{{ historyMenu.mode==='undo' ? t('Undo history') : t('Redo history') }}</div>
                    <div v-for="(g, i) in historyMenu.items" :key="g.actionStack + '-' + i"
                        class="history-menu-item" :class="{ 'history-menu-item-hl': i <= historyMenu.hover }"
                        @mouseenter="historyMenu.hover = i"
                        @click="historyApply(i)"
                    >
                        <span class="history-menu-num">{{ i + 1 }}</span>
                        <span class="history-menu-label">{{ g.label }}</span>
                    </div>
                    <div class="history-menu-hint">
                        {{ historyMenu.hover >= 0 ? (historyMenu.mode === 'undo' ? tn(historyMenu.hover + 1, 'Undo {n} action', 'Undo {n} actions') : tn(historyMenu.hover + 1, 'Redo {n} action', 'Redo {n} actions')) : t('Click an action to revert to that point') }}
                    </div>
                </div>
            </template>

            <div class="grid-commandPanel-top-right widget-commandPanel-2" v-show="show_commandPanel_topLeft" @mouseenter="onShow_commandPanel_topLeft" @mouseleave="onClose_commandPanel_topLeft" style="top: 100%; right: 0;">
                <div :style="commandPanel_topLeft_scrollStyle">
                    <!-- IE 2026 11 04 / ODOO-350449 (заказ Игоря: форма ⚙ по наведению — в стиле вкладки Display): группы с заголовком, взаимоисключающие кнопки — одной сегментной группой,
                         переключатели — «подпись — Off | On», числа — подпись слева, поле справа (раскладка utils/gearFormLayout.js, команды те же); выкл fe.ux.gearFormStyle — прежний вид -->
                    <div v-if="gearForm_on()" class="gear-form-v2" data-gear-form="1">
                        <div v-for="g in gearForm_sections" :key="'gf-' + g.group" class="do-group" :data-gf-group="g.group">
                            <div class="do-group-title">{{ t(g.group) }}</div>
                            <!-- IE 2026 11 04 / ODOO-350449 (поправка Игоря: булевы в форме ⚙ — снова кнопкой-тумблером, перечисления — группой): переключатели группы — прежними кнопками (тот же компонент команды, нажатая = включено) одним рядом с переносом -->
                            <div v-for="it in g.items" :key="it.key" class="do-row" :class="'gf-' + it.kind" :data-gf-param="gearForm_params(it)">
                                <SegSwitch v-if="it.kind === 'seg'" size="sm" :label="it.label" :label-help="it.help" :items="gearForm_items(it)"
                                    :model-value="gearForm_value(it)" @pick="(k, ev) => gearForm_pick(it, k, ev)" />
                                <template v-else-if="it.kind === 'toggles'">
                                    <component v-for="attrM in it.cmds" :key="attrM.html_id" :widget_id="widget_id" :is="attrM.component" :attr_id="attrM.id" :initialAttr="attrM" />
                                </template>
                                <template v-else-if="it.kind === 'num'">
                                    <span class="gf-label" v-uiHelp="it.help || null">{{ it.label }}</span>
                                    <component :key="it.cmds[0].html_id" :widget_id="widget_id" :is="it.cmds[0].component" :attr_id="it.cmds[0].id" :initialAttr="it.cmds[0]" />
                                </template>
                                <template v-else>
                                    <component v-for="attrM in it.cmds" :key="attrM.html_id" :widget_id="widget_id" :is="attrM.component" :attr_id="attrM.id" :initialAttr="attrM" />
                                </template>
                            </div>
                        </div>
                    </div>
                    <div v-else class="ml-1">
                        <div class="widget-commandPanel-row mb-2" v-for="(row, rowIndex) in commandPanel_topLeft"
                            :key="'row-' + rowIndex"
                        >
                            <component v-for="attrM in row"
                                :key="attrM.html_id"
                                :widget_id="widget_id"
                                :is="attrM.component"
                                :attr_id="attrM.id"
                                :initialAttr="attrM"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <!-- IE 2026 09 29 / ODOO-343342 (заказ Игоря: форма ячейки по 🏷): кнопка 🏷 формы ячейки — в угловом островке справа в строке команд (как у графика и карты); шеврон в ячейке скрыт (fe.ux.cellFormTagBtn) 
                 IE 2026 09 30 / ODOO-343342 (заказ Игоря: 🏷 слева в группе кнопок, как на графике): первая (левая) кнопка группы 🏷 ⚙ ≡ — порядок как у графика; прижатие вправо (menu-push-right) — на ней -->
            <div class="corner-island grid-cellform-island" :class="{ 'menu-push-right': menuPushRight() }" v-if="cellFormTag_show()">
                <div class="button-lt cellform-tag-btn p-2" :class="{ 'cellform-tag-btn-on': cellFormTag_open(), 'p-button-active': cellFormTag_open(), 'cellform-tag-btn-off': cellFormTag_off() }"
                    v-wjTooltip="cellFormTag_here() ? t('Close the cell form (F4)') : t('Cell form — F4')" @mousedown.prevent @click="cellFormTag_click"
                    v-uiHelp="{ key: 'grid.cellFormTagBtn', state: () => (cellFormTag_open() ? 'open' : 'closed') }">
                    <i class="pi pi-tags"/>
                </div><!-- IE 2026 10 12 / ODOO-343342 (заказ Игоря: форма ячейки по 🏷): нажатая 🏷 (форма этого грида открыта) — класс p-button-active (App.vue, янтарная заливка), как у нажатой кнопки шапки виджета «Hide empty rows» (≠ с бейджем) -->
            </div>
            <!-- IE 2026 09 23 / ODOO-341407: i18n -->
            <!-- IE 2026 09 28 / ODOO-342342 (заказ Игоря: «"меню" — прижато вправо»): ⚙ и ≡ — у правого края строки и без чипсов (Hide filter chips): прижимается первый из них
                 (margin-left: auto — класс menu-push-right, стиль в MenuPanel.vue); флаг fe.ux.menuPanelEverywhere (utils/menuPanelHost.js) -->
            <div class="button-1 p-2" ref="cogButton" v-if="!attr?.hideGridSettings" :class="{ 'menu-push-right': menuPushRight() && !cellFormTag_show() }" v-wjTooltip="t('View params (Alt F1)')" @click="onToggle_gridSettings" v-uiHelp="'grid.viewParams.cog'" @mouseenter="onShow_commandPanel_topLeft" @mouseleave="onClose_commandPanel_topLeft">
                <i class="pi pi-cog"/>
            </div>
    
            <div class="widget_menu mr-2" :class="{ 'menu-push-right': menuPushRight() && !!attr?.hideGridSettings && !cellFormTag_show() }" @click.capture="mobileActionMenuTap"><!-- IE 2026 09 28 / ODOO-342342: без ⚙ прижимается сам ≡ -->
                <!-- IE 2026 09 22 / ODOO-… (предложение Игоря, шаг 2): ≡ таблицы — панель функций в стиле 1С (components/MenuPanel.vue); прежнее wj-menu — мобильный профиль / выключатель fe.ux.menuPanelGrid -->
                <!-- IE 2026 09 22 (заказ Игоря, п.4): поиск, звёзды и «только избранные»; избранные — личные, в привязке к сегменту виджета (уточнение Игоря) -->
                <!-- IE 2026 09 23 / ODOO-341407: i18n -->
                <!-- IE 2026 09 24 / ODOO-… (заказ Игоря: заголовок панелей-меню): ряд «Table menu · заголовок виджета (· заголовок грида)» (иконка ряда — pi-bars, как у кнопки) -->
                <!-- IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt): help — вид панели для объяснений элементов по Alt (utils/uiHelp/menuPanel.js) -->
                <MenuPanel v-if="actionMenu.length && store.menuPanel_on('Grid')" :items="actionMenu" align="right" :caret="false" btnClass="widget-menu-btn grid-menu-btn" :title="t('Table menu')" titleIcon="pi pi-bars" :subtitle="menuPanelSubtitle()"
                    :openDelay="200" :runsTitle="t('Table')" search :searchPlaceholder="t('Search commands…')" :favKey="menuFavKind()" :favOf="menuFavOf" :epoch="store._favEpoch"
                    :favTitle="t('Favourite command (for tables of widgets of this segment)')" help="grid" @pick="menuPanelPick" @fav="menuFav">
                    <template #trigger><i class="pi pi-bars pi-bold"></i></template>
                </MenuPanel>
                <wj-menu id="actionMenuId" :displayMemberPath="'titleAction'" :subItemsPath="'attrs'" :showDropDownButton="false"
                    v-else-if="actionMenu.length"
                    :openOnHover="!store.mobileUi?.on" :isAnimated="false" :itemsSource="actionMenu" :initialized="initMenu" :itemClicked="menuNodeClicked" :formatItem="store.formatMenuItem"
                >
                    <i class="pi pi-bars pi-bold"></i>
                </wj-menu>
            </div>
        </div>

        <div :class="gridClass" :style="gridStyle" ref="attr_container" tabindex="0">
            <!-- IE 2026 09 23 / ODOO-341407: i18n -->
            <wj-group-panel v-if="false && get_viewParam('showGroupPanel')" :placeholder="t('Drag columns here to create groups')" :initialized="groupPanelInitialized"/>
            <!-- IE 2026 09 07 / ODOO-337259: подсказка грида «ленивая» — контент при показе (Alt / Show tooltips) -->
            <wj-flex-grid
                :id="attr.html_id"
                :class="'my-grid attr-grid-input '+attr.cssClass||''"
                v-wjContextMenu="'contextMenuId'+attr.html_id"
                v-wjTooltipFn="() => attr.tooltip"
                v-visible="handleVisibility"
                v-if="visibility"
                
                :initialized="initialized"
                :formatItem="formatItem_fast"
                :autoGenerateColumns="false"
                :headersVisibility="headersVisibility_eff()"
                
                :rowAdded="rowAdded"
                :pasting="pasting"
                :copying="copying"
                :pastingCell="pastingCell"
                :pastedCell="pastedCell"
                :pasted="pasted"
                :columnGroupCollapsedChanged="columnGroupCollapsedChanged"
                :groupCollapsedChanged="groupCollapsedChanged"

                :refreshing="refreshing"
                :refreshed="refreshed"
                :scrollPositionChanged="scrollPositionChanged"
                
                :updatingView="updatingView"
                :updatedView="updatedView"
                :updatingLayout="updatingLayout"
                :updatedLayout="updatedLayout"
                
                :beginningEdit="beginningEdit"
                :prepareCellForEdit="prepareCellForEdit"
                :cellEditEnding="cellEditEnding"
                :cellEditEnded="cellEditEnded"
                
                :rowEditEnding="rowEditEnding"
                :rowEditEnded="rowEditEnded"

                :allowMerging="'Cells'"

                :allowSorting="get_viewParam('allowSorting', store.setting('fe.grid.allowSorting', 'SingleColumn'))"
                :allowDragging="'Columns'"

                :itemsSourceChanged="itemsSourceChanged"
                :selectionChanging="selectionChanging"
                :selectionChanged="selectionChanged"

                :draggingColumn="draggingColumn"
                
                :showSort="true"
                :allowPinning="get_viewParam('allowPinning','None')"
                :isTabHolderVisible="false"
                @click="execute_click"
                @dblclick="execute_dblclick"
                :showMarquee="!attr.hideMarquee"
                :showSelectedHeaders="'All'"
                :sortedColumn="sortedColumn"
                :sortingColumn="sortingColumn"

                :allowResizing="get_viewParam('allowResizing','Both')"
                :resizedColumn="resizedColumn"
                :resizedRow="resizedRow"

                :cloneFrozenCells="true"
                :frozenRows="store.mobileUi?.on ? 0 : (attr.frozenRows || 0)"
                :frozenColumns="frozenColumns_safe ?? (attr.frozenColumns || 0)"
            >

                <wj-flex-grid-filter v-if="get_viewParam('showFilter', true)"
                    :initialized="filterInitialized"
                    :filterChanged="filterChanged"
                />
            </wj-flex-grid>

            <wj-menu
                style="display: none"
                dropDownCssClass="ctx-menu"
                :initialized="gp_initializedMenu"
                :itemClicked="gp_itemClicked" >
                <!-- IE 2026 09 23 / ODOO-341407: i18n -->
                <wj-menu-item>
                    <span class='wj-glyph-down-right'></span> {{ t('Expand All') }}
                </wj-menu-item>
                <wj-menu-item>
                    <span class='wj-glyph-right'></span> {{ t('Collapse All') }}
                </wj-menu-item>
            </wj-menu>
            <!-- IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк): меню правой кнопки по заголовку колонки / строке-группе — панель MenuPanel без видимой кнопки (обёртка display:none), открывается show({at}) у точки клика; панель телепортируется в body -->
            <span v-if="ctxMenuPop.items.length" style="display:none"><MenuPanel ref="ctxMenuPanel" :items="ctxMenuPop.items" :hover="false" :caret="false" btnClass="grid-ctx-menu-btn" :title="ctxMenuPop.title" :titleIcon="ctxMenuPop.icon" :subtitle="ctxMenuPop.subtitle" help="grid" @pick="ctxMenu_pick" @close="ctxMenu_closed"/></span>
        </div>

        <!-- IE 2026 10 25 / ODOO-348925 (заказ Игоря: цвета как на слайде — редактор цвета ColorPicker): ячейка колонки editor 'color' в правке — палитра PrimeVue ColorPicker под ячейкой; mousedown.prevent — фокус остаётся
             в редакторе wijmo (ручной ввод hex, Enter — записать, Esc — отменить); выбор пишет '#RRGGBB' в редактор, «Apply» — записать, «No colour» — очистить. Объяснение — по Alt / Show tooltips -->
        <Teleport v-if="colorEd.open" :to="colorEd.portal || 'body'">
            <div ref="colorPop" class="grid-color-pop" :style="{ left: colorEd.left + 'px', top: colorEd.top + 'px' }" @mousedown.prevent.stop @pointerdown.stop @click.stop v-uiHelp="'grid.colorEditor'">
                <ColorPicker :modelValue="colorEd.picker" @update:modelValue="colorEd_pick" :inline="true" format="hex" />
                <div class="grid-color-pop-bar">
                    <span class="grid-color-pop-sw" :class="{ 'is-empty': !colorEd.hex, 'is-light': colorEd.light }" :style="colorEd.hex ? { background: colorEd.hex } : null"></span>
                    <span class="grid-color-pop-hex" :class="{ 'is-invalid': colorEd.invalid }">{{ colorEd.invalid ? t('Not a colour code - use #RRGGBB') : (colorEd.hex || t('No colour')) }}</span>
                </div>
                <div class="grid-color-pop-btns">
                    <button type="button" class="grid-color-pop-btn" @click="colorEd_clear">{{ t('No colour') }}</button>
                    <button type="button" class="grid-color-pop-btn is-main" @click="colorEd_apply">{{ t('Apply') }}</button>
                </div>
            </div>
        </Teleport>

        <wj-color-picker style="display:none;position:fixed;z-index:100" :initialized="colorPickerInit">
        </wj-color-picker>

        <wj-combo-box style="display:none;position:fixed;z-index:100" :isEditable="true" :isRequired="false" :initialized="rowStyleComboInit">
        </wj-combo-box>

    </Attr>
</template>

<script>
import { useMainStore } from '@/stores/mainStore'
import { overlayRoot } from '@/utils/overlayRoot'   // IE 2026 09 23 / ODOO-… (замечание Игоря: панели-меню в Full screen): корень оверлеев — полноэкранный виджет либо body
import { cellPie_bindingOf, CELL_PIE_FLAG } from '@/utils/cellPie'   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: кругові діаграми за статусами у клітинках REPORT2, опції зрізу і їх розміщення)
import { cellRing_build, cellRing_scale, cellRing_scaleGroup, cellRing_signalsOf, cellRing_flagOn } from '@/utils/cellRing'   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T1): единый рендер круга ячейки
import { cellView_activeOf, cellView_flagOn, cellView_get, cellView_layersOf, cellView_tipHtml, cellView_statsOf, cellView_paletteOf, cellView_emptyNoteAt, cellView_emptyTipHtml } from '@/utils/cellViews'   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T1): регистр режимов вида ячеек
import { SIGNALS_VIEW, SIGNALS_FLAG, SIGNALS_EMPTY_FLAG, signals_suppress } from '@/utils/cellViews/signals'   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p198 вид «Сигнали» — проблемні сигнали шарами кола, фон лише від lead time / циклу поповнення / зон запасу)
import { SIGNAL_TIP_SKIP_MARKS, signalTip_on, signalTip_rows, signalTip_pick, signalTip_focusOf, signalTip_html } from '@/utils/signalTipProblems'
import { SIGNALS_PIE_FLAG, TIP_ONE_LINE_FLAG, TIP_INSTANT_FLAG, signalsAgg_flagOn, signalsAgg_count, signalsAgg_model, signalsAgg_tipHtml, signalsAgg_isTruncated, signalTip_signalRows, signalTip_mergeRows, signalTip_cacheFor, signalTip_cacheKey, signalTip_noteOf, SIGNALS_PIE_CACHED_FLAG, signalsAgg_scan, signalsAgg_idle } from '@/utils/signalsAggregate'   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: агрегат сигналов кругом в кнопке; проблемы подсказки в одну строку, клик — форма ячейки)   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p231 підказка по сигналу — проблема як у формі комірки)
import { SIGNAL_CHAINS_METHOD, PREFETCH_PORTION, PREFETCH_BUDGET_MS, PREFETCH_DEBOUNCE_MS, PREFETCH_IDLE_TIMEOUT_MS, PREFETCH_BUSY_RETRY_MS, PREFETCH_ERRORS_OFF, sigPrefetch_flagOn, sigPrefetch_stat, sigPrefetch_statPortion, sigPrefetch_cap, sigPrefetch_rangeCells, sigPrefetch_nextPortion, sigPrefetch_requeue, sigPrefetch_pending, sigPrefetch_inBatch, sigTip_stableVerOn, sigTip_verNext, sigPrefetch_cellOf, sigPrefetch_mark, sigPrefetch_release, sigPrefetch_answerOf, sigPrefetch_merge, sigPrefetch_mayStart, sigPrefetch_off, sigPrefetch_isOff } from '@/utils/signalChainsPrefetch'   // IE 2026 11 03 / ODOO-350449 (Игорь: предзагрузка цепочек сигналов; BE ie-dm7 #1009)   // IE 2026 11 03 / ODOO-350449 (ie-dm7 #128809, проба p250: порция 8, повтор truncated, дефолт ВЫКЛ, без ожидания пакета)
import { sigPrefetch_adaptiveOn, sigPrefetch_portionSize, sigPrefetch_adaptPortion, sigPrefetch_statAdapt } from '@/utils/signalChainsPrefetch'   // IE 2026 11 04 / ODOO-350449 (webscm #129836: адаптивная порция предзагрузки по времени бэка на ячейку)
import { readLight_fields } from '@/utils/readMethodLight'   // IE 2026 11 03 / ODOO-350449 (ie-dm7 #128926: порции 15, бюджет 5 с, группы только по Alt, лёгкий запрос)
import { STOCK_CELLS_METHOD, STOCK_PORTION, STOCK_BUDGET_MS, STOCK_DEBOUNCE_MS, STOCK_RETRY_MAX, STOCK_ERRORS_OFF, STOCK_MEMO_MAX, stockCells_fe, stockCells_stat, stockCells_off, stockCells_isOff, stockCells_opts, stockCells_fields, stockCells_params, stockCells_answerOf, stockCells_merge, stockRows_index, stockRows_portion, stockCell_layer, stockCell_key, stockCell_tip, stockRow_scale, stock_prevMonth, STATS as STOCK_STATS } from '@/utils/stockCells'   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: виды ячеек запаса под ключ — Z5 по умолчанию; BE ie-dm7 stock_cells_batch)   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: виды ячеек запаса — общая шкала строки)   // IE 2026 11 03 / ODOO-350449 (проба p259: стык после дефицита — сброс к 0 пунктиром): stock_prevMonth
import { SIGNAL_TIP_DOC_SHARED_FLAG, signalTipDoc_register } from '@/utils/signalTipDoc'   // IE 2026 11 03 / ODOO-350449 (webscm #128539: одна пара слушателей document на все гриды)
import { story_chains, story_verdict } from '@/utils/cellStory'   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p231 підказка по сигналу — проблема як у формі комірки)
import { UNC_HEADERS_FLAG, UNC_TITLE_CLASS, uncHeaders_suppress, uncBlock_titleIs } from '@/utils/uncoveredHeaders'   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p205 заголовки рядків блоку «Непокрито» без червоної заливки — менше сигналів)
import { parentHide_mode, parentHide_isRow, rowTotal_is, rowTotals_signalsOn } from '@/utils/gridRowHide'   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p201 баланс — «Сигнали» типово, розкритий батьківський рядок без підсумків і сигналів (hover показує), підсумок рядка без сигналів — опція)
import { STATUS_ZONES_VIEW } from '@/utils/cellViews/statusZones'   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T1)
import { cellBars_build, cellBars_sig, cellBars_html } from '@/utils/cellBars'   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: форма Стовпчики та Запас площею — T15): столбики слоёв
import { pieGaps_on } from '@/utils/pieGaps'   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p211 контрастні кольори категорій і білий роздільник між секторами кіл)
import { cellChart_fillOn } from '@/utils/cellRing'   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p190 діаграми в клітинках — на всю висоту рядка, компактні й високі)
import { cellArea_isStockRow, cellArea_values, cellArea_rowMax, cellArea_neighbors, cellArea_zoneColor, cellArea_segment, cellArea_svg } from '@/utils/cellArea'   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: форма Стовпчики та Запас площею — T15): площадь запаса
import { cellArea_segmentOC, cellArea_openCloseOn } from '@/utils/cellArea'   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p208 форма «Площа» — від запасу на початок періоду до запасу на кінець, стик між комірками)
import { cellShape_resolve, cellShape_flags, cellShape_parse, cellShape_panelOf, cellShape_next, cellShape_available, CELL_SHAPE_TITLES } from '@/utils/cellShape'   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: форма Стовпчики та Запас площею — T15)
import { cellPie_isViewButton } from '@/utils/cellPie'   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p183: перемикач «Рядки: Компактні / Високі» у таблиці REPORT2, як у Heatmap (grid)): панель видов ячеек — и прежние кнопки status_pie
import { GRID_ROWS, GRID_TALL_ROW_H, gridRows_flagOn, gridRows_syncState, gridRows_norm, gridRows_height, gridRows_scrollY } from '@/utils/gridRows'   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p183: перемикач «Рядки: Компактні / Високі» у таблиці REPORT2, як у Heatmap (grid))
import { gridRows_anchorFlagOn, gridRows_anchorPick, gridRows_anchorScrollY } from '@/utils/gridRows'   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p197 перемикач «Рядки» — зберегти виділення і якір прокрутки на центрі виділеної клітинки)
import { gridRows_rowHeight } from '@/utils/gridRows'   // IE 2026 11 02 / ODOO-350449 (сводна перевірка main на dev02: p199 — якір при scroll 0, повернення висоти рядків, перемалювання колонок «Всього», Alt-підказка «Рядки»)
import { gridRows_initial } from '@/utils/gridRows'   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p201 — «Рядки» натиснута типово: високі рядки в звіті з видами комірок)
import { yearTotalsButton_on, yearTotals_plan, yearTotals_want } from '@/utils/yearTotals'   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p217 кнопка Σ — річні підсумки за опцією, типово вимкнено)
import { sigmaSteady_on, yearTotals_hasMerge } from '@/utils/yearTotals'   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p233 Σ не смикає панель команд)
import { yearTotalsMuted_on, yearTotal_cellMode, YEAR_TOTAL_MODE_CLASSES, yearTotal_modeClasses, yearTotal_mutedWidth, yearTotal_dates, yearTotal_opening, yearTotal_valueAt, yearTotal_areaArgs, yearTotal_uncIs } from '@/utils/yearTotals'   // IE 2026 11 02 / ODOO-350449 (дополнение Игоря к p217, вариант 1: развёрнутый год — приглушённый итог, свёрнутый — остаток на начало года)
import { autoSizeRows_rowH } from '@/utils/gridAutoSizeRows'   // IE 2026 11 02 / ODOO-350449 (сводна перевірка main на dev02: p199 — якір при scroll 0, повернення висоти рядків, перемалювання колонок «Всього», Alt-підказка «Рядки»)
import { stickyGroupScrolled_on, stickyGroup_scrolledChain } from '@/utils/stickyGroupScrolled'   // IE 2026 11 02 / ODOO-349799 (sticky-group) (замечание Игоря по dev02, «Конфігурація»): полоса группы — только когда строка группы ушла за верхний край (fe.ux.gridStickyGroupOnlyScrolled)
import { cellViewBtn_is, cellViewBtn_id } from '@/utils/cellViewState'   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: форма Стовпчики та Запас площею — T15): shape кнопки активного вида
import { cellViewBtn_variant } from '@/utils/cellViewState'
import { optionSeg_on, optionSeg_classes } from '@/utils/cellViewState'   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p191 — опції виглядів однією склеєною групою кнопок, як «Міра» теплокарти)   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by)
import { composition_splitByOf } from '@/utils/cellViews/composition'   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by)
import { t, tn } from '@/i18n'   // IE 2026 09 23 / ODOO-341407: i18n — словарь UI-строк (t / tn)
import { copyExcel_table, copyExcel_fromClip, copyExcel_toggleGet, copyExcel_toggleSet, copyExcel_memoSet, copyExcel_count } from '@/utils/copyExcel'   // IE 2026 10 02 / ODOO-5800 (заказ Игоря: копирование в Excel for Mac с заливкой — HTML-исходник в text/plain)
import { story_refsApply } from '@/utils/cellStory'   // IE 2026 10 04 / ODOO-5800 (fe-78)
import { gho_extent, gho_clipRight } from '@/utils/groupHeaderOverflow'   // IE 2026 10 12 / ODOO-335099 (заказ Андрея через dm #72941, RP1): заголовок группы перетекает через границу закреплённых колонок
import { DOC_STATUS_WAIT_FLAG, cellDocs_cellStatuses, cellDocs_preStatus, cellDocs_wait, cellDocs_restore, SAMEDOC_SKIP_REGISTER_FLAG, cellDocs_qtyCheck, cellDocs_rowQty } from '@/utils/cellDocs'   // IE 2026 10 05 / ODOO-5800 (fe-83): статус документов формы ячейки по строкам ЭТОЙ ячейки, без мигания до ответа паспорта
import { story_normalize, story_mockPick, story_mockResolve, story_compareWith } from '@/utils/cellStory'   // IE 2026 10 01 / ODOO-5800 (пакет G): story формы ячейки — проблема → причина → решение → деньги; story_compareWith — колонка «с решением» как compare_with бэка
import { story_isCritical, story_criticalCmp, story_criticalOn, story_mismatchOfFormula, story_stockCheck, story_rowNodes, story_isCompareRow, story_formulaLeaves } from '@/utils/cellStory'   // IE 2026 10 05 / ODOO-5800 (fe-84): + story_isCompareRow / story_formulaLeaves — формула остатка не зависит от режима сравнения   // IE 2026 10 03 / ODOO-5800 (fe-51): + story_rowNodes — узлы строки без memo-строк   // IE 2026 10 03 / ODOO-5800 (заказ Игоря: «Показать критич ош если небьется расчетный запас с фактич»): оценка critical — свой вид ячейки сетки (METRIC_CRIT_CLASS); story_stockCheck — допуск и выключатель бэка (story.stock_check, CONTRACT v4 §4)
import { COMPARE_ROW_TYPE_BINDING, rowType_label, compareNav_targetsOf, compare_kidsWithHidden, compare_hiddenRowsOf } from '@/utils/compareRows'   // IE 2026 10 05 / ODOO-5800 (fe-87): служебные строки в режимах сравнения   // IE 2026 10 06 / ODOO-5800: + compare_kidsWithHidden, compare_hiddenRowsOf (формула остатка: спрятанные «Differences only» слагаемые)
import { durUnit } from '@/utils/durationText'   // IE 2026 09 24 / ODOO-341407: единицы длительности под язык интерфейса (бейдж дельты дат «+1 р 2 міс»)
import { clipOverlay_show, clipOverlay_textRanges } from '@/utils/clipOverlay'   // IE 2026 09 18 / ODOO-… (замечание Игоря): «продолжение» обрезанного текста — пиксель в пиксель
import { cellPeek_on, cellPeek_truncated, cellPeek_layers } from '@/utils/cellPeek'   // IE 2026 11 04 / ODOO-350449 (замечание Игоря: продолжение ячейки при наведении — только при обрезке и не поверх содержимого)
import { adf_on, adf_block, adf_againstOf, adf_viewOf, adf_index, adf_badgeText, adf_tipText, adf_resizedText, adf_tabRowsHidden, adf_tableRowsHidden, adf_attrPath, adf_tabSteps, adf_hiddenText, adf_i18nHiddenText, ADF_FIELD_NODESCEND, ADF_VIEW_KEY, cm_on, cm_rowTarget, cm_targetOf, cm_pointerEvt, adf_targetKey, CM_ROWS_BINDING } from '@/utils/auditDiff'   // IE 2026 10 31 / ODOO-349799 (PR3): связь строк «Changes» и формы   // IE 2026 10 31 / ODOO-349799: путь к вкладкам цели, «поле скрыто»   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: подсветка изменений записи из аудита)
import { jsonFieldValue_parse } from '@/utils/jsonFieldValue'   // IE 2026 10 24 / ODOO-348823: значение JSON-поля строкой JSON — разобрать, не обходить по символам
import altTooltip from '@/utils/altTooltip' // IE 2026 09 07 / ODOO-337259: зажатый Alt — подсказка ячейки по запросу (cellTooltip)
import { mergeBackHoverCol, mergeBackIsShifted, mergeBackTipHtml } from '@/utils/mergeBackHover'   // IE 2026 10 26 / ODOO-5800 (заказ Игоря 26.10: сдвинутая влево ячейка субъекта — подсветка заголовка исходной колонки и подсказка)
import uiHelp, { uiHelp_rowsHtml, uiHelp_recordRowsHtml, uiHelp_enabled, uiHelp_entry, uiHelp_html, escHtml } from '@/utils/uiHelp'   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U1: ссылочная ячейка — строки объяснения (что это, как открыть) и объяснение записи; · U5: uiHelp (default) — bind / unbind бейджей свёртки и пункта меню «выбрать все»; uiHelp_html — объяснения элементов в ячейках (стрелка формы, кнопка и флажки заголовков строк); uiHelp_entry / escHtml — строка «Marks»
import { tipActions_html, tipActions_bind, recordActions } from '@/utils/tipActions'   // IE 2026 09 23 / ODOO-… (заказ Игоря: кнопки в подсказках): кнопки в подсказке ссылочной ячейки
import recordHelp from '@/utils/recordHelp'   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2: «Edit description» в подсказке ячейки-ссылки (админ)
import { dictVisibleOnly_on, inHiddenTab, tabsLazy_count } from '@/utils/tabsLazy'   // IE 2026 09 26 / ODOO-5800: префетч словарей только у грида видимой вкладки
import { gridText_tags, gridText_labelWidthChars, gridText_tabGridD5 } from '@/utils/gridText'   // IE 2026 09 28 / ODOO-342342 (приёмка Д2, Д5): теги списка текстом, ширина подписей формы; IE 2026 09 29 / ODOO-342342 (ревью п.2): Д5 — только форма кейса
import { formatMarkDetail, markLineText } from '@/utils/cellMarkLine'   // IE 2026 10 31 / ODOO-5800 (заказ Игоря: Alt-довідка в одноколонковій формі): метка «Formatting» — только у сработавшего правила; строка метки — состояние и подробность без объяснения
import { sigRow_refTitle, sigNames_fromRules, sigRow_causeDetail, sigCell_setCauseDetail, sigCell_holdCauseDetail, sigCell_causeDetailPlan, CAUSE_DETAIL_KEY } from '@/utils/signalModel'   // IE 2026 10 04 / ODOO-5800 (fe-78): модель сигналов v2 — ссылочные поля строки грида сигналов, названия записей для формы ячейки
import { tagIds_isScalar, tagIds_segment, tagIds_linkAttr, tagIds_title, tagIds_label, tagIds_key, tagIds_text, tagIds_commit, tagIds_remove, tagIds_add } from '@/utils/tagIds'   // IE 2026 10 05 / ODOO-5800 (fe-80): поле-список id записей (AttrTags + relation_segment)
import { cellChips_lastVisible, cellChips_bindOnce } from '@/utils/cellChips'   // IE 2026 10 15 / ODOO-5512: Backspace in the chip input = ⊗ on the last visible chip; chip input handlers on both formatItem paths
import { dl2_cellBlank, dl2_hookGetCellData } from '@/utils/dl2CellBlank'
import { planLevels_on, planCell_classes, planCell_applyClasses, planHeader_class, planHeader_applyClass, planChips_of, planCell_hint } from '@/utils/planLevels'   // IE 2026 10 18 / ODOO-5800 (Igor, п. 5: отчёты планов по уровням): маркер ручной корректировки, классы статуса / горизонта, чипы статуса по горизонтам (fe.ux.planLevels)
import { planApproval_titleResolver, planApproval_confirmLabels } from '@/utils/planApproval'   // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239)
import { planApproval_summaryCacheOn, planApproval_gridKey, planApproval_versionOf, planApproval_summaryKey, planApproval_cacheGet, planApproval_cachePut, planApproval_cacheDrop, planApproval_stat } from '@/utils/planApproval'   // IE 2026 11 04 / ODOO-5800 (проба p269: Esc закрывает меню, а не виджет; лёгкий запрос сводки)
import { planApproval_on, planApproval_menu, planApproval_summary, planApproval_scopeObjects, planApproval_objectsOfRows, planApproval_hasPlanRows, planApproval_flatRows, planApproval_unitTitle, planApproval_pairs, planApproval_whereSegment, planApproval_rowState, planApproval_rowDecision, planApproval_errorText, planApproval_pillHtml, planApproval_historyUnits, planApproval_decide, planApproval_call, METHODS as PLAN_APPROVAL_METHODS, REASON_SEGMENT as PLAN_DECISION_REASON } from '@/utils/planApproval'   // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B)   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128436: этап C бэка — пилюля по decision_state, by_key, названия, отказ целиком)   // IE 2026 11 03 / ODOO-5800 (webscm #128539: кнопки нет у дерева с группами сверху): planApproval_flatRows   // IE 2026 11 03 / ODOO-5800 (проба p244: planApproval_unitTitle, planApproval_pairs)
import { ruleApproval_on, ruleApproval_listEnabled, ruleApproval_target, ruleApproval_sig, ruleApproval_state, ruleApproval_visible, ruleApproval_merge, ruleApproval_statusRecs, ruleApproval_menu, ruleApproval_pillHtml, ruleApproval_pillColIndex, ruleApproval_pillTip, ruleApproval_validate, ruleApproval_action, ruleApproval_onWrite, ruleApproval_call, ruleApproval_historyUnits, ruleApproval_isMap, METHODS as RULE_APPROVAL_METHODS, STATUS_SEGMENT as RULE_STATUS_SEGMENT, LIMIT as RULE_APPROVAL_LIMIT } from '@/utils/ruleApproval'   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128579: согласование правил MAP-*, этап C); IE 2026 11 03 / ODOO-5800 (ie-dm7 #128579: согласование правил MAP-*, этап C — правки пробы p246): ruleApproval_pillColIndex
import { m03FlagSteps, m03FlagLiveDecision } from '@/utils/m03FlagsLocal'   // IE 2026 10 18 / ODOO-5800 (Igor, M03 на схеме флажками без политики): шаги ПМ → БЮМ → МД по колонкам грида, флаг fe.ux.m03FlagsLocal
import { planFlags_on, planFlagField, planFlagPartial, planFlagCascadeTargets } from '@/utils/planFlags'   // IE 2026 10 19 / ODOO-5800 (plan flags, Igor 19.10): булевы флажки уровней планов KAM / PM / BUM / MD — живой итог группы по листьям поддерева, каскад клика по группе на листья (fe.ux.planFlags)
import { copyMerged_cell, copyMerged_matrix, copyMerged_trim } from '@/utils/copyMerged'   // IE 2026 10 16 / ODOO-5800 (Igor: Cmd+C по объединённой ячейке — пустой буфер; trim текста ячеек)
import { m03FlagsLocalOn, m03CascadeOn, m03CascadeOrderOn, m03FlagBindings, m03LowerBindings, m03UpperBindings, m03CascadeDims, m03CascadeTargets, m03FlagTrue, m03CellLocked, m03AggregateOrder, m03AggregateOrderText } from '@/utils/m03Flags'   // IE 2026 10 18 / ODOO-5800 (Igor, п. 3–4): M03 без политики — колонки флажков по полям ApprovedPM/BUM/MD (живой итог «частично / все ✓» как 14.10) и каскад флажка БЮМ / МД по измерениям строки (fe.ux.m03FlagsLocal)
import { approvalFlagPartialOn, approvalFlagPartial, approvalPartialCellTip, approvalFlagPartialTip, approvalFlagPartialLiveOn, approvalFlagBindings, approvalPartialLive, approvalPartialState, approvalFlagPartialIncrementalOn, approvalPartialIndex, approvalPartialLiveIdx, approvalPartialAffected } from '@/utils/approval'   // IE 2026 10 14 / ODOO-5800 (app7 #84309: клик ✓ПМ на 20 тыс. строк — 5 с): индекс «итог → документы», сброс и перерисовка только предков   // IE 2026 10 14 / ODOO-5800 (Igor, скрин 1coh_001 «БЮ: VMS»): итог флага — живой расчёт на фронте из подчинённых документов   // IE 2026 10 14 / ODOO-5800 (Igor): итог группы по колонке флажка — «частично» (полузаполненный чекбокс)   // IE 2026 10 07 / ODOO-5800 (заказ Игоря): «Hidden» поля строки DL2 гасит ячейку своего уровня — _DLRow.cells[binding].blank (utils/dl2CellBlank.js)
import { FLAG_DL2_SETTINGS_TITLES, dl2_isFieldsPath, dl2_needsDict, dl2_fieldTitle, dl2_dictT, dl2_dict } from '@/utils/dl2FieldTitle'   // IE 2026 10 08 / ODOO-341407 (Igor 08.10, «Signals»): названия полей раскладки DL2 в настройках — как подписи колонок отчёта
import { FLAG_DL2_SORT_CHIPS, dl2_sortChips } from '@/utils/dl2SortChips'   // IE 2026 10 10 / ODOO-341407 (Andrey via core #74338: sort chips in the layout list)
import { approvalOn as approval_switchOn, approvalFormMode, approvalOf, approvalUnitIds, approvalPill, approvalCountSeparate, approvalTip, approvalLockReason, approvalLockOf, approvalDataLockOf, approvalCellDataLock, approvalClosedKind, approvalClosedValueCol, approvalMenu, approvalRowMenu, approvalAction, approvalActions, approvalActionTitle, approvalActionLabel, approvalSelectionStep, approvalDoc, approvalFlagSteps, approvalOrderMark, approvalFlagLiveOpen, approvalFlagLiveOrder, approvalFlagMark, approvalFlagOrderMissing, approvalCellTip, approvalWaitingUsers, approvalOpenRef, approvalLinksOn, approvalTransitionsOn, approvalTransitionsCommon, approvalPanelApply, approvalPanelIsLegacy, approvalTransitionAction } from '@/utils/approval'   /* IE 2026 10 16 / ODOO-5800: кнопки монитора единиц по переходам WORKFLOW v2 */   /* IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — FE1-gimp FE1 */   // IE 2026 10 09 / ODOO-345618 (заказ Игоря: согласование на сегменте): F1 — пилюля в заголовке строки-группы, замок, подменю «Approval» (fe.ux.approval); IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ): F8 — + approvalClosedValueCol
import { approvalYearIntegrityOn, approvalCascadeApply } from '@/utils/approval'   // IE 2026 10 15 / ODOO-5800 (Igor 15.10: целостность флагов по годам): cascade_rows ответа save → чекбоксы соседних лет того же документа
import { dictGet as i18n_dictGet } from '@/i18n/relocalize'   // IE 2026 10 08 / ODOO-341407: словарь бэка языка (i18n_dict_get; кэш памяти / IndexedDB) — тот же, что подписывает колонки отчёта
import { shownTitle_of, shownTitle_sortValue, shownTitle_tip } from '@/utils/shownTitle'   // IE 2026 10 04 / ODOO-5800 (fe-71): показанный текст ячейки из поля строки `<binding>-title` — отрисовка, подсказка, поиск, сортировка
import { frozenTitle_apply, frozenTitle_stale, FROZEN_TITLE_FLAG } from '@/utils/frozenClipTitle'   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #114076: двойной тултип в колонке ответственного): нативная подсказка обрезанной замороженной ячейки — своя, под текст своей строки
import { planLabel_hasPh, planLabel_approvalAt, planLabel_fill, planLabel_copyText, planLabel_hookGrid, planLabel_editLocked, PLAN_LABEL_DATE_FLAG } from '@/utils/planLabelDate'   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана): дата утверждения в подписи строки плана — «{approval_at}» → местное время
import { colorEditorOn, colorAttrFor, colorCellView, colorCommitValue, colorPickerValue, colorFromPicker, colorNorm, colorPopupPos, colorIsLight } from '@/utils/gridColorEditor'   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: цвета как на слайде — редактор цвета ColorPicker)
import { rowLinkOn, rlConfig, rlItems, rlSig, rlShown, rlDisplay, rlResolve, rlKey, rlLinkObj, rlInstall, rlInstallAll, rlFixNewRow, getPath as rlGetPath, RL_TYPE, rlPickOnEnter, rlLooseResolve, rlMergeBarrier } from '@/utils/rowLink'   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: AttrRowLink — ссылка на строку табличной части той же записи)   // IE 2026 10 25 / ODOO-348878 (заказ Игоря: подбор RowLink — Enter и закреплённые колонки) (p041): + rlPickOnEnter, rlLooseResolve, rlMergeBarrier
import { rowHasBox as i18nFields_rowHasBox, formRowsFor as i18nFields_formRowsFor, bindingsOf as i18nFields_bindingsOf, fieldPath as i18nFields_fieldPath,
    isTranslatable as i18nFields_isTranslatable, FLAG_FORM_EDIT as I18N_FLAG_FORM_EDIT,
    listColsFor as i18nFields_listColsFor, isAuto as i18nFields_isAuto, TIP_AUTO as I18N_TIP_AUTO,
    rowPathOf as i18nFields_rowPathOf, newRecordBaseEdit as i18nFields_newRecordBaseEdit, listRowOf as i18nFields_listRowOf } from '@/utils/i18nFields'   // IE 2026 10 06 / ODOO-341407 (заказ Игоря п.1): у строки списка есть контейнер перевода поля (путь — из binding колонки); (п.2, В3): строки формы «<поле> (uk)/(ru)», правка основной строки под uk / ru — только перевод; (п.2): колонки списка «<колонка> (uk)/(ru)», словарный перевод в ячейке
import * as wjcCore from '@mescius/wijmo';
import { formatAggValue } from '@/utils/formatAggValue'   // IE 2026 11 01 / ODOO-349799 (group-bytes): агрегат колонки bytes — KB/MB
import * as wjGrid from '@mescius/wijmo.grid';
const _fmtCssMemo = new Map()   // IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL5: cssText снимка ячейки → [[свойство, значение, приоритет]] (applyCssText без временного div на каждую ячейку)
import { RH_BOOL_FLAG, rhBool_default, rhBool_checked, rhBool_implicit } from '@/utils/rowHeadersBool.js'   // IE 2026 10 23 / ODOO-5800 (ie-dm7): умолчание флажков заголовков строк (use / position=rowHeaders) — только показ, в строки не пишется (fe.ux.rhBoolImplicitDefault)
import { gridSaveBar_on, gridSave_method, gridSave_baseline, gridSave_diff, gridSave_barVisible, gridSaveGuard_on, gridSave_reapply } from '@/utils/gridSaveBar'   // IE 2026 10 13 / ODOO-5800: полоса Save над гридом ленивой вкладки (fe.ux.gridSaveBar)
import { toRaw as gridSave_toRaw } from 'vue'   // IE 2026 10 13 / ODOO-5800: тождество строк снимка ленивого грида
import { gdrOn, gdrMerge, gdrSnap, gdrShowPlan, gdrCount } from '@/utils/gridDeferredRefresh'   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: правка на графе схемы — обновление гридов)
import { gcaOn, gcaPlan, gcaSchedule } from '@/utils/gridCollapseBulk'   // IE 2026 10 25 / ODOO-348878 (заказ Игоря: высота строк после «свернуть все»)
import { editKeep_flagOn, editKeep_sameRows, editKeep_snapshot, editKeep_restore, undoKeep_flagOn, undoKeep_group, boolEditKeep_flagOn, editKeep_scopeRows, editKeep_addRange, editRefresh_cols } from '@/utils/gridEditKeep'   // IE 2026 10 14 / ODOO-5800: undo / redo ячеек — точечная перерисовка (fe.ux.undoKeepRefresh)
import { alertChildKeep_flagOn, alertChild_build, alertChild_update } from '@/utils/alertChild'   // IE 2026 10 14 / ODOO-5800: карта alert-потомков — точечное обновление после правки строки (fe.ux.alertChildKeep)   // IE 2026 10 14 / ODOO-5800: флажок под правилами оформления — точечный проход и прямая перерисовка ячеек (fe.ux.boolEditKeepRefresh)   // IE 2026 10 14 / ODOO-5800: правки грида переживают фоновый ответ по тем же строкам
import { frozenCloneSync_flagOn, FROZEN_STAMP_KEY, frozenCell_state, frozenCell_delta, frozenCell_shift, frozenClone_fix } from '@/utils/frozenClone'   // IE 2026 10 15 / ODOO-5800: клон замороженных колонок — копии по строкам после точечной перерисовки / правки
import { gridEditMode_on, gridEditMode_applies, gridEditMode_readOnly, gridEditMode_rowLink, gridEditMode_openPossible, gridEditMode_openAction, gridEditMode_openItemAction, gridEditMode_buttons } from '@/utils/gridEditMode'   // IE 2026 10 14 / ODOO-5800: режим редактирования динамического списка как у виджета списка (fe.ux.gridEditMode)
import { pollKeepsRowForm_on, rowFormSkipInternal_on, rowForm_holdRetarget, rowForm_gridHidden, rowForm_retargetSkip } from '@/utils/rowFormGate'   // IE 2026 10 13 / ODOO-5800: перестройка грида фоновым обновлением / скрытый грид не перецепляют форму строки
import { setSelectorsClickCurrent_on, setSelectors_hasChannel, setSelectors_busyTarget, setSelectors_clickCurrent } from '@/utils/setSelectorsClick'   // IE 2026 10 25 / ODOO-348730: клик по уже выделенной строке ставит фишку селектора
import { markRaw } from 'vue'   // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL2: нереактивные экранные кэши ячеек (created)
import { InputDate, InputTime, ComboBox, AutoComplete, InputColor, InputNumber } from "@mescius/wijmo.input";
import { layoutCandidates } from '@/utils/keyboardLayout'   // IE 2026 09 10 / ODOO-…: чипс поиска не в той раскладке
import { searchLadderExtra, rowMatchTerms } from '@/utils/searchMatch'   // IE 2026 10 02 / ODOO-345043 (заказ Игоря: поиск — лишний символ в запросе): последняя ступень поиска по таблице
import { navPos_clamp, navStep, navSubs_build } from '@/utils/gridSearchNavChip'   // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс)
import { searchTerms, fuzzyMaxTier, fuzzyFindTier, FUZZY_TIERS, searchPhrase, phraseFind, phraseTest } from '@/utils/searchMatch'   // IE 2026 09 12 / ODOO-… (заказ Игоря): поиск по частям + опечатки (ступени)
import { liveChip_new, liveChip_set, chips_withLive, chips_dropLive } from '@/utils/gridLiveSearch'   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска): живой поиск полосы чипсов (виртуальный чипс, в запись не пишется)
import { headerCells_collect, headerHit_terms, headerHit_phrase, headerExclude_terms, headerNav_stops, headerSearch_sig } from '@/utils/gridSearchHeaders'   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
import { gridSearchAlt_lows, gridSearchAlt_hit, gridSearchAlt_matched, gridSearchAlt_ladder, gridSearchAlt_spec, gridSearchAlt_langs, gridSearchAlt_langName } from '@/utils/gridSearchAlt'   // IE 2026 09 25 / ODOO-… (замечание Игоря: поиск в таблице по названиям на других языках): ступень «на другом языке» — названия записей ссылочных ячеек на других языках (titles_alt словаря)
import { rowNum_text, rowNum_hitTerms, rowNum_hideHit, rowNum_chipTerms } from '@/utils/gridSearchRowNum'   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
import { gridTotalRow_is } from '@/utils/gridTotalRow'   // IE 2026 09 30 / ODOO-343436: строка итога всегда видна под фильтром непустых
import { gridColWidth_visible, gridTreeCol_need } from '@/utils/gridColWidth'   // IE 2026 10 08 / ODOO-5800: ширина колонки после ресайза мышью — видимая, не сырой 0 wijmo; минимум первой колонки дерева
let _durFitCtx = null   // IE 2026 09 10 / ODOO-… (замечание Игоря): canvas для замера текста длительности (durFit_width)
import { h,createApp, toRaw } from 'vue/dist/vue.esm-bundler.js'; // IE 2026 09 04 / ODOO-336379: toRaw — сырой объект строки для python-CSS и сигнатуры строки
import "@mescius/wijmo.vue2.grid";
import { CellMaker, SparklineType, SparklineMarkers } from '@mescius/wijmo.grid.cellmaker';
// ODOO-4443: вычислитель условных правил общий с чартами
import { cfCheckWHERE, cfResolveRef, cfCheckCondition, cfClassDeltaCss, cfWhereLeaves, cfSetLegacy, cfWhereIsGroup, cfRulesFields } from '@/utils/cfEval'   /* IE 2026 10 14 / ODOO-5800: поля условий правил — область точечного прохода */
import { chipPlace_isInput, chipPlace_of } from '@/utils/chipPlace'   // IE 2026 09 19 / ODOO-5800 (пункт 3 Игоря: чипсы таблицы на входе выборки)
import { treeStrict_of } from '@/utils/treeStrict'   // IE 2026 10 31 / ODOO-349799: строгий отбор дерева под чипсом-выражением «= row.<поле>»
// IE 2026 09 18 / ODOO-… (именованные стили): группы семантических стилей сегмента CSS-CLASS (см. AttrGrid.styleKeys_push)
// какие именованные стили заменяют прежний класс заливки (tools/probes/styles_bind_apply.py пишет пару «именованный прежний»)
// IE 2026 09 20 / ODOO-5800 (Igor: «раскраску в ячейке ожидаю не от форматирования, а от метрик» — опция отчёта «Metric data in cells»)
const CF_ABSENT = Symbol('cf-absent')      // IE 2026 10 07 / ODOO-5800: «поля в строке нет» (отличается от null / '')
const CF_NO_RULES = Object.freeze({})          // отчёт без правил оформления, но с заливкой от метрик: cf_compute работает по пустому набору правил
const METRIC_FILL_NONE = Object.freeze([])
const CELL_RULES_NONE = Object.freeze([])   // IE 2026 09 20 / ODOO-5800 (Igor: «для каждой ячейки иметь привязку к применимым правилам … показать в форме drilldown — применимые правила»)
const FORMAT_NO_IDS = Object.freeze([])   // IE 2026 09 20 / ODOO-5800 (Igor: колонка Selector и статистика грида Conditional format, чипс условного оформления CHIP-Format)
const SAMEDOC_CUR_MS = 1800   // IE 2026 09 25 / ODOO-5800 (Igor: переходы ‹ › по ячейкам тех же документов из формы ячейки): длительность вспышки текущей остановки = анимации cellSameDocCur (CSS ниже)
const METRIC_FILL_NOSET = Object.freeze({ has: () => false })
// IE 2026 10 03 / ODOO-5800 (заказ Игоря: «Показать критич ош если небьется расчетный запас с фактич»): класс ячейки, у которой есть строка метрики оценки critical
// (расхождение расчётного и фактического запаса — причина stock_mismatch): насыщенный красный с уголком — строже и отличимо от bad (стиль — .cell-metric-critical ниже).
// Выключатель fe.cellForm.stockMismatchCritical (по умолчанию вкл; выкл — critical красится фоном своей оценки, как прежде)
const METRIC_CRIT_CLASS = 'cell-metric-critical'
const STYLE_RAW_TWINS = {
    red: ['stock-critical', 'grade-bad', 'alert-row', 'alert-uncovered', 'kpi-bad', 'value-negative'],
    orange: ['stock-min', 'grade-warning'],
    yellow: ['stock-opt', 'kpi-mid', 'grade-notice', 'grade-warning'],   // grade-notice — IE 2026 09 18 / ODOO-…: жёлтый, мягкий уровень предупреждения
    green: ['stock-max', 'grade-good', 'kpi-good'],
    grey: ['status-muted', 'stock-nosales'],
    blue: ['stock-over-max'],   // IE 2026 10 01 / ODOO-5800 (Igor 01.10): синяя шкала сверхнормативного запаса (> max / > 2×max)
    'blue-strong': ['stock-excess'],   // IE 2026 10 01 / ODOO-5800
}
import { formatChip_isEmpty, formatChip_ids, formatChip_sig, formatChip_copy, formatChip_matchRow, formatChip_keepsTask, formatChip_has, formatChip_request, formatChip_pendingApply, cfStats_index, cfStats_applyRow, CF_STATS_KEYS } from '@/utils/formatChip'   // IE 2026 09 20 / ODOO-5800 (Igor: колонка Selector и статистика грида Conditional format, чипс условного оформления CHIP-Format)
import { filterTotals_compute, ft_col, FT_HINT, FT_STALE_HINT } from '@/utils/filterTotals'   // IE 2026 09 21 / ODOO-5800 (Igor: под чипсом-фильтром строк итоги групп — по видимым строкам); IE 2026 09 23 / ODOO-341407: FT_HINT()/FT_STALE_HINT() — функции (i18n)
import { dateBar_plan, dateBar_scales, dateBar_geom, dateBar_parse, dateBar_dayStart } from '@/utils/dateBars'   // IE 2026 09 22 / ODOO-… (заказ Игоря): полосы-интервалы дат в ячейках
import { rowEmpty_buildPlan, rowEmpty_byPlan, rowEmpty_value, rowEmpty_valueEmpty } from '@/utils/rowEmpty'   // IE 2026 09 20 / ODOO-… (R22: быстрая проверка «строка пуста» по плану колонок)
import { pageGotoChip_config, pageGotoChip_rowIsData, pageGotoChip_columnOk } from '@/utils/pageGotoChip'   // IE 2026 09 30 / ODOO-343433: клик по строке REPORT2 → страница стола с чипсом
import { rulesDict_index, cellRules_list, cellRules_listTargets, cellRules_commonWhere, cellRules_chip, cellRules_month } from '@/utils/cellRules'   // IE 2026 09 20 / ODOO-5800 (Igor: «для каждой ячейки иметь привязку к применимым правилам … показать в форме drilldown — применимые правила»)
import { metricHit_ranges } from '@/utils/metricHit'   // IE 2026 09 20 / ODOO-5800 (Igor: переходы чипса метрик по ячейкам, подсветка параметра ячейки и подпадающих ячеек по наведению на чипс)
import { metricChip_matchRow, metricChip_matchKey, metricChip_isEmpty, metricChip_matchedKeys, metricChip_sig, metricChip_copy, metricChip_useToggle, metricChip_selApply, metricChip_compact, metricChip_histPush, metricSet_rowConditions, metricSet_keys, metricKey_parse, metricKey_base, metricKey_covers, metricRules_h4, METRIC_HORIZON_ALL, metricFormat_isOff, metricFormat_offApply, metricData_index, metricData_keys, metricData_detail, metricData_detailText, metricData_rowIds /* IE 2026 10 03 / ODOO-5800 */, metricChip_localize /* IE 2026 10 04 / ODOO-5800 (fe-76) */ } from '@/utils/metricChip'   // IE 2026 09 18 / ODOO-5800 (заказ Игоря «чипс-метрик»)
import { metricNav_stops, metricNav_memoInherited } from '@/utils/metricChip'   // IE 2026 10 05 / ODOO-5800 (fe-82): остановки ‹ › чипса метрик — чистая функция
import { metricNav_carry, metricNav_step } from '@/utils/metricChip'   // IE 2026 10 05 / ODOO-5800 (fe-88): позиция обхода ‹ › чипса метрик — первый переход ведёт на первую остановку
import { metricNav_optionGain, metricNav_otherHiding } from '@/utils/metricChip'   // IE 2026 10 05 / ODOO-5800 (fe-86): ячейки сигнала в строках выключенных опций — хвост «+N» счётчика чипса метрик
import { cellMatch_ranges, cellMatch_subscribe, cellMatch_publish, cellMatch_key, cellMatch_others, cellMatch_onChange, cellMatch_textsIn, cellMatch_hiddenText, cellMatch_hiddenClass } from '@/utils/cellMatch' // IE 2026 09 17 / ODOO-… (замечание Игоря): подсветка одинакового текста — по всем виджетам страницы
import { pyWorker_copyRows, pyWorker_copyScope, pyWorker_plain, pyWorker_applyDiff, pyWorker_supported } from '@/utils/pyWorkerPool'
// IE 2026 09 23 / ODOO-… (заказ Игоря: итог группы = единственный потомок): классы ячейки-повтора итога группы по варианту (AttrGrid.groupDup_paint)
const GROUP_DUP_CLASSES = ['gt-dup-dim', 'gt-dup-hover', 'gt-dup-arrow'] // IE 2026 09 05 / ODOO-336379: python-пересчёт в Web Worker
import { add, filter, i, re, round, string, to } from 'mathjs';
import { Selector,BooleanChecker } from '@mescius/wijmo.grid.selector'
import { listenerCount, nextTick, title } from 'process';
import { kMaxLength } from 'buffer';
import _ from 'lodash';
import { DirectiveCellFactoryBase } from '@mescius/wijmo.interop.grid/es5-esm';
import { bind } from 'lodash';
import { mergeTrees } from '../../utils/merge_trees.js';
import AttrButton from './AttrButton.vue';
import SegSwitch from '@/components/ui/SegSwitch.vue';   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p189 єдиний вигляд полос перемикачів — заголовки, відступи, Alt-підказки пунктів)
import { method } from 'lodash';
import { picker_dblClickChooses, picker_clickStep } from '@/utils/gridPicker'   // IE 2026 10 11 / ODOO-345618: двойной клик по строке списка выбора = Choice (fe.ux.pickerDblClick)
import { cellForm_clickReopens, cellForm_editOpens, cellForm_isSingleCell, cellForm_emptyMergedSkip, cellPassport_reportAllowed, cellPassport_periodOf, cellPassport_mergeDocCells } from '@/utils/cellFormGate'
import { cellPassport_overrides } from '@/utils/cellPassportOverrides'   // IE 2026 10 22 / ODOO-5800 (unsaved): незаписанные правки грида → params.overrides паспорта ячейки
import { cellPassport_whereBlockOf, cellPassport_blockWhereApplied, CELL_PASSPORT_WHERE_BLOCK_FLAG } from '@/utils/cellFormGate'   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: паспорт — отбор полосы)
import { cellDocs_qtySource } from '@/utils/cellDocs'   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: паспорт — отбор полосы)
import { cellDocsMore_extra } from '@/utils/cellDocsMore'   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #114865: «ще N документів» — догрузка cell_docs_more): clickable / more хвоста документов
import { cellPassport_blockDims } from '@/utils/cellFormGate'   // IE 2026 10 15 / ODOO-5800 (Igor: у групповой строки «LBE ковзний» нет блока VERSIONS): мера / тип меры из отбора узла лэйаута групповой строки
import { cellForm_sameSelection, cellForm_selAction, cellForm_itemId } from '@/utils/cellFormGate'   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: форма ячейки по 🏷 не гаснет при перепривязке данных)
import { cellForm_followResult, cellForm_tagState } from '@/utils/cellFormGate'   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: открытая форма следует за выделением) — FB6b
import { cellForm_selFollow, cellForm_followTarget } from '@/utils/cellFormGate'   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: открытая форма следует за выделением)
import { cellForm_visibleHere } from '@/utils/cellFormGate'   // IE 2026 10 12 / ODOO-5800 (заказ Игоря: форма ячейки не закрывается при открытии из неё записей)
import { cellForm_refPick } from '@/utils/cellFormGate'   // IE 2026 10 15 / ODOO-345813 (заказ Игоря: Scope в новой строке грида списка окон — список по клику)
import { responsible_on, responsible_wanted, mine_cfg, mine_isOn, mine_toggle, mine_button, responsible_linkOn, responsible_cellUsers, responsible_cellHtml, mineChip_hidesButton } from '@/utils/cellResponsible'   // IE 2026 10 12 / ODOO-5800: mineChip_hidesButton — чипс «Mine» вместо кнопки   // IE 2026 10 09 / ODOO-345618: кнопка «Mine» грида сигналов — чипс responsible_users
import { cellObjects_wanted, cellObjects_model } from '@/utils/cellObjects'   // IE 2026 10 08 / ODOO-5800 (Igor: список объектов за ячейкой отчёта по сигналам, выбор чипсом)   // IE 2026 10 08 / ODOO-5800: паспорт у ячейки квартального / годового итога   // IE 2026 09 30 / ODOO-343433: явный клик по ячейке снова открывает форму после Esc / ✕
import { FLAG_GRID_AUTOCOMPLETE_KEYS, pickOnEnter, moveHighlight } from '@/utils/gridAutocomplete'   // IE 2026 10 10 / ODOO-341407 (Andrey via core #74395: grid autocomplete — detached value, Enter, arrows)
import { inflDeepest_target, inflDeepest_isEmpty, inflDeepest_prune } from '@/utils/inflDeepest'   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p204 підсвітка залежних комірок — у розкритого батька лише точна дочірня комірка)
import { cellBasis_model } from '@/utils/cellBasis'   // IE 2026 10 09 / ODOO-5800 (этап 2 «Снимок основания ЗП»): блок BASIS формы ячейки — основание ЗП при согласовании против текущего расчёта
import { fixDates_on } from '@/utils/cellFixDates'   // IE 2026 10 28 / ODOO-5800 (заказ Игоря: раздел Fix dates в форме ячейки): раздел FIX DATES формы ячейки
import { menuPanelHost_on, menuPanelHost_marginLeft } from '@/utils/menuPanelHost'   // IE 2026 09 28 / ODOO-342342 (заказ Игоря: «"меню" — прижато вправо»): прижатие ⚙ / ≡ строки грида
import { ew_on, ew_rows, ew_apply } from '@/utils/buttonsEnabledWhen'   // IE 2026 10 13 / ODOO-5800: кнопки командной панели с enabled_when — активны только при подходящих строках выделения (fe.ux.buttonsEnabledWhen)
import { plainLevel_is, PLAIN_LEVEL_CLASS } from '@/utils/plainLevel'   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p206 рядок Data Layout без оформлення рівня — білий фон у розкритого рядка об'єкта, опція): строка без фона уровня (fe.ux.plainLevelRows)
import { alertIsRow } from '@/utils/alertPlain'   // IE 2026 10 13 / ODOO-5800: MOQ top-up / alert-plain строки не красят потомков (fe.ux.alertPlainRows)
import { foldState_snapshot, foldState_restore } from '@/utils/gridKeepExpanded'   // IE 2026 10 17 / ODOO-5800: раскрытые группы дерева переживают пересборку данных (select после первого кадра) — свёртка по ключу строки раскладки (fe.ux.gridKeepExpanded)
import { linkCellHtml, thumbSizeFor } from '@/utils/sourceLink'   // IE 2026 10 18 / ODOO-347310: AttrUrl / AttrImageUrl в ячейках
import { loadImage, peekImage, installThumbPreview } from '@/utils/sourceImage'   // IE 2026 10 18 / ODOO-347310
import { SEG_LINK_CLASS, SEG_LINK_CELL_CLASS, segLinkCell_on, segLinkCell_html, segLinkCell_segment, segLinkCell_widgetInit } from '@/utils/segLinkCell'   // IE 2026 10 23 / ODOO-5800 (заказ Игоря, скрин 1): ярлык «список сегмента» в колонке Segment вкладки Sources карточки DS
import { treeNode_pi } from '@/utils/treeNodeIcon'   // IE 2026 10 24 / ODOO-348705 (заказ Игоря: иконка ссылки на список в дереве — как ярлык списка)
import { cgHeadersWijmo } from '@/utils/crossGridLook'   // IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение): заголовки грида шахматки — нумерация штатным headersVisibility
import { liveSelection } from '@/utils/gridLiveFlex'   // IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение) (p038): выделение только живого FlexGrid — рендер после пересоздания wijmo (смена «Заголовки») не падает
import { cgSlideRow } from '@/utils/crossGridSlide'   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106094: шахматка — вид слайда, центрирование, группы без фона) (p051): кнопка «Slide look» в панели ⚙ грида шахматки
import { cellFill_mode, cellFill_isFill, cellFill_filled, cellFill_shape, cellFill_layersCached, cellFill_rowNeighbor, cellFill_colNeighbor, cellFill_haloOn, cellFill_markGeom, cellFill_heatHsl, cellFill_groupHsl, cellFill_dataFill, cellFill_cellKey } from '@/utils/cellFillRound'   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)   // IE 2026 11 03 / ODOO-350449 (проба p252: фон ячеек — слои поверх cell-lt/cell-rc, соседи через скрытые колонки): + cellFill_colNeighbor   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р4): + cellFill_heatHsl / groupHsl / dataFill / cellKey
import { DISPLAY_EVENT } from '@/utils/displayOptions'   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: все варианты отображения — во вкладке Display шестерёнки, не на форме)
import { gearForm_on, gearForm_layout, gearForm_items, gearForm_value, gearForm_param, gearForm_params, gearForm_pickCommand } from '@/utils/gearFormLayout'   // IE 2026 11 04 / ODOO-350449 (заказ Игоря: форма ⚙ по наведению — в стиле вкладки Display); gearForm_params — IE 2026 11 04 / ODOO-350449 (поправка Игоря: булевы в форме ⚙ — снова кнопкой-тумблером, перечисления — группой)
import { editCommit_pending } from '@/utils/editCommit'   // IE 2026 11 04 / ODOO-350449 (заказ Игоря: форма ⚙ по наведению — в стиле вкладки Display): как AttrButton.onClick — значение открытого редактора ячейки в запись до команды
import { SEC_KEYS, SEC_TOKENS, SEC_CLASS_ALL, secStyle_mode, mono_on, mono_textClasses, sec_rowIs, sec_kind, sec_labelGuess, sec_rowLayers, sec_railLayers, sec_cellLayersCached, sec_textClasses, sec_cellOrClear } from '@/utils/sectionStyle'   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: мягкие разделители разделов и монохром — опции) · IE 2026 11 03 / ODOO-350449 (проба p254: S2 — цвет только «Непокрито», прокручиваемая часть, Esc фокуса не закрывает виджет): + sec_cellOrClear
import { relationRow_flagOn, relationRow_target, relationRow_activeAttr, relationRow_helpVars, relationRow_rowIndex } from '@/utils/relationRow'   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #115712, слово Igor: relation_row — переход к шагу согласования)
import { mtl_segments, mtl_resolve, mtl_resolveMany, mtl_subscribe, mtl_segmentOf } from '@/utils/multiTypeLinks'   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди)
import { setAttrBackRef } from '@/utils/attrBackRef'   // IE 2026 10 25 / ODOO-348878 (hotfix: ⚙ шахматки — циклическая ссылка в attr)
import { colnum_number, colnum_attrsIndex } from '@/utils/fieldsColnum'   // IE 2026 10 23 / ODOO-348708 (заказ Игоря: окно «Вигляд doc.fields» — колонка «Колонка» = номер в шапке грида; ⚙ ставит окно на колонку родителя)
import { fastPassGroupRevive_on, fastPass_groupSeen, fastPass_reviveParents } from '@/utils/gridFastPassGroups'
import { groupLevels_on, groupLevelClass, groupGuides, groupGuide_x, groupRowPill_on, groupPill_kind, groupPill_x, groupPill_paint, lastVisibleCol } from '@/utils/gridGroupLevels'   // IE 2026 11 03 / ODOO-350449 (group row pill): плашка строки-группы на всю строку от отступа уровня (fe.ux.groupRowPill)     // IE 2026 11 02 / ODOO-349799 (group-levels): строки-группы wijmo по уровню + направляющие слева как у дерева (fe.ux.gridGroupLevels)   // IE 2026 11 01 / ODOO-349799 (sort-tree): fast-проход после пересортировки сгруппированного грида — видимые строки из кэша оживляют группы-родители
import { TREE_LEVEL_STYLE_FLAG, TREE_SUBTREE_HOVER_FLAG, TREE_INDENT, TLS_CLASSES, treeLevelStyle_read, treeLevels_build, treeLevels_groupOf, treeLevels_rowClasses, treeLevel_layers, railColor_order } from '@/utils/treeLevelStyle'   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: стили уровней дерева — опции A/B/C/E/F)
import { groupHeaderValue_on, groupHeader_format, groupHeader_chain, groupHeader_tipHtml } from '@/utils/gridGroupHeader'   // IE 2026 11 02 / ODOO-349799 (group-header-value): заголовок строки-группы — только значение; опция чипа «Field and count» — полный вид; Alt-подсказка с полной информацией о группе (fe.ux.gridGroupHeaderValue)
import { gridEmptyScan_on, emptyScan_begin, emptyScan_column, emptyScan_end } from '@/utils/gridEmptyScan'   // IE 2026 10 29 / ODOO-5800 (webscm #114418: долгая задача 0,86 с после Shift+F3 — скан пустых колонок соседнего грида)
import { gridAutoSizeRows_on, autoSizeRows_begin, autoSizeRows_batch, autoSizeRows_end } from '@/utils/gridAutoSizeRows'   // IE 2026 10 29 / ODOO-5800 (заказ Игоря: длинная задача Shift+F3): autoSizeRows без лишнего invalidate wijmo, флаг fe.ux.gridAutoSizeRowsLazy
import { gridSortNulls_on, sortNulls_compare } from '@/utils/gridSortNulls'
import { cellIcons_on, groupLeafIndent_on, cellIcon_pi, cellIcon_html, cellIcon_params, groupLevel_attr, groupIcon_pi, groupIcon_params, cellIcon_paramsFromDataset, cellIcon_action, cellIcon_command, leafPad, CELL_ICON_ID, CELL_ICON_CLASS } from '@/utils/gridCellIcons'   // IE 2026 11 02 / ODOO-349799 (cell-icons): иконка по значению строки / группы (kind_pi, addon_pi, segment_pi, collection_pi), клик — список (icon_method), Alt — запись; отступ листа под группой (fe.ux.gridCellIcons, fe.ux.gridGroupLeafIndent)   // IE 2026 11 02 / ODOO-349799 (sort-nulls): пустые значения числовой колонки — перед нулём по возрастанию, после — по убыванию (fe.ux.gridSortNullsFirst)
import { LINK_DROPDOWN_PROBE_LIMIT, linkDropdown_shouldProbe, linkDropdown_probeStart, linkDropdown_probeSettle, linkDropdown_isComplete, linkDropdown_fullMax } from '@/utils/linkDropdownSmallAll'   // IE 2026 10 28 / ODOO-5800 (просьба ie-dm7: выпадающий список ссылки при открытии — полный для малых сегментов)
import { linkTextToId_on, linkIsRef, linkIsFormula, linkResolveText, linkLegacyResolve } from '@/utils/linkTextToId'   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #116081, дефект Igor: процесна модель — id, не назва)

class CustomCellFactory extends DirectiveCellFactoryBase {
    constructor(flex, vueObj) {
        super(flex);
        this.vueObj = vueObj;
        // flex.mergeManager = new CustomMergeManager(flex, vueObj)
    
        this._deferred = new Map();
        this._deferred0 = new Map();
        this._fixCells = new Map();
        this._flushScheduled = false;
        this.alreadyFormat = 0;
        this.outRange = 0;
    }
    // getEditorValue
    updateCell(panel, row, col, cell) {
        const vueObj = this.vueObj;
        const flex = panel.grid;
        const vRange = flex.viewRange;
        const data_cell = cell.data_cell || {};
        if (panel === flex.cells && cell[FROZEN_STAMP_KEY] && typeof vueObj.frozenCell_fixStale === 'function') vueObj.frozenCell_fixStale(panel, col, cell)   // IE 2026 10 15 / ODOO-5800: замороженная колонка, если ниже перерисовка пропущена (кэш эпохи / прокрутка) — геометрия из состояния штампа в текущее

        const key = `${panel.cellType}-${row}-${col}`;
        let _cache = vueObj.cache_data_cells.get(key);
        if (!_cache) {
            _cache = {key, index: ++ vueObj.cache_index};
            vueObj.cache_data_cells.set(key, _cache);
        }

        // frozen
        let isFrozen = (panel === flex.cells || panel === flex.columnHeaders) && flex.frozenColumns && col < flex.frozenColumns
        isFrozen = false // cloneFrozenCells
        if (isFrozen) {
            const left = vueObj.calc_left(panel, col, _cache.paddingLeft) + 'px';
            if (cell.style.left !== left) {
                cell.style.left = left
                _cache.frozenLeft = cell.style.left
            }
            _cache.isFrozen = isFrozen
        }
        if (panel === flex.cells) vueObj.hideZero_apply(panel, row, col, cell)   // IE 2026 08 30 / ODOO-5800

        if ((row < vRange.topRow - 10 || row > vRange.bottomRow + 10) && panel === flex.cells) {
            this.outRange ++
            return;
        }

        // R18a (dm 2026 08 04): замороженные колонки при прокрутке — самые дорогие ячейки
        // (длинные названия объектов, ~7 мс/шт) и пере-форматируются на каждый шаг, хотя их
        // СОДЕРЖИМОЕ не меняется (позицию ведёт wijmo). Если DOM-элемент уже несёт эту же
        // ячейку (data_cell совпал по row/col) — пропускаем целиком на время прокрутки.
        // Выкл: window.fastEntry.set('frozenSkip', false)
        // IE 2026 08 27 / ODOO-11312 (M03, an-dm; клиентский кейс Delta 26.08): пропуск форматирования
        // шёл по ПОЗИЦИИ (row/col + эпоха irefresh). При раскрытии узла дерева, сортировке или обновлении
        // данных без refreshing() строки под той же позицией уже другие, а DOM-элемент переиспользован —
        // хвост блока показывал значения соседних строк (в M03 — цифры чужого документа, и правка уходила
        // в чужой документ). Теперь пропуск только если за позицией та же строка данных и та же колонка.
        // Выкл (прежнее поведение): window.fastEntry.set('cellSkipIdentity', false)
        const _identOK = (vueObj.store?.fastEntry?.cellSkipIdentity === false)
            || (data_cell.item === undefined && data_cell.colKey === undefined)
            || (data_cell.item === panel.rows[row]?.dataItem && data_cell.colKey === panel.columns[col]?.binding);
        if (vueObj.isScrolling && panel === flex.cells && flex.frozenColumns && col < flex.frozenColumns
            && data_cell.row === row && data_cell.col === col && _identOK
            && vueObj.store?.fastEntry?.frozenSkip !== false) {
            this.alreadyFormat ++
            return;
        }

        const isFormated = (data_cell.row === row && data_cell.col === col && data_cell.irefresh === vueObj.irefresh && _identOK);
        if (isFormated) {
            this.alreadyFormat ++
            this.check_frozen(panel, cell, key, _cache);
        } else {
            // R18c (dm 2026 08 04): откладывать и при ВЕРТИКАЛЬНОЙ прокрутке — раньше
            // деферился только чистый горизонтальный скролл (isScrollingX), вертикаль шла
            // полным синхронным formatItem по каждой ячейке. Выкл: fastEntry.scrollDeferV
            const _deferScroll = vueObj.isScrollingX
                || (vueObj.isScrolling && vueObj.store?.fastEntry?.scrollDeferV !== false)
            if (!_deferScroll) {
                this._process(key, panel, row, col, cell)
            } else if (_cache.className || isFrozen || panel !== flex.cells) {
                this._deferred0.set(key, { panel, row, col, cell });
                if (!this._flushScheduled) {
                    this._flushScheduled = true;
                    requestAnimationFrame(() => this._flush0());
                }
            } else {
                // R16 scrollBlank: до отложенной обработки в переиспользованной DOM-ячейке
                // остаётся ЧУЖОЕ содержимое (значения не на своих местах при прокрутке) —
                // зачищаем сразу, ячейка пустая до догона. Выкл: window.fastEntry.set('scrollBlank', false)
                // R16b (dm 2026 08 04): зачищать и ПУСТЫЕ ячейки — у них переезжал класс
                // с фоном-паттерном (radial-gradient «точки») и inline-стили cf: артефакты
                // при прокрутке вправо/вниз и обратно. Геометрию (left/top/w/h) не трогаем.
                if (vueObj.store?.fastEntry?.scrollBlank !== false && panel === flex.cells) {
                    if (cell.textContent) cell.textContent = '';
                    if (cell.className !== 'wj-cell') cell.className = 'wj-cell';
                    const _st = cell.style;
                    if (_st.background || _st.backgroundColor || _st.backgroundImage) _st.background = '';
                    if (_st.color) _st.color = '';
                    if (_st.fontWeight) _st.fontWeight = '';
                    if (_st.fontStyle) _st.fontStyle = '';
                    if (_st.textDecoration) _st.textDecoration = '';
                }
                this._deferred.set(key, { panel, row, col, cell });
                // this._deferred.push({ panel, row, col, cell })

                clearTimeout(this._flushTimeout);
                if (vueObj.store?.fastEntry?.scrollBlank !== false) {
                    // R16: догон по кадрам с бюджетом времени — быстрее капельных батчей 100/50мс
                    if (!this._rafFlush) {
                        this._rafFlush = true;
                        requestAnimationFrame(() => { this._rafFlush = false; this._flushBudget(8); });
                    }
                } else {
                    this._flushTimeout = window.$cg.setTimeout(this, "AttrGrid.CustomCellFactory", () => {
                        this._flush(false, 100);
                    }, 50);
                }
            }
        }
    }

    _process(key, panel, row, col, cell) {
        const vueObj = this.vueObj;
        const flex = panel.grid;
        const _cache = vueObj.cache_data_cells.get(key);

        // const isFormated = (data_cell.row === row && data_cell.col === col && data_cell.irefresh === vueObj.irefresh);
        // if (isFormated) {
        //     return;
        // }

        super.updateCell(panel, row, col, cell);
        if (panel === flex.cells && typeof vueObj.frozenCell_stamp === 'function') vueObj.frozenCell_stamp(panel, col, cell)   // IE 2026 10 15 / ODOO-5800: штамп состояния (правка / прокрутка), в котором wijmo посчитал геометрию замороженной ячейки

        // merge
        const mgr = flex.mergeManager;
        const range = mgr.getMergedRange(panel, row, col, true);
        if (range?.col !== range?.col2) {
            let width = 0;
            for (let col_ = range.col; col_ <= range.col2; col_++) {
                // скрытые (hide-empty) колонки ширины не дают — иначе мерженная
                // ячейка шире видимого пролёта и наезжает на соседние группы
                if (panel.columns[col_]?.visible === false) continue;
                width += panel.columns[col_].renderWidth || panel.columns[col_].width || 0;
                
                if (vueObj.attr.use_delivery) {
                    let col = flex.columns[col_],
                    attr_col = vueObj.attr_by_binding[col?.binding]
                    // if (attr_col?.attrs) {
                    //     for (let attr of attr_col.attrs) {
                    //         if (attr.break_before) {
                    //             width += vueObj.break_width;
                    //             break;
                    //         }
                    //     }
                    // } else {
                        if (vueObj.breakOf(attr_col)) {   // IE 2026 09 19 / ODOO-…: + разрыв, переехавший со скрытой колонки
                            width -= vueObj.break_width;
                        }
                    // }
                }
            }
            cell.style.width = width + 'px';
        }
        if (range?.row !== range?.row2) {
            let height = 0;
            for (let row_ = range.row; row_ <= range.row2; row_++) {
                height += panel.rows[row_].renderHeight;
            }
            cell.style.height = height + 'px';
        }

        this.check_frozen(panel, cell, key, _cache);
        // IE 2026 08 30 / ODOO-5800 (репорт Игоря: нули возвращались при прокрутке):
        // текст ячейки ставит super.updateCell ЗДЕСЬ — и на отложенном пути (_deferred0 →
        // _flush0) это происходит уже после входа formatItem, где стояла очистка. Чистим
        // ноль сразу после отрисовки, иначе переиспользованная ячейка приезжает с «0»
        vueObj.hideZero_apply(panel, row, col, cell);
    }

    _flush0() {
        this._flushScheduled = false;
        // R18b (dm 2026 08 04): бюджет кадра и для «кешированной» очереди (deferred0:
        // кеш-путь/frozen/заголовки) — прыжок прокрутки собирал в ней один синхронный
        // кусок ~400 мс. Хвост дорисовывается следующими кадрами.
        // Выкл: window.fastEntry.set('flushBudget', false)
        const _budget = this.vueObj.store?.fastEntry?.flushBudget !== false
        const t0 = performance.now();
        for (const [key, entry] of this._deferred0) {
            const { panel, row, col, cell } = entry
            this._deferred0.delete(key);
            this._process(key, panel, row, col, cell);
            if (_budget && performance.now() - t0 > 8) break;
        }
        if (this._deferred0.size && !this._flushScheduled) {
            this._flushScheduled = true;
            requestAnimationFrame(() => this._flush0());
        }
    }
    _flush_formatItem() {
        const vueObj = this.vueObj;
        const flex = vueObj.flex;
        const vRange = flex.viewRange;

        for (const [key, e] of vueObj.deferred_formatItem) {
            if ((e.row < vRange.topRow - 10 || e.row > vRange.bottomRow + 10) && e.panel === flex.cells) {
                continue;
            }
            const _cache = vueObj.cache_data_cells.get(key) || {};
            delete _cache.className
            vueObj.formatItem(flex, e);
        }

        vueObj.deferred_formatItem.clear();
    }
    
    // R16 scrollBlank: догон отложенных ячеек кадрами с бюджетом времени (мс) —
    // хвост из тысяч ячеек (широкие отчёты) разбирается за несколько кадров,
    // а не капельными батчами 100/50мс
    _flushBudget(budgetMs) {
        const flex = this.vueObj.flex;
        const vRange = flex.viewRange;
        const t0 = performance.now();
        let processed = 0, outRange = 0;
        for (const [key, entry] of this._deferred) {
            const { panel, row, col, cell } = entry;
            this._deferred.delete(key);
            if ((row < vRange.topRow - 10 || row > vRange.bottomRow + 10) && panel === flex.cells) {
                outRange++;
                continue;
            }
            this._process(key, panel, row, col, cell);
            processed++;
            if (performance.now() - t0 > budgetMs) break;
        }
        if (this._deferred.size && !this._rafFlush) {
            this._rafFlush = true;
            requestAnimationFrame(() => { this._rafFlush = false; this._flushBudget(budgetMs); });
        }
    }

    _flush(reverse_, BATCH_SIZE) {
        const flex = this.vueObj.flex;
        const vRange = flex.viewRange;

        let processed = 0, outRange = 0;
        let rest = new Map();
        for (const [key, entry] of this._deferred) {
            const { panel, row, col, cell } = entry
            if ((row < vRange.topRow - 10 || row > vRange.bottomRow + 10) && panel === flex.cells) {
                outRange ++;
                continue;
            }

            if (!BATCH_SIZE || processed < BATCH_SIZE) {
                this._process(key, panel, row, col, cell);
                processed ++
            } else {
                rest.set(key, entry)
            }
        }

        this._deferred = rest;
        console.log(`_flush: processed ${processed} outRange ${this.outRange} + ${outRange} alreadyFormat ${this.alreadyFormat}`); //  rest ${this._deferred.size}
        this.alreadyFormat = 0; this.outRange = 0;

        if (this._deferred.size) {
            clearTimeout(this._flushTimeout);
            this._flushTimeout = window.$cg.setTimeout(this, "AttrGrid.CustomCellFactory", () => {
                this._flush(false, 100);
            }, 50);
        }
    }
    
    check_frozen(panel, cell, key, _cache) {
        const vueObj = this.vueObj;
        const flex = this.vueObj.flex;
        if (_cache.isFrozen) {
            if (_cache.fixStyle) {
                Object.assign(cell.style, _cache.fixStyle);
            } else {
                const left = _cache.frozenLeft
                if (left !== null && left !== undefined && cell.style.left !== left) {
                    cell.style.left = left;
                }
                if (vueObj.isScrollingX && panel === flex.cells) {
                    // this.fixAtCurrentPlace(cell, key, _cache)
                }
            }
        }
    }
    
    fixAtCurrentPlace(cell, key, _cache) {
        // const cellStyle = window.getComputedStyle(cell);
        const { left, top, width, height } = cell.getBoundingClientRect();
        const { left:left0, top:top0 } = cell.parentElement.getBoundingClientRect();

        _cache.prevStyle = {
            position: cell.style.position || '',
            left    : cell.style.left     || '',
            top     : cell.style.top      || '',
            width   : cell.style.width    || '',
            height  : cell.style.height   || '',
        }

        _cache.fixStyle = {
            position: 'fixed',
            left: (left) + 'px',
            top:  (top) + 'px',
            width: width + 'px',
            height: height + 'px',
        }
        Object.assign(cell.style, _cache.fixStyle);

        this._fixCells.set(key, cell);
    }

    unfixFromCurrentPlaceAll() {
        const vueObj = this.vueObj;
        for (const [key, cell] of this._fixCells) {
            let _cache = vueObj.cache_data_cells.get(key);
            if (!_cache.prevStyle) {
                console.log(`unfixFromCurrentPlaceAll: no prevStyle for key ${key}`);
            }
            Object.assign(cell.style, _cache.prevStyle);
            delete _cache.fixStyle
            delete _cache.prevStyle
        }
        this._fixCells.clear();
    }

    // disposeCell(cell) {
    //     console.log(`disposeCell`);
        
    //     // delete cell.data_cell;
    //     // delete cell.style.backgroundColor;

    //     super.disposeCell(cell);
    // }
}

class CustomMergeManager extends wjGrid.MergeManager {
    constructor(flex, vueObj) {
        super();
        this.vueObj = vueObj;
    }
    // булевы колонки НЕ участвуют в авто-мердже: невыставленный чекбокс
    // форматируется в '' и «пустая» ячейка всасывалась в текстовый корень —
    // флаг некуда поставить, а смерженный чекбокс непонятно к чему относится
    col_isBool(panel, c) {
        const b = panel.columns[c]?.binding
        const a = b && this.vueObj.attr_by_binding?.[b]
        return a?.attr_type === 'AttrBool' || rlMergeBarrier(a, this.vueObj._rlCols)   // IE 2026 10 25 / ODOO-348878 (заказ Игоря: подбор RowLink — Enter и закреплённые колонки) (p041): лист AttrRowLink — тоже барьер; прежде пустые ячейки подбора новой строки сливались в закреплённой области (mergeColumns = frozenColumns), правка уходила в корень, список не открывался
    }
    // IE 2026 09 17 / ODOO-… (заказ Игоря: «доработаем merge и в направлении назад»): диапазон [c1..c2], посчитанный
    // как раньше (значение + пустые справа, либо область одних пустых), расширяется на пустые колонки ПЕРЕД значением:
    // строка описана mergeBack_info (k — колонка значения, startCol — с какой колонки объединяем: не левее значка
    // свёртки и колонки родительской строки + 1, чтобы «лесенка» уровней сохранялась). Корень объединения у wijmo —
    // левая ячейка, значение в него дорисовывает mergeBack_apply, правка уходит в колонку значения (beginningEdit).
    mergeBack_extend(panel, irow, icol, c1, c2) {
        if (this.vueObj._mergeBackEditRow === irow || this.vueObj._mergeBackExportOff) return [c1, c2]   // IE 2026 09 18: строка в правке — без объединения «назад»; IE 2026 09 24 / ODOO-… (замечание Игоря: подписи строк в xlsx при объединении «назад»): на время выгрузки xlsx / pdf — тоже (mergeBack_exportOff)
        const mb = this.vueObj.mergeBack_info(panel, irow)
        if (!mb) return [c1, c2]
        if (c1 === mb.k) return [mb.startCol, c2]                       // диапазон значения — тянем влево
        if (c2 === mb.k - 1 && c1 <= mb.startCol) {                      // пустая область перед значением
            if (icol < mb.startCol) return [c1, mb.startCol - 1]         // ячейка левее начала объединения — остаётся в пустом диапазоне
            const kr = this.getMergedRange(panel, irow, mb.k, true)      // ячейка внутри объединения — диапазон значения
            return kr ? [kr.col, kr.col2] : [c1, c2]
        }
        return [c1, c2]
    }
    getMergedRange(panel, irow, icol, clip) {
        // const t0 = performance.now();
        // performance.mark(`mgStart`);
        // try {
            const vueObj = this.vueObj;
            if (irow === -1 || icol === -1) {
                return
            }
            // IE 2026 09 26 / ODOO-5800 (pageerror «reading 'dataMap'» при сужении отчёта, Demo 1EiJ_001: выделена колонка 21, после
            // перечитывания колонок 21): wijmo _syncSelection (itemsSource) спрашивает объединение по ПРЕЖНЕЙ колонке выделения ещё до
            // того, как сам её поправит; базовый MergeManager на ячейку вне панели отвечает null, а свой расчёт читал getCellData
            // несуществующей колонки. Ячейка вне панели — без объединения, как у wijmo. Выключатель fe.ux.gridSelOutOfRange (дефолт ВКЛ)
            if ((irow >= panel.rows.length || icol >= panel.columns.length) && vueObj?.store?.setting('fe.ux.gridSelOutOfRange', true) !== false) {
                vueObj.selOutOfRange_count?.('merge')
                return null
            }
            const flex = panel.grid;
            if (panel === flex.columnHeaders) {
                const mergeRange = super.getMergedRange(panel, irow, icol, clip);
                // // const value = panel.getCellData(irow, icol, true)
                // if (mergeRange && mergeRange.row === mergeRange.row2 && mergeRange.col === mergeRange.col2) {
                //     const nextValue = panel.getCellData(irow + 1, icol, true)
                //     if (typeof nextValue === 'string' && nextValue.includes('↑')) {
                //         return new wjGrid.CellRange(irow, icol, irow + 1, icol)
                //     }
                // }

                if (irow === vueObj.columnNumberRow) {
                    return new wjGrid.CellRange(irow, icol, irow, icol)
                } else if (vueObj.isMappedWidget_rows && irow === vueObj.isMappedWidget_rows) {
                    return new wjGrid.CellRange(irow, icol, irow, icol)
                } else if (vueObj.stickyScrollStart && irow >= vueObj.stickyScrollStart) {
                    return new wjGrid.CellRange(irow, vueObj.firstColumnIsVisible || 0, irow, panel.columns.length-1)
                }

                return mergeRange

            } else if (panel === flex.columnFooters) {
                // подпись Total в подвале агрегатов: растянуть ячейку первой
                // видимой колонки до первой значимой (см. aggregateFooters)
                const fr = vueObj.footerTotalRange
                if (fr && irow === 0 && icol >= fr.c1 && icol <= fr.c2) {
                    return new wjGrid.CellRange(0, fr.c1, 0, fr.c2)
                }
                return super.getMergedRange(panel, irow, icol, clip);
            } else if (panel === flex.rowHeaders) {
                // IE 2026 09 05 / ODOO-336283 (заказ Игоря): колонка-группа AttrTabHeader в панели заголовков строк —
                // подряд идущие строки с одним титулом группы = одна объединённая по вертикали ячейка (свёрнутые
                // строки прозрачны); остальные колонки шапки строк — как раньше
                const _rh = (vueObj.rowHeaders_cols_pos || []).find(x => x.col_idx === icol && x.mergeRows)
                if (_rh && vueObj.store.perf_flag('dl2_tabheader_merge', true)) {
                    const rowsH = panel.rows
                    const _get = (i) => rowsH[i]?.dataItem ? vueObj.store.get_value(rowsH[i].dataItem, _rh.binding) : undefined
                    const val = _get(irow)
                    if (val !== undefined && val !== null && val !== '') {
                        let r1 = irow, r2 = irow
                        while (r1 > 0) {
                            const rr = rowsH[r1 - 1]
                            if (!rr?.dataItem || !(rr.visibleIndex === -1 || _get(r1 - 1) === val)) break
                            r1--
                        }
                        while (r2 + 1 < rowsH.length) {
                            const rr = rowsH[r2 + 1]
                            if (!rr?.dataItem || !(rr.visibleIndex === -1 || _get(r2 + 1) === val)) break
                            r2++
                        }
                        while (r1 < irow && rowsH[r1].visibleIndex === -1) r1++
                        while (r2 > irow && rowsH[r2].visibleIndex === -1) r2--
                        return new wjGrid.CellRange(r1, icol, r2, icol)
                    }
                }
                return super.getMergedRange(panel, irow, icol, clip);
            } else if (panel !== flex.cells) {
                return super.getMergedRange(panel, irow, icol, clip);
            }

            // IE 2026 09 03 / ODOO-336283: колонка-группа (строка лэйаута AttrTabCol, поле с mergeRows):
            // подряд идущие ячейки с одним значением — одна объединённая по вертикали ячейка напротив
            // строк группы; скрытые (свёрнутые) строки прозрачны — диапазон на них не рвётся
            const mergeRowsBinding = panel.columns[icol]?.binding
            if (mergeRowsBinding && vueObj.attr_by_binding?.[mergeRowsBinding]?.mergeRows) {
                const rowsM = panel.rows
                const _rt0 = rowsM[irow]?.dataItem?._DLRow?.row_type
                const val = (_rt0 === 'tab' || _rt0 === 'tabrow') ? '' : rowsM[irow]?.dataItem?.[mergeRowsBinding]
                if (val === undefined || val === null || val === '') {
                    // пусто (строка вне групп) или полоса-заголовок: дальше — горизонтальный мерж шапки
                } else {
                let r1 = irow, r2 = irow
                while (r1 > 0) {
                    const rr = rowsM[r1 - 1]
                    if (!rr?.dataItem || !(rr.visibleIndex === -1 || rr.dataItem[mergeRowsBinding] === val)) break
                    r1--
                }
                while (r2 + 1 < rowsM.length) {
                    const rr = rowsM[r2 + 1]
                    if (!rr?.dataItem || !(rr.visibleIndex === -1 || rr.dataItem[mergeRowsBinding] === val)) break
                    r2++
                }
                while (r1 < irow && rowsM[r1].visibleIndex === -1) r1++
                while (r2 > irow && rowsM[r2].visibleIndex === -1) r2--
                return new wjGrid.CellRange(r1, icol, r2, icol)
                }
            }

            let merge = vueObj.get_cells(null, irow, icol)?.merge
            if (merge) {
                let irow2, irow1 = irow2 = irow,
                    icol2, icol1 = icol2 = icol

                // <<
                if (merge === 'left') {
                    while (icol1 > 0) {
                        const merge1 = vueObj.get_cells(null, irow, icol1 - 1)?.merge
                        if (merge1 === 'left') icol1 --
                        else if (merge1 === 'root') { icol1 --; break }
                        else if (merge1 === 'up') { icol1 --; merge = 'up'; break }
                        else break
                    }
                }

                // >>
                if (merge === 'root' || merge === 'left') {
                    while (icol2 < panel.columns.length - 1) {
                        const merge1 = vueObj.get_cells(null, irow, icol2 + 1)?.merge
                        if (merge1 === 'left') icol2 ++
                        else break
                    }
                }
                
                // up
                if (merge === 'up') {
                    while (irow1 > 0) {
                        const merge1 = vueObj.get_cells(null, irow1 - 1, icol1)?.merge
                        if (merge1 === 'up') irow1 --
                        else if (merge1 === 'root') { irow1 --; break }
                        else break
                    }
                }
                
                // down
                if (merge === 'root' || merge === 'up') {
                    while (irow2 < panel.rows.length - 1) {
                        const merge1 = vueObj.get_cells(null, irow2 + 1, icol1)?.merge
                        if (merge1 === 'up') irow2 ++
                        else break
                    }
                }

                return new wjGrid.CellRange(irow1, icol1, irow2, icol2)
            }

            // печатная форма: объединение ячеек по colspan/rowspan из
            // _cells.col_N (Merge right / Merge down в настройках ячейки).
            // Спаны ПРЕДВЫЧИСЛЯЮТСЯ индексом (raw-доступ без реактивных
            // прокси): прежний путь сканировал до 40 строк × все _cells на
            // КАЖДУЮ отрисовку ячейки — клик в большом превью замирал на
            // десять+ секунд (профиль: getMergedRange + proxy get). TTL 1с
            // подхватывает правки colspan в редакторе шаблона.
            if (panel === flex.cells && (vueObj.attr.isPrint || vueObj.attr.isPrintTemplate)) {
                const rowsP = panel.rows
                let mi = vueObj._printMergeIdx
                const nowTs = performance.now()
                if (!mi || mi.rows !== rowsP.length || mi.cols !== panel.columns.length
                        || nowTs - mi.ts > 1000) {
                    const colIndex = {}
                    for (let ci = 0; ci < panel.columns.length; ci++) colIndex[panel.columns[ci].binding] = ci
                    const spans = []
                    for (let r = 0; r < rowsP.length; r++) {
                        const di0 = rowsP[r].dataItem
                        const di = di0 && di0.__v_raw ? di0.__v_raw : di0
                        const ov = di && di._cells
                        if (!ov) continue
                        for (const cb in ov) {
                            if (!cb.startsWith('col_')) continue
                            const o = ov[cb]
                            if (!o) continue
                            const cs = parseInt(o.colspan) || 1
                            const rs = parseInt(o.rowspan) || 1
                            if (cs <= 1 && rs <= 1) continue
                            const c0 = colIndex[cb]
                            if (c0 == null) continue
                            spans.push({r1: r, r2: Math.min(r + rs - 1, rowsP.length - 1),
                                        c1: c0, c2: Math.min(c0 + cs - 1, panel.columns.length - 1)})
                        }
                    }
                    mi = vueObj._printMergeIdx = {rows: rowsP.length, cols: panel.columns.length, spans, ts: nowTs}
                }
                for (const sp of mi.spans) {
                    if (sp.r1 <= irow && irow <= sp.r2 && sp.c1 <= icol && icol <= sp.c2) {
                        return new wjGrid.CellRange(sp.r1, sp.c1, sp.r2, sp.c2)
                    }
                }
                return
            }

            if (vueObj.mergeColumnBlocksColMap) {
                const colMap = vueObj.mergeColumnBlocksColMap
                const mergeColumns2 = Math.max(vueObj.mergeColumnBlocksTotal, vueObj.mergeColumns || 0)
                const dataItem = panel.rows[irow]?.dataItem
                // строки с values_placement === 'none' мержим до конца строки, но только
                // в области данных (после mergeColumns2): корень merge не должен попадать
                // в frozen-колонки, иначе их клон (cloneFrozenCells) растягивается на всю
                // ширину и перекрывает прокручиваемую область (артефакт при прокрутке)
                const mergeToEnd = dataItem?._DLRow?.values_placement === 'none' && icol >= mergeColumns2
                const mergeBound = mergeToEnd ? panel.columns.length : mergeColumns2
                if (!mergeToEnd && icol >= mergeColumns2) {
                    return
                }
                if (dataItem?._DLRow?.mergeRow || dataItem?.MD?.mergeRow) { // MD.mergeRow — легаси, бэк транслирует в _DLRow (prepare_attrs)
                    return new wjGrid.CellRange(irow, 0, irow, panel.columns.length - 1)
                }

                const key = `${panel.cellType}-${irow}-${icol}`;
                let _cache = vueObj.cache_data_cells.get(key);
                if (!_cache) {
                    _cache = {key, index: ++ vueObj.cache_index};
                    vueObj.cache_data_cells.set(key, _cache);
                }

                if (!_cache.merge_calc) {
                    // единица мержа — блок (colSpan) или одиночная колонка за блоками
                    const unitOf = (c) => colMap[c] || {start: c, end: c, logCol: c}
                    const unitValue = (u) => panel.getCellData(irow, u.logCol, true)
                    // булевы единицы — барьер мержа (см. col_isBool).
                    // IE 2026 09 02 / ODOO-11316 (заказ Игоря): у строки с
                    // values_placement === 'none' булевы КОЛОНКИ пусты (чекбоксы — это
                    // values, они не выводятся) — барьер не действует, титул строки
                    // мержится и через них (М03: строка номенклатуры 33:5..33:8)
                    const noValsRow = dataItem?._DLRow?.values_placement === 'none'
                    const unitIsBool = (u) => {
                        if (noValsRow) return false
                        for (let c = u.start; c <= u.end; c++) if (this.col_isBool(panel, c)) return true
                        return false
                    }

                    const unit0 = unitOf(icol)
                    if (unitIsBool(unit0)) {
                        _cache.merge_col = _cache.merge_col2 = icol
                        _cache.merge_calc = true
                        return
                    }

                    // 1) root: идём влево по единицам пока пусто
                    // (для mergeToEnd — не выходим за границу области данных mergeColumns2)
                    const rootMin = mergeToEnd ? mergeColumns2 : 0
                    let root = unit0
                    while (root.start > rootMin && unitValue(root) === '') {
                        const prev = unitOf(root.start - 1)
                        if (unitIsBool(prev)) break
                        root = prev
                    }

                    // 2) от root идём вправо пока пусто (в пределах mergeBound)
                    // мержим как непустой root с пустыми справа,
                    // так и область, состоящую только из пустых ячеек
                    let end = root
                    while (end.end + 1 < mergeBound && end.end + 1 < panel.columns.length) {
                        const next = unitOf(end.end + 1)
                        if (unitValue(next) !== '' || unitIsBool(next)) break
                        end = next
                    }
                    _cache.merge_col = root.start
                    _cache.merge_col2 = end.end
                    _cache.merge_calc = true
                }

                // IE 2026 09 17 / ODOO-… (заказ Игоря, merge «назад»): пустые колонки перед значением входят в его объединение
                const _mbB = this.mergeBack_extend(panel, irow, icol, _cache.merge_col, _cache.merge_col2)
                if (_mbB[0] === _mbB[1]) {
                    return
                }
                return new wjGrid.CellRange(irow, _mbB[0], irow, _mbB[1])
            }

            const mergeColumns = vueObj.mergeColumns
            const row = panel.rows[irow]
            const dataItem = row?.dataItem
            // строки с values_placement === 'none' мержим до конца строки, но только
            // в области данных (после mergeColumns): корень merge не должен попадать
            // в frozen-колонки, иначе их клон (cloneFrozenCells) растягивается на всю
            // ширину и перекрывает прокручиваемую область (артефакт при прокрутке)
            const mergeToEnd = dataItem?._DLRow?.values_placement === 'none' && icol >= mergeColumns
            if (!mergeToEnd && (mergeColumns < 2 || icol >= mergeColumns)) {
                return // super.getMergedRange(panel, irow, icol, clip);
            }
            const mergeBound = mergeToEnd ? panel.columns.length : mergeColumns
            if (dataItem?._DLRow?.mergeRow || dataItem?.MD?.mergeRow) { // MD.mergeRow — легаси, бэк транслирует в _DLRow (prepare_attrs)
                return new wjGrid.CellRange(irow, 0, irow, panel.columns.length-1)
            }
            
            // // if (clip === void 0) {
            // //     clip = true
            // // }

            const key = `${panel.cellType}-${irow}-${icol}`;
            let _cache = vueObj.cache_data_cells.get(key);
            if (!_cache) {
                _cache = {key, index: ++ vueObj.cache_index};
                vueObj.cache_data_cells.set(key, _cache);
            }
            
            let { merge_calc, merge_col, merge_col2 } = _cache;
            if (!merge_calc) {
                // --- ВАЖНО: считаем rootCol и endCol так, чтобы они были ОДИНАКОВЫ для всех ячеек блока

                // булева ячейка сама не мержится (см. col_isBool).
                // IE 2026 09 02 / ODOO-11316 (заказ Игоря): у строки с values_placement
                // === 'none' булевы колонки пусты (values не выводятся) — барьер снят
                const noValsRow = dataItem?._DLRow?.values_placement === 'none'
                if (!noValsRow && this.col_isBool(panel, icol)) {
                    _cache.merge_col = _cache.merge_col2 = icol
                    _cache.merge_calc = true
                    return
                }

                // 1) rootCol: идём влево пока пусто (для mergeToEnd — не выходим за mergeColumns);
                // булевы колонки — барьер: через них не проходим и их не поглощаем
                const rootMin = mergeToEnd ? mergeColumns : 0
                let rootCol = icol;
                while (rootCol > rootMin) {
                    const v = panel.getCellData(irow, rootCol, true);
                    if (v !== '') break;
                    if (!noValsRow && this.col_isBool(panel, rootCol - 1)) break;
                    rootCol--;
                }

                // IE 2026 09 17 / ODOO-… (заказ Игоря: «доработаем merge и в направлении назад»): пустые колонки перед
                // значением блока входят в его объединение — расширение делает mergeBack_extend ниже (диапазон по
                // строке кэшируется в mergeBack_info); значение в корень дорисовывает mergeBack_apply.
                // IE 2026 09 17 / ODOO-…: rootCol здесь — как раньше (значение + пустые справа); расширение влево —
                // отдельным шагом mergeBack_extend после расчёта, чтобы кэш merge_col/merge_col2 ячейки оставался прежним.
                const srcCol = rootCol, blockStart = rootCol

                // 2) endCol: от srcCol идём вправо пока пусто (в пределах mergeBound)
                // мержим как непустой root с пустыми справа,
                // так и область, состоящую только из пустых ячеек
                let endCol = srcCol;
                while (
                    endCol + 1 < mergeBound &&
                    endCol + 1 < panel.columns.length
                ) {
                    if (!noValsRow && this.col_isBool(panel, endCol + 1)) break;
                    const vRight = panel.getCellData(irow, endCol + 1, true);
                    if (vRight === '') endCol++;
                    else break;
                }

                merge_col = blockStart;
                merge_col2 = endCol;
                _cache.merge_src = srcCol;

                _cache.merge_calc = true;
            }

            // если есть merge — возвращаем диапазон
            if (merge_col !== undefined || merge_col2 !== undefined) {
                _cache.merge_col = merge_col;
                _cache.merge_col2 = merge_col2;

                // если мы внутри блока — возвращаем один и тот же range
                let c1 = merge_col ?? icol;
                let c2 = merge_col2 ?? icol;
                // IE 2026 09 17 / ODOO-… (заказ Игоря, merge «назад»): пустые колонки перед значением входят в его объединение
                [c1, c2] = this.mergeBack_extend(panel, irow, icol, c1, c2);

                if (icol >= c1 && icol <= c2 && c1 !== c2) {
                    return new wjGrid.CellRange(irow, c1, irow, c2);
                }
            }

            // иначе не мержим
            return;

        // } finally {
        //     performance.mark(`mgEnd`);
        //     performance.measure('mergeRange', `mgStart`, `mgEnd`);
        //     performance.clearMarks(`mgStart`);
        //     performance.clearMarks(`mgEnd`);
        //     performance.clearMeasures('mergeRange');
        //     vueObj.TIME.getMergedRange_time  += performance.now() - t0;
        //     vueObj.TIME.getMergedRange_count ++
        // }
    }
}

let tooltip = new wjcCore.Tooltip({
    // showAtMouse: true,
    showDelay: 1500,
})

// френдли-тултип узких заголовков при ВЫКЛЮЧЕННОМ Show tooltips:
// показ управляется вручную (таймеры в headerTooltip_over)
let headerTip = new wjcCore.Tooltip({
    showDelay: 0,
})

var __extends = (this && this.__extends) || (function() {
    var extendStatics = function(d, b) {
        extendStatics =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
                function(d, b) {
                    d.__proto__ = b;
                }) ||
            function(d, b) {
                for (let p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype =
            b === null
                ? Object.create(b)
                : ((__.prototype = b.prototype), new __());
    };
})()

export default {
    components: { SegSwitch },   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p189 єдиний вигляд полос перемикачів — заголовки, відступи, Alt-підказки пунктів)
    props: {
        widget_id: [String, Number],
        attr_id: String,
        initialAttr: {
            type: Object,
            default: null,
        },
        parentAttr: { // объект вкладки от рендерящего AttrTab/AttrTabRow (tabs_noId)
            type: Object,
            default: null,
        },
    },
    data: () => ({
        WIDGET: {},
        data: [],
        liveChip: liveChip_new(),   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска): набранный в полосе чипсов текст (до Enter) — чипс поиска с «Show rows without matches», только в памяти грида
        grid_isEmpty: true, // нет видимых колонок — грид скрыт (см. gridClass/refreshed)
        deletedItems: [],
        // columns: [],
        col_input: {},
        attr_by_binding: {},
        itemsSource_by_binding: {},
        column_by_binding: {},
        // R1 (fastEntry.holdTitles): сегменты Link-колонок, тайтлы которых ещё не
        // приехали на первом пакете данных; пока не null — виджет держит скелетон
        // (WIDGET._gridTitlesPending), чтобы кадр с сырыми id не мелькал
        titles_pending: null,
        allow_formatItem:true,
        tooltip_html:'',
        colorPicker: null,
        applyFillColor: null,
        // IE 2026 09 04 / ODOO-336283: CSS-дефолт полосы-заголовка (Tab / Tab row) — зелёная нижняя половина строки;
        // дубликат бэковского data_layout2.DL2_BAND_STYLE_DEFAULT (менять синхронно)
        DL2_BAND_STYLE_DEFAULT: 'linear-gradient(to bottom, transparent 50%, #92d050 50%)',
        applyRowStyle: null, // rowStyleButtons: CSS-свойство цвета ('color' | 'background-color' | 'border-*-color') — пишем в поле style строки
        rowStyleCombo: null, // rowStyleButtons: комбобокс ручного ввода значения (Custom...)
        rowStyleComboProp: null, // CSS-свойство, для которого открыт rowStyleCombo

        TIME: {
            getMergedRange_time: 0,
            getMergedRange_count: 0,
            formatItem_time: 0,
            formatItem_count: 0,
        },
        
        multiLevel: 0, // 10
       
        commandPanel_topLeft: [],
        show_commandPanel_topLeft: false,
        commandPanel_topLeft_maxHeight: null,

        groupIndex: -1,

        headerRows: 0,
        headerColumns: 0,
        row_bottom: 0,
        column_left: 0,
        rowHeaders_col_selector: null,
        rowHeaders_col_use: null,
        rowHeaders_cols_pos: [],
        rowHeaders_col_feSelected: null,
        showFeSelected: false,

        use_rowNumberColumn: true,
        rowNumberColumn: null,
        columnNumberColumn: null,

        useColumnNumberRow: true,
        useColumnNumberRow_filter: true,
        columnNumberRow: null,

        stickyScrollStart: null,
        frozenColumns_safe: null, // клэмп frozen: граница не должна резать группу колонок
        colorEd: { open: false, left: 0, top: 0, picker: null, hex: '', invalid: false, light: false, portal: null },   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: цвета как на слайде — редактор цвета ColorPicker): всплывающая палитра редактора ячейки
        ctxMenuPop: { title: '', subtitle: '', icon: '', items: [] },   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк)
        stickyScrollRows: [],
        rowLevelGroup_ranges_length: 0,
        
        isMappedWidget_rows: 0,
        isMappedWidget_cols: 0,

        changesStack: {},
        backendStack: {},
        backendProcessed: false,

        undoStack: [],
        redoStack: [],
        modified: false,
        gridSave_count: 0,   // IE 2026 10 13 / ODOO-5800: изменённых строк ленивого грида с saveMethod (полоса Save)
        gridSave_saving: false,   // IE 2026 10 13 / ODOO-5800: запрос saveMethod в полёте
        // выпадающая история Undo/Redo (список последних действий)
        historyMenu: { show: false, mode: 'undo', items: [], hover: -1, style: {} },

        irefresh: 0,
        divCells: new Map(),
        cache_data_cells: new Map(),
        cache2_data_cells: new Map(),
        css_relevance: 0,
        cache1_data_cells__call: new Map(),
        cache2_data_cells__call: new Map(),
        cache2_data_cells__call__used: 0,
        cache_process_dataItem_py: new Map(),
        cache_process_dataItem_py__used: 0,
        cache_index: 0,
        deferred_formatItem: new Map(),
        cells_doc: {},
        cells_binding_map: {},
        stickyRowsHeaders: [],

        
        actionStack: 0,
        canUndo: false,
        canRedo: false,
        actionCount: 0,
        pastedVal: null,
        newVal: null,
        lightView_active: false, // текущий лёгкий вид (кэш для formatItem, см. lightView_apply)
        aggAll_showAll: false, // тумблер "All" сводной таблицы (agg_sources): строки всех источников / только основного

        lastAction_sid: 0,
        break_width: 15,

        commandPanel: [],
        sigPie: null,   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: агрегат сигналов кругом в кнопке; проблемы подсказки в одну строку, клик — форма ячейки): модель диаграммы-агрегата сигналов (utils/signalsAggregate.signalsAgg_model), пересчёт с дебаунсом (sigPie_schedule)
        showFmTestDialog: false,
        fmTestNow: '',
        commandPanelMaxVisible: Infinity,
        commandPanelAreaWidth: null,
        commandPanelMenuWidth: null,
        commandPanelResizeObserver: null,
        actionMenu: [],
        ind_commandPanel: 0,
        hslGroups: {},

        topLeftMenu_cssClass: 'pi-arrow-right',
        currentSelectionHTML: '',
        currentSelectionHTML_base: '',
        conditions_multi: ['in', 'NOT in', 'LIKE', 'NOT LIKE', 'between'],

        allowDragging: false,

        value_multi_inEdit: {},

        frmModifyChip: null,
        visibility: true,
        lastScroll: { left: 0, top: 0 },
        
        use_performance: false,
        performance_data:{},
        performance_maxTime: 2,

        performanceView: {
            t0: null,
            count: 0,
            time: 0,
            maxTime: 0,
            cells_count: 0,
            cells_time: 0,
        },

        // template for buttons on AttrLink
        // IE 2026 09 23 / ODOO-341407: i18n (aria-label)
        tplBtn:{
            AttrDoc_choice:
                `<span wj-part="btn" class="wj-input-group-btn cell-value-show">
                    <button class="wj-btn wj-btn-default attr-doc-button my-text-shadow" id="onСhoice__Click" tabindex="-1" type="button" aria-label="${t('Toggle choose in list')}">
                        <i class="pi pi-doc pi-ellipsis-h" id="onСhoice__Click"></i>
                    </button>
                </span>`,
            AttrDoc_showDroppedDown:
                `<span wj-part="btn" class="wj-input-group-btn cell-value-show">
                    <button class="wj-btn wj-btn-default attr-doc-button my-text-shadow" id="onButtonShowDroppedDown__Click" tabindex="-1" type="button" aria-label="${t('Select')}">
                        <i class="pi pi-doc pi-angle-down" id="onButtonShowDroppedDown__Click"></i>
                    </button>
                </span>`,
            AttrDoc_open:
                `<span wj-part="btn" class="wj-input-group-btn cell-value-show">
                    <button class="wj-btn wj-btn-default attr-doc-button my-text-shadow" id="onButtonOpen__Click" tabindex="-1" type="button" aria-label="${t('Internal link')}">
                        <i class="pi pi-doc pi-arrow-right" id="onButtonOpen__Click"></i>
                    </button>
                </span>`,
            AttrDoc_search:
                `<span wj-part="btn" class="wj-input-group-btn">
                    <button class="wj-btn wj-btn-default attr-doc-button my-text-shadow" id="onButtonSearch__Click" tabindex="-1" type="button" aria-label="${t('Search')}">
                        <i class="pi pi-doc pi-search" id="onButtonSearch__Click"></i>
                    </button>
                </span>`,
            OpenGroup:
                `<div role="button" class="wj-elem-collapse" id="onButtonCollapsed__Click">
                    <span class="pi pi-doc pi-plus-circle" id="onButtonCollapsed__Click"></span>
                </div>`,
            CloseGroup:
                `<div role="button" class="wj-elem-collapse" id="onButtonCollapsed__Click">
                    <span class="pi pi-doc pi-minus-circle" id="onButtonCollapsed__Click"></span>
                </div>`,
            ApplySelector:
                `<span wj-part="btn" class="wj-input-group-btn">
                    <button class="wj-btn wj-btn-default attr-doc-button my-text-shadow" id="onSelector__Click" tabindex="-1" type="button" aria-label="${t('Internal link')}">
                        <i class="pi pi-doc pi-check-square" id="onSelector__Click"></i>
                    </button>
                </span>`
        },

        CellTypeName: {
            0: 'None',
            1: 'Cell',
            2: 'ColumnHeader',
            3: 'RowHeader',
            4: 'TopLeft',
            5: 'ColumnFooter',
            6: 'BottomLeft',
            7: 'Filter',
        },
    }),
    setup() {
        const store = useMainStore()
        return { store }
    },
    created() {
        // if (!this.store.hide_console) console.log(`created ${this.attr_id}`)
        // IE 2026 10 02 / ODOO-5800: flex (wijmo FlexGrid) присваивается в initialized(); до него шаблон
        // (cellFormTag_here/off) читал необъявленное свойство — «[Vue warn]: Property "flex" was accessed
        // during render but is not defined on instance» ×150 на загрузку. Объявляем НЕреактивно (не в data —
        // wijmo-объект нельзя заворачивать в reactive): null до инициализации.
        this.flex = null
        // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL2: экранные кэши ячеек (cache_data_cells — снимки className / cssText, divCells — DOM-элементы ячеек) читаются и пишутся
        // formatItem-ом на КАЖДУЮ ячейку каждой перерисовки; в data() они реактивные — каждое get / set идёт через прокси Vue (замер dev02 M03 45×91,
        // коммит флажка: перерисовка 1,1 с → 0,9 с). Шаблон, computed и watch их не читают — реактивность не нужна. Выключатель fe.ux.gridCacheRaw (дефолт ВКЛ;
        // выкл — как прежде, реактивные; действует с открытия виджета)
        if (this.store.setting('fe.ux.gridCacheRaw', true) !== false) { this.cache_data_cells = markRaw(new Map()); this.divCells = markRaw(new Map()) }
        const WIDGET = this.WIDGET = this.store.findWidget(this.widget_id).WIDGET
        // IE 2026 08 20 / ODOO-336291 (mobile UX) (#4193): кнопка правого стека шлёт тик — открыть dropdown текущей ячейки
        // 21.08: открытие ПОСЛЕ завершения клика по кнопке — иначе тот же клик закрывал dropdown как 'внешний'
        // IE 2026 09 04 / ODOO-336291 (mobile UX): P-20 cellSyncFast — открытие сразу после завершения клика (таймер 0 вместо 80 мс:
        // click кнопки уже отработал, «внешним» для dropdown он не будет)
        this.$watch(() => this.store.mobileCellDropdownTick, () => window.$cg.setTimeout(this, 'mobDdOpen', () => this.mobileOpenCellDropdown(), this.store.mobileUi?.cellSyncFast !== false ? 0 : 80))
        this.$watch(() => this.store.mobileCellOpenTick, () => this.mobileOpenCellLink())
        // initialAttr — ДО content_Changed: полоса AttrTabGridLanes передаёт attr
        // объектом без attr_id, и content_Changed_main требует this.attr
        if (this.initialAttr) {
            this.attr = this.initialAttr
            // IE 2026 08 19 / ODOO-5512: initialAttr-гриды не попадают в attrs_vueObj
            // (нет attr_id) — обратная ссылка для хоста (список настроек в дропдауне)
            // IE 2026 10 25 / ODOO-348878 (hotfix: ⚙ шахматки — циклическая ссылка в attr): ссылка — неперечислимым свойством; прежде (this.attr.vueObj = this) ключ копировался в запись формы вида ⚙ (mainStore, widget-row-viewParams:
            // все ключи attr, кроме служебных) — компонент → initialAttr → vueObj: JSON.stringify в send_widgetOpen падал, форма «View …» пустая, следующий ⚙ — бесконечная рекурсия
            setAttrBackRef(this.attr, 'vueObj', this)
        }
        this.content_Changed({isVue:true})
        // this.attr.groupMenu = {
        //     commandPanel: [
        //         {"tooltip":"Select","command":"executeWidgetMethod","method":"select","cssClass":"pi pi-refresh","type":"AttrButton","id":"root_4_AttrButton","html_id":"root_4_AttrButton","component":"AttrButton","attrs":[]}
        //     ],
        // }

        const WORKSPACE = this.store.WORKSPACES[WIDGET.workspace]
        this.PAGE = WORKSPACE.PAGES[WIDGET.page]
    },
    mounted() {
        this._secOptH = (ev) => this.sec_onDisplayOption(ev); window.addEventListener('fe-display-option', this._secOptH)   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: мягкие разделители разделов и монохром — опции)
        this.WIDGET.attrsResize = this.WIDGET.attrsResize || []
        this.WIDGET.attrsResize.push(this.attrResize)
        this._dispOptH = (e) => this.displayOption_changed(e && e.detail)   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: все варианты отображения — во вкладке Display шестерёнки, не на форме): выбор во вкладке Display ⚙ — перерисовать
        window.addEventListener(DISPLAY_EVENT, this._dispOptH)   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: все варианты отображения — во вкладке Display шестерёнки, не на форме)
        this.sameValue_busInit()   // IE 2026 09 17 / ODOO-… (замечание Игоря): слушаем выбор ячейки в других виджетах страницы
        try { if (this.WIDGET?._formatAuto && this.attr?.name === 'dataSheet') this.formatAuto_wait() } catch (e) { /* заявки нет */ }   // IE 2026 09 20 / ODOO-5800: заявка на чипс оформления пережила пересоздание грида

        // dropdown.show() flips `visible` inside a 100ms timer, so reading it right
        // after show() is stale. Watch the reactive visible/key instead and refresh
        // the cell chevrons exactly when visibility actually changes (any trigger).
        this._unwatch_dropdownToggle = this.$watch(
            () => {
                const d = this.store.dropdown
                return d ? `${d.visible ? 1 : 0}:${d.key || ''}` : ''
            },
            () => { this.refresh_dropdownToggles(); this.influence_dropdownSync() }   // IE 2026 09 19 / ODOO-… (замечание Игоря: формула расчёта остатка — внутри формы ячейки, когда форма выведена)
        )

        if (this.itemsSourcesView_grid()) {
            // реактивный пересчёт колонки use таблицы-реестра при любых изменениях
            // целевого грида: флаг use, удаление/вставка/правка строк, смена целевого грида
            this._unwatch_itemsSourcesView = this.$watch(
                () => {
                    const target = this.get_itemsSourcesView_target()
                    if (!target) return ''
                    const parts = []
                    const collect = (rr, deep) => {
                        for (const r of Array.isArray(rr) ? rr : []) {
                            const key = this.itemsSourcesView_target_key(r, target.mode)
                            if (key) parts.push(`${key}:${r.use !== false ? 1 : 0}`)
                            if (deep) collect(r.attrs, deep)
                        }
                    }
                    collect(target.data || [], target.mode === 'row')
                    return parts.join('|')
                },
                () => {
                    if (!Array.isArray(this.data)) return
                    this.itemsSourcesView_recalc_use(this.data)
                    if (this.flex?.hostElement) this.flexRefresh()
                }
            )
        }

        // АН 2026 08 15 / ODOO-4997: страничные каналы симуляции/подсветки —
        // (1) подсветка строк по измерениям, выделенным в графе Supply Chain Flow;
        // (2) ретрансляция sim-изменений: ответ пришёл виджету-отправителю, а
        // целевые строки живут в другом инстансе грида (Гант: секции Busy/Free)
        this._dimHighlightHandler = (ev) => this.applyDimHighlight(ev?.detail)
        window.addEventListener('wscm-dim-highlight', this._dimHighlightHandler)
        // АН 2026 08 15 / ODOO-4997: ссылка на компонент с DOM-корня грида —
        // для диагностики/автотестов (как __vueGraph у графа)
        this.$nextTick(() => { try { if (this.flex?.hostElement) this.flex.hostElement.__vueGrid = this } catch (e) { /* грид мог не иниться — хук диагностический */ } })
        this._simRelayHandler = (ev) => {
            const d = ev?.detail
            if (!d || d.source_widget === this.WIDGET?.id) return
            try { this.sim_applyChanges({ sim: d.sim, _simRelay: true, objects: d.objects }) } catch (e) { /* чужой формат — молча */ }   // IE 2026 09 25 / ODOO-5800 (D4): objects
        }
        window.addEventListener('wscm-sim-changes', this._simRelayHandler)
        // IE 2026 09 24 / ODOO-341407 (поручение Игоря: смена языка без перезагрузки): шапки колонок — из attrs вида (перелокализованы на
        // клиенте, phase 'attrs'), командная панель / меню таблицы — пересборка (строки t() кэшируются при сборке), invalidate —
        // строки wijmo и форматы (fe.i18n.formatsCulture='auto') перечитывают культуру
        this._i18nHandler = (ev) => {
            const phase = ev?.detail?.phase || ''
            // IE 2026 09 25 / ODOO-341407: фоновое перечитывание словарей после переключения (relocalize, phase 'dicts') — только перепривязать dataMap
            // ссылочных колонок (в т.ч. у грида страницы в KeepAlive: вотчер itemsSource_change_index там не отрабатывает — Sales$ держал подписи
            // MEASURE прежнего языка до пересборки)
            if (phase === 'dicts') {
                try { if (this.i18n_rebindDataMaps() && this.flex?.hostElement) this.flex.invalidate() } catch (e) { console.warn('[i18n] grid dataMaps (background)', e) }
                return
            }
            try {
                const n = this.i18n_relabelColumns()
                if (phase === 'attrs') { try { this.set_commandPanel() } catch (e) { console.warn('[i18n] grid command panel', e) } }
                // IE 2026 09 24 / ODOO-341407 (проверка dev02: после живого переключения поля формы INFO оставались на прежнем языке — подпись
                // «Підказка» и значение-перевод под ru / en): строки AttrTabGrid — копии узлов вида (attrsTabGrid_from_attrs), relocalize
                // переводит сами узлы; пересобираем строки формы — подписи из перелокализованных узлов, значения полей translate по правилу
                // отображения нового языка (attr_get → {binding}_{lang} → база), ссылки — по перечитанным справочникам (phase 'data')
                // (открытая форма ячейки этого грида / правка ячейки — не пересобираем: phase 'data' приходит через 10–15 с после переключения)
                if ((phase === 'attrs' || phase === 'data') && this.attr?.attr_type === 'AttrTabGrid' && !this.flex?.activeEditor
                    && !(this.store.dropdown?.visible && this.store.dropdown.vueObj === this)) {
                    try { this.content_Changed({ isVue: true }) } catch (e) { console.warn('[i18n] form rows', e) }
                }
                if (phase === 'data') { try { this.i18n_rebindDataMaps() } catch (e) { console.warn('[i18n] grid dataMaps', e) } }   // IE 2026 09 24 / ODOO-341407: справочники перечитаны — свежие dataMap ссылочных колонок
                // IE 2026 09 24 / ODOO-341407: строка Σ выделения (Cnt / Avg … и длительности «5 міс 19 дн») собирается при смене выделения — пересчитать под новым языком;
                // ячейки длительностей перерисует invalidate ниже (formatItem → formatDaysHTML / formatTimeHTML под текущий язык)
                if (phase === 'ui' && this.flex) { try { this.showGridSummaryLine() } catch (e) { console.warn('[i18n] grid summary line', e) } }
                // IE 2026 09 24 / ODOO-341407 (проверка dev02: после живого переключения панель шестерёнки — «Frozen columns», «Frozen rows»,
                // «Rows height (1 - 7)» … — оставалась на прежнем языке): commandPanel_topLeft собирается один раз (set_commandsActive, строки t()
                // кэшируются в attrs) — сбрасываем, следующий показ собирает его под новым языком; показанную сейчас — пересобираем сразу
                if (phase === 'ui' && this.commandPanel_topLeft?.length) {
                    const shown = this.show_commandPanel_topLeft
                    this.commandPanel_topLeft = []
                    if (shown) this.$nextTick(() => { try { this.set_commandsActive() } catch (e) { console.warn('[i18n] grid view params panel', e) } })
                }
                if (this.flex?.hostElement) this.flex.invalidate()
                if (n && !this.store.hide_console) console.log(`[i18n] grid ${this.attr?.name || this.attr_id}: ${n} column headers relabelled`)
            } catch (e) { console.warn('[i18n] grid relabel', e) }
        }
        window.addEventListener('i18n:changed', this._i18nHandler)
        this._tlsOptHandler = (ev) => this.tls_option(ev)   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: стили уровней дерева — опции A/B/C/E/F): опции вкладки Display на лету
        window.addEventListener('fe-display-option', this._tlsOptHandler)   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: стили уровней дерева — опции A/B/C/E/F)
    },
    beforeUnmount() {
        if (this._dispOptH) window.removeEventListener(DISPLAY_EVENT, this._dispOptH)   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: все варианты отображения — во вкладке Display шестерёнки, не на форме)
        if (this._secOptH) window.removeEventListener('fe-display-option', this._secOptH)   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: мягкие разделители разделов и монохром — опции)
        try { this.planApproval_headerSync(null) } catch (e) { /* шапки нет */ }   // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239): кнопка шапки уходит вместе с гридом
        try { const by = this.WIDGET?._yearTotalsHasBy; if (by) yearTotals_hasMerge(by, 'g' + this.$.uid, null) } catch (e) { /* без итогов */ }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p233 Σ не смикає панель команд): ушедший грид не держит Σ в шапке
        try { this.colorEd_close() } catch (e) { /* палитра не открыта */ }   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: цвета как на слайде — редактор цвета ColorPicker): снять слушатели палитры
        if (this._i18nHandler) window.removeEventListener('i18n:changed', this._i18nHandler)   // IE 2026 09 24 / ODOO-341407
        if (this._tlsOptHandler) window.removeEventListener('fe-display-option', this._tlsOptHandler)   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: стили уровней дерева — опции A/B/C/E/F)
        try { clearTimeout(this._sigPieT); if (this._sigPieIdle) { this._sigPieIdle(); this._sigPieIdle = null } const d = this._sigTipDoc; if (d && d.off) { d.off(); this._sigTipDoc = null } else if (d) { document.removeEventListener('click', d.onClick, true); document.removeEventListener('mouseover', d.onOver, true); this._sigTipDoc = null } } catch (e) { /* слушателей нет */ }   // IE 2026 11 03 / ODOO-350449 (webscm #128539: одна пара слушателей document на все гриды): общая пара — снять регистрацию грида; + отмена расчёта круга в простое   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: агрегат сигналов кругом в кнопке; проблемы подсказки в одну строку, клик — форма ячейки)
        try { this.sigPrefetch_cancel(true) } catch (e) { /* очереди нет */ }
        try { this.stk_cancel(true) } catch (e) { /* очереди нет */ }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: виды ячеек запаса под ключ — Z5 по умолчанию; BE ie-dm7 stock_cells_batch)   // IE 2026 11 03 / ODOO-350449 (Игорь: предзагрузка цепочек сигналов; BE ie-dm7 #1009): закрытие виджета — очередь предзагрузки снята, ответ порции в полёте отбрасывается
        try { clearTimeout(this._gridSaveT); const _gs = this.WIDGET?._gridSave?.[this.attr?.binding]; if (_gs && _gs.vm === this) _gs.vm = null } catch (e) { /* нет состояния */ }   // IE 2026 10 13 / ODOO-5800: компонент грида не держится в состоянии полосы Save
        try { clearTimeout(this._metricHitT); metricHit_ranges(this.sameValue_busKey() + ':' + (this.attr?.html_id || this.attr?.name || ''), [], []) } catch (e) { /* реестр подсветки недоступен */ }   // IE 2026 09 20 / ODOO-5800 (Igor: переходы чипса метрик по ячейкам, подсветка параметра ячейки и подпадающих ячеек по наведению на чипс)
        // АН 2026 08 15 / ODOO-4997: снять страничные слушатели
        this._cmUnsub?.(); this._cmUnsub = null; this._cmUnsubCh?.(); this._cmUnsubCh = null; if (this._cmKey) cellMatch_ranges(this._cmKey, null)   // IE 2026 09 17: снять подсветку одинакового текста этого грида
        if (this._dimHighlightHandler) window.removeEventListener('wscm-dim-highlight', this._dimHighlightHandler)
        if (this._simRelayHandler) window.removeEventListener('wscm-sim-changes', this._simRelayHandler)
        if (this._bpPaintTimer) clearTimeout(this._bpPaintTimer)
        if (this._formatAuto_t) { clearInterval(this._formatAuto_t); this._formatAuto_t = null }   // IE 2026 09 20 / ODOO-5800 (ожидание словаря чипса оформления)
        this.titles_release('unmount') // R1: не оставить виджету висящий _gridTitlesPending
        this._unwatch_itemsSourcesView?.()
        clearTimeout(this._isv_position_timer)
        this.selectorAllMenu_hide(true)
        this.selectorAllMenu_unsuppress() // снять document-слушатель ухода курсора
        this._foldBadges_hide?.() // панель бейджей живёт в body — убрать явно
        this.commandPanelResizeObserver?.disconnect()
        if (this._cpRafId) cancelAnimationFrame(this._cpRafId)
        if (this._hdrClipRaf) cancelAnimationFrame(this._hdrClipRaf) // IE 2026 09 04 / ODOO-336291 (mobile UX): P-07
        if (this._mbRaf) cancelAnimationFrame(this._mbRaf) // P-08
        if (this._mobCellRaf) cancelAnimationFrame(this._mobCellRaf) // P-20
        this._unwatch_dropdownToggle?.()
        this.store.attr_destroyPyodide(this)
        this.store.attr_deregister(this)
    },
    methods: {
        updateCommandPanelOverflow() {
            if (this._cpRafId) cancelAnimationFrame(this._cpRafId)
            this._cpRafId = requestAnimationFrame(() => {
                this._cpRafId = null
                if (!this._cpItemWidths?.length) return
                const cpArea = this.$refs.commandPanelArea
                const topLine = this.$refs.attr_top_line
                if (!cpArea || !topLine) return
                if (!topLine.clientWidth) return // вкладка скрыта — нулевые замеры испортят ширины
                // замеры, сделанные на скрытой вкладке (offsetWidth = 0), — переснять при показе
                if (this._cpItemWidths.every(w => !w)) {
                    const menuEl = this.$refs.commandPanelMenu
                    const widths = menuEl ? Array.from(menuEl.children).map(el => el.offsetWidth) : []
                    if (!widths.some(w => w)) return
                    this._cpItemWidths = widths
                }
                const chipsEl = topLine.querySelector('.grid-chips')
                // Chips desired single-line width: sum children + gaps(4px) + padding(8px)
                let chipsDesiredWidth = 130
                if (chipsEl) {
                    const inputContainer = chipsEl.querySelector('.input-container')
                    if (inputContainer) {
                        const children = Array.from(inputContainer.children)
                        const sumW = children.reduce((s, el) => s + el.offsetWidth, 0)
                        chipsDesiredWidth = Math.max(sumW + Math.max(children.length - 1, 0) * 4 + 8, 130)
                    }
                }
                // available считаем от СТАБИЛЬНОЙ ширины всей верхней линии:
                // текущие ширины cpArea/чипс-блока зависят от числа показанных
                // кнопок (перенос чипсов на 2 строки двигает их на десятки px) —
                // обратная связь зацикливала показ/скрытие кнопок (моргание на
                // узких виджетах DataHub), гистерезис ниже её не гасил
                let fixedW = 0
                for (const ch of topLine.children) {
                    if (ch === cpArea || ch === chipsEl) continue
                    const cs = getComputedStyle(ch)
                    if (cs.position === 'absolute' || cs.display === 'none') continue
                    fixedW += ch.offsetWidth + menuPanelHost_marginLeft(ch.classList, cs.marginLeft) + (parseFloat(cs.marginRight) || 0)   // IE 2026 09 28 / ODOO-342342: авто-отступ прижатого вправо ⚙ / ≡ — свободное место, не занятое
                }
                const available = Math.max(topLine.clientWidth - fixedW - (chipsEl ? chipsDesiredWidth : 0), 0)
                let total = 0
                let maxVisible = this._cpItemWidths.length
                for (let i = 0; i < this._cpItemWidths.length; i++) {
                    total += this._cpItemWidths[i]
                    if (total > available) { maxVisible = i; break }
                }
                // If some items overflow, reserve space for the overflow button and recalculate
                let overflowBtnWidth = 0
                if (maxVisible < this._cpItemWidths.length) {
                    const overflowBtnEl = cpArea.querySelector('.commandPanel-overflow-btn')
                    overflowBtnWidth = overflowBtnEl ? overflowBtnEl.offsetWidth : 28
                    const availableForItems = Math.max(available - overflowBtnWidth, 0)
                    total = 0
                    maxVisible = this._cpItemWidths.length
                    for (let i = 0; i < this._cpItemWidths.length; i++) {
                        total += this._cpItemWidths[i]
                        if (total > availableForItems) { maxVisible = i; break }
                    }
                }
                // гистерезис против моргания: на малой ширине с чипсами ширина
                // чипс-блока зависит от ширины самой панели (перенос строк) —
                // расширяемся только при запасе ≥24px, сжимаемся как обычно
                if (maxVisible > this.commandPanelMaxVisible && Number.isFinite(this.commandPanelMaxVisible)) {
                    const availableGuard = Math.max(available - 24, 0)
                    let t = 0, mv = this._cpItemWidths.length
                    for (let i = 0; i < this._cpItemWidths.length; i++) {
                        t += this._cpItemWidths[i]
                        if (t > availableGuard) { mv = i; break }
                    }
                    if (mv <= this.commandPanelMaxVisible) maxVisible = this.commandPanelMaxVisible
                }
                // анти-флаппинг: чипсы эластичные (усекаются/переносятся), их
                // замеры меняются от самого показа/скрытия кнопок — расчёт может
                // колебаться сжатие↔расширение несколько раз в секунду (моргание
                // узких виджетов DataHub). Если сразу после сжатия при ТЕХ ЖЕ
                // условиях (ширина линии + состав чипсов) хотим расшириться —
                // блокируем расширение, пока условия реально не изменятся
                const _cpSig = topLine.clientWidth + '|'
                    + (chipsEl?.querySelector('.input-container')?.children.length ?? -1)
                if (maxVisible > this.commandPanelMaxVisible && Number.isFinite(this.commandPanelMaxVisible)) {
                    if (this._cpFlapBlockSig === _cpSig) {
                        maxVisible = this.commandPanelMaxVisible
                    } else if (this._cpShrink && Date.now() - this._cpShrink.t < 1000
                            && this._cpShrink.sig === _cpSig) {
                        this._cpFlapBlockSig = _cpSig
                        maxVisible = this.commandPanelMaxVisible
                    } else {
                        this._cpFlapBlockSig = null
                    }
                }
                // ИЕ 2026-08-14: автогаситель моргания при сжатии виджета до малых
                // размеров. Сценарий, который прежние guard'ы не покрывали: показ
                // кнопки двигает чипс-блок → чипсы переносятся/усекаются → ширина
                // линии сама меняется (скроллбар/перенос) → подписи _cpSig чередуются
                // A/B и flap-block не срабатывает — панель мигает. Детектор: ≥3
                // переключений mv за 1.5с в узкой полосе ширин (<48px) = осцилляция;
                // клэмпим панель к МЕНЬШЕМУ mv, пока ширина не выйдет из полосы
                // (реальное растягивание её снимает само)
                {
                    const wNow = topLine.clientWidth
                    if (this._cpClamp && (wNow < this._cpClamp.lo || wNow > this._cpClamp.hi)) this._cpClamp = null
                    if (this._cpClamp && maxVisible > this._cpClamp.mv) maxVisible = this._cpClamp.mv
                    if (maxVisible !== this.commandPanelMaxVisible && Number.isFinite(this.commandPanelMaxVisible)) {
                        const now = Date.now()
                        this._cpFlips = (this._cpFlips || []).filter(f => now - f.t < 1500)
                        this._cpFlips.push({ t: now, w: wNow, mv: maxVisible })
                        if (this._cpFlips.length >= 3) {
                            const ws = this._cpFlips.map(f => f.w)
                            const lo = Math.min(...ws), hi = Math.max(...ws)
                            if (hi - lo < 48) {
                                const mvMin = Math.min(...this._cpFlips.map(f => f.mv))
                                this._cpClamp = { mv: mvMin, lo: lo - 8, hi: hi + 8 }
                                if (maxVisible > mvMin) maxVisible = mvMin
                            }
                        }
                    }
                    if (maxVisible < this.commandPanelMaxVisible && Number.isFinite(this.commandPanelMaxVisible)) {
                        this._cpShrink = { t: Date.now(), sig: _cpSig }
                    }
                }
                // IE 2026 09 04 / ODOO-336331 (заказ Игоря): закреплённые команды (attrButton.pinned) не уходят в ⋮ —
                // в узкой панели настроек теги-чипсы съедали всю ширину и прятали Save-as; чипсы эластичны (перенос/усечение)
                {
                    let lastPinned = -1
                    for (let i = 0; i < Math.min(this.commandPanel.length, this._cpItemWidths.length); i++) if (this.commandPanel[i]?.pinned) lastPinned = i
                    if (lastPinned >= 0 && maxVisible < lastPinned + 1) maxVisible = lastPinned + 1
                }
                if (this.commandPanelMaxVisible !== maxVisible) {
                    this.commandPanelMaxVisible = maxVisible
                }

                let visibleItemsWidth = this._cpItemWidths.slice(0, maxVisible).reduce((a, b) => a + b, 0)
                let visibleWidth = visibleItemsWidth + overflowBtnWidth

                if (!this.commandPanelOverflow.length) {
                    visibleItemsWidth += 10
                    visibleWidth += 10
                }

                if (this.commandPanelMenuWidth !== visibleItemsWidth) {
                    this.commandPanelMenuWidth = visibleItemsWidth
                }
                if (this.commandPanelAreaWidth !== visibleWidth) {
                    this.commandPanelAreaWidth = visibleWidth
                }
            })
        },
        refreshing() {
            this._fmtF = null   // IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL5: полная перерисовка — настройки прохода читаются заново
            let _keep = this.editKeep_take()   // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL3: перерисовка wijmo после правки одной ячейки — кэш и пропуск formatItem у прочих строк
            if (!_keep) this.irefresh++
            try { if (this.breakCarry_update()) { this._breakGaps = null; if (_keep) { this.editKeep_abort('breaks'); _keep = null } } } catch (e) { /* колонки ещё не готовы */ }   // IE 2026 09 19 / ODOO-…: разрыв скрытой колонки — на ближайшую видимую
            if (_keep) this.editKeep_pass(_keep)
            else {
            this.divCells.clear()
            this.cache_data_cells.clear()
            }
            // IE 2026 08 27 / ODOO-5800 (заказ Игоря): режим линий дерева и промер глифа
            // свёртки — заново на каждый refresh (смена tree_lines / rowsHeight / шрифта)
            this._treeLinesMode = null; this._treeLinesNoGaps = null
            this._frameGlyph = null
            this._frameGlyphTries = 0
            this._groupLevelsOn = undefined   // IE 2026 11 02 / ODOO-349799 (group-levels): флаг перечитывается на каждый refresh
            this._groupHeaderOn = undefined   // IE 2026 11 02 / ODOO-349799 (group-header-value): флаг перечитывается на каждый refresh
            this._cellIconsOn = undefined; this._leafIndentOn = undefined   // IE 2026 11 02 / ODOO-349799 (cell-icons): флаги перечитываются на каждый refresh
            this._groupPillOn = undefined; this._pillLastCol = undefined   // IE 2026 11 03 / ODOO-350449 (group row pill): флаг и последняя видимая колонка — заново на каждый refresh
            try { this.flex?.hostElement?.classList?.toggle('grp-pill-on', this.groupPill_on()) } catch (e) { /* грид ещё не создан */ }   // IE 2026 11 03 / ODOO-350449 (group row pill): линии дерева цвета треугольника (CSS .grp-pill-on)
            this._tlsS = null; this._tlsT = null; this._tlsLastCol = undefined   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: стили уровней дерева — опции A/B/C/E/F): опции, структура строк и последняя колонка — заново на каждый refresh
            try { this.tls_hostSync() } catch (e) { /* грид ещё не создан */ }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: стили уровней дерева — опции A/B/C/E/F)
            if (!_keep) {   // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL3: точечный проход — накопленное formatItem по всем ячейкам (зазоры, отложенные) не сбрасывается: прочие строки formatItem не проходят
            this.deferred_formatItem.clear()
            this._breakGaps?.clear()   // позиции break-зазоров пересоберёт formatItem
            this._breakPlanGaps?.clear(); this._planStartOn = undefined   // IE 2026 09 29 / ODOO-343343 (заказ Игоря: начало плана штриховкой)
            }
            this._foldAggGroups = null // агрегаты свёрнутых групп — пересчёт с данными
            this._apprPartialCache = null; this._apprFlagCols = null   // IE 2026 10 14 / ODOO-5800 (Igor): живой итог флага — на новый проход рисования
            // IE 2026 09 21 / ODOO-5800 (итоги строк-групп по отбору): правка значений сбрасывает _foldAggCache (места правок: decomp / paste / undo / sim) — по несовпадению с
            // отметкой итоги по отбору пересчитываются один раз на refresh; простой refresh (прокрутка настроек, свёртка) расчёт не повторяет
            const _ftDirty = !!this._ftMap && this._foldAggCache !== this._ftStamp
            this._foldAggCache = null
            this._foldAggDLScale = null
            this._foldHdrBlank = null
            if (this._ftMap) {
                if (_ftDirty) this.filterTotals_recompute(undefined, false)
                else { this._foldAggCache = new WeakMap(); this._ftStamp = this._foldAggCache }
            }
        },
        // IE 2026 08 27 / ODOO-5800 (заказ Игоря): линии дерева. '' (не задано) = плавная
        // Г-рамка (как «Settings tree»), 'dotted' = прежний пунктир с зазорами секций.
        // Приоритет: параметр вида tree_lines грида > attr.tree_frame='L' (синоним рамки)
        // > глобальный флаг store.treeLines.mode (localStorage 'treeLines', URL ?treeLines=)
        // > дефолт (рамка). Результат кэшируется до следующего refreshing().
        treeLines_mode() {
            if (this._treeLinesMode) return this._treeLinesMode
            let v = this.get_viewParam('tree_lines', '') || this.attr?.tree_lines || ''
            if (!v && this.get_viewParam('tree_lines_dotted', false)) v = 'dotted' // IE 2026 08 27 / ODOO-5800: чекбокс «Dotted tree lines»
            if (!v && this.attr?.tree_frame === 'L') v = 'frame'
            if (!v) v = this.store?.treeLines?.mode || ''
            this._treeLinesMode = v === 'dotted' ? 'dotted' : 'frame'
            return this._treeLinesMode
        },
        treeLines_isFrame() {
            return this.treeLines_mode() === 'frame'
        },
        // IE 2026 11 02 / ODOO-349799 (group-levels): выключатель fe.ux.gridGroupLevels (дефолт ВКЛ), ответ кэшируется до refreshing()
        groupLevels_on() {
            if (this._groupLevelsOn === undefined) this._groupLevelsOn = groupLevels_on(this.store)
            return this._groupLevelsOn
        },
        // IE 2026 11 02 / ODOO-349799 (group-header-value): выключатель fe.ux.gridGroupHeaderValue (дефолт ВКЛ), ответ кэшируется до refreshing()
        groupHeaderValue_on() {
            if (this._groupHeaderOn === undefined) this._groupHeaderOn = groupHeaderValue_on(this.store)
            return this._groupHeaderOn
        },
        // IE 2026 11 02 / ODOO-349799 (cell-icons): выключатели fe.ux.gridCellIcons (иконки по значению и клик по ним) и fe.ux.gridGroupLeafIndent (отступ листа под группой), дефолт ВКЛ, ответ кэшируется до refreshing()
        cellIcons_on() {
            if (this._cellIconsOn === undefined) this._cellIconsOn = cellIcons_on(this.store)
            return this._cellIconsOn
        },
        groupLeafIndent_on() {
            if (this._leafIndentOn === undefined) this._leafIndentOn = groupLeafIndent_on(this.store)
            return this._leafIndentOn
        },
        // IE 2026 11 02 / ODOO-349799 (cell-icons): биндинги группировки wijmo по уровням (groupDescriptions[i].propertyName) — колонка иконки строки-группы уровня i
        groupBindings_list() {
            const out = []
            try { const gds = this.flex?.collectionView?.groupDescriptions; if (gds) for (let i = 0; i < gds.length; i++) out.push(String(gds[i]?.propertyName ?? '')) } catch (e) { /* нет группировки */ }
            return out
        },
        // IE 2026 11 02 / ODOO-349799 (cell-icons): клик по иконке значения (id onCellIcon__Click): без Alt — метод бэка icon_method колонки с {level, value, row_id} (ответ — штатная команда
        // widget_open списка); с Alt (или без icon_method) — прежнее открытие записи. У строки-группы — колонка группировки её уровня, value — имя группы, записи нет.
        // true — клик обработан
        cellIcon_click(data_cell, e) {
            const flex = this.flex
            const row = flex?.rows?.[data_cell?.row]
            if (!row) return false
            const isGroup = row instanceof wjGrid.GroupRow
            let attr_col, params
            if (isGroup) {
                const g = row.dataItem
                const gBind = String(g?.groupDescription?.propertyName ?? '')
                attr_col = this.attr_by_binding?.[gBind] || groupLevel_attr(this.attr_by_binding, this.groupBindings_list(), Number.isInteger(row.level) ? row.level : 0, null)
                params = groupIcon_params(attr_col, g)
            } else {
                attr_col = this.attr_by_binding?.[data_cell.col_binding]
                const dataItem = row.dataItem
                let value = dataItem ? this.store.get_value(dataItem, attr_col?.binding || data_cell.col_binding) : null
                if (attr_col?.attr_type === 'AttrMulti' && dataItem) { const V = this.store.check_AttrMulti(attr_col, dataItem); value = V?.value ?? value }
                params = cellIcon_params(attr_col, value, dataItem)
            }
            if (!params.level || params.value == null) { const d = cellIcon_paramsFromDataset(e?.target?.dataset); params = { level: params.level || d.level, value: params.value ?? d.value, row_id: params.row_id ?? d.row_id } }
            const act = cellIcon_action(attr_col, !!e?.altKey)
            if (act.open) {
                if (isGroup) return false
                this.onButtonOpen__Click(data_cell, e)
                return true
            }
            if (!params.level || params.value == null) return false
            this.store.executeWidgetMethod(this.WIDGET?.vueObj || this, { ...cellIcon_command(act.method, params), no_del_last_backend_action: true })
            return true
        },
        // IE 2026 11 02 / ODOO-349799 (group-header-value) (заказ Игоря, скрин «Конфігурація» по чипу «Вид, Підсистема»): формат заголовка строки-группы wijmo (flex.groupHeaderFormat —
        // его читает GroupRow.getGroupHeader, а через getCellData и полоса закреплённых строк set_stickyRowsTitle): по умолчанию только значение
        // («Довідники»); опция чипа группировки «Field and count» (chip.meta.fieldAndCount) или выключенный флаг — null, то есть штатная строка культуры
        // wijmo «{name}: <b>{value}</b> ({count:n0} items)» с переводом счётчика («елементи»), как до правки. Сеттер wijmo сам перерисовывает грид при смене.
        // Вызывается из set_itemsSource (до нового CollectionView) и из apply_CHIPS (переключение опции не меняет биндинги группировки — compareChipGroup его не видит)
        groupHeader_apply() {
            const flex = this.flex
            if (!flex) return
            const fmt = groupHeader_format(this.groupHeaderValue_on(), this.$refs.chips?.getChipGroupFieldAndCount?.() === true)
            if ((flex.groupHeaderFormat ?? null) !== fmt) flex.groupHeaderFormat = fmt
        },
        // IE 2026 11 02 / ODOO-349799 (group-header-value): Alt-подсказка строки-группы wijmo (сгруппированный список, не дерево childItemsPath): поле группировки, значение, число подчинённых
        // элементов; для вложенных уровней — цепочка родителей (ближайшие выше строки-группы меньших уровней, utils/gridGroupHeader.groupHeader_chain).
        // Поле — заголовок колонки (title attr / header колонки wijmo / биндинг), значение — как у wijmo: dataMap колонки, иначе имя группы. '' — не группа
        groupHeader_tip(row) {
            const flex = this.flex
            if (!flex || this.attr?.childItemsPath) return ''
            const rows = flex.rows
            const chain = groupHeader_chain((i) => {
                const r = rows[i]
                return r instanceof wjGrid.GroupRow && r.dataItem instanceof wjcCore.CollectionViewGroup ? { group: true, level: Number.isInteger(r.level) ? r.level : 0 } : null
            }, row)
            if (!chain.length) return ''
            const levels = chain.map(i => {
                const g = rows[i].dataItem
                const binding = String(g.groupDescription?.propertyName ?? '')
                let col = null
                try { col = flex.getColumn(binding) } catch (e) { col = null }
                const field = this.attr_by_binding?.[binding]?.title || col?.header || binding
                let value = g.name
                try { if (col?.dataMap) value = col.dataMap.getDisplayValue(g.name) ?? g.name } catch (e) { value = g.name }
                return { field, value: value == null ? '' : String(value), count: Array.isArray(g.items) ? g.items.length : undefined }
            })
            return groupHeader_tipHtml(levels, { tn, esc: wjcCore.escapeHtml })
        },
        // IE 2026 11 02 / ODOO-349799 (group-levels): строка-группа wijmo (сгруппированный список) — класс уровня на всех её ячейках; в колонке дерева (первой видимой,
        // где wijmo рисует глиф свёртки и отступ treeIndent × уровень) — направляющие предков тем же механизмом, что у дерева REPORT2
        // (formatItem_cells_break): оверлеи cell-frame-left / cell-frame-corner / cell-frame-bottom (рамка) либо cell-divider-left (пунктир) в <i>,
        // геометрия — treeLines_frameGlyph / treeLines_isFrame; у раскрытой группы — ствол от глифа (cell-frame-left-start / cell-divider-left-0).
        // Листовая строка под группами — уровень maxGroupLevel + 1 (как отступ wijmo). Оверлей кладётся в СВОЙ слот _cache.grpGuides (не в _cache.div0:
        // там оверлей ветки delivery — зазоры секций, он у списка тоже есть) — кэш-путь formatItem (e_col > 0) клонирует оба; колонка дерева —
        // первая ВИДИМАЯ (сгруппированные колонки скрыты, firstVisibleIndex > 0 — кэш-путь и у неё); на полном пути старый оверлей снимается и строится заново
        // (живой промер dev02 «Конфігурація» 02.11: use_delivery у списка true по умолчанию, вызов стоял под !use_delivery и не исполнялся)
        groupLevels_cellApply(e_cell, e_style, row, irow, e_col, rows, _cache, isXlsxExport) {
            const flex = this.flex
            const isGroup = row instanceof wjGrid.GroupRow
            const maxLevel = rows.maxGroupLevel
            const level = isGroup ? (Number.isInteger(row.level) ? row.level : 0) : maxLevel + 1
            // IE 2026 11 02 / ODOO-349799 (group-collapsed): свёрнутая группа — без фона уровня и жирности, как свёрнутый узел дерева (formatItem_cells: group-row-level-N
            // только при !row.isCollapsed); перерисовка при toggle — wijmo refresh внутри _setCollapsed → событие refreshing → сброс cache_data_cells → полный проход
            if (isGroup) wjcCore.addClass(e_cell, groupLevelClass(level, this.cellFill_has(e_cell, e_style), !!row.isCollapsed))
            if (isXlsxExport || e_col !== flex.columns.firstVisibleIndex) return
            const old = e_cell.querySelector(':scope > i.grp-guides')
            if (old) old.remove()
            _cache.grpGuides = null
            // IE 2026 11 02 / ODOO-349799 (cell-icons): иконка значения группы (колонка группировки её уровня, класс из первой строки группы) — после кнопки-глифа, перед текстом;
            // клон в _cache.grpIcon для кэш-пути. Лист под группами — отступ на ширину кнопки-глифа (fg.tx), чтобы стоять правее текста родителя
            // IE 2026 11 02 / ODOO-349799 (cell-icons) (живой промер dev02 после сборки -62: у листа colIcon true в Collection, а в колонке дерева иконки нет): старую иконку снимать
            // ТОЛЬКО у группы — у листа тот же `i.cell-icon` только что вставил formatItem_cells_AttrMulti (этот метод стоит после него), и снятие здесь убирало её
            const oldIcon = isGroup ? e_cell.querySelector(':scope > i.' + CELL_ICON_CLASS) : null
            if (oldIcon) oldIcon.remove()
            _cache.grpIcon = null
            if (isGroup && this.cellIcons_on()) {
                const gBind = String(row.dataItem?.groupDescription?.propertyName ?? '')
                const gAttr = this.attr_by_binding?.[gBind] || groupLevel_attr(this.attr_by_binding, this.groupBindings_list(), level, null)
                const ipi = groupIcon_pi(gAttr, row.dataItem)
                if (ipi) {
                    const html = cellIcon_html(ipi, groupIcon_params(gAttr, row.dataItem), t('Open list'))
                    const btn = e_cell.querySelector(':scope > .wj-elem-collapse')
                    if (btn) btn.insertAdjacentHTML('afterend', html); else e_cell.insertAdjacentHTML('afterbegin', html)
                    const el = e_cell.querySelector(':scope > i.' + CELL_ICON_CLASS)
                    if (el) _cache.grpIcon = el.cloneNode(true)
                }
            }
            if (!isGroup && this.groupLeafIndent_on()) {
                const fgl = this.treeLines_frameGlyph()
                // IE 2026 11 02 / ODOO-349799 (cell-icons) (живой промер dev02 «Конфігурація» 02.11: текст листа 131 при тексте группы 136): текст листа — правее текста
                // родительской группы на ширину кнопки-глифа (leafPad: + 2 × tx вместо treeIndent + tx); иконка значения у родителя (колонка группировки уровня maxLevel,
                // класс из той же строки — группа однородна) и у листа (колонка дерева) сдвигают текст — разница их ширин (fgl.iw) входит в отступ
                // у листа — ФАКТИЧЕСКОЕ наличие иконки в ячейке (вставлена выше по проходу), не расчёт по данным (IE 2026 11 02 / ODOO-349799 (cell-icons))
                const leafIcon = !!e_cell.querySelector(':scope > i.' + CELL_ICON_CLASS)
                const dIcon = this.cellIcons_on() ? ((cellIcon_pi(groupLevel_attr(this.attr_by_binding, this.groupBindings_list(), maxLevel, null), row.dataItem) ? 1 : 0)
                    - (leafIcon ? 1 : 0)) * (fgl.iw || 0) : 0
                const lp = leafPad(flex._cellPadLeft || 0, flex.treeIndent || 14, maxLevel, fgl.tx || fgl.w, dIcon)
                if (lp !== null) e_style.paddingLeft = `${lp}px`
            }
            // следующая видимая строка — где закрываются секции предков (как _cache.iNext у дерева)
            let iNext = irow + 1
            while (iNext < rows.length && rows[iNext].visibleIndex === -1) iNext++
            const nextLevel = iNext >= rows.length ? -1 : (rows[iNext] instanceof wjGrid.GroupRow ? (Number.isInteger(rows[iNext].level) ? rows[iNext].level : 0) : maxLevel + 1)
            const guides = groupGuides(level, nextLevel)
            const stem = isGroup && !row.isCollapsed
            if (!guides.length && !stem) return
            const useFrame = this.treeLines_isFrame()
            const fg = this.treeLines_frameGlyph()
            const glyphX = useFrame ? fg.x : 5   // пунктир — по прежней константе breakPaddingLeft дерева
            const padLeft = flex._cellPadLeft || 0, ind = flex.treeIndent || 14
            const div0 = document.createElement('i')
            div0.className = 'grp-guides'
            for (const g of guides) {
                const x = groupGuide_x(glyphX, padLeft, ind, g.ilevel)
                const d = document.createElement('div')
                d.className = useFrame ? 'cell-frame-left' : 'cell-divider-left'
                d.style.left = `${x}px`
                if (g.isLast) d.style.bottom = useFrame ? '6px' : '-2px'
                div0.appendChild(d)
                if (g.isLast && useFrame) {
                    const dc = document.createElement('div')
                    dc.className = 'cell-frame-corner'
                    dc.style.left = `${x}px`
                    div0.appendChild(dc)
                    const db = document.createElement('div')
                    db.className = 'cell-frame-bottom'
                    db.style.left = `${x + 7}px`
                    div0.appendChild(db)
                }
            }
            if (stem) {
                const x0 = groupGuide_x(glyphX, padLeft, ind, level)
                const pill = this.groupPill_on()   // IE 2026 11 03 / ODOO-350449 (group row pill): ствол — от нижнего края треугольника, без дуги над глифом
                if (useFrame) {
                    if (fg.r && !pill) {
                        const dc = document.createElement('div')
                        dc.className = 'cell-frame-top-corner'
                        dc.style.left = `${x0}px`
                        dc.style.top = `${fg.y}px`
                        dc.style.width = `${fg.r}px`
                        dc.style.height = `${fg.r}px`
                        dc.style.borderTopLeftRadius = `${fg.r}px`
                        div0.appendChild(dc)
                    }
                    const d = document.createElement('div')
                    d.className = 'cell-frame-left cell-frame-left-start'
                    d.style.left = `${x0}px`
                    d.style.top = `${pill ? (fg.gb ?? fg.y + 3) : fg.y + fg.r}px`   // IE 2026 11 03 / ODOO-350449 (group row pill)
                    div0.appendChild(d)
                } else {
                    const d = document.createElement('div')
                    d.className = 'cell-divider-left-0'
                    d.style.left = `${x0}px`
                    div0.appendChild(d)
                }
            }
            e_cell.appendChild(div0)
            _cache.grpGuides = div0.cloneNode(true)
        },
        // IE 2026 08 27 / ODOO-5800 (замечание Игоря 27.08: в отчётах с колонками-карточками нижняя
        // рамка карточек «съехала» при прокрутке): зазор секции (+10px, маски) нужен карточкам
        // (break_before) как нижняя граница — убираем его только в режиме рамки И без карточек
        treeLines_noGaps() {
            if (!this.treeLines_isFrame()) return false
            if (this._treeLinesNoGaps !== undefined && this._treeLinesNoGaps !== null) return this._treeLinesNoGaps
            const hasCards = Object.values(this.attr_by_binding || {}).some(a => a && a.break_before)
            this._treeLinesNoGaps = !hasCards
            return this._treeLinesNoGaps
        },
        // геометрия глифа свёртки (wj-glyph-down-right) относительно ячейки дерева:
        // x — левый край треугольника (ствол линии), y — его нижний край (начало
        // дуги), w — ширина, r — радиус дуги стыка. Один промер зондом на refresh
        // (в ячейках грида тот же шрифт/паддинг), без обхода реальных строк —
        // иначе дети, отрисованные до родителя, легли бы по другой сетке.
        // Не промерилось (грид не в DOM, экспорт) — прежняя геометрия: x=5, штрих
        // 6px от низа строки, без дуги (r=0).
        treeLines_frameGlyph() {
            if (this._frameGlyph) return this._frameGlyph
            const flex = this.flex
            const defaultSize = flex?.rows?.defaultSize || 24
            let fg = { x: 5, y: defaultSize - 6, w: 0, r: 0, tx: 0, iw: 0, gb: defaultSize - 6 }   // IE 2026 11 02 / ODOO-349799 (cell-icons): tx — левый край текста после кнопки-глифа, iw — ширина иконки значения (cell-icon pr-2) (0 — не промерен)   // IE 2026 11 03 / ODOO-350449 (group row pill): gb — нижний край треугольника (без промера — прежняя точка ствола)
            let measured = false
            try {
                const host = flex?.cells?.hostElement
                if (host && host.isConnected) {
                    const probe = document.createElement('div')
                    probe.className = 'wj-cell tree-cell tree-group-cell group-row-level-0'
                    probe.style.cssText = `position:absolute;left:-9999px;top:0;width:200px;height:${defaultSize}px;padding-left:0;visibility:hidden;white-space:nowrap;overflow:visible`
                    probe.innerHTML = '<button class="wj-btn wj-btn-glyph wj-elem-collapse" type="button" tabindex="-1"><span class="wj-glyph-down-right"></span></button><span>x</span><i class="cell-link cell-icon pr-2 pi pi-box"></i>'   // IE 2026 11 02 / ODOO-349799 (cell-icons): иконка значения — после текста, чтобы не сдвигать промер tx
                    host.appendChild(probe)
                    const g = probe.querySelector('.wj-glyph-down-right')
                    const gr = g.getBoundingClientRect(), pr = probe.getBoundingClientRect()
                    const xr = probe.querySelector(':scope > span:not(.wj-glyph-down-right)').getBoundingClientRect()   // IE 2026 11 02 / ODOO-349799 (cell-icons): текст после кнопки-глифа — отступ листа под группой (leafPad)
                    const ir = probe.lastElementChild.getBoundingClientRect()   // IE 2026 11 02 / ODOO-349799 (cell-icons): ширина иконки значения (leafPad: разница иконок родителя и листа)
                    probe.remove()
                    if (gr.width > 0 && pr.height > 0) {
                        measured = true
                        const w = Math.round(gr.width)
                        fg = {
                            x: Math.round(gr.left - pr.left),
                            y: Math.max(1, Math.round(gr.bottom - pr.top) - 3), // IE 2026 08 27 (Игорь): начало дуги внутри треугольника
                            w,
                            r: Math.max(4, Math.min(8, Math.round(w * 0.7))),
                            tx: Math.max(0, Math.round(xr.left - pr.left)),   // IE 2026 11 02 / ODOO-349799 (cell-icons)
                            gb: Math.max(1, Math.round(gr.bottom - pr.top)),   // IE 2026 11 03 / ODOO-350449 (group row pill): нижний край треугольника — начало ствола без дуги
                            iw: Math.max(0, Math.round(ir.width)),   // IE 2026 11 02 / ODOO-349799 (cell-icons)
                        }
                        // дуга + ствол должны поместиться до низа строки
                        if (fg.y + fg.r > defaultSize - 2) fg.r = Math.max(0, defaultSize - 2 - fg.y)
                    }
                }
            } catch (e) { /* без промера — прежняя геометрия */ }
            // грид скрыт (display:none — нулевой промер): не кэшировать, повторить в
            // следующей ячейке; после 3 неудач — прежняя геометрия до refreshing()
            this._frameGlyphTries = measured ? 0 : (this._frameGlyphTries || 0) + 1
            if (measured || this._frameGlyphTries >= 3) this._frameGlyph = fg
            return fg
        },
        updatingView(flex, e) {
            // состав гасимых подписей шапки зависит от свёртки групп — пересобрать
            // на каждой перерисовке (программная свёртка события не шлёт)
            this._foldHdrBlank = null
            this._rowEmptyPass = null   // R21 / R22 (IE 2026 09 20 / ODOO-…): новый проход отрисовки — память «строка пуста» и план колонок собираются заново
            this._groupDup = null   // IE 2026 09 23 / ODOO-… (заказ Игоря: итог группы = единственный потомок): повторы считаются заново на каждом проходе (видимость / свёртка потомков)
            if (this.use_performance) {
                this.performanceView.t0 = performance.now()
            }
            if (this.need_aggregate) {
                this.aggregateFront()
                this.actionStack++
                this.need_aggregate = false
            }
            if (this.need_restoreVisibility && this.rowLevelGroup_ranges_length) {
                this.restoreVisibility()
                this.need_restoreVisibility = false
            } else if (this.need_collapsedAll) {
                if (!this.store.hide_console) console.log('updatingView+need_collapsedAll')
                this.need_collapsedAll = false
                this.collapsedAll(false, true)
            }
            // compare-строки (≡ prev / Δ / Δ%) — по умолчанию СВЁРНУТЫ под основной
            // строкой; один проход на каждую новую сборку данных
            if (this._compareCollapsed_data !== this.data && this.flex?.rows?.length) {
                this._compareCollapsed_data = this.data
                for (const row of this.flex.rows) {
                    const di = row.dataItem
                    if (di?.attrs?.length && di.attrs[0]?._variant && !row.isCollapsed) {
                        try { row.isCollapsed = true } catch (e) { /* не tree-строка */ }
                    }
                }
            }
        },
        // ---- IE 2026 10 07 / ODOO-5800 (заказ Игоря: «Hidden» поля строки DL2 гасит ячейку своего уровня): ГАСИМАЯ ЯЧЕЙКА — `_DLRow.cells[<binding>].blank === true` (кладёт бэк, тот же контейнер,
        // что `.dir` у «Direction»). Колонки отчёта общие для всех уровней и дедуплицируются по binding, а значение каждая строка кладёт из СВОЕГО dataItem — у строк уровня, где поле
        // скрыто, в общей колонке стояло значение родителя (Мережевий шар: пилюля «Погано» в «Ступінь» у строк C). Значение остаётся в dataItem (условное оформление соседних ячеек и
        // drill-down читают его); гасится показ: ячейка выглядит как ячейка строки БЕЗ значения по этому binding — ни текста, ни пилюли, ни оформления САМОЙ ячейки (условное оформление,
        // мета бэка, стрелка Direction), пуста в выгрузке XLSX / CSV / PDF (getCellData), при копировании и в подсказке. Оформление СТРОКИ (_DLRow.cssClasses, правила kind=row) остаётся.
        // Выключатель fe.ux.dl2HiddenBlank (дефолт ВКЛ; выкл — как до правки: значение строки видно). Чистая часть — utils/dl2CellBlank.js ----
        autocompleteKeys_on() { return this.store.setting(FLAG_GRID_AUTOCOMPLETE_KEYS, true) !== false },   // IE 2026 10 10 / ODOO-341407 (Andrey via core #74395: grid autocomplete — detached value, Enter, arrows)
        dl2Blank_on() { return this.fmtSetting('fe.ux.dl2HiddenBlank', true) !== false },   // IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL5
        foldKeep_on() { return this.fmtSetting('fe.ux.gridKeepExpanded', true) !== false },   // IE 2026 10 17 / ODOO-5800: свёртка дерева по ключу строки переживает пересборку данных (выкл — прежнее: дефолт DL после select)
        // ---- IE 2026 10 08 / ODOO-5800 (Igor 08.10: «когда растягиваешь по вертикали ячейки то нужно заполнять пропуски прямоугольником с белым фоном, иначе при прокрутке
        // на фикс областях видны артефакты, см строки 3-4»; Мережевий шар). Замороженные колонки видны КЛОНОМ (cloneFrozenCells: [wj-part="fcells"],
        // .wj-frozen-clone), а под ним лежат основные экземпляры тех же ячеек ([wj-part="cells"]) и проезжающие при горизонтальной прокрутке ячейки
        // данных. Сам клон прозрачен: где ячейка клона не покрывает строку целиком — зазор секции (_cache.breakTop: ячейка сдвинута вниз на 10px,
        // высота — одна строка), зазор колонок (breakLeft), обрезка карточек — сквозь пропуск видно то, что под клоном. После вертикальной
        // прокрутки основной экземпляр стоит со сдвигом на величину прокрутки (замер 08.10 на dev02, прокрутка 12px: основной 361..376, клон
        // 373..388), и в зазоре между строками 11 и 12 читается «…блема Дефіцит» соседней строки. Правка: под ячейками клона — один непрозрачный
        // прямоугольник ::before фоном ячеек (var(--surface-card), тема — тёмная тоже) на ширину замороженных колонок и высоту до последней строки,
        // z-index 1 как у ячеек .wj-frozen: основные экземпляры (раньше в дереве) под ним, ячейки клона (позже) — поверх. Выключатель fe.ux.frozenMergeFill (дефолт ВКЛ; выкл — как до правки: клон прозрачен) ----
        frozenFill_on() { return this.store.setting('fe.ux.frozenMergeFill', true) !== false },   // IE 2026 10 08 / ODOO-5800
        frozenFill_sync(flex) {   // IE 2026 10 08 / ODOO-5800: зовётся из updatedView (каждый кадр прокрутки) — пишет стиль только при изменении
            const fct = flex?._fCt   // IE 2026 10 08 / ODOO-5800: клон замороженных — [wj-part="fcells"] (wijmo держит ссылку в _fCt)
            if (!fct) return   // IE 2026 10 08 / ODOO-5800
            const fz = flex.frozenColumns || 0   // IE 2026 10 08 / ODOO-5800
            const w = (fz && this.frozenFill_on()) ? Math.round(flex.columns.getFrozenSize() || 0) : 0   // IE 2026 10 08 / ODOO-5800: штатная сумма renderSize замороженных (скрытая = 0)
            const bottom = w ? Math.round((flex.rows.getTotalSize() || 0) + (flex.scrollPosition?.y || 0)) : 0   // IE 2026 10 08 / ODOO-5800: низ последней строки в координатах клона (top клона = верх данных)
            const h = Math.max(0, Math.min(bottom, fct.clientHeight || bottom))   // IE 2026 10 08 / ODOO-5800: не ниже видимой области и не ниже последней строки
            const on = w > 0 && h > 0   // IE 2026 10 08 / ODOO-5800
            if (fct.classList.contains('fz-fill') !== on) fct.classList.toggle('fz-fill', on)   // IE 2026 10 08 / ODOO-5800
            if (!on) return   // IE 2026 10 08 / ODOO-5800
            const ws = w + 'px', hs = h + 'px'   // IE 2026 10 08 / ODOO-5800
            if (fct.style.getPropertyValue('--fz-fill-w') !== ws) fct.style.setProperty('--fz-fill-w', ws)   // IE 2026 10 08 / ODOO-5800
            if (fct.style.getPropertyValue('--fz-fill-h') !== hs) fct.style.setProperty('--fz-fill-h', hs)   // IE 2026 10 08 / ODOO-5800
        },   // IE 2026 10 08 / ODOO-5800
        cellBlank(dataItem, binding) { return dl2_cellBlank(dataItem, binding) && this.dl2Blank_on() },
        // корень «пусто везде, где wijmo читает значение»: getCellData панели ячеек (текст при отрисовке, XLSX / CSV / PDF, getClipString, поиск, объединение) — см. dl2_hookGetCellData
        dl2Blank_hook(flex) { try { dl2_hookGetCellData(flex?.cells, () => this.dl2Blank_on()) } catch (e) { /* панель не та — значение как было */ } },
        // ---- IE 2026 10 08 / ODOO-341407 (Igor 08.10, скрины «Signals»: в отчёте подписи «Ступінь», «Тип правила», в настройках — «Grade», «Rule type»): НАЗВАНИЕ ПОЛЯ / МЕРЫ
        // СТРОКИ РАСКЛАДКИ DL2 в настройках отчёта — чипсы колонок Fields / Values грида раскладки (chipLabel) и колонка Title грида полей строки (localized_cellValue) —
        // тем же правилом, что подпись колонки отчёта (бэк attrs.localize_attrs): свой title_{lang} поля → словарь бэка по title (en — только кириллица) → title.
        // Только показ: запись и база title не меняются; правка ячейки Title под uk / ru по-прежнему пишет только перевод title_{lang} (F2, решение В3).
        // Чистая логика — utils/dl2FieldTitle.js; выключатель fe.i18n.dl2SettingsTitles (по умолчанию ВКЛ; выкл — английская база, как до правки) ----
        dl2Titles_on() { return this.store.setting(FLAG_DL2_SETTINGS_TITLES, true) !== false },
        // путь грида в записи-владельце: свой binding; у формы строки (widget-row) — путь строки в родительской записи (store.i18n_linkBinding). '' — строки-записи / нет binding
        dl2Titles_gridPath() {
            const b = this.attr?.binding
            if (typeof b !== 'string' || !b || b.startsWith('_')) return ''
            if (this.WIDGET?.widget !== 'widget-row') return b
            try { return String(this.store.i18n_linkBinding(this.WIDGET, b)?.binding || '') } catch (e) { return '' }
        },
        // показанное название поля раскладки по пути path ('' — не поле раскладки DL2, выключено или названия нет: показ как раньше). Словарь бэка грузится
        // лениво, один раз на язык; до ответа — база, по ответу грид перерисовывается
        dl2Titles_label(field, path) {
            if (!field || typeof field !== 'object' || !dl2_isFieldsPath(path) || !this.dl2Titles_on()) return ''
            const lang = this.store.get_lang() || 'en'
            let T = null
            if (dl2_needsDict(field, lang)) {
                const dict = dl2_dict(lang) || dl2_dict(lang, (L) => i18n_dictGet(this.store, L), this.dl2Titles_waiter(lang))
                if (dict) T = dl2_dictT(dict, lang)
            }
            return dl2_fieldTitle(field, lang, T)
        },
        // IE 2026 10 10 / ODOO-341407 (Andrey via core #74338: sort chips in the layout list): сортировка строки раскладки DL2 (dataItem.ORDER) — только чтение-чипсы после чипсов полей в колонке Fields грида раскладки.
        // Не тянутся, без ⊗ и fieldIndex (обработчики перетаскивания / удаления вешаются только на чипсы полей). Логика — utils/dl2SortChips.js; выключатель fe.dl2.sortChips (по умолчанию ВКЛ)
        dl2Sort_on() { return this.store.setting(FLAG_DL2_SORT_CHIPS, true) !== false },
        dl2Sort_appendChips(chipWrapper, dataItem, attr_col) {
            try {
                if (!chipWrapper || !dataItem || attr_col?.binding !== 'fields' || !this.dl2Sort_on()) return
                if (!dl2_isFieldsPath(this.dl2Titles_gridPath() + '.' + attr_col.binding)) return
                const items = dl2_sortChips(dataItem, (field, binding) => field ? this.chipLabel(field, attr_col) : binding)
                for (const o of items) {
                    const asc = o.dir === 'ASC'
                    const chip = document.createElement('div')
                    chip.classList.add('chip', 'mr-1', 'scale70', 'chip-sort')
                    chip.title = this.t('Sort') + ': ' + o.label + ' ' + (asc ? this.t('ascending') : this.t('descending')) + (o.sequence ? ' · ' + o.sequence : '')
                    const icon = document.createElement('span')
                    icon.classList.add('chip-icon', 'pi', asc ? 'pi-sort-amount-up' : 'pi-sort-amount-down')
                    chip.appendChild(icon)
                    const text = document.createElement('span')
                    text.classList.add('chip-text')
                    text.textContent = o.label + (asc ? ' \u2191' : ' \u2193')
                    chip.appendChild(text)
                    chipWrapper.appendChild(chip)
                }
            } catch (e) { /* сортировка не нарисовалась — чипсы полей остаются */ }
        },
        // одна подписка грида на загрузку словаря языка: по ответу — перерисовка (formatItem прочтёт словарь)
        dl2Titles_waiter(lang) {
            const w = this._dl2TitlesWait || (this._dl2TitlesWait = {})
            if (w[lang]) return null
            w[lang] = true
            return (L, ok) => {
                delete w[lang]
                if (ok) { try { if (this.flex?.hostElement) this.flex.invalidate() } catch (e) { /* грид закрыт */ } }
            }
        },
        localized_cellValue(attr_col, dataItem) {
            // i18n: перевод значения переводимой колонки ('' — перевода нет, показываем базу)
            if (!attr_col?.translate || !dataItem) return ''
            if (this.cellBlank(dataItem, attr_col.binding)) return ''   // IE 2026 10 07 / ODOO-5800: погашенная ячейка — перевода нет, как у ячейки без значения
            // IE 2026 10 08 / ODOO-341407: строка грида полей / мер строки раскладки DL2 — название, как у колонки отчёта (свой перевод → словарь бэка); база — ''
            if (attr_col.binding === 'title') {
                const dl2 = this.dl2Titles_label(dataItem, this.dl2Titles_gridPath())
                if (dl2) return dl2 === dataItem.title ? '' : dl2
            }
            const store = this.store,
            lang = store.get_lang()
            if (!lang) {
                // IE 2026 09 25 / ODOO-341407 (этап 1 переводов данных 1С): под en — строки-записи (_doc.*, колонка title) с английским вариантом
                // названия meta.title_en (запись с не английской базой: поле 1С / CLDR); у строк конфигурации title_en — бэкап локализации, не читаем
                if (attr_col.binding !== 'title' || !String(this.attr?.binding || '').startsWith('_doc.')) return ''
                const title_en = store.get_value(dataItem, this.i18n_rowLangBinding(attr_col.binding, attr_col.binding, 'en'))
                return (title_en && typeof title_en === 'string') ? title_en : ''
            }
            // IE 2026 09 24 / ODOO-341407: строки конфигурации записи — суффикс рядом с ключом (title_uk), строки-записи — meta.title_{lang}
            const translated = store.get_value(dataItem, this.i18n_rowLangBinding(attr_col.binding, attr_col.binding, lang))
            return (translated && typeof translated === 'string') ? translated : ''
        },
        localize_cellText(e_cell, attr_col, dataItem) {
            // i18n: колонка с флагом translate — в ячейке показываем перевод, если он непустой
            const translated = this.localized_cellValue(attr_col, dataItem)
            if (translated && e_cell.textContent !== translated && !e_cell.querySelector('input')) {
                // IE 2026 09 30 / ODOO-343491 (Игорь: список из дерева настроек — иконки, раскрытие, отступ): в ячейке дерева textContent стирал кнопку свёртки wijmo
                // (.wj-elem-collapse) и спейсер, на кэш-пути — и линии рамки: у строк с переводом не было глифа и отступа, текст ложился на линии
                // (список из «Дерева настроек»). Меняем только текст: глиф, спейсер и элементы без текста (линии, иконка) остаются на месте
                if (e_cell.querySelector(':scope > .wj-elem-collapse, :scope > .wj-elem-collapse-space')) {
                    let tn = null
                    for (const n of [...e_cell.childNodes]) {
                        if (n.nodeType === 1 && (n.classList.contains('wj-elem-collapse') || n.classList.contains('wj-elem-collapse-space') || !n.textContent)) continue
                        if (!tn) { tn = document.createTextNode(translated); e_cell.insertBefore(tn, n) }
                        n.remove()
                    }
                    if (!tn) [...e_cell.querySelectorAll(':scope > .wj-elem-collapse, :scope > .wj-elem-collapse-space')].pop().after(document.createTextNode(translated))
                } else {
                    e_cell.textContent = translated
                }
            }
        },
        // IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL5 (Igor: «должно быть кеширование + см. моё кеширование formatItem»): кэш-путь formatItem стоит ~200 мс на перерисовку M03 (45 × 91,
        // 844 ячейки): на КАЖДУЮ ячейку — действия Pinia store.setting / perf_flag / get_value (обёртка действия + реактивные чтения настроек), разбор cssText
        // временным div, повторная запись одинаковых className / data-*. Проход перерисовки (эпоха _fmtF: до микрозадачи, сброс в refreshing() и при смене
        // настроек — _settingsEpoch / _settingsOverride) читает настройки и perf-флаги один раз; значения ячейки — прямым чтением поля строки, если путь —
        // собственное поле (как первая ветка store.get_value). Настройки, значение строки и разбор cssText — на весь проход (и в getMergedRange вне formatItem;
        // там настройка сверяет эпоху на каждом чтении), perf-флаги — только внутри formatItem (depth); вне прохода — как раньше.
        // Выключатель fe.ux.gridFormatFast (по умолчанию вкл). Счётчик window.__gridFormatFast {pass, off, memoHit, memoMiss, cssHit, classSkip}
        formatItem_fast(flex, e) {
            if (e.panel === flex.cells) this.frozenCell_stamp(e.panel, e.col, e.cell)   // IE 2026 10 15 / ODOO-5800: штамп состояния геометрии замороженной ячейки — formatItem wijmo идёт из CellFactory.updateCell сразу после расчёта top/left (и для копий клона; грид без CustomCellFactory — DirectiveCellFactory wijmo, крючок в _process не срабатывает: замер dev02 1coh_001 fe-2026-10-15-1)
            const F = this.fmtFast_pass()
            // IE 2026 11 03 / ODOO-350449 (заказ Игоря: виды ячеек запаса под ключ — Z5 по умолчанию; BE ie-dm7 stock_cells_batch): слой ячейки запаса (stockCell_after) — пост-шаг обоих путей, до уровней дерева
            if (!F) return this.treeLevel_after(flex, e, this.stockCell_after(flex, e, this.groupPill_after(flex, e, this.formatItem(flex, e))))   // IE 2026 11 03 / ODOO-350449 (group row pill): плашка — после formatItem (полный и кэш-путь)   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: стили уровней дерева — опции A/B/C/E/F): стиль уровней — последним
            F.depth++
            try { return this.treeLevel_after(flex, e, this.stockCell_after(flex, e, this.groupPill_after(flex, e, this.formatItem(flex, e)))) } finally { F.depth-- }   // IE 2026 11 03 / ODOO-350449 (group row pill)   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: стили уровней дерева — опции A/B/C/E/F)
        },
        // IE 2026 11 03 / ODOO-350449 (group row pill) (замечание Игоря, скрины Segments / «Конфігурація» / REPORT2): фон раскрытой строки-группы — закруглённая плашка на всю строку
        // от отступа своего уровня (utils/gridGroupLevels: groupPill_kind / groupPill_x / groupPill_paint). Последний шаг КАЖДОГО formatItem ячейки данных:
        // кэш-путь (e_col > 0) копирует className снимка строки — классы начала / конца плашки здесь выставляются заново по колонке ячейки.
        // Выключатель fe.ux.groupRowPill (дефолт ВКЛ, кэш до refreshing); выкл — плашки нет (снимаются и оставшиеся)
        groupPill_after(flex, e, r) {
            const cell = e?.cell
            if (!cell || !flex || e.panel !== flex.cells) return r
            let kind = this.groupPill_on() ? groupPill_kind(cell.className, PLAIN_LEVEL_CLASS) : null   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: стили уровней дерева — опции A/B/C/E/F)
            if (kind === 'tree' && this.tls_state().mode !== 'now') kind = null   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: стили уровней дерева — опции A/B/C/E/F): у дерева в режимах A/B/C/E/F плашки нет
            if (!kind) { if (cell.classList?.contains('grp-pill')) groupPill_paint(cell, null); return r }
            const cols = flex.columns
            if (this._pillLastCol === undefined) this._pillLastCol = lastVisibleCol(cols)
            const c2 = e.range && Number.isInteger(e.range.col2) ? e.range.col2 : e.col
            const start = kind === 'tree' ? cell.classList.contains('tree-cell') : e.col === cols?.firstVisibleIndex
            groupPill_paint(cell, { start, end: c2 >= this._pillLastCol, x: start ? groupPill_x(kind, cell.style.paddingLeft) : 0 })
            return r
        },
        // IE 2026 11 03 / ODOO-350449 (заказ Игоря: все варианты отображения — во вкладке Display шестерёнки, не на форме): флаг вида сменили во вкладке Display —
        // кэш плашки группы снят, предзагрузка цепочек сигналов снята / запущена по флагу, грид перерисован (formatItem читает флаги заново); отклик сразу, форма не закрывается
        displayOption_changed(d) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: все варианты отображения — во вкладке Display шестерёнки, не на форме)
            const flex = this.flex
            if (!flex || flex.disposed) return
            this._groupPillOn = undefined; this._pillLastCol = undefined
            if (d && d.key === 'fe.ux.signalChainsPrefetch') { try { if (d.value === false) this.sigPrefetch_cancel(); else this.sigPrefetch_schedule() } catch (e) { /* без предзагрузки */ } }
            try { flex.invalidate() } catch (e) { /* грид пересоздаётся */ }
            this._stkOpts = null   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: виды ячеек запаса под ключ — Z5 по умолчанию; BE ie-dm7 stock_cells_batch): опции вида запаса — заново (invalidate перерисует асинхронно); смена вида / полей запроса — догрузка
            if (d && /^fe\.ux\.stock/.test(String(d.key || ''))) { try { this.stk_schedule(0) } catch (e) { /* без слоя запаса */ } }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: виды ячеек запаса под ключ — Z5 по умолчанию; BE ie-dm7 stock_cells_batch)
        },
        groupPill_on() {   // IE 2026 11 03 / ODOO-350449 (group row pill): ответ кэшируется до refreshing()
            if (this._groupPillOn === undefined) this._groupPillOn = groupRowPill_on(this.store)
            return this._groupPillOn
        },
        // IE 2026 11 03 / ODOO-350449 (заказ Игоря: стили уровней дерева — опции A/B/C/E/F): варианты прототипа tree_levels_proto как опции на живой базе.
        // fe.ux.treeLevelStyle: now (дефолт — как сейчас) | guides (A) | depth (B) | rail (C) | card (E) | focus (F); fe.ux.treeSubtreeHover (из D, дефолт ВЫКЛ).
        // Расчёты — utils/treeLevelStyle.js; здесь — пост-шаг formatItem_fast (последний, после плашки — и на кэш-пути): фон ячейки и её маски отступа
        // (cell-delivery-left-0) слоями background-image, классы фокуса / поддерева. Новых узлов нет, ширина ячеек не меняется. Только дерево childItemsPath.
        // На лету: window-событие fe-display-option {key, value} → значение поверх настройки, flex.invalidate(). Хеш пробы: &fe.ux.treeLevelStyle=guides.
        // Счётчик window.__treeLevelStyle { paint, foreign, sync, build }
        tls_state() {
            if (this._tlsS) return this._tlsS
            const o = treeLevelStyle_read(this.store, this._tlsOv)
            const tree = !!this.attr?.childItemsPath && this.attr?.attr_type !== 'AttrTabGrid' && !this.attr?.isPrint && !this.attr?.isPrintTemplate
            o.active = tree && (o.mode !== 'now' || o.hover)
            if (!tree) o.mode = 'now'
            this._tlsS = o
            return o
        },
        tls_hostSync() {
            const host = this.flex?.hostElement
            if (!host) return
            const S = this.tls_state()
            host.classList.toggle('tls-on', S.active && S.mode !== 'now')
            for (const m of ['guides', 'depth', 'rail', 'card', 'focus']) host.classList.toggle('tls-' + m, S.active && S.mode === m)
            host.classList.toggle('tls-hover', S.active && S.hover)
            this.tls_focusMark()   // IE 2026 11 03 / ODOO-350449 (проба p254: S2 — цвет только «Непокрито», прокручиваемая часть, Esc фокуса не закрывает виджет)
        },
        // IE 2026 11 03 / ODOO-350449 (проба p254: S2 — цвет только «Непокрито», прокручиваемая часть, Esc фокуса не закрывает виджет): признак на DOM «фокус дерева активен» (класс tls-focus-on хоста) — глобальный Esc App.vue его пропускает, Esc снимает фокус в гриде (tls_key)
        tls_focusMark(flex) {   // IE 2026 11 03 / ODOO-350449 (проба p254: S2 — цвет только «Непокрито», прокручиваемая часть, Esc фокуса не закрывает виджет)
            const host = (flex || this.flex)?.hostElement
            if (!host) return
            const S = this.tls_state()
            const on = !!(S.active && S.mode === 'focus' && this._tlsFocus >= 0)
            if (host.classList.contains('tls-focus-on') !== on) host.classList.toggle('tls-focus-on', on)
        },
        tls_tree(flex) {   // структура видимых строк — один раз на refresh (сброс в refreshing; сверка числа строк)
            const rows = flex?.rows
            const n = rows ? rows.length : 0
            if (this._tlsT && this._tlsT.n === n) return this._tlsT
            const T = treeLevels_build(n, (i) => {
                const row = rows[i]
                const open = !!(row && row.hasChildren && !row.isCollapsed)
                return { level: row?.level, visible: row ? row.isVisible !== false : false, open, styled: open && !this.plainLevel_row(row, row.dataItem) }
            })
            T.memo = new Map(); T.rail = null
            const sel = flex.selection?.row
            this._tlsBranch = treeLevels_groupOf(T, sel)
            this._tlsFocus = this._tlsFocusOff ? -1 : treeLevels_groupOf(T, sel)
            this.tls_focusMark(flex)   // IE 2026 11 03 / ODOO-350449 (проба p254: S2 — цвет только «Непокрито», прокручиваемая часть, Esc фокуса не закрывает виджет)
            if (!(this._tlsHover >= 0 && this._tlsHover < n && T.open[this._tlsHover])) this._tlsHover = -1
            this._tlsT = T
            const st = window.__treeLevelStyle || (window.__treeLevelStyle = { paint: 0, foreign: 0, sync: 0, build: 0 })
            st.build++
            return T
        },
        tls_railIdx(r) {   // цвет полосы раздела — по подписи корня в колонке дерева, порядок появления в строках (раз на refresh)
            const T = this._tlsT
            if (!T) return 0
            if (!T.rail) {
                const cap = (i) => { try { return this.flex.getCellData(i, 0, true) } catch (e) { return '' } }
                const caps = new Map()
                for (let i = 0; i < T.n; i++) if (T.root[i] === i) caps.set(i, String(cap(i) ?? ''))
                const order = railColor_order(caps.values())
                T.rail = new Map([...caps].map(([i, c]) => [i, order.get(c)]))
            }
            return T.rail.get(r) || 0
        },
        tls_bg(el, css) {   // слои фона элемента; чужой inline background-image не трогаем (свой — атрибут data-tlsbg: его несёт и копия кэш-пути)
            if (!el) return
            const cur = el.style.backgroundImage
            const own = el.hasAttribute('data-tlsbg') && (!cur || el.__tlsBg === undefined || cur === el.__tlsBg)
            if (cur && !own) { if (css) window.__treeLevelStyle.foreign++; return }
            if (!css) {
                if (own) { el.style.backgroundImage = ''; el.style.backgroundPosition = ''; el.style.backgroundSize = ''; el.style.backgroundRepeat = ''; el.removeAttribute('data-tlsbg') }
                el.__tlsBg = undefined; el.__tlsSig = undefined
                return
            }
            const sig = css.image + '|' + css.position + '|' + css.size
            if (own && cur && el.__tlsSig === sig) return
            el.style.backgroundImage = css.image
            el.style.backgroundPosition = css.position
            el.style.backgroundSize = css.size
            el.style.backgroundRepeat = 'no-repeat'
            el.setAttribute('data-tlsbg', '1')
            el.__tlsBg = el.style.backgroundImage; el.__tlsSig = sig
        },
        tls_cls(cell, irow) {
            const want = treeLevels_rowClasses(this._tlsT, irow, this.tls_state().mode === 'focus' ? this._tlsFocus : -1, this.tls_state().hover ? this._tlsHover : -1)
            const cl = cell.classList
            for (const c of TLS_CLASSES) if (want[c] !== cl.contains(c)) cl.toggle(c, want[c])
        },
        tls_clear(cell) {
            for (const c of TLS_CLASSES) if (cell.classList.contains(c)) cell.classList.remove(c)
            this.tls_bg(cell, null)
            this.tls_bg(cell.querySelector(':scope > i > .cell-delivery-left-0'), null)
            cell.__tls = 0
        },
        tls_paint(flex, cell, irow, kind) {
            const S = this.tls_state(), T = this.tls_tree(flex)
            if (irow < 0 || irow >= T.n || !T.vis[irow]) { this.tls_clear(cell); return }
            this.tls_cls(cell, irow)
            const mask = kind === 't' ? cell.querySelector(':scope > i > .cell-delivery-left-0') : null
            if (S.mode === 'now' || S.mode === 'focus') { this.tls_bg(cell, null); if (mask) this.tls_bg(mask, null); cell.__tls = 1; return }
            const key = irow * 4 + (kind === 't' ? 0 : kind === 'l' ? 1 : 2)
            let L = T.memo.get(key)
            if (!L) {
                const fg = this.treeLines_frameGlyph()
                const gl = Number.isFinite(fg?.x) ? fg.x : 5
                const gc = gl + (fg?.w ? Math.round(fg.w / 2) : 4)
                L = treeLevel_layers(S.mode, T, irow, kind, { indent: TREE_INDENT, gl, gc }, { branch: this._tlsBranch, railIdx: (r) => this.tls_railIdx(r) })
                T.memo.set(key, L)
            }
            this.tls_bg(cell, L.cell)
            if (mask) this.tls_bg(mask, L.mask)
            cell.__tls = 1
            window.__treeLevelStyle.paint++
        },
        treeLevel_after(flex, e, r) {   // пост-шаг КАЖДОГО formatItem ячейки данных (полный и кэш-путь): wijmo переиспользует элементы — состояние ставится заново
            const cell = e?.cell
            if (!cell || !flex || e.panel !== flex.cells) return r
            if (!this.tls_state().active) { if (cell.__tls) this.tls_clear(cell); return r }
            let kind = 'c'
            if (cell.classList.contains('tree-cell')) kind = 't'
            else {
                if (this._tlsLastCol === undefined) this._tlsLastCol = lastVisibleCol(flex.columns)
                const c2 = e.range && Number.isInteger(e.range.col2) ? e.range.col2 : e.col
                if (c2 >= this._tlsLastCol) kind = 'l'
            }
            this.tls_paint(flex, cell, e.row, kind)
            return r
        },
        tls_sync(flex, onlyTree) {   // без перерисовки грида: классы (фокус, поддерево) или слои колонки дерева (ветка guides) у видимых ячеек по data-gr
            const host = flex?.hostElement
            if (!host || !this._tlsT) return
            const st = window.__treeLevelStyle; if (st) st.sync++
            host.querySelectorAll(onlyTree ? '.wj-cells .wj-cell.tree-cell[data-gr]' : '.wj-cells .wj-cell[data-gr]').forEach(cell => {
                const irow = Number(cell.dataset.gr)
                if (onlyTree) this.tls_paint(flex, cell, irow, 't'); else this.tls_cls(cell, irow)
            })
        },
        tls_selChanged(flex) {   // ветка текущей строки (guides) и корень фокуса (focus) — по выделению
            const S = this.tls_state()
            if (!S.active || (S.mode !== 'guides' && S.mode !== 'focus') || !this._tlsT) return
            const g = treeLevels_groupOf(this._tlsT, flex.selection?.row)
            if (S.mode === 'guides' && g !== this._tlsBranch) { this._tlsBranch = g; this._tlsT.memo.clear(); this.tls_sync(flex, true) }
            if (S.mode === 'focus') { this._tlsFocusOff = false; if (g !== this._tlsFocus) { this._tlsFocus = g; this.tls_sync(flex, false) } this.tls_focusMark(flex) }   // IE 2026 11 03 / ODOO-350449 (проба p254: S2 — цвет только «Непокрито», прокручиваемая часть, Esc фокуса не закрывает виджет): + признак фокуса на хосте
        },
        tls_hover(flex, r) {   // наведение: раскрытая группа под курсором — её поддерево
            const S = this.tls_state()
            if (!S.active || !S.hover) return
            const T = this.tls_tree(flex)
            const h = r >= 0 && r < T.n && T.open[r] ? r : -1
            if (h === this._tlsHover) return
            this._tlsHover = h
            this.tls_sync(flex, false)
        },
        tls_key(flex, ev) {   // Esc в режиме фокуса — снять приглушение до следующего выбора
            if (ev?.key !== 'Escape' || this.tls_state().mode !== 'focus' || !this.tls_state().active || this._tlsFocus < 0 || flex.activeEditor) return
            this._tlsFocusOff = true; this._tlsFocus = -1
            this.tls_focusMark(flex)   // IE 2026 11 03 / ODOO-350449 (проба p254: S2 — цвет только «Непокрито», прокручиваемая часть, Esc фокуса не закрывает виджет): следующий Esc — глобальный (закрытие виджета, как раньше)
            try { ev.stopPropagation(); ev.preventDefault() } catch (e) { /* событие без методов */ }   // IE 2026 11 03 / ODOO-350449: Esc, снявший фокус, не доходит до глобального Esc App.vue (тот закрыл бы виджет)
            this.tls_sync(flex, false)
        },
        tls_option(ev) {   // window fe-display-option {key, value} (вкладка Display) — свои ключи применяются на лету
            const d = ev?.detail
            if (!d || (d.key !== TREE_LEVEL_STYLE_FLAG && d.key !== TREE_SUBTREE_HOVER_FLAG)) return
            const ov = this._tlsOv || (this._tlsOv = {})
            if (d.value === undefined || d.value === null) delete ov[d.key]; else ov[d.key] = d.value
            this._tlsS = null; this._tlsT = null; this._tlsHover = -1
            try { this.tls_hostSync(); this.flex?.invalidate() } catch (e) { /* грид разрушен */ }
        },
        fmtFast_pass() {
            const st = this.store
            const ep = st._settingsEpoch, ov = st._settingsOverride
            let F = this._fmtF
            if (F && F.ep === ep && F.ov === ov) return F.on ? F : null
            const on = st.setting('fe.ux.gridFormatFast', true) !== false
            const c = window.__gridFormatFast || (window.__gridFormatFast = { pass: 0, off: 0, memoHit: 0, memoMiss: 0, cssHit: 0, classSkip: 0 })
            F = this._fmtF = { on, depth: 0, ep, ov: st._settingsOverride, set: new Map(), perf: new Map(), c }
            if (on) c.pass++; else c.off++
            queueMicrotask(() => { if (this._fmtF === F) this._fmtF = null })
            return on ? F : null
        },
        // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p206 рядок Data Layout без оформлення рівня — білий фон у розкритого рядка об'єкта, опція)
        // раскрытая строка-группа без фона уровня: признак строки Data Layout (_DLRow.plain_level) или опция отчёта «Plain top group rows»
        // (doc.params.plain_top_groups — строки-группы верхнего уровня без итогов); правило — utils/plainLevel.js
        plainLevel_row(row, dataItem) {
            return plainLevel_is(dataItem, row?.level, {
                on: this.fmtSetting('fe.ux.plainLevelRows', true) !== false,
                topGroups: !!this.WIDGET?.record?.doc?.params?.plain_top_groups,
            })
        },
        fmtSetting(key, def_) {   // store.setting один раз на проход (только внутри formatItem_fast)
            const F = this._fmtF
            if (!F || !F.on || (def_ !== null && (typeof def_ === 'object' || typeof def_ === 'function'))) return this.store.setting(key, def_)
            if (!F.depth && (F.ep !== this.store._settingsEpoch || F.ov !== this.store._settingsOverride)) return this.store.setting(key, def_)   // IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL5: вне formatItem (getMergedRange) — со сверкой эпохи настроек
            const k = key + '\u0001' + typeof def_ + ':' + String(def_)
            if (F.set.has(k)) { F.c.memoHit++; return F.set.get(k) }
            const v = this.store.setting(key, def_)
            F.set.set(k, v); F.c.memoMiss++
            return v
        },
        fmtPerf(key, fn) {   // perf-флаг / флаг записи — один раз на проход
            const F = this._fmtF
            if (!F || !F.on || !F.depth) return fn()
            let v = F.perf.get(key)
            if (v === undefined) { v = fn(); F.perf.set(key, v) } else F.c.memoHit++
            return v
        },
        fmtGetValue(dataItem, binding) {   // собственное поле строки — без действия Pinia (та же первая ветка store.get_value); иначе store.get_value
            const F = this._fmtF
            if (F && F.on && dataItem !== null && typeof dataItem === 'object' && typeof binding === 'string' && binding in dataItem) return dataItem[binding]
            return this.store.get_value(dataItem, binding)
        },
        formatItem(flex, e, isXlsxExport=false) {
            window.$cg.callSub(`start`);
            const vueObj = this;
            let t0
            if (this.use_performance) {
                t0 = performance.now()
            }
            const rows = flex.rows,
            e_cell = e.cell,
            e_style = e_cell.style,
            e_col = e.col,
            e_row = e.row,
            e_panel = e.panel;
            const _fF = this._fmtF, _fOn = !!(_fF && _fF.on && _fF.depth)   // IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL5: проход formatItem_fast — без повторной записи того же className / data-*
            const _cfrS = window.__cellFillStats, _cfrT0 = _cfrS ? performance.now() : 0   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N): замер formatItem (ячейки, ms) — счётчик заводится режимом ≠ off; для замера «до» — window.__cellFillStats = {cells: 0, ms: 0}
            // this.attr.allow_formatItem = false

            // hover-подсветка строки: тегируем ячейки данных индексом строки, чтобы
            // синхронно подсветить строку и в замороженной клон-панели (.wj-frozen-clone),
            // до которой не достаёт CSS :hover. Ставим рано — работает и на кеш-пути.
            if (e_panel === flex.cells) {
                if (!_fOn || e_cell.getAttribute('data-gr') !== String(e_row)) e_cell.dataset.gr = e_row   // IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL5
                // АН 2026 08 15 / ODOO-4997: рыжий обвод строк, чьи измерения
                // выделены в графе Supply Chain Flow (см. applyDimHighlight)
                if (this._dimHighlightRows?.size) {
                    e_cell.classList.toggle('dim-highlight', this._dimHighlightRows.has(rows[e_row]?.dataItem))
                } else if (e_cell.classList.contains('dim-highlight')) {
                    e_cell.classList.remove('dim-highlight')
                }
                // IE 2026 10 07 / ODOO-5800: у погашенной ячейки (_DLRow.cells[binding].blank) нет ни полосы данных, ни красного цвета отрицательного — как у ячейки без значения (null вместо строки)
                const _dl2Blank0 = this.cellBlank(rows[e_row]?.dataItem, flex.columns[e_col]?.binding)
                // АН 2026 08 15 / ODOO-4997: Data bars / Data columns строк (узлы DL)
                this.rowStyle_paint(e_cell, _dl2Blank0 ? null : rows[e_row]?.dataItem, flex.columns[e_col])   // IE 2026 10 07 / ODOO-5800
                // IE 2026 08 15 / ODOO-4997 (заказ Игоря): отрицательные значения
                // датных ячеек — красным шрифтом; пересчёт на КАЖДОМ formatItem,
                // потому выделение переживает точечные обновления симуляции
                this.negValue_paint(e_cell, _dl2Blank0 ? null : rows[e_row]?.dataItem, flex.columns[e_col])   // IE 2026 10 07 / ODOO-5800
                this.linkSegBinding_paint(e_cell, rows[e_row]?.dataItem, flex.columns[e_col]) // IE 2026 08 28 / ODOO-5800
                this.mtl_paint(e_cell, rows[e_row]?.dataItem, flex.columns[e_col])   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди)
                this.influence_paint(e_cell, rows[e_row]?.dataItem, flex.columns[e_col])   // IE 2026 09 14 / ODOO-5800: влияющие ячейки
                this.sameDoc_paint(e_cell, rows[e_row]?.dataItem, flex.columns[e_col])   // IE 2026 09 22 / ODOO-5800: ячейки тех же документов (повтор — в хвосте, после кэш-пути)
            }
            else if (e_panel === flex.rowHeaders) { if (!_fOn || e_cell.getAttribute('data-ghr') !== String(e_row)) e_cell.dataset.ghr = e_row }   // IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL5
            else if (e_panel === flex.columnHeaders) {
                if (!_fOn || e_cell.getAttribute('data-ghc') !== String(e_col)) e_cell.dataset.ghc = e_col   // IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL5
                // подписи мелких дат под свёрнутой группой дат — гасим
                this.foldHdr_blankCell(e_cell, flex.columns[e_col]?.binding, e_row)
                // направление своей (иерархической) сортировки рисуем сами:
                // штатную мы отменили, значит и штатной стрелки не будет
                // АН 2026 08 08: рисуем в ряду шапки, по которому кликнули (hrow),
                // после восстановления — в нижнем видимом ряду титулов; раньше
                // целились в rows.length-1, а это скрытый служебный sticky-ряд
                // (create_stickyRows дописывает их в конец) — стрелка туда не
                // попадала. Guard от дубля: formatItem зовётся для каждой колонки
                // merge-диапазона группы с ТЕМ ЖЕ элементом ячейки
                if (this.hierSort?.dir
                        && flex.columns[e_col]?.binding === this.hierSort.binding
                        && e_row === this.hierSort_arrowRow(e_panel)
                        && !e_cell.querySelector('.hier-sort-arrow')) {
                    e_cell.innerHTML += `<span class="hier-sort-arrow">${this.hierSort.dir > 0 ? ' \u25b2' : ' \u25bc'}</span>`
                }
            }
            else if (e_panel === flex.columnFooters) {
                // подпись Total подвала агрегатов (formatItem зовётся для каждой
                // колонки merge-диапазона с тем же элементом — присваивание идемпотентно)
                const fr = vueObj.footerTotalRange
                if (fr && e_row === 0 && e_col >= fr.c1 && e_col <= fr.c2) {
                    e_cell.textContent = t('Total')   // IE 2026 09 23 / ODOO-341407: i18n
                }
            }

            // if (e_panel === flex.cells && e_cell.dataset.fmtDone === '1') {
            //     return
            // } else {
            //     e_cell.dataset.fmtDone = '1'
            // }
            
            const {key, _cache} = this.get_cache(e)
            this.divCells.set(key, e_cell)

            // MAIN
            window.$cg.callEnd(); window.$cg.callSub(`main ${vueObj.CellTypeName[e_panel.cellType]}`);
            // только явное false: updateAttrs (ответ бэка) стирает фронтовые флаги с attr,
            // и до load_data (?? true) флаг отсутствует — рендер в этом окне должен красить,
            // иначе wijmo-invalidate от apply_CHIPS даёт «сырой» кадр (серые группы, даты без формата)
            if (this.attr.allow_formatItem === false) {
                e_cell.data_cell = { 
                    // col_binding: col_binding,
                    row: e_row,
                    col: e_col,
                    irefresh: this.irefresh,
                    // cellType: e_panel.cellType,
                }
            } else {
                if (e_panel === flex.cells) {
                    let _effectiveCol = e_col
                    if (vueObj.mergeColumnBlocksColMap && e_col < vueObj.mergeColumnBlocksTotal) {
                        const _block = vueObj.mergeColumnBlocksColMap[e_col]
                        if (_block?.start === e_col && _block.logCol !== e_col) _effectiveCol = _block.logCol
                    }
                    let col = flex.columns[_effectiveCol],
                    attr_col = this.attr_by_binding[col.binding]

                    // IE 2026 09 04 / ODOO-336291 (mobile UX): R-2 frozenCloneHold — пока палец ведёт грид по горизонтали (window._mobPanActive),
                    // frozen-ячейка в том же DOM-элементе, с той же строкой данных, колонкой и эпохой не переформатируется: содержимое
                    // не менялось, а полный путь (col 0 не кэшируется — useTimeout требует e_col > 0) и проверка обрезки с forced
                    // layout шли на КАЖДЫЙ кадр. Счётчик: this._mobFzSkip. Выкл: window.mobileUi.set('frozenCloneHold', false)
                    if (window._mobPanActive && flex.frozenColumns && e_col < flex.frozenColumns && !isXlsxExport
                            && this.store.mobileUi?.frozenCloneHold !== false) {
                        const _dc = e_cell.data_cell, _di = rows[e_row]?.dataItem
                        if (_dc && _di !== undefined && _dc.row === e_row && _dc.col === e_col && _dc.irefresh === this.irefresh
                                && _dc.col_binding === col.binding && e_cell.__mobFzItem === _di) {
                            this._mobFzSkip = (this._mobFzSkip || 0) + 1
                            window.$cg.callEnd()
                            return
                        }
                        e_cell.__mobFzItem = _di
                    }

                    e_cell.data_cell = {
                        irow: e_row,
                        col_binding: col.binding,
                        row: e_row,
                        col: e_col,
                        irefresh: this.irefresh,
                        // cellType: e_panel.cellType,
                    }

                    wjcCore.removeClass(e_cell, 'wj-group')

                    const {key2, _cache2} = this.get_cache2(e)
                    _cache.seq = (_cache.seq || 0) + 1
                    const isFrozen = flex.frozenColumns && e_col < flex.frozenColumns
                    
                    this.use_cache = true
                    const useTimeout = (this.use_cache||false) && !isXlsxExport && _cache.className && e_col > 0 // && e_col >= this.attr.frozenColumns
                    if (useTimeout) {
                        if (_cache.className) { if (_fOn && e_cell.className === _cache.className) _fF.c.classSkip++; else e_cell.className = _cache.className }   // IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL5
                        if (_cache.cssText) vueObj.applyCssText(e_cell.style, _cache.cssText);
                        // IE 2026 08 16 / ODOO-4997: карточная колонка — класс мог
                        // попасть в кэш до включения режима, применяем поверх
                        if (this.cards_isCol(col.binding)) wjcCore.addClass(e_cell, 'card-col')
                        // спил-ячейки обрезаем и на быстром пути — иначе при
                        // прокрутке заголовки групп налезали на карточки
                        this.cards_clipCell(e_cell, e_style, col)

                        if (_cache.breakLeft) {
                            _cache.prevLeft = parseFloat(e_style.left) || 0;
                            _cache.prevWidth = parseFloat(e_style.width) || 0;

                            e_style.left = `${_cache.prevLeft + _cache.breakLeft}px`;
                            e_style.width = `${_cache.prevWidth - _cache.breakLeft}px`;
                        }

                        if (_cache.breakTop) {
                            _cache.prevTop = parseFloat(e_style.top || '0');
                            _cache.prevHeight = parseFloat(e_style.height || '0');

                            e_style.top = `${_cache.prevTop + _cache.breakTop}px`;
                            e_style.height = `${rows[e_row]?.dataItem?._DLRow?.height || rows[e_row]?.dataItem?._cells?._row?.height || rows.defaultSize}px`; // _cache.prevHeight - _cache.breakTop; IE 2026 09 03 / ODOO-336283
                        }

                        if (_cache.div0) {
                            e_cell.appendChild(_cache.div0.cloneNode(true));
                        }
                        if (_cache.grpGuides) e_cell.appendChild(_cache.grpGuides.cloneNode(true))   // IE 2026 11 02 / ODOO-349799 (group-levels): направляющие групп списка — свой слот, колонка дерева у сгруппированного списка — не нулевая (кэш-путь)
                        // IE 2026 09 05 / ODOO-336330 (репорт Игоря): иконка ссылки (cell-link) и на кэш-пути — базовый
                        // updateCell wijmo переписывает содержимое ячейки текстом, а иконку создаёт только полный
                        // formatItem_cells; при свёртке/развёртке группы первый кадр (перерисовка без refreshing)
                        // шёл без иконок, второй (ResizeObserver → refresh → сброс кэша) — с ними. Счётчик:
                        // vueObj._linkIconCacheHits. Выкл: window.fastEntry.set('linkIconCache', false)
                        if (_cache.grpIcon && !e_cell.querySelector(':scope > i.' + CELL_ICON_CLASS)) {   // IE 2026 11 02 / ODOO-349799 (cell-icons): иконка группы на кэш-пути — после кнопки-глифа
                            const _gb = e_cell.querySelector(':scope > .wj-elem-collapse')
                            if (_gb) _gb.insertAdjacentElement('afterend', _cache.grpIcon.cloneNode(true)); else e_cell.prepend(_cache.grpIcon.cloneNode(true))
                        }
                        if (_cache.linkPi && vueObj.store?.fastEntry?.linkIconCache !== false
                                && !e_cell.querySelector('.cell-link') && e_cell.textContent) {
                            const _li = _cache.linkPiEl ? _cache.linkPiEl.cloneNode(true) : document.createElement('i')   // IE 2026 11 02 / ODOO-349799 (cell-icons): иконка по значению — клон с id и data-атрибутами
                            if (!_cache.linkPiEl) _li.classList = [`cell-link pr-2 ${_cache.linkPi}`]
                            const _ftn = Array.from(e_cell.childNodes).find(node => node.nodeType === Node.TEXT_NODE)
                            const _inp = _ftn ? null : e_cell.querySelector('input')
                            if (_ftn) e_cell.insertBefore(_li, _ftn); else if (_inp) e_cell.insertBefore(_li, _inp); else e_cell.appendChild(_li)
                            vueObj._linkIconCacheHits = (vueObj._linkIconCacheHits || 0) + 1
                        }
                        // IE 2026 09 17 / ODOO-… (замечание Игоря): сводка значений свёрнутого условия
                        // «в списке» — и на кэш-пути: базовый updateCell wijmo переписал содержимое
                        // пустым значением строки условия, а полный formatItem_cells пропущен; у раскрытой
                        // строки сводки нет (значения видны дочерними строками)
                        if (vueObj.attr.childItemsPath && rows[e_row]?.hasChildren) {
                            const _wsum = vueObj.whereSummary_html(rows[e_row], rows[e_row].dataItem, col.binding)
                            if (_wsum) {
                                if (e_cell.innerHTML !== _wsum) e_cell.innerHTML = _wsum
                                wjcCore.addClass(e_cell, 'where-values-summary')
                            } else {
                                wjcCore.removeClass(e_cell, 'where-values-summary')
                            }
                        }
                        
                        // // this.deferred_formatItem.set(key, e);

                        // dm 2026 08 04: _cache2 может быть undefined (строка без dataItem /
                        // колонка вне attr_by_binding — DL2-компоновка): TypeError здесь ронял
                        // formatItem на каждой такой ячейке при прокрутке → грид рисовался
                        // с артефактами (съезд колонок, чужое содержимое). Скрин Игоря 04.08.
                        if (_cache2?.css_user) wjcCore.addClass(e_cell, _cache2.css_user)


                        let row = rows[e_row],
                        dataItem = row.dataItem,
                        _dl2Blank = vueObj.cellBlank(dataItem, col.binding),   // IE 2026 10 07 / ODOO-5800: погашенная ячейка (_DLRow.cells[binding].blank) — значения нет: ни текста, ни пилюли, ни оформления самой ячейки
                        value = (dataItem && !_dl2Blank) ? vueObj.foldAgg_getValue(dataItem, attr_col?.binding, attr_col) : null,   // IE 2026 10 07 / ODOO-5800
                        V = attr_col,
                        cell_attr_type = V?.attr_type,
                        cell_format = V?.format
                        // ODOO-5009: формат меры строки (общая колонка значений value_)
                        // должен применяться и БЕЗ transpose — флаг пускает такую ячейку
                        // в ветку перерисовки ниже, где раньше стоял гард measureT
                        let measureRowFormat = false
                        if (V?.measure_in_dataItem) {
                            const measure = dataItem.measure || vueObj.get_measure_(dataItem); // measure_ через реестр fields_
                            if (measure?.attr_type) {
                                cell_attr_type = measure.attr_type;
                                cell_format = measure.format;
                                measureRowFormat = !!measure.format
                            }
                        }
                        // transpose: параметры ячейки (объект-значение) > строки (row.measure) > колонки
                        const measureT = this.transpose_measure(attr_col, dataItem)
                        if (measureT) {
                            const cellT = this.transpose_cellObject(value)
                            if (cellT) {
                                value = cellT.value
                                if (!e_cell.querySelector('input')) {
                                    // АН 2026 08 10: Link-поле карточки (formatRowsAsColumns) — в ячейке
                                    // резолвнутый valueStr (itemsSource), а не сырой id
                                    e_cell.textContent = ((cellT.attr_type === 'AttrLink' && cellT.valueStr) ? cellT.valueStr : value) ?? ''
                                }
                            } else if (this.attr.formatRowsAsColumns) {
                                value = measureT.value // raw-значение колонки-строки для форматирования
                            }
                            cell_attr_type = cellT?.attr_type || measureT.attr_type || cell_attr_type
                            cell_format = cellT?.format || measureT.format || cell_format
                        }
                        if (attr_col.attr_type === 'AttrMulti' && !measureT && !_dl2Blank) {   // IE 2026 10 07 / ODOO-5800: у погашенной ячейки мульти-значения нет
                            V = this.store.check_AttrMulti(attr_col, dataItem)
                            cell_attr_type = V?.attr_type
                            value = V?.value
                        }
                        // агрегат свёрнутой группы: перерисовать текст числовой ячейки
                        if (dataItem && attr_col && !_dl2Blank) {   // IE 2026 10 07 / ODOO-5800: погашенная ячейка — без агрегата / итога по отбору
                            const _fold = vueObj.foldAgg_value(dataItem, attr_col.binding0 || attr_col.binding, attr_col)
                            vueObj.foldAgg_paintCell(e_cell, _fold, cell_attr_type, cell_format, attr_col, col)
                            vueObj.groupBytes_paint(e_cell, rows[e_row], col, attr_col)   // IE 2026 11 01 / ODOO-349799 (group-bytes)
                            vueObj.filterTotals_mark(e_cell, _fold, dataItem, attr_col.binding0 || attr_col.binding)   // IE 2026 09 21 / ODOO-5800: итог по отбору — пометка ячейки
                        }
                        this.localize_cellText(e_cell, attr_col, dataItem)
                        this.planLabelDate_cellApply(e_cell, dataItem)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана): кэш-путь — wijmo переписал текст ячейки сырым значением
                        if (attr_col.attr_type === 'AttrNumber') {
                            wjcCore.addClass(e_cell, 'wj-align-right')
                        }

                        if (cell_attr_type === 'AttrBool' && attr_col.attr_type !== 'AttrMulti') {
                            wjcCore.addClass(e_cell, 'checkbox')
                            const chk = e_cell.querySelector('input[type=checkbox]')
                            if (attr_col.checkbox_always) {
                                // IE 2026 09 04 / ODOO-336331 (заказ Игоря): колонка-флаг read-only — всегда обычный чекбокс
                                // (и снятый тоже), без disabled-блёклости; переключение — cellClick_method грида
                                let c2 = chk
                                if (!c2) { c2 = document.createElement('input'); c2.type = 'checkbox'; c2.className = 'wj-cell-check'; c2.tabIndex = -1; e_cell.innerHTML = ''; e_cell.appendChild(c2) }
                                c2.checked = value === true
                                c2.disabled = false
                            } else if (vueObj.approvalFlagPartial_apply(e_cell, dataItem, col.binding, value, e_row)) {   // IE 2026 10 14 / ODOO-5800: живой итог — строка грида e_row
                                // IE 2026 10 14 / ODOO-5800 (Igor): итог группы — флаг у части документов — полузаполненный чекбокс (мета бэка approval_partial)
                            } else if (chk && value !== true) {
                                // chk.indeterminate = false
                                e_cell.innerHTML = ``
                            }
                        }
                        // IE 2026 09 10 / ODOO-… (заказ Игоря): AttrBool в строках AttrTabGrid (колонка Value — AttrMulti, тип из строки) —
                        // настоящий чекбокс вместо текста true/false; переключение — клик, пробел/буква, вставка (boolCell_*)
                        if (attr_col.attr_type === 'AttrMulti' && cell_attr_type === 'AttrBool' && !measureT
                                && vueObj.attr.attr_type === 'AttrTabGrid' && !isXlsxExport) {   // boolCell v3
                            vueObj.boolCell_render(e_cell, value)
                        }
                        // if (attr_col.attr_type === 'AttrMulti' && (V?.attr_type === 'AttrBool')) {
                        //     wjcCore.addClass(e_cell, 'checkbox')
                        //     // const chk = e_cell.querySelector('input[type=checkbox]')
                        //     // if (chk && value !== true) {
                        //     //     // chk.indeterminate = false
                        //     //     e_cell.innerHTML = ``
                        //     // }
                        //     // if (!e_cell.querySelector('input')) {
                        //         // wjcCore.addClass(e_cell, 'wj-align-left')
                        //         // e_cell.innerHTML = value
                        //         //     ? `<i class="pi pi-check-square" style="margin-left:2px"></i>`
                        //         //     : ''
                        //     // }
                        // } else 
                        // IE 2026 08 31 / ODOO-5884: формат строки/ячейки сильнее ТИПА колонки —
                        // типовую отрисовку длительности/даты пропускаем, значение печатает
                        // cf_applyFormat ниже (иначе Δ% в колонке дней оставался «6.3d»)
                        const _dlFmtWins = !!vueObj.cf_rowFormat(dataItem, col.binding)
                            && (cell_attr_type === 'AttrDate' || cell_attr_type === 'AttrTime' || cell_attr_type === 'AttrDays')
                        if (!_dlFmtWins && (cell_attr_type === 'AttrDate' || cell_attr_type === 'AttrTime' || cell_attr_type === 'AttrDays' || (attr_col.attr_type === 'AttrMulti' && cell_attr_type === 'AttrNumber') || ((measureT || measureRowFormat) && cell_attr_type === 'AttrNumber' && cell_format))) {
                            if (value) {
                                const input = e_cell.querySelector('input')
                                if (!input) {
                                    if (cell_attr_type === 'AttrDate') {
                                        e_cell.innerHTML = vueObj.store.formatDateHTML(value, V.utc_to_local)
                                    } else if (cell_attr_type === 'AttrTime') {
                                        const _fa = {attr_type:cell_attr_type, format:cell_format, unit:measureT?.unit || attr_col.unit}
                                        e_cell.innerHTML = vueObj.store.formatTimeHTML(value, _fa)
                                        vueObj.durFit_apply(e_cell, value, _fa, 'time', col)   // IE 2026 09 10 / ODOO-… (замечание Игоря): не влезает — округлить
                                    } else if (cell_attr_type === 'AttrDays') {
                                        const _fa = {attr_type:cell_attr_type, format:cell_format}
                                        e_cell.innerHTML = vueObj.store.formatDaysHTML(value, _fa)
                                        vueObj.durFit_apply(e_cell, value, _fa, 'days', col)   // IE 2026 09 10 / ODOO-… (замечание Игоря)
                                    } else if (cell_attr_type === 'AttrNumber' && value && Math.abs(+value) < 0.0001) {
                                        // «жёсткий ноль» (эпсилон-драфт 1e-7) — рисуем «-»
                                        e_cell.innerHTML = '<span class="num-inner">-</span>'
                                    } else if (cell_attr_type === 'AttrNumber' && value && cell_format === 'bytes') {
                                        e_cell.innerHTML = vueObj.store.formatNumberHTML(value, {attr_type:cell_attr_type, format:cell_format})
                                    } else if (attr_col.attr_type === 'AttrMulti' && cell_attr_type === 'AttrNumber') {
                                        // ODOO-4251: формат строки применяется и БЕЗ transpose — в карточке
                                        // (AttrTabGrid) строка = поле записи, и гард (measureT && …) отбрасывал
                                        // её формат: «Знижка, %» с n2 показывалась как «19». Приоритет прежний:
                                        // значение → строка → колонка.
                                        e_cell.innerHTML = `<span class="num-inner">${wjcCore.Globalize.format(value, cell_format || attr_col.format || 'n0')}</span>`
                                        wjcCore.addClass(e_cell, 'num-inner')
                                        if (value < 0) {
                                            wjcCore.addClass(e_cell, 'num-negative')
                                        }
                                    } else if ((measureT || measureRowFormat) && cell_attr_type === 'AttrNumber' && typeof value === 'number') {
                                        // transpose: формат числа из параметров строки (row.measure).
                                        // ODOO-5009: и мера строки в общей колонке значений (value_,
                                        // measure_in_dataItem) — без флага ячейку рисовал wijmo
                                        // форматом КОЛОНКИ (n0 вместо p0/n2 меры). Приоритет прежний:
                                        // значение → мера строки → колонка.
                                        e_cell.innerHTML = `<span class="num-inner">${wjcCore.Globalize.format(value, cell_format || 'n0')}</span>`
                                        wjcCore.addClass(e_cell, 'num-inner')
                                        if (value < 0) {
                                            wjcCore.addClass(e_cell, 'num-negative')
                                        }
                                    }
                                }
                            }
                        }

                        if (attr_col.attr_type === 'AttrGrid' && Array.isArray(value)) {
                            const input = e_cell.querySelector('input')
                            if (!input) {
                                e_cell.textContent = ''
                                const ctxK = { flex, e_cell, dataItem, attr_colC: attr_col, valueC: value, _tagsRow: null, _idsAttr: null, _idsRO: false }   // IE 2026 10 15 / ODOO-5512: cache path = plain AttrGrid cell (no AttrTags row / id list here)
                                const chipWrapper = document.createElement('div')
                                chipWrapper.style.cssText = 'position:relative;display:flex;flex-wrap:wrap;align-items:center;width:100%;height:100%'
                                e_cell.appendChild(chipWrapper)
                                for (const field of value) {
                                    if (field.use === false) continue
                                    const chip = document.createElement('div')
                                    chip.classList.add('chip', 'mr-1', 'scale70')
                                    // скрытые поля отличаем визуально, чтобы их не искали в таблице
                                    if (field.hidden) chip.classList.add('chip-hidden')
                                    chip.draggable = true
                                    chip.dataset.fieldIndex = String(value.indexOf(field))
                                    const chipIcon = document.createElement('span')
                                    chipIcon.classList.add('chip-icon', 'pi', field.pi || 'pi-bars')
                                    chip.appendChild(chipIcon)
                                    const chipText = document.createElement('span')
                                    chipText.classList.add('chip-text')
                                    chipText.textContent = vueObj.chipLabel(field, attr_col)
                                    chip.appendChild(chipText)
                                    const chipRemove = document.createElement('i')
                                    chipRemove.classList.add('chip-remove', 'pi', 'pi-times-circle')
                                    chipRemove.addEventListener('click', (ev) => { ev.stopPropagation(); vueObj.chipRemove_apply(field, ctxK) })   // IE 2026 10 15 / ODOO-5512: ⊗ on the cache path had no handler either
                                    chip.appendChild(chipRemove)
                                    chipWrapper.appendChild(chip)
                                }
                                vueObj.dl2Sort_appendChips(chipWrapper, dataItem, attr_col)   // IE 2026 10 10 / ODOO-341407 (Andrey via core #74338: sort chips in the layout list)
                                if (vueObj.chipInput_allowed(attr_col)) {   // IE 2026 10 14 / ODOO-335246: как в полном пути (formatItem_cells) — поле ввода только если свой текст есть куда писать
                                    const chipInput = document.createElement('input')
                                    chipInput.classList.add('chip-input-cell')
                                    chipInput.type = 'text'
                                    vueObj.chipInput_bind(chipInput, ctxK)   // IE 2026 10 15 / ODOO-5512 (ie-engine7 14.10: Enter did nothing in the input created after a scroll — no handlers on the cache path)
                                    chipWrapper.appendChild(chipInput)
                                }
                            }
                        }

                        if (attr_col.attr_type === 'AttrJSON' || attr_col.attr_type === 'AttrCSS') {
                            const input = e_cell.querySelector('input')
                            if (!input) {
                                const isJSON = attr_col.attr_type === 'AttrJSON'
                                const label = isJSON ? 'JSON' : 'CSS'
                                let preview = ''
                                let hasContent = false
                                if (value && typeof value === 'object') {
                                    const keys = Object.keys(value)
                                    hasContent = keys.length > 0
                                    if (hasContent) {
                                        if (isJSON) {
                                            preview = Array.isArray(value) ? `[${value.length}]` : `{ ${keys.slice(0, 3).join(', ')}${keys.length > 3 ? '…' : ''} }`
                                        } else {
                                            const entries = Object.entries(value)
                                            const shown = entries.slice(0, 2).map(([k, v]) => `${k}: ${v}`).join('; ')
                                            preview = shown + (entries.length > 2 ? '…' : '')
                                        }
                                    }
                                } else if (typeof value === 'string' && value.trim()) {
                                    hasContent = true
                                    preview = value.length > 40 ? value.slice(0, 40) + '…' : value
                                }
                                if (hasContent) {
                                    e_cell.innerHTML = `<span class="cell-code-badge cell-code-badge-${label.toLowerCase()}">${label}</span><span class="cell-code-preview">${preview}</span>`
                                } else {
                                    // пустой объект: wijmo уже вписал String(value) = «[object Object]» —
                                    // чистим, как в полном пути (formatItem_cells)
                                    e_cell.innerHTML = ''
                                }
                            }
                        }
                        // IE 2026 10 18 / ODOO-347310: ссылка в систему-источник (AttrUrl) и миниатюра изображения (AttrImageUrl) — и на кэш-пути
                        if ((attr_col.attr_type === 'AttrUrl' || attr_col.attr_type === 'AttrImageUrl') && !isXlsxExport) {
                            vueObj.sourceCell_render(e_cell, attr_col, value)
                        }
                        if (!isXlsxExport && segLinkCell_on(vueObj.attr, attr_col, value)) vueObj.segLinkCell_render(e_cell)   // IE 2026 10 23 / ODOO-5800 (заказ Игоря, скрин 1): ярлык «список сегмента» — и на кэш-пути

                        //
                        // vueObj.cache1_data_cells__call.set(key, {e:{col:e_col, row:e_row, cell:e_cell, panel:e_panel}});
                        
                        vueObj.formatItem_cells__start_t0 = performance.now()
                        if (!vueObj.formatItem_cells__start_WORKIING) {
                            vueObj.formatItem_cells__start_WORKIING = true
                            window.$cg.callSub(`py__start`);
                            vueObj.formatItem_cells__start()
                            window.$cg.callEnd();
                        }

                        // IE 2026 10 14 / ODOO-5800 (Igor; бот dev02 ui_partial_flag A5z/A8: колонка «Затверджено ПМ» заморожена, клон .wj-frozen-clone пуст): ячейка «частично»
                        // (approvalFlagPartial_apply выше) не стирается — у строки-группы без значения (null) эта ветка снимала созданный там input на КЭШ-ПУТИ, а клон замороженных
                        // wijmo перерисовывает именно им (cloneNode → cellFactory.updateCell → formatItem); полный путь (formatItem_cells) этой очистки не имеет — отсюда «основная ячейка с input, клон пустой»
                        if (col.dataType === wijmo.DataType.Boolean && value == null && !e_cell.classList.contains('approval-partial') && !e_cell.classList.contains('approval-agg')) {   // IE 2026 10 14 / ODOO-5800; approval-agg — живой итог «все ✓» при значении null
                            e.cell.innerHTML = ''   // 🔥 чекбокса не будет
                        }

                        // format/align/source условных правил: контент не в кэше
                        // (_cache.className/cssText) — на быстром пути переприменяется
                        if (dataItem && attr_col?.binding && !_dl2Blank) {   // IE 2026 10 07 / ODOO-5800: погашенная ячейка — без формата / подмены содержимого от правил
                            vueObj.cf_applyFormat(e_cell, e_style, dataItem, col.binding, attr_col, value)
                        }
                        // IE 2026 08 24 / ODOO-5884: веточный дифф-бейдж поля (Branch copy vs рабочая версия)
                        if (dataItem) vueObj.cowBadge_apply(e_cell, dataItem, col.binding, e_row)
                        if (dataItem) vueObj.cmpBadge_apply(e_cell, dataItem, col.binding, e_row)  // «Mark changes»
                        if (dataItem) vueObj.auditDiffBadge_apply(e_cell, dataItem, col.binding, e_row)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: подсветка изменений записи из аудита)
                        if (dataItem) vueObj.placeholder_apply(e_cell, dataItem, col.binding)   // IE 2026 09 05 / ODOO-336330: плейсхолдер дефолта — контент не в кэше

                        // ячейка-превью оформления: контент не в кэше — переприменяется
                        vueObj.formatPreview_cellApply(e_cell, e_style, dataItem, attr_col, col.binding)

                        // IE 2026 10 04 / ODOO-5800 (fe-71) (замечание: короткие Signal / Reason грида Metrics пропадали после прокрутки): показанный текст `<binding>-title` — и на кэш-пути.
                        // Базовый updateCell wijmo при возврате строки в окно переписывает ячейку названием записи / сырым значением, а подстановка `-title`
                        // жила только в полном formatItem_cells (formatItem_cells_innerHTML), который кэш-путь пропускает. Здесь же — подсказка ячейки от бэка.
                        // До подсветки поиска ниже (она идёт по показанному тексту). Выключатель fe.grid.shownTitle
                        // IE 2026 10 05 / ODOO-5800 (fe-85) (ревью cause detail: после прокрутки ячейка «Причина» показывала числа чужой строки либо теряла свои): подсказка с
                        // числами проверки причины — и на кэш-пути. Раньше её ставил и снимал только полный formatItem_cells, а кэш-путь его пропускает: элемент ячейки,
                        // переиспользованный wijmo под другую строку, оставался с прежним title (updateCell wijmo атрибут title не трогает).
                        // IE 2026 10 06 / ODOO-5800 (fe-88): до shownTitle_cellApply — тот ставит ячейке свою подсказку бэка, снятая здесь карточка её не затирает
                        vueObj.causeDetail_cellApply(e_cell, dataItem, attr_col, rows[e_row] instanceof wjGrid.GroupRow, e_row, e_col, true)
                        vueObj.shownTitle_cellApply(e_cell, dataItem, attr_col, e_row, e_col, true)
                        // cache path skips formatItem_cells, so re-apply CHIPS search highlight manually
                        if (vueObj.CHIPS_view.length || vueObj.WIDGET.widget_class === 'widget_SEARCH') {   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска)
                            const input = e_cell.querySelector('input')
                            if (!input && e_cell.textContent) {
                                const highlightedTitle = vueObj.store.check_CHIPS_highlighted(vueObj.WIDGET, e_cell.textContent, vueObj.CHIPS_view, true)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска)
                                if (highlightedTitle) {
                                    e_cell.innerHTML = e_cell.innerHTML.replace(
                                        e_cell.innerHTML.replace(/<\/?[^>]+(>|$)/g, ""),
                                        highlightedTitle
                                    )
                                }
                            }
                        }
                        vueObj.searchAlt_cellMark(e_cell, dataItem, attr_col, value)   // IE 2026 09 25 / ODOO-… (замечание Игоря: поиск в таблице по названиям на других языках): класс search-alt-hit живёт в кэше className — ставится / снимается и на кэш-пути

                        // чипс статуса — DOM, не className; на кеш-пути formatItem_cells
                        // пропущен, поэтому переприменяем вручную (иначе теряется при прокрутке).
                        // Любая статус-колонка (AttrLink/AttrLinkChips с relation_segment STATUS*).
                        if ((attr_col?.attr_type === 'AttrLinkChips' || attr_col?.attr_type === 'AttrLink')
                            && vueObj.isChipSegment(attr_col?.relation_segment)) {   // IE 2026 09 18 / ODOO-5800: + GRADE
                            vueObj.applyStatusChip(e_cell, attr_col, dataItem)
                        } else { // IE 2026 08 26 / ODOO-5800: статус-поле формы записи (AttrTabGrid)
                            const _tf = vueObj.tabGridStatusAttr(dataItem, col.binding)
                            if (_tf) vueObj.applyStatusChip(e_cell, _tf, dataItem, _tf.value)
                        }

                        // IE 2026 08 16 / ODOO-4997: gantt-полосы — DOM, не className;
                        // кеш-путь пропускает formatItem_cells — переприменяем
                        // (симметрично статус-чипсу выше), иначе полосы не рисуются
                        // у ячеек со значением (Busy у Manufacturing Work Centers)
                        if (dataItem?.$gantt) {
                            vueObj.formatItem_gantt_apply(e_cell, dataItem, col.binding, attr_col)
                        }

                        // IE 2026 08 18 / ODOO-5512 (Игорь): бейдж дельты и метка правки —
                        // атрибуты/классы вне кэша className: на кеш-пути переприменяем
                        // из changesStack, иначе пропадают при прокрутке (ячейка 42/18)
                        if (dataItem && attr_col && !isXlsxExport && !vueObj.attr.isPrintTemplate && !vueObj.attr.isPrint) {
                            const _ks = `${e_row}:${col.binding}`
                            const _rs = vueObj.changesStack[_ks]
                            if (_rs) {
                                if (_rs.pastedVal && !_rs.newVal) {
                                    wjcCore.addClass(e_cell, 'wj-has-stack-error')
                                } else if ((_rs.indirect || _rs.related) && !_rs.user) {
                                    wjcCore.addClass(e_cell, 'wj-has-stack-indirect')
                                } else {
                                    wjcCore.addClass(e_cell, 'wj-has-stack')
                                }
                                vueObj.chgBadge_apply(e_cell, _rs)
                            } else {
                                vueObj.chgBadge_clear(e_cell)
                                // правка отменена, а класс остался в кэше className
                                for (const _c of ['wj-has-stack', 'wj-has-stack-indirect', 'wj-has-stack-error']) {
                                    if (e_cell.classList.contains(_c)) wjcCore.removeClass(e_cell, _c)
                                }
                            }
                            vueObj.flash_apply(e_cell, _ks)
                            vueObj.autoValue_apply(e_cell, dataItem, col.binding)   // IE 2026 09 02 / ODOO-11316
                            vueObj.ddNode_attach(e_cell, dataItem, col.binding, e_row, e_col)
                        }

                        const _dd_relSeg = V?.relation_segment || value?.relation_segment || attr_col?.relation_segment
                        vueObj.formatItem_dropdownToggle(e_cell, attr_col, e_row, e_row, e_col, col.binding, key, dataItem, isXlsxExport, vueObj.attr.isPrintTemplate || vueObj.attr.isPrint, !!_dd_relSeg, value)

                    } else {
                        _cache.prevLeft = null
                        _cache.prevWidth = null
                        _cache.prevTop = null
                        _cache.prevHeight = null
                        vueObj.formatItem_cells(e, isXlsxExport, useTimeout, _cache.seq)
                    }

                    // IE 2026 09 17 / ODOO-… (заказ Игоря): merge «назад» — значение объединения дорисовывается в его
                    // корень (левую ячейку) и на кэш-пути (см. mergeBack_apply)
                    // IE 2026 11 01 / ODOO-350449 (заказ Игоря: кругові діаграми за статусами у клітинках REPORT2, опції зрізу і їх розміщення): пирог статусов ячейки-даты — после обоих путей (кэш и полный formatItem_cells), поверх всех перезаписей
                    // содержимого (числа, cf_applyFormat, подсветка поиска), иначе пропадал бы при прокрутке; DOM, не className
                    vueObj.cellView_apply(e_cell, rows[e_row]?.dataItem, col, isXlsxExport, rows[e_row])   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T1): круг активного вида ячеек (cellRing) — оба пути, DOM .cell-ring
                    vueObj.yearTotal_paint(e_cell, rows[e_row]?.dataItem, col, isXlsxExport, rows[e_row])   // IE 2026 11 02 / ODOO-350449 (дополнение Игоря к p217, вариант 1: развёрнутый год — приглушённый итог, свёрнутый — остаток на начало года)
                    vueObj.rowTotal_signalsPaint(e_cell, col, isXlsxExport)   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p201 баланс — «Сигнали» типово, розкритий батьківський рядок без підсумків і сигналів (hover показує), підсумок рядка без сигналів — опція): итог строки за период — без заливки сигналов (опция)
                    vueObj.mergeBack_apply(e, flex, isXlsxExport)
                    // IE 2026 10 09 / ODOO-345618 (заказ Игоря: согласование на сегменте): пилюля статуса согласования и счётчик утверждённых детей — после заголовка строки-группы (колонка дерева);
                    // DOM, не className — как значение объединения выше, переприменяется на обоих путях formatItem (кэш-путь переписывает ячейку). Без данных согласования у строки — ничего
                    if (e_col === 0 || e_cell.__apprPill) vueObj.approvalPill_apply(e_cell, rows[e_row]?.dataItem, e_col, isXlsxExport, e_row)
                    if (!isXlsxExport && vueObj._apprListCols !== false) vueObj.approvalList_apply(e_cell, rows[e_row]?.dataItem, e_col)   // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — FE1-gfmt FE1: монитор — люди ссылками, срок текстом
                    if (!isXlsxExport) vueObj.responsibleCell_apply(e_cell, rows[e_row]?.dataItem, e_col)   // IE 2026 10 10 / ODOO-345618 (Igor 10.10: Responsible is a link): основной ответственный ссылкой на USER + «+N»
                    vueObj.breakArrow_fix(e_cell)   // IE 2026 09 17 (замечание Игоря): стрелка разрыва — одна и в зазоре
                    // IE 2026 11 01 / ODOO-350449 (заказ Игоря: теплова карта на базі таблиці — порівняльна вкладка): внешний декор ячейки данных — функция attr.cellDecor_apply(e_cell, dataItem, col, isXlsxExport, vueObj) встраивающего компонента
                    // (AttrHeatmapGrid: кружок вида «Bubbles»); после обоих путей formatItem (кэш-путь переписывает ячейку), DOM, не className; ошибка декора грид не ломает
                    if (typeof vueObj.attr.cellDecor_apply === 'function') { try { vueObj.attr.cellDecor_apply(e_cell, rows[e_row]?.dataItem, col, isXlsxExport, vueObj, rows[e_row]) } catch (err) { /* декор не обязателен */ } }   // IE 2026 11 01 / ODOO-350449 (замечания Игоря по dev02: раскрытая строка-группа): + строка wijmo (раскрыта ли)
                    // IE 2026 09 17 / ODOO-… (заказ Игоря): ячейки с таким же текстом, что у выбранной — пересборка подсветки
                    // после отрисовки (решение принимается по ОТРИСОВАННОМУ тексту ячейки, см. sameValue_hlApply)
                    if (vueObj._sameVal || vueObj._sameValExt || vueObj._sameValHL) vueObj.sameValue_hlSchedule()
                    if (vueObj._metricHitAll || vueObj._metricHitCur) vueObj.metricHit_schedule()   // IE 2026 09 20 / ODOO-5800 (Igor: переходы чипса метрик по ячейкам, подсветка параметра ячейки и подпадающих ячеек по наведению на чипс)
                    // IE 2026 09 17 / ODOO-… (замечания Игоря): строка-алерт (Uncovered, Expired, …) помечает и свои подчинённые строки
                    vueObj.alertChild_paint(e_cell, rows[e_row]?.dataItem, e_col)
                    if (!isXlsxExport) vueObj.uncHeaders_paint(e_cell, rows, e_row, e_col, col)   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p205 заголовки рядків блоку «Непокрито» без червоної заливки — менше сигналів)
                    // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — M2-1: ячейка, закрытая согласованием, — серая заливка (appr-closed); класс сверяется по факту на обоих путях (кэш-путь переписал className снимком)
                    vueObj.approvalClosed_paint(e_cell, rows[e_row]?.dataItem, e_col, isXlsxExport)
                    if (vueObj._rlCols || e_cell.__rlTip || e_cell.classList.contains('rl-not-found')) vueObj.rl_cellApply(e_cell, rows[e_row]?.dataItem, e_col, isXlsxExport)   // IE 2026 10 25 / ODOO-348925: AttrRowLink — на обоих путях formatItem (кэш-путь переписывает ячейку)
                    if (vueObj._colorCols || e_cell.__colorSw) vueObj.colorCell_apply(e_cell, rows[e_row]?.dataItem, e_row, e_col, isXlsxExport)   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: цвета как на слайде — редактор цвета ColorPicker): образец цвета — на обоих путях formatItem
                    // IE 2026 10 18 / ODOO-5800 (Igor, п. 5: отчёты планов по уровням): классы ячейки по мете плана (_DLRow.cells[b].provenance / status, _DLRow.plan) — plan-manual (треугольник), plan-approved / -draft / -returned / -locked
                    // (заливка); сверяются по факту на обоих путях formatItem (кэш-путь переписал className снимком). Чипы статуса по горизонтам (_DLRow.status_chips) — DOM в заголовке строки, как пилюля согласования
                    vueObj.planCell_paint(e_cell, rows[e_row]?.dataItem, e_col, isXlsxExport)   // IE 2026 10 18 / ODOO-5800
                    if (e_col === 0 || e_cell.__planChips) vueObj.planChips_apply(e_cell, rows[e_row]?.dataItem, e_col, isXlsxExport)   // IE 2026 10 18 / ODOO-5800
                    if (vueObj._raState || e_cell.__raPill) vueObj.ruleApproval_pillApply(e_cell, rows[e_row]?.dataItem, e_col, isXlsxExport)   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128579: согласование правил MAP-*, этап C): пилюля статуса правила в колонке-названии списка MAP-*
                    if (e_col === 0 || e_cell.__paPill) vueObj.planApproval_pillApply(e_cell, rows[e_row]?.dataItem, e_col, isXlsxExport, e_row)   // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B): пилюля и замок строки плана ЗП / DO
                    // IE 2026 10 12 / ODOO-345618 (заказ Игоря: чекбокс у выделенной булевой ячейки): выделенная редактируемая булева ячейка со значением не true — снятый чекбокс
                    // (обе ветки выше стирают снятый чекбокс wijmo); на обоих путях formatItem, переиспользованный wijmo элемент чужой строки чекбокс не уносит
                    if (!isXlsxExport && (e_cell.__boolSel || (flex.selection && flex.selection.row === e_row && flex.selection.col === e_col))) vueObj.boolSel_apply(e_cell, e_row, e_col)   // IE 2026 10 12 / ODOO-345618 (заказ Игоря: чекбокс у выделенной булевой ячейки)
                    // IE 2026 09 22 / ODOO-… (заказ Игоря): полоса-интервал дат у нижнего края ячейки (пары «с / по», одиночные даты)
                    vueObj.dateBar_paint(e_cell, rows[e_row]?.dataItem, e_col, flex, isXlsxExport)
                    // IE 2026 09 25 / ODOO-5800 (Igor: переходы ‹ › по ячейкам тех же документов из формы ячейки): кэш-путь выше переписал className снимком — классы, поставленные
                    // ДО него (sameDoc_paint в начале formatItem), могли пропасть, а класс вспышки из снимка — вернуться; здесь оба решаются заново по состоянию грида:
                    // рамка «тех же документов» (проба 25.09: memo-строка «of which expired» оставалась без рамки) и вспышка текущей остановки ‹ › (по индексам строки /
                    // колонки; элемент, переиспользованный wijmo под другую ячейку, класс теряет — иначе вспышка «переезжала» бы с ним)
                    vueObj.sameDoc_paint(e_cell, rows[e_row]?.dataItem, flex.columns[e_col])
                    if (vueObj._sameDocCur || e_cell.__sameDocCur || e_cell.classList.contains('cell-same-doc-cur')) vueObj.sameDocNav_paint(e_cell, e_row, e_col)
                    // IE 2026 09 23 / ODOO-… (заказ Игоря: итог группы = единственный потомок): ячейка раскрытой группы, повторяющая единственного потомка, — приглушена / спрятана / «↓»
                    vueObj.groupDup_paint(e_cell, flex, rows, e_row, e_col, isXlsxExport)
                    if (vueObj._i18nListCols || e_cell.__i18nAuto) vueObj.i18nFields_cellPaint(e_cell, rows[e_row]?.dataItem, flex.columns[e_col])   // IE 2026 10 06 / ODOO-341407 (п.2): словарный перевод в колонке «… (uk)» — серым, с подсказкой (обе ветки: кэш-путь переписывает className)
                    if (vueObj.attr.attr_type === 'AttrTabGrid' && !isXlsxExport && flex.columns[e_col]?.binding === 'attr.title') vueObj.i18nFields_labelPaint(e_cell, rows[e_row]?.dataItem)   // IE 2026 10 06 / ODOO-341407 (ревью U9): подпись «Назва (uk)» — язык не режется
                    // IE 2026 09 18 / ODOO-… (заказ Игоря): отбор по стилям — ячейки данных без отобранных стилей приглушены
                    if (vueObj._styleFilterKeys?.length || vueObj._metricFilterDoc || vueObj._formatFilterDoc || e_cell.classList.contains('style-filter-dim')) vueObj.styleFilter_paint(e_cell, rows[e_row]?.dataItem, e_col)

                    // spill — ячейка, мерженная до конца строки (values_placement === 'none',
                    // та же логика, что mergeToEnd в getMergedRange): разрешаем контенту выходить
                    // за границы (overflow: visible).
                    // Если есть frozen-колонки — spill вешаем только на клон frozen-ячейки
                    // (cloneFrozenCells); на не-frozen ячейки не вешаем, иначе клон
                    // растягивается на всю ширину и перекрывает прокручиваемую область.
                    // Если frozen-колонок нет — вешаем на любую мерженную до конца ячейку.
                    const spill_dataItem = rows[e_row]?.dataItem
                    const spill_mergeBase = vueObj.mergeColumnBlocksColMap
                        ? Math.max(vueObj.mergeColumnBlocksTotal, vueObj.mergeColumns || 0)
                        : vueObj.mergeColumns
                    const spill_toEnd = spill_dataItem?._DLRow?.values_placement === 'none' && e_col >= spill_mergeBase
                    const spill_isFrozen = flex.frozenColumns && e_col < flex.frozenColumns
                    const spill = spill_toEnd && (flex.frozenColumns
                        ? (spill_isFrozen && vueObj.isInFrozenClone(e_cell, flex))
                        : true)
                    e_cell.classList.toggle('spill', !!spill)

                    // конец фиксированной области: контент не должен налезать на
                    // нефиксированные ячейки (их z-order ниже). Spill-клону
                    // ограничиваем ширину фиксированной областью; обрезанным
                    // frozen-ячейкам — нативный тултип с полным значением
                    if (spill_isFrozen) {
                        // ограничение касается ЛЮБОЙ ячейки фиксированных колонок:
                        // мерженная ячейка (mergeRow) шире своей колонки и без
                        // ограничения рисуется поверх прокручиваемой области
                        const frozenW = flex.columns.slice(0, flex.frozenColumns)
                            .reduce((s, c) => s + (c.renderWidth || 0), 0)
                        // IE 2026 09 18 (замечание Игоря: «после прокрутки вправо ячейки замороженной области схлопываются»):
                        // при горизонтальной прокрутке wijmo сдвигает frozen-ячейки на величину прокрутки (style.left = pos − scrollX),
                        // и «frozenW − left» уходил в минус → max-width: 0px. Левый край берём у КОЛОНКИ корня ячейки
                        const rootCol = flex.columns[e.range ? e.range.col : e_col]
                        // фактический левый край: style.left минус компенсация прокрутки (включает сдвиг отступа уровня дерева),
                        // но не левее самой колонки
                        const visLeft = parseFloat(e_style.left || '') + (flex.scrollPosition?.x || 0)
                        const colLeft = Number.isFinite(rootCol?.pos) ? rootCol.pos : 0
                        const cellLeft = Number.isFinite(visLeft) ? Math.max(colLeft, visLeft) : colLeft
                        const maxW = Math.max(0, frozenW - cellLeft)
                        e_style.maxWidth = `${maxW}px`
                        // IE 2026 09 18 (замечание Игоря: «при скроллинге вправо задвоенный текст в строках-полосах»): фон
                        // frozen-ячейки обязан быть НЕПРОЗРАЧНЫМ — клон замороженных колонок лежит поверх прокрученного
                        // оригинала, и сквозь прозрачную половину градиента полосы (linear-gradient(transparent 50%, цвет 50%))
                        // читался уехавший влево текст оригинала. Под градиент кладём цвет фона грида.
                        // IE 2026 09 18 / ODOO-… (именованные стили): полоса со стилем-ссылкой (cssClass строки: band-po …) несёт градиент
                        // классом, inline его нет — признак полосы берём у строки
                        const _bandRow = spill_dataItem?._DLRow
                        if ((e_style.backgroundImage && e_style.backgroundImage.includes('gradient'))
                            || (_bandRow?.cssClass && (_bandRow.row_type === 'tab' || _bandRow.row_type === 'tabrow' || /(^|\s)band-/.test(_bandRow.cssClass)))) {
                            const bc = e_style.backgroundColor
                            if (!bc || bc === 'initial' || bc === 'transparent' || /rgba\([^)]*,\s*0\s*\)/.test(bc)) {
                                const b = vueObj.alert_baseColor()
                                e_style.backgroundColor = `rgb(${b.r}, ${b.g}, ${b.b})`
                            }
                        }
                        // переполнение скрываем только когда содержимое реально
                        // шире: иначе обрезались бы декоративные оверлеи строки.
                        // Проверка ДВАЖДЫ (сразу и после кадра): контент ячейки
                        // дозаполняется после formatItem, и одноразовый замер
                        // оставлял overflow:visible — длинный титул налезал на
                        // область данных при горизонтальной прокрутке
                        const _frozenClip = () => {
                            if (!e_cell.isConnected) return
                            if (e_cell.scrollWidth > Math.min(maxW, e_cell.clientWidth || maxW) + 1) {
                                e_style.overflow = 'hidden'
                                e_style.textOverflow = 'ellipsis'
                                // тултип — только когда текст реально нечем прочитать:
                                // у разлитой ячейки (spill) скрытая часть и так показана
                                // продолжением поверх соседних колонок, и нативная
                                // подсказка просто дублировала бы её
                                frozenTitle_apply(e_cell, e_cell.textContent, true, spill, vueObj.store.setting(FROZEN_TITLE_FLAG, true) !== false)   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #114076: двойной тултип в колонке ответственного): было «if (!e_cell.title) title = text» — подсказка чужой строки на переиспользованном элементе
                            } else if (e_cell.__fzTitle) frozenTitle_apply(e_cell, e_cell.textContent, false, spill, vueObj.store.setting(FROZEN_TITLE_FLAG, true) !== false)   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #114076: двойной тултип в колонке ответственного): текст больше не обрезан — своя подсказка снимается
                        }
                        // IE 2026 10 29 / ODOO-5800 (ie-dm7 #114076: двойной тултип в колонке ответственного): элемент переиспользован под другую строку (прокрутка, раскрытие групп) и несёт НАШУ подсказку с текстом прежней —
                        // снять сразу, до клона замороженных колонок wijmo (клон копирует атрибуты); обрезанную заново подпишет проверка после кадра
                        if (e_cell.__fzTitle && frozenTitle_stale(e_cell.getAttribute('title'), e_cell.__fzTitle, e_cell.textContent, true) && vueObj.fmtSetting(FROZEN_TITLE_FLAG, true) !== false) { e_cell.removeAttribute('title'); e_cell.__fzTitle = null }   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #114076: двойной тултип в колонке ответственного)
                        // IE 2026 09 04 / ODOO-336379 (флаг frozen_clip_batch): проверка переполнения — одна rAF
                        // на волну для ВСЕХ фиксированных ячеек (сначала все чтения, потом записи), а не rAF +
                        // принудительный layout на каждую ячейку (профиль CPU×4: _frozenClip 11,7 % времени)
                        if (vueObj.cssPerf_on('frozen_clip_batch')) {
                            vueObj.frozenClip_enqueue(e_cell, maxW, spill)
                        } else {
                            _frozenClip()
                            requestAnimationFrame(_frozenClip)
                        }
                    } else if (e_cell.__fzTitle && frozenTitle_stale(e_cell.getAttribute('title'), e_cell.__fzTitle, e_cell.textContent, false) && vueObj.fmtSetting(FROZEN_TITLE_FLAG, true) !== false) {   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #114076: двойной тултип в колонке ответственного): элемент замороженной ячейки достался незамороженной — наша подсказка снимается
                        e_cell.removeAttribute('title'); e_cell.__fzTitle = null   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #114076: двойной тултип в колонке ответственного)
                    }
                    // IE 2026 10 12 / ODOO-335099 (заказ Андрея через dm #72941, RP1: заголовок группы MRV_001 резался границей закреплённых колонок): при горизонтальной прокрутке 0
                    // текст строки-группы продолжается поверх пустых незакреплённых ячеек справа. Разметка — атрибутом data-gho и переменной --gho-r (хвост formatItem —
                    // оба пути, полный и кэш; className клона wijmo переписывает при прокрутке, атрибуты — нет); «прокрутка 0» решает CSS по атрибуту хоста data-gho-x0
                    vueObj.groupHeaderOverflow_paint(e_cell, flex, rows, e_row, e_col, e.range, isXlsxExport)

                } else if (this.no_allow_formatItemHeaders) {
                    // do nothing
                } else if (e_panel === flex.rowHeaders) {
                    let irow = e_row,
                        row = rows[irow],
                        dataItem = row.dataItem,
                        elements_overflow = []
                    // IE 2026 09 26 / ODOO-… (заказ Игоря: doc.use в заголовках строк): элемент ячейки грид переиспользует — подсказка флажка (Show tooltips)
                    // прежней ячейки снимается; у флажка данных ставится заново ниже (ячейка номера / selector «Enabled» не несёт)
                    if (e_cell.__rhTipSet) { tooltip.setTooltip(e_cell, null); e_cell.__rhTipSet = false }

                    wjcCore.addClass(e_cell, 'data-cell')
                    e_cell.data_cell = { 
                        irow: irow,
                        row: e_row,
                        col: e_col,
                        irefresh: this.irefresh,
                        // IE 2026 08 27 / ODOO-11312 (M03, an-dm): идентичность содержимого ячейки —
                        // строка данных и биндинг колонки; по ним updateCell решает, можно ли не
                        // переформатировать DOM-элемент, а не только по позиции (см. CellFactory.updateCell)
                        item: row?.dataItem,
                        colKey: e_panel.columns[e_col]?.binding,
                        // cellType: e_panel.cellType,
                    }

                    if (this.attr.childItemsPath) { 
                        if (row.hasChildren) {
                            if (row.isCollapsed) {
                                // row.height = null
                            } else {
                                wjcCore.addClass(e_cell, `group-row-level-${row.level}`)
                                if (this.plainLevel_row(row, dataItem)) wjcCore.addClass(e_cell, PLAIN_LEVEL_CLASS)   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p206 рядок Data Layout без оформлення рівня — білий фон у розкритого рядка об'єкта, опція)
                            }
                        }

                        if (_cache.sectionEnd === undefined) { // (1)
                            let iPrev = irow - 1;
                            while (iPrev > 0 && rows[iPrev].visibleIndex === -1) iPrev--;
                            _cache.sectionStart = iPrev > 0 && row.level < rows[iPrev].level

                            let iNext = irow + 1
                            while (iNext < rows.length && rows[iNext].visibleIndex === -1) iNext++;
                            _cache.sectionEnd = iNext < rows.length && row.level > rows[iNext].level
                            _cache.iNext = iNext
                        }

                        // break-top
                        if (this.attr.use_delivery) {
                            if (_cache.sectionStart) {
                                // IE 2026 08 20 / ODOO-5512 (заказ Игоря): при
                                // Borders=None высота всех строк одинаковая —
                                // без зазора на границе поддеревьев
                                // IE 2026 08 27 / ODOO-5800: в режиме рамки (tree_lines не 'dotted') зазоров секций нет
                                _cache.breakTop = (this.attr.borders === 'None' || this.treeLines_noGaps()) ? 0 : 10 // row.level === 0 ? this.break_width : row.level === 1 ? 10 : 5
                                const prevTop = parseFloat(e_style.top || '0');
                                e_style.top = `${prevTop + _cache.breakTop}px`;
                                const prevHeight = parseFloat(e_style.height || '0');
                                e_style.height = `${prevHeight - _cache.breakTop}px`;

                                // // delivery-top
                                // if (_cache.breakTop) {
                                //     let div1 = document.createElement('div')
                                //     div1.className = `cell-delivery-top`
                                //     div1.style.top = `-${_cache.breakTop}px`
                                //     div1.style.height = `${_cache.breakTop}px`
                                //     elements_overflow.push(div1)
                                // }
                            }
                            if (_cache.sectionEnd) {
                                // delivery-top (при Borders=None зазора нет —
                                // IE 2026 08 20 / ODOO-5512)
                                _cache.breakBottom = (this.attr.borders === 'None' || this.treeLines_noGaps()) ? 0 : 10 // IE 2026 08 27 / ODOO-5800
                                if (_cache.breakBottom) {
                                    let div1 = document.createElement('div')
                                    div1.className = `cell-delivery-top`
                                    div1.style.left = `-${_cache.paddingLeft||0}px`
                                    div1.style.right = `-1px`
                                    div1.style.bottom = `-${_cache.breakBottom}px`
                                    div1.style.height = `${_cache.breakBottom}px`
                                    elements_overflow.push(div1)
                                }
                            }
                        }

                        // if (row.level > rows[irow+1]?.level) { // irow+1 < rows.length && 
                        //     wjcCore.addClass(e_cell, `row-bottom-group`)
                        // }

                        if (e_col === 0 && row.level < rows[irow-1]?.level) {
                            wjcCore.addClass(e_cell, `row-top-left-group`)
                        }
                        // if (e_col === 0 && row.level !== rows[irow+1]?.level) {
                        //     wjcCore.addClass(e_cell, `row-bottom-left-group`)
                        // }

                        if (e_cell.parentElement?.parentElement?.parentElement && e_cell.parentElement.parentElement.parentElement.style['overflow'] !== 'hidden') {
                            e_cell.parentElement.parentElement.parentElement.style['overflow'] = `hidden`
                        }
                        if (e_cell.parentElement && e_cell.parentElement.style['left'] !== `${row.level * this.multiLevel}px`) {
                            e_cell.parentElement.style['left'] = `${row.level * this.multiLevel}px`
                        }
                    }

                    if (e_col === this.rowNumberColumn) {
                        if (dataItem && dataItem.cssClass_rowHeader) {
                            wjcCore.addClass(e_cell, dataItem.cssClass_rowHeader)
                        }

                        // rowIndexOffset: сквозная нумерация секций мульти-вертикальной
                        // таблицы печати (AttrGridGroup)
                        let rowTitle = e_row + 1 + (this.attr.rowIndexOffset || 0),
                        rowNumber = rowTitle,
                        rowPrefix = ''
                        if (!dataItem) {
                            rowTitle = rowNumber = '*'
                        }
                        // const rowTitle = dataItem?._meta?.number || ''
                        // const rowPrefix = dataItem?._meta?.prefix || ''
                        // const rowNumber = dataItem?._meta?.number0 || ''

                        if (rowTitle) {
                            let rowHeaderButton = ''
                            // IE 2026 09 19 / ODOO-… (замечание Игоря: «верни иконки открытия виджета элемента на заголовке строки … в виде стрелочки
                            // вправо»): значок брался из оформления команды двойного клика, а после набора иконок платформы (13.09) у команд
                            // «открыть элемент» там иконка СЕГМЕНТА записи (калькулятор, лист …) — стрелка пропала. У команды открытия —
                            // снова стрелка; у прочих команд двойного клика (выбор настройки ✓ и т.п.) значок команды остаётся
                            const _rhIco = ((this.dblclick_action?.command === 'widget_open' || this.dblclick_action?._openRecord) ? '' : this.dblclick_action?.cssClass) || this.topLeftMenu_cssClass   // IE 2026 10 14 / ODOO-5800: открытие записи строки динамического списка — та же стрелка
                            if (this.dblclick_action) {
                                // IE 2026 09 23 / ODOO-341407: i18n (aria-label)
                                rowHeaderButton = 
                                `<div class="row-header">
                                    <button class="button-hover wj-btn wj-btn-default attr-doc-button my-text-shadow" id="onHeader__Click" tabindex="-1" type="button" aria-label="${t('Internal link')}">
                                        <i class="pi pi-doc ${_rhIco}" id="onHeader__Click"></i>
                                    </button>
                                </div>`
                            }
                            const _rnHit = dataItem && !isXlsxExport && this.gridSearchRowNum_hit(rowNumber)   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки): номер строки найден чипсом поиска
                            e_cell.innerHTML = `<span class="row-prefix">${rowPrefix}</span><span class="row-number">${_rnHit ? `<span class="wj-state-match">${rowNumber}</span>` : rowNumber}</span>${rowHeaderButton}`   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
                            wjcCore.toggleClass(e_cell, 'wj-state-match-cur', this._gridNavRowCur === e_row)   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки): рамка текущей остановки ‹ ›
                        } else {
                            e_cell.innerHTML = ''
                        }

                        // nodeRow
                        if (dataItem?._fe?.['@@node_key']) {
                            const node = this.PAGE.nodes_svg?.[ dataItem._fe['@@node_key'] ]
                            if (node) {
                                node.div = e_cell
                                node.col = e_col
                                node.row = e_row
                                node.join = 'center'
                            }
                        }

                    } else if (e_col === this.columnNumberColumn) {
                        const _rhNew = !!this._rhFlagsOn   // IE 2026 09 26 / ODOO-… (заказ Игоря: doc.use в заголовках строк): positionNew — тоже колонка заголовков строк
                        const isServiceRow = (d) => {
                            if (!d) return false
                            const b = d.binding
                            return b === 'selector' || b === 'use' || d.position === 'rowHeaders' || (_rhNew && d.positionNew === 'rowHeaders')
                        }
                        if (!dataItem || this.store.get_value(dataItem, 'use') === false || isServiceRow(dataItem)) {
                            e_cell.innerText = ''
                        } else {
                            // IE 2026 10 23 / ODOO-348708 (заказ Игоря): номер = номер колонки в шапке самого грида (e_col + 1). Вложенный грид (attr_type AttrGrid: conditional_format, WHERE, fields…)
                            // в шапке родителя — ОДНА колонка, его дети и потомки номера не получают и счётчик не двигают (utils/fieldsColnum.js; раньше считались листьями наравне с колонками).
                            // hidden=true — не колонка (isHidden грида); v-if/access колонок окно не видит — там расхождение возможно.
                            const isEnabled = (d) => d && this.store.get_value(d, 'use') !== false && d.hidden !== true && !isServiceRow(d)
                            const colNum = colnum_number(flex.rows, e_row, isEnabled)
                            e_cell.innerText = colNum ?? ''
                        }

                    } else if (e_col === this.rowHeaders_col_feSelected) {
                        let isSelected = false
                        for (const range of this.flex.selectedRanges) {
                            const r1 = Math.min(range.row, range.row2)
                            const r2 = Math.max(range.row, range.row2)
                            if (r1 <= e_row && e_row <= r2) { isSelected = true; break }
                        }
                        let checkbox = document.createElement('input')
                        checkbox.type = 'checkbox'
                        checkbox.className = 'fe-selected-check'
                        checkbox.tabIndex = -1
                        checkbox.id = 'onFeSelected__Click'
                        checkbox.checked = isSelected
                        const _irow = e_row
                        checkbox.addEventListener('mousedown', (evt) => {
                            evt.preventDefault()
                            evt.stopPropagation()
                            evt.stopImmediatePropagation()
                            const saved = this.isRowHeaderClick
                            this.isRowHeaderClick = false
                            // preserve current scroll position: changing selectedRanges makes
                            // Wijmo scroll the (possibly off-screen) selection into view
                            const _sp = this.flex.scrollPosition
                            const _spx = _sp.x, _spy = _sp.y
                            const currRanges = this.flex.selectedRanges
                            const c1 = currRanges[0]?.leftCol ?? 0
                            const c2 = currRanges[0]?.rightCol ?? 0
                            const alreadyIn = currRanges.some(rng => {
                                const r1 = Math.min(rng.row, rng.row2), r2 = Math.max(rng.row, rng.row2)
                                return r1 <= _irow && _irow <= r2
                            })
                            if (!alreadyIn) {
                                this.flex.selectedRanges = [...currRanges, new wjGrid.CellRange(_irow, c1, _irow, c2)]
                            } else {
                                const newRanges = []
                                for (const rng of currRanges) {
                                    const r1 = Math.min(rng.row, rng.row2), r2 = Math.max(rng.row, rng.row2)
                                    const rc1 = Math.min(rng.col, rng.col2), rc2 = Math.max(rng.col, rng.col2)
                                    if (r2 < _irow || r1 > _irow) {
                                        newRanges.push(new wjGrid.CellRange(r1, rc1, r2, rc2))
                                    } else {
                                        if (r1 < _irow) newRanges.push(new wjGrid.CellRange(r1, rc1, _irow - 1, rc2))
                                        if (r2 > _irow) newRanges.push(new wjGrid.CellRange(_irow + 1, rc1, r2, rc2))
                                    }
                                }
                                if (!newRanges.length) newRanges.push(new wjGrid.CellRange(_irow, c1, _irow, c1))
                                this.flex.selectedRanges = newRanges
                            }
                            this.flex.scrollPosition = new wjcCore.Point(_spx, _spy)
                            this.isRowHeaderClick = saved
                        })
                        e_cell.innerHTML = ''
                        e_cell.style.display = 'flex'
                        e_cell.style.alignItems = 'center'
                        e_cell.style.justifyContent = 'center'
                        e_cell.appendChild(checkbox)

                    } else if (e_col === this.rowHeaders_col_selector || e_col === this.rowHeaders_col_use || this.rowHeaders_cols_pos.some(x => x.col_idx === e_col)) {
                        let binding, rh_text = false
                        if (e_col === this.rowHeaders_col_selector) binding = 'selector'
                        else if (e_col === this.rowHeaders_col_use) binding = 'use'
                        else {
                            const rh = this.rowHeaders_cols_pos.find(x => x.col_idx === e_col)
                            binding = rh.binding
                            // не-bool атрибут position='rowHeaders' — текстовая служебная
                            // колонка (например Type у compare: ≡ prev / Δ / Δ%)
                            rh_text = rh.attr_type && rh.attr_type !== 'AttrBool'
                        }

                        wjcCore.addClass(e_cell, 'data-cell')
                        e_cell.data_cell.binding = binding

                        if (rh_text) {
                            let v = this.store.get_value(dataItem, binding)   // IE 2026 10 05 / ODOO-5800 (fe-87): let
                            // IE 2026 10 05 / ODOO-5800 (fe-87; замечание Игоря 05.10: в «Differences only» у полос в колонке Type — литерал «tabrow»): колонка метки строки сравнения
                            // привязана к _DLRow.row_type, а там же лежит вид строки раскладки (tab / tabrow / …) — технический перечень пользователю не показывается
                            // (utils/compareRows.rowType_label). Выключатель fe.ux.compareServiceRows (false — печать как раньше)
                            if (binding === COMPARE_ROW_TYPE_BINDING && this.store.setting('fe.ux.compareServiceRows', true) !== false) v = rowType_label(v)   // IE 2026 10 05 / ODOO-5800 (fe-87)
                            e_cell.innerText = v == null ? '' : String(v)
                            e_cell.style.textAlign = 'center'
                            const _rhm = this.rowHeaders_cols_pos.find(x => x.col_idx === e_col)
                            if (_rhm?.mergeRows) {
                                // IE 2026 09 05 / ODOO-336283 (заказ Игоря): титул группы AttrTabHeader в шапке строк —
                                // жирный, по центру объединённой ячейки; стиль полосы (Style узла) — из _DLRow.cells
                                wjcCore.addClass(e_cell, _rhm.cssClass || 'row-dl-tabhdr')
                                const _cm = dataItem?._DLRow?.cells?.[binding]
                                if (_cm?.cssStyle) e_cell.style.cssText += ';' + _cm.cssStyle
                            } else if (v) {
                                // маркер заголовка compare-строки (≡ prev / Δ / Δ%)
                                wjcCore.addClass(e_cell, 'row-compare-header')
                            }
                            if (dataItem?._DLRow?.cmp_prev_only) wjcCore.addClass(e_cell, 'row-compare-prev-only')   // IE 2026 10 30 / ODOO-5800 (compare: prev-only ghost rows): ячейка шапки строки-призрака — тот же приглушённый тон, что у ячеек данных (cssClasses бэка до шапки не доходят)
                        } else if (binding === 'selector' && typeof this.attr.selectorRow_state === 'function' && this.selectorRow_stateOf(dataItem) === null) {
                            // IE 2026 11 01 / ODOO-350449 (заказ Игоря через ie-webscm7-2 #122315: легенда вимк., колонка прапорців у Числах, чіп як селектор): колонка-селектор встраивающего компонента (AttrHeatmapGrid): у строки без флажка (группа) — пустая ячейка
                            e_cell.innerHTML = ''
                        } else {
                            let checkbox = document.createElement('input')
                            checkbox.type = 'checkbox'
                            checkbox.className = 'wj-cell-check'
                            checkbox.tabIndex = -1
                            checkbox.id = 'onSelector__Click'
                            checkbox.checked = this.rhBool_checkedOf(dataItem, binding, e_col)   // IE 2026 10 23 / ODOO-5800
                            if (binding === 'selector' && typeof this.attr.selectorRow_state === 'function') checkbox.checked = !!this.selectorRow_stateOf(dataItem)   // IE 2026 11 01 / ODOO-350449 (заказ Игоря через ie-webscm7-2 #122315: легенда вимк., колонка прапорців у Числах, чіп як селектор): состояние — от встраивающего компонента (чипс стола)
                            // checkbox.disabled = this.flex.isReadOnly
                            e_cell.innerHTML = ''
                            e_cell.appendChild(checkbox)
                            // IE 2026 09 26 / ODOO-… (заказ Игоря: doc.use в заголовках строк): строка заблокирована (у языков — en: _DLRow.cells[binding].isReadOnly) —
                            // флажок виден без блёклости disabled, но не переключается; вид — из меты ячейки (cssClasses, как у ячейки данных), причина — в
                            // подсказке (Alt / Show tooltips) и в уведомлении при клике
                            const _rhLk = this.rhLock_of(dataItem, binding)
                            if (_rhLk) {
                                wjcCore.addClass(e_cell, 'rh-locked')
                                if (Array.isArray(_rhLk.cssClasses) && _rhLk.cssClasses.length) wjcCore.addClass(e_cell, _rhLk.cssClasses.join(' '))
                                checkbox.setAttribute('aria-disabled', 'true')
                            }
                            // подсказка Show tooltips — у флажка данных (не selector / use); снятие с переиспользованного элемента — в начале ветки rowHeaders
                            if (this._rhFlagsOn && this.store.showTooltip && binding !== 'selector' && binding !== 'use') {
                                const _rhTipT = this.rhTip_html(e_row, e_col)
                                if (_rhTipT) { tooltip.setTooltip(e_cell, _rhTipT); e_cell.__rhTipSet = true }
                            }
                        }
                        // IE 2026 08 24 / ODOO-5884 (замечание Игоря): бейджи изменений и в зоне заголовков
                        // строк (галка use и служебные rowHeaders-колонки): текущие правки, Branch copy,
                        // «Mark changes» — та же логика, что у ячеек данных
                        if (dataItem && binding !== 'selector') {
                            const _chg = (this.undoStack || []).find(x => x && (x.$item === dataItem || x.item === dataItem) && (x.col_binding === binding || x.binding === binding))
                            if (_chg) this.chgBadge_apply(e_cell, _chg)
                            else this.chgBadge_clear(e_cell)
                            this.cowBadge_apply(e_cell, dataItem, binding, e_row)
                            this.cmpBadge_apply(e_cell, dataItem, binding, e_row)
                            this.auditDiffBadge_apply(e_cell, dataItem, binding, e_row)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: подсветка изменений записи из аудита)
                        }
                    }

                    // need_overflow
                    if (elements_overflow.length) {
                        e_style.overflow = 'visible';
                        // перенос — только при wordWrap колонки rowHeaders (см.
                        // аналогичную ветку ячеек данных): по умолчанию обрезка
                        if (flex.rowHeaders.columns[e_col]?.wordWrap) {
                            e_style.wordBreak = 'break-all';
                            e_style.whiteSpace = 'normal';
                            e_style.overflowWrap = 'break-word';
                            e_style.hyphens = 'auto';
                        }

                        // текст узкой колонки не выходит за рамки ячейки: клип во
                        // внутренний контейнер; линии групп (div0) — вне клипа
                        if (!e_cell.querySelector(':scope > .cell-text-clip')) {
                            const clip = document.createElement('div')
                            clip.className = 'cell-text-clip'
                            while (e_cell.firstChild) clip.appendChild(e_cell.firstChild)
                            e_cell.appendChild(clip)
                        }

                        let div0 = document.createElement('i')
                        for (let i=0; i<elements_overflow.length; i++) {
                            div0.appendChild(elements_overflow[i])
                        }
                        e_cell.appendChild(div0)
                    }

                    if (dataItem?._meta?.new) {
                        wjcCore.addClass(e_cell, 'new')
                    } else if (dataItem?._meta?.modified) {
                        wjcCore.addClass(e_cell, 'modified')
                    }

                } else if (e_panel === flex.columnHeaders) {
                    let col = flex.columns[e_col],
                        col_binding = col.binding,
                        attr_col = this.attr_by_binding[col_binding];

                    e_cell.data_cell = {
                        col_binding: col_binding,
                        row: e_row,
                        col: e_col,
                        irefresh: this.irefresh,
                        // cellType: e_panel.cellType,
                    }

                    // IE 2026 08 16 / ODOO-4997: карточное оформление колонок
                    // (Row style 'Cards' на строке колонок лэйаута) — шапка:
                    // верхняя строка (заголовок) — синяя скруглённая, остальные
                    // строки шапки — карточный фон
                    if (this.cards_isCol(col_binding)) {
                        wjcCore.addClass(e_cell, e_row === 0 ? 'card-col-head-top' : 'card-col-head')
                    }

                    // IE 2026 08 16 / ODOO-4997 (заказ Игоря, MWC п.4): Hide title
                    // у меры прячет ПОДПИСЬ меры в шапке (строку 'Busy');
                    // дату и номер колонки не трогаем — гасим только ячейку,
                    // чей текст равен титулу меры
                    if (attr_col?.hideTitle && attr_col?.raw_binding) {
                        const _mt = String(attr_col.title || '').trim()
                        if (_mt && e_cell.textContent.trim() === _mt) e_cell.textContent = ''
                        // IE 2026 08 16 (заказ Игоря): пустую ячейку скрытого
                        // титула визуально сливаем с ячейкой даты выше
                        wjcCore.addClass(e_cell, 'hdr-title-hidden')
                    }

                    // merge
                    const rng = flex.getMergedRange(e_panel, e_row, e_col, true)
                    if (rng && rng.row !== rng.row2) {
                        wjcCore.addClass(e_cell, 'merged-rows')
                    }

                    const expandedAttr = e_cell.getAttribute('aria-expanded');
                    const isCollapsed = expandedAttr === 'false';
                    // if (isCollapsed) {
                    //     wjcCore.addClass(e_cell, 'wj-align-left')
                    // } else {
                    //     wjcCore.addClass(e_cell, 'wj-align-center') // 2025-08-01
                    // }
                    wjcCore.removeClass(e_cell, 'cg-hdr-al')   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: заголовок группы колонок по align)
                    const _gAl = this.colgroupHdr_align(rng, e_row, e_col)   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: заголовок группы колонок по align): 'center' | 'right' | '' (нет align / выключатель)
                    if (_gAl) {   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: заголовок группы колонок по align)
                        wjcCore.addClass(e_cell, 'cg-hdr-al')   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: заголовок группы колонок по align): не липнет (set_stickyColumns)
                        wjcCore.addClass(e_cell, _gAl === 'right' ? 'wj-align-right' : 'wj-align-center')   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: заголовок группы колонок по align)
                        wjcCore.removeClass(e_cell, _gAl === 'right' ? 'wj-align-center' : 'wj-align-right')   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: заголовок группы колонок по align)
                        wjcCore.removeClass(e_cell, 'wj-align-left')   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: заголовок группы колонок по align)
                    } else if (rng && rng.col !== rng.col2) {
                        wjcCore.addClass(e_cell, 'wj-align-left')
                        wjcCore.removeClass(e_cell, 'wj-align-center')
                    } else {
                        wjcCore.addClass(e_cell, 'wj-align-center')
                        wjcCore.removeClass(e_cell, 'wj-align-left')
                    }
                    if (!_gAl) wjcCore.removeClass(e_cell, 'wj-align-right')   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: заголовок группы колонок по align): у группы с right класс нужен


                    if (col.header === '↑') {
                        wjcCore.addClass(e_cell, 'no-top-border')
                    }

                    // линия начала таблицы — на ячейках ВЕРХНЕГО ряда шапки (не на
                    // контейнере .wj-colheaders): тогда break-before сдвиг естественно
                    // разрывает её в зазоре между колонками (не висит серым сегментом)
                    if (e_row === 0) {
                        wjcCore.addClass(e_cell, 'cs-topline')
                    }

                    // узкая колонка: центрирование обрезало заголовок с ОБЕИХ сторон
                    // («ead tim») — при переполнении показываем начало с многоточием
                    // IE 2026 09 04 / ODOO-336291 (mobile UX): P-07 hdrClipCheck — чтение scrollWidth/clientWidth здесь =
                    // forced layout на КАЖДУЮ ячейку шапки на каждом шаге прокрутки (45 % CPU горизонтального
                    // пана, аудит B-01). 'deferred' (дефолт): результат по ключу текст+ширина из кэша,
                    // незнакомые ячейки меряются одним rAF после отрисовки (hdrClip_check); 'sync' — прежнее;
                    // 'off' — без проверки. Переключение: window.fastEntry.set('hdrClipCheck', …)
                    const _hcc = this.store?.fastEntry?.hdrClipCheck ?? 'deferred'
                    if (_hcc === 'sync') {
                        if (e_cell.scrollWidth > e_cell.clientWidth + 1) {
                            wjcCore.addClass(e_cell, 'hdr-clip-start')
                        }
                    } else if (_hcc !== 'off') {
                        this.hdrClip_check(e_cell)
                    }

                    // columnGroups
                    // IE 2026 11 01 / ODOO-349799 (group-header-class): было `if (e.range_col !== e.range_col2)` — таких полей у wijmo FormatItemEventArgs
                    // нет (опечатка переименования 3821c106, 28.10.2025: e.range.col / e.range.col2 → e.range_col / e.range_col2): undefined !== undefined
                    // ложно всегда, attr группы на ячейку её заголовка не доходил — оставался attr первой leaf-колонки (cssClass_columnHeader /
                    // cssClasses_columnHeader группы с бэка не красили заголовок: «Configuration objects», группы Addon records / Modified / Local серые).
                    // Ключ `${первая колонка группы}-${ряд}` строит scan_columnGroups_fromFlex только для групп — ищем без условия по ширине
                    // (группа из одной видимой колонки — тоже ячейка группы)
                    attr_col = this.attr_by_bindingColumnGroup[`${col_binding}-${e_row}`] || attr_col   // IE 2026 11 01 / ODOO-349799 (group-header-class)

                    // разрыв break_before: как у полос мульти-таблицы — без правого
                    // бордюра у левого блока и левого у правого (края зазора чистые)
                    if (this.attr.use_delivery) {
                        if (attr_col && this.breakOf(attr_col)) {   // IE 2026 09 19 / ODOO-…: + разрыв, переехавший со скрытой колонки
                            wjcCore.addClass(e_cell, 'cs-break-right')
                        }
                        let _nextIdx = (rng && rng.col2 != null ? rng.col2 : e_col) + 1   // IE 2026 11 01 / ODOO-349799 (group-header-class): rng — объединённый диапазон ячейки (e.range_col2 у wijmo не было → для группы брался второй её столбец)
                        while (flex.columns[_nextIdx] && !flex.columns[_nextIdx].visible) _nextIdx++
                        const _nextCol = flex.columns[_nextIdx]
                        if (_nextCol) {
                            // флаг может лежать на группе (attr_by_bindingColumnGroup), не на leaf
                            const _nAttr = this.attr_by_bindingColumnGroup?.[`${_nextCol.binding}-${e_row}`]
                                || this.attr_by_binding[_nextCol.binding]
                            if (this.breakOf(_nAttr)) {   // IE 2026 09 19 / ODOO-…: + разрыв, переехавший со скрытой колонки
                                wjcCore.addClass(e_cell, 'cs-break-prev')
                            }
                        }
                    }

                    // break-left
                    if (this.attr.use_delivery) {
                        if (attr_col && this.breakOf(attr_col)) {   // IE 2026 09 19 / ODOO-…: + разрыв, переехавший со скрытой колонки
                            const left = parseFloat(e_style.left) || 0;
                            const width = parseFloat(e_style.width) || 0;

                            e_style.left = `${left + this.break_width}px`;
                            e_style.width = `${width - this.break_width}px`;
                        }
                    }

                    // // frozenColumns - background
                    // const paddingLeft = 33
                    // if (e_col === 0 && paddingLeft && this.attr.frozenColumns) { 
                    //     let div1 = document.createElement('div')
                    //     div1.classList = [`background`]
                    //     div1.style.left = `-${paddingLeft}px`
                    //     div1.style.width = `${paddingLeft}px`
                    //     e_cell.insertBefore(div1, e_cell.firstChild)
                    // }

                    // useColumnNumberRow
                    if (e_row === this.columnNumberRow) {
                        wjcCore.addClass(e_cell, 'wj-header-number-row')
                        e_cell.innerText = e_col + 1

                        // создаём иконку «воронки»
                        if (this.useColumnNumberRow_filter) {
                            const icon = document.createElement('i');
                            icon.className = 'wj-glyph-filter'; // готовый класс Wijmo
                            icon.style.marginLeft = '4px';
                            icon.addEventListener('click', (evt) => {
                                evt.stopPropagation();
                                evt.preventDefault();
                                if (!this.filter) return;
                                this.filter.editColumnFilter(col);
                            });

                            e_cell.appendChild(icon);
                        }
                    } else if (this.isMappedWidget_rows && e_row === this.isMappedWidget_rows) {
                        if (attr_col.isMapped) {
                            wjcCore.addClass(e_cell, `mapped-cels pl-4`)
                            e_cell.innerHTML = `<i class="pi top-2 left-2 ${this.attr_isMappedWidget.pi2}"></i>${attr_col.mapped_title}` // (${attr_col.isMapped}) 
                        } else {
                            wjcCore.addClass(e_cell, `no-mapped-cels`)
                            e_cell.textContent = ``
                        }
                        if (attr_col['@@node_key']) {
                            const node = this.PAGE.nodes_svg?.[ attr_col['@@node_key'] ]
                            if (node) {
                                node.div = e_cell
                                node.col = e_col
                                // node.row = e_row
                                node.join = 'top'
                            }
                        }
                    } else if (e_row === this.stickyScrollStart) {
                        // ⚠ тайтл НЕ пишем в ячейку: он живёт в оверлее
                        // .sticky-scroll-title (см. set_stickyRowsTitle_afterTimeout —
                        // ячейка скроллится по X, текст в ней дёргался). Ячейку
                        // чистим: wijmo мог переиспользовать её с чужим контентом.
                        if (e_cell.firstChild) e_cell.textContent = ''

                        wjcCore.addClass(e_cell, 'wj-header')
                        wjcCore.addClass(e_cell, 'sticky-scroll')

                        this.set_stickyRowsTitle()

                    } else {
                        wjcCore.addClass(e_cell, 'wj-header-top')
                        // не помещающийся титул прижимаем ВЛЕВО (обрезка только
                        // справа; по центру резало с обеих сторон: «ead tim»)
                        // IE 2026 09 04 / ODOO-336291 (mobile UX): P-07 — отдельный rAF на КАЖДУЮ ячейку читал scrollWidth
                        // после записи стиля соседкой (layout thrash уже внутри кадра); в режиме 'deferred'
                        // выравнивание ставит общий батч hdrClip_check (одно чтение на кадр, из кэша — без чтения)
                        if (_hcc === 'sync') {
                            requestAnimationFrame(() => {
                                if (!e_cell.isConnected) return
                                if (e_cell.scrollWidth > e_cell.clientWidth + 1) {
                                    e_cell.style.textAlign = 'left'
                                    e_cell.style.justifyContent = 'flex-start'
                                }
                            })
                        } else if (_hcc !== 'off') {
                            this.hdrClip_check(e_cell, true)
                        }
                        // независимые каналы: табличная часть cssClasses_columnHeader —
                        // header-правила conditional_format/миграция; строковый
                        // cssClass_columnHeader — пользовательский, рендерятся оба
                        if (attr_col && Array.isArray(attr_col.cssClasses_columnHeader)) {
                            const cssClasses = this.store.resolve_cssClasses(attr_col.cssClasses_columnHeader)
                            if (cssClasses) {
                                wjcCore.addClass(e_cell, cssClasses)
                            }
                        }
                        if (attr_col && attr_col.cssClass_columnHeader) {
                            wjcCore.addClass(e_cell, attr_col.cssClass_columnHeader)
                        }
                        this.planHeader_paint(e_cell, attr_col, e_panel, e_row, e_col)   // IE 2026 10 18 / ODOO-5800 (Igor, п. 5): полоса горизонта в заголовке колонки — plan-horizon-tactical / -strategic по attr_col.horizon; IE 2026 10 19: только нижняя строка шапки
                        if (attr_col) {
                            if (this.store.showTooltip) {
                                // IE 2026 09 07 / ODOO-337259: карточка колонки — общая с показом по Alt (columnHeader_tooltipDoc)
                                tooltip.setTooltip(e_cell, this.store.tooltip_html(this.columnHeader_tooltipDoc(attr_col)))
                            }
                        }
                    }

                } else if (e_panel.cellType === 5) { // ColumnFooter
                    let col = flex.columns[e_col],
                        col_binding = col.binding,
                        attr_col = this.attr_by_binding[col_binding];

                    e_cell.data_cell = { 
                        row: e_row,
                        col: e_col,
                        irefresh: this.irefresh,
                        // cellType: e_panel.cellType,
                    }
                    if (this.attr.use_delivery) {
                        // break-left
                        if (attr_col && this.breakOf(attr_col)) {   // IE 2026 09 19 / ODOO-…: + разрыв, переехавший со скрытой колонки
                            const left = parseFloat(e_style.left) || 0;
                            const width = parseFloat(e_style.width) || 0;

                            // позиция зазора — для масок шапки (set_breakGapMasks)
                            if (!this._breakGaps) this._breakGaps = new Map()
                            this._breakGaps.set(Math.round(left), this.break_width)
                            if (this.breakMode(attr_col) === 'plan') { if (!this._breakPlanGaps) this._breakPlanGaps = new Set(); this._breakPlanGaps.add(Math.round(left)) }   // footer · IE 2026 09 29 / ODOO-343343 (заказ Игоря: начало плана штриховкой)

                            e_style.left = `${left + this.break_width}px`;
                            e_style.width = `${width - this.break_width}px`;
                        }
                    }

                    if (attr_col.attr_type === 'AttrBool') {
                        let count = 0
                        for (let row of this.data000) {
                            if (row[col_binding]) {
                                count++
                            }
                        }
                        if (count) {
                            e_cell.textContent = count
                        }
                    } else if (attr_col.aggregateFooters_basis) {
                        // aggregateFooters_basis
                        e_cell.textContent = this.calc_aggregateFooters_basis(attr_col, this.data000)
                    } else if (attr_col.attr_type === 'AttrNumber' && attr_col.format === 'bytes' && col.aggregate && flex.collectionView) {
                        // IE 2026 11 01 / ODOO-349799 (group-bytes): подвал колонки bytes — KB/MB, не сырые байты (wijmo печатает сумму форматом колонки)
                        const _cv = flex.collectionView
                        const _agg = typeof _cv.getAggregate === 'function' ? _cv.getAggregate(col.aggregate, col.binding) : wjcCore.getAggregate(col.aggregate, _cv.items, col.binding)
                        e_cell.textContent = formatAggValue(_agg, 'bytes', this.store)
                    }

                } else if (e_panel === flex.topLeftCells) {
                    let col = this.flex.rowHeaders.columns[e_col]
                    
                    e_cell.data_cell = { 
                        row: e_row,
                        col: e_col,
                        irefresh: this.irefresh,
                        // cellType: e_panel.cellType,
                    }

                    if (this.isMappedWidget_rows && e_row === this.isMappedWidget_rows) {
                        wjcCore.addClass(e_cell, `mapped-cels`)
                        e_cell.innerHTML = `<i class="pi pi-link"></i>`
                    } else if (e_row === this.stickyScrollStart) {
                        wjcCore.addClass(e_cell, 'wj-header')
                        wjcCore.addClass(e_cell, 'sticky-scroll')

                    } else {
                        if (e_col === this.rowHeaders_col_feSelected && e_row === this.columnNumberRow) {
                            let allSelected = true, someSelected = false
                            for (let i = 0; i < flex.rows.length; i++) {
                                const di = flex.rows[i].dataItem
                                if (!di) continue
                                if (di._fe?.selected) someSelected = true
                                else allSelected = false
                            }
                            if (!someSelected) allSelected = false

                            const checkbox = document.createElement('input')
                            checkbox.type = 'checkbox'
                            checkbox.className = 'fe-selected-check'
                            checkbox.tabIndex = -1
                            checkbox.id = 'onFeSelectedAll__Click'
                            checkbox.checked = allSelected
                            checkbox.indeterminate = someSelected && !allSelected
                            checkbox.addEventListener('mousedown', (evt) => {
                                evt.preventDefault()
                                evt.stopPropagation()
                                evt.stopImmediatePropagation()
                                const saved = this.isRowHeaderClick
                                this.isRowHeaderClick = false
                                const hasAny = this.flex.rows.some(r => r.dataItem?._fe?.selected)
                                if (hasAny) {
                                    this.flex.selectedRanges = [new wjGrid.CellRange(-1, -1, -1, -1)]
                                } else {
                                    const lastRow = this.flex.rows.length - 1
                                    const c1 = this.flex.selectedRanges[0]?.leftCol ?? 0
                                    const c2 = this.flex.selectedRanges[0]?.rightCol ?? 0
                                    this.flex.selectedRanges = [new wjGrid.CellRange(0, c1, lastRow, c2)]
                                }
                                this.isRowHeaderClick = saved
                            })
                            e_cell.innerHTML = ''
                            e_cell.style.display = 'flex'
                            e_cell.style.alignItems = 'center'
                            e_cell.style.justifyContent = 'center'
                            if (allSelected) {
                                e_cell.style.backgroundColor = '#4a7c8a'
                            } else if (someSelected) {
                                e_cell.style.backgroundColor = '#ff8a00'
                            } else {
                                e_cell.style.backgroundColor = ''
                            }
                            e_cell.appendChild(checkbox)

                        } else if ((e_col === this.rowHeaders_col_selector || e_col === this.rowHeaders_col_use || this.rowHeaders_cols_pos.some(x => x.col_idx === e_col)) && e_row === this.columnNumberRow
                                   && !(x => x && x.attr_type && x.attr_type !== 'AttrBool')(this.rowHeaders_cols_pos.find(x => x.col_idx === e_col))
                                   && !(e_col === this.rowHeaders_col_selector && typeof this.attr.selectorRow_state === 'function')) {   // IE 2026 11 01 / ODOO-350449 (заказ Игоря через ie-webscm7-2 #122315: легенда вимк., колонка прапорців у Числах, чіп як селектор): у колонки-селектора встраивающего компонента общего флажка нет
                            let binding
                            if (e_col === this.rowHeaders_col_selector) binding = 'selector'
                            else if (e_col === this.rowHeaders_col_use) binding = 'use'
                            else binding = this.rowHeaders_cols_pos.find(x => x.col_idx === e_col).binding
                            let allChecked = true, someChecked = false
                            for (let i = 0; i < flex.rows.length; i++) {
                                const di = flex.rows[i].dataItem
                                if (!di) continue
                                if (this.rhBool_checkedOf(di, binding, e_col)) someChecked = true   // IE 2026 10 23 / ODOO-5800
                                else allChecked = false
                            }
                            if (!someChecked) allChecked = false

                            const checkbox = document.createElement('input')
                            checkbox.type = 'checkbox'
                            checkbox.className = 'wj-cell-check selector-all'
                            checkbox.tabIndex = -1
                            checkbox.id = 'onSelectorAll__Click'
                            checkbox.checked = allChecked
                            checkbox.indeterminate = someChecked && !allChecked
                            checkbox.dataset.binding = binding
                            checkbox.addEventListener('mouseenter', () => this.selectorAllMenu_show(checkbox, binding))
                            checkbox.addEventListener('mouseleave', () => this.selectorAllMenu_hide())
                            e_cell.innerHTML = ''
                            e_cell.style.display = 'flex'
                            e_cell.style.alignItems = 'center'
                            e_cell.style.justifyContent = 'center'
                            if (allChecked) {
                                e_cell.style.backgroundColor = '#4a7c8a'
                            } else if (someChecked) {
                                e_cell.style.backgroundColor = '#ff8a00'
                            } else {
                                e_cell.style.backgroundColor = ''
                            }
                            e_cell.appendChild(checkbox)
                        }

                        if (e_row === this.columnNumberRow) {
                            wjcCore.addClass(e_cell, 'wj-header-number-row')
                        } else {
                            wjcCore.addClass(e_cell, 'wj-header-top')
                            if (this.store.showTooltip) {
                                if (col.tooltip) {
                                    tooltip.setTooltip(e_cell, col.tooltip)
                                } else if (col.title) {
                                    tooltip.setTooltip(e_cell, col.title)
                                }
                            }
                        }

                        // if (this.attr.header_height) {
                        //     flex.rowHeaders.rows[0].height = 10
                        //     // row.height = this.attr.header_height
                        // }
                    }
                }
            }
            if (e_panel === flex.columnHeaders && !isXlsxExport) this.gridSearchHeaders_cellPaint(e_cell, e_row, e_col)   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок): подсветка найденного в заголовке + рамка текущей остановки
            window.$cg.callEnd(); window.$cg.callSub(`end`);

            _cache.className = e_cell.className
            // _cache.innerHTML = e_cell.innerHTML
            // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N): фон с учётом соседей — после снимка className (в кеш классы и слои не попадают), на обоих путях formatItem
            if (e_panel === flex.cells && !isXlsxExport && this.attr.allow_formatItem !== false) this.cfr_paint(flex, e_cell, e_row, e_col)   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)
            if (e_panel === flex.cells && !isXlsxExport && !this.attr.isPrint && !this.attr.isPrintTemplate && this.attr.allow_formatItem !== false) this.sec_paint(flex, e, e_cell, e_row, e_col)   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: мягкие разделители разделов и монохром — опции): разделы — после снимка className, оба пути formatItem

            // check divCell for fixed columns
            const dropdown = this.store.dropdown
            if (dropdown.key === key && dropdown.divCell !== e_cell) {
                dropdown.divCell = e_cell
                dropdown.divCell.addEventListener('mouseenter', dropdown.mouseenter)
                dropdown.divCell.addEventListener('mouseleave', dropdown.mouseleave)
            }

            if (this.use_performance) {
                const t1 = performance.now();
                const time = t1 - t0;
                let p = this.performance_data[key]
                if (!p) {
                    p = this.performance_data[key] = {
                        count: 0,
                        time: 0
                    }
                }
                p.count += 1
                p.time += time
                this.performance_maxTime = Math.max(this.performance_maxTime, time)
                this.performanceView.cells_count += 1
                this.performanceView.cells_time += time
                
                if (this.attr.show_performance) {
                    let p = this.performance_data[key]
                    if (p) {
                        // e_cell.innerHTML = `<span class="performance-data">${p.time.toFixed(0)} / ${p.count}:  </span>`

                        // 1) Определяем «максимальное» время, при котором считаем p.time == 100%
                        //    Всё, что больше — будет на самом «медленном» красном шаге.
                        // 2) Вычисляем нормализованное значение от 0 до 1
                        const norm = Math.min(p.time / this.performance_maxTime, 1);
                        // 3) Переводим norm в индекс от 0 до 9
                        const levels = 10;
                        const idx = Math.floor(norm * (levels - 1));  // 0…9

                        // 4) Готовим HSL-цвет для этого шага:
                        //    hue от 120° (зелёный) до 0° (красный)
                        const hue = 120 - (120 * idx) / (levels - 1);
                        //    лёгкость (lightness) можно держать постоянной, или тоже менять, если хочется
                        const lightness = 85; // 85% — очень светлый фон, чтобы текст был читаем
                        const bgColor = `hsl(${hue.toFixed(0)}, 100%, ${lightness}%)`;

                        // 5) Применяем содержимое и фон
                        e_cell.innerHTML = `<span class="performance-data">${p.time.toFixed(0)} / ${p.count}</span>`;
                        e_style.setProperty('background-color', bgColor, 'important');   
                    } else {
                        e_cell.innerHTML = `<span class="performance-data"></span>`
                        e_style.backgroundColor = ''
                    }
                }
            }

            if (_cfrS && e_panel === flex.cells) { _cfrS.cells++; _cfrS.ms += performance.now() - _cfrT0 }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)
            // this.TIME.formatItem_time  += performance.now() - t0;
            // this.TIME.formatItem_count ++
            
            window.$cg.callEnd();
        },
        _make_dropdownToggleBtn(e_cell) {
            const btn = document.createElement('button')
            btn.className = 'cell-dropdown-toggle'
            btn.tabIndex = -1
            btn.type = 'button'
            btn.onpointerdown = (ev) => ev.preventDefault()
            btn.title = t('Cell form — F4')   // IE 2026 09 23 / ODOO-341407: i18n; IE 2026 09 21 / ODOO-… (замечание Игоря: стрелка формы ячейки на выбранной ячейке, F4 — без входа в правку)
            const icon = document.createElement('i')
            icon.id = 'onRefToggle__Click'
            btn.id = 'onRefToggle__Click'
            btn.appendChild(icon)
            e_cell.appendChild(btn)
            return btn
        },
        formatItem_dropdownToggle(e_cell, attr_col, irow, e_row, e_col, col_binding, key, dataItem, isXlsxExport, isPrint, isRef, cellValue) {
            if (isXlsxExport || isPrint || !dataItem || irow < this.headerRows || this.attr?.cellForm_off) {   // IE 2026 10 31 / ODOO-5800 (заказ Игоря: таблиця форми комірки — на AttrGrid): грид внутри формы ячейки (attr.cellForm_off) — без кнопки формы
                e_cell.querySelector('.cell-dropdown-toggle')?.remove()
                return
            }
            // AttrBool (чекбокс) — без кнопки и без dropdown;
            // в блоке mergeColumns — без кнопки только для пустых (слитых) ячеек
            const inMergeEmpty = (cellValue == null || cellValue === '')
                && e_col < Math.max(this.mergeColumnBlocksTotal || 0, this.mergeColumns || 0)
            const isBoolCell = e_cell.classList.contains('checkbox')
            // IE 2026 09 07 / ODOO-5512 (заказ Игоря): на чекбокс-ячейке dropdown открывается в инфо-режиме
            // (история правки «кто и когда менял», оформление) — кнопка-шеврон видна при наведении
            // (CSS .wj-cell.checkbox:hover .on-bool); выключатель — perf-флаг dropdown_bool (дефолт ВКЛ)
            const isBoolDD = isBoolCell && this.fmtPerf('p:dropdown_bool', () => this.store.perf_flag('dropdown_bool', true))   // IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL5
            if (inMergeEmpty || (isBoolCell && !isBoolDD)) {
                e_cell.querySelector('.cell-dropdown-toggle')?.remove()
                return
            }
            const isDropdownHere = this.store.dropdown.visible && this.store.dropdown.key === key
            // IE 2026 09 21 / ODOO-… (замечание Игоря: стрелка формы ячейки на выбранной ячейке, F4 — без входа в правку): у ВЫБРАННОЙ ячейки любого типа
            // стрелка есть сразу (открыть форму без входа в правку); у остальных — как было
            const _selNow = this.flex?.selection
            const isActiveCell = !!_selNow && _selNow.row === e_row && _selNow.col === e_col && this.cellForm_arrowOn()
            // На не-ссылочных ячейках кнопку открытия не показываем — оставляем только
            // кнопку закрытия, когда dropdown уже открыт на этой ячейке.
            // IE 2026 09 26 / ODOO-… (замечания Игоря: форма ячейки): кнопки свёртки формы в ячейке нет — закрывает ✕ формы; в ячейке только стрелка раскрытия, пока форма на ней не показана
            if (isDropdownHere && this.cellForm_closeAlwaysOn()) {
                // IE 2026 09 27 / ODOO-… (дефект p203: стрелки при открытой форме ячейки): кнопка не снимается, а становится невидимой заглушкой — иначе клик в угол ячейки попадал в саму выбранную ячейку
                // (wijmo: клик по выбранной ячейке = правка), фокус уходил в редактор, стрелки и F4 переставали двигать выделение / открывать форму
                this.cellForm_shield(e_cell, { irow: e_row, row: e_row, col: e_col, col_binding }, (isRef || isBoolDD) ? '1' : '0')
                return
            }
            if (!isRef && !isBoolDD && !isDropdownHere && !isActiveCell) {
                e_cell.querySelector('.cell-dropdown-toggle')?.remove()
                return
            }
            let toggleBtn = e_cell.querySelector('.cell-dropdown-toggle')
            if (!toggleBtn) toggleBtn = this._make_dropdownToggleBtn(e_cell)
            if (toggleBtn.classList.contains('cell-form-here')) this.cellForm_unshield(toggleBtn)   // IE 2026 09 27 / ODOO-… (дефект p203: стрелки при открытой форме ячейки): форма ушла с ячейки — заглушка снова обычная кнопка
            toggleBtn.dataset.ref = (isRef || isBoolDD) ? '1' : '0'   // IE 2026 09 07 / ODOO-5512: на чекбоксе кнопка живёт как у ссылочных (refresh_dropdownToggles её не снимает)
            toggleBtn.classList.toggle('on-bool', isBoolDD)
            toggleBtn.firstElementChild.className = isDropdownHere ? 'pi pi-chevron-up' : 'pi pi-chevron-down'
            toggleBtn.classList.toggle('open', isDropdownHere)
            toggleBtn.classList.toggle('at-active', isActiveCell && !isDropdownHere)   // выбранная ячейка: стрелка видна без наведения
            // при выравнивании текста вправо кнопку показываем слева, чтобы не перекрывать значение
            toggleBtn.classList.toggle('align-left', e_cell.classList.contains('wj-align-right'))
            toggleBtn.data_cell = { irow: e_row, row: e_row, col: e_col, col_binding }
            const inSel = this.flex.selectedRanges?.some(r => irow >= r.topRow && irow <= r.bottomRow && e_col >= r.leftCol && e_col <= r.rightCol)
            toggleBtn.classList.toggle('in-selection', !!inSel)
        },
        refresh_dropdownToggles() {
            const vueObj = this
            const flex = vueObj.flex
            if (!flex?.hostElement) return
            const ranges = flex.selectedRanges
            const dropdown = vueObj.store.dropdown
            const cellType = flex.cells.cellType
            // only treat a cell as "open" when the dropdown is actually visible;
            // dropdown.show() flips `visible` async (100ms timer), so this runs via the watcher
            const activeKey = (dropdown?.visible && dropdown.key) ? dropdown.key : null
            // IE 2026 09 21 / ODOO-… (замечание Игоря: стрелка формы ячейки на выбранной ячейке, F4 — без входа в правку): выбранная ячейка держит стрелку формы
            const _sel = flex.selection
            const selKey = (_sel && _sel.row >= 0 && _sel.col >= 0 && _sel.row >= (vueObj.headerRows || 0) && vueObj.cellForm_arrowOn()) ? `${cellType}-${_sel.row}-${_sel.col}` : null
            const closeAlways = vueObj.cellForm_closeAlwaysOn()   // IE 2026 09 26 / ODOO-… (замечания Игоря: форма ячейки)
            flex.hostElement.querySelectorAll('.cell-dropdown-toggle').forEach(btn => {
                const dc = btn.data_cell
                if (!dc) return
                const key = `${cellType}-${dc.row}-${dc.col}`
                const isActive = !!activeKey && key === activeKey
                const isSel = !!selKey && key === selKey
                // не-ссылочная кнопка существует только пока dropdown открыт на её ячейке — либо ячейка выбрана
                if (isActive && closeAlways) { vueObj.cellForm_shield(btn.parentElement, dc, null, btn); return }   // IE 2026 09 26 / ODOO-… (замечания Игоря: форма ячейки): у ячейки с показанной формой стрелки-свёртки нет; IE 2026 09 27 / ODOO-… (дефект p203: стрелки при открытой форме ячейки): невидимая заглушка вместо снятия
                if (btn.classList.contains('cell-form-here')) vueObj.cellForm_unshield(btn)   // IE 2026 09 27 / ODOO-… (дефект p203: стрелки при открытой форме ячейки): форма ушла с ячейки — снова обычная кнопка (или снимается ниже)
                if (btn.dataset.ref !== '1' && !isActive && !isSel) {
                    btn.remove()
                    return
                }
                btn.classList.toggle('at-active', isSel && !isActive)
                if (dc.irow != null) {
                    const inSel = ranges?.some(r => dc.irow >= r.topRow && dc.irow <= r.bottomRow && dc.col >= r.leftCol && dc.col <= r.rightCol)
                    btn.classList.toggle('in-selection', !!inSel)
                }
                btn.firstElementChild.className = isActive ? 'pi pi-chevron-up' : 'pi pi-chevron-down'
                btn.classList.toggle('open', isActive)
            })
            // выбранная не-ссылочная ячейка: стрелка открытия формы (formatItem создаёт её только при отрисовке — выбор ячейки отрисовки не вызывает)
            if (selKey && selKey !== activeKey) {
                const e_cell = vueObj.divCells.get(selKey)
                const dc = e_cell?.data_cell
                if (e_cell && dc && e_cell.isConnected && !e_cell.querySelector('.cell-dropdown-toggle') && !e_cell.querySelector('input, textarea')
                        && !(e_cell.classList.contains('checkbox') && !vueObj.store.perf_flag('dropdown_bool', true))) {
                    const btn = vueObj._make_dropdownToggleBtn(e_cell)
                    btn.dataset.ref = '0'
                    btn.firstElementChild.className = 'pi pi-chevron-down'
                    btn.classList.add('at-active')
                    btn.classList.toggle('align-left', e_cell.classList.contains('wj-align-right'))
                    btn.data_cell = { irow: dc.irow ?? dc.row, row: dc.row, col: dc.col, col_binding: dc.col_binding }
                }
            }
            // когда dropdown открыт на не-ссылочной ячейке — показываем кнопку закрытия,
            // даже если formatItem её не создал (не-ссылочные кнопки не рендерятся)
            // IE 2026 09 26 / ODOO-… (замечания Игоря: форма ячейки): кнопки закрытия в ячейке нет — закрывает ✕ формы (выключатель fe.ux.cellFormCloseAlways — прежняя кнопка)
            // IE 2026 09 27 / ODOO-… (дефект p203: стрелки при открытой форме ячейки): форма показана на ячейке без кнопки — заглушка на месте кнопки (в ячейке с редактором — нет: редактор занимает ячейку)
            if (activeKey && closeAlways) {
                const e_cell = vueObj.divCells.get(activeKey)
                if (e_cell && e_cell.isConnected && e_cell.data_cell && !e_cell.querySelector('.cell-dropdown-toggle') && !e_cell.querySelector('input, textarea')) vueObj.cellForm_shield(e_cell, e_cell.data_cell, '0')
            }
            if (activeKey && !closeAlways) {
                const e_cell = vueObj.divCells.get(activeKey)
                if (e_cell && !e_cell.querySelector('.cell-dropdown-toggle')) {
                    const dc = e_cell.data_cell
                    if (dc) {
                        const btn = vueObj._make_dropdownToggleBtn(e_cell)
                        btn.dataset.ref = '0'
                        btn.firstElementChild.className = 'pi pi-chevron-up'
                        btn.classList.add('open')
                        btn.classList.toggle('align-left', e_cell.classList.contains('wj-align-right'))
                        btn.data_cell = { irow: dc.irow ?? dc.row, row: dc.row, col: dc.col, col_binding: dc.col_binding }
                    }
                }
            }
        },
        // IE 2026 08 16 / ODOO-4997 (заказ Игоря, гант Manufacturing Work
        // Centers): отрисовка gantt-полос ячейки — вынесена из formatItem_cells,
        // потому что быстрый кеш-путь formatItem пропускает полный рендер, а
        // полосы — DOM, в кэш className не попадают: у ячеек СО ЗНАЧЕНИЕМ
        // (Busy 1.5h) полосы иначе не рисовались вовсе. Метод сам чистит
        // ячейку от чужих/старых полос (переиспользование DOM при прокрутке).
        formatItem_gantt_apply(e_cell, dataItem, col_binding, attr_col) {
            // АН 2026 08 14: ячейка-представитель СВЁРНУТОЙ группы колонок-дат
            // собирает интервалы всех дней группы (день = 1/n ширины ячейки)
            let ganttBars = dataItem?.$gantt?.[col_binding]
            if (!ganttBars && dataItem?.$gantt && attr_col?.raw_binding) {
                const _grpG = (this.foldAgg_groups().get(col_binding) || []).find(g => g.isCollapsed)
                if (_grpG) {
                    const _gBinds = this.foldAgg_sourceBindings(_grpG, attr_col.raw_binding)
                    const _n = _gBinds.length || 1
                    const _merged = []
                    _gBinds.forEach((b, i) => {
                        for (const bar of dataItem.$gantt[b] || []) {
                            const _l = Math.max(0, parseFloat((/left:\s*(-?[\d.]+)%/.exec(bar.cssText) || [])[1]) || 0)
                            const _w = parseFloat((/width:\s*([\d.]+)%/.exec(bar.cssText) || [])[1]) || 100
                            const _bg = (/background-color:[^;]+/.exec(bar.cssText) || [''])[0]
                            _merged.push({ ...bar,
                                cssText: `top:20%; left:${((i + _l / 100) / _n * 100).toFixed(2)}%; `
                                    + `width:${Math.max(_w / _n, 1.2).toFixed(2)}%; ${_bg};` })
                        }
                    })
                    if (_merged.length) ganttBars = _merged
                }
            }
            const _old = e_cell.querySelectorAll('.gantt-bar')
            if (_old.length) _old.forEach(b => b.remove())
            // IE 2026 08 16 / ODOO-4997 (заказ Игоря): числа гант-меры в ячейке
            // не показываем (данные в тултипе полосы) — И там, где полоса не
            // построилась (п.2: «где-то даты, где-то интервалы»); текстовые
            // узлы убираем, полосы и прочие элементы остаются
            const _hideVal = (ganttBars && ganttBars.some(b => b && b.hide_value))
                || (attr_col?.cellTemplate === 'gantt-busy' && !attr_col?.gantt_show_value)
            if (_hideVal) {
                for (const nd of [...e_cell.childNodes]) {
                    if (nd.nodeType === 3 && nd.textContent.trim()) nd.remove()
                }
            }
            if (!ganttBars) return
            // АН 2026 08 14 (опция отчёта gantt_bright, дефолт ВКЛ): яркие полосы
            // в стиле scheduling workbench; выключается doc.params.gantt_bright=false
            const _brightOn = this.WIDGET?.record?.doc?.params?.gantt_bright !== false
            const _brightPalette = ['#58a6d6', '#63b76c', '#2f5eaa', '#e8a33d', '#7e6bc4', '#3aa8a0']
            const _brightColor = (seed) => {
                let h = 0
                const s = String(seed || '')
                for (let i = 0; i < s.length; i++) h = ((h << 5) - h + s.charCodeAt(i)) | 0
                return _brightPalette[Math.abs(h) % _brightPalette.length]
            }
            let tooltip_doc2
            for (let bar_gantt of ganttBars) {
                let bar = document.createElement('div')
                if (bar_gantt.className.indexOf('gantt-bar') !== -1) {
                    bar.className = bar_gantt.className
                    bar.style.cssText = bar_gantt.cssText
                    if (_brightOn) {
                        if (!bar.style.backgroundColor || bar.style.backgroundColor === 'rgba(0, 0, 0, 0.3)') {
                            bar.style.backgroundColor = _brightColor(bar_gantt.workcenter || bar_gantt.from)
                        }
                        bar.style.top = '18%'
                        bar.style.height = '58%'
                        bar.style.borderRadius = '3px'
                        bar.style.opacity = '0.95'
                    }
                    e_cell.appendChild(bar)
                    // IE 2026 08 16: полоса может нести свой tooltip (гант занятости
                    // РЦ: Busy/Schedule/Utilization) — он приоритетнее From/To
                    tooltip_doc2 = bar_gantt.tooltip || {   // IE 2026 09 23 / ODOO-341407: i18n
                        [t('From')]: this.store.formatDateHTML(bar_gantt.from),
                        [t('To')]: this.store.formatDateHTML(bar_gantt.to),
                    }
                } else {
                    bar.className = bar_gantt.className // 'in-bar'
                    e_cell.appendChild(bar)
                    tooltip_doc2 = bar_gantt.tooltip
                }
                // IE 2026 08 16 (заказ Игоря): тултипы полос ганта — ВСЕГДА,
                // независимо от пользовательской настройки Show tooltips
                // (в полосе нет текста, тултип — единственный способ прочитать её)
                if (tooltip_doc2) {
                    tooltip.setTooltip(bar, this.store.tooltip_html(tooltip_doc2))
                }
            }
        },
        formatItem_cells(e, isXlsxExport=false, useTimeout=true, seq=null) {
            window.$cg.callSub(`start`);
            const vueObj = this;
            const flex = vueObj.flex
            const breakPaddingLeft = 5, breakCollapseWidth = 12

            const {key, _cache} = vueObj.get_cache(e)
            const {key2, _cache2} = vueObj.get_cache2(e)

            const e_col = e.col,
            e_row = e.row,
            rows = flex.rows

            let e_cell = e.cell,
            e_style = e_cell.style,
            prevTop, prevHeight, prevLeft, prevWidth;

            // // ------- async-start -------
            // if (!isXlsxExport && e_col >= this.attr.frozenColumns && _cache.className) {
            //     if (_cache.className) e_cell.className = _cache.className
                
            //     if (_cache.breakLeft) {
            //         prevLeft = parseFloat(e_style.left) || 0;
            //         prevWidth = parseFloat(e_style.width) || 0;

            //         e_style.left = `${prevLeft + _cache.breakLeft}px`;
            //         e_style.width = `${prevWidth - _cache.breakLeft}px`;
            //     }

            //     if (_cache.breakTop) {
            //         prevTop = parseFloat(e_style.top || '0');
            //         prevHeight = parseFloat(e_style.height || '0');

            //         e_style.top = `${prevTop + _cache.breakTop}px`;
            //         e_style.height = `${rows.defaultSize}px`; // prevHeight - _cache.breakTop
            //     }
                
            //     // // this.deferred_formatItem.set(key, e);

            //     if (_cache2.css_user) wjcCore.addClass(e_cell, _cache2.css_user)

            //     // await vueObj.store.sleep(500);
            // }
            // if (seq!==null && _cache.seq !== seq) {
            //     vueObj.sequence_missed = (vueObj.sequence_missed||0) + 1
            //     return
            // } else {
            //     vueObj.sequence_called = (vueObj.sequence_called||0) + 1
            //     if (seq!==1) {
            //         return
            //     }
            // }
            // if (e_cell !== vueObj.divCells.get(key)) {
            //     return
            // }

            if (useTimeout) {
                // e_cell = vueObj.divCells.get(key)
                if (!e_cell?.isConnected || e_cell.data_cell.row !== e_row || e_cell.data_cell.col !== e_col) {
                    return
                }
            }

            if (_cache.prevTop !== null) e_style.top = `${_cache.prevTop}px`;
            if (_cache.prevHeight !== null) e_style.height = `${_cache.prevHeight}px`;

            if (_cache.prevLeft !== null) e_style.left = `${_cache.prevLeft}px`;
            if (_cache.prevWidth !== null) e_style.width = `${_cache.prevWidth}px`;
            // ------- async-end -------

            const isPrint = vueObj.attr.isPrintTemplate || vueObj.attr.isPrint

            window.$cg.callEnd(); window.$cg.callSub(`start2`);
            let _effectiveCol2 = e_col
            if (vueObj.mergeColumnBlocksColMap && e_col < vueObj.mergeColumnBlocksTotal) {
                const _block2 = vueObj.mergeColumnBlocksColMap[e_col]
                if (_block2?.start === e_col && _block2.logCol !== e_col) _effectiveCol2 = _block2.logCol
            }
            let col = flex.columns[_effectiveCol2],
            irow = e_row,
            col_binding = col.binding,
            row = rows[irow],
            dataItem = row.dataItem,
            attr_col = vueObj.attr_by_binding[col_binding],
            itemsSource = vueObj.itemsSource_by_binding[col_binding],
            groupItem = row instanceof wjGrid.GroupRow ? dataItem : null

            // IE 2026 09 26 / ODOO-5800 (pageerror «reading 'binding'» при сужении отчёта, Demo 1EiJ_001 — перерисовка из возврата выделения,
            // selRestore_apply): у колонки нет описания в attr_by_binding — ячейку грид знает, а отчёт уже нет (переходное состояние
            // перестройки колонок). Свою отрисовку такой ячейки не делаем (ниже attr_col читается без проверок); следующая перерисовка —
            // по согласованным колонкам. Выключатель fe.ux.gridSelOutOfRange (дефолт ВКЛ); счётчик — window.gridSelOutOfRange.format
            if (!attr_col && vueObj.store.setting('fe.ux.gridSelOutOfRange', true) !== false) {
                vueObj.selOutOfRange_count('format')
                window.$cg.callEnd()
                return
            }

            const input = e_cell.querySelector('input')
            // IE 2026 10 07 / ODOO-5800 (заказ Игоря: «Hidden» поля строки DL2 гасит ячейку своего уровня): погашенная ячейка (_DLRow.cells[binding].blank) — значения и показанного текста
            // нет, как у ячейки строки без значения по этому binding; значение остаётся в dataItem (условное оформление соседних ячеек и drill-down читают его)
            const _dl2Blank = vueObj.cellBlank(dataItem, col_binding)
            const title_back = _dl2Blank ? '' : (dataItem?.[`${attr_col.binding}-title`] || sigRow_refTitle(dataItem, attr_col.binding, itemsSource?.ids));   // IE 2026 10 04 / ODOO-5800 (fe-78): строка грида сигналов v2 — ссылка; записи нет в словаре — название от бэка
            // IE 2026 10 05 / ODOO-5800 (fe-85) (Igor 05.10, п. 3 «да»: подсказка с числами при наведении на причину в гриде сигналов): строка бэка reason_detail — title ячейки «Причина»;
            // поля нет — подсказка не ставится, своя прежняя (переиспользованная ячейка) снимается. Выключатель fe.signals.causeDetail (дефолт ВКЛ)
            vueObj.causeDetail_cellApply(e_cell, dataItem, attr_col, !!groupItem, irow, e_col, false)   // IE 2026 10 05 / ODOO-5800 (fe-85) (ревью cause detail): один помощник на оба пути formatItem
            let value = (dataItem && !_dl2Blank) ? vueObj.foldAgg_getValue(dataItem, attr_col?.binding, attr_col) : null;   // IE 2026 10 07 / ODOO-5800
            // агрегат свёрнутой группы: перерисовать текст числовой ячейки
            if (dataItem && attr_col && !_dl2Blank) {   // IE 2026 10 07 / ODOO-5800
                const _fold = vueObj.foldAgg_value(dataItem, attr_col.binding0 || attr_col.binding, attr_col)
                vueObj.foldAgg_paintCell(e_cell, _fold, attr_col.attr_type, attr_col.format, attr_col, col)
                vueObj.groupBytes_paint(e_cell, row, col, attr_col)   // IE 2026 11 01 / ODOO-349799 (group-bytes)
                vueObj.filterTotals_mark(e_cell, _fold, dataItem, attr_col.binding0 || attr_col.binding)   // IE 2026 09 21 / ODOO-5800: итог по отбору — пометка ячейки
            }

            // IE 2026 08 16 / ODOO-4997: карточное оформление колонок данных
            // (Row style 'Cards' на строке колонок лэйаута) — класс кэшируется
            // вместе с прочим оформлением ячейки
            if (dataItem && vueObj.cards_isCol(col_binding)) {
                wjcCore.addClass(e_cell, 'card-col')
            }
            // мерженная/спил-ячейка (заголовок вложенной группы, текущий через
            // карточные колонки) — гасим её пунктирные break-линии и ОБРЕЗАЕМ,
            // чтобы не рисовалась поверх карточек (ревью Игоря: «артефакты»)
            if (vueObj.cards_colsMode()) {
                const _cw = parseFloat(e_style.width) || 0
                if (_cw > (col.renderWidth || col.width || 0) + 8) {
                    wjcCore.addClass(e_cell, 'card-spill')
                }
                vueObj.cards_clipCell(e_cell, e_style, col)
            }

            // transpose: параметры ячейки (объект-значение) > строки (row.measure) > колонки
            const measureT = vueObj.transpose_measure(attr_col, dataItem)
            const cellT = measureT ? vueObj.transpose_cellObject(value) : null
            if (cellT) {
                value = cellT.value
                if (!input && !title_back) {
                    // АН 2026 08 10: Link-поле карточки (formatRowsAsColumns) — в ячейке
                    // резолвнутый valueStr (itemsSource), а не сырой id
                    e_cell.textContent = ((cellT.attr_type === 'AttrLink' && cellT.valueStr) ? cellT.valueStr : value) ?? ''
                }
            }

            window.$cg.callEnd(); window.$cg.callSub(`cells`);
            let _cells = null
            if (dataItem?._cells) {
                const raw_binding = col_binding.replace('data::', '')
                _cells = vueObj.store.get_value(dataItem, `_cells.${raw_binding}`)
            }
            const cell_field = _cells?.fields?.[0]
            if (isPrint && cell_field) {
                attr_col = cell_field
                if (attr_col.attr_type === 'AttrLink') {
                    itemsSource = vueObj.store.get_itemsSource(vueObj, {}, attr_col, { fetchMode: 'justGet' })
                }
            }
            if (isPrint) {
                flex.hostElement.classList.add('no-style');
            }

            // clear-style
            window.$cg.callEnd(); window.$cg.callSub(`clear-style`);
            if (e_style.color) {
                e_style.color = ''
            }
            if (e_style.backgroundColor) {
                e_style.backgroundColor = ''
            }
            if (e_cell._savedStyle) {
                Object.keys(e_cell._savedStyle).forEach(prop => {
                    e_style.removeProperty(prop);
                });
                delete e_cell._savedStyle;
            }

            // IE 2026 09 18 / ODOO-… (именованные стили, находка ie-dm7): тепловая заливка этой отрисовки — ниже её снимает
            // именованный стиль правила с фоном (ruleFill_overHeat)
            let _heatBg = ''
            // hslGroup
            window.$cg.callEnd(); window.$cg.callSub(`hslGroup`);
            // АН 2026 08 09 / IE 2026 08 30 / ODOO-5800: строчная (AttrTabGrid) и колоночная hslGroup — расчёт в heat_cellBg (IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р4): общий с соседями слоя fe.ux.cellFillRound)
            const _heatHsl = vueObj.heat_cellBg(dataItem, col_binding, attr_col, value, rows[e_row]?.level ?? -1)   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р4)
            if (_heatHsl !== undefined) {   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р4)
                if (_heatHsl) {
                    // АН 2026 08 09: поля формы несут .cell-info с background !important —
                    // строчную hsl-подсветку ставим инлайном с important (как cell-background-*).
                    // IE 2026 08 30 / ODOO-5800 (заказ Игоря «HLS группы для колонок производительности»):
                    // то же нужно и КОЛОНОЧНЫМ hsl-группам — деревья статистик живут в форме
                    // записи, и обычный инлайн проигрывал cell-info !important (все ячейки серые)
                    e_style.setProperty('background-color', _heatHsl, 'important');
                    _heatBg = e_style.backgroundColor   // как её нормализовал браузер — для сверки «фон всё ещё тепловой»
                } else {
                    e_style.backgroundColor = _heatHsl;
                }
            }

            // IE 2026 08 30 / ODOO-5800 (заказ Игоря): в колонках с hideZero ноль показываем
            // ПУСТО. Ноль рисует сам wijmo по формату колонки (ветки formatItem_cells
            // работают под `if (value)` и до нуля не доходят), поэтому чистим содержимое
            // здесь — в общем хвосте formatItem, который проходит и кеш-путь ячейки.
            // Ячейку в режиме правки не трогаем.
            if (attr_col?.hideZero && e_cell && !e_cell.querySelector('input, textarea')) {
                // Проверяем ТЕКСТ ячейки, а не значение: на быстром пути formatItem (кеш
                // className/div0, ветка useTimeout) переменная value живёт в своей области,
                // и проверка по ней не срабатывала — при вертикальной прокрутке нули
                // возвращались на переиспользованных ячейках (репорт Игоря 30.08).
                // Текст есть в обоих путях, поэтому чистим по нему.
                const _t = (e_cell.textContent || '').trim()
                if (_t === '0' || _t === '0,0' || _t === '0.0' || _t === '0,00' || _t === '0.00') {
                    e_cell.textContent = ''
                }
            }

            if (vueObj.attr.use_hslGroup && groupItem && groupItem.level >= 0) {
                e_style.backgroundColor = cellFill_groupHsl(groupItem.level)   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р4): тот же цвет уровня — общий с соседями слоя fe.ux.cellFillRound
            }

            // row-AddEventListener
            window.$cg.callEnd(); window.$cg.callSub(`rowAddEventListener`);
            const formatItem_cells_rowAddEventListener = () => {
                let wjRow = wjcCore.closest(e_cell, '.wj-cell') // .wj-row
                if (wjRow && !wjRow.__handlersAdded) {
                    wjRow.__handlersAdded = true
                    wjRow.draggable = e_col >= (flex.frozenColumns || 0)
                    if (wjRow.draggable) {
                        wjRow.addEventListener('dragstart', vueObj.dragStart)
                        wjRow.addEventListener('dragend', vueObj.dragEnd)
                        wjRow.addEventListener('mousedown', vueObj.wjRow_mousedown)
                    }
                    wjRow.addEventListener('dragover', vueObj.dragOver)
                    wjRow.addEventListener('drop', vueObj.dragDrop)
                }
            }
            formatItem_cells_rowAddEventListener()

            // innerHTML
            window.$cg.callEnd(); window.$cg.callSub(`innerHTML`);
            const formatItem_cells_innerHTML = () => {
                if (row.isReadOnly !== false && flex.isReadOnly === false ) {
                    // console.log('set row.isReadOnly = false')
                    this.flex_check_isReadOnly()
                }

                vueObj.localize_cellText(e_cell, attr_col, dataItem)
                vueObj.planLabelDate_cellApply(e_cell, dataItem)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана): полный путь

                if (dataItem && vueObj.attr.attr_type === 'AttrTabGrid' && col_binding === 'attr.title' && dataItem.attr.isDimension) {
                    e_cell.innerHTML = `<span class="pi pi-key pr-1"></span>` + e_cell.innerHTML
                }

                if (attr_col?.name === 'AttrTabGrid-mapped_title' && vueObj.isMappedWidget_cols) {
                    if (dataItem.attr.isMapped) {
                        wjcCore.addClass(e_cell, `mapped-cels pl-1`)

                        const node = vueObj.PAGE.nodes_svg?.[ dataItem.attr['@@node_key'] ]
                        if (node) {
                            node.div = e_cell
                            node.row = e_row
                            node.join = 'horizontal'
                        }
                    } else {
                        wjcCore.addClass(e_cell, `no-mapped-cels`)
                    }
                }
                if (e_col === 1 && vueObj.isMappedWidget_cols && dataItem.attr.isMapped) {
                    e_cell.innerHTML = `<i class="pi pl-1 pr-2 ${vueObj.attr_isMappedWidget.pi}"></i>` + e_cell.innerHTML
                }

                // title
                if (title_back) {
                    vueObj.store.updateCellText(e_cell, title_back);
                } else if (e_col === 0 && dataItem?.groupDescription?.propertyName && dataItem.name) {
                    itemsSource = vueObj.itemsSource_by_binding?.[dataItem.groupDescription.propertyName]
                    const id = dataItem.name
                    const title = itemsSource?.ids?.[id]?.title
                    if (title) {
                        vueObj.store.updateCellText(e_cell, title, id)
                    }
                } else if (dataItem && (attr_col.attr_type === 'AttrLink-2025' || (attr_col.attr_type === 'AttrLink' && vueObj.attr.isPrint))) {
                    let id = value
                    // if (!id && dataItem.groupDescription?.propertyName && dataItem.name) {
                    //     itemsSource = vueObj.itemsSource_by_binding[dataItem.groupDescription.propertyName]
                    //     id = dataItem.name
                    // }
                    if (id) {
                        const title = itemsSource?.ids?.[id]?.title
                        if (input) {
                            if (title) {
                                input.value = title
                            }
                        } else {
                            if (title) {
                                vueObj.store.updateCellText(e_cell, title, id)
                                // vueObj.flex.setCellData(e_row, e_col, title)

                            } else if (String(id).startsWith('=')){
                                wjcCore.addClass(e_cell, 'eval-text')
                                let highlightedEval = vueObj.store.check_eval_highlighted(vueObj.WIDGET, id, itemsSource)
                                if (highlightedEval) {
                                    e_cell.innerHTML = highlightedEval
                                }

                            } else if (String(id).startsWith('#')){
                                vueObj.store.updateCellText(e_cell, id)
                                wjcCore.addClass(e_cell, 'custom-text')

                            } else {
                                vueObj.store.updateCellText(e_cell, id)
                                // warning «несогласованная ссылка» только когда резолвить
                                // есть чем: без relation_segment/itemsSource значение
                                // самодостаточно (строка/число — напр. статический текст
                                // ячейки печати, source_field.value без binding)
                                const _isStaticPrintCell = vueObj.printCellsTab_isActive?.()
                                    && !dataItem.binding && dataItem.source_field?.value != null
                                if (!_isStaticPrintCell
                                    && (attr_col.relation_segment || attr_col.use_itemsSourcesView
                                        || (Array.isArray(attr_col.itemsSource) && attr_col.itemsSource.length)
                                        || itemsSource?.data?.length)) {
                                    wjcCore.addClass(e_cell, 'custom-value-warning')
                                }
                                // if (attr_col.attr_type === 'AttrLink' && vueObj.store.fetchMode === 'by_ids' && attr_col.relation_segment) {
                                //     vueObj.store.queue_titlesByIds(vueObj, attr_col.relation_segment, id)
                                // }
                            }
                        }
                    }
                }

                if ((cellT?.attr_type || measureT?.attr_type || attr_col.attr_type) === 'AttrNumber') {
                    wjcCore.addClass(e_cell, 'wj-align-right')
                    if (vueObj.attr.isPrint) {
                        if (value) {
                            let str = Math.abs(+value) < 0.0001 ? '-'
                                : wjcCore.Globalize.format(value, cellT?.format || measureT?.format || attr_col.format || 'n2')
                            vueObj.store.updateCellText(e_cell, str)
                            
                            if (value < 0) {
                                wjcCore.addClass(e_cell, 'num-negative')
                            }

                        } else {
                            e_cell.textContent = ''
                        }
                    }
                }

                if (attr_col?.attr_type === 'AttrBool') {
                    wjcCore.addClass(e_cell, 'checkbox')
                    const chk = e_cell.querySelector('input[type=checkbox]')
                    if (attr_col.checkbox_always) {
                        // IE 2026 09 04 / ODOO-336331 (заказ Игоря): колонка-флаг read-only (Default списка вариантов) — всегда
                        // обычный чекбокс, и снятый тоже, без disabled-блёклости (эта ветка formatItem_cells шла ПОСЛЕ
                        // основной и стирала инпут у неотмеченных); переключение — cellClick_method грида
                        let c2 = chk
                        if (!c2) { c2 = document.createElement('input'); c2.type = 'checkbox'; c2.className = 'wj-cell-check'; c2.tabIndex = -1; e_cell.innerHTML = ''; e_cell.appendChild(c2) }
                        c2.checked = value === true
                        c2.disabled = false
                    } else if (vueObj.approvalFlagPartial_apply(e_cell, dataItem, col_binding, value, e_row)) {   // IE 2026 10 14 / ODOO-5800: живой итог — строка грида e_row
                        // IE 2026 10 14 / ODOO-5800 (Igor): итог группы — флаг у части документов — полузаполненный чекбокс (мета бэка approval_partial)
                    } else if (chk && value !== true) {
                        // chk.indeterminate = false
                        e_cell.innerHTML = ``
                    }
                }

                if (attr_col?.attr_type === 'AttrJSON' || attr_col?.attr_type === 'AttrCSS') {
                    const isJSON = attr_col.attr_type === 'AttrJSON'
                    const label = isJSON ? 'JSON' : 'CSS'
                    let preview = ''
                    let hasContent = false
                    if (value && typeof value === 'object') {
                        const keys = Object.keys(value)
                        hasContent = keys.length > 0
                        if (hasContent) {
                            if (isJSON) {
                                if (Array.isArray(value)) {
                                    preview = `[${value.length}]`
                                } else {
                                    preview = `{ ${keys.slice(0, 3).join(', ')}${keys.length > 3 ? '…' : ''} }`
                                }
                            } else {
                                const entries = Object.entries(value)
                                const shown = entries.slice(0, 2).map(([k, v]) => `${k}: ${v}`).join('; ')
                                preview = shown + (entries.length > 2 ? '…' : '')
                            }
                        }
                    } else if (typeof value === 'string' && value.trim()) {
                        hasContent = true
                        preview = value.length > 40 ? value.slice(0, 40) + '…' : value
                    }
                    if (hasContent) {
                        e_cell.innerHTML = `<span class="cell-code-badge cell-code-badge-${label.toLowerCase()}">${label}</span><span class="cell-code-preview">${preview}</span>`
                    } else {
                        e_cell.innerHTML = ''
                    }
                }
                // IE 2026 10 18 / ODOO-347310: ссылка в систему-источник (AttrUrl) и миниатюра изображения (AttrImageUrl)
                if ((attr_col?.attr_type === 'AttrUrl' || attr_col?.attr_type === 'AttrImageUrl') && !isXlsxExport) {
                    vueObj.sourceCell_render(e_cell, attr_col, value)
                }
                if (!isXlsxExport && segLinkCell_on(vueObj.attr, attr_col, value)) vueObj.segLinkCell_render(e_cell)   // IE 2026 10 23 / ODOO-5800 (заказ Игоря, скрин 1): ярлык «список сегмента» в колонке Segment вкладки Sources

                // aggregateFooters_basis
                if (groupItem && attr_col.aggregateFooters_basis) {
                    e_cell.textContent = vueObj.calc_aggregateFooters_basis(attr_col, groupItem.items)
                }

                // // columnGroups collapse << rem 2026-01-08 is old code 
                // if (attr_col && irow ==0 && e_col >= vueObj.headerColumns && 'isCollapsed' in attr_col) {
                //     let div1 = document.createElement('div')
                //     e_style.cssText += `padding-left: 30px !important;`
                //     div1.style.cssText += `padding: 6px 0px 6px 6px !important;`
                //     div1.classList = ["data-cell attr-column-button-group wj-control"]
                //     e_cell.appendChild(div1)
                //     if (attr_col.isCollapsed) {
                //         div1.innerHTML = vueObj.tplBtn.OpenGroup
                //     } else {
                //         div1.innerHTML = vueObj.tplBtn.CloseGroup
                //     }
                //     div1.data_cell = {
                //         col_binding: col_binding,
                //     }
                // }

                // row ApplySelector
                if (attr_col && irow >= vueObj.headerRows && attr_col.addBtn_ApplySelector) {
                    wjcCore.addClass(e_cell, 'attr-selector')
                    let div1 = document.createElement('div')
                    div1.classList = ["data-cell attr-doc-button-group wj-control"]
                    e_cell.appendChild(div1)
                    div1.innerHTML = vueObj.tplBtn.ApplySelector
                    div1.data_cell = {
                        irow: irow,
                    }
                    // e_cell.innerHTML = `<input type="checkbox" v-model="allocGr.isCollapsed">` + e_cell.innerHTML
                }

                if (isXlsxExport && attr_col.cellTemplate) {
                    // e_cell.innerHTML = ''
                    e.cancel = true;
                    e.xlsxCell.value = '';
                }
            }
            formatItem_cells_innerHTML()

            // css
            window.$cg.callEnd(); window.$cg.callSub(`CSS`);
            const formatItem_cells_CSS = () => {
                if (dataItem && dataItem.row_id) { // TODEL M01
                    const cssClass_row = vueObj.cells_doc[dataItem.row_id]?.cssClass,
                    cssClass_cell = vueObj.cells_doc[`${dataItem.row_id}.${attr_col.binding}`]?.cssClass
                    if (cssClass_row) {
                        wjcCore.addClass(e_cell, cssClass_row)
                    }
                    if (cssClass_cell) {
                        wjcCore.addClass(e_cell, cssClass_cell)
                    }
                }
                // сводная таблица правил: колонки Source кликабельны (source_link)
                if (attr_col?.source_link && dataItem?.source_row_title && vueObj.attr.agg_sources) {
                    wjcCore.addClass(e_cell, 'agg-source-link')
                }

                // style
                let styleSrc = {};
                if (cell_field !== attr_col) {
                    // если обе заданы и разные — объединяем объектами
                    styleSrc = {
                        ...(attr_col?.style || {}),
                        ...(cell_field?.style || {})
                    };
                } else {
                    // иначе берём то, что есть
                    styleSrc = cell_field?.style || {};
                }
                // AttrTabGrid: строка = поле виджета — Style из настроек атрибута (attr.style);
                // строка важнее колонки (как в transpose: ячейка > строка > колонка)
                if (vueObj.attr.attr_type === 'AttrTabGrid' && dataItem?.attr?.style) {
                    styleSrc = { ...styleSrc, ...vueObj.store.normalizeStyle(dataItem.attr.style) };
                }
                for (const [prop, val] of Object.entries(styleSrc)) {
                    if (val) e_style.setProperty(prop, val, 'important'); // или без 'important', если не нужно
                }
                e_cell._savedStyle = { ...styleSrc };              

                // IE 2026 09 03 / ODOO-336283: полоса-заголовок (строка лэйаута AttrTab / AttrTabRow)
                if (dataItem?._DLRow?.row_type === 'tab' || dataItem?._DLRow?.row_type === 'tabrow') {
                    wjcCore.addClass(e_cell, 'row-dl-tab')
                }
                // IE 2026 09 23 / ODOO-5800: memo-строка («· of which …») — курсив и приглушённый цвет всей строки
                if (dataItem?._DLRow?.memo && vueObj.memoRows_on()) {
                    wjcCore.addClass(e_cell, 'row-dl-memo')
                }
                if (dataItem?._DLRow?.cssClass) {
                    wjcCore.addClass(e_cell, dataItem._DLRow.cssClass)
                }
                // условное оформление строки (conditional_format): cssClasses — массив имён,
                // уже резолвнутых на бэке (без реестра get_cssClasses); дополняет одиночный cssClass
                if (Array.isArray(dataItem?._DLRow?.cssClasses) && dataItem._DLRow.cssClasses.length) {
                    wjcCore.addClass(e_cell, dataItem._DLRow.cssClasses.join(' '))
                }
                if (dataItem?._DLRow?.cssStyle) {
                    e_style.cssText += dataItem._DLRow.cssStyle
                }
                // IE 2026 09 07 / ODOO-4443 (заказ Игоря): строчные правила с опцией «Values only» — бэк-режим кладёт их
                // в корзину _DLRow.cssClasses_vo / cssStyle_vo (attrs.cf_add_row), фронт-режим — в cfRow.cssClassesVO ниже;
                // на ячейки данных они ложатся только при непустом значении, на ячейки заголовка строки — всегда
                const _cfVO = !!dataItem && vueObj.cf_valuesOnlyAllowed(attr_col, value)
                if (_cfVO && Array.isArray(dataItem?._DLRow?.cssClasses_vo) && dataItem._DLRow.cssClasses_vo.length) {
                    wjcCore.addClass(e_cell, dataItem._DLRow.cssClasses_vo.join(' '))
                }
                if (_cfVO && dataItem?._DLRow?.cssStyle_vo) {
                    e_style.cssText += dataItem._DLRow.cssStyle_vo
                }
                // IE 2026 09 04 / ODOO-336283 (заказ Игоря): оформление полосы-заголовка (AttrTab / AttrTabRow)
                // живёт в поле Style строки лэйаута (редактируется в Group field → Style; бэк подставляет дефолт
                // dl2 DL2_BAND_STYLE_DEFAULT, если поле пусто) — formatItem ничего поверх не рисует, класс
                // .row-dl-tab даёт лишь нейтральный фон
                // фронт-вычисление условных правил (cf_rules, режим по умолчанию — без
                // Apply on backend): результат строки из кэша, конкатенация с готовыми
                // _DLRow-результатами (бэк-режим/conditions)
                if (dataItem && vueObj.attr.cf_rules) {
                    const cfRow = vueObj.cf_compute(dataItem, '', null)
                    if (cfRow) {
                        if (cfRow.cssClasses.length) {
                            wjcCore.addClass(e_cell, cfRow.cssClasses.join(' '))
                        }
                        if (cfRow.cssStyle) {
                            e_style.cssText += cfRow.cssStyle
                        }
                        // IE 2026 09 07 / ODOO-4443: корзина «Values only» строчных заданий (см. cf_compute)
                        if (_cfVO && cfRow.cssClassesVO?.length) {
                            wjcCore.addClass(e_cell, cfRow.cssClassesVO.join(' '))
                        }
                        if (_cfVO && cfRow.cssStyleVO) {
                            e_style.cssText += cfRow.cssStyleVO
                        }
                    }
                }
                if (dataItem && vueObj.attr.attr_type === 'AttrTabGrid' && dataItem.attr) {
                    // строка = поле виджета (как measureT в transpose): Style и классы поля —
                    // на все ячейки строки; классы шапки — на ячейку заголовка (attr.title)
                    if (dataItem.attr.cssStyle) {
                        e_style.cssText += dataItem.attr.cssStyle
                    }
                    // независимые каналы: табличная часть cssClasses — правила/миграция,
                    // строковый cssClass — пользовательский; рендерятся оба
                    if (Array.isArray(dataItem.attr.cssClasses)) {
                        const cssClasses_row = vueObj.store.resolve_cssClasses(dataItem.attr.cssClasses)
                        if (cssClasses_row) {
                            wjcCore.addClass(e_cell, cssClasses_row)
                        }
                    }
                    if (dataItem.attr.cssClass) {
                        wjcCore.addClass(e_cell, dataItem.attr.cssClass)
                    }
                    // IE 2026 09 20 / ODOO-5800 (Igor 20.09: «показывай двойную стрелку вправо перед полем sales_country … с разделителем перед колонкой и двойной стрелочкой перед ним в списках правил и в формах их элементов»):
                    // вариант разрыва break_before у ПОЛЯ карточки (тот же реквизит, что у колонки списка) — разделитель над строкой поля и знак стрелки перед
                    // значением: From / → To / ⇒ Possible sales country читаются в карточке так же, как в списке. Выключатель fe.ux.cardBreak
                    if (dataItem.attr.break_before && vueObj.store.setting('fe.ux.cardBreak', true) !== false) {
                        const _cb = vueObj.breakMode({ break_before: dataItem.attr.break_before })
                        if (_cb) wjcCore.addClass(e_cell, 'card-break-before')
                        if (col_binding === 'attr.valueStr' && _cb.indexOf('arrow') === 0) {
                            wjcCore.addClass(e_cell, _cb === 'arrow_left' ? 'cell-dir-from' : (_cb === 'arrow_double' ? 'cell-dir-to-double' : (_cb === 'arrow_both' ? 'cell-dir-both' : 'cell-dir-to')))
                        }
                    }
                    if (col_binding === 'attr.title') {
                        if (Array.isArray(dataItem.attr.cssClasses_columnHeader)) {
                            const cssClasses_head = vueObj.store.resolve_cssClasses(dataItem.attr.cssClasses_columnHeader)
                            if (cssClasses_head) {
                                wjcCore.addClass(e_cell, cssClasses_head)
                            }
                        }
                        if (dataItem.attr.cssClass_columnHeader) {
                            wjcCore.addClass(e_cell, dataItem.attr.cssClass_columnHeader)
                        }
                    }
                }
                if (attr_col && attr_col.cssStyle) {
                    e_style.cssText += attr_col.cssStyle // + `content:"${e_col} ${col_binding} ${attr_col.title}";`
                }
                if (attr_col && dataItem && !_dl2Blank && dataItem[`cssClass-${attr_col.binding}`]) {   // IE 2026 10 07 / ODOO-5800: класс самой ячейки от бэка — у погашенной нет
                    wjcCore.addClass(e_cell, dataItem[`cssClass-${attr_col.binding}`])
                }
                // Статусы: цвет живёт у элемента справочника (doc.cssClass), а не в коде —
                // тогда раскраска работает во ВСЕХ таблицах со статусом, включая будущие,
                // и палитра правится из UI. Ограничено сегментами STATUS*, чтобы не
                // задеть остальные ссылочные колонки.
                if (attr_col && (attr_col.attr_type === 'AttrLink' || attr_col.attr_type === 'AttrLinkChips')
                    && vueObj.isChipSegment(attr_col.relation_segment)) {   // IE 2026 09 18 / ODOO-5800: + GRADE
                    // ВСЕ статус-колонки рисуем чипсом-пилюлей: и AttrLinkChips
                    // (предопределённые поля), и обычные AttrLink-статусы, определённые
                    // в самой базе (напр. TXN Status). чипс — DOM, его нет в кеше
                    // className; тот же хелпер вызывается и на кеш-пути formatItem.
                    vueObj.applyStatusChip(e_cell, attr_col, dataItem)
                } else { // IE 2026 08 26 / ODOO-5800 (заказ Игоря): статус-поле формы записи (AttrTabGrid) — пилюля
                    const _tf = vueObj.tabGridStatusAttr(dataItem, col_binding)
                    if (_tf) vueObj.applyStatusChip(e_cell, _tf, dataItem, _tf.value)
                }
                // независимые каналы колонки: табличная часть cssClasses — безусловные
                // правила conditional_format/миграция; строковый cssClass —
                // пользовательский; рендерятся оба (конкатенация)
                if (attr_col && Array.isArray(attr_col.cssClasses)) {
                    const cssClasses = vueObj.store.resolve_cssClasses(attr_col.cssClasses)
                    if (cssClasses) {
                        wjcCore.addClass(e_cell, cssClasses)
                    }
                }
                if (attr_col && attr_col.cssClass) {
                    wjcCore.addClass(e_cell, attr_col.cssClass)
                }
                if (attr_col && dataItem && 'level' in dataItem && attr_col[`cssClass-${dataItem.level}`]) {
                    wjcCore.addClass(e_cell, attr_col[`cssClass-${dataItem.level}`])
                }
                // transpose: стили из параметров строки (row.measure), поверх — из ячейки-объекта
                if (measureT) {
                    if (measureT.cssStyle) {
                        e_style.cssText += measureT.cssStyle
                    }
                    // табличная часть cssClasses (ссылки на CSS-CLASS) — источник правды;
                    // строковый cssClass — легаси-fallback
                    if (Array.isArray(measureT.cssClasses)) {
                        const cssClassesT = vueObj.store.resolve_cssClasses(measureT.cssClasses)
                        if (cssClassesT) {
                            wjcCore.addClass(e_cell, cssClassesT)
                        }
                    } else if (measureT.cssClass) {
                        wjcCore.addClass(e_cell, measureT.cssClass)
                    }
                    if (cellT?.cssStyle) {
                        e_style.cssText += cellT.cssStyle
                    }
                    if (cellT?.cssClass) {
                        wjcCore.addClass(e_cell, cellT.cssClass)
                    }
                    // подсказка строки-меры (tooltip + Default) — в cellTooltip_html (IE 2026 09 07 / ODOO-337259)
                    // formatRowsAsColumns: enum-значение — cssClass элемента itemsSource, как в гриде
                    if (vueObj.attr.formatRowsAsColumns && measureT.value != null && measureT.value !== ''
                        && (Array.isArray(measureT.itemsSource) || measureT.use_itemsSourcesView || measureT.relation_segment)) {
                        const itemsSourceT = vueObj.store.get_itemsSource(vueObj, {}, measureT, { fetchMode: 'justGet' })
                        const itemT = itemsSourceT?.ids?.[measureT.value]
                        if (itemT?.cssClass) {
                            wjcCore.addClass(e_cell, itemT.cssClass)
                        }
                    }
                }
                if (value?.is_customValueWarning) { // && attr_col.customValueWarning
                    wjcCore.addClass(e_cell, 'custom-value-warning')
                }

                if (input) {
                    wjcCore.addClass(e_cell, `cell-input`)
                }

                // isNode
                if (attr_col && dataItem?.use === false && (attr_col.binding === 'title' || attr_col.binding === 'node') && !vueObj.attr.nonEmpty_ignore_use) {
                    wjcCore.addClass(e_cell, 'use-false')
                }

                // if (dataItem && dataItem.cssStyle) { 2025 01 21
                //     e_style.cssText += dataItem.cssStyle
                // }
                // if (dataItem && dataItem.cssClass) {
                //     // if (!vueObj.attr_by_binding?.title || col_binding=='title') { LOOK 2024-09-05 for AttrTabGrid
                //         wjcCore.addClass(e_cell, dataItem.cssClass)
                //     // }
                // }
                // undoStack
                // changesStack (undoStack)
                let has_stack = false
                if (dataItem && attr_col && !isPrint) {
                    // let i = vueObj.data000.indexOf(dataItem)
                    const key_stack = `${irow}:${col_binding}`
                    if (key_stack in vueObj.changesStack) {
                        let rowStack = vueObj.changesStack[key_stack]
                        // IE 2026 08 19 / ODOO-5512 (заказ Игоря): «Old value»/«Pasted»
                        // из тултипа убраны — история правки ячейки (старое значение,
                        // автор, время) показывается блоком CORRECTION в дропдауне
                        // ячейки (dropdown_prepare → correction_info)
                        if (rowStack.pastedVal && !rowStack.newVal) {
                        // if (+(rowStack.pastedVal || 0) && !rowStack.newVal) {
                            wjcCore.addClass(e_cell, 'wj-has-stack-error')
                        } else if ((rowStack.indirect || rowStack.related) && !rowStack.user) {
                            // IE 2026 08 18 / ODOO-4997 (заказ Игоря): КОСВЕННЫЕ
                            // корректировки (декомпозиция, итоги предков, каскад
                            // дистрибуции) фон НЕ трогают — он принадлежит
                            // условному оформлению. Постоянная метка — угловой
                            // бейдж с дельтой, цвет по направлению отклонения
                            wjcCore.addClass(e_cell, 'wj-has-stack-indirect')
                        } else {
                            wjcCore.addClass(e_cell, 'wj-has-stack')
                        }
                        vueObj.chgBadge_apply(e_cell, rowStack)
                        has_stack = true
                    // } else if (`${dataItem.measure}:${attr_col.date}` in vueObj.data_overrides) {
                    //     wjcCore.addClass(e_cell, 'wj-has-cell-data')
                    //     let row_overrides = vueObj.data_overrides[`${dataItem.measure}:${attr_col.date}`]
                    //     tooltip.setTooltip(e_cell, `<b>Old value:</b><br/>${row_overrides.oldVal}<br/>${row_overrides.tooltip}`);
                    //     has_stack = true
                    } else {
                        // IE 2026 08 18: ячейки переиспользуются при прокрутке —
                        // чужой бейдж снимаем явно
                        vueObj.chgBadge_clear(e_cell)
                    }
                    // IE 2026 08 18 (заказ Игоря п.2,3,5,7): вспышка ставится
                    // по пачке ТЕКУЩЕГО действия, гаснет сама (CSS forwards) и
                    // не переживает следующее действие пользователя
                    vueObj.flash_apply(e_cell, key_stack)
                    vueObj.autoValue_apply(e_cell, dataItem, col_binding)   // IE 2026 09 02 / ODOO-11316
                    // IE 2026 08 19 / ODOO-5512: якорь линии расшифровки — ячейка
                    vueObj.ddNode_attach(e_cell, dataItem, col_binding, irow, e_col)
                    // IE 2026 09 25 / ODOO-5800 (D1): оценка автоплана превью симуляции — пометка «виртуальный документ» на ячейке
                    vueObj.simVirtual_apply(e_cell, dataItem, col_binding, attr_col)

                    // if (irow >= vueObj.headerRows && e_col >= vueObj.headerColumns && dataItem && !dataItem.levelGroup) {
                    //     for (let iStack=vueObj.undoStack.length-1; iStack>=0 && vueObj.undoStack[iStack].actionStack > vueObj.actionStack-100; iStack--) {
                    //         if (vueObj.undoStack[iStack].i==irow && vueObj.undoStack[iStack].col_binding==col_binding) {
                    //             wjcCore.addClass(e_cell, "wj-has-stack");
                    //             // wjcCore.addClass(e_cell, 'wj-has-notes')
                    //             tooltip.setTooltip(e_cell, `<b>Old value:</b><br/>${vueObj.undoStack[iStack].val}`);
                    //             break
                    //         }
                    //     }
                    // }

                }
                
                // мета ячейки _DLRow.cells[binding] — единый контейнер (условное оформление
                // + conditions + KPI + тултипы; сюда переехал legacy-канал MD, который бэк
                // переходно зеркалит). Имена классов уже резолвнуты. Блок после каналов
                // колонки/строки — inline-стили ячейки перекрывают их
                // IE 2026 10 07 / ODOO-5800 (заказ Игоря: «Hidden» поля строки DL2 гасит ячейку своего уровня): у погашенной ячейки (cells[binding].blank) мета бэка не применяется целиком — ни
                // классов / стиля условного оформления (режим Apply on backend), ни стрелки Direction (бэк ставит dir и на скрытое значение): ячейка выглядит как ячейка без значения
                const cf_cell = irow >= vueObj.headerRows && !_dl2Blank && dataItem?._DLRow?.cells?.[col_binding]
                if (cf_cell) {
                    if (Array.isArray(cf_cell.cssClasses) && cf_cell.cssClasses.length) {
                        wjcCore.addClass(e_cell, cf_cell.cssClasses.join(' '))
                    }
                    if (cf_cell.cssStyle) {
                        e_style.cssText += cf_cell.cssStyle
                    }
                    // IE 2026 09 18 / ODOO-5800 (Igor): опция поля строки раскладки «Direction» — стрелка направления перед
                    // значением (Country cor: ← приход «от неё», → расход / запас «в неё»); бэк кладёт dir в мету ячейки
                    // (data_layout2._direction_pass), стрелку рисует CSS ::before класса cell-dir-from / cell-dir-to
                    if (cf_cell.dir === 'from' || cf_cell.dir === 'to') {
                        wjcCore.addClass(e_cell, 'cell-dir-' + cf_cell.dir)
                    } else if (cf_cell.dir === 'to_double') {   // IE 2026 09 20 / ODOO-5800 (Igor 20.09: «показывай двойную стрелку вправо перед полем sales_country … с разделителем перед колонкой и двойной стрелочкой перед ним в списках правил и в формах их элементов»)
                        wjcCore.addClass(e_cell, 'cell-dir-to-double')
                    }
                    // тултип / KPI ячейки (cf_cell) — в cellTooltip_html (IE 2026 09 07 / ODOO-337259)
                }
                // фронт-вычисление условных правил: результат ячейки из кэша,
                // конкатенация с готовыми _DLRow.cells (бэк-режим/conditions/KPI)
                // IE 2026 10 07 / ODOO-5800: оформление САМОЙ погашенной ячейки (правила cell / measure, заливка от метрик) не считается; правила строки (cfRow выше) и оформление соседних ячеек —
                // по значению dataItem, как раньше
                if (irow >= vueObj.headerRows && dataItem && !_dl2Blank && (vueObj.attr.cf_rules || vueObj.metricFill_state()) && attr_col?.binding) {   // IE 2026 09 20 / ODOO-5800: и заливка от метрик без правил оформления
                    const cfCell = vueObj.cf_compute(dataItem, col_binding, attr_col)
                    if (cfCell) {
                        if (cfCell.cssClasses.length) {
                            wjcCore.addClass(e_cell, cfCell.cssClasses.join(' '))
                        }
                        if (cfCell.cssStyle) {
                            e_style.cssText += cfCell.cssStyle
                        }
                    }
                }
                // IE 2026 09 18 / ODOO-… (именованные стили, находка ie-dm7): заливка ПРАВИЛА главнее тепловой заливки hslGroup.
                // Тепловая ставится inline с !important (иначе её гасит cell-info) — фон класса её перебить не может, а цвет
                // текста класса применяется: белый текст Grade · Bad на светлой тепловой заливке не читается. Если на ячейке
                // есть именованный стиль реестра С ФОНОМ и само правило inline-фон не задало — тепловую заливку снимаем.
                // Прежние классы cell-background-* без именованного двойника не участвуют — там вид прежний.
                if (_heatBg && e_style.backgroundColor === _heatBg && (vueObj.ruleFill_overHeat(e_cell) || e_cell.classList.contains(METRIC_CRIT_CLASS))) {   // IE 2026 10 03 / ODOO-5800: + критическая ошибка (класс METRIC_CRIT_CLASS) главнее тепловой заливки — иначе её inline-фон с !important оставил бы от критического вида белый текст на светлом
                    e_style.removeProperty('background-color')
                }
                // IE 2026 09 22 / ODOO-5800 (замечание Игоря, «Stock state» списка стран: «бейдж лишний — достаточно текста и условного
                // оформления фона»): пилюля оценки (GRADE, заказ 18.09) остаётся только там, где у ячейки нет своей заливки; есть заливка
                // от правил / метрик / тепловая — оценка обычным текстом на ней. Статусы документов (STATUS*) не трогаем
                if (irow >= vueObj.headerRows && attr_col && vueObj.gradeChip_plainOnFill(attr_col) && e_cell.classList.contains('has-status-chip')) {
                    vueObj.gradeChip_flatten(e_cell, e_style)
                }
                // format/align/source условных правил (строка + ячейка,
                // фронт- и бэк-канал) — формат/выравнивание/подмена содержимого
                if (irow >= vueObj.headerRows && dataItem && attr_col?.binding) {
                    if (!_dl2Blank) vueObj.cf_applyFormat(e_cell, e_style, dataItem, col_binding, attr_col, value)   // IE 2026 10 07 / ODOO-5800: погашенная ячейка — без формата / подмены содержимого от правил
                    if (dataItem) vueObj.cowBadge_apply(e_cell, dataItem, col_binding, irow)  // IE 2026 08 24 / ODOO-5884
                    if (dataItem) vueObj.cmpBadge_apply(e_cell, dataItem, col_binding, irow)  // «Mark changes»
                    if (dataItem) vueObj.auditDiffBadge_apply(e_cell, dataItem, col_binding, irow)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: подсветка изменений записи из аудита)
                }

                // MD.tooltip, cellsStyle
                if (irow >= vueObj.headerRows && dataItem && dataItem.MD) {
                    // MD.tooltip — в cellTooltip_html (IE 2026 09 07 / ODOO-337259)
                    if (dataItem.MD.rowStyle) {
                        e_style.cssText += dataItem.MD.rowStyle
                    }
                    if (!_dl2Blank && dataItem.MD.cellsStyle && dataItem.MD.cellsStyle[col_binding]) {   // IE 2026 10 07 / ODOO-5800: стиль / класс САМОЙ ячейки (MD) — у погашенной нет; стиль строки (rowStyle) остаётся
                        e_style.cssText += dataItem.MD.cellsStyle[col_binding]
                    }
                    if (!_dl2Blank && dataItem.MD.cssClass && dataItem.MD.cssClass[col_binding]) {   // IE 2026 10 07 / ODOO-5800
                        wjcCore.addClass(e_cell, dataItem.MD.cssClass[col_binding])
                    }
                    // MD.KPIs_doc — в cellTooltip_html (IE 2026 09 07 / ODOO-337259)
                }
                
                // подсказка ячейки регистрируется ОДНИМ вызовом после AttrMulti (IE 2026 09 07 / ODOO-337259)

                // cells_binding
                if (vueObj.attr.cells_binding && irow >= vueObj.headerRows && e_col >= vueObj.headerColumns && dataItem) {
                    const data_row = irow - vueObj.headerRows + 1
                    const data_col = e_col - vueObj.headerColumns + 1
                    const cb_cell = vueObj.cells_binding_map[data_row]?.[data_col]
                    if (cb_cell) {
                        if (cb_cell.cssClass) {
                            wjcCore.addClass(e_cell, cb_cell.cssClass)
                        }
                        if (cb_cell.style) {
                            e_style.cssText += cb_cell.style
                        }
                        if (cb_cell.comment) {
                            wjcCore.addClass(e_cell, 'wj-has-notes')
                            const recVal = cb_cell.value != null ? cb_cell.value : ''
                            const curVal = value != null ? String(value) : ''
                            // IE 2026 09 23 / ODOO-341407: i18n (UI-строки — английские)
                            let ttHtml = `<b>${t('Recommendation:')}</b> ${recVal}`   // IE 2026 09 23 / ODOO-341407: ревью i18n — теги вне ключа словаря
                            if (curVal) ttHtml += `<br/><b>${t('Current value:')}</b> ${curVal}`   // IE 2026 09 23 / ODOO-341407: ревью i18n — теги вне ключа словаря
                            ttHtml += `<br/><br/>${cb_cell.comment}`
                            tooltip.setTooltip(e_cell, ttHtml)
                        }
                    }
                }

                // быстрые флаги выделения (Grid style: Highlight negative / Highlight empty) —
                // из определения поля колонки (viewList/fields); для мер — из определения
                // меры строки: transpose — row.measure (measureT), REPORT2 — measure/measure_
                // на листовых колонках данных (raw_binding, как cf target measure)
                if (irow >= vueObj.headerRows && dataItem && attr_col) {
                    let hl_field = cell_field || attr_col
                    if (measureT) {
                        hl_field = measureT
                    } else if (attr_col.raw_binding || attr_col.measure_in_dataItem) {
                        hl_field = dataItem.measure || vueObj.get_measure_(dataItem) || hl_field
                    }
                    if (hl_field?.highlightNegative
                        && (typeof value === 'number' || (typeof value === 'string' && value.trim() !== ''))
                        && +value < 0) {
                        wjcCore.addClass(e_cell, 'color-red')
                    }
                    if (hl_field?.highlightEmpty && (value == null || value === '')) {
                        wjcCore.addClass(e_cell, 'cell-background-grey')
                    }
                }

                // 0
                if (value === 0 && attr_col) {
                    wjcCore.addClass(e_cell, 'cell-zero')
                }

                // hide empty rows
                if ((vueObj.attr.hideEmptyRows || (vueObj.attr_nonEmptyWidget?.active && !vueObj.attr.showEmptyAlways)) && dataItem) {   // IE 2026 09 05 / ODOO-336330: форма настроек — пустые строки не серятся
                    if (vueObj.rowEmpty_pass(dataItem)) {   // R21 (IE 2026 09 20 / ODOO-…): один расчёт на строку за проход отрисовки, не на ячейку
                        wjcCore.addClass(e_cell, 'cell-empty')
                    }
                }

                if (vueObj.attr.use_cells && _cells) {
                    if (_cells?.value || _cells?.isNull) {
                        wjcCore.addClass(e_cell, 'wj-has-cell-data')
                    }
                }

                const useComment = true
                if (useComment && _cells) {
                    if (_cells?.comment) {
                        wjcCore.addClass(e_cell, 'wj-has-notes')
                    }

                    // TODEL 2025-10-04
                    if (_cells?.color) { 
                        e_style.setProperty('color', _cells.color, 'important');
                    }
                    if (_cells?.backgroundColor) {
                        e_style.setProperty('background-color', _cells.backgroundColor, 'important');
                    }
                }

                // IE 2026 08 19 / ODOO-5512 (заказ Игоря п.6): оформление ЭЛЕМЕНТА
                // списка — meta.appearance элемента (row._appearance из
                // widget_LIST.select / get_parents_tree): цвет — на все ячейки
                // строки, комментарий — маркер и тултип на первой колонке
                const _appRow = vueObj.attr.elements_appearance && dataItem?._appearance
                if (_appRow) {
                    if (_appRow.color) e_style.setProperty('color', _appRow.color, 'important')
                    if (_appRow.backgroundColor) e_style.setProperty('background-color', _appRow.backgroundColor, 'important')
                    // IE 2026 08 20 (заказ Игоря): произвольные свойства из меню
                    // стилей (Row fill/fore, font, border, padding) — словарь style
                    if (_appRow.style && typeof _appRow.style === 'object') {
                        for (const _k in _appRow.style) {
                            if (_appRow.style[_k]) e_style.setProperty(_k, String(_appRow.style[_k]), 'important')
                        }
                    }
                    if (_appRow.comment && e_col === 0) {
                        wjcCore.addClass(e_cell, 'wj-has-notes')
                        tooltip.setTooltip(e_cell, String(_appRow.comment))
                    }
                }

            }
            formatItem_cells_CSS()
            window.$cg.callEnd();

            // css_calc
            if (dataItem && attr_col.binding) {
                window.$cg.callSub(`css_calc`);
                // IE 2026 09 04 / ODOO-336379 (флаг css_invalidate_scoped): актуальность ячейки = max(общая метка, метка строки)
                if (_cache2.css_calc && _cache2.css_relevance < Math.max(vueObj.css_relevance, vueObj.css_rowRel(dataItem))) {
                    _cache2.css_calc = false;
                }
                if (!_cache2.css_calc && !_cache2.css_promise && vueObj.cache2_data_cells__call__used!==-1) {
                    _cache2.css_calc = true;
                    vueObj.cache2_data_cells__call.set(key2, {dataItem, attr_col, _cache2, key, row:e_row, col: e_col});

                    vueObj.formatItem_cells_calcCSS_py__start_t0 = performance.now()
                    if (!vueObj.formatItem_cells_calcCSS_py__start_WORKIING) {
                        vueObj.formatItem_cells_calcCSS_py__start_WORKIING = true
                        window.$cg.callSub(`py__start`);
                        vueObj.formatItem_cells_calcCSS_py__start()
                        window.$cg.callEnd();
                    }
                }
                if (_cache2?.css_user) { // dm 2026 08 04: _cache2 undefined без dataItem (см. 1374)
                    wjcCore.addClass(e_cell, _cache2.css_user)
                    // classes.push( ..._cache2.css_user .split(' ') .filter(c => c) );
                }
                window.$cg.callEnd();
            }

            // Gantt — перенесён ПОСЛЕ секции AttrMulti (она перезаписывает
            // innerHTML значением, стирая полосы), см. вызов ниже
            // (IE 2026 08 16 / ODOO-4997)

            // AttrMulti
            window.$cg.callSub('AttrMulti');
            const formatItem_cells_AttrMulti = () => {
                let V = attr_col, pi, piEl = null   // IE 2026 11 02 / ODOO-349799 (cell-icons): piEl — параметры иконки по значению (не null → элемент с id onCellIcon__Click)
                if (dataItem && attr_col?.attr_type === 'AttrMulti') {
                    wjcCore.addClass(e_cell, 'cell-multi')
                    V = value
                    if (!V) {
                        // transpose/formatRowsAsColumns (AttrTabGrid-карточка): `value` — уже
                        // РАСПАКОВАННЫЙ скаляр ячейки ('' у пустых полей), а multi-словарь строки
                        // существует — резолвим его, НЕ пересоздаём. Пересоздание затирало весь
                        // дескриптор dataItem.attr (title='') + ложно взводило _meta.modified —
                        // титулы пустых строк карточки пропадали после resize (задача 12).
                        // check_AttrMulti возвращает существующий словарь как есть и создаёт
                        // новый только когда значения реально нет (поведение обычных гридов
                        // не меняется)
                        V = vueObj.store.check_AttrMulti(attr_col, dataItem)
                    }

                    if (String(V.value).startsWith('#') || String(V.value).startsWith('=')){
                        wjcCore.addClass(e_cell, 'custom-text')
                    }

                    // svg
                    if (vueObj.attr.attr_type !== 'AttrTabGrid') {
                        const node = vueObj.PAGE.nodes_svg?.[ V['@@node_key'] ]
                        if (node) {
                            if (node.div !== e_cell) {
                                node.div = e_cell
                            }
                            if (node.row !== e_row) {
                                node.row = e_row
                            }
                            const newJoin = 'horizontal-center'
                            if (node.join !== newJoin) {
                                node.join = newJoin
                            }
                        }
                    }

                    // tooltip поля-строки / мульти-значения — в cellTooltip_html (IE 2026 09 07 / ODOO-337259)

                    // prefix, pi
                    if (input) {
                        vueObj.ghostText_additionalPadding = 0
                    }
                    const V_pi = (vueObj.attr.attr_type === 'AttrTabGrid' && col_binding === 'attr.valueStr' && dataItem?.attr)
                        ? dataItem.attr : V
                    if (attr_col && dataItem && V_pi.pi && V_pi.value && !String(V_pi.relation_segment).startsWith('{')
                        && !e_cell.classList.contains('has-status-chip') && !e_cell.classList.contains('grade-plain')) { // !input && // IE 2026 08 26 / ODOO-5800: у статус-пилюли стрелки нет; IE 2026 09 22: и у оценки текстом на заливке
                        // IE 2026 10 24 / ODOO-348705 (заказ Игоря: иконка ссылки на список в дереве — как ярлык списка): узел-ссылка на запись WIDGET-LIST — pi-folder-open вместо pi-list реестра (utils/treeNodeIcon.js; выключатель fe.ux.treeListFolderOpen, дефолт ВКЛ, читается один раз на проход);
                        // итоговый класс уходит в _cache.linkPi (ниже) — кэш-путь прокрутки вставит ту же иконку
                        pi = treeNode_pi(V_pi, vueObj.fmtSetting('fe.ux.treeListFolderOpen', true) !== false)   // IE 2026 10 24 / ODOO-348705 (заказ Игоря: иконка ссылки на список в дереве — как ярлык списка)
                    }
                    // IE 2026 09 04 / ODOO-336331 (заказ Игоря): бейдж в начале ячейки-словаря (title.badge — «Current»
                    // у открытой настройки в списках панели настроек), стиль как у «Branch copy»
                    if (attr_col && dataItem && !input && V_pi && typeof V_pi === 'object' && V_pi.badge) {
                        for (const b of [...e_cell.querySelectorAll('.cell-badge')]) b.remove()
                        const bd = document.createElement('span')
                        bd.className = 'cell-badge ' + (V_pi.badge_class || '')
                        bd.textContent = String(V_pi.badge)
                        if (V_pi.badge_title) bd.title = String(V_pi.badge_title)
                        const firstTextNode0 = Array.from(e_cell.childNodes).find(node => node.nodeType === Node.TEXT_NODE)
                        if (firstTextNode0) e_cell.insertBefore(bd, firstTextNode0); else e_cell.prepend(bd)
                    }
                    // IE 2026 09 05 / ODOO-336330: кодовый дефолт пустого поля формы настроек (attr.placeholder) — см. placeholder_apply
                    if (attr_col && dataItem && !input) vueObj.placeholder_apply(e_cell, dataItem, col_binding)
                }

                // IE 2026 11 02 / ODOO-349799 (cell-icons): колонка с icon_binding — иконка ПО ЗНАЧЕНИЮ строки (ключ `<binding>_pi` от бэка) вместо иконки сегмента; элемент с id onCellIcon__Click
                // и data-атрибутами (level, value, row_id) — клик открывает список (cellIcon_click); клон в _cache.linkPiEl для кэш-пути.
                // Стоит ВНЕ ветки AttrMulti (IE 2026 11 02 / ODOO-349799 (cell-icons), живой промер dev02 «Конфігурація» 02.11): колонки Kind / Subsystem / Segment страницы
                // предопределённых — AttrLink со строковым значением ('ADDON'), Collection — AttrStr; внутри ветки `attr_type === 'AttrMulti'` блок не исполнялся,
                // и у листовой строки в колонке дерева (segment) иконки не было, хотя segment_pi в строке есть
                if (attr_col?.icon_binding && dataItem && !groupItem && vueObj.cellIcons_on()) {
                    const _ipi = cellIcon_pi(attr_col, dataItem)
                    if (_ipi) {
                        pi = _ipi
                        piEl = cellIcon_params(attr_col, (attr_col.attr_type === 'AttrMulti' && V && typeof V === 'object') ? V.value : value, dataItem)
                    }
                }
                if (value && attr_col.attr_type === 'AttrLink' && vueObj.attr.isPrint) {
                    pi = vueObj.store.get_value_segment(attr_col.relation_segment, 'pi', "pi pi-arrow-right")
                }

                // IE 2026 09 05 / ODOO-336330 (репорт Игоря): класс иконки ссылки — в кэш ячейки, кэш-путь formatItem
                // вставит её сам (linkIconCache), иначе первый кадр после свёртки группы шёл без иконок
                _cache.linkPi = pi || ''
                _cache.linkPiEl = null   // IE 2026 11 02 / ODOO-349799 (cell-icons)
                if (pi) {
                    let div1 = document.createElement('i')
                    div1.classList = [`cell-link pr-2 ${pi}`]
                    if (piEl) {   // IE 2026 11 02 / ODOO-349799 (cell-icons): иконка по значению — id ветки клика и data-атрибуты параметров
                        const _tpl = document.createElement('div')
                        _tpl.innerHTML = cellIcon_html(pi, piEl, t('Open list'))
                        if (_tpl.firstElementChild) { div1 = _tpl.firstElementChild; _cache.linkPiEl = div1.cloneNode(true) }
                    }

                    // e_cell.prepend(div1)
                    const firstTextNode = Array.from(e_cell.childNodes).find(node => node.nodeType === Node.TEXT_NODE);
                    if (firstTextNode) {
                        vueObj.ghostText_additionalPadding = 12.25 + 7
                        e_cell.insertBefore(div1, firstTextNode)
                        // IE 2026 09 04 / ODOO-336331 (заказ Игоря): порядок «иконка → бейдж Current → заголовок» — бейдж вставлен раньше иконки,
                        // иконку переносим перед ним
                        const _bd0 = e_cell.querySelector('.cell-badge')
                        if (_bd0 && _bd0.nextSibling === div1) e_cell.insertBefore(div1, _bd0)
                    } else if (input) {
                        vueObj.ghostText_additionalPadding = 12.25 + 7
                        e_cell.insertBefore(div1, input)
                    } else {
                        e_cell.appendChild(div1)
                    }
                    if (input) {
                        wjcCore.addClass(input, `attrmulti-attrlink`)
                        if (vueObj.multiLevel) {
                            vueObj.ghostText_additionalPadding = 12.25 + 7
                        }
                    }
                }

                // search
                if (!input && e_cell.textContent && (vueObj.CHIPS_view.length || vueObj.WIDGET.widget_class === 'widget_SEARCH')) {   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска)
                    let highlightedTitle = vueObj.store.check_CHIPS_highlighted(vueObj.WIDGET, e_cell.textContent, vueObj.CHIPS_view, true)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска)
                    if (highlightedTitle) {
                        // e_cell.innerHTML = highlightedTitle
                        e_cell.innerHTML = e_cell.innerHTML.replace(
                            e_cell.innerHTML.replace(/<\/?[^>]+(>|$)/g, ""),
                            highlightedTitle
                        )
                    }
                }
                vueObj.searchAlt_cellMark(e_cell, dataItem, attr_col, value)   // IE 2026 09 25 / ODOO-… (замечание Игоря: поиск в таблице по названиям на других языках): ячейка-ссылка, найденная по названию на другом языке — класс search-alt-hit

                // IE 2026 09 23 / ODOO-341407: i18n (подписи-префиксы типов)
                const prefixMapping = {
                    'AttrTab': { class: 'AttrTab', text: t('Tab') },
                    'AttrTabRow': { class: 'AttrTab', text: t('Tab row') },
                    'AttrTabCol': { class: 'AttrTab', text: t('Tab col') }, // IE 2026 09 03 / ODOO-336283
                    'AttrTabPanel': { class: 'AttrTab', text: t('Tab Panel') },
                    // тип правила усл. оформления (cf_rule_types_apply бэка);
                    // CHIP-CondFormat — обычное правило, без чипса (как
                    // обычные поля в гридах полей)
                    'AttrTabOR': { class: 'AttrTab', text: t('Tab OR') },

                    'AttrTabGrid': { class: 'AttrTabGrid', text: t('Fields Grid') },
                    'AttrGrid': { class: 'AttrGrid', text: t('Grid') },
                    'AttrGridRows': { class: 'AttrTab', text: t('Rows') },
                    'AttrGridColumns': { class: 'AttrTab', text: t('Columns') },
                    'AttrChart': { class: 'AttrGrid', text: t('Chart') },
                    'AttrTreeMap': { class: 'AttrGrid', text: t('Tree Map') },
                    'AttrButton': { class: 'AttrButton', text: t('Button') },
                };
                const prefixMapping2 = {
                    ...prefixMapping,
                    'AttrStr': { class: 'Attr', text: t('Text') },
                    'AttrBool': { class: 'Attr', text: t('Boolean') },
                    'AttrNumber': { class: 'Attr', text: t('Number') },
                    'AttrDate': { class: 'Attr', text: t('Date') },
                    'AttrTime': { class: 'Attr', text: t('Time') },
                    'AttrDays': { class: 'Attr', text: t('Days') },
                    'AttrLink': { class: 'Attr', text: t('Link') },
                    'AttrLinkOdoo': { class: 'Attr', text: t('Link Odoo') },
                    'AttrMulti': { class: 'Attr', text: t('Multi') },
                    'AttrList': { class: 'Attr', text: t('List') },
                    'AttrHTML': { class: 'Attr', text: t('HTML') },

                    'AttrJSON': { class: 'Attr', text: t('JSON') },
                    'AttrCSS': { class: 'Attr', text: t('CSS') },
                    'AttrStrMulti': { class: 'Attr', text: t('Text Multi') },
                };

                const add_prefix = (prefix, checkTooltip=false) => {
                    const div1 = document.createElement('b');
                    let divPi, divTooltip;

                    div1.classList.add(prefix.class);
                    div1.classList.add('mr-1');
                    div1.innerText = prefix.text;
                    if (dataItem.pi) {
                        divPi = document.createElement('i');
                        divPi.classList.add('ml-1');
                        dataItem.pi.split(' ').forEach(className => divPi.classList.add(className));
                    }
                    if (!dataItem.title && dataItem.tooltip && checkTooltip) {
                        divTooltip = document.createElement('i');
                        divTooltip.classList.add('ml-1');
                        divTooltip.classList.add('field-tooltip');
                        divTooltip.innerText = dataItem.tooltip;
                    }

                    const firstTextNode = Array.from(e_cell.childNodes).find(node => node.nodeType === Node.TEXT_NODE);
                    if (firstTextNode) {
                        e_cell.insertBefore(div1, firstTextNode);
                        if (divPi) e_cell.insertBefore(divPi, firstTextNode);
                        if (divTooltip) e_cell.insertBefore(divTooltip, firstTextNode);
                    } else if (input) {
                        e_cell.insertBefore(div1, input);
                        if (divPi) e_cell.insertBefore(divPi, input);
                        if (divTooltip) e_cell.insertBefore(divTooltip, input);
                    } else {
                        e_cell.appendChild(div1);
                        if (divPi) e_cell.appendChild(divPi);
                        if (divTooltip) e_cell.appendChild(divTooltip);
                    }
                    return div1
                };

                // AttrGrid cell — показать поля как chips
                // (пустая ячейка табличной части с Link-колонкой — тоже: рендерим input
                // добавления, массив создаётся при первом добавлении, см. chip_add)
                // IE 2026 08 19 / ODOO-5512 (заказ Игоря): AttrTags — строка AttrTabGrid
                // (теги элемента): та же механика чипсов-в-ячейке — подбор из itemsSource
                // словаря сегмента / relation_segment, Enter добавляет свой тег,
                // ⊗/Backspace/Del удаляют; значение — массив по binding строки (doc.tags),
                // запись сохраняется штатной кнопкой Save (tagsRow_commit → attr_set)
                const _tagsRow = (vueObj.attr.attr_type === 'AttrTabGrid' && col_binding === 'attr.valueStr'
                    && dataItem?.attr?.attr_type === 'AttrTags') ? dataItem.attr : null
                let attr_colC = attr_col
                let valueC = value
                if (_tagsRow) {
                    attr_colC = _tagsRow
                    valueC = Array.isArray(_tagsRow.value) ? _tagsRow.value : []
                }
                // IE 2026 10 05 / ODOO-5800 (fe-80; prod_check18 A): строка-список id записей (AttrTags + relation_segment, значение — массив строк-id: doc.causes /
                // doc.solutions / doc.signals справочников модели сигналов) — чипсы с названиями записей; только чтение (isReadOnly) — без ⊗ и поля добавления
                const _idsAttr = _tagsRow ? tagIds_linkAttr(_tagsRow) : null
                const _idsRO = !!(_idsAttr && _tagsRow.isReadOnly)
                if ((_tagsRow || attr_colC?.attr_type === 'AttrGrid') && (Array.isArray(valueC)
                    || (valueC == null && dataItem && vueObj.chipLabelAttr(attr_colC)?.attr_type === 'AttrLink'))) {
                    if (!Array.isArray(valueC)) {
                        valueC = []
                    }
                    e_cell.textContent = ''
                    const ctxC = { flex, e_cell, dataItem, attr_colC, valueC, _tagsRow, _idsAttr, _idsRO }   // IE 2026 10 15 / ODOO-5512: shared context of ⊗ (chipRemove_apply) and the chip input (chipInput_bind)
                    // Inner wrapper keeps position:relative off the wj-cell (which is position:absolute)
                    const chipWrapper = document.createElement('div')
                    chipWrapper.style.cssText = 'position:relative;display:flex;flex-wrap:wrap;align-items:center;width:100%;height:100%'
                    e_cell.appendChild(chipWrapper)
                    for (const field of valueC) {
                        if (field.use === false) continue

                        const chip = document.createElement('div')
                        chip.classList.add('chip', 'mr-1', 'scale70')
                        // скрытые поля отличаем визуально, чтобы их не искали в таблице
                        if (field.hidden) {
                            chip.classList.add('chip-hidden')
                            chip.title = t('Hidden field')   // IE 2026 09 23 / ODOO-341407: i18n
                        }
                        chip.draggable = true
                        chip.dataset.fieldIndex = String(valueC.indexOf(field))

                        const chipIcon = document.createElement('span')
                        chipIcon.classList.add('chip-icon', 'pi', field.pi || (_tagsRow ? 'pi-tag' : 'pi-bars'))
                        chipIcon.addEventListener('click', (ev) => {
                            ev.stopPropagation()
                            if (_tagsRow) return // тег — не поле табличной части, widget-row не о чем
                            const actionMenu = {
                                'tooltip': t('Open cell'),   // IE 2026 09 23 / ODOO-341407: i18n
                                'action_name': 'action-front-openLine-2025-09-23',
                                command: 'widget_open',
                                'widget': 'widget-row',
                                'type': 'widget-row-cell',
                                '_activate': true,
                                'get_currentRow': true,
                                'get_Parent': true,
                                'open_in_children_widget': true,
                                'cssClass': 'pi p-button-white pi-pencil',
                                'binding': vueObj.attr.binding,
                                col_binding: attr_colC?.binding,
                                attrs: [],
                                widgetRow_params: vueObj.attr.widgetRow_params,
                                activeAttr: { binding: attr_colC?.binding, rowIndex: valueC.indexOf(field) },
                            }
                            vueObj.store.executeStoreMethod(vueObj.WIDGET.vueObj, actionMenu, vueObj.attr)
                        })
                        chip.appendChild(chipIcon)

                        const chipText = document.createElement('span')
                        chipText.classList.add('chip-text')
                        chipText.textContent = vueObj.chipLabel(field, attr_colC)
                        chip.appendChild(chipText)

                        // IE 2026 08 19 (заказ Игоря): выделить тег кликом — Del удаляет
                        if (_tagsRow) {
                            chip.addEventListener('click', (ev) => {
                                ev.stopPropagation()
                                const was = chip.classList.contains('chip-selected')
                                chipWrapper.querySelectorAll('.chip-selected').forEach(el => el.classList.remove('chip-selected'))
                                vueObj._tagsSelected = null
                                if (!was) { chip.classList.add('chip-selected'); vueObj._tagsSelected = field }
                                input.focus()
                            })
                        }

                        const chipRemove = document.createElement('i')
                        chipRemove.classList.add('chip-remove', 'pi', 'pi-times-circle')
                        chipRemove.addEventListener('click', (ev) => {
                            ev.stopPropagation()
                            vueObj.chipRemove_apply(field, ctxC)   // IE 2026 10 15 / ODOO-5512: one path for ⊗ and Backspace in the empty chip input
                        })
                        if (!_idsRO) chip.appendChild(chipRemove)   // IE 2026 10 05 / ODOO-5800 (fe-80)

                        chip.addEventListener('dragstart', (ev) => {
                            ev.stopPropagation()
                            vueObj.store.params_dragSource = {
                                type: 'attrGridField',
                                field: field,
                                sourceValue: valueC,
                                sourceCell: e_cell.data_cell,
                                vueObj: vueObj,
                            }
                        })
                        chipWrapper.appendChild(chip)
                    }
                    if (!_tagsRow) vueObj.dl2Sort_appendChips(chipWrapper, dataItem, attr_colC)   // IE 2026 10 10 / ODOO-341407 (Andrey via core #74338: sort chips in the layout list)

                    // input для добавления новых chips
                    const input = document.createElement('input')
                    input.classList.add('chip-input-cell')
                    input.type = 'text'
                    vueObj.chipInput_bind(input, ctxC)   // IE 2026 10 15 / ODOO-5512: handlers (selection / Enter / Backspace / blur) — one function for this path and the formatItem cache path
                    chipWrapper.appendChild(input)

                    const overflowBadge = document.createElement('div')
                    overflowBadge.classList.add('chip-overflow-badge')
                    overflowBadge.style.display = 'none'
                    chipWrapper.appendChild(overflowBadge)
                    const _capturedCell = e_cell.data_cell
                    requestAnimationFrame(() => {
                        if (e_cell.data_cell !== _capturedCell) return
                        const cellRect = e_cell.getBoundingClientRect()
                        if (!cellRect.height) return
                        let hiddenCount = 0
                        for (const chip of e_cell.querySelectorAll('.chip')) {
                            if (chip.getBoundingClientRect().bottom > cellRect.bottom + 1) hiddenCount++
                        }
                        overflowBadge.style.display = hiddenCount > 0 ? 'flex' : 'none'
                        if (hiddenCount > 0) overflowBadge.textContent = `+${hiddenCount}`
                    })
                }

                // prefix, field; в лёгком виде (lightView) чипс-префикс типа
                // на колонке Title — всегда, даже без prefix_field в конфиге
                if (dataItem && (attr_col?.prefix_field === 'attr_type'
                    || (vueObj.lightView_active && attr_col?.binding === 'title'))) {
                    const attr_type = dataItem.attr_type;
                    const prefix = prefixMapping[attr_type]
                    if (prefix) {
                        add_prefix(prefix, true)
                    }
                }

                if (_cells?._isHeader) {
                    wjcCore.addClass(e_cell, 'wj-header-top')
                    wjcCore.addClass(e_cell, 'wj-header')
                    wjcCore.addClass(e_cell, 'wj-align-center')
                    // wjcCore.addClass(e_cell, 'align-center')
                }

                // строка-секция мульти-вертикальной таблицы: полоса с заголовком
                // секции в первой колонке (children — строки шаблона секции)
                if ((vueObj.attr.isPrintTemplate || vueObj.attr.isPrint)
                        && dataItem?.attr_type === 'AttrGrid') {
                    wjcCore.addClass(e_cell, 'print-section-row')
                    if (attr_col?.binding === 'col_1') {
                        const secLabel = `§ ${dataItem.title || t('Section')}`   // IE 2026 09 23 / ODOO-341407: i18n
                        vueObj.store.updateCellText(e_cell, secLabel)
                        if (!(e_cell.textContent || '').includes(secLabel)) {
                            e_cell.appendChild(document.createTextNode(secLabel))
                        }
                    }
                }

                // spill: текст печати продолжается поверх ПУСТЫХ ячеек справа
                // (опция printTextSpill, по умолчанию ВКЛ) — титулы/подписи не
                // режутся шириной колонки; бордюры/фоны справа отсутствуют, так
                // что продление безболезненно (см. постановку)
                if ((vueObj.attr.isPrint || vueObj.attr.isPrintTemplate) && dataItem
                        && String(col_binding || '').startsWith('col_')
                        && vueObj.get_viewParam('printTextSpill', true) !== false) {
                    const _txt = (e_cell.textContent || '').trim()
                    if (_txt) {
                        const _colN = parseInt(String(col_binding).slice(4)) || 0
                        let _emptyRight = true
                        for (let k = _colN + 1; k <= Math.min(_colN + 8, 49); k++) {
                            const _key = 'col_' + k
                            const _v = dataItem[_key]
                            const _hasVal = typeof _v === 'string' ? !!_v.trim() : _v != null
                            const _ov = dataItem._cells?.[_key]
                            if (_hasVal || (_ov && _ov.fields && _ov.fields.length)) { _emptyRight = false; break }
                        }
                        if (_emptyRight) wjcCore.addClass(e_cell, 'print-spill')
                    }
                }

                if (vueObj.attr.isPrintTemplate && cell_field) {
                    // fields[0] только со стилем (статический текст ячейки) —
                    // текст не затираем и чипс не рисуем
                    const hasField = cell_field.title || cell_field.binding || cell_field.source != null
                    const prefix = prefixMapping2[cell_field?.attr_type]
                    if (hasField) {
                        // подпись ячейки шаблона: title, иначе binding, иначе source
                        const label = cell_field.title || cell_field.binding
                            || (cell_field.source != null ? String(cell_field.source) : '')
                        vueObj.store.updateCellText(e_cell, label)
                        // пустая ячейка (нет значения col_N — контент задан fields[0]):
                        // текстового узла нет, updateCellText не создаёт — добавляем
                        if (label && !(e_cell.textContent || '').includes(label)) {
                            e_cell.appendChild(document.createTextNode(label))
                        }
                        if (!_cells._isHeader && prefix) {
                            // чипс типа — короткий (первая буква), полное имя в подсказке
                            const div1 = add_prefix({ class: prefix.class, text: (prefix.text || '').slice(0, 1) })
                            div1.title = prefix.text
                            wjcCore.addClass(div1, 'cell-link')
                            wjcCore.addClass(div1, 'chip-short')
                        }
                    }
                }
                // if (vueObj.attr.isPrint) {
                //     if (_cells?.valueStr) {
                //         e_cell.textContent = _cells.valueStr
                //     }
                // }

                // selector cell
                if (vueObj.attr.selector_cell && attr_col && dataItem && dataItem[attr_col.binding_doc] && typeof dataItem[attr_col.binding_doc] === 'object' && 'selector' in dataItem[attr_col.binding_doc]) {
                    let cell_doc = dataItem[attr_col.binding_doc]
                    wjcCore.addClass(e_cell, 'attr-KPI')
                    
                    let div1 = document.createElement('div')
                    div1.classList = ["data-cell attr-KPI-group"]

                    if ('selector' in cell_doc) {
                        let checkbox = document.createElement('input')

                        checkbox.type = 'checkbox'
                        checkbox.className = 'wj-cell-check'
                        checkbox.tabIndex = -1
                        checkbox.id = 'onSelectorKPI__Click'
                        checkbox.checked = cell_doc.selector || false
                        if (checkbox.checked) {
                            checkbox.classList = ["attr-KPI-selector attr-KPI-selector-on wj-control"]
                        } else {
                            checkbox.classList = ["attr-KPI-selector wj-control"]
                        }
                        div1.appendChild(checkbox)
                    }

                    if (cell_doc.action) {
                        let button = document.createElement('button');
                        button.className = 'attr-KPI-button wj-btn wj-btn-default my-text-shadow';
                        button.id = 'onButtonKPI__Click';
                        button.tabIndex = -1;
                        button.type = 'button';
                        button.setAttribute('aria-label', t('Toggle choose in list'));   // IE 2026 09 23 / ODOO-341407: i18n
                            let icon = document.createElement('i');
                            icon.className = 'pi pi-doc pi-arrow-right';
                            icon.id = 'onButtonKPI__Click';
                        button.appendChild(icon);
                        div1.appendChild(button)
                    }

                    e_cell.appendChild(div1)
                    
                    div1.data_cell = {
                        irow: irow,
                        binding_doc: attr_col.binding_doc,
                        col_binding: col_binding,
                        row: e_row,
                        col: e_col
                    }
                }

                // date time
                if (!input && dataItem && !title_back && !_dl2Blank && !vueObj.attr.isPrintTemplate) {   // IE 2026 10 07 / ODOO-5800: погашенная ячейка — форматировать нечего
                    let value
                    if (attr_col?.attr_type === 'AttrMulti') {
                        value = V.value
                    } else {
                        value = vueObj.foldAgg_getValue(dataItem, col_binding, attr_col)
                    }

                    let cell_attr_type = V?.attr_type
                    let cell_format = V?.format
                    // ODOO-5009: см. комментарий в первой копии цепочки — формат меры
                    // строки (value_) не должен требовать transpose
                    let measureRowFormat = false
                    if (V?.measure_in_dataItem) {
                        const measure = dataItem.measure || vueObj.get_measure_(dataItem); // measure_ через реестр fields_
                        if (measure?.attr_type) {
                            cell_attr_type = measure.attr_type;
                            cell_format = measure.format;
                            measureRowFormat = !!measure.format
                        }
                    }
                    // transpose: параметры ячейки (объект-значение) > строки (row.measure) > колонки
                    if (measureT) {
                        if (cellT) {
                            value = cellT.value
                        } else if (vueObj.attr.formatRowsAsColumns) {
                            value = measureT.value // raw-значение колонки-строки для форматирования
                        }
                        cell_attr_type = cellT?.attr_type || measureT.attr_type || cell_attr_type
                        cell_format = cellT?.format || measureT.format || cell_format
                    }

                    // IE 2026 08 31 / ODOO-5884: формат строки/ячейки (_DLRow.format) сильнее типа —
                    // см. одноимённый комментарий в первой копии цепочки
                    if (vueObj.cf_rowFormat(dataItem, col_binding)
                            && (cell_attr_type === 'AttrDate' || cell_attr_type === 'AttrTime' || cell_attr_type === 'AttrDays')) {
                        cell_attr_type = null
                    }
                    if (value) {
                        if (cell_attr_type === 'AttrDate') {
                            e_cell.innerHTML = vueObj.store.formatDateHTML(value, V.utc_to_local)
                        } else if (cell_attr_type === 'AttrTime') {
                            const _fa = {attr_type:cell_attr_type, format:cell_format, unit:cellT?.unit || measureT?.unit || attr_col?.unit}
                            e_cell.innerHTML = vueObj.store.formatTimeHTML(value, _fa)
                            vueObj.durFit_apply(e_cell, value, _fa, 'time', vueObj.flex?.columns?.[e.col])   // IE 2026 09 10 / ODOO-… (замечание Игоря): не влезает — округлить
                        } else if (cell_attr_type === 'AttrDays') {
                            const _fa = {attr_type:cell_attr_type, format:cell_format}
                            e_cell.innerHTML = vueObj.store.formatDaysHTML(value, _fa)
                            vueObj.durFit_apply(e_cell, value, _fa, 'days', vueObj.flex?.columns?.[e.col])   // IE 2026 09 10 / ODOO-… (замечание Игоря)
                        } else if (cell_attr_type === 'AttrNumber' && value && Math.abs(+value) < 0.0001) {
                            // «жёсткий ноль» (эпсилон-драфт 1e-7) — рисуем «-»
                            e_cell.innerHTML = '<span class="num-inner">-</span>'
                        } else if (cell_attr_type === 'AttrNumber' && value && cell_format === 'bytes') {
                            e_cell.innerHTML = vueObj.store.formatNumberHTML(value, {attr_type:cell_attr_type, format:cell_format})
                        } else if (attr_col?.attr_type === 'AttrMulti' && cell_attr_type === 'AttrNumber') {
                            // ODOO-4251: см. комментарий в первой копии цепочки — формат строки
                            // (поля записи в карточке AttrTabGrid) не должен требовать transpose
                            e_cell.innerHTML = `<span class="num-inner">${wjcCore.Globalize.format(value, cell_format || attr_col.format || 'n0')}</span>`
                            if (value < 0) {
                                wjcCore.addClass(e_cell, 'num-negative')
                            }
                        } else if ((measureT || measureRowFormat) && cell_attr_type === 'AttrNumber' && cell_format && typeof value === 'number') {
                            // transpose: формат числа из параметров строки (row.measure).
                            // ODOO-5009: и мера строки в общей колонке значений (value_) — без
                            // флага ячейку рисовал wijmo форматом колонки (n0 вместо p0/n2)
                            e_cell.innerHTML = `<span class="num-inner">${wjcCore.Globalize.format(value, cell_format)}</span>`
                            if (value < 0) {
                                wjcCore.addClass(e_cell, 'num-negative')
                            }
                        }
                    }
                    // IE 2026 09 10 / ODOO-… (заказ Игоря): строка AttrBool в AttrTabGrid (колонка Value = AttrMulti) — настоящий
                    // чекбокс вместо текста true/false и на полном пути отрисовки; кэш-путь formatItem рисует его сам (boolCell_render)
                    if (!isXlsxExport && !isPrint && attr_col?.attr_type === 'AttrMulti' && cell_attr_type === 'AttrBool' && !measureT
                            && vueObj.attr.attr_type === 'AttrTabGrid') {
                        vueObj.boolCell_render(e_cell, value)
                    }
                }
            }

            // IE 2026 08 23 / ODOO-5884 (баг Игоря «Δ% в днях»): формат строки/ячейки правил и compare-строк
            // (_DLRow.format — Δ% несёт 'p0') применяется и на ЭТОМ пути отрисовки, как в основном formatItem
            // (там cf_applyFormat стоит после типовой отрисовки; здесь его не было — Δ% в колонке дней оставался «0.3d»)
            if (dataItem && attr_col?.binding) {
                if (!_dl2Blank) vueObj.cf_applyFormat(e_cell, e_cell.style, dataItem, col_binding, attr_col, value)   // IE 2026 10 07 / ODOO-5800: погашенная ячейка — без формата / подмены содержимого от правил
                if (dataItem) vueObj.cowBadge_apply(e_cell, dataItem, col_binding, e_row)  // IE 2026 08 24 / ODOO-5884
                if (dataItem) vueObj.cmpBadge_apply(e_cell, dataItem, col_binding, e_row)  // «Mark changes»
                if (dataItem) vueObj.auditDiffBadge_apply(e_cell, dataItem, col_binding, e_row)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: подсветка изменений записи из аудита)
            }

            // ref-toggle button: chevron icon in cell corner, visible on hover
            const _dd_relSeg = value?.relation_segment || attr_col?.relation_segment
            vueObj.formatItem_dropdownToggle(e_cell, attr_col, irow, e_row, e_col, col_binding, key, dataItem, isXlsxExport, isPrint, !!_dd_relSeg, value)
            formatItem_cells_AttrMulti()
            window.$cg.callEnd();
            // IE 2026 09 07 / ODOO-337259: подсказка ячейки — ОДНИМ вызовом после всех каналов (cellTooltip_html: мера
            // transpose, KPI, тултип cf/MD, поле-строка AttrTabGrid / мульти-значение, рекомендация cells_binding,
            // комментарий согласования). Раньше каналы перетирали друг друга через setTooltip (пустой doc стирал
            // тултип cf/MD), а блок поля/мульти-значения дописывал doc уже ПОСЛЕ регистрации — подсказки строк
            // формы (Tooltip / Default / Field) не доходили до ячейки вовсе
            if (vueObj.store.showTooltip) {
                tooltip.setTooltip(e_cell, vueObj.cellTooltip_html(flex.cells, irow, e_col) || null)
            }
            // IE 2026 10 04 / ODOO-5800 (fe-71): подсказка бэка у ячейки с показанным текстом `<binding>-title` — и без Show tooltips (см. shownTitle_cellApply)
            vueObj.shownTitle_cellApply(e_cell, dataItem, attr_col, irow, e_col, false)

            // Gantt — вынесено в formatItem_gantt_apply (IE 2026 08 16 /
            // ODOO-4997): переиспользуется быстрым кеш-путём formatItem.
            // Вызов стоит ПОСЛЕ AttrMulti: та ветка пишет e_cell.innerHTML
            // значением ячейки (Busy '1.5h') и стирала добавленные полосы
            if (dataItem?.$gantt) {
                window.$cg.callSub('gantt');
                vueObj.formatItem_gantt_apply(e_cell, dataItem, col_binding, attr_col)
                window.$cg.callEnd();
            }

            // delivery
            if (vueObj.attr.use_delivery && !isPrint) {
                window.$cg.callSub('break');
                const formatItem_cells_break = () => {
                    window.$cg.callSub('1');
                    // IE 2026 08 27 / ODOO-5800 (заказ Игоря): режим линий дерева (рамка / пунктир)
                    // и счётчики времени рядом с флагом — сравнение вариантов на одном гриде
                    const useFrame = vueObj.treeLines_isFrame()
                    const noGaps = vueObj.treeLines_noGaps() // IE 2026 08 27 / ODOO-5800: зазоры остаются при карточках
                    const _tlStats = vueObj.store?._treeLinesStats
                    const _tl0 = _tlStats ? performance.now() : 0
                    if (_cache.sectionEnd === undefined) { // (2)
                        let iPrev = irow - 1;
                        while (iPrev > 0 && rows[iPrev].visibleIndex === -1) iPrev--;
                        _cache.sectionStart = iPrev > 0 && row.level < rows[iPrev].level

                        let iNext = irow + 1
                        while (iNext < rows.length && rows[iNext].visibleIndex === -1) iNext++;
                        _cache.sectionEnd = iNext < rows.length && row.level > rows[iNext].level
                        _cache.iNext = iNext
                    }
                    window.$cg.callEnd(); window.$cg.callSub('2');

                    // break-top
                    const format0 = false
                    let elements_overflow = []
                    _cache.breakTop = 0
                    let new_height = null
                    if (_cache.sectionStart) {
                        // IE 2026 08 20 / ODOO-5512 (заказ Игоря): при Borders=None
                        // высота всех строк одинаковая — без зазора секций
                        // IE 2026 08 27 / ODOO-5800: в режиме рамки зазора секций нет
                        _cache.breakTop = (vueObj.attr.borders === 'None' || noGaps) ? 0 : 10 // row.level === 0 ? vueObj.break_width : row.level === 1 ? 10 : 5
                        new_height = (dataItem?._DLRow?.height || dataItem?._cells?._row?.height || rows.defaultSize) + _cache.breakTop // IE 2026 09 03 / ODOO-336283: Row height строки лэйаута
                        if (row.height !== new_height) {
                            row.height = new_height
                        }
                    } else if (dataItem?._DLRow?.height || dataItem?._cells?._row?.height) { // IE 2026 09 03 / ODOO-336283
                        new_height = dataItem?._DLRow?.height || dataItem._cells._row.height
                        if (row.height !== new_height) {
                            row.height = new_height
                        } 
                    }
                    window.$cg.callEnd(); window.$cg.callSub('4');
                    if (_cache.sectionStart) {
                        if (prevTop === undefined) {
                            prevTop = parseFloat(e_style.top || '0');
                            prevHeight = parseFloat(e_style.height || '0');
                        }

                        e_style.top = `${prevTop + _cache.breakTop}px`;
                        e_style.height = `${dataItem?._DLRow?.height || dataItem?._cells?._row?.height || rows.defaultSize}px`; // prevHeight - _cache.breakTop; IE 2026 09 03 / ODOO-336283

                        // // delivery-top
                        // if (_cache.breakTop) {
                        //     let div1 = document.createElement('div')
                        //     div1.className = `cell-delivery-top`
                        //     div1.style.top = `-${_cache.breakTop}px`
                        //     div1.style.height = `${_cache.breakTop}px`
                        //     elements_overflow.push(div1)
                        // }

                        // border-top; на 1px выше — смыкается с окончаниями
                        // вертикальных пунктиров веток (bottom:-2px у isLast).
                        // IE 2026 08 27 / ODOO-5800: в режиме рамки его нет — низ группы
                        // рисует угол+горизонталь рамки в колонке дерева
                        if (!useFrame) {
                            let div1 = document.createElement('div')
                            div1.style.top = `${-_cache.breakTop}px`;
                            if (e_col === 0) div1.style.left = `${breakPaddingLeft + 2 + (row.level - row.level) * breakCollapseWidth}px`;
                            if (vueObj.breakOf(attr_col)) div1.style.left = `-${vueObj.break_width}px`;   // IE 2026 09 19 / ODOO-…
                            div1.className = 'cell-delivery-top-border'
                            elements_overflow.push(div1)
                        }
                    }
                    window.$cg.callEnd(); window.$cg.callSub('5');

                    // break-left
                    _cache.breakLeft = 0
                    if (vueObj.breakOf(attr_col)) {   // IE 2026 09 19 / ODOO-…: + разрыв, переехавший со скрытой колонки (breakCarry_update)
                        // const cellStyle = window.getComputedStyle(e_cell);
                        const left = parseFloat(e_style.left) || 0;
                        const width = parseFloat(e_style.width) || 0;

                        // IE 2026 08 16 (заказ Игоря): расширенный отступ между
                        // карточками, двойной — перед первой; маскам шапки
                        // сообщаем СУММАРНУЮ ширину зазора
                        const _cardEx = vueObj.cards_extraShift(col_binding)

                        // позиция зазора — для масок шапки (set_breakGapMasks)
                        if (!vueObj._breakGaps) vueObj._breakGaps = new Map()
                        vueObj._breakGaps.set(Math.round(left), vueObj.break_width + _cardEx)
                        if (vueObj.breakMode(attr_col) === 'plan') { if (!vueObj._breakPlanGaps) vueObj._breakPlanGaps = new Set(); vueObj._breakPlanGaps.add(Math.round(left)) }   // body · IE 2026 09 29 / ODOO-343343 (заказ Игоря: начало плана штриховкой)

                        _cache.breakLeft = vueObj.break_width + _cardEx;
                        e_style.left = `${left + _cache.breakLeft}px`;
                        e_style.width = `${width - _cache.breakLeft}px`;

                        // // delivery-left
                        // if (_cache.breakLeft) {
                        //     let div1 = document.createElement('div')
                        //     div1.className = `cell-delivery-left`
                        //     div1.style.left = `-${_cache.breakLeft}px`
                        //     div1.style.width = `${_cache.breakLeft}px`
                        //     elements_overflow.push(div1)
                        // }
                        
                        // border-left
                        let div1 = document.createElement('div')
                        // div1.style.top = `-${_cache.breakTop}px`;
                        div1.style.left = `-7px`;
                        div1.className = 'cell-delivery-left-border'
                        elements_overflow.push(div1)

                        // IE 2026 09 17 / ODOO-… (заказ Игоря): разрыв со СТРЕЛКОЙ — направление читается
                        // по строкам, без чтения шапки (From → To). Стрелка живёт в зазоре: элемент
                        // overflow ячейки со сдвигом влево на ширину зазора (как пунктир выше)
                        // IE 2026 09 17 (замечание Игоря: «вторая стрелка справа», «не отработало выделение схожих
                        // ячеек»): знак стрелки — НЕ текст элемента, а его ::before (см. CSS .break-arrow): текст ячейки
                        // остаётся чистым для подсветки одинаковых ячеек и любых копирований textContent, а сам элемент
                        // хвост formatItem держит на месте (breakArrow_fix) при любых перестройках ячейки
                        const _bMode = vueObj.breakMode(attr_col)
                        if (_bMode.indexOf('arrow') === 0) {
                            const _ar = document.createElement('div')
                            _ar.className = 'break-arrow' + (_bMode === 'arrow_left' ? ' break-arrow-l' : (_bMode === 'arrow_both' ? ' break-arrow-b' : (_bMode === 'arrow_double' ? ' break-arrow-d' : '')))   // IE 2026 09 20 / ODOO-5800 (Igor 20.09: «показывай двойную стрелку вправо перед полем sales_country … с разделителем перед колонкой и двойной стрелочкой перед ним в списках правил и в формах их элементов»)
                            _ar.style.left = `-${_cache.breakLeft}px`
                            _ar.style.width = `${_cache.breakLeft}px`
                            elements_overflow.push(_ar)
                            wjcCore.addClass(e_cell, 'break-arrow-cell')   // пунктир под стрелкой не рисуем
                        } else if (_bMode === 'plan') {
                            // IE 2026 09 29 / ODOO-343343 (заказ Игоря: начало плана штриховкой): штриховка плана в зазоре — тот же механизм, что у стрелки (элемент .break-arrow держит breakArrow_fix, живёт в кэше div0)
                            // IE 2026 09 30 / ODOO-343343 (заказ Игоря: штриховка начала плана — одним элементом): штриховка — ОДНА полоса на грид (planStart_band), не в каждой ячейке
                            wjcCore.addClass(e_cell, 'break-arrow-cell')   // точечную вертикаль под штриховкой не рисуем
                            const _ps = vueObj.planStartStat(); if (!_ps.colIds[col_binding]) { _ps.colIds[col_binding] = 1; _ps.cols = Object.keys(_ps.colIds).length }
                        } else if (e_cell.classList.contains('break-arrow-cell')) {
                            wjcCore.removeClass(e_cell, 'break-arrow-cell')
                        }
                    }
                    window.$cg.callEnd(); window.$cg.callSub('6');

                    if (vueObj.attr.childItemsPath) {
                        wjcCore.removeClass(e_cell, 'wj-group')
                        if (row.hasChildren) {
                            if (row.isCollapsed) {
                                // row.height = null
                                if (vueObj.attr.attr_type === 'AttrTabGrid' && col_binding === 'attr.valueStr') {
                                    let doc = vueObj.attrsTabGrid_to_JSON(dataItem[vueObj.attr.childItemsPath], 'valueStr', false)
                                    e_cell.innerHTML = vueObj.store.JS_stringifyHtml(doc)
                                }
                            } else if (vueObj.attr.attr_type !== 'AttrTabGrid') {
                                wjcCore.addClass(e_cell, `group-row-level-${row.level}`)
                                if (vueObj.plainLevel_row(row, dataItem)) wjcCore.addClass(e_cell, PLAIN_LEVEL_CLASS)   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p206 рядок Data Layout без оформлення рівня — білий фон у розкритого рядка об'єкта, опція): класс уходит и в снимок кэш-пути (_cache.className)
                                // row.height = 38
                            }
                            // условие «в списке»: в самой строке условия видно,
                            // сколько значений в отборе и первые из них — иначе она
                            // пуста, а значения читаются только прокруткой списка.
                            // IE 2026 09 17 / ODOO-… (замечание Игоря): только у СВЁРНУТОЙ строки —
                            // раскрытый список сам показывает значения дочерними строками, сводка
                            // над ним их дублировала; расчёт общий с кэш-путём — whereSummary_html
                            const _wsum = vueObj.whereSummary_html(row, dataItem, col_binding)
                            if (_wsum) {
                                e_cell.innerHTML = _wsum
                                wjcCore.addClass(e_cell, 'where-values-summary')
                            }
                        }
                        // if (irow+1 < rows.length && row.level > rows[irow+1].level) {
                        //     wjcCore.addClass(e_cell, `row-bottom-group`)
                        // }
                    }
                    window.$cg.callEnd(); window.$cg.callSub('7');

                    // row padding - collapse
                    e_style.borderLeft = `none`
                    if (vueObj.attr.childItemsPath && e_col === 0) {
                        // ячейка дерева: треугольник прижимаем влево независимо от
                        // выравнивания значений (числовая колонка = wj-align-right,
                        // и кнопка уезжала к правому краю — ИЕ 2026-08-11, Components)
                        wjcCore.addClass(e_cell, 'tree-cell')
                        // подпись группы (уровень + объект) — сразу за треугольником,
                        // а не у правого края объединённой ячейки (ИЕ 2026-08-12)
                        if (row.hasChildren) wjcCore.addClass(e_cell, 'tree-group-cell')
                        const hasChilds = vueObj.attr.childItemsPath && dataItem && (dataItem[vueObj.attr.childItemsPath]||[]).length
                        let paddingLeft = parseInt(e_style['padding-left'])

                        if (!hasChilds) {
                            if (vueObj.expandLinkFields_row(dataItem)) {
                                // lazy-раскрытие Link-поля (get_link_fields): кнопка — копия нативной
                                // пары «кнопка дерева + спейсер» (те же классы → те же отступы);
                                // скрытую нативную пару листа wijmo вставляет ПОСЛЕ formatItem —
                                // её прячет CSS по маркеру link-expand-cell, чтобы геометрия строки
                                // до и после загрузки детей совпадала (не моргало)
                                wjcCore.addClass(e_cell, 'link-expand-cell')
                                let btn = document.createElement('button')
                                btn.className = 'wj-btn wj-btn-glyph wj-elem-collapse link-expand'
                                btn.type = 'button'
                                btn.tabIndex = -1
                                btn.id = 'onExpandLinkFields__Click'
                                btn.innerHTML = dataItem._isv_link_loading
                                    ? `<span class="pi pi-spin pi-spinner" id="onExpandLinkFields__Click"></span>`
                                    : `<span class="wj-glyph-right" id="onExpandLinkFields__Click"></span>`
                                let space = document.createElement('span')
                                space.className = 'wj-elem-collapse-space link-expand-space'
                                e_cell.insertBefore(space, e_cell.firstChild)
                                e_cell.insertBefore(btn, space)
                            } else if (dataItem?.attr_type === 'AttrLink' && (dataItem.relation_segment || mtl_segments(dataItem, vueObj.store))) {   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди) · p048b: индикатор ссылочного поля и у составного типа
                                // индикатор ссылочного поля (все режимы) —
                                // контурный треугольник; декоративный
                                // (не раскрывает, без id-обработчика).
                                // В гридах expandLinkFields — ветка выше,
                                // кликабельная, не дублируется
                                wjcCore.addClass(e_cell, 'link-expand-cell')
                                let btn = document.createElement('button')
                                btn.className = 'wj-btn wj-btn-glyph wj-elem-collapse link-expand link-expand-static'
                                btn.type = 'button'
                                btn.tabIndex = -1
                                btn.innerHTML = `<span class="wj-glyph-right"></span>`
                                let space = document.createElement('span')
                                space.className = 'wj-elem-collapse-space link-expand-space'
                                e_cell.insertBefore(space, e_cell.firstChild)
                                e_cell.insertBefore(btn, space)
                            } else {
                                wjcCore.addClass(e_cell, 'hide-collapse')

                                let div1 = document.createElement('i')
                                div1.classList = [`pi pi-ellipsis-v pl-2 visibility-hidden`]
                                e_cell.insertBefore(div1, e_cell.firstChild)
                            }
                        }

                        paddingLeft = row.level * breakCollapseWidth
                        e_style['padding-left'] = `0px`
                        const left = parseFloat(e_style.left) || 0;
                        e_style.left = `${left + paddingLeft}px`

                        _cache.paddingLeft = paddingLeft
    
                        // delivery-left-0
                        if (paddingLeft) { // && vueObj.attr.frozenColumns
                            let div1 = document.createElement('div')
                            div1.className = `cell-delivery-left-0`
                            div1.style.left = `-${paddingLeft}px`
                            div1.style.width = `${paddingLeft}px`
                            elements_overflow.push(div1)
                        }
    
                        // const width = parseFloat(getComputedStyle(e_cell).width);
                        const width = parseFloat(e_style.width) || 0;
                        e_style.width = `${width - paddingLeft}px`;
                        // e_style.borderTopLeftRadius = '0.5rem';
                        // if (hasChilds && irow) e_style.borderBottomLeftRadius = '0.5rem';

                        if (vueObj.attr.childItemsPath) {
                            // IE 2026 08 20 / ODOO-5512 (заказ Игоря): tree_frame='L' —
                            // вместо пунктирных вертикалей Г-образная рамка группы
                            // подчинённых: сплошная вертикаль + скруглённый угол +
                            // горизонталь под последней строкой (как окантовка карточек)
                            // IE 2026 08 27 / ODOO-5800: useFrame — режим линий (см. начало closure);
                            // ствол рамки — по промеренному левому краю треугольника, пунктир — по прежней константе
                            const fg = useFrame ? vueObj.treeLines_frameGlyph() : null
                            const lineLeft = useFrame ? fg.x : breakPaddingLeft
                            if (row.level) {
                                const iNext = _cache.iNext
                                for (let ilevel = 0; ilevel < row.level; ilevel++) {
                                    const isLast = iNext === rows.length || rows[iNext].level === undefined || ilevel + 1 > rows[iNext].level
                                    
                                    if (!isLast) {
                                        // let div1 = document.createElement('i')
                                        // div1.classList = [`pi pi-ellipsis-v indent pl-0 pr-2`]
                                        // div0.append(div1)
                                    } else {
                                        // let div1 = document.createElement('i')
                                        // div1.classList = [`pi pi-ellipsis-v indent-last-v pl-0 pr-2`]
                                        // div0.append(div1)

                                        // div1 = document.createElement('i')
                                        // div1.classList = [`pi pi-ellipsis-h indent-last-h pl-0 pr-2`]
                                        // div0.append(div1)
                                    }

                                    const _lx = lineLeft + (ilevel - row.level) * breakCollapseWidth // IE 2026 08 27 / ODOO-5800
                                    let div1 = document.createElement('div')
                                    div1.style.top = `-${_cache.breakTop}px`;
                                    if (isLast) {
                                        div1.style.bottom = useFrame ? `6px` : `-2px`;
                                    }
                                    div1.style.left = `${_lx}px`;
                                    div1.className = useFrame ? 'cell-frame-left' : 'cell-divider-left'
                                    elements_overflow.push(div1)
                                    if (isLast && useFrame) {
                                        // скруглённый угол + горизонталь до края ячейки
                                        let dc = document.createElement('div')
                                        dc.style.left = `${_lx}px`
                                        dc.className = 'cell-frame-corner'
                                        elements_overflow.push(dc)
                                        let db = document.createElement('div')
                                        db.style.left = `${_lx + 7}px`
                                        db.className = 'cell-frame-bottom'
                                        elements_overflow.push(db)
                                    }
                                }
                            }

                            if (hasChilds && !row.isCollapsed) {
                                // let div1 = document.createElement('i')
                                // div1.classList = [`pi pi-ellipsis-v indent-collapse`]
                                // div0.append(div1)

                                if (useFrame) {
                                    // IE 2026 08 27 / ODOO-5800 (заказ Игоря): стык с треугольником —
                                    // дуга от нижнего края глифа (border-top-left-radius) переходит
                                    // в ствол, ствол идёт до низа строки (к линиям детей)
                                    const _pill = vueObj.groupPill_on()   // IE 2026 11 03 / ODOO-350449 (group row pill): ствол — от нижнего края треугольника, без дуги над глифом
                                    if (fg.r && !_pill) {
                                        let dc = document.createElement('div')
                                        dc.className = 'cell-frame-top-corner'
                                        dc.style.left = `${fg.x}px`
                                        dc.style.top = `${fg.y}px`
                                        dc.style.width = `${fg.r}px`
                                        dc.style.height = `${fg.r}px`
                                        dc.style.borderTopLeftRadius = `${fg.r}px`
                                        elements_overflow.push(dc)
                                    }
                                    let div1 = document.createElement('div')
                                    div1.className = 'cell-frame-left cell-frame-left-start'
                                    div1.style.left = `${fg.x}px`
                                    div1.style.top = `${_pill ? (fg.gb ?? fg.y + 3) : fg.y + fg.r}px`   // IE 2026 11 03 / ODOO-350449 (group row pill)
                                    elements_overflow.push(div1)
                                } else {
                                    let div1 = document.createElement('div')
                                    div1.style.left = `${breakPaddingLeft + (row.level - row.level) * breakCollapseWidth}px`;
                                    div1.className = 'cell-divider-left-0'
                                    elements_overflow.push(div1)
                                }
                            }

                            // borderBottom; у конца секции линию не рисуем — визуальную
                            // границу уже даёт пунктирная секционная линия ниже
                            e_style.borderBottom = `none`
                            if (!_cache.sectionEnd) {
                                let div1 = document.createElement('div')
                                div1.style.left = `${(row.level - row.level + 1) * breakCollapseWidth}px`;
                                div1.className = 'border-bottom'
                                elements_overflow.push(div1)
                            }
                        }
                    }
                    window.$cg.callEnd(); window.$cg.callSub('8');
                    
                    if (_cache.sectionEnd) {
                        // delivery-top (IE 2026 08 27 / ODOO-5800: в режиме рамки зазора и маски нет)
                        _cache.breakBottom = noGaps ? 0 : 10
                        if (_cache.breakBottom) {
                            let div1 = document.createElement('div')
                            div1.className = `cell-delivery-top`
                            div1.style.left = `-${_cache.paddingLeft||0}px`
                            div1.style.bottom = `-${_cache.breakBottom}px`
                            div1.style.height = `${_cache.breakBottom}px`
                            elements_overflow.push(div1)
                        }
                    }
                    window.$cg.callEnd(); window.$cg.callSub('9');

                    // need_overflow
                    if (elements_overflow.length) {
                        e_style.overflow = 'visible';
                        // перенос текста — ТОЛЬКО при включённой настройке поля
                        // wordWrap: раньше сам факт декоративных оверлеев (линии
                        // групп/разрывы секций) принудительно включал
                        // normal+break-all, и текст «переносился по умолчанию»
                        // в трети ячеек дерева. По умолчанию — обрезка (nowrap
                        // ячейки наследуется клипом ниже), правило 2026-07-28.
                        if (flex.columns[e_col]?.wordWrap) {
                            e_style.wordBreak = 'break-all';
                            e_style.whiteSpace = 'normal';
                            e_style.overflowWrap = 'break-word';
                            e_style.hyphens = 'auto';
                        }


                        // if (input) {
                        //     e_cell.insertBefore(div0, input)
                        // } else {
                        //     e_cell.insertBefore(div0, e_cell.firstChild)
                        // }

                        // if (!input) {
                        //     const span = document.createElement('span')
                        //     span.className = 'cell-text-wrapper'
                        //     while (e_cell.firstChild) {
                        //         span.appendChild(e_cell.firstChild)
                        //     }

                        //     e_cell.appendChild(span)
                        // }

                        // текст узкой колонки не выходит за рамки ячейки: клип во
                        // внутренний контейнер; линии групп (div0) — вне клипа
                        if (!e_cell.querySelector(':scope > .cell-text-clip')) {
                            const clip = document.createElement('div')
                            clip.className = 'cell-text-clip'
                            while (e_cell.firstChild) clip.appendChild(e_cell.firstChild)
                            e_cell.appendChild(clip)
                        }

                        let div0 = document.createElement('i')
                        for (let i=0; i<elements_overflow.length; i++) {
                            div0.appendChild(elements_overflow[i])
                        }
                        // const topCell = vueObj.isCellCoveredByClone(e_cell)
                        // if (topCell) {
                        //     topCell.appendChild(div0)
                        //     e.cell.style.backgroundColor = 'red';
                        // } else {
                            e_cell.appendChild(div0)
                            _cache.div0 = div0.cloneNode(true)
                            
                        //     e.cell.style.backgroundColor = 'lightgreen';
                        // }
                    }
                    if (_tlStats) { // IE 2026 08 27 / ODOO-5800: замер рядом с флагом
                        _tlStats.formatItem_break_ms += performance.now() - _tl0
                        _tlStats.formatItem_break_calls++
                    }
                    window.$cg.callEnd();
                }
                formatItem_cells_break()
                window.$cg.callEnd();
            }

            // IE 2026 11 02 / ODOO-349799 (group-levels) (заказ Игоря, скрин «Конфігурація» по чипу «Вид, Підсистема»): строки-группы wijmo (GroupRow сгруппированного
            // списка — не дерево childItemsPath, у него свои линии в ветке delivery выше) — класс по уровню (0 — темнее и жирнее, глубже — светлее; фон уровня
            // только без своей заливки: правило / именованный стиль / cell-background-* / hslGroup главнее — поэтому после formatItem_cells_CSS) и направляющие
            // слева по образцу дерева REPORT2: те же оверлеи cell-frame-left / cell-divider-left (режим treeLines_mode) в колонке дерева у групп 1-го уровня
            // и глубже и у листовых строк под ними. Стоит ПОСЛЕ AttrMulti (та ветка переписывает innerHTML) и ПОСЛЕ ветки delivery: use_delivery у любого грида true по умолчанию
            // (`this.attr.use_delivery ?? true`), поэтому не условие, а порядок — ветка delivery кладёт свой оверлей в _cache.div0, направляющие групп — в _cache.grpGuides;
            // ниже только превью оформления и снимок className в кэш (классы уровня попадают в него). Выключатель fe.ux.gridGroupLevels (дефолт ВКЛ)
            if (!vueObj.attr.childItemsPath && !isPrint && rows.maxGroupLevel > -1 && vueObj.groupLevels_on()) {   // IE 2026 11 02 / ODOO-349799 (group-levels): без !use_delivery — он true у всех гридов
                vueObj.groupLevels_cellApply(e_cell, e_style, row, irow, e_col, rows, _cache, isXlsxExport)
            }

            // ячейка-превью оформления: образец поверх штатного рендера
            vueObj.formatPreview_cellApply(e_cell, e_style, dataItem, attr_col, col_binding)

            _cache.className = e_cell.className
            _cache.cssText = vueObj.cacheInlineStylesExcept(e_cell);
        },
        
        // AttrLinkChips: отрисовка статуса скруглённой пилюлей (Odoo-стиль).
        // Вызывается и в formatItem_cells (первый рендер), и на кеш-пути
        // formatItem (где formatItem_cells пропущен) — чипс это DOM, а не className,
        // поэтому его нужно переприменять вручную, иначе теряется после прокрутки.
        // IE 2026 08 26 / ODOO-5800 (заказ Игоря): форма записи (AttrTabGrid) — статус-ПОЛЕ строки
        // (dataItem.attr с relation_segment STATUS*) рисуется той же пилюлей в колонке значения;
        // значение берём из самого поля (valueOverride), не из dataItem по биндингу колонки
        // IE 2026 09 18 / ODOO-5800 (Igor: «сделай Grade везде как статусы документов — в виде цветных бейджей»): справочники, чьи значения
        // рисуются пилюлей с цветом элемента (doc.cssClass записи справочника): статусы STATUS* и оценки GRADE. Цвета оценок — в записях
        // GRADE (config_metric.py). Выключатель fe.ux.gradeChip (дефолт ВКЛ) — оценка снова обычной ссылкой
        isChipSegment(rs) {
            const t = String(rs || '')
            if (t.startsWith('STATUS')) return true
            return t === 'GRADE' && this.store.setting('fe.ux.gradeChip', true) !== false
        },
        tabGridStatusAttr(dataItem, col_binding) {
            if (this.attr?.attr_type !== 'AttrTabGrid' || col_binding !== 'attr.valueStr') return null
            const f = dataItem?.attr
            if (!f || !(f.attr_type === 'AttrLinkChips' || f.attr_type === 'AttrLink')) return null
            if (!this.isChipSegment(f.relation_segment)) return null   // IE 2026 09 18 / ODOO-5800: + GRADE
            return f
        },
        applyStatusChip(e_cell, attr_col, dataItem, valueOverride) {
            const vueObj = this
            // чипс рисуем для ЛЮБОЙ статус-колонки (relation_segment STATUS*): и
            // AttrLinkChips (предопределённые поля), и обычных AttrLink-статусов,
            // определённых в самой базе (напр. TXN Status). Определяющий признак —
            // сегмент STATUS*, а не attr_type.
            if (!e_cell || !attr_col) return
            if (!(attr_col.attr_type === 'AttrLinkChips' || attr_col.attr_type === 'AttrLink')) return
            if (!vueObj.isChipSegment(attr_col.relation_segment)) return   // IE 2026 09 18 / ODOO-5800: + GRADE
            if (e_cell.querySelector('input')) return // идёт редактирование — не трогаем
            // IE 2026 09 22 / ODOO-5800 (замечание Игоря «Stock state»): кэш-путь — ячейка оценки с заливкой правила (класс grade-plain из
            // полного рендера, см. gradeChip_flatten): пилюли нет, значение — текст dataMap
            if (e_cell.classList.contains('grade-plain') && vueObj.gradeChip_plainOnFill(attr_col)) {
                e_cell.querySelector('.status-chip')?.remove()
                wjcCore.removeClass(e_cell, 'has-status-chip')
                return
            }
            // старый чипс и заливку всей ячейки снимаем (цвет несёт сам чипс;
            // заливку мог навесить cssClass-status из log.py)
            e_cell.querySelector('.status-chip')?.remove()
            for (const c of [...e_cell.classList]) if (c.startsWith('cell-background')) e_cell.classList.remove(c)
            // IE 2026 10 07 / ODOO-5800 (заказ Игоря: «Hidden» поля строки DL2 гасит ячейку своего уровня): у погашенной ячейки (_DLRow.cells[binding].blank) значения нет — пилюли тоже
            // (значение остаётся в dataItem — условное оформление и drill-down читают его); старая пилюля и её класс снимаются ветками ниже, как у ячейки без значения
            const valueS = valueOverride !== undefined ? valueOverride
                : ((dataItem && !vueObj.cellBlank(dataItem, attr_col.binding)) ? vueObj.store.get_value(dataItem, attr_col.binding) : null)
            // IE 2026 08 26 / ODOO-5800: в форме записи ссылка-стрелка «→» перед статусом не нужна — пилюля сама значение
            if (valueOverride !== undefined) for (const i of [...e_cell.querySelectorAll('i.pi, .cell-link')]) i.remove()
            if (valueS == null || valueS === '') {
                wjcCore.removeClass(e_cell, 'has-status-chip')
                return
            }
            // статусов немного — полный список со стилями (fetchMode:'all')
            const itemsSourceS = vueObj.store.get_itemsSource(vueObj, {}, attr_col, { fetchMode: 'all' })
            const itemS = itemsSourceS?.ids?.[valueS]
            const cssClassS = itemS?.cssClass
            for (const n of [...e_cell.childNodes]) if (n.nodeType === 3) n.remove() // текст dataMap
            const chip = document.createElement('span')
            chip.className = 'status-chip' + (cssClassS ? ' ' + cssClassS : '')
            chip.textContent = itemS?.title ?? String(valueS)
            // IE 2026 09 18 / ODOO-5800 (Igor: «Grade везде как статусы документов»): в ячейке ДЕРЕВА пилюля встаёт ПОСЛЕ значка свёртки
            // (у листа — после его невидимого спейсера), иначе стрелка уезжала за пилюлю и отступ уровня терялся
            const treeAnchor = e_cell.querySelector(':scope > .wj-elem-collapse-space, :scope > .cell-text-clip > .wj-elem-collapse-space')
                || e_cell.querySelector(':scope > .wj-elem-collapse, :scope > .cell-text-clip > .wj-elem-collapse')
            if (treeAnchor) treeAnchor.after(chip)
            else e_cell.insertBefore(chip, e_cell.firstChild)
            wjcCore.addClass(e_cell, 'has-status-chip')
        },
        // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N): заливка ячеек условного оформления с учётом соседей (настройка fe.ux.cellFillRound,
        // режимы и формы — utils/cellFillRound.js). Соседи (слева / справа / сверху / снизу / по диагонали) берутся по ДАННЫМ — те же каналы оформления, что
        // красит formatItem (styleKeys_row + styleKeys_cellOwn: _DLRow, правила отчёта / строки / поля, cssClass-<binding>, MD), а не по DOM: соседняя
        // ячейка может быть ещё не отрисована или за краем окна. Цвет ключа правила измеряется один раз (getComputedStyle своей ячейки) на тему / схему.
        // Состояние одного прохода отрисовки: режим, кеш соседей; конец прохода — microtask (измерен новый цвет, соседи рисовались без него — одна перерисовка)
        cfr_tick(flex) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)
            let T = this._cfrT
            if (T) return T
            const mode = cellFill_mode((k, d) => this.store.setting(k, d))   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)
            const halo = cellFill_haloOn((k, d) => this.store.setting(k, d))   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: ореол вокруг сигнальных меток в цветной ячейке)
            T = this._cfrT = { mode, halo, info: new Map(), rowK: new Map(), learned: 0, unknown: 0, flex }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)
            if (mode !== 'off' || halo) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: ореол вокруг сигнальных меток в цветной ячейке): ореол меток — и в режиме off   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)
                this._cfrEver = true
                const body = document.body ? (document.body.className.match(/cscheme-[\w-]+/g) || []).join(' ') : ''
                const theme = ((this.$appState && this.$appState.darkTheme) ? 'd' : 'l') + '|' + body
                if (!this._cfrC || this._cfrC.theme !== theme) this._cfrC = { theme, colors: new Map(), base: '', line: '' }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N): цвета ключей — на тему / схему
                if (!this._cfrC.base) this.cfr_probeBase(flex)
                if (mode !== 'off' && !window.__cellFillStats) window.__cellFillStats = { cells: 0, ms: 0, paintCells: 0, paintMs: 0, learned: 0, repaints: 0, hit: 0, miss: 0 }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)
            }
            queueMicrotask(() => {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)
                const t = this._cfrT
                this._cfrT = null
                if (!t || (t.mode === 'off' && !t.halo)) return
                if (t.learned && t.unknown && (this._cfrRep = (this._cfrRep || 0) + 1) <= 3) {
                    if (window.__cellFillStats) window.__cellFillStats.repaints++
                    requestAnimationFrame(() => { try { const f = this.flex || t.flex; if (f) f.invalidate() } catch (e) { /* грид пересоздан */ } })
                } else if (!t.learned) this._cfrRep = 0
            })
            return T
        },
        // фон пустой ячейки и цвет линии сетки текущей темы — пробная ячейка в панели данных (непрозрачный: прозрачная — фон ближайшего непрозрачного предка)
        cfr_probeBase(flex) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)
            try {
                const host = (flex && flex.cells && flex.cells.hostElement) || (flex && flex.hostElement)
                if (!host) return
                const el = document.createElement('div')
                el.className = 'wj-cell'
                el.style.cssText = 'position:absolute;left:-10000px;top:-10000px;width:40px;height:16px;pointer-events:none;visibility:hidden'
                host.appendChild(el)
                const cs = getComputedStyle(el)
                let base = cs.backgroundColor
                const line = cs.borderBottomColor
                el.remove()
                for (let p = host, k = 0; p && k < 8 && !cellFill_isFill(base, 'rgba(0, 0, 0, 0)'); p = p.parentElement, k++) base = getComputedStyle(p).backgroundColor
                if (!cellFill_isFill(base, 'rgba(0, 0, 0, 0)')) base = (this.$appState && this.$appState.darkTheme) ? 'rgb(30, 30, 30)' : 'rgb(255, 255, 255)'
                this._cfrC.base = base
                this._cfrC.line = line || base
            } catch (e) { /* без пробы — режим не рисует */ }
        },
        // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р4): оттенок тепловой заливки ячейки (hslGroup колонки; AttrTabGrid — группа на СТРОКЕ, значение из записи) — общий расчёт
        // formatItem_cells и соседей слоя cfr_info. undefined — ячейка не тепловая, null — без оттенка, иначе 'hsl(…)'
        heat_cellBg(dataItem, col_binding, attr_col, value, level) {   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р4)
            let hsl_attr = attr_col
            let hsl_value = value
            // АН 2026 08 09: hslGroup в AttrTabGrid — группа задана на СТРОКЕ (поле записи), красим только ячейку значения; значение берём из записи
            // (в attr.valueStr может лежать форматированный текст типа '19sec')
            if (this.attr.attr_type === 'AttrTabGrid' && dataItem?.attr?.hslGroup && col_binding === 'attr.valueStr') {
                hsl_attr = dataItem.attr
                const _raw = Number(this.store.get_value(this.WIDGET.record, dataItem.attr.binding))
                hsl_value = isNaN(_raw) ? null : _raw
            }
            if (!(hsl_attr?.hslGroup && this.hslGroups?.[hsl_attr.hslGroup] && hsl_value)) return undefined
            const grpAll = this.hslGroups[hsl_attr.hslGroup] || {}
            // IE 2026 08 30 / ODOO-5800 (заказ Игоря): нормировка по шкале СВОЕГО уровня дерева; общая статистика — фолбэк (плоский грид, AttrTabGrid-строки)
            const grp = (grpAll.byLevel && grpAll.byLevel[level]) || grpAll
            return cellFill_heatHsl(grp, hsl_value)
        },
        // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р4): снимает ли оформление тепловую заливку (как formatItem: именованный стиль реестра с фоном — ruleFill_overHeat, критическая метрика) — по ключам
        heat_ruleOver(keys) {   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р4)
            if (keys.includes(METRIC_CRIT_CLASS)) return true
            if (this._ruleFillOn === undefined) this._ruleFillOn = this.store.setting('fe.ux.gridRuleFillOverHeat', true) !== false
            if (!this._ruleFillOn) return false
            const byName = this.store.cssClassesByName
            return !!byName && keys.some(k => !k.startsWith('inline:') && this.styleName_hasFill(k, byName))
        },
        // сосед (строка r, колонка c) по данным: null — граница (нет ячейки, скрытая колонка, строка-раздел / полоса, строка шапки)
        // или { k: ключ правил оформления, c: цвет (строка / null — без заливки / undefined — не измерен) }.
        // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р4): прежде границей были и колонки НЕ данных (cf_isDataCol = false: атрибуты строки отчёта — doc.minDOS 17D_001,
        // все колонки списка без cf_rules.fields) и тепловая hslGroup / весь грид use_hslGroup — слой там не рисовался (.cfr = 0). Теперь: колонка не
        // данных — ключ с привязкой колонки (cellFill_cellKey: цвет замеряется отдельно, CSS колонки под тем же классом не путается с колонкой данных);
        // тепловая и цвет уровня группы — цвет по данным (heat_cellBg / cellFill_groupHsl), без замера; именованный стиль правила с фоном и
        // критическая метрика снимают тепловую (как formatItem — heat_ruleOver) — тогда цвет ключа правил
        cfr_info(T, flex, r, c) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)
            const key = r * 65536 + c
            if (T.info.has(key)) return T.info.get(key)
            let v = null
            try {
                const row = flex.rows[r], col = flex.columns[c]
                const di = row && row.dataItem
                const attr_col = col && col.binding ? this.attr_by_binding[col.binding] : null
                if (di && attr_col && col.isVisible !== false && r >= (this.headerRows || 0)) {   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р4): − cf_isDataCol, − hslGroup
                    const dl = di._DLRow
                    if (!(dl && (dl.row_type === 'tab' || dl.row_type === 'tabrow'))) {
                        let rk = T.rowK.get(di)
                        if (!rk) { rk = this.styleKeys_row(di); T.rowK.set(di, rk) }
                        const keys = rk.all.slice()
                        if (rk.vo.length && this.cf_valuesOnlyAllowed(attr_col, this.foldAgg_getValue(di, attr_col.binding, attr_col))) keys.push(...rk.vo)
                        for (const k of this.styleKeys_cellOwn(di, col.binding, attr_col)) if (!keys.includes(k)) keys.push(k)
                        if (!keys.some(k => /^band-/.test(k) || (/^inline:/.test(k) && /gradient|background-image/.test(k)))) {
                            let fill = null   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р4): заливка по данным (тепловая / уровень группы)
                            if (this.attr.use_hslGroup && row instanceof wjGrid.GroupRow && di.level >= 0) {   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р4): строка-группа use_hslGroup — inline цвет уровня; inline-фон правила (cssText позже) главнее
                                if (!keys.some(k => /^inline:/.test(k) && /background/.test(k))) fill = cellFill_dataFill(cellFill_groupHsl(di.level), 'grp')
                            } else if (attr_col.hslGroup || (this.attr.attr_type === 'AttrTabGrid' && di.attr && di.attr.hslGroup)) {   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р4): тепловая — то же значение, что берёт formatItem_cells
                                let val = this.cellBlank(di, col.binding) ? null : this.foldAgg_getValue(di, attr_col.binding, attr_col)
                                if (this.transpose_measure(attr_col, di)) { const ct = this.transpose_cellObject(val); if (ct) val = ct.value }
                                const hb = this.heat_cellBg(di, col.binding, attr_col, val, row.level ?? -1)
                                if (hb && !this.heat_ruleOver(keys)) fill = cellFill_dataFill(hb)
                            }
                            if (fill) v = fill
                            else {
                                const k = cellFill_cellKey(keys, this.cf_isDataCol(attr_col), col.binding)   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р4): колонка не данных — ключ с привязкой колонки
                                v = { k, c: k ? this._cfrC.colors.get(k) : null }
                            }
                        }
                    }
                }
            } catch (e) { v = null }
            T.info.set(key, v)
            return v
        },
        // слои фона ячейки по соседям (вызов — конец formatItem ячейки данных, оба пути); режим off — снять прежние слои, если грид их рисовал
        cfr_paint(flex, e_cell, e_row, e_col) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)
            const T = this.cfr_tick(flex)
            const mark = T.halo ? e_cell.__cfrMark : null   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: ореол вокруг сигнальных меток в цветной ячейке): метка ячейки (cellView_apply / cellBars_put) — без чтения раскладки
            if (T.mode === 'off' && !mark) { if (this._cfrEver) this.cfr_set(e_cell, null, false); return }
            const S = window.__cellFillStats, t0 = performance.now()
            const C = this._cfrC
            let L = null, filled = false
            const row = flex.rows[e_row], col = flex.columns[e_col]
            const self = (C && C.base && row && col && !this.attr.isPrint && !e_cell.style.backgroundImage) ? this.cfr_info(T, flex, e_row, e_col) : null   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р4): − use_hslGroup (цвет уровня группы — по данным, cfr_info)
            if (self) {
                if (self.k && self.c === undefined) {   // цвет своей заливки — один раз на ключ и тему; тон выделения / наведения — не заливка: их классы снимаются на замер
                    const state = [...e_cell.classList].filter(k => /^wj-state-|^wj-row-hover$|^style-filter-dim$/.test(k))
                    state.forEach(k => e_cell.classList.remove(k))
                    const bg = getComputedStyle(e_cell).backgroundColor
                    let own = cellFill_isFill(bg, C.base)
                    // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р4): колонка не данных (ключ §col:) — свой фон колонки (CSS заголовка строки и т. п.) не заливка правила: сверка с той же
                    // ячейкой без классов правил; inline-фон правила — заливка без сверки
                    if (own && self.k.includes('§col:') && !/(^|\|)inline:[^|]*background/.test(self.k)) {
                        const rc = self.k.split('§col:')[0].split('|').filter(k => k && !k.startsWith('inline:') && e_cell.classList.contains(k))
                        rc.forEach(k => e_cell.classList.remove(k))
                        const bg0 = getComputedStyle(e_cell).backgroundColor
                        rc.forEach(k => e_cell.classList.add(k))
                        if (bg0 === bg) own = false
                    }
                    state.forEach(k => e_cell.classList.add(k))
                    self.c = own ? bg : null
                    C.colors.set(self.k, self.c)
                    T.learned++
                    if (S) S.learned++
                }
                const fr = flex.frozenColumns || 0, frr = flex.frozenRows || 0
                // IE 2026 11 03 / ODOO-350449 (проба p252: фон ячеек — слои поверх cell-lt/cell-rc, соседи через скрытые колонки): сосед — ближайшая ВИДИМАЯ колонка (скрытые .offset между месяцами и нулевой ширины пропускаются);
                // граница заморозки и разрыв колонок (break-зазор, breakOf) рвут пробег
                const colN = (d) => cellFill_colNeighbor(flex.columns, e_col, d, fr, (cc) => this.breakOf(cc && cc.binding ? this.attr_by_binding[cc.binding] : null))   // IE 2026 11 03 / ODOO-350449 (проба p252: фон ячеек — слои поверх cell-lt/cell-rc, соседи через скрытые колонки)
                const rowN = (d) => { if (frr > 0 && ((d < 0 && e_row === frr) || (d > 0 && e_row === frr - 1))) return -1; return cellFill_rowNeighbor(flex.rows, e_row, d) }
                const at = (r, c) => (r >= 0 && c >= 0 ? this.cfr_info(T, flex, r, c) : null)
                const cl = colN(-1), cr = colN(1)
                const nb = T.mode === 'off' ? { self } : { self, l: at(e_row, cl), r: at(e_row, cr) }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: ореол вокруг сигнальных меток в цветной ячейке)
                if (T.mode === 'tiles' || T.mode === 'areas') {
                    const ru = rowN(-1), rd = rowN(1)
                    nb.t = at(ru, e_col); nb.b = at(rd, e_col)
                    if (T.mode === 'areas' && !cellFill_filled(self)) { nb.tl = at(ru, cl); nb.tr = at(ru, cr); nb.bl = at(rd, cl); nb.br = at(rd, cr) }
                }
                for (const k in nb) { const n = nb[k]; if (n && n.k && n.c === undefined) T.unknown++ }   // сосед не измерен — форма по ключу; после замера — перерисовка
                let sh = T.mode === 'off' ? null : cellFill_shape(T.mode, nb)   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: ореол вокруг сигнальных меток в цветной ячейке)
                if (sh && sh.unknown) T.unknown++
                // IE 2026 11 03 / ODOO-350449 (проба p252: фон ячеек — слои поверх cell-lt/cell-rc, соседи через скрытые колонки): размер — по inline-стилю самой ячейки: break-зазор (начало плана, «855») сдвигает left и сужает width ячейки на break_width,
                // а слои по col.renderWidth уезжали за правый край — правый конец пробега оставался прямоугольным
                const H = parseFloat(e_cell.style.height) || (row.renderHeight > 0 ? row.renderHeight : flex.rows.defaultSize) || 0, W = parseFloat(e_cell.style.width) || col.renderWidth || col.width || 0   // IE 2026 11 03 / ODOO-350449 (проба p252: фон ячеек — слои поверх cell-lt/cell-rc, соседи через скрытые колонки)
                const mg = mark && cellFill_filled(self) && typeof self.c === 'string' ? cellFill_markGeom(mark, W, H) : null   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: ореол вокруг сигнальных меток в цветной ячейке): ореол — только на цветной заливке
                if (mg && (!sh || (sh.m === 'areas' && !sh.f))) sh = { m: 'plain' }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: ореол вокруг сигнальных меток в цветной ячейке)
                L = sh && !sh.empty ? cellFill_layersCached(sh, W, H, C.base, C.line, S, mg) : null   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: ореол вокруг сигнальных меток в цветной ячейке)
                filled = !!L && sh.m !== 'plain' && !(sh.m === 'areas' && !sh.f)   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: ореол вокруг сигнальных меток в цветной ячейке)
            }
            this.cfr_set(e_cell, L, filled)
            if (S) { S.paintCells++; S.paintMs += performance.now() - t0 }
        },
        // класс cfr — слои из свойств --cfr-img / -size / -pos (CSS ниже), cfr-f — залитая ячейка: рамка прозрачна (линию сетки рисует слой); сверка по inline-стилю
        cfr_set(el, L, filled) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)
            const on = !!L, f = on && !!filled
            if (el.classList.contains('cfr') !== on) el.classList.toggle('cfr', on)
            if (el.classList.contains('cfr-f') !== f) el.classList.toggle('cfr-f', f)
            const img = L ? L.img : ''
            if (el.style.getPropertyValue('--cfr-img') === img) return
            if (L) { el.style.setProperty('--cfr-img', L.img); el.style.setProperty('--cfr-size', L.size); el.style.setProperty('--cfr-pos', L.pos) } else { el.style.removeProperty('--cfr-img'); el.style.removeProperty('--cfr-size'); el.style.removeProperty('--cfr-pos') }
        },
        // IE 2026 11 03 / ODOO-350449 (заказ Игоря: мягкие разделители разделов и монохром — опции): строки-разделы (полосы лэйаута) по настройке fe.ux.sectionStyle —
        // слои background-image ячеек (utils/sectionStyle.js), без DOM. Вызов — конец formatItem ячейки панели данных, оба пути (после снимка className — в кеш не попадает).
        // Состояние прохода: режим, токены, ширины закреплённой части / строки, вид разделов; конец прохода — microtask
        sec_tick(flex) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: мягкие разделители разделов и монохром — опции)
            let T = this._secT
            if (T && T.flex === flex) return T
            const mode = secStyle_mode((k, d) => this.store.setting(k, d))
            const mono = mono_on((k, d) => this.store.setting(k, d))   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: мягкие разделители разделов и монохром — опции)
            T = this._secT = { flex, mode, mono, kind: new Map(), sec: new Map() }
            const host = flex.hostElement   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: мягкие разделители разделов и монохром — опции): монохром — флаг-класс хоста грида (CSS под :where(.ux-mono))
            if (host && host.classList.contains('ux-mono') !== mono) host.classList.toggle('ux-mono', mono)
            if (mono) this._secEver = true   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: мягкие разделители разделов и монохром — опции)
            if (mode !== 'now') {
                this._secEver = true
                const cols = flex.columns, fz = flex.frozenColumns || 0
                let fw = 0
                for (let c = 0; c < fz; c++) fw += cols[c].isVisible === false ? 0 : (cols[c].renderWidth || 0)
                T.fw = fw
                T.rw = Math.max(fw + 1, cols.getTotalSize ? cols.getTotalSize() : fw)
                const tok = { ...SEC_TOKENS }
                try {
                    const cs = getComputedStyle(document.documentElement)
                    for (const k of Object.keys(tok)) { const v = cs.getPropertyValue(`--sec-${k}`).trim(); if (v) tok[k] = v }
                } catch (e) { /* без токенов CSS — значения по умолчанию */ }
                tok.sig = Object.values(tok).join(',')
                T.tok = tok
            }
            queueMicrotask(() => { if (this._secT === T) this._secT = null })
            return T
        },
        // вид раздела строки r (null — не раздел); «Непокрито» — по строкам блока (uncBlock_titleIs), не по подписи
        sec_kindAt(T, rows, r) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: мягкие разделители разделов и монохром — опции)
            if (T.kind.has(r)) return T.kind.get(r)
            const di = rows[r]?.dataItem
            let k = null
            if (di && sec_rowIs(di)) k = sec_kind(di, uncBlock_titleIs((j) => rows[j]?.dataItem || null, r))
            T.kind.set(r, k)
            return k
        },
        // раздел строки r для рейки S6: { k, pos: node | mid | end } или null — строка вне раздела (выше уровнем / до первого раздела)
        sec_railAt(T, rows, r) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: мягкие разделители разделов и монохром — опции)
            if (T.sec.has(r)) return T.sec.get(r)
            let v = null
            const k0 = this.sec_kindAt(T, rows, r)
            if (k0) v = { k: k0, pos: 'node' }
            else {
                const lv = rows[r]?.level || 0
                for (let j = r - 1; j >= 0 && j >= r - 400; j--) {
                    const row = rows[j]
                    if (!row || row.visibleIndex === -1) continue
                    if ((row.level || 0) < lv) break
                    const k = this.sec_kindAt(T, rows, j)
                    if (k) {
                        const n = cellFill_rowNeighbor(rows, r, 1)
                        const last = n < 0 || !rows[n] || (rows[n].level || 0) < lv || !!this.sec_kindAt(T, rows, n)
                        v = { k, pos: last ? 'end' : 'mid' }
                        break
                    }
                }
            }
            T.sec.set(r, v)
            return v
        },
        sec_paint(flex, e, e_cell, e_row, e_col) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: мягкие разделители разделов и монохром — опции)
            const T = this.sec_tick(flex)
            const rows = flex.rows, row = rows[e_row]
            if (T.mode === 'now') {
                const pm = T.mono && row ? mono_textClasses(true, this.sec_kindAt(T, rows, e_row)) : []   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: мягкие разделители разделов и монохром — опции): монохром — «+» / «−» нейтральные
                if (pm.length || this._secEver) this.sec_set(e_cell, null, pm)
                return
            }
            const c0 = e.range ? e.range.col : e_col
            const col = flex.columns[c0]
            const kind = row ? this.sec_kindAt(T, rows, e_row) : null
            const rail = T.mode === 'rail' && c0 === 0 && row ? this.sec_railAt(T, rows, e_row) : null
            if (!col || (!kind && !rail)) { if (this._secEver) this.sec_set(e_cell, null, null); return }
            const H = (row.renderHeight > 0 ? row.renderHeight : rows.defaultSize) || 0
            const fz = flex.frozenColumns || 0
            const colLeft = Number.isFinite(col.pos) ? col.pos : 0
            let cellX = colLeft
            if (fz && c0 < fz) { const vl = parseFloat(e_cell.style.left || '') + (flex.scrollPosition?.x || 0); if (Number.isFinite(vl)) cellX = Math.max(colLeft, vl) }
            let W = parseFloat(e_cell.style.width || '')
            if (!(W > 0)) W = col.renderWidth || 0
            const tok = T.tok
            let lbl = null
            if (kind) {
                const memo = (this._secLbl && this._secLbl.src === this.data) ? this._secLbl : (this._secLbl = { src: this.data, m: new WeakMap() })
                lbl = memo.m.get(row.dataItem)
                const inFz = !fz || c0 < fz
                if (inFz && (e_cell.textContent || '').trim()) {
                    if (!lbl) lbl = sec_labelGuess(e_cell.textContent, cellX)
                    this.sec_measureQueue(flex, e_cell, row.dataItem, cellX)
                }
                if (!lbl) lbl = sec_labelGuess('', 0)
            }
            const fw = T.fw || (cellX + W)
            const g = kind ? { H, fw, rw: T.rw, lx: lbl.x, lw: lbl.w, ly: lbl.y, lh: lbl.h, lr: fw } : null
            const rc = rail ? (rail.k === 'unc' ? tok.attn : tok.sep2) : ''
            const key = `${T.mode}|${kind || ''}|${rail ? rail.pos + rail.k : ''}|${H}|${Math.round(fw)}|${Math.round(T.rw)}|${g ? [g.lx, g.lw, g.ly, g.lh].map(v => v == null ? '' : Math.round(v)).join(',') : ''}|${tok.sig}`
            const CL = sec_cellLayersCached(key, () => {
                const L = rail ? sec_railLayers(rail.pos, H, rc).map(([i, x, y, w, h]) => [i, x + cellX, y, w, h]) : []
                return kind ? L.concat(sec_rowLayers(T.mode, kind, g, tok) || []) : L
            }, cellX, W)
            this.sec_set(e_cell, sec_cellOrClear(CL, kind), kind ? sec_textClasses(T.mode, kind) : [])   // IE 2026 11 03 / ODOO-350449 (проба p254: S2 — цвет только «Непокрито», прокручиваемая часть, Esc фокуса не закрывает виджет): ячейка раздела без слоёв (прокручиваемая часть) — sec-on с пустым слоем, старая полоса снимается
        },
        // подпись раздела: x / ширина / вертикаль текста — замер после кадра (Range по первому текстовому узлу); изменилась — одна перерисовка (не больше 3 подряд)
        sec_measureQueue(flex, el, di, cellX) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: мягкие разделители разделов и монохром — опции)
            const q = this._secMq || (this._secMq = [])
            if (q.length > 64) return
            el.__secX = cellX
            q.push([el, di])
            if (q.length > 1) return
            requestAnimationFrame(() => {
                const list = this._secMq || []
                this._secMq = []
                const memo = this._secLbl
                if (!memo) return
                let changed = false
                for (const [cell, item] of list) {
                    try {
                        if (!cell.isConnected) continue
                        const w = document.createTreeWalker(cell, NodeFilter.SHOW_TEXT, { acceptNode: (n) => (n.nodeValue && n.nodeValue.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP) })
                        const tn = w.nextNode()
                        if (!tn) continue
                        const rg = document.createRange()
                        rg.selectNodeContents(tn)
                        const r = rg.getBoundingClientRect(), cr = cell.getBoundingClientRect()
                        if (!(r.width > 0)) continue
                        const v = { x: (cell.__secX || 0) + (r.left - cr.left), w: r.width, y: r.top - cr.top, h: r.height }
                        const o = memo.m.get(item)
                        if (!o || o.guess || Math.abs(o.x - v.x) > 1 || Math.abs(o.w - v.w) > 1 || Math.abs((o.y || 0) - v.y) > 1) { memo.m.set(item, v); changed = true }
                    } catch (e) { /* ячейка пересоздана */ }
                }
                if (changed && (this._secRep = (this._secRep || 0) + 1) <= 3) { try { (this.flex || flex).invalidate() } catch (e) { /* грид пересоздан */ } }
                else if (!changed) this._secRep = 0
            })
        },
        // класс sec-on — слои из --sec-img / -size / -pos (CSS ниже); классы подписи sec-t-<режим>, sec-k-unc, sec-k-sign; сверка по inline-стилю
        sec_set(el, CL, cls) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: мягкие разделители разделов и монохром — опции)
            const want = new Set(cls || [])
            if (CL) want.add('sec-on')
            for (const c of SEC_CLASS_ALL) { const h = want.has(c); if (el.classList.contains(c) !== h) el.classList.toggle(c, h) }
            const img = CL ? CL.img : ''
            if (el.style.getPropertyValue('--sec-img') === img) return
            if (CL) { el.style.setProperty('--sec-img', CL.img); el.style.setProperty('--sec-size', CL.size); el.style.setProperty('--sec-pos', CL.pos) } else { el.style.removeProperty('--sec-img'); el.style.removeProperty('--sec-size'); el.style.removeProperty('--sec-pos') }
        },
        // вкладка Display шлёт window-событие fe-display-option { key, value }: свои ключи — перерисовка грида
        sec_onDisplayOption(ev) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: мягкие разделители разделов и монохром — опции)
            const key = ev?.detail?.key
            if (!SEC_KEYS.includes(key) || !this.flex) return
            this._secT = null
            this._secRep = 0
            this._cfrC = null   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: мягкие разделители разделов и монохром — опции): монохром меняет заливки — цвета ключей фона с учётом соседей заново
            try { this.flex.invalidate() } catch (e) { /* грид пересоздан */ }
        },
        cacheInlineStylesExcept(e_cell, exclude = ['left', 'width', 'top', 'height']) {
            if (!e_cell || !e_cell.style) return '';
            const excludeSet = new Set(exclude);

            const cssParts = [];
            for (let i = 0; i < e_cell.style.length; i++) {
                const prop = e_cell.style[i];
                if (excludeSet.has(prop)) continue;

                const val = e_cell.style.getPropertyValue(prop);
                const priority = e_cell.style.getPropertyPriority(prop);
                cssParts.push(`${prop}: ${val}${priority ? ' !important' : ''};`);
            }

            return cssParts.join(' ');
        },
        applyCssText(e_style, cssText) {
            if (!e_style || !cssText) return;
            const _fF = this._fmtF
            if (_fF && _fF.on) {   // IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL5: разбор снимка cssText — один раз (модульный кэш), запись только отличающихся свойств
                let list = _fmtCssMemo.get(cssText)
                if (list) _fF.c.cssHit++
                else {
                    const tmp = document.createElement('div')
                    tmp.style.cssText = cssText
                    list = []
                    for (let i = 0; i < tmp.style.length; i++) {
                        const prop = tmp.style[i]
                        list.push([prop, tmp.style.getPropertyValue(prop), tmp.style.getPropertyPriority(prop)])
                    }
                    if (_fmtCssMemo.size > 5000) _fmtCssMemo.clear()
                    _fmtCssMemo.set(cssText, list)
                }
                for (let i = 0; i < list.length; i++) {
                    const [prop, val, pr] = list[i]
                    if (e_style.getPropertyValue(prop) !== val || e_style.getPropertyPriority(prop) !== pr) e_style.setProperty(prop, val, pr)
                }
                return
            }
            const tmp = document.createElement('div');
            tmp.style.cssText = cssText;

            for (let i = 0; i < tmp.style.length; i++) {
                const prop = tmp.style[i];
                const val = tmp.style.getPropertyValue(prop);
                const pr  = tmp.style.getPropertyPriority(prop);
                e_style.setProperty(prop, val, pr);
            }
        },

        isCellCoveredByClone(cell) {
            const r = cell.getBoundingClientRect();
            const topEl = document.elementFromPoint(r.left + r.width/2, r.top + r.height/2);
            const topCell = topEl?.closest?.('.wj-cell');
            // если сверху другая .wj-cell из frozen-clone — значит текущая под клоном
            //  && topCell.closest('.wj-frozen-clone'));
            return (topCell && topCell !== cell) ? topCell : false;
        },
        isInFrozenClone(cell, grid) {
            let p = cell.parentElement;
            const host = grid.hostElement;
            while (p && p !== host) {
                const cls = p.className;
                if (cls && (cls.indexOf('wj-frozen-clone') !== -1 || (cls.match(/frozen/i) && cls.match(/clone/i)))) {
                    return true;
                }
                p = p.parentElement;
            }
            return false;
        },

        // ---------- conditional_format: фронт-вычисление условных правил ----------
        // Режим по умолчанию (без Apply on backend): бэк отдаёт разрезолвленные правила
        // attr.cf_rules (REPORT2: {report, sets}, LIST: {report, fields}) и ссылки строк
        // _DLRow.cf; фронт матчит WHERE для видимых ячеек с кэшем. Кэш отдельно от строк
        // данных (строки уходят на бэк при сохранении/поллинге) — Map по ключу
        // (_fe.key строки, binding колонки; для строки binding пустой). Инвалидация —
        // вместе с кэшами ячеек при load_data (новый select / правка настроек виджета).
        cf_compute(dataItem, col_binding, attr_col, collect) {
            const vueObj = this
            // IE 2026 09 20 / ODOO-5800 (Igor: «раскраску в ячейке ожидаю не от форматирования, а от метрик» — опция отчёта «Metric data in cells»):
            // _mf — состояние заливки от метрик (только контекст ячейки); отчёт без правил оформления считается по пустому набору правил
            const _mf = (dataItem && col_binding) ? this.metricFill_state() : null
            const rules = this.attr.cf_rules || (_mf ? CF_NO_RULES : null)
            if (!rules || !dataItem) return null
            if (rules !== CF_NO_RULES && this._styleNamesFor !== rules) this.styleNames_queue()   // IE 2026 09 18: имена классов правил — в реестр стилей
            if (!dataItem._fe?.key) {
                (dataItem._fe = dataItem._fe || {}).key = ++ this.cache_index
            }
            const cacheKey = `${dataItem._fe.key}:${col_binding}`
            if (!this.cf_cache) this.cf_cache = new Map()
            // collect — массив-коллектор сработавших заданий (список правил в
            // dropdown ячейки): кэш хранит только итоговый стиль, поэтому при
            // сборе прогоняем задания заново (редкое событие — открытие dropdown)
            if (!collect && this.cf_cache.has(cacheKey)) return this.cf_cache.get(cacheKey)

            let result = null
            // ячейка-представитель свёрнутой группы колонок показывает АГРЕГАТ —
            // условные правила меры оцениваем по нему, а не по скрытому сырому
            // значению колонки (ИЕ 2026-08-12: Uncovered-ячейка свёрнутого марта
            // с агрегатом 1 880 не красилась: сырое значение 01.03 пусто).
            // Кэш согласован: cf_cache чистится при смене свёртки групп
            const fold = (col_binding && attr_col?.raw_binding)
                ? this.foldAgg_value(dataItem, attr_col.binding0 || col_binding, attr_col) : null
            const cellValue = (o, b) => (fold && o === dataItem && b === col_binding)
                ? fold.v : vueObj.store.get_value(o, b)
            // вид строки (группа флагов «Use for», ключ задания useFor):
            // группировка — есть подчинённые строки (attrs у REPORT2,
            // дерево childItemsPath у LIST), иначе строка данных (листовая)
            const isGroupRow = !!(dataItem[this.attr.childItemsPath || 'attrs']?.length)
            // группа «ИЛИ» (правило-родитель типа AttrTabOR; legacy first_match
            // конвертирует бэк, cf_rule_types_apply): члены несут общий orGroup,
            // одинаковый order и идут подряд в порядке грида — применяется только
            // первое совпавшее задание группы в пределах этого контекста
            // (вызов cf_compute = контекст)
            const firedOrGroups = new Set()
            let firedBases = null   // IE 2026 09 20 / ODOO-5800: основы ключей метрик настоящих заданий, сработавших на ячейке (заливка от метрик им уступает)
            const apply = (task) => {
                // useFor: нет ключа — только строки данных; неподходящая
                // строка — пропуск без проверки WHERE и без учёта orGroup
                if (isGroupRow ? !task.useFor?.includes('groups')
                    : (task.useFor && !task.useFor.includes('data'))) return
                if (task.orGroup && firedOrGroups.has(task.orGroup)) return
                // measure: пустые ячейки не красятся (0 — красится); исключение —
                // задание без '#value'-ссылок (только companion/поля строки):
                // применяется и к пустым — паритет со скриптовой раскраской
                // (get_cssClass красил по supply_horizon независимо от значения)
                if (task.kind === 'measure' && cellValue(dataItem, col_binding) == null) {
                    const w_ = cfWhereLeaves(task.WHERE)   // IE 2026 09 18 / ODOO-5800: листовые условия сквозь группы #and / #or
                    const valueFree = w_.length && !w_.some(w => {
                        const lv = (w?.leftValue && typeof w.leftValue === 'object') ? w.leftValue.value : w?.leftValue
                        return lv === '#value'
                    })
                    if (!valueFree) return
                }
                // IE 2026 09 07 / ODOO-4443 (заказ Игоря): опция правила «Values only» (valuesOnly) — ячейки
                // ДАННЫХ красятся только там, где есть значение (0 — значение, null/'' — нет). В контексте
                // ячейки (cell/measure-задание на колонке данных) пустую ячейку пропускаем; в контексте
                // строки ячейка ещё неизвестна — классы/стиль уходят в отдельную корзину cssClassesVO /
                // cssStyleVO, а formatItem кладёт её только на непустые ячейки данных (ячейки заголовка
                // строки — Measure type / Subject / Alert … — красятся всегда, см. cf_valuesOnlyAllowed)
                if (task.valuesOnly && col_binding && vueObj.cf_isDataCol(attr_col)) {
                    const cv = cellValue(dataItem, col_binding)
                    if (cv == null || cv === '') return
                }
                if (!vueObj.cf_checkWHERE(task, dataItem, col_binding, attr_col, cellValue)) return
                if (task.orGroup) firedOrGroups.add(task.orGroup)
                if (_mf && task.metric_key) (firedBases || (firedBases = new Set())).add(task.metric_key)
                if (collect) collect.push(task)
                if (!result) result = { cssClasses: [], cssStyle: '', cssClassesVO: [], cssStyleVO: '' }
                if (task.rule_id) (result.ruleIds || (result.ruleIds = [])).push(task.rule_id)   // IE 2026 09 20 / ODOO-5800 (чипс условного оформления): какие правила окрасили ячейку / строку
                const _vo = !!(task.valuesOnly && !col_binding)   // IE 2026 09 07 / ODOO-4443: строчное задание «Values only»
                // IE 2026 09 19 / ODOO-5800 (Igor: Use вкладки Metrics, флаг чипса «Show other formatting»): скрытое оформление — без классов и стиля (metricFmt_hides)
                const _fmtHide = vueObj.metricFmt_hides(task, dataItem, col_binding)
                if (!_fmtHide && Array.isArray(task.cssClasses) && task.cssClasses.length) {
                    (_vo ? result.cssClassesVO : result.cssClasses).push(...task.cssClasses)
                }
                if (!_fmtHide && task.cssStyle) {
                    if (_vo) result.cssStyleVO = result.cssStyleVO ? result.cssStyleVO + '; ' + task.cssStyle : task.cssStyle
                    else result.cssStyle = result.cssStyle ? result.cssStyle + '; ' + task.cssStyle : task.cssStyle
                }
                // format/align/isReadOnly/source (cf_job_payload): свойство задания,
                // применённого последним, побеждает — как стиль
                if (task.format) result.format = task.format
                if (task.align) result.align = task.align
                if (task.isReadOnly) result.isReadOnly = true
                if (task.source != null && task.source !== '') result.source = task.source
            }
            const tasks = []
            if (col_binding === '') {
                // строка: условные правила отчёта (report) + рулсет строки (_DLRow.cf);
                // порядок сбора report → set — полевые правила приоритетнее (см. сортировку)
                for (const task of rules.report || []) {
                    if (task.kind === 'row') tasks.push(task)
                }
                for (const task of rules.sets?.[dataItem._DLRow?.cf] || []) {
                    if (task.kind === 'row') tasks.push(task)
                }
            } else if (rules.fields) {
                // LIST: cell-задания report (правило отчёта с целевыми полями,
                // cf_expand_report_rule) + правила поля — на ячейки своей колонки
                // (пустые не пропускаются); report раньше полевых (см. сортировку).
                // AttrTabGrid (карточка элемента сегмента, view): поле — это СТРОКА
                // (dataItem.attr.binding), а колонка значений одна ('attr.valueStr'),
                // поэтому полевые правила ключуем по биндингу поля строки, а не колонки.
                const fieldKey = (this.attr.attr_type === 'AttrTabGrid'
                    && col_binding === 'attr.valueStr' && dataItem?.attr?.binding)
                    ? dataItem.attr.binding
                    : col_binding
                for (const task of rules.report || []) {
                    if (task.kind === 'cell' && task.binding === fieldKey) tasks.push(task)
                }
                for (const task of rules.fields[fieldKey] || []) {
                    if (task.kind !== 'row') tasks.push(task)
                }
            } else {
                // REPORT2: cell — на ячейку своего binding; measure — на листовые
                // колонки данных (у них есть raw_binding). Канал report может нести
                // cell/measure-задания (правило отчёта с целевыми полями,
                // cf_expand_report_rule) — диспетчеризация по kind общая
                const collect_cellTasks = (list) => {
                    for (const task of list || []) {
                        if (task.kind === 'cell' && task.binding === col_binding) {
                            tasks.push(task)
                        } else if (task.kind === 'measure' && attr_col?.raw_binding) {
                            tasks.push(task)
                        }
                    }
                }
                collect_cellTasks(rules.report)
                collect_cellTasks(rules.sets?.[dataItem._DLRow?.cf])
            }
            // приоритет (order, эквивалент attrs.cf_sort_jobs бэка): побеждает стиль,
            // применённый последним — order по убыванию (0/нет — высший, применяется
            // последним); при равном order устойчивая сортировка сохраняет порядок
            // сбора (report → полевые, внутри каналов — порядок бэка)
            if (tasks.length > 1) {
                tasks.sort((a, b) => (+b.order || 0) - (+a.order || 0))
            }
            for (const task of tasks) apply(task)
            // IE 2026 09 20 / ODOO-5800 (Igor: «раскраску в ячейке ожидаю не от форматирования, а от метрик» — опция отчёта «Metric data in cells»):
            // ключи строк деталей ячейки — синтетические сработавшие задания; красит худшая оценка среди нескрытых, настоящее правило той же основы главнее
            if (_mf && (_mf.groups || !isGroupRow)) {
                const synth = vueObj.metricFill_cellTasks(_mf, dataItem, col_binding, attr_col)
                if (synth.length) {
                    const rowBases = vueObj.metricFill_rowBases(dataItem)
                    // IE 2026 09 20 / ODOO-5800 (Igor: «форматирование от #cell.supply_horizon переделать на метрики правил»): ключи-слои (css_layer: горизонт lt / rc, окно
                    // блокировки) красят ВСЕ разом и поверх заливки худшей оценки — как правила оформления по спутникам, которые срабатывали одновременно (ячейка и в LT, и
                    // заблокирована). Выключатель fe.ux.metricFillLayers: слой спорит за заливку как обычный ключ
                    const layersOn = _mf.layers !== false
                    let painter = null
                    const layers = []
                    let crit = false   // IE 2026 10 03 / ODOO-5800: у ячейки есть нескрытый ключ оценки critical
                    for (const t of synth) {
                        // IE 2026 10 03 / ODOO-5800 (заказ Игоря: «Показать критич ош если небьется расчетный запас с фактич»): критическая ошибка видна и там, где ячейку красит
                        // настоящее правило той же основы ключа (синтетическое задание ему уступает) — класс METRIC_CRIT_CLASS кладётся отдельно; скрытое оформление
                        // (Use вкладки Metrics, чипс со снятым «Show other formatting») по-прежнему скрыто
                        if (t._crit && !crit && !vueObj.metricFmt_hides(t, dataItem, col_binding)) crit = true
                        if ((firedBases && firedBases.has(t.metric_key)) || rowBases.has(t.metric_key)) continue
                        if (collect) collect.push(t)
                        if (!(t.cssClasses.length || t.cssStyle) || vueObj.metricFmt_hides(t, dataItem, col_binding)) continue
                        if (t._layer && layersOn) layers.push(t)
                        else if (!painter) painter = t
                    }
                    for (const pt of (painter ? [painter, ...layers] : layers)) {
                        if (!result) result = { cssClasses: [], cssStyle: '', cssClassesVO: [], cssStyleVO: '' }
                        for (const cl of pt.cssClasses) if (!result.cssClasses.includes(cl)) result.cssClasses.push(cl)
                        if (pt.cssStyle) result.cssStyle = result.cssStyle ? result.cssStyle + '; ' + pt.cssStyle : pt.cssStyle
                    }
                    if (crit) {   // IE 2026 10 03 / ODOO-5800
                        if (!result) result = { cssClasses: [], cssStyle: '', cssClassesVO: [], cssStyleVO: '' }
                        if (!result.cssClasses.includes(METRIC_CRIT_CLASS)) result.cssClasses.push(METRIC_CRIT_CLASS)
                    }
                }
            }
            this.cf_cache.set(cacheKey, result)
            return result
        },
        // задания, реально применённые к ячейке (инфо-блок в dropdown):
        // строчные (фон всей строки под ячейкой) + ячейковые, в порядке применения
        // IE 2026 08 19 / ODOO-5512 (заказ Игоря): история правки ячейки для блока
        // CORRECTION дропдауна — вместо тултипа «Old value»: несохранённая правка
        // сессии (changesStack: было → стало, дельта, ручная/связанная/вставка) и
        // сохранённая ручная корректировка _cells (автор, время, значение до неё)
        correctionInfo_forCell(dataItem, col_binding, attr_col, irow, _cells, cellText='') {
            const out = []
            if (!dataItem || !attr_col) return out
            // процентность — как у бейджа дельты: формат колонки (pN) или текст ячейки
            const isPct = /^p\d*$/i.test(String(attr_col.format || '')) || /%/.test(cellText || '')
            const fmt = (v) => {
                if (v === null || v === undefined || v === '') return '—'
                if (typeof v === 'boolean') return v ? '\u2713' : '\u2717'   // IE 2026 09 07 / ODOO-5512: чекбокс — ✓ / ✗
                const n = Number(v)
                if (typeof v !== 'boolean' && !Number.isNaN(n) && /^-?[\d.]/.test(String(v).trim())) {
                    try { return wjcCore.Globalize.format(n, attr_col.format || (isPct ? 'p1' : (Number.isInteger(n) ? 'n0' : 'n2'))) } catch (e) { return String(v) }
                }
                return String(v)
            }
            const rowStack = this.changesStack?.[`${irow}:${col_binding}`]
            const hasSaved = !!(_cells && (('value' in _cells) || ('isNull' in _cells)))
            let ownEdit = false
            if (rowStack) {
                const d = this.chgDelta ? this.chgDelta(rowStack, isPct) : null
                const linked = (rowStack.indirect || rowStack.related) && !rowStack.user
                ownEdit = !linked && !(rowStack.pastedVal && !rowStack.newVal)
                // IE 2026 09 23 / ODOO-341407: i18n (подписи блоков формы ячейки)
                out.push({
                    kind: rowStack.pastedVal && !rowStack.newVal ? 'error' : (linked ? 'linked' : 'edit'),
                    title: rowStack.pastedVal && !rowStack.newVal ? t('Pasted value not applied')
                        : (linked ? t('Recalculated after an edit') : t('Edited in this session')),
                    from: fmt(rowStack.val), to: fmt(rowStack.newVal),
                    delta: d?.text || '', up: !!d?.up,
                    pasted: rowStack.pastedVal ? String(rowStack.pastedVal) : '',
                    // своя правка с use_cells: автор/время уже записаны в _cells — одной строкой
                    by: ownEdit && hasSaved ? (_cells.updated_by || '') : '',
                    at: ownEdit && hasSaved ? (_cells.updated_at || '') : '',
                    meta: t('not saved yet'),
                })
            }
            if (hasSaved && !ownEdit) {
                out.push({
                    kind: 'saved',
                    title: t('Manual correction'),
                    from: ('value_before' in _cells) ? fmt(_cells.value_before) : '',
                    to: fmt(_cells.isNull && (_cells.value === null || _cells.value === undefined) ? null : _cells.value),
                    by: _cells.updated_by || '', at: _cells.updated_at || '',
                    meta: t('saved with the report'),
                })
            }
            if (hasSaved) {
                if (_cells.updated_by) {
                    // имя автора — из справочника USER (подтянется асинхронно, блок реактивен)
                    try { this.store.get_itemsSource(this, {}, { attr_type: 'AttrLink', relation_segment: 'USER' }, { fetchMode: 'by_ids', ids: [_cells.updated_by] }) } catch (e) { /* без имени — покажем id */ }
                }
            }
            // IE 2026 08 24 / ODOO-5884 (заказ Игоря): отклонение от сравниваемой процессной модели —
            // оригинал в сравниваемой модели, абсолютное и относительное отклонение (любые режимы сравнения)
            const cmp = dataItem?._DLRow?.cmp_cells?.[col_binding]
            if (cmp && cmp.text) {
                // IE 2026 08 26 / ODOO-5800: текстовое отличие от сравниваемой модели — было/стало без дельты
                out.push({
                    kind: 'cmp', title: t('Vs compared process model'),
                    from: (cmp.prev === null || cmp.prev === undefined || cmp.prev === '') ? '\u2014' : String(cmp.prev_title || cmp.prev),
                    to: cellText || '', delta: '\u2260', up: false, meta: t('value changed'),
                })
            } else if (cmp) {
                const relTxt = (cmp.rel === null || cmp.rel === undefined) ? ''
                    : ((cmp.rel > 0 ? '+' : '\u2212') + Math.round(Math.abs(cmp.rel) * 1000) / 10 + '%')
                out.push({
                    kind: 'cmp', title: t('Vs compared process model'),
                    from: fmt(cmp.prev), to: cellText || fmt((Number(cmp.prev) || 0) + cmp.delta),
                    delta: (cmp.delta > 0 ? '+' : '\u2212') + fmt(Math.abs(cmp.delta)),
                    up: cmp.delta > 0,
                    meta: relTxt ? t('vs model {rel}', { rel: relTxt }) : '',
                })
            }
            return out
        },
        cf_appliedForCell(dataItem, col_binding, attr_col) {
            const applied = []
            // IE 2026 09 20 / ODOO-5800 (Igor 20.09: «и в форме дропдаун — у нас там же есть описание причины усл. формата из строки настройки усл. формата»): карточка записи —
            // оформление поля считает бэк (common_modules/record_cf.py) и отдаёт сработавшие правила узлом поля attr.cf_applied = [{title, cssClasses, cssStyle}];
            // форма поля показывает их блоком FORMATS, как форма ячейки списка / отчёта
            if (this.attr?.attr_type === 'AttrTabGrid' && Array.isArray(dataItem?.attr?.cf_applied)) {
                return dataItem.attr.cf_applied.filter(t => t && t.title).map(t => ({ kind: 'cell', title: t.title, cssClasses: Array.isArray(t.cssClasses) ? t.cssClasses : [], cssStyle: t.cssStyle || '' }))
            }
            if ((!this.attr.cf_rules && !this.metricFill_state()) || !dataItem) return applied   // IE 2026 09 20 / ODOO-5800: и заливка от метрик без правил оформления
            this.cf_compute(dataItem, '', null, applied)
            if (col_binding && !this.cellBlank(dataItem, col_binding)) this.cf_compute(dataItem, col_binding, attr_col, applied)   // IE 2026 10 07 / ODOO-5800: погашенную ячейку правила ячейки не красят — в списке «применено» их нет
            // IE 2026 09 07 / ODOO-4443: на пустой ячейке данных строчные задания «Values only» не применены —
            // в блоке FORMATS дропдауна их не показываем
            if (col_binding && !this.cf_valuesOnlyAllowed(attr_col, this.foldAgg_getValue(dataItem, attr_col?.binding, attr_col))) {
                return applied.filter(t => !t.valuesOnly)
            }
            return applied
        },
        // IE 2026 09 07 / ODOO-4443 (заказ Игоря): опция правила «Values only». Колонка данных — листовая колонка
        // значений REPORT2 (есть raw_binding) либо любая привязанная колонка списка (канал fields); ячейки
        // заголовка строки отчёта (Measure type / Subject / Alert / Country …) колонками данных не считаются
        cf_isDataCol(attr_col) {
            if (!attr_col) return false
            return !!(this.attr.cf_rules?.fields ? attr_col.binding : attr_col.raw_binding)
        },
        // применимо ли к ячейке оформление «Values only»: не колонка данных — всегда; колонка данных — при
        // непустом значении (0 — значение, null/'' — пусто; для свёрнутой группы колонок value — агрегат)
        cf_valuesOnlyAllowed(attr_col, value) {
            if (!this.cf_isDataCol(attr_col)) return true
            return !(value == null || value === '')
        },
        // ODOO-4443: тела вынесены в @/utils/cfEval — общий вычислитель с чартами.
        // Сигнатуры прежние: остальной код грида зовёт их как раньше.
        cf_checkWHERE(task, dataItem, col_binding, attr_col, getValue) {
            // getValue: подмена доступа к значению (агрегат свёрнутой группы)
            const base = getValue || ((o, b) => this.store.get_value(o, b))
            const ctx = { getValue: base }
            // IE 2026 10 07 / ODOO-5800 (Igor: «если grade не выводить в строке 4, теряется условное оформление, хотя grade есть у родительской строки»):
            // fe.ux.cfInheritParent (дефолт ВКЛ): поле условия ОТСУТСТВУЕТ в строке (нет ключа / undefined; null и '' — значение) — берётся у ближайшего предка по
            // дереву DL2. Только для вычисления правила: данные строки, показ и сохранение не меняются. Вкл/выкл — ?fe.ux.cfInheritParent=false (без пересборки)
            if (this.cf_inheritOn()) {
                ctx.getValueInherit = (o, b) => {
                    let cur = o
                    for (let depth = 0; cur && depth < 64; depth++) {
                        const v = this.store.get_value(cur, b, CF_ABSENT)
                        if (v !== CF_ABSENT && v !== undefined) {
                            const own = cur === o
                            if (!own) this.cf_inheritCount('hit')
                            return (own && b === col_binding) ? base(o, b) : v   // свёрнутая группа колонок: агрегат считает base
                        }
                        cur = this.cf_parentOf(cur)
                    }
                    return null
                }
            }
            return cfCheckWHERE(task, dataItem, col_binding, attr_col, ctx)
        },
        // IE 2026 10 07 / ODOO-5800: родительская строка дерева DL2 для вычисления условного оформления. Карта «потомок -> родитель» строится лениво обходом
        // data000 по childItemsPath (не пишется в данные строк: в сохранения / JSON не попадает) и живёт в cf_cache — сбрасывается вместе с ним при любой смене данных
        cf_parentOf(item) {
            if (!item || typeof item !== 'object') return null
            if (!this.cf_cache) this.cf_cache = new Map()
            let m = this.cf_cache.get('§cfParents')
            if (!m) {
                m = new WeakMap()
                const kids = this.attr?.childItemsPath || 'attrs'
                const stack = [[toRaw(this.data000 || this.data), null]]
                while (stack.length) {
                    const [arr, parent] = stack.pop()
                    if (!Array.isArray(arr)) continue
                    for (const it of arr) {
                        if (!it || typeof it !== 'object') continue
                        const raw = toRaw(it)
                        if (parent) m.set(raw, parent)
                        const ch = raw[kids]
                        if (Array.isArray(ch) && ch.length) stack.push([toRaw(ch), raw])
                    }
                }
                this.cf_cache.set('§cfParents', m)
                this.cf_inheritCount('build')
            }
            return m.get(toRaw(item)) || null
        },
        cf_inheritOn() {
            const on = this.store.setting('fe.ux.cfInheritParent', true) !== false
            if (on !== this._cfInhOn) {   // переключили флаг — кэш результатов правил считался по прежнему режиму
                this._cfInhOn = on
                this.cf_cache?.clear()
            }
            return on
        },
        cf_inheritCount(kind) {
            // замер fe.ux.cfInheritParent: build — сколько раз строилась карта родителей, hit — сколько значений взято у предка
            try {
                const c = (window.cfInheritParent = window.cfInheritParent || { build: 0, hit: 0 })
                c[kind] = (c[kind] || 0) + 1
            } catch (e) { /* без замера */ }
        },
        cf_resolveRef(ref, col_binding, attr_col) {
            return cfResolveRef(ref, col_binding, attr_col)
        },
        cf_checkCondition(left, w) {
            return cfCheckCondition(left, w)
        },
        cf_rowFormat(dataItem, col_binding) {
            // IE 2026 08 31 / ODOO-5884 (заказ Игоря «Δ% печатается днями»): формат, пришедший
            // на СТРОКУ/ЯЧЕЙКУ (_DLRow.format — у compare-строки Δ% это 'p0'), СИЛЬНЕЕ типа
            // колонки. В колонках длительностей (AttrTime/AttrDays) 6.3333 печаталось как
            // «6.3d» и читалось как дни, а не как отклонение 633%.
            const dl = dataItem?._DLRow
            if (!dl) return null
            return (col_binding && dl.cells?.[col_binding]?.format) || dl.format || null
        },
        cf_formatProps(dataItem, col_binding, attr_col) {
            // format/align/isReadOnly/source попавших под правила заданий для ячейки:
            // строка → ячейка, бэк-канал (_DLRow, Apply on backend) → фронт
            // (cf_compute); позднее заполненное свойство побеждает (как стиль)
            let props = null
            const merge = (src) => {
                if (!src || (!src.format && !src.align && !src.isReadOnly && (src.source == null || src.source === ''))) return
                props = props || {}
                if (src.format) props.format = src.format
                if (src.align) props.align = src.align
                if (src.isReadOnly) props.isReadOnly = true
                if (src.source != null && src.source !== '') props.source = src.source
            }
            merge(dataItem?._DLRow)
            if (this.attr.cf_rules) {
                merge(this.cf_compute(dataItem, '', null))
            }
            if (col_binding) {
                // IE 2026 10 07 / ODOO-5800: у погашенной ячейки нет формата / выравнивания / подмены содержимого от меты и правил ячейки, но ЗАПРЕТ ПРАВКИ (isReadOnly) остаётся — это защита ячейки, не показ
                const _dl2Blank = this.cellBlank(dataItem, col_binding)
                const mergeCell = (src) => merge(_dl2Blank ? (src && src.isReadOnly ? { isReadOnly: true } : null) : src)
                // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL4: флажок, закрытый бэком «по порядку», при поставленных в строке флажках шагов ниже — открыт (approvalFlag_open)
                const _cm = dataItem?._DLRow?.cells?.[col_binding]
                mergeCell(_cm && _cm.isReadOnly === true && this.approvalFlag_open(dataItem, col_binding) ? { ..._cm, isReadOnly: false } : _cm)
                if (this.attr.cf_rules && attr_col?.binding) {
                    mergeCell(this.cf_compute(dataItem, col_binding, attr_col))
                }
            }
            return props
        },
        cf_applyFormat(e_cell, e_style, dataItem, col_binding, attr_col, value) {
            // применение format/align/source к ячейке (рендер единый для
            // фронт- и бэк-режима). Контент не кэшируется в _cache.className/
            // cssText — вызывается и на быстром пути formatItem
            const props = this.cf_formatProps(dataItem, col_binding, attr_col)
            if (!props) return
            if (props.align) {
                e_style.textAlign = props.align
            }
            if (!props.format && props.source == null) return
            if (e_cell.querySelector('input')) return // редактор/чекбокс не трогаем
            let v = value
            if (props.source != null) {
                v = this.cf_sourceValue(props.source, dataItem)
            }
            let text = null
            const vNum = (typeof v === 'string' && v.trim() !== '' && !isNaN(+v)) ? +v : v
            if (props.format && (typeof vNum === 'number' || vNum instanceof Date)) {
                text = wjcCore.Globalize.format(vNum, props.format)
            } else if (props.source != null) {
                text = v == null ? '' : String(v)
            }
            if (text == null || e_cell.textContent === text) return
            if (props.source != null || !e_cell.firstElementChild) {
                // подмена содержимого (или простая текстовая ячейка)
                e_cell.textContent = text
            } else {
                // переформатирование значения внутри разметки (num-inner и т.п.)
                this.store.updateCellText(e_cell, text)
            }
        },
        cf_sourceValue(source, dataItem) {
            // Source правила (source_field.value, семантика eval_type='DL'):
            // '=' — DL-выражение с контекстом строки; подобранное поле —
            // значение поля строки; иначе — фиксированный текст
            const s = String(source)
            if (s.startsWith('=')) {
                try {
                    return new Function('row', 'dataItem', `return ${s.slice(1)};`)(dataItem, dataItem)
                } catch (e) {
                    return ''
                }
            }
            const v = this.store.get_value(dataItem, s)
            return v !== undefined ? v : s
        },
        // ---------------- formatPreview_*: колонка-превью оформления ----------------
        // Шаблон поля F_formatPreview (маркер formatPreview: true, binding _formatPreview —
        // виртуальный, значение не хранится): образец значения с применёнными
        // cssClass/style/format/align строки. preview_bindings (map) переопределяет
        // источники; плейсхолдеры {x} в binding'ах резолвятся значениями строки.
        // Зеркало бэка: ADDON_scm_core/config_fields.py > F_formatPreview
        formatPreview_attr(attr_col, dataItem, col_binding) {
            // ячейка-превью: колонка-маркер | строка-поле карточки (AttrTabGrid)
            if (attr_col?.formatPreview) return attr_col
            if (this.attr.attr_type === 'AttrTabGrid' && col_binding === 'attr.valueStr' && dataItem?.attr?.formatPreview) {
                return dataItem.attr
            }
            return null
        },
        formatPreview_sources(previewAttr, dataItem) {
            // реквизиты оформления: по умолчанию — своей строки (как у соседних колонок);
            // в карточке (строка AttrTabGrid) — поля той же карточки (префикс биндинга —
            // от соседней строки-поля оформления)
            const store = this.store,
            pb = previewAttr.preview_bindings || {},
            isCardRow = previewAttr === dataItem?.attr
            const resolve_pb = (binding) => {
                binding = String(binding).replace(/\{([\w.]+)\}/g, (m, k) => {
                    const v = store.get_value(dataItem, k)
                    return v == null ? m : v
                })
                if (!isCardRow) {
                    const v = store.get_value(dataItem, binding)
                    if (v != null) return v
                }
                return store.attr_get(this.WIDGET, { binding })
            }
            let prefix = ''
            if (isCardRow) {
                for (const row of this.flex.rows) {
                    const b = row.dataItem?.attr?.binding || '',
                    tail = b.split('.').pop()
                    if (['cssClass', 'style', 'format', 'align'].includes(tail)) {
                        prefix = b.slice(0, b.length - tail.length)
                        break
                    }
                }
                prefix = prefix || 'doc.'
            }
            const read = (key) => {
                if (pb[key]) return resolve_pb(pb[key])
                return isCardRow
                    ? store.attr_get(this.WIDGET, { binding: prefix + key })
                    : store.get_value(dataItem, key)
            }
            const src = {
                cssClass: read('cssClass'),
                style: read('style'),
                format: read('format'),
                align: read('align'),
                attr_type: read('attr_type'),
                // Source-подстановка содержимого ячейки (source_field) — влияет на текст образца
                source: read('source_field'),
            }
            // табличная часть cssClasses строки — как при обычном рендере, дополняет cssClass
            if (!pb.cssClass && !isCardRow && Array.isArray(dataItem?.cssClasses)) {
                const names = store.resolve_cssClasses(dataItem.cssClasses)
                if (names) src.cssClass = src.cssClass ? `${names} ${src.cssClass}` : names
            }
            return src
        },
        formatPreview_styleText(style) {
            // поле style строки: CSS-текст как есть | словарь AttrCSS
            if (!style) return ''
            if (typeof style === 'string') return style.trim()
            return Object.entries(this.store.normalizeStyle(style)).map(([k, v]) => `${k}: ${v}`).join('; ')
        },
        formatPreview_align(align, attr_type) {
            // явный Align побеждает; иначе — дефолт грида по типу (как wijmo по
            // col.dataType): числа/даты/время — вправо, булево — по центру, прочее — влево
            if (align) return align
            if (['AttrNumber', 'AttrDate', 'AttrTime', 'AttrDays'].includes(attr_type)) return 'right'
            if (attr_type === 'AttrBool') return 'center'
            return 'left'
        },
        formatPreview_sourceLiteral(source) {
            // Source-подстановка: в образце показываем только ФИКСИРОВАННЫЙ текст.
            // '='-DL-выражение и подобранное поле (есть relation_segment/attr_type)
            // без строки данных не вычислить — образец остаётся типовым.
            if (!source || typeof source !== 'object') return null
            if (source.relation_segment || source.attr_type) return null
            const v = source.value
            if (typeof v !== 'string' || !v || v.startsWith('=')) return null
            return source.valueStr || v
        },
        formatPreview_sampleText(attr_type, format) {
            // образец по типу и формату: то, что реально появится в целевой колонке
            const fmt = typeof format === 'string' ? format.trim() : ''
            try {
                if (attr_type === 'AttrDate') return wjcCore.Globalize.format(new Date(), fmt || 'd')
                if (attr_type === 'AttrTime') return wjcCore.Globalize.format(new Date(), fmt || 't')
                if (attr_type === 'AttrBool') return '✓'
                if (attr_type === 'AttrNumber' || /^[nfp]\d*$/i.test(fmt)) {
                    return wjcCore.Globalize.format(/^p/i.test(fmt) ? 0.1234 : 1234.567, fmt || 'n2')
                }
            } catch (e) {
                if (attr_type === 'AttrNumber') return wjcCore.Globalize.format(1234.567, 'n2')
            }
            return 'Abc'
        },
        formatPreview_cellApply(e_cell, e_style, dataItem, attr_col, col_binding) {
            const previewAttr = dataItem ? this.formatPreview_attr(attr_col, dataItem, col_binding) : null
            if (!previewAttr) return
            if (e_cell.querySelector('input')) return
            const src = this.formatPreview_sources(previewAttr, dataItem),
            cssClass = typeof src.cssClass === 'string' ? src.cssClass.trim() : '',
            styleText = this.formatPreview_styleText(src.style),
            format = typeof src.format === 'string' ? src.format.trim() : ''
            e_cell.textContent = ''
            // все три источника пусты (align один смысла не имеет) — образец не показываем
            if (!cssClass && !styleText && !format) return
            // изоляция: отступ от бордюров ячейки-грида, чтобы мини-ячейка образца
            // не сливалась с сеткой самого превью
            e_style.padding = '2px'
            e_style.overflow = 'hidden'
            // мини-ячейка — воспроизводит ячейку рабочей таблицы (свой бордюр + фон/стиль +
            // выравнивание); к ней применяются cssClass/style строки
            const box = document.createElement('div')
            box.className = 'format-preview-box' + (cssClass ? ' ' + cssClass : '')
            // классы, живущие только в контексте ячейки (.wj-cell.cell-rc и т.п.),
            // напрямую на превью не срабатывают — добавляем их дельту инлайном;
            // явный Style идёт после и побеждает
            const deltaCss = cssClass
                ? cssClass.split(/\s+/).map(c => cfClassDeltaCss(c, this.flex?.hostElement)).join('')
                : ''
            if (deltaCss || styleText) box.style.cssText = deltaCss + (styleText || '')
            const span = document.createElement('span')
            span.className = 'format-preview-sample'
            // Align (или дефолт по типу) — как в колонке рабочей таблицы
            span.style.textAlign = this.formatPreview_align(src.align, src.attr_type)
            // Source-литерал замещает типовой образец (что реально появится в ячейке)
            const literal = this.formatPreview_sourceLiteral(src.source)
            span.textContent = literal != null ? String(literal) : this.formatPreview_sampleText(src.attr_type, format)
            box.appendChild(span)
            e_cell.appendChild(box)
        },
        formatPreview_afterEdit(irow, col_binding, dataItem) {
            // живое превью: правка источников оформления перерисовывает ячейку-превью
            const KEYS = ['cssClass', 'cssClasses', 'style', 'format', 'align', 'attr_type'],
            // source_field лежит в под-биндингах (.value/.valueStr) — ловим по вхождению
            isFmtKey = (b) => KEYS.includes(String(b).split('.').pop()) || String(b).includes('source_field'),
            flex = this.flex
            if (!flex) return
            let irow2 = irow, icol
            if (this.attr.attr_type === 'AttrTabGrid') {
                // карточка: правка строки-поля оформления → строка-превью
                if (!isFmtKey(dataItem?.attr?.binding || '')) return
                irow2 = flex.rows.findIndex(r => r.dataItem?.attr?.formatPreview)
                icol = flex.columns.findIndex(c => c.binding === 'attr.valueStr')
            } else {
                if (!isFmtKey(col_binding)) return
                icol = flex.columns.findIndex(c => this.attr_by_binding[c.binding]?.formatPreview)
            }
            if (irow2 < 0 || icol < 0) return
            // после коммита редактора wijmo
            setTimeout(() => {
                if (flex.hostElement && irow2 < flex.rows.length) {
                    flex.refreshRange(new wjGrid.CellRange(irow2, icol, irow2, icol))
                }
            }, 0)
        },
        get_measure_(dataItem) {
            // реестр полей-мер attr.fields_ (дедуп measure_): свойства меры по ссылке
            // measure_.id, fallback на сам measure_, пока бэк присылает полные копии
            const m = dataItem?.measure_
            if (m?.id != null && this.attr.fields_?.[m.id]) {
                return this.attr.fields_[m.id]
            }
            return m
        },
        // ===== IE 2026 09 17 / ODOO-… (заказ Игоря: «доработаем merge и в направлении назад: в строке 205 значение в
        // колонке 5, а перед ней пусто — можно объединить; при выделении ячейки показывать выделение в шапке ЕЁ колонки») =====
        // Настоящее объединение (Игорь: «мне нравился больше вариант с Merge»): CustomMergeManager.mergeBack_extend
        // расширяет диапазон значения влево на пустые колонки перед ним — не левее значка свёртки (у строк с подчинёнными)
        // и колонки родительской строки + 1 («лесенка» уровней сохраняется). Корень объединения у wijmo — левая ячейка:
        // значение в него дорисовывает mergeBack_apply из ХВОСТА formatItem (и на кэш-пути — раньше содержимое терялось
        // после прокрутки), выделение объединения подсвечивает в шапке колонку значения (mergeBack_selCol), правка по
        // объединению начинается в колонке значения (beginningEdit). Внутренняя опция fe.ux.gridMergeBack (по умолчанию вкл).
        // IE 2026 09 23 / ODOO-… (рамка выделения): грид данных виджета — основная таблица отчёта / списка (dataSheet, _doc.data), не форма
        // ---------------- IE 2026 09 23 / ODOO-… (заказ Игоря: итог группы = единственный потомок) ----------------
        // «когда раскрываешь подчинённые строки в отчёте и там ровно одна строка, полностью повторяющая итоговую, добавить опцию, по которой
        // user-friendly скрывать цифры в итоговой строке, чтобы меньше было визуального текста»; решение 23.09 по макету A–D:
        // «согласен на А (как по умолчанию для всех), но сделай и B, C».
        // Правило — ПО ЯЧЕЙКЕ: ячейка РАСКРЫТОЙ строки-группы — «повтор», когда среди её видимых прямых потомков (строки wijmo уровня + 1,
        // row.visible; строки сравнения _variant не считаются) ровно один несёт непустое значение в этой колонке и значение группы равно ему
        // (числа — допуск 1e-9, строки — точно; оба пусты → не повтор; 0 — пустое, как спрятанный ноль cell-zero). Цепочки считаются:
        // «Starting inventory 41 098 → Warehouse 41 098 → Украина 41 098 → Склад хранения 41 098» — три верхние строки повторы. Где потомков
        // со значением два и больше (настоящая сумма) или группа считается иначе — число остаётся. Свёрнутая группа — как есть.
        // Только грид ДАННЫХ отчёта (dataSheet с деревом строк раскладки _DLRow; списки, формы AttrTabGrid, печать / экспорт — нет),
        // только колонки значений (за областью измерений). Данные не трогаем — только класс на ячейке в хвосте formatItem (оба пути):
        //   A dim   — gt-dup-dim: ячейка на 12 % (opacity var(--gt-dup-dim): настройка базы fe.ux.gridGroupTotalsDimOpacity, IE 2026 09 23 / ODOO-…
        //             «максимально приглушим цифры»; было 38 % по макету), наведение на строку — обычная; при отрисовке приглушение ставится
        //             без CSS-перехода (fe.ux.gridGroupTotalsDimInstant, IE 2026 09 24 / ODOO-5800 — иначе переиспользованная wijmo ячейка
        //             «моргала» при горизонтальной прокрутке: 150 мс гасла от 1 до .12), плавно — только проявление по наведению;
        //   B hover — gt-dup-hover: текст прозрачный (-webkit-text-fill-color — цвет текста не трогаем), по наведению на строку проступает;
        //   C arrow — gt-dup-arrow: текст спрятан, знак «↓» (::before) у правого края, подсказка title; по наведению — число.
        // Вариант — настройка виджета doc.params.group_totals_repeat (dim | hover | arrow | off; форма Options отчёта, бэк config_widgets),
        // пусто → настройка базы fe.ux.gridGroupTotalsRepeat (по умолчанию dim = A для всех). Кэш «повтор» — на проход отрисовки
        // (_groupDup: WeakMap строка группы → Map колонка → bool), сброс в updatingView / itemsSourceChanged / groupCollapsedChanged.
        // Спрятанный текст (B / C) для подсветок одинакового текста и вхождений — как спрятанный ноль (cellMatch_hiddenClass).
        groupDup_mode() {
            let v = this.WIDGET?.record?.doc?.params?.group_totals_repeat
            if (v === undefined || v === null || v === '') v = this.store.setting('fe.ux.gridGroupTotalsRepeat', 'dim')
            v = String(v || '').trim().toLowerCase()
            return (v === 'dim' || v === 'hover' || v === 'arrow') ? v : 'off'
        },
        groupDup_state(flex) {
            let st = this._groupDup
            if (st && st.flex === flex) return st
            const on = !!flex && this.selFrame_isDataGrid() && !!this.attr?.childItemsPath && !this.attr.isPrint && !this.attr.isPrintTemplate
            const mode = on ? this.groupDup_mode() : 'off'
            // колонки значений — за областью измерений (как «шапка строки» у alertChild_paint) и за замороженными
            const bound = Math.max(this.mergeColumnBlocksTotal || 0, this.mergeColumns || 0, (flex && flex.frozenColumns) || 0)
            // IE 2026 09 24 / ODOO-5800: под отбором строк повтор сверяется по показанным итогам по отбору; отдельный выключатель приглушения fe.ux.filterTotalsGroupDup (ВКЛ)
            st = { flex, mode, bound, map: new WeakMap(), paths: {},
                ft: mode !== 'off' && !!this._ftMap && this.filterTotals_allPaths() && this.store.setting('fe.ux.filterTotalsGroupDup', true) !== false }
            st.ph = on && parentHide_mode(this.WIDGET?.record?.doc?.params, (k, d) => this.store.setting(k, d)) === 'hide'   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p201 баланс — «Сигнали» типово, розкритий батьківський рядок без підсумків і сигналів (hover показує), підсумок рядка без сигналів — опція): раскрытая строка-группа — вся
            st.phKeep = this.store.setting('fe.ux.parentSignalsKeepComplement', true) !== false   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p232 сигнал батьківського рядка лишається, якщо підлеглі — інша міра): дети — только другие меры (дополнение) — родитель не приглушается, круги остаются
            st.phMode = mode !== 'off' ? mode : 'dim'   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p201 баланс — «Сигнали» типово, розкритий батьківський рядок без підсумків і сигналів (hover показує), підсумок рядка без сигналів — опція): вариант приглушения строки — как у повтора (off — dim)
            this._groupDup = st
            return st
        },
        // сырое значение ячейки строки (объект-значение {value, …} — по value)
        groupDup_value(raw, binding, st) {
            let path = st.paths[binding]
            if (!path) path = st.paths[binding] = toRaw(this.store._parse_binding(binding)) || []
            let v = rowEmpty_value(raw, binding, path)
            if (v && typeof v === 'object' && !Array.isArray(v) && 'value' in v) v = v.value
            return v
        },
        groupDup_same(a, b) {
            if (typeof a === 'number' && typeof b === 'number') return Math.abs(a - b) <= 1e-9 || Math.abs(a - b) <= 1e-12 * Math.max(Math.abs(a), Math.abs(b))
            if (typeof a === 'string' && typeof b === 'string') return a === b
            if ((typeof a === 'number' && typeof b === 'string') || (typeof a === 'string' && typeof b === 'number')) {
                if (String(a).trim() === '' || String(b).trim() === '') return false
                const x = Number(a), y = Number(b)
                return Number.isFinite(x) && Number.isFinite(y) && Math.abs(x - y) <= 1e-9
            }
            return false
        },
        // ячейка (irow, icol) — повтор итога группы (см. правило выше); кэш на проход по строке группы и колонке
        groupDup_isRepeat(flex, rows, irow, icol, st) {
            const row = rows[irow]
            if (!row || !row.hasChildren || row.isCollapsed || row.visible === false) return false
            const d = row.dataItem
            if (!d || !d._DLRow || d._DLRow.row_type === 'tabrow' || d._variant) return false
            let m = st.map.get(d)
            if (!m) { m = new Map(); st.map.set(d, m) }
            if (m.has(icol)) return m.get(icol)
            let res = false
            const binding = flex.columns[icol]?.binding
            if (binding) {
                // IE 2026 09 24 / ODOO-5800 (Igor: итоги под фильтром строк — 58:27 / 58:35): при действующем отборе в ячейке группы показан итог по отбору (_ftMap), а не значение
                // строки данных — повтор «итог группы = единственный видимый потомок» сверяется по показанным значениям (иначе «Ex-Delta 432 = Грузия 432» не приглушалась, а
                // сверка шла по итогам бэка 13 824 / 432). Опция fe.ux.filterTotalsAllPaths
                const b0 = st.ft ? (this.attr_by_binding[binding]?.binding0 || binding) : binding
                const valOf = (x) => { if (st.ft) { const o = this.filterTotals_cell(x, b0); if (o !== undefined) return o } return this.groupDup_value(toRaw(x), binding, st) }
                const gv = valOf(d)
                if (!rowEmpty_valueEmpty(gv)) {
                    const lvl = row.level ?? 0
                    let n = 0, cv
                    for (let j = irow + 1; j < rows.length; j++) {
                        const r = rows[j], l = r.level ?? 0
                        if (l <= lvl) break
                        if (l !== lvl + 1 || r.visible === false) continue   // только видимые ПРЯМЫЕ потомки
                        const cd = r.dataItem
                        if (!cd || cd._variant) continue
                        const v = valOf(cd)   // IE 2026 09 24 / ODOO-5800: показанное значение подчинённой строки
                        if (rowEmpty_valueEmpty(v)) continue
                        n++; cv = v
                        if (n > 1) break
                    }
                    res = n === 1 && this.groupDup_same(gv, cv)
                }
            }
            m.set(icol, res)
            return res
        },
        groupDup_paint(e_cell, flex, rows, irow, icol, isXlsxExport) {
            const st = isXlsxExport ? null : this.groupDup_state(flex)
            const mode = st ? st.mode : 'off'
            const ph = !!st && st.ph && icol >= st.bound && parentHide_isRow(rows[irow], st.phKeep)   // // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p232 сигнал батьківського рядка лишається, якщо підлеглі — інша міра); IE 2026 11 02 / ODOO-350449 (заказ Игоря: p201 баланс — «Сигнали» типово, розкритий батьківський рядок без підсумків і сигналів (hover показує), підсумок рядка без сигналів — опція): раскрытая строка-группа — все ячейки значений
            const dup = !ph && mode !== 'off' && icol >= st.bound && this.groupDup_isRepeat(flex, rows, irow, icol, st)
            const cl = e_cell.classList, want = ph ? 'gt-dup-' + st.phMode : (dup ? 'gt-dup-' + mode : '')   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p201 баланс — «Сигнали» типово, розкритий батьківський рядок без підсумків і сигналів (hover показує), підсумок рядка без сигналів — опція)
            for (const c of GROUP_DUP_CLASSES) if (c !== want && cl.contains(c)) cl.remove(c)   // кэш-путь formatItem переписывает className — сверяем по факту
            if (want && !cl.contains(want)) cl.add(want)
            if (dup) { if (e_cell.__gtDupT || !e_cell.title) { e_cell.title = t('Same as the row below'); e_cell.__gtDupT = true } }
            else if (e_cell.__gtDupT) { e_cell.removeAttribute('title'); e_cell.__gtDupT = false }
        },
        // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p201 баланс — «Сигнали» типово, розкритий батьківський рядок без підсумків і сигналів (hover показує), підсумок рядка без сигналів — опція)
        // раскрытая строка-группа (режим hide, gridRowHide.js): круги видов ячеек в ней не создаются, пока строка не под мышью (_phHoverRow — индекс строки
        // под курсором, ставит обработчик mousemove наведения строки); оба пути formatItem спрашивают здесь
        parentHide_ringOff(row) {
            const flex = this.flex
            if (!flex || !row) return false
            const st = this.groupDup_state(flex)
            return !!st.ph && parentHide_isRow(row, st.phKeep) && row !== flex.rows[this._phHoverRow ?? -1]   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p232 сигнал батьківського рядка лишається, якщо підлеглі — інша міра)
        },
        // наведение сменило строку: круги строки, с которой ушли, снимаются, у строки под мышью — рисуются (только видимые ячейки, без перерисовки грида)
        parentHide_hover(flex, r) {
            const old = this._phHoverRow ?? -1
            if (old === r) return
            this._phHoverRow = r
            if (!flex || !this.cellView_on() || !this.groupDup_state(flex).ph) return
            const vr = flex.viewRange
            for (const i of [old, r]) {
                const row = i >= 0 ? flex.rows[i] : null
                if (!parentHide_isRow(row, this.groupDup_state(flex).phKeep)) continue   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p232 сигнал батьківського рядка лишається, якщо підлеглі — інша міра)
                for (let c = vr.leftCol; c <= vr.rightCol; c++) {
                    const e = flex.cells.getCellElement(i, c)
                    if (e) this.cellView_apply(e, row.dataItem, flex.columns[c], false, row)
                }
            }
            window.__parentHide = window.__parentHide || { hover: 0, totals: 0 }
            window.__parentHide.hover++
        },
        // итог строки за период (`_total::…`): заливка проблемных сигналов снимается (оба пути formatItem — кеш-путь переписал className снимком),
        // если отчёт не включил doc.params.row_totals_signals; выключатель базы fe.ux.rowTotalsNoSignals
        // // IE 2026 11 02 / ODOO-350449 (дополнение Игоря к p217, вариант 1: развёрнутый год — приглушённый итог, свёрнутый — остаток на начало года)
        // ячейка итога года ('_total::<YYYY>::…', yearTotals_sync → this._ytInfo): развёрнутый год — приглушённая (классы yt-muted*; строка запаса —
        // «—» без заливки и «мост» кривой запаса на уровне середины Грудень → Січень; блок «Непокрито» — мелкое красное), свёрнутый — обычная, у строки
        // запаса — остаток на начало года (первый период года в горизонте) и кусок площади через него. DOM на обоих путях formatItem
        yearTotal_paint(e_cell, dataItem, col, isXlsxExport, row) {
            const yi = e_cell && this._ytInfo && col && this._ytInfo.by[col.binding]
            if (!yi) {
                if (e_cell && e_cell.__ytMode) { for (const c of YEAR_TOTAL_MODE_CLASSES) e_cell.classList.remove(c); e_cell.__ytMode = '' }
                return
            }
            if (isXlsxExport || !dataItem || typeof dataItem !== 'object' || dataItem._DLRow?.row_type === 'tab') return
            const stockInfo = yi.measure ? this.cellArea_rowInfo(dataItem, yi.measure) : null
            const stock = !!(stockInfo && stockInfo.stock)
            const mode = yearTotal_cellMode({ collapsed: yi.collapsed, muted: this._ytInfo.muted, stock, unc: !stock && yearTotal_uncIs(dataItem, e_cell.classList) })
            const want = yearTotal_modeClasses(mode)
            for (const c of YEAR_TOTAL_MODE_CLASSES) { if (want.includes(c)) { if (!e_cell.classList.contains(c)) e_cell.classList.add(c) } else if (e_cell.classList.contains(c)) e_cell.classList.remove(c) }
            e_cell.__ytMode = mode
            if (mode !== 'opening' && mode !== 'muted-stock') return
            const D = yearTotal_dates(this.cellArea_dates(yi.measure), yi.year)
            let text
            if (mode === 'opening') {
                const v = yearTotal_opening(dataItem, yi.measure, D.dates)
                text = v === null ? '' : wjcCore.Globalize.format(v, col.format || 'n0')
            } else text = '—'
            e_cell.textContent = text
            // кривая запаса (форма «Площа» у строки запаса): кусок через колонку итога
            if (!this.cellView_on() || this.parentHide_ringOff(row) || !D.dates.length) return
            const b0 = { date: D.dates[0], measure: yi.measure }
            if (this.cellShape_of(dataItem, b0) !== 'area') return
            const val = (d) => yearTotal_valueAt(dataItem, d, yi.measure)
            const A = yearTotal_areaArgs({ collapsed: yi.collapsed, prevVal: val(D.prev), opening: val(D.dates[0]) !== null ? val(D.dates[0]) : yearTotal_opening(dataItem, yi.measure, D.dates),
                lastVal: val(D.dates[D.dates.length - 1]), afterVal: val(D.next) })
            if (!A) return
            const ref = this.cellArea_of(dataItem, this.flex.columns.getColumn(`${yi.collapsed ? D.dates[0] : D.dates[D.dates.length - 1]}.${yi.measure}`), yi.collapsed ? b0 : { date: D.dates[D.dates.length - 1], measure: yi.measure })
            const seg = cellArea_segment({ prev: A.prev, value: A.value, next: A.next, max: stockInfo.max, w: col.renderWidth || col.width || 0, h: this.flex?.rows?.defaultSize || 24, color: ref && ref.color })
            if (!seg) return
            if (A.bridge) seg.path = `M0 ${seg.h} Z`   // «мост»: только линия, без заливки
            this.cellArea_put(e_cell, seg)
        },
        rowTotal_signalsPaint(e_cell, col, isXlsxExport) {
            if (isXlsxExport || !e_cell || !rowTotal_is(col?.binding) || !this.selFrame_isDataGrid()) return
            if (rowTotals_signalsOn(this.WIDGET?.record?.doc?.params, (k, d) => this.store.setting(k, d))) return
            const drop = signals_suppress(e_cell.classList)
            if (!drop.length) return
            for (const c of drop) e_cell.classList.remove(c)
            window.__parentHide = window.__parentHide || { hover: 0, totals: 0 }
            window.__parentHide.totals++
        },
        selFrame_isDataGrid() {
            const a = this.attr
            if (!a || String(a.cssClass || '').includes('attrs-tab-grid')) return false
            return a.name === 'dataSheet' || a.binding === '_doc.data'
        },
        // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ) — ревью webscm #110599: грид заперт архивом только у ДАННЫХ МОДЕЛИ — таблица данных виджета отчёта / записей версии / списка над витриной версии
        // (или карточка / строка данных целиком); вкладки настроек, формы настроек, справочники вне версии — редактируются (store.readonly_archiveGrid → utils/readonlyPolicy.ro_archiveLocksGrid)
        archiveRo() {
            return !!this.store.readonly_archiveGrid?.(this.WIDGET, this.selFrame_isDataGrid())
        },
        // флажок заголовка строк (use / position …, «выбрать всё» и одиночный) в архиве: true — отказ (чекбокс возвращён, тост). Флажок selector — выбор строки, не данные
        // (selector_noModified) — работает как обычно. restore — значение, которое вернуть чекбоксу (по умолчанию — обратное нажатому)
        archiveRo_flag(binding, e, restore) {
            if (!binding || this.selector_noModified(binding) || !this.archiveRo?.()) return false
            try { e?.preventDefault?.() } catch (err) { /* событие уже отработало */ }
            if (e?.target?.type === 'checkbox') e.target.checked = restore !== undefined ? restore : !e.target.checked
            this.store.readonly_toast('', 'edit')
            this.flexRefresh()
            return true
        },
        mergeBack_on() { return this.fmtSetting('fe.ux.gridMergeBack', true) !== false },   // IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL5
        // строка: k — первая колонка со значением в области измерений; startCol — с какой колонки растягиваем
        // (0, или 1 у строк со значком свёртки в колонке дерева); px — ширина пустых колонок между ними
        // первая колонка со значением в области измерений (−1 — нет или до неё стоит булева колонка-барьер)
        mergeBack_firstCol(p, irow, bound) {
            for (let c = 0; c < Math.min(bound, p.columns.length); c++) {
                if (p.columns[c].visible === false) continue
                if (this.attr_by_binding?.[p.columns[c].binding]?.attr_type === 'AttrBool') return -1
                let v = ''
                try { v = p.getCellData(irow, c, true) } catch (err) { v = '' }
                if (v !== '' && v != null) return c
            }
            return -1
        },
        mergeBack_info(p, irow) {
            if (!p || !this.mergeBack_on()) return null
            const bound = Math.max(this.mergeColumnBlocksTotal || 0, this.mergeColumns || 0)
            if (bound < 2) return null
            const row = p.rows[irow], dataItem = row?.dataItem
            if (!dataItem || dataItem._DLRow?.mergeRow || dataItem.MD?.mergeRow) return null
            const key = `${p.cellType}-${irow}-0`
            let _c = this.cache_data_cells.get(key)
            if (!_c) { _c = { key, index: ++this.cache_index }; this.cache_data_cells.set(key, _c) }
            if (!_c.mb) {
                const k = this.mergeBack_firstCol(p, irow, bound)
                // IE 2026 09 17 / ODOO-… (замечание Игоря: «при мерже влево делай это до первой колонки») и
                // IE 2026 09 18 («нужно до стрелочки, иначе разрыв»; «строка 130 смещена левее родителя»):
                // объединяем всегда ОТ КОЛОНКИ ДЕРЕВА (col 0). Её ячейка у wijmo несёт отступ уровня и значок
                // свёртки (у листьев — невидимый спейсер той же ширины), а значение дорисовывается ПОСЛЕ значка
                // (mergeBack_apply): текст начинается прямо у стрелочки, подчинённая строка стоит правее родителя.
                // Барьер — только булева колонка (mergeBack_firstCol).
                const startCol = 0
                _c.mb = { k, startCol }
            }
            const mb = _c.mb
            return mb.k > mb.startCol ? mb : null
        },
        // значение объединения «назад» — в его корне (левой ячейке, wijmo рисует только её): отдельным span'ом,
        // не затирая содержимое ячейки; зовётся из ХВОСТА formatItem, то есть и на кэш-пути (там содержимое
        // ячейки переписывается wijmo, и без переприменения значения «пропадали» после прокрутки)
        mergeBack_apply(e, flex, isXlsxExport) {
            const p = e?.panel, cell = e?.cell
            if (!p || !flex || p !== flex.cells || !cell) return
            const irow = e.range ? e.range.row : e.row, icol = e.range ? e.range.col : e.col
            let txt = '', chipCss = null
            if (!isXlsxExport && !this.attr.isPrint && !this.attr.isPrintTemplate) {
                const mb = this.mergeBack_info(p, irow)
                if (mb && icol === mb.startCol) {
                    try { txt = p.getCellData(irow, mb.k, true) } catch (err) { txt = '' }
                    txt = (txt === null || txt === undefined) ? '' : String(txt)
                    // IE 2026 09 18 / ODOO-5800 (Igor: «сделай Grade везде как статусы документов — в виде цветных бейджей»): колонка значения —
                    // ссылка на справочник-пилюлю (STATUS* / GRADE, isChipSegment) → значение объединения рисуется той же пилюлей с цветом
                    // элемента справочника. Выключатель fe.ux.mergeBackChip (по умолчанию вкл)
                    if (txt) chipCss = this.mergeBack_chipCss(p, irow, mb.k)
                }
            }
            const box = cell.querySelector(':scope > .cell-text-clip') || cell
            let span = box.querySelector(':scope > .merge-back-value') || cell.querySelector('.merge-back-value')
            if (!txt) {
                if (span) span.remove()
                if (cell.classList.contains('merge-back')) wjcCore.removeClass(cell, 'merge-back')
                if (cell.classList.contains('merge-back-chip')) wjcCore.removeClass(cell, 'merge-back-chip')
                return
            }
            if (!span || span.parentElement !== box) {
                if (span) span.remove()
                span = document.createElement('span')
                span.className = 'merge-back-value'
                box.appendChild(span)
            }
            // IE 2026 09 18 / ODOO-… (регресс merge «назад», найден пробой partsearch_check): значение объединения рисуется
            // своим span'ом уже ПОСЛЕ подсветки поиска formatItem — найденное в нём не подсвечивалось. Подсветка — здесь же
            let html = ''
            if (this.CHIPS_view.length || this.WIDGET?.widget_class === 'widget_SEARCH') {   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска)
                const escTxt = txt.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
                html = this.store.check_CHIPS_highlighted(this.WIDGET, escTxt, this.CHIPS_view, true) || ''   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска)
            }
            if (html) { if (span.__mbHtml !== html) { span.innerHTML = html; span.__mbHtml = html } }
            else if (span.__mbHtml || span.textContent !== txt) { span.textContent = txt; span.__mbHtml = '' }
            // ячейки wijmo переиспользуются — класс пилюли выставляется на каждом проходе (и снимается, когда значение — не пилюля)
            const spanCls = 'merge-back-value' + (chipCss === null ? '' : ' status-chip' + (chipCss ? ' ' + chipCss : ''))
            if (span.className !== spanCls) span.className = spanCls
            // IE 2026 09 18 / ODOO-5800: метка ячейки с пилюлей — её блок текста становится flex-строкой (см. стиль .merge-back-chip): пилюля,
            // не влезающая в узкую колонку на пиксель, ужимается с многоточием внутри, а не пропадает целиком (атомарный inline-block
            // при text-overflow: ellipsis браузер скрывает полностью — отчёт «Stock + Arrival», колонка Grade 48px)
            if (cell.classList.contains('merge-back-chip') !== (chipCss !== null)) cell.classList.toggle('merge-back-chip', chipCss !== null)
            if (!cell.classList.contains('merge-back')) wjcCore.addClass(cell, 'merge-back')
        },
        // класс пилюли значения объединения «назад»: null — колонка значения не пилюля; '' — пилюля без цвета элемента
        mergeBack_chipCss(p, irow, k) {
            if (this.fmtSetting('fe.ux.mergeBackChip', true) === false) return null   // IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL5
            const colK = p.columns[k]
            const attrK = colK?.binding ? this.attr_by_binding?.[colK.binding] : null
            if (!attrK || !(attrK.attr_type === 'AttrLink' || attrK.attr_type === 'AttrLinkChips') || !this.isChipSegment(attrK.relation_segment)) return null
            let raw = null
            try { raw = p.getCellData(irow, k, false) } catch (err) { raw = null }
            if (raw === null || raw === undefined || raw === '') return null
            const src = this.store.get_itemsSource(this, {}, attrK, { fetchMode: 'all' })
            return String(src?.ids?.[raw]?.cssClass || '')
        },
        // ---------------- IE 2026 10 09 / ODOO-345618 (заказ Игоря: согласование на сегменте) · F1: данные согласования строк отчёта (utils/approval.js; контракт — work-approval.md) ----------------
        // Бэк кладёт в _DLRow строки: isReadOnly / cells[b].isReadOnly (замок — его уже читает is_editable) и approval (rows_status: pill, status, locked, reason, actions, waiting_for,
        // children {total, approved}, status_at / status_by). Здесь: (1) пилюля статуса и счётчик «утверждено / всего» после заголовка строки-группы (колонка дерева, DOM в хвосте
        // formatItem — оба пути); (2) замок approval.locked строки и её подчинённых — в is_editable и в обходных путях (очистка корректировок, Undo / Redo), причина отказа — текст
        // approvalLockReason; (3) подменю «Approval» командной панели — только у записи с doc._approval. Выключатель fe.ux.approval (по умолчанию вкл.); без данных от бэка — ничего.
        approval_on() { return approval_switchOn((k, d) => this.fmtSetting(k, d)) },
        // IE 2026 10 14 / ODOO-5800 (Igor, скрин dev02 «M03 Marketing plan · CF», ячейка 357:6 ✓ при флаге у 1 документа из 8): итог группы по колонке флажка — «частично».
        // Бэк (approval_wiring.partial_flags) кладёт строке-группе значение False и мету _DLRow.cells[колонка].approval_partial {approved, total}; здесь — полузаполненный
        // (indeterminate) чекбокс и перевод подсказки (cellTooltip_html). Выключатель fe.ux.approvalFlagPartial (дефолт ВКЛ) поверх fe.ux.approval. Клик по группе — как раньше.
        // IE 2026 10 14 / ODOO-5800 (Igor, скрин 1coh_001 под чипсом «БЮ: VMS»: квадрат на заголовках групп 1 / 20 в колонке БЮМ, итог 29 «LBE 2026» ПМ ✓ при флаге у одного документа из N, без живого
        // пересчёта): итог считается ЖИВЬЁМ на фронте — utils/approval.js approvalPartialLive по строкам грида (flex.rows: уровень + dataItem): документы строки-итога — строки поддерева её родителя глубже
        // неё с тем же ключом _DLRow.where, значения — несохранённые тоже (fmtGetValue). Состояние: все ✓ → ✓, ни одного → пусто, часть → полузаполненный + подсказка «Approved partially: N of M».
        // Мета бэка approval_partial при живом расчёте не читается (она ложилась на заголовок группы). Строка-итог, которую пользователь правил сам (changesStack irow:binding), показывает его значение —
        // клик по итогу не меняется. Кэш — на проход рисования (approvalPartial_reset: refreshing / setModified / load_data / undo-redo); правка колонки флажка перерисовывает грид (approvalPartial_afterEdit).
        // Выключатель fe.ux.approvalFlagPartialLive (дефолт ВКЛ; выкл — мета бэка, как до правки) поверх fe.ux.approvalFlagPartial. irow — строка грида (без неё живой расчёт невозможен — null)
        approvalFlagPartial_of(dataItem, col_binding, value, irow) {
            if (!this.approval_on() || !approvalFlagPartialOn((k, d) => this.fmtSetting(k, d))) return null
            if (planFlagField(col_binding) && this.planFlags_on()) {   // IE 2026 10 19 / ODOO-5800 (plan flags, Igor 19.10): колонка флажка уровня плана — итог по листьям поддерева (utils/planFlags.js), лист с частичным агрегатом DS — полузаполненный
                const p = typeof irow === 'number' && irow >= 0 ? this.planFlagPartial_live(dataItem, col_binding, irow) : null
                return p ? { approved: p.approved, total: p.total, state: p.state } : null
            }
            if (approvalFlagPartialLiveOn((k, d) => this.fmtSetting(k, d))) {   // IE 2026 10 14 / ODOO-5800 (Igor): живой расчёт
                const p = typeof irow === 'number' && irow >= 0 ? this.approvalPartial_live(dataItem, col_binding, irow) : null
                return p ? { approved: p.approved, total: p.total, state: approvalPartialState(p) } : null
            }
            const p = approvalFlagPartial(dataItem, col_binding, value)
            return p ? { approved: p.approved, total: p.total, state: 'part' } : null
        },
        approvalPartial_cols() {   // IE 2026 10 14 / ODOO-5800 (Igor): привязки колонок флажков — по шагам политики (doc._approval.flags / step_info), не по названию
            let c = this._apprFlagCols
            if (!c) {
                const _bindings = Object.keys(this.attr_by_binding || {})
                let _list = approvalFlagBindings(approvalDoc(this.WIDGET?.record?.doc), _bindings)
                // IE 2026 10 18 / ODOO-5800 (Igor, п. 3: M03 возвращён на флажки, политики у сегмента нет — doc._approval пуст, итоги групп пропали): без шагов политики — колонки
                // флажков M03 по полям ApprovedPM / ApprovedBUM / ApprovedMD (utils/m03Flags.js), итог «частично / все ✓» считается как прежде (fe.ux.m03FlagsLocal, дефолт ВКЛ)
                if (!_list.length && this.m03Flags_on()) _list = m03FlagBindings(_bindings)
                c = this._apprFlagCols = new Set(_list)
            }
            return c
        },
        approvalPartial_live(dataItem, col_binding, irow) {   // IE 2026 10 14 / ODOO-5800 (Igor): {approved, total} строки-итога либо null; кэш на проход рисования
            const flex = this.flex
            if (!flex || !dataItem || this.attr?.attr_type === 'AttrTabGrid' || this.attr?.isPrintTemplate) return null
            if (!this.approvalPartial_cols().has(col_binding)) return null
            if (this.changesStack?.[`${irow}:${col_binding}`]) return null   // пользователь правил саму строку-итог — его значение, как раньше
            let C = this._apprPartialCache
            if (!C || C.rows !== flex.rows) C = this._apprPartialCache = { rows: flex.rows, map: new Map() }
            const k = irow + ':' + col_binding
            if (C.map.has(k)) return C.map.get(k)
            const row = flex.rows[irow]
            const idx = row && row.dataItem === dataItem && this.approvalPartial_incOn() ? this.approvalPartial_index() : null   // IE 2026 10 14 / ODOO-5800 (app7 #84309): по индексу — O(корзина), не проход поддерева
            const p = row && row.dataItem === dataItem ? (idx ? approvalPartialLiveIdx(idx, flex.rows, irow, col_binding, (x, b) => this.fmtGetValue(x, b)) : approvalPartialLive(flex.rows, irow, col_binding, (x, b) => this.fmtGetValue(x, b))) : null
            C.map.set(k, p)
            return p
        },
        approvalPartial_reset() { this._apprPartialCache = null },   // IE 2026 10 14 / ODOO-5800 (Igor): данные / порядок строк изменились
        // IE 2026 10 14 / ODOO-5800 (app7 #84309, бой ev31, срез 1coh_001 Pimafucin №3: 20 375 строк = 1 211 заголовков, 4 482 итога, 14 682 документа — клик ✓ПМ у документа: DOM через
        // 5 167 мс, longtask): до правки каждый итог на проходе рисования сканировал поддерево родителя (approvalPartialLive), setModified сбрасывал кэш целиком, а approvalPartial_afterEdit
        // перерисовывал грид целиком (flexRefresh = apply_CHIPS + formatItem по всем видимым ячейкам). Теперь: индекс «итог → документы» (approvalPartialIndex) строится один раз на
        // набор строк (flex.rows; сбрасывается collectionChanged — load_data / отбор / сортировка; свёртка строки не меняют), итог — по своей корзине; правка документа сбрасывает
        // кэш только итогов-предков (approvalPartialAffected) и перерисовывает только их ячейки колонки (flex.refreshRange + клон замороженных). Выключатель
        // fe.ux.approvalFlagPartialIncremental (дефолт ВКЛ; выкл — как до правки). Тест — tests/unit/approvalFlagPartial.test.mjs (синтетика 20 тыс. строк, замер)
        approvalPartial_incOn() { return approvalFlagPartialIncrementalOn((k, d) => this.fmtSetting(k, d)) },
        approvalPartial_index() {   // индекс текущих flex.rows; null — грида нет
            const flex = this.flex
            if (!flex || !flex.rows) return null
            let I = this._apprPartialIdx
            if (!I || I.rows !== flex.rows || I.idx.n !== flex.rows.length) {
                const rows = flex.rows
                I = this._apprPartialIdx = { rows, idx: approvalPartialIndex(rows) }
                if (!rows.__apprIdxHook) {   // новые / переставленные строки — индекс заново (лениво, при первом итоге)
                    rows.__apprIdxHook = true
                    try { rows.collectionChanged.addHandler(() => { this._apprPartialIdx = null }) } catch (e) { /* не ObservableArray */ }
                }
            }
            return I.idx
        },
        approvalPartial_invalidate(irow, dataItem, col_binding) {   // сброс кэша итогов-предков правленной строки (null col_binding — все колонки флажков); → строки итогов либо null (сброшено целиком)
            const C = this._apprPartialCache
            if (!C) return []
            if (!this.approvalPartial_incOn()) { this._apprPartialCache = null; return null }
            const idx = this.approvalPartial_index()
            if (!idx) { this._apprPartialCache = null; return null }
            let r = typeof irow === 'number' && irow >= 0 ? irow : -1
            if (r < 0 && dataItem) { const i = idx.byItem.get(dataItem); r = typeof i === 'number' ? i : -1 }
            if (r < 0 || (dataItem && this.flex?.rows?.[r]?.dataItem !== dataItem)) { this._apprPartialCache = null; return null }
            const aff = approvalPartialAffected(idx, r)
            const cols = col_binding ? [col_binding] : [...this.approvalPartial_cols()]
            for (const t of aff) for (const b of cols) C.map.delete(t + ':' + b)
            return aff
        },
        // перерисовать ячейки итогов (строки rowsIdx) колонки col_binding — только отрисованные (viewRange): прямое cellFactory.updateCell ячейки + замена её копии в клоне
        // замороженных ([wj-part="fcells"] _fCt — копии .wj-frozen по порядку, как строит wijmo _updateFrozenCells); иначе (редактор открыт / клон не сходится) — один
        // refreshRange на диапазон строк (замер dev02: refreshRange одной ячейки ≈ 58 мс — wijmo пересобирает клон замороженных целиком)
        approvalPartial_refreshCells(rowsIdx, col_binding) {
            const flex = this.flex
            if (!flex || !flex.hostElement || !rowsIdx || !rowsIdx.length) return 0
            const col = flex.columns.getColumn(col_binding)
            if (!col || col.index < 0) return 0
            let vr = null
            try { vr = flex.viewRange } catch (e) { vr = null }
            const todo = rowsIdx.filter(r => !vr || (r >= vr.row && r <= vr.row2))
            if (!todo.length) return 0
            const c = col.index, cells = flex.cells, cf = flex.cellFactory
            let n = 0, fail = !(cf && typeof cf.updateCell === 'function') || !!flex.activeEditor
            if (!fail) for (const r of todo) {
                let el = null
                try { el = cells.getCellElement(r, c) } catch (e) { el = null }
                if (!el) continue
                try {
                    cf.updateCell(cells, r, c, el, flex.getMergedRange(cells, r, c))
                    if (!this.approvalPartial_cloneCell(flex, el)) { fail = true; break }
                    n++
                } catch (e) { fail = true; break }
            }
            if (fail) {
                try { flex.refreshRange(new wjGrid.CellRange(Math.min(...todo), c, Math.max(...todo), c)); n = todo.length } catch (e) { /* грид закрыт */ }
            }
            return n
        },
        approvalPartial_cloneCell(flex, el) {   // копия ячейки el в клоне замороженных — свежим cloneNode (позиция — стиль старой копии); false — клон не сходится с .wj-frozen (нужен refreshRange)
            const fct = flex._fCt, ect = flex._eCt
            if (!fct || !ect || !fct.childElementCount || !el.classList.contains('wj-frozen')) return true
            const fro = ect.querySelectorAll('.wj-frozen')
            if (fct.childElementCount !== fro.length) return false
            let i = -1
            for (let k = 0; k < fro.length; k++) if (fro[k] === el) { i = k; break }
            const old = i >= 0 ? fct.children[i] : null
            if (!old) return false
            const nu = this.editRefresh_cloneOf(el, old)   // IE 2026 10 14 / ODOO-5800 (pfperf3): с индексом ячейки wijmo — иначе второй клик по чекбоксу в клоне не попадал в ячейку
            fct.replaceChild(nu, old)
            return true
        },
        // IE 2026 10 14 / ODOO-5800 (CDP-профиль dev02 pfperf3, 20 тыс. строк: после первого клика ✓PM второй клик по той же ячейке ничего не делал): копия ячейки в клоне замороженных —
        // cloneNode без экспандо wijmo GridPanel._INDEX_KEY ({row, col, rng, panel}; wijmo кладёт его и на свои копии в _updateFrozenCells), а HitTestInfo(element) из
        // _MouseHandler._click берёт строку / колонку именно из него: без ключа клик по чекбоксу копии давал row −1 и startEditing не начинался. Ключ — ссылкой на тот же
        // объект, что у оригинала (как у wijmo). Позиция — стиль старой копии
        editRefresh_cloneOf(el, old) {
            const nu = el.cloneNode(true)
            nu.style.cssText = old.style.cssText
            try { this.frozenClone_copyPos(el, nu) } catch (e) { /* позиция старой копии */ }   // IE 2026 10 15 / ODOO-5800: top/left — по штампу состояния el (ячейка могла быть нарисована в правке), не по старой копии
            try { const K = wjGrid.GridPanel._INDEX_KEY; if (K && el[K]) nu[K] = el[K] } catch (e) { /* без ключа — как раньше */ }
            return nu
        },
        // чекбокс у выделенной булевой ячейки (boolSel_apply, ODOO-345618) — в НАСТОЯЩУЮ ячейку выделения и её копию в клоне: после refreshRange строки правки (editRefresh_rows)
        // divCells держит другой элемент той же позиции, и boolSel_sync по release клика рисует не туда (замер dev02: divCells.get(key) !== cells.getCellElement); раньше это
        // скрывала полная перерисовка грида из approvalPartial_afterEdit. Отложенно (setTimeout 0) — после release удержания кнопки (_boolSelHold)
        // IE 2026 10 15 / ODOO-5800 (Igor 15.10: «если ставится флаг "2028", то предыдущие флаги ставятся автоматом, и наоборот — … как на бэке, так и на фронте»): ответ save (gridSaved) несёт cascade_rows —
        // флажки соседних лет того же документа и шага, которые поставил / снял бэк (approval.flags_input, хвост годов). Чекбоксы строк тех же документов / лет правятся в гриде без Save и до re-select
        // статусов (utils/approval.js approvalCascadeApply: по _DLRow.record_id + ключу отбора data::year / data::measure); до ответа соседи не трогаются (отказ бэка — тост, рассинхрона нет).
        // Выключатель fe.ux.approvalYearIntegrity (дефолт ВКЛ; выкл — соседей обновит re-select статусов, как раньше). → число правленых ячеек
        approvalCascade_apply(cascade) {
            if (!Array.isArray(cascade) || !cascade.length || !this.approval_on() || !approvalYearIntegrityOn((k, d) => this.fmtSetting(k, d))) return 0
            const flex = this.flex
            if (!flex || !flex.rows || !(flex.rows.length > 0)) return 0
            const bindings = [...this.approvalPartial_cols()]
            if (!bindings.length) return 0
            const done = approvalCascadeApply(flex.rows, cascade, bindings, (x, b) => this.fmtGetValue(x, b), (x, b, v) => this.store.set_value(x, b, v, null, null, null, false))
            if (done.length) {
                try { this.approvalPartial_reset() } catch (e) { /* кэша итогов нет */ }
                try { flex.refresh() } catch (e) { /* грид закрыт */ }
                if (!this.store.hide_console) console.log(`[${this.WIDGET?.id}] approval: cascade_rows — ${done.length} cell(s) of sibling years follow the server verdict`)
            }
            return done.length
        },
        approvalPartial_boolSel() {
            const flex = this.flex
            if (!flex || !flex.hostElement || flex.activeEditor || !this.boolSel_on()) return
            const sel = flex.selection
            if (!sel || sel.row < 0 || sel.col < 0) return
            const el = flex.cells.getCellElement(sel.row, sel.col)
            if (!el) return
            this.boolSel_apply(el, sel.row, sel.col)
            this.approvalPartial_cloneCell(flex, el)
        },
        approvalPartial_afterEdit(col_binding, irow, dataItem) {   // IE 2026 10 14 / ODOO-5800 (Igor): правка флажка документа — итоги по колонке перерисовать (flexRefresh — отложенный, один на пачку)
            const inc = this.approvalPartial_incOn()   // IE 2026 10 14 / ODOO-5800 (app7 #84309): только предки, только их ячейки
            if (!inc) this._apprPartialCache = null
            if (this.attr?.attr_type === 'AttrTabGrid' || !this.approval_on() || !approvalFlagPartialOn((k, d) => this.fmtSetting(k, d)) || !approvalFlagPartialLiveOn((k, d) => this.fmtSetting(k, d))) return
            if (!this.approvalPartial_cols().has(col_binding)) return
            if (inc) {
                const aff = this.approvalPartial_invalidate(irow, dataItem, col_binding)
                if (aff) {
                    this.approvalPartial_refreshCells(aff, col_binding)
                    window.$cg.setTimeout(this, 'AttrGrid.approvalPartial_boolSel', () => { try { this.approvalPartial_boolSel() } catch (e) { /* грид закрыт */ } }, 0)
                    return
                }
            }
            this.flexRefresh()
        },
        // IE 2026 10 18 / ODOO-5800 (Igor, п. 4: «БЮМ → поставить ApprovedBUM на все загруженные строки с теми же Бизнес юниты + бренд + БиТ_Регионы, без учёта Сводной номенклатуры;
        // для МД — на всех строках того же БЮ без учёта Бит_регионы»): каскад на фронте при УСТАНОВКЕ флажка — цели по utils/m03Flags.js m03CascadeTargets (строки-документы грида в памяти
        // с тем же ключом меры / года и теми же измерениями doc.БЮ / doc.Бренд / doc.Страна; снятие — только своя строка; порядок шагов — fe.ux.m03CascadeOrder), каждая — через set_value
        // (стек отмены, changesStack, _meta.modified — уходят одним Save вместе с кликнутой), затем сброс кэша итогов и перерисовка грида (итоги групп, условное оформление «locked (BUM|MD)»
        // по живым значениям). Защита от повторного входа — _m03Cascading. Выключатели fe.ux.m03FlagsLocal / fe.ux.m03Cascade (дефолт ВКЛ)
        m03Flags_on() { return m03FlagsLocalOn((k, d) => this.fmtSetting(k, d)) },
        // IE 2026 10 19 / ODOO-5800 (plan flags, Igor 19.10): булевы флажки согласования уровней планов (страницы 13–18 стола 0af_001, колонки approved_customer / _market / _portfolio / _company группы «Approved»,
        // источник DS-PLAN-LEVEL-DOCS). Итог строки-группы — живьём по листьям её поддерева (utils/planFlags.planFlagPartial: все ✓ → ✓, ни одного → пусто, часть → полузаполненный;
        // лист с частичным агрегатом DS approved_partial — полузаполненный); кэш — тот же, что у итогов M03 (approvalPartial_reset). Строка-итог, правленная пользователем
        // (changesStack), показывает его значение. Выключатель fe.ux.planFlags (дефолт ВКЛ; выкл — итог группы = «any» бэка, каскада нет)
        planFlags_on() { return planFlags_on((k, d) => this.fmtSetting(k, d)) },
        planFlagPartial_live(dataItem, col_binding, irow) {
            const flex = this.flex
            if (!flex || !dataItem || this.attr?.attr_type === 'AttrTabGrid' || this.attr?.isPrintTemplate) return null
            if (this.changesStack?.[`${irow}:${col_binding}`]) return null
            let C = this._apprPartialCache
            if (!C || C.rows !== flex.rows) C = this._apprPartialCache = { rows: flex.rows, map: new Map() }
            const k = 'pf:' + irow + ':' + col_binding
            if (C.map.has(k)) return C.map.get(k)
            const row = flex.rows[irow]
            const p = row && row.dataItem === dataItem ? planFlagPartial(flex.rows, irow, col_binding, (x, b) => this.fmtGetValue(x, b)) : null
            C.map.set(k, p)
            return p
        },
        // IE 2026 10 19 / ODOO-5800 (plan flags, Igor 19.10): клик по флажку строки-группы — та же отметка на все листья её поддерева (установка и снятие симметричны; листья, запертые бэком или правилом CF
        // isReadOnly, — мимо), каждый лист — через set_value (стек отмены, changesStack, modified — уходят одним Save; бэк plan_flags переводит статусы документов уровня
        // страницы по измерениям ячеек). Правка любой ячейки флажка сбрасывает кэш итогов и перерисовывает грид. Защита от повторного входа — _planCascading
        planFlags_afterEdit(col_binding, irow, dataItem, newVal) {
            if (this._planCascading || !planFlagField(col_binding) || !this.planFlags_on()) return
            if (this.attr?.attr_type === 'AttrTabGrid' || this.attr?.isPrintTemplate) return
            const flex = this.flex
            if (!flex || !flex.rows || !(flex.rows.length > 0)) return
            const r = (typeof irow === 'number' && irow >= 0 && flex.rows[irow]?.dataItem === dataItem) ? irow : this.rows_indexOf(dataItem)
            let n = 0
            if (r >= 0) {
                const canSet = (x) => { try { return !this.cf_formatProps(x, col_binding, this.attr_by_binding?.[col_binding])?.isReadOnly } catch (e) { return true } }
                const targets = planFlagCascadeTargets(flex.rows, r, col_binding, (x, b) => this.fmtGetValue(x, b), newVal, canSet)
                if (targets.length) {
                    this._planCascading = true
                    try {
                        for (const t of targets) this.set_value(t.irow, t.dataItem, col_binding, this.fmtGetValue(t.dataItem, col_binding), newVal === true || newVal === 1 || newVal === 'true', true, null, false)
                    } finally { this._planCascading = false }
                    n = targets.length
                }
            }
            try { this.approvalPartial_reset() } catch (e) { /* кэша итогов нет */ }
            this.flexRefresh()
            if (n && !this.store.hide_console) console.log(`[${this.WIDGET?.id}] plan flags: ${col_binding} ${newVal ? 'set' : 'clear'} cascade — ${n} row(s) of the group`)
        },
        // IE 2026 10 18 / ODOO-5800 (Igor, скрин: родитель бренда STR 2029 с частичным ПМ (36.6), а на SKU 74.7 поставили БЮМ): порядок по АГРЕГАТУ измерения шага — ставить БЮМ можно, только когда ПМ стоит
        // на всех загруженных строках того же БЮ + бренд (+ страна) с той же мерой / годом, МД — когда БЮМ на всех строках той же БЮ (utils/m03Flags.m03AggregateOrder над целями каскада). Снятие (флажок стоит)
        // агрегат не держит; пометка бэка (политика) — решает бэк. null — правило не применимо; иначе {ok, missing}. Выключатель fe.ux.m03AggregateOrder (дефолт ВКЛ) под fe.ux.m03FlagsLocal
        m03Flag_aggOrder(irow, binding) {
            if (!this.m03Flags_on() || !this.approval_on() || this.fmtSetting('fe.ux.m03AggregateOrder', true) === false) return null
            if (this.attr?.attr_type === 'AttrTabGrid' || this.attr?.isPrintTemplate) return null
            const flex = this.flex, di = flex?.rows?.[irow]?.dataItem
            if (!di || binding == null || !this.approvalPartial_cols().has(binding) || !m03CascadeDims(binding)) return null
            if (approvalFlagMark(di, binding) || m03FlagTrue(this.fmtGetValue(di, binding))) return null
            return m03AggregateOrder(flex.rows, irow, binding, (x, b) => this.fmtGetValue(x, b), m03LowerBindings(binding, [...this.approvalPartial_cols()]))
        },
        // IE 2026 10 18 / ODOO-5800 (Igor: «каскад должен быть СИММЕТРИЧНЫМ»): снятие БЮМ — снять ApprovedBUM на тех же целях (БЮ + бренд + страна), снятие МД — на всех строках той же БЮ,
        // снятие ПМ — только своя строка; флажки ниже у целей остаются (МД снят — БЮМ стоит, но редактируем по живому замку), цели с поставленным флажком выше — мимо (упорядочение, fe.ux.m03CascadeOrder)
        m03Flags_afterEdit(col_binding, irow, dataItem, newVal) {
            if (this._m03Cascading) return
            const _clear = !m03FlagTrue(newVal)
            if (this.attr?.attr_type === 'AttrTabGrid' || this.attr?.isPrintTemplate) return
            const _st = (k, d) => this.fmtSetting(k, d)
            if (!this.approval_on() || !m03FlagsLocalOn(_st) || !m03CascadeOn(_st)) return
            const flex = this.flex
            if (!flex || !flex.rows || !(flex.rows.length > 0)) return
            if (!this.approvalPartial_cols().has(col_binding) || !m03CascadeDims(col_binding)) return
            const r = (typeof irow === 'number' && irow >= 0 && flex.rows[irow]?.dataItem === dataItem) ? irow : this.rows_indexOf(dataItem)
            if (!(r >= 0)) return
            const _ord = m03CascadeOrderOn(_st), _cols = [...this.approvalPartial_cols()]
            const lower = _ord && !_clear ? m03LowerBindings(col_binding, _cols) : [], upper = _ord && _clear ? m03UpperBindings(col_binding, _cols) : []   // IE 2026 10 18 / ODOO-5800: симметрия
            const res = m03CascadeTargets(flex.rows, r, col_binding, (x, b) => this.fmtGetValue(x, b), { clear: _clear, lower, upper, canSet: (x) => !m03CellLocked(x, col_binding) })
            if (!res.targets.length) return
            this._m03Cascading = true
            try {
                for (const t of res.targets) this.set_value(t.irow, t.dataItem, col_binding, this.fmtGetValue(t.dataItem, col_binding), _clear ? newVal : true, true, null, false)
            } finally { this._m03Cascading = false }
            try { this.approvalPartial_reset() } catch (e) { /* кэша итогов нет */ }
            this.flexRefresh()
            if (!this.store.hide_console) console.log(`[${this.WIDGET?.id}] m03 flags: ${col_binding} ${_clear ? 'clear ' : ''}cascade — ${res.targets.length} row(s) by step dimensions${res.missingDims.length ? ' (dimension not loaded: ' + res.missingDims.join(', ') + ')' : ''}`)
        },
        approvalFlagPartial_apply(e_cell, dataItem, col_binding, value, irow) {
            const p = this.approvalFlagPartial_of(dataItem, col_binding, value, irow)
            if (!p) {
                if (e_cell.classList.contains('approval-partial') || e_cell.classList.contains('approval-agg')) e_cell.classList.remove('approval-partial', 'approval-agg')   // IE 2026 10 14 / ODOO-5800: снимок className кэш-пути
                return false
            }
            if (p.state === 'none') {   // IE 2026 10 14 / ODOO-5800 (Igor): ни у одного документа — пусто (и когда агрегат бэка «any» дал true)
                e_cell.innerHTML = ''
                e_cell.classList.remove('approval-partial'); e_cell.classList.add('checkbox', 'approval-agg')
                return true
            }
            let c = e_cell.querySelector('input[type=checkbox]')
            if (!c) { c = document.createElement('input'); c.type = 'checkbox'; c.className = 'wj-cell-check'; c.tabIndex = -1; e_cell.innerHTML = ''; e_cell.appendChild(c) }
            if (p.state === 'all') {   // IE 2026 10 14 / ODOO-5800 (Igor): у всех документов — ✓ (и когда значение строки ещё null / false)
                c.checked = true; c.indeterminate = false; c.classList.remove('approval-partial-chk')
                e_cell.classList.remove('approval-partial'); e_cell.classList.add('checkbox', 'approval-agg')
                return true
            }
            c.checked = false
            c.indeterminate = true
            c.classList.add('approval-partial-chk')
            e_cell.classList.remove('approval-agg')
            wjcCore.addClass(e_cell, 'checkbox approval-partial')
            e_cell.title = ''
            return true
        },   // IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL5
        approval_of(dataItem) { return this.approval_on() ? approvalOf(dataItem) : null },
        // закрытая строка (сама либо потомок строки-группы) → её approval, иначе null
        approval_lock(dataItem) { return dataItem && this.approval_on() ? approvalLockOf(dataItem, this.attr.childItemsPath || '') : null },
        // IE 2026 10 09 / ODOO-345618 (F2, REPORT-D 2.9): флажковый ввод (M03) — строка закрыта ПО ДАННЫМ (approval.data_locked): approval.locked = false, закрытые ячейки помечает бэк
        // (_DLRow.cells[колонка].isReadOnly — is_editable их уже читает), флажки остаются редактируемыми по решению движка. Обходные пути (очистка корректировок, Undo / Redo) смотрят ячейку:
        // approval_cellLock — строка закрыта целиком либо ячейка помечена бэком в строке (потомке группы) с data_locked → approval закрытой строки, иначе null
        approval_dataLock(dataItem) { return dataItem && this.approval_on() ? approvalDataLockOf(dataItem, this.attr.childItemsPath || '') : null },
        approval_cellLock(dataItem, col_binding) {
            if (!dataItem || !this.approval_on()) return null
            const cp = this.attr.childItemsPath || ''
            const _rl = approvalLockOf(dataItem, cp)
            if (_rl) return _rl
            const _dl = approvalCellDataLock(dataItem, col_binding, cp)
            return _dl && !this.approvalFlag_open(dataItem, col_binding) ? _dl : null   // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL4: флажок, открытый живым порядком
        },
        // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL4 (Igor: «раньше при изменении флага ПМ открывался доступ для изменения флага БЮМ»): флажок шага, закрытый бэком «по порядку»
        // (noedit-approval-order), открыт, когда в строке уже поставлены (в том числе не сохранены) флажки шагов ниже — как решал прежний код отчёта M03 по живому значению; pre_write проводит их одним Save по
        // порядку шагов. Снят флажок ниже — снова закрыт. Причины no-right / locked / button / branch не открываются. Читают is_editable / beginningEdit (через cf_formatProps), обходные пути
        // (approval_cellLock) и серая заливка (approvalClosed_paint). Выключатель fe.ux.approvalFlagsLiveOrder (по умолчанию вкл.; false — пометка бэка действует до Save, как до FL4)
        // IE 2026 10 18 / ODOO-5800 (Igor, замечание 1: «МД спочатку потребує ПМ і БЮМ» при поставленных в строке ПМ и БЮМ): M03 вернулся на схему флажками —
        // политики у сегмента нет (doc.approval.use=false), doc._approval не приходит, approvalFlagSteps пуст → живой порядок FL4c молчал, и класс
        // noedit-approval-order правила CF «ApprovedMD order (BUM first)», посчитанный до клика по БЮМ, держал МД закрытым с тостом по всему списку шагов.
        // Шаги без политики — по колонкам флажков грида (utils/m03FlagsLocal.m03FlagSteps); с политикой — как раньше. Выключатель fe.ux.m03FlagsLocal (дефолт ВКЛ)
        approvalFlag_steps() {
            return m03FlagSteps(approvalDoc(this.WIDGET?.record?.doc), Object.keys(this.attr_by_binding || {}), (k, d) => this.fmtSetting(k, d))
        },
        // IE 2026 10 18 / ODOO-5800 (Igor, остаток: снять БЮМ сразу после снятия МД): у ячейки класс noedit-approval-locked от правила CF — в cssClass колонки, кэше css_user или DOM (те же источники, что у is_editable / readOnly_reason)
        m03Flag_lockedClass(e, attr_col) {
            const _cls = (attr_col?.cssClass || '') + ' ' + (this.get_cache2(e)?._cache2?.css_user || '') + ' ' + (this.divCells.get(`${this.flex?.cells?.cellType}-${e.row}-${e.col}`)?.className || '')
            return /\bnoedit-approval-locked\b/.test(_cls)
        },
        approvalFlag_open(dataItem, binding, hookOrder = false) {
            if (!dataItem || binding == null) return false
            // IE 2026 10 14 / ODOO-345618 (заказ Игоря: флажки по порядку без Save) — FL4c: hookOrder — класс noedit-approval-order пришёл от python-хука отчёта (пометки cells[] бэка у ячейки нет; ПМ-копия 1ot9_001): тот же живой порядок
            // без пометки. Пометка бэка с другим кодом (no-right / locked / button / branch) — закрыто всегда
            const _mk = approvalFlagMark(dataItem, binding)
            if (_mk ? _mk.code !== 'approval-order' : !hookOrder) return false
            if (this.fmtSetting('fe.ux.approvalFlagsLiveOrder', true) === false || !this.approval_on()) return false   // IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL5
            // IE 2026 10 14 / ODOO-345618 (заказ Игоря: флажки по порядку без Save) — FL4b: без ворот права на роль шага (checkAccess_py): код права бэк шлёт отдельно (noedit-no-right), право проверит pre_write при Save
            const _steps = this.fmtPerf('apprSteps', () => this.approvalFlag_steps())   /* IE 2026 10 18 / ODOO-5800: шаги и без политики (fe.ux.m03FlagsLocal) */, _read = (b) => this.fmtGetValue(dataItem, b)
            return _mk ? approvalFlagLiveOpen(dataItem, binding, _steps, _read) : approvalFlagLiveOrder(binding, _steps, _read)   // IE 2026 10 14 / ODOO-345618 (заказ Игоря: флажки по порядку без Save) — FL4c   // IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL5: fmtGetValue
        },
        // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — M2-1: ячейка, закрытая согласованием, выглядит закрытой — серая заливка (класс appr-closed), а не персиковая «редактируемая»: editable в её классах
        // приходит от python-хука отчёта (он про флажки и роли, о статусе согласования не знает: в DOM «noedit-locked editable»), и у запертых ячеек M03 был тот же фон, что у открытых. Красится то, что бэк объявил
        // закрытым (utils/approval.js approvalClosedKind) — в обоих режимах одинаково: пометка бэка у ячейки (флажковый ввод: data_locked + cells[b].isReadOnly; флажок, который движок не принял бы) либо замок самой
        // строки (режим действий: approval.locked — закрыта вся строка). Класс сверяется по факту на обоих путях formatItem (кэш-путь переписывает className снимком); печать / выгрузка и таблицы без doc._approval —
        // класса нет. Выключатель fe.ux.approvalClosedFill (по умолчанию вкл.). F8 / F8b (10.10): красятся числовые и логические (флажки) колонки — см. ниже, выключатель fe.ux.approvalClosedFillValuesOnly
        approvalClosed_paint(e_cell, dataItem, e_col, isXlsxExport) {
            let on = false
            if (dataItem && !isXlsxExport && this.approvalPaint_gate().on) {   // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL2: условия прохода — approvalPaint_gate
                const col = this.flex?.columns?.[e_col], b = col?.binding   // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ): колонка нужна и для типа
                // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — F8 / F8b: серым красятся ячейки ЗНАЧЕНИЙ и ФЛАЖКОВ согласования — числовые и логические (checkbox) колонки (approvalClosedValueCol: wijmo dataType Number / Boolean либо attr_type такой же).
                // Подписи, измерения, текст, ссылки и даты остаются закрытыми для ввода (noedit-*, is_editable), но без заливки; флажок серый, когда его закрыл бэк («закрыт по порядку», закрытая версия) — иначе не видно, что он заблокирован. Решается по колонке и строке на КАЖДОМ
                // вызове (хвост formatItem, оба пути): класс, пришедший из снимка className на подписи, снимается. Тип колонки проверяется первым (дёшево); выключатель fe.ux.approvalClosedFillValuesOnly (по умолчанию вкл.; false — прежний вид: вся закрытая строка) читается только на колонках не значений
                on = b != null && (approvalClosedValueCol(col, wjcCore.DataType.Number, wjcCore.DataType.Boolean) || !this.approvalPaint_gate().valuesOnly) && approvalClosedKind(dataItem, b, this.attr.childItemsPath || '') !== '' && !this.approvalFlag_open(dataItem, b)   // IE 2026 10 10 / ODOO-345618 — FL4: открыт живым порядком — не серый
            }
            if (e_cell.classList.contains('appr-closed') !== on) e_cell.classList.toggle('appr-closed', on)
        },
        // IE 2026 10 18 / ODOO-5800 (Igor, п. 5 плана: отчёты планов по уровням — DL2 WIDGET-REPORT2 над SALES-CALC-<уровень>; «плашка — треугольник в углу ячейки, показывающий, что в этой ячейке есть ручная корректировка»):
        // чистая логика — utils/planLevels.js (контракт меты строки / ячейки там же); здесь — применение к DOM на хвосте formatItem (оба пути). Выключатель fe.ux.planLevels (дефолт ВКЛ), читается
        // через fmtSetting (один store.setting на проход рисования). Печать / выгрузка — без классов. У строк без плановой меты (M03, Баланс) planCell_classes даёт [] — классы только снимаются, если были
        planLevels_on() { return planLevels_on((k, d) => this.fmtSetting(k, d)) },   // IE 2026 10 18 / ODOO-5800
        planCell_paint(e_cell, dataItem, e_col, isXlsxExport) {   // IE 2026 10 18 / ODOO-5800
            let want = null
            let hint = ''   // IE 2026 10 19 / ODOO-5800 (KAM seed): подсказка «Base changed after your adjustment» ячейки с plan-base-changed
            if (dataItem && !isXlsxExport && !this.attr.isPrint && !this.attr.isPrintTemplate && this.planLevels_on()) {
                const b = this.flex?.columns?.[e_col]?.binding
                if (b != null) { want = planCell_classes(dataItem, b); hint = planCell_hint(dataItem, b) }   // IE 2026 10 19 / ODOO-5800
            }
            planCell_applyClasses(e_cell.classList, want)
            if (hint) { if (e_cell.title !== hint) e_cell.title = hint; e_cell.__planHint = true }   // IE 2026 10 19 / ODOO-5800
            else if (e_cell.__planHint) { e_cell.__planHint = false; e_cell.removeAttribute('title') }   // IE 2026 10 19 / ODOO-5800: своя подсказка снимается, чужая не трогается
        },   // IE 2026 10 18 / ODOO-5800
        planHeader_paint(e_cell, attr_col, e_panel, e_row, e_col) {   // IE 2026 10 18 / ODOO-5800: заголовок колонки — полоса горизонта (класс снимается, если колонка без горизонта / флаг выкл)
            let cls = (attr_col && !this.attr.isPrint && !this.attr.isPrintTemplate && this.planLevels_on()) ? planHeader_class(attr_col) : ''
            if (cls && e_panel && !this.planHeader_isBottomRow(e_panel, e_row, e_col)) cls = ''   // IE 2026 10 19 / ODOO-5800 (Igor: «подчёркивание на всех колонках»): полоса один раз на колонку — только в нижней строке шапки (у групп лет / месяцев и у строк свёрнутого года выше — нет)
            planHeader_applyClass(e_cell.classList, cls)
        },   // IE 2026 10 18 / ODOO-5800
        planHeader_isBottomRow(e_panel, e_row, e_col) {   // IE 2026 10 19 / ODOO-5800: ячейка шапки лежит в нижнем ряду ТИТУЛОВ панели (сама или объединением по вертикали)
            const rows = e_panel.rows
            if (!rows) return true
            // служебные ряды внизу шапки — номера колонок (columnNumberRow), mapped-ряд, sticky-ряды (скрытые) — не титулы и через planHeader_paint не идут:
            // нижний ряд = последний видимый ряд титулов (как hierSort_arrowRow), иначе полоса пропадала везде при включённых номерах колонок
            const service = (r) => r === this.columnNumberRow || (this.isMappedWidget_rows && r === this.isMappedWidget_rows) || (this.stickyScrollStart != null && r >= this.stickyScrollStart)
            let last = rows.length - 1
            while (last > 0 && (!rows[last].visible || service(last))) last--
            if (e_row == null || e_row >= last) return true
            try { const mr = this.flex && this.flex.getMergedRange(e_panel, e_row, e_col, false); return !!mr && mr.row2 >= last } catch (e) { return false }
        },   // IE 2026 10 19 / ODOO-5800
        // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B): кнопка «Plan approval» шапки (меню по видам планов, сводка plan_decision_summary по объектам строк отчёта),
        // решения plan_decision (сначала dry: true — подтверждение списка позиций), окно History (plan_decision_history → store.approvalHistory_open), пилюля строки.
        // Логика — utils/planApproval; флаг fe.ux.planApproval (выкл — кнопки и пилюли нет, отчёт как прежде)
        planApproval_isOn() { return planApproval_on((k, d) => this.store.setting(k, d)) },
        planApproval_applies() {
            try {
                if (!this.planApproval_isOn() || this.archiveRo?.() || !this.selFrame_isDataGrid() || this.attr.isPrint || this.attr.isPrintTemplate) return false
                const items = this.flex?.collectionView?.sourceCollection || []
                const cp = this.planApproval_childPath()   // IE 2026 11 03 / ODOO-5800 (webscm #128539: кнопки нет у дерева с группами сверху): дерево — строки плана во вложенных узлах
                // IE 2026 11 03 / ODOO-5800 (ревью этапа B): итог — на эпоху перерисовки и набор строк (перебор до 20000 строк — не на каждый set_commandPanel / открытие формы)
                const c = this._paApplies
                if (c && c.k === this.irefresh && c.items === items && c.n === items.length && c.cp === String(cp)) return c.v   // IE 2026 11 03 / ODOO-5800 (webscm #128539: кнопки нет у дерева с группами сверху)
                const v = JSON.stringify(this.WIDGET?.record?.doc?.params?.source_segments || '').includes('PLAN-DOCS') || planApproval_hasPlanRows(items, 20000, cp)   // IE 2026 11 03 / ODOO-5800 (webscm #128539: кнопки нет у дерева с группами сверху)
                this._paApplies = { k: this.irefresh, items, n: items.length, cp: String(cp), v }   // IE 2026 11 03 / ODOO-5800 (webscm #128539: кнопки нет у дерева с группами сверху)
                return v
            } catch (e) { return false }
        },
        // дети узла дерева грида (flex.childItemsPath, иначе attr.childItemsPath: 'attrs' REPORT2, '_childs' чипа Hierarchy; строка или массив по уровням); '' — плоский список   // IE 2026 11 03 / ODOO-5800 (webscm #128539: кнопки нет у дерева с группами сверху)
        planApproval_childPath() { return this.flex?.childItemsPath || this.attr?.childItemsPath || '' },   // IE 2026 11 03 / ODOO-5800 (webscm #128539: кнопки нет у дерева с группами сверху)
        planApproval_objects() {   // IE 2026 11 03 / ODOO-5800 (webscm #128539: кнопки нет у дерева с группами сверху): объекты и вложенных строк дерева — кэш на эпоху перерисовки, как у planApproval_applies
            const items = this.flex?.collectionView?.sourceCollection || []
            const cp = this.planApproval_childPath()
            const c = this._paObjs
            if (c && c.k === this.irefresh && c.items === items && c.n === items.length && c.cp === String(cp)) return c.v
            const v = planApproval_objectsOfRows(items, 20000, cp)
            this._paObjs = { k: this.irefresh, items, n: items.length, cp: String(cp), v }
            return v
        },
        planApproval_reasonsSrc() { return this.store?.itemsSource?.[PLAN_DECISION_REASON] || null },
        planApproval_button() {
            if (!this.planApproval_applies()) { this._paSum = null; this._paSig = ''; return null }
            const objs = this.planApproval_objects()
            if (!objs.length) return null
            const sig = objs.join('|')
            if (sig !== this._paSig) { this._paSig = sig; this._paSum = null; this.planApproval_loadSummary(objs) }
            const d = new Date(), today = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0')
            return planApproval_menu(this._paSum, { source_name: this.attr.name, binding: this.attr.binding, reasons: this.planApproval_reasonsSrc(), today })
        },
        planApproval_loadSummary(objs) {
            const seq = this._paSeq = (this._paSeq || 0) + 1
            const ck = this.planApproval_summaryCk(objs)   // IE 2026 11 04 / ODOO-5800 (проба p269: Esc закрывает меню, а не виджет; лёгкий запрос сводки)
            const hit = ck ? planApproval_cacheGet(ck) : undefined   // IE 2026 11 04 / ODOO-5800 (проба p269: Esc закрывает меню, а не виджет; лёгкий запрос сводки)
            if (hit !== undefined) { this._paSum = planApproval_summary(hit); planApproval_stat('cacheHit'); try { this.flex?.invalidate() } catch (e) { /* грида нет */ } return }   // IE 2026 11 04 / ODOO-5800 (проба p269: Esc закрывает меню, а не виджет; лёгкий запрос сводки): кнопку соберёт вызвавший planApproval_button (читает _paSum после вызова), пилюли — перерисовкой
            planApproval_call(this, PLAN_APPROVAL_METHODS.summary, { objects: objs }, (answer) => {
                if (ck) planApproval_cachePut(ck, answer?.plan_decision_summary)   // IE 2026 11 04 / ODOO-5800 (проба p269: Esc закрывает меню, а не виджет; лёгкий запрос сводки)
                if (seq !== this._paSeq) return
                this._paSum = planApproval_summary(answer?.plan_decision_summary)
                try { this.set_commandPanel() } catch (e) { /* грид перестраивается */ }
                try { this.flex?.invalidate() } catch (e) { /* грида нет */ }   // пилюли строк — по сводке
            })
        },
        // IE 2026 11 04 / ODOO-5800 (проба p269: Esc закрывает меню, а не виджет; лёгкий запрос сводки): ключ кэша сводки (грид + версия стола + позиции); флаг fe.ux.planApprovalSummaryCache выкл. — '' (без кэша)
        planApproval_summaryCk(objs) {
            try {
                if (!planApproval_summaryCacheOn((k, d) => this.store.setting(k, d))) return ''
                const wr = this.store.WORKSPACES?.[this.WIDGET?.workspace]?.record || this.WIDGET?.workspace_record || {}
                return planApproval_summaryKey(planApproval_gridKey(this), planApproval_versionOf(wr), objs)
            } catch (e) { return '' }
        },
        // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239): кнопка — в ряду шапки отчёта (Widget.set_commandPanel берёт WIDGET._paHeaderBtn), как в прототипе;
        // выключатель fe.ux.planApprovalHeaderRow (дефолт ВКЛ; ВЫКЛ — кнопка с подписью и чипами в панели грида, как до правки)
        planApproval_headerRowOn() { try { return this.store.setting('fe.ux.planApprovalHeaderRow', true) !== false } catch (e) { return true } },
        planApproval_headerSync(btn) {
            const W = this.WIDGET
            if (!W) return
            const owner = 'g' + this.$.uid
            if (!btn) {
                if (!W._paHeaderBtn || W._paHeaderOwner !== owner) return
                W._paHeaderBtn = null; W._paHeaderOwner = ''; W._paHeaderSig = ''
            } else {
                const sig = [btn.title, btn.cssClass, btn.headerHtml, (btn.attrs || []).map(a => (a.name || '') + ':' + (a.title || '') + ':' + (a.disabled ? 1 : 0)).join('|')].join('#')
                if (W._paHeaderBtn && W._paHeaderOwner === owner && W._paHeaderSig === sig) return
                W._paHeaderBtn = btn; W._paHeaderOwner = owner; W._paHeaderSig = sig
            }
            try { W.attrs_vueObj?.WIDGET?.set_commandPanel?.() } catch (e) { /* шапку перерисует следующий ответ */ }
        },
        // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239): названия позиций окна подтверждения вместо id измерений (preview.title бэка — GUID через « · »): словари стора, поля «-title» строк, DataMap колонок
        planApproval_titleOf() {
            const maps = []
            try { for (const c of this.flex?.columns || []) if (c && c.dataMap) maps.push(c.dataMap) } catch (e) { /* грид перестраивается */ }
            const cp = this.planApproval_childPath()   // IE 2026 11 03 / ODOO-5800 (webscm #128539: кнопки нет у дерева с группами сверху): названия и из вложенных строк дерева
            return planApproval_titleResolver({ itemsSource: this.store?.itemsSource, rows: planApproval_flatRows(this.flex?.collectionView?.sourceCollection || [], cp), dataMaps: maps })   // IE 2026 11 03 / ODOO-5800 (webscm #128539: кнопки нет у дерева с группами сверху)
        },
        planApproval_note(text, status) { if (text) try { this.store.show_notification({ text, status, timeout: 7000 }) } catch (e) { /* стора уведомлений нет */ } },
        // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239): кнопки окна — «Cancel» и действие решения (Approve / Mark processed / Withdraw / Confirm), не «Ні» / «Так»;
        // закрытие окна ✕ (onHide) — та же отмена: вызывающий снимает «занято»; исход — ровно один раз
        planApproval_confirm(text, accept, reject, decision, opts = null) {
            let settled = false
            const once = (fn) => () => { if (settled) return; settled = true; if (typeof fn === 'function') fn() }
            const ok = once(accept), no = once(reject)
            const blocked = !!opts?.blocked   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128436: этап C бэка — пилюля по decision_state, by_key, названия, отказ целиком): отказ целиком (dry ok:false с refused) — список в окне, кнопка действия недоступна, закрытие = отмена
            const App = this.store?.App
            if (blocked) {
                if (App?.$confirm?.require) App.$confirm.require({ message: text, header: t('Plan approval'), icon: 'pi pi-exclamation-triangle', ...planApproval_confirmLabels(decision),
                    acceptClass: 'p-button-success p-disabled pa-accept-off', rejectLabel: t('Close'), accept: no, reject: no, onHide: no })
                else { try { window.alert(text) } catch (e) { /* без окна */ } no() }
            } else if (App?.$confirm?.require) App.$confirm.require({ message: text, header: t('Plan approval'), icon: 'pi pi-verified', acceptClass: 'p-button-success', ...planApproval_confirmLabels(decision), accept: ok, reject: no, onHide: no })
            else if (window.confirm(text)) ok()
            else no()
        },
        // пункт меню шапки: params окна ввода (until / reason / comment) — у process_until / withdraw (planApproval_inputOf)
        planApproval_run(item) {
            if (!this.planApproval_isOn()) return
            const seg = String(item?.pa_segment || ''), decision = String(item?.pa_decision || '')
            const scope = planApproval_scopeObjects(this.planApproval_objects(), seg)
            if (!scope || !decision) return
            if (decision === 'history') {
                planApproval_call(this, PLAN_APPROVAL_METHODS.history, { scope }, (answer) => {
                    const h = answer?.plan_decision_history, hs = String(h?.state || '')
                    const he = h ? planApproval_errorText(hs, h.code, h.message) : ''   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128436: этап C бэка — пилюля по decision_state, by_key, названия, отказ целиком): версия не из ПМ — текстом для человека
                    if (!h || hs === 'off' || he) { this.planApproval_note(hs === 'off' ? t('Plan approval is switched off') : (he || t('No answer from the server')), 'warning'); return }   // IE 2026 11 03 / ODOO-5800 (ревью этапа B): выключатель / ошибка бэка — не «решений нет»
                    const units = planApproval_historyUnits(h.events, { reasons: this.planApproval_reasonsSrc(), titleOf: planApproval_unitTitle(this._paSum, this.planApproval_titleOf()) })   // IE 2026 11 03 / ODOO-5800 (проба p244: заголовок окна History — название позиции, не id)
                    if (!units.length) { this.planApproval_note(t('No plan decisions yet'), 'warning'); return }
                    try { this.store.approvalHistory_open(units, this.WIDGET) } catch (e) { console.warn('plan approval: history', e) }
                })
                return
            }
            const p = item?.params || {}
            planApproval_decide(this, { decision, scope, form: { until: p.until, reason: p.reason, comment: p.comment }, titleOf: this.planApproval_titleOf(),   // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239)
                note: (txt, st) => this.planApproval_note(txt, st), confirm: (txt, ok, no, d, o) => this.planApproval_confirm(txt, ok, no, d, o),   /* IE 2026 11 03 / ODOO-5800 (проба p243: обёртка теряла {blocked} — окно отказа было с активной кнопкой действия) */
                done: (res) => { if (res && res.stage === 'write') { this._paSig = ''; try { this.set_commandPanel() } catch (e) { /* грид перестраивается */ } } } })
            if (item && item.params) { delete item.params.comment; delete item.params.reason; delete item.params.until }   // пункт меню переиспользуется — поля окна не переживают клик
        },
        // сегмент строки (WHERE строки и предков, как у формы ячейки) — кэш на эпоху перерисовки
        planApproval_rowSegment(dataItem, irow) { return this.planApproval_rowWhere(dataItem, irow).seg },   // IE 2026 11 03 / ODOO-5800 (проба p244: сегмент и пары WHERE — из одного сбора)
        // пары WHERE строки и предков ({поле: значение}, planApproval_pairs) и сегмент — для сопоставления видимой строки плана с ключами сводки (planApproval_keyMatch)
        planApproval_rowWhere(dataItem, irow) {   // IE 2026 11 03 / ODOO-5800 (проба p244: видимая строка плана по WHERE)
            if (!this._paSegCache || this._paSegCache.k !== this.irefresh) this._paSegCache = { k: this.irefresh, m: new WeakMap() }
            const m = this._paSegCache.m
            if (m.has(dataItem)) return m.get(dataItem)
            let r = { seg: '', pairs: null }
            try { const pairs = planApproval_pairs(this.cellPassport_rowWhere(dataItem, irow, [], new Set(), true, null)); r = { seg: planApproval_whereSegment(pairs), pairs } } catch (e) { r = { seg: '', pairs: null } }
            m.set(dataItem, r)
            return r
        },
        // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128579: согласование правил MAP-*, этап C): список правил карты (виджет списка с doc.params.approval.rules, флаг fe.ux.ruleApproval) — кнопка «Approval» со сводкой
        // (rule_approval_state по видимым строкам, summary: true; кэш — по набору id), пилюля статуса в колонке-названии, команды над выделением (feSelected → selectedRanges →
        // currentRow) с окном подтверждения. Колонку в грид не добавляем: колонки списка присылает бэк и хранит раскладка пользователя — пилюля, как планы в Балансе. Логика — utils/ruleApproval
        ruleApproval_isOn() {
            try { return !this.attr.isPrint && !this.attr.isPrintTemplate && this.selFrame_isDataGrid() && ruleApproval_listEnabled(this.WIDGET?.record?.doc) && ruleApproval_on((k, d) => this.store.setting(k, d)) } catch (e) { return false }
        },
        ruleApproval_recs() { return ruleApproval_statusRecs(this.store?.itemsSource?.[RULE_STATUS_SEGMENT]) },
        ruleApproval_targetNow() { return ruleApproval_target(this.flex?.collectionView?.items || [], this.WIDGET?.record?.doc?.params?.segment, RULE_APPROVAL_LIMIT) },
        ruleApproval_button() {
            if (!this.ruleApproval_isOn()) { if (this._raState || this._raSig) { this._raState = null; this._raSig = ''; try { this.flex?.invalidate() } catch (e) { /* грида нет */ } } return null }
            const tg = this.ruleApproval_targetNow()
            if (!tg.ids.length) return null
            const sig = ruleApproval_sig(tg.segment, tg.version, tg.ids)
            if (sig !== this._raSig) { this._raSig = sig; this._raLoaded = false; this.ruleApproval_load({ rules: tg.ids, segment: tg.segment, version: tg.version, summary: true }, false) }
            if (this._raLoaded && !ruleApproval_visible(this._raState)) return null   // off: true / у карты нет политики — ничего не показываем
            return ruleApproval_menu(this._raLoaded ? this._raState : null, { source_name: this.attr.name, binding: this.attr.binding })
        },
        // merge — ответ поверх кэша (actions_after после записи), иначе замена
        ruleApproval_load(params, merge) {
            const seq = this._raSeq = (this._raSeq || 0) + 1
            ruleApproval_call(this, RULE_APPROVAL_METHODS.state, params, (answer) => {
                if (seq !== this._raSeq) return
                const st = ruleApproval_state(answer?.rule_approval, this.ruleApproval_recs())
                this._raState = merge ? ruleApproval_merge(this._raState, st) : st
                this._raLoaded = true
                if (merge) this._raSig = ''   // счётчики сводки устарели — следующая перестройка панели перечитает видимые строки с summary
                try { this.set_commandPanel() } catch (e) { /* грид перестраивается */ }
                try { this.flex?.invalidate() } catch (e) { /* грида нет */ }
            })
        },
        // id выделенных правил: отмеченные строки (feSelected) → выделение → текущая строка
        ruleApproval_selected() {
            const flex = this.flex
            if (!flex) return []
            let items = flex.rows.filter(r => r.isVisible !== false && r.dataItem?._fe?.selected).map(r => r.dataItem)
            if (!items.length) items = this.approval_selectedItems()
            if (!items.length && flex.collectionView?.currentItem) items = [flex.collectionView.currentItem]
            return ruleApproval_target(items, this.WIDGET?.record?.doc?.params?.segment, RULE_APPROVAL_LIMIT)
        },
        ruleApproval_titleOf() {
            const by = new Map()
            for (const it of this.flex?.collectionView?.items || []) if (it && it.id != null) by.set(String(it.id), String(it.title || ''))
            return (id) => by.get(String(id)) || ''
        },
        ruleApproval_note(text, status) { if (text) try { this.store.show_notification({ text, status, timeout: 9000 }) } catch (e) { /* стора уведомлений нет */ } },
        // пункт меню кнопки «Approval» (ruleApproval_menu → executeVueObjMethod)
        ruleApproval_run(item) {
            if (!this.ruleApproval_isOn()) return
            const action = String(item?.ra_action || '')
            const tg = this.ruleApproval_selected(), titleOf = this.ruleApproval_titleOf()
            if (action === 'history') {
                const row = tg.ids.length === 1 ? this._raState?.rows?.[tg.ids[0]] : null
                if (!row) { this.ruleApproval_note(t('Select one rule to see its history'), 'warning'); return }
                const units = ruleApproval_historyUnits(row, titleOf(row.rule))
                if (!units[0].events.length) { this.ruleApproval_note(t('No approval events yet'), 'warning'); return }
                this.store.approvalHistory_open(units, this.WIDGET)
                return
            }
            const why = ruleApproval_validate(action, tg.ids, this._raState)
            if (why) { this.ruleApproval_note(why, 'warning'); return }
            const a = ruleApproval_action(action, { rules: tg.ids, segment: tg.segment, version: tg.version }, { titleOf, source_name: this.attr.name, binding: this.attr.binding })
            ruleApproval_onWrite(a, { titleOf, note: (txt, st) => this.ruleApproval_note(txt, st), onState: (after) => this.ruleApproval_load(after.params, true) })
            this.store.executeStoreMethod(this.WIDGET?.vueObj || this, a)   // окно ввода (список правил, комментарий) — store.confirmInput
        },
        // колонка пилюли: utils/ruleApproval.ruleApproval_pillColIndex — title / name / code достаточной ширины, иначе первая широкая видимая
        // (IE 2026 11 03 / ODOO-5800 (ie-dm7 #128579: согласование правил MAP-*, этап C — правки пробы p246): в «Purchasing rules» title — 48 px, пилюли не видно); кэш — эпоха irefresh + число колонок + их суммарная ширина (сдвиг / скрытие / ширина колонки — пересчёт)
        ruleApproval_pillCol() {
            const cols = this.flex?.columns
            let k = String(this.irefresh)
            try { k += '|' + (cols?.length || 0) + '|' + (cols?.getTotalSize?.() || 0) } catch (e) { /* колонок нет */ }   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128579: согласование правил MAP-*, этап C — правки пробы p246)
            if (this._raPillColK === k) return this._raPillCol
            let c = 0
            try { c = ruleApproval_pillColIndex(Array.from(cols || []).map(x => ({ binding: x?.binding, visible: x?.isVisible !== false, width: x?.renderWidth ?? x?.width, bool: x?.dataType === wjcCore.DataType.Boolean }))) } catch (e) { /* колонок нет */ }   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128579: согласование правил MAP-*, этап C — правки пробы p246)
            this._raPillColK = k; this._raPillCol = c
            return c
        },
        ruleApproval_pillApply(e_cell, dataItem, e_col, isXlsxExport) {
            const drop = () => {
                if (!e_cell.__raPill) return
                e_cell.__raPill = false
                for (const n of [...e_cell.querySelectorAll('.ra-pill')]) n.remove()
                if (e_cell.classList.contains('ra-pill-host')) wjcCore.removeClass(e_cell, 'ra-pill-host')
            }
            if (isXlsxExport || !dataItem || !ruleApproval_visible(this._raState) || e_col !== this.ruleApproval_pillCol()) return drop()
            if (!ruleApproval_isMap(dataItem.segment || this._raState.segment)) return drop()
            const row = this._raState.rows[String(dataItem.id ?? '')]
            if (!row) return drop()
            const html = ruleApproval_pillHtml(row, (v) => this.store.escapeHtml(String(v ?? '')))
            const box = e_cell.querySelector(':scope > .cell-text-clip') || e_cell
            let pe = box.querySelector(':scope > .ra-pill')
            if (!pe || pe.__raHtml !== html) {
                if (pe) pe.remove()
                const tmp = document.createElement('span'); tmp.innerHTML = html
                pe = tmp.firstChild
                pe.__raHtml = html
                pe.dataset.raText = ruleApproval_pillTip(row)
            }
            // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128579: согласование правил MAP-*, этап C — правки пробы p246): пилюля — В НАЧАЛЕ содержимого ячейки (перед текстом): длинное название обрезается многоточием, пилюля видна всегда; ширину колонки не меняет
            if (box.firstChild !== pe) box.insertBefore(pe, box.firstChild)
            if (!e_cell.classList.contains('ra-pill-host')) wjcCore.addClass(e_cell, 'ra-pill-host')
            e_cell.__raPill = true
        },
        planApproval_pillApply(e_cell, dataItem, e_col, isXlsxExport, e_row) {
            const drop = () => {
                if (!e_cell.__paPill) return
                e_cell.__paPill = false
                for (const n of [...e_cell.querySelectorAll('.pa-pill')]) n.remove()
                if (e_cell.classList.contains('pa-pill-host')) wjcCore.removeClass(e_cell, 'pa-pill-host')
            }
            if (e_col !== 0 || isXlsxExport || !dataItem || this.attr.isPrint || this.attr.isPrintTemplate) return drop()
            if (!this._paSum && !planApproval_rowDecision(dataItem)) return drop()   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128436: этап C бэка — пилюля по decision_state, by_key, названия, отказ целиком): decision_state — и с префиксом пути   // IE 2026 11 03 / ODOO-5800 (ревью этапа B): дешёвая проверка — до чтения настройки (горячий путь formatItem)
            if (!this.planApproval_isOn()) return drop()
            const rw = this.planApproval_rowWhere(dataItem, e_row), seg = rw.seg   // IE 2026 11 03 / ODOO-5800 (проба p244: видимая строка плана по WHERE)
            const rs = seg ? planApproval_rowState(dataItem, seg, this._paSum, rw.pairs) : null   // IE 2026 11 03 / ODOO-5800 (проба p244: видимая строка плана по WHERE)
            if (!rs) return drop()
            const html = planApproval_pillHtml(rs, (v) => this.store.escapeHtml(String(v ?? '')))
            const box = e_cell.querySelector(':scope > .cell-text-clip') || e_cell
            const anchor = box.querySelector(':scope > .cell-dropdown-toggle')
            let pe = box.querySelector(':scope > .pa-pill')
            if (!pe || pe.__paHtml !== html) {
                if (pe) pe.remove()
                const tmp = document.createElement('span'); tmp.innerHTML = html
                pe = tmp.firstChild
                pe.__paHtml = html
                pe.dataset.paText = rs.text
                box.insertBefore(pe, anchor || null)
            }
            if (!e_cell.classList.contains('pa-pill-host')) wjcCore.addClass(e_cell, 'pa-pill-host')
            e_cell.__paPill = true
        },
        planChips_apply(e_cell, dataItem, e_col, isXlsxExport) {   // IE 2026 10 18 / ODOO-5800: чипы «T · Затверджено», «S · Чернетка» после текста заголовка строки (колонка 0), перед кнопкой формы ячейки — как approvalPill_apply
            const drop = () => {
                if (!e_cell.__planChips) return
                e_cell.__planChips = false
                for (const n of [...e_cell.querySelectorAll('.plan-chips')]) n.remove()
            }
            if (e_col !== 0 || isXlsxExport || this.attr.isPrint || this.attr.isPrintTemplate || !this.planLevels_on()) return drop()
            const chips = planChips_of(dataItem)
            if (!chips.length) return drop()
            const box = e_cell.querySelector(':scope > .cell-text-clip') || e_cell
            const anchor = box.querySelector(':scope > .cell-dropdown-toggle')
            let host = box.querySelector(':scope > .plan-chips')
            if (!host) { host = document.createElement('span'); host.className = 'plan-chips'; box.insertBefore(host, anchor || null) }
            const esc = (v) => this.store.escapeHtml(String(v ?? ''))
            const html = chips.map(c => `<span class="${esc(c.css)}" title="${esc(c.title)}" data-plan-status="${esc(c.status)}" data-plan-horizon="${esc(c.horizon)}">${esc(c.text)}</span>`).join('')
            if (host.innerHTML !== html) host.innerHTML = html
            e_cell.__planChips = true
        },   // IE 2026 10 18 / ODOO-5800
        // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL2 (Igor: «должно быть кеширование»): approvalClosed_paint зовётся на КАЖДУЮ ячейку каждой перерисовки (2 232 вызова на коммит флажка M03),
        // и каждый раз читал approval_on() + два store.setting (реактивные get) и doc._approval. Эти условия не зависят от ячейки — считаются один раз на проход
        // рисования (эпоха irefresh: refreshing() её сдвигает — смена настроек / данных перерисовывает грид через refreshing). Выключатель fe.ux.approvalPaintCache
        // (дефолт ВКЛ; выкл — считать на каждой ячейке, как прежде)
        approvalPaint_gate() {
            const k = this.irefresh
            let g = this._apprPaintGate
            if (g && g.k === k) return g
            const useCache = this.store.setting('fe.ux.approvalPaintCache', true) !== false
            g = { k: useCache ? k : NaN,
                on: !this.attr.isPrint && !this.attr.isPrintTemplate && !!approvalDoc(this.WIDGET?.record?.doc) && !!this.approval_on() && this.store.setting('fe.ux.approvalClosedFill', true) !== false,
                valuesOnly: this.store.setting('fe.ux.approvalClosedFillValuesOnly', true) !== false }
            this._apprPaintGate = g
            return g
        },
        // IE 2026 10 09 / ODOO-345618 (заказ Игоря: согласование — звено «ответственный»): кнопка «Mine» командной панели и её клик — чипс стола responsible_users (utils/cellResponsible)
        signalsMine_button() {
            try {
                if (!responsible_on((k, d) => this.store.setting(k, d)) || !this.selFrame_isDataGrid() || this.attr.isPrint || this.attr.isPrintTemplate) return null
                if (!responsible_wanted({ source_segments: this.WIDGET?.record?.doc?.params?.source_segments })) return null
                if (mineChip_hidesButton(this.WIDGET?.record?.doc, (k, d) => this.store.setting(k, d))) return null   // IE 2026 10 12 / ODOO-5800: у виджета чипс «Mine» (форма списка чипсов) — кнопки нет (флаг fe.ux.signalsMineChip)
                const W = this.store?.WORKSPACES?.[this.WIDGET?.workspace]
                const on = mine_isOn(W?.record?.doc?.params?.WHERE, this.store?.user)
                return mine_button({ t, on, source_name: this.attr.name, binding: this.attr.binding })
            } catch (e) { return null }
        },
        signalsMine_Click() {
            const store = this.store, WIDGET = this.WIDGET
            const cfg = mine_cfg(WIDGET)
            const ws = String(WIDGET?.workspace || ''), W = store?.WORKSPACES?.[ws]
            const params = W?.record?.doc?.params
            if (!cfg || !params || !store?.user) return
            const res = mine_toggle(params.WHERE, cfg, store.user)
            if (!res.changed) { try { store.show_notification({ text: t('The current user is unknown — the Mine chip is not set'), status: 'warning' }) } catch (e) { /* нет сторы */ } return }
            params.WHERE = res.WHERE
            delete params.calc_selectors_mark   // метка расчётных селекторов — пересчитает бэк на applySelector (как pageGotoChip_run)
            try { store.update_CHIPS_from_WHERE?.(params) } catch (e) { /* чипсы шапки — best effort */ }
            W.selector_version = (W.selector_version ?? 0) + 1
            try { store.workspace_applySelector(ws, cfg.page) } catch (e) { console.warn('signals mine: applySelector', e) }
        },
        // имя пользователя для подсказок согласования — справочник USER, как у блока CORRECTION формы ячейки (corr_userTitle); нет — как пришло
        approval_userTitle(uid) {
            const src = this.store?.itemsSource?.['USER']
            const it = src?.ids?.[uid] || (src?.data || []).find(x => x?.id === uid)
            return it?.title || (this.store?.user?.id === uid ? (this.store.user.title || uid) : uid)
        },
        // IE 2026 10 09 / ODOO-345618 (F2): пилюля стоит в строке-группе УРОВНЯ ЕДИНИЦЫ (DESIGN §3.6): строки данных под ней несут тот же статус и замок, но пилюли не получают. Строка — верх своей
        // единицы, когда нижняя единица её цепочки (approval.units: наименьший номер шага) не совпадает с нижней единицей родительской строки (ближайшая выше строка меньшего уровня) либо родителя нет.
        // Нет approval.units (прежний вид) или плоский грид — пилюля у каждой строки, как в F1
        approval_isUnitTop(ap, e_row) {
            const low = (a) => {
                const u = a && a.units
                if (!u || typeof u !== 'object') return ''
                let k = null
                for (const key of Object.keys(u)) { const n = +key; if (Number.isFinite(n) && (k === null || n < k)) k = n }
                return k === null ? '' : String(u[String(k)] ?? '')
            }
            const mine = low(ap)
            if (!mine) return true
            const rows = this.flex?.rows, row = rows?.[e_row]
            if (!row || !(row.level > 0)) return true
            for (let i = e_row - 1; i >= 0; i--) {
                const r = rows[i]
                if (r && r.level < row.level) {
                    const pa = approvalOf(r.dataItem)
                    return !pa || low(pa) !== mine
                }
            }
            return true
        },
        // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — FE1-glist FE1 (C-02, B-03): списки единиц (монитор, «ждут меня»): колонка Waiting for (doc.waiting_for_text) — ответственный ссылкой на USER + «+N» (все имена — в подсказке);
        // колонка Due state по коду (doc.due_state) — текст бэка due_state_text (до пересева колонка ещё привязана к коду). Ячейки — после отрисовки (DOM), на обоих путях formatItem
        // IE 2026 10 10 / ODOO-345618 (Игорь 10.10: «я ожидаю что "Ответственный" — это будет ссылка, и не совсем пойму почему сейчас несколько»): колонка responsible_text (DS::Signals, грид
        // сигналов отчёта) — имя ОСНОВНОГО ответственного ссылкой на запись USER, « +N» — остальные (все с ролями — в подсказке). Люди — поле строки responsible (список / JSON-текст);
        // его нет у строки (раскладка без скрытого поля) — ячейка как есть. Флаги fe.ux.signalsResponsible / fe.ux.signalsResponsibleLink (дефолт ВКЛ). DOM — после отрисовки, оба пути formatItem
        responsibleCell_apply(e_cell, dataItem, e_col) {
            const col = this.flex?.columns?.[e_col], b = String(col?.binding || '')
            if (!dataItem || !b || !(b === 'responsible_text' || b.endsWith('.responsible_text'))) return
            if (!responsible_on((k, d) => this.store.setting(k, d)) || !responsible_linkOn((k, d) => this.store.setting(k, d))) return
            const us = responsible_cellUsers(dataItem)
            if (!us.length) return
            const esc = (v) => this.store.escapeHtml(String(v ?? ''))
            const html = responsible_cellHtml(us, esc, (x) => this.t ? this.t(x) : x)
            if (!html) return
            e_cell.innerHTML = html
            const a = e_cell.querySelector('a.resp-user-link')
            if (a) a.onclick = (ev) => { ev.preventDefault(); ev.stopPropagation(); if (a.dataset.respUser) approvalOpenRef(this.store, this.WIDGET?.vueObj || this, { segment: 'USER', id: a.dataset.respUser }) }
        },
        approvalList_apply(e_cell, dataItem, e_col) {
            const col = this.flex?.columns?.[e_col], b = String(col?.binding || '')
            if (!dataItem || !b || !(b.endsWith('waiting_for_text') || b.endsWith('.due_state'))) return
            const d = dataItem.doc && typeof dataItem.doc === 'object' ? dataItem.doc : dataItem
            if (b.endsWith('.due_state')) { if (d.due_state_text !== undefined && e_cell.textContent !== String(d.due_state_text)) e_cell.textContent = String(d.due_state_text || ''); return }
            if (!approvalLinksOn((k, v) => this.store.setting(k, v))) return
            const us = approvalWaitingUsers(d.waiting_for_users, null, (u) => this.approval_userTitle(u)).filter(u => u.id || u.noUser)   // IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FE5: без записи USER — имя текстом (span), e-mail в подсказке
            if (!us.length) return
            const esc = (v) => this.store.escapeHtml(String(v ?? ''))
            e_cell.innerHTML = (us[0].id ? `<a class="appr-user-link" data-appr-user="${esc(us[0].id)}" title="${esc(us[0].tip)}">${esc(us[0].name)}</a>` : `<span class="appr-user-name" title="${esc(us[0].tip)}">${esc(us[0].name)}</span>`) + (us.length > 1 ? `<span class="appr-user-more" title="${esc(us.map(u => u.name).join(', '))}"> · +${us.length - 1}</span>` : '')
            const a = e_cell.firstChild
            if (a && a.dataset && a.dataset.apprUser) a.onclick = (ev) => { ev.preventDefault(); ev.stopPropagation(); approvalOpenRef(this.store, this.WIDGET?.vueObj || this, { segment: 'USER', id: a.dataset.apprUser }) }
        },
        approvalPill_apply(e_cell, dataItem, e_col, isXlsxExport, e_row) {
            const drop = () => {
                if (!e_cell.__apprPill) return
                e_cell.__apprPill = false
                for (const n of [...e_cell.querySelectorAll('.appr-pill, .appr-count')]) n.remove()
                if (e_cell.classList.contains('appr-pill-host')) wjcCore.removeClass(e_cell, 'appr-pill-host')
            }
            if (e_col !== 0 || isXlsxExport || this.attr.isPrint || this.attr.isPrintTemplate) return drop()
            const ap = this.approval_of(dataItem)
            if (ap && e_row != null && !this.approval_isUnitTop(ap, e_row)) return drop()
            const pill = ap ? approvalPill(ap) : null, cnt = ap ? approvalCountSeparate(ap) : null
            if (!pill && !cnt) return drop()
            const box = e_cell.querySelector(':scope > .cell-text-clip') || e_cell
            const anchor = box.querySelector(':scope > .cell-dropdown-toggle')   // кнопка формы ячейки — последняя в блоке; пилюля встаёт перед ней, сразу за текстом заголовка
            let pe = box.querySelector(':scope > .appr-pill'), ce = box.querySelector(':scope > .appr-count')
            if (pill) {
                if (!pe) { pe = document.createElement('span'); box.insertBefore(pe, ce || anchor || null) }
                const cls = 'status-chip appr-pill ' + pill.css
                if (pe.className !== cls) pe.className = cls
                if (pe.textContent !== pill.text) pe.textContent = pill.text
                pe.dataset.apprStatus = pill.status || ''
                pe.dataset.apprShort = pill.short || ''   // IE 2026 10 09 / ODOO-345618 (F2): узкая колонка — пилюля сокращается до статуса (approvalPill_fit)
                if (pe.style.maxWidth) pe.style.maxWidth = ''
                this.approvalPill_fit(e_cell)
            } else if (pe) pe.remove()
            if (cnt) {
                if (!ce) { ce = document.createElement('span'); box.insertBefore(ce, anchor || null) }
                const cls = 'appr-count' + (cnt.done ? ' is-done' : '')
                if (ce.className !== cls) ce.className = cls
                if (ce.textContent !== cnt.text) ce.textContent = cnt.text
            } else if (ce) ce.remove()
            e_cell.__apprPill = true
            if (!e_cell.classList.contains('appr-pill-host')) wjcCore.addClass(e_cell, 'appr-pill-host')
        },
        // IE 2026 10 09 / ODOO-345618 (F2, проба M03 на dev02: первая колонка 200 px): пилюля с хвостом («In review · Brand manager») рядом с заголовком не помещается — text-overflow: ellipsis прячет её ЦЕЛИКОМ
        // (атомарный inline-блок) и ставит «…», статус пропадает. После отрисовки (один rAF на пачку ячеек: сначала все замеры, потом правки — без раскладки на каждую ячейку) переполненная пилюля
        // сокращается до статуса («In review»); если и так не помещается (uk: «На погодженні») — ей задаётся ширина по свободному месту, надпись усекается её собственным «…». Хвост остаётся в Alt-подсказке и форме ячейки.
        // Следующая отрисовка возвращает полный текст и снимает предел ширины (apply), замер повторяется — ширина колонки могла измениться. Ширины — раскладочные (scrollWidth / clientWidth), не из getBoundingClientRect: пилюля сжата transform: scale(.9)
        approvalPill_fit(e_cell) {
            const q = this._apprFitQ || (this._apprFitQ = new Set())
            q.add(e_cell)
            if (this._apprFitRaf) return
            this._apprFitRaf = requestAnimationFrame(() => {
                this._apprFitRaf = 0
                const cells = [...q]
                q.clear()
                const over = (pe) => { const box = pe.parentElement; return !!box && box.scrollWidth > box.clientWidth + 1 }
                const list = []
                for (const c of cells) {
                    if (!c.isConnected || !c.__apprPill) continue
                    const pe = c.querySelector('.appr-pill')
                    if (pe && over(pe)) list.push(pe)
                }
                if (!list.length) return
                for (const pe of list) { const short = pe.dataset.apprShort; if (short && pe.textContent !== short) pe.textContent = short }
                for (const pe of list.filter(over)) {   // второй замер — один пересчёт раскладки на пачку
                    const box = pe.parentElement
                    const left = pe.getBoundingClientRect().left - box.getBoundingClientRect().left   // transform-origin слева: левая кромка не сдвигается масштабом
                    pe.style.maxWidth = Math.max(36, Math.floor(box.clientWidth - left - 18)) + 'px'   // 18 px — запас под стрелку формы ячейки справа
                }
            })
        },
        // подменю «Approval» командной панели: только у основной таблицы (dataSheet / _doc.data) записи с doc._approval; null — подменю нет
        approval_menu() {
            if (this.archiveRo?.()) return null   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): архивная ПМ — без действий согласования
            if (!this.approval_on() || !this.selFrame_isDataGrid() || this.attr.isPrint || this.attr.isPrintTemplate) return null
            const da = approvalDoc(this.WIDGET?.record?.doc)
            // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — FE1-gmenu FE1 (DU2): список единиц (монитор / «ждут меня», doc._approval_monitor): у администратора (строки с doc.can_set_due) — «Set due…» над выделенными строками
            if (!da && this.WIDGET?.record?.doc?._approval_monitor && (this.flex?.collectionView?.items || []).some(r => r?.doc?.can_set_due === true)) {
                const a = approvalAction('set_due', {}, { source_name: this.attr.name, binding: this.attr.binding })
                return { name: 'button-approval-menu', title: t('Approval'), tooltip: t('Approval'), attr_type: 'AttrMenu', autoGeneratedButton: true, cssClass: 'pi p-button-white pi-verified', uiHelp: 'approval.menu', attrs: [a] }
            }
            return da ? approvalMenu(da, { source_name: this.attr.name, binding: this.attr.binding, my: this.store.setting('fe.ux.approvalMyList', true) !== false }) : null   // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ): + «My approvals…» (fe.ux.approvalMyList)
        },
        // IE 2026 10 09 / ODOO-345618 (F2): пункт «Approval» панели ROW формы ячейки — действия строки по approval.actions бэка (+ «за утверждающего»), каждое над единицей строки (params.unit); null — пункта нет
        approval_rowMenu(dataItem) {
            if (this.archiveRo?.()) return null   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): архивная ПМ — без действий согласования строки
            if (!dataItem || !this.approval_on() || !this.selFrame_isDataGrid() || this.attr.isPrint || this.attr.isPrintTemplate) return null
            const da = approvalDoc(this.WIDGET?.record?.doc), ap = approvalOf(dataItem)
            return da && ap ? approvalRowMenu(ap, da, { source_name: this.attr.name, binding: this.attr.binding, steps: this.store.setting('fe.ux.approvalStepLabel', true) !== false }) : null   // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ): подпись пункта с названием шага (fe.ux.approvalStepLabel)
        },
        // строки выделения (без повторов, не больше 2000) — для решения «за утверждающего»
        approval_selectedItems() {
            const out = [], seen = new Set(), flex = this.flex
            if (!flex) return out
            for (const rg of flex.selectedRanges || []) {
                const r0 = Math.min(rg.row, rg.row2), r1 = Math.max(rg.row, rg.row2)
                for (let r = r0; r <= r1 && out.length < 2000; r++) {
                    const di = flex.rows[r]?.isVisible === false ? null : flex.rows[r]?.dataItem   // скрытые отбором строки в выделение не входят (как у бэка: selected_items)
                    if (di && !seen.has(di)) { seen.add(di); out.push(di) }
                }
            }
            return out
        },
        // исполнитель пунктов подменю «Approval» (командная панель, ROW формы ячейки): действие над выделением либо (params.unit) над единицей строки. «За утверждающего» — когда действие есть у строки
        // только в approval.actions_on_behalf (флаг пункта ROW либо по выделенным строкам): окно с обязательным комментарием, params.on_behalf = true. Категории возврата — по doc._approval на момент клика
        approval_run(item) {
            if (!this.approval_on()) return
            const code = String(item?.approval_code || '')
            if (!code) return
            const da = approvalDoc(this.WIDGET?.record?.doc) || {}
            let onBehalf = item.approval_behalf === true
            if (!onBehalf && !item?.params?.unit && code !== 'history') {
                onBehalf = this.approval_selectedItems().some(di => {
                    const ap = approvalOf(di)
                    return !!ap && approvalActions({ actions: ap.actions_on_behalf }, { history: false }).some(x => x.code === code) && !approvalActions({ actions: ap.actions }, { history: false }).some(x => x.code === code)
                })
            }
            // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ): у пункта строки (params.unit) подпись уже несёт шаг и «за утверждающего» («Reopen · Marketing director») — она же заголовок окна комментария
            // Пункт подменю командной панели (выделение, без params.unit): шаг называется, если он один у всех выделенных строк (approvalSelectionStep) — «Reopen · Marketing director» в заголовке окна комментария
            let title = item?.params?.unit && typeof item.title === 'string' ? item.title : undefined
            if (title === undefined && !item?.params?.unit && code !== 'history' && this.store.setting('fe.ux.approvalStepLabel', true) !== false) {
                const step = approvalSelectionStep(this.approval_selectedItems(), code)
                if (step) title = approvalActionLabel({ title: approvalActionTitle(code), step, onBehalf })
            }
            const a = approvalAction(code, da, { source_name: this.attr.name, binding: this.attr.binding, params: item.params, onBehalf, title })
            this.store.executeStoreMethod(this.WIDGET?.vueObj || this, a)
        },
        // IE 2026 10 16 / ODOO-5800 (ЗП-20261016-2, стадия D): панель списка единиц согласования (монитор approval-monitor / «ждут меня»: WIDGET.groupMenu.commandPanel с APPROVE / RETURN / …) — если выделенные
        // единицы несут transitions (записи WORKFLOW v2 из allowed_actions бэка; общие для всех выделенных), кнопки строятся по ним (utils/approval.approvalPanelApply), старые прячутся; иначе — старая панель.
        // Зовётся по смене выделения (selectionChanged / toggleFeSelected) и при перестройке панели грида; отложенно, как ew_update. Выключатель fe.ux.approvalTransitions (поверх fe.ux.approval)
        apprTr_update() {
            clearTimeout(this._apprTrT)
            this._apprTrT = setTimeout(() => {
                try {
                    const W = this.WIDGET, panel = W?.groupMenu?.commandPanel
                    if (!Array.isArray(panel) || !panel.some(approvalPanelIsLegacy)) return
                    const on = this.approval_on() && approvalTransitionsOn((k, d) => this.fmtSetting(k, d))
                    let trs = null
                    if (on && this.flex?.hostElement) {
                        const items = this.flex.rows.filter(r => r.isVisible !== false && r.dataItem?._fe?.selected).map(r => r.dataItem)
                        if (!items.length) items.push(...this.approval_selectedItems())
                        if (!items.length && this.flex.collectionView?.currentItem) items.push(this.flex.collectionView.currentItem)
                        trs = approvalTransitionsCommon(items)
                    }
                    const res = approvalPanelApply(panel, trs, { source_name: this.attr?.name, binding: this.attr?.binding })
                    if (!res.changed) return
                    this._apprTrInd = (this._apprTrInd || 0) + 1
                    if (res.added.length) this.store.prepare_attrs(res.added, 'approval-tr-' + (W?.id || '') + '-' + this._apprTrInd)
                    const wv = W?.attrs_vueObj?.WIDGET
                    if (wv && typeof wv.set_commandPanel === 'function') wv.set_commandPanel()
                } catch (e) { /* грид в перестройке — панель останется как была */ }
            }, 120)
        },
        // исполнитель кнопки перехода панели списка (approvalTransitionPanel: executeVueObjMethod → сюда): метод виджета approval_transition_by_id по выделенным строкам (feSelected → selectedRanges → currentRow,
        // как у APPROVE / RETURN), окно комментария / категории — по записи перехода (comment_required / category_required / on_behalf)
        approval_transition_run(item) {
            if (!this.approval_on()) return
            const tr = item?.approval_transition
            if (!tr || !tr.transitionId) return
            const da = approvalDoc(this.WIDGET?.record?.doc) || {}
            const a = approvalTransitionAction(tr, da, { source_name: this.attr.name, binding: this.attr.binding, onBehalf: !!tr.onBehalf, list: true })
            this.store.executeStoreMethod(this.WIDGET?.vueObj || this, a)
        },
        // Undo / Redo / откат всех правок: группа на вершине стека, затрагивающая закрытую строку, не применяется — как отказ правки (красный флеш, тост с причиной); true — отклонено
        approval_stackBlocked(fromStack) {
            if (!fromStack || !fromStack.length || !this.approval_on()) return false
            const as = fromStack[fromStack.length - 1].actionStack
            let hit = null
            for (let i = fromStack.length - 1; i >= 0 && fromStack[i].actionStack === as; i--) {
                const a = fromStack[i]
                const di = a.$item || (a.irow != null ? this.flex?.rows?.[a.irow]?.dataItem : null)
                if (di && a.col_binding != null && this.approval_cellLock(di, a.col_binding)) { hit = a; break }   // IE 2026 10 09 / ODOO-345618 (F2): + ячейка, закрытая бэком в строке с data_locked
            }
            if (!hit) return false
            const irow = hit.$item ? this.rows_indexOf(hit.$item) : hit.irow
            let icol = -1
            for (let k = 0; k < (this.flex?.columns?.length || 0); k++) if (this.flex.columns[k].binding === hit.col_binding) { icol = k; break }
            if (irow >= 0 && icol >= 0) this.readOnly_reject(irow, icol, hit.method === 'cells' ? 'clearCells' : 'undoRedo')
            return true
        },
        // колонка, которую подсвечивает шапка при выделении ячейки: выделение всегда на ячейке значения
        mergeBack_selCol(row, col) {
            const flex = this.flex
            if (!flex) return col
            const mb = this.mergeBack_info(flex.cells, row)
            return (mb && col >= mb.startCol && col < mb.k) ? mb.k : col
        },
        // выделение / правка, попавшие в пустую часть перед значением, переводятся на ячейку значения
        mergeBack_redirect(flex, row, col) {
            if (row < 0 || col < 0) return -1
            const mb = this.mergeBack_info(flex.cells, row)
            return (mb && col >= mb.startCol && col < mb.k) ? mb.k : -1
        },
        // IE 2026 10 26 / ODOO-5800 (заказ Игоря 26.10: сдвинутая влево ячейка субъекта — подсветка заголовка исходной колонки и подсказка): колонка, которую описывает ячейка данных под курсором (hitTest по центру объединения даёт его середину): в объединении «назад» —
        // колонка значения k, иначе — колонка под курсором, как было. Для слоёв обрезанной шапки (hdrHover_sync) и подсказки по удержанию (headerTooltip_over)
        mergeBack_cellCol(row, col) {   // IE 2026 10 26 / ODOO-5800 (заказ Игоря 26.10: сдвинутая влево ячейка субъекта — подсветка заголовка исходной колонки и подсказка)
            const flex = this.flex   // IE 2026 10 26 / ODOO-5800 (заказ Игоря 26.10: сдвинутая влево ячейка субъекта — подсветка заголовка исходной колонки и подсказка)
            if (!flex || row == null || row < 0 || col == null || col < 0) return col   // IE 2026 10 26 / ODOO-5800 (заказ Игоря 26.10: сдвинутая влево ячейка субъекта — подсветка заголовка исходной колонки и подсказка)
            const mb = this.mergeBack_info(flex.cells, row)   // IE 2026 10 26 / ODOO-5800 (заказ Игоря 26.10: сдвинутая влево ячейка субъекта — подсветка заголовка исходной колонки и подсказка)
            if (!mb) return col   // IE 2026 10 26 / ODOO-5800 (заказ Игоря 26.10: сдвинутая влево ячейка субъекта — подсветка заголовка исходной колонки и подсказка): выключатель fe.ux.gridMergeBack / строка без объединения «назад» — как было
            let mr = null   // IE 2026 10 26 / ODOO-5800 (заказ Игоря 26.10: сдвинутая влево ячейка субъекта — подсветка заголовка исходной колонки и подсказка)
            try { mr = flex.getMergedRange(flex.cells, row, col) } catch (e) { mr = null }   // IE 2026 10 26 / ODOO-5800 (заказ Игоря 26.10: сдвинутая влево ячейка субъекта — подсветка заголовка исходной колонки и подсказка)
            return mergeBackHoverCol(mb, col, mr, 'col')   // IE 2026 10 26 / ODOO-5800 (заказ Игоря 26.10: сдвинутая влево ячейка субъекта — подсветка заголовка исходной колонки и подсказка)
        },   // IE 2026 10 26 / ODOO-5800 (заказ Игоря 26.10: сдвинутая влево ячейка субъекта — подсветка заголовка исходной колонки и подсказка)
        // IE 2026 09 17 / ODOO-… (замечание Игоря): сводка значений условия «в списке»
        // («2: ↑ IN, ↑ IN uncovered» в ячейке Value строки условия) — только у СВЁРНУТОЙ
        // строки; у раскрытой значения видны дочерними строками, и заголовок списка не
        // показывается. Возвращает HTML сводки или '' (выключенные строки use=false
        // в сводку не попадают — ИЕ 2026-08-16); зовётся с полного и с кэш-пути formatItem
        whereSummary_html(row, dataItem, col_binding) {
            if (!row?.hasChildren || !row.isCollapsed || !dataItem?.condition) return ''
            if (col_binding !== 'rightValue.valueStr' || dataItem.rightValue?.valueStr) return ''
            const values = (dataItem[this.attr.childItemsPath] || [])
                .filter(child => child && child.use !== false)
                .map(child => child?.rightValue?.valueStr || child?.rightValue?.value || '')
                .filter(Boolean)
            if (!values.length) return ''
            return this.store.escapeHtml(
                `${values.length}: ${values.slice(0, 3).join(', ')}${values.length > 3 ? ', …' : ''}`)
        },
        get_cache(e) {
            const vueObj = this

            // const isFrozenClone = wjcCore.hasClass(e.cell, 'wj-frozen')
            const isFrozenClone = false // В противном случае не открывается Drop Down на фиксированных колонках

            const key = `${e.panel.cellType}-${e.row}-${e.col}${isFrozenClone ? '-frozen' : ''}`;
            let _cache = this.cache_data_cells.get(key);
            if (!_cache) {
                _cache = {key, index: ++ vueObj.cache_index};
                this.cache_data_cells.set(key, _cache);
            }
            // _cache.e = e
            return {key, _cache}
        },
        get_cache2(e) {
            const vueObj = this;
            const flex = vueObj.flex

            let col = flex.columns[e.col],
            irow = e.row,
            col_binding = col.binding,
            row = flex.rows[irow],
            dataItem = row.dataItem,
            attr_col = this.attr_by_binding[col_binding]

            let key2, _cache2;
            if (dataItem && attr_col?.binding) {
                if (!dataItem._fe?.key) {
                    if (!dataItem._fe) dataItem._fe = {}
                    dataItem._fe.key = ++ vueObj.cache_index
                }
                key2 = `${dataItem._fe.key}-${attr_col.binding}`;
                _cache2 = vueObj.cache2_data_cells.get(key2);
                if (!_cache2) {
                    _cache2 = {}
                    vueObj.cache2_data_cells.set(key2, _cache2);
                }
            }

            return {key2, _cache2}
        },
        formatItemXlsx(e) {
            if (e?.xlsxCell && planLabel_hasPh(e.xlsxCell.value)) e.xlsxCell.value = this.planLabelDate_text(e.xlsxCell.value, e.panel?.rows?.[e.row]?.dataItem)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана): выгрузка xlsx — текстовая форма даты
            // R15d (dm 2026 08 04): из всего formatItem в xlsx-файл попадает только
            // очистка значения cellTemplate-колонок — DOM-ячейку конвертер после
            // коллбэка не читает (стили берёт из прохода updateCell + getComputedStyle
            // ДО коллбэка). Полный formatItem здесь удваивал время экспорта и мусорил
            // экранные кеши (cache_data_cells/divCells) данными выгрузки.
            // Выкл (старый путь): window.fastEntry.set('xlsxLightFormat', false)
            if (this.store?.fastEntry?.xlsxLightFormat === false) {
                this.formatItem(this.flex, e, true)
                return
            }
            if (e.panel !== this.flex.cells) return
            const binding = e.panel.columns[e.col]?.binding
            if (!binding) return
            const attr_col = this.attr_by_bindingColumnGroup?.[`${binding}-${e.row}`] || this.attr_by_binding?.[binding]
            if (attr_col?.cellTemplate) {
                e.cancel = true;
                e.xlsxCell.value = '';
            }
        },
        updatedView(flex, e) {
            this._editKeepPass = false   // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL3: точечный проход закончен (_updateContent wijmo)
            this.gridPerf_touch('view', 0) // IE 2026 09 04 / ODOO-336379: активность вида после вставки
            if (this.isVisible) {
                this.PAGE.vueObj?.refreshe_svg()
            }
            // sticky-заголовки групп шапки: виртуализация пересоздаёт ячейки ПОСЛЕ
            // scrollPositionChanged — свежие ячейки оставались без paddingLeft (текст
            // группы «съедался» слева). Переприменяем после каждого обновления вида;
            // функция лёгкая (цепочка parentGroup + ячейки шапки).
            if (this.isVisible && flex?.hostElement && flex.columns?.length) {
                try { this.set_stickyColumns_afterTimeout() } catch { /* viewRange мог не устояться */ }
                try { this.set_breakGapMasks() } catch { /* колонки могли пересоздаваться */ }
                try { this.planStart_band() } catch { /* колонки могли пересоздаваться */ }   // IE 2026 09 30 / ODOO-343343 (заказ Игоря: штриховка начала плана — одним элементом)
                try { this.frozenFill_sync(flex) } catch { /* клон замороженных мог пересоздаваться */ }   // IE 2026 10 08 / ODOO-5800: непрозрачная подложка под клоном замороженных колонок
                try { this.groupHeaderOverflow_sync(flex) } catch { /* грид мог перестраиваться */ }   // IE 2026 10 12 / ODOO-335099 (RP1): атрибуты хоста «прокрутка 0» и «клон есть»
                try { this.sigPrefetch_schedule() } catch { /* грид мог перестраиваться */ }
                try { this.stk_schedule() } catch { /* грид мог перестраиваться */ }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: виды ячеек запаса под ключ — Z5 по умолчанию; BE ie-dm7 stock_cells_batch)   // IE 2026 11 03 / ODOO-350449 (Игорь: предзагрузка цепочек сигналов; BE ie-dm7 #1009): видимые строки отрисованы — цепочки сигналов экрана пакетом в простое (дебаунс)
                // IE 2026 08 16 / ODOO-4997: рамки-оверлеи карточных колонок
                try { this.cards_overlay_sync() } catch { /* колонки могли пересоздаваться */ }
                // IE 2026 09 02 / ODOO-11316 (регресс «значение моргает при вводе»,
                // замечание Игоря): перебитие введённого проверяем ПОСЛЕ того как
                // перестроения вида УСТОЯЛИСЬ (короткий перевзводимый таймер), а не на
                // каждом промежуточном кадре. Иначе фронт-декомпозиция ловится в
                // переходном состоянии (cur≠entered на миг) → ложный флеш + flex.refresh →
                // только что введённая ячейка на кадр пустеет и мигает. По ощущению —
                // всё равно сразу (десятки мс), но без ложных срабатываний.
                if (this._afterEditWatch && this._afterEditWatch.length) {
                    this.afterEdit_scheduleCheck()
                }
                // IE 2026 09 02 / ODOO-4997 (замечание Игоря): полоса под строкой выделения —
                // JS-оверлей вместо .wj-marquee::after (абсолютный ::after на ±100000px
                // УЧИТЫВАЛСЯ в scrollWidth: у форм-гридов (ACCESS стола) прокрутка
                // раздувалась до ~100k px — крошечный «гиперреактивный» ползунок при
                // полностью видимом содержимом)
                // IE 2026 09 04 / ODOO-336291 (mobile UX): P-08 marqueeBandRaf — два getBoundingClientRect на каждый updatedView
                // (15 % CPU горизонтального пана) → один rAF на серию обновлений; чисто горизонтальная
                // прокрутка (та же вертикаль/выделение/строки) пропускается — top полосы не меняется.
                // Выкл (прежнее: синхронно в каждом updatedView): window.fastEntry.set('marqueeBandRaf', false)
                if (this.store?.fastEntry?.marqueeBandRaf !== false) this.marqueeBand_schedule()
                else { try { this.marqueeBand_sync() } catch { /* marquee мог пересоздаваться */ } }
            }
            if (this.use_performance) {
                const t1 = performance.now();
                const time = t1 - this.performanceView.t0;

                this.performanceView.count += 1
                this.performanceView.time += time
                this.performanceView.maxTime = Math.max(this.performanceView.maxTime, time)
             
                // console.log(`p-view-{${this.attr.binding}-${this.performanceView.count}}: ${(time - this.performanceView.cells_time).toFixed(0)} ms + cells: ${this.performanceView.cells_time.toFixed(0)} / ${this.performanceView.cells_count}`)
                this.performanceView.cells_count = 0
                this.performanceView.cells_time = 0
            }
        },
        // IE 2026 09 04 / ODOO-336291 (mobile UX): P-08 — планировщик marqueeBand_sync (один rAF на серию updatedView, пропуск
        // при неизменной вертикали: та же строка выделения, scrollPosition.y, число/высота строк, эпоха данных)
        marqueeBand_schedule() {
            if (this._mbRaf) return
            this._mbRaf = requestAnimationFrame(() => {
                this._mbRaf = 0
                const flex = this.flex
                if (!flex) return
                // IE 2026 10 31 / ODOO-349799: rAF мог сработать уже ПОСЛЕ уничтожения грида (форма Master data = AttrTabGridLanes пересобирает грид в полосы, старый flex.dispose()) —
                // у выброшенного FlexGrid selection/scrollPosition бросают «Cannot read properties of null (reading 'selection')» (pageerror при навигации по изменениям)
                if (flex.disposed || this.$?.isUnmounted) return
                const sel = flex.selection, sp = flex.scrollPosition
                const sig = `${sel?.row}|${sel?.row2}|${sp?.y}|${flex.rows?.length}|${flex.rows?.defaultSize}|${this.irefresh}|${flex.columnHeaders?.height}|${flex.columnFooters?.height}|${flex.frozenRows}`   // IE 2026 10 05 / ODOO-343986: клип полосы зависит от высоты шапки/футера и замороженных строк
                const band = this._marqueeBand
                if (sig === this._mbSig && band?.isConnected && band.style.display !== 'none') return
                this._mbSig = sig
                try { this.marqueeBand_sync() } catch { /* marquee мог пересоздаваться */ }
            })
        },
        // IE 2026 09 04 / ODOO-336291 (mobile UX): P-07 — проверка обрезки заголовка без layout-чтения в formatItem: ключ = текст + ширина
        // ячейки (style.width ставит wijmo/фабрика); известный ключ — класс из кэша, новые ячейки копятся
        // и меряются одним rAF (сначала все чтения, потом записи — один layout на кадр вместо одного на ячейку)
        hdrClip_check(cell, align = false) {
            const key = (cell.textContent || '') + '|' + (cell.style.width || '')
            const cache = this._hdrClipCache || (this._hdrClipCache = new Map())
            // align — ячейка wj-header-top: обрезанный титул прижимается влево и inline-стилем
            const apply = (c, clip, al) => { if (!clip) return; wjcCore.addClass(c, 'hdr-clip-start'); if (al) { c.style.textAlign = 'left'; c.style.justifyContent = 'flex-start' } }
            const hit = cache.get(key)
            if (hit !== undefined) { apply(cell, hit, align); return }
            const pend = this._hdrClipPending || (this._hdrClipPending = new Map())
            pend.set(cell, { key, align: align || !!pend.get(cell)?.align })
            if (this._hdrClipRaf) return
            this._hdrClipRaf = requestAnimationFrame(() => {
                this._hdrClipRaf = 0
                const p = this._hdrClipPending; this._hdrClipPending = null
                if (!p) return
                const res = []
                for (const [c, e] of p) {
                    if (!c.isConnected) continue
                    if ((c.textContent || '') + '|' + (c.style.width || '') !== e.key) continue // ячейка уже переиспользована под другую колонку
                    res.push([c, e, c.scrollWidth > c.clientWidth + 1])
                }
                if (cache.size > 5000) cache.clear()
                for (const [c, e, clip] of res) { cache.set(e.key, clip); apply(c, clip, e.align) }
            })
        },
        marqueeBand_sync() {
            // IE 2026 09 02 / ODOO-4997 (замечание Игоря): приглушённая линия по нижней
            // границе выделения ВО ВСЮ ширину грида (задача 19b) — отдельным оверлеем в
            // host: не участвует в scrollWidth панелей (::after на ±100000px раздувал
            // горизонтальную прокрутку форм-гридов). Исключения прежние: attrs-грид и
            // грид с одной строкой данных.
            if (this.flex?.disposed || this.$?.isUnmounted) return   // IE 2026 10 31 / ODOO-349799: выброшенный грид (синхронный путь при marqueeBandRaf=false)
            const host = this.flex?.hostElement
            if (!host) return
            let band = this._marqueeBand
            if (band && band.parentElement !== host) { band.remove(); band = null }
            const off = () => { if (band) band.style.display = 'none' }
            if (host.classList.contains('grid-single-row') || host.closest('.attrs-tab-grid')) return off()
            const mq = host.querySelector('.wj-marquee')
            if (!mq || mq.style.display === 'none') return off()
            const mr = mq.getBoundingClientRect()
            if (!(mr.width > 0)) return off()
            if (!band) {
                band = this._marqueeBand = document.createElement('div')
                band.className = 'wj-marquee-band'
                host.appendChild(band)
            }
            const hr = host.getBoundingClientRect()
            const top = Math.round(mr.bottom - hr.top)
            // IE 2026 10 05 / ODOO-343986: полоса — оверлей в host поверх всего грида (z-index 5 > шапка 4), поэтому при прокрутке
            // строки выделения под шапку она рисовалась ПОВЕРХ шапки колонок (раньше ::after жил внутри marquee и клиппился
            // вьюпортом ячеек). Клипуем её вручную по видимой области ЯЧЕЕК: сверху — шапка колонок (+ замороженные строки, если
            // выделенная строка под ними прокручена), снизу — футер колонок и горизонтальный скроллбар; ничего видимого — скрываем.
            const BAND_H = 2
            const flex = this.flex
            const root = host.querySelector('[wj-part="root"]')
            const rootTop = root ? Math.round(root.getBoundingClientRect().top - hr.top) : 0 // IE 2026 10 05 / ODOO-343986: рамка host сдвигает root
            let cellsTop = rootTop + (flex.columnHeaders?.height || 0)
            const frozenRows = flex.frozenRows || 0
            if (frozenRows > 0 && (flex.selection?.row2 ?? flex.selection?.row ?? 0) >= frozenRows) {
                for (let i = 0; i < frozenRows; i++) cellsTop += flex.rows[i]?.renderHeight || 0
            }
            let cellsBottom = root ? rootTop + root.clientHeight : hr.height
            cellsBottom -= flex.columnFooters?.height || 0
            const clipTop = Math.max(0, cellsTop - top)
            const clipBottom = Math.max(0, top + BAND_H - cellsBottom)
            if (clipTop + clipBottom >= BAND_H) return off()
            band.style.display = ''
            band.style.clipPath = clipTop || clipBottom ? `inset(${clipTop}px 0 ${clipBottom}px 0)` : ''
            band.style.top = top + 'px'
        },
        refreshed() {
            this.sigPie_schedule()   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: агрегат сигналов кругом в кнопке; проблемы подсказки в одну строку, клик — форма ячейки): новые строки (данные, фильтр, массовая свёртка) — агрегат заново (дебаунс)
            {
                // фактически отрисованное состояние: ни одной видимой колонки = «кочерыжка»
                const cols = this.flex?.columns
                const isEmpty = !cols || !cols.some(c => c.visible !== false)
                if (this.grid_isEmpty !== isEmpty) {
                    this.grid_isEmpty = isEmpty
                }
            }
            {
                // одна строка данных — подчёркивание строки под выделенной ячейкой
                // не несёт смысла (нечего отделять), гасим полосу выделения (marqueeBand_sync)
                const rows = this.flex?.rows
                let dataRows = 0
                if (rows) { for (let i = 0; i < rows.length; i++) { if (!(rows[i] instanceof wjGrid.GroupRow)) { dataRows++; if (dataRows > 1) break } } }
                this.flex?.hostElement?.classList.toggle('grid-single-row', dataRows === 1)
            }
            if (this.isVisible) {
                this.PAGE.vueObj?.refreshe_svg()
            }
        },

        columns() {
            return this.attr.attrs_columns || this.attr.attrs
        },
        content_Changed(command) {
            if (this.mode === 'Embedded') return
            this.store.widget_attr_set(this)

            // IE 2026 10 14 / ODOO-5800 (Igor 14.10, M03 1coh_001: чипс Corrections пропадал и Save гасла через мгновение после правки — фоновый ответ опроса каскада
            // (autoRecalc_check → cascade_state_refresh → updateDoc с updates бейджа) рассылал content_Changed без isVue, и грид сбрасывал историю правок, чипс, modified и
            // сим-сессию как при новых данных, хотя массив строк не заменён): свежесть данных — по ссылке на массив строк (utils/gridEditKeep, флаг fe.ux.editKeepOnSameRows).
            // Тот же массив без isVue — перестройка идёт, состояние правки (undo/redo, changesStack, modified, чипс) и сим-сессия остаются (load_data: editKeep_restore)
            const _sameRows = !command?.isVue && this.editKeep_sameRows()   // IE 2026 10 14 / ODOO-5800
            this._editKeepOnLoad = _sameRows   // IE 2026 10 14 / ODOO-5800: читает ближайший load_data
            // АН 2026 08 14 / ODOO-4997: пришли свежие данные (select/Rfr) —
            // накопленная сим-сессия на бэке больше не соответствует экрану
            if (!command?.isVue && !_sameRows) {   // IE 2026 10 14 / ODOO-5800: те же строки — сим-сессия и леджер превью живут
                this._bpBranchMap = null
                this._bpFieldRoles = null // АН 2026 08 15 / ODOO-4997
                this._simTablesRequested = false
                this._simLedger = null // АН 2026 08 15 / ODOO-4997: свежие данные — леджер превью с нуля
                this._simVirtual = null // IE 2026 09 25 / ODOO-5800 (D1): оценки автоплана превью — с нуля
                this._storyPreview = null   // IE 2026 10 01 / ODOO-5800: превью решения story — сим-сессия сброшена вместе с данными
                this._simCtxMap = null  // IE 2026 09 25 / ODOO-5800 (D2/D5): контекст строк — заново по новым данным
                this._simEmpty = null   // IE 2026 09 25 / ODOO-5800: пустые до симуляции ячейки — с нуля
                this._simInFlight = false
                this._rowStyleStats = null // АН 2026 08 15 / ODOO-4997: min/max строк — с нуля
                this._rowStyleBindings = null
            }
            if (this._simTouched?.size && !command?.isVue && !_sameRows) this.sim_sendReset()   // IE 2026 10 14 / ODOO-5800: те же строки — сессию не сбрасывать
            if (!command?.isVue && !_sameRows) this._simSessionId = null // IE 2026 08 19: новые данные — новая сим-сессия на бэке (сброс прежней ушёл выше)
            // IE 2026 08 20 / ODOO-5512 (баг Игоря «зависает чипс Corrections»):
            // обновление отчёта строит данные с базы — история правок ссылается
            // на СТАРЫЕ строки и чипс корректировок держался с бейджем; свежие
            // данные = чистая история undo/redo и снятый чипс
            // IE 2026 10 14 / ODOO-5800: те же строки (массив не заменён) — история и чипс остаются
            if (!command?.isVue && !_sameRows && (this.undoStack.length || this.redoStack.length)) {
                this.undoStack.length = 0
                this.redoStack.length = 0
                this._corrNavIdx = -1
                this.corrChip_schedule()
            }

            this.content_Changed_main(command)

            this.need_content_Changed_afterTimeout = true
            if (!this.isVisible) {
                // tabDictPrefetch: сам рендер отложен до первого показа вкладки
                // (lazyTabs), но словари/тайтлы link-колонок заказываем уже
                // сейчас — ответы приедут, пока вкладка скрыта, и первый показ
                // пройдёт без пересборки itemsSource на их приход (мелькание
                // «строки → пусто → строки» при первом входе на вкладку)
                // IE 2026 09 26 / ODOO-5800: грид СКРЫТОЙ вкладки словари заранее не заказывает (fe.ux.gridDictPrefetchVisibleOnly) — prefetch_hiddenDicts_lazy
                if (this.store.fastEntry?.tabDictPrefetch !== false) this.prefetch_hiddenDicts_lazy()
                return
            }
            if (this.content_Changed_timeout) { clearTimeout(this.content_Changed_timeout) }
            // большой отчёт: построение кадра — длинный СИНХРОННЫЙ блок, во время
            // которого клик по Stop уже не обработать. Даём браузеру отрисовать
            // кадр с кнопкой и разобрать очередь событий (двойной rAF), и только
            // потом строим — так нажатие успевает дойти до content_Changed_afterTimeout
            const heavyFirstDraw = !!this.WIDGET._firstLoading && this.bigRender_isHeavy()
            // IE 2026 10 13 / ODOO-5800: перестройка по рассылке фонового обновления (WidgetAttrs ставит _rowFormKeepNow на время рассылки) — смены выделения
            // внутри неё (set_itemsSource / selRestore_apply) открытую форму строки не перецепляют (selectionChanged: rowForm_holdRetarget)
            let keepRowForms = false
            try { keepRowForms = gridSave_toRaw(this.WIDGET)?._rowFormKeepNow === true } catch (e) { keepRowForms = false }
            const afterTimeout = () => {   // IE 2026 10 13 / ODOO-5800
                this._rowFormHold = keepRowForms
                try { this.content_Changed_afterTimeout(command) } finally { this._rowFormHold = false }
            }
            this.content_Changed_timeout = window.$cg.setTimeout(this, "AttrGrid.content_Changed", () => {
                if (!heavyFirstDraw) {
                    afterTimeout()   // IE 2026 10 13 / ODOO-5800
                    return
                }
                requestAnimationFrame(() => requestAnimationFrame(() => {
                    if (this.flex?.hostElement) afterTimeout()   // IE 2026 10 13 / ODOO-5800
                }))
            }, this.isVisible ? 1 : 700)
        },
        // IE 2026 10 25 / ODOO-348925 (заказ Игоря: AttrRowLink — ссылка на строку табличной части той же записи): колонка AttrRowLink — лист группы колонок (<база>.title / <база>.name), ссылка на строку табличной части rows_binding той же записи.
        // Хранится только ключ (<база>.<key_binding>); title-лист читает ключ через неперечислимый аксессор объекта ссылки, карта колонки показывает живое название
        // строки-источника («Not found: <ключ>» — ключа нет). Источник — this.WIDGET.record; живость — сверка подписи (ключи + названия + вложенность) не чаще 250 мс
        // из formatItem (оба пути) и при каждой сборке колонок. Выключатель fe.ux.rowLink (выкл — колонка как у старого FE: текст значения). Счётчики window.__rlStats
        rl_on() {
            return rowLinkOn((k, d) => this.store.setting(k, d))
        },
        rl_stats() {
            if (!window.__rlStats) window.__rlStats = { builds: 0, installs: 0, writes: 0, refused: 0, notFound: 0 }
            return window.__rlStats
        },
        rl_is(attr_col) {
            return !!(attr_col && attr_col.attr_type === RL_TYPE && this._rlCols && this._rlCols[attr_col.binding])
        },
        // ветка scan_column_fromAttrs: колонка с подбором (как AttrLink со статичным списком), карта ключ → название ставится в rl_sync
        rl_col(attr_col, col) {
            const { cfg, errors } = rlConfig(attr_col)
            col.dataType = wjcCore.DataType.String
            if (errors.length) {
                console.warn('AttrRowLink: column is not configured', attr_col.binding, errors)
                return
            }
            if (!this._rlCols) this._rlCols = {}
            this._rlCols[col.binding] = { cfg, attr_col, col, src: null }
            if (!col.minWidth) col.minWidth = 60
            col.dataMapEditor = 'AutoComplete'
            col.isRequired = false
            // список подбора дропдауна грида (dropdown_setItems → store.get_itemsSource → attr.itemsSource) — неперечислимое свойство: описание колонки в JSON не меняется
            if (!Object.getOwnPropertyDescriptor(attr_col, 'itemsSource')) {
                const b = col.binding
                Object.defineProperty(attr_col, 'itemsSource', { configurable: true, enumerable: false, get: () => this._rlCols?.[b]?.src?.items || [] })
            }
        },
        // пункты подбора и карты колонок по подписи источника; аксессоры title на строках таблицы. true — источник изменился (нужна перерисовка)
        rl_sync(force = false) {
            const cols = this._rlCols
            if (!cols) return false
            const now = performance.now()
            if (!force && this._rlT && now - this._rlT < 250) return false
            this._rlT = now
            const stats = this.rl_stats()
            let lang = ''
            try { lang = this.store.get_lang() || '' } catch (e) { lang = '' }
            const rec = this.WIDGET?.record
            if (!this._rlSrc) this._rlSrc = {}
            const seen = {}
            let changed = false
            for (const b in cols) {
                const ent = cols[b], cfg = ent.cfg
                const sk = [cfg.rows_binding, cfg.key_binding, cfg.title_binding, cfg.children_path].join('|')
                let src = seen[sk]
                if (!src) {
                    const rows = rlGetPath(rec, cfg.rows_binding)
                    const sig = rlSig(rows, cfg, lang)
                    src = this._rlSrc[sk]
                    if (!src || src.sig !== sig) {
                        src = this._rlSrc[sk] = { sig, ...rlItems(rows, cfg, lang) }
                        stats.builds++
                        changed = true
                        if (src.dupKeys.length) console.warn(`AttrRowLink: duplicate keys in ${cfg.rows_binding} (the first row is used):`, src.dupKeys)
                    }
                    seen[sk] = src
                }
                if (ent.src !== src || !ent.col.dataMap) {
                    ent.src = src
                    const dm = new wjGrid.DataMap(src.items, 'id', 'caption')
                    dm.getDisplayValue = (v) => rlDisplay(v, cfg, src.index, t)
                    ent.col.dataMap = dm
                    changed = true
                }
            }
            // правка источника в другом гриде той же записи (другая вкладка) — сразу: вотчер подписи (реактивная запись); без реактивности — сверка из formatItem
            if (!this._rlWatch && typeof this.$watch === 'function') {
                this._rlWatch = this.$watch(() => this.rl_watchSig(), () => {
                    if (this.rl_sync(true)) { try { this.flex?.invalidate() } catch (err) { /* грид снят */ } }
                })
            }
            const data = this.data
            if (force || changed || data !== this._rlData || (Array.isArray(data) ? data.length : 0) !== this._rlDataN) {
                this._rlData = data
                this._rlDataN = Array.isArray(data) ? data.length : 0
                stats.installs += rlInstallAll(data, Object.values(cols).map(x => x.cfg), this.attr?.childItemsPath || 'attrs')
            }
            return changed
        },
        // подпись источников всех листов (для вотчера): ключи + названия + вложенность
        rl_watchSig() {
            const cols = this._rlCols
            if (!cols) return ''
            let lang = ''
            try { lang = this.store.get_lang() || '' } catch (e) { lang = '' }
            const rec = this.WIDGET?.record, seen = new Set(), out = []
            for (const b in cols) {
                const cfg = cols[b].cfg, sk = [cfg.rows_binding, cfg.key_binding, cfg.title_binding, cfg.children_path].join('|')
                if (seen.has(sk)) continue
                seen.add(sk)
                out.push(rlSig(rlGetPath(rec, cfg.rows_binding), cfg, lang))
            }
            return out.join('\u0003')
        },
        // оба пути formatItem (кэш-путь пропускает formatItem_cells): аксессор строки, текст ячейки, курсив «Not found», подсказка по Alt / Show tooltips
        // ---- IE 2026 10 25 / ODOO-348925 (заказ Игоря: цвета как на слайде — редактор цвета ColorPicker): колонка editor 'color' (бэк PR #477, doc.nodes.color) — образец цвета
        // в ячейке и палитра PrimeVue ColorPicker при правке; чистые функции — utils/gridColorEditor.js. Выключатель fe.ux.gridColorEditor (дефолт ВКЛ)
        colorEd_on() {
            return colorEditorOn((k, d) => this.store.setting(k, d))
        },
        colorEd_stats() {
            if (!window.__colorEdStats) window.__colorEdStats = { opens: 0, picks: 0, commits: 0 }
            return window.__colorEdStats
        },
        // карта binding → описание колонок с editor 'color'; форма записи / карточка строки (AttrTabGrid) — колонка значения attr.valueStr (поле — строка, решает colorAttrFor)
        colorEd_scan() {
            this._colorCols = null
            if (!this.colorEd_on()) return
            const m = {}
            for (const [b, a] of Object.entries(this.attr_by_binding || {})) if (a && a.editor === 'color') m[b] = a
            if (this.attr?.attr_type === 'AttrTabGrid' && !m['attr.valueStr']) m['attr.valueStr'] = 'row'
            this._colorCols = Object.keys(m).length ? m : null
        },
        // описание поля с редактором цвета у ячейки (row, col) или null
        colorEd_attrAt(row, col) {
            if (!this._colorCols || !this.flex) return null
            const c = this.flex.columns[col]
            if (!c || !this._colorCols[c.binding]) return null
            return colorAttrFor(this.attr_by_binding[c.binding], this.flex.rows[row]?.dataItem, this.attr?.attr_type, c.binding)
        },
        // образец цвета перед hex-текстом; ячейка не цветовая (элемент переиспользован wijmo), открыт редактор, пусто / не цвет, выгрузка — образца нет
        colorCell_apply(e_cell, dataItem, e_row, e_col, isXlsxExport) {
            if (!e_cell) return
            let sw = e_cell.__colorSw ? e_cell.querySelector(':scope > .cell-color-sw') : null
            const a = (!isXlsxExport && dataItem) ? this.colorEd_attrAt(e_row, e_col) : null
            const view = a && !e_cell.querySelector('input') ? colorCellView(this.flex.getCellData(e_row, e_col, false)) : null
            if (!view || !view.swatch) {
                if (sw) sw.remove()
                if (e_cell.__colorSw) { e_cell.__colorSw = false; e_cell.classList.remove('cell-color') }
                return
            }
            if (!sw) { sw = document.createElement('span'); sw.className = 'cell-color-sw'; e_cell.insertBefore(sw, e_cell.firstChild) }
            if (sw.__c !== view.swatch) { sw.style.background = view.swatch; sw.__c = view.swatch }
            sw.classList.toggle('is-light', colorIsLight(view.swatch))
            e_cell.__colorSw = true
            if (!e_cell.classList.contains('cell-color')) e_cell.classList.add('cell-color')
        },
        // редактор ячейки открыт (prepareCellForEdit): палитра под ячейкой; ввод в редакторе двигает палитру
        colorEd_open(row, col, editor) {
            if (!editor || editor.type === 'checkbox' || editor.readOnly || !this.colorEd_attrAt(row, col)) return false
            if (this.colorEd.open) this.colorEd_close()
            this._colorEdEl = editor
            this.colorEd.portal = overlayRoot()
            this.colorEd_sync(editor.value, false)
            this.colorEd.open = true
            if (!this._colorEdInput) this._colorEdInput = () => this.colorEd_sync(this._colorEdEl?.value, true)
            if (!this._colorEdPlace) this._colorEdPlace = () => this.colorEd_place()
            editor.addEventListener('input', this._colorEdInput)
            window.addEventListener('scroll', this._colorEdPlace, true)
            window.addEventListener('resize', this._colorEdPlace)
            this.$nextTick(() => this.colorEd_place())
            this.colorEd_stats().opens++
            return true
        },
        colorEd_sync(text, fromInput) {
            const ed = this.colorEd, n = colorNorm(text)
            ed.hex = n || ''
            ed.invalid = n === null
            ed.light = !!n && colorIsLight(n)
            if (n) { const p = colorPickerValue(n); if (ed.picker !== p) ed.picker = p }
            else if (!fromInput) ed.picker = null
        },
        colorEd_place() {
            if (!this.colorEd.open) return
            const el = this._colorEdEl
            if (!el || !el.isConnected) { this.colorEd_close(); return }
            const pop = this.$refs.colorPop
            const r = (el.closest('.wj-cell') || el).getBoundingClientRect()
            const p = colorPopupPos(r, pop ? pop.offsetWidth : 210, pop ? pop.offsetHeight : 240, window.innerWidth, window.innerHeight)
            if (this.colorEd.left !== p.left) this.colorEd.left = p.left
            if (this.colorEd.top !== p.top) this.colorEd.top = p.top
        },
        // выбор в палитре: '#RRGGBB' — в редактор ячейки (запись — Enter / Apply / уход фокуса, тем же путём, что ручной ввод)
        colorEd_pick(v) {
            const el = this._colorEdEl, hex = colorFromPicker(v)
            if (typeof v === 'string') this.colorEd.picker = v
            if (!hex || !el || !el.isConnected) return
            el.value = hex
            this.colorEd_sync(hex, true)
            this.colorEd_stats().picks++
        },
        colorEd_apply() {
            const f = this.flex, el = this._colorEdEl
            if (f && el && f.activeEditor === el) { this.colorEd_stats().commits++; f.finishEditing(false) }
            this.colorEd_close()
            try { f && f.focus() } catch (err) { /* грид снят */ }
        },
        colorEd_clear() {
            const el = this._colorEdEl
            if (el && el.isConnected) el.value = ''
            this.colorEd_apply()
        },
        colorEd_close() {
            if (this._colorEdEl && this._colorEdInput) this._colorEdEl.removeEventListener('input', this._colorEdInput)
            if (this._colorEdPlace) { window.removeEventListener('scroll', this._colorEdPlace, true); window.removeEventListener('resize', this._colorEdPlace) }
            this._colorEdEl = null
            if (this.colorEd.open) this.colorEd.open = false
            this.colorEd.portal = null
        },
        // значение на запись цветовой ячейки (ввод, вставка, выбор): '#RRGGBB'; пусто — ''; не цвет — как введено
        colorEd_commitValue(e, v) {
            if (typeof v !== 'string' || !this._colorCols || !e) return v
            return this.colorEd_attrAt(e.row, e.col) ? colorCommitValue(v) : v
        },
        rl_cellApply(e_cell, dataItem, e_col, isXlsxExport) {
            const col = this.flex?.columns?.[e_col]
            const ent = col && this._rlCols?.[col.binding]
            if (!ent || !e_cell) {
                if (e_cell && e_cell.__rlTip) { tooltip.setTooltip(e_cell, null); e_cell.__rlTip = false }
                if (e_cell && e_cell.classList.contains('rl-not-found')) e_cell.classList.remove('rl-not-found')
                return
            }
            if (this.rl_sync(false) && !this._rlInv) {
                this._rlInv = true
                setTimeout(() => { this._rlInv = false; try { this.flex?.invalidate() } catch (err) { /* грид снят */ } }, 0)
            }
            const cfg = ent.cfg
            if (!dataItem || !ent.src) return
            if (cfg.part === 'title' && rlInstall(rlLinkObj(dataItem, cfg), cfg)) this.rl_stats().installs++
            if (e_cell.querySelector('input')) return   // открыт редактор
            const sh = rlShown(dataItem, cfg, ent.src.index, t)
            if (e_cell.textContent !== sh.text) {
                const tn = Array.from(e_cell.childNodes).find(n => n.nodeType === 3)
                if (tn) tn.nodeValue = sh.text
                else if (!e_cell.children.length) e_cell.textContent = sh.text
                else if (sh.text) e_cell.insertBefore(document.createTextNode(sh.text), e_cell.firstChild)
            }
            if (e_cell.classList.contains('rl-not-found') !== sh.notFound) e_cell.classList.toggle('rl-not-found', sh.notFound)
            if (sh.notFound) this.rl_stats().notFound++
            if (isXlsxExport) return
            if (sh.notFound) {
                tooltip.setTooltip(e_cell, wjcCore.escapeHtml(t('Row "{key}" is not in {table}', { key: sh.key, table: cfg.rows_binding })))
                e_cell.__rlTip = true
            } else if (e_cell.__rlTip) {
                tooltip.setTooltip(e_cell, null)
                e_cell.__rlTip = false
            }
        },
        // правка листа (ввод, вставка, Delete, выбор из списка): текст → ключ строки источника, пишется <база>.<key_binding> через set_value (undo / признак изменения)
        rl_editCommit(irow, dataItem, ent, text) {
            this.rl_sync(true)
            const cfg = ent.cfg, stats = this.rl_stats()
            if (!dataItem || !ent.src) return false
            for (const x of Object.values(this._rlCols || {})) if (x.cfg.base === cfg.base) rlFixNewRow(dataItem, x.cfg)
            const old = rlKey(dataItem, cfg)
            const s = text === null || text === undefined ? '' : String(text)
            if (old && s === rlShown(dataItem, cfg, ent.src.index, t).text) return false   // редактор закрыт без правки (title-лист показывает название, не ключ)
            let r = rlResolve(s, ent.src.items)   // IE 2026 10 25 / ODOO-348878 (заказ Игоря: подбор RowLink — Enter и закреплённые колонки) (p041)
            if (r.refused) { const _rlL = rlLooseResolve(s, ent.src.items); if (!_rlL.refused) { r = _rlL; stats.loose = (stats.loose || 0) + 1 } }   // IE 2026 10 25 / ODOO-348878 (заказ Игоря: подбор RowLink — Enter и закреплённые колонки) (p041): Tab / уход из ячейки / Enter без списка — недонабранный текст, указывающий один пункт, принимается
            if (r.refused) {
                stats.refused++
                this.store.show_notification({ text: t('No row "{text}" in {table}: choose a row from the list', { text: s, table: cfg.rows_binding }), status: 'warning', timeout: 6000 })
                return false
            }
            if (r.key === old && rlLinkObj(dataItem, cfg)) return false
            this.set_value(irow, dataItem, cfg.keyPath, old, r.key, true, null)
            this.actionStack++   // IE 2026 10 25 / ODOO-348925: правка листа — своя группа отмены, как у обычной ячейки (cellEditEnding2: set_value, затем actionStack++); ветки RowLink выходят раньше общего счётчика
            for (const x of Object.values(this._rlCols || {})) if (x.cfg.base === cfg.base && x.cfg.part === 'title') rlInstall(rlLinkObj(dataItem, x.cfg), x.cfg)
            stats.writes++
            try { this.flex?.invalidate() } catch (err) { /* грид снят */ }
            return true
        },
        bigRender_isHeavy() {
            // грубая оценка объёма первого кадра: строки × колонки данных
            const rows = Array.isArray(this.data) ? this.data.length : 0
            if (!rows) return false
            const cols = (this.attr?.attrs_columns?.length || this.flex?.columns?.length || 0) || 1
            return rows * cols > 20000
        },
        content_Changed_main(command) {
            // АН 2026 08 09: при HMR-ремоунте WIDGET.groupMenu/attr могут быть ещё пусты —
            // без guard'а страница падала оверлеем «reading 'groupMenu'»
            if (!this.attr || !this.WIDGET) return
            this.attr_isMappedWidget = this.store.get_field0(this.WIDGET.groupMenu?.commandPanel || [], 'isMapped-widget', 'name')

            if (this.attr?.attrs_binding) {
                this.attr.attrs = this.store.get_value(this.WIDGET.record, this.attr.attrs_binding, [])
            }

            if (this.attr.attr_type === 'AttrTabGrid') {
                this.data = []
                this.attrsTabGrid_from_attrs(this.attr.attrs, this.data) // attrsTabGrid 2024 11 28

                // IE 2026 08 20 / ODOO-5512: mapped-режим только при УСТАНОВЛЕННОЙ
                // связи (check_binding): до первого set_isMappedWidget hide ещё
                // undefined, и перестройка после команды перекрытия (Shift Alt
                // Enter) штриховала карточку «незамапленными» ячейками-артефактами
                this.isMappedWidget_cols = (this.attr_isMappedWidget && !this.attr_isMappedWidget.hide
                    && this.attr_isMappedWidget.check_binding
                    && !this.attr.noMapped && this.WIDGET.record?.segment !== 'TASKS-transform') ? 1 : 0
                for (let attr of this.columns()) {
                    if (attr.name === 'AttrTabGrid-mapped_title') {
                        attr.use = !!this.isMappedWidget_cols
                    }
                }
            } else {
                if (this.itemsSourcesView_grid()) {
                    this.itemsSourcesView_prepare() // вкладка-реестр: копия реестра родителя + пересчёт use
                }
                if (this.printCellsTab_isActive()) {
                    // вкладка Print cells: проекция канона doc.printTemplate
                    // в '_doc.printCells' (эфемерная, строит фронт)
                    this.printCellsTab_build()
                }
                let new_data = this.store.attr_get(this.WIDGET, this.attr)
                // IE 2026 09 10 / ODOO-… (замечание Игоря «после выбора настройки иногда пропадает иерархия»): список настроек
                // (_doc.settings_list / _doc.variants_list) живёт в _doc записи, а ответ select виджета подменяет _doc
                // данными — строки списка пропадали (пустой/плоский список при открытой панели). Дерево у виджета
                // есть (parents_tree) — пересобрать строки на месте
                if ((this.attr?.name === 'settings-list' || this.attr?.name === 'variants-list') && !(Array.isArray(new_data) && new_data.length)) {
                    const wv = this.WIDGET?.attrs_vueObj?.WIDGET
                    const tree = this.attr.name === 'settings-list' ? this.WIDGET?.parents_tree : this.WIDGET?.variants_tree
                    if (wv?.settingsList_rebuild && Array.isArray(tree) && tree.length) {
                        try { wv.settingsList_ensureDefaultChips?.(); wv.settingsList_rebuild(this.attr.name === 'settings-list' ? 'settings' : 'variants') } catch (e) { /* панель могла закрыться */ }
                        new_data = this.store.attr_get(this.WIDGET, this.attr)
                    }
                }
                // клон дерева колонок (old_attrs) здесь не считаем: его читала
                // только проверка noChanges, которая отключена, а на отчёте это
                // десятки тысяч узлов на каждую перерисовку
                this.data = new_data
                if (!this.data || !Array.isArray(this.data)) {
                    this.store.attr_set(this.WIDGET, this.attr, [], null, null, false)
                    this.data = this.store.attr_get(this.WIDGET, this.attr) || []
                } else if (this.data.length && !this.store.isinstance_dict(this.data[0])) {
                    // convert int >> dict
                    for (let i = 0; i < this.data.length; i++) {
                        this.data[i] = {value:this.data[i]}
                    }
                    this.attr.attrs_columns = [
                        {binding:'value', title:t('Value'), width:'*', attr_type:'AttrStr'}   // IE 2026 09 23 / ODOO-341407: i18n
                    ]
                }
                if (this.aggAll_isSummary()) {
                    this.aggAll_build() // агрегат собирает фронт (бэк _doc не заполняет)
                    if (this.aggAll_identityMode()) {
                        // "All" отжата: данные — сама таблица основного
                        // источника (Report), а не агрегат из копий
                        const record = this.rowIds_record()
                        const binding = this.aggAll_mainDef().binding
                        if (record) {
                            let d = this.store.get_value(record, binding)
                            if (!Array.isArray(d)) {
                                this.store.set_value(record, binding, [])
                                d = this.store.get_value(record, binding)
                            }
                            this.data = d
                        }
                    }
                }
                this.rowIds_check()
            }

            if (this.parent_attr?.attr_type === 'AttrTab' && this.attr.attr_type !== 'AttrTabGrid' && !this.parent_attr?.['hide-countItems'] ) {
                // && this.parent_attr.attrs[0] === this.attr       << LOOK bad if first 'Header'
                this.attr['can-set_AttrTabPanel_countItems'] = true
            }
          
            this.set_AttrTabPanel_countItems_afterTimeout()
            
            this.attr_nonEmptyWidget = this.store.get_field0(this.WIDGET.groupMenu.commandPanel, 'non-empty-widget', 'name')
            if (!this.attr.showEmpty && this.attr_nonEmptyWidget) {
                this.applysCHIPS_register()   // IE 2026 09 10 / ODOO-…: ключ регистрации — см. applysCHIPS_register
                // this.store.check_nonEmptyWidget(this.WIDGET)
            }

            if (!this.isVisible) {
                this.check_attrTab(this.data)
            }
        },
        content_Changed_afterTimeout(command) {
            this.need_content_Changed_afterTimeout = false
            // пользователь нажал Stop, пока строился кадр: тело не рисуем
            // (данные остаются в записи; следующий запрос/refresh снимет флаг)
            if (this.WIDGET._renderStopped) {
                return
            }
            this.tooltip_html = this.store.tooltip_attr(this)

            if (this.flex && this.flex.hostElement) {
                if (this.noChanges) {
                    this.noChanges = false
                    return
                }

                // вся пересборка (columns.clear → set_itemsSource → apply_CHIPS скрытие
                // пустых строк) одним обновлением wijmo: первый кадр сразу с
                // отфильтрованными строками, без промежуточного «все строки видимы»
                this.flex.deferUpdate(() => {
                    this.load_data()
                    this.rowHeaders()
                })
                this.set_commandPanel()
                this.attrResize()
                this.getSelectionWorkspace_date()
                // this.set_AttrTabPanel_countItems()

                if (this.itemsSourcesView_grid()) {
                    // ит.2 §2: позиционирование по выделенной строке основной таблицы
                    // (открытие widget-row, переход по строкам, активация вкладки)
                    this.$nextTick(() => this.itemsSourcesView_position())
                }

                if (this.WIDGET.widget === 'widget-row' && this.attr.name === 'main-AttrTabGrid' && this.WIDGET.layout?.height_fit_rows) {
                    // подгонка высоты попапа по фактическим строкам (widget_open layout.height_fit_rows)
                    this.$nextTick(() => this.store.fit_widgetRow_height(this))
                }

                this.need_flexRefresh_afterTimeout = false
                // this.flex.endUpdate() << refreshing(), but cache not empty
            }
        },
        load_data() {
            const flex = this.flex
            this.ignore_selectionChanged = true
            this.chips_seedDefaults()   // IE 2026 10 30 / ODOO-349799: стартовые чипсы attr.CHIPS — до первого apply_CHIPS (ниже по load_data)
            this.processing_fieldsMapping()
            this.gridSave_keepPending()   // IE 2026 10 13 / ODOO-5800: строки пришли поверх несохранённых правок ленивого грида — правки возвращаются до сборки грида (fe.ux.gridSaveGuard)
            // IE 2026 10 14 / ODOO-5800: перестройка по фоновому ответу с ТЕМИ ЖЕ строками (content_Changed: _editKeepOnLoad) — снимок состояния правки, возврат ниже
            // (строки те же объекты, undo-стек резолвит их по ссылке, changesStack — по irow того же порядка). Ссылка на массив — для следующей проверки (editKeep_sameRows)
            const _sameRowsLoad = this._editKeepOnLoad === true && this.editKeep_sameRows()   // IE 2026 11 03 / ODOO-350449 (ie-dm7 #128809, проба p250: порция 8, повтор truncated, дефолт ВЫКЛ, без ожидания пакета): и для версии кеша подсказки сигнала (sigTip_verNext)
            const _editKeep = _sameRowsLoad ? editKeep_snapshot(this) : null   // IE 2026 11 03 / ODOO-350449 (ie-dm7 #128809, проба p250: порция 8, повтор truncated, дефолт ВЫКЛ, без ожидания пакета)
            this._editKeepOnLoad = false
            this.deletedItems = []
            this.parentDataItem = null
            this.parentDataItem_iroot = null
            this.changesStack = {}
            this.backendStack = {}
            this._apprPartialCache = null; this._apprFlagCols = null; this._apprPartialIdx = null   // IE 2026 10 14 / ODOO-5800 (Igor): живой итог флага — новые строки (app7 #84309: и индекс)
            if (this._paLoaded) planApproval_cacheDrop(planApproval_gridKey(this)); this._paLoaded = true   // IE 2026 11 04 / ODOO-5800 (проба p269: Esc закрывает меню, а не виджет; лёгкий запрос сводки): повторная загрузка данных грида — сводка «Plan approval» перечитывается; первая загрузка нового экземпляра грида кэш (≤ 30 с) не снимает
            this.divCells.clear()
            // py-раскраска (css_user в cache2) ключуется по dataItem._fe.key, а обновление
            // данных с бэка приносит новые объекты строк — без переноса ключей первый кадр
            // рендерится без условного форматирования («лишний слайд»), цвета доезжают после
            // пересчёта py. Переносим _fe.key позиционно со старых строк на новые и не чистим
            // cache2, а помечаем устаревшим — старые цвета красят первый кадр, py заменяет поштучно
            const preserve_css = !!this.get_cssClass_py && this.cache2_data_cells.size < 50000
            if (preserve_css && Array.isArray(this.data000) && Array.isArray(this.data) && this.data000 !== this.data) {
                const childPath = this.attr.childItemsPath
                const transfer_feKeys = (oldRows, newRows) => {
                    const n = Math.min(oldRows.length, newRows.length)
                    for (let i = 0; i < n; i++) {
                        const o = oldRows[i], nw = newRows[i]
                        if (!o || !nw) continue
                        if (o._fe?.key && !nw._fe?.key) {
                            (nw._fe = nw._fe || {}).key = o._fe.key
                        }
                        if (childPath && Array.isArray(o[childPath]) && Array.isArray(nw[childPath])) {
                            transfer_feKeys(o[childPath], nw[childPath])
                        }
                    }
                }
                transfer_feKeys(this.data000, this.data)
            }
            this.cf_cache?.clear() // conditional_format: пересчёт при новом select/Update
            this._cellViewVer = (this._cellViewVer || 0) + 1; this._cellRingScale = null   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T1): новый ответ — кеш слоёв и шкалы вида ячеек устарел
            this._sigTipVer = sigTip_verNext(this._sigTipVer, _sameRowsLoad)   // IE 2026 11 03 / ODOO-350449 (ie-dm7 #128809, проба p250: порция 8, повтор truncated, дефолт ВЫКЛ, без ожидания пакета): кеш подсказки сигнала — только по смене массива строк (ответ settings_form / select_report_audit строк не меняет)
            this._alertKids = null; this._alertKidsS = null; this._alertClsColor = null; this._alertBaseColor = null // IE 2026 09 17: цвета строк-алертов пересчитываются с новыми данными   // IE 2026 10 14 / ODOO-5800: и мемо точечного обновления
            this.cache_data_cells.clear()
            this.css_invalidate_all('select') // IE 2026 08 18 / ODOO-5512: новые данные — прежние css_user устарели, пересчёт обязателен (IE 2026 09 04 / ODOO-336379: через css_invalidate_all — сброс мемо и строчных меток)
            if (preserve_css) {
                // cache_index не сбрасываем: новые строки не должны получить ключи,
                // совпадающие с перенесёнными
                for (const _c2 of this.cache2_data_cells.values()) {
                    _c2.css_calc = false
                    _c2.css_promise = null
                }
            } else {
                this.cache_index = 0
                this.cache2_data_cells.clear()
            }
            this.cache1_data_cells__call.clear()
            this.cache2_data_cells__call.clear()
            this.cache2_data_cells__call__used = 0
            this.cache_process_dataItem_py.clear()
            this.cache_process_dataItem_py__used = 0
            this.deferred_formatItem.clear()
            this.backendProcessed = false

            this.attr.use_cells = this.get_viewParam('use_cells')
            this.attr.use_editable = this.get_viewParam('use_editable')
            // IE 2026 08 18 / ODOO-5512: метод пересчёта после правки тоже может
            // приходить через fieldsMapping -> doc.viewParams.dataSheet (M03), а не
            // только из определения вида; без гидрации правка не уходила в afterEdit
            this.attr.executeWidgetMethod_afterEdit = this.get_viewParam('executeWidgetMethod_afterEdit', this.attr.executeWidgetMethod_afterEdit || '')
            this.attr.allowDragging = this.get_viewParam('allowDragging')
            // IE 2026 09 05 / ODOO-336330: showEmptyAlways (определение вида) — форма настроек: пустое поле = кодовый
            // дефолт, прятать его нельзя. Сохранённый doc.viewParams.<grid>.showEmpty=false (он же
            // приезжает в attr через set_viewParams бэка) и Alt-A (non-empty-widget) такой грид не трогают —
            // иначе группы без переопределений (Engine, Cache TTLs, весь Frontend) исчезали целиком
            this.attr.showEmpty = this.attr.showEmptyAlways ? true : this.get_viewParam('showEmpty')
            this.attr.hideEmptyRows = this.get_viewParam('hideEmptyRows')
            // IE 2026 08 30 / ODOO-5800 (заказ Игоря «добавь и здесь подвал»): значение из
            // ОПРЕДЕЛЕНИЯ вида — дефолт для viewParam. Без него конфигурационное
            // aggregateFooters=True затиралось undefined'ом (у записи параметр не сохранён),
            // и подвал не появлялся, хотя в конфиге он включён
            this.attr.aggregateFooters = this.get_viewParam('aggregateFooters', this.attr.aggregateFooters)

            this.attr_loadPyodide()
            
            this.undoStack.length = 0
            this.redoStack.length = 0
            this.modified = false
            if (_editKeep) { editKeep_restore(this, _editKeep); this.corrChip_schedule() }   // IE 2026 10 14 / ODOO-5800: те же строки — правки, чипс Corrections и Save остаются
            try { this._editKeepRowsRef = Array.isArray(this.data) ? gridSave_toRaw(this.data) : null } catch (e) { this._editKeepRowsRef = null }   // IE 2026 10 14 / ODOO-5800
            // this.irefresh++
            this.count_formatItem_cells_calcCSS_py = 0

            this.attr.show_performance = this.attr.show_performance ?? false
            // R18 (dm 2026 08 04): кастомная фабрика по умолчанию ВКЛ (флаг scrollFactory) —
            // без неё вся отложенная обработка ячеек при прокрутке не работает вовсе
            // (замер СНГ$: 125 полных formatItem на каждый шаг горизонтали).
            // Явное значение из viewParams записи всегда главнее.
            this.attr.use_customCellFactory = this.attr.use_customCellFactory
                ?? (this.store?.fastEntry?.scrollFactory !== false)
            this.attr.allow_formatItem = this.attr.allow_formatItem ?? true
            this.attr.use_delivery = this.attr.use_delivery ?? true
            this.use_performance = this.attr.show_performance

            this.set_commandsActive()

            this.attrWHERE_vueObj = this.WIDGET.vueObj.get_vueObj?.('viewWHERE')
            if (this.attrWHERE_vueObj?.attr?.['target-binding'] !== this.attr.binding) {
                this.attrWHERE_vueObj = null

            }

            // if (this.attr['default-CHIPS'] && !this['set-default-CHIPS']) {
            //     this.CHIPS.push(this.attr['default-CHIPS'])
            //     this['set-default-CHIPS'] = true
            // }

            // TEMP
            const CHIPS0 = this.get_viewParam('filterChips', [])
            if (CHIPS0.length) {
                for (const chip of CHIPS0) {
                    if (chip.attr_type === 'AttrOrder') {
                        chip.attr_type = 'CHIP-Order'
                    } else if (chip.attr_type === 'AttrGroup') {
                        chip.attr_type = 'CHIP-Group'
                    }
                }
                this.set_viewParam('CHIPS', CHIPS0)
                this.set_viewParam('filterChips', null)
            }

            try {
                this.selectedRanges_BEFORE = this.selBefore_snap(flex.selectedRanges)   // IE 2026 09 27 / ODOO-5800: снимок с binding колонок (selRestore_apply, fe.ux.gridSelOutOfRange)
            } catch (e) {
                this.selectedRanges_BEFORE = null
            }

            this.mergeColumns = this.attr?.mergeColumns || 0
            const frozenColumns = flex.frozenColumns || 0
            if (frozenColumns && frozenColumns > this.mergeColumns) {
                this.mergeColumns = frozenColumns
            }

            this.qqq = 0
            flex.selectionMode = this.attr.selectionMode || this.store.setting('fe.grid.selectionMode', 'MultiRange')
            if (this.attr.childItemsPath) {
                flex.childItemsPath = this.attr.childItemsPath
                flex.selectionMode = this.attr.selectionMode || this.store.setting('fe.grid.selectionMode', 'MultiRange')
            } else {
                flex.childItemsPath = ''
            }
            
            this.dblclick_action = this.get_dblclick_action()

            // IE 2026 08 20 (заказ Игоря): Borders=None — нижних линий нет, высоту
            // строк под них не резервируем (компактнее на 2px)
            // IE 2026 09 04 / ODOO-336331 (заказ Игоря): rowsHeightStandard — строки стандартной высоты (rowsHeight 0/пусто = 2),
            // компактность Borders=None (−2px) к такому гриду не применяется (списки Settings tree / Variants панели настроек)
            if (this.attr.borders === 'None' && flex.rows && !this.attr.rowsHeightStandard) {
                if (!this._bordersNone_size0) this._bordersNone_size0 = flex.rows.defaultSize
                const _target = Math.max(14, this._bordersNone_size0 - 2)
                if (flex.rows.defaultSize !== _target) flex.rows.defaultSize = _target
            }
            // IE 2026 09 04 / ODOO-336291 (mobile UX): B-21 rowHeight — строки под палец: ≥ 32 px на телефоне (17 px — палец накрывал 2.5 строки,
            // глиф группы 20×15, тумблер ячейки 16×16). Выкл: window.mobileUi.set('rowHeight', false)
            if (this.store.mobileUi?.on && this.store.mobileUi.rowHeight !== false && flex.rows && flex.rows.defaultSize < 32) {
                flex.rows.defaultSize = 32
            }
            this.gridRows_sync(); this.gridRows_apply(flex, true)   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p183: перемикач «Рядки: Компактні / Високі» у таблиці REPORT2, як у Heatmap (grid)): «Високі» переживают новую выборку / смену опций (штатная высота выше могла вернуться)

            // IE 2026 08 20 / ODOO-336291 (mobile UX): на телефоне гриды без редактирования —
            // dblclick пальцем недоступен; выкл: window.mobileUi.set('readOnlyGrids', false)
            // IE 2026 09 04 / ODOO-336291 (mobile UX): B-24 settingsEditable — грид полей (AttrTabGrid) — исключение, см. mobileEditableGrid
            flex.isReadOnly = !!(this.store.mobileUi?.on && this.store.mobileUi.readOnlyGrids && !this.mobileEditableGrid())
                || (false && this.get_viewParam('isReadOnly'))
                || this.store.readonly_on()   // IE 2026 09 29 / ODOO-342781: роль «только чтение» — ни одна ячейка не редактируется (wijmo не открывает редактор, вставку, очистку, чекбоксы)
            this.roEdit_hook(flex)   // IE 2026 09 29 / ODOO-342781: тост «Read-only access: editing is disabled» на попытку правки
            if (flex.hostElement) flex.hostElement.dataset.mobEditable = (this.store.mobileUi?.on && this.mobileEditableGrid()) ? '1' : ''

            this.aggregateFooters()
            
            //columns
            this.attr_by_binding = {}
            this.parentAttr_by_idAttr = {}
            this.idAttr_max = 0
            this.attr_by_bindingColumnGroup = {}
            this.column_by_binding0 = {}
            this.columnGroups_by_binding0 = {}
            flex.columns.clear()
            this.column_by_binding = {}
            this.autoSizeColumnsList = []
            let col = null
            this.icol = 0
            this.attr.column_childItemsPath = this.attr?.column_childItemsPath || 'attrs' // 2024 11 27
            this.fill_collapseTo(this.attr[this.attr.column_childItemsPath])
            this.hide_clonesColumns()

            this.viewParam_attrs = this.store.get_viewParam(this.WIDGET, this.attr.name, 'attr_by_binding', {}, this.attr)
            
            // OLD 2025-07-01
            this.widths = this.store.get_viewParam(this.WIDGET, this.attr.name, 'widths', null, this.attr) 
            if (this.widths !== null && this.widths !== undefined) {
                for (let key in this.widths) {
                    this.viewParam_attrs[key] = this.viewParam_attrs[key] || {}
                    this.viewParam_attrs[key].width = this.widths[key]
                }

                this.widths = null
                this.store.set_viewParam(this.WIDGET, this.attr.name, 'widths', this.widths, this.attr)
            }

            // hide empty 'binding' columns 2025-08-19
            const scan_columns = (columns) => {
                let haveChildren0 = 0
                for (let col of columns||[]) {
                    if (col.use !== false) {
                        let haveChildren = 0
                        if (col.attrs) {
                            haveChildren = scan_columns(col.attrs)
                            haveChildren0 += haveChildren
                        }
                        if (col.binding) {
                            haveChildren0 += 1
                        } else if (!haveChildren) {
                            col.use = false
                            // IE 2026 08 17 / ODOO-4997 (заказ Игоря): убран
                            // console.log «hide empty-binding column …» — спамил консоль
                        }
                    }
                }
                return haveChildren0
            }
            scan_columns(this.attr.attrs)

            let _colsForScan = this.columns()
            // IE 2026 10 06 / ODOO-341407 (заказ Игоря п.2): опция «Show translation fields» — за translate-колонками таблицы данных списка колонки
            // «<колонка> (uk)/(ru)»; НОВЫЙ массив (attr.attrs — узел вида: уходит на бэк и в ⚙ таблицы — не мутируется), обе функции сканирования ниже идут по нему
            _colsForScan = this.i18nFields_listCols(_colsForScan)
            if (this.attr.column_childItemsPath) {
                _colsForScan = this.collapse_arrowLayer_attrs(_colsForScan, this.attr.column_childItemsPath)
            }
            if (this.attr.column_childItemsPath) {
                let columnGroups = this.scan_columnGroups_fromAttrs(_colsForScan, this.attr.column_childItemsPath)

                // get hierarchy from 'level'
                // columnGroups = this.store.get_hierarchy(columnGroups, 'columns')
                // дефолтная свёртка колонок (fold_cols_level) — СИНХРОННО в
                // определениях, до присвоения: первый кадр строится сразу в нужной
                // свёртке, без отложенной лесенки и промежуточных кадров
                // (ИЕ 2026-08-12: «раскрыл — через секунду схлопнулось обратно»)
                this.foldDefault_applyColsDefs(columnGroups)
                flex.columnGroups = columnGroups

                this.create_stickyRows()

                for (let col of flex.columns) {
                    this.column_by_binding0[col.binding] = col
                }
                this.scan_columnGroups_fromFlex(flex.columnGroups)
            }

            // ----------------------------------------------------------------------------------------------------------------
            // const startTime0 = performance.now()

            this._rlCols = null   // IE 2026 10 25 / ODOO-348925: листы AttrRowLink — заново на каждую сборку колонок
            this.scan_column_fromAttrs(_colsForScan, this.attr.column_childItemsPath)
            if (this._rlCols) this.rl_sync(true)   // IE 2026 10 25 / ODOO-348925: карты ключ → название и аксессоры title
            this.colorEd_scan()   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: цвета как на слайде — редактор цвета ColorPicker): колонки с editor 'color' — заново на каждую сборку колонок
            // if (!this.store.hide_console) console.log(`scan_column_fromAttrs ${this.attr.binding} ${this.columns().length} (Δ ${Math.round(performance.now() - startTime0)}ms)`)

            // ── граница frozen не должна резать группу колонок ──────────────────
            // wijmo (MergeManager._getMergedRange, ветка columnGroups) делит merge-
            // диапазон шапки по границе frozen: группа, пересёкшая границу, рисуется
            // ДВУМЯ ячейками с одним текстом («2026 | 2026», «Q1 2026 | Q1 2026»).
            // attr.frozenColumns приходит с бэка как число головных колонок, но
            // фронт часть из них не создаёт (isHidden: use=false / v-if / доступ) —
            // граница уезжает внутрь первой группы периодов. Сдвигаем её влево до
            // начала разрезанной группы; в здоровом случае клэмп ничего не меняет.
            {
                if (this._frozenDefault === undefined) this._frozenDefault = this.attr.frozenColumns || 0   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк): значение вида при открытии — для «Reset frozen columns»
                let _fz = this.i18nFields_frozenShift(this.attr.frozenColumns || 0)   // IE 2026 10 06 / ODOO-341407: + колонки переводов «(uk)/(ru)» левее границы (attr.frozenColumns не меняется)
                _fz = this.frozenColumns_clamp(_fz, flex)   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк): телефон и клэмп вынесены в frozenColumns_clamp (то же правило — для меню колонки)
                this.frozenColumns_safe = _fz
                if (flex.frozenColumns !== _fz) flex.frozenColumns = _fz
                // merge шапки строк считался выше по старому значению — подровнять
                if (_fz > (this.attr?.mergeColumns || 0)) this.mergeColumns = _fz
                else this.mergeColumns = this.attr?.mergeColumns || 0
            }

            {
                const _colMap = [], _cols = this.flex.columns, _abp = this.attr_by_binding
                let _physCol = 0
                for (let _logCol = 0; _logCol < _cols.length; _logCol++) {
                    const _span = _abp[_cols[_logCol]?.binding]?.colSpan
                    if (!(_span > 1)) break
                    const _s = _physCol, _e = _physCol + _span - 1
                    for (let _c = _s; _c <= _e; _c++) _colMap[_c] = {start: _s, end: _e, logCol: _logCol}
                    _physCol += _span
                }
                this.mergeColumnBlocksColMap = _colMap.length >= 2 ? _colMap : null
                this.mergeColumnBlocksTotal = _physCol
                this._dataColumns_nonEmpty_cache = null
            }

            this.set_itemsSource()

            const set_modified = false
            for (let attr_col of this.columns()) {
                if (attr_col.attr_type === 'AttrNumber') {
                    flex.rows.forEach((item) => {
                        let value = this.store.get_value(item?.dataItem||{}, attr_col.binding)
                        if (value != null && typeof value === 'string') { // 2023 05 23 for data_strip
                            this.store.set_value(item.dataItem, attr_col.binding, +value, null, null, null, set_modified)
                        }
                    })
                }
            }
            this.prepare_AttrMulti_all()
            this.prepare_printTemplate()
            this.resolve_titlesByIds_()

            // handle button clicks
            // flex.addEventListener(flex.hostElement, 'click', this.click)
            
            // if (this.WIDGET.widget_class=='widget_SOP_document') {

            // if (this.parent_attr.showEmpty) {
            //     this.attr.showEmpty = true
            // }
            if (!this.attr.showEmpty && this.attr_nonEmptyWidget) {
                this.applysCHIPS_register()   // IE 2026 09 10 / ODOO-…: ключ регистрации — см. applysCHIPS_register
                this.store.check_nonEmptyWidget(this.WIDGET)
            }
            this.apply_CHIPS()

            this.set_headerColumns()
            this.formatSheet()
            this.collapsedAll(true)
            // }
            // if (flex.sortManager.checkSortItemExists(0)==-1) {  
            //     flex.sortManager.addSortLevel(0, true)  !!! problems with ediding: Uncaught TypeError: Cannot set properties of undefined (setting '_view')
            // }
            // flex.sortManager.commitSort()
            // this.set_headerColumns()
            this.use_selectorMeasures()
            this.check_WHERE()
            this.setBreakBefore(this.attr)
            this.autoSizeColumns()
            // this.autoSizeRows()
            // flex.columnHeaders.rows.defaultSize = this.break_width >> .attr-grid .wj-cell
            this.scanRowsID()
            this.load_cells_binding()
            this.set_stickyRows()
            this.lightView_apply() // после построения колонок (lightView: скрыть всё, кроме Title)
            this.ignore_selectionChanged = false

            if ('selectRow' in this.attr) {
                let row = this.attr.selectRow
                // IE 2026 10 29 / ODOO-5800 (ie-dm7 #115712, слово Igor: relation_row — переход к шагу согласования): строка по значению поля (set_activeAttr, relation_row) — пересверка по строкам грида (сортировка / группировка меняют индекс)
                const rrMatch = this.attr.selectRow_match, rrOpen = !!this.attr.selectRow_openRow
                delete this.attr.selectRow_match
                delete this.attr.selectRow_openRow
                if (rrMatch) {
                    const i_ = relationRow_rowIndex(flex.rows, rrMatch, (r) => r?.dataItem)
                    if (i_ >= 0) row = i_
                }
                const row2 = rrMatch ? row : (this.attr.selectRow2 ?? row)
                delete this.attr.selectRow
                delete this.attr.selectRow2
                const r1 = Math.min(row, row2), r2 = Math.max(row, row2)
                const range = new wjGrid.CellRange(r1, 0, r2, flex.columns.length - 1)
                this.selectedRanges_BEFORE = this.selBefore_snap([range])   // IE 2026 09 27 / ODOO-5800: снимок с binding колонок
                if (r1 >= 0 && r1 < flex.rows.length) {
                    flex.selection = range
                    flex.scrollIntoView(r1, 0)
                    if (rrOpen) this.relationRow_openSelected()   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #115712, слово Igor: relation_row — переход к шагу согласования)
                }
            }
            this.gridSave_baselineIfNew()   // IE 2026 10 13 / ODOO-5800: пришли новые строки ленивой вкладки — снимок для Save / Discard
        },
        processing_fieldsMapping() {
            const fieldsMapping = this.WIDGET.record?.doc?.params?.fieldsMapping || [];
            if (fieldsMapping.length && this.attr.name) {
                this.fieldsMapping = {};
                const name_ = 'viewParams.'+this.attr.name + '.'

                const parse_fieldsMapping = (fieldsMapping_) => {
                    for (const field of fieldsMapping_) {
                        if (field.use && (field.attr.binding||'').startsWith(name_)) {   
                            const binding = field.attr.binding.replace(name_, '');
                            this.attr[binding] = field.attr.value;
                        }
                        if ((field.attrs||[]).length) {
                            parse_fieldsMapping(field.attrs);
                        }
                    }
                }

                parse_fieldsMapping(fieldsMapping)
            }
        },
        load_cells_binding() {
            this.cells_binding_map = {}
            const binding = this.attr.cells_binding
            if (!binding) return

            const cells_data = this.store.get_value(this.WIDGET.record, binding)
            const cells_array = cells_data?.data ?? (Array.isArray(cells_data) ? cells_data : null)
            if (!cells_array) return

            const map = {}
            for (const cell of cells_array) {
                if (!map[cell.row]) map[cell.row] = {}
                map[cell.row][cell.col] = cell
            }
            this.cells_binding_map = map
        },
        scanRowsID() {
            if (!this.attr.useRowsID) return

            const cells_doc = this.cells_doc = {};
            const prefixRows = 'doc.dataRows.';

            function scan_cells_doc(fields) {
                for (const field of fields) {
                    if (field.use !== false) { // && !field.hidden
                        if (field.binding && field.binding.startsWith(prefixRows)) {
                            const cell_binding = field.binding.replace(prefixRows, '');
                            cells_doc[cell_binding] = field;
                        }
                        if (field.attrs) {
                            scan_cells_doc(field.attrs);
                        }
                    }
                }
            }

            scan_cells_doc(this.WIDGET.view);
        },
        hide_clonesColumns() {
            const bindings = {}
            let scan_columns = (columns) => {
                for (let col of columns) {
                    if (col.binding && !this.isHidden(col)) {
                        if (col.binding in bindings) {
                            col.use = false
                        } else {
                            bindings[col.binding] = true
                        }
                    }
                    if (col.attrs) {
                        scan_columns(col.attrs)
                    }
                }
            }

            scan_columns(this.attr.attrs)
        },
        foldBadges_init(flex) {
            const vueObj = this
            // Ховер по верхнему левому углу таблицы (topLeftCells) показывает бейджи
            // «1..N» — по числу уровней группировки строк; клик по «n» сворачивает
            // строки до n уровней (collapseGroupsToLevel(n-1), работает и для
            // childItemsPath-дерева отчёта). Шапка скрыта (углa нет/нулевой) — не
            // показываем. Панель живёт в hostElement и умирает вместе с ним.
            const host = flex.hostElement
            let panel = null, openTimer = null, hideTimer = null, docOver = null
            const hide = () => {
                clearTimeout(openTimer); openTimer = null
                clearTimeout(hideTimer); hideTimer = null
                if (docOver) { document.removeEventListener('mouseover', docOver, true); docOver = null }
                if (panel) { panel.querySelectorAll('[data-help]').forEach(b => uiHelp.unbind(b)); panel.remove(); panel = null }   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5 (накат 28.09): снять регистрацию подсказок бейджей — иначе список wijmo Tooltip копил бы убранные элементы
            }
            // курсор ушёл с угла — не гасим мгновенно: панель вынесена из грида,
            // и путь к самим бейджам лежит ЧЕРЕЗ выход за пределы hostElement
            const hideSoon = () => {
                clearTimeout(openTimer); openTimer = null
                if (!panel || hideTimer) return
                hideTimer = setTimeout(() => { hideTimer = null; hide() }, 200)
            }
            this._foldBadges_hide = hide
            const show = () => {
                if (panel) return
                const tl = host.querySelector('[wj-part="tl"]')
                if (!tl || !tl.offsetHeight) return
                let maxParent = -1
                for (const row of flex.rows) {
                    if (row.hasChildren || row.constructor?.name === 'GroupRow') {
                        const l = row.level ?? 0
                        if (l > maxParent) maxParent = l
                    }
                }
                // уровни СВОРАЧИВАЕМЫХ групп колонок: runtime-экземпляры ColumnGroup
                // отдаёт getColumnGroups() (мутация flex.columnGroups — сырых
                // определений — на грид не действует)
                let maxColParent = -1
                const walkColGroups = (groups, fn) => {
                    for (const g of groups || []) {
                        if (g.columns && g.columns.length) {
                            // collapseTo бывает строкой, массивом И индексом/нулём
                            // (multidates-генератор дат) — проверка .length теряла такие группы
                            if (g.collapseTo !== undefined && g.collapseTo !== null && g.collapseTo !== '') fn(g)
                            walkColGroups(g.columns, fn)
                        }
                    }
                }
                const colGroupsRoot = () => (flex.getColumnGroups && flex.getColumnGroups()) || []
                walkColGroups(colGroupsRoot(), (g) => { if (g.level > maxColParent) maxColParent = g.level })
                if (maxParent < 0 && maxColParent < 0) return // группировок нет
                panel = document.createElement('div')
                panel.className = 'fold-badges'
                const mkBadge = (parent, label, tooltip, onClick, helpState) => {
                    const b = document.createElement('div')
                    b.className = 'fold-badge'
                    b.textContent = label
                    b.title = tooltip
                    if (helpState) uiHelp.bind(b, { key: 'grid.foldBadge', state: helpState })   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5: снимается в hide() — панель пересоздаётся на каждое наведение
                    b.addEventListener('mousedown', (e) => {
                        e.preventDefault(); e.stopPropagation(); onClick()
                    })
                    parent.appendChild(b)
                }
                // диагностика «почему нет бейджей» — читается из headless/консоли
                host._foldDiag = { rowLevels: maxParent + 1, colLevels: maxColParent + 1,
                                   colGroupsTotal: (() => { let t = 0; const cnt = (gs) => { for (const g of gs || []) { if (g.columns && g.columns.length) { t++; cnt(g.columns) } } }; cnt(colGroupsRoot()); return t })() }
                // ориентация по эскизу ИЕ 2026-08-11: от угла ВПРАВО — колонки
                // (горизонтальная структура), ВНИЗ — строки (вертикальная)
                if (maxColParent >= 0) {
                    const colStrip = document.createElement('div')
                    colStrip.className = 'fold-badges-h'
                    // состояний у колонок «уровни + 1»: пороги сворачивания
                    // 1..L и полное раскрытие — при одном уровне группировки
                    // нужны ДВА бейджа (свернуть / развернуть всё)
                    for (let n = 1; n <= maxColParent + 2; n++) {
                        const isLast = n === maxColParent + 2
                        mkBadge(colStrip, n,   // IE 2026 09 23 / ODOO-341407: i18n
                            isLast ? t('Expand all columns') : tn(n, 'Collapse columns to {n} level', 'Collapse columns to {n} levels'),
                            () => vueObj.foldCols_toLevel(flex, n, { expandAll: isLast }),
                            isLast ? 'expandAll' : 'cols')   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5
                    }
                    panel.appendChild(colStrip)
                }
                if (maxParent >= 0) {
                    const rowStrip = document.createElement('div')
                    rowStrip.className = 'fold-badges-v'
                    for (let n = 1; n <= maxParent + 1; n++) {
                        const isLast = n === maxParent + 1
                        mkBadge(rowStrip, n,   // IE 2026 09 23 / ODOO-341407: i18n
                            isLast ? t('Expand all rows') : tn(n, 'Collapse rows to {n} level', 'Collapse rows to {n} levels'),
                            () => flex.deferUpdate(() => flex.collapseGroupsToLevel(isLast ? maxParent + 1 : n - 1)),
                            isLast ? 'expandAll' : 'rows')   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5
                    }
                    panel.appendChild(rowStrip)
                }
                // ИЕ 2026-08-14: центр бейджей — НА кромке таблицы (сдвиг на половину
                // бейджа влево и вверх). Панель живёт не в гриде, а в body: и
                // hostElement, и .attr-grid имеют overflow:hidden, внутри них
                // вынесенные за край бейджи обрезало бы пополам. Отсюда position:fixed
                // и координаты вьюпорта.
                const tlR = tl.getBoundingClientRect()
                const HALF = 9 // половина .fold-badge (18px)
                panel.style.left = `${tlR.left - HALF}px`
                panel.style.top = `${tlR.top - HALF}px`
                // панель прозрачна для мыши, её собственный mouseenter не приходит —
                // держим её живой по всплывающему mouseover от самих бейджей
                panel.addEventListener('mouseover', () => { clearTimeout(hideTimer); hideTimer = null })
                // курсор мог уйти мимо грида (в топбар, к чипсам) — там событий host
                // не будет, поэтому ловим уход на document
                docOver = (ev) => {
                    const t = ev.target
                    if (t instanceof Element && (panel?.contains(t) || host.contains(t))) return
                    hideSoon()
                }
                document.addEventListener('mouseover', docOver, true)
                overlayRoot().appendChild(panel)   // IE 2026 09 23 / ODOO-… (замечание Игоря: панели-меню в Full screen): полноэкран документа — панель в body, полноэкран виджета — в нём
            }
            // зона ховера шире самого угла: вся высота шапки и ~240px ширины
            // (левый блок заголовков) — по эскизу ИЕ 2026-08-11
            host.addEventListener('mousemove', (e) => {
                if (panel && panel.contains(e.target)) return
                const tl = host.querySelector('[wj-part="tl"]')
                if (!tl || !tl.offsetHeight) { hide(); return }
                const r = tl.getBoundingClientRect()
                const zoneW = Math.max(r.width * 2, 240)
                const inZone = e.clientX >= r.left && e.clientX <= r.left + zoneW
                    && e.clientY >= r.top && e.clientY <= r.bottom
                if (!inZone) { hideSoon(); return }
                clearTimeout(hideTimer); hideTimer = null
                if (panel || openTimer) return
                // ИЕ 2026-08-14: бейджи по НАМЕРЕНИЮ, а не по касанию — угол лежит
                // на пути к верхним чипсам, и мгновенный показ давал мельтешение.
                // IE 2026 08 27 / ODOO-5800 (заказ Игоря): своя, заметно большая пауза
                // (1.5 с по умолчанию) вместо общей hoverOpenMs — бейджи не выскакивают
                // при проезде к кнопкам панели/чипсам; уход из зоны до срабатывания
                // таймера отменяет показ (hideSoon/mouseleave). Настройка без пересборки:
                // window.fastEntry.set('groupBadgesDelayMs', N)
                const openMs = this.store.fastEntry?.groupBadgesDelayMs ?? this.store.setting('fe.ux.groupBadgesDelayMs', 1500)   // IE 2026 09 05 / ODOO-336330: настройка базы; fastEntry — личный override
                openTimer = setTimeout(() => { openTimer = null; show() }, openMs)
            })
            host.addEventListener('mouseleave', hideSoon)
            // IE 2026 09 13 / ODOO-… (заказ Игоря): клик по самому верхнему левому углу шапки (ячейка tl) — бейджи уровней
            // строк и колонок СРАЗУ, без паузы ховера (пауза защищает от мельтешения при проезде мышью, клик — явное намерение)
            host.addEventListener('click', (e) => {
                const tl = host.querySelector('[wj-part="tl"]')
                if (!tl || !tl.offsetHeight) return
                const r = tl.getBoundingClientRect()
                if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) return
                clearTimeout(openTimer); openTimer = null
                clearTimeout(hideTimer); hideTimer = null
                if (!panel) show()
            })
        },
        // ---- IE 2026 09 21 / ODOO-5800: ИТОГИ СТРОК-ГРУПП ПО ОТБОРУ ----
        // Igor 21.09 (скрин Purchase Balance под чипсом поиска «Беларусь»): «При чипсе-фильтре строк без флага "Show rows without matches" нужно пересчитывать итоги. Давай
        // сделаем это как опция, пока в коде, по умолчанию вкл». Итог строки-группы считает бэк по всем строкам данных группы; чипс таблицы (поиск / метрики / оформление /
        // стиль / условие с местом Table) прячет подчинённые строки на фронте — итог расходился с видимым. Под прячущим чипсом итог пересчитывается по ВИДИМЫМ подчинённым
        // строкам — ТОЛЬКО ДЛЯ ПОКАЗА: значения строк данных не меняются (сохранение, undo, снимок no-op сохранения, _cells их не видят), пересчитанное лежит в побочной карте
        // this._ftMap (сырая строка данных → {колонка: значение}), подставляется при отрисовке (foldAgg_value → foldAgg_paintCell, обе ветки formatItem) и снимается вместе с
        // отбором — итоги бэка возвращаются как были. Что пересчитывается и самопроверка — utils/filterTotals.js. Ячейка с итогом по отбору помечена (класс ft-total, подсказка),
        // правка такой ячейки отменяется (итог по отбору не число документа). Опция: fe.ux.filterTotalsRecalc (по умолчанию ВКЛ; false — прежнее поведение)
        filterTotals_on() {
            try { return this.store.setting('fe.ux.filterTotalsRecalc', true) !== false } catch (e) { return true }
        },
        // IE 2026 09 24 / ODOO-5800 (Igor, скрин 1fxa_001 под поиском «PSP Pharma Ltd»: «в ячейке 58:27 я вижу 31 000 — не могу понять, с чего она»; «в продолжение см ячейка 58:35»):
        // итог по отбору — на ВСЕХ путях показа итога группы. Причина 58:27 / 58:35: memo-строка «· of which expired» (161 за 2026-09, бэк: _DLRow.memo + total_excluded — в итог
        // родителя не входит) считалась слагаемым «Грузии» → самопроверка 2 808 ≠ 2 969 → итог бэка по всем строкам (ft-stale), у «Ex-Delta» колонка «испорчена» (тоже итог бэка);
        // «Всього» 2026 — то же (8 856 ≠ 9 017). Под опцией: (1) строки вне итога родителя (total_excluded / memo) — вне арифметики родителя (filterTotals_compute, detached);
        // (2) форма ячейки (строка-якорь, формула прихода / расхода) и приглушение повтора итога группы (gt-dup-dim) берут показанный итог по отбору, а не значение строки данных.
        // Опция fe.ux.filterTotalsAllPaths (по умолчанию ВКЛ; false — прежнее поведение); приглушение повтора по итогам отбора — ещё и fe.ux.filterTotalsGroupDup (ВКЛ)
        filterTotals_allPaths() {
            try { return this.store.setting('fe.ux.filterTotalsAllPaths', true) !== false } catch (e) { return true }
        },
        // IE 2026 09 24 / ODOO-5800: показанный итог ячейки при действующем отборе — { v, all } (v — итог по отбору, all — значение строки данных = итог по всем строкам) или null
        filterTotals_shown(dataItem, binding) {
            if (!this._ftMap || !dataItem || !this.filterTotals_allPaths()) return null
            const a = this.attr_by_binding[binding]
            const b0 = (a && a.binding0) || binding
            const v = this.filterTotals_cell(dataItem, b0)
            if (v === undefined) return null
            return { v, all: this.store.get_value(dataItem, binding) }
        },
        filterTotals_cell(dataItem, binding) {
            // undefined — итога по отбору у ячейки нет; null — итог по отбору «пусто»
            const m = this._ftMap
            if (!m || !dataItem) return undefined
            const o = m.get(toRaw(dataItem))
            return o && binding in o ? o[binding] : undefined
        },
        filterTotals_rule(attr_col, item) {
            // правило агрегата ячейки — как на бэке (data_layout2.fill_dataItem_values) и у агрегатов свёрнутых периодов (foldAgg_value)
            let rule
            if (attr_col.raw_binding === 'value_') {   // общая колонка значений: агрегат задаёт мера строки
                const m = item.measure_ || (typeof item.measure === 'object' ? item.measure : null) || {}
                rule = m.aggregateScale || this.foldAgg_dlScale(item._DLRow?.row_id) || m.aggregateFooters || 'Sum'
            } else {
                rule = attr_col.aggregateScale || this.foldAgg_dlScale(item._DLRow?.row_id) || attr_col.aggregateFooters || attr_col.aggregate || 'Sum'
            }
            const asm = attr_col.aggregateScale_measure
            if (asm && typeof asm === 'object') {
                const mId = typeof item.measure === 'string' ? item.measure : (item.measure?.id ?? item.measure_?.id)
                if (mId && asm[mId]) rule = asm[mId]
            }
            return rule
        },
        filterTotals_cols() {
            // числовые колонки значений лэйаута (raw_binding есть только у них), включая спрятанные листья свёрнутых периодов — их складывает агрегат свёрнутого периода
            const out = [], seen = new Set()
            for (const col of this.flex?.columns || []) {
                const b = col.binding, a = b ? this.attr_by_binding[b] : null
                if (!a || !a.raw_binding || seen.has(b)) continue
                if (!(a.attr_type === 'AttrNumber' || a.attr_type === 'AttrTime' || a.attr_type === 'AttrDays' || a.measure_in_dataItem)) continue
                seen.add(b)
                out.push(ft_col(b, (item) => this.filterTotals_rule(a, item), b + '_w'))
            }
            return out
        },
        filterTotals_recompute(active, redraw = true) {
            // active: true — действует прячущий чипс таблицы, false — отбора нет, undefined — повторный расчёт после правки значений (признак прежний)
            if (active === undefined) active = !!this._ftActive
            this._ftActive = !!active
            const had = !!this._ftMap
            let map = null, stats = null, stale = null
            try {
                if (active && this.filterTotals_on() && this.attr?.childItemsPath && this.flex?.rows?.length) {
                    const rows = this.flex.rows, list = new Array(rows.length)
                    let hidden = false
                    const _allPaths = this.filterTotals_allPaths()   // IE 2026 09 24 / ODOO-5800: строки вне итога родителя (memo «· of which …» / total_excluded) — не слагаемые родителя
                    for (let i = 0; i < rows.length; i++) {
                        const r = rows[i], it = r.dataItem ? toRaw(r.dataItem) : null
                        list[i] = { level: r.level, visible: r.visible !== false, item: it, skip: !it || !!it._variant,
                            detached: _allPaths && !!it && !!(it._DLRow?.total_excluded || it._DLRow?.memo) }   // IE 2026 09 24 / ODOO-5800
                        if (it && r.visible === false) hidden = true
                    }
                    const cols = hidden ? this.filterTotals_cols() : []
                    if (cols.length) {
                        const t0 = performance.now()
                        const res = filterTotals_compute(list, cols)
                        stats = res.stats; stats.ms = Math.round(performance.now() - t0); stats.rows = rows.length; stats.cols = cols.length
                        if (res.map.size || res.stale.size) { map = res.map; stale = res.stale }
                    }
                }
            } catch (e) { map = null; console.warn('filterTotals skipped:', e) }
            this._ftStats = stats
            if (!had && !map) return
            this._ftMap = map
            this._ftStale = map ? stale : null   // ячейки затронутых групп, оставшиеся с итогом бэка по всем строкам — приглушаются
            this.cf_cache?.clear()   // условное оформление ячеек итогов считается по показанному значению
            this._foldAggCache = new WeakMap(); this._ftStamp = this._foldAggCache
            if (redraw) { try { this.flex.invalidate() } catch (e) { /* грид ещё не готов */ } }
        },
        filterTotals_mark(e_cell, fold, dataItem, binding) {
            // пометка ячейки с итогом по отбору — в обеих ветках formatItem (класс из кэша className мог остаться от прошлого состояния); ячейка затронутой отбором группы,
            // оставшаяся с итогом бэка по ВСЕМ строкам (правило фронтом не воспроизводится), приглушается — видно, какие числа по отбору, а какие нет
            if (!this._ftSeen && !(fold && fold.ft) && !this._ftStale) return   // до первого итога по отбору в этом гриде ячейки не проверяются вовсе
            const ft = !!(fold && fold.ft)
            const st = !ft && !!this._ftStale && !!dataItem && !!this._ftStale.get(toRaw(dataItem))?.has(binding)
            if (ft || st) this._ftSeen = true
            const cl = e_cell.classList
            if (ft !== cl.contains('ft-total')) { if (ft) wjcCore.addClass(e_cell, 'ft-total'); else wjcCore.removeClass(e_cell, 'ft-total') }
            if (st !== cl.contains('ft-stale')) { if (st) wjcCore.addClass(e_cell, 'ft-stale'); else wjcCore.removeClass(e_cell, 'ft-stale') }
            if (ft || st) { if (!e_cell.title || e_cell.__ftTitle) { e_cell.title = ft ? FT_HINT() : FT_STALE_HINT(); e_cell.__ftTitle = true } }
            else if (e_cell.__ftTitle) { e_cell.removeAttribute('title'); e_cell.__ftTitle = false }
        },
        // ---- агрегаты свёрнутых групп колонок (ИЕ 2026-08-11) ----
        // Видимая collapseTo-колонка свёрнутой группы показывает агрегат по листовым
        // колонкам группы с тем же raw_binding (колонки-даты multidates). Правила —
        // как на бэке (data_layout2): aggregateScale поля → aggregateScale_measure
        // по мере строки → aggregateFooters → Sum. Считается в formatItem на лету,
        // кэш по dataItem; сбрасывается в refreshing() вместе с кэшем ячеек.
        foldAgg_groups() {
            if (this._foldAggGroups) return this._foldAggGroups
            const map = new Map()
            const walk = (groups) => {
                for (const g of groups || []) {
                    if (!g.columns || !g.columns.length) continue
                    const ct = g.collapseTo
                    if (ct !== undefined && ct !== null && ct !== '') {
                        for (let rep of Array.isArray(ct) ? ct : [ct]) {
                            if (typeof rep === 'number') rep = g.columns[rep]?.binding
                            if (typeof rep === 'string' && rep) {
                                if (!map.has(rep)) map.set(rep, [])
                                map.get(rep).push(g) // обход сверху вниз: внешние группы раньше внутренних
                            }
                        }
                    }
                    walk(g.columns)
                }
            }
            walk((this.flex?.getColumnGroups && this.flex.getColumnGroups()) || [])
            this._foldAggGroups = map
            return map
        },
        foldAgg_value(dataItem, col_binding, attr_col) {
            // → {v} если ячейка — представитель свёрнутой группы и правило поддержано, иначе null
            if (!dataItem || !attr_col?.raw_binding) return null
            const groups = this.foldAgg_groups().get(col_binding)
            const grp = groups ? groups.find(g => g.isCollapsed) : null // внешняя свёрнутая — она и видна
            if (!grp) {
                // IE 2026 09 21 / ODOO-5800 (Igor: под чипсом-фильтром строк итоги групп — по видимым строкам): у строки-группы есть итог по отбору — показываем его
                // (значение строки данных не меняется; ft — признак для пометки ячейки)
                if (this._ftMap) { const _o = this.filterTotals_cell(dataItem, col_binding); if (_o !== undefined) return { v: _o, ft: true } }
                return null
            }
            let cellMap = this._foldAggCache?.get(dataItem)
            if (cellMap && col_binding in cellMap) return cellMap[col_binding]
            // порядок BE (data_layout2): aggregateScale поля → «Aggregate DataLayout»
            // строки DL (наследуется родителем — Stock: opening_balance) → aggregateFooters
            let rule = attr_col.aggregateScale || this.foldAgg_dlScale(dataItem._DLRow?.row_id)
                || attr_col.aggregateFooters || attr_col.aggregate || 'Sum'
            const asm = attr_col.aggregateScale_measure
            if (asm && typeof asm === 'object') {
                const mId = typeof dataItem.measure === 'string' ? dataItem.measure
                    : (dataItem.measure?.id ?? dataItem.measure_?.id)
                if (mId && asm[mId]) rule = asm[mId]
            }
            const bindings = this.foldAgg_sourceBindings(grp, attr_col.raw_binding)
            const vals = []
            // IE 2026 09 21 / ODOO-5800: у строки-группы с итогами по отбору свёрнутый период складывается из значений ПО ОТБОРУ (иначе свёрнутый год показывал бы итог по всем строкам)
            const _ft = this._ftMap ? this._ftMap.get(toRaw(dataItem)) : null
            let _ftHit = false
            const _val = (b) => { if (_ft && b in _ft) { _ftHit = true; return _ft[b] } return this.store.get_value(dataItem, b) }
            for (const b of bindings) {
                const v = _val(b)
                if (v !== null && v !== undefined && v !== '') vals.push(v)
            }
            let out
            const nums = () => vals.map(Number).filter(n => !Number.isNaN(n))
            switch (rule) {
                case 'Sum': { const n = nums(); out = { v: n.length ? n.reduce((a, b) => a + b, 0) : null }; break }
                case 'Avg': { const n = nums(); out = { v: n.length ? n.reduce((a, b) => a + b, 0) / n.length : null }; break }
                // IE 2026 09 11 / ODOO-5800: WAvg — средневзвешенное (веса <binding>_w считает бэкенд); в свёрнутых периодах
                // весов нет → Max месяцев, как и бэкенд без весов (прежнее поведение колонок DOS)
                // IE 2026 09 16 / ODOO-5800 (решение Игоря): без весов — пусто, а не Max (DOS без потребления не определён; как бэкенд
                // с wavg_nomax); веса сосед-колонок <binding>_w берутся, если они есть в строке; выключатель fe.ux.wavgNoMax=false → Max
                case 'WAvg': {
                    if (this.store?.setting?.('fe.ux.wavgNoMax', true) === false) { const n = nums(); out = { v: n.length ? Math.max(...n) : null }; break }
                    let ws = 0, wv = 0, anyW = false
                    for (const b of bindings) {
                        const v = Number(_val(b)); const w = Number(_val(b + '_w'))   // IE 2026 09 21 / ODOO-5800: значения и веса — по отбору, когда он действует
                        if (Number.isNaN(v) || Number.isNaN(w) || !(w > 0)) continue
                        anyW = true; ws += w; wv += v * w
                    }
                    out = { v: anyW && ws > 0 ? wv / ws : null }; break
                }
                case 'Max': { const n = nums(); out = { v: n.length ? Math.max(...n) : null }; break }
                case 'Min': { const n = nums(); out = { v: n.length ? Math.min(...n) : null }; break }
                case 'Cnt': out = { v: vals.length || null }; break
                case 'CntDst': out = { v: vals.length ? new Set(vals.map(String)).size : null }; break
                case 'First': case 'opening_balance': out = { v: vals.length ? vals[0] : null }; break
                case 'Last': case 'closing_balance': out = { v: vals.length ? vals[vals.length - 1] : null }; break
                default: out = null // None / grade / status и пр. — ячейку не переопределяем
            }
            if (out && _ftHit) out.ft = true   // IE 2026 09 21 / ODOO-5800: агрегат свёрнутого периода сложен из итогов по отбору — ячейка помечается так же
            if (!this._foldAggCache) this._foldAggCache = new WeakMap()
            if (!cellMap) { cellMap = {}; this._foldAggCache.set(dataItem, cellMap) }
            cellMap[col_binding] = out
            return out
        },
        foldAgg_dlScale(row_id) {
            // эффективный aggregateScale строки DL по row_id (_DLRow дата-строки):
            // наследуется от родительской строки, как node_row._aggregateScale на бэке
            if (!row_id) return undefined
            let map = this._foldAggDLScale
            if (!map) {
                map = this._foldAggDLScale = {}
                const walk = (rows, inherited) => {
                    for (const r of rows || []) {
                        if (!r || typeof r !== 'object') continue
                        const eff = r.aggregateScale || inherited
                        if (r.row_id) map[r.row_id] = eff
                        walk(r.attrs, eff)
                    }
                }
                walk(this.WIDGET?.record?.doc?.params?.data_layout2, undefined)
            }
            return map[row_id]
        },
        foldAgg_sourceBindings(grp, raw_binding) {
            // Что складывать в агрегате свёрнутой группы. У периода бывает своя
            // колонка ИТОГА (BE: binding `_total::<период>::<мера>`, ветка «Total»):
            // если она есть — берём ЕЁ и НЕ разбираем период глубже, иначе итог
            // задваивается с днями (ИЕ 2026-08-11: 389 940 вместо значения Total).
            // Кэш на группе — по мере (структура колонок при свёртке не меняется).
            const cache = grp._foldPick || (grp._foldPick = {})
            if (cache[raw_binding]) return cache[raw_binding]
            const isTotal = (b) => String(b || '').startsWith('_total::')
            const rawOf = (b) => this.attr_by_binding[b]?.raw_binding
            const leavesOf = (g, acc = []) => {
                if (!g.columns || !g.columns.length) { acc.push(g); return acc }
                for (const c of g.columns) leavesOf(c, acc)
                return acc
            }
            const out = []
            const pick = (g) => {
                if (!g.columns || !g.columns.length) {
                    // одиночная колонка итога в выборку не попадает: её берут выше
                    if (!isTotal(g.binding) && rawOf(g.binding) === raw_binding) out.push(g.binding)
                    return
                }
                // ветка итога периода = подгруппа, ВСЕ листья которой `_total::`
                const totalChild = g.columns.find(c => {
                    const ls = leavesOf(c)
                    return ls.length && ls.every(l => isTotal(l.binding))
                })
                if (totalChild) {
                    const leaf = leavesOf(totalChild).find(l => rawOf(l.binding) === raw_binding)
                    if (leaf) { out.push(leaf.binding); return }
                }
                for (const c of g.columns) pick(c)
            }
            pick(grp)
            cache[raw_binding] = out
            return out
        },
        // ---- декомпозиция правки агрегатной ячейки в детальные (ИЕ 2026-08-12) ----
        // Введённое в ячейку строки-группы и/или свёрнутого периода число
        // раскладывается по детальным ячейкам (листовые строки × листовые
        // даты) пропорционально их текущим значениям; изменёнными помечаются
        // ИМЕННО детали (на бэк уходят они), агрегат только подсвечивается.
        // Ввели меньше/ноль — пропорция сжимает/зануляет; деталей с данными
        // нет — всё количество кладётся в ПЕРВУЮ детальную ячейку.
        // ---- онлайн-превью баланса (ИЕ 2026-08-14, заказ Игоря «быстрая обратная
        // связь»): правка приходной/расходной строки блока объекта тут же ГРУБО
        // смещает строку остатков (Stock/Starting inventory) на всех датах строго
        // ПОСЛЕ даты правки: остаток -= Δпродаж (или += Δприхода). Косвенные
        // правки (indirect) — подсветка/undo без отправки на бэк; точные цифры
        // приедут select'ом после сохранения и каскада. Опция записи отчёта
        // doc.params.online_balance_preview (по умолчанию выключено).
        // ---- АН 2026 08 15 / ODOO-4997: стили строк «Data bars» (заказ Игоря) ----
        // Excel-подобное оформление ЧЕРЕЗ узлы data_layout2: row_style =
        // 'data_bars' (горизонтальная полоса) | 'color_scales' (дефолт —
        // существующий механизм HSL group, здесь не рендерится) | 'data_columns'
        // (вертикальная мини-гистограмма); row_style_scheme — цветовая схема.
        // Статистика группы (min/max строки) считается ОДИН РАЗ и кэшируется
        // (rowStyle_stats) — требование Игоря по скорости; отключение на лету:
        // window.__rowStyleOff = true (правило опций: дефолт ВКЛ).
        // IE 2026 08 16 / ODOO-4997 (заказ Игоря): Row style 'Cards' на СТРОКЕ
        // КОЛОНОК data_layout2 — колонки данных оформляются как карточки
        // сравнения (визуально, сущность таблицы не меняется): белый «зазор» и
        // рамка по бокам каждой data-колонки, шапка — карточная. Классы
        // применяются в formatItem по каждой панели.
        cards_colsMode() {
            if (this._cardsModeIr === this.irefresh && this._cardsMode !== undefined) return this._cardsMode
            this._cardsModeIr = this.irefresh
            let mode = false
            const dl2 = this.WIDGET?.record?.doc?.params?.data_layout2
            const walk = (nodes) => {
                for (const n of nodes || []) {
                    if (!n || n.use === false) continue
                    if (n.template === 'F_columns' || n.attr_type === 'AttrGridColumns') { // IE 2026 09 03 / ODOO-336283: вид узла по attr_type
                        for (const r of n.attrs || []) {
                            if (r && r.use !== false && r.row_style === 'cards') { mode = true; return }
                        }
                        continue
                    }
                    walk(n.attrs)
                }
            }
            if (Array.isArray(dl2)) for (const g of dl2) { if (g?.use !== false) walk(g?.attrs) }
            this._cardsMode = mode
            return mode
        },
        cards_isCol(binding) {
            // карточная колонка = листовая КОЛОНКА ДАННЫХ (raw_binding есть
            // только у колонок, порождённых значениями строки колонок)
            if (!binding || !this.cards_colsMode()) return false
            const ac = this.attr_by_binding[binding]
            return !!ac?.raw_binding
        },
        cards_extraShift(binding) {
            // IE 2026 08 16 (заказ Игоря): юзерфрендли-отступ между карточками
            // (+6px к break-сдвигу) и двойной перед ПЕРВОЙ карточкой (+12px);
            // ячейки сдвигаются break-механизмом, рамки-оверлеи — синхронно
            if (!this.cards_isCol(binding)) return 0
            if (this._cardsFirstIr !== this.irefresh || this._cardsFirst === undefined) {
                this._cardsFirstIr = this.irefresh
                let first = null
                for (const c of this.flex?.columns || []) {
                    if (c.binding && this.cards_isCol(c.binding)) { first = c.binding; break }
                }
                this._cardsFirst = first
            }
            return binding === this._cardsFirst ? 12 : 6
        },
        cards_cellGeom(panel, colIndex, originLeft) {
            // IE 2026 08 16: геометрия НЕмерженной ячейки в ЭКРАННЫХ координатах
            // (относительно левого края области данных). style.left не годится:
            // при горизонтальной прокрутке ячейки едут, а style.left остаётся —
            // рамки «отвязывались» от ячеек (ревью Игоря)
            const host = panel?.hostElement
            if (!host) return null
            const colW = panel.columns?.[colIndex]?.renderWidth || 0
            // штатный доступ к ячейке панели (надёжнее меток data_cell, которые
            // ставит наш formatItem: у части ячеек их нет)
            let vr = null
            try { vr = panel.viewRange } catch { vr = null }
            if (vr && typeof panel.getCellElement === 'function') {
                const r1 = Math.max(0, vr.topRow), r2 = Math.min(panel.rows.length - 1, vr.bottomRow)
                for (let r = r1; r <= r2 && r <= r1 + 12; r++) {
                    let el = null
                    try { el = panel.getCellElement(r, colIndex) } catch { el = null }
                    if (!el) continue
                    const rect = el.getBoundingClientRect()
                    if (!(rect.width > 0)) continue
                    if (colW && rect.width > colW + 6) continue // спил — не показатель
                    return { left: rect.left - originLeft, width: rect.width }
                }
            }
            for (const c of host.querySelectorAll('.wj-cell')) {
                const dc = c.data_cell
                if (!dc || dc.col !== colIndex) continue
                const r = c.getBoundingClientRect()
                if (!(r.width > 0)) continue
                if (colW && r.width > colW + 6) continue
                return { left: r.left - originLeft, width: r.width }
            }
            return null
        },
        cards_clipCell(e_cell, e_style, col) {
            // IE 2026 08 16 (ревью Игоря): мерженные/спил-ячейки (заголовки
            // вложенных групп) заходили в зону карточек и рисовались поверх них.
            // Обрезаем: не-карточная ячейка — до левой границы первой карточки,
            // карточная — по ширине своей колонки
            if (!this.cards_colsMode() || !col) return
            const w = parseFloat(e_style.width) || 0
            const colW = col.renderWidth || col.width || 0
            if (!(w > colW + 4)) return // не спил
            const left = parseFloat(e_style.left) || 0
            if (this.cards_isCol(col.binding)) {
                e_style.width = `${Math.max(0, colW)}px`
                return
            }
            // кэш границы: ключом и позиция горизонтальной прокрутки — при
            // скролле col.pos едет, устаревшая граница резала не там
            let _sx = 0
            try { _sx = Math.round(this.flex.scrollPosition.x) } catch { _sx = 0 }
            const _edgeKey = `${this.irefresh}|${_sx}`
            if (this._cardsEdgeKey !== _edgeKey) {
                this._cardsEdgeKey = _edgeKey
                let edge = null
                for (const c of this.flex?.columns || []) {
                    if (c.binding && c.visible !== false && this.cards_isCol(c.binding)) { edge = c.pos; break }
                }
                this._cardsEdge = edge
            }
            const edge = this._cardsEdge
            if (edge != null && left < edge && left + w > edge) {
                e_style.width = `${Math.max(0, Math.round(edge - left - 2))}px`
            }
        },
        cards_headTitle(binding) {
            // титул карточки = title ближайшего ПРЕДКА листа в дереве колонок
            // вида (группа-горизонт); кэш до пересборки грида
            if (this._cardsHeadIr !== this.irefresh || !this._cardsHeadTitles) {
                this._cardsHeadIr = this.irefresh
                const map = this._cardsHeadTitles = {}
                const walk = (nodes, parentTitle) => {
                    for (const n of nodes || []) {
                        if (!n || typeof n !== 'object') continue
                        const myTitle = String(n.title ?? n.header ?? '') || parentTitle
                        if (n.binding && !n.attrs?.length) map[n.binding] = parentTitle || myTitle
                        walk(n.attrs, myTitle)
                    }
                }
                walk(this.attr?.attrs, '')
            }
            return this._cardsHeadTitles[binding]
                || String(this.attr_by_binding[binding]?.title ?? '')
        },
        // IE 2026 08 16 / ODOO-4997 (ревью Игоря): рамка карточки — ОТДЕЛЬНЫЙ
        // оверлей с паддингом от ячеек, а не бордеры самих ячеек (те давали
        // артефакты за скруглением и «лесенку»). По оверлею на карточную
        // колонку в панели шапки (скруглённый верх) и в панели данных —
        // элементы живут в скролл-слоях wijmo и едут вместе с гридом.
        cards_overlay_sync() {
            // IE 2026 08 16 (ревью Игоря): рамки карточек живут в СВОЁМ слое над
            // гридом. Внутри панелей wijmo их держать нельзя: грид переиспользует
            // дочерние элементы панели как ячейки — наши div становились ячейками,
            // и содержимое рисовалось поверх соседних карточек.
            const flex = this.flex
            const gridHost = flex?.hostElement
            if (!gridHost || !flex.cells?.hostElement) return
            const mode = this.cards_colsMode()
            let layer = gridHost.querySelector(':scope > .cards-layer')
            let fzLayer = gridHost.querySelector(':scope > .cards-layer-frozen') // IE 2026 10 06 / ODOO-5800
            if (!mode) { layer?.remove(); fzLayer?.remove(); return } // IE 2026 10 06 / ODOO-5800
            if (!layer) {
                layer = document.createElement('div')
                layer.className = 'cards-layer'
                gridHost.appendChild(layer)
            }
            const hostRect = gridHost.getBoundingClientRect()
            const headRect = flex.columnHeaders.hostElement?.getBoundingClientRect()
            const cellsRect = flex.cells.hostElement?.getBoundingClientRect()
            if (!headRect || !cellsRect) return
            // слой начинается на левом крае ОБЛАСТИ ДАННЫХ (правее замороженных
            // колонок): overflow:hidden обрезает карточки, уехавшие под frozen
            // IE 2026 10 06 / ODOO-5800: край — НЕПОДВИЖНЫЙ (rowHeaders + frozen). Панель
            // [wj-part=cells] сама едет с прокруткой, и прежний край по cellsRect.left
            // упирался в 0, а рамки оставались на месте: отставали от ячеек на scrollX − rowHeaders
            const _sx = flex.cells.hostElement.parentElement?.scrollLeft ?? -(flex.scrollPosition?.x || 0) // IE 2026 10 06 / ODOO-5800
            const _fzN = flex.frozenColumns || 0 // IE 2026 10 06 / ODOO-5800
            const _frozenW = _fzN ? (flex.columns.getFrozenSize() || 0) : 0 // IE 2026 10 06 / ODOO-5800: штатная сумма renderSize замороженных (скрытая колонка = 0)
            const _rhEdge = cellsRect.left + _sx - hostRect.left // IE 2026 10 06 / ODOO-5800: неподвижный край rowHeaders (левый край данных без прокрутки)
            const dataLeft = Math.max(0, Math.round(_rhEdge + _frozenW)) // IE 2026 10 06 / ODOO-5800
            const originLeft = hostRect.left + dataLeft // IE 2026 10 06 / ODOO-5800: начало координат рамок = левый край слоя на экране
            if (layer.style.left !== dataLeft + 'px') layer.style.left = dataLeft + 'px'
            // IE 2026 10 06 / ODOO-5800 (ревью R1): карточка ВНУТРИ замороженных колонок (View params → Frozen columns
            // захватил карточную колонку) лежит целиком левее края слоя и обрезалась им — пропадали рамка и шапка.
            // Такие карточки рисуются вторым слоем от края rowHeaders (без обрезки по frozen); их ячейка на экране
            // неподвижна: при клоне замороженных (cloneFrozenCells, [wj-part="fcells"] не пуст) основной экземпляр
            // в cells стоит в координатах содержимого и едет с прокруткой, а клон — на том же left от неподвижного
            // края, то есть экранная позиция = позиция основного + scrollLeft; без клона (правка ячейки) wijmo ставит
            // основной экземпляр неподвижно сам (CellFactory.updateCell: left = pos − scrollPosition.x)
            const fzLeft = Math.max(0, Math.round(_rhEdge)) // IE 2026 10 06 / ODOO-5800
            const fzOriginLeft = hostRect.left + fzLeft // IE 2026 10 06 / ODOO-5800
            const _fcells = _fzN ? flex.cells.hostElement.parentElement?.parentElement?.querySelector(':scope > [wj-part="fcells"]') : null // IE 2026 10 06 / ODOO-5800: свой клон, не вложенного грида
            const _cloneOn = !!_fcells?.childElementCount // IE 2026 10 06 / ODOO-5800
            const headTop = Math.max(0, headRect.top - hostRect.top)
            // высота шапки — по её строкам: разница cellsRect.top - headRect.top
            // схлопывалась при прокрутке (панель данных уезжает под шапку)
            let headH = 0
            try {
                for (let i = 0; i < flex.columnHeaders.rows.length; i++) {
                    headH += flex.columnHeaders.rows[i].renderHeight || flex.columnHeaders.rows[i].height || 0
                }
            } catch { headH = 0 }
            if (!headH) headH = Math.max(0, cellsRect.top - headRect.top)
            const bodyTop = headTop + headH
            // IE 2026 08 17 (заказ Игоря): карточка ЗАКРЫТА снизу — рамка кончается
            // на последней строке данных (а не тянется до низа виджета).
            // IE 2026 08 18 (заказ Игоря): + нижний отступ-«подвал», чтобы рамка
            // не прилипала к последней строке (в пределах высоты виджета)
            const PAD_BOTTOM = 8
            let bodyH = Math.max(0, hostRect.height - bodyTop)
            try {
                const rows = flex.cells.rows
                if (rows.length) { // IE 2026 10 06 / ODOO-5800
                    // IE 2026 10 06 / ODOO-5800: cellsRect.top уже учитывает вертикальную прокрутку
                    // (панель едет вместе с ней); + scrollPosition.y считал её второй раз, и при
                    // прокрутке вниз рамка закрывалась на scrollY выше последней строки.
                    // Низ данных — getTotalSize (сумма renderSize видимых строк): у скрытой последней
                    // строки (фильтр, «непустые») фолбэк last.height уводил низ рамки ниже данных
                    const contentBottom = cellsRect.top + rows.getTotalSize() // IE 2026 10 06 / ODOO-5800
                    const b = Math.min(hostRect.bottom, contentBottom + PAD_BOTTOM) - (hostRect.top + bodyTop)
                    if (b > 0) bodyH = b
                }
            } catch { /* строки могли перестраиваться */ }
            const keep = new Set()
            const keepFz = new Set() // IE 2026 10 06 / ODOO-5800
            const PAD = 4 // одинаковый внутренний отступ слева и справа
            for (const col of flex.columns) {
                if (!col.binding || col.visible === false || !this.cards_isCol(col.binding)) continue
                const fz = col.index < _fzN // IE 2026 10 06 / ODOO-5800: замороженная карточка — во второй слой
                // геометрия — по ФАКТИЧЕСКОЙ ячейке колонки (расчёт по col.pos
                // расходился с реальным положением: рамка налезала на соседа)
                const geo = fz // IE 2026 10 06 / ODOO-5800
                    ? (this.cards_cellGeom(flex.cells, col.index, fzOriginLeft - (_cloneOn ? _sx : 0)) // IE 2026 10 06 / ODOO-5800
                        || this.cards_cellGeom(flex.columnHeaders, col.index, fzOriginLeft)) // IE 2026 10 06 / ODOO-5800: замороженная ячейка шапки неподвижна всегда
                    : (this.cards_cellGeom(flex.cells, col.index, originLeft) // IE 2026 10 06 / ODOO-5800
                        || this.cards_cellGeom(flex.columnHeaders, col.index, originLeft)) // IE 2026 10 06 / ODOO-5800
                if (!geo) continue
                const left = Math.round(geo.left - PAD)
                const width = Math.max(0, Math.round(geo.width + PAD * 2))
                if (!fz && left + width <= 0) continue // уехала под frozen-колонки; IE 2026 10 06 / ODOO-5800: замороженная не уезжает
                let lay = layer // IE 2026 10 06 / ODOO-5800
                if (fz) { // IE 2026 10 06 / ODOO-5800
                    if (!fzLayer) { // IE 2026 10 06 / ODOO-5800
                        fzLayer = document.createElement('div') // IE 2026 10 06 / ODOO-5800
                        fzLayer.className = 'cards-layer-frozen' // IE 2026 10 06 / ODOO-5800
                        gridHost.appendChild(fzLayer) // IE 2026 10 06 / ODOO-5800: после слоя данных — сверху
                    } // IE 2026 10 06 / ODOO-5800
                    if (fzLayer.style.left !== fzLeft + 'px') fzLayer.style.left = fzLeft + 'px' // IE 2026 10 06 / ODOO-5800
                    lay = fzLayer // IE 2026 10 06 / ODOO-5800
                } // IE 2026 10 06 / ODOO-5800
                for (const kind of ['head', 'body']) {
                    const key = kind + '|' + col.binding
                    if (fz) keepFz.add(key); else keep.add(key) // IE 2026 10 06 / ODOO-5800
                    let ov = lay.querySelector(`:scope > [data-key="${CSS.escape(key)}"]`) // IE 2026 10 06 / ODOO-5800
                    if (!ov) {
                        ov = document.createElement('div')
                        ov.className = 'card-overlay card-overlay-' + kind
                        ov.dataset.key = key
                        lay.appendChild(ov) // IE 2026 10 06 / ODOO-5800
                    }
                    const st = ov.style
                    const top = kind === 'head' ? headTop : bodyTop
                    const h = kind === 'head' ? headH : bodyH
                    if (st.left !== left + 'px') st.left = left + 'px'
                    if (st.width !== width + 'px') st.width = width + 'px'
                    if (st.top !== top + 'px') st.top = top + 'px'
                    if (st.height !== h + 'px') st.height = h + 'px'
                    if (kind === 'head') {
                        // шапка карточки — ТОЛЬКО заголовок горизонта (накрывает
                        // подпись меры и номер колонки, «объединяя» ячейки)
                        const _t = this.cards_headTitle(col.binding)
                        if (_t && ov.textContent !== _t) ov.textContent = _t
                        const ac = this.attr_by_binding[col.binding]
                        const cur = !!(ac?.cssClasses_columnHeader?.length || ac?.cssClass_columnHeader)
                        ov.classList.toggle('card-overlay-current', cur)
                    }
                }
            }
            for (const ov of [...layer.children]) {
                if (!keep.has(ov.dataset.key)) ov.remove()
            }
            if (fzLayer && !keepFz.size) fzLayer.remove() // IE 2026 10 06 / ODOO-5800: замороженных карточек нет — слоя нет
            else if (fzLayer) { for (const ov of [...fzLayer.children]) { if (!keepFz.has(ov.dataset.key)) ov.remove() } } // IE 2026 10 06 / ODOO-5800
        },
        rowStyle_schemes() {
            return this._rowStyleSchemes || (this._rowStyleSchemes = {
                blue:   { pos: { strong: 'rgba(90,141,201,.55)',  faint: 'rgba(90,141,201,.14)' },
                          neg: { strong: 'rgba(229,115,115,.55)', faint: 'rgba(229,115,115,.14)' } },
                green:  { pos: { strong: 'rgba(95,168,101,.55)',  faint: 'rgba(95,168,101,.14)' },
                          neg: { strong: 'rgba(229,115,115,.55)', faint: 'rgba(229,115,115,.14)' } },
                orange: { pos: { strong: 'rgba(242,153,74,.55)',  faint: 'rgba(242,153,74,.14)' },
                          neg: { strong: 'rgba(229,115,115,.55)', faint: 'rgba(229,115,115,.14)' } },
                grey:   { pos: { strong: 'rgba(144,164,174,.5)',  faint: 'rgba(144,164,174,.14)' },
                          neg: { strong: 'rgba(229,115,115,.5)',  faint: 'rgba(229,115,115,.14)' } },
            })
        },
        rowStyle_bindings(raw = 'quantity') {
            // датные колонки данных ОДНОЙ меры (raw) — кэш до смены данных.
            // IE 2026 08 15 / ODOO-4997: канал настройки НА ПОЛЕ — стиль может
            // стоять на любой мере (duration/offset/...), не только quantity
            if (!this._rowStyleBindings) this._rowStyleBindings = {}
            if (!this._rowStyleBindings[raw]) {
                const esc = raw.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
                const re = new RegExp('^\\d{4}-\\d{2}-\\d{2}\\.' + esc + '$')
                const out = []
                for (const b in this.attr_by_binding) {
                    if (re.test(b)) out.push(b)
                }
                this._rowStyleBindings[raw] = out
            }
            return this._rowStyleBindings[raw]
        },
        rowStyle_stats(dataItem, raw = 'quantity') {
            // min/max ГРУППЫ (датные ячейки строки узла ПО ОДНОЙ мере):
            // вычисляется один раз, переиспользуется всеми ячейками строки;
            // сброс — при новых данных и после правок (рядом с _foldAggCache)
            if (!this._rowStyleStats) this._rowStyleStats = new Map()
            let byRaw = this._rowStyleStats.get(dataItem)
            if (!byRaw) { byRaw = {}; this._rowStyleStats.set(dataItem, byRaw) }
            if (raw in byRaw) return byRaw[raw]
            let min = Infinity, max = -Infinity
            for (const b of this.rowStyle_bindings(raw)) {
                const v = parseFloat(this.store.get_value(dataItem, b))
                if (Number.isNaN(v)) continue
                if (v < min) min = v
                if (v > max) max = v
            }
            const st = min === Infinity ? null : {
                min, max,
                span: (max - min) || Math.abs(max) || 1,
                negSpan: Math.max(Math.abs(min), Math.abs(max)) || 1,
                hasNeg: min < 0,
            }
            byRaw[raw] = st
            return st
        },
        // ---- IE 2026 09 14 / ODOO-5800 (заказ Игоря): подсветка ячеек, ВЛИЯЮЩИХ на выбранную (опция отчёта
        // doc.params.influence_highlight, рядом с опциями симуляции). Роли строк — как у онлайн-симуляции остатков
        // (balancePreview_roleOf: stock / in / out, блок объекта = корень дерева данных):
        //   остаток[t] = остаток[t−1] (база, синий) + приходы[t−1] (зелёные, «+») − расходы[t−1] (красные, «−») того же субъекта;
        //   приход/расход[t] → остатки всех последующих периодов (знак по роли). Под выбранной ячейкой — формула с суммами.
        // IE 2026 09 17 (заказ Игоря): Option groups на фронте — строка принадлежит группе своего узла раскладки (option_group наследуется
        // вглубь) по _DLRow.row_id; выключенная группа = _ogHide на строках + apply_CHIPS (как _DLRow.hide), без запроса к бэку
        optionGroup_nodeMap() {
            const dl2 = this.store.get_value(this.WIDGET?.record, 'doc.params.data_layout2') || []
            if (this._ogMap && this._ogMapSrc === dl2) return this._ogMap
            const m = {}
            const walk = (rows, g) => {
                for (const r of rows || []) {
                    if (!r || typeof r !== 'object') continue
                    const g2 = String(r.option_group || '').trim() || g
                    if (r.row_id && g2) m[r.row_id] = g2
                    walk(r.attrs, g2)
                }
            }
            walk(dl2, '')
            this._ogMap = m; this._ogMapSrc = dl2
            return m
        },
        optionGroup_of(dataItem) {
            const rid = dataItem?._DLRow?.row_id
            return rid ? (this.optionGroup_nodeMap()[rid] || '') : ''
        },
        optionGroup_rows(group) {
            const out = [], kids = this.attr?.childItemsPath || 'attrs'
            const walk = (rows) => { for (const r of rows || []) { if (!r || typeof r !== 'object') continue; if (this.optionGroup_of(r) === group) out.push(r); walk(r[kids]) } }
            walk(this.data000 || this.data || [])
            return out
        },
        optionGroup_hasRows(group) { return this.optionGroup_rows(group).length > 0 },
        // IE 2026 10 05 / ODOO-5800 (fe-86): название опции для пользователя — подпись её кнопки шапки отчёта (на языке интерфейса: «ЗП 2» у группы «PO 2»); кнопки нет — название группы
        optionGroup_caption(group) {
            const g = String(group || '').trim()
            if (!g) return ''
            const b = (this.WIDGET?.groupMenu?.commandPanel || []).find(x => x?.method === 'toggle_option_group' && String(x.params?.group || '').trim() === g)
            return String(b?.title || g).trim()
        },
        optionGroup_setHidden(group, hidden) {
            const rows = this.optionGroup_rows(group)
            for (const r of rows) {
                if (hidden) r._ogHide = true; else delete r._ogHide
                // IE 2026 09 17 / ODOO-…: сбросить кэш видимости строки — на fast-проходе apply_CHIPS (фильтр «непустые» даёт
                // псевдо-чипс) строка с кэшем берётся из него, и после пустой соседки (кэш сбрасывает set_visible_to_chids_level)
                // строка группы оставалась видимой / скрытой по старому состоянию; без кэша она пересчитывается полностью
                if (r._fe) r._fe.visible = undefined
            }
            this._mdfDirty = true   // IE 2026 09 19 / ODOO-5800: видимость строк групп сменилась — пересчитать поправку словаря метрик (metricDict_frontSync)
            return rows.length
        },
        optionGroup_apply(group, on) {
            const n = this.optionGroup_setHidden(group, !on)
            const c = this.optionGroup_setColsHidden(group, !on)   // IE 2026 10 22 / ODOO-5800: + колонки группы (precache групп колонок)
            if (n || !c) this.apply_CHIPS(null, { fast: true })   // быстрый проход: пересчитываются только строки группы (кэш сброшен выше), ~0,5 с
            return { rows: n, cols: c }   // IE 2026 10 22 / ODOO-5800
        },
        // IE 2026 10 22 / ODOO-5800 (заказ Игоря: кнопки групп опций отчётов согласования — мгновенно на фронте, «по сути включив precache»):
        // группы КОЛОНОК. Колонка грида принадлежит группе своего узла раскладки под корнем колонок (AttrGridColumns; option_group наследуется
        // вглубь — узлы-группы под узлом месяца: Fact / Base / Qty / Amount $ / Share %…) — по raw_binding значения (values[].binding) узла:
        // бэк (data_layout2.fill_view) сплющивает узлы-обёртки без титула, но raw_binding у колонки остаётся. Мера, встречающаяся и в узле
        // другой группы / вне групп, неоднозначна — её колонки группе не приписываются (переключение такой группы уйдёт штатным reload).
        // Карта кэшируется по ссылке на data_layout2 (как optionGroup_nodeMap)
        optionGroup_colMap() {
            const dl2 = this.store.get_value(this.WIDGET?.record, 'doc.params.data_layout2') || []
            if (this._ogColMap && this._ogColMapSrc === dl2) return this._ogColMap
            const owner = {}   // raw_binding → группа ('' — без группы, '*' — неоднозначно)
            const isCols = r => r.attr_type === 'AttrGridColumns' || r.template === 'AttrGridColumns' || r.component === 'AttrGridColumns'
            const own = (raw, g) => { if (!(raw in owner)) owner[raw] = g; else if (owner[raw] !== g) owner[raw] = '*' }
            const walkValues = (values, g, depth) => {
                for (const v of values || []) {
                    if (!v || typeof v !== 'object') continue
                    const raw = String(v.binding || '').trim()
                    if (raw) own(raw, g)
                    if (depth < 8) walkValues(v.attrs, g, depth + 1)
                }
            }
            const walk = (rows, inCols, g, depth) => {
                for (const r of rows || []) {
                    if (!r || typeof r !== 'object') continue
                    const cols = inCols || isCols(r)
                    const g2 = cols ? (String(r.option_group || '').trim() || g) : ''
                    if (cols && Array.isArray(r.values)) walkValues(r.values, g2, 0)
                    if (depth < 16) walk(r.attrs, cols, g2, depth + 1)
                }
            }
            walk(dl2, false, '', 0)
            const m = {}
            for (const [raw, g] of Object.entries(owner)) { if (g && g !== '*') (m[g] = m[g] || new Set()).add(raw) }
            this._ogColMap = m; this._ogColMapSrc = dl2
            return m
        },
        // колонки грида (wijmo Column) группы опций: по raw_binding поля вида (attr_by_binding) — скрытые полем (hidden) в гриде не строятся
        optionGroup_cols(group) {
            const raws = this.optionGroup_colMap()[String(group || '').trim()]
            if (!raws || !raws.size || !this.flex) return []
            const out = []
            for (const col of this.flex.columns) {
                const a = this.attr_by_binding[col.binding]
                if (a && a.raw_binding && raws.has(a.raw_binding)) out.push({ col, attr_col: a })
            }
            return out
        },
        optionGroup_hasCols(group) { return this.optionGroup_cols(group).length > 0 },
        // спрятать / показать колонки группы на месте: _ogHide на поле вида (его чтит apply_CHIPS_columns — иначе проход «пустые колонки»
        // вернул бы их), visible у колонки wijmo; заголовок группы в многоуровневой шапке wijmo рисует по видимым колонкам диапазона —
        // без них его нет; представитель свёрнутого периода (collapseTo) — перевести на видимую колонку (optionGroup_fixCollapseTo)
        // // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p217 кнопка Σ — річні підсумки за опцією, типово вимкнено): колонки годового итога ('_total::<YYYY>::…') — видны при нажатой Σ шапки (WIDGET._yearTotalsOn) или у свёрнутого года;
        // иначе visible = false (+ _ytHide на поле вида — его чтут apply_CHIPS_columns, lightView и группы опций). Без перезапроса бэка; → число изменённых колонок
        yearTotals_sync() {
            const flex = this.flex
            if (!flex?.getColumnGroups || !this.attr_by_binding) return 0
            const flag = yearTotalsButton_on((k, d) => this.store.setting(k, d))
            const P = yearTotals_plan(flex.getColumnGroups() || [], { on: !!this.WIDGET?._yearTotalsOn, flag })
            const steady = sigmaSteady_on((k, d) => this.store.setting(k, d))   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p233 Σ не смикає панель команд)
            const has = this.WIDGET ? yearTotals_hasMerge(this.WIDGET._yearTotalsHasBy || (this.WIDGET._yearTotalsHasBy = {}), 'g' + this.$.uid, flag && P.has, steady) : false   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p233 Σ не смикає панель команд): Σ есть, если итоги есть хоть у одного грида виджета
            if (this.WIDGET && !!this.WIDGET._yearTotalsHas !== has) {   // кнопка Σ в шапке — только у виджета с годовыми итогами
                this.WIDGET._yearTotalsHas = has   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p233 Σ не смикає панель команд)
                if (typeof window !== 'undefined') { const S = window.__yearTotals || (window.__yearTotals = { syncs: 0, cols: 0 }); S.hasFlips = (S.hasFlips || 0) + 1 }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p233 Σ не смикає панель команд): счётчик пробы — перестроек шапки из-за Σ
                try { this.WIDGET.attrs_vueObj?.WIDGET?.set_commandPanel?.() } catch (e) { /* шапку перерисует следующий ответ */ }
            }
            const todo = [], widths = []
            const muted = flag && yearTotalsMuted_on((k, d) => this.store.setting(k, d))   // IE 2026 11 02 / ODOO-350449 (дополнение Игоря к p217, вариант 1: развёрнутый год — приглушённый итог, свёрнутый — остаток на начало года)
            const info = this._ytInfo = { muted, by: Object.create(null) }   // IE 2026 11 02 / ODOO-350449 (дополнение Игоря к p217, вариант 1: развёрнутый год — приглушённый итог, свёрнутый — остаток на начало года): вид ячеек итога для formatItem (yearTotal_paint)
            for (const { col, hide, year, collapsed, measure, monthW } of P.items) {
                const a = this.attr_by_binding[col.binding]
                if (a && !!a._ytHide !== hide) { if (hide) a._ytHide = true; else delete a._ytHide }
                const want = yearTotals_want(hide, a)
                if (col.visible !== want) todo.push([col, want])
                info.by[col.binding] = { year, collapsed, measure }
                // // IE 2026 11 02 / ODOO-350449 (дополнение Игоря к p217, вариант 1: развёрнутый год — приглушённый итог, свёрнутый — остаток на начало года): развёрнутый год — колонка итога ~70 % месяца (исходная ширина — col._ytW0), свёрнутый / выключатель — прежняя
                const mw = muted && !collapsed ? yearTotal_mutedWidth(monthW) : 0
                if (mw && col._ytW0 === undefined) col._ytW0 = col.width
                const w = mw || (col._ytW0 !== undefined ? col._ytW0 : col.width)
                if (col.width !== w) widths.push([col, w])
                if (!mw && col._ytW0 !== undefined) widths.push([col, col._ytW0, true])
            }
            if (!todo.length && !widths.length) return 0
            const apply = () => { for (const [c, w] of todo) c.visible = w; for (const [c, w, drop] of widths) { if (c.width !== w) c.width = w; if (drop) delete c._ytW0 } }
            if (flex.deferUpdate) flex.deferUpdate(apply); else apply()
            for (const _c of this.cache_data_cells?.values?.() || []) { delete _c.merge_calc; delete _c.merge_col; delete _c.merge_col2 }   // merge считан по прежним видимым колонкам
            this._foldHdrBlank = null
            this.flexRefresh()
            if (typeof window !== 'undefined') { const S = window.__yearTotals || (window.__yearTotals = { syncs: 0, cols: 0 }); S.syncs++; S.cols += todo.length }   // счётчик пробы
            return todo.length
        },
        optionGroup_setColsHidden(group, hidden) {
            const cols = this.optionGroup_cols(group)
            if (!cols.length) return 0
            const apply = () => {
                for (const { col, attr_col } of cols) {
                    if (hidden) attr_col._ogHide = true; else delete attr_col._ogHide
                    const want = !hidden && !attr_col.hide_beacose_empty && !attr_col._ytHide   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p217 кнопка Σ — річні підсумки за опцією, типово вимкнено): + колонка годового итога, спрятанная кнопкой Σ
                    if (col.visible !== want) col.visible = want
                }
                this.optionGroup_fixCollapseTo()
            }
            if (this.flex?.deferUpdate) this.flex.deferUpdate(apply); else apply()
            for (const _c of this.cache_data_cells?.values?.() || []) { delete _c.merge_calc; delete _c.merge_col; delete _c.merge_col2 }   // merge считан по прежним видимым колонкам
            this._foldHdrBlank = null
            this.flexRefresh()
            return cols.length
        },
        // представитель свёрнутой группы колонок (collapseTo) спрятан группой опций — группа показала бы пусто: перевести на первую
        // видимую колонку диапазона (исходный collapseTo — в _ogCollapseTo0, возвращается, когда его колонка снова видна)
        optionGroup_fixCollapseTo() {
            const flex = this.flex
            if (!flex?.getColumnGroups) return
            const colsOf = (g) => { const out = []; const walk = (gs) => { for (const c of gs || []) { if (c.columns && c.columns.length) walk(c.columns); else out.push(c) } }; walk(g.columns); return out }
            const walk = (groups) => {
                for (const g of groups || []) {
                    if (!g.columns || !g.columns.length) continue
                    const ct0 = g._ogCollapseTo0 !== undefined ? g._ogCollapseTo0 : g.collapseTo
                    const leaves = colsOf(g)
                    const byBinding = (b) => leaves.find(c => c.binding === b)
                    const rep = typeof ct0 === 'string' ? byBinding(ct0) : null
                    if (rep && rep.visible === false && !this.attr_by_binding?.[rep.binding]?._ytHide) {   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p217 кнопка Σ — річні підсумки за опцією, типово вимкнено): итог года, спрятанный кнопкой Σ, остаётся представителем — свёрнутый год показывает итог (yearTotals_sync)
                        const alt = leaves.find(c => c.visible !== false)
                        if (alt && alt.binding !== g.collapseTo) { if (g._ogCollapseTo0 === undefined) g._ogCollapseTo0 = g.collapseTo; g.collapseTo = alt.binding }
                    } else if (g._ogCollapseTo0 !== undefined && (!rep || rep.visible !== false)) {
                        g.collapseTo = g._ogCollapseTo0; delete g._ogCollapseTo0
                    }
                    walk(g.columns)
                }
            }
            walk(flex.getColumnGroups() || [])
            this._foldAggGroups = null   // представители свёрнутых групп сменились — пересобрать карту агрегатов
        },
        // IE 2026 09 17 / ODOO-… (заказ Игоря): прекеш строк выключенных групп — option_groups[].precache: бэк строит
        // строки группы и при use=false (dl2.option_groups_precache), фронт прячет их при приходе данных (как _DLRow.hide),
        // и включение / выключение группы идёт без запроса к бэку (mainStore.optionGroup_toggleFast). Один раз на набор данных
        // IE 2026 10 22 / ODOO-5800: + колонки выключенных precache-групп — на каждую пересборку колонок (attr_by_binding новый: scan_column_fromAttrs
        // ставит visible = true), флаг fe.ux.optionGroupColumnsFast (по умолчанию ВКЛ)
        optionGroup_initHidden() {
            const src = this.data000 || this.data
            const rowsNew = !!src && this._ogInitSrc !== src && !!this.attr?.childItemsPath
            const colsNew = !!this.attr_by_binding && this._ogInitCols !== this.attr_by_binding && this.store.optionGroup_colsFast()   // IE 2026 10 22 / ODOO-5800
            if (!rowsNew && !colsNew) return
            if (rowsNew) this._ogInitSrc = src
            if (colsNew) this._ogInitCols = this.attr_by_binding
            const groups = this.store.get_value(this.WIDGET?.record, 'doc.params.option_groups')
            if (!Array.isArray(groups) || !groups.length) return
            for (const g of groups) {
                const t = String(g?.title || '').trim()
                if (!t || g.use) continue
                if (rowsNew) this.optionGroup_setHidden(t, true)
                if (colsNew) this.optionGroup_setColsHidden(t, true)   // IE 2026 10 22 / ODOO-5800
            }
        },
        // IE 2026 09 19 / ODOO-5800 (идея ie-dm7 #30920, слово Игоря): словарь метрик таблицы «в сеансе». Решение Игоря 19.09: пустая настройка приёма
        // глобального чипса метрик = Table chip только у виджета со словарём метрик, у остальных — Input; есть ли словарь, говорит статический признак
        // бэка record._doc.metric_dict (по записи на момент ответа). Группы строк, переключённые НА ФРОНТЕ (mainStore.optionGroup_toggleFast), и выключенные
        // precache-группы могут спрятать ВСЕ строки с отметками метрик: словаря у таблицы по сути нет — отметка WIDGET._metricDictFrontOff (её читает
        // mainStore.metricChipG_accept → приём input, зеркала нет); строки вернулись — отметка снята. Сменился приём под действующим чипсом — виджет
        // перечитывается один раз (mainStore.metricChipG_acceptChanged). Считается на приход данных и на переключение групп; ведёт грид данных
        metricDict_frontSync() {
            const W = this.WIDGET
            if (!W || this.attr?.name !== 'dataSheet') return false
            const src = this.data000 || this.data
            if (this._mdfSrc === src && !this._mdfDirty) return false
            this._mdfSrc = src; this._mdfDirty = false
            let marked = 0, shown = 0
            if (Array.isArray(this.attr?.metric_rules) && this.attr.metric_rules.length) {
                const kids = this.attr?.childItemsPath || 'attrs'
                const walk = (rows) => { for (const r of rows || []) { if (!r || typeof r !== 'object') continue; const m = r._DLRow?.metrics; if (Array.isArray(m) && m.length) { marked++; if (!r._ogHide) shown++ } walk(r[kids]) } }
                walk(src || [])
            }
            const off = marked > 0 && shown === 0
            if (off === !!W._metricDictFrontOff) return false
            const before = this.store.metricChipG_accept(W)
            if (off) W._metricDictFrontOff = true; else delete W._metricDictFrontOff
            this.store.metricChipG_acceptChanged(W, before)
            return true
        },
        influence_on() {
            return !!this.store.get_value(this.WIDGET?.record, 'doc.params.influence_highlight') && this.attr?.attr_type !== 'AttrTabGrid'
        },
        influence_clear(invalidate = true) {
            if (!this._infl) return
            this._infl = null
            this.influence_formulaShow(null)
            if (invalidate) this.flex?.invalidate()
        },
        influence_update(flex) {
            if (!this.influence_on()) { this.influence_clear(); return }
            this.influence_hoverInit(flex)   // IE 2026 09 17 (замечание Игоря): примечание к расчёту — только пока курсор над выбранной ячейкой
            const sel = flex.selection
            const row = sel && sel.row >= 0 ? flex.rows[sel.row] : null
            const it = row?.dataItem
            const col = sel && sel.col >= 0 ? flex.columns[sel.col] : null
            const b = col?.binding || ''
            const m = /^(\d{4}-\d{2}-\d{2})\.(.+)$/.exec(b)
            if (!it || !m) { this.influence_clear(); return }
            const date = m[1], suffix = m[2]
            const kidsPath = this.attr.childItemsPath || 'attrs'
            // IE 2026 10 06 / ODOO-5800 (ревью 05.10): в «Differences only» бэк оставляет в дереве грида только показанные строки, а неизменённые кладёт поддеревом в служебный список
            // _cmp_hidden показанного родителя (data_layout2.compare_diff_filter) — грид, фильтры, итоги, печать и утверждение их не видят. Формуле остатка нужны ВСЕ слагаемые блока
            // объекта: обход подчинённых здесь идёт вместе со спрятанными (utils/compareRows.compare_kidsWithHidden). Спрятанное слагаемое входит в суммы и в счёт строк «(in, N rows)»,
            // но на экране не метится (его строки нет; раньше метка ложилась на ближайшего видимого предка — вплоть до строки объекта). Выключатель fe.cellForm.formulaHiddenRows
            const _hidRowsOn = this.store.setting('fe.cellForm.formulaHiddenRows', true) !== false   // IE 2026 10 06 / ODOO-5800
            const kidsOf = _hidRowsOn ? compare_kidsWithHidden(kidsPath) : ((x) => x?.[kidsPath])   // IE 2026 10 06 / ODOO-5800
            // IE 2026 09 17 / ODOO-5800 (заказ Игоря): роль 'none' («Not in balance») — строка и её вложенные из
            // арифметики баланса исключены: не становятся ни базой, ни приходом, ни расходом (стадии одного
            // документа PO и план-факт продаж сети остаток склада не двигают)
            const roleOf = (x) => {
                const r0 = this.balancePreview_roleOf(x)
                if (r0 === 'none') return null
                return r0 || (/^(Stock|Starting inventory|Inventory)/i.test(this.balancePreview_branchOf(x) || '') ? 'stock' : null)
            }
            const role = roleOf(it)
            if (!role) { this.influence_clear(); return }
            // IE 2026 09 23 / ODOO-5800 (Igor: «of which uncovered / expired»): memo-строка — часть строки документа, в
            // суммы формулы не входит (иначе двойной счёт с родителем) и сама подсветку не ведёт; строка, у которой других
            // подчинённых нет, — лист. Выключатель fe.ux.memoRows
            const isMemo = (x) => this.memoRow_is(x)
            if (isMemo(it)) { this.influence_clear(); return }
            // IE 2026 10 05 / ODOO-5800 (fe-84; замечание Игоря 05.10: в «Differences only» из формулы пропадали приход и расход — «70 753 = 70 753 … −29 260» вместо «70 753 + 60 055 − 85 001 = 45 807 … −4 314»):
            // под-строки сравнения («≡ prev» / «Δ» / «Δ%», режимы Differences only и Full comparison) бэк кладёт ДЕТЬМИ изменившейся строки — строка прихода / расхода переставала быть листом и в суммы
            // не шла. Под-строка сравнения — не лист и не «ребёнок» (как memo), сама формулу не ведёт; слагаемые берутся со строк текущей модели во всех режимах сравнения
            // (utils/cellStory.story_formulaLeaves). Выключатель fe.cellForm.formulaFullRows (false — прежний обход)
            const _fullRows = this.store.setting('fe.cellForm.formulaFullRows', true) !== false
            if (_fullRows && story_isCompareRow(it)) { this.influence_clear(); return }
            // даты колонок той же меры (лист датных колонок), по порядку
            const dates = new Set()
            for (const k in this.attr_by_binding) {
                const mm = /^(\d{4}-\d{2}-\d{2})\.(.+)$/.exec(k)
                if (mm && mm[2] === suffix && !this.attr_by_binding[k]?.attrs?.length) dates.add(mm[1])
            }
            const uniq = [...dates].sort()
            const idx = uniq.indexOf(date)
            if (idx < 0) { this.influence_clear(); return }
            // блок объекта: корень дерева данных, содержащий выбранную строку; родители, листья с ролями
            let top = null
            const parentOf = new Map()
            const holds = (x) => { if (x === it) return true; for (const k of x?.[kidsPath] || []) if (holds(k)) return true; return false }
            for (const r of (this.data000 || this.data || [])) { if (holds(r)) { top = r; break } }
            if (!top) { this.influence_clear(); return }
            let leaves = []   // IE 2026 10 05 / ODOO-5800 (fe-84): let — при fe.cellForm.formulaFullRows листья даёт story_formulaLeaves
            const scan = (x, parent, groupTitle) => {
                parentOf.set(x, parent)
                if (isMemo(x)) return   // IE 2026 09 23 / ODOO-5800: memo-строка — не лист (её объём уже в родителе)
                const kidsAll = x?.[kidsPath]
                const kids = Array.isArray(kidsAll) ? kidsAll.filter(k => !isMemo(k)) : kidsAll   // IE 2026 09 23 / ODOO-5800: одни memo-дети → строка сама лист
                const gt = String(x?.measure_type || '') || groupTitle   // группа — по measure_type узла (заголовок _dlhdr_0 груб: «Ex-Distr» содержит distr)
                if (!Array.isArray(kids) || !kids.length) { const ro = roleOf(x); if (ro) leaves.push({ it: x, role: ro, group: gt }) }
                for (const k of kidsAll || []) scan(k, x, gt)
            }
            // IE 2026 10 05 / ODOO-5800 (fe-84): листья без под-строк сравнения (story_formulaLeaves заполняет и parentOf); выключатель снят — прежний scan
            if (_fullRows) { const fl = story_formulaLeaves(top, kidsOf, roleOf, isMemo); leaves = fl.leaves; for (const [k, v] of fl.parentOf) parentOf.set(k, v) } else scan(top, null, '')   // IE 2026 10 06 / ODOO-5800: kidsOf — вместе со спрятанными строками (было kidsPath)
            const hidRows = _hidRowsOn ? compare_hiddenRowsOf(top, kidsPath) : new Set()   // IE 2026 10 06 / ODOO-5800: строки блока, которых нет в дереве грида
            // субъекты выбранной строки: свой или субъекты её подчинённых
            const subjectsOf = (x) => {
                const out = new Set()
                const walk = (y) => { if (y?.subject) out.add(y.subject); for (const k of kidsOf(y) || []) walk(k) }   // IE 2026 10 06 / ODOO-5800: субъекты и спрятанных подчинённых
                walk(x); return out
            }
            const subjSet = subjectsOf(it)
            const inSet = (x) => !subjSet.size || (x.subject && subjSet.has(x.subject))
            // ячейка подсветки — видимая строка: сама или ближайший видимый предок (свёрнутые детали)
            const visible = new Set()
            for (const r of flex.rows) if (r.isVisible && r.dataItem) visible.add(r.dataItem)
            const visibleRow = (x) => { let y = x; while (y && !visible.has(y)) y = parentOf.get(y); return y || x }
            // у РАСКРЫТОГО видимого предка лист спрятан не свёрткой, а фильтром (пустые строки): пустой лист не метится, непустой — запасная метка
            // родителю, снимается, если в той же колонке помечен видимый потомок (utils/inflDeepest). Выключатель fe.ux.cellBasisDeepest (false — как было)
            const _deepOn = this.store.setting('fe.ux.cellBasisDeepest', true) !== false   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p204 підсвітка залежних комірок — у розкритого батька лише точна дочірня комірка)
            const expandedRows = new Set(), deepFallback = new Map()   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p204 підсвітка залежних комірок — у розкритого батька лише точна дочірня комірка)
            if (_deepOn) for (const r of flex.rows) if (r.isVisible && r.dataItem && r.hasChildren && !r.isCollapsed) expandedRows.add(r.dataItem)   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p204 підсвітка залежних комірок — у розкритого батька лише точна дочірня комірка)
            // IE 2026 10 06 / ODOO-5800 (повторное ревью): строка слагаемого для счёта «N rows». Спрятанное слагаемое — своя строка, только когда его ближайший предок из
            // дерева грида виден и раскрыт (в обычном режиме эта строка была бы видна сама); под свёрнутой показанной группой оно относится к ней — как считает
            // обычный режим (было: каждое спрятанное слагаемое — отдельная строка, «(out, 2 rows)» при одной подсвеченной группе). Спрятанная группа,
            // свёрнутая по раскладке (_DLRow.isCollapsed), считается одной строкой за свои слагаемые
            const collapsedRows = new Set()   // IE 2026 10 06 / ODOO-5800
            for (const r of flex.rows) if (r.isVisible && r.dataItem && r.hasChildren && r.isCollapsed) collapsedRows.add(r.dataItem)   // IE 2026 10 06 / ODOO-5800
            // IE 2026 10 06 / ODOO-5800 (dev02_check40 / prod_check44, пункт B: «− 85 001 (витрата, 3 рядки)» в «Differences only» против «2 рядки» в остальных режимах): спрятанная строка
            // была бы видна в обычном режиме, только если её пропускает фильтр грида «пустые строки» (проход видимости: _DLRow.hide / _ogHide, isEmpty, _use_off; предка
            // оживляет видимый потомок). Пустые слагаемые (расход того же субъекта без чисел) в обычном режиме скрыты и относятся к видимому предку — здесь считались
            // отдельными строками. hidAlive — «строка прошла бы фильтр»; termRow спускается от показанного предка по спрятанным, пока строка жива и не свёрнута
            const _hidEmpty = _hidRowsOn && !!this._hide_empty()   // IE 2026 10 06 / ODOO-5800
            let _hidCols = null   // IE 2026 10 06 / ODOO-5800: колонки проверки пустоты — один раз за проход
            const _aliveOf = new Map()   // IE 2026 10 06 / ODOO-5800
            const hidAlive = (y) => {   // IE 2026 10 06 / ODOO-5800
                if (_aliveOf.has(y)) return _aliveOf.get(y)   // IE 2026 10 06 / ODOO-5800
                let v = true   // IE 2026 10 06 / ODOO-5800
                if (_hidEmpty && this._use_off(y)) v = false   // IE 2026 10 06 / ODOO-5800: выключенная строка уходит с поддеревом
                else if (y?._DLRow?.hide || y?._ogHide || (_hidEmpty && this.isEmpty(y, _hidCols || (_hidCols = this.columns())))) v = (kidsOf(y) || []).some(hidAlive)   // IE 2026 10 06 / ODOO-5800
                _aliveOf.set(y, v); return v   // IE 2026 10 06 / ODOO-5800
            }   // IE 2026 10 06 / ODOO-5800
            const termRow = (x) => {   // IE 2026 10 06 / ODOO-5800
                if (!hidRows.has(x)) return visibleRow(x)   // IE 2026 10 06 / ODOO-5800
                const chain = []   // IE 2026 10 06 / ODOO-5800: спрятанные строки от x вверх до показанного предка p
                let p = x   // IE 2026 10 06 / ODOO-5800
                for (; p && hidRows.has(p); p = parentOf.get(p)) chain.push(p)   // IE 2026 10 06 / ODOO-5800
                if (!p) return chain.slice(1).reduce((o, h) => (h._DLRow?.isCollapsed ? h : o), x)   // IE 2026 10 06 / ODOO-5800: показанного предка нет — как раньше
                const shownKids = p[kidsPath]   // IE 2026 10 06 / ODOO-5800
                const closed = collapsedRows.has(p) || (!!p._DLRow?.isCollapsed && !(Array.isArray(shownKids) && shownKids.length))   // IE 2026 10 06 / ODOO-5800: группа без показанных подчинённых в гриде не сворачивается — по признаку раскладки
                if (!visible.has(p) || closed) return visibleRow(p)   // IE 2026 10 06 / ODOO-5800
                let cur = p   // IE 2026 10 06 / ODOO-5800
                for (let i = chain.length - 1; i >= 0; i--) {   // IE 2026 10 06 / ODOO-5800: сверху вниз — пустая строка видимой не была, свёрнутая прячет подчинённых
                    if (!hidAlive(chain[i])) break   // IE 2026 10 06 / ODOO-5800
                    cur = chain[i]   // IE 2026 10 06 / ODOO-5800
                    if (cur._DLRow?.isCollapsed) break   // IE 2026 10 06 / ODOO-5800
                }   // IE 2026 10 06 / ODOO-5800
                return cur   // IE 2026 10 06 / ODOO-5800
            }   // IE 2026 10 06 / ODOO-5800
            const cells = new Map()   // dataItem → Map(binding → 'base' | 'plus' | 'minus')
            const mark = (x, bb, kind) => { if (!this.attr_by_binding[bb] || hidRows.has(x)) return; const v = visibleRow(x)
                if (_deepOn) {   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p204 підсвітка залежних комірок — у розкритого батька лише точна дочірня комірка)
                    const vExp = v !== x && expandedRows.has(v)
                    const tg = inflDeepest_target({ x, v, vExpanded: vExp, empty: vExp && inflDeepest_isEmpty(this.store.get_value(x, bb)) })
                    if (tg === 'skip') return
                    if (tg === 'fallback') { if (!deepFallback.has(v)) deepFallback.set(v, new Set()); deepFallback.get(v).add(bb) } else deepFallback.get(v)?.delete(bb)
                }
                if (!cells.has(v)) cells.set(v, new Map()); const cm = cells.get(v); if (cm.get(bb) !== 'base') cm.set(bb, kind) }   // IE 2026 10 06 / ODOO-5800: спрятанное слагаемое на экране не метится
            const bnd = (d) => `${d}.${suffix}`
            const val = (x, bb) => { const v = parseFloat(this.store.get_value(x, bb)); return Number.isNaN(v) ? 0 : v }
            // IE 2026 09 24 / ODOO-5800 (Igor: форма на 58:27 под поиском «PSP Pharma Ltd» — «+ 31 633 → …» при 1 296 в ячейке): приход / расход ВЫБРАННОЙ ячейки группы под отбором —
            // показанный итог по отбору (как в ячейке); формула остатка по-прежнему по всем строкам. Опция fe.ux.filterTotalsAllPaths
            const flowOf = (x, bb) => { const fs = this.filterTotals_shown(x, bb); if (fs) { const v = parseFloat(fs.v); return Number.isNaN(v) ? 0 : v } return val(x, bb) }
            const title = String(it.measure_type || it._dlhdr_0 || it.title || '')
            // IE 2026 09 16 (замечание Игоря): строка НЕПОКРЫТОГО объёма (мера *_uncovered / alert Uncovered) остаток не меняет — списать
            // (получить) нужно, но операция невозможна: такие ячейки метятся знаком ⊘ своего цвета и в суммы формулы не входят
            const isUncOwn = (x) => this.balancePreview_uncOf(x)   // IE 2026 09 17: явная роль строки раскладки Uncovered inflow / outflow
                || /_uncovered$/i.test(String(x?.measure ?? x?.measure_?.binding ?? x?.measure_?.id ?? ''))
                || /^uncovered$/i.test(String(x?.alert || '').trim())
            // IE 2026 09 21 / ODOO-5800 (замечание Игоря со скрином: «ячейки с uncovered нужно показывать с особым выделением, так как они не меняют запас»):
            // признак НАСЛЕДУЕТСЯ от предков. В раскладке Purchase Balance alert = Uncovered стоит на строке уровня страны, её подчинённые строки субъектов
            // своего alert не несут — они метились обычными «+» / «−» и входили в суммы формулы остатка. Выключатель fe.ux.inflUncInherit
            const _uncInherit = this.store.setting('fe.ux.inflUncInherit', true) !== false
            const isUnc = (x) => {
                if (isUncOwn(x)) return true
                if (!_uncInherit) return false
                for (let y = parentOf.get(x), n = 0; y && n < 16; y = parentOf.get(y), n++) if (isUncOwn(y)) return true
                return false
            }
            // склад (BW): его расход — отгрузки Ex-Delta дистрибьюторам ТОЙ ЖЕ СТРАНЫ (мера у них IN — приход дистрибьютора;
            // строки Ex-Delta, отнесённые к субъекту самого склада, двусмысленны и не считаются)
            // IE 2026 09 23 / ODOO-341407 (Igor): единая аббревиатура таможенного склада на язык — en BW, uk ТЦ, ru ТС; подписи строк приходят с бэка уже переведёнными
            const isBWTitle = (t) => /\bBW\b|склад|warehouse|(^|[^\p{L}])(МС|ТЦ|ТС)(?![\p{L}])/iu.test(String(t || ''))   // IE 2026 09 25 / ODOO-341407 (Igor 25.09): uk-аббревиатура склада — «МС» (митний склад) вместо «ТЦ»; «ТЦ» оставлен для старых снимков
            const isBW = isBWTitle(title)
            // IE 2026 09 23 / ODOO-5800: строка «−» Ex-Delta разделена на «Shipment from BW» (distr_group_ship) и «In transit» (distr_group_transit) — обе строки = отгрузки склада
            const isExDelta = (l) => /^distr_group(_ship|_transit)?$|ex-delta/i.test(l.group || '')
            const countryOf = (x) => { let y = x; while (y) { if (y.country) return y.country; y = parentOf.get(y) } return null }
            const countriesOf = (x) => { const out = new Set(); const walk = (y) => { const c = countryOf(y); if (c) out.add(c); for (const k of kidsOf(y) || []) walk(k) }; walk(x); return out }   // IE 2026 10 06 / ODOO-5800: + спрятанные подчинённые
            let formula = null
            if (role === 'stock') {
                if (idx === 0) { this.influence_clear(); return }
                const prev = uniq[idx - 1]
                mark(it, bnd(prev), 'base')
                const cSet = isBW ? countriesOf(it) : new Set()
                let sumIn = 0, sumOut = 0, uncIn = 0, uncOut = 0
                const inRows = new Set(), outRows = new Set(), uncInRows = new Set(), uncOutRows = new Set()
                for (const l of leaves) {
                    if (l.it === it || l.role === 'stock') continue
                    let kind = null
                    if (isBW) {
                        // склад — транзит: приход = закупки на склад, расход = отгрузки Ex-Delta дистрибьюторам его страны;
                        // продажи, отнесённые к субъекту склада (план страны), — не его расход
                        // групповая строка всех складов блока — все отгрузки Ex-Delta; строка одного склада — отгрузки его страны
                        if (isExDelta(l)) { if (inSet(l.it)) continue; const c = countryOf(l.it); if (!it.subject || (c && cSet.has(c))) kind = 'minus' }
                        else if (l.role === 'in' && inSet(l.it)) kind = 'plus'
                    } else if (inSet(l.it)) kind = l.role === 'in' ? 'plus' : (l.role === 'out' ? 'minus' : null)
                    if (!kind) continue
                    const v = val(l.it, bnd(prev))
                    if (isUnc(l.it)) {   // IE 2026 09 16: непокрытый объём — знак ⊘, в остаток не входит
                        mark(l.it, bnd(prev), kind + '-unc')
                        if (kind === 'plus') { uncIn += v; uncInRows.add(termRow(l.it)) } else { uncOut += v; uncOutRows.add(termRow(l.it)) }   // IE 2026 10 06 / ODOO-5800: termRow
                        continue
                    }
                    mark(l.it, bnd(prev), kind)
                    if (kind === 'plus') { sumIn += v; inRows.add(termRow(l.it)) } else { sumOut += v; outRows.add(termRow(l.it)) }   // IE 2026 10 06 / ODOO-5800: termRow
                }
                const base = val(it, bnd(prev)), cur = val(it, b)
                // IE 2026 10 02 / ODOO-5800 (решение Игоря 02.10: ворота «факт» по разделителю плана грида, без правки BE — ни SS_plan/
                // actualized_stock, ни узловой dfs на фронт не идут, см. handoff-tools/2026-10-02/stock_mismatch/RESULT.md): период cur не
                // позже месяца начала планового горизонта (attr.break_before === 'plan', тот же признак красит штриховку-разделитель —
                // breakMode AttrGrid.vue:13299, planStartOn ~13168) — строго после него план по построению равен расчёту (как и подстановка
                // актуализации из плана), показывать расхождение там нечего
                const _planMonth = this.influence_planStartMonth(flex)
                const factGate = !!_planMonth && date.slice(0, 7) <= _planMonth
                // IE 2026 10 03 / ODOO-5800 (CONTRACT v7 §8, fe-50; замер prod_check/KZ-node.md: строка «Казахстан / MD828» — группа 5 узлов, формула по суммам строки): nodes — число субъектов (узлов) за строкой
                // (subjectsOf; 0 — субъектов в дереве нет, считается одним узлом), factMonth — период ячейки = месяц факта (начала плана): локальная формула критикует только один узел в месяце факта (utils/cellStory.story_mismatchOfFormula)
                // IE 2026 10 03 / ODOO-5800 (fe-51; бот prod_check2: subjSet считал memo-строки «Покриття запасу» / «· of which …» — их subject = заголовок — узлами: группа 5 узлов → 12, одиночный узел → 2–3 и вместо причины skip «row total (2 nodes)»):
                // nodes — различные субъекты по id без memo-строк (сырой _DLRow.memo, utils/cellStory.story_rowNodes); subjSet подсветки — как было
                const nodes = story_rowNodes(it, kidsOf), factMonth = !!_planMonth && date.slice(0, 7) === _planMonth   // IE 2026 10 06 / ODOO-5800: узлы за строкой — вместе со спрятанными подчинёнными (было kidsPath)
                formula = { kind: 'stock', base, sumIn, sumOut, nIn: inRows.size, nOut: outRows.size, calc: base + sumIn - sumOut, cur, prev,
                    uncIn, uncOut, nUncIn: uncInRows.size, nUncOut: uncOutRows.size, factGate, nodes, factMonth }
            } else if ((role === 'in' || role === 'out') && isUnc(it)) {
                // IE 2026 09 16: непокрытая ячейка на остатки не влияет — без подсветки, только пояснение
                formula = { kind: 'unc', role, flow: flowOf(it, b) }   // IE 2026 09 24 / ODOO-5800
            } else if (role === 'in' || role === 'out') {
                // приход/расход → остатки последующих периодов тех же субъектов; Ex-Delta — ещё и расход склада той же страны
                const flowSubjects = subjectsOf(it)
                const sign = role === 'in' ? 'plus' : 'minus'
                const exDelta = /^distr_group(_ship|_transit)?$|ex-delta/i.test(String(it.measure_type || '')) || isExDelta({ group: String(parentOf.get(it)?.measure_type || '') })   // IE 2026 09 23 / ODOO-5800: + разделённые типы
                const flowCountries = exDelta ? countriesOf(it) : new Set()
                const targets = new Set()
                for (const l of leaves) {
                    if (l.role !== 'stock') continue
                    const vis = termRow(l.it)   // IE 2026 10 06 / ODOO-5800: спрятанная строка остатка — сама себе строка
                    let kind = null
                    if (exDelta && isBWTitle(vis?.measure_type)) { const c = countryOf(l.it); if (c && flowCountries.has(c)) kind = 'minus' }
                    else if (!flowSubjects.size || (l.it.subject && flowSubjects.has(l.it.subject))) kind = sign
                    if (!kind) continue
                    for (let j = idx + 1; j < uniq.length; j++) mark(l.it, bnd(uniq[j]), kind)
                    targets.add(vis)
                }
                formula = { kind: role, flow: flowOf(it, b), n: targets.size, from: uniq[idx + 1] || null }   // IE 2026 09 24 / ODOO-5800
            } else { this.influence_clear(); return }
            if (_deepOn && deepFallback.size) inflDeepest_prune(cells, deepFallback, parentOf)   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p204 підсвітка залежних комірок — у розкритого батька лише точна дочірня комірка): точная дочерняя ячейка на экране — запасная метка родителя снимается
            this._infl = { cells, anchor: { it, b } }
            this.influence_formulaShow(formula, sel)
            flex.invalidate()
        },
        // IE 2026 10 02 / ODOO-5800 (решение Игоря 02.10, без правки BE): месяц первой колонки планового горизонта — по тому же признаку,
        // которым рисуется штриховка-разделитель «Plan start» (attr.break_before === 'plan', бэк ставит на колонку периода с date_fact_stock,
        // см. breakMode ниже и комментарий у planStartOn). Поле читаем НАПРЯМУЮ, минуя fe.ux.planStartMark — это переключатель отрисовки
        // штриховки, он не должен гасить данные формулы остатка.
        // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p204 підсвітка залежних комірок — у розкритого батька лише точна дочірня комірка): раскрытие / свёртка строки при выбранной ячейке — подсветка влияющих
        // пересчитывается (раньше оставалась от состояния на момент выбора). Один пересчёт после окончания обновления грида; выключатель fe.ux.cellBasisDeepest
        influence_reschedule() {
            if (this._inflResched) return
            this._inflResched = true
            let n = 0
            const run = () => {
                const f = this.flex
                if (f && f.isUpdating && n++ < 20) { setTimeout(run, 30); return }
                this._inflResched = false
                if (f && this._infl) { try { this.influence_update(f) } catch (e) { if (window.__simDebug) console.log('influence:', e) } }
            }
            setTimeout(run, 0)
        },
        influence_planStartMonth(flex) {
            if (!flex?.columns || !this.attr_by_binding) return null
            for (const col of flex.columns) {
                const a = col.binding ? this.attr_by_binding[col.binding] : null
                if (a && String(a.break_before) === 'plan') {
                    const m = /^(\d{4}-\d{2}-\d{2})\./.exec(col.binding)
                    if (m) return m[1].slice(0, 7)
                }
            }
            return null
        },
        // ===== IE 2026 09 22 / ODOO-5800 (Igor: «в строках 3–18 данные на основе одних и тех же документов, только сгруппированных по разным реквизитам дат этих
        // документов. Предлагаю — как ты показываешь зависимые ячейки по оборотам / приходу / расходу / остаткам — показать и ячейки, при позиционировании на одной
        // из них с данными, в которых данные из (ссылок) этих же доков»): «ТЕ ЖЕ ДОКУМЕНТЫ». Бэк (хвост common_modules/doc_links.py) кладёт в ячейку-дату
        // спутник doc_ids — id документов-источников строк (source_id: заказ поставщику «ПП #299», плановый заказ, документ движения); названия —
        // record._doc.doc_links.titles. Выделена ячейка с doc_ids → все ячейки грида, чьи doc_ids пересекаются с ней, получают класс cell-same-doc (сама —
        // cell-same-doc-anchor); пересчёт на смене выделения, как подсветка влияющих ячеек. Выключатель fe.ux.sameDocHighlight
        sameDoc_on() {
            return this.store.setting('fe.ux.sameDocHighlight', true) !== false && this.attr?.attr_type !== 'AttrTabGrid'
        },
        sameDoc_clear(invalidate = true) {
            this.sameDocNav_reset()   // IE 2026 09 25 / ODOO-5800: остановки ‹ › формы ячейки живут вместе с набором «тех же документов»
            if (!this._sameDoc) return
            this._sameDoc = null
            if (invalidate) this.flex?.invalidate()
        },
        sameDoc_cellOf(dataItem, binding) {
            const d = String(binding || '').slice(0, 10)
            if (!dataItem || !/^\d{4}-\d{2}-\d{2}$/.test(d)) return null
            const c = dataItem[d]
            return c && typeof c === 'object' && Array.isArray(c.doc_ids) && c.doc_ids.length ? { date: d, cell: c } : null
        },
        sameDoc_update(flex) {
            if (!this.sameDoc_on()) { this.sameDoc_clear(); return }
            const sel = flex.selection
            const it = sel && sel.row >= 0 ? flex.rows[sel.row]?.dataItem : null
            const col = sel && sel.col >= 0 ? flex.columns[sel.col] : null
            const hit = this.sameDoc_cellOf(it, col?.binding)
            if (!hit) { this.sameDoc_clear(); return }
            const want = new Set(hit.cell.doc_ids.map(String))
            const cells = new Map()   // dataItem → Set(дата)
            const aggs = new Map()   // IE 2026 09 25 / ODOO-5800: dataItem → Set(дата) АГРЕГАТНЫХ ячеек (красятся, не считаются) — переходы ‹ › формы ячейки их пропускают
            const kidsPath = this.attr.childItemsPath || 'attrs'
            // IE 2026 09 22 / ODOO-5800 (Igor: «когда пишешь "11 more cells…" — считай только детальные ячейки без итоговых, как в чипсе метрик»): ячейка строки-группы, под которой
            // (в её поддереве) в той же колонке есть ячейка тех же документов, — агрегат: подсвечивается, но не считается (как drop_aggregates чипса метрик). Выключатель fe.ux.sameDocDetailed
            const detailed = this.store.setting('fe.ux.sameDocDetailed', true) !== false
            let n = 0
            const walk = (r) => {   // → Set(дата) ячеек тех же документов в поддереве r (включая r)
                const sub = new Set()
                if (!r || typeof r !== 'object') return sub
                for (const kid of r[kidsPath] || []) for (const d of walk(kid)) sub.add(d)
                for (const k in r) {
                    if (k.length !== 10 || k.charCodeAt(0) < 48 || k.charCodeAt(0) > 57) continue
                    const c = r[k]
                    if (!c || typeof c !== 'object' || !Array.isArray(c.doc_ids) || (r === it && k === hit.date)) continue
                    if (!c.doc_ids.some(x => want.has(String(x)))) continue
                    let s = cells.get(r)
                    if (!s) { s = new Set(); cells.set(r, s) }
                    s.add(k)
                    if (!(detailed && sub.has(k))) n++
                    else { let a = aggs.get(r); if (!a) { a = new Set(); aggs.set(r, a) } a.add(k) }   // IE 2026 09 25 / ODOO-5800: агрегат группы — не остановка ‹ ›
                    sub.add(k)
                }
                return sub
            }
            for (const r of (this.data000 || this.data || [])) walk(r)
            this.sameDocNav_reset()   // IE 2026 09 25 / ODOO-5800: новая выделенная ячейка — остановки ‹ › и вспышка прежней снимаются
            this._sameDoc = { cells, aggs, anchor: { it, date: hit.date }, n, ids: want, binding: col?.binding || '' }   // IE 2026 09 25 / ODOO-5800: aggs, binding — для переходов ‹ › формы ячейки
            flex.invalidate()
        },
        sameDoc_paint(e_cell, dataItem, col) {
            const st = this._sameDoc
            let kind = null
            if (st && dataItem) {
                const d = String(col?.binding || '').slice(0, 10)
                if (dataItem === st.anchor.it && d === st.anchor.date) kind = 'anchor'
                else { const s = st.cells.get(dataItem); if (s && s.has(d)) kind = 'same' }
            }
            // IE 2026 09 25 / ODOO-5800 (проба переходов ‹ ›: memo-строка «of which expired» без рамки): метка на элементе — не истина, кэш-путь formatItem переписывает
            // className снимком (класс мог пропасть, а мог и остаться в снимке у уже не «той» ячейки) — сверяем с реальными классами и правим только расхождение
            const prev = e_cell.__sameDoc || null
            const hasSame = e_cell.classList.contains('cell-same-doc-same'), hasAnchor = e_cell.classList.contains('cell-same-doc-anchor')
            const has = kind === 'same' ? hasSame : (kind === 'anchor' ? hasAnchor : !(hasSame || hasAnchor))
            if (kind === prev && has) return
            if (hasSame && kind !== 'same') e_cell.classList.remove('cell-same-doc-same')
            if (hasAnchor && kind !== 'anchor') e_cell.classList.remove('cell-same-doc-anchor')
            if (kind && !(kind === 'same' ? hasSame : hasAnchor)) e_cell.classList.add('cell-same-doc-' + kind)
            e_cell.__sameDoc = kind
        },
        // IE 2026 10 01 / ODOO-5800 (Igor: «добавить … количества в документы формы дропдаун»): количество документов в ячейке {id: число} — проверенное по значению ячейки:
        // сумма больше значения (строка-группа видит лишнее: непокрытая часть, все движения документа за месяц) — количества не показываются (null), знак — как у значения.
        // Источник — спутник ячейки doc_qty (doc_links, точный) либо qtyOf (движения паспорта). Выключатель fe.cellForm.docQty (false — без количеств)
        sameDoc_qtyCheck(qtyOf, dataItem, binding) {
            if (!qtyOf || typeof qtyOf !== 'object' || this.store.setting('fe.cellForm.docQty', true) === false) return null
            const [m, f] = String(binding || '').split('.'); const v = f ? dataItem?.[m]?.[f] : null
            // IE 2026 10 27 / ODOO-5800 (слово Игоря 27.10 через ie-dm7 #109544: документы без ссылки — количество и статус в блоке документов):
            // строки регистра 1С (register:*) — вне суммы проверки (регистр догружается позже расчёта); выключатель fe.ux.sameDocQtyCheckSkipRegister (false — по всем строкам)
            return cellDocs_qtyCheck(qtyOf, v, this.store.setting(SAMEDOC_SKIP_REGISTER_FLAG, true) !== false)
        },
        // названия документов ячейки (для формы ячейки): [{id, title}] по record._doc.doc_links.titles, без названия — id
        sameDoc_titles(dataItem, binding) {
            const hit = this.sameDoc_cellOf(dataItem, binding)
            if (!hit) return []
            const DL = this.WIDGET?.record?._doc?.doc_links || {}, T = DL.titles || {}, D = DL.docs || {}
            const Q = this.sameDoc_qtyCheck(hit.cell.doc_qty, dataItem, binding) || {}   // IE 2026 10 01 / ODOO-5800: количества документов в ячейке (спутник doc_qty)
            // IE 2026 09 22 / ODOO-5800: вид и статус до прихода паспорта — документ движка по префиксу id (D-SO-… → SO), документ 1С — по строке источника (.docs {id: [сегмент, статус]})
            const CS = cellDocs_cellStatuses(hit.cell, hit.cell.doc_ids)   // IE 2026 10 05 / ODOO-5800 (fe-83): статусы строк источника ЭТОЙ ячейки (спутник doc_st)
            return hit.cell.doc_ids.map(id => {
                const sid = String(id), m = /^D-(PO|DO|MO|SO)-/.exec(sid), x = D[sid]
                const kind = m ? { id: m[1], text: m[1], hint: '' } : (Array.isArray(x) && x[0] ? { id: x[0], text: x[0], hint: '' } : null)
                const status = cellDocs_preStatus(sid, D, CS)   // IE 2026 10 05 / ODOO-5800 (fe-83): статус строк этой ячейки, иначе (прежнее) — строки источника на весь отчёт
                return { id: sid, title: T[sid] || sid, kind, status, link: null, qty: Q[sid] ?? null, status_raw: '' }   // IE 2026 10 01 / ODOO-5800: + qty, status_raw
            })
        },
        // ===== IE 2026 09 25 / ODOO-5800 (Igor: «Нужна возможность показать-перейти (но не делая их выбранными, иначе текущая форма-дропдаун будет неактуальная и
        // перерисуется) на них как в чипсе поиска "<>"»): ПЕРЕХОДЫ ‹ › ПО ЯЧЕЙКАМ ТЕХ ЖЕ ДОКУМЕНТОВ из блока DOCUMENTS формы ячейки. Остановки — детальные ячейки
        // _sameDoc (агрегаты групп не считаются, как в «N more cells») в порядке строк и колонок грида; колонка месяца — с тем же хвостом привязки, что у
        // ячейки-якоря (.quantity / …), иначе первая видимая колонка этого месяца. Шаг: свёрнутых предков раскрыть (navRow_reveal, как у чипсов метрик /
        // оформления), прокрутить (scrollIntoView — замороженные строки / колонки учитывает сам wijmo) и ВСПЫХНУТЬ ячейкой (класс cell-same-doc-cur, keyframes с
        // отрицательной задержкой — ячейка, перерисованная прокруткой, продолжает анимацию с нужной фазы, как flash_apply, а не мигает заново). Выделение грида
        // (flex.selection) НЕ трогается — форма остаётся у своей ячейки, selectionChanged не срабатывает. Выключатель fe.cellForm.sameDocNav (false — только ссылка)
        sameDocNav_on() { return this.store.setting('fe.cellForm.sameDocNav', true) !== false },
        // список остановок [{r, c}] (кэш по набору _sameDoc и числу строк / колонок грида); null — набора нет или выключено
        sameDocNav_list() {
            const st = this._sameDoc, flex = this.flex
            if (!st || !flex?.rows || !flex.columns || !this.sameDocNav_on()) return null
            const nav = this._sameDocNav
            if (nav && nav.st === st && nav.rowsN === flex.rows.length && nav.colsN === flex.columns.length) return nav
            const suffix = String(st.binding || '').slice(10)
            const list = []
            for (let r = 0; r < flex.rows.length; r++) {
                const row = flex.rows[r], it = row.dataItem
                if (!it || row.visible === false) continue   // строки, спрятанные отбором, — не остановки (как у поиска); свёрнутые группы раскрываются на шаге
                const dates = st.cells.get(it)
                if (!dates) continue
                const agg = st.aggs?.get(it)
                const best = new Map()   // месяц → индекс колонки
                for (let c = 0; c < flex.columns.length; c++) {
                    const col = flex.columns[c], b = String(col.binding || ''), d = b.slice(0, 10)
                    if (!dates.has(d) || !col.isVisible || (agg && agg.has(d))) continue
                    const cur = best.get(d)
                    if (cur == null || (b === d + suffix && String(flex.columns[cur].binding || '') !== d + suffix)) best.set(d, c)
                }
                for (const c of [...best.values()].sort((a, b) => a - b)) list.push({ r, c })
            }
            this._sameDocNav = { st, list, index: -1, rowsN: flex.rows.length, colsN: flex.columns.length }
            return this._sameDocNav
        },
        // шаг ‹ › (dir ±1) по кругу; → {index, total} для счётчика формы, null — остановок нет
        sameDocNav_step(dir) {
            const nav = this.sameDocNav_list()
            if (!nav || !nav.list.length) return null
            const n = nav.list.length
            nav.index = nav.index < 0 ? (dir < 0 ? n - 1 : 0) : (nav.index + dir + n) % n
            const m = nav.list[nav.index]
            this.cellShow_flash(m.r, m.c)
            return { index: nav.index, total: n }
        },
        // показать ячейку БЕЗ выбора: раскрыть свёрнутых предков строки, прокрутить к ячейке и вспыхнуть ею на SAMEDOC_CUR_MS; выделение и форма не меняются
        cellShow_flash(r, c) {
            const flex = this.flex
            if (!flex?.rows?.[r] || !flex.columns?.[c]) return false
            this.cellShow_clear()
            try { this.navRow_reveal(r) } catch (e) { /* грид в перестройке */ }
            try { flex.scrollIntoView(r, c) } catch (e) { /* грид в перестройке */ }
            this._sameDocCur = { r, c, ts: Date.now() }
            this.sameDocNav_paintAt(r, c)   // ячейка уже в кадре — прокрутки (и перерисовки через formatItem) может не быть
            this._sameDocCurT = setTimeout(() => { this._sameDocCurT = null; this.cellShow_clear() }, SAMEDOC_CUR_MS + 60)
            return true
        },
        cellShow_clear() {
            clearTimeout(this._sameDocCurT); this._sameDocCurT = null
            const cur = this._sameDocCur
            if (!cur) return
            this._sameDocCur = null
            this.sameDocNav_paintAt(cur.r, cur.c)
        },
        sameDocNav_paintAt(r, c) {
            let el = null
            try { el = this.flex?.cells?.getCellElement(r, c) } catch (e) { el = null }
            if (el) this.sameDocNav_paint(el, r, c)
        },
        // из formatItem (хвост, после кэш-пути) и напрямую: класс вспышки — только у ячейки (r, c) текущей остановки и только пока вспышка идёт; решение — по состоянию
        // грида и РЕАЛЬНОМУ классу (снимок className кэш-пути мог его стереть или вернуть), не по метке; animationDelay — фаза (как flash_apply)
        sameDocNav_paint(e_cell, r, c) {
            const cur = this._sameDocCur
            const age = cur ? Date.now() - cur.ts : SAMEDOC_CUR_MS
            const has = e_cell.classList.contains('cell-same-doc-cur')
            if (cur && cur.r === r && cur.c === c && age < SAMEDOC_CUR_MS) {
                e_cell.style.animationDelay = `-${age}ms`
                if (!has) e_cell.classList.add('cell-same-doc-cur')
                e_cell.__sameDocCur = true
                return
            }
            if (!has && !e_cell.__sameDocCur) return
            if (has) e_cell.classList.remove('cell-same-doc-cur')
            e_cell.__sameDocCur = false
            if (e_cell.style.animationDelay && !e_cell.classList.contains('wj-cell-flash') && !e_cell.classList.contains('wj-cell-flash-override')) e_cell.style.animationDelay = ''
        },
        // закрытие формы / смена выделения / новый набор «тех же документов»: остановки забыть, вспышку снять
        sameDocNav_reset() {
            this._sameDocNav = null
            this.cellShow_clear()
        },
        influence_paint(e_cell, dataItem, col) {
            const info = this._infl && dataItem ? this._infl.cells.get(dataItem) : null
            const kind = (info && info.get(col?.binding)) || null
            const prev = e_cell.__infl || null
            if (kind === prev) return
            if (prev) { e_cell.classList.remove('cell-infl-' + prev); delete e_cell.dataset.infl }
            if (kind) { e_cell.classList.add('cell-infl-' + kind); e_cell.dataset.infl = kind === 'plus' ? '+' : (kind === 'minus' ? '−' : (kind === 'base' ? '=' : '⊘')) }   // IE 2026 09 16: ⊘ — непокрытый объём (операция невозможна)
            e_cell.__infl = kind
        },
        // ===== IE 2026 09 17 / ODOO-… (заказ Игоря): «при выделении ячейки целиком — выделять целиком ячейки,
        // содержащие такой же текст» (продолжение подсветки вхождений выделенного ТЕКСТА, ODOO-5828, только по ячейкам).
        // Текст берётся отформатированным (как видит пользователь), сравнение по всей ячейке; сама выбранная ячейка
        // и так обведена рамкой выделения. Внутренняя опция fe.ux.gridSameValueHighlight (по умолчанию вкл),
        // порог длины — fe.data.gridSameValueMinLen (по умолчанию 2: одиночная цифра красила бы пол-таблицы).
        // ===== IE 2026 09 17 / ODOO-… (замечания Игоря: «в строке 59 Uncovered — нужно выделять шапку подчинённых
        // строк и значимые значения в подчинённых ячейках»; «то же касается и других алертов: смотри, как в строке 107 —
        // и должна распространяться на строку 108») =====
        // Строка-алерт: непустое поле alert (Uncovered, Expired, …) или мера *_uncovered (отчёты, где alert не заполнен).
        // Свою раскраску такая строка получает от условного оформления (классы cell-background-* и/или inline-стиль
        // строки) — и только САМА строка. Её подчинённые строки метит фронт ТЕМ ЖЕ цветом слабее: шапка (колонки
        // измерений) заметнее, непустые значения мягче; наследуется ближайший алерт-предок.
        // Цвет ложится в --alert-child-bg смесью с фактическим фоном грида, то есть НЕПРОЗРАЧНЫМ: сквозь
        // полупрозрачный фон клона замороженных колонок (cloneFrozenCells) после горизонтальной прокрутки
        // просвечивает прокрученный оригинал и текст двоится (замечание Игоря 17.09 про строку 60).
        // Внутренняя опция fe.ux.gridAlertChildMark (по умолчанию вкл; прежнее имя fe.ux.gridUncChildMark).
        // IE 2026 09 23 / ODOO-5800 (Igor: «of which uncovered / expired»): memo-строки отчёта (_DLRow.memo с бэка —
        // «· of which uncovered / expired» под строкой документа) — курсив, приглушённая подпись, без заливки alert-строки,
        // не лист для подсветки влияния и декомпозиции правки. Выключатель fe.ux.memoRows (по умолчанию вкл)
        memoRows_on() { return this.store.setting('fe.ux.memoRows', true) !== false },
        memoRow_is(dataItem) { return !!dataItem?._DLRow?.memo && this.memoRows_on() },
        alert_isRow(dataItem) {
            if (!dataItem) return false
            if (this.memoRow_is(dataItem)) return false   // IE 2026 09 23 / ODOO-5800: подпись memo лежит в колонке alert — это не alert-строка
            // IE 2026 10 13 / ODOO-5800 (Igor: «Убери выделение в разделе Добір до MOQ»): measure IN_moq_topup и класс alert-plain — не alert-строка; значение alert остаётся (фильтры). Флаг fe.ux.alertPlainRows (по умолчанию вкл)
            return alertIsRow(dataItem, {
                plainOn: this.fmtSetting('fe.ux.alertPlainRows', true) !== false,
                classes: () => {
                    const c = [dataItem?._DLRow?.cssClasses]
                    if (this.attr?.cf_rules) { try { c.push(this.cf_compute(dataItem, '', null)?.cssClasses) } catch (e) { /* без классов правил */ } }
                    return c
                },
            })
        },
        alert_rgb(str) {
            const s = String(str || '').trim()
            let m = /^rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)(?:[,/\s]+([\d.]+))?/i.exec(s)
            if (m) { const a = m[4] === undefined ? 1 : +m[4]; return a > 0.02 ? { r: +m[1], g: +m[2], b: +m[3], a } : null }
            m = /^#([0-9a-f]{3,8})$/i.exec(s)
            if (m) {
                let h = m[1]
                if (h.length === 3 || h.length === 4) h = h.split('').map(c => c + c).join('')
                return { r: parseInt(h.slice(0, 2), 16), g: parseInt(h.slice(2, 4), 16), b: parseInt(h.slice(4, 6), 16), a: h.length >= 8 ? parseInt(h.slice(6, 8), 16) / 255 : 1 }
            }
            return null
        },
        // цвет класса оформления — замером скрытого элемента с этим классом внутри хоста грида: правила
        // cell-background-* живут в CSS компонента и зависят от цветовой гаммы; кэш по имени класса
        alert_classColor(cls) {
            if (!this._alertClsColor) this._alertClsColor = new Map()
            if (this._alertClsColor.has(cls)) return this._alertClsColor.get(cls)
            let col = null
            try {
                const host = this.flex?.hostElement || document.body
                const el = document.createElement('div')
                el.className = 'wj-cell ' + cls
                el.style.cssText = 'position:absolute;left:-10000px;top:-10000px;width:1px;height:1px;pointer-events:none'
                host.appendChild(el)
                col = this.alert_rgb(getComputedStyle(el).backgroundColor)
                host.removeChild(el)
            } catch (e) { col = null }
            this._alertClsColor.set(cls, col)
            return col
        },
        // фон, на котором лежат ячейки грида (зависит от гаммы): с ним смешиваем, чтобы результат был непрозрачным
        alert_baseColor() {
            if (this._alertBaseColor) return this._alertBaseColor
            let col = null
            try {
                let el = this.flex?.hostElement
                while (el && !col) {
                    col = this.alert_rgb(getComputedStyle(el).backgroundColor)
                    if (col && col.a < 0.99) col = null
                    el = el.parentElement
                }
            } catch (e) { col = null }
            this._alertBaseColor = col || { r: 255, g: 255, b: 255, a: 1 }
            return this._alertBaseColor
        },
        alertRow_color(dataItem) {
            const cls = []
            const push = (a) => { if (Array.isArray(a)) cls.push(...a.map(x => String(x || '').trim()).filter(Boolean)) }
            push(dataItem?._DLRow?.cssClasses)
            let style = String(dataItem?._DLRow?.cssStyle || '')
            if (this.attr?.cf_rules) {
                try {
                    const cf = this.cf_compute(dataItem, '', null)
                    if (cf) { push(cf.cssClasses); style += ';' + (cf.cssStyle || '') }
                } catch (e) { /* правила не вычислились — цвет возьмём из классов строки */ }
            }
            const m = /background(?:-color)?\s*:\s*([^;!]+)/i.exec(style)
            const inline = m ? this.alert_rgb(m[1]) : null
            if (inline) return inline
            for (let i = cls.length - 1; i >= 0; i--) { const c = this.alert_classColor(cls[i]); if (c) return c }
            return this.alert_classColor('cell-background-red') || { r: 255, g: 138, b: 138, a: 1 }
        },
        // строка-потомок -> цвет её ближайшего алерт-предка (кэш на набор данных)
        alertChild_map() {
            if (this._alertKidsSrc === this.data && this._alertKids) return this._alertKids
            // IE 2026 10 14 / ODOO-5800 (app7 #84472, 20 тыс. строк): обход — utils/alertChild (без рекурсии, с мемо собственного цвета и картой родителей для точечного обновления alertChild_invalidate)
            const S = alertChild_build(this.data, this.attr?.childItemsPath || 'attrs', (it) => this.alertChild_own(it))
            this._alertKidsS = S
            this._alertKids = S.map
            this._alertKidsSrc = this.data
            return S.map
        },
        alertChild_own(it) { return this.alert_isRow(it) ? (this.alertRow_color(it) || null) : null },   // IE 2026 10 14 / ODOO-5800: собственный цвет alert-строки (null — не alert-строка)
        alertChildKeep_on() { return alertChildKeep_flagOn((k, d) => this.store.setting(k, d)) },   // IE 2026 10 14 / ODOO-5800
        // IE 2026 10 14 / ODOO-5800 (app7 #84472: клик ✓PM на 20 тыс. строк — 2,7 с из 3,4 с уходило на полную перестройку этой карты после сброса _alertKids = null в set_value, при пустой
        // карте): правка строки dataItem — заново оцениваются только она и предки, поддерево — у самого верхнего изменившегося (utils/alertChild.alertChild_update);
        // карты нет / строка не из неё / выключатель — прежний полный сброс. Счётчик window.__gridAlertChildKeep {keep, walked, full}
        alertChild_invalidate(dataItem) {
            const st = (window.__gridAlertChildKeep = window.__gridAlertChildKeep || { keep: 0, walked: 0, full: 0 })
            const S = this._alertKidsS
            if (!S || !this._alertKids || this._alertKidsSrc !== this.data || !dataItem || !this.alertChildKeep_on()) { st.full++; this._alertKids = null; this._alertKidsS = null; return }
            let n = -1
            try { n = alertChild_update(S, dataItem, this.attr?.childItemsPath || 'attrs', (it) => this.alertChild_own(it)) } catch (e) { n = -1 }
            if (n < 0) { st.full++; this._alertKids = null; this._alertKidsS = null; return }
            st.keep++; st.walked += n
        },
        // ---------------- IE 2026 09 18 / ODOO-… (заказ Игоря: именованные стили): стили ячеек — статистика и отбор ----------------
        // «показать на вкладке отчёта статистику по использованным стилям и отобрать стили — тем самым отфильтровать ячейки,
        // в которых они есть: как поиск, но не по тексту, а по именованным стилям». Ключ стиля — имя класса (именованный стиль
        // сегмента CSS-CLASS или класс фронта) либо «inline:<css>» (безымянный стиль — кандидат на выделение в именованный).
        // Каналы те же, что красит formatItem: строка (_DLRow, правила отчёта / строки), ячейка (_DLRow.cells, правила поля /
        // меры, cssClass-<binding>, MD). Отбор — чипс поиска с заголовком «style:<ключ>␟<ключ>» (apply_CHIPS / check_CHIPS)
        styleKey_inline(css) {
            const t = String(css || '').replace(/\s+/g, ' ').replace(/;\s*$/, '').trim()
            return t ? 'inline:' + t : ''
        },
        // Именованный (семантический) стиль в наборе классов делает прежний класс заливки и inline-градиент полосы его дублёрами:
        // в общей с боевым контуром базе правило несёт оба («stock-critical cell-background-red» — прежние фронты красят по второму),
        // в статистику и отбор идёт только именованный
        styleKeys_push(out, classes, css) {
            const list = []
            if (classes) {
                for (const n of (Array.isArray(classes) ? classes : String(classes).split(/\s+/))) {
                    for (const k of String(n || '').split(/\s+/)) if (k) list.push(k)
                }
            }
            let band = false
            for (let i = 0; i < list.length; i++) {
                const k = list[i]
                if (/^band-/.test(k)) band = true
                // прежний класс заливки сразу за именованным стилем своего цвета — дублёр из того же правила
                const m = /^cell-background-([\w-]+)$/.exec(k)   // IE 2026 10 01 / ODOO-5800: + cell-background-blue-strong
                if (m && i > 0 && (STYLE_RAW_TWINS[m[1]] || []).includes(list[i - 1])) continue
                if (!out.includes(k)) out.push(k)
            }
            if (css && !(band && /gradient/.test(css))) { const k = this.styleKey_inline(css); if (k && !out.includes(k)) out.push(k) }
        },
        // имена классов из заданий правил (attr.cf_rules) и строк — в реестр стилей: бэк без режима «весь реестр» отдаёт стиль только
        // по запросу id, а правила несут одни имена (у предопределённых стилей id = имя)
        styleNames_queue() {
            const rules = this.attr?.cf_rules
            if (!rules || this._styleNamesFor === rules) return
            this._styleNamesFor = rules
            const names = new Set()
            const take = (list) => { for (const t of list || []) for (const n of t?.cssClasses || []) if (n && !this.store.cssClass_info(n)) names.add(n) }
            take(rules.report)
            for (const k in rules.sets || {}) take(rules.sets[k])
            for (const k in rules.fields || {}) take(rules.fields[k])
            if (names.size) this.store.queue_cssClasses([...names])
        },
        // строчные каналы: all — на все ячейки строки; vo — «Values only» (ячейки данных — только со значением)
        styleKeys_row(dataItem) {
            const all = [], vo = []
            const d = dataItem?._DLRow
            if (d) {
                // класс строки и её стиль — одним набором: полоса с именованным стилем (band-po) и прежней inline-заливкой — один стиль
                this.styleKeys_push(all, [d.cssClass, ...(Array.isArray(d.cssClasses) ? d.cssClasses : [])].filter(Boolean), d.cssStyle)
                this.styleKeys_push(vo, d.cssClasses_vo, d.cssStyle_vo)
            }
            if (dataItem && this.attr.cf_rules) {
                const cf = this.cf_compute(dataItem, '', null)
                if (cf) { this.styleKeys_push(all, cf.cssClasses, cf.cssStyle); this.styleKeys_push(vo, cf.cssClassesVO, cf.cssStyleVO) }
            }
            if (dataItem?.MD?.rowStyle) this.styleKeys_push(all, null, dataItem.MD.rowStyle)
            return { all, vo }
        },
        // свои каналы ячейки (без строчных)
        styleKeys_cellOwn(dataItem, col_binding, attr_col) {
            const out = []
            if (!dataItem || !col_binding) return out
            if (this.cellBlank(dataItem, col_binding)) return out   // IE 2026 10 07 / ODOO-5800: у погашенной ячейки своих стилей нет (статистика и отбор по стилям читают то, что видно)
            const b = attr_col?.binding || col_binding
            if (dataItem[`cssClass-${b}`]) this.styleKeys_push(out, dataItem[`cssClass-${b}`], null)
            const c = dataItem._DLRow?.cells?.[col_binding]
            if (c) this.styleKeys_push(out, c.cssClasses, c.cssStyle)
            if ((this.attr.cf_rules || this.metricFill_state()) && attr_col?.binding) {   // IE 2026 09 20 / ODOO-5800: и заливка от метрик без правил оформления
                const cf = this.cf_compute(dataItem, col_binding, attr_col)
                if (cf) this.styleKeys_push(out, cf.cssClasses, cf.cssStyle)
            }
            const md = dataItem.MD
            if (md) {
                if (md.cssClass?.[col_binding]) this.styleKeys_push(out, md.cssClass[col_binding], null)
                if (md.cellsStyle?.[col_binding]) this.styleKeys_push(out, null, md.cellsStyle[col_binding])
            }
            return out
        },
        // R20 (fastEntry.dictIdsGuard): есть ли среди пришедших id значения ссылочной колонки. Множество значений колонки собирается
        // один раз на набор данных и живёт в cf_cache — сбрасывается вместе с ним при любой смене данных (select, правка, вставка)
        linkIds_uses(binding, came) {
            if (!this.flex || !binding) return true
            if (!this.cf_cache) this.cf_cache = new Map()
            const ck = '§linkids:' + binding
            let set = this.cf_cache.get(ck)
            if (!set) {
                set = new Set()
                for (const row of this.flex.rows) {
                    const d = row.dataItem
                    if (!d) continue
                    const v = this.store.get_value(d, binding)
                    if (v == null || v === '') continue
                    if (Array.isArray(v)) { for (const x of v) set.add(String(x && typeof x === 'object' ? (x.id ?? x.value) : x)) }
                    else set.add(String(typeof v === 'object' ? (v.id ?? v.value) : v))
                }
                this.cf_cache.set(ck, set)
            }
            for (const id of came) if (set.has(id)) return true
            return false
        },
        // все стили строки (строчные + всех её ячеек) — для отбора; живёт в cf_cache и сбрасывается вместе с ним
        styleKeys_rowSet(dataItem) {
            if (!dataItem || !this.flex) return null
            if (!dataItem._fe?.key) (dataItem._fe = dataItem._fe || {}).key = ++this.cache_index
            if (!this.cf_cache) this.cf_cache = new Map()
            const ck = '§styles:' + dataItem._fe.key
            let set = this.cf_cache.get(ck)
            if (set) return set
            set = new Set()
            const row = this.styleKeys_row(dataItem)
            for (const k of row.all) set.add(k)
            for (const k of row.vo) set.add(k)
            for (const col of this.flex.columns) {
                const attr_col = col.binding ? this.attr_by_binding[col.binding] : null
                if (!attr_col) continue
                for (const k of this.styleKeys_cellOwn(dataItem, col.binding, attr_col)) set.add(k)
            }
            this.cf_cache.set(ck, set)
            return set
        },
        // статистика стилей загруженных строк: порциями по 25 мс (большой отчёт не замораживает интерфейс).
        // done([{key, rows, cells, rowLevel, cols}]); progress(i, n)
        styleStats_compute(done, progress) {
            const flex = this.flex
            if (!flex?.rows) { done([]); return }
            const run = (this._styleStatsRun = (this._styleStatsRun || 0) + 1)
            const stats = new Map()
            const get = (k) => { let st = stats.get(k); if (!st) { st = { key: k, rows: 0, cells: 0, rowLevel: 0, cols: 0 }; stats.set(k, st) } return st }
            const cols = []
            for (const col of flex.columns) { const a = col.binding ? this.attr_by_binding[col.binding] : null; if (a) cols.push([col.binding, a]) }
            // статические стили колонок (не зависят от данных) — счётчик колонок
            for (const [, a] of cols) {
                const ks = []
                this.styleKeys_push(ks, a.cssClass, a.cssStyle)
                if (Array.isArray(a.cssClasses)) this.styleKeys_push(ks, this.store.resolve_cssClasses(a.cssClasses), null)
                for (const k of ks) get(k).cols++
            }
            let i = 0, rowsSeen = 0
            const n = flex.rows.length
            const step = () => {
                if (run !== this._styleStatsRun || !this.flex) return
                const t0 = performance.now()
                while (i < n && performance.now() - t0 < 25) {
                    const dataItem = flex.rows[i++].dataItem
                    if (!dataItem || dataItem._variant || dataItem._DLRow?.hide || dataItem._ogHide) continue
                    rowsSeen++
                    const seen = new Set()
                    const row = this.styleKeys_row(dataItem)
                    for (const k of row.all) { get(k).rowLevel++; seen.add(k) }
                    for (const k of row.vo) seen.add(k)
                    for (const [binding, a] of cols) {
                        for (const k of this.styleKeys_cellOwn(dataItem, binding, a)) { get(k).cells++; seen.add(k) }
                        if (row.vo.length && this.cf_isDataCol(a)) {
                            const v = this.store.get_value(dataItem, binding)
                            if (!(v == null || v === '')) for (const k of row.vo) get(k).cells++
                        }
                    }
                    for (const k of seen) get(k).rows++
                }
                if (progress) progress(i, n)
                if (i < n) setTimeout(step, 0)
                else done([...stats.values()], { rows: rowsSeen, cols: cols.length })
            }
            step()
        },
        // какие правила оформления дают стиль: ключ стиля → заголовки заданий правил (attr.cf_rules: отчёт, наборы строк, поля).
        // От данных не зависит — это «кто ссылается на стиль» в настройке виджета
        styleRules_map() {
            const map = new Map()
            const rules = this.attr?.cf_rules
            // IE 2026 09 18 / ODOO-… (именованные стили): у виджета с бэковым оформлением (params.conditional_format_backend) задания
            // правил на фронт не приходят — отметки уже лежат в _DLRow; правила читаем из записи самого виджета: все таблицы
            // conditional_format документа (отчёт / список, поля, строки раскладки), группы правил — через attrs
            if (!rules) {
                const doc = this.WIDGET?.record?.doc
                const names = (r) => {
                    const out = []
                    for (const row of r.cssClasses || []) if (row && row.use !== false && row.cssClass) out.push(String(row.cssClass))
                    if (typeof r.cssClass === 'string') for (const n of r.cssClass.split(/\s+/)) if (n && !out.includes(n)) out.push(n)
                    return out
                }
                const takeRules = (list) => {
                    for (const r of list || []) {
                        if (!r || typeof r !== 'object' || r.use === false) continue
                        const keys = []
                        this.styleKeys_push(keys, names(r), typeof r.style === 'string' ? r.style : '')
                        const title = String(r.title || '').trim()
                        if (title) for (const k of keys) { if (!map.has(k)) map.set(k, new Set()); map.get(k).add(title) }
                        if (Array.isArray(r.attrs)) takeRules(r.attrs)
                    }
                }
                let budget = 200000   // страховка от очень больших записей
                const walk = (n) => {
                    if (!n || typeof n !== 'object' || --budget < 0) return
                    if (Array.isArray(n)) { for (const v of n) walk(v); return }
                    for (const k in n) {
                        if (k === 'conditional_format' && Array.isArray(n[k])) takeRules(n[k])
                        else if (k !== 'data' && k !== '_doc') walk(n[k])
                    }
                }
                try { walk(doc) } catch (e) { /* запись без правил */ }
                return map
            }
            // IE 2026 09 23 / ODOO-341407: i18n (в цикле t — правило, словарь — this.t)
            const take = (list, scope) => {
                for (const t of list || []) {
                    const keys = []
                    this.styleKeys_push(keys, t?.cssClasses, t?.cssStyle)
                    const title = String(t?.title || '').trim() || scope   // IE 2026 09 23 / ODOO-341407: ревью i18n — подпись области целой фразой (не «{scope} rule» из двух переводов)
                    for (const k of keys) { if (!map.has(k)) map.set(k, new Set()); map.get(k).add(title) }
                }
            }
            take(rules.report, t('Report rule'))   // IE 2026 09 23 / ODOO-341407: ревью i18n
            for (const k in rules.sets || {}) take(rules.sets[k], t('Row rule'))   // IE 2026 09 23 / ODOO-341407: ревью i18n
            for (const k in rules.fields || {}) take(rules.fields[k], t('Field rule'))   // IE 2026 09 23 / ODOO-341407: ревью i18n
            return map
        },
        // образец стиля для списка: вид скрытого элемента с этим классом ВНУТРИ хоста грида (правила классов зависят от гаммы)
        styleSample_css(key) {
            if (!this._styleSample) this._styleSample = new Map()
            if (this._styleSample.has(key)) return this._styleSample.get(key)
            let css = ''
            try {
                const host = this.flex?.hostElement || document.body
                const el = document.createElement('div')
                el.style.cssText = 'position:absolute;left:-10000px;top:-10000px;width:40px;height:16px;pointer-events:none'
                if (key.startsWith('inline:')) { el.className = 'wj-cell'; el.style.cssText += ';' + key.slice(7) }
                else el.className = 'wj-cell ' + key
                host.appendChild(el)
                const cs = getComputedStyle(el), base = getComputedStyle(host)
                const parts = []
                if (cs.backgroundImage && cs.backgroundImage !== 'none') parts.push(`background-image:${cs.backgroundImage}`)
                if (cs.backgroundColor && cs.backgroundColor !== 'rgba(0, 0, 0, 0)') parts.push(`background-color:${cs.backgroundColor}`)
                if (cs.color) parts.push(`color:${cs.color}`)
                if (cs.fontWeight && cs.fontWeight !== base.fontWeight) parts.push(`font-weight:${cs.fontWeight}`)
                if (cs.fontStyle && cs.fontStyle !== 'normal') parts.push(`font-style:${cs.fontStyle}`)
                if (cs.textDecorationLine && cs.textDecorationLine !== 'none') parts.push(`text-decoration:${cs.textDecorationLine}`)
                for (const side of ['Top', 'Right', 'Bottom', 'Left']) {
                    const w = parseFloat(cs[`border${side}Width`]) || 0
                    if (w > 1 || (w && side !== 'Bottom')) parts.push(`border-${side.toLowerCase()}:${cs[`border${side}Width`]} ${cs[`border${side}Style`]} ${cs[`border${side}Color`]}`)
                }
                host.removeChild(el)
                css = parts.join(';')
            } catch (e) { css = '' }
            this._styleSample.set(key, css)
            return css
        },
        // ---- отбор по стилям: чипс поиска «style:…» ----
        styleFilter_parse(title) {
            const t = String(title || '')
            return t.startsWith('style:') ? t.slice(6).split('␟').map(x => x.trim()).filter(Boolean) : []
        },
        styleFilter_chip() {
            return (this.CHIPS || []).find(c => c.segment === 'CHIP-Search' && String(c.title || '').startsWith('style:')) || null
        },
        styleFilter_keys() {
            const chip = this.styleFilter_chip()
            return chip && chip.meta?.use !== false ? this.styleFilter_parse(chip.title) : []
        },
        styleFilter_titleHTML(keys) {
            const esc = (x) => this.store.escapeHtml(String(x))
            const one = (k) => {
                const info = k.startsWith('inline:') ? null : this.store.cssClass_info(k)
                const title = info?.title || (k.startsWith('inline:') ? k.slice(7) : k)
                const css = this.styleSample_css(k).replace(/"/g, '&quot;')
                return `<span style="display:inline-block;width:9px;height:9px;border-radius:2px;margin:0 3px 0 5px;vertical-align:-1px;box-shadow:0 0 0 1px rgba(0,0,0,.18);${css}"></span>${esc(title.length > 28 ? title.slice(0, 27) + '…' : title)}`
            }
            return t('Styles:') + keys.slice(0, 3).map(one).join(',') + (keys.length > 3 ? ` +${keys.length - 3}` : '')   // IE 2026 09 23 / ODOO-341407: i18n
        },
        styleFilter_set(keys) {
            keys = [...new Set((keys || []).filter(Boolean))]
            const chipsVue = this.$refs.chips
            const list = chipsVue ? chipsVue.chipsRaw : this.CHIPS
            const isStyle = (c) => c && c.segment === 'CHIP-Search' && String(c.title || '').startsWith('style:')
            const idx = (list || []).findIndex(isStyle)
            if (!keys.length) {
                if (idx < 0) return
                list.splice(idx, 1)
            } else {
                const title = 'style:' + keys.join('␟')
                const meta = { use: true, pi: 'pi-palette', titleHTML: this.styleFilter_titleHTML(keys) }
                if (idx >= 0) { list[idx].title = title; list[idx].meta = { ...(list[idx].meta || {}), ...meta } }
                else list.push({ segment: 'CHIP-Search', title, meta })
            }
            if (chipsVue) chipsVue.emitChips()
            else { this.CHIPS = [...list]; this.apply_CHIPS() }
        },
        styleFilter_toggle(key, exclusive = false) {
            const cur = this.styleFilter_keys()
            const has = cur.includes(key)
            this.styleFilter_set(exclusive ? (has && cur.length === 1 ? [] : [key]) : (has ? cur.filter(k => k !== key) : [...cur, key]))
        },
        // IE 2026 09 18 / ODOO-…: есть ли на ячейке именованный стиль реестра CSS-CLASS с фоном (в основном виде либо в варианте
        // по цветовой схеме). Ответ по имени класса кэшируется до смены реестра; выключатель fe.ux.gridRuleFillOverHeat
        ruleFill_overHeat(e_cell) {
            if (this._ruleFillOn === undefined) this._ruleFillOn = this.store.setting('fe.ux.gridRuleFillOverHeat', true) !== false
            if (!this._ruleFillOn) return false
            return this.styleFill_has(e_cell)
        },
        // IE 2026 09 22 / ODOO-5800 (замечание Игоря «Stock state»): пилюля оценки (GRADE) — только без своей заливки ячейки. Выключатель
        // fe.ux.gradePlainOnFill (дефолт ВКЛ; выкл — пилюля и на заливке, как 18.09)
        gradeChip_plainOnFill(attr_col) {
            if (String(attr_col?.relation_segment || '') !== 'GRADE') return false
            if (this._gradePlainOn === undefined) this._gradePlainOn = this.store.setting('fe.ux.gradePlainOnFill', true) !== false
            return this._gradePlainOn
        },
        // есть ли у ячейки заливка: inline (правило / метрики / тепловая), прежний класс cell-background-*, именованный стиль реестра с фоном
        cellFill_has(e_cell, e_style) {
            if (e_style && (e_style.backgroundColor || e_style.background)) return true
            for (const n of e_cell.classList) if (n.startsWith('cell-background')) return true
            return this.styleFill_has(e_cell)
        },
        // пилюля → обычный текст того же значения на месте пилюли (в ячейке дерева — после значка свёртки); класс grade-plain уходит в кэш
        // className ячейки — кэш-путь (applyStatusChip) пилюлю не восстанавливает
        gradeChip_flatten(e_cell, e_style) {
            if (!this.cellFill_has(e_cell, e_style)) return false
            const chip = e_cell.querySelector('.status-chip')
            if (chip) chip.replaceWith(document.createTextNode(chip.textContent || ''))
            wjcCore.removeClass(e_cell, 'has-status-chip')
            wjcCore.addClass(e_cell, 'grade-plain')
            return true
        },
        styleFill_has(e_cell) {
            const byName = this.store.cssClassesByName
            if (!byName) return false
            for (const n of e_cell.classList) {
                if (n.charCodeAt(0) === 119 && n.startsWith('wj-')) continue
                if (this.styleName_hasFill(n, byName)) return true
            }
            return false
        },
        // именованный стиль реестра с фоном? (кэш по имени; IE 2026 09 23 — вынесено из styleFill_has для chipFill_strip)
        styleName_hasFill(n, byName) {
            const cache = this._ruleFillCache || (this._ruleFillCache = new Map())
            let has = cache.get(n)
            if (has === undefined) {
                const info = byName ? byName[n] : null
                has = !!info && (/background/i.test(String(info.styles || '')) || (info.schemes || []).some(v => v && v.use !== false && /background/i.test(String(v.styles || ''))))
                cache.set(n, has)
            }
            return has
        },
        // IE 2026 09 23 / ODOO-5800: строка классов хука без заливок (cell-background-* и именованные стили реестра с фоном) — для ячеек с пилюлей
        chipFill_strip(css) {
            const byName = this.store.cssClassesByName
            const out = String(css).split(/\s+/).filter(n => n && !n.startsWith('cell-background-') && !this.styleName_hasFill(n, byName))
            return out.join(' ')
        },
        chipDropsHookFill() {
            if (this._chipDropsHookFill === undefined) this._chipDropsHookFill = this.store.setting('fe.ux.chipDropsHookFill', true) !== false
            return this._chipDropsHookFill
        },
        // ---- IE 2026 09 18 / ODOO-5800 (заказ Игоря «чипс-метрик»): чипс метрик списка (CHIP-Metric) ----
        metricChip_on() {
            if (this._metricChipOn === undefined) this._metricChipOn = this.store.setting('fe.ux.metricChip', true) !== false
            return this._metricChipOn
        },
        // счётчик совпадений и остановки ‹ › чипса метрик: остановка — видимая строка с отметкой отобранного правила
        metricNav_recompute() {
            const flex = this.flex
            let chips = (this.CHIPS || []).filter(c => c.segment === 'CHIP-Metric' && c.meta?.use !== false)
            const _mir = this.metricMirror_chip()   // IE 2026 09 19 / ODOO-5800 (заказ Игоря «глобальный чипс-метрик»: приём чипса отчётом): зеркало — когда своего действующего чипса нет
            if (_mir) chips = [_mir]
            if (!flex?.hostElement || !chips.length) {
                this._gridNavMetric = null
                // IE 2026 10 05 / ODOO-5800 (fe-86) (наблюдение бота на бандле fe-85, dev02_check33: чипс сняли ⊗ — рамка «текущей остановки» оставалась в таблице до новой постановки чипса):
                // чипса метрик больше нет — рамка его обхода снимается (metricHit_apply без списка остановок только убирает классы). Рамку обхода чипса оформления
                // (_hitNavKind = 'format') ведёт он сам. Выключатель fe.ux.metricNavFrameClear (false — как было: рамка до следующего чипса)
                if (flex?.hostElement && this._hitNavKind !== 'format' && (this._metricHitCur || this._metricHitOn) && this.store.setting('fe.ux.metricNavFrameClear', true) !== false) { this._metricHitCur = null; this.metricHit_schedule() }   // IE 2026 10 05 / ODOO-5800
                return
            }
            const chip = chips[0], doc = chip.doc
            const list = []
            let _more = null   // IE 2026 10 05 / ODOO-5800 (fe-86): { count, options } — ячейки сигнала в строках выключенных опций
            let _moreSkip = 'off'   // IE 2026 10 05 / ODOO-5800 (fe-86): почему хвост не считался ('' — посчитан точно); 'off' — выключатель снят либо чипс пуст
            if (this.metricChip_on() && !metricChip_isEmpty(doc)) {
                // проверка отметок строки дешёвая — считаем ВСЕ строки (предел searchNavMaxRows нужен текстовому поиску);
                // колонка остановки (c: null) вычисляется при самом переходе — metricNav_col по колонкам для тысяч строк дорог
                // IE 2026 09 20 / ODOO-5800 (Igor: переходы чипса метрик по ячейкам, подсветка параметра ячейки и подпадающих ячеек по наведению на чипс):
                // остановки — ЯЧЕЙКИ строки, подпадающие под чипс (metricNav_cellsOfRow); строка с отметкой без такой ячейки (правило на строку, отметка
                // из строк данных) — одна остановка «вся строка». У грида с фронтовым оформлением ячейки считаются по заданиям — для первых
                // fe.data.metricCellNavMaxRows строк с отметками (1500), остальные остаются остановками-строками (колонка — лениво, как раньше)
                const cellNav = this.metricCellNav_on()
                let budget = cellNav ? this.store.setting('fe.data.metricCellNavMaxRows', 1500) : 0
                // IE 2026 09 21 / ODOO-5800 (Igor, скрин счётчика 3/3 над чипсом метрик: «это один кейс и ещё две итоговых ячейки, в которые он попал "агрегированием"; я ожидаю, что
                // буду видеть статистику и навигацию по самым детальным ячейкам, которые выведены в отчёте, без их агрегации»): остановка у строки-ГРУППЫ снимается, когда такая же
                // остановка (та же колонка) есть у строки НИЖЕ неё по дереву — ячейка группы лишь агрегат детальных ячеек; остановка «вся строка» группы — когда ниже есть любая
                // остановка. Группа без остановок ниже (собственная метрика группы, детальные строки скрыты отбором) остаётся. Отметки строк не трогаем: отбор и подсветка
                // групп — как раньше. Выключатель fe.ux.metricNavDetailed (false — прежний счёт). Статистику словаря (вкладка Metrics, списки формы чипса) так же считает бэк
                const detailed = this.store.setting('fe.ux.metricNavDetailed', true) !== false
                // IE 2026 10 05 / ODOO-5800 (fe-82) (Igor 05.10: «ожидал, что чипс селектора будет иметь переход и ходить по … ячейкам»): счёт остановок — чистая функция
                // utils/metricChip.metricNav_stops (юнит-тест metricNavStops); memo-строка («Покриття запасу») с унаследованными от родителя отметками ключей ячеек остановкой
                // не служит — своей ячейки сигнала у неё нет (решение 03.10, metricFill_idsAt), переход вёл в колонку object. Выключатель fe.ux.metricNavMemoSkip
                const _mst = (this.memoRows_on() && this.store.setting('fe.ux.metricNavMemoSkip', true) !== false) ? this.metricFill_state() : null   // IE 2026 10 05 / ODOO-5800
                const _rows = flex.rows   // IE 2026 10 05 / ODOO-5800
                // IE 2026 10 05 / ODOO-5800 (fe-86) (решение Игоря 05.10 20:48 UTC по замеру selector_nav2 — строка грида сигналов «Підтверджений документ у минулому · Минуле»: «Комірок» 2,
                // чипс «1/1»: «Показывать «1/1» с подсказкой «ещё 1 в выключенной опции». Счёт честный, вид отчёта не меняется сам»): вторая ячейка сигнала лежит в строках
                // выключенной опции «ЗП 2» — бэк их строит и считает (precache), фронт прячет (_ogHide), обход идёт только по видимым строкам. Остановки считаются второй раз,
                // со строками выключенных опций как с показанными: разница — сколько ячеек прибавит включение опций (utils/metricChip.metricNav_optionGain; хвост «+N» счётчика и
                // строка его подсказки — AttrChips). Чипс ничего не включает и строк не показывает. Второй проход — только когда такие строки есть; ячейки строки считаются
                // один раз (_cellsOf: первый проход прежний, предел fe.data.metricCellNavMaxRows тратится как раньше). Счёт ведётся, только когда он точен: предел не исчерпан
                // и строки не прячет ничто, кроме чипса метрик, «глаза» и самих опций (metricNavHidden_exact). Выключатель fe.ux.metricNavHiddenHint (false — как было)
                const _hh = this.store.setting('fe.ux.metricNavHiddenHint', true) !== false   // IE 2026 10 05 / ODOO-5800
                const _cellsOf = _hh ? new Map() : null   // IE 2026 10 05 / ODOO-5800
                let _ogAny = false   // IE 2026 10 05 / ODOO-5800: есть строки, спрятанные выключенной опцией
                const _api = {   // IE 2026 10 05 / ODOO-5800
                    level: (r) => _rows[r].level,
                    live: (r) => { const d = _rows[r].dataItem; if (_hh && d && d._ogHide) _ogAny = true; return !!d && _rows[r].visible !== false },   // IE 2026 10 05 / ODOO-5800: + _ogAny
                    match: (r) => metricChip_matchRow(_rows[r].dataItem, doc),
                    skip: _mst ? (r) => metricNav_memoInherited(_rows[r].dataItem, doc, (k) => _mst.byKey.has(k)) : null,
                    cells: (r) => {   // IE 2026 10 05 / ODOO-5800: правило прежнее, результат запоминается на второй проход
                        if (_cellsOf && _cellsOf.has(r)) return _cellsOf.get(r)
                        const v = (cellNav && (_rows[r].dataItem._DLRow?.metric_cells_map || budget-- > 0)) ? this.metricNav_cellsOfRow(_rows[r].dataItem, doc) : null
                        if (_cellsOf) _cellsOf.set(r, v)
                        return v
                    },
                }
                for (const x of metricNav_stops(_rows.length, _api, detailed)) list.push(x)   // IE 2026 10 05 / ODOO-5800
                // IE 2026 10 05 / ODOO-5800 (fe-86, доработка по ревью): хвост считается по модели прохода видимости строк (utils/metricChip.metricNav_optionGain →
                // metricNav_rowsVisible — цикл apply_CHIPS как чистая функция): что покажет ПОЛНЫЙ проход после включения выключенных опций, включая оживление предков
                // показанной строки (находка ревью: пустая под «глазом» строка опции со своей ячейкой сигнала давала «0 +1», а после включения опции — «2») и показ
                // потомков показанной строки при «Show rows without matches». Счёт показывается, только когда он точен; причина отказа — в _gridNavMetric.moreSkip:
                // 'none' — строк, спрятанных опциями, нет; 'budget' — исчерпан предел ячеек либо строк больше fe.data.metricNavHiddenMaxRows (нестрогий отбор под
                // «глазом» требует пустоты каждой строки); 'chips' — чипсов метрик несколько; 'other' — строки прячет ещё и другой чипс таблицы, фильтр колонок либо
                // грид не дерево отчёта; 'inexact' — есть выключенные строки use, модель не воспроизвела действующую видимость строк либо кнопки опций (быстрый
                // проход apply_CHIPS) дали бы другие остановки, чем полный проход; '' — счёт точен
                if (_hh) {   // IE 2026 10 05 / ODOO-5800
                    if (!_ogAny) _moreSkip = 'none'
                    else if (budget < 0) _moreSkip = 'budget'
                    else if (chips.length !== 1) _moreSkip = 'chips'
                    else if (!this.metricNavHidden_exact() || !this.attr?.childItemsPath || this.attr?.attr_type === 'AttrTabGrid' || flex.itemsSource?.groupDescriptions?.length) _moreSkip = 'other'
                    else {
                        const _hideEmpty = !!this._hide_empty(), _chipHides = !(chip._raw || chip).showAllLines
                        const _strict = _chipHides && this.store.setting('fe.ux.metricChipStrictTree', true) !== false
                        if (!_strict && _hideEmpty && _rows.length > this.store.setting('fe.data.metricNavHiddenMaxRows', 5000)) _moreSkip = 'budget'
                        else if (_hideEmpty && _rows.some(row => row.dataItem && row.dataItem.use === false)) _moreSkip = 'inexact'   // выключенная строка use прячет своё поддерево — в модель не входит
                        else {
                            const _emptyOf = new Map()
                            const _g = metricNav_optionGain(_rows.length, _api, {
                                chips: _chipHides || _hideEmpty, strict: _strict,
                                data: (r) => !!_rows[r].dataItem,
                                off: (r) => { const d = _rows[r].dataItem; return d._ogHide ? (this.optionGroup_of(d) || ' ') : '' },
                                layoutHide: (r) => !!_rows[r].dataItem._DLRow?.hide,
                                pass: (r) => !_rows[r].dataItem._variant && (!_chipHides || _api.match(r)),   // compare-подстроку проход не оценивает; прячущий чипс метрик пропускает строки с отметкой
                                empty: (r) => { if (!_hideEmpty) return false; let v = _emptyOf.get(r); if (v === undefined) { v = !!this.isEmpty(_rows[r].dataItem, this.columns()); _emptyOf.set(r, v) } return v },
                                band: (r) => _rows[r].dataItem._DLRow?.row_type === 'tabrow',
                            }, list, detailed)
                            _moreSkip = budget < 0 ? 'budget' : (_g.exact ? '' : 'inexact')
                            if (!_moreSkip && _g.count > 0) {
                                const names = []
                                for (const id of _g.options) { const t0 = this.optionGroup_caption(id); if (t0 && !names.includes(t0)) names.push(t0) }
                                _more = { count: _g.count, options: names }
                            }
                        }
                    }
                }
            }
            // IE 2026 10 05 / ODOO-5800 (fe-88) (замер ботом dev02 fe-84, handoff-tools/2026-10-05/selector_nav2: после флажка Selector строки грида сигналов счётчик «1/5»,
            // первый клик › — сразу «2/5», первая остановка показывалась только после полного круга): позиция обхода — utils/metricChip.metricNav_carry (юнит-тест
            // metricNavFirstStop). До первого перехода обход «не начат» (started = false): счётчик показывает только число остановок (matchIndex = -1), первый клик ›
            // ведёт на первую остановку, ‹ — на последнюю (onChipSearchNav). После пересчёта позиция идёт за ячейкой обхода, а не за её номером (замер: к отбору на «3/5»
            // добавили вторую строку Selector — «3/6» при выделенной четвёртой остановке). Сам чипс ячейку не выделяет: пересчёт идёт после любого отбора, грид отчёта в этот
            // момент бывает на скрытой вкладке, а выделение ячейки двигает чипс периода стола. Выключатель fe.ux.metricNavFirstStop (false — прежнее: «1/N» сразу)
            const _sig = metricChip_sig(doc)   // IE 2026 10 05 / ODOO-5800
            const _pos = metricNav_carry(this._gridNavMetric, _sig, list, this.store.setting('fe.ux.metricNavFirstStop', true) !== false)   // IE 2026 10 05 / ODOO-5800
            const idx = _pos.index   // IE 2026 10 05 / ODOO-5800
            this._gridNavMetric = { list, index: idx, started: _pos.started, sig: _sig, cells: this.metricCellNav_on(), cellSet: new Set(list.filter(x => x.c != null && !x.whole).map(x => x.r + ':' + x.c)), moreSkip: _moreSkip }   // IE 2026 10 05 / ODOO-5800: + started, sig; + moreSkip (fe-86)
            if (this._hitNavKind !== 'format') {   // IE 2026 09 20 / ODOO-5800: подсветка попаданий общая у чипса метрик и чипса оформления — её ведёт тот, чей чипс наведён / чья остановка выбрана
                // IE 2026 10 05 / ODOO-5800 (fe-88): обход не начат (чипс поставлен заново, отбор сменился) — подсветка «текущей остановки» прежнего обхода снимается
                // (замер: чипс сняли и поставили заново — счётчик «1/5», а текущей оставалась подсвечена ячейка прежней третьей остановки)
                if (this._metricHitCur && (!_pos.started || !this._gridNavMetric.cellSet.has(this._metricHitCur.r + ':' + this._metricHitCur.c))) this._metricHitCur = null   // IE 2026 10 05 / ODOO-5800
                if (this._metricHitAll || this._metricHitCur || this._metricHitOn) this.metricHit_schedule()
            }
            for (const c of chips) { c.matchCount = metricChip_isEmpty(c.doc) ? null : list.length; c.matchIndex = list.length ? (_pos.started ? idx : -1) : 0 }   // IE 2026 10 05 / ODOO-5800: -1 — обход не начат, счётчик без номера (AttrChips.chipMatch_text)
            // IE 2026 10 05 / ODOO-5800 (fe-86): хвост «+N» счётчика и опции для его подсказки (AttrChips.chipMore_text / chipMore_vars). Чипс живёт в записи виджета (viewParams) —
            // поля ставятся, только когда спрятанные ячейки есть, и снимаются, когда их нет; список опций заменяется, только если сменился (без лишних срабатываний реактивности)
            for (const c of chips) {   // IE 2026 10 05 / ODOO-5800
                const n = (_more && !metricChip_isEmpty(c.doc)) ? _more.count : 0
                if (!n) { if (c.matchMore !== undefined) delete c.matchMore; if (c.matchMoreIn !== undefined) delete c.matchMoreIn; continue }
                if (c.matchMore !== n) c.matchMore = n
                if (!Array.isArray(c.matchMoreIn) || c.matchMoreIn.join('\u241F') !== _more.options.join('\u241F')) c.matchMoreIn = _more.options.slice()
            }
            this.$refs.chips?.$forceUpdate()
        },
        // IE 2026 10 05 / ODOO-5800 (fe-86): счёт ячеек в строках выключенных опций точен, когда строки прячут только чипс метрик, «глаз» пустых строк и сами опции: другой прячущий
        // чипс таблицы (поиск, условие, стиль, оформление — отметка apply_CHIPS) либо фильтр колонок мог бы спрятать эти строки и после включения опции
        metricNavHidden_exact() { return !this._hideChipsOther && !this.treeFilter_isActive() },
        // ---- IE 2026 09 20 / ODOO-5800 (Igor: переходы чипса метрик по ячейкам, подсветка параметра ячейки и подпадающих ячеек по наведению на чипс) ----
        // Слова Игоря: «при переходах в чипсе-метрик - я ожидаю что будут переходы по ячейкам; также будет выделен параметр ячейки»; «при наведении на
        // чипсе-метрик - выделять все видимые ячейки подпадающие под чипс поиска - как вариант выделяя параметр ячеек». Выключатель fe.ux.metricChipCellNav
        metricCellNav_on() {
            if (this._metricCellNavOn === undefined) this._metricCellNavOn = this.store.metricSelector_on() && this.store.setting('fe.ux.metricChipCellNav', true) !== false
            return this._metricCellNavOn
        },
        metricNav_colIndex(binding) {
            const cols = this.flex.columns
            if (!this._metricColIdx || this._metricColIdxFor !== cols || this._metricColIdxN !== cols.length) {
                this._metricColIdx = new Map(); this._metricColIdxFor = cols; this._metricColIdxN = cols.length
                for (let c = 0; c < cols.length; c++) if (cols[c].binding) this._metricColIdx.set(cols[c].binding, c)
            }
            const c = this._metricColIdx.get(binding)
            return c === undefined ? -1 : c
        },
        // ячейки строки, подпадающие под отбор чипса: оформление на бэке — точная карта бэка _DLRow.metric_cells_map = {binding: [ключи]} ('' — вся
        // строка, остановкой-ячейкой не служит); оформление на фронте — сработавшие на ячейке задания с metric_key (ключ ячейки = основа + горизонт).
        // Скрытое оформление (Use выключен) остановке не мешает: правило по-прежнему срабатывает
        metricNav_cellsOfRow(dataItem, doc) {
            const flex = this.flex, out = []
            const map = dataItem?._DLRow?.metric_cells_map
            if (map && typeof map === 'object') {
                for (const b of Object.keys(map)) {
                    if (!b || !(map[b] || []).some(k => metricChip_matchKey(k, doc))) continue
                    const c = this.metricNav_colIndex(b)
                    if (c >= 0 && flex.columns[c].isVisible) out.push(c)
                }
                return out.sort((x, y) => x - y)
            }
            if (!this.attr?.cf_rules && !this.metricFill_state()) return out   // IE 2026 09 20 / ODOO-5800: ячейки метрик из таблицы деталей есть и без правил оформления
            for (let c = 0; c < flex.columns.length; c++) {
                const col = flex.columns[c], attr_col = col.binding ? this.attr_by_binding[col.binding] : null
                if (!attr_col || !col.isVisible) continue
                const applied = []
                this.cf_compute(dataItem, col.binding, attr_col, applied)
                if (applied.some(t => t.metric_key && metricChip_matchKey(this.metricCell_key(t, dataItem, col.binding), doc))) out.push(c)
            }
            return out
        },
        onChipMetricHover(e) {
            const on = !!(e && e.on) && this.metricCellNav_on()
            const kind = (e && e.segment === 'CHIP-Format') ? 'format' : 'metric'   // IE 2026 09 20 / ODOO-5800: наведён чипс условного оформления
            if (on === !!this._metricHitAll && (!on || kind === this._hitNavKind)) return
            if (on) { if (kind !== this._hitNavKind) this._metricHitCur = null; this._hitNavKind = kind }
            this._metricHitAll = on
            this.metricHit_schedule()
        },
        metricHit_schedule() {
            if (this.flex && this._metricHitFlex !== this.flex) {   // выделение ушло с остановки — её подсветка снимается; обработчик — на текущем экземпляре грида
                this._metricHitSelH = this._metricHitSelH || (() => { if (this._metricHitCur) this.metricHit_schedule() })
                try { this.flex.selectionChanged.addHandler(this._metricHitSelH) } catch (e) { /* грид разрушен */ }
                this._metricHitFlex = this.flex
            }
            // ждущий таймер НЕ перезапускаем: планирование зовётся из отрисовки каждой ячейки, и при частых перерисовках перезапуск откладывал бы
            // применение бесконечно (находка пробы: подсветка остановки не снималась); состояние читается в момент срабатывания
            this._metricHitCalls = (this._metricHitCalls || 0) + 1
            if (this._metricHitT) return
            this._metricHitT = setTimeout(() => { this._metricHitT = null; try { this.metricHit_apply() } catch (e) { /* грид разрушен */ } }, 40)
        },
        // значение ячейки — «параметр», который видит пользователь: текст ячейки без служебных узлов (стрелка разрыва, кнопки, значок свёртки)
        metricHit_textRange(cell) {
            if (this.hlSkipHidden_on() && cellMatch_hiddenText(cell)) return null   // IE 2026 09 20 / ODOO-5828: спрятанный ноль — как ячейка без значения: рамка ячейки, а не подсветка невидимого текста
            const walker = document.createTreeWalker(cell, NodeFilter.SHOW_TEXT, null)
            let n, first = null, last = null
            while ((n = walker.nextNode())) {
                if (!(n.nodeValue || '').trim()) continue
                const pe = n.parentElement
                if (pe && pe.closest('.break-arrow, .cell-dropdown-toggle, .wj-elem-collapse, .row-header, button')) continue
                if (!first) first = n
                last = n
            }
            if (!first) return null
            const r = document.createRange()
            try { r.setStart(first, 0); r.setEnd(last, (last.nodeValue || '').length) } catch (e) { return null }
            return r
        },
        // подсветка по ОТРИСОВАННЫМ ячейкам: все подпадающие (курсор над чипсом) и текущая остановка ‹ › (пока выделение стоит на ней)
        metricHit_apply() {
            const flex = this.flex, host = flex?.hostElement
            const all = [], cur = []
            const nav = this._hitNavKind === 'format' ? this._gridNavFormat : this._gridNavMetric   // IE 2026 09 20 / ODOO-5800: чипс условного оформления ходит по своему списку
            let curCell = this._metricHitCur
            if (curCell) { const sel = flex?.selection; if (!sel || sel.row !== curCell.r || sel.col !== curCell.c) curCell = this._metricHitCur = null }   // выделение ушло с остановки
            let marked = 0
            const _hitBorder = this.store.setting('fe.ux.metricHitBorder', true) !== false
            if (host && ((nav?.cells && (this._metricHitAll || curCell)) || this._metricHitOn)) {
                const live = !!nav?.cells && (this._metricHitAll || !!curCell)
                for (const cell of this.sameValue_cells(host)) {
                    // рамка ячейки без значения (метрика «поле не заполнено» метит ПУСТЫЕ ячейки — текста для подсветки нет): снять прежнюю, ниже поставить заново
                    if (cell.classList.contains('metric-hit-cell')) cell.classList.remove('metric-hit-cell')
                    if (cell.classList.contains('metric-hit-cur-cell')) cell.classList.remove('metric-hit-cur-cell')
                    if (!live) continue
                    const cr = cell.getBoundingClientRect()
                    if (cr.width < 2 || cr.height < 2) continue
                    // строка / колонка отрисованной ячейки: метка formatItem (data_cell); hitTest — запасной путь (у ячейки на нижней кромке видимой
                    // области он возвращает -1 — находка пробы: первая остановка после прокрутки оставалась без подсветки)
                    const dc = cell.data_cell
                    let hr = (dc && Number.isInteger(dc.row) && Number.isInteger(dc.col)) ? dc.row : -1, hc = hr >= 0 ? dc.col : -1
                    if (hr < 0) {
                        let ht = null
                        try { ht = flex.hitTest(cr.left + Math.min(6, cr.width / 2), cr.top + cr.height / 2) } catch (e) { ht = null }
                        if (!ht || ht.panel !== flex.cells) continue
                        hr = ht.row; hc = ht.col
                    }
                    const isCur = !!curCell && curCell.r === hr && curCell.c === hc
                    if (!isCur && !(this._metricHitAll && nav.cellSet.has(hr + ':' + hc))) continue
                    // IE 2026 09 20 / ODOO-5800 (Igor 20.09: «при наведении на чипс-метрик, чипс-условного оформления я ожидал, что выделятся бордюры соответствующих
                    // ячеек, а не текст внутри них»): подпадающая ячейка и текущая остановка ‹ › выделяются РАМКОЙ ячейки (классы metric-hit-cell /
                    // metric-hit-cur-cell — раньше только у ячеек без значения); прежняя подсветка текста — выключателем fe.ux.metricHitBorder = false
                    const r = _hitBorder ? null : this.metricHit_textRange(cell)
                    if (!r) { cell.classList.add(isCur ? 'metric-hit-cur-cell' : 'metric-hit-cell'); marked++; continue }
                    if (isCur) cur.push(r); else if (all.length < 1200) all.push(r)
                }
            }
            this._metricHitOn = all.length > 0 || cur.length > 0 || marked > 0
            metricHit_ranges(this.sameValue_busKey() + ':' + (this.attr?.html_id || this.attr?.name || ''), all, cur)
        },
        // колонка остановки: первая видимая ячейка строки, несущая класс отобранного правила (иначе первая видимая колонка)
        metricNav_col(dataItem, doc, c0) {
            const want = this.metricCss_forRow(dataItem, doc)
            if (!want.size) return c0
            const flex = this.flex
            for (let c = 0; c < flex.columns.length; c++) {
                const col = flex.columns[c], attr_col = col.binding ? this.attr_by_binding[col.binding] : null
                if (!attr_col || !col.isVisible) continue
                const own = this.styleKeys_cellOwn(dataItem, col.binding, attr_col)
                if (own.length && this.metricCell_hit(dataItem, col.binding, own, doc)) return c   // IE 2026 09 19 / ODOO-5800 (Igor: измерение horizon в ключе метрики): ячейка отобранного правила и его горизонта
            }
            return c0
        },
        // классы правил, под которые строка попала по отбору чипса (из словаря attr.metric_rules: css правила)
        metricCss_forRow(dataItem, doc) {
            if (!this._metricCssByKey || this._metricCssFor !== this.attr?.metric_rules) {
                this._metricCssFor = this.attr?.metric_rules
                this._metricCssByKey = new Map()
                for (const e of this.attr?.metric_rules || []) this._metricCssByKey.set(e.key, String(e.css || '').split(/\s+/).filter(Boolean))
            }
            const out = new Set()
            for (const k of metricChip_matchedKeys(dataItem?._DLRow?.metrics, doc)) for (const n of this._metricCssByKey.get(k) || []) out.add(n)
            return out
        },
        // ---- IE 2026 09 19 / ODOO-5800 (Igor: измерение horizon в ключе метрики) ----
        // Слова Игоря 19.09: «grade|metric|reason — нужно добавить измерение — grade|metric|reason|horizon — как в таблицу статистики, так и в
        // чипс-метрик и дропдаун форму». Бэк ie-dm7 (be-ie c58323347) на запрос с client.metric_horizon отдаёт ключи из четырёх частей: словарь
        // attr.metric_rules (+ horizon / horizon_title / horizon_order), отметки строк _DLRow.metrics, строки статистики. Задание оформления
        // по-прежнему несёт metric_key из ТРЁХ частей (основа); горизонт ЯЧЕЙКИ фронт собирает так же, как бэк (dl2.metric_marks_dl2):
        //   1) job.metric_horizon — горизонт задан в самом правиле (колонка Horizon группы Metric грида правил);
        //   2) задание строки / поля (kind row / cell) без своего горизонта — 'all' (метрика применима ко всем горизонтам);
        //   3) задание колонок данных (kind measure): горизонт колонки attr.metric_horizon_cols[binding] (отчёты страницы Metrics: колонки по
        //      полю horizon), иначе спутник ячейки — первый непустой из attr.metric_horizon_companions в контейнере ячейки
        //      (row['2027-02-01'].supply_horizon), иначе '' (горизонт неизвестен).
        // Режим виден по словарю (записи несут horizon); словарь из трёх частей — всё как до измерения horizon
        metricH_on() {
            const rules = this.attr?.metric_rules
            if (this._metricH4For !== rules) { this._metricH4For = rules; this._metricH4 = metricRules_h4(rules) }
            return this._metricH4
        },
        // горизонт ячейки колонки данных: ось колонок → спутник ячейки → ''
        metricCol_horizon(dataItem, col_binding) {
            const h = this.attr?.metric_horizon_cols?.[col_binding]
            if (h) return String(h)
            const comps = this.attr?.metric_horizon_companions
            if (!Array.isArray(comps) || !comps.length || !dataItem || !col_binding) return ''
            const cache = this._metricColParts || (this._metricColParts = new Map())
            let parts = cache.get(col_binding)
            if (!parts) { parts = String(col_binding).split('.'); cache.set(col_binding, parts) }
            let v = dataItem
            for (let i = 0; i < parts.length - 1; i++) { v = (v && typeof v === 'object') ? v[parts[i]] : null; if (v == null) return '' }
            if (v && typeof v === 'object') for (const k of comps) { const x = v[k]; if (x) return String(typeof x === 'object' ? (x.value ?? x.id ?? '') : x) }
            return ''
        },
        metricCell_horizon(task, dataItem, col_binding) {
            if (task?.metric_horizon) return String(task.metric_horizon)
            if (task?.kind !== 'measure') return METRIC_HORIZON_ALL
            const own = this.metricCell_ownKeys(task, dataItem, col_binding)   // IE 2026 10 01 / ODOO-5800
            if (own.length) return metricKey_parse(own[0]).horizon || ''
            const sib = this.metricCell_siblingKeys(task, dataItem, col_binding)   // IE 2026 10 02 / ODOO-5800: детали той же метрики с другой основой
            if (sib.length) return metricKey_parse(sib[0]).horizon || ''
            return this.metricCol_horizon(dataItem, col_binding)
        },
        // IE 2026 10 01 / ODOO-5800 (Igor, форма ячейки запаса 2027-02: «почему написано в метрике что это Минуле»): у ячейки со строками деталей метрик
        // (опция «Metric data in cells») горизонт метрики задания по значению — горизонт СТРОК ДЕТАЛЕЙ той же основы ключа в этой ячейке, а не спутник
        // supply_horizon: у строк запаса он не заполнен по смыслу (merge_horizon без горизонтов правил даёт 'past' и ячейкам 2027 года), и правило
        // «value: category max» давало ключ «… · Past» рядом с той же метрикой из деталей («… · Replenishment cycle»). Зеркало бэка (dl2.metric_marks_dl2).
        // Ключи деталей ячейки с основой задания (четыре части); пусто — деталей нет, горизонт как раньше. Выключатель fe.ux.cellMetricOwnHorizon
        metricCell_ownKeys(task, dataItem, col_binding) {
            if (!task || task._metricFill || task.metric_horizon || task.kind !== 'measure' || !task.metric_key || !dataItem || !col_binding) return METRIC_FILL_NONE
            if (!this.metricH_on() || this.store.setting('fe.ux.cellMetricOwnHorizon', true) === false) return METRIC_FILL_NONE
            const st = this.metricFill_state()
            if (!st) return METRIC_FILL_NONE
            const keys = this.metricFill_cellKeys(st, dataItem, col_binding, this.attr_by_binding[col_binding])
            return keys.length ? keys.filter(k => metricKey_base(k) === task.metric_key) : METRIC_FILL_NONE
        },
        // IE 2026 10 02 / ODOO-5800 (Igor, та же форма ячейки запаса 2027-02: «Запас: покриття понад дві партії · Минуле» осталось): основа задания по значению не совпала
        // ни с одним ключом деталей ячейки — правило «value: category excess (two lots)» объявляет причину stock::excess_lots всей категории excess, а движок поставил
        // узлу на эту дату stock::above_excess, — и горизонт шёл от спутника supply_horizon = 'past' (у строк запаса он 'past' всегда: витрина Balance его не несёт).
        // Теперь горизонт — строк деталей той же МЕТРИКИ (open_balance) в этой ячейке: состояние остатка узла на дату одно, горизонт у всех его строк один (rc).
        // Ключи деталей ячейки с метрикой задания и другой основой; пусто — таких нет (спутник, как раньше). Зеркало бэка (dl2 _cm_own_h, ветка sib).
        // Выключатель fe.ux.cellMetricSiblingHorizon (действует при fe.ux.cellMetricOwnHorizon)
        metricCell_siblingKeys(task, dataItem, col_binding) {
            if (!task || task._metricFill || task.metric_horizon || task.kind !== 'measure' || !task.metric_key || !dataItem || !col_binding) return METRIC_FILL_NONE
            if (!this.metricH_on() || this.store.setting('fe.ux.cellMetricOwnHorizon', true) === false || this.store.setting('fe.ux.cellMetricSiblingHorizon', true) === false) return METRIC_FILL_NONE
            const st = this.metricFill_state()
            if (!st) return METRIC_FILL_NONE
            const keys = this.metricFill_cellKeys(st, dataItem, col_binding, this.attr_by_binding[col_binding])
            if (!keys.length) return METRIC_FILL_NONE
            const metric = metricKey_parse(task.metric_key).metric
            const out = keys.filter(k => metricKey_base(k) !== task.metric_key && metricKey_parse(k).metric === metric)
            return out.length ? out : METRIC_FILL_NONE
        },
        // ключ метрики ЯЧЕЙКИ по сработавшему заданию: основа + горизонт (словарь из трёх частей — сама основа)
        metricCell_key(task, dataItem, col_binding) {
            // IE 2026 09 20 / ODOO-5800 (заливка от метрик): у синтетического задания ключ точный — metric_key строки деталей (горизонт МЕТРИКИ, не спутника ячейки)
            if (task._metricFill) return this.metricH_on() ? task.metric_key4 : task.metric_key
            return this.metricH_on() ? task.metric_key + '|' + this.metricCell_horizon(task, dataItem, col_binding) : task.metric_key
        },
        // прошедшие отбор отметки строки: [{h — горизонт ключа (null — ключ из трёх частей), css — классы правила]; раз на строку и отбор
        metricRow_hits(dataItem, mdoc) {
            let m = this._metricRowHits
            if (!m || m.doc !== mdoc || m.rules !== this.attr?.metric_rules) m = this._metricRowHits = { doc: mdoc, rules: this.attr?.metric_rules, map: new WeakMap() }
            let v = dataItem ? m.map.get(dataItem) : null
            if (!v) {
                this.metricCss_forRow(null, mdoc)   // словарь классов по ключам
                v = metricChip_matchedKeys(dataItem?._DLRow?.metrics, mdoc).map(k => ({ h: metricKey_parse(k).horizon, css: this._metricCssByKey.get(k) || [] }))
                if (dataItem) m.map.set(dataItem, v)
            }
            return v
        },
        // ячейка окрашена отобранным правилом: её класс принадлежит прошедшей отбор отметке, а у ячейки колонки данных с известным
        // горизонтом — отметке ЭТОГО горизонта (классы одного правила по всем горизонтам общие: без проверки горизонта под отбором
        // «Lead time» читались бы и ячейки прошлого). Свободный горизонт отметки ('' / три части) и 'all' ячейку не ограничивают
        metricCell_hit(dataItem, col_binding, own, mdoc) {
            // IE 2026 09 20 / ODOO-5800 (заливка от метрик): ключи ячейки из таблицы деталей — точный ответ (классы у ключей одной оценки общие)
            const _mf = this.metricFill_state()
            if (_mf && this.metricFill_cellMatches(_mf, dataItem, col_binding, this.attr_by_binding[col_binding], mdoc)) return true
            const hits = this.metricRow_hits(dataItem, mdoc)
            if (!hits.length) return false
            const ch = this.metricH_on() ? this.metricCol_horizon(dataItem, col_binding) : ''
            // IE 2026 10 02 / ODOO-5800: отметка с горизонтом строк деталей ЭТОЙ ячейки проходит и при другом спутнике (ключ задания по значению несёт горизонт деталей той же
            // основы / метрики — metricCell_horizon, а спутник строк запаса — 'past' при деталях rc). Выключатель fe.ux.cellMetricOwnHorizon
            const dh = (ch && _mf && this.store.setting('fe.ux.cellMetricOwnHorizon', true) !== false)
                ? this.metricFill_cellKeys(_mf, dataItem, col_binding, this.attr_by_binding[col_binding]).map(k => metricKey_parse(k).horizon) : METRIC_FILL_NONE
            for (const m of hits) {
                if (ch && !(m.h === null || m.h === '' || m.h === METRIC_HORIZON_ALL || m.h === ch || dh.includes(m.h))) continue
                if (own.some(k => m.css.includes(k))) return true
            }
            return false
        },
        // ---- IE 2026 09 18 / ODOO-5800 (заказ Игоря: колонка use вкладки Metrics) ----
        // Грид вкладки Metrics (бэк ie-dm7: attr.metricChip_use, строки _doc.metrics_stats с key = '<grade>|<metric>|<reason>'):
        // use строки = её ключ проходит правило чипса метрик грида ДАННЫХ того же виджета; клик по use меняет отбор чипса
        metricUse_dataGrid() {
            return Object.values(this.WIDGET?.applys_CHIPS || {}).find(g => g && g !== this && Array.isArray(g.attr?.metric_rules) && g.attr.metric_rules.length) || null
        },
        // действующий отбор чипса метрик этого грида (null — чипса нет либо он выключен)
        metricChip_docNow() {
            const chip = (this.$refs.chips?.chipsRaw || this.CHIPS || []).find(c => c && c.segment === 'CHIP-Metric')
            const own = chip && chip.meta?.use !== false && this.metricChip_on() ? chip.doc : null
            if (own && !metricChip_isEmpty(own)) return own
            return this.metricMirror_chip()?.doc || own   // IE 2026 09 19 / ODOO-5800 (заказ Игоря «глобальный чипс-метрик»: приём чипса отчётом): иначе — зеркало глобального чипса
        },
        // ---- IE 2026 09 19 / ODOO-5800 (заказ Игоря «глобальный чипс-метрик»: приём чипса отчётом) ----
        // Настройка виджета doc.params.metric_chip_accept = table / both: отбор глобального чипса метрик стола зеркалится над таблицей
        // виртуальным чипсом CHIP-Metric — отбор строк по отметкам, приглушение, счётчик и ‹ ›, колонка use вкладки Metrics. Объект зеркала
        // живёт на WIDGET (не в записи: в viewParams не попадает и с настройками виджета не сохраняется), снимается вместе с глобальным
        // чипсом; свой действующий чипс метрик грида главнее зеркала; ⊗ на зеркале прячет его до следующей смены глобального отбора
        // IE 2026 09 19 / ODOO-5800 (находка ie-dm7 #30452: зеркало чипса метрик прятало все строки): зеркало действует, только когда словарь метрик ЭТОГО грида знает хоть что-то из
        // отбора глобального чипса (c.known — число ключей attr.metric_rules, проходящих отбор: одинаково для комбинаций и пары
        // Grade / Metric). Отметки строк — ключи того же словаря: отбор, которого словарь не знает, не совпал бы ни с одной строкой и
        // спрятал бы ВСЮ таблицу (замер ie-dm7: Purchase Balance, чипс bad|oos|uncovered::in::no_rule_out, видимых 0 из 455). Такой
        // отчёт чипс просто не замечает: ни отбора строк, ни чипса над таблицей. Выключатель fe.ux.metricMirrorKnownOnly
        metricMirror_chip() {
            const c = this.WIDGET?._metricMirror?.[this.attr?.name]
            if (!c || !this.metricChip_on() || (c.dismissedSig && c.dismissedSig === c.sig)) return null
            if (!(c.known > 0) && this.store.setting('fe.ux.metricMirrorKnownOnly', true) !== false) return null
            if ((this.CHIPS || []).some(x => x && x.segment === 'CHIP-Metric' && x.meta?.use !== false && !metricChip_isEmpty(x.doc))) return null
            return c
        },
        // объект зеркала привести к действующему отбору (true — изменился). Зеркало ведёт только грид со словарём метрик
        // (attr.metric_rules приходит с данными и сам не реактивен — поэтому сверка идёт и в начале apply_CHIPS)
        metricMirror_ensure() {
            const name = this.attr?.name, W = this.WIDGET
            if (!name || !W?.workspace) return false
            const has = Array.isArray(this.attr?.metric_rules) && this.attr.metric_rules.length > 0
            const sig = has ? this.metricMirror_sig : ''
            const cur = W._metricMirror?.[name] || null
            if (!sig) {
                if (!cur) return false
                const rest = { ...W._metricMirror }; delete rest[name]; W._metricMirror = rest
                return true
            }
            // сколько ключей словаря грида проходит отбор чипса; словарь приходит с данными — пересчёт при каждой сверке
            // IE 2026 10 04 / ODOO-5800 (fe-76) (Igor 04.10: «проверь функционал фильтрации по глобальному чипсу-метрик»): комбинация / горизонт глобального чипса, которых словарь
            // ЭТОГО грида не знает (ключ взят на другом уровне: узел ↔ носитель отчёта), сопоставляются по основе сигнала — metricChip_localize. src — отбор шапки стола как есть,
            // doc — действующий отбор этого грида (объект меняется только со сменой отбора шапки либо итога сопоставления: по нему ведутся кэши отметок строк),
            // fallback — что сведено к основе (пометка чипса над таблицей). Выключатель fe.ux.metricChipBaseFallback = false — doc = src, как до fe-76
            const same = !!cur && cur.sig === sig
            const src = same ? (cur.src || cur.doc) : metricChip_copy(this.store.metricChipG_docActive(W.workspace) || {})
            const loc = this.store.setting('fe.ux.metricChipBaseFallback', true) !== false ? metricChip_localize(src, this.attr.metric_rules) : { doc: src, fallback: null }
            const fbSig = loc.fallback ? metricChip_sig(loc.doc) : ''
            const docNow = same && (cur.fbSig || '') === fbSig ? cur.doc : loc.doc
            const known = this.attr.metric_rules.reduce((n, e) => n + (e && e.key && metricChip_matchKey(e.key, docNow) ? 1 : 0), 0)
            if (same && docNow === cur.doc) { if (cur.known === known) return false; cur.known = known; return true }
            const doc = docNow
            if (cur) { cur.doc = doc; cur.src = src; cur.fbSig = fbSig; cur.fallback = loc.fallback; cur.sig = sig; if (!same) cur.dismissedSig = ''; cur.known = known }
            else W._metricMirror = { ...(W._metricMirror || {}), [name]: { segment: 'CHIP-Metric', _mirror: true, _isVirtual: true, title: '', meta: { use: true, pi: 'pi-bullseye' }, doc, src, fbSig, fallback: loc.fallback, sig, known, dismissedSig: '', showAllLines: false, matchCount: null, matchIndex: 0 } }
            return true
        },
        metricMirror_sync() {
            if (!this.metricMirror_ensure()) return
            try { this.apply_CHIPS() } catch (e) { /* грид ещё не готов — отбор применится с приходом данных */ }
        },
        metricUse_sync() {
            const flex = this.flex
            if (!this.attr?.metricChip_use || !flex) return
            const doc = this.metricUse_dataGrid()?.metricChip_docNow() || null
            const b = this.metricSel_binding(), fmt = this.metricFmt_on(), off = fmt ? this.metricFmt_offList() : null   // IE 2026 09 19 / ODOO-5800 (Igor: Use вкладки Metrics = оформление метрики видно в таблице, состав чипса — колонка Selector)
            let changed = false
            for (const row of flex.rows) {
                const it = row.dataItem
                if (!it || !it.key) continue
                const v = !!doc && metricChip_matchKey(it.key, doc)
                if (this.store.isTrue(it[b]) !== v || typeof it[b] !== 'boolean') { it[b] = v; changed = true }
                if (fmt) { const u = !metricFormat_isOff(off, it.key); if (it.use !== u) { it.use = u; changed = true } }
            }
            if (changed) { try { flex.invalidate() } catch (e) { /* грид ещё не готов */ } }
        },
        // отбор чипса сменился — гриды вкладки Metrics этого виджета пересчитывают use
        metricUse_notify() {
            for (const g of Object.values(this.WIDGET?.applys_CHIPS || {})) { if (g && g !== this && g.attr?.metricChip_use) { try { g.metricUse_sync() } catch (e) { /* вкладка не смонтирована */ } } }
        },
        // чекбокс Use в заголовках строк: Alt / Ctrl / Cmd — только эта строка (остальные снять); клик внутри выделения
        // нескольких строк — всем выделенным; иначе одна строка
        metricUse_selectorClick(irow, checked, e, range) {
            const flex = this.flex
            if (e && (e.altKey || e.ctrlKey || e.metaKey)) {
                for (let r = 0; r < flex.rows.length; r++) { const d = flex.rows[r].dataItem; if (d?.key) d[this.metricSel_binding()] = r === irow ? !!checked : false }   // IE 2026 09 19 / ODOO-5800 (Igor: Use вкладки Metrics = оформление метрики видно в таблице, состав чипса — колонка Selector)
            } else {
                const [a, b] = range && range[0] !== range[1] ? range : [irow, irow]
                for (let r = a; r <= b; r++) { const row = flex.rows[r], d = row?.dataItem; if (d?.key && row.visible !== false) d[this.metricSel_binding()] = !!checked }
            }
            try { flex.invalidate() } catch (err) { /* грид ещё не готов */ }
            this.metricUse_schedule()
        },
        // клик по флажку Use: переключить строку; при выделении нескольких строк — всем выделенным значение кликнутой
        metricUse_click(irow) {
            const flex = this.flex, it = flex?.rows?.[irow]?.dataItem
            if (!it) return
            const b = this.metricSel_binding()   // IE 2026 09 19 / ODOO-5800 (Igor: Use вкладки Metrics = оформление метрики видно в таблице, состав чипса — колонка Selector)
            const val = !this.store.isTrue(it[b])
            const sel = flex.selectedRanges?.[0]
            const inRange = sel && sel.isValid && sel.topRow !== sel.bottomRow && sel.topRow <= irow && irow <= sel.bottomRow
            for (let r = inRange ? sel.topRow : irow; r <= (inRange ? sel.bottomRow : irow); r++) {
                const row = flex.rows[r], d = row?.dataItem
                if (d && d.key && row.visible !== false) d[b] = val
            }
            try { flex.invalidate() } catch (e) { /* грид ещё не готов */ }
            this.metricUse_schedule()
        },
        // ---- IE 2026 09 19 / ODOO-5800 (Igor: Use вкладки Metrics = оформление метрики видно в таблице, состав чипса — колонка Selector) ----
        // Контракт ie-dm7 (на запрос с client.metric_selector): узел грида вкладки несёт metricChip_selector = 'selector' (колонка состава чипса — её ведёт
        // фронт, как раньше вёл use), metricFormat_use = 'use' (оформление метрики видно) и metricFormat_off_binding (где лежит список выключенных ключей).
        // Поле use грид рисует системным чекбоксом в заголовках строк, selector приходит обычной колонкой AttrBool (грид только для чтения — клик ловим сами)
        metricSel_binding() { const b = this.attr?.metricChip_selector; return (b && this.store.metricSelector_on()) ? String(b) : 'use' },
        metricFmt_on() { return !!(this.attr?.metricFormat_use && this.attr?.metricChip_selector && this.store.metricSelector_on()) },
        metricFmt_binding() { return String(this.attr?.metricFormat_off_binding || 'doc.params.metric_format_off') },
        metricFmt_offList() { const v = this.store.get_value(this.WIDGET?.record, this.metricFmt_binding()); return Array.isArray(v) ? v : [] },
        // чекбокс Use в заголовках строк в новом назначении: Alt / Ctrl / Cmd — оформление только этой метрики; клик внутри выделения — всем выделенным
        metricFmt_selectorClick(irow, checked, e, range) {
            const rows = this.flex.rows, on = !!checked
            if (e && (e.altKey || e.ctrlKey || e.metaKey)) {
                for (let k = 0; k < rows.length; k++) { const it = rows[k].dataItem; if (it?.key) it.use = k === irow ? on : false }
            } else {
                const [from, to] = range && range[0] !== range[1] ? range : [irow, irow]
                for (let k = from; k <= to; k++) { const it = rows[k]?.dataItem; if (it?.key && rows[k].visible !== false) it.use = on }
            }
            try { this.flex.invalidate() } catch (err) { /* грид ещё не готов */ }
            this.metricFmt_schedule()
        },
        metricFmt_schedule() {
            clearTimeout(this._metricFmt_t)
            this._metricFmt_t = window.$cg.setTimeout(this, 'AttrGrid.metricFmt_apply', () => this.metricFmt_apply(), 0)
        },
        // клики по Use → настройка виджета doc.params.metric_format_off (запись становится изменённой — это настройка, она сохраняется с виджетом);
        // пустой список — ключ параметра снять; затем гриды данных виджета перекладывают оформление
        metricFmt_apply() {
            const W = this.WIDGET, rec = W?.record
            if (!rec || !this.flex) return
            const rows = []
            for (const row of this.flex.rows) { const it = row.dataItem; if (it?.key) rows.push({ key: it.key, use: this.store.isTrue(it.use) }) }
            const old = this.metricFmt_offList(), list = metricFormat_offApply(old, rows)
            if (JSON.stringify(old) !== JSON.stringify(list)) {
                const b = this.metricFmt_binding()
                if (list.length) this.store.set_value(rec, b, list)
                else {
                    const parts = b.split('.'), last = parts.pop(), host = this.store.get_value(rec, parts.join('.'))
                    if (host && typeof host === 'object') delete host[last]
                    rec._meta = rec._meta || {}; rec._meta.modified = true
                }
            }
            this.metricUse_sync()
            for (const g of Object.values(W.applys_CHIPS || {})) { if (g && g !== this && typeof g.metricFmt_changed === 'function') { try { g.metricFmt_changed(true) } catch (e) { /* грид не смонтирован */ } } }
        },
        // ---- грид ДАННЫХ: какое оформление скрыто ----
        // off — ключи, выключенные колонкой Use; only — отбор чипса метрик при снятом флаге «Show other formatting» (иначе null). Слова Игоря: «добавь еще
        // рядом флаг "показать другие форматирования" - те ожидаю что без флага будут показаны только форматирования по тек; и тоже по умолчанию вкл»
        metricFmt_state() {
            const offRef = this.WIDGET?.record?.doc?.params?.metric_format_off, onlySig = this._metricOnlySig || '', fmtSig = this._formatOnlySig || ''
            let m = this._metricFmtMemo
            if (!m || m.offRef !== offRef || m.onlySig !== onlySig || m.fmtSig !== fmtSig) {
                const off = (Array.isArray(offRef) && this.store.metricSelector_on()) ? offRef.map(x => String(x || '')).filter(Boolean) : []
                const only = onlySig ? (this._metricOnlyDoc || null) : null
                const onlyFmt = fmtSig ? (this._formatOnlyDoc || null) : null   // IE 2026 09 20 / ODOO-5800 (чипс условного оформления): его флаг «Show other formatting» снят
                m = this._metricFmtMemo = { offRef, onlySig, fmtSig, off, only, onlyFmt, active: off.length > 0 || !!only || !!onlyFmt }
            }
            return m.active ? m : null
        },
        // ---- IE 2026 09 20 / ODOO-5800 (Igor: «раскраску в ячейке ожидаю не от форматирования, а от метрик» — опция отчёта «Metric data in cells») ----
        // Слова Игоря 20.09 (ячейка непокрытой поставки «Литва ← Швеция · Uncovered», март 2027): «я ожидаю в ячейке увидеть раскраску не от форматирования —
        // а от метрик, по которым эта поставка невозможна». Бэк ie-dm7 (be-ie 91b58e9a0, опция отчёта «Metric data in cells» либо флаг запроса
        // dl2_engine.metricData): спутник ячейки metric_ids → строки таблицы деталей record._doc.metric_data; словарь attr.metric_rules несёт запись на каждый
        // ключ ячеек (cell_ids: true, css — фон оценки, comment — пояснение причины), строки — отметки _DLRow.metrics.
        // Устройство: каждый РАЗНЫЙ ключ строк деталей ячейки = синтетическое сработавшее задание оформления этой ячейки (_metricFill) — всё, что построено поверх
        // заданий с metric_key (Use вкладки Metrics, флаг чипса «Show other formatting», блок METRICS формы ячейки, переходы ‹ › по ячейкам, подсветка по
        // наведению, приглушение под чипсом), работает той же веткой. Красит ХУДШАЯ оценка (минимальный grade_order, при равенстве — порядок словаря) среди
        // ключей, чьё оформление не скрыто; настоящее правило оформления с той же основой ключа главнее (двойной заливки нет — вид остатков не меняется).
        // Представитель свёрнутой группы колонок показывает агрегат — ему принадлежат метрики всех колонок группы. Строки-группы — под выключателем
        // fe.ux.metricFillGroups, всё вместе — fe.ux.metricFill (оба по умолчанию вкл). Состояние живёт в cf_cache и сбрасывается вместе с ним
        metricFill_state() {
            if (!this.cf_cache) this.cf_cache = new Map()
            let st = this.cf_cache.get('§metricFill')
            if (st === undefined) {
                st = null
                const md = this.WIDGET?.record?._doc?.metric_data, dict = this.attr?.metric_rules
                if (md && Array.isArray(dict) && dict.length && this.metricChip_on() && this.store.setting('fe.ux.metricFill', true) !== false) {
                    const ix = metricData_index(md)
                    if (ix) {
                        const byKey = new Map()
                        dict.forEach((e, i) => { if (e && e.key && e.cell_ids) byKey.set(e.key, { e, i }) })
                        if (byKey.size) st = { ix, byKey, h4: metricRules_h4(dict), tasks: new Map(), groups: this.store.setting('fe.ux.metricFillGroups', true) !== false, layers: this.store.setting('fe.ux.metricFillLayers', true) !== false /* IE 2026 09 20 / ODOO-5800: ключи-слои */,
                            ruleStyle: this.metricFill_ruleStyles() /* IE 2026 10 01 / ODOO-5800: стиль метрики, объявленный правилом отчёта */ }
                    }
                }
                this.cf_cache.set('§metricFill', st)
            }
            return st
        },
        // IE 2026 10 01 / ODOO-5800 (Igor 01.10: сверхнормативный запас — синяя шкала, а не красное): образец стиля ключа ячейки — от ПРАВИЛА отчёта с тем же
        // ключом метрики (задание с metric_key — основа grade|metric|reason — без горизонта правила), а не от фона оценки записи GRADE. Запись словаря ключа
        // ячеек (cell_ids) несёт фон оценки (grade-bad → красный) и у неё нет правила, когда правило ни на одной строке не сработало (категория excess
        // в агрегате строк отсутствует) или его горизонт не совпал с горизонтом строки деталей: красный «bad» на итогах запаса при синем правиле
        // «value: category excess». Первое задание основы в порядке грида. Выключатель fe.ux.metricFillRuleStyle (по умолчанию вкл)
        metricFill_ruleStyles() {
            const out = new Map()
            if (this.store.setting('fe.ux.metricFillRuleStyle', true) === false) return out
            const rules = this.attr?.cf_rules
            if (!rules) return out
            const take = (list) => { for (const t of list || []) if (t && t.metric_key && !t.metric_horizon && !out.has(t.metric_key) && ((t.cssClasses || []).length || t.cssStyle)) out.set(t.metric_key, t) }
            take(rules.report)
            for (const k in rules.sets || {}) take(rules.sets[k])
            for (const k in rules.fields || {}) take(rules.fields[k])
            return out
        },
        // номера строк деталей в контейнере ячейки колонки binding ('2027-03-01.quantity' → row['2027-03-01'].metric_ids)
        // IE 2026 10 03 / ODOO-5800: memo-строка (memoRow_is: «Stock cover», «· of which …») спутника не несёт — её metric_ids унаследованы от строки родителя
        // (данные memo = строки зерна родителя) и относятся к его мере: critical stock_mismatch красил «Покриття запасу». Разбор — utils/metricChip.metricData_rowIds
        metricFill_idsAt(st, dataItem, binding) {
            const cache = this._metricColParts || (this._metricColParts = new Map())
            let parts = cache.get(binding)
            if (!parts) { parts = String(binding).split('.'); cache.set(binding, parts) }
            return metricData_rowIds(dataItem, parts, st.ix.binding, this.memoRows_on())
        },
        // листовые колонки свёрнутой группы той же меры (колонки итогов периода спутника не несут)
        metricFill_foldBindings(grp, raw_binding) {
            const cache = grp._mfLeaves || (grp._mfLeaves = {})
            if (cache[raw_binding]) return cache[raw_binding]
            const out = []
            const walk = (g) => {
                if (!g.columns || !g.columns.length) { if (g.binding && !String(g.binding).startsWith('_total::') && this.attr_by_binding[g.binding]?.raw_binding === raw_binding) out.push(g.binding); return }
                for (const c of g.columns) walk(c)
            }
            walk(grp)
            cache[raw_binding] = out
            return out
        },
        metricFill_ids(st, dataItem, col_binding, attr_col) {
            if (!dataItem || !col_binding) return null
            if (attr_col?.raw_binding) {
                const groups = this.foldAgg_groups().get(attr_col.binding0 || col_binding)
                const grp = groups && groups.find(g => g.isCollapsed)
                if (grp) {
                    let all = null
                    for (const b of this.metricFill_foldBindings(grp, attr_col.raw_binding)) {
                        const ids = this.metricFill_idsAt(st, dataItem, b)
                        if (ids) { if (!all) all = new Set(); for (const i of ids) all.add(i) }
                    }
                    return all ? [...all].sort((x, y) => x - y) : null
                }
            }
            return this.metricFill_idsAt(st, dataItem, col_binding)
        },
        // ключи метрик ячейки (как в словаре: четыре части либо три)
        metricFill_cellKeys(st, dataItem, col_binding, attr_col) {
            const ids = this.metricFill_ids(st, dataItem, col_binding, attr_col)
            return ids ? metricData_keys(st.ix, ids, st.h4) : METRIC_FILL_NONE
        },
        metricFill_cellMatches(st, dataItem, col_binding, attr_col, doc) {
            for (const k of this.metricFill_cellKeys(st, dataItem, col_binding, attr_col)) if (st.byKey.has(k) && metricChip_matchKey(k, doc)) return true
            return false
        },
        // синтетические задания ячейки — по одному на ключ, худшая оценка первой; объект задания общий для всех ячеек ключа
        metricFill_cellTasks(st, dataItem, col_binding, attr_col) {
            const keys = this.metricFill_cellKeys(st, dataItem, col_binding, attr_col)
            if (!keys.length) return METRIC_FILL_NONE
            const out = []
            for (const k of keys) {
                let t = st.tasks.get(k)
                if (t === undefined) {
                    const rec = st.byKey.get(k)
                    if (!rec) t = null
                    else {
                        const e = rec.e
                        // IE 2026 09 20 / ODOO-5800 (Igor: «форматирование от #cell.supply_horizon переделать на метрики правил»): css_layer — образец стиля ключа задан источником строк
                        // (горизонт lt / rc, «мухомор» окна блокировки) и кладётся СЛОЕМ, а не спорит за заливку худшей оценки
                        // IE 2026 10 01 / ODOO-5800: запись без правила и не слой — стиль правила отчёта той же основы ключа (metricFill_ruleStyles), иначе фон оценки записи
                        const rs = (!e.rule && !e.css_layer && st.ruleStyle) ? st.ruleStyle.get(metricKey_base(k)) : null
                        // IE 2026 10 01 / ODOO-5800: при равной оценке — ключ со стилем правила меньшего Order (0 — высший, как у заданий оформления: применяется последним);
                        // без стиля правила — после всех (запас > 2×max, stock::excess_lots, Order 147 — насыщенный синий — главнее части выше max, stock::excess, Order 185)
                        // IE 2026 10 01 / ODOO-5800: Order — правила той же основы и тогда, когда бэк уже слил правило в запись (e.rule: горизонт ячейки от деталей)
                        const ro = rs || (st.ruleStyle ? st.ruleStyle.get(metricKey_base(k)) : null)
                        t = { kind: 'measure', _metricFill: true, _layer: !!e.css_layer, _gorder: +e.grade_order || 0, _rorder: ro ? (+ro.order || 0) : Infinity, _dorder: rec.i, metric_key: metricKey_base(k), metric_key4: k,
                            cssClasses: rs ? [...(rs.cssClasses || [])] : String(e.css || '').split(/\s+/).filter(Boolean), cssStyle: rs ? (rs.cssStyle || '') : (e.style || ''),
                            title: [e.grade_title, e.metric_title, e.reason_title, e.horizon ? (e.horizon_title || e.horizon) : '', e.status ? (e.status_title || e.status) : ''].filter(Boolean).join(' · ') }   // IE 2026 09 21 / ODOO-5800: + статус документа
                        // IE 2026 10 03 / ODOO-5800 (заказ Игоря: «Показать критич ош если небьется расчетный запас с фактич»): ключ оценки critical — самый строгий (сортировка ниже:
                        // раньше любого grade_order) и несёт свой класс ячейки METRIC_CRIT_CLASS поверх образца стиля; ключ-слой (css_layer) критическим не бывает
                        if (!t._layer && story_isCritical(e.grade || metricKey_parse(k).grade)) { t._crit = true; if (!t.cssClasses.includes(METRIC_CRIT_CLASS)) t.cssClasses.push(METRIC_CRIT_CLASS) }
                    }
                    st.tasks.set(k, t)
                }
                if (t) out.push(t)
            }
            if (out.length > 1) out.sort((a, b) => story_criticalCmp(a, b) || (a._gorder - b._gorder) || (a._rorder - b._rorder) || (a._dorder - b._dorder))   // IE 2026 10 01 / ODOO-5800: + Order правила   // IE 2026 10 03 / ODOO-5800: critical — первым
            return out
        },
        // основы ключей метрик настоящих СТРОЧНЫХ заданий, сработавших на строке (красят всю строку — синтетическое задание той же основы не нужно); раз на строку
        metricFill_rowBases(dataItem) {
            if (!this.attr?.cf_rules) return METRIC_FILL_NOSET
            if (!dataItem._fe?.key) (dataItem._fe = dataItem._fe || {}).key = ++ this.cache_index
            const ck = '§mfrow:' + dataItem._fe.key
            let set = this.cf_cache.get(ck)
            if (set === undefined) {
                const applied = []
                this.cf_compute(dataItem, '', null, applied)
                set = METRIC_FILL_NOSET
                for (const t of applied) if (t.metric_key) { if (set === METRIC_FILL_NOSET) set = new Set(); set.add(t.metric_key) }
                this.cf_cache.set(ck, set)
            }
            return set
        },
        // ---- IE 2026 09 20 / ODOO-5800 (Igor: «для каждой ячейки иметь привязку к применимым правилам … показать в форме drilldown — применимые правила») ----
        // Бэк ie-dm7 (be-ie cac5abb2a, вместе с опцией отчёта «Metric data in cells»): в спутник ячейки metric_ids входят и строки деталей уровня 'rule' правила самой
        // строки источника, у таблицы деталей колонки rule_id / rule_segment, словарь правил record._doc.rules = {fields, rows, titles}. Правила ячейки = разные пары
        // (rule_segment, rule_id) по строкам деталей её metric_ids; состояние в ячейке — действует / замечание правила / не применимо: причина (utils/cellRules.js).
        // Строка-группа и представитель свёрнутой группы колонок несут объединение (metricFill_ids). Названия метрик и причин — из словаря метрик виджета.
        // Состояние живёт в cf_cache. Выключатель fe.ux.cellRules
        cellRules_state() {
            if (!this.cf_cache) this.cf_cache = new Map()
            let st = this.cf_cache.get('§cellRules')
            if (st === undefined) {
                st = null
                const d = this.WIDGET?.record?._doc
                if (d?.metric_data && d?.rules && this.store.setting('fe.ux.cellRules', true) !== false) {
                    const ix = metricData_index(d.metric_data), rules = rulesDict_index(d.rules)
                    if (ix && rules) {
                        const mT = new Map(), rT = new Map(), rC = new Map()
                        for (const e of this.attr?.metric_rules || []) {
                            if (!e) continue
                            if (e.metric && e.metric_title) mT.set(e.metric, e.metric_title)
                            if (e.reason && e.reason_title) rT.set(e.reason, e.reason_title)
                            if (e.reason && e.comment) rC.set(e.reason, e.comment)
                        }
                        st = { ix, rules, names: { metric: (id) => mT.get(id), reason: (id) => rT.get(id), comment: (id) => rC.get(id) } }
                    }
                }
                this.cf_cache.set('§cellRules', st)
            }
            return st
        },
        cellRules_forCell(dataItem, col_binding, attr_col) {
            const st = this.cellRules_state()
            if (!st || !dataItem || !col_binding) return CELL_RULES_NONE
            const ids = this.metricFill_ids(st, dataItem, col_binding, attr_col)
            // IE 2026 09 22 / ODOO-5800 (Igor: «показывай правила для ячеек без количеств; нет действующего — то, что действовало последним»): правила строки (_DLRow.rules
            // хвоста rule_cell_state) — в любой ячейке колонки-даты, состояние по её месяцу; выключатель fe.ux.cellRulesRow
            const rowRules = this.store.setting('fe.ux.cellRulesRow', true) !== false ? (dataItem._DLRow?.rules || null) : null
            const month = rowRules ? cellRules_month(col_binding) : ''
            if (!ids && !(rowRules && rowRules.length && month)) return CELL_RULES_NONE
            return cellRules_list(st.ix, ids || [], st.rules, st.names, month ? { rowRules, month } : null)
        },
        // IE 2026 09 20 / ODOO-5800 (Igor через ie-dm7 #32448: команда «открыть список правил» блока RULES формы ячейки): цели команды — списочные виджеты правил
        // (record._doc.rules.lists бэка e8ab6722e; ключа нет — команды нет) по ВСЕМ правилам ячейки, а не только по показанным 12; цель несёт готовый отбор —
        // измерения, общие для правил ячейки этого вида (utils/cellRules.js). Выключатель fe.ux.cellRulesOpenList
        cellRules_lists(rules) {
            const st = this.cellRules_state()
            if (!st || !rules?.length || this.store.setting('fe.ux.cellRulesOpenList', true) === false) return []
            const skip = this.store.setting('fe.data.cellRulesListSkipDims', '')
            const skipList = String(skip || '').split(',').map(x => x.trim()).filter(Boolean)
            return cellRules_listTargets(rules, this.WIDGET?.record?._doc?.rules?.lists).map(t => {
                const q = cellRules_commonWhere(st.rules, rules, t.segment, skipList)
                return { ...t, where: q.where, chipTitle: q.title, dims: q.dims }
            }).filter(t => t.where.length)
        },
        cellRules_openList(t) {
            if (!t?.widget || !t.where?.length) return
            try { const _dd = this.store.dropdown; if (_dd && !_dd.cellForm_recordOpened?.()) _dd.hide?.() } catch (e) { /* форма уже закрыта */ }   // IE 2026 10 12 / ODOO-5800 (заказ Игоря: форма ячейки не закрывается при открытии из неё записей): запись открывается из формы — форма остаётся (Dropdown.cellForm_recordOpened; fe.ux.cellFormKeepOnRecordOpen = false — прежнее прятание)
            this.store.cellRulesList_open(this.WIDGET?.vueObj || this, t, cellRules_chip(JSON.parse(JSON.stringify(t.where)), t.chipTitle))
        },
        // переход в запись правила (коллекция work.maps) — как открытие элемента из формы чипса
        cellRules_open(r) {
            if (!r || !r.id || !r.segment) return
            try { const _dd = this.store.dropdown; if (_dd && !_dd.cellForm_recordOpened?.()) _dd.hide?.() } catch (e) { /* форма уже закрыта */ }   // IE 2026 10 12 / ODOO-5800 (заказ Игоря: форма ячейки не закрывается при открытии из неё записей): запись открывается из формы — форма остаётся (Dropdown.cellForm_recordOpened; fe.ux.cellFormKeepOnRecordOpen = false — прежнее прятание)
            this.store.executeStoreMethod(this.WIDGET?.vueObj || this, { command: 'widget_open', widget: 'widget-record', _activate: true, item: { id: String(r.id), segment: r.segment } })
        },
        // IE 2026 09 21 / ODOO-5800 (п. 1 «Недоделанного» передачи ie-dm7 → ie-bio7: названия узла / правила / документа в пояснении и в блоке DETAILS — кликабельные): переход в запись
        // по ссылке бэка {kind, id, segment, version?, collection?} — правило (work.maps), узел расчёта (SKU-CALC версии, work.records), документ-источник движения (входящий
        // сегмент datahub.inbound либо плановый заказ версии). Бэк отдаёт ссылку открываемой без догадок; форма прячется, запись открывается — как cellRules_open.
        // Проверено пробой до правки (21.09): item {id, segment, version} открывает карточку узла (widget_CALC), документа и правила (widget_RECORD)
        cellLink_open(l) {
            if (!l || !l.id || !l.segment) return
            try { const _dd = this.store.dropdown; if (_dd && !_dd.cellForm_recordOpened?.()) _dd.hide?.() } catch (e) { /* форма уже закрыта */ }   // IE 2026 10 12 / ODOO-5800 (заказ Игоря: форма ячейки не закрывается при открытии из неё записей): запись открывается из формы — форма остаётся (Dropdown.cellForm_recordOpened; fe.ux.cellFormKeepOnRecordOpen = false — прежнее прятание)
            const item = { id: String(l.id), segment: String(l.segment) }
            if (l.version) item.version = String(l.version)
            if (l.collection) item._meta = { collection: String(l.collection) }
            this.store.executeStoreMethod(this.WIDGET?.vueObj || this, { command: 'widget_open', widget: 'widget-record', _activate: true, item })
        },
        // строка METRICS формы ячейки: период, количество и число исходных строк ключа в ЭТОЙ ячейке
        metricFill_detailText(st, dataItem, col_binding, attr_col, key) {
            const ids = this.metricFill_ids(st, dataItem, col_binding, attr_col)
            return ids ? metricData_detailText(metricData_detail(st.ix, ids, key, st.h4)) : ''
        },
        // IE 2026 09 21 / ODOO-5800 (Igor 21.09: «стоя на любой ячейке отчёта Purchase Balance я смогу увидеть причины, по которым было выполнено или не смогло быть выполнено движение …
        // пользователь развёрнуто получит ответ — что здесь произошло»): ПАСПОРТ ЯЧЕЙКИ — по запросу при открытии формы (метод отчёта cell_passport, бэк ie-dm7
        // common_modules/cell_passport.py): движения с документами, пары приход ↔ расход, «почему так запланировано», числа узла за месяц. Уходят измерения строки (её _DLRow.where и
        // предков) и дата колонки; отчёт не перечитывается, виджет в «загрузку» не уходит; ответ устаревшего запроса (форма уже на другой ячейке) отбрасывается.
        // Только у отчёта с опцией «Metric data in cells» и у колонок дат. Выключатель fe.ux.cellPassport
        // IE 2026 10 08 / ODOO-5800 (Igor, «Ex-Delta CIS (by shipment date)$» WKo_001: форма ячейки пустая — у отчёта нет опции «Metric data in cells», запрос паспорта не уходил):
        // паспорт запрашивается у ЛЮБОГО отчёта REPORT2 — метод бэка cell_passport ленивый и от опции не зависит (ему нужны версия стола и измерения строки); без узла / версии
        // бэк отвечает «no version / month», и формы остаётся прежней. Выключатель fe.ux.cellPassportAnyReport (false — прежнее: только при record._doc.metric_data).
        // Чистая часть — utils/cellFormGate.cellPassport_reportAllowed (tests/unit/cellPassportAnyReport.test.mjs)
        // IE 2026 10 22 / ODOO-5800 (unsaved): отборы строки и её предков — пары [ключ, значение] (where паспорта ячейки): поля _DLRow.where строки и предков (по уровням видимых
        // строк грида; irow не задан — ищется по dataItem), + мера блока лэйаута (cellPassport_blockDims). where / seen — накопители вызывающего (cellPassport_load) либо свои
        // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: паспорт — отбор полосы): dlRows (массив) — накопитель _DLRow строки и предков (их where_block — params.where_block паспорта)
        cellPassport_rowWhere(dataItem, irow = -1, where = [], seen = new Set(), blkOn = null, dlRows = null) {   // IE 2026 10 22 / ODOO-5800 (unsaved)
            const _blkOn = blkOn === null ? this.store.setting('fe.ux.cellPassportBlockMeasure', true) !== false : blkOn
            const add = (it) => { if (Array.isArray(dlRows) && it?._DLRow) dlRows.push(it._DLRow)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: паспорт — отбор полосы)
                for (const w of (it?._DLRow?.where || [])) { const k = String(w?.leftValue?.value ?? w?.leftValue ?? ''); const v = w?.rightValue?.value ?? w?.rightValue
                if (k && v !== undefined && v !== null && v !== '' && typeof v !== 'object' && !seen.has(k)) { seen.add(k); where.push([k, v]) } }
                if (_blkOn) for (const [k, v] of cellPassport_blockDims(it?._DLRow)) if (!seen.has(k)) { seen.add(k); where.push([k, v]) } }   // IE 2026 10 15 / ODOO-5800
            add(dataItem)
            const rows = this.flex?.rows || []
            if (!(irow >= 0 && rows[irow] && rows[irow].dataItem === dataItem)) irow = rows.findIndex(r => r && r.dataItem === dataItem)
            let lvl = irow >= 0 ? rows[irow]?.level : 0
            for (let i = irow - 1; i >= 0 && lvl > 0; i--) { const r = rows[i]; if (r && r.level < lvl) { lvl = r.level; add(r.dataItem) } }
            return where
        },
        cellPassport_unsavedOn() { try { return this.store.setting('fe.cellForm.passportUnsaved', true) !== false } catch (e) { return true } },   // IE 2026 10 22 / ODOO-5800 (unsaved)
        cellPassport_overrides(dataItem) {   // IE 2026 10 22 / ODOO-5800 (unsaved): незаписанные правки undo-стека → params.overrides (пусто — правок нет / ошибка)
            try { return cellPassport_overrides(this.undoStack, { dataItem, whereOf: (it) => this.cellPassport_rowWhere(it) }) } catch (e) { console.warn('cell passport: overrides skipped:', e); return [] }
        },
        // IE 2026 10 22 / ODOO-5800 (unsaved): форма ячейки открыта (закреплена / следует за выделением) на строке грида, где только что правили ячейку, — паспорт перечитывается с
        // незаписанными правками (после онлайн-пересчёта строки, 100 мс), только у форм с блоками планов / версий; ячейка dropdown.key = <тип>-<строка>-<колонка>
        cellPassport_refreshUnsaved(dataItem) {   // IE 2026 10 22 / ODOO-5800 (unsaved)
            try {
                const dd = this.store.dropdown
                if (!dd || !dd.visible || dd.vueObj !== this || !dd.dataItem || !(dd.cell_plan || dd.cell_versions) || !this.cellPassport_unsavedOn()) return
                const m = /^(.*)-(\d+)-(\d+)$/.exec(String(dd.key || ''))
                if (!m) return
                const irow = Number(m[2]), binding = this.flex?.columns?.[Number(m[3])]?.binding
                if (!binding) return
                clearTimeout(this._cellPassportUnsavedT)
                this._cellPassportUnsavedT = setTimeout(() => { try { if (dd.visible && dd.vueObj === this && dd.dataItem) this.cellPassport_load(dd, dd.dataItem, binding, irow) } catch (e) { /* форма уже закрыта */ } }, 400)
            } catch (e) { /* формы нет */ }
        },
        cellPassport_load(dropdown, dataItem, col_binding, irow) {
            dropdown.cell_passport = null; dropdown.cell_passport_loading = false; dropdown.cell_series = null; dropdown.cell_gantt = null; dropdown.ganttHover = ''   // IE 2026 09 22 / ODOO-5800: серии мини-графика и Гант — вместе с паспортом
            dropdown.docsMore_reset?.()   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #114865: «ще N документів» — догрузка cell_docs_more): паспорт читается заново — догруженное снято вместе с ним
            dropdown.cell_group = null   // IE 2026 09 25 / ODOO-5800: пометка итоговой строки (cell_passport.group: единственный узел группы / сумма узлов)
            dropdown.cell_story = null; dropdown.cell_story_preview = ''; dropdown.cell_story_previewOn = false   // IE 2026 10 01 / ODOO-5800 (пакет G): story ячейки — вместе с паспортом
            dropdown.cell_stock_check = null   // IE 2026 10 03 / ODOO-5800 (CONTRACT v4 §4): допуск и выключатель бэка этой ячейки — вместе со story (пока ответа нет — умолчания 10 шт. / 1 % / 5 %)
            dropdown.cell_objects = null   // IE 2026 10 08 / ODOO-5800: блок OBJECTS (объекты за ячейкой отчёта по сигналам) — вместе с паспортом
            dropdown.cell_versions = null   // IE 2026 10 15 / ODOO-5800 (ЗП-№7, этап 4): блок VERSIONS — вместе с паспортом
            dropdown.cell_plan = null   // IE 2026 10 22 / ODOO-5800: блоки PLANS / CORRECTIONS / SIGNALS страниц планов (cell_passport.plan) — вместе с паспортом
            dropdown.cell_plan_doc = null   // IE 2026 10 15 / ODOO-5800 (ЗП-№5, P4): блок PLAN APPROVAL строк планов — вместе с паспортом
            dropdown.cell_basis = null   // IE 2026 10 09 / ODOO-5800: блок BASIS (основание ЗП при согласовании / сейчас) — вместе с паспортом
            dropdown.cell_plan_scope = null   // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B): скоуп раздела PLAN DECISION формы ячейки ({where, month} — как у cell_passport)
            dropdown.cell_fix_dates = null   // IE 2026 10 28 / ODOO-5800 (заказ Игоря: раздел Fix dates в форме ячейки): раздел FIX DATES (cell_passport.fix_dates) — вместе с паспортом
            dropdown.cell_approval = null   // IE 2026 10 09 / ODOO-345618 (заказ Игоря: согласование на сегменте): раздел APPROVAL (cell_passport.approval) — вместе с паспортом
            dropdown.cell_form_blocks = null   // IE 2026 10 15 / ODOO-5800 (п. 2 формы ячейки): коды блоков формы меры (cell_passport.form_blocks) — вместе с паспортом; null — все блоки
            try {
                if (this.store.setting('fe.ux.cellPassport', true) === false) return
                if (!cellPassport_reportAllowed({ widget_class: this.WIDGET?.widget_class, metric_data: this.WIDGET?.record?._doc?.metric_data,
                    anyReport: this.store.setting('fe.ux.cellPassportAnyReport', true) !== false })) return   // IE 2026 10 08 / ODOO-5800: паспорт у любого отчёта REPORT2
                // IE 2026 10 08 / ODOO-5800 (Igor, WKo_001: ячейка КВАРТАЛЬНОГО / ГОДОВОГО итога `_total::2026Q3::…` при свёрнутых месяцах — паспорта не было): период ячейки —
                // месяцы итога, пересечённые с месяцами колонок грида (utils/cellFormGate.cellPassport_periodOf); month — первый месяц периода, months — список 'YYYY-MM' в запрос
                // (бэк cell_passport_period строит DETAILS · MOVEMENTS / документы за весь период). Выключатель fe.ux.cellPassportPeriodTotals (false — прежнее: у итога паспорта нет)
                const _periodOn = this.store.setting('fe.ux.cellPassportPeriodTotals', true) !== false
                const _per = cellPassport_periodOf(col_binding, _periodOn ? (this.flex?.columns || []).map(c => String(c?.binding || '').slice(0, 10)).filter(x => /^\d{4}-\d{2}-\d{2}$/.test(x)) : null, _periodOn)
                // IE 2026 10 08 / ODOO-5800 (Igor: «в виджетах страницы Сигналы … показать список объектов и возможность селекта по ним»): у отчёта по сигналам (источник DS::Signals;
                // utils/cellObjects.cellObjects_wanted) паспорт запрашивается и БЕЗ колонки даты (колонки — меры / виды сигналов): бэк строит блок OBJECTS по измерениям строки
                // (params.objects = 1 → cell_passport.objects); month пустой — прочих секций бэк не строит, как прежде. Флаг fe.ux.cellPassportObjects (дефолт ВКЛ)
                const _objOn = this.store.setting('fe.ux.cellPassportObjects', true) !== false && cellObjects_wanted({ source_segments: this.WIDGET?.record?.doc?.params?.source_segments })
                const _versOn = this.store.setting('fe.ux.cellVersionsChart', true) !== false   // IE 2026 10 15 / ODOO-5800 (ЗП-№7, этап 4): блок VERSIONS — мера ячейки по предыдущим версиям; у ячейки с месяцем; прежний бэк параметр не читает — блока нет
                const _basisOn = this.store.setting('fe.ux.cellPassportBasis', true) !== false   // IE 2026 10 09 / ODOO-5800 (этап 2 «Снимок основания ЗП»): блок BASIS — у ячейки с месяцем; прежний бэк параметр не читает — блока нет
                // IE 2026 10 09 / ODOO-345618 (F2): у строки в цикле согласования паспорт запрашивается и БЕЗ колонки даты (итоговая колонка, колонка-мера): бэк строит раздел APPROVAL по измерениям строки
                // (REPORT-E п. 2: «ячейка без месяца — блок возвращается и при state: no version / month»); month пустой — прочих секций бэк не строит. Режим fe.cellForm.approval = off — запроса нет
                const _apprAp = (!_per && !_objOn && dataItem && this.approval_on() && approvalFormMode((k, d) => this.store.setting(k, d)) !== 'off') ? approvalOf(dataItem) : null
                if ((!_per && !_objOn && !(_apprAp && _apprAp.in_cycle !== false)) || !dataItem) return
                const month = _per ? _per.month : '', _months = _per ? _per.months : null
                const where = [], seen = new Set()
                // IE 2026 10 15 / ODOO-5800 (Igor, dev02: у групповой строки «LBE ковзний · 2026-11 · 3 000» нет блока VERSIONS, у дочерней «LBE ковзний / Україна» есть): отбор самого узла
                // лэйаута (measure in [LBE_rolling]) лежит в _DLRow.where_block, не в where — мера группы одной меры (и тип меры) из него тоже уходит бэку (cellPassport_blockDims);
                // поля строки и предков — первыми, как прежде. Выключатель fe.ux.cellPassportBlockMeasure (дефолт ВКЛ; false — прежнее: только поля строки)
                const _blkOn = this.store.setting('fe.ux.cellPassportBlockMeasure', true) !== false   // IE 2026 10 15 / ODOO-5800
                // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: паспорт — отбор полосы): отбор узла раскладки строки и её предков (_DLRow.where_block, utils/cellFormGate.cellPassport_whereBlockOf) —
                // бэку params.where_block (PR #530: движения ячейки — только строки полосы). Выключатель fe.ux.cellPassportWhereBlock (дефолт ВКЛ; false — прежний запрос и количества)
                const _wbOn = this.store.setting(CELL_PASSPORT_WHERE_BLOCK_FLAG, true) !== false, _wbRows = _wbOn ? [] : null   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: паспорт — отбор полосы)
                this.cellPassport_rowWhere(dataItem, irow, where, seen, _blkOn, _wbRows)   // IE 2026 10 22 / ODOO-5800 (unsaved): тот же сбор, вынесен в метод — нужен и правкам других строк (overrides)
                if (!where.length) return
                const seq = this._cellPassportSeq = (this._cellPassportSeq || 0) + 1
                dropdown.cell_passport_loading = true
                // IE 2026 09 22 / ODOO-5800 (Igor: «в свёрнутом блоке документов … статистика документов по видам и статусам»): документы ячейки (спутник doc_ids) — тем же запросом:
                // бэк (cell_passport.docs_info) возвращает название записи, вид и статус; сегмент / статус документов 1С известны строкам источника (record._doc.doc_links.docs)
                const params = { where, month }
                if (month && this.planApproval_applies()) dropdown.cell_plan_scope = { where: where.map(w => (Array.isArray(w) ? w.slice() : w)), month }   // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B); ревью: только в Балансе (planApproval_applies), не во всех отчётах при флаге
                if (_months) params.months = _months   // IE 2026 10 08 / ODOO-5800: месяцы периода итога (прежний бэк параметр не читает — паспорт первого месяца)
                if (_wbRows) { const _wb = cellPassport_whereBlockOf(_wbRows); if (_wb.length) params.where_block = _wb }   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: паспорт — отбор полосы)
                if (_objOn) params.objects = 1   // IE 2026 10 08 / ODOO-5800: блок OBJECTS — объекты за ячейкой (прежний бэк параметр не читает — блока нет)
                // IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FE2 (UX1 G-02): единицы строки, которые отчёт уже знает (пилюля строки), — бэку раздела APPROVAL: строка-итог M03 без полей нижнего шага иначе остаётся без раздела.
                // Прежний бэк параметр не читает. Выключатель fe.ux.approvalCellUnits (дефолт ВКЛ)
                if (dataItem && this.approval_on() && this.store.setting('fe.ux.approvalCellUnits', true) !== false) { const _au = approvalUnitIds(approvalOf(dataItem)); if (_au.length) params.approval_units = _au }
                if (_versOn && month) params.versions = 1   // IE 2026 10 15 / ODOO-5800 (ЗП-№7, этап 4): блок VERSIONS (cell_passport.versions_block)
                const _planOn = this.store.setting('fe.cellForm.planPassport', true) !== false   // IE 2026 10 22 / ODOO-5800: блоки страниц планов — params.plan = 1 (бэк plan_cell_passport; прежний бэк параметр не читает — ключа нет)
                if (_planOn && month) params.plan = 1   // IE 2026 10 22 / ODOO-5800
                // IE 2026 10 22 / ODOO-5800 (unsaved; Igor 22.10: «после внесения корректировки, до ещё записи в базу … актуальные столбики и графики версий в плане и отклонения от того,
                // что сверху, снизу, что на текущем уровне»): незаписанные правки грида (undo-стек: та же выборка, что у Save; utils/cellPassportOverrides) — бэку params.overrides:
                // блоки PLANS / CORRECTIONS (plan_cell_passport.apply_overrides) и VERSIONS (apply_versions_overrides) считаются с правками, ответ несёт unsaved — форма помечает
                // «незбережено». Прежний бэк параметр не читает. Выключатель fe.cellForm.passportUnsaved (дефолт ВКЛ)
                if (month && (_planOn || _versOn) && this.cellPassport_unsavedOn()) { const _ov = this.cellPassport_overrides(dataItem); if (_ov.length) params.overrides = _ov }   // IE 2026 10 22 / ODOO-5800 (unsaved)
                if (_basisOn && month) params.basis = 1   // IE 2026 10 09 / ODOO-5800: блок BASIS — последний открытый снимок основания ЗП документа ячейки против текущих строк узла (cell_passport.basis)
                // IE 2026 10 01 / ODOO-5800 (пакет G, DESIGN §1): story ячейки (проблема / причины / решения / сравнение / риски / сигналы) — params.story = 1; прежний бэк параметр не читает —
                // story в ответе нет, блоков нет. Выключатель fe.ux.cellStory (false — параметр не уходит, блоков нет)
                const _storyOn = this.cellStory_on()
                if (_storyOn) params.story = 1
                // IE 2026 09 25 / ODOO-5800 (Igor, скрины «Баланс постачання та попиту»: «стоя на итоговой ячейке я не вижу графика запасов, который вижу на ячейке ниже … при одной
                // подчинённой строке можно показывать всё то же самое, что и на детальной; при нескольких — график по итоговым данным подчинённых строк»): у итоговой строки без
                // субъекта в измерениях — подчинённые строки группы (пары объект / субъект, число детальных строк) в params.group; бэк (cell_passport.GROUP_SWITCH) строит паспорт
                // единственного узла либо сводный. Бэк без поддержки параметр не читает — ответ прежний, форма прежняя. Выключатель fe.cellForm.groupRows
                const _grpOn = this.store.setting('fe.cellForm.groupRows', true) !== false
                if (_grpOn) { const _grp = this.cellPassport_group(dataItem, where); if (_grp) params.group = _grp }
                // IE 2026 10 08 / ODOO-5800: у итога периода — объединение спутников doc_ids / doc_qty / doc_st ячеек месяцев периода (cellPassport_mergeDocCells) вместо одной ячейки
                const _docHit = !this.sameDoc_on() ? null : (_months ? (() => { const _mc = cellPassport_mergeDocCells(_months.map(m => dataItem[m + '-01'])); return _mc ? { date: month, cell: _mc } : null })() : this.sameDoc_cellOf(dataItem, col_binding))
                if (_docHit) {
                    const DL = this.WIDGET?.record?._doc?.doc_links || {}, D = DL.docs || {}
                    params.doc_ids = _docHit.cell.doc_ids.slice(0, 32).map(String)
                    params.doc_segs = {}; params.doc_statuses = {}
                    for (const id of params.doc_ids) { const x = D[id]; if (Array.isArray(x)) { if (x[0]) params.doc_segs[id] = x[0]; if (x[1]) params.doc_statuses[id] = x[1] } }
                    // IE 2026 10 05 / ODOO-5800 (fe-83): статусы документа по строкам источника, спустившимся в ЭТУ ячейку (спутник doc_st), — бэк берёт их вместо статуса первой строки
                    // документа на весь отчёт; прежний бэк параметр doc_cell_statuses не читает — ему в doc_statuses уходит первый статус строк ячейки
                    const _cs = cellDocs_cellStatuses(_docHit.cell, params.doc_ids)
                    if (Object.keys(_cs).length) { params.doc_cell_statuses = _cs; for (const id of Object.keys(_cs)) params.doc_statuses[id] = _cs[id][0] }
                }
                this.store.executeWidgetMethod({ WIDGET: this.WIDGET }, { command: 'executeWidgetMethod', method: 'cell_passport', params,
                    record_sendToBackend_exclude: ['_doc'], widget_sendToBackend_exclude: ['view'], no_del_last_backend_action: true,
                    _response_callback: (answer) => {
                        // IE 2026 09 21 / ODOO-5800 (приёмка ie-bio7, checks/REPORT.md «Попутный дефект»): ответ паспорта нужен только форме ячейки — это не updateDoc записи виджета.
                        // Запрос везёт обёртку { WIDGET } без методов компонента, а ветка updateDoc стора безусловно зовёт vueObj.content_Changed() → TypeError на КАЖДОЕ открытие
                        // формы с паспортом (замер: 6 из 6), остаток разбора ответа обрывался. Команду ответа снимаем — как store.metricChipG_dict; заглушка content_Changed
                        // не годится: updateDoc с пустым updates повёл бы set_nonEmptyWidget / sync_WORKSPACE на каждое открытие формы. Выключатель fe.ux.cellPassportAnswerOnly
                        if (answer && this.store.setting('fe.ux.cellPassportAnswerOnly', true) !== false) { answer.command = ''; delete answer.updates }
                        if (seq !== this._cellPassportSeq) return
                        dropdown.cell_passport_loading = false
                        dropdown.cell_passport = (answer?.cell_passport?.sections || []).filter(s => s && (s.rows || []).length)
                        { const _fb = answer?.cell_passport?.form_blocks; dropdown.cell_form_blocks = (Array.isArray(_fb) && _fb.length) ? _fb.map(String) : null }   // IE 2026 10 15 / ODOO-5800 (п. 2 формы ячейки): коды блоков меры — Dropdown.cellForm_blockOn прячет остальные (бэк их не строит; formula / rules — из грида)
                        // IE 2026 09 25 / ODOO-5800 (Igor: «в форме-дропдаун для LBE нужно показать параметры утверждения и кто и когда последний корректировал — как в M03»):
                        // секция утверждения LBE-плана (kind 'approval' — блок APPROVAL формы) и корректировки ячейки из документа M03 (cell_passport.corrections в формате
                        // correctionInfo_forCell) — в блок CORRECTION рядом с правками сессии; прежние строки паспорта (passport: true) снимаются, свои остаются.
                        // Выключатель fe.cellForm.lbeApproval (false — ни секции, ни корректировок: прежний вид)
                        const _lbeOn = this.store.setting('fe.cellForm.lbeApproval', true) !== false
                        if (!_lbeOn) dropdown.cell_passport = dropdown.cell_passport.filter(s => s.kind !== 'approval')
                        const _corr = _lbeOn ? answer?.cell_passport?.corrections : null
                        if (Array.isArray(_corr) && _corr.length) dropdown.correction_info = [...(dropdown.correction_info || []).filter(c => c && !c.passport), ..._corr.map(c => ({ ...c, passport: true }))]
                        dropdown.cell_series = (this.store.setting('fe.ux.cellMiniChart', true) !== false && answer?.cell_passport?.series && Array.isArray(answer.cell_passport.series.rows)) ? answer.cell_passport.series : null   // IE 2026 09 22 / ODOO-5800 (Igor: мини-график в форме)
                        dropdown.cell_gantt = (this.store.setting('fe.ux.cellGantt', true) !== false && answer?.cell_passport?.gantt && Array.isArray(answer.cell_passport.gantt.items)) ? answer.cell_passport.gantt : null   // IE 2026 09 22 / ODOO-5800 (Igor: Гант в DETAILS · MOVEMENTS)
                        // IE 2026 09 25 / ODOO-5800: итоговая строка — что показано (mode 'single' — единственный узел группы, 'sum' — сумма узлов); ответа без group (прежний бэк) — пометки нет
                        dropdown.cell_objects = _objOn ? cellObjects_model(answer?.cell_passport?.objects) : null   // IE 2026 10 08 / ODOO-5800: блок OBJECTS (utils/cellObjects)
                        { const _pd = answer?.cell_passport?.plan_doc; dropdown.cell_plan_doc = (this.store.setting('fe.ux.planDocsRows', true) !== false && _pd && typeof _pd === 'object' && !Array.isArray(_pd) && _pd.id) ? _pd : null }   // IE 2026 10 15 / ODOO-5800 (ЗП-№5, P4): блок PLAN APPROVAL (utils/cellPlanDoc строит модель в Dropdown); прежний бэк ключа не шлёт — блока нет
                        { const _pv = answer?.cell_passport?.versions; dropdown.cell_versions = (_versOn && month && _pv && typeof _pv === 'object' && _pv.state === 'ok' && Array.isArray(_pv.series)) ? _pv : null }   // IE 2026 10 15 / ODOO-5800 (ЗП-№7, этап 4): блок VERSIONS (utils/cellVersionsChart строит модель в Dropdown)
                        dropdown.cell_basis = (_basisOn && month) ? cellBasis_model(answer?.cell_passport?.basis) : null   // IE 2026 10 09 / ODOO-5800: блок BASIS (utils/cellBasis)
                        { const _fd = answer?.cell_passport?.fix_dates; dropdown.cell_fix_dates = (fixDates_on((k, d) => this.store.setting(k, d)) && _fd && typeof _fd === 'object' && !Array.isArray(_fd)) ? _fd : null }   // IE 2026 10 28 / ODOO-5800 (заказ Игоря: раздел Fix dates в форме ячейки): раздел FIX DATES (utils/cellFixDates строит модель в Dropdown); прежний бэк ключа не шлёт — раздела нет; флаг fe.ux.cellFixDates
                        { const _pp = answer?.cell_passport?.plan; dropdown.cell_plan = (_planOn && month && _pp && typeof _pp === 'object' && _pp.state === 'ok') ? _pp : null }   // IE 2026 10 22 / ODOO-5800: блоки PLANS / CORRECTIONS / SIGNALS (CellPlanPassport.vue строит модель)
                        // IE 2026 10 09 / ODOO-345618 (заказ Игоря: согласование на сегменте): паспорт ячейки несёт approval {chain, edits, segment, locked, reason} — у ячеек строки сегмента с политикой;
                        // прежний бэк поля не присылает — раздела нет. Выключатели fe.ux.approval / fe.cellForm.approval — в Dropdown (apprSec)
                        { const _pa = answer?.cell_passport?.approval; dropdown.cell_approval = (_pa && typeof _pa === 'object' && !Array.isArray(_pa)) ? _pa : null }
                        // IE 2026 10 16 / ODOO-5800 (ЗП-20261016-2, блок v2): запасной канал контракта — approval_v2 рядом с approval в паспорте (а не внутри) — кладём внутрь, модель одна (Dropdown.apprV2)
                        { const _v2 = answer?.cell_passport?.approval_v2; if (_v2 && typeof _v2 === 'object' && !Array.isArray(_v2) && dropdown.cell_approval && !dropdown.cell_approval.approval_v2) dropdown.cell_approval = { ...dropdown.cell_approval, approval_v2: _v2 } }
                        const _grpAns = answer?.cell_passport?.group
                        dropdown.cell_group = (_grpOn && _grpAns && typeof _grpAns === 'object' && (_grpAns.mode === 'single' || _grpAns.mode === 'sum')) ? _grpAns : null
                        if (_storyOn) { try { this.cellStory_apply(dropdown, answer?.cell_passport?.story, { where, month, dataItem, irow, seq }) } catch (e) { dropdown.cell_story = null } }
                        try { this.signalTip_focusApply(dropdown) } catch (e) { /* форма закрыта */ }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p231 підказка по сигналу — проблема як у формі комірки): клик по сигналу — раскрыть его проблему, когда story пришёл   // IE 2026 10 01 / ODOO-5800: story ячейки / мок
                        // IE 2026 09 22 / ODOO-5800: документы ячейки с названием записи, видом и статусом (порядок = doc_ids); без записи — название строки источника / id
                        const _docs = answer?.cell_passport?.docs
                        if (Array.isArray(_docs) && _docs.length && Array.isArray(dropdown.cell_docs)) {
                            const T = this.WIDGET?.record?._doc?.doc_links?.titles || {}
                            // IE 2026 10 01 / ODOO-5800 (Igor: статусы и количества документов): количество документа в ячейке — спутник ячейки doc_qty (строки отчёта, точно), иначе
                            // движения паспорта (qty бэка), оба — только если в сумме не больше значения ячейки (sameDoc_qtyCheck); сырой статус исходного документа — status_raw бэка
                            const _cellQ = this.sameDoc_qtyCheck(_docHit?.cell?.doc_qty, dataItem, col_binding)
                            const _pq = {}; for (const d of _docs) if (d && d.qty != null) _pq[String(d.id)] = d.qty
                            // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: паспорт — отбор полосы): движения ячейки отобраны отбором полосы (block_where бэка применён) — первыми qty бэка docs[].qty, спутник — запасной
                            const _Q = cellDocs_qtySource(_cellQ, this.sameDoc_qtyCheck(_pq, dataItem, col_binding), _wbOn && cellPassport_blockWhereApplied(answer?.cell_passport?.block_where))   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: паспорт — отбор полосы)
                            // IE 2026 10 27 / ODOO-5800 (слово Игоря 27.10 через ie-dm7 #109544: документы без ссылки — количество и статус в блоке документов): строка без документа (d.nodoc) — своё qty бэка, когда проверенные количества пришли спутником doc_qty (в нём id nodoc нет);
                            // подсказка строки (hint бэка: число движений) и nodoc — в форму
                            // IE 2026 10 27 / ODOO-5800 (слово Игоря 27.10 через ie-dm7 #109544: количества строк регистра при спутнике doc_qty): строки регистра 1С (register:*) — тоже своё qty бэка; выключатели fe.cellForm.docQty и fe.ux.sameDocQtyCheckSkipRegister — один раз до цикла
                            const _qOpt = { on: this.store.setting('fe.cellForm.docQty', true) !== false, register: this.store.setting(SAMEDOC_SKIP_REGISTER_FLAG, true) !== false }
                            dropdown.cell_docs = _docs.map(d => ({ id: String(d.id), title: (d.title && d.title !== d.id) ? d.title : (T[d.id] || String(d.id)), kind: d.kind || null, status: d.status || null, link: d.link || null,
                                qty: cellDocs_rowQty(d, _Q, _qOpt), status_raw: d.status_raw ? String(d.status_raw) : '', hint: d.hint ? String(d.hint) : '', nodoc: d.nodoc || null }))
                            dropdown.cell_docs.forEach((x, i) => Object.assign(x, cellDocsMore_extra(_docs[i])))   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #114865: «ще N документів» — догрузка cell_docs_more): clickable / more хвоста
                            // IE 2026 10 01 / ODOO-5800: единственный документ ячейки без количества (прежний бэк) — его вклад = значение ячейки
                            if (dropdown.cell_docs.length === 1 && dropdown.cell_docs[0].qty == null && this.store.setting('fe.cellForm.docQty', true) !== false) {
                                const [_m, _f] = String(col_binding || '').split('.'); const _v = _f ? dataItem?.[_m]?.[_f] : null
                                if (typeof _v === 'number' && isFinite(_v)) dropdown.cell_docs[0].qty = _v
                            }
                        } else if (Array.isArray(dropdown.cell_docs)) dropdown.cell_docs = cellDocs_restore(dropdown.cell_docs)   // IE 2026 10 05 / ODOO-5800 (fe-83): паспорт без документов — предварительный статус возвращается
                        // IE 2026 09 21 / ODOO-5800 (приёмка: форма открывалась вниз ДО прихода DETAILS, вырастала на 190–340 px и уходила за низ окна): пересмотр стороны и предела
                        // высоты после роста содержимого (Dropdown.fit_review, fe.ux.dropdownFitViewport)
                        this.$nextTick(() => { try { dropdown.fit_review?.() } catch (e) { /* форма уже закрыта */ } })
                    } })
            } catch (e) { dropdown.cell_passport_loading = false }
        },
        // IE 2026 09 25 / ODOO-5800 (Igor: паспорт итоговой строки): подчинённые строки группы для cell_passport — {nodes: [[объект, субъект], …] в порядке строк (без повторов,
        // не больше 200), rows: число детальных строк, total: сколько пар было} либо null (строка не группа, в измерениях строки уже есть субъект, у подчинённых нет субъектов).
        // Подчинённые — дерево данных строки (дети childItemsPath, любая глубина), а не видимые строки грида: свёрнутые группы и строки, спрятанные фильтром, тоже входят в
        // число группы. Memo-строки «· of which …» (вне итога родителя: _DLRow.memo / total_excluded) не считаются. Объект пары — ближайший в цепочке строк, иначе объект строки
        // ---- IE 2026 10 01 / ODOO-5800 (Igor: «делай под ключ» — форма ячейки «проблема → причина → решение → деньги», DESIGN §1 / пакет G) ----
        // story ячейки: ответ бэка cell_passport.story (params.story = 1) → dropdown.cell_story; флаг вкладки fe.ux.cellStoryMock задан — мок СИЛЬНЕЕ ответа бэка
        // ('auto' — по названию строки и месяцу, либо id кейса '1'…'5', '4b', '0'; feSettings / URL ?fe.ux.cellStoryMock=auto; нет подходящего мока — ответ бэка),
        // без story в ответе и без флага блоков нет. Решения: Simulate — правки
        // sim_request.edits в штатную симуляцию грида (origin 'story': бэк не заносит их в правки пользователя, ответ — оценка), Save не загорается;
        // Check with engine — метод виджета cell_story_effect (изолированная сессия движка, БД не пишет); Reset preview — обратные правки.
        // Выключатели fe.ux.cellStory, fe.cellForm.storyPreview
        cellStory_on() { try { return this.store.setting('fe.ux.cellStory', true) !== false } catch (e) { return false } },
        cellStory_apply(dropdown, raw, ctx) {
            const cellKey = JSON.stringify([ctx.where, ctx.month])
            dropdown._storyCell = cellKey
            dropdown._storyCtx = { where: ctx.where, month: ctx.month }
            try { story_refsApply(raw, sigNames_fromRules(this.attr?.metric_rules)) } catch (e) { /* названия бэка остаются */ }   // IE 2026 10 04 / ODOO-5800 (fe-78) (модель сигналов v2): подписи звеньев — названия записей по id-полям
            // IE 2026 10 03 / ODOO-5800 (CONTRACT v4 §4, заказ координатора): бэк кладёт в КАЖДЫЙ story блок stock_check {enabled, tol_abs, tol_pct, v5: tol_turn_pct} — допуск и выключатель критической ошибки расхождения запаса.
            // Блок идёт в форму отдельным полем (cell_stock_check): story_normalize превращает пустой ответ (проблем и сигналов нет — как раз случай «механизм выключен») в null, и блок пропал бы вместе с ним.
            // Запоминаем и в гриде (_stockCheck): примечание-формула под ячейкой (influence_formulaShow) сверяет формулу без story — до первого ответа с блоком там умолчания; блока в ответе нет (старый бэк) — всё как было
            const _ck = story_stockCheck(raw)   // действующие значения блока ответа либо null (блока нет)
            dropdown.cell_stock_check = _ck
            if (_ck) this._stockCheck = _ck
            dropdown.cell_story_previewOn = !!this.store.get_value(this.WIDGET?.record, 'doc.params.online_balance_preview')
            const show = (st) => {
                dropdown.cell_story = st
                dropdown.cell_story_preview = (st && this._storyPreview && this._storyPreview.cell === cellKey) ? this._storyPreview.id : ''
                this.$nextTick(() => { try { dropdown.fit_review?.() } catch (e) { /* форма закрыта */ } })
            }
            const st = story_normalize(raw)   // IE 2026 10 01 / ODOO-5800 (стык с бэком story-int): state 'ok' | 'none' (проблемы нет — только Signals); иначе null
            const mockId = this.store.setting('fe.ux.cellStoryMock', '')
            const mockOn = !(mockId === '' || mockId === null || mockId === undefined || mockId === false)
            if (!mockOn) { if (st) show(st); return }
            // IE 2026 10 01 / ODOO-5800: флаг мока задан явно — мок сильнее ответа бэка (бэк dev02 уже отдаёт story по каждой ячейке, иначе до мока не добраться);
            // нет подходящего мока / чанк не загрузился — ответ бэка как есть
            import('@/utils/cellStoryMocks').then(mod => {
                if (ctx.seq !== this._cellPassportSeq) return   // форма уже на другой ячейке
                // моки — реальные ответы бэка по 8 ячейкам (int_out): 'auto' — по названию строки и месяцу ячейки; effects — записанные ответы cell_story_effect
                const hit = story_mockPick(mod.CELL_STORY_MOCKS || mod.default, mockId, this.cellStory_rowText(ctx.dataItem, ctx.irow), ctx.month)
                if (!hit) { if (st) show(st); return }
                const w = {}; for (const [k, v] of ctx.where || []) if (!(k in w)) w[k] = v
                const st2 = story_normalize(story_mockResolve(hit.story, { object: w.object ?? w.calc_object, subject: w.subject ?? w.calc_subject, month: ctx.month }))
                if (st2) { st2._mock = hit.id; st2._mockEffects = hit.effects || null; show(st2) } else if (st) show(st)
            }).catch(() => { if (ctx.seq === this._cellPassportSeq && st) show(st) })
        },
        // текст строки ячейки и её предков (названия объекта / узла) — для выбора мока 'auto'
        cellStory_rowText(dataItem, irow) {
            const out = []
            const take = (it) => { if (!it || typeof it !== 'object') return; for (const v of Object.values(it)) { if (typeof v === 'string') out.push(v); else if (v && typeof v === 'object' && !Array.isArray(v)) { if (typeof v.title === 'string') out.push(v.title); if (typeof v.name === 'string') out.push(v.name) } } }
            // показанный текст первых колонок строки — названия объекта / узла из справочника (в dataItem — только id)
            const shown = (r) => { for (let c = 0; c < 3; c++) { try { const v = this.flex.getCellData(r, c, true); if (v) out.push(String(v)) } catch (e) { /* колонки нет */ } } }
            take(dataItem); shown(irow)
            const rows = this.flex?.rows || []
            let lvl = rows[irow]?.level
            for (let i = irow - 1; i >= 0 && lvl > 0; i--) { const r = rows[i]; if (r && r.level < lvl) { lvl = r.level; take(r.dataItem); shown(i) } }
            // названия объектов чипса стола (строки отчёта с одним объектом его названия не несут)
            try { const wsWhere = this.store.get_value(this.store.WORKSPACES?.[this.WIDGET?.workspace]?.record || this.WIDGET?.workspace_record || {}, 'doc.params.WHERE', []) || []
                for (const r2 of wsWhere) if (r2 && r2.use !== false && /object/.test(String(r2?.leftValue?.value || ''))) for (const a2 of r2.attrs || []) if (a2?.rightValue?.valueStr) out.push(String(a2.rightValue.valueStr)) } catch (e) { /* без чипсов */ }
            return out.join(' \u0001 ').slice(0, 20000)
        },
        // колонка «с решением» из эффекта решения (бэк прислал compare.with только для лучшего рычага; после Check with engine — по эффекту движка):
        // та же арифметика, что compare_with бэка — utils/cellStory.story_compareWith (IE 2026 10 01 / ODOO-5800)
        cellStory_with(st, sol) { return story_compareWith(st?.compare?.now || {}, sol, st?.problem?.kind) },
        // ячейка формы для бэка: объект / узел — из измерений строки (where), месяц колонки, страна (цена расхода по стране)
        cellStory_cell(dropdown) {
            const c = dropdown?._storyCtx || {}, w = {}
            for (const [k, v] of c.where || []) if (!(k in w)) w[k] = v
            return { object: w.object ?? w.calc_object ?? '', subject: w.subject ?? w.calc_subject ?? '', month: c.month || '', country: w.country ?? '' }
        },
        cellStory_preview(dropdown, sol) {
            try {
                if (this.store.setting('fe.cellForm.storyPreview', true) === false) return
                const edits0 = sol?.sim_request?.edits || []
                if (!edits0.length) return
                if (!this.store.get_value(this.WIDGET?.record, 'doc.params.online_balance_preview')) {
                    this.store.show_notification({ text: t('Turn on Simulation mode in the report settings'), status: 'warning', timeout: 6000 }); return
                }
                if (this._storyPreview) this.cellStory_reset(dropdown)   // другое решение — сначала снять прежнее превью
                const edits = edits0.slice(0, 6).filter(e => e && e.object && e.subject && /^\d{4}-\d{2}-\d{2}/.test(String(e.date || '')) && Number(e.delta))
                if (!edits.length) return
                for (const e of edits) this.cellStory_queue(e, Number(e.delta))
                this._storyPreview = { cell: dropdown._storyCell, id: sol.id, edits }
                dropdown.cell_story_preview = sol.id
                const st = dropdown.cell_story
                if (st?.compare && !(st.compare.with && st.compare.with.solution_id === sol.id && !st.compare.with._preview)) { const w = this.cellStory_with(st, sol); if (w) st.compare.with = { ...w, _preview: true } }   // IE 2026 10 01 / ODOO-5800: без эффекта колонки нет
            } catch (e) { console.error('cell story: preview failed', e) }
        },
        // правка решения → очередь штатной симуляции грида (sim_queueEdit): мера (IN), вид движения, следующая дата и origin 'story' — как в sim_request бэка
        cellStory_queue(e, delta) {
            this.sim_queueEdit({ object: e.object, subject: e.subject, workcenter: e.workcenter || undefined }, String(e.date).slice(0, 10), e.role || 'link', delta,
                { measure_type: e.measure_type || undefined, measure: e.measure || undefined, date_next: e.date_next || undefined, origin: 'story' })   // IE 2026 10 01 / ODOO-5800: + measure
        },
        cellStory_reset(dropdown) {
            const p = this._storyPreview
            if (!p) return
            this._storyPreview = null
            for (const e of p.edits || []) this.cellStory_queue(e, -Number(e.delta))
            if (dropdown) {
                dropdown.cell_story_preview = ''
                const cmp = dropdown.cell_story?.compare
                if (cmp && cmp.with && cmp.with._preview && cmp.with.solution_id === p.id) cmp.with = null
            }
        },
        // ответ симуляции на превью решения: правок пользователя нет — Save не активна (оценка, сохранять нечего)
        cellStory_saveOff() {
            const user = Object.values(this.changesStack || {}).filter(rs => rs && ((rs.method === 'val' && !rs.indirect && !rs.related) || (rs.method === 'aggEdit' && rs.user)))
            const structural = (this.undoStack || []).some(a => a && a.col_binding == null)
            if (!user.length && !structural && (this.modified || this._roCaptured)) this.noop_unmodified()
        },
        // «Check with engine»: метод виджета cell_story_effect — params РОВНО как принимает бэк (cell_story_solutions.engine_effect): edits решения,
        // cell {object, subject, month, country}, problem {kind, qty, period_from, period_to}, solution_id. Ответ: effect (kind engine) → эффект решения и колонка
        // «с решением»; note / pre_edit_changes / virtual_docs / missing_docs / ms — заметки движка у решения (sol._engine) для блока «сейчас / с решением».
        // effect null («no balance change») — уведомление; state off / error / no version — уведомление с текстом состояния. IE 2026 10 01 / ODOO-5800
        cellStory_effect(dropdown, sol) {
            const st = dropdown?.cell_story
            if (!st || !sol || !sol.sim_request || sol._engineBusy) return
            sol._engineBusy = true
            const done = (r) => {
                sol._engineBusy = false
                if (dropdown.cell_story !== st) return
                sol._engine = { note: r.note || '', pre_edit_changes: r.pre_edit_changes || {}, virtual_docs: r.virtual_docs || [], missing_docs: r.missing_docs || [], identity: r.identity || null, ms: r.ms, ms_sim: r.ms_sim }
                if (r.effect) sol.effect = { ...r.effect, kind: 'engine' }
                if (st.compare) st.compare.with = this.cellStory_with(st, sol)
                if (!r.effect) this.store.show_notification({ text: t('Check with engine: the plan does not change with this solution') + (r.note ? ' (' + t(String(r.note)) + ')' : ''), status: 'info', timeout: 6000 })
            }
            if (st._mock) {   // мок — записанный ответ движка по этому решению (int_out), иначе оценка как движок
                const rec = st._mockEffects && st._mockEffects[sol.id]
                setTimeout(() => done(rec && rec.state === 'ok' ? rec : { state: 'ok', effect: { ...(sol.effect || {}), kind: 'engine' }, note: '', ms: 0 }), 700)
                return
            }
            const guard = setTimeout(() => { if (sol._engineBusy) sol._engineBusy = false }, 30000)
            try {
                this.store.executeWidgetMethod({ WIDGET: this.WIDGET }, { command: 'executeWidgetMethod', method: 'cell_story_effect',
                    params: { edits: sol.sim_request.edits, cell: this.cellStory_cell(dropdown), solution_id: sol.id,
                        problem: st.problem ? { kind: st.problem.kind, qty: st.problem.qty, period_from: st.problem.period_from, period_to: st.problem.period_to } : {} },
                    record_sendToBackend_exclude: ['_doc'], widget_sendToBackend_exclude: ['view'], no_del_last_backend_action: true,
                    _response_callback: (answer) => {
                        if (answer) { answer.command = ''; delete answer.updates }   // ответ нужен только форме (как у cell_passport)
                        clearTimeout(guard)
                        const r = answer?.cell_story_effect
                        if (r && r.state === 'ok') done(r)
                        else {
                            sol._engineBusy = false
                            const state = r && r.state ? String(r.state) : ''
                            const why = state === 'off' ? t('switched off on the backend') : state.slice(0, 120)
                            this.store.show_notification({ text: t('Check with engine: no result for this solution') + (why ? ' (' + why + ')' : ''), status: 'warning', timeout: 8000 })
                        }
                    } })
            } catch (e) { clearTimeout(guard); sol._engineBusy = false }
        },
        cellPassport_group(dataItem, where) {
            try {
                const key = this.attr?.childItemsPath || 'attrs'
                const w0 = {}; for (const [k, v] of (where || [])) if (!(k in w0)) w0[k] = v
                if (w0.subject !== undefined) return null
                const own = (it) => { const o = {}; for (const w of (it?._DLRow?.where || [])) { const k = String(w?.leftValue?.value ?? w?.leftValue ?? ''); const v = w?.rightValue?.value ?? w?.rightValue
                    if (k && v !== undefined && v !== null && v !== '' && typeof v !== 'object' && !(k in o)) o[k] = v } return o }
                const kids = (it) => (Array.isArray(it?.[key]) ? it[key] : []).filter(ch => ch && typeof ch === 'object' && !ch._DLRow?.memo && !ch._DLRow?.total_excluded)
                if (!kids(dataItem).length) return null
                const MAX = 200, pairs = [], seen = new Set(); let rows = 0, total = 0
                const walk = (it, obj, depth) => {
                    for (const ch of kids(it)) {
                        const o = own(ch), ob = o.object !== undefined ? o.object : obj
                        if (o.subject !== undefined) { const k = String(ob ?? '') + '\u0001' + String(o.subject); if (!seen.has(k)) { seen.add(k); total++; if (pairs.length < MAX) pairs.push([ob ?? null, o.subject]) } }
                        const sub = kids(ch)
                        if (!sub.length) rows++
                        else if (depth < 16) walk(ch, ob, depth + 1)
                    }
                }
                walk(dataItem, w0.object, 0)
                return pairs.length ? { nodes: pairs, rows, total } : null
            } catch (e) { return null }
        },
        // IE 2026 09 21 / ODOO-5800: детали ключа в ячейке объектом (период, количество, пояснения причины) — для формы ячейки
        metricFill_detail(st, dataItem, col_binding, attr_col, key) {
            const ids = this.metricFill_ids(st, dataItem, col_binding, attr_col)
            return ids ? metricData_detail(st.ix, ids, key, st.h4) : null
        },
        // оформление задания скрыто: ключ его метрики выключен колонкой Use либо действует чипс со снятым «Show other formatting», а задание — не выбранной
        // им метрики (или вовсе не метрики). Скрытое задание по-прежнему СРАБАТЫВАЕТ (занимает группу «первое совпавшее», видно в форме ячейки,
        // format / align / isReadOnly / source действуют — иначе «12 %» превратится в 0,12): не кладутся только классы и стиль
        metricFmt_hides(task, dataItem, col_binding) {
            const st = this.metricFmt_state()
            if (!st) return false
            // IE 2026 09 20 / ODOO-5800 (чипс условного оформления): флаг «Show other formatting» бывает снят у чипса метрик, у чипса оформления либо у обоих —
            // оформление задания остаётся, если его выбрал ХОТЯ БЫ ОДИН из чипсов со снятым флагом (метрика — по ключу, правило — по rule_id)
            const anyOnly = !!st.only || !!st.onlyFmt
            if (!task.metric_key) return anyOnly && !(st.onlyFmt && formatChip_keepsTask(task, st.onlyFmt))
            const key = this.metricCell_key(task, dataItem, col_binding)
            if (st.off.length && metricFormat_isOff(st.off, key)) return true
            if (!anyOnly) return false
            if (st.only && metricChip_matchKey(key, st.only)) return false
            return !(st.onlyFmt && formatChip_keepsTask(task, st.onlyFmt))
        },
        // отбор чипса метрик этого грида при снятом «Show other formatting» (свой действующий чипс, иначе зеркало глобального); null — флаг стоит
        metricFmt_onlyDoc() {
            if (!this.store.metricSelector_on() || !this.metricChip_on()) return null
            const own = (this.CHIPS || []).find(c => c && c.segment === 'CHIP-Metric' && c.meta?.use !== false && !metricChip_isEmpty(c.doc))
            const chip = own || this.metricMirror_chip()
            return chip && chip.showOtherFormats === false && !metricChip_isEmpty(chip.doc) ? chip.doc : null
        },
        // список выключенных ключей либо флаг чипса сменились — оформление пересчитать; у виджета с оформлением на бэке красит бэк — перечитать с паузой
        // reload — состояние сменил пользователь (клик по Use, флаг чипса): у виджета с оформлением на бэке красит бэк — перечитать; состояние при открытии
        // (сохранённый чипс со снятым флагом) бэк уже учёл — перечитывать нечего
        metricFmt_changed(reload = false) {
            this._metricFmtMemo = null
            this.cf_cache?.clear()
            try { this.flex?.invalidate() } catch (e) { /* грид ещё не готов */ }
            if (reload && this.attr?.name === 'dataSheet' && this.WIDGET?.record?.doc?.params?.conditional_format_backend) {
                clearTimeout(this._metricFmtReload_t)
                this._metricFmtReload_t = setTimeout(() => { try { this.$refs.chips?._reload_widget?.() } catch (e) { /* виджет закрыт */ } }, this.store.setting('fe.data.chipPlaceReloadMs', 450))
            }
        },
        metricUse_schedule() {
            clearTimeout(this._metricUse_t)
            this._metricUse_t = window.$cg.setTimeout(this, 'AttrGrid.metricUse_apply', () => this.metricUse_apply(), 0)
        },
        // клики по use (в том числе по диапазону строк) → новый отбор чипса: включить — ключ в комбинации, выключить — убрать,
        // развернув пару Grade / Metric в явные комбинации; затем свёртка (все правила оценки выбраны → одна запись Grade)
        metricUse_apply() {
            const dg = this.metricUse_dataGrid()
            if (!dg || !this.flex) { this.metricUse_sync(); return }
            const rules = dg.attr.metric_rules
            // IE 2026 09 20 / ODOO-5800 (находка ie-dm7: клик Selector по строке ключа с неизвестным горизонтом откатывался):
            // отбор меняют только строки, которые пользователь переключил (флажок расходится с показом прежнего отбора) — metricChip_selApply
            const b = this.metricSel_binding(), rows = []   // IE 2026 09 19 / ODOO-5800 (Igor: Use вкладки Metrics = оформление метрики видно в таблице, состав чипса — колонка Selector)
            for (const row of this.flex.rows) { const it = row.dataItem; if (it && it.key) rows.push({ key: it.key, on: this.store.isTrue(it[b]) }) }
            const doc = metricChip_selApply(dg.metricChip_docNow() || {}, rows, rules)
            dg.$refs.chips?.metricChip_setDoc(metricChip_compact(doc, rules), { fromSelector: true })   // IE 2026 10 07 / ODOO-5800: новый чипс от селектора — с «Show rows without matches»
            this.metricUse_sync()   // если отбор не изменился (чипс выключен настройкой) — вернуть use как есть
        },
        // ---- IE 2026 09 19 / ODOO-5800 (Igor: «в форме дропдаун для ячейки показывать не формат, а метрики (если формат связан с ними) с
        // чекбоксом, как в чипсе метрик, по которому будет создан / обновлён чипс метрик») ----
        // Метрики ЯЧЕЙКИ: ключи метрик строки (_DLRow.metrics — ставит бэк), относящиеся к этой ячейке:
        //   · сработавшие на ячейке задания оформления с metric_key (бэк 255bfb855) — точный ответ фронтового режима, в т.ч. правил по
        //     значению ячейки (колонки дат отчёта);
        //   · словарь attr.metric_rules: цель правил ключа — это поле (fields) либо вся строка (row) — у виджетов с оформлением на бэке
        //     заданий на фронте нет, а правило без оформления задания не даёт вовсе.
        // on — ключ проходит действующий чипс метрик. Выключатель fe.ux.cellMetrics (по умолчанию вкл) — блок FORMATS как раньше.
        metricCell_list(dataItem, col_binding, attr_col, applied) {
            if (!dataItem || !this.metricChip_on() || this.store.setting('fe.ux.cellMetrics', true) === false) return []
            const rules = Array.isArray(this.attr?.metric_rules) ? this.attr.metric_rules : []
            const marks = dataItem._DLRow?.metrics
            if (!rules.length || !Array.isArray(marks) || !marks.length) return []
            const keys = []
            // IE 2026 09 19 / ODOO-5800 (Igor: измерение horizon в ключе метрики): ключ ячейки = основа задания + горизонт (metricCell_key — те же правила, что у бэка);
            // отметки с таким ключом у строки нет (горизонт фронта и бэка разошлись: агрегат свёрнутой группы колонок) — отметки строки с этой основой
            const h4 = this.metricH_on()
            for (const t of applied || []) {
                if (!t.metric_key) continue
                // IE 2026 10 01 / ODOO-5800: задание по значению в ячейке со строками деталей той же основы — метрики деталей (их горизонт), без ключа «· Past» от спутника
                const own = this.metricCell_ownKeys(t, dataItem, col_binding)
                if (own.length) { for (const k of own) if (!keys.includes(k)) keys.push(k); continue }
                const ck = this.metricCell_key(t, dataItem, col_binding)
                if (marks.includes(ck)) { if (!keys.includes(ck)) keys.push(ck) }
                else if (h4) for (const m of marks) if (metricKey_base(m) === t.metric_key && !keys.includes(m)) keys.push(m)
            }
            const b = attr_col?.binding || col_binding
            // IE 2026 09 19 / ODOO-5800 (приёмка этапа 3, моя ошибка -35): у ВСЕХ ключей словаря Purchase Balance row: true (ключ приходит и из правила
            // «value: category …», и из строк данных группы Metrics), fields пустой — запасная ветка брала все отметки строки: форма ячейки
            // «Starting inventory» показывала 3 метрики при 1 сработавшем задании, итоговая колонка — 3 при 0. Ключ с фронтовым заданием
            // (cf_rules): точный ответ — сработавшие на ячейке задания (собраны выше); строка, у которой НИ ОДНА ячейка этим правилом не
            // окрашена, — попадание целиком (то же правило, что приглушение ie-webscm7, metricRow_whole). Ключ без фронтового задания
            // (строки данных, оформление на бэке) — по цели словаря, как раньше. Выключатель fe.ux.cellMetricsExact (по умолчанию вкл)
            const exact = this.store.setting('fe.ux.cellMetricsExact', true) !== false
            const fe = exact ? this.metricCell_feKeys() : null
            let rowApplied = null
            const _mf = this.metricFill_state()   // IE 2026 09 20 / ODOO-5800 (заливка от метрик): ключ с cell_ids относится только к ячейкам из спутника — запасная ветка «цель row / fields» не для него
            for (const r of rules) {
                if (!marks.includes(r.key) || keys.includes(r.key)) continue
                if (_mf && r.cell_ids) continue
                const base = h4 ? metricKey_base(r.key) : r.key   // задания фронта несут основу ключа (три части)
                if (fe && fe.has(base)) {
                    if (!rowApplied) rowApplied = this.metricCell_rowApplied(dataItem)
                    if (!rowApplied.has(base)) keys.push(r.key)
                    continue
                }
                if (r.row || (Array.isArray(r.fields) && (r.fields.includes(b) || r.fields.includes(col_binding)))) keys.push(r.key)
            }
            const by = new Map(rules.map(r => [r.key, r]))
            const doc = this.metricChip_docNow()
            const _notesOn = this.store.setting('fe.ux.cellMetricNotes', true) !== false   // IE 2026 09 21 / ODOO-5800: пояснение причины второй строкой под метрикой
            return keys.filter(k => by.has(k)).map(k => {
                const r = by.get(k)
                const _d = (_mf && r.cell_ids) ? this.metricFill_detail(_mf, dataItem, col_binding, attr_col, k) : null
                // IE 2026 10 01 / ODOO-5800 (Igor: «синим мы хотели выделить Наднормативні початкові запаси» — в форме метрика была красной при синей ячейке): образец
                // метрики деталей без своего правила — стиль правила отчёта той же основы ключа, как у заливки ячейки (metricFill_cellTasks), а не фон оценки (grade-bad)
                const _rs = (_mf && _mf.ruleStyle && r.cell_ids && !r.rule && !r.css_layer) ? _mf.ruleStyle.get(metricKey_base(k)) : null
                // IE 2026 10 03 / ODOO-5800 (заказ Игоря: «Показать критич ош если небьется расчетный запас с фактич»): образец метрики оценки critical в форме — тем же классом, что ячейка сетки
                const _crit = (!r.css_layer && story_isCritical(r.grade || metricKey_parse(k).grade)) ? [METRIC_CRIT_CLASS] : []
                return { key: k, title: [r.grade_title, r.metric_title, r.reason_title, r.horizon ? (r.horizon_title || r.horizon) : '', r.status ? (r.status_title || r.status) : ''].filter(Boolean).join(' · '), rule: r.rule || (_rs ? (_rs.title || '') : ''),   // IE 2026 09 21 / ODOO-5800: + статус документа
                    cssClasses: (_rs ? [...(_rs.cssClasses || [])] : String(r.css || '').split(' ').filter(Boolean)).concat(_crit) /* IE 2026 10 03 / ODOO-5800 */, cssStyle: _rs ? (_rs.cssStyle || '') : (r.style || ''), rows: r.rows, on: !!doc && metricChip_matchKey(k, doc),
                    // IE 2026 09 20 / ODOO-5800 (заливка от метрик): детали ключа в ЭТОЙ ячейке (период · количество · число исходных строк) и пояснение причины
                    detail: _d ? metricData_detailText(_d) : '', comment: r.comment || '',
                    // IE 2026 09 21 / ODOO-5800 (Igor, скрин строки METRICS: «статус дока — который можно показать как бейдж»): заголовок без статуса и сам статус отдельно —
                    // форма рисует его пилюлей платформы (цвет — cssClass записи STATUS-doc из словаря бэка status_css; у прежнего бэка его нет — пилюля нейтральная)
                    titleCore: [r.grade_title, r.metric_title, r.reason_title, r.horizon ? (r.horizon_title || r.horizon) : ''].filter(Boolean).join(' · '),
                    status: r.status ? { id: r.status, title: r.status_title || r.status, css: r.status_css || '' } : null,
                    // IE 2026 09 21 / ODOO-5800 (Igor: причину показывать однозначнее — фактами; обе причины): пояснение из строк деталей ячейки (узел, документ, lead time)
                    notes: (_d && _notesOn) ? (_d.notes || []) : [] }
            })
        },
        // IE 2026 09 19 / ODOO-5800: ключи метрик, у которых есть фронтовые задания оформления (каналы cf_rules: report / sets / fields) — раз на набор правил
        metricCell_feKeys() {
            const rules = this.attr?.cf_rules
            if (this._metricFeKeysFor === rules && this._metricFeKeys) return this._metricFeKeys
            const keys = new Set()
            const take = (v) => {
                if (Array.isArray(v)) { for (const t of v) if (t && t.metric_key) keys.add(t.metric_key) }
                else if (v && typeof v === 'object') for (const x of Object.values(v)) if (Array.isArray(x)) take(x)
            }
            for (const v of Object.values(rules || {})) take(v)
            this._metricFeKeysFor = rules
            this._metricFeKeys = keys
            return keys
        },
        // ключи метрик заданий, сработавших хотя бы на одной ячейке строки (открытие формы ячейки — событие редкое, строка одна)
        metricCell_rowApplied(dataItem) {
            const out = new Set()
            for (const col of this.flex?.columns || []) {
                const a = col.binding ? this.attr_by_binding[col.binding] : null
                if (!a) continue
                for (const t of this.cf_appliedForCell(dataItem, col.binding, a)) if (t.metric_key) out.add(t.metric_key)
            }
            return out
        },
        // флажок метрики в форме ячейки: включить — ключ в отбор чипса метрик этого грида (нет чипса — создаётся), выключить — убрать
        // (пара Grade / Metric разворачивается в явные комбинации, как у колонки Use вкладки Metrics); возвращает новое состояние ключей
        metricCell_toggle(key, on, list) {
            const rules = Array.isArray(this.attr?.metric_rules) ? this.attr.metric_rules : []
            if (!rules.length || !this.$refs.chips?.metricChip_setDoc) return list || []
            let doc = metricChip_copy(this.metricChip_docNow() || {})
            doc = metricChip_useToggle(doc, key, rules, !!on)
            doc = metricChip_compact(doc, rules)
            this.$refs.chips.metricChip_setDoc(doc)
            for (const m of list || []) m.on = !metricChip_isEmpty(doc) && metricChip_matchKey(m.key, doc)
            return list || []
        },
        // ---- IE 2026 09 19 / ODOO-5800 (заказ Игоря «глобальный чипс-метрик»: постановка из виджетов) ----
        // Слова Игоря: «из виджетов (страница Metrics: Network layer, Movement Pipeline, Balance Pipeline, Stock + Arrival) можно было
        // установить глобальный чипс-метрик». Строки таких отчётов несут grade / metric / reason — своё значение либо значение строки-предка;
        // строка-группа (тип правила, группа причин) раскрывается в свои строки причин. Условия строк сопоставляются со словарём ЭТОГО отчёта
        // (metric_chip_keys бэка с widget = отчёт: его витрина под его отборами), поэтому «Bad» отчёта Balance Pipeline — это Bad-метрики
        // именно этого отчёта. Резолвится чипс через отчёт чипса стола, когда его словарь покрывает все ключи (отчёт всей витрины), иначе —
        // через сам отчёт-источник. Shift / Ctrl — добавить к действующему чипсу. Выключатели fe.ux.metricChip, fe.ux.metricChipGlobal
        metricSet_offered() {
            if (this.attr?.name !== 'dataSheet' || !this.metricChip_on() || this.store.setting('fe.ux.metricChipGlobal', true) === false) return false
            const rec = this.WIDGET?.record
            if (!rec?.doc?.params?.selector_map) return false
            return (rec.doc.viewList || []).some(f => f && f.binding === 'grade')
        },
        metricSet_click() {
            const ev = window.event, add = !!(ev && (ev.shiftKey || ev.ctrlKey || ev.metaKey))
            const flex = this.flex, store = this.store
            if (!flex) return
            const idx = new Set()
            // IE 2026 09 19 / ODOO-5800 (Igor: измерение horizon в ключе метрики): выделены ТОЛЬКО ячейки колонок горизонта (attr.metric_horizon_cols — отчёты страницы
            // Metrics, колонки по полю horizon) — условие строки получает горизонты этих колонок; в выделение попала любая другая колонка
            // (название строки, итог) — строка целиком, без горизонта, как раньше
            const hcols = this.attr?.metric_horizon_cols || null
            const rowH = new Map()
            for (const rng of (flex.selectedRanges?.length ? flex.selectedRanges : [flex.selection])) {
                if (!rng || rng.row < 0) continue
                let hs = []
                if (hcols) {
                    for (let c = Math.min(rng.col, rng.col2); c <= Math.max(rng.col, rng.col2); c++) {
                        const col = flex.columns[c]
                        if (!col || !col.isVisible) continue
                        const h = hcols[col.binding]
                        if (!h) { hs = null; break }
                        hs.push(String(h))
                    }
                }
                for (let r = Math.min(rng.row, rng.row2); r <= Math.max(rng.row, rng.row2); r++) {
                    idx.add(r)
                    const cur = rowH.get(r)
                    rowH.set(r, (cur === null || !hs || !hs.length) ? null : [...(cur || []), ...hs])
                }
            }
            const rows = flex.rows.map(r => ({ level: r.level ?? 0, item: r.dataItem }))
            const conds = metricSet_rowConditions(rows, [...idx], (i) => rowH.get(i) || [])
            // IE 2026 09 23 / ODOO-341407: i18n (уведомления чипса метрик — и ниже в metricSet_apply)
            if (!conds.length) { store.show_notification({ text: t('Set metrics chip: select rows that carry a grade, a metric or a reason'), status: 'warning', timeout: 7000 }); return }
            const source = String(this.WIDGET?.record?.id || '')
            store.metricChipG_dict(source, (dict) => {
                if (!dict) { store.show_notification({ text: t('Set metrics chip: the metric dictionary of this report is not available'), status: 'warning', timeout: 7000 }); return }
                this.metricSet_apply(metricSet_keys(conds, dict), add, source, dict)
            }, 60000)
        },
        // поставить глобальный чипс метрик по ключам (add — добавить к действующему отбору); source — отчёт метрик, из словаря которого ключи
        metricSet_apply(keys, add, source = '', dictS = null) {
            const store = this.store, ws = this.WIDGET?.workspace
            keys = [...new Set((keys || []).filter(Boolean))]
            if (!keys.length) { store.show_notification({ text: t('Set metrics chip: the selected rows have no metrics in the dictionary'), status: 'warning', timeout: 7000 }); return }   // IE 2026 09 23 / ODOO-341407: i18n
            const cur = add ? store.metricChipG_docActive(ws) : null
            const want = [...new Set([...(cur?.combos || []), ...keys])]
            const go = (widget, dict) => {
                if (!widget) { store.show_notification({ text: t('Metrics chip: the workspace has no metrics report to resolve the chip'), status: 'warning', timeout: 9000 }); return }
                let doc = { grades: [...(cur?.grades || [])], metrics: [...(cur?.metrics || [])], horizons: [...(cur?.horizons || [])], statuses: [...(cur?.statuses || [])], combos: want,
                    kinds: [...(cur?.kinds || [])], signals: [...(cur?.signals || [])], ...((cur?.reasons || []).length ? { reasons: [...cur.reasons] } : {}) /* IE 2026 10 04 / ODOO-5800 (fe-78): + причины */ }   // IE 2026 10 04 / ODOO-5800 (fe-74): виды / сигналы действующего чипса сигналов при добавлении (Shift / Ctrl) остаются
                if (dict?.length) doc = metricChip_compact(doc, dict)   // все правила оценки словаря выбраны → одна запись Grade
                store.metricChipG_set(doc, (ok) => {
                    if (!ok) { store.show_notification({ text: t('Metrics chip was not applied: the workspace has no metrics report to resolve it'), status: 'warning', timeout: 9000 }); return }
                    try { metricChip_histPush(localStorage, store.metricChipG_historyKey(ws), doc) } catch (e) { /* без истории */ }
                }, widget)
            }
            const R = store.metricChipG_report(ws)
            if (!R || R === source) { go(source || R, R === source ? dictS : null); return }
            // у стола уже есть отчёт чипса: чипс идёт через него, если его словарь покрывает все ключи; иначе — через отчёт-источник
            store.metricChipG_dict(R, (dictR) => {
                const have = new Set((dictR || []).map(k => k && k.key))
                const covers = !!dictR && want.every(k => have.has(k) || dictR.some(e => e && e.key && metricKey_covers(k, e.key)))   // IE 2026 09 19 / ODOO-5800 (Igor: измерение horizon в ключе метрики): комбинация из трёх частей — любая запись её основы
                if (covers || !source) go(R, covers ? dictR : null)
                else go(source, cur ? null : dictS)
            }, 60000)
        },
        // IE 2026 09 19 / ODOO-5800 (чипс метрик: попадание «вся строка»). Словарь метрик (бэк ie-dm7) помечает цель ключа: row — вся строка (правило без целевых полей,
        // ключ из строк данных), fields / measure — ячейки. Кроме того, у группы строк с флагом Stats отметки поднимаются родителю, а сами
        // строки в грид не приходят. Замер Purchase Balance dev02: из 107 строк с отметками только у 41 есть ячейка, окрашенная правилом
        // своей отметки, — у остальных приглушалось всё окрашенное, и строка-попадание выглядела как промах. Правило по факту: строка с
        // отметкой отобранного правила, у которой нет НИ ОДНОЙ ячейки, окрашенной этим правилом, — попадание целиком (‹ › и так встают на
        // первую видимую ячейку такой строки, metricNav_col). Выключатель fe.ux.metricChipRowHit
        metricRow_whole(dataItem, want, mdoc) {
            if (!this.flex) return false
            if (this._metricRowHitOn === undefined) this._metricRowHitOn = this.store.setting('fe.ux.metricChipRowHit', true) !== false
            if (!this._metricRowHitOn) return false
            let m = this._metricRowWhole
            if (!m || m.sig !== (this._metricFilterSig || '')) m = this._metricRowWhole = { sig: this._metricFilterSig || '', map: new WeakMap() }
            let v = m.map.get(dataItem)
            if (v === undefined) {
                // попадание — по отметкам строки (у ключа может и не быть своих классов оформления); затем — нет ли ячейки его правила
                v = metricChip_matchedKeys(dataItem?._DLRow?.metrics, mdoc).length > 0
                const _mf = v ? this.metricFill_state() : null   // IE 2026 09 20 / ODOO-5800 (заливка от метрик): ячейки ключа известны точно и без оформления (оценка info)
                if (v && (want?.size || _mf)) {
                    for (const col of this.flex.columns) {
                        const a = col.binding ? this.attr_by_binding[col.binding] : null
                        if (!a) continue
                        if (_mf && this.metricFill_cellMatches(_mf, dataItem, col.binding, a, mdoc)) { v = false; break }
                        if (!want?.size) continue
                        const own = this.styleKeys_cellOwn(dataItem, col.binding, a)
                        if (own.length && this.metricCell_hit(dataItem, col.binding, own, mdoc)) { v = false; break }   // IE 2026 09 19 / ODOO-5800 (Igor: измерение horizon в ключе метрики)
                    }
                }
                m.map.set(dataItem, v)
            }
            return v
        },
        // ---- IE 2026 09 20 / ODOO-5800 (Igor: колонка Selector и статистика грида Conditional format, чипс условного оформления CHIP-Format) ----
        // Слова Игоря 19.09: «давай на скрине3 [грид Conditional format] тоже добавим колонки со статистикой строк и ячеек под этими строками форматов»; «тогда
        // предлагаю и на скрине3 добавить колонку "selector", по которой показывать новый чипс-условного-оформления; по функционалу схожий с чипсом-метрик».
        // Контракт ie-dm7 (be-ie 8c7179816, на запрос с client.metric_selector): словарь attr.format_rules (только правила с selector = true), отметки строк
        // _DLRow.formats = [row_id], задания оформления несут rule_id — «какое правило ОКРАСИЛО» (порядок и группы First match — как у раскраски; сработавшие
        // правила ячейки копятся в результате cf_compute: ruleIds). Оформление на бэке: заданий нет — ячейки правила даёт карта _DLRow.format_cells_map
        // = {binding: [row_id]} ('' — вся строка), когда бэк её пришлёт; без неё остановка — строка целиком. Выключатель fe.ux.formatChip
        formatChip_on() {
            if (this._formatChipOn === undefined) this._formatChipOn = this.store.metricSelector_on() && this.store.setting('fe.ux.formatChip', true) !== false
            return this._formatChipOn
        },
        formatChip_chip() {
            if (!this.formatChip_on()) return null
            return (this.CHIPS || []).find(c => c && c.segment === 'CHIP-Format' && c.meta?.use !== false && !formatChip_isEmpty(c.doc)) || null
        },
        // отбор чипса оформления при снятом «Show other formatting» (null — флаг стоит либо чипса нет)
        formatFmt_onlyDoc() {
            const chip = this.formatChip_chip()
            return chip && chip.showOtherFormats === false ? chip.doc : null
        },
        // правила, окрасившие ячейку (col_binding = '' — строку целиком)
        formatCell_ruleIds(dataItem, col_binding, attr_col) {
            const map = dataItem?._DLRow?.format_cells_map
            if (map && typeof map === 'object') return map[col_binding] || FORMAT_NO_IDS
            if (!this.attr?.cf_rules) return FORMAT_NO_IDS
            return this.cf_compute(dataItem, col_binding, col_binding ? attr_col : null)?.ruleIds || FORMAT_NO_IDS
        },
        formatCell_hit(dataItem, col_binding, attr_col, ids) {
            for (const id of this.formatCell_ruleIds(dataItem, col_binding, attr_col)) if (ids.includes(id)) return true
            return false
        },
        // ячейки строки, окрашенные отобранными правилами (индексы видимых колонок)
        formatNav_cellsOfRow(dataItem, ids) {
            const flex = this.flex, out = []
            const map = dataItem?._DLRow?.format_cells_map
            if (map && typeof map === 'object') {
                for (const b of Object.keys(map)) {
                    if (!b || !(map[b] || []).some(id => ids.includes(id))) continue
                    const c = this.metricNav_colIndex(b)
                    if (c >= 0 && flex.columns[c].isVisible) out.push(c)
                }
                return out.sort((x, y) => x - y)
            }
            if (!this.attr?.cf_rules) return null   // оформление на бэке без карты ячеек: остановка — строка целиком
            for (let c = 0; c < flex.columns.length; c++) {
                const col = flex.columns[c], attr_col = col.binding ? this.attr_by_binding[col.binding] : null
                if (!attr_col || !col.isVisible) continue
                if (this.formatCell_hit(dataItem, col.binding, attr_col, ids)) out.push(c)
            }
            return out
        },
        // счётчик и остановки ‹ › чипса оформления: ячейки, окрашенные отобранными правилами; строка с отметкой без такой ячейки (правило на всю строку,
        // оформление на бэке) — одна остановка «вся строка»
        formatNav_recompute() {
            this.formatAuto_apply()   // IE 2026 09 20 / ODOO-5800 (Igor 20.09: Selector правила и флажок правила в форме ячейки создают чипс оформления)
            const flex = this.flex
            const chips = (this.CHIPS || []).filter(c => c && c.segment === 'CHIP-Format' && c.meta?.use !== false)
            if (!flex?.hostElement || !chips.length || !this.formatChip_on()) { this._gridNavFormat = null; return }
            const chip = chips[0], ids = formatChip_ids(chip.doc), list = []
            if (ids.length) {
                let budget = this.store.setting('fe.data.metricCellNavMaxRows', 1500)
                for (let r = 0; r < flex.rows.length; r++) {
                    const row = flex.rows[r]
                    if (!row.dataItem || row.visible === false || !formatChip_matchRow(row.dataItem, chip.doc)) continue
                    const cells = (row.dataItem._DLRow?.format_cells_map || budget-- > 0) ? this.formatNav_cellsOfRow(row.dataItem, ids) : null
                    if (cells && cells.length) for (const c of cells) list.push({ r, c })
                    else list.push({ r, c: null, whole: true })
                }
            }
            const idx = Math.min(this._gridNavFormat?.index || 0, Math.max(0, list.length - 1))
            this._gridNavFormat = { list, index: idx, cells: true, cellSet: new Set(list.filter(x => x.c != null && !x.whole).map(x => x.r + ':' + x.c)) }
            if (this._hitNavKind === 'format') {
                if (this._metricHitCur && !this._gridNavFormat.cellSet.has(this._metricHitCur.r + ':' + this._metricHitCur.c)) this._metricHitCur = null
                if (this._metricHitAll || this._metricHitCur || this._metricHitOn) this.metricHit_schedule()
            }
            for (const c of chips) { c.matchCount = formatChip_isEmpty(c.doc) ? null : list.length; c.matchIndex = list.length ? idx : 0 }
            this.$refs.chips?.$forceUpdate()
        },
        // строка-попадание целиком: отметка отобранного правила есть, а ячейки, окрашенной им, нет (правило на всю строку, оформление на бэке без карты)
        formatRow_whole(dataItem, ids) {
            let m = this._formatRowWhole
            if (!m || m.sig !== (this._formatFilterSig || '')) m = this._formatRowWhole = { sig: this._formatFilterSig || '', map: new WeakMap() }
            let v = m.map.get(dataItem)
            if (v === undefined) {
                v = (dataItem?._DLRow?.formats || []).some(id => ids.includes(id))
                if (v) { const cells = this.formatNav_cellsOfRow(dataItem, ids); if (cells && cells.length) v = false }
                m.map.set(dataItem, v)
            }
            return v
        },
        // ---- грид правил Conditional format (сводный, _doc.conditional_format_all) ----
        formatSel_grid() { return String(this.attr?.binding || '') === '_doc.conditional_format_all' && this.store.metricSelector_on() },
        formatSel_dataGrid() { return Object.values(this.WIDGET?.applys_CHIPS || {}).find(g => g && g !== this && g.attr?.name === 'dataSheet') || null },
        // щелчок по Selector правила: признак — настройка правила (сохраняется с записью виджета, запись становится «изменённой»); словарь чипса
        // (attr.format_rules), отметки строк и rule_id заданий считает бэк при select — данные виджета перечитываются с паузой (запись уходит целиком)
        formatSel_changed() {
            const rec = this.rowIds_record() || this.WIDGET?.record
            if (rec) { rec._meta = rec._meta || {}; rec._meta.modified = true }
            try { this.aggAll_afterChange() } catch (e) { /* не сводный грид */ }
            clearTimeout(this._formatSelReload_t)
            this._formatSelReload_t = setTimeout(() => {
                const chips = this.formatSel_dataGrid()?.$refs?.chips
                try { chips?._reload_widget?.() } catch (e) { /* виджет закрыт */ }
            }, this.store.setting('fe.data.chipPlaceReloadMs', 450))
        },
        // Selector строки-ГРУППЫ правил (Tab / First match): в словарь чипса бэк кладёт только сами правила — щелчок по группе ставит / снимает признак всем её
        // подчинённым правилам (иначе флажок группы ничего бы не значил)
        formatSel_propagate(r1, r2, checked) {
            const walk = (rows) => { for (const it of rows || []) { if (!this.store.isinstance_dict(it)) continue; this.store.set_value(it, 'selector', !!checked); walk(it.attrs) } }
            for (let r = r1; r <= r2; r++) { const it = this.flex?.rows?.[r]?.dataItem; if (it && Array.isArray(it.attrs) && it.attrs.length) walk(it.attrs) }
        },
        // IE 2026 09 20 / ODOO-5800 (находка ie-dm7: Selector правила, переключённый на гриде скрытой вкладки, не доезжал до записи):
        // признак Selector хранится в правиле ЗАПИСИ. Строка грида обычно и есть объект правила записи (режим без «All»), но не всегда: грид на скрытой вкладке
        // обновляет данные только при показе — после перечитывания его строки устаревшие; в режиме «All» строки — копии (их довозит write-back). Переключённым
        // строкам (и их подчинённым правилам) значение дублируется в правило записи по row_id — только там, где объект другой и значение расходится
        formatSel_syncRecord(r1, r2) {
            const rows = this.flex?.rows
            if (!rows) return 0
            let byId = null, n = 0
            const index = () => {
                const map = new Map()
                const walk = (list) => { for (const x of list || []) { if (!this.store.isinstance_dict(x)) continue; if (typeof x.row_id === 'string' && !map.has(x.row_id)) map.set(x.row_id, x); walk(x.attrs) } }
                try { this.aggAll_walkSources(({ container }) => walk(container)) } catch (e) { /* не сводный грид */ }
                return map
            }
            const sync = (it) => {
                if (!this.store.isinstance_dict(it)) return
                if (typeof it.row_id === 'string') {
                    if (!byId) byId = index()
                    const rec = byId.get(it.row_id)
                    if (rec && rec !== it && !!rec.selector !== !!it.selector) { this.store.set_value(rec, 'selector', !!it.selector); n++ }
                }
                for (const ch of (Array.isArray(it.attrs) ? it.attrs : [])) sync(ch)
            }
            for (let r = Math.max(0, r1); r <= r2 && r < rows.length; r++) sync(rows[r]?.dataItem)
            return n
        },
        // ---- IE 2026 09 20 / ODOO-5800 (Igor 20.09: «при вкл селектора на строке условного оформления я ожидал, что появится чипс условного оформления над основной
        // таблицей, с помощью которого я смогу увидеть ячейки, для которых применилось это условное оформление»; «так же ожидал увидеть чекбокс в строках усл.
        // форматирования, применённых к ячейке (форма дропдаун ячейки): чекбокс показывает, что чипс есть и правило в нём; по аналогии со строками метрик — при его
        // включении появится чипс») ----
        // Selector правила = состав чипса оформления (как Selector вкладки Metrics = состав чипса метрик): отбор меняют только переключённые правила. Снятые уходят
        // из чипса сразу; включённые попадают в чипс, когда бэк вернёт их в словаре attr.format_rules (данные перечитывает formatSel_changed / formatCell_toggle), —
        // до тех пор ждут в WIDGET._formatAuto (общее для грида правил и грида данных, переживает пересоздание грида; старше 10 минут — забывается).
        // Выключатель fe.ux.formatChipAuto (по умолчанию вкл): прежнее поведение — чипс только предлагается в меню «+»
        formatAuto_on() { return this.formatChip_on() && this.store.setting('fe.ux.formatChipAuto', true) !== false },
        formatAuto_dict() { return (Array.isArray(this.attr?.format_rules) ? this.attr.format_rules : []).map(e => e && e.id).filter(Boolean) },
        formatAuto_chipDoc() { return ((this.CHIPS || []).find(c => c && c.segment === 'CHIP-Format') || {}).doc || null },
        // грид правил: row_id переключённых строк и их подчинённых правил → заявка гриду данных
        formatSel_autoChip(r1, r2, checked, solo) {
            const dg = this.formatSel_dataGrid()
            if (!dg || typeof dg.formatAuto_request !== 'function') return
            const ids = []
            const walk = (it) => { if (!this.store.isinstance_dict(it)) return; if (typeof it.row_id === 'string' && it.row_id) ids.push(it.row_id); for (const ch of (Array.isArray(it.attrs) ? it.attrs : [])) walk(ch) }
            for (let r = Math.max(0, r1); r <= r2 && r < (this.flex?.rows?.length || 0); r++) walk(this.flex.rows[r]?.dataItem)
            dg.formatAuto_request(ids, !!checked, !!solo)
        },
        // грид данных: заявка на изменение отбора чипса оформления
        formatAuto_request(ids, on, solo = false) {
            const chips = this.$refs.chips
            if (!this.formatAuto_on() || !chips || typeof chips.formatChip_setDoc !== 'function') return false
            const cur = this.formatAuto_chipDoc()
            const res = formatChip_request(cur, this.formatAuto_dict(), ids, on, solo)
            if (this.WIDGET) this.WIDGET._formatAuto = res.pending.length ? { ids: res.pending, at: Date.now() } : null
            if (formatChip_sig(res.doc) !== formatChip_sig(cur)) chips.formatChip_setDoc(res.doc)
            if (res.pending.length) this.formatAuto_wait()
            return true
        },
        // словарь приходит с перечитанными данными; узел грида (attr) при этом меняется без реактивного события, а грид на скрытой вкладке данных не обновляется
        // вовсе (приёмка 20.09: словарь пришёл, чипса нет) — поэтому ждём словарь коротким опросом, пока заявка жива
        formatAuto_wait() {
            clearInterval(this._formatAuto_t)
            this._formatAuto_t = setInterval(() => {
                let alive = false
                try { this.formatAuto_apply(); alive = !!this.WIDGET?._formatAuto && !!this.flex } catch (e) { alive = false }
                if (!alive) { clearInterval(this._formatAuto_t); this._formatAuto_t = null }
            }, 400)
        },
        // пришёл словарь чипса (данные перечитаны): ждавшие правила — в чипс
        formatAuto_apply() {
            const W = this.WIDGET, p = W?._formatAuto
            if (!p || this.attr?.name !== 'dataSheet') return
            if (Date.now() - p.at > 600000 || !this.formatAuto_on()) { W._formatAuto = null; return }   // 10 минут: пользователь может долго оставаться на вкладке настроек
            const chips = this.$refs.chips
            if (!chips || typeof chips.formatChip_setDoc !== 'function') return
            const cur = this.formatAuto_chipDoc()
            const res = formatChip_pendingApply(cur, this.formatAuto_dict(), p.ids)
            if (!res.added.length) return   // словарь ещё прежний — ждём перечитанных данных
            W._formatAuto = null
            if (formatChip_sig(res.doc) !== formatChip_sig(cur)) chips.formatChip_setDoc(res.doc)
        },
        // правило записи по row_id — во всех контейнерах conditional_format записи (отчёт, строки раскладки, поля, меры)
        formatRule_find(id) {
            const rec = this.rowIds_record() || this.WIDGET?.record, seen = new Set()
            let found = null
            const inRules = (list) => { for (const x of list || []) { if (found) return; if (!this.store.isinstance_dict(x)) continue; if (x.row_id === id) { found = x; return } inRules(x.attrs) } }
            const walk = (o, depth) => {
                if (found || !o || typeof o !== 'object' || depth > 14 || seen.has(o)) return
                seen.add(o)
                if (Array.isArray(o)) { for (const x of o) walk(x, depth + 1); return }
                for (const k of Object.keys(o)) {
                    const v = o[k]
                    if (k === 'conditional_format' && Array.isArray(v)) { inRules(v); if (found) return }
                    else if (v && typeof v === 'object') walk(v, depth + 1)
                }
            }
            walk(rec?.doc?.params, 0)
            return found
        },
        // форма ячейки, блок FORMATS: флажок правила → чипс оформления. Правила нет в словаре (его Selector выключен) — Selector включается в правиле записи
        // (как щелчок по Selector в гриде правил: запись становится «изменённой»), данные перечитываются, правило попадает в чипс с приходом словаря
        formatCell_toggle(rule_id, on, list) {
            if (!rule_id || !this.formatAuto_on()) return list || []
            if (on && !this.formatAuto_dict().includes(rule_id)) {
                const rule = this.formatRule_find(rule_id)
                if (!rule) return list || []
                this.store.set_value(rule, 'selector', true)
                const rec = this.rowIds_record() || this.WIDGET?.record
                if (rec) { rec._meta = rec._meta || {}; rec._meta.modified = true }
                this.formatAuto_request([rule_id], true)
                clearTimeout(this._formatCellReload_t)
                this._formatCellReload_t = setTimeout(() => { try { this.$refs.chips?._reload_widget?.() } catch (e) { /* виджет закрыт */ } }, this.store.setting('fe.data.chipPlaceReloadMs', 450))
                for (const t of list || []) if (t.rule_id === rule_id) t.on = true   // чипс появится с приходом словаря
                return list || []
            }
            this.formatAuto_request([rule_id], !!on)
            const doc = this.formatAuto_chipDoc()
            for (const t of list || []) if (t.rule_id) t.on = formatChip_has(doc, t.rule_id)
            return list || []
        },
        // статистика правил (метод cf_stats): записи record._doc.cf_stats по row_id — строкам сводного грида; в режиме «All» правила вложенных источников
        // (строк раскладки, полей, мер) цифр в себе не несут. Фон значимых чисел — только у правил-метрик (fill)
        cfStats_map() {
            if (!this.formatSel_grid()) return null
            const ref = (this.rowIds_record() || this.WIDGET?.record)?._doc?.cf_stats
            if (!Array.isArray(ref) || !ref.length) return null
            if (this._cfStatsRef !== ref) { this._cfStatsRef = ref; this._cfStatsIx = cfStats_index(ref) }
            return this._cfStatsIx
        },
        // остановка ‹ › под свёрнутой группой в DOM не попадает (выделение уходит в невидимую строку, подсветке не на чем встать) — раскрыть её свёрнутых
        // предков, как это делают переходы «Go to DL» и поиск строки раскладки; индексы строк при этом не меняются. Выключатель fe.ux.chipNavReveal
        navRow_reveal(r) {
            const rows = this.flex?.rows
            if (!rows || !rows[r] || rows[r].isVisible || this.store.setting('fe.ux.chipNavReveal', true) === false) return false
            let lvl = rows[r].level ?? 0, opened = false
            for (let i = r - 1; i >= 0 && lvl > 0; i--) {
                const row = rows[i]
                if ((row.level ?? 0) < lvl) { if (row.isCollapsed) { row.isCollapsed = false; opened = true } lvl = row.level ?? 0 }
            }
            return opened
        },
        // переход ‹ › чипса условного оформления
        formatNav_step(dir) {
            const nav = this._gridNavFormat
            if (!nav?.list?.length) return
            nav.index = (nav.index + dir + nav.list.length) % nav.list.length
            const m = nav.list[nav.index]
            if (m.c == null) { m.c = 0; for (let c = 0; c < this.flex.columns.length; c++) if (this.flex.columns[c].isVisible) { m.c = c; break } }
            this.navRow_reveal(m.r)
            this.flex.select(new wjGrid.CellRange(m.r, m.c), true)
            this.flex.scrollIntoView(m.r, m.c)
            this._hitNavKind = 'format'
            this._metricHitCur = !m.whole ? { r: m.r, c: m.c } : null
            this.metricHit_schedule()
            for (const chip of (this.CHIPS || [])) if (chip.segment === 'CHIP-Format') chip.matchIndex = nav.index
            this.$refs.chips?.$forceUpdate()
        },
        // форма ячейки, блок METRICS: метрика ячейки → глобальный чипс метрик стола
        metricCell_toGlobal(key, add) { this.metricSet_apply([key], !!add) },
        // ячейки данных без отобранных стилей приглушаются — отобранные читаются сразу (fe.ux.gridStyleFilterDim)
        styleFilter_paint(e_cell, dataItem, e_col) {
            const keys = this._styleFilterKeys
            let dim = false
            // IE 2026 09 18 / ODOO-5800 (заказ Игоря «чипс-метрик»): при отборе чипса метрик сразу читаются ячейки, окрашенные ОТОБРАННЫМИ правилами: ячейки,
            // окрашенные прочими правилами оформления, приглушены (та же настройка fe.ux.gridStyleFilterDim). Ячейки без оформления
            // (названия, коды) не трогаем — список должен читаться. Классы у правил одной оценки общие, по ячейкам бэк отметок не даёт
            const mdoc = this._metricDim ? this._metricFilterDoc : null   // IE 2026 10 07 / ODOO-5800: без флага чипса «Dim other formatting» чипс сигналов не приглушает (и не мешает чипсу оформления)
            if (mdoc && dataItem && this._styleFilterDim && !keys?.length) {
                const col = this.flex?.columns?.[e_col]
                const attr_col = col?.binding ? this.attr_by_binding[col.binding] : null
                const own = attr_col ? this.styleKeys_cellOwn(dataItem, col.binding, attr_col) : []
                if (own.length) {
                    const want = this.metricCss_forRow(dataItem, mdoc)
                    dim = !this.metricCell_hit(dataItem, col.binding, own, mdoc)   // IE 2026 09 19 / ODOO-5800 (Igor: измерение horizon в ключе метрики): класс отобранного правила И его горизонт
                    // IE 2026 09 19 / ODOO-5800 (чипс метрик: попадание «вся строка»): у строки есть отметка отобранного правила, но ни одна её ячейка этим правилом не окрашена —
                    // попадание = вся строка, её ячейки не приглушаются
                    if (dim && this.metricRow_whole(dataItem, want, mdoc)) dim = false
                }
            }
            // IE 2026 09 20 / ODOO-5800 (Igor: колонка Selector и статистика грида Conditional format, чипс условного оформления CHIP-Format): под чипсом оформления читаются ячейки, окрашенные ОТОБРАННЫМИ правилами —
            // окрашенные прочим приглушены; при двух чипсах (метрик и оформления) ячейку спасает попадание под любой из них
            const fids = this._formatFilterIds
            if (fids && fids.length && dataItem && this._styleFilterDim && !keys?.length && (dim || !mdoc)) {
                const col = this.flex?.columns?.[e_col]
                const attr_col = col?.binding ? this.attr_by_binding[col.binding] : null
                const own = attr_col ? this.styleKeys_cellOwn(dataItem, col.binding, attr_col) : []
                if (own.length) dim = !this.formatCell_hit(dataItem, col.binding, attr_col, fids) && !this.formatCell_hit(dataItem, '', null, fids) && !this.formatRow_whole(dataItem, fids)
            }
            if (keys?.length && dataItem && this._styleFilterDim) {
                const col = this.flex?.columns?.[e_col]
                const attr_col = col?.binding ? this.attr_by_binding[col.binding] : null
                if (attr_col?.raw_binding) {
                    const row = this.styleKeys_row(dataItem)
                    let hit = keys.some(k => row.all.includes(k))
                    if (!hit) {
                        const own = this.styleKeys_cellOwn(dataItem, col.binding, attr_col)
                        hit = keys.some(k => own.includes(k))
                        if (!hit && row.vo.length) { const v = this.store.get_value(dataItem, col.binding); hit = !(v == null || v === '') && keys.some(k => row.vo.includes(k)) }
                    }
                    dim = !hit
                }
            }
            if (e_cell.classList.contains('style-filter-dim') !== dim) e_cell.classList.toggle('style-filter-dim', dim)
        },
        // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p205 заголовки рядків блоку «Непокрито» без червоної заливки — менше сигналів)
        // заголовок строки блока «Непокрито» (колонки слева от дат: мера, иерархия, атрибуты) — без заливки «непокрыто» (alert-row / alert-uncovered
        // и двойник cell-background-red снимаются; ячейки-даты не трогаются); полоса-заголовок самого блока — бордовый текст (класс unc-block-title).
        // Оба пути formatItem (кеш-путь переписал className снимком — снимается заново). Выключатель fe.ux.uncoveredRowHeadersPlain (ВЫКЛ — прежняя заливка)
        uncHeaders_paint(e_cell, rows, e_row, e_col, col) {
            if (!e_cell) return
            const on = this.fmtSetting(UNC_HEADERS_FLAG, true) !== false
            const dataItem = rows?.[e_row]?.dataItem
            let title = false
            if (on && dataItem) {
                if (!cellPie_bindingOf(col?.binding)) {
                    const bound = Math.max(this.mergeColumnBlocksTotal || 0, this.mergeColumns || 0, this.flex?.frozenColumns || 0)
                    if (e_col < bound) {
                        const drop = uncHeaders_suppress(e_cell.classList)
                        for (const c of drop) e_cell.classList.remove(c)
                    }
                }
                const T = this._secT
                const legacy = ((T && T.flex === this.flex) ? T.mode : secStyle_mode((k, d) => this.store.setting(k, d))) === 'now'   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р3/Р9): «As before» — бордовые «+» / «−», как до #369
                const memo = (this._uncTitleMemo && this._uncTitleMemo.src === this.data && this._uncTitleMemo.legacy === legacy) ? this._uncTitleMemo : (this._uncTitleMemo = { src: this.data, legacy, m: new WeakMap() })   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р3/Р9)
                if (memo.m.has(dataItem)) title = memo.m.get(dataItem)
                else { title = uncBlock_titleIs((j) => rows[j]?.dataItem || null, e_row, 60, legacy); memo.m.set(dataItem, title) }   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р3/Р9)
            }
            if (title) wjcCore.addClass(e_cell, UNC_TITLE_CLASS)
            else if (e_cell.classList.contains(UNC_TITLE_CLASS)) wjcCore.removeClass(e_cell, UNC_TITLE_CLASS)
        },
        alertChild_paint(e_cell, dataItem, e_col) {
            const on = dataItem && this.fmtSetting('fe.ux.gridAlertChildMark', this.fmtSetting('fe.ux.gridUncChildMark', true)) !== false   // IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL5
            const color = on ? this.alertChild_map().get(dataItem) : null
            let bg = ''
            if (color) {
                const bound = Math.max(this.mergeColumnBlocksTotal || 0, this.mergeColumns || 0)
                const head = e_col < bound
                if (head || (e_cell.textContent || '').trim()) {   // шапка строки или значимое значение
                    const k = head ? 0.55 : 0.30
                    const base = this.alert_baseColor()
                    const mix = (a, b) => Math.max(0, Math.min(255, Math.round(a * k + b * (1 - k))))
                    bg = `rgb(${mix(color.r, base.r)}, ${mix(color.g, base.g)}, ${mix(color.b, base.b)})`
                }
            }
            // переменную могли стереть вместе с cssText ячейки на перерисовке — сверяем и мемо, и факт
            if (e_cell.__alertChild === bg && (!bg || e_cell.style.getPropertyValue('--alert-child-bg') === bg)) return
            if (bg) { e_cell.style.setProperty('--alert-child-bg', bg); wjcCore.addClass(e_cell, 'cell-alert-child') }
            else { e_cell.style.removeProperty('--alert-child-bg'); wjcCore.removeClass(e_cell, 'cell-alert-child') }
            e_cell.__alertChild = bg
        },
        sameValue_update(flex) {
            if (!flex?.hostElement) return
            let txt = ''
            const on = this.store.setting('fe.ux.gridSameValueHighlight', true) !== false
            const sel = flex.selection
            const oneCell = sel && sel.row >= 0 && sel.col >= 0 && sel.row === sel.row2 && sel.col === sel.col2
            if (on && oneCell) {
                txt = this.sameValue_selText(flex, sel)
                if (txt.length < this.store.setting('fe.data.gridSameValueMinLen', 2)) txt = ''
            }
            const key = txt ? `${sel.row}:${sel.col}:${txt}` : ''
            if (this._sameValKey === key) return
            this._sameValKey = key
            this._sameVal = txt
            if (txt) this._sameValExt = ''   // свой выбор перекрывает подсветку, пришедшую из другого виджета
            this.sameValue_publish(txt)
            // сама выбранная ячейка не подсвечивается; у объединённой это ВЕСЬ её диапазон (рисуется его левая ячейка)
            let c1 = sel ? sel.col : -1, c2 = c1
            if (txt) { try { const rng = flex.mergeManager?.getMergedRange(flex.cells, sel.row, sel.col, true); if (rng) { c1 = rng.col; c2 = rng.col2 } } catch (e) { /* без объединения */ } }
            this._sameValCell = txt ? { row: sel.row, col1: c1, col2: c2 } : null
            this.sameValue_hlSchedule()
        },
        // IE 2026 09 17 / ODOO-… (замечание Игоря): «выделив Грузию в верхнем виджете, ожидал, что в нижнем
        // виджете тоже подсветится Грузия» — текст выбранной ячейки уходит на шину (src/utils/cellMatch.js),
        // и его подсвечивают гриды ОСТАЛЬНЫХ виджетов той же страницы. Подсветка следует за последним кликом:
        // свой выбор гасит пришедший текст, пришедший текст гасит свой выбор.
        // Внутренняя опция fe.ux.gridSameValueCrossWidget (по умолчанию вкл).
        sameValue_busKey() { return (this._cmKey = this._cmKey || cellMatch_key()) },
        sameValue_crossOn() { return this.store.setting('fe.ux.gridSameValueCrossWidget', true) !== false },
        sameValue_publish(txt) {
            // публикуем всегда: опцию проверяет приёмник — иначе выключенная опция оставила бы
            // висеть подсветку, пришедшую до выключения
            try { cellMatch_publish(txt, this.sameValue_busKey(), this.WIDGET?.page) } catch (e) { /* шина недоступна */ }
        },
        sameValue_busInit() {
            if (this._cmUnsub) return
            const key = this.sameValue_busKey()
            this._cmUnsub = cellMatch_subscribe((text, src, page) => {
                if (src === key) return
                const my = this.WIDGET?.page
                if (page && my && page !== my) return   // только виджеты той же страницы
                if (!this.sameValue_crossOn()) { if (this._sameValExt) { this._sameValExt = ''; this.sameValue_hlSchedule() } return }
                if ((this._sameValExt || '') === text && !this._sameVal) return
                if (text) { this._sameVal = ''; this._sameValKey = ''; this._sameValCell = null }
                this._sameValExt = text
                this.sameValue_hlSchedule()
            })
            // IE 2026 09 18 (заказ Игоря): другой грид страницы нашёл / потерял совпадения — пересчитать, подсвечивать ли
            // текст СВОЕЙ выбранной ячейки (он подсвечивается, только когда совпадения есть где-то ещё)
            this._cmUnsubCh = cellMatch_onChange((src) => {
                if (src === key || !this._sameVal) return
                if (cellMatch_others(key) !== this._sameValOthersExt) this.sameValue_hlSchedule()
            })
        },
        // IE 2026 09 17 / ODOO-… (замечания Игоря): сравниваем ОТРИСОВАННЫЙ текст ячейки — как видит пользователь.
        // Значение из данных для этого не годится: ячейка может быть объединённой (значение в другой колонке),
        // с чипсами / вложенным гридом (в данных объект, а не текст) — тогда «одинаковыми» оказывались все такие ячейки.
        sameValue_cellText(el) {
            // IE 2026 09 17 (замечание Игоря): служебные узлы ячейки (оверлеи разрыва/линий групп в <i>, стрелка
            // разрыва, кнопка раскрытия ссылки, значок свёртки) в текст не входят — иначе «ТС Aversi хранение»
            // со стрелкой не совпадало с такой же ячейкой без неё
            const box = el.querySelector(':scope > .cell-text-clip') || el
            let t = ''
            for (const n of box.childNodes) {
                if (n.nodeType === 3) { t += n.nodeValue; continue }
                if (n.nodeType !== 1) continue
                if (n.tagName === 'I' && !n.className) continue
                if (n.matches('.break-arrow, .cell-dropdown-toggle, .wj-elem-collapse, .cell-delivery-left-border, .cell-delivery-top-border')) continue
                t += n.textContent
            }
            return t.replace(/\s+/g, ' ').trim()
        },
        // IE 2026 09 17 / ODOO-… (замечание Игоря): в ячейках бывают ВЛОЖЕННЫЕ гриды (чипсы фильтра, поля, значения) —
        // их ячейки не наши: берём только те, у которых ближайший грид — этот
        sameValue_cells(host) { return [...host.querySelectorAll('.wj-cells .wj-cell')].filter(c => c.closest('.wj-flexgrid') === host) },
        // IE 2026 10 01 / ODOO-5800 (Igor: «выделил 926:9 — вижу подсветку в 940:9 с тем же текстом; встал в 940:9 — в 926:9 подсветки нет»):
        // где ячейка ЛОГИЧЕСКИ — по индексу wijmo на самом элементе (hitTest(элемент): строка, колонка, объединённый диапазон; клон
        // замороженной области несёт тот же индекс), а не по месту на экране. Место на экране при горизонтальной прокрутке с замороженными
        // колонками врёт: основной экземпляр замороженной ячейки уезжает вместе с прокруткой (видна его копия в .wj-frozen-clone), а ячейка
        // значений, наполовину ушедшая под замороженные колонки, левым краем попадает в замороженную колонку — её число бралось как текст
        // выбранной ячейки (у строки 926 там пусто — срабатывал запасной путь по данным и находился код, у 940 там число — искалось оно)
        sameValue_cellPos(el) {
            let ht = null
            try { ht = this.flex?.hitTest(el) } catch (e) { ht = null }
            if (!ht || ht.row < 0 || ht.col < 0 || (ht.panel && ht.panel !== this.flex.cells)) return null
            const r = ht.range
            return r ? { row: r.topRow, row2: r.bottomRow, col: r.leftCol, col2: r.rightCol } : { row: ht.row, row2: ht.row, col: ht.col, col2: ht.col }
        },
        sameValue_selText(flex, sel) {
            // элемент выбранной ячейки — по индексу wijmo (sameValue_cellPos), у объединённой — элемент её диапазона. Метка выделения
            // .wj-state-selected не годится: при рамке выделения (showMarquee, гриды отчётов) wijmo ставит выбранной ячейке только
            // .wj-state-active, а снимок className кэш-пути formatItem мог оставить метку на прежней ячейке
            const host = flex.hostElement
            let el = null
            try { el = flex.cells.getCellElement(sel.row, sel.col) } catch (e) { el = null }
            if (el && el.closest('.wj-flexgrid') !== host) el = null
            if (!el && host) {
                for (const c of this.sameValue_cells(host)) {
                    const p = this.sameValue_cellPos(c)
                    if (p && sel.row >= p.row && sel.row <= p.row2 && sel.col >= p.col && sel.col <= p.col2) { el = c; break }
                }
            }
            if (el && this.hlSkipHidden_on() && cellMatch_hiddenText(el)) return ''   // IE 2026 09 20 / ODOO-5828: выбрана ячейка со спрятанным нулём — для пользователя она пуста
            const t = el ? this.sameValue_cellText(el) : ''
            if (t) return t
            // значение из данных — только если это простой текст: у ячейки с чипсами / вложенным гридом там объект,
            // и такие ячейки «совпадали» друг с другом (замечание Игоря про грид раскладки)
            const raw = this.sameValue_text(flex.cells, sel.row, sel.col)
            return /\[object /.test(raw) ? '' : raw
        },
        // IE 2026 09 17 / ODOO-… (замечание Игоря): ячейка может быть ОБЪЕДИНЁННОЙ — значение лежит не в ней, а в
        // колонке-источнике диапазона (merge_src у merge «назад») или в его единственной непустой ячейке
        sameValue_text(panel, row, col) {
            let v = ''
            try { v = String(panel.getCellData(row, col, true) ?? '').trim() } catch (e) { v = '' }
            if (v) return v
            const _c = this.cache_data_cells.get(`${panel.cellType}-${row}-${col}`)
            const src = _c?.merge_src
            if (src !== undefined && src !== null && src !== col) {
                try { v = String(panel.getCellData(row, src, true) ?? '').trim() } catch (e) { v = '' }
                if (v) return v
            }
            try {
                const rng = this.flex?.mergeManager?.getMergedRange(panel, row, col, true)
                if (rng && rng.col !== rng.col2) {
                    for (let c = rng.col; c <= rng.col2 && !v; c++) {
                        const t = String(panel.getCellData(row, c, true) ?? '').trim()
                        if (t) v = t
                    }
                }
            } catch (e) { /* без объединения — как есть */ }
            return v
        },
        // IE 2026 09 20 / ODOO-5828 (замечание Игоря: «вижу выделения нулей — в ячейках, в которых они были скрыты как пустые значения»): подсветки
        // не красят текст, которого пользователь не видит (спрятанный ноль — cell-zero); выключатель fe.ux.highlightSkipHidden
        hlSkipHidden_on() { return this.store.setting('fe.ux.highlightSkipHidden', true) !== false },
        // подсветка ТЕКСТА (а не ячейки целиком) — тем же механизмом, что подсветка вхождений выделенного текста
        // (CSS Custom Highlight API, ::highlight(cell-match) в App.vue): DOM ячеек не трогаем, диапазоны
        // пересобираются после каждой отрисовки (виртуализация wijmo)
        sameValue_hlSchedule() {
            if (this._sameValHLT) return
            this._sameValHLT = window.$cg.setTimeout(this, 'AttrGrid.sameValueHL', () => { this._sameValHLT = null; this.sameValue_hlApply() }, 40)
        },
        sameValue_hlApply() {
            const CSSH = window.CSS && window.CSS.highlights
            if (!CSSH || typeof window.Highlight !== 'function') return
            const host = this.flex?.hostElement
            const txt = this._sameVal || this._sameValExt || ''
            const ranges = []
            const selfRanges = []   // IE 2026 09 18 (заказ Игоря): текст самой выбранной ячейки — подсвечивается, если совпадения есть где-то ещё
            const rangeOf = (cell) => {
                const walker = document.createTreeWalker(cell, NodeFilter.SHOW_TEXT, null)
                let n
                while ((n = walker.nextNode())) {
                    const v = n.nodeValue || ''
                    const i = v.indexOf(txt)
                    if (i < 0) continue
                    const r = document.createRange()
                    try { r.setStart(n, i); r.setEnd(n, i + txt.length) } catch (e) { continue }
                    return r   // в ячейке подсвечиваем её значение — одно вхождение
                }
                return null
            }
            if (host) {
                const sc = this._sameVal ? this._sameValCell : null   // пришедший текст: выбранной ячейки в этом гриде нет
                const skipHidden = this.hlSkipHidden_on()   // IE 2026 09 20 / ODOO-5828
                for (const cell of this.sameValue_cells(host)) {
                    if (skipHidden && cellMatch_hiddenClass(cell)) {   // спрятанный ноль / повтор итога группы (IE 2026 09 23 / ODOO-…): не совпадение и не подсветка
                        if (cell.classList.contains('cell-same-value')) cell.classList.remove('cell-same-value')
                        continue
                    }
                    const same = !!txt && this.sameValue_cellText(cell) === txt
                    // сама выбранная ячейка (и её клон в замороженной области) — под рамкой выделения, не подсвечиваем. IE 2026 10 01 / ODOO-5800:
                    // узнаём её по индексу wijmo (sameValue_cellPos), а не hitTest'ом по месту на экране — основной экземпляр замороженной ячейки
                    // при горизонтальной прокрутке стоит не там, где виден, и считался «совпадением в другой ячейке»
                    let skip = false
                    if (sc) {
                        if (same) { const p = this.sameValue_cellPos(cell); skip = !!p && sc.row >= p.row && sc.row <= p.row2 && p.col <= sc.col2 && p.col2 >= sc.col1 }
                    } else skip = cell.classList.contains('wj-state-selected')   // пришедший текст — как было
                    const on = same && !skip
                    if (cell.classList.contains('cell-same-value') !== on) cell.classList.toggle('cell-same-value', on)
                    if (same && skip && sc && selfRanges.length < 4) { const r = rangeOf(cell); if (r) selfRanges.push(r) }   // выбранная ячейка (и её клон в замороженной области)
                    if (!on || ranges.length >= 600) continue
                    const r = rangeOf(cell)
                    if (r) ranges.push(r)
                }
            }
            // IE 2026 09 18 (заказ Игоря): «если есть такие значения в этом виджете или в других — выделять и текст в текущей
            // ячейке по такому же формату». Совпадения: свои (ranges) + найденные другими гридами страницы (общий реестр).
            // Внутренняя опция fe.ux.gridSameValueSelf (по умолчанию вкл).
            let selfN = 0
            if (this._sameVal && selfRanges.length && this.store.setting('fe.ux.gridSameValueSelf', true) !== false) {
                const ext = this.sameValue_crossOn() ? cellMatch_others(this.sameValue_busKey()) : 0
                this._sameValOthersExt = ext
                if (ranges.length + ext > 0) { selfN = selfRanges.length; ranges.push(...selfRanges) }
            } else this._sameValOthersExt = this._sameVal ? cellMatch_others(this.sameValue_busKey()) : 0
            if (!ranges.length) { if (this._sameValHL) { cellMatch_ranges(this.sameValue_busKey(), null); this._sameValHL = false } return }
            cellMatch_ranges(this.sameValue_busKey(), ranges, selfN)   // общий реестр: диапазоны всех гридов страницы в одном Highlight
            this._sameValHL = true
        },
        // формула под выбранной ячейкой: остаток = база + приходы − расходы (сумма против значения ячейки)
        influence_formulaShow(f, sel) {
            const host = this.flex?.hostElement
            if (!host) return
            // IE 2026 10 03 / ODOO-5800 (заказ Игоря: «Показать критич ош если небьется расчетный запас с фактич»): числа формулы остатка выбранной ячейки — для формы ячейки
            // (Dropdown.infl_formula_data → верхний вердикт «Critical» и красная рамка блока FORMULA, utils/cellStory.story_verdict / story_mismatchOfFormula). Объект заморожен:
            // Vue его не оборачивает, influence_toDropdown сравнивает по ссылке. Не формула остатка (приход / расход / непокрытое) либо формулы нет — null
            this._inflData = (f && f.kind === 'stock') ? Object.freeze({ kind: 'stock', prev: f.prev, base: f.base, sumIn: f.sumIn, sumOut: f.sumOut, calc: f.calc, cur: f.cur, factGate: !!f.factGate, nodes: f.nodes, factMonth: f.factMonth }) : null   // IE 2026 10 03 / ODOO-5800 (CONTRACT v7 §8, fe-50): + nodes, factMonth
            if (!f) { if (this._inflEl) { this._inflEl.remove(); this._inflEl = null } this._inflHover = false; this._inflText = ''; this._inflHtml = ''; this._inflShort = ''; this.influence_toDropdown(); return }
            const fmt = (v) => (Math.round(v) || 0).toLocaleString('ru-RU').replace(/^-/, '−')   // IE 2026 10 03 / ODOO-5800 (CONTRACT v3: base = 0 при оборотах, calc < 0): знак числа — «−» (U+2212) как у операторов формулы и у вердикта (ru-RU печатает ASCII-дефис); «−0» не пишется
            // IE 2026 09 22 / ODOO-5800 (замечание Игоря, скрин формы ячейки запаса: «не показывай нулевые части слагаемых … и выдели числа в формуле жирным»):
            // формула собирается из частей [{v, b}] — b = число (жирным в форме ячейки); нулевые слагаемые (приход/расход/непокрытое = 0 после округления) не пишутся
            const T = []; const num = (v) => T.push({ v: fmt(v), b: true }); const txt = (v) => T.push({ v })
            const numBad = (v) => T.push({ v: fmt(v), b: true, cls: 'infl-bad' })   // IE 2026 10 02 / ODOO-5800: число «плохо» (расхождение факт/расчёт) — цвет как у бейджа «Погано»
            const zero = (v) => Math.abs(Math.round(v)) === 0
            if (f.kind === 'stock') {
                const diff = f.cur - f.calc
                // IE 2026 09 23 / ODOO-341407: i18n (текст формулы остатка)
                txt(`${f.prev.slice(0, 7)}: `); num(f.base); txt(' ' + t('(stock)'))
                if (!zero(f.sumIn)) { txt(' + '); num(f.sumIn); txt(' ' + tn(f.nIn, '(in, {n} row)', '(in, {n} rows)')) }
                if (!zero(f.sumOut)) { txt(' − '); num(f.sumOut); txt(' ' + tn(f.nOut, '(out, {n} row)', '(out, {n} rows)')) }
                txt(' = '); num(f.calc)
                if (Math.abs(diff) > 0.5) { txt(' · ' + t('cell') + ' '); numBad(f.cur); txt(', ' + t('other', null, 'formula') + ' ' + (diff > 0 ? '+' : '−')); numBad(Math.abs(diff)) } else txt(' ✓')   // IE 2026 09 24 / ODOO-341407: контекстный ключ словаря (ревизия омонимов); IE 2026 10 02 / ODOO-5800: cur/diff — цвет «плохо» (условие показа — прежнее, без ворот факт/план: решение Игоря — ворота только у короткой сводки)
                // IE 2026 09 16: непокрытые объёмы — отдельно, в остаток не вошли
                const unc = []
                if (f.nUncOut && !zero(f.uncOut)) unc.push([f.uncOut, `⊘ −`, ' ' + tn(f.nUncOut, '({n} row, write-off impossible)', '({n} rows, write-off impossible)')])
                if (f.nUncIn && !zero(f.uncIn)) unc.push([f.uncIn, `⊘ +`, ' ' + tn(f.nUncIn, '({n} row, receipt impossible)', '({n} rows, receipt impossible)')])
                if (unc.length) { txt(' · ' + t('uncovered, not applied:') + ' '); unc.forEach(([v, pre, post], i) => { if (i) txt(', '); txt(pre); num(v); txt(post) }) }
            } else if (f.kind === 'unc') {
                txt('⊘ '); num(Math.abs(f.flow)); txt(' ' + t('uncovered — {reason}: stock not affected', { reason: f.role === 'out' ? t('write-off needed but impossible (no stock)') : t('receipt needed but impossible (not covered)') }))
            } else {
                txt(f.kind === 'in' ? '+' : '−'); num(Math.abs(f.flow)); txt(' → ' + t('stock rows ({n}) of every period', { n: f.n }) + (f.from ? ' ' + t('from {date}', { date: f.from.slice(0, 7) }) : ''))
            }
            const text = T.map(t => t.v).join('')
            const _esc = (x) => String(x).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            this._inflHtml = T.map(t => t.b ? ('<b' + (t.cls ? ' class="' + t.cls + '"' : '') + '>' + _esc(t.v) + '</b>') : _esc(t.v)).join('')   // IE 2026 10 02 / ODOO-5800: + cls (цвет «плохо»)
            // краткая сводка для свёрнутого блока формы (IE 2026 09 22, пункт 3.1 Игоря: «… 2 090 − 600 = 1 490»): остаток ± ненулевые обороты = итог
            if (f.kind === 'stock') {
                const sh = [`${f.prev.slice(0, 7)}: <b>${_esc(fmt(f.base))}</b>`]
                if (!zero(f.sumIn)) sh.push(` + <b>${_esc(fmt(f.sumIn))}</b>`)
                if (!zero(f.sumOut)) sh.push(` − <b>${_esc(fmt(f.sumOut))}</b>`)
                sh.push(` = <b>${_esc(fmt(f.calc))}</b>`)
                // IE 2026 10 02 / ODOO-5800 (решение Игоря 02.10): остаток не бьётся с ФАКТИЧЕСКИ записанным остатком следующего периода —
                // только в свёрнутой сводке (развёрнутая формула выше уже показывает «· cell …, formula ±…» безусловно — там только цвет, без ворот),
                // и только когда period cur не позже месяца начала плана (f.factGate, иначе по построению расхождения не бывает — подстановка
                // актуализации из плана тоже даёт diff 0, ворота по периоду этого не различают и это ожидаемо, см. RESULT.md)
                const diffShort = f.cur - f.calc
                if (f.factGate && Math.abs(diffShort) > 0.5) {
                    const signShort = diffShort > 0 ? '+' : '−'
                    const tip = _esc(t('Closing stock does not reconcile with the actual opening stock of the next period: {cur} vs {calc} ({diff})',
                        { cur: fmt(f.cur), calc: fmt(f.calc), diff: signShort + fmt(Math.abs(diffShort)) }))
                    sh.push(` <span class="infl-bad" title="${tip}">≠ <b>${_esc(fmt(f.cur))}</b> (${signShort}<b>${_esc(fmt(Math.abs(diffShort)))}</b>)</span>`)
                }
                this._inflShort = sh.join('')
            } else this._inflShort = this._inflHtml
            if (this._inflEl && this._inflEl.parentElement !== host) { this._inflEl.remove(); this._inflEl = null }   // IE 2026 09 17: грид пересоздан — элемент со старого хоста
            if (!this._inflEl) {
                this._inflEl = document.createElement('div')
                this._inflEl.className = 'infl-formula'
                this._inflEl.style.display = 'none'   // IE 2026 09 17 (замечание Игоря): видно только пока курсор над выбранной ячейкой
                host.appendChild(this._inflEl)
            }
            if (this._inflScrollFlex !== this.flex) {   // IE 2026 09 17: обработчик прокрутки — на текущем экземпляре грида (при пересоздании прежний теряется)
                if (this._inflScrollFlex && this._inflScrollH) { try { this._inflScrollFlex.scrollPositionChanged.removeHandler(this._inflScrollH) } catch (e) { /* прежний грид уже разрушен */ } }
                this._inflScrollH = this._inflScrollH || (() => this.influence_place())
                this.flex.scrollPositionChanged.addHandler(this._inflScrollH)
                this._inflScrollFlex = this.flex
            }
            // IE 2026 10 03 / ODOO-5800 (заказ Игоря: «Показать критич ош если небьется расчетный запас с фактич»): расхождение на границе факта — и примечание под выбранной
            // ячейкой (форма скрыта) в красной рамке с пометкой «Critical», как блок FORMULA формы; текст для формы (_inflText) прежний
            // IE 2026 10 03 / ODOO-5800 (CONTRACT v4 §4): допуск и выключатель — блок stock_check бэка из последнего ответа story этого грида (this._stockCheck, ставит cellStory_apply); story ещё не было — умолчания 10 шт. / 1 % / 5 % оборота (CONTRACT v5)
            // IE 2026 10 03 / ODOO-5800 (CONTRACT v7 §8, fe-50): блок бэка v7 (checked) — локальная формула не критикует вовсе (story_mismatchOfFormula → null); группа (f.nodes > 1) и не месяц факта — тоже нет
            const _crit = story_criticalOn(this._stockCheck) && !!story_mismatchOfFormula(f, this._stockCheck)
            this._inflEl.classList.toggle('is-critical', _crit)
            this._inflEl.textContent = (_crit ? t('Critical') + ' · ' : '') + text   // IE 2026 10 03 / ODOO-5800: + пометка
            this._inflText = text; this.influence_toDropdown()   // IE 2026 09 19 / ODOO-… (замечание Игоря: формула расчёта остатка — внутри формы ячейки, когда форма выведена)
            this._inflHover = this.influence_overSelected(this._inflLastPt)   // IE 2026 09 17: курсор уже над ячейкой (клик по ней) — показать сразу
            this.influence_place()
        },
        // IE 2026 09 17 (замечание Игоря «показывай примечание к расчёту ячейки, только если мышка над ней»): примечание закрывало соседние
        // ячейки всё время, пока ячейка была выбрана — теперь оно видно только под курсором над выбранной ячейкой; подсветка влияющих
        // ячеек остаётся с выбором. Курсор отслеживается по mousemove хоста грида (последняя точка — для показа сразу после клика)
        influence_hoverInit(flex) {
            const host = flex?.hostElement
            if (!host || this._inflHost === host) return
            if (this._inflHost && this._inflMoveH) {   // грид пересоздан (перечитывание отчёта) — слушатели на прежнем хосте снять
                this._inflHost.removeEventListener('mousemove', this._inflMoveH)
                this._inflHost.removeEventListener('mouseleave', this._inflLeaveH)
            }
            if (!this._inflMoveH) {
                this._inflMoveH = (e) => {
                    this._inflLastPt = { x: e.clientX, y: e.clientY }
                    if (!this._inflEl) return
                    const over = this.influence_overSelected(this._inflLastPt)
                    if (over === !!this._inflHover) return
                    this._inflHover = over
                    this.influence_place()
                }
                this._inflLeaveH = () => {
                    this._inflLastPt = null
                    if (this._inflHover) { this._inflHover = false; this.influence_place() }
                }
            }
            this._inflHost = host
            host.addEventListener('mousemove', this._inflMoveH)
            host.addEventListener('mouseleave', this._inflLeaveH)
        },
        // IE 2026 09 19 / ODOO-… (замечание Игоря: формула расчёта остатка — внутри формы ячейки, когда форма выведена).
        // Слова Игоря (скрин Purchase Balance): «показывай выделенный на скрине tooltip с формулой расчета внутри формы дропдаун ячейки, если такая
        // выведена». Форма ячейки открывается под той же ячейкой, что и примечание с формулой, — они накладывались. Пока форма выведена на ячейке-якоре
        // подсветки влияющих ячеек, формула живёт ВНУТРИ формы (Dropdown.infl_formula), плавающее примечание скрыто; форма закрылась — примечание снова
        // показывается под курсором над выбранной ячейкой. Выключатель fe.ux.inflFormulaInDropdown
        influence_toDropdown() {
            const dd = this.store.dropdown
            if (!dd || dd.vueObj !== this) return false
            const a = this._infl?.anchor, flex = this.flex, sel = flex?.selection
            const on = !!this._inflText && !!a && dd.dataItem === a.it && !!sel && sel.col >= 0 && flex.columns[sel.col]?.binding === a.b
                && this.store.setting('fe.ux.inflFormulaInDropdown', true) !== false
            const text = on ? this._inflText : ''
            if ((dd.infl_formula || '') !== text) dd.infl_formula = text
            const html = on ? (this._inflHtml || '') : '', short = on ? (this._inflShort || '') : ''   // IE 2026 09 22 / ODOO-5800: числа жирным; сводка для свёрнутого блока
            if ((dd.infl_formula_html || '') !== html) dd.infl_formula_html = html
            if ((dd.infl_formula_short || '') !== short) dd.infl_formula_short = short
            const data = on ? (this._inflData || null) : null   // IE 2026 10 03 / ODOO-5800: числа формулы остатка — вердикт «Critical» и красная рамка формулы в форме ячейки
            if ((dd.infl_formula_data || null) !== data) dd.infl_formula_data = data
            return on
        },
        influence_inDropdown() { const dd = this.store.dropdown; return !!dd && !!dd.visible && dd.vueObj === this && !!dd.infl_formula },
        influence_dropdownSync() { try { this.influence_toDropdown(); this.influence_place() } catch (e) { /* грид ещё не готов */ } },
        influence_overSelected(pt) {
            const flex = this.flex, sel = flex?.selection
            if (!pt || !flex || !sel || sel.row < 0 || sel.col < 0) return false
            try {
                const ht = flex.hitTest(pt.x, pt.y)
                return !!ht && ht.panel === flex.cells && ht.row === sel.row && ht.col === sel.col
            } catch (err) { return false }
        },
        influence_place() {
            const el = this._inflEl, flex = this.flex
            if (!el || !flex) return
            // IE 2026 09 20 / ODOO-5800 (уточнение Игоря: «достаточно в дропдаун …; не нужно при наведении показывать»): формула живёт только в выпадающей
            // форме ячейки (influence_toDropdown); плавающее примечание по наведению — по настройке fe.ux.inflFormulaHover = true (по умолчанию выключено)
            if (this.store.setting('fe.ux.inflFormulaHover', false) !== true) { el.style.display = 'none'; return }
            if (!this._inflHover) { el.style.display = 'none'; return }   // IE 2026 09 17 (замечание Игоря): без курсора над ячейкой — скрыто
            if (this.influence_inDropdown()) { el.style.display = 'none'; return }   // IE 2026 09 19 / ODOO-… (замечание Игоря: формула расчёта остатка — внутри формы ячейки, когда форма выведена)
            const sel = flex.selection
            const cell = sel && sel.row >= 0 && sel.col >= 0 ? flex.cells.getCellElement(sel.row, sel.col) : null
            if (!cell) { el.style.display = 'none'; return }
            const hr = flex.hostElement.getBoundingClientRect(), cr = cell.getBoundingClientRect()
            el.style.display = ''
            const below = cr.bottom - hr.top + 2
            el.style.top = (below + el.offsetHeight + 4 > hr.height ? cr.top - hr.top - el.offsetHeight - 2 : below) + 'px'
            el.style.left = Math.max(2, Math.min(cr.left - hr.left, hr.width - el.offsetWidth - 4)) + 'px'
        },
        negValue_paint(e_cell, dataItem, col) {
            // IE 2026 08 15 / ODOO-4997: отрицательное значение датной ячейки —
            // красный шрифт (класс), дёшево: только parseFloat + toggle
            const binding = col?.binding || ''
            if (!dataItem || !/^\d{4}-\d{2}-\d{2}\./.test(binding)) {
                e_cell.classList.remove('cell-neg-value'); e_cell.__negV = 0
                if (e_cell.__negC) { e_cell.style.removeProperty('color'); e_cell.__negC = 0 }
                return
            }
            const v = parseFloat(this.store.get_value(dataItem, binding))
            const neg = !Number.isNaN(v) && v < 0
            // IE 2026 10 19 / ODOO-347310: решаем по РЕАЛЬНОМУ состоянию ячейки, а не по
            // маркеру __negV/__negC — wijmo при перерисовке сбрасывает класс и цвет,
            // а маркер на элементе остаётся, и покраска молча пропускалась (чёрные минусы)
            if (neg !== e_cell.classList.contains('cell-neg-value')) {
                e_cell.classList.toggle('cell-neg-value', neg)
            }
            e_cell.__negV = neg ? 1 : 0
            // IE 2026 08 16 (заказ Игоря): условное оформление пишет цвет INLINE —
            // класс проигрывал и отрицательные оставались чёрными; красим
            // важным inline-цветом, при смене знака свой цвет снимаем
            if (neg) {
                if (e_cell.__negC !== 1 || e_cell.style.getPropertyPriority('color') !== 'important' || e_cell.style.getPropertyValue('color') !== 'rgb(198, 40, 40)') {
                    e_cell.style.setProperty('color', '#c62828', 'important')
                    e_cell.__negC = 1
                }
            } else if (e_cell.__negC) {
                e_cell.style.removeProperty('color')
                e_cell.__negC = 0
            }
        },
        rowStyle_clearCell(e_cell) {
            // IE 2026 08 15 / ODOO-4997: столбик data_columns — отдельный элемент
            e_cell.__rsPend = null // отменить отложенную вставку (microtask)
            if (e_cell.__rsBar) {
                e_cell.__rsBar.remove()
                e_cell.__rsBar = null
            }
            if (!e_cell.__rsBg) return
            e_cell.style.backgroundImage = ''
            e_cell.style.backgroundSize = ''
            e_cell.style.backgroundRepeat = ''
            e_cell.style.backgroundPosition = ''
            e_cell.__rsBg = 0
        },
        rowStyle_paint(e_cell, dataItem, col) {
            // рендер полосы/столбика в formatItem: только чтение кэшей + одна
            // ячейка — ничего тяжелее (скорость, требование Игоря)
            if (window.__rowStyleOff) { this.rowStyle_clearCell(e_cell); return }
            const binding = col?.binding || ''
            const mDate = /^(\d{4}-\d{2}-\d{2})\.(.+)$/.exec(binding)
            if (!mDate) { this.rowStyle_clearCell(e_cell); return }
            const raw = mDate[2]
            // IE 2026 08 15 / ODOO-4997: канал настройки НА ПОЛЕ (DS.attrs_field,
            // за HSL group) — перекрывает строковую настройку data_layout2
            const fa = this.attr_by_binding[binding]
            let style = fa?.row_style || null
            let scheme = fa?.row_style_scheme || null
            if (!style && raw === 'quantity') {
                // строковый канал (узлы data_layout2) — как раньше, только quantity
                const rid = dataItem?._DLRow?.row_id
                if (rid) {
                    this.balancePreview_branchOf(dataItem) // прогрев карты узлов (разово)
                    const cfg = this._bpBranchMap?.[rid]
                    style = cfg?.rs || null
                    scheme = scheme || cfg?.rsc || null
                }
            }
            if (!style || style === 'color_scales') { this.rowStyle_clearCell(e_cell); return }
            // выделение ячейки главнее полосы
            if (e_cell.classList.contains('wj-state-selected') || e_cell.classList.contains('wj-state-multi-selected')) {
                this.rowStyle_clearCell(e_cell); return
            }
            const v = parseFloat(this.store.get_value(dataItem, binding))
            const st = Number.isNaN(v) ? null : this.rowStyle_stats(dataItem, raw)
            if (!st) { this.rowStyle_clearCell(e_cell); return }
            // семантика Excel: без отрицательных — (v−min)/(max−min); с
            // отрицательными — от нуля, |v|/max(|min|,|max|), минус — красным
            const frac = st.hasNeg ? Math.abs(v) / st.negSpan : (v - st.min) / st.span
            const pct = Math.round(Math.max(0.03, Math.min(1, frac)) * 100)
            const scheme2 = this.rowStyle_schemes()[scheme] || this.rowStyle_schemes().blue
            const c = v < 0 ? scheme2.neg : scheme2.pos
            if (style === 'data_columns') {
                // IE 2026 08 15 / ODOO-4997 (заказ Игоря): столбик — узкий элемент
                // ОДИНАКОВОЙ ширины (~один символ), слева с отступом 2px,
                // закруглённые верхние углы; градиент так не умеет
                e_cell.style.backgroundImage = ''
                e_cell.style.backgroundSize = ''
                e_cell.style.backgroundRepeat = ''
                e_cell.style.backgroundPosition = ''
                // столбик вставляем МИКРОТАСКОМ: дальше по formatItem штатный код
                // пишет e_cell.innerHTML и снёс бы вставленный сейчас элемент
                e_cell.__rsPend = { pct, color: c.strong }
                if (!e_cell.__rsQueued) {
                    e_cell.__rsQueued = 1
                    queueMicrotask(() => {
                        e_cell.__rsQueued = 0
                        const p = e_cell.__rsPend
                        if (!p || !e_cell.isConnected) return
                        let bar = e_cell.querySelector(':scope > .rs-col-bar')
                        if (!bar) {
                            bar = document.createElement('div')
                            bar.className = 'rs-col-bar'
                            e_cell.appendChild(bar)
                        }
                        bar.style.height = p.pct + '%'
                        bar.style.background = p.color
                        e_cell.__rsBar = bar
                    })
                }
            } else { // data_bars: градиентная заливка как Excel Gradient Fill
                e_cell.__rsPend = null
                if (e_cell.__rsBar) { e_cell.__rsBar.remove(); e_cell.__rsBar = null }
                e_cell.style.backgroundImage = `linear-gradient(to right, ${c.strong} 0%, ${c.faint} ${pct}%, transparent ${pct}%)`
                e_cell.style.backgroundSize = ''
                e_cell.style.backgroundRepeat = ''
                e_cell.style.backgroundPosition = ''
            }
            e_cell.__rsBg = 1
        },
        balancePreview_branchOf(dataItem) {
            // ветка лэйаута строки (Sales/Purch/Distr IN/Distr OUT/Stock/...) по
            // _DLRow.row_id: первый титулованный уровень пути в data_layout2.
            // АН 2026 08 14 / ODOO-4997: рядом с титулом собирается и ЯВНАЯ роль
            // узла balance_role ('in'|'out'|'stock'|'none', наследуется вглубь; 'none' — вне баланса) — матч
            // по названию ветки остаётся fallback'ом для лэйаутов без ролей.
            const rid = dataItem?._DLRow?.row_id
            if (!rid) return null
            if (!this._bpBranchMap) {
                const dl2 = this.store.get_value(this.WIDGET?.record, 'doc.params.data_layout2') || []
                const m = {}
                // АН 2026 08 15 / ODOO-4997: структурный fallback для лэйаутов без
                // row_id (Гант): роль узла ищется по полям группировки — строка
                // принадлежит самому ГЛУБОКОМУ узлу с ролью, чьё поле на ней непусто
                const fieldRoles = []
                // АН 2026 08 15 / ODOO-4997 (п.2 Игоря «не угадывать природу строки»):
                // мера документа калькуляции берётся из WHERE-фильтра узла лэйаута
                // (measure = open_balance/SP/PO...) — сопоставление, а не словарь имён
                const nodeMeasure = (r) => {
                    const scanW = (rows) => {
                        for (const w of rows || []) {
                            if (!w || w.use === false) continue
                            if ((w.leftValue?.value === 'measure') && (w.condition === '=' || !w.condition)
                                && typeof w.rightValue?.value === 'string' && w.rightValue.value) {
                                return w.rightValue.value
                            }
                            // IE 2026 08 20 / ODOO-5512 (баг Игоря: Ex-Distr «↑спрос →
                            // ↓закупки»): мульти-мера узла (condition 'in', напр.
                            // OUT + OUT_uncovered) меру не выдавала → role='link' →
                            // бэк лепил приход; берём первую НЕ-_uncovered меру списка
                            if ((w.leftValue?.value === 'measure') && w.condition === 'in' && Array.isArray(w.attrs)) {
                                for (const a of w.attrs) {
                                    const v = a?.rightValue?.value
                                    if (typeof v === 'string' && v && !v.endsWith('_uncovered')) return v
                                }
                            }
                            const sub = scanW(w.attrs)
                            if (sub) return sub
                        }
                        return null
                    }
                    return scanW(r.WHERE)
                }
                // АН 2026 08 15 / ODOO-4997 (заказ Игоря «Data bars»): стиль строки
                // задаётся на УЗЛЕ data_layout2 (row_style: 'data_bars' |
                // 'color_scales' | 'data_columns'; row_style_scheme: палитра) и
                // наследуется вглубь — рендер см. rowStyle_paint
                const walk = (rows, branch, role, measure, depth, rstyle, rscheme) => {
                    for (const r of rows || []) {
                        if (!r || typeof r !== 'object') continue
                        const b = branch || (typeof r.title === 'string' && r.title.trim() ? r.title.trim() : null)
                        const ro = role || r.balance_role || null
                        const me = nodeMeasure(r) || measure || null
                        const rs = r.row_style || rstyle || null
                        const rsc = r.row_style_scheme || rscheme || null
                        if (r.row_id) m[r.row_id] = { b, ro, me, rs, rsc }
                        if (ro && !r.row_id) {
                            // только ВИДИМЫЕ поля узла: скрытые (subject на Ганте)
                            // есть и на чужих уровнях — дали бы ложную роль
                            for (const f of r.fields || []) {
                                if (f?.binding && !f.hidden) fieldRoles.push({ binding: f.binding, role: ro, measure: me, depth })
                            }
                        }
                        walk(r.attrs, b, ro, me, depth + 1, rs, rsc)
                    }
                }
                for (const root of dl2) walk(root?.attrs, null, root?.balance_role || null, null, 0, root?.row_style || null, root?.row_style_scheme || null) // корневую строку блока пропускаем
                this._bpBranchMap = m
                this._bpFieldRoles = fieldRoles.sort((a, z) => z.depth - a.depth)
            }
            return this._bpBranchMap[rid]?.b || null
        },
        // IE 2026 09 17 (заказ Игоря «шаблон выделения строк»): роль строки раскладки balance_role (поле «Balance role» строки, наследуется
        // вложенными): stock | in | out | unc_in | unc_out — последние две = движение нужно, но невозможно (непокрытое): направление
        // для расчёта, знак ⊘ и «в остаток не входит» — balancePreview_uncOf
        balanceRole_base(r) { return r === 'unc_in' ? 'in' : (r === 'unc_out' ? 'out' : (r || null)) },
        balancePreview_uncOf(dataItem) {
            this.balancePreview_branchOf(dataItem) // прогревает _bpBranchMap
            const rid = dataItem?._DLRow?.row_id
            const r = (rid && this._bpBranchMap?.[rid]?.ro) || dataItem?._DLRow?.balance_role || null
            return r === 'unc_in' || r === 'unc_out'
        },
        balancePreview_roleOf(dataItem) {
            this.balancePreview_branchOf(dataItem) // прогревает _bpBranchMap
            const rid = dataItem?._DLRow?.row_id
            const byId = rid && this._bpBranchMap?.[rid]?.ro
            if (byId) return this.balanceRole_base(byId)   // IE 2026 09 17: unc_in / unc_out → направление
            // АН 2026 08 15 / ODOO-4997: явная роль на строке (если бэк проложит)
            if (dataItem?._DLRow?.balance_role) return this.balanceRole_base(dataItem._DLRow.balance_role)
            // структурный fallback: глубочайший узел с ролью, чьё поле непусто
            for (const e of this._bpFieldRoles || []) {
                const v = dataItem?.[e.binding]
                if (v !== undefined && v !== null && v !== '' && v !== 0 && v !== '0') return this.balanceRole_base(e.role)
            }
            // АН 2026 08 15 / ODOO-4997: роль из МЕРЫ (сопоставление с документом
            // калькуляции), а не из названия ветки
            const me = this.balancePreview_measureOf(dataItem)
            if (me) {
                const r2 = this.balancePreview_measureRole(me)
                if (r2) return r2
            }
            return null
        },
        balancePreview_measureOf(dataItem) {
            // АН 2026 08 15 / ODOO-4997 (п.2 Игоря): мера строки как в документе
            // калькуляции — из карты лэйаута (WHERE узла), затем со строки
            this.balancePreview_branchOf(dataItem) // прогревает _bpBranchMap
            const rid = dataItem?._DLRow?.row_id
            const byId = rid && this._bpBranchMap?.[rid]?.me
            if (byId) return byId
            const mRow = dataItem?.measure ?? dataItem?.measure_?.binding ?? dataItem?.measure_?.id
            if (typeof mRow === 'string' && mRow) return mRow.split('::').pop()
            return null
        },
        balancePreview_measureRole(me) {
            // таблица сопоставления «мера документа калькуляции → роль в балансе»
            if (/^(open_balance|close_balance)$/.test(me)) return 'stock'
            if (/^(SP|SS|SO|NS|NO|OUT|OOS|DS_OUT|OUT_uncovered|OUT_autoplan|SO_autoplan|NO_autoplan)$/.test(me)) return 'out'
            if (/^(PO|MO|DO|IN|MS|PS|DS_IN|IN_done|MO_done|PO_done|IN_autoplan|DO_IN_autoplan|IN_target)$/.test(me)) return 'in'
            return null
        },
        balancePreview_afterEdit(dataItem, colBindings, oldTotal, newTotal, opts = null) {
            if (!this.store.get_value(this.WIDGET?.record, 'doc.params.online_balance_preview')) return
            const branch = this.balancePreview_branchOf(dataItem)
            // знак влияния на остаток: расходные уменьшают, приходные увеличивают.
            // АН 2026 08 14 / ODOO-4997: приоритет — явная роль balance_role узла;
            // словарь названий веток остаётся для лэйаутов без ролей
            const role = this.balancePreview_roleOf(dataItem)
            // IE 2026 09 17 / ODOO-5800 (заказ Игоря): 'none' — строка вне баланса; остаток она не двигает, и
            // резерв по названию ветки («Sales» → минус) для неё не работает. Правка-связь (по measure_type)
            // остаётся: бэк сам решит, какие документы двигает такая строка
            const sign = role === 'none' ? 0 : role === 'in' ? 1 : role === 'out' ? -1 :
                         { 'Sales': -1, 'Needs': -1, 'Distr OUT': -1,
                           'Purch': 1, 'Purchases': 1, 'Distr IN': 1, 'Manuf': 1 }[branch]
            if (window.__simDebug) console.log('sim: afterEdit', JSON.stringify({ branch, role, sign, rid: dataItem?._DLRow?.row_id })) // АН 2026 08 15 / ODOO-4997
            // IE 2026 08 19 / ODOO-5512 (заказ Игоря): «Shipment from Supplier»
            // (OrderSupplierShipment) остаток сам не двигает, но связан с приходом
            // «Estimated Arrival to BW» через документ PO — правка уходит на бэк
            // как link-правка: бэк вернёт корреспондирующую правку прихода
            // (sim po_link) и пересчёт остатков склада прихода
            // IE 2026 09 25 / ODOO-5800 (D5, разбор ie-fado7: лист раскладки несёт только субъект — правка уходила без measure_type,
            // бэк не вычитал дельту пользователя из изменений мер, откат возвращал её в ячейку): тип меры и alert — свои либо
            // ближайшего предка (только у строк с ролью в балансе: строки вне баланса без своего типа меры по-прежнему не уходят).
            // Выключатель fe.sim.editContext
            const _ctx = this.sim_flag('editContext') ? this.sim_rowContext(dataItem) : null
            const mtEdit = String(dataItem?.measure_type || '') || (_ctx && sign ? String(_ctx.measure_type || '') : '')
            const alertEdit = (_ctx ? String(_ctx.alert || '') : String(dataItem?.alert || '')) || undefined
            // IE 2026 08 19: движок на транзакциях — любая строка с типом меры уходит
            // на бэк (он сам решит, какие транзакции/документы и балансы она двигает)
            const linkOnly = !sign && !!mtEdit
            if (!sign && !linkOnly) return
            const o = parseFloat(oldTotal), n = parseFloat(newTotal)
            const delta = ((Number.isNaN(n) ? 0 : n) - (Number.isNaN(o) ? 0 : o)) * (sign || 1)
            if (!delta) return
            const dates = (colBindings || []).map(b => String(b).slice(0, 10))
                .filter(d => /^\d{4}-\d{2}-\d{2}$/.test(d))
            if (!dates.length) return
            const dEdit = dates.sort()[0]
            // блок объекта: корень дерева данных, содержащий правленую строку
            const kidsPath = this.attr.childItemsPath || 'attrs'
            let top = null
            const holds = (it) => {
                if (it === dataItem) return true
                for (const k of it?.[kidsPath] || []) if (holds(k)) return true
                return false
            }
            for (const r of (this.data000 || this.data || [])) {
                if (holds(r)) { top = r; break }
            }
            if (!top) return
            // строки остатков блока (ветка Stock; берём ЛИСТЬЯ — детали subject'ов)
            const stockLeaves = []
            // IE 2026 09 25 / ODOO-5800 (проверка на DM 25.09): под строкой остатка склада — только memo-строки «· of which expired»
            // (total_excluded) — такая строка сама лист остатка, иначе превью остатков DM не находило строку склада. Выключатель fe.sim.memoLeaves
            const _memoOn = this.sim_flag('memoLeaves')
            const scan = (it) => {
                const kids = it?.[kidsPath]
                // АН 2026 08 14 / ODOO-4997: остаток — по явной роли 'stock' или по
                // названию ветки; 'Starting inventory' (R1h_001) раньше не матчился
                const isStock = this.balancePreview_roleOf(it) === 'stock'
                    || /^(Stock|Starting inventory|Inventory)/i.test(this.balancePreview_branchOf(it) || '')
                const ownKids = Array.isArray(kids) ? (_memoOn ? kids.filter(k => !k?._DLRow?.total_excluded) : kids) : []
                if (isStock && !ownKids.length && !(_memoOn && it?._DLRow?.total_excluded)) stockLeaves.push(it)
                for (const k of kids || []) scan(k)
            }
            scan(top)
            // дельта — одна на блок: пишем в остаток СУБЪЕКТА правки, нет его —
            // в первый лист (иначе размножилась бы на все склады сети)
            const subjEdit = dataItem?.subject
            const stockTargets = stockLeaves.length ? [
                stockLeaves.find(it => subjEdit && it.subject === subjEdit) || stockLeaves[0],
            ] : []
            // АН 2026 08 14 / ODOO-4997: серверная симуляция — та же правка уходит
            // на бэк (батчем, debounce): object/subject строки-меры пусты, берём
            // их с блока/листа остатков; бэк пересчитает остатки/DOS на
            // документах калькуляции и вернёт ТОЧНЫЕ значения (sim_applyChanges).
            // АН 2026 08 15 / ODOO-4997: очередь — ДО гейта stock-строк: на Ганте
            // отдельных строк остатка нет (остаток — колонко-мера
            // <дата>.sku_data::open_balance), ответ применит sim_applyChanges
            // IE 2026 08 19 / ODOO-5512: контекст ячейки для бэка — тип меры и
            // конец периода колонки (связь мер заказа поставщику через документ)
            const _ac0 = this.attr_by_binding?.[dEdit] || this.attr_by_binding?.[(colBindings || [])[0]]
                || this.column_by_binding?.[(colBindings || [])[0]]
            this.sim_queueEdit({
                object: dataItem?.object || top?.object,
                subject: subjEdit || stockTargets[0]?.subject || top?.subject,
                workcenter: dataItem?.workcenter || top?.workcenter,
            }, dEdit, linkOnly ? 'link' : (role || (sign > 0 ? 'in' : 'out')),
                (Number.isNaN(n) ? 0 : n) - (Number.isNaN(o) ? 0 : o),
                { measure_type: mtEdit || undefined, measure: this.balancePreview_measureOf(dataItem) || undefined,
                  alert: alertEdit,   // IE 2026 09 25 / ODOO-5800 (D2/D5): ключ правки строки «| Uncovered» на бэке — свой
                  date_next: _ac0?.date_next || (_ac0?.parents_ || []).map(p => p?.date_next).find(Boolean) || undefined,
                  // IE 2026 08 20 / ODOO-5512 (заказ Игоря): «-» в ячейке =
                  // жёсткий ноль (эпсилон 1e-7) — на бэке это драфт-маркер
                  // периода: автопланы не ранее следующего периода
                  hard_zero: (!Number.isNaN(n) && n > 0 && n < 1e-4) || undefined })
            // IE 2026 08 19: откат/повтор — только уведомить бэк (ячейки вернул сам откат)
            if (opts?.queueOnly) return
            if (linkOnly || !stockLeaves.length) return
            // АН 2026 08 15 / ODOO-4997 (п.1 Игоря «интерфейс залипает»): тяжёлая
            // отрисовка превью уходит из критического пути правки — быстрые правки
            // нескольких ячеек копятся в очередь и красятся ОДНИМ отложенным
            // проходом внутри deferUpdate (одна перерисовка)
            // IE 2026 08 15: запоминаем actionStack породившей правки — отложенная
            // отрисовка превью попадёт в ТУ ЖЕ undo-группу (одно событие)
            ;(this._bpPaintQueue = this._bpPaintQueue || []).push({ stockTargets, dEdit, delta, as: this.actionStack })
            if (!this._bpPaintTimer) {
                this._bpPaintTimer = setTimeout(() => this.balancePreview_paintQueued(), 0)
            }
        },
        balancePreview_paintQueued() {
            // АН 2026 08 15 / ODOO-4997: отложенная отрисовка локального превью.
            // Семантика по МЕРЕ строки (п.2): open-мера — колонки СТРОГО после даты
            // правки; close-мера — плюс период самой правки. Каждая локальная дельта
            // пишется в леджер _simLedger — применение серверного ответа (дельтами)
            // корректирует только расхождение, без мелькания (п.3).
            this._bpPaintTimer = null
            const queue = this._bpPaintQueue || []
            this._bpPaintQueue = []
            if (!queue.length) return
            const allDateBindings = []
            for (const b in this.attr_by_binding) {
                if (/^\d{4}-\d{2}-\d{2}\.quantity$/.test(b)) allDateBindings.push(b)
            }
            allDateBindings.sort()
            if (!allDateBindings.length) return
            const paint = () => {
                const ancestors = new Map() // target → Set(bindings)
                for (const task of queue) {
                    for (const it of task.stockTargets) {
                        const me = this.balancePreview_measureOf(it) || ''
                        const isClose = /close/.test(me)
                        const bindings = []
                        let lastBefore = null
                        for (const b of allDateBindings) {
                            const d = b.slice(0, 10)
                            if (d <= task.dEdit) { lastBefore = b; continue }
                            bindings.push(b)
                        }
                        // close-мера меняется уже в периоде правки
                        if (isClose && lastBefore) bindings.unshift(lastBefore)
                        if (!bindings.length) continue
                        const irowIt = this.rows_indexOf(it)
                        for (const b of bindings) {
                            const cur = parseFloat(this.store.get_value(it, b))
                            if (Number.isNaN(cur)) continue // пустая ячейка остатка — не выдумываем
                            const next = Math.round((cur + task.delta) * 1e6) / 1e6
                            this.set_value(irowIt, it, b, cur, next, true, null, true)
                            this.sim_ledgerAdd(it, b, task.delta)
                        }
                        if (!ancestors.has(it)) ancestors.set(it, new Set())
                        for (const b of bindings) ancestors.get(it).add(b)
                    }
                }
                for (const [it, bset] of ancestors) {
                    this.decomp_syncAncestors(it, Array.from(bset))
                }
                if (ancestors.size) {
                    this._foldAggCache = null
                    this._rowStyleStats = null // АН 2026 08 15 / ODOO-4997
                    this.flexRefresh()
                }
            }
            // IE 2026 08 15: рисуем под actionStack породившей правки — превью
            // склеивается с нею в одну undo-группу (заказ Игоря «одно событие»)
            const _savedAS = this.actionStack
            const _queueAS = queue[0]?.as
            if (_queueAS != null) this.actionStack = _queueAS
            try {
                if (this.flex?.deferUpdate) this.flex.deferUpdate(paint)
                else paint()
            } finally {
                this.actionStack = _savedAS
            }
        },
        dimHl_foldDates(colIdx, ac) {
            // АН 2026 08 15 / ODOO-4997 (замечание Игоря п.2): период СВЁРНУТОЙ
            // группы колонок-дат по ИНДЕКСУ колонки. Ключ fold-карты — wijmo
            // binding колонки ('2026-03-01.quantity'), НЕ attr-биндинг ('n6') —
            // старый lookup по binding0 никогда не совпадал и период не
            // раскрывался. Даты берём из ЛИСТЬЕВ группы (не sourceBindings:
            // Total-ветка отдала бы '_total::…' вместо дней).
            try {
                const key = this.flex?.columns?.[colIdx]?.binding
                const map = this.foldAgg_groups?.() || new Map()
                let grp = key && map.get(key)?.find(g => g.isCollapsed)
                if (!grp && ac?.date) {
                    // представитель в карте один на группу (обычно '.quantity') —
                    // для соседних мер того же периода ищем по дате колонки
                    const d = String(ac.date).slice(0, 10)
                    for (const [k, gs] of map) {
                        if (!String(k).startsWith(d)) continue
                        grp = gs.find(g => g.isCollapsed)
                        if (grp) break
                    }
                }
                if (!grp) return null
                const leaves = []
                const walk = (g) => {
                    if (!g.columns || !g.columns.length) { leaves.push(g.binding); return }
                    for (const c of g.columns) walk(c)
                }
                walk(grp)
                const ds = leaves.map(b => String(b).slice(0, 10))
                    .filter(s => /^\d{4}-\d{2}-\d{2}$/.test(s)).sort()
                if (!ds.length) return null
                return { from: ds[0], to: ds[ds.length - 1] }
            } catch (e) { return null }
        },
        dimHighlight_onNav(flex) {
            if (this._dimHlApplying) return // программное перемещение из приёмника — не ре-эмитим
            // АН 2026 08 15 / ODOO-4997: эмит подсветки от ПОЛЬЗОВАТЕЛЬСКОЙ навигации
            // по ячейкам (debounce 150 мс; дедуп по последним измерениям). Приёмники
            // применяют выделение ТИХО и не ре-эмитят — каскадного зацикливания нет
            // by construction; свой источник игнорируется по detail.source.
            clearTimeout(this._dimHlNavTimer)
            this._dimHlNavTimer = setTimeout(() => {
                try {
                    const sel = flex?.selection
                    const it = sel && sel.row >= 0 ? flex.rows[sel.row]?.dataItem : null
                    if (!it) return
                    // object/subject строки-меры пусты — наследуем от предков блока
                    const kidsPath = this.attr.childItemsPath || 'attrs'
                    let object = it.object, subject = it.subject
                    if (!object || !subject) {
                        const walk = (r, inhO, inhS) => {
                            const o = r?.object || inhO, s = r?.subject || inhS
                            if (r === it) return { o, s }
                            for (const k of r?.[kidsPath] || []) {
                                const res = walk(k, o, s)
                                if (res) return res
                            }
                            return null
                        }
                        for (const r of (this.data000 || this.data || [])) {
                            const res = walk(r, null, null)
                            if (res) { object = object || res.o; subject = subject || res.s; break }
                        }
                    }
                    const values = []
                    const val = (x) => x === undefined || x === null ? '' :
                        (typeof x === 'object' ? String(x.id ?? x.value ?? '') : String(x))
                    // АН 2026 08 15 / ODOO-4997 (замечание Игоря п.1): без СУБЪЕКТА не
                    // подсвечиваем — сигнал «только объект» отмечал бы ВСЕ точки
                    // бабла этого объекта (бессмысленно при фильтре по объекту);
                    // пустой список снимает прежнюю подсветку
                    if (val(subject) && val(subject) !== '0') {
                        for (const [v, kind] of [[object, 'object'], [subject, 'subject']]) {
                            const s = val(v)
                            if (s && s !== '0') values.push({ key: s, kind, bare: s.split('::')[0] !== s ? s.split('::')[0] : undefined })
                        }
                    }
                    // АН 2026 08 15 / ODOO-4997 (замечание Игоря п.7): дата/период
                    // выделенной КОЛОНКИ едет в сигнале — бабл выделяет точку месяца,
                    // свёрнутый месяц отдаёт период целиком
                    try {
                        let ac = null, acCi = -1
                        for (let ci = sel.col; ci >= 0 && ci >= sel.col - 3; ci--) {
                            ac = this.get_attr_col(ci, true)
                            if (ac?.date) { acCi = ci; break }
                        }
                        if (ac?.date) {
                            let from = String(ac.date).slice(0, 10), to = from
                            const f = this.dimHl_foldDates(acCi, ac) // свёрнутый период — целиком (п.2)
                            if (f) { from = f.from; to = f.to }
                            // IE 2026 08 15 (замечание Игоря п.13): строка БЕЗ
                            // субъекта, но с датной колонкой — эмитим «только
                            // дату»: приёмники СУЖАЮТ прежнюю подсветку по
                            // периоду (бабл: последний субъектный контекст)
                            values.push({ kind: 'date', from, to })
                        }
                    } catch (e) { /* колонка без даты */ }
                    // IE 2026 08 17 / ODOO-4997 (решение Игоря, «строго»): в сигнал
                    // уходят ТОЛЬКО измерения из Set fields виджета; дата — если
                    // выделенная колонка входит в датные поля списка; пусто —
                    // виджет молчит (прежнюю подсветку соседей не трогаем)
                    const allowDate = this.selDate_fields('set') ? this.selDate_set() : false
                    const gated = this.store.selDims_filter(this.WIDGET, 'set', values, allowDate)
                    if (!gated.length) return
                    values.length = 0; values.push(...gated)
                    const sig = values.map(v => v.key || (v.from + '..' + v.to)).join('|')
                    if (sig === this._dimHlNavLast) return // дедуп — не спамить при движении по строке
                    this._dimHlNavLast = sig
                    if (window.__simDebug) console.log('sim: grid emit dim-highlight', values.length, 'values from', this.WIDGET?.id)
                    window.dispatchEvent(new CustomEvent('wscm-dim-highlight', {
                        detail: { source: this.WIDGET?.id, page: this.WIDGET?.page, values },
                    }))
                } catch (e) { /* навигация не должна падать из-за подсветки */ }
            }, this.store.setting('fe.ux.gridDimHighlightDebounceMs', 150))   // IE 2026 09 05 / ODOO-336330
        },
        applyDimHighlight(detail) {
            // АН 2026 08 15 / ODOO-4997 (заказ Игоря): каскад ПОДСВЕТКИ от графа
            // Supply Chain Flow — строки, чьи измерения (workcenter/subject/object,
            // uuid ИЛИ титул) выделены в графе, получают рыжий обвод (как выделение
            // ячейки). Пустой values = снять подсветку.
            if (!detail || detail.source === this.WIDGET?.id) return
            // IE 2026 08 17 / ODOO-4997 (решение Игоря, «строго»): виджет принимает
            // подсветку ТОЛЬКО по измерениям из своих Get fields (subject/object …);
            // пустой список — не реагирует. Дата в сигнале проходит, если в Get
            // fields есть датное поле (позиционирование колонки ниже)
            const getDims = this.store.selDims_of(this.WIDGET, 'get')
            const getDate = !!(this.selDate_fields('get') && this.selDate_get())
            if (!getDims.length && !getDate) return
            detail = { ...detail, values: (detail.values || []).filter(v => v?.kind === 'date' ? getDate : getDims.includes(String(v?.kind || ''))) }
            if (!detail.values.length) return
            this._dimGetDims = getDims
            // IE 2026 08 15 (жалоба Игоря п.18 «выделяется вся область»):
            // ключи собираем ПО ИЗМЕРЕНИЯМ — вырожденное измерение отчёта
            // (один субъект на странице Ганта, один объект при чипсе) сигнал
            // не различает и метило бы всё; такие ключи выкидываем
            const kSubjT = new Set(), kObjT = new Set(), kAnyT = new Set()
            for (const v of detail.values || []) {
                if (v?.kind === 'date') continue
                const dst = v?.kind === 'subject' ? kSubjT : v?.kind === 'object' ? kObjT : kAnyT
                for (const k of [v?.key, v?.bare, v?.label, v?.doc_id]) if (k) dst.add(String(k))
            }
            const hadKeys = kSubjT.size + kObjT.size + kAnyT.size > 0
            const keys = new Set()
            // IE 2026 08 15 (п.13): сигнал «ТОЛЬКО дата» (строка без субъекта,
            // датная колонка) — прежнюю подсветку строк НЕ трогаем, период
            // уходит штатным каналом Chart; сужение делает бабл
            if (!hadKeys && (detail.values || []).some(v => v?.kind === 'date')) return
            {
                // пп.9/18: мощности измерений отчёта — ВЫРОЖДЕННОЕ измерение
                // (≤1 различного значения) из матча исключается; если после
                // этого ключей не осталось — подсветку не трогаем вовсе
                const kidsPath0 = this.attr.childItemsPath || 'attrs'
                const val0 = (x) => x === undefined || x === null ? '' :
                    (typeof x === 'object' ? String(x.title ?? x.id ?? x.value ?? '') : String(x))
                const uObj = new Set(), uSubj = new Set()
                const dims = (it) => {
                    const o = val0(it?.object), s = val0(it?.subject)
                    if (o) uObj.add(o); if (s) uSubj.add(s)
                    for (const k of (it?.[kidsPath0] || [])) dims(k)
                }
                for (const r of (this.data000 || this.data || [])) dims(r)
                for (const k of kSubjT) keys.add(k)
                for (const k of kObjT) keys.add(k)
                for (const k of kAnyT) keys.add(k)
                // вырожденные ПОЛЯ отчёта в матче не участвуют (сигнал по ним
                // пометил бы всё) — остальные поля (workcenter и т.п.) матчатся
                this._dimDegSubj = uSubj.size <= 1
                this._dimDegObj = uObj.size <= 1
            }
            const rows = new Set()
            if (keys.size) {
                const kidsPath = this.attr.childItemsPath || 'attrs'
                const val = (x) => x === undefined || x === null ? '' :
                    (typeof x === 'object' ? String(x.title ?? x.id ?? x.value ?? '') : String(x))
                // матч по ЛЮБОМУ собственному строковому полю строки (uuid или титул):
                // имена полей разнятся между лэйаутами — жёсткий список пропускал строки
                const hitBy = (it) => {
                    for (const k in it) {
                        if (k.startsWith('_') || k === kidsPath) continue
                        // IE 2026 08 17 («строго»): матч ТОЛЬКО по полям из Get fields
                        if (this._dimGetDims?.length && !this._dimGetDims.includes(k)) continue
                        // пп.9/18: вырожденные поля отчёта не различают — пропуск
                        if (k === 'subject' && this._dimDegSubj) continue
                        if (k === 'object' && this._dimDegObj) continue
                        const s = val(it[k])
                        if (s && (keys.has(s) || (s.includes('::') && keys.has(s.split('::')[0])))) return true
                    }
                    return false
                }
                const directRows = this._dimHighlightDirect = new Set()
                const scan = (it, inhO, inhS, parents) => {
                    // object/subject наследуются от предков — строки-меры сами пусты
                    const o = val(it?.object) || inhO, s2 = val(it?.subject) || inhS
                    const gd = this._dimGetDims || []
                    if (hitBy(it) || (gd.includes('object') && !this._dimDegObj && o && keys.has(o)) || (gd.includes('subject') && !this._dimDegSubj && s2 && keys.has(s2))) {
                        rows.add(it)
                        directRows.add(it) // сама совпавшая строка (не предок)
                        // совпавший лист может быть свёрнут — подсвечиваем и путь к нему
                        for (const p of parents) rows.add(p)
                    }
                    const kids = it?.[kidsPath] || []
                    if (kids.length) {
                        parents.push(it)
                        for (const k of kids) scan(k, o, s2, parents)
                        parents.pop()
                    }
                }
                for (const r of (this.data000 || this.data || [])) scan(r, '', '', [])
                // пп.9/18: совпадений нет из-за вырожденности — выделение НЕ меняем
                if (!rows.size && (this._dimDegSubj || this._dimDegObj)) {
                    if (window.__simDebug) console.log('sim: dim-highlight unchanged (degenerate, no match)', this.WIDGET?.id)
                    return
                }
                if (window.__simDebug) console.log('sim: dim-highlight matched', rows.size, 'rows in', this.WIDGET?.id)
            }
            this._dimHighlightRows = rows
            if (window.__simDebug) console.log('sim: dim-highlight', keys.size, 'keys →', rows.size, 'rows in', this.WIDGET?.id)
            // АН 2026 08 15 / ODOO-4997 (замечание Игоря п.6): переместить ВЫДЕЛЕНИЕ
            // на первую ВИДИМУЮ строку, совпавшую НЕПОСРЕДСТВЕННО (не предка),
            // сохранив колонку текущего выделения. Программное перемещение — под
            // гардом ignore_selectionChanged (не эмитим и не дёргаем Chart-период).
            try {
                const direct = this._dimHighlightDirect
                if (direct?.size && this.flex?.rows?.length) {
                    // АН 2026 08 15 / ODOO-4997 (п.7): сигнал с ДАТОЙ — колонка
                    // выделения = датная колонка этой даты (штатный канал периода
                    // дёрнет Chart); без даты — колонка сохраняется (п.6)
                    const dateRanges = (detail.values || []).filter(v => v?.kind === 'date' && v.from)
                    let col = this.flex.selection && this.flex.selection.col >= 0 ? this.flex.selection.col : 0
                    let withDate = false
                    if (dateRanges.length) {
                        const from = dateRanges[0].from, to = dateRanges[0].to || dateRanges[0].from
                        for (let ci = 0; ci < this.flex.columns.length; ci++) {
                            const ac = this.get_attr_col(ci, true)
                            if (!ac?.date) continue
                            let cFrom = String(ac.date).slice(0, 10), cTo = cFrom
                            const f = this.dimHl_foldDates(ci, ac) // свёрнутый период колонки (п.2)
                            if (f) { cFrom = f.from; cTo = f.to }
                            if (cFrom <= to && cTo >= from) { col = ci; withDate = true; break }
                        }
                    }
                    for (let i = 0; i < this.flex.rows.length; i++) {
                        const fr = this.flex.rows[i]
                        if (!fr || fr.isVisible === false) continue
                        const di = fr.dataItem
                        if (di && direct.has(di)) {
                            // с датой — гард только на ре-эмит (Chart-период обновится),
                            // без даты — полный гард (период не трогаем)
                            this._dimHlApplying = true
                            if (!withDate) this.ignore_selectionChanged = true
                            try { this.flex.select(new wjGrid.CellRange(i, col, i, col), true) }
                            finally { this.ignore_selectionChanged = false; this._dimHlApplying = false }
                            break
                        }
                    }
                }
            } catch (e) { /* перемещение выделения — best effort */ }
            this.flexRefresh()
        },
        sim_ledgerAdd(it, b, delta, tagUndo = true) {
            // АН 2026 08 15 / ODOO-4997: леджер локально применённых дельт превью —
            // серверный ответ применяется как (server_delta − ledger), обычно 0
            if (!this._simLedger) this._simLedger = new Map()
            if (!this._simLedger.has(it)) this._simLedger.set(it, new Map())
            const m = this._simLedger.get(it)
            m.set(b, (m.get(b) || 0) + delta)
            // IE 2026 08 19 / ODOO-5512: помечаем запись undo этой правки — откат/повтор
            // двигает леджер вместе со значением ячейки (иначе после Ctrl+Z леджер
            // «помнил» применённую дельту, а ячейка уже исходная)
            if (tagUndo) {
                for (let i = this.undoStack.length - 1; i >= Math.max(0, this.undoStack.length - 64); i--) {
                    const top = this.undoStack[i]
                    if (top && top.$item === it && top.col_binding === b && top.simLedger === undefined) { top.simLedger = delta; break }
                }
            }
        },
        // ---- АН 2026 08 14 / ODOO-4997: серверная симуляция правок ----
        // Правки копятся и батчем (debounce 500 мс) уезжают на бэк
        // (widget_REPORT2.simulate_cell_edits → common_modules/simulation.py).
        // Бэк держит документы калькуляции в кэше, применяет накопленные дельты
        // и отвечает точечными изменениями (остатки/DOS/зона) — sim_applyChanges
        // кладёт их поверх локальной аппроксимации. При обновлении данных
        // виджета (select/Rfr) сим-сессия на бэке сбрасывается (sim_sendReset).
        sim_queueEdit(dataItem, date, role, delta, extra = null) {
            if (!delta) return
            let object = dataItem?.object, subject = dataItem?.subject
            // IE 2026 08 21: строки-агрегаты после снятия группировки по субъекту
            // (заказ Игоря, FADO qY0_001) не несут object/subject — фолбэк из
            // ЕДИНСТВЕННОГО значения активного чипса стола (Object/Warehouse):
            // при выбранном чипсе контекст правки однозначен
            if (!object || !subject) {
                const wsWhere = this.store.get_value(this.store.WORKSPACES?.[this.WIDGET?.workspace]?.record || this.WIDGET?.workspace_record || {}, 'doc.params.WHERE', []) || []
                const selOne = (names) => {
                    for (const r2 of wsWhere) {
                        if (r2?.use === false) continue
                        const b = (r2?.leftValue?.value || '')
                        if (!names.includes(b)) continue
                        const vals = (r2?.attrs || []).filter(a2 => a2?.use !== false)
                            .map(a2 => a2?.rightValue?.value).filter(Boolean)
                        if (vals.length === 1) return vals[0]
                    }
                    return null
                }
                if (!subject) subject = selOne(['subject', 'calc_subject'])
                if (!object) object = selOne(['object', 'calc_object'])
                if (window.__simDebug) console.log('sim: fallback object/subject from workspace chips', object, subject)
            }
            if (!object || !subject) {
                // АН 2026 08 15 / ODOO-4997: диагностика (window.__simDebug = true)
                if (window.__simDebug) console.log('sim: edit skipped, no object/subject', object, subject, date, role, delta)
                return
            }
            if (window.__simDebug) console.log('sim: edit queued', object, subject, date, role, delta)
            // IE 2026 08 15 / ODOO-4997 (заказ Игоря «одно событие undo»): ответ
            // симуляции применится ПОД actionStack породившей правки — прямая
            // правка + декомпозиция + сим-корректировки склеиваются в ОДНУ
            // undo-группу (один пункт истории, один Ctrl+Z)
            this._simLastEditAS = this.actionStack
            this._simLastEditUndo = !!this._simQueueFromUndo   // IE 2026 09 25 / ODOO-5800: правка из отката / повтора (sim_applyChanges, fe.sim.undoGroup)
            // АН 2026 08 15 / ODOO-4997 (заказ Игоря): замер реакции системы —
            // от ПЕРВОЙ правки серии до применения ВСЕХ изменений
            if (!this._simBatchT0) { this._simBatchT0 = performance.now(); this._simBatchEdits = 0 }
            this._simBatchEdits++
            this._simQueue = this._simQueue || []
            this._simQueue.push({
                object, subject, date, role, delta,
                workcenter: dataItem?.workcenter || undefined,
                ...(extra || {}), // IE 2026 08 19: measure_type / date_next ячейки
            })
            this._simTouched = this._simTouched || new Map()
            this._simTouched.set(`${object}::${subject}`, { object, subject })
            // АН 2026 08 15 / ODOO-4997: доп. таблицы (_doc.sim_*) — один запрос
            // на сессию симуляции, при первой правке; сброс — в content_Changed
            if (!this._simTablesRequested) {
                this._simTablesRequested = true
                this.sim_requestTables()
            }
            if (this._simTimer) clearTimeout(this._simTimer)
            this._simTimer = setTimeout(() => this.sim_flushEdits(), this.store.setting('fe.ux.simFlushMs', 500))   // IE 2026 09 05 / ODOO-336330
        },
        sim_flushEdits() {
            // АН 2026 08 15 / ODOO-4997 (п.1): пока запрос в полёте — новые правки
            // копятся в очереди и уйдут следующим батчем после ответа (без
            // параллельных запросов сессия на бэке накапливается строго по порядку)
            if (this._simInFlight) return
            const edits = this._simQueue || []
            this._simQueue = []
            if (!edits.length) return
            this._simInFlight = true
            const WIDGET = this.WIDGET
            WIDGET.notification = WIDGET.notification || {}
            WIDGET.notification.text = t('Simulation...')   // IE 2026 09 23 / ODOO-341407: i18n
            WIDGET.notification.status = 'pending'
            WIDGET.notification.visible = true
            // АН 2026 08 15 / ODOO-4997: диагностика отправки (__simDebug)
            if (window.__simDebug) {
                console.log('sim: flush', edits.length, 'vueObj:', !!this.WIDGET?.vueObj)
                const rec = this.WIDGET?.record || {}
                const sizes = Object.keys(rec).map(k => {
                    try { return k + ':' + (JSON.stringify(rec[k]) || '').length } catch (e) { return k + ':ERR' }
                })
                console.log('sim: record sizes', sizes.join(' '))
            }
            this._simInFlightEdits = edits   // IE 2026 09 25 / ODOO-5800 (D4): объекты батча — область полноты ответа (старый бэк без sim.objects)
            try {
                this.store.executeStoreMethod(this.WIDGET.vueObj || this, {
                    command: 'executeWidgetMethod',
                    method: 'simulate_cell_edits',
                    // IE 2026 09 25 / ODOO-5800: выключатели бэка not-sim_* — в запросе (переключение целиком клиентское, fe.sim.*)
                    params: { edits, sim_session: this.sim_sessionId(), ...this.sim_beFlags() },
                    // АН 2026 08 15 / ODOO-4997: view Ганта — мегабайты (18 МБ),
                    // бэк-методам симуляции он не нужен
                    widget_sendToBackend_exclude: ['view'],
                    record_sendToBackend_exclude: ['_doc'],
                    no_del_last_backend_action: true,
                    no_notification: true,
                }, this.attr)
            } catch (e) {
                if (window.__simDebug) console.log('sim: flush failed', String(e).slice(0, 300))
                WIDGET.notification.visible = false
                this._simInFlight = false
            }
        },
        sim_applyChanges(action) {
            // АН 2026 08 15 / ODOO-4997 (п.1): запрос завершён — если за время
            // полёта накопились правки, отправить следующий батч
            this._simInFlight = false
            if (this._simQueue?.length) {
                if (this._simTimer) clearTimeout(this._simTimer)
                this._simTimer = setTimeout(() => this.sim_flushEdits(), 50)
            }
            const sim = action?.sim || {}
            const WIDGET = this.WIDGET
            if (WIDGET.notification?.status === 'pending' && WIDGET.notification?.text === t('Simulation...')) {   // IE 2026 09 23 / ODOO-341407: i18n (сравнение с тем же переводом)
                WIDGET.notification.visible = false
            }
            if (sim.reset) return
            if (sim.missing_docs?.length) {
                WIDGET.notification = { text: tn(sim.missing_docs.length, 'Simulation: no calculation document for {n} item', 'Simulation: no calculation document for {n} items'), status: 'warning', visible: true }   // IE 2026 09 23 / ODOO-341407: i18n
            }
            const changes = sim.changes || []
            // IE 2026 09 25 / ODOO-5800 (D4, разбор ie-fado7: накопленная правка 0 → changes=[] — прежние дельты леджера оставались на экране):
            // ответ — ПОЛНАЯ картина по объектам своих сессий (sim.objects; старый бэк — объекты батча): чего нет в ответе, того нет —
            // дельты леджера по этим объектам, не подтверждённые ответом, снимаются. Выключатель fe.sim.emptyRevert
            const _scope = this.sim_scopeObjects(sim, action)
            const _revertOn = this.sim_flag('emptyRevert') && _scope.size > 0 && !!(this._simLedger?.size || this._simVirtual?.size)
            if (!changes.length && !(sim.corr_edits || []).length && !(sim.txn_changes || []).length
                && !(sim.offset_changes || []).length && !_revertOn) return // IE 2026 08 20: offset-only ответ (undo)
            // IE 2026 08 19 / ODOO-5512: виртуальные документы симуляции — сообщить даты
            if ((sim.virtual_docs || []).length) {
                const txt = sim.virtual_docs.slice(0, 3).map(v => `${v.doc}: ` + Object.entries(v.dates || {}).map(([k, d]) => `${k} ${d}`).join(', ')).join(' · ')
                this.store.show_notification({ text: tn(sim.virtual_docs.length, 'Simulation: no documents in the cell — created {n} virtual document. {docs}', 'Simulation: no documents in the cell — created {n} virtual documents. {docs}', { docs: txt }), status: 'info' })   // IE 2026 09 23 / ODOO-341407: i18n
            }
            const kidsPath = this.attr.childItemsPath || 'attrs'
            // индексируем листовые строки остатков по (object независимо) subject
            const stockLeavesBySubj = new Map()
            const _memoOn = this.sim_flag('memoLeaves')   // IE 2026 09 25 / ODOO-5800: memo-строки «· of which …» не прячут лист остатка склада
            const scan = (it, topObject) => {
                const kids = it?.[kidsPath]
                const isStock = this.balancePreview_roleOf(it) === 'stock'
                    || /^(Stock|Starting inventory|Inventory)/i.test(this.balancePreview_branchOf(it) || '')
                const ownKids = Array.isArray(kids) ? (_memoOn ? kids.filter(k => !k?._DLRow?.total_excluded) : kids) : []
                if (isStock && !ownKids.length && !(_memoOn && it?._DLRow?.total_excluded)) {
                    const keyO = topObject || it.object || ''
                    stockLeavesBySubj.set(`${keyO}::${it.subject || ''}`, it)
                    if (!stockLeavesBySubj.has(`${keyO}::`)) stockLeavesBySubj.set(`${keyO}::`, it)
                }
                for (const k of kids || []) scan(k, topObject)
            }
            for (const r of (this.data000 || this.data || [])) scan(r, r.object || '')
            // АН 2026 08 15 / ODOO-4997: Гант — отдельной строки остатка нет,
            // остаток лежит колонко-мерой <дата>.sku_data::open_balance на самой
            // строке объекта; индексируем ВСЕ строки по object::subject
            const rowsByKey = new Map()
            const rowObject = new Map()   // IE 2026 09 25 / ODOO-5800 (D4): строка → объект (с наследованием) — область снятия дельт
            // IE 2026 08 15 / ODOO-4997: object листовых строк IN/OUT наследуется
            // от строки объекта — индексируем с наследованием (для corr-каскада)
            const scanAll = (it, inhObject) => {
                const own = (it?.object && it.object !== 0 && it.object !== '0') ? it.object : null
                const o = own || inhObject
                if (o) {
                    const k = `${o}::${it.subject || ''}`
                    if (!rowsByKey.has(k)) rowsByKey.set(k, [])
                    rowsByKey.get(k).push(it)
                    rowObject.set(it, String(o))
                }
                for (const k2 of it?.[kidsPath] || []) scanAll(k2, o)
            }
            for (const r of (this.data000 || this.data || [])) scanAll(r, null)
            // IE 2026 09 25 / ODOO-5800 (D2/D1): контекст строк с наследованием от предков (measure_type / alert / txn_status / мера) и
            // учёт покрытых ответом ячеек леджера (D4)
            const _alertOn = this.sim_flag('alertMatch')
            const _virtOn = this.sim_flag('virtualMark')
            const _sumOn = this.sim_flag('sumLeafTxn')   // IE 2026 09 25 / ODOO-5800: изменения мер одной ячейки листа складываются (txn_changes ниже)
            const ctxMap = _alertOn || _virtOn ? this.sim_ctxMap() : new Map()
            const covered = new Map()
            const cover = (it, b) => { if (!covered.has(it)) covered.set(it, new Set()); covered.get(it).add(b) }
            if (_virtOn) this.sim_virtualClear(_scope, rowObject)
            // АН 2026 08 15 / ODOO-4997: индекс датных биндингов по СУФФИКСУ меры —
            // на Ганте формат ключа сложнее `<дата>.sku_data::open_balance`,
            // жёсткая строка не находила колонку (applied rows 0)
            const bindByDate = new Map() // date → {suffix → binding}
            for (const b in this.attr_by_binding) {
                const mDate = /^(\d{4}-\d{2}-\d{2})\.(.+)$/.exec(b)
                if (!mDate) continue
                if (!bindByDate.has(mDate[1])) bindByDate.set(mDate[1], [])
                bindByDate.get(mDate[1]).push({ suffix: mDate[2], b })
            }
            const bindingFor = (date, measure) => {
                for (const e of bindByDate.get(date) || []) {
                    if (e.suffix === measure || e.suffix.endsWith('::' + measure) || e.suffix.endsWith('.' + measure)) return e.b
                }
                return null
            }
            // IE 2026 08 15 / ODOO-4997 (вопрос Игоря «корреспонденции не увидел»):
            // дневной колонки нет (месяц свёрнут БЕЗ детальных колонок) — кладём
            // в колонку-ПЕРИОД, содержащую дату (последняя колонка с датой ≤ d)
            const _colsByMeasure = new Map()
            const bindingForRange = (date, measure) => {
                let arr = _colsByMeasure.get(measure)
                if (!arr) {
                    arr = []
                    for (const [d, list] of bindByDate) {
                        for (const e of list) {
                            if (e.suffix === measure || e.suffix.endsWith('::' + measure) || e.suffix.endsWith('.' + measure)) arr.push({ d, b: e.b })
                        }
                    }
                    arr.sort((a, z) => (a.d < z.d ? -1 : 1))
                    _colsByMeasure.set(measure, arr)
                }
                let best = null
                for (const e of arr) {
                    if (e.d <= date) best = e
                    else break
                }
                return best?.b || null
            }
            const touchedRows = new Map()
            const matchedRows = new Set() // строки-цели найдены (даже если менять нечего)
            const setCell = (it, b, next) => {
                if (next === undefined || next === null || !b || !this.attr_by_binding[b]) return
                matchedRows.add(it)
                const cur = parseFloat(this.store.get_value(it, b))
                if (Number.isNaN(cur)) return // пустая ячейка — не выдумываем
                const rounded = Math.round(next * 1e6) / 1e6
                if (Math.abs(cur - rounded) < 1e-9) return
                this.set_value(this.rows_indexOf(it), it, b, cur, rounded, true, null, true)
                if (!touchedRows.has(it)) touchedRows.set(it, [])
                touchedRows.get(it).push(b)
            }
            // АН 2026 08 15 / ODOO-4997 (п.3 Игоря «мелькание цифр»): применяем
            // ДЕЛЬТЫ сервера поверх исходных значений строки, с поправкой на уже
            // применённую локальную дельту (леджер) — при совпадении локальной
            // аппроксимации с сервером ячейка не трогается вовсе. Абсолюты
            // документа калькуляции не навязываем строкам отчёта: их агрегаты
            // могут отличаться (разрезы, страна) — это и было мельканием.
            const applyDelta = (it, b, serverDelta) => {
                if (serverDelta === undefined || serverDelta === null || !b || !this.attr_by_binding[b]) return
                matchedRows.add(it)
                cover(it, b)   // IE 2026 09 25 / ODOO-5800 (D4): ячейка описана ответом
                const applied = this._simLedger?.get(it)?.get(b) || 0
                const adjust = serverDelta - applied
                if (Math.abs(adjust) < 1e-6) return
                const cur = parseFloat(this.store.get_value(it, b))
                if (Number.isNaN(cur)) return
                this.set_value(this.rows_indexOf(it), it, b, cur, Math.round((cur + adjust) * 1e6) / 1e6, true, null, true)
                this.sim_ledgerAdd(it, b, adjust)
                if (!touchedRows.has(it)) touchedRows.set(it, [])
                touchedRows.get(it).push(b)
            }
            const applyAll = () => {
                for (const ch of changes) {
                    const it = stockLeavesBySubj.get(`${ch.object}::${ch.subject}`)
                        || stockLeavesBySubj.get(`${ch.object}::`)
                    if (it) {
                        const b = bindingFor(ch.date, 'quantity') || `${ch.date}.quantity`
                        // мера строки остатков: из карты лэйаута (п.2), затем measure_
                        const me = this.balancePreview_measureOf(it) || ''
                        const isOpen = /open/.test(me)
                        const dlt = isOpen ? ch.open_delta : ch.close_delta
                        if (dlt !== undefined) applyDelta(it, b, dlt)
                        else setCell(it, b, isOpen ? ch.open_balance : ch.close_balance) // старый бэк без дельт
                        continue
                    }
                    // Гант: суб-значения остатка на строках объекта (все вхождения
                    // объекта — он может стоять под несколькими РЦ)
                    for (const rowIt of rowsByKey.get(`${ch.object}::${ch.subject}`) || []) {
                        applyDelta(rowIt, bindingFor(ch.date, 'open_balance'), ch.open_delta)
                        applyDelta(rowIt, bindingFor(ch.date, 'close_balance'), ch.close_delta)
                    }
                }
                // wc_changes — сдвиг занятости/свободного времени РЦ (строки WC:
                // workcenter/subject = UUID РЦ, объекта нет); busy_delta — дельта
                for (const wc of (sim.wc_changes || [])) {
                    const dBusy = parseFloat(wc.busy_delta)
                    if (!dBusy || Number.isNaN(dBusy)) continue
                    for (const it of wcRows) {
                        if (it.workcenter !== wc.workcenter && it.subject !== wc.workcenter) continue
                        applyDelta(it, bindingFor(wc.date, 'WC_free'), -dBusy)
                        applyDelta(it, bindingFor(wc.date, 'WC_busy'), dBusy)
                    }
                }
                // IE 2026 08 15 / ODOO-4997 (заказ Игоря): корреспондирующие
                // правки каскада дистрибуции — расход ИСТОЧНИКА в его OUT-строке
                // с корреспондентом = правленный филиал, дата = дата − лид.
                // corr_edits инкрементальны (только новые правки батча) —
                // применяем прямым добавлением, без леджера
                // IE 2026 08 19 / ODOO-5512 (заказ Игоря): движок на транзакциях —
                // изменения МЕР отчёта (накопительно, склад × тип меры × мера × дата):
                // строка того же объекта с тем же типом меры (склад — если есть),
                // дельта сервера − леджер → в листья строки + пересчёт строки-владельца
                const _bareId = (x) => String(x?.id ?? x ?? '').split('::')[0]
                // IE 2026 09 25 / ODOO-5800 (проба 25.09, 1fxa_001, Headrin Next mousse: после 60→0 в PO Arrival 2027-06 строка Shipment 2027-05
                // показывала 9672 вместо 9612 — два изменения одного листа, −60 документа PO и +9612 документа автоплана, применялись «последний
                // побеждает»: дельта каждого сравнивалась со ВСЕМ леджером листа, уже включавшим предыдущее изменение ответа). Изменения, легшие
                // в одну ячейку листа (лист × колонка месяца; строка выбрана по measure_type + alert + мере), СКЛАДЫВАЮТСЯ: цель леджера листа =
                // сумма долей их дельт, применяется разница с леджером один раз после всех изменений ответа. Выключатель fe.sim.sumLeafTxn
                // (false — прежнее применение по одному)
                const _txnAcc = new Map()   // лист → Map(b → { target, owners: Set(строка-цель), n })
                const _txnAgg = new Set()   // строки-цели, раскладывающие дельту в свои листья (итог — сумма листьев)
                // IE 2026 09 25 / ODOO-5800: складываются РАЗНЫЕ ключи ответа; повтор того же ключа (нормативы автоплана пересчитываются
                // эшелоном источника на каждую пару дистрибуции — _ap_norms бэка) — последний, как прежде
                let _txnList = sim.txn_changes || []
                if (_sumOn) {
                    const uniq = new Map()
                    for (const tc of _txnList) uniq.set([tc.object, tc.subject, tc.measure_type, tc.measure, tc.date, tc.alert ?? '', tc.virtual ?? '', tc.status ?? ''].join('|'), tc)
                    _txnList = [...uniq.values()]
                }
                for (const tc of _txnList) {
                    // IE 2026 09 25 / ODOO-5800 (D2, разбор ie-fado7: непокрытое +4 ложилось в обычную строку PO / её лист Done): строка —
                    // по measure_type И alert (свои либо унаследованные от предков: лист несёт только субъект) и по мере, если у строки она
                    // задана (MO документа PO не в строку прихода IN); строка без alert над листьями с одним alert — строка этого alert
                    // (зонт «⚠ Uncovered»). Выключатель fe.sim.alertMatch — прежнее сопоставление только по своему measure_type
                    const tcHasAlert = _alertOn && tc.alert !== undefined && tc.alert !== null
                    const tcAlert = String(tc.alert ?? '')
                    let cands = []
                    for (const [k, list] of rowsByKey) {
                        if (!k.startsWith(`${tc.object}::`)) continue
                        for (const rowIt of list) {
                            const cx = _alertOn ? (ctxMap.get(rowIt) || {}) : null
                            const mtRow = cx ? String(cx.measure_type || rowIt?.measure_type || '') : String(rowIt?.measure_type || '')
                            if (mtRow !== String(tc.measure_type)) continue
                            if (tcHasAlert && this.sim_rowAlert(rowIt, ctxMap) !== tcAlert) continue
                            if (cx && tc.measure && cx.measure && String(cx.measure) !== String(tc.measure)) continue
                            cands.push({ rowIt, subj: k.slice(String(tc.object).length + 2) })
                        }
                    }
                    if (!cands.length) continue
                    for (const c of cands) { const ri = this.rows_indexOf(c.rowIt); c.lvl = ri >= 0 ? (this.flex.rows[ri]?.level ?? 99) : 99 }
                    cands.sort((a, z) => a.lvl - z.lvl)
                    const minLvl = cands[0].lvl
                    const top = cands.filter(c => c.lvl === minLvl)
                    // строка со складом дельты; у строки без склада (агрегат) — только если склад дельты не нашёлся
                    // IE 2026 09 25 / ODOO-5800 (D2): с наследованием — верхняя строка СКЛАДА дельты (группа / лист субъекта), не зонт всех складов
                    const subjMatch = _alertOn ? cands.filter(c => c.subj && _bareId(c.subj) === _bareId(tc.subject)) : []
                    const pick = subjMatch[0] || top.find(c => c.subj && _bareId(c.subj) === _bareId(tc.subject)) || top.find(c => !c.subj)
                    const it = pick?.rowIt
                    if (!it) continue
                    const b = bindingFor(tc.date, 'quantity') || bindingForRange(tc.date, 'quantity')
                    if (!b || !this.attr_by_binding[b]) continue
                    matchedRows.add(it)
                    const leaves = this.decomp_leafRows(it)
                    const parts = leaves.length ? leaves : [it]
                    // IE 2026 09 25 / ODOO-5800 (D2, проверка на DM): у листьев есть склад, но склада дельты среди них нет — не класть в чужой
                    // склад (зонт всех складов раскладывал дельту склада BW в лист другого склада); листья без склада (FADO) — как прежде
                    if (_alertOn && tc.subject) {
                        const subjOf = (x) => String((ctxMap.get(x) || {}).subject || x?.subject || '')
                        if (parts.some(x => subjOf(x)) && !parts.some(x => _bareId(subjOf(x)) === _bareId(tc.subject))) {
                            if (window.__simDebug) console.log('sim: txn change skipped — no row of the subject', tc.measure_type, tc.alert || '', tc.subject?.slice?.(0, 8), tc.date, tc.delta)
                            continue
                        }
                    }
                    for (const x of parts) cover(x, b)   // IE 2026 09 25 / ODOO-5800 (D4)
                    // IE 2026 09 25 / ODOO-5800 (D1): документ автоплана превью — в лист того же статуса документа (⚡Auto-scheduled), не в первый
                    const isVirt = _virtOn && !!tc.virtual
                    const statusPart = isVirt && tc.status && parts.length > 1
                        ? parts.find(x => String((ctxMap.get(x) || {}).txn_status || x?.txn_status || '') === String(tc.status)) || null : null
                    // леджер — по ЛИСТЬЯМ (их записи undo и несут дельту)
                    const applied = parts.reduce((a, x) => a + (this._simLedger?.get(x)?.get(b) || 0), 0)
                    const adjust = (tc.delta || 0) - applied
                    // IE 2026 09 25 / ODOO-5800 (fe.sim.sumLeafTxn): доли листьев — по значению БЕЗ дельт превью (текущее − леджер листа): цель
                    // не зависит от уже применённого, повтор того же ответа ячейку не трогает; выкл — по текущему значению, как прежде
                    const vals = parts.map(x => { const v = parseFloat(this.store.get_value(x, b)); return (Number.isNaN(v) ? 0 : v) - (_sumOn ? (this._simLedger?.get(x)?.get(b) || 0) : 0) })
                    const S = vals.reduce((a, v) => a + v, 0)
                    const shareOf = (x, i) => statusPart ? (x === statusPart ? 1 : 0) : (S > 0 ? vals[i] / S : (i === 0 ? 1 : 0))
                    if (isVirt) {
                        // пометка «оценка автоплана» — на листьях, куда легла оценка, и на самой строке (для зонта — полная сумма)
                        parts.forEach((x, i) => { const sh = shareOf(x, i); if (sh) this.sim_virtualSet(x, b, (tc.delta || 0) * sh, tc) })
                        if (parts[0] !== it || parts.length > 1) this.sim_virtualSet(it, b, tc.delta || 0, tc)
                    }
                    if (_sumOn) {
                        // IE 2026 09 25 / ODOO-5800: накопление — доля дельты в цель леджера листа; применение — после цикла (ниже)
                        let accS = 0
                        parts.forEach((x, i) => {
                            const dPart = i === parts.length - 1 ? (tc.delta || 0) - accS : Math.round((tc.delta || 0) * shareOf(x, i) * 1e6) / 1e6
                            accS += dPart
                            if (!_txnAcc.has(x)) _txnAcc.set(x, new Map())
                            const acc = _txnAcc.get(x)
                            if (!acc.has(b)) acc.set(b, { target: 0, owners: new Set(), n: 0 })
                            const e = acc.get(b)
                            e.target += dPart
                            e.owners.add(it)
                            e.n++
                        })
                        if (parts[0] !== it) _txnAgg.add(it)
                        if (window.__simDebug) console.log('sim: txn change summed', tc.measure_type, tc.alert || '', tc.virtual || '', tc.subject?.slice?.(0, 8), tc.date, tc.delta, (tc.docs || []).join(';'))
                        continue
                    }
                    if (Math.abs(adjust) < 1e-6) continue
                    let acc = 0
                    parts.forEach((x, i) => {
                        const share = shareOf(x, i)
                        const dPart = i === parts.length - 1 ? adjust - acc : Math.round(adjust * share * 1e6) / 1e6
                        acc += dPart
                        if (!dPart) return
                        const cur0 = parseFloat(this.store.get_value(x, b))
                        if (Number.isNaN(cur0)) this.sim_emptyMark(x, b)   // IE 2026 09 25 / ODOO-5800: пустая ячейка — при полном откате снова пустая, не «0»
                        this.sim_setDelta(x, b, cur0, dPart)
                        this.sim_ledgerAdd(x, b, dPart)
                    })
                    if (parts[0] !== it) this.decomp_syncAncestors(it, [b])
                    if (!touchedRows.has(it)) touchedRows.set(it, [])
                    touchedRows.get(it).push(b)
                    if (window.__simDebug) console.log('sim: txn change applied', tc.measure_type, tc.alert || '', tc.virtual || '', tc.subject?.slice?.(0, 8), tc.date, adjust, (tc.docs || []).join(';'))
                }
                // IE 2026 09 25 / ODOO-5800 (fe.sim.sumLeafTxn): накопленное — на лист × колонку один раз: цель (сумма долей изменений ответа) −
                // леджер листа; совпало — ячейка не трогается. Строки-цели над листьями — сумма листьев (decomp_syncAncestors)
                if (_sumOn && _txnAcc.size) {
                    const owners = new Map()   // строка-цель → Set(b)
                    for (const [x, acc] of _txnAcc) {
                        for (const [b, e] of acc) {
                            const adj = Math.round((e.target - (this._simLedger?.get(x)?.get(b) || 0)) * 1e6) / 1e6
                            if (Math.abs(adj) < 1e-6) continue
                            const cur0 = parseFloat(this.store.get_value(x, b))
                            if (Number.isNaN(cur0)) this.sim_emptyMark(x, b)   // пустая ячейка — при полном откате снова пустая, не «0»
                            this.sim_setDelta(x, b, cur0, adj)
                            this.sim_ledgerAdd(x, b, adj)
                            for (const it of e.owners) {
                                if (!owners.has(it)) owners.set(it, new Set())
                                owners.get(it).add(b)
                            }
                            if (window.__simDebug) console.log('sim: txn change applied (sum of ' + e.n + ')', b, 'target', e.target, 'adjust', adj)
                        }
                    }
                    for (const [it, bs] of owners) {
                        if (_txnAgg.has(it)) this.decomp_syncAncestors(it, [...bs])
                        if (!touchedRows.has(it)) touchedRows.set(it, [])
                        touchedRows.get(it).push(...bs)
                    }
                }
                // IE 2026 08 20 / ODOO-5512 (заказ Игоря): пересчитанные OFFSET
                // ячеек (Max по живым транзакциям месяца) — АБСОЛЮТ в колонку
                // <дата>.offset строки того же типа меры; оба режима симуляции
                for (const oc of (sim.offset_changes || [])) {
                    let cands = []
                    for (const [k, list] of rowsByKey) {
                        if (!k.startsWith(`${oc.object}::`)) continue
                        for (const rowIt of list) {
                            if (String(rowIt?.measure_type || '') !== String(oc.measure_type)) continue
                            cands.push({ rowIt, subj: k.slice(String(oc.object).length + 2) })
                        }
                    }
                    if (!cands.length) continue
                    for (const c of cands) { const ri = this.rows_indexOf(c.rowIt); c.lvl = ri >= 0 ? (this.flex.rows[ri]?.level ?? 99) : 99 }
                    cands.sort((a, z) => a.lvl - z.lvl)
                    const minLvl = cands[0].lvl
                    const top = cands.filter(c => c.lvl === minLvl)
                    const pick = top.find(c => c.subj && _bareId(c.subj) === _bareId(oc.subject)) || top.find(c => !c.subj) || top[0]
                    const it = pick?.rowIt
                    if (!it) continue
                    const b = bindingFor(oc.date, 'offset') || bindingForRange(oc.date, 'offset')
                    if (!b) continue
                    setCell(it, b, oc.offset)
                    if (window.__simDebug) console.log('sim: offset applied', oc.measure_type, oc.date, oc.offset)
                }
                for (const ce of (sim.corr_edits || [])) {
                    const bare = (x) => String(x?.id ?? x ?? '').split('::')[0]
                    if (ce.kind === 'po_link') {
                        // IE 2026 08 19 / ODOO-5512 (заказ Игоря): парная мера заказа
                        // поставщику (Shipment ↔ Estimated Arrival) — строка того же
                        // объекта с measure_type пары; сначала строка со складом
                        // правки, иначе любая (у «Shipment from Supplier» склада нет)
                        let cands = []
                        for (const [k, list] of rowsByKey) {
                            if (!k.startsWith(`${ce.object}::`)) continue
                            for (const rowIt of list) {
                                if (String(rowIt?.measure_type || '') !== String(ce.measure_type)) continue
                                cands.push({ rowIt, subj: k.slice(String(ce.object).length + 2) })
                            }
                        }
                        // верхняя (видимая) строка меры: у уровня-1 есть подчинённые
                        // детали, но итог предка по листьям тут не пересчитывается
                        // (узел с фильтром меры итоги детей не принимает) — правим её
                        for (const c of cands) { const ri = this.rows_indexOf(c.rowIt); c.lvl = ri >= 0 ? (this.flex.rows[ri]?.level ?? 99) : 99 }
                        cands.sort((a, z) => a.lvl - z.lvl)
                        const minLvl = cands.length ? cands[0].lvl : 99
                        const top = cands.filter(c => c.lvl === minLvl)
                        const pick = top.find(c => c.subj && bare(c.subj) === bare(ce.subject)) || top.find(c => !c.subj) || top[0]
                        const it = pick?.rowIt
                        if (!it) { if (window.__simDebug) console.log('sim: po_link — no target row', ce.measure_type); continue }
                        const b = bindingFor(ce.date, 'quantity') || bindingForRange(ce.date, 'quantity')
                        if (!b) continue
                        matchedRows.add(it)
                        // как декомпозиция правки агрегата: дельта — в ЛИСТЬЯ строки
                        // (пропорционально текущим значениям, пусто — в первый), затем
                        // сама строка пересчитывается суммой листьев (syncAncestors по
                        // строке-владельцу; предок с фильтром меры итоги детей не
                        // принимает — прямой set_value на агрегат откатывался бы)
                        const leaves = this.decomp_leafRows(it)
                        const parts = leaves.length ? leaves : [it]
                        const vals = parts.map(x => { const v = parseFloat(this.store.get_value(x, b)); return Number.isNaN(v) ? 0 : v })
                        const S = vals.reduce((a, v) => a + v, 0)
                        let acc = 0
                        parts.forEach((x, i) => {
                            const share = S > 0 ? vals[i] / S : (i === 0 ? 1 : 0)
                            const dPart = i === parts.length - 1 ? (ce.delta || 0) - acc : Math.round((ce.delta || 0) * share * 1e6) / 1e6
                            acc += dPart
                            if (!dPart) return
                            const cur0 = parseFloat(this.store.get_value(x, b))
                            const next = Math.round(((Number.isNaN(cur0) ? 0 : cur0) + dPart) * 1e6) / 1e6
                            this.set_value(this.rows_indexOf(x), x, b, cur0, next, true, null, true)
                        })
                        if (parts[0] !== it) this.decomp_syncAncestors(it, [b])
                        if (!touchedRows.has(it)) touchedRows.set(it, [])
                        touchedRows.get(it).push(b)
                        if (window.__simDebug) console.log('sim: po_link applied', ce.measure_type, ce.date, ce.delta, ce.source_title, 'leaves', parts.length)
                        continue
                    }
                    const cand = rowsByKey.get(`${ce.object}::${ce.subject}`) || []
                    let target = null, fallback = null
                    for (const rowIt of cand) {
                        if (this.balancePreview_roleOf(rowIt) !== 'out') continue
                        const corr = bare(rowIt.subject_cor ?? rowIt.correspondent)
                        if (corr && corr === bare(ce.corr_subject)) { target = rowIt; break }
                        if (!corr && !fallback) fallback = rowIt
                    }
                    const it = target || fallback
                    if (!it) continue
                    const b = bindingFor(ce.date, 'quantity') || bindingForRange(ce.date, 'quantity')
                    if (!b) continue
                    matchedRows.add(it)
                    const cur0 = parseFloat(this.store.get_value(it, b))
                    const cur = Number.isNaN(cur0) ? 0 : cur0 // пустая ячейка: новый расход
                    const next = Math.round((cur + (ce.delta || 0)) * 1e6) / 1e6
                    this.set_value(this.rows_indexOf(it), it, b, cur0, next, true, null, true)
                    if (!touchedRows.has(it)) touchedRows.set(it, [])
                    touchedRows.get(it).push(b)
                    if (window.__simDebug) console.log('sim: corr edit applied', ce.subject, ce.date, ce.delta, 'lt', ce.lt)
                }
                // IE 2026 09 25 / ODOO-5800 (D4): дельты леджера по объектам ответа, которых ответ не подтвердил, — снять (накопленная
                // правка 0 → база; локальная аппроксимация отката и прежние оценки автоплана без ответа не остаются)
                if (_revertOn && this._simLedger) {
                    for (const [it, m] of this._simLedger) {
                        const o = rowObject.get(it) || (it?.object ? String(it.object) : '')
                        if (!o || !_scope.has(o)) continue
                        for (const [b, d] of m) {
                            if (Math.abs(d) < 1e-9 || covered.get(it)?.has(b)) continue
                            const cur = parseFloat(this.store.get_value(it, b))
                            if (!this.attr_by_binding[b] || Number.isNaN(cur)) { m.set(b, 0); continue }
                            this.sim_setDelta(it, b, cur, -d)
                            this.sim_ledgerAdd(it, b, -d)
                            if (!touchedRows.has(it)) touchedRows.set(it, [])
                            touchedRows.get(it).push(b)
                            if (window.__simDebug) console.log('sim: ledger delta reverted (not in response)', b, -d)
                        }
                    }
                }
                for (const [it, bindings] of touchedRows) {
                    this.decomp_syncAncestors(it, bindings)
                }
            }
            const wcRows = []
            if ((sim.wc_changes || []).length) {
                const scanWC = (it) => {
                    if ((!it?.object || it.object === 0 || it.object === '0')
                        && (it?.workcenter || it?.subject)) wcRows.push(it)
                    for (const k2 of it?.[kidsPath] || []) scanWC(k2)
                }
                for (const r of (this.data000 || this.data || [])) scanWC(r)
            }
            // АН 2026 08 15 / ODOO-4997 (п.1): применение — одной перерисовкой.
            // IE 2026 08 15: под actionStack ПОРОДИВШЕЙ правки — сим-корректировки
            // попадают в ту же undo-группу (одно событие в истории)
            const _savedAS = this.actionStack
            // IE 2026 09 25 / ODOO-5800 (проба undo 25.09, 1fxa_001: две правки → Ctrl+Z → ответ на откат клал записи новой группой поверх стека
            // и чистил redo — второй Ctrl+Z снимал только их, Ctrl+Y после ответа не работал): ответ на правку из отката / повтора
            // (changeStack_) ложится в группу ВЕРШИНЫ undo-стека (текущее состояние), redo-стек не чистится. Выключатель fe.sim.undoGroup
            const _undoResp = !!this._simLastEditUndo && this.sim_flag('undoGroup')
            const _topAS = _undoResp ? this.undoStack[this.undoStack.length - 1]?.actionStack : undefined
            // IE 2026 09 26 / ODOO-5800 (ie-fado7, FADO 26.09, прогон U2: «каждый Ctrl+Z до базы оставляет в истории пустой шаг, правка
            // возвращается только вторым Ctrl+Y»): откат снял ПОСЛЕДНЮЮ группу — undo-стек пуст, «группы вершины» нет, и записи ответа на откат
            // (там — пара .offset строки PO 75945600→0→75945600, в сумме ноль) ложились НОВОЙ группой под _simLastEditAS. Следующий Ctrl+Z
            // снимал эту пустую группу в redo поверх откаченной правки, и первый Ctrl+Y повторял её. Стек пуст = экран в базе: ответ на такой
            // откат — подгонка базы, не шаг истории; значения применяются, записи в undo не ложатся (set_value — _simNoHistory).
            // Выключатель fe.sim.undoBaseNoStep (дефолт ВКЛ; действует вместе с fe.sim.undoGroup), замер — this._simBaseNoStep
            const _baseResp = _undoResp && _topAS == null && this.sim_flag('undoBaseNoStep')
            if (_topAS != null) this.actionStack = _topAS
            else if (this._simLastEditAS != null) this.actionStack = this._simLastEditAS
            if (_undoResp) this._simKeepRedo = true
            if (_baseResp) { this._simNoHistory = true; this._simBaseNoStep = (this._simBaseNoStep || 0) + 1 }   // IE 2026 09 26 / ODOO-5800
            try {
                if (this.flex?.deferUpdate) this.flex.deferUpdate(applyAll)
                else applyAll()
            } finally {
                this.actionStack = _savedAS
                this._simKeepRedo = false
                this._simNoHistory = false   // IE 2026 09 26 / ODOO-5800: fe.sim.undoBaseNoStep
            }
            // АН 2026 08 15 / ODOO-4997: диагностика применения (__simDebug).
            // matched = строки-цели найдены; touched=0 при matched>0 — норма:
            // локальная аппроксимация совпала с сервером бит-в-бит (дельты)
            if (window.__simDebug) console.log('sim: applied rows', touchedRows.size,
                'matched', matchedRows.size, 'changes', changes.length, 'wc', (sim.wc_changes || []).length)
            if (touchedRows.size) {
                this._foldAggCache = null
                this._rowStyleStats = null // АН 2026 08 15 / ODOO-4997: значения строк изменились
                // АН 2026 08 15 / ODOO-4997 (вопрос Игоря о точечном обновлении):
                // один refresh на ВЕСЬ батч; formatItem идёт только по видимым
                // ячейкам (виртуализация). Замер стоимости — в __simDebug.
                const _tR = performance.now()
                this.flexRefresh()
                if (window.__simDebug) console.log('sim: refresh took', Math.round(performance.now() - _tR), 'ms for', touchedRows.size, 'rows')
                // IE 2026 09 25 / ODOO-5800 (D3/D4): после применения ответа — состояние Save и changesStack по факту правок пользователя:
                // правок не осталось (полный откат, ответ снял дельты) — косвенные остатки цепочек вычищаются, бейджи и Save гаснут
                if (this.sim_flag('revertLeaves')) { try { this.saveState_sync() } catch (e) { /* панель могла не иниться */ } }
                if (this._storyPreview) { try { this.cellStory_saveOff() } catch (e) { /* панель могла не иниться */ } }   // IE 2026 10 01 / ODOO-5800: превью решения story — оценка, Save не загорается
            }
            if (!matchedRows.size && !action?._simRelay && (changes.length || (sim.wc_changes || []).length)) {
                // строки ответа живут в ДРУГОМ инстансе грида той же страницы
                // (Гант: секции Busy/Free — отдельные AttrGrid) — ретранслируем
                // событие, чужие инстансы применят у себя
                try {
                    window.dispatchEvent(new CustomEvent('wscm-sim-changes', {
                        detail: { sim, source_widget: this.WIDGET?.id, objects: [..._scope] },   // IE 2026 09 25 / ODOO-5800 (D4): область полноты ответа
                    }))
                } catch (e) { console.warn('sim relay skipped', e) }
            }
            // АН 2026 08 15 / ODOO-4997 (заказ Игоря): обратная связь о скорости —
            // серия правок доставлена полностью (очередь пуста, в полёте ничего)
            if (!action?._simRelay && this._simBatchT0 && !this._simQueue?.length && !this._simInFlight) {
                const secs = ((performance.now() - this._simBatchT0) / 1000).toFixed(1)
                const nEdits = this._simBatchEdits || 0
                this._simBatchT0 = null; this._simBatchEdits = 0
                if (window.__simDebug) console.log('sim: batch done', nEdits, 'edits in', secs, 's')
                WIDGET.notification = {
                    text: tn(nEdits, 'Simulation: {n} edit applied in {secs}s', 'Simulation: {n} edits applied in {secs}s', { secs }),   // IE 2026 09 23 / ODOO-341407: i18n
                    status: 'success', visible: true,
                }
                clearTimeout(this._simNotifTimer)
                this._simNotifTimer = setTimeout(() => {
                    if (WIDGET.notification?.status === 'success') WIDGET.notification.visible = false
                }, 3000)
            }
        },
        sim_applyTables(action) {
            // доп. таблицы симуляции — в _doc записи виджета (заказ Игоря:
            // «все дополнительные таблицы храним в этом же виджете в _doc»)
            const tables = action?.sim_tables || {}
            const _doc = this.WIDGET?.record?._doc
            if (!_doc) return
            for (const k in tables) _doc[k] = tables[k]
        },
        sim_requestTables() {
            // запрос доп. таблиц по видимым строкам отчёта (object × subject)
            const keys = new Map()
            const kidsPath = this.attr.childItemsPath || 'attrs'
            // АН 2026 08 15 / ODOO-4997: object живёт на блоке, subject — на листе
            // (строки остатков) — наследуем object вглубь
            const walk = (it, inhObject) => {
                const o = it?.object || inhObject
                if (o && it?.subject) keys.set(`${o}::${it.subject}`, { object: o, subject: it.subject })
                for (const k of it?.[kidsPath] || []) walk(k, o)
            }
            for (const r of (this.data000 || this.data || [])) walk(r, null)
            if (window.__simDebug) console.log('sim: tables keys', keys.size)
            if (!keys.size) return
            // АН 2026 08 15 / ODOO-4997: не роняем очередь правок при сбое
            try {
                this.store.executeStoreMethod(this.WIDGET.vueObj || this, {
                    command: 'executeWidgetMethod',
                    method: 'sim_get_tables',
                    params: { keys: [...keys.values()] },
                    widget_sendToBackend_exclude: ['view'], // АН 2026 08 15 / ODOO-4997
                    record_sendToBackend_exclude: ['_doc'],
                    no_del_last_backend_action: true,
                    no_notification: true,
                }, this.attr)
            } catch (e) {
                if (window.__simDebug) console.log('sim: tables request failed', String(e).slice(0, 300))
            }
        },
        sim_sessionId() {
            // IE 2026 08 19 / ODOO-5512: идентификатор сим-сессии ЭТОГО экземпляра
            // грида — уходит в каждый запрос симуляции и входит в ключ кэша бэка:
            // новая страница/переоткрытый виджет начинает с чистой сессии (раньше
            // накопленные правки прежней вкладки жили на бэке 30 мин и
            // прибавлялись к новым)
            if (!this._simSessionId) this._simSessionId = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`
            return this._simSessionId
        },
        sim_sendReset() {
            const touched = this._simTouched
            this._simTouched = null
            this._simQueue = []
            if (this._simTimer) { clearTimeout(this._simTimer); this._simTimer = null }
            if (!touched || !touched.size) return
            this.store.executeStoreMethod(this.WIDGET.vueObj || this, {
                command: 'executeWidgetMethod',
                method: 'simulate_cell_edits',
                params: { reset: true, keys: [...touched.values()], sim_session: this.sim_sessionId() },
                widget_sendToBackend_exclude: ['view'], // АН 2026 08 15 / ODOO-4997
                record_sendToBackend_exclude: ['_doc'],
                no_del_last_backend_action: true,
                no_notification: true,
            }, this.attr)
        },
        // ---- IE 2026 09 25 / ODOO-5800: дефекты превью симуляции D1–D5 (разбор ie-fado7 25.09, FADO qY0_001 / DM 1fxa_001) ----
        // Выключатели fe.sim.* (feSettings.set / localStorage / URL ?fe.sim.<ключ>=false), дефолт ВКЛ:
        //   alertMatch    — D2: строка изменения меры — по measure_type + alert (+ мера), с наследованием от предков, верхняя строка склада дельты;
        //   emptyRevert   — D4: ответ — полная картина по объектам сессий: неподтверждённые дельты леджера снимаются (накопленная правка 0 = база);
        //   editContext   — D5: правка листа несёт measure_type / alert ближайшего предка;
        //   virtualMark   — D1: документы автоплана превью — пометка «оценка» на ячейке (тултип), ввод в такую ячейку снимает оценку;
        //   revertLeaves  — D3: возврат агрегата к исходному итогу восстанавливает раскладку деталей, Save гаснет по факту правок;
        //   revertOverEstimate — D1 (остаток, fe-2026-09-25-39 → далее): «без изменений» при вводе — против значения без оценки автоплана,
        //                 ввод, равный базе, при показанной оценке идёт путём отката (cellEditEnding2 / sim_virtualPeek);
        //   undoContext   — Ctrl+Z / Ctrl+Y правки агрегата шлёт на бэк дельты листьев раскладки (как ввод), а не агрегатной строки
        //                 (changeStack__ / aggEdit.simLeaves; IE 2026 09 25 / ODOO-5800);
        //   undoGroup     — ответ симуляции на откат / повтор — в группу вершины undo-стека, redo не чистится (sim_applyChanges /
        //                 _simKeepRedo; IE 2026 09 25 / ODOO-5800);
        //   undoBaseNoStep — ответ на откат, опустошивший undo-стек (экран в базе), не заводит в истории новую («пустую») группу:
        //                 значения применяются без записей undo (sim_applyChanges / set_value _simNoHistory; IE 2026 09 26 / ODOO-5800);
        //   sumLeafTxn    — изменения мер ответа (txn_changes), легшие в одну ячейку листа (лист × колонка месяца), складываются, а не
        //                 «последний побеждает» (Shipment −60 PO и +9612 автоплана = 9612, не 9672; IE 2026 09 25 / ODOO-5800);
        //   alertKey / rollbackTargets / virtualMark — уходят на бэк ключами not-sim_alert_key / not-sim_rollback_targets / not-sim_virtual_mark
        sim_flag(name, def = true) {
            try { return this.store.setting('fe.sim.' + name, def) !== false } catch (e) { return def }
        },
        sim_beFlags() {
            const off = {}
            for (const [fe, be] of [['alertKey', 'sim_alert_key'], ['rollbackTargets', 'sim_rollback_targets'], ['virtualMark', 'sim_virtual_mark']]) {
                if (!this.sim_flag(fe)) off['not-' + be] = true
            }
            return Object.keys(off).length ? { sim_flags: off } : {}
        },
        sim_scopeObjects(sim, action) {
            // объекты, по которым ответ полон: sim.objects (бэк 25.09+) → objects ретрансляции → объекты отправленного батча
            const out = new Set()
            for (const o of (sim?.objects || action?.objects || [])) if (o) out.add(String(o))
            if (!out.size && !action?._simRelay) for (const e of (this._simInFlightEdits || [])) if (e?.object) out.add(String(e.object))
            return out
        },
        sim_ctxMap() {
            // контекст строк с наследованием: measure_type / alert / txn_status — свои (поле строки или WHERE узла), иначе ближайшего предка;
            // мера — по карте лэйаута (balancePreview_measureOf). Кэш до новых данных (content_Changed)
            if (this._simCtxMap) return this._simCtxMap
            const kidsPath = this.attr.childItemsPath || 'attrs'
            const map = new Map()
            const scalar = (v) => (v === undefined || v === null || v === '') ? '' : (typeof v === 'object' ? String(v.id ?? v.binding ?? '') : String(v))
            const whereOf = (it) => {
                const o = {}
                for (const w of (it?._DLRow?.where || [])) {
                    const k = scalar(w?.leftValue?.value ?? w?.leftValue), v = w?.rightValue?.value ?? w?.rightValue
                    if (k && v !== undefined && v !== null && v !== '' && typeof v !== 'object') o[k] = String(v)
                }
                return o
            }
            const walk = (it, inh) => {
                const w = whereOf(it)
                const own = (f) => scalar(it?.[f]) || w[f] || ''
                const cx = { measure_type: own('measure_type') || inh.measure_type || '', alert: own('alert') || inh.alert || '',
                             txn_status: own('txn_status') || inh.txn_status || '', subject: own('subject') || inh.subject || '', measure: '' }
                try { cx.measure = String(this.balancePreview_measureOf(it) || '') } catch (e) { cx.measure = '' }
                map.set(it, cx)
                for (const k of it?.[kidsPath] || []) walk(k, cx)
            }
            for (const r of (this.data000 || this.data || [])) walk(r, {})
            this._simCtxMap = map
            return map
        },
        sim_rowContext(it) {
            return this.sim_ctxMap().get(it) || { measure_type: String(it?.measure_type || ''), alert: String(it?.alert || ''), txn_status: String(it?.txn_status || ''), measure: '' }
        },
        sim_rowAlert(it, ctxMap) {
            // alert строки: свой / унаследованный; у строки без alert — общий alert её листьев (зонт «⚠ Uncovered» над строками «| Uncovered»)
            const map = ctxMap || this.sim_ctxMap()
            const cx = map.get(it) || {}
            if (cx.alert) return String(cx.alert)
            const leaves = this.decomp_leafRows(it)
            if (!leaves.length || (leaves.length === 1 && leaves[0] === it)) return ''
            let common = null
            for (const l of leaves) {
                const a = String((map.get(l) || {}).alert || '')
                if (common === null) common = a
                else if (common !== a) return ''
            }
            return common || ''
        },
        sim_emptyMark(it, b) {
            // ячейка была ПУСТОЙ до дельты симуляции — полный откат возвращает пустоту, а не «0»
            if (!this._simEmpty) this._simEmpty = new Map()
            if (!this._simEmpty.has(it)) this._simEmpty.set(it, new Set())
            this._simEmpty.get(it).add(b)
        },
        sim_setDelta(it, b, cur, delta) {
            // косвенная запись дельты симуляции в ячейку; итог 0 у изначально пустой ячейки — снова пусто
            const next = Math.round(((Number.isNaN(cur) ? 0 : cur) + delta) * 1e6) / 1e6
            const wasEmpty = this._simEmpty?.get(it)?.has(b)
            if (wasEmpty && Math.abs(next) < 1e-9) {
                this._simEmpty.get(it).delete(b)
                this.set_value(this.rows_indexOf(it), it, b, cur, null, true, null, true)
                return
            }
            this.set_value(this.rows_indexOf(it), it, b, cur, next, true, null, true)
        },
        sim_virtualSet(it, b, qty, tc) {
            // D1: оценка автоплана превью на ячейке — сумма виртуальных документов ответа (абсолют по объекту, см. sim_virtualClear)
            if (!this._simVirtual) this._simVirtual = new Map()
            if (!this._simVirtual.has(it)) this._simVirtual.set(it, new Map())
            const m = this._simVirtual.get(it)
            const prev = m.get(b)
            m.set(b, { qty: (prev?.qty || 0) + qty, docs: [...new Set([...(prev?.docs || []), ...(tc?.docs || [])])].slice(0, 5), status: tc?.status || prev?.status || '' })
        },
        sim_virtualClear(scope, rowObject) {
            if (!this._simVirtual) return
            for (const it of [...this._simVirtual.keys()]) {
                const o = rowObject?.get(it) || (it?.object ? String(it.object) : '')
                if (!scope || !scope.size || !o || scope.has(o)) this._simVirtual.delete(it)
            }
        },
        sim_virtualPeek(dataItem, b, b2) {
            // IE 2026 09 25 / ODOO-5800 (D1, остаток): значение строки БЕЗ оценки автоплана превью — ничего не снимает (снятие — sim_stripVirtual);
            // null — оценки на строке / её листьях нет. Агрегат = сумма листьев (его собственная пометка — та же сумма, листьями уже учтена)
            if (!this._simVirtual?.size || !dataItem || !b) return null
            const leaves = this.decomp_leafRows(dataItem)
            const isAgg = leaves.length > 0 && !(leaves.length === 1 && leaves[0] === dataItem)
            let qty = 0, n = 0
            for (const it of (isAgg ? leaves : [dataItem])) {
                const m = this._simVirtual.get(it)
                if (!m) continue
                for (const bb of new Set([b, b2].filter(Boolean))) {
                    const v = m.get(bb)
                    if (!v) continue
                    n++
                    qty += v.qty || 0
                }
            }
            if (!n) return null
            const cur = parseFloat(this.store.get_value(dataItem, b))
            return Number.isNaN(cur) ? null : Math.round((cur - qty) * 1e6) / 1e6
        },
        sim_sameNumber(real, newVal) {
            // IE 2026 09 25 / ODOO-5800 (D1, остаток): введённый текст числовой ячейки равен числу — как парсит ввод cellEditEnding2
            // (пробелы-разделители, запятая); пусто / не число — не «то же»
            if (typeof newVal === 'number') return Math.abs(newVal - real) < 1e-9
            const s = String(newVal ?? '').replaceAll(' ', '').replace(',', '.').trim()
            if (s === '') return false
            const num = Number(s)
            return Number.isFinite(num) && Math.abs(num - real) < 1e-9
        },
        sim_stripVirtual(dataItem, b, b2) {
            // ввод в ячейку с оценкой автоплана: оценка снимается с листьев и самой строки (значение и леджер) — введённое число относится
            // к реальным документам; возвращает значение строки без оценки (null — оценки не было)
            if (!this._simVirtual?.size || !b) return null
            const leaves = this.decomp_leafRows(dataItem)
            const isAgg = leaves.length > 0 && !(leaves.length === 1 && leaves[0] === dataItem)
            const rows = [dataItem, ...leaves]
            const synced = []
            let n = 0
            for (const it of rows) {
                const m = this._simVirtual.get(it)
                if (!m) continue
                for (const bb of [b, b2]) {
                    const v = bb && m.get(bb)
                    if (!v) continue
                    m.delete(bb)
                    n++
                    if (it === dataItem && isAgg) continue   // агрегат пересчитается суммой листьев
                    const cur = parseFloat(this.store.get_value(it, bb))
                    if (Number.isNaN(cur) || !v.qty) continue
                    this.sim_setDelta(it, bb, cur, -v.qty)
                    this.sim_ledgerAdd(it, bb, -v.qty)
                    if (it !== dataItem) synced.push(it)
                }
                if (!m.size) this._simVirtual.delete(it)
            }
            if (!n) return null
            for (const it of synced) this.decomp_syncAncestors(it, [b])
            if (window.__simDebug) console.log('sim: virtual estimate stripped before edit', b, n)
            const cur = parseFloat(this.store.get_value(dataItem, b))
            return Number.isNaN(cur) ? null : cur
        },
        simVirtual_apply(e_cell, dataItem, col_binding, attr_col) {
            // D1: пометка «оценка автоплана превью» — класс + тултип; ячейки переиспользуются при прокрутке — чужую пометку снимаем
            const m = this._simVirtual?.get(dataItem)
            const v = m && this.sim_flag('virtualMark') ? (m.get(attr_col?.binding0 || col_binding) || m.get(col_binding)) : null
            if (!v) {
                if (e_cell.hasAttribute('data-sim-virtual')) {
                    e_cell.removeAttribute('data-sim-virtual')
                    wjcCore.removeClass(e_cell, 'cell-sim-virtual')
                    if (e_cell._simVirtTitle && e_cell.title === e_cell._simVirtTitle) e_cell.title = ''
                    e_cell._simVirtTitle = null
                }
                return
            }
            const q = Math.round(v.qty * 100) / 100
            e_cell.setAttribute('data-sim-virtual', String(q))
            wjcCore.addClass(e_cell, 'cell-sim-virtual')
            const tip = t('Autoplan preview: virtual document {qty} (not saved). {docs}', { qty: (q > 0 ? '+' : '') + q, docs: (v.docs || []).join('; ') })
            e_cell.title = tip
            e_cell._simVirtTitle = tip
        },
        decomp_leafRows(dataItem) {
            const kidsPath = this.attr.childItemsPath || 'attrs'
            const out = []
            // IE 2026 08 28 / ODOO-5828 (заказ Игоря): подчинённая строка ВНЕ итога родителя
            // (бэк ставит _DLRow.total_excluded строкам, не прошедшим отбор строки-зонта —
            // напр. «| Uncovered» под зонтом IN без alert) в раскладку правки и в итог
            // не берётся. Сама строка (корень обхода) исключением не считается — её
            // собственные листья раскладываются как обычно
            const walk = (it, isRoot) => {
                if (!isRoot && it?._DLRow?.total_excluded) return
                const kids = it?.[kidsPath]
                // IE 2026 09 23 / ODOO-5800: строка, у которой все подчинённые вне итога (memo «· of which …» /
                // total_excluded), — сама лист: иначе её сумма листьев пустая и итог родителя обнулялся бы
                const own = Array.isArray(kids) ? kids.filter(k => !k?._DLRow?.total_excluded) : []
                if (own.length) { for (const k of own) walk(k, false) }
                else out.push(it)
            }
            walk(dataItem, true)
            return out
        },
        decomp_cellEdit(irow, dataItem, attr_col, col_binding, newVal) {
            // опция виджета (Corrections → Recalculation): по умолчанию ВЫКЛ
            if (!this.store.get_value(this.WIDGET?.record, 'doc.params.decompose_cell_edit')) return false
            // IE 2026 08 15 / ODOO-4997 (заказ Игоря п.19): декомпозиция/итоги —
            // только основная таблица; формы параметров (AttrTabGrid) редактируют
            // ту же запись и ловили опцию виджета (итог «3» в GROUPING)
            if (this.attr?.attr_type === 'AttrTabGrid') return false
            // применимо: числовая ячейка данных с правилом Sum и подчинёнными
            if (!dataItem || !attr_col?.raw_binding) return false
            if (typeof newVal !== 'number' || Number.isNaN(newVal)) return false
            let rule = attr_col.aggregateScale || this.foldAgg_dlScale(dataItem._DLRow?.row_id)
                || attr_col.aggregateFooters || attr_col.aggregate || 'Sum'
            const asm = attr_col.aggregateScale_measure
            if (asm && typeof asm === 'object') {
                const mId = typeof dataItem.measure === 'string' ? dataItem.measure
                    : (dataItem.measure?.id ?? dataItem.measure_?.id)
                if (mId && asm[mId]) rule = asm[mId]
            }
            if (rule !== 'Sum') return false
            // колонки: листовые даты свёрнутой группы (без Total), иначе сама колонка
            const groups = this.foldAgg_groups().get(attr_col.binding0 || col_binding)
            const grp = groups?.find(g => g.isCollapsed)
            const colBindings = grp
                ? this.foldAgg_sourceBindings(grp, attr_col.raw_binding) : [col_binding]
            // строки: листовые подчинённые (сама строка, если лист)
            const leaves = this.decomp_leafRows(dataItem)
            if (leaves.length === 1 && leaves[0] === dataItem
                && colBindings.length === 1 && colBindings[0] === col_binding) return false
            const details = []
            for (const it of leaves) {
                for (const b of colBindings) {
                    const v = parseFloat(this.store.get_value(it, b))
                    details.push({ it, b, v: Number.isNaN(v) ? 0 : v })
                }
            }
            if (!details.length) return false
            const S = details.reduce((a, d) => a + d.v, 0)
            // АН 2026 08 15 / ODOO-4997 (п.1 «интерфейс залипает»): индекс строк —
            // одним проходом (был линейный поиск на КАЖДУЮ деталь), записи —
            // внутри одного deferUpdate (одна перерисовка вместо N)
            const irowByItem = new Map()
            for (let i = 0; i < this.flex.rows.length; i++) {
                const di = this.flex.rows[i].dataItem
                if (di && !irowByItem.has(di)) irowByItem.set(di, i)
            }
            const written = []
            const write = (d, v) => {
                if (d.v === v) return
                written.push({ it: d.it, b: d.b, from: d.v, to: v })
                this.set_value(irowByItem.get(d.it) ?? irow, d.it, d.b, d.v, v)
            }
            // IE 2026 09 25 / ODOO-5800 (D3, разбор ie-fado7: PO 8→0→8 раскладывал «8» в первый лист Done, а не обратно в ⚡Auto-scheduled —
            // детали оставались правлеными, Save горел): возврат агрегата к ИСХОДНОМУ итогу деталей восстанавливает их исходную раскладку
            // (исходное детали — val0 первой правки цепочки в changesStack, без записи — текущее). Выключатель fe.sim.revertLeaves
            let _orig = null
            if (this.sim_flag('revertLeaves')) {
                const vals = details.map(d => {
                    const rs = this.changesStack?.[`${irowByItem.get(d.it) ?? irow}:${d.b}`]
                    const v0 = rs ? (rs.val0 !== undefined ? rs.val0 : rs.val) : d.v
                    const n = parseFloat(v0)
                    return Number.isNaN(n) ? 0 : n
                })
                _orig = { vals, sum: vals.reduce((a, v) => a + v, 0) }
            }
            const doWrites = () => {
                if (newVal > 0 && newVal < 0.0001) {
                    // «жёсткий ноль» группы: эпсилон КАЖДОЙ детали — пропорциональная
                    // раскладка размолола бы 1e-7 в обычные нули
                    for (const d of details) write(d, 0.0000001)
                } else if (_orig && Math.abs(_orig.sum - newVal) < 1e-9 && details.some((d, i) => d.v !== _orig.vals[i])) {
                    // IE 2026 09 25 / ODOO-5800 (D3): итог = исходному — детали обратно к исходным значениям
                    details.forEach((d, i) => write(d, _orig.vals[i]))
                } else if (S > 0) {
                    // пропорция с накопительным округлением — сумма деталей = введённому
                    let accExact = 0, accAssigned = 0
                    for (const d of details) {
                        accExact += d.v * newVal / S
                        const v = Math.round((accExact - accAssigned) * 1e6) / 1e6
                        const vr = Math.round(v) === v ? v : Math.round(v)
                        accAssigned += vr
                        write(d, vr)
                    }
                } else {
                    // деталей с данными нет — всё в первую детальную ячейку
                    write(details[0], newVal)
                }
            }
            // IE 2026 08 15: детали декомпозиции — «связанные» правки (стиль и
            // подпись истории отделяют их от правленной рукой агрегатной ячейки)
            this._relatedEdits = true
            try {
                if (this.flex?.deferUpdate) this.flex.deferUpdate(doWrites)
                else doWrites()
            } finally {
                this._relatedEdits = false
            }
            // онлайн-превью баланса: IE 2026 08 28 / ODOO-5828 (заказ Игоря): в симуляцию
            // уходят РАЗЛОЖЕННЫЕ детали — у листа есть свои measure_type/measure/subject
            // (ключи применения правки на бэке), а строка-агрегат (зонт IN/OUT/Stock) их
            // не несёт: её общая дельта заставляла бэк угадывать документ применения
            for (const w of written) {
                this.balancePreview_afterEdit(w.it, [w.b], w.from, w.to)
            }
            // IE 2026 08 28 / ODOO-5828 (заказ Игоря): промежуточные строки между
            // правленной и листьями — пересчитать снизу вверх (раскладка пишет только
            // в листья, и группа посередине оставалась со старым числом)
            this.decomp_syncDescendants(dataItem, colBindings)
            // отображение агрегатов: сама строка и предки — сумма своих листьев
            // по каждой затронутой дате. КОСВЕННЫЕ правки (indirect): в undo-стеке
            // и подсветке изменённых, но на бэк при записи отчёта не уходят
            this.decomp_syncAncestors(dataItem, colBindings)
            // маркер правки пользователя в агрегатной ячейке — ПОСЛЕДНИМ в группе:
            // changesStack[irow:col] показывает старый АГРЕГАТ в тултипе Old value,
            // подсветка — штатная (wj-has-stack); данных не несёт, undo — no-op
            this.pushStack({
                // IE 2026 08 15: user — ячейка, правленная РУКОЙ (яркая подсветка
                // и заголовок группы в истории undo)
                method: 'aggEdit', indirect: true, user: true, actionStack: this.actionStack,
                irow, icol: attr_col.icol, $key: dataItem.$key, $item: dataItem,
                col_binding, val: S, newVal,
                // IE 2026 09 25 / ODOO-5800: листья раскладки, ушедшие в симуляцию при вводе, — откат / повтор (changeStack__) шлёт их же
                // дельты, а не агрегатную (на бэк запись стека не уходит: aggEdit — indirect)
                simLeaves: written.map(w => ({ it: w.it, b: w.b, from: w.from, to: w.to })),
            })
            this._foldAggCache = null // агрегаты свёрнутых групп пересчитать
            this._rowStyleStats = null // АН 2026 08 15 / ODOO-4997
            // IE 2026 08 18 (заказ Игоря п.3,7): вспышка по всей пачке правки —
            // и по деталям, и по агрегатной ячейке; при массовом пересчёте
            // вместо вспышек одна сводка
            this.flash_start(this.flash_ofAction(this.actionStack))
            this.flexRefresh()
            // IE 2026 09 25 / ODOO-5800 (D3): состояние Save по факту правок пользователя — агрегат, вернувшийся к исходному
            // (и детали к исходной раскладке), правок не оставляет: Save гаснет, как у прямой правки ячейки (pushStack no-op)
            if (this.sim_flag('revertLeaves')) this.saveState_sync()
            return true
        },
        decomp_rowAcceptsTotals(row) {
            // IE 2026 08 15 / ODOO-4997: настройки узла data_layout2 строки —
            // 'No values' и «фильтр не для детей» выключают приём итогов
            const dl = row?._DLRow
            if (!dl) return true
            if ((dl.values_placement || '') === 'none') return false
            // IE 2026 08 28 / ODOO-5828: строка с «фильтром не для детей» итоги подчинённых
            // принимает, если бэк подтвердил, что не исключённые дети покрывают её отбор
            // целиком (_DLRow.totals_included) — тогда её значение = сумма своих листьев
            if (dl.WHERE_no_inherit && !dl.totals_included) return false
            return true
        },
        decomp_syncDescendants(dataItem, touched) {
            // IE 2026 08 28 / ODOO-5828: подчинённые ГРУППЫ правленной строки (не листья) —
            // сумма своих листьев, снизу вверх. Строки вне итога родителя (total_excluded)
            // не трогаем: раскладка в них не шла, их значения остаются как были
            const kidsPath = this.attr.childItemsPath || 'attrs'
            const walk = (it, isRoot) => {
                if (!isRoot && it?._DLRow?.total_excluded) return
                const kids = it?.[kidsPath]
                if (!Array.isArray(kids) || !kids.length) return
                for (const k of kids) walk(k, false)
                if (isRoot || !this.decomp_rowAcceptsTotals(it)) return
                for (const b of touched) {
                    const sum = this.decomp_leafRows(it)
                        .reduce((a, x) => a + (parseFloat(this.store.get_value(x, b)) || 0), 0)
                    const cur = parseFloat(this.store.get_value(it, b))
                    const curV = Number.isNaN(cur) ? null : cur
                    if (curV !== sum) this.set_value(this.rows_indexOf(it), it, b, curV, sum, true, null, true)
                }
            }
            walk(dataItem, true)
        },
        decomp_syncAncestors(dataItem, touched) {
            // IE 2026 08 15 / ODOO-4997 (заказ Игоря п.19): подбивка итогов —
            // ТОЛЬКО основная таблица виджета списка/отчёта; формы параметров
            // (AttrTabGrid: Collapse columns to level и т.п.) итоги не суммируют
            if (this.attr?.attr_type === 'AttrTabGrid') return
            // сама строка и предки — сумма своих листьев по каждому затронутому
            // биндингу; КОСВЕННЫЕ правки (indirect) — undo/подсветка без бэка.
            // ИЕ 2026 08 13: вынесено из decomp_cellEdit — тем же путём итоги
            // пересчитываются и при правке ДЕТАЛЬНОЙ ячейки (обратная сторона
            // декомпозиции: правишь 45:115 — на лету обновляется 41:115).
            const chain = []
            const findPath = (rows, acc) => {
                for (const r of rows || []) {
                    if (r === dataItem) { chain.push(...acc, r); return true }
                    if (findPath(r[this.attr.childItemsPath || 'attrs'], [...acc, r])) return true
                }
                return false
            }
            findPath(this.data000 || this.data, [])
            for (const row of chain) {
                if (row !== dataItem && !Array.isArray(row[this.attr.childItemsPath || 'attrs'])) continue
                // IE 2026 08 15 / ODOO-4997 (заказ Игоря): предок НЕ принимает
                // итоги подчинённых, если его узел DL говорит об этом:
                // Values placement = No values ИЛИ Filter: not for child rows
                // (фильтр строки не наследуется — её значения не сумма детей)
                if (row !== dataItem && !this.decomp_rowAcceptsTotals(row)) continue
                for (const b of touched) {
                    const sum = this.decomp_leafRows(row)
                        .reduce((a, it) => a + (parseFloat(this.store.get_value(it, b)) || 0), 0)
                    const cur = parseFloat(this.store.get_value(row, b))
                    const curV = Number.isNaN(cur) ? null : cur
                    if (curV !== sum) this.set_value(this.rows_indexOf(row), row, b, curV, sum, true, null, true)
                }
            }
        },
        foldAgg_getValue(dataItem, binding, attr_col) {
            // значение ячейки с учётом агрегата свёрнутой группы
            const f = dataItem && attr_col ? this.foldAgg_value(dataItem, attr_col.binding0 || binding, attr_col) : null
            return f ? f.v : this.fmtGetValue(dataItem, binding)   // IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL5
        },
        foldAgg_paintCell(e_cell, fold, cell_attr_type, cell_format, attr_col, col) {
            // wijmo уже вписал в ячейку значение колонки-представителя — числовые/строковые
            // перерисовываем агрегатом; спецтипы (AttrTime/Date/Days) перерисуют из value штатные ветки
            if (!fold || e_cell.querySelector('input')) return
            if (fold.v === null || fold.v === undefined || fold.v === '') {
                e_cell.textContent = ''
                return
            }
            if (cell_attr_type === 'AttrDate' || cell_attr_type === 'AttrTime' || cell_attr_type === 'AttrDays') return
            const n = Number(fold.v)
            if ((cell_format || attr_col.format) === 'bytes' && !Number.isNaN(n)) {   // IE 2026 11 01 / ODOO-349799 (group-bytes): агрегат свёрнутой группы колонки bytes — KB/MB, как листья
                e_cell.textContent = formatAggValue(n, 'bytes', this.store)
                return
            }
            e_cell.textContent = Number.isNaN(n) ? String(fold.v)
                : wjcCore.Globalize.format(n, cell_format || attr_col.format || col.format || 'n0')
        },
        groupBytes_paint(e_cell, row, col, attr_col) {
            // IE 2026 11 01 / ODOO-349799 (group-bytes): строка-группа wijmo (GroupRow над CollectionViewGroup) печатает сумму по группе форматом колонки — для 'bytes' это сырые байты;
            // пишем KB/MB тем же текстом, что листовые ячейки. Колонка заголовка группы (первая видимая) не трогается
            if (!(row instanceof wjGrid.GroupRow) || typeof row.dataItem?.getAggregate !== 'function') return false
            if (attr_col?.attr_type !== 'AttrNumber' || attr_col.format !== 'bytes' || !col?.aggregate) return false
            const flex = this.flex
            if (!flex || col === flex.columns[flex.columns.firstVisibleIndex] || e_cell.querySelector('input')) return false
            let v
            try { v = row.dataItem.getAggregate(col.aggregate, col.binding, flex.collectionView) } catch (e) { return false }
            e_cell.textContent = formatAggValue(v, 'bytes', this.store)
            wjcCore.addClass(e_cell, 'wj-align-right')
            return true
        },
        // ---- подписи дат под свёрнутой группой дат (ИЕ 2026-08-11) ----
        // Свёрнутая группа дат (квартал/месяц/неделя) показывает колонку-представителя,
        // и её шапка повторяла более мелкую детализацию («+ Q2 2026» → «April»,
        // «10W» → «2 Mon») — вводит в заблуждение. Такие подписи гасим: остаётся
        // заголовок самой группы, глиф свёртки и листья-меры («↩», Offset, Duration).
        // Датой считаем узел, чьи листовые колонки названы датой (генератор multidates),
        // поэтому НЕ-датовые группировки колонок (Past / Now / Lead time) не затронуты.
        foldHdr_isDateNode(g) {
            const isDateBinding = (b) => /^\d{4}-\d{2}-\d{2}(\.|$)/.test(String(b || ''))
            if (!g.columns || !g.columns.length) return isDateBinding(g.binding)
            let found = false
            const walk = (gs) => {
                for (const c of gs || []) {
                    if (found) return
                    if (c.columns && c.columns.length) walk(c.columns)
                    else if (isDateBinding(c.binding)) found = true
                }
            }
            walk(g.columns)
            return found
        },
        foldHdr_isDateLabel(g, hasKids) {
            if (hasKids) return this.foldHdr_isDateNode(g)
            const a = this.attr_by_binding[g.binding]
            if (a?._groupTitle) return !!(a._collapsedGroup?.date || a._collapsedGroup?.freq)
            return !!(a?.date || a?.freq) || /^\d{4}-\d{2}-\d{2}$/.test(String(g.binding || ''))
        },
        foldHdr_blankMap() {
            // binding видимой колонки → уровни шапки (= ряды columnHeaders), где подпись гасим
            if (this._foldHdrBlank) return this._foldHdrBlank
            const map = new Map()
            const markBlank = (g) => {
                const level = g.level ?? 0
                const add = (binding) => {
                    if (!binding) return
                    if (!map.has(binding)) map.set(binding, new Set())
                    map.get(binding).add(level)
                }
                if (!g.columns || !g.columns.length) { add(g.binding); return }
                const walk = (gs) => {
                    for (const c of gs || []) {
                        if (c.columns && c.columns.length) walk(c.columns)
                        else add(c.binding)
                    }
                }
                walk(g.columns)
            }
            const walk = (groups, insideCollapsedDate) => {
                for (const g of groups || []) {
                    const hasKids = !!(g.columns && g.columns.length)
                    let inside = insideCollapsedDate
                    if (inside) {
                        // гасим подпись уровня ДАТЫ; подпись меры («↩», Offset,
                        // Duration) остаётся. Месяц с единственным «↩» слит в одну
                        // колонку (collapse_arrowLayer_attrs) — там подпись даты
                        // приезжает из _groupTitle схлопнутой группы
                        if (this.foldHdr_isDateLabel(g, hasKids)) markBlank(g)
                    } else if (hasKids && g.isCollapsed && this.foldHdr_isDateNode(g)) {
                        inside = true
                    }
                    if (hasKids) walk(g.columns, inside)
                }
            }
            walk((this.flex?.getColumnGroups && this.flex.getColumnGroups()) || [], false)
            this._foldHdrBlank = map
            return map
        },
        foldHdr_blankCell(e_cell, binding, level) {
            const levels = this.foldHdr_blankMap().get(binding)
            if (!levels || !levels.has(level)) return
            // только текст: глиф свёртки (.wj-elem-collapse) и прочие элементы остаются
            for (const node of [...e_cell.childNodes]) {
                if (node.nodeType === Node.TEXT_NODE) node.textContent = ''
            }
        },
        // ---- дефолтная свёртка групп из параметров отчёта (ИЕ 2026-08-11) ----
        // doc.params.fold_rows_level / fold_cols_level: 0/пусто — не трогаем; иначе
        // свернуть группы до N уровней (как fold-бейджи), приоритетнее isCollapsed
        // из DL. Колонки — в ОПРЕДЕЛЕНИЯХ групп на каждом скане (пересборки при
        // загрузке не теряют свёртку), но сохранённое пользователем состояние
        // (viewParam_attrs) сильнее. Строки — в DL-фолбэке set_itemsSource:
        // переформирование открытого отчёта восстанавливает текущее состояние штатно.
        foldDefault_level(key) {
            // IE 2026 09 17 (замечание Игоря «во всех AttrTabGrid при открытии виджета — группа Value свёрнута»): параметры свёртки
            // ОТЧЁТА (fold_rows_level / fold_cols_level) — для таблицы данных; в формах настроек (AttrTabGrid) fold_cols_level = 3
            // разворачивал группу Value (глубина 0 < 2). Формам — свёртка из определений колонок
            if (this.attr?.attr_type === 'AttrTabGrid') return 0
            const n = Math.floor(Number(this.WIDGET?.record?.doc?.params?.[key]))
            return n > 0 ? n : 0
        },
        // IE 2026 09 17 (замечание Игоря): свёртка колоночных групп ФОРМ настроек (AttrTabGrid) — сеансовая память экземпляра виджета
        // (WIDGET._tabGridFold[grid][key]), не viewParams записи: при открытии виджета группы берут свёртку определений (Value свёрнута),
        // сохранённые в записях раскрытия игнорируются, ручное раскрытие живёт до закрытия виджета и переживает пересборку грида
        foldMem_isForm() { return this.attr?.attr_type === 'AttrTabGrid' },
        foldMem_get(key) {
            if (!key) return undefined
            if (this.foldMem_isForm()) return this.WIDGET?._tabGridFold?.[this.attr.name]?.[key]
            return this.foldColsPersist_enabled() ? this.viewParam_attrs?.[key]?.isCollapsed : undefined
        },
        foldMem_set(key, isCollapsed) {
            if (!key || !this.foldMem_isForm()) return false
            const W = this.WIDGET
            if (!W) return true
            W._tabGridFold = W._tabGridFold || {}
            const m = W._tabGridFold[this.attr.name] = W._tabGridFold[this.attr.name] || {}
            m[key] = isCollapsed
            return true
        },
        foldCols_keepScroll(flex, fn) {
            // Смена свёртки пересобирает колонки, и wijmo подтягивает вид к выделению —
            // грид уезжает в конец по горизонтали (ИЕ 2026-08-11). Держим позицию:
            // сразу после правки и ещё на двух кадрах, пока идёт доразметка.
            const sp = flex.scrollPosition
            const x = sp?.x ?? 0, y = sp?.y ?? 0
            const restore = () => {
                if (!flex.hostElement) return
                const cur = flex.scrollPosition
                if (cur && (cur.x !== x || cur.y !== y)) flex.scrollPosition = new wjcCore.Point(x, y)
            }
            fn()
            restore()
            requestAnimationFrame(restore)
            setTimeout(restore, 60)
        },
        foldCols_toLevel(flex, n, { expandAll = false } = {}) {
            // Свернуть группы колонок до n уровней. wijmo НЕ сворачивает родителя
            // за один проход, если в том же проходе меняются и вложенные группы
            // (у ИЕ 2026-08-11 март оставался развёрнутым, а «бейдж 4, потом 3»
            // давал верный вид). Поэтому идём ЛЕСЕНКОЙ: сначала самый глубокий
            // уровень, затем на шаг выше, и каждый проход — в своём тике.
            // IE 2026 09 25 / ODOO-341407: пути групп — ключи свёртки по базовым заголовкам (foldGroups_paths), как у ручной свёртки
            const groups = this.foldGroups_paths(flex).filter(({ g }) => g.collapseTo !== undefined && g.collapseTo !== null && g.collapseTo !== '').map(({ g, p }) => ({ g, p }))
            if (!groups.length) return
            // бейдж — ручное действие: итоговую свёрнутость пишем в fold::-ключи,
            // чтобы выбранный уровень пережил пересборку/обновление данных
            let vpChanged = false
            for (const { g, p } of groups) {
                const want = expandAll ? false : (g.level ?? 0) >= n - 1
                const key = `fold::${p}`
                if (this.viewParam_attrs[key]?.isCollapsed !== want) {
                    this.viewParam_attrs[key] = { ...this.viewParam_attrs[key], isCollapsed: want }
                    vpChanged = true
                }
            }
            // клон — гарантируем запись и modified (set_viewParam no-op при том же объекте)
            if (vpChanged) this.store.set_viewParam(this.WIDGET, this.attr.name, 'attr_by_binding', { ...this.viewParam_attrs }, this.attr)
            const pass = (L) => {
                if (!flex.hostElement) return
                this._foldHdrBlank = null
                this.cf_cache?.clear()
                this.foldCols_keepScroll(flex, () => flex.deferUpdate(() => {
                    for (const { g } of groups) {
                        const want = expandAll ? false : (g.level ?? 0) >= L - 1
                        if (g.isCollapsed !== want) g.isCollapsed = want
                    }
                }))
            }
            if (expandAll) { pass(0); return }
            const maxL = groups.reduce((m, { g }) => Math.max(m, g.level ?? 0), 0)
            let step = 0
            for (let L = maxL + 1; L >= n; L--) {
                const _L = L
                if (step === 0) pass(_L)
                else setTimeout(() => pass(_L), step * 30)
                step++
            }
        },
        foldDefault_applyColsDefs(columnGroups) {
            // МОДЕЛЬ свёртки в определениях групп (до flex.columnGroups): ручную
            // свёрнутость (_userCollapsed из fold::-ключей и legacy-листа) не
            // трогаем; вложенные уровни тоже сворачиваем — при раскрытии родителя
            // это даёт drill-down. ВИЗУАЛ определения не дают — см. reapplyLive
            const n = this.foldDefault_level('fold_cols_level')
            if (!n) return
            const walk = (gs, depth) => {
                for (const g of gs || []) {
                    if (!g.columns || !g.columns.length) continue
                    const foldable = g.collapseTo !== undefined && g.collapseTo !== null && g.collapseTo !== ''
                    if (foldable && !g._userCollapsed) g.isCollapsed = depth >= n - 1
                    walk(g.columns, depth + 1)
                }
            }
            walk(columnGroups, 0)
        },
        foldDefault_reapplyLive(flex) {
            // wijmo применяет свёртку колонок только через СЕТТЕР живой группы:
            // isCollapsed, заданный в определениях columnGroups, в рендер не
            // попадает — месяц оставался визуально раскрытым, а подписи недель
            // гасились как «под свёрнутой группой» (ИЕ 2026-08-12, «забитые
            // заголовки»). Пере-дёргиваем сеттер у ВЕРХНИХ свёрнутых групп —
            // синхронно, до первого кадра; их поддеревья скрываются целиком,
            // вложенная свёртка остаётся в модели для drill-down
            const tops = []
            const walk = (gs) => {
                for (const g of gs || []) {
                    if (!g.columns || !g.columns.length) continue
                    if (g.isCollapsed) tops.push(g)
                    else walk(g.columns)
                }
            }
            walk((flex.getColumnGroups && flex.getColumnGroups()) || [])
            // АН 2026 08 14: передёргивание сеттера — ПРОГРАММНОЕ применение
            // дефолтной свёртки при построении грида; события collapsedChanged
            // от него не должны персистить fold-состояние и метить запись
            // изменённой (виджет становился modified сразу после первого
            // рендера, без действий пользователя)
            this._foldSilent = true
            try {
                for (const g of tops) {
                    g.isCollapsed = false
                    g.isCollapsed = true
                }
            } finally {
                this._foldSilent = false
            }
        },
        foldCols_drillOne(flex, group) {
            // раскрыли группу — следующий уровень показываем СВЁРНУТЫМ (drill-down
            // по одному уровню), иначе разворачивается сразу до дней (ИЕ 2026-08-11)
            if (!group || group.isCollapsed) return
            const kids = (group.columns || []).filter(c => c.columns && c.columns.length
                && c.collapseTo !== undefined && c.collapseTo !== null && c.collapseTo !== '')
            if (!kids.length) return
            // СИНХРОННО, до перерисовки: отложенный проход давал промежуточный
            // кадр с раскрытием до последнего уровня и рывком прокрутки —
            // «мельтешит несколько кадров, ожидаю один» (ИЕ 2026-08-12)
            this._foldHdrBlank = null
            this.cf_cache?.clear()
            for (const k of kids) if (!k.isCollapsed) k.isCollapsed = true
        },
        foldGroupPath(flex, grp) {
            // путь группы по заголовкам от корня ('Q1 2026/March 2026/9W') —
            // тот же формат, что _foldPath определений в scan_columnGroups_fromAttrs
            // IE 2026 09 25 / ODOO-341407: путь — из определения группы (_foldPath: базовые заголовки, одинаковые на всех языках); у группы без
            // определения — по показанным заголовкам, как раньше
            const hit = this.foldGroups_paths(flex).find(x => x.g === grp)
            return hit ? hit.p : null
        },
        // IE 2026 09 25 / ODOO-341407: группы колонок живого грида вместе с их определениями (flex.columnGroups — описания, из которых wijmo создал
        // группы; порядок тот же, ср. i18n_relabelColumns): [{g, d, p, pl}] — p ключ свёртки (путь определения _foldPath, без определения — по
        // показанным заголовкам), pl — путь по показанным заголовкам (прежний формат ключа)
        foldGroups_paths(flex) {
            const out = []
            const walk = (gs, defs, p0, pl0, depth) => {
                if (!gs || typeof gs.length !== 'number' || depth > 16) return   // g.columns живой группы — коллекция wijmo (не обязательно Array)
                for (let i = 0; i < gs.length; i++) {
                    const g = gs[i]
                    if (!g || !g.columns || !g.columns.length) continue
                    const d = (defs && typeof defs.length === 'number') ? defs[i] : null
                    const pl = (pl0 ? pl0 + '/' : '') + String(g.header ?? g.name ?? g.binding ?? '')
                    const p = (d && typeof d._foldPath === 'string') ? d._foldPath : (p0 ? p0 + '/' : '') + String(g.header ?? g.name ?? g.binding ?? '')
                    out.push({ g, d, p, pl })
                    walk(g.columns, d && d.columns, p, pl, depth + 1)
                }
            }
            try { walk((flex.getColumnGroups && flex.getColumnGroups()) || [], flex.columnGroups, '', '', 0) } catch (e) { /* грид пересоздаётся */ }
            return out
        },
        // IE 2026 09 25 / ODOO-341407: базовый (английский) заголовок узла колонки — бэкап title_en, который ставит перевод (бэк attrs._i18n_apply,
        // клиент relocalize._set); у схлопнутого слоя «↩» — заголовок группы. Без бэкапа — title как есть (он и есть база)
        foldTitle_base(attr_col) {
            if (!attr_col || typeof attr_col !== 'object') return null
            const src = (attr_col._groupTitle && attr_col._collapsedGroup) ? attr_col._collapsedGroup : attr_col
            const en = src.title_en
            if (typeof en === 'string' && en) return en
            return typeof src.title === 'string' ? src.title : null
        },
        // IE 2026 09 25 / ODOO-341407: ключи свёртки групп по базовым заголовкам (флаг объекта i18nSwitch — fe.i18n.foldKeysBase, по умолчанию вкл.)
        foldKeys_base() {
            try { return this.store.setting('fe.i18n.foldKeysBase', true) !== false } catch (e) { return true }
        },
        async autoSizeRows() {
            if (!this.attr.use_delivery) return;

            const flex = this.flex;
            const rows = flex.rows;
            const defaultSize = rows.defaultSize;
            // IE 2026 08 27 / ODOO-5800 (заказ Игоря): в режиме рамки (tree_lines не 'dotted')
            // строка после поддерева не выше остальных — зазор +10px только у пунктира
            const breakTop = this.treeLines_noGaps() ? 0 : 10;
            const newHeightStart = defaultSize + breakTop;
            const _tlStats = this.store?._treeLinesStats
            let _tlSync = 0 // IE 2026 08 27 / ODOO-5800: суммируем только синхронные куски (без ожидания между порциями)

            const batchSize = this.store.setting('fe.grid.autoSizeBatchRows', 500); // строк за проход; IE 2026 09 05 / ODOO-336330: настройка базы

            // IE 2026 10 29 / ODOO-5800 (заказ Игоря: длинная задача Shift+F3): при флаге fe.ux.gridAutoSizeRowsLazy — план высот без записи,
            // порция без изменений не входит в deferUpdate (wijmo endUpdate безусловно взводит invalidate → лишний полный refresh)
            if (gridAutoSizeRows_on(this.store)) _tlSync = await this.autoSizeRows_lazy(rows, { defaultSize, breakTop, batchSize, timed: !!_tlStats })   // IE 2026 10 29 / ODOO-5800 (заказ Игоря: длинная задача Shift+F3)
            else   // IE 2026 10 29 / ODOO-5800 (заказ Игоря: длинная задача Shift+F3): флаг выкл — прежний цикл без изменений
            for (let start = 0; start < rows.length; start += batchSize) {
                const end = Math.min(start + batchSize, rows.length);

                // один «кусок» обновляем внутри одного deferUpdate
                const _tl0 = _tlStats ? performance.now() : 0
                flex.deferUpdate(() => {
                    for (let i = start; i < end; i++) {
                        const row = rows[i];
                        // задача 18: скрытым (свёрнутым) строкам высоту не назначаем,
                        // и «предыдущей» считаем предыдущую ВИДИМУЮ строку (как в
                        // formatItem) — иначе каждая группа после свёрнутых детей
                        // соседа ложно считалась началом секции и получала +10px
                        if (row.visibleIndex === -1) continue;
                        let iPrev = i - 1;
                        while (iPrev >= 0 && rows[iPrev].visibleIndex === -1) iPrev--;
                        const prevRow = iPrev >= 0 ? rows[iPrev] : null;
                        const sectionStart = !!(prevRow && row.level < prevRow.level);
                        const dataItem = row.dataItem;

                        let newHeight = null;
                        // IE 2026 09 03 / ODOO-336283: высота строки из настройки строки лэйаута (_DLRow.height)
                        const rowH = dataItem?._DLRow?.height || dataItem?._cells?._row?.height || 0
                        if (sectionStart) {
                            newHeight = breakTop ? (rowH || defaultSize) + breakTop : (rowH || null); // IE 2026 08 27 / ODOO-5800
                        } else if (rowH) {
                            newHeight = rowH;
                        }

                        if (newHeight !== null) {
                            if (row.height !== newHeight) row.height = newHeight;
                        } else if (row.height !== null) {
                            // сброс устаревшей высоты: строка больше не начало секции
                            // (после разворота/сворачивания) — иначе +10px оставался навсегда
                            row.height = null;
                        }
                    }
                });
                if (_tlStats) _tlSync += performance.now() - _tl0

                // отдаём управление UI между порциями
                await this.store.sleep(0); // или: await Promise.resolve();
            }
            if (_tlStats) { // IE 2026 08 27 / ODOO-5800: замер рядом с флагом (только CPU-время кусков)
                _tlStats.autoSizeRows_ms += _tlSync
                _tlStats.autoSizeRows_calls++
            }

            if (this.attr.autoRowHeights || this.get_viewParam('autoRowHeights')) {
                const chipHeight = 22 // approximate chip height in px
                const cellPadding = 4
                const defaultH = rows.defaultSize
                const attrGridCols = []
                for (const [binding, attr_col] of Object.entries(this.attr_by_binding || {})) {
                    if (attr_col?.attr_type === 'AttrGrid') attrGridCols.push(binding)
                }
                if (attrGridCols.length) {
                    let _arhChanged = 0   // IE 2026 10 29 / ODOO-5800 (заказ Игоря: длинная задача Shift+F3): число изменённых высот (для endUpdate при флаге)
                    const _arh = () => {   // IE 2026 10 29 / ODOO-5800 (заказ Игоря: длинная задача Shift+F3): тело прежнего deferUpdate
                        for (let i = 0; i < rows.length; i++) {
                            const dataItem = rows[i].dataItem
                            if (!dataItem) continue
                            let maxChips = 0
                            for (const binding of attrGridCols) {
                                const val = this.store.get_value(dataItem, binding)
                                if (Array.isArray(val)) {
                                    const count = val.filter(f => f.use !== false).length
                                    if (count > maxChips) maxChips = count
                                }
                            }
                            const neededH = maxChips > 0 ? Math.max(defaultH, maxChips * chipHeight + cellPadding) : defaultH
                            if (rows[i].height !== neededH && neededH > defaultH) {
                                rows[i].height = neededH
                                _arhChanged++   // IE 2026 10 29 / ODOO-5800 (заказ Игоря: длинная задача Shift+F3)
                            }
                        }
                    }
                    // IE 2026 10 29 / ODOO-5800 (заказ Игоря: длинная задача Shift+F3): при флаге — invalidate только если высоты менялись; флаг выкл — deferUpdate, как раньше
                    if (gridAutoSizeRows_on(this.store)) { flex.beginUpdate(); try { _arh() } finally { flex.endUpdate(_arhChanged > 0) } }
                    else flex.deferUpdate(_arh)
                }
            }
        },
        // IE 2026 10 29 / ODOO-5800 (заказ Игоря: длинная задача Shift+F3): порции autoSizeRows при флаге fe.ux.gridAutoSizeRowsLazy (utils/gridAutoSizeRows.js).
        // План высот порции без записи (autoSizeRows_plan — семантика прежнего цикла: скрытые пропускаются, начало секции, rowH, сброс к null),
        // запись только изменённых строк внутри одного deferUpdate на порцию; порция без изменений в deferUpdate не входит — Control.endUpdate()
        // wijmo не взводит invalidate (таймер 10 мс → полный FlexGrid.refresh 165–250 мс на Stock Move). Возвращает мс синхронных кусков (_treeLinesStats)
        async autoSizeRows_lazy(rows, { defaultSize, breakTop, batchSize, timed = false }) {
            const flex = this.flex
            const acc = autoSizeRows_begin(rows.length)
            let sync = 0
            for (let start = 0; start < rows.length; start += batchSize) {
                const end = Math.min(start + batchSize, rows.length)
                const t0 = timed ? performance.now() : 0
                const changes = autoSizeRows_batch(acc, rows, { defaultSize, breakTop, start, end })
                if (changes.length) flex.deferUpdate(() => { for (const c of changes) c.row.height = c.height })
                if (timed) sync += performance.now() - t0
                // отдаём управление UI между порциями (как прежний цикл)
                await this.store.sleep(0)
            }
            autoSizeRows_end(acc)
            return sync
        },
        // IE 2026 09 22 / ODOO-… (заказ Игоря 22.09): полосы-интервалы дат в ячейках списка. «Период с / период по — min / max по строкам,
        // интервал Ганта периода действия; граница ячеек «с» | «по» — текущая дата; одиночная дата (Updated at) — положение относительно
        // других как колонка гистограммы у нижнего бордюра; ненавязчиво, за текстом, по наведению — небольшое увеличение».
        // Логика — utils/dateBars.js (роли колонок по имени поля / заголовку, пары, шкалы, геометрия); здесь — состояние на набор данных
        // (план колонок + шкалы, пересчёт при смене источника / числа строк / состава колонок и после правки ячейки) и отрисовка
        // элемента .cell-date-bar в хвосте formatItem (и на кэш-пути — wijmo переписывает содержимое ячейки при каждой отрисовке).
        // Выключатели: fe.ux.gridDateBars; колонка 'date-bar': false | 'tick' | 'bar' | 'interval'; fe.data.gridDateBarsSeam 'today' | 'fact'.
        dateBar_on() {
            if (this.attr?.isPrint || this.attr?.isPrintTemplate || this.attr?.attr_type === 'AttrTabGrid') return false
            if (this.WIDGET?.widget_class === 'widget_REPORT2' && this.attr?.name === 'dataSheet') return false   // отчёт: датные колонки — периоды шапки
            return this.store.setting('fe.ux.gridDateBars', true) !== false
        },
        dateBar_state(flex) {
            const rows = flex?.rows
            if (!rows || !this.attr_by_binding) return null
            const src = this.data000 || this.data
            const st = this._dateBar
            if (st && st.src === src && st.n === rows.length && st.ncol === flex.columns.length) return st.on ? st : null
            const on = this.dateBar_on()
            const st2 = { src, n: rows.length, ncol: flex.columns.length, on, plan: null, scales: null, paths: {}, seam: 0 }
            this._dateBar = st2
            if (!on) return null
            const cols = []
            flex.columns.forEach((c, i) => {
                const a = c.binding ? this.attr_by_binding[c.binding] : null
                if (!a || a.attr_type !== 'AttrDate') return
                cols.push({ binding: c.binding, title: c.header || a.title || '', index: i, mode: a['date-bar'] })
            })
            const plan = cols.length ? dateBar_plan(cols) : null
            if (!plan || !Object.keys(plan.byBinding).length) { st2.on = false; return null }
            for (const b of Object.keys(plan.byBinding)) st2.paths[b] = toRaw(this.store._parse_binding(b))
            let seam = null
            if (this.store.setting('fe.data.gridDateBarsSeam', 'today') === 'fact') seam = dateBar_parse(this.store.get_value(this.store.activeWORKSPACE?.record, 'doc.params.date_fact_stock'))
            st2.seam = dateBar_dayStart(isFinite(seam) && seam != null ? seam : null)
            const items = []
            for (const r of rows) if (r.dataItem) items.push(toRaw(r.dataItem))
            st2.scales = dateBar_scales(items, plan, (row, b) => rowEmpty_value(row, b, st2.paths[b]), st2.seam)
            st2.plan = plan
            return st2
        },
        dateBar_paint(e_cell, dataItem, e_col, flex, isXlsxExport) {
            if (isXlsxExport) return
            const st = this.dateBar_state(flex)
            const col = st && flex.columns[e_col]
            const entry = col && st.plan.byBinding[col.binding]
            if (!entry || !dataItem) {
                const last = e_cell.lastElementChild
                if (last && last.classList.contains('cell-date-bar')) last.remove()
                return
            }
            const old = e_cell.querySelector(':scope > .cell-date-bar')
            const raw = toRaw(dataItem)
            const get = (b) => rowEmpty_value(raw, b, st.paths[b])
            const values = entry.kind === 'single' ? { value: get(col.binding) }
                : entry.kind === 'from' ? { from: get(col.binding), to: get(entry.pair) } : { from: get(entry.pair), to: get(col.binding) }
            const g = dateBar_geom(entry, st.scales, values, col.renderWidth || 0)
            if (!g) { if (old) old.remove(); return }
            const el = old || document.createElement('span')
            const cls = 'cell-date-bar' + (g.cls ? ' ' + g.cls : '')
            if (el.className !== cls) el.className = cls
            const left = g.x.toFixed(1) + 'px', width = g.w.toFixed(1) + 'px'
            if (el.style.left !== left) el.style.left = left
            if (el.style.width !== width) el.style.width = width
            if (!old) e_cell.appendChild(el)
        },
        // IE 2026 09 17 / ODOO-… (заказ Игоря): «Break before» из булева стал ВАРИАНТОМ разрыва —
        // '' (нет) | 'gap' (прежний пустой зазор) | 'arrow' (→) | 'arrow_left' (←) | 'arrow_both' (↔) | 'arrow_double' (⇒ — «возможная продажа», IE 2026 09 20).
        // Старые записи несут true/false: true = 'gap' (бэк чинит значение при открытии записи,
        // здесь — страховка для ещё не пересохранённых записей и чужих сборок бэка)
        // IE 2026 09 17 (замечание Игоря: «вторая стрелка справа при выделении»): при перестройке содержимого
        // ячейки (кнопка раскрытия ссылки, обёртка редактора, обрезка текста) элемент стрелки мог оказаться
        // внутри другого контейнера или продублироваться — оставляем ровно один, прямо в ячейке
        breakArrow_fix(e_cell) {
            const arrows = e_cell.querySelectorAll('.break-arrow')
            if (!arrows.length) return
            const keep = arrows[0]
            for (let i = 1; i < arrows.length; i++) arrows[i].remove()
            const par = keep.parentElement
            if (par !== e_cell && !(par && par.parentElement === e_cell && par.tagName === 'I')) e_cell.appendChild(keep)
        },
        // IE 2026 09 19 / ODOO-… (замечание Игоря по Sales Routes: «теряется разделитель колонок, если первая колонка после — пустая и вкл
        // set_nonEmptyWidget; нужно показывать разделитель если видима колонка до или после»). Разрыв живёт на колонке (break_before — первая колонка
        // блока): спрятанная колонка (фильтр «непустые», скрытие вручную, свёрнутая группа) уносила его с собой, и блоки From | To сливались. Разрыв
        // скрытой колонки переезжает на ближайшую ВИДИМУЮ колонку справа (attr._breakCarry — вариант разрыва; сам break_before не трогаем), если
        // слева от границы есть хоть одна видимая колонка; у колонки со своим разрывом второго зазора нет. Пересчёт — на каждый refresh грида
        // (refreshing: смена видимости колонок всегда ведёт к refresh). Выключатель fe.ux.gridBreakCarry
        breakOf(attr) { return attr ? (attr.break_before || attr._breakCarry || false) : false },
        breakCarry_update() {
            const flex = this.flex
            if (!flex?.columns?.length || !this.attr_by_binding) return false
            if (this._breakCarryOn === undefined) this._breakCarryOn = this.store.setting('fe.ux.gridBreakCarry', true) !== false
            let pending = '', seenVisible = false, changed = false
            for (const col of flex.columns) {
                const a = this.attr_by_binding[col.binding]
                const shown = col.isVisible !== false && col.visible !== false
                if (!a) { if (shown) { seenVisible = true; pending = '' } continue }
                const own = a.break_before ? this.breakMode({ break_before: a.break_before }) : ''
                let carry = ''
                if (!shown) { if (own && !pending) pending = own }
                else {
                    if (!own && pending && seenVisible && this._breakCarryOn) carry = pending
                    pending = ''; seenVisible = true
                }
                if ((a._breakCarry || '') !== carry) { if (carry) a._breakCarry = carry; else delete a._breakCarry; changed = true }
                // зазор рисуется ВНУТРИ колонки (ячейки сдвигаются и сужаются на break_width): колонка, не рассчитанная на разрыв, на время переезда
                // получает эти 15 px сверху — её текст не обрезается сильнее прежнего; отметка живёт на объекте колонки (новые колонки — с чистого листа)
                if (carry && !col._breakCarryW && typeof col.width === 'number') { col.width = col.width + this.break_width; col._breakCarryW = true }
                else if (!carry && col._breakCarryW) { if (typeof col.width === 'number') col.width = Math.max(20, col.width - this.break_width); col._breakCarryW = false }
            }
            return changed
        },
        // IE 2026 09 29 / ODOO-343343 (заказ Игоря: начало плана штриховкой): вариант разрыва 'plan' («Plan start», бэк ставит на колонку периода с date_fact_stock): в зазоре — штриховка цвета плана.
        // Выключатель fe.ux.planStartMark (по умолчанию вкл; выкл — прежний пустой разрыв); читается заново на каждый refresh
        planStartOn() {
            if (this._planStartOn === undefined) this._planStartOn = this.store.setting('fe.ux.planStartMark', true) !== false
            return this._planStartOn
        },
        // IE 2026 09 30 / ODOO-343343 (заказ Игоря: штриховка начала плана — одним элементом): штриховка «начала плана» в теле — ОДИН элемент на грид (Игорь: «как один элемент», как рамка групп treeLines).
        // Полоса — ребёнок [wj-part="root"] сразу после [wj-part="cells"] (не внутри панели: wijmo переиспользует её детей как ячейки): координаты
        // содержимого (left = cells.offsetLeft + позиция зазора, top = cells.offsetTop, высота = вся область данных), поэтому она прокручивается
        // вместе с рядами без пересчёта; ниже клона замороженных (fcells), под выделением; pointer-events: none. Набор зазоров — тот же, что у масок
        // шапки (_breakGaps / _breakPlanGaps, их пишет formatItem). Фаза штрихов задаётся от верха ШАПКИ (маска шапки — тот же градиент от своего
        // верха), при вертикальной прокрутке сдвигается на кратное периоду 7·√2 — стык с шапкой и стыки рядов без шва. Синхронизация — из updatedView.
        planStart_band() {
            const flex = this.flex
            const root = flex?.hostElement?.querySelector('[wj-part="root"]')
            const cells = root?.querySelector(':scope > [wj-part="cells"]')
            const ch = flex?.hostElement?.querySelector('[wj-part="ch"]') || flex?.hostElement?.querySelector('[wj-part="chcells"]')
            const gaps = []
            if (root && cells && ch && this.planStartOn() && this.attr.use_delivery && this.break_width && this._breakGaps?.size && this._breakPlanGaps?.size) {
                for (const [left, width] of this._breakGaps) if (this._breakPlanGaps.has(left)) gaps.push([left, width])
            }
            const have = root ? [...root.querySelectorAll(':scope > .plan-start-band-el')] : []
            if (!gaps.length) { this._planBandSig = ''; have.forEach(e => e.remove()); if (cells && cells.__altTipAt) { cells.__altTipAt = null; cells.removeAttribute('data-alt-tip-at') } return }
            const H = cells.offsetHeight
            if (!(H > 0)) { this._planBandSig = ''; have.forEach(e => e.remove()); return }
            // замороженные колонки: зазор внутри них не уезжает при горизонтальной прокрутке (полоса едет вместе с scrollLeft, поверх клона замороженных)
            let frozenW = 0
            try { for (let i = 0; i < flex.frozenColumns; i++) { const c = flex.columns[i]; if (c && c.visible) frozenW += c.renderWidth || c.width || 0 } } catch { frozenW = 0 }
            const y0 = ch.offsetTop - root.offsetTop   // верх шапки в координатах корня (начало фазы штрихов)
            // updatedView идёт на каждый кадр прокрутки: ничего не изменилось — выходим (фазу по прокрутке ведёт слушатель корня)
            const sig = [gaps.map(g => g.join(':')).join(','), H, cells.offsetLeft, cells.offsetTop, frozenW, y0].join('|')
            if (sig === this._planBandSig && have.length === gaps.length && have.every(e => e.parentNode === root)) { this.planStart_masks(root); return }
            this._planBandSig = sig
            const keep = new Set()
            for (const [left, width] of gaps) {
                const key = String(left)
                let el = have.find(e => e.dataset.left === key)
                if (!el) {
                    el = document.createElement('div')
                    el.className = 'plan-start-band-el ps-cap ps-cap-bottom'   // IE 2026 09 30 / ODOO-343343 (заказ Игоря: элемент Plan start одинаковый во всех формах): вид — общие классы .ps-* (App.vue)
                    el.dataset.left = key
                    el.setAttribute('aria-hidden', 'true')
                }
                el.dataset.frozen = left < frozenW - 1 ? '1' : ''
                if (el.parentNode !== root) cells.after(el)   // ровно за cells: под клоном замороженных и выделением
                const st = el.style
                const L = cells.offsetLeft + left, T = cells.offsetTop
                if (st.left !== L + 'px') st.left = L + 'px'
                if (st.top !== T + 'px') st.top = T + 'px'
                if (st.width !== width + 'px') st.width = width + 'px'
                if (st.height !== H + 'px') st.height = H + 'px'
                keep.add(el)
            }
            have.forEach(e => { if (!keep.has(e)) e.remove() })
            // Alt-объяснение по зазору тела: под полосой (pointer-events: none) ячейки зазора нет — цель под курсором сама панель cells; точка → planStart_bandTip
            if (!cells.__altTipAt) { cells.__altTipAt = (x, y) => this.planStart_bandTip(x, y); cells.setAttribute('data-alt-tip-at', '') }
            this._planBandY0 = y0
            this._planBandT = cells.offsetTop
            if (!root.__planBandScroll) { root.__planBandScroll = () => this.planStart_phase(root); root.addEventListener('scroll', root.__planBandScroll, { passive: true }) }
            this.planStart_phase(root)
            const ps = this.planStartStat(); ps.band = keep.size; ps.bandH = H
        },
        // Alt-объяснение по полосе: (x, y — координаты окна) точка внутри видимой части полосы (ниже шапки, в пределах окна прокрутки) → { content, inst, rect } с записью
        // grid.mark.breakGap / 'plan' (тот же текст, что у флажка шапки); иначе null. Зовут __altTipAt панели cells (пустой зазор) и cellTooltip (ячейка под полосой: строка-группа)
        planStart_bandTip(x, y) {
            const flex = this.flex
            const root = flex?.hostElement?.querySelector('[wj-part="root"]')
            if (!root || !this.planStartOn() || !uiHelp_enabled()) return null
            const bands = root.querySelectorAll(':scope > .plan-start-band-el')
            if (!bands.length) return null
            const rr = root.getBoundingClientRect()
            const ch = flex.hostElement.querySelector('[wj-part="ch"]') || flex.hostElement.querySelector('[wj-part="chcells"]')
            const top = Math.max(rr.top, ch ? ch.getBoundingClientRect().bottom : rr.top), bottom = rr.top + root.clientHeight
            for (const b of bands) {
                const r = b.getBoundingClientRect()
                if (x < r.left || x > r.right || y < Math.max(r.top, top) || y > Math.min(r.bottom, bottom)) continue
                const html = this.cellMarks_html([{ key: 'grid.mark.breakGap', state: 'plan' }]).replace(/^<br>/, '')
                if (!html) return null
                const st = this.planStartStat(); st.bandTips = (st.bandTips || 0) + 1
                return { content: html, inst: tooltip, rect: new wjcCore.Rect(r.left, Math.max(r.top, top), r.width, Math.min(r.bottom, bottom) - Math.max(r.top, top)) }
            }
            return null
        },
        // IE 2026 09 30 / ODOO-343343 (заказ Игоря: штриховка начала плана — одним элементом): зазор внутри замороженных колонок — маска шапки (верх капсулы) стоит на месте вместе с полосой тела (translateX по scrollLeft корня)
        planStart_masks(root) {
            const chc = root.parentElement && root.parentElement.querySelector('[wj-part="chcells"]')
            if (!chc) return
            const bands = [...root.querySelectorAll(':scope > .plan-start-band-el')]
            for (const m of chc.querySelectorAll(':scope > .break-gap-plan')) {
                const b = bands.find(e => e.dataset.left === String(Math.round(parseFloat(m.style.left))))
                const tx = b && b.dataset.frozen ? `translateX(${root.scrollLeft}px)` : ''
                if (m.style.transform !== tx) m.style.transform = tx
            }
        },
        // фаза штрихов полосы: изображение начинается на верху шапки; k — его верх в координатах полосы, приводится к (-P, 0] сдвигом на кратное периоду
        planStart_phase(root) {
            const P = 7 * Math.SQRT2
            let k = root.scrollTop + (this._planBandY0 || 0) - (this._planBandT || 0)
            if (k > 0) k -= P * Math.ceil(k / P)
            for (const el of root.querySelectorAll(':scope > .plan-start-band-el')) {
                const h = (parseFloat(el.style.height) || 0) - k + 2
                el.style.backgroundSize = `100% ${h}px`
                el.style.backgroundPosition = `0 ${k}px`
                const tx = el.dataset.frozen ? `translateX(${root.scrollLeft}px)` : ''
                if (el.style.transform !== tx) el.style.transform = tx
            }
            this.planStart_masks(root)
        },
        // IE 2026 09 30 / ODOO-343343 (заказ Игоря: начало плана штриховкой — объяснение по Alt у флажков): курсор (x, y — координаты окна) внутри маски .break-gap-plan шапки → { content, inst, rect } с записью grid.mark.breakGap / 'plan' (тот же текст,
        // что в строке «Marks» ячейки зазора в теле); иначе null. Только по Alt (сюда приходят cellTooltip и __altTipAt контейнера chcells); выключатель fe.ux.planStartMark
        planStart_headerTip(el, x, y) {
            if (!el || !this._breakPlanGaps || !this._breakPlanGaps.size || !this.planStartOn() || !uiHelp_enabled()) return null
            const ch = this.flex && this.flex.hostElement && this.flex.hostElement.querySelector('[wj-part="chcells"]')
            if (!ch) return null
            const root = ch.closest('[wj-part="ch"]') || ch.parentElement || ch   // панель шапки (курсор под ячейками шапки попадает на неё, а не на chcells)
            if (!root.contains(el)) return null
            for (const m of ch.querySelectorAll(':scope > .break-gap-plan')) {
                const r = m.getBoundingClientRect()
                if (x < r.left || x > r.right || y < r.top || y > r.bottom) continue
                const html = this.cellMarks_html([{ key: 'grid.mark.breakGap', state: 'plan' }]).replace(/^<br>/, '')
                if (!html) return null
                const st = this.planStartStat(); st.headerTips = (st.headerTips || 0) + 1
                return { content: html, inst: tooltip, rect: new wjcCore.Rect(r.left, r.top, r.width, r.height) }
            }
            return null
        },
        planStartStat() {
            const w = window
            if (!w.__planStart) w.__planStart = { cols: 0, charts: 0, refused: 0, reason: '', colIds: {}, chartIds: {} }
            return w.__planStart
        },
        breakMode(attr) {
            const v = attr && (attr.break_before || attr._breakCarry)
            if (v === true) return 'gap'
            if (!v) return ''
            const s = String(v)
            if (s === 'plan') {   // IE 2026 09 29 / ODOO-343343 (заказ Игоря: начало плана штриховкой)
                if (this.planStartOn()) return 'plan'
                const st = this.planStartStat(); st.refused++; st.reason = 'off (fe.ux.planStartMark)'
                return 'gap'
            }
            return ['gap', 'arrow', 'arrow_left', 'arrow_both', 'arrow_double'].includes(s) ? s : 'gap'
        },
        setBreakBefore(view, breakBefore = false) {
            let childBreakBefore = breakBefore;
            let isFirst = true;

            for (const field_ of view.attrs || []) {
                if (breakBefore) {
                    field_.break_before = breakBefore;   // IE 2026 09 17: вниз идёт ВАРИАНТ разрыва, не true
                    breakBefore = false;
                }
                if (field_.attrs) {
                    // IE 2026 09 17 / ODOO-…: если у узла есть СВОЯ колонка (binding), разрыв рисует
                    // она сама — вниз вариант не спускаем, иначе внутри блока встаёт второй зазор
                    // (группа «To» = колонка subject_to + вложенная country_to давала два разрыва)
                    const own_ = field_.break_before;
                    const childBreakBefore_ = field_.binding ? false : own_;
                    const res_ = this.setBreakBefore(field_, childBreakBefore_);
                    field_.break_before = field_.binding ? (own_ || res_) : res_;
                }
                if (field_.break_before && isFirst) {
                    childBreakBefore = field_.break_before;   // IE 2026 09 17: вариант разрыва группы
                }
                isFirst = false;
            }
            return childBreakBefore;
        },
        autoSizeColumns() {
            this.need_autoSizeColumns = true
            // if (this.isVisible && this.autoSizeColumnsList.length && this.need_autoSizeColumns) {
            //     if (this.autoSizeColumns_timeout) { clearTimeout(this.autoSizeColumns_timeout) }
            //     this.autoSizeColumns_timeout = window.$cg.setTimeout(this, "AttrGrid.autoSizeColumns", () => {
            //         const startTime0 = performance.now(), startCount0 = this.formatItem_count
            //         for (let col of this.autoSizeColumnsList) {
            //             const attr_col = this.attr_by_binding[col.binding],
            //             autoIncrement = this.extractAutoIncrement(attr_col.width)

            //             const startTime = performance.now(), startCount = this.formatItem_count
            //             this.flex.autoSizeColumn(col.index)
                        
            //             if (autoIncrement) {
            //                 col.width = col.renderWidth + autoIncrement
            //             }
            //             if (!this.store.hide_console) console.log(`autoSizeColumns ${col.binding}  ${this.formatItem_count - startCount} (Δ ${Math.round(performance.now() - startTime)}ms)`)
            //         }
            //         if (!this.store.hide_console) console.log(`autoSizeColumns SUM  ${this.formatItem_count - startCount0} (Δ ${Math.round(performance.now() - startTime0)}ms)`)
            //         this.need_autoSizeColumns = false
            //     }, 100)
            // }
        },
        // Текст, который пользователь РЕАЛЬНО увидит в ячейке: Link-колонки резолвятся
        // через dataMap колонки (itemsSource_by_binding у гридов-отчётов пуст, и без
        // dataMap ширина вставала по guid — ровно 36 символов), числа — через формат
        // колонки ('n0' и т.п.), иначе меряется хвост float'а (24646.728999999996).
        // null = значение осталось сырым id: в ширину не берём, пересчёт сделает
        // watch itemsSource, когда словарь приедет.
        autoSize_displayValue(value, attr_col, col, itemsSource, format) {
            // пусто — это тоже измерение ширины (строка нулевой длины): колонка,
            // заполненная в паре строк из ста, не должна занимать место под них
            if (value === null || value === undefined || value === '') return ''

            if (String(attr_col.attr_type || '').startsWith('AttrLink')) {
                let title = itemsSource?.ids?.[value]?.title
                if (!title) {
                    try { title = col?.dataMap?.getDisplayValue(value) } catch (e) { title = null }
                }
                if (title && title !== value) return String(title)
                return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(String(value))
                    ? null : String(value)
            }

            if (format) {
                try {
                    const text = wjcCore.Globalize.format(value, format)
                    if (text !== null && text !== undefined && text !== '') return String(text)
                } catch (e) { /* формат колонки не по значению — меряем сырое */ }
            }
            return String(value)
        },
        autoSizeColumn(attr_col, addIncrement = 0, col = null) {
            const isNumber = attr_col.attr_type === 'AttrNumber'
            // формат колонки на момент сборки ещё не проставлен (col.format ниже по коду) —
            // берём тот же источник, что и formatItem: настройку поля, дефолт чисел 'n0'
            const format = isNumber ? (col?.format || attr_col.format || 'n0') : (col?.format || null)
            let autoIncrement = this.extractAutoIncrement(attr_col.width),
                // числам нужен МАКСИМУМ (обрезанное число читается как другое число),
                // поэтому выборка строк больше: словарь по ним не резолвится, это дёшево
                maxRows = isNumber ? this.store.setting('fe.grid.autoWidthNumericRows', 200) : this.store.setting('fe.grid.autoWidthTextRows', 50),  // Maximum rows to process (including nested); IE 2026 09 05 / ODOO-336330
                maxLength = this.store.setting('fe.grid.autoWidthMinChars', 5),  // Default minimum length
                sizeSymbol = 8,  // Character width multiplier
                itemsSource = this.itemsSource_by_binding[attr_col.binding],
                formatted = false,  // значения посчитаны по формату колонки (разделители уже внутри)
                lengths = [];  // Store lengths of values

            // Recursive function to collect value lengths
            const collectLengths = (rows, increment = 0) => {
                if (maxRows <= 0 || !rows) return;

                for (let i = 0; i < rows.length; i++) {
                    if (maxRows <= 0) break;

                    let row = rows[i];
                    const text = this.autoSize_displayValue(
                        this.store.get_value(row, attr_col.binding), attr_col, col, itemsSource, format);

                    maxRows--; // Reduce the remaining row count

                    if (text !== null) {
                        if (format) formatted = true;
                        lengths.push(text.length + increment);
                    }

                    // Recursively process nested attributes
                    if (Array.isArray(row.attrs) && row.attrs.length) {
                        collectLengths(row.attrs, increment + addIncrement);
                    }
                }
            };

            collectLengths(this.data);

            // Заголовок тоже занимает место, но показывать его целиком не обязательно:
            // обрезанный хвост виден по наведению (headerTooltip_over). Берём 80% титула.
            const headerLength = Math.min(20,
                Math.ceil(String(attr_col._groupTitle || attr_col.title || '').length * 0.8));

            if (lengths.length === 0) {
                // колонка пуста во всех строках (частый случай в отчётах — измерение,
                // которое в этой выборке не заполнено): под заголовок не расширяем,
                // иначе пустые измерения съедают ширину у колонок с данными
                return 6 * sizeSymbol + autoIncrement; // Return default if no data
            }

            // IE 2026 09 28 / ODOO-342342 (приёмка Д5): подписи формы (AttrTabGrid, колонка attr.title) — по самой длинной подписи: подпись не режем
            // (по 80-му перцентилю колонка вставала в 105 px, и «What you will see», «Proof in numbers», «Client question» обрезались)
            // IE 2026 09 29 / ODOO-342342 (ревью ie-dm7 п.2): только форма кейса (About) — прочие AttrTabGrid (формы записей, widget-row, настройки) как на main
            if (gridText_tabGridD5(this.attr) && attr_col.binding === 'attr.title' && this.store.setting('fe.grid.tabGridLabelsFull', true) !== false) {
                const wch = gridText_labelWidthChars(lengths)
                if (wch) return Math.max(wch, headerLength) * sizeSymbol + autoIncrement
            }

            // Sort collected lengths in ascending order
            lengths.sort((a, b) => a - b);

            maxLength = lengths[lengths.length - 1];
            // Числа режем нельзя — берём максимум. Текст режем по 80-му перцентилю:
            // длинные хвосты уходят в тултип, а колонка не раздувается под них.
            if (!isNumber && (maxLength > 20 || lengths.length >= 10)) {
                // Define percentile boundaries (ignore extreme 10% on both ends)
                let lowerBound = Math.floor(lengths.length * 0.1);  // 10% index
                let upperBound = Math.floor(lengths.length * 0.8);  // 80% index

                // Get the max length within the main 70% of values
                // (0 — валидный результат: колонка пуста в 80% строк, поэтому не `||`)
                const percentile = lengths.slice(lowerBound, upperBound).pop();
                maxLength = percentile === undefined ? maxLength : percentile;
            }

            // колонка, пустая в подавляющем большинстве строк (измерение, не
            // заполненное в этой выборке): держим минимальной, не растягивая под заголовок
            const hasContent = maxLength > 0;

            // Restrict maximum length for date fields
            if (attr_col.attr_type === 'AttrDate' && maxLength > 19) {
                maxLength = 19;
            } else if ( maxLength < 10) {
                maxLength += 2
            }

            if (isNumber && !formatted) {
                maxLength = maxLength || 6;
                const separators = Math.floor((maxLength - 1) / 3);
                maxLength += separators;
            }

            if (hasContent) {
                maxLength = Math.max(maxLength, headerLength);
            }

            // Потолок: число обязано влезать целиком, текст/ссылку режем — хвост
            // читается по наведению, зато таблица остаётся обозримой по ширине.
            return Math.min(isNumber ? 60 : 30, Math.max(6, maxLength)) * sizeSymbol + autoIncrement;
        },
        extractAutoIncrement(width) {
            if (typeof width !== 'string') return 0;
            const match = width.toLowerCase().match(/auto\s*\+\s*(\d+)/);
            return match ? parseInt(match[1], 10) : 0;
        },
        // Грид, собранный ДО прихода данных (виджет открыт из меню, а не со стола),
        // получает дефолт «нет данных» — 6 символов на колонку, и таким и остаётся.
        // Один раз после первых данных пересчитываем ТОЛЬКО такие колонки; явные
        // ширины настроек и сохранённые пользователем (viewParam_attrs) не трогаем.
        autoSizeColumns_afterData() {
            if (this._autoSizedAfterData || !this.data?.length || !this.flex?.columns?.length) return
            this._autoSizedAfterData = true
            for (const col of this.flex.columns) {
                const attr_col = this.attr_by_binding?.[col.binding]
                if (!attr_col) continue
                const width = attr_col.width
                const isAuto = !width || (typeof width === 'string' && width.toLowerCase().includes('auto'))
                if (!isAuto || this.viewParam_attrs?.[col.binding]?.width) continue
                if (Math.round(col.width) !== 6 * 8 + this.extractAutoIncrement(width)) continue // уже посчитана по данным
                col.width = this.autoSizeColumn(attr_col, 0, col)
            }
        },
        // Защита от граблей: кнопки разворота дерева рисуются в ПЕРВОЙ видимой
        // колонке с отступом treeIndent×level. Если колонка уже, чем нужно самому
        // глубокому уровню с детьми, кнопка вылезает за её край и накрывается
        // соседней merged-ячейкой: треугольник ВИДЕН (просвечивает), но клик
        // достаётся соседке — узел невозможно развернуть (кейс «in country»,
        // R1o_001, 2026-08-03). Поднимаем ширину до минимума по фактической
        // глубине дерева; только увеличиваем, широкие колонки не трогаем.
        // IE 2026 10 08 / ODOO-5800 (Игорь: «Конвеєр руху» — после Save «Rule type» снова 54): страж поднимал ширину после КАЖДОЙ
        // пересборки, а мышью колонку можно было сузить ниже минимума дерева — сохранялось 25, после Save снова 54. Минимум дерева
        // теперь ещё и minWidth колонки: wijmo не даёт утянуть её уже, resizedColumn запоминает видимую ширину (gridColWidth_visible) —
        // что видно, то и сохранено и вернётся. Прежний minWidth колонки — в _treeMinBase, возвращается, когда колонка
        // перестала быть первой видимой или дерево стало мельче / пропало.
        ensureTreeColMinWidth() {
            if (!this.flex) return
            for (const c of this.flex.columns) {   // IE 2026 10 08 / ODOO-5800
                if (c._treeMinBase !== undefined) { c.minWidth = c._treeMinBase; delete c._treeMinBase }
            }
            if (!this.flex.childItemsPath) return
            let maxLevel = 0
            for (const row of this.flex.rows) {
                if (row.hasChildren && row.level > maxLevel) maxLevel = row.level
            }
            if (!maxLevel) return
            const col = this.flex.columns.find(c => c.visible !== false)
            if (!col) return
            // кнопка ~20px + зазор; treeIndent — отступ одного уровня
            const need = gridTreeCol_need(this.flex.treeIndent, maxLevel)   // IE 2026 10 08 / ODOO-5800: та же формула, utils/gridColWidth.js
            if (col.renderWidth < need && (typeof col.width !== 'number' || col.width < need)) {
                col.width = need
            }
            // IE 2026 10 08 / ODOO-5800: minWidth — ПОСЛЕ подъёма ширины: иначе renderWidth уже прижат к need, сырая ширина остаётся
            // дефолтом «нет данных» (48) и autoSizeColumns_afterData перемеряет колонку по данным (прогон dist1: Rule type 120 вместо 54)
            if (!(col.minWidth >= need)) { col._treeMinBase = col.minWidth; col.minWidth = need }
        },
        set_itemsSource() {
            this.flex.beginUpdate();
            // IE 2026 08 18 / ODOO-5512 (заказ Игоря): пустой отчёт (расшифровка пустой
            // ячейки) — явная надпись «No data» вместо голой шапки; ставим по факту
            // прихода данных, а не при создании грида (иначе мигает во время загрузки)
            if (this.attr.name === 'dataSheet' && this.WIDGET?.record?.segment === 'WIDGET-REPORT2') {
                try { this.flex.noDataOverlayContent = (Array.isArray(this.data) && this.data.length) ? '' : t('No data') } catch (e) { /* старый wijmo */ }   // IE 2026 09 23 / ODOO-341407: i18n
            }
            let groupDescriptions = this.$refs.chips?.getChipGroup()||[],
            sortDescriptions = this.$refs.chips?.getChipOrder()||[],
            treeBindings = this.$refs.chips?.getChipTree()||[]

            if (!this.parentDataItem) {
                this.data000 = this.data
            } else {
                this.data000 = this.parentDataItem.attrs = this.parentDataItem.attrs || []
            }

            // CHIP-Tree (Hierarchy): бэк отдаёт плоский список, дерево по parent-полю собирает фронт.
            // data000 остаётся плоским (агрегаты/поиск/iroot работают по нему), в CollectionView идут корни
            let itemsSource_data = this.data000
            this.applied_chipTree = treeBindings
            if (treeBindings.length && (!this.attr.childItemsPath || this.attr.childItemsPath === '_childs')) {
                itemsSource_data = this.build_treeByParent(this.data000, treeBindings[0], this.$refs.chips?.getChipOrder(true) || [])
                this.attr.childItemsPath = '_childs' // runtime-only: включает штатную tree-механику грида (отступы, collapse)
                groupDescriptions = [] // wijmo не совмещает childItemsPath с группировкой
            } else if (this.attr.childItemsPath === '_childs') {
                this.attr.childItemsPath = ''
                this.flex.childItemsPath = ''
                for (const row of this.data000) delete row._childs
            }

            this.assignHierarchicalNumbers(this.data)

            this.ignore_selectionChanged = true

            const collapsedState = new Map();
            const collapsedItems = new Set(); // tree-строки (childItemsPath): состояние переживает пересборку по dataItem
            const old_lenght = this.flex.rows.length
            let have_isCollapsed = false
            this.flex.rows.forEach((row, index) => {
                if (row instanceof wjGrid.GroupRow) {
                    collapsedState.set(index, row.isCollapsed);
                    if (row.isCollapsed && !have_isCollapsed) {
                        have_isCollapsed = true
                    }
                } else if (row.hasChildren && row.isCollapsed && row.dataItem) {
                    collapsedItems.add(row.dataItem)
                }
            });

            // IE 2026 10 17 / ODOO-5800 (Igor 17.10: группы M03 схлопываются через ~2 с после первого кадра): свёртка дерева ПО КЛЮЧУ строки раскладки
            // (_DLRow.row_id / name / where) — ветки ниже хранят её по индексам (GroupRow) и по ссылке на dataItem; пришедшие с select новые
            // строки в другом числе теряли раскрытое пользователем и получали дефолт DL. Снимок — до замены источника, возврат — после дефолтов
            const _foldSnap = (this.attr.childItemsPath && this.foldKeep_on()) ? foldState_snapshot(this.flex.rows) : null
            this.groupHeader_apply()   // IE 2026 11 02 / ODOO-349799 (group-header-value): формат заголовка группы — до нового CollectionView (первая отрисовка уже в нужном виде)
            this.flex.itemsSource = new wjcCore.CollectionView(itemsSource_data, {
                sortDescriptions: sortDescriptions,
                groupDescriptions: groupDescriptions,
                // groupIndex: -1
            })
            // IE 2026 11 02 / ODOO-349799 (sort-nulls): wijmo рождает CollectionView с sortNulls = Last — пустые ячейки числовой колонки шли ПОСЛЕ чисел
            // и по возрастанию (Игорь, «Конфігурація», чипс «Кількість»). Comparer (utils/gridSortNulls.js) ставит пусто < любое число, включая 0,
            // направление накладывает wijmo; строковые пары — штатный порядок. Выключатель fe.ux.gridSortNullsFirst (по умолчанию ВКЛ)
            if (gridSortNulls_on(this.store)) this.flex.itemsSource.sortComparer = sortNulls_compare
            // numericSort: значения мер нередко приезжают строками ("9970.5") —
            // штатный компаратор сортирует их лексикографически ("999" выше "9975",
            // кейс DOS у FADO). Строку, которая целиком число, сравниваем числом.
            // АН 2026 08 08: конвертер ставим всегда — титул ссылки приезжает
            // отдельным полем <binding>_title (BE 9dac7368, серверный порядок
            // уровней): CollectionView пересортирует КОРНИ дерева сам (syncChip),
            // и без титула корни разъезжались бы с уровнями hierSort_comparator
            const _sortDataMaps = new Map() // sd.property -> dataMap|null (см. ниже)
            this.flex.itemsSource.sortConverter = (sd, item, value) => {
                // IE 2026 10 04 / ODOO-5800 (fe-71): строка показывает в колонке текст `<binding>-title` — сортировка по показанному (он главнее `_title` и dataMap)
                { const _shown = shownTitle_sortValue(item, sd.property); if (_shown !== undefined && this.shownTitle_on()) return _shown }
                const title = item?.[`${sd.property}_title`]   // АН 2026 08 08
                if (title !== null && title !== undefined && title !== '') return title
                // ODOO-5102: колонка-ССЫЛКА сортируется по ВИДИМОМУ титулу, а не по id.
                // Поле <binding>_title приезжает не всегда (его отдаёт бэкенд для
                // порядка уровней отчёта); в списках по витрине его нет, в строке
                // лежит голый uuid — и клик по шапке упорядочивал по uuid, то есть
                // «сортировка не срабатывает» с точки зрения пользователя.
                // Титул в этом случае знает dataMap колонки (тот же источник, из
                // которого ячейка рисует текст) — берём его. Тот же приоритет, что
                // в hierSort_comparator: поле строки → dataMap → сырое значение.
                if (value !== null && value !== undefined && value !== '') {
                    if (!_sortDataMaps.has(sd.property)) {
                        const col = this.flex.columns.getColumn(sd.property)
                        _sortDataMaps.set(sd.property, col?.dataMap || null)
                    }
                    const dataMap = _sortDataMaps.get(sd.property)
                    if (dataMap) {
                        const mapped = dataMap.getDisplayValue(value)
                        if (mapped !== null && mapped !== undefined && mapped !== '') return mapped
                    }
                }
                if (this.store.fastEntry?.numericSort !== false
                        && typeof value === 'string' && value.trim() !== '') {
                    const n = Number(value)
                    if (!Number.isNaN(n)) return n
                }
                return value
            }

            this.hierSort_restore()

            if (this.aggAll_isSummary()) {
                // сводная таблица: тумблер "All" отжат — только строки
                // основного источника (данные агрегата не трогаем —
                // write-back работает по полному массиву)
                this.flex.itemsSource.filter = (row) => this.aggAll_showAll || !this.aggAll_isExtraRow(row)
            }

            if (this.attr.childItemsPath && collapsedItems.size) {
                this.flex.deferUpdate(() => {
                    for (let row of this.flex.rows) {
                        if (row.hasChildren && collapsedItems.has(row.dataItem) && !row.isCollapsed) {
                            row.isCollapsed = true
                        }
                    }
                })
            }
            
            this.flex.itemsSource.refreshOnEdit = false; // иначе будет дергаться полле rowEditEnding()
            // this.flex.itemsSource.filter = (dataItem) => { return !dataItem?._fe?.visible}

            if (old_lenght === this.flex.rows.length) {
                this.flex.deferUpdate(() => {
                    if (have_isCollapsed) this.flex.collapseGroupsToLevel(0)
                    for (const [index, saved] of collapsedState) {
                        const row = this.flex.rows[index];
                        // если индексы могли поменяться, защититесь лишней проверкой:
                        const isGroup = (this.attr.childItemsPath && row.dataItem?.attrs?.length) || (!this.attr.childItemsPath && row instanceof wjGrid.GroupRow)
                        if (!row || !isGroup) {
                            continue;
                        }
                        if (row.isCollapsed !== saved) {
                            row.isCollapsed = saved
                        }
                    }
                });
            } else if (this.attr.childItemsPath) {
                const _foldRowsN = this.foldDefault_level('fold_rows_level')
                this.flex.deferUpdate(() => {
                    if (_foldRowsN) {
                        // дефолтная свёртка строк из параметров отчёта — приоритетнее DL
                        this.flex.collapseGroupsToLevel(_foldRowsN - 1)
                        return
                    }
                    for (let row of this.flex.rows) {
                        if (row.hasChildren && (row.dataItem?._DLRow?.isCollapsed || row.dataItem?.measure?.isCollapsed || this.get_measure_(row.dataItem)?.isCollapsed)) {
                            row.isCollapsed = true
                        }
                    }
                })
            }
            if (_foldSnap && _foldSnap.size && this.attr.childItemsPath) {   // IE 2026 10 17 / ODOO-5800: что пользователь раскрыл / свернул — остаётся и после новых строк
                this.flex.deferUpdate(() => { foldState_restore(this.flex.rows, _foldSnap) })
            }
   
            this.ignore_selectionChanged = false

            if (this.filter) {
                this.filter.showSortButtons = false
                if (!this.$refs.chips?.compareGridFilter(this, this.filter)) {
                    // this.$nextTick(() => {
                        this.filter.filterDefinition = this.$refs.chips?.getChipGridFilter()
                    // });
                }
            }
            
            if (groupDescriptions.length) {
                // for (let binding of groupDescriptions) {
                //     let col = this.column_by_binding[binding]
                //     if (col) {
                //         col.visible = false
                //     }
                // }
                
                // // let gd = this.flex.collectionView.groupDescriptions;
                // //  // remove group
                // // for (let i = 0; i < gd.length; i++) {
                // //     if (gd[i].propertyName === col.binding) {
                // //         gd.removeAt(i);
                // //         return; // we're done
                // //     }
                // // }
                // // // add group
                // // gd.push(new PropertyGroupDescription(col.binding));
            } else if (this.attr.childItemsPath) {
                this.flex.childItemsPath = this.attr.childItemsPath
            }
            if (this.attr['collapseGroupsToLevel']) {
                this.flex.collapseGroupsToLevel(this.attr.collapseGroupsToLevel - 1)
            }

            this.flex.itemsSource.collectionChanged.addHandler((s, e) => {
                const _asT0 = this._gridPerfCur ? performance.now() : 0 // IE 2026 09 04 / ODOO-336379: замер autoSizeRows после вставки
                this.autoSizeRows()
                this.editKeep_onCommit(e)   // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL3: commit строки правки — вторая перерисовка точечно
                if (_asT0) this.gridPerf_touch('autosize', performance.now() - _asT0)
                if (this.isPasting) {
                    this.isPasting = false
                    this.apply_CHIPS(null, {fast:true}) // need for correct re-hiding rows, after pasting on hiding rows 2025-09-09
                }
            });

            this.autoSizeColumns_afterData()
            this.rhCol_autoSize()   // IE 2026 09 17 (замечание Игоря): автоширина колонок-групп шапки строк по пришедшим данным
            this.ensureTreeColMinWidth()

            this.flex.endUpdate();
            if (this.flex.rows.length && this.selectedRanges_BEFORE && this.selectedRanges_BEFORE[0].row !== -1 && JSON.stringify(this.flex.selectedRanges) !== JSON.stringify(this.selectedRanges_BEFORE)) {
                this._selRestorePending = (this._selRestorePending || 0) + 1   // IE 2026 09 27 / ODOO-5800 (сброс выделения при доливе словаря): возврат ждёт nextTick — selKeep_snap не перезаписывает снимок сброшенным выделением
                this.$nextTick(() => {
                    this._selRestorePending = Math.max(0, (this._selRestorePending || 0) - 1)   // IE 2026 09 27 / ODOO-5800 (сброс выделения при доливе словаря)
                    if (!this.flex?.hostElement) return // грид уже disposed (nextTick пережил unmount)
                    // preserve scroll: restoring an off-screen selection makes Wijmo scroll it into view
                    const _sp = this.flex.scrollPosition
                    const _spx = _sp.x, _spy = _sp.y
                    this.selRestore_apply() // ! is HARD operation // IE 2026 09 26 / ODOO-5800: возврат прежнего выделения — не выбор пользователя (чипс периода)
                    this.flex.scrollPosition = new wjcCore.Point(_spx, _spy)
                })
            }
   
            this.flex.itemsSource.refresh() // need for correct sorting in col with dataMap 2025-09-09
            this.flex_check_isReadOnly()
            this.tabGrid_wrapMulti(true)   // IE 2026 09 28 / ODOO-342342 (приёмка Д5): многострочный текст формы — по словам, строка по высоте текста
            // АН 2026 08 08: подвал итогов — после построения колонок (aggregate у
            // колонок назначается выше по ходу set_itemsSource; ранний вызов при
            // инициализации оставлял Σ и агрегаты пустыми после переоткрытия)
            this.aggregateFooters()
            // визуальное применение свёртки групп — строго ПОСЛЕ endUpdate:
            // внутри цикла обновления сеттер isCollapsed не доходит до рендера
            // (из-за этого месяц оставался раскрытым), а здесь тот же JS-проход,
            // браузер рисует уже готовый вид — без промежуточного кадра
            this.foldDefault_reapplyLive(this.flex)
        },
        build_treeByParent(data, parentBinding, sortPairs=[]) {
            // CHIP-Tree (Hierarchy): собирает плоский список в дерево по parent-полю.
            // parent ссылается на id (или name) строки-родителя; дети складываются в row._childs
            // (runtime-поле, при обновлении данных с бэка вычищается updateDoc_ifChanged).
            // Сироты (родитель не в выборке) и циклы становятся корнями — строки не теряются.
            const resolve = (row, binding) => {
                let val = binding.split('.').reduce((o, k) => (o == null ? o : o[k]), row)
                if (val && typeof val === 'object') val = val.value ?? val.id ?? val.name
                return (val === undefined || val === null || val === '') ? null : String(val)
            }

            const row_byKey = new Map()
            for (const row of data) {
                delete row._childs // от прошлой сборки
                const key = row.id ?? row.name
                if (key !== undefined && key !== null && key !== '') row_byKey.set(String(key), row)
            }

            const parentRow_of = new Map()
            for (const row of data) {
                const p = resolve(row, parentBinding)
                const parentRow = p === null ? null : row_byKey.get(p)
                parentRow_of.set(row, (parentRow && parentRow !== row) ? parentRow : null)
            }

            const roots = []
            for (const row of data) {
                // защита от циклов: встретили повтор в цепочке предков — строка становится корнем
                const seen = new Set([row])
                let ancestor = parentRow_of.get(row)
                while (ancestor && !seen.has(ancestor)) {
                    seen.add(ancestor)
                    ancestor = parentRow_of.get(ancestor)
                }
                const parentRow = ancestor ? null : parentRow_of.get(row)
                if (parentRow) {
                    (parentRow._childs = parentRow._childs || []).push(row)
                } else {
                    roots.push(row)
                }
            }

            if (sortPairs.length) {
                // CollectionView сортирует только корни — детей сортируем сами тем же CHIP-Order
                const get = (row, binding) => {
                    let val = binding.split('.').reduce((o, k) => (o == null ? o : o[k]), row)
                    if (val && typeof val === 'object') val = val.valueStr ?? val.value
                    return val
                }
                const cmp = (a, b) => {
                    for (const [binding, direction] of sortPairs) {
                        const va = get(a, binding), vb = get(b, binding)
                        let r
                        if (va == null && vb == null) r = 0
                        else if (va == null) r = -1
                        else if (vb == null) r = 1
                        else if (typeof va === 'number' && typeof vb === 'number') r = va - vb
                        else r = String(va).localeCompare(String(vb), undefined, {numeric: true})
                        if (r) return direction === 'DESC' ? -r : r
                    }
                    return 0
                }
                const sortDeep = rows => {
                    rows.sort(cmp)
                    for (const row of rows) {
                        if (row._childs) sortDeep(row._childs)
                    }
                }
                sortDeep(roots)
            }

            return roots
        },
        assignHierarchicalNumbers(data) {
            const vueObj = this
            let globalCounter = 1
            this.number_length = 0

            function traverse(rows, prefix = '') {
                rows.forEach((row, index) => {
                    const groupNumber = `${prefix}${index + 1}`;
                    row._meta = row._meta || {}
                    row._meta.number = groupNumber // `${groupNumber}-${globalCounter}`;
                    row._meta.prefix = prefix
                    row._meta.number0 = index + 1

                    vueObj.number_length = Math.max(vueObj.number_length||0, groupNumber.length)
                    
                    globalCounter++

                    if (row.attrs && Array.isArray(row.attrs)) {
                        traverse(row.attrs, `${groupNumber}-`);
                    }
                });
            }

            // traverse(data);
        },
        isHidden(attr_col) {
            return attr_col.use === false || attr_col.hidden === true
                || (attr_col['v-if'] && !this.eval_column_vIf(attr_col))
                || !this.store.checkAccess(attr_col)
        },
        eval_column_vIf(attr_col) {
            // 'v-if' колонки — выражение в контексте полей конфиг-узла грида.
            // 'agg_sources' — не сырое поле узла, а состояние сводного грида:
            // truthy только при нажатом тумблере "All" (отжат — виден один
            // источник, колонки Stored in не нужны; на гридах-источниках
            // agg_sources нет вовсе)
            const ctx = { attr: this.attr, attr_col }
            for (const k in this.attr) {
                if (!(k in ctx) && /^[A-Za-z_$][A-Za-z0-9_$]*$/.test(k)) {
                    ctx[k] = this.attr[k]
                }
            }
            ctx.agg_sources = (this.aggAll_isSummary() && this.aggAll_showAll) ? this.attr.agg_sources : null
            return this.store.eval_value(this.WIDGET, attr_col['v-if'], ctx)
        },
        // IE 2026 08 30 / ODOO-5800 (репорт Игоря: «при прокрутке снова появляются 0»):
        // в колонке с hideZero ноль рисует сам wijmo (по binding и формату) ДО formatItem,
        // а formatItem на переиспользованной ячейке выходит рано (isFormated / frozenSkip /
        // вне видимого диапазона) и до места очистки не доходит. Поэтому чистим здесь —
        // в самом начале, по тексту ячейки, независимо от того, каким путём пойдёт дальше.
        hideZero_apply(panel, row, col, cell) {
            try {
                if (!cell || !panel || !panel.columns) return
                const binding = panel.columns[col]?.binding
                if (!binding) return
                const attr_col = this.attr_by_binding?.[binding]
                if (!attr_col?.hideZero) return
                if (cell.querySelector('input, textarea')) return
                const t = (cell.textContent || '').trim()
                if (t === '0' || t === '0,0' || t === '0.0' || t === '0,00' || t === '0.00') {
                    cell.textContent = ''
                }
            } catch (e) { /* косметика: не мешаем отрисовке */ }
        },
        fill_collapseTo(attrs) {
            let collapseTo0
            for (let attr_col of attrs) {
                if (!this.isHidden(attr_col)) {
                    // collapseTo может прийти от BE (свернуть группу в свою колонку-итог).
                    // Запоминаем его один раз — ДО перезаписи ниже, т.к. attrs мутируются на месте
                    // и авто-вычисленное значение иначе не отличить от пришедшего с бэка.
                    if (!('collapseTo_be' in attr_col)) {
                        attr_col.collapseTo_be = attr_col.collapseTo ?? null
                    }

                    delete attr_col.collapseTo

                    if (attr_col.collapseTo_be != null) {
                        attr_col.collapseTo = attr_col.collapseTo_be     // приоритет BE
                    } else if (attr_col.binding) {
                        if (attr_col.attr_type === 'AttrMulti') {
                            attr_col.collapseTo = `${attr_col.binding}.valueStr`
                        } else {
                            attr_col.collapseTo = attr_col.binding
                        }
                    }

                    if (!collapseTo0 && attr_col.binding) {
                        if (attr_col.attr_type === 'AttrMulti') {
                            collapseTo0 = `${attr_col.binding}.valueStr`
                        } else {
                            collapseTo0 = attr_col.binding
                        }
                    }

                    if (attr_col[this.attr.column_childItemsPath]) {
                        const collapseTo = this.fill_collapseTo(attr_col[this.attr.column_childItemsPath])
                        if (collapseTo) {
                            if (!attr_col.collapseTo) {
                                attr_col.collapseTo = collapseTo
                            }
                            if (!collapseTo0) {
                                collapseTo0 = collapseTo
                            }
                        }
                    }
                }
            }
            return collapseTo0
        },
        // Схлопывание слоя «↩»: группа без собственного binding, у которой остался
        // ЕДИНСТВЕННЫЙ видимый подчинённый с титулом '↩' (или пустым) и без своих
        // детей, рендерится одной колонкой — титул группы, binding ребёнка
        // (кейс: скрытый Offset — месяц с одним '↩'). Преобразование выполняется
        // НАД исходными attrs ДО обоих проходов (scan_columnGroups_fromAttrs и
        // scan_column_fromAttrs): правка только первого прохода ломает второй
        // (bindingColumnGroup undefined). Структура view не мутируется: новые
        // массивы вешаются на группу полем _kidsCollapsed, подмена читается
        // обоими проходами; _groupTitle — титул для шапки схлопнутой колонки.
        collapse_arrowLayer_attrs(attrs, childItemsPath) {
            const out = []
            for (const attr_col of attrs || []) {
                if (!attr_col || typeof attr_col !== 'object') { out.push(attr_col); continue }
                const kids = attr_col.attr_type !== 'AttrGrid' && attr_col[childItemsPath]?.length
                    ? attr_col[childItemsPath] : null
                if (kids && !this.isHidden(attr_col)) {
                    const kidsCollapsed = this.collapse_arrowLayer_attrs(kids, childItemsPath)
                    const visible = kidsCollapsed.filter(k => !this.isHidden(k))
                    const only = visible.length === 1 ? visible[0] : null
                    const t = only ? String(only.title || '').trim() : null
                    if (!attr_col.binding && only && (t === '↩' || t === '')
                            && !(only[childItemsPath]?.length) && !only._kidsCollapsed) {
                        only._groupTitle = attr_col.title
                        // ODOO-4113: группа (месяц) выбрасывается из дерева колонок,
                        // а date/date_next живут на ней — сохраняем ссылку, чтобы
                        // scan_column_fromAttrs восстановил родительскую цепочку
                        // (иначе после 014bfe5f мертвы связка выделения грид↔чарт
                        // и тултип Period).
                        // enumerable:false обязателен: ссылка циклическая (группа
                        // содержит лист), enumerable-вариант ронял JSON.stringify
                        // запроса расшифровки ячейки (ODOO-4263) — запрос не уходил.
                        Object.defineProperty(only, '_collapsedGroup', {
                            value: attr_col, configurable: true, writable: true, enumerable: false,
                        })
                        out.push(only)
                        continue
                    }
                    attr_col._kidsCollapsed = kidsCollapsed
                } else {
                    delete attr_col._kidsCollapsed
                }
                delete attr_col._groupTitle
                delete attr_col._collapsedGroup
                out.push(attr_col)
            }
            return out
        },
        scan_columnGroups_fromAttrs(attrs, childItemsPath, parent_col=null, path='', pathLoc='') {   // IE 2026 09 25 / ODOO-341407: + pathLoc — путь по показанным заголовкам (ключ свёртки прежнего формата)
            let columnGroups = []

            for (let attr_col of attrs) {
                if (!this.isHidden(attr_col)) {
                    if (attr_col.binding === 'selector' || attr_col.binding === 'use' || this.rhPos_is(attr_col)) {   // IE 2026 09 26 / ODOO-… (заказ Игоря: doc.use в заголовках строк): и positionNew
                        this.attr.binding_forSelectorHotkeys = attr_col.binding
                        continue
                    }

                    // Раскрутка AttrTab с noGroup — влить дочерние колонки без группировки
                    if (attr_col.attr_type === 'AttrTab' && attr_col.noGroup && attr_col[childItemsPath]?.length) {
                        const children = this.scan_columnGroups_fromAttrs(attr_col._kidsCollapsed || attr_col[childItemsPath], childItemsPath, parent_col, path, pathLoc)   // IE 2026 09 25 / ODOO-341407: + pathLoc
                        columnGroups.push(...children)
                        continue
                    }

                    let col = {}
                    // if (attr_col.level) {
                    //     col.level = attr_col.level
                    // }
                    // IE 2026 09 24 / ODOO-341407: ссылка на attr_col для переподписи шапки при смене языка без reload (i18n_relabelColumns);
                    // не enumerable — wijmo копирует enumerable поля описания, а ссылка циклическая (JSON.stringify описаний)
                    Object.defineProperty(col, '_attr_col', { value: attr_col, enumerable: false, configurable: true, writable: true })
                    col.name = attr_col._groupTitle || attr_col.title
                    col.header = attr_col._groupTitle || attr_col.title
                    if (attr_col.binding) {
                        if (attr_col.attr_type === 'AttrMulti') {
                            col.binding = `${attr_col.binding}.valueStr`
                        } else {
                            col.binding = attr_col.binding
                        }
                    } else {
                        col.binding = `n${this.icol++}`
                    }
                    attr_col.binding0 = col.binding
                    // стабильный путь группы по заголовкам — ключ сохранения свёрнутости
                    // (binding у групп генерённый n<i> и пересборку не переживает)
                    // IE 2026 09 25 / ODOO-341407 (замечание пользователей через Игоря: после живого переключения языка «в отчёте не показываются прошлые
                    // периоды»; воспроизведено на dev02 — Sales$ R1oU_001: раскрыл «3 кв. 2026» → переключил язык → месяцы снова свёрнуты): заголовки групп
                    // (YTD / YTG / Total, «Q3 2026», месяцы) бэк переводит под язык запроса, и путь по ПОКАЗАННЫМ заголовкам на другом языке другой —
                    // перезапрос отчёта после переключения пересобирает колонки, ручная свёртка / раскрытие не находится, группы встают в умолчание
                    // (fold_cols_level). Путь — по БАЗОВЫМ заголовкам (бэкап {title}_en, который бэк и relocalize ставят переведённому узлу), одинаков на
                    // всех языках; ключ прежнего формата (по показанным заголовкам) читается запасным. Выкл: window.i18nSwitch.set('foldKeysBase', false)
                    col._foldPathLoc = (pathLoc ? pathLoc + '/' : '') + String(col.name ?? col.binding ?? '')
                    col._foldPath = this.foldKeys_base() ? (path ? path + '/' : '') + String(this.foldTitle_base(attr_col) ?? col.name ?? col.binding ?? '') : col._foldPathLoc
                    // IE 2026 09 10 / ODOO-5800 (заказ Игоря): длительности (AttrDays/AttrTime) без явного Align —
                    // вправо, как числа и Offset отчёта; пустая строка align у wijmo отключала выравнивание по типу
                    col.align = attr_col.align || ((attr_col.attr_type === 'AttrDays' || attr_col.attr_type === 'AttrTime') ? 'right' : attr_col.align)
                    if (attr_col.collapseTo) {
                        col.collapseTo = attr_col.collapseTo
                    }

                    const isCollapsed0 = this.foldMem_get(attr_col.binding)   // IE 2026 09 17: формы — сеансовая память, не viewParams
                    if (isCollapsed0 !== undefined) {
                        if (col.collapseTo === col.binding && parent_col !== null) {
                            parent_col.isCollapsed = isCollapsed0
                            parent_col._userCollapsed = true // ручное — параметр не трогает
                        } else {
                            col.isCollapsed = isCollapsed0
                            col._userCollapsed = true
                        }
                    } else if (attr_col.isCollapsed) {
                        col.isCollapsed = attr_col.isCollapsed
                    }
                    if (attr_col[childItemsPath]?.length && attr_col?.attr_type !== 'AttrGrid') {
                        let col2
                        if (attr_col.binding) { //2025 02
                            // ++columns.group
                            col2 = {
                                ...col,
                                header: '↑',
                            }
                        }
                        col['columns'] = this.scan_columnGroups_fromAttrs(attr_col._kidsCollapsed || attr_col[childItemsPath], childItemsPath, col, col._foldPath, col._foldPathLoc)   // IE 2026 09 25 / ODOO-341407: + путь прежнего формата
                        if (col2) {
                            col['columns'].unshift(col2)
                        }
                        // восстановление свёрнутости ГРУППЫ по стабильному пути:
                        // ручное состояние переживает пересборку одинаковой структуры
                        let manual0 = this.foldMem_get(`fold::${col._foldPath}`)   // IE 2026 09 17: формы — сеансовая память
                        if (manual0 === undefined && col._foldPathLoc !== col._foldPath) manual0 = this.foldMem_get(`fold::${col._foldPathLoc}`)   // IE 2026 09 25 / ODOO-341407: ключ прежнего формата (по показанным заголовкам)
                        if (manual0 !== undefined) {
                            col.isCollapsed = manual0
                            col._userCollapsed = true
                        }
                        // if (col['columns'][0]) {
                        //     attr_col[childItemsPath][0].cssClass = 'group-col-level-0-start'
                        //     attr_col[childItemsPath][attr_col[childItemsPath].length - 1].cssClass = 'group-col-level-0-end'
                        //     // col.collapseTo = col['columns'][0].binding
                        // }
                    }

                    columnGroups.push(col)
                }
            }

            return columnGroups
        },
        scan_column_fromAttrs(attrs, childItemsPath, parentAttr) {
            if (this.attr.hide_columnHeaders) {
                this.flex.columnHeaders.rows.length = 0
            } else if (this.attr.hideHeadersTitle && this.flex.columnHeaders.rows.length) {
                this.flex.columnHeaders.rows[0].visible = false
            }

            
            for (let attr_col of attrs) {
                attr_col.idAttr = ++this.idAttr_max
                attr_col.style = this.store.normalizeStyle(attr_col?.style)
                if (!this.isHidden(attr_col)) {
                    // CSS-CLASS: неизвестные ссылки классов поля — в очередь одного батча get_cssClasses
                    this.store.queue_cssClasses_fromAttr(attr_col)
                    if (attr_col.attr_type === 'AttrTab' && attr_col.noGroup) {
                        if (attr_col[childItemsPath]?.length && attr_col?.attr_type !== 'AttrGrid') {
                            this.scan_column_fromAttrs(attr_col._kidsCollapsed || attr_col[childItemsPath], childItemsPath, parentAttr)
                        }
                        this.attr_by_binding[attr_col.binding] = attr_col
                        continue
                    }

                    if (attr_col.binding === 'selector' || attr_col.binding === 'use' || this.rhPos_is(attr_col)) {   // IE 2026 09 26 / ODOO-… (заказ Игоря: doc.use в заголовках строк): и positionNew
                        this.attr_by_binding[attr_col.binding] = attr_col
                        continue
                    }
                        
                    let col = null
                    if (childItemsPath) {
                        col = this.column_by_binding0[attr_col.binding0]
                        if (!col) {
                            let columnGroup = this.columnGroups_by_binding0[attr_col.binding0],
                                bindingColumnGroup = columnGroup.bindingColumnGroup
                            col = columnGroup.col
                            this.attr_by_bindingColumnGroup[bindingColumnGroup] = attr_col
                            attr_col.is_columnGroup = true
                            // continue
                            // if (!this.store.hide_console) console.log('!!!Error')
                        }
                    } else {
                        col = new wjGrid.Column()
                        col.name = attr_col.title
                    }
                    if (col.header !== '↑') {
                        col.header = attr_col._groupTitle || attr_col.title
                    }
                    col.align = attr_col.align || ((attr_col.attr_type === 'AttrDays' || attr_col.attr_type === 'AttrTime') ? 'right' : attr_col.align)   // IE 2026 09 10 / ODOO-5800: длительности вправо
                    if (!attr_col.is_columnGroup) {
                        col.binding = attr_col.binding
                        // col.cssClass = attr_col.cssClass
                        let width = null
                        if (typeof attr_col.width === 'number') {
                            width = attr_col.width || null
                        } else if (typeof attr_col.width === 'string') {
                            if (isNaN(Number(attr_col.width))) {
                                width = attr_col.width || null
                            } else {
                                width = Number(attr_col.width) || null
                            }
                        }
                        const width0 = this.viewParam_attrs?.[attr_col.binding]?.width
                        if (width0) {
                            col.width = width0
                        } else if (typeof width === 'string' && width.toLowerCase().includes('auto')) {
                            col.width = this.autoSizeColumn(attr_col, this.flex.columns.length? 0 : 5, col)
                            // this.autoSizeColumnsList.push(col)
                            //     // autoSizeColumn
                            //     col.quickAutoSize = true
                            //     col.autoSizeMode = 2 // AutoSizeMode.Cells
                        } else if (width) {
                            col.width = width
                        } else {
                            col.width = this.autoSizeColumn(attr_col, this.flex.columns.length? 0 : 5, col)
                            // this.autoSizeColumnsList.push(col)
                        }
                        col.minWidth = attr_col.minWidth || 25
                        if (typeof attr_col.width === 'string' && attr_col.width.includes('*') && !attr_col.minWidth) {
                            col.minWidth = 60
                        }
                        if (attr_col.wordWrap) {
                            col.wordWrap = attr_col.wordWrap
                        }
                        // col.wordWrap = true
                        // this.flex.autoRowHeights = true

                        col.isReadOnly = attr_col.isReadOnly
                        col.visible = true // (!('visible' in attr_col) || attr_col.visible)
                        col.allowMerging = attr_col.allowMerging||false
                        
                        col.type = attr_col.attr_type
                        if (attr_col.attr_type === 'AttrLin-2025') {
                            if (!col.minWidth) {
                                col.minWidth = 60
                            }
                            this.itemsSource_by_binding[col.binding] = this.store.get_itemsSource(this, {}, attr_col, { fetchMode: 'all' })
                        } else if (attr_col.attr_type === 'AttrLink-2025') {
                            if (!col.minWidth) {
                                col.minWidth = 60
                            }
                            this.itemsSource_by_binding[col.binding] = this.store.get_itemsSource(this, {}, attr_col, { fetchMode: 'all' })
                        } else if (attr_col.attr_type === RL_TYPE && this.rl_on()) {   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: AttrRowLink — ссылка на строку табличной части той же записи)
                            this.rl_col(attr_col, col)   // IE 2026 10 25 / ODOO-348925
                        } else if (attr_col.attr_type === 'AttrLink' || attr_col.attr_type === 'AttrLinkChips') {
                            // AttrLinkChips = AttrLink по данным/редактированию, отличается
                            // только отрисовкой (чипс-пилюля, см. formatItem-блок STATUS).
                            if (!col.minWidth) {
                                col.minWidth = 60
                            }

                            col.dataMapEditor = 'AutoComplete'
                            col.isRequired = false

                            // col.editor = new AutoComplete(document.createElement('div'), {
                            //     // itemsSource: map.collectionView,
                            //     // displayMemberPath: map.displayMemberPath,
                            //     // selectedValuePath: map.selectedValuePath
                            // });

                            // статусов немного — тянем ПОЛНЫЙ список со стилями,
                            // чтобы у чипса всегда был свой фон (не грузить по ids).
                            // Статус-колонки (STATUS*) — тоже полный список: любая из них
                            // рисуется чипсом (в т.ч. обычные AttrLink, напр. TXN Status).
                            const _isStatusCol = this.isChipSegment(attr_col.relation_segment)   // IE 2026 09 18 / ODOO-5800: + GRADE
                            if (this.store.fetchMode === 'by_ids' && attr_col.relation_segment
                                && attr_col.attr_type !== 'AttrLinkChips' && !_isStatusCol) {
                                this.store.get_itemsSource(this, col, attr_col, { fetchMode: 'justGet' })
                                // this.resolve_titlesByIds_(this.data000, attr_col)
                                // см ниже
                            } else if (!mtl_segments(attr_col, this.store)) {   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди): составной тип — без словаря колонки (сегмент у каждого id свой, название кладёт mtl_paint)
                                this.store.get_itemsSource(this, col, attr_col, { fetchMode: 'all' })
                            }

                        } else if (attr_col.attr_type === 'AttrStr') {
                            if (!col.minWidth && (attr_col.title||'').toLowerCase().includes('title')) {
                                col.minWidth = 60
                            }
                            col.dataType = wjcCore.DataType.String
                        } else if (attr_col.attr_type === 'AttrMulti') {
                            col.binding = `${attr_col.binding}.valueStr`
                            col.dataType = wjcCore.DataType.String

                            if (this.attr.attr_type !== 'AttrTabGrid') {
                                for (let dataItem of this.data) {
                                    let V = this.store.get_value(dataItem, attr_col.binding)
                                    if (V) {
                                        this.store.prepare_AttrMulti(this, attr_col, dataItem)
                                    }
                                }
                            }
                        } else if (attr_col.attr_type === 'AttrLinkOdoo') {
                            if (!col.minWidth && (attr_col.title||'').toLowerCase().includes('title')) {
                                col.minWidth = 60
                            }
                            col.dataType = wjcCore.DataType.String
                            col.binding = attr_col.binding + '[1]'
                        } else if (attr_col.attr_type === 'AttrBool') {
                            col.dataType = wjcCore.DataType.Boolean
                            // col.cellTemplate = (ctx) => {
                            //     if (ctx.value === true) {
                            //         return `<input type="checkbox" disabled checked/>`;
                            //     }
                            //     return '';
                            // };
                        } else if (attr_col.attr_type === 'AttrDate') {
                            // дата обязана влезать целиком: обрезанная «2026-01-…» нечитаема.
                            // autoSizeColumn даёт 10 симв. × 8px = 80px, но жирное начертание
                            // и паддинги ячейки требуют больше — держим минимум под ISO-дату
                            if (!attr_col.minWidth) {
                                col.minWidth = 90
                            }
                            col.dataType = wjcCore.DataType.String // Date
                        } else if (attr_col.attr_type === 'AttrTime') {
                            col.dataType = wjcCore.DataType.Number
                        } else if (attr_col.attr_type === 'AttrDays') {
                            col.dataType = wjcCore.DataType.Number
                        } else if (attr_col.attr_type === 'AttrNumber') {
                            col.dataType = wjcCore.DataType.Number
                            col.format = attr_col.format || 'n0'
                            col.step = attr_col.step
                            col.aggregate = attr_col.aggregateFooters || 'Sum'
                            if (attr_col.cellTemplate === 'tplRating') {
                                this.tplRating = CellMaker.makeRating({   // IE 2026 09 23 / ODOO-341407: i18n
                                    range: [0, 5],
                                    label: t('See Forecast Rating')
                                })
                                col.cellTemplate = this.tplRating
                            }
                        } else if (attr_col.attr_type === 'AttrList') {
                            if (attr_col.cellTemplate === 'tplSparkLine') {
                                this.tplSparkLine = CellMaker.makeSparkline({
                                    markers: SparklineMarkers.High | SparklineMarkers.Low,
                                    label: t('Forecast'),   // IE 2026 09 23 / ODOO-341407: i18n
                                })
                                col.cellTemplate = this.tplSparkLine
                            } else if (attr_col.cellTemplate === 'tplSparkColumn') {
                                this.tplSparkColumn = CellMaker.makeSparkline({
                                    type: SparklineType.Column,
                                    markers: SparklineMarkers.Low,
                                    label: t('Forecast'),   // IE 2026 09 23 / ODOO-341407: i18n
                                })
                                col.cellTemplate = this.tplSparkColumn
                            } else if (attr_col.cellTemplate === 'tplSparkLoss') {
                                this.tplSparkLoss = CellMaker.makeSparkline({
                                    type: SparklineType.WinLoss,
                                    markers: SparklineMarkers.Negative,
                                    label: t('Forecast'),   // IE 2026 09 23 / ODOO-341407: i18n
                                })
                                col.cellTemplate = this.tplSparkLoss
                            }
                        } else if (attr_col.attr_type === 'AttrTags' && this.attr.attr_type !== 'AttrTabGrid') {
                            // IE 2026 09 28 / ODOO-342342 (приёмка Д2): колонка тегов в списке (doc.tags — таблица {use, title}) — названия через запятую;
                            // без шаблона ячейка показывала «[object Object],[object Object]». Правка тегов — в форме записи (строка AttrTabGrid с чипсами)
                            col.dataType = wjcCore.DataType.String
                            col.isReadOnly = true
                            // IE 2026 10 05 / ODOO-5800 (fe-80; prod_check18 E): список id записей (relation_segment, без колонок таблицы) — названия записей через
                            // запятую, а не id (справочник «Solutions»: колонки Signals / Causes); названия догружаются словарём сегмента, перерисовка — по его приходу
                            const _idsLink = tagIds_linkAttr(attr_col)
                            col.cellTemplate = !_idsLink ? ((ctx) => wjcCore.escapeHtml(gridText_tags(ctx.value))) : ((ctx) => {
                                let raw = ctx.value
                                try { const v = ctx.item ? this.store.get_value(ctx.item, attr_col.binding) : undefined; if (v !== undefined && v !== null) raw = v } catch (e) { /* значение ячейки wijmo */ }
                                const list = Array.isArray(raw) ? raw : (typeof raw === 'string' && raw ? raw.split(',').map(x => x.trim()).filter(Boolean) : [])
                                const want = list.filter(tagIds_isScalar).map(String)
                                const its = want.length ? this.store.get_itemsSource(this, {}, _idsLink, { fetchMode: 'by_ids', ids: want }) : null
                                return wjcCore.escapeHtml(tagIds_text(list, its?.ids))
                            })
                        } else {
                            col.dataType = wjcCore.DataType.String
                        }

                        if (attr_col.collapseTo) {
                            col.collapseTo = attr_col.collapseTo
                        }

                        const isCollapsed0 = this.foldMem_get(attr_col.binding)   // IE 2026 09 17: формы — сеансовая память, не viewParams
                        if (isCollapsed0 !== undefined) {
                            col.isCollapsed = isCollapsed0
                        } else if (attr_col.isCollapsed) {
                            col.isCollapsed = attr_col.isCollapsed
                        }

                        this.attr_by_binding[col.binding] = attr_col
                        this.column_by_binding[col.binding] = col
                        // ODOO-4113: лист схлопнутого слоя «↩» (collapse_arrowLayer_attrs) —
                        // вернуть в цепочку выброшенную группу с date/date_next; idAttr
                        // группе назначаем всегда заново (idAttr_max сбрасывается на
                        // каждом скане, а группа циклом не обходится)
                        if (attr_col._collapsedGroup) {
                            const _grp = attr_col._collapsedGroup
                            _grp.idAttr = ++this.idAttr_max
                            this.parentAttr_by_idAttr[attr_col.idAttr] = _grp
                            if (parentAttr) {
                                this.parentAttr_by_idAttr[_grp.idAttr] = parentAttr
                            }
                        } else if (parentAttr) {
                            this.parentAttr_by_idAttr[attr_col.idAttr] = parentAttr
                        }
                    }
                    if (!childItemsPath) {
                        this.flex.columns.push(col)
                    } else if (attr_col[childItemsPath]?.length && attr_col?.attr_type !== 'AttrGrid') {
                        // record intermediate level for full parent chain traversal
                        if (parentAttr) {
                            this.parentAttr_by_idAttr[attr_col.idAttr] = parentAttr
                        }
                        this.scan_column_fromAttrs(attr_col._kidsCollapsed || attr_col[childItemsPath], childItemsPath, attr_col)
                    }
                }
            }

            // icol
            for (let icol = 0; icol<this.flex.columns.length; icol++) {
                let col = this.flex.columns[icol]
                if (col.binding && col.binding in this.attr_by_binding) {
                    let attr_col = this.attr_by_binding[col.binding]
                    attr_col.icol = icol
                }
            }
        },
        scan_columnGroups_fromFlex(columnGroups, row=0) {
            let first_col_binding = ''
            for (let col of columnGroups) {
                if (col.columns && col.columns.length) {
                    let first_col_binding0 = this.scan_columnGroups_fromFlex(col.columns, row+1),
                        binding0 = col.binding
                    delete col.binding
                    this.columnGroups_by_binding0[binding0] = {
                        col: col,
                        bindingColumnGroup: `${first_col_binding0}-${row}`,
                    }
                    if (first_col_binding === '') {
                        first_col_binding = first_col_binding0
                    }
                } else if (first_col_binding === '') {
                    first_col_binding = col.binding
                }
            }
            return first_col_binding
        },
        rowHeaders() {
            this.flex.rowHeaders.columns.clear()
            this._rhFlagsOn = this.rhFlags_on()   // IE 2026 09 26 / ODOO-… (заказ Игоря: doc.use в заголовках строк): блокировки строк флажков и positionNew — на это построение
            let col

            // _fe.selected
            this.rowHeaders_col_feSelected = null
            if (this.showFeSelected) {
                col = new wjGrid.Column()
                col.header = '✓'
                col.width = 16
                this.rowHeaders_col_feSelected = this.flex.rowHeaders.columns.push(col) - 1
            }

            // selector
            let attr_selector = this.columns().find(attr_col => attr_col.binding === 'selector')
            this.rowHeaders_col_selector = null
            if (attr_selector) {
                col = this.col_selector = new wjGrid.Column()
                col.header = attr_selector.title
                if (this.store.showTooltip) {
                    col.tooltip = attr_selector.tooltip
                }
                col.width = 25
                // col.dataType = wjcCore.DataType.Boolean
                // col.binding = attr_selector.binding
                this.rowHeaders_col_selector = this.flex.rowHeaders.columns.push(col) - 1
                // new BooleanChecker(col)

                // this.flex.isReadOnly = false // TODO attr_selector >> !isReadOnly
            }

            // #
            let levels = 0
            if (this.attr.childItemsPath) {
                for (let row of this.flex.rows) {
                    if (levels < row.level) {
                        levels = row.level
                    }
                }
            }

            if (this.use_rowNumberColumn) {
                col = new wjGrid.Column()
                col.header = '⋮'
                col.width = Math.max(30, 6 * this.number_length||5)
                this.rowNumberColumn = this.flex.rowHeaders.columns.push(col) - 1
            }

            this.columnNumberColumn = null
            if (this.rowNumberColumn !== null && this.attr.isColumnsConfig) {
                col = new wjGrid.Column()
                col.header = t('Column')   // IE 2026 09 23 / ODOO-341407: i18n
                col.width = Math.max(30, 6 * this.number_length||5)
                this.columnNumberColumn = this.flex.rowHeaders.columns.push(col) - 1
            }
            
            // use
            let attr_use = this.columns().find(attr_col => attr_col.binding === 'use')
            this.rowHeaders_col_use = null
            if (attr_use) {
                // det default value
                if (!this.rhBool_noWrite()) {   // IE 2026 10 23 / ODOO-5800: нет ключа = включено, в данные не пишем (иначе все строки «изменены»)
                    this.flex.rows.forEach((item) => {
                        if (item.dataItem && this.store.get_value(item.dataItem, attr_use.binding) == null) {
                            this.store.set_value(item.dataItem, attr_use.binding, true)
                        }
                    })
                }

                col = new wjGrid.Column()
                col.header = attr_use.title
                if (this.store.showTooltip) {
                    col.tooltip = attr_use.tooltip
                }
                col.width = 25
                // col.dataType = wjcCore.DataType.Boolean
                // col.binding = attr_use.binding
                this.rowHeaders_col_use = this.flex.rowHeaders.columns.push(col) - 1
                // new BooleanChecker(col)
            }

            // position='rowHeaders'
            this.rowHeaders_cols_pos = []
            for (const attr_rh of this.columns().filter(attr_col => this.rhPos_is(attr_col))) {   // IE 2026 09 26 / ODOO-… (заказ Игоря: doc.use в заголовках строк): и positionNew
                const _rhNewOnly = attr_rh.position !== 'rowHeaders'   // колонка пришла ключом positionNew (у прежнего фронта — обычная колонка)
                col = new wjGrid.Column()
                col.header = attr_rh.title
                if (this.store.showTooltip) {
                    col.tooltip = attr_rh.tooltip
                }
                // IE 2026 09 17 (замечание Игоря): ширина колонки-группы — сохранённая пользователем (с виджетом, как у обычных колонок),
                // иначе автоширина по содержимому (_dlhdr_*), иначе ширина из attr (колонка Type compare шире галочки)
                const _wUser = this.viewParam_attrs?.[attr_rh.binding]?.width
                col.width = _wUser || (String(attr_rh.binding || '').startsWith('_dlhdr_') ? this.rhCol_autoWidth(attr_rh) : ((_rhNewOnly && attr_rh.attr_type === 'AttrBool') ? 25 : (attr_rh.width || 25)))   // IE 2026 09 26 / ODOO-… (заказ Игоря: doc.use в заголовках строк): флажок по positionNew — ширина чекбокса (ширина attr — у колонки прежнего фронта)
                const col_idx = this.flex.rowHeaders.columns.push(col) - 1
                // IE 2026 09 05 / ODOO-336283 (заказ Игоря): колонка-группа AttrTabHeader в шапке строк — mergeRows
                // (вертикальный мерж в панели заголовков строк, см. MergeManager) и класс ячейки
                this.rowHeaders_cols_pos.push({ col_idx, binding: attr_rh.binding, attr_type: attr_rh.attr_type,
                    mergeRows: !!attr_rh.mergeRows, cssClass: attr_rh.cssClass || '',
                    def: attr_rh.attr_type === 'AttrBool' ? rhBool_default(attr_rh, false) : undefined })   // IE 2026 10 23 / ODOO-5800: умолчание показа флажка
                // IE 2026 09 26 / ODOO-… (заказ Игоря: doc.use в заголовках строк): флажок по positionNew — данные строки как есть (пусто = снято, строка не помечается
                // изменённой при отрисовке); умолчание — только заданное attr.default
                const _rhDef = _rhNewOnly ? attr_rh.default : true
                if (attr_rh.attr_type === 'AttrBool' && _rhDef != null && !this.rhBool_noWrite()) {   // IE 2026 10 23 / ODOO-5800: запись умолчания — только при выключенном fe.ux.rhBoolImplicitDefault
                    this.flex.rows.forEach((item) => {
                        if (item.dataItem && this.store.get_value(item.dataItem, attr_rh.binding) == null) {
                            this.store.set_value(item.dataItem, attr_rh.binding, _rhDef)
                        }
                    })
                }
            }
            
            // IE 2026 09 05 / ODOO-336283: мерж ячеек панели заголовков строк — только когда есть
            // колонка-группа (AttrTabHeader); иначе прежний режим (Cells). Выкл: window.gridPerf.set('dl2_tabheader_merge', false)
            try {
                const _hdrMerge = this.rowHeaders_cols_pos.some(x => x.mergeRows) && this.store.perf_flag('dl2_tabheader_merge', true)
                const _am = _hdrMerge ? (wjGrid.AllowMerging.Cells | wjGrid.AllowMerging.RowHeaders) : wjGrid.AllowMerging.Cells
                if (this.flex.allowMerging !== _am) this.flex.allowMerging = _am
            } catch (e) { /* старый wijmo без флагов — прежний режим */ }

            const TEST_ROW_HEADERS = false
            if (TEST_ROW_HEADERS) {
                for (let i = 0; i < this.attr.frozenColumns; i++) {
                    // col = this.column_by_binding0[attr_col.binding0]
                    col = this.flex.columns[i]
                    this.flex.rowHeaders.columns.push(col)
                }
            }
        },  
        set_headerColumns() {
            // for (let col of this.flex.columns) {
            //     let attr_col = this.attr_by_binding[col.binding]
            //     this.flex.setCellData(0, col.index, attr_col.title)
            // }
            // this.flexRefresh()
        },
        formatSheet(){
            // hslGroup
            const hslGroups = this.hslGroups = {};

            // сбор колонок по группам
            for (let binding in this.attr_by_binding) {
                const attr_col = this.attr_by_binding[binding];
                if (attr_col.hslGroup) {
                    hslGroups[attr_col.hslGroup] = hslGroups[attr_col.hslGroup] || { attr_by_binding: {}, min: null, max: null };
                    hslGroups[attr_col.hslGroup].attr_by_binding[binding] = attr_col;
                }
            }

            // утилита перцентиля
            const _percentile = (arr, p) => {
                    if (!arr.length) return null;
                    const a = arr.slice().sort((x, y) => x - y);
                    const i = (a.length - 1) * p;
                    const lo = Math.floor(i), hi = Math.ceil(i);
                    if (lo === hi) return a[lo];
                    const t = i - lo;
                    return a[lo] * (1 - t) + a[hi] * t;
                };

                // обойдём группы и посчитаем min/max/p5/p95, а также признак отрицательных/положительных
                for (let group in hslGroups) {
                let min = null, max = null;
                const values = []; // соберём валидные числовые значения
                let hasNeg = false, hasPos = false;

                const byLevel = {}; // IE 2026 08 30 / ODOO-5800: значения в разрезе уровня дерева
                for (let binding in hslGroups[group].attr_by_binding) {
                    const attr_col = hslGroups[group].attr_by_binding[binding];
                    for (const row of this.flex.rows) {
                        let v = this.store.get_value(row.dataItem||{}, binding);
                        if (v !== null && v !== undefined && v !== '') {
                            v = Number(v);
                            if (!isNaN(v)) {
                            values.push(v);
                            if (min === null || v < min) min = v;
                            if (max === null || v > max) max = v;
                            if (v < 0) hasNeg = true;
                            if (v > 0) hasPos = true;
                            const _lvl = row.level ?? -1;
                            (byLevel[_lvl] = byLevel[_lvl] || []).push(v);
                            }
                        }
                    }
                }

                // перцентили (если значений мало — fallback к min/max)
                const p5  = values.length ? _percentile(values, 0.05) : min;
                const p95 = values.length ? _percentile(values, 0.95) : max;

                hslGroups[group].min  = min;
                hslGroups[group].max  = max;
                hslGroups[group].p5   = p5;
                hslGroups[group].p95  = p95;
                hslGroups[group].hasNeg = hasNeg;
                hslGroups[group].hasPos = hasPos;

                // IE 2026 08 30 / ODOO-5800 (заказ Игоря): в дереве итоговая строка суммирует
                // детей и при ОБЩЕЙ шкале всегда забирала максимум, обесцвечивая детальные.
                // Шкала считается отдельно на каждый уровень дерева: итоги уровня сравниваются
                // между собой, детали — между собой. Плоский грид (один уровень) не меняется.
                const _byLvl = {};
                for (const _lvl in byLevel) {
                    const _vals = byLevel[_lvl];
                    let _mn = _vals[0], _mx = _vals[0], _neg = false, _pos = false;
                    for (const _v of _vals) {
                        if (_v < _mn) _mn = _v;
                        if (_v > _mx) _mx = _v;
                        if (_v < 0) _neg = true;
                        if (_v > 0) _pos = true;
                    }
                    _byLvl[_lvl] = {
                        min: _mn, max: _mx,
                        p5: _percentile(_vals, 0.05), p95: _percentile(_vals, 0.95),
                        hasNeg: _neg, hasPos: _pos,
                    };
                }
                hslGroups[group].byLevel = _byLvl;
            }

            // АН 2026 08 09: AttrTabGrid — hslGroup задаётся на строках (полях записи)
            if (this.attr.attr_type === 'AttrTabGrid') {
                const rowGroups = {}
                for (const row of this.flex.rows) {
                    const a2 = row.dataItem?.attr
                    if (!a2?.hslGroup) continue
                    const v = Number(this.store.get_value(this.WIDGET.record, a2.binding))
                    if (isNaN(v)) continue
                    ;(rowGroups[a2.hslGroup] = rowGroups[a2.hslGroup] || []).push(v)
                }
                for (const g in rowGroups) {
                    const values = rowGroups[g]
                    hslGroups[g] = {
                        attr_by_binding: {},
                        min: Math.min(...values), max: Math.max(...values),
                        p5: _percentile(values, 0.05), p95: _percentile(values, 0.95),
                        hasNeg: values.some(v => v < 0), hasPos: values.some(v => v > 0),
                    }
                }
                // АН 2026 08 09: первая отрисовка идёт синхронно при set_itemsSource —
                // ДО расчёта групп; без явной инвалидации кеш ячеек оставит их без
                // подсветки. Перерисовываем только при изменении статистики групп.
                const _sig = JSON.stringify(Object.keys(rowGroups).sort().map(g2 => [g2, hslGroups[g2].min, hslGroups[g2].max]))
                if (this._hslRowSig !== _sig) {
                    this._hslRowSig = _sig
                    if (Object.keys(rowGroups).length) {
                        this.$nextTick(() => { try { this.refreshing(); this.flex.invalidate() } catch (e) { /* грид мог закрыться */ } })
                    }
                }
            }



            

            // if (!this.store.hide_console) console.log('formatSheet')
            // let row = new wjGrid.Row()
            // this.flex.columnHeaders.rows.push(row)

            if (this.attr.headerRows) {
                this.headerRows = this.attr.headerRows // 3
            }
            if (this.attr.headerColumns) {
                this.headerColumns = this.attr.headerColumns // 1
            }
            this.row_bottom = this.data000.length
            this.column_left = this.flex.columns.length-1

            this.formatRows()
            this.formatColumns()
            this.mergeHeaderTop()
            // this.mergeHeaderLeft_leftToRight()
            this.mergeHeaderFirstCell()
            // this.mergeHeaderLeft_topToBottom()

            this.flexRefresh()
            this.attrResize()
        },
        formatRows() {
            // rowlevelGroup_ranges
            let rowLevelGroup_ranges = {}
            this.data000.forEach((row, i) => {
                if (!rowLevelGroup_ranges[row.levelGroup]) rowLevelGroup_ranges[row.levelGroup] = []
                rowLevelGroup_ranges[row.levelGroup].push(new wjGrid.CellRange(i+1, 0, i+1, this.column_left))
            })
            
            // format rows
            let levelGroups_ICellStyle = {
                // 0: {
                //     // backgroundColor: "#4488CC",
                //     className: "grid-detail-row",
                //  }, 
                1: {
                    className: "grid-group1-row",
                 }, 
                2: {
                     className: "grid-group2-row",
                 }, 
                99: { //total
                     className: "grid-total-row",
                }, 
                100: { //header
                    className: "wj-header-row",
                },
            }
            this.rowLevelGroup_ranges_length = rowLevelGroup_ranges.length
            // if (rowLevelGroup_ranges.length > 1) 
                this.flex.alternatingRowStep = 0
            for (let levelGroup in levelGroups_ICellStyle) {
                if (rowLevelGroup_ranges[levelGroup]) {
                    this.flex.applyCellsStyle(levelGroups_ICellStyle[levelGroup], rowLevelGroup_ranges[levelGroup])
                }
            }

        },
        formatColumns() {
            // colValue_ranges
            let colValue_ranges = {}
            this.columns().forEach((attr_col, i) => {
                if (!colValue_ranges[attr_col.value]) colValue_ranges[attr_col.value] = []
                colValue_ranges[attr_col.value].push(new wjGrid.CellRange(0, i, this.row_bottom, i))
            })
            
            // format columns
            let value_ICellStyle = {
                'sum': {
                    // className: "cell-sum",
                    color: 'green',
                },
            }
            for (let value in value_ICellStyle) {
                if (colValue_ranges[value]) {
                    this.flex.applyCellsStyle(value_ICellStyle[value], colValue_ranges[value])
                }
            }
        },
        mergeHeaderTop() {
            let merge_ranges = []
            for (let irow = 0; irow < this.headerRows; irow++) {
                let icol_mergeLeft = this.headerColumns,
                    icol_mergeRight = this.headerColumns
                for (let icol = icol_mergeLeft + 1; icol <= this.column_left; icol++) {
                    // getCellValue
                    if (this.flex.getCellValue(irow, icol_mergeLeft) === this.flex.getCellValue(irow, icol)) {
                        icol_mergeRight = icol
                    } else {
                        if (icol_mergeLeft < icol_mergeRight) {
                            merge_ranges.push(new wjGrid.CellRange(irow, icol_mergeLeft, irow, icol_mergeRight))
                        }
                        icol_mergeLeft = icol_mergeRight = icol
                    }
                }
                if (icol_mergeLeft < icol_mergeRight) {
                    merge_ranges.push(new wjGrid.CellRange(irow, icol_mergeLeft, irow, icol_mergeRight))
                }
            }
            merge_ranges.forEach(range => {
                this.flex.mergeRange(range)
                this.flex.applyCellsStyle({ className: "wj-header-row" }, range)
            })
        },
        mergeHeaderFirstCell() {
            if (this.headerRows > 1) {
                let range = new wjGrid.CellRange(0, 0, this.headerRows-1, this.headerColumns-1)
                this.flex.mergeRange(range)
                this.flex.applyCellsStyle({ className: "wj-header-row" }, range)
            }
        },
        mergeHeaderLeft_leftToRight() {
            let merge_ranges = []
            for (let irow = this.headerRows; irow <= this.row_bottom; irow++) {
                let icol_mergeLeft = 0,
                    icol_mergeRight = 0
                for (let icol = 1; icol < this.headerColumns; icol++) {
                    // getCellValue
                    if (!this.flex.getCellValue(irow, icol)) {
                        icol_mergeRight = icol
                    } else {
                        if (icol_mergeLeft < icol_mergeRight) {
                            merge_ranges.push(new wjGrid.CellRange(irow, icol_mergeLeft, irow, icol_mergeRight))
                        }
                        icol_mergeLeft = icol_mergeRight = icol
                    }
                }
                if (icol_mergeLeft < icol_mergeRight) {
                    merge_ranges.push(new wjGrid.CellRange(irow, icol_mergeLeft, irow, icol_mergeRight))
                }
            }
            merge_ranges.forEach(range => {
                this.flex.mergeRange(range)
            })
        },
        mergeHeaderLeft_topToBottom() {
            let merge_ranges = []
            for (let icol = 0; icol < this.headerColumns; icol++) {
                let irow_mergeTop = 0,
                    irow_mergeBottom = 0
                for (let irow = this.headerRows; irow <= this.row_bottom; irow++) {
                    // getCellValue
                    if (this.flex.getCellValue(irow_mergeTop, icol) === this.flex.getCellValue(irow, icol)) {
                        irow_mergeBottom = irow
                        this.flex.setCellValue(irow, icol)
                    } else {
                        if (irow_mergeTop < irow_mergeBottom) {
                            merge_ranges.push(new wjGrid.CellRange(irow_mergeTop, icol, irow_mergeBottom, icol))
                        }
                        irow_mergeTop = irow_mergeBottom = irow
                    }
                }
                if (irow_mergeTop < irow_mergeBottom) {
                    merge_ranges.push(new wjGrid.CellRange(irow_mergeTop, icol, irow_mergeBottom, icol))
                }
            }
            merge_ranges.forEach(range => {
                this.flex.mergeRange(range)
            })
        },
        groupAll() {
            this.collapsedAll(true)
        },
        ungroupAll() {
            this.collapsedAll(false)
        },
        collapsedAll(forsed=null, justRefresh=false) {
            this.collapsedAllRows(forsed, justRefresh)
            this.collapsedAllColumns(forsed, justRefresh)
        },
        collapsedAllRows(forsed, justRefresh=false) {
            if (this.attr.attr_type === 'AttrTabGrid') {
                for (let row of this.flex.rows) {
                    if (row.dataItem?.attr?.isCollapsed && !row.isCollapsed) {
                        row.isCollapsed = true
                    }
                }
            }

            // for (let i=0; i<this.data000.length; i++) {
            //     let dataItem = this.data000[i]
            //     if (dataItem.isCollapsed) {
            //         this.collapsed_rowGroup(i, forsed ?? dataItem.isCollapsed, justRefresh);
            //     }
            // }
        },
        collapsedAllColumns(forsed, justRefresh=false) {
            // for (let attr_col of this.columns()) {
            //     if ('isCollapsed' in attr_col) { // && !attr_col.isCollapsed
            //         this.collapsed_columnGroup(attr_col.binding, forsed ?? attr_col.isCollapsed, justRefresh)
            //     }
            // }
        },
        initialized(flex) {
            this.store.cssClasses_loadAll()   // IE 2026 09 18 / ODOO-… (заказ Игоря): именованные стили — весь реестр один раз на сеанс
            cfSetLegacy(this.store.setting('fe.data.cfSetLegacy', false) === true)   // IE 2026 09 18 / ODOO-5800: set / !set — как на бэке (выключатель прежней трактовки)
            // IE 2026 08 20 / ODOO-336291 (mobile UX), 21.08: мобильный профиль — числовые
            // заголовки скрыты по умолчанию через wijmo (место освобождается)
            if (this.store?.mobileUi?.on) this.$nextTick(() => this.WIDGET?.attrs_vueObj?.WIDGET?.applyMobileGridHeads?.())
            // 21.08: состояние активной ячейки для мобильных кнопок правого стека;
            // click тоже — selectionChanged не стреляет при тапе в УЖЕ выбранную ячейку
            if (this.store?.mobileUi?.on) {
                // IE 2026 09 04 / ODOO-336291 (mobile UX): P-20 cellSyncFast — первый sync в следующем кадре (кнопки ячейки без
                // паузы 150 мс); таймер 150 мс остаётся страховкой (фокус wijmo может прийти позже touchend).
                // Выкл: window.mobileUi.set('cellSyncFast', false)
                const syncSoon = () => {
                    if (this.store.mobileUi?.cellSyncFast !== false && !this._mobCellRaf) {
                        this._mobCellRaf = requestAnimationFrame(() => { this._mobCellRaf = 0; try { this.mobileCellSync() } catch (e) { /* грид в перестройке */ } })
                    }
                    window.$cg.setTimeout(this, 'mobCellSync', () => this.mobileCellSync(), 150)
                }
                flex.selectionChanged.addHandler(syncSoon)
                flex.hostElement.addEventListener('click', syncSoon, true)
            }
            // IE 2026 08 18 (заказ Игоря п.6): подсветка связанных ячеек по наведению
            this.$nextTick(() => this.trace_init())
            const vueObj = this
            this.flex = flex
            // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5 [ДЕФЕКТ, defects-found.md]: __vueGrid ставился только в mounted() —
            // после пересоздания хоста wijmo (смена Headers: v-if="visibility") у НОВОГО хоста __vueGrid не было, и Alt-подсказки ячеек этого грида переставали работать
            try { if (flex.hostElement) flex.hostElement.__vueGrid = this } catch (e) { /* хост мог не иниться */ }
            this.selUser_hook(flex)   // IE 2026 09 27 / ODOO-5800: признак выбора пользователя для Set selectors (fe.ux.setSelectorsUserOnly)
            this.pickerDbl_hook(flex)   // IE 2026 10 11 / ODOO-345618: двойной клик по ячейке frozen-колонки (Title) списка выбора = Choice
            this.planLabelDate_hook(flex)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана): Ctrl+C путём wijmo / CSV (getClipString) и Ctrl+C в редакторе ячейки — дата текстом, не токен
            this.dl2Blank_hook(flex)   // IE 2026 10 07 / ODOO-5800: погашенные ячейки DL2 (_DLRow.cells[binding].blank) — пустые для wijmo: отрисовка, XLSX / CSV / PDF, буфер, редактор
            this.copyExcel_pasteHook(flex)   // IE 2026 10 02 / ODOO-5800 (заказ Игоря: копирование в Excel for Mac с заливкой — HTML-исходник в text/plain): своя «Excel-форма» из буфера вставляется теми же значениями, что TSV
            // IE 2026 09 04 / ODOO-336291 (mobile UX): R-2 frozenCloneHold (верификация 04.09: пан 300 px с frozenColumns=1 в 3–5 раз медленнее,
            // чем без него). wijmo (cloneFrozenCells) на КАЖДЫЙ кадр прокрутки удаляет и клонирует заново все frozen-ячейки
            // (_updateFrozenCells из _updateContent(recycle)); каждый клон проходит полный formatItem (самые дорогие ячейки —
            // длинные названия) и проверку обрезки с forced layout, а грязный DOM делает дорогими _fixScroll/updateContent.
            // Пока палец ведёт грид (window._mobPanActive, Widget.vue) и вертикаль/состав строк-колонок не менялись — клон
            // держим: по горизонтали frozen-ячейки не меняются. Не-recycle обновления (refresh/invalidate) строят клон как
            // раньше. Счётчик: this._mobFzHeld. Выкл: window.mobileUi.set('frozenCloneHold', false)
            if (this.store?.mobileUi?.on && !flex._mobFzPatched && typeof flex._updateFrozenCells === 'function') {
                flex._mobFzPatched = true
                const _uc = flex._updateContent, _ufc = flex._updateFrozenCells
                flex._updateContent = function (recycle, state) {
                    this._mobFzRecycle = !!recycle
                    return _uc.call(this, recycle, state)
                }
                flex._updateFrozenCells = function (e, t) {
                    const key = `${this._ptScrl?.y}|${this.rows?.length}|${this.columns?.length}|${this.frozenColumns}|${vueObj.irefresh}`
                    if (!t && this._mobFzRecycle && window._mobPanActive && vueObj.store.mobileUi?.frozenCloneHold !== false
                            && this._fCt?.childElementCount && this._mobFzKey === key) {
                        vueObj._mobFzHeld = (vueObj._mobFzHeld || 0) + 1
                        return
                    }
                    _ufc.call(this, e, t)
                    this._mobFzKey = key
                }
            }
            // IE 2026 09 04 / ODOO-336331 (заказ Игоря): клик по гриду — нативным слушателем хоста: @click обёртки
            // wj-flex-grid до хоста доходит не всегда (колонка-флаг Default списка вариантов не реагировала);
            // повторный вызов из Vue-слушателя гасится меткой e.__agClickDone в execute_click
            flex.hostElement.addEventListener('click', (e) => {
                // IE 2026 09 04 / ODOO-336331: клик по хосту грида, который компонент уже сменил/снял (открытие записи из списка
                // пересоздаёт грид на mousedown) — hitTest мёртвого грида падает на getBoundingClientRect(null); молча выходим
                if (flex !== this.flex || !flex.hostElement || !flex.hostElement.isConnected) return
                try { this.execute_click(e) } catch (err) { console.warn('execute_click', err) }
            })

            // подключаем хоткеи один раз
            this.bindGridHotkeys();

            // шаблон печати: перенос ячейки drag'ом за рамку выделения
            if (this.attr.isPrintTemplate) {
                this.printCellDrag_init()
            }

            // френдли-тултипы шапки при ВЫКЛЮЧЕННОМ Show tooltips: обрезанный
            // титул — подсказка с тайтлом; удержание ~1.5с — полный тултип
            flex.hostElement.addEventListener('mouseover', this.headerTooltip_over)
            flex.hostElement.addEventListener('mouseleave', this.headerTooltip_hide)

            // бейджи уровней группировки строк на ховер верхнего левого угла:
            // клик по «N» сворачивает дерево строк до N уровней (см. foldBadges_init)
            this.foldBadges_init(flex)

            // hover-подсветка ВСЕЙ строки, включая замороженные колонки. CSS :hover не
            // достаёт клон-панель замороженных (.wj-frozen-clone нет .wj-row), поэтому
            // синхронизируем классом .wj-row-hover по data-gr (см. formatItem-тег).
            {
                const host = flex.hostElement
                let hoverRow = -1
                let hoverCol = -1
                const clearHover = () => {
                    if (hoverRow < 0 && hoverCol < 0) return
                    host.querySelectorAll('.wj-cell.wj-row-hover').forEach(c => c.classList.remove('wj-row-hover'))
                    host.querySelectorAll('.wj-cell.wj-hover-header').forEach(c => c.classList.remove('wj-hover-header'))
                    hoverRow = -1
                    hoverCol = -1
                }
                host.addEventListener('mousemove', (ev) => {
                    const ht = flex.hitTest(ev)
                    const isCell = ht && ht.cellType === wjGrid.CellType.Cell
                    const r = isCell ? ht.row : -1
                    const c = isCell ? ht.col : -1
                    if (r === hoverRow && c === hoverCol) return
                    clearHover()
                    this.tls_hover(flex, r)   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: стили уровней дерева — опции A/B/C/E/F): подсветка поддерева по наведению (fe.ux.treeSubtreeHover)
                    this.parentHide_hover(flex, r)   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p201 баланс — «Сигнали» типово, розкритий батьківський рядок без підсумків і сигналів (hover показує), підсумок рядка без сигналів — опція): круги раскрытой строки-группы — по наведению
                    if (r >= 0) {
                        hoverRow = r
                        hoverCol = c
                        host.querySelectorAll(`.wj-cell[data-gr="${r}"]`).forEach(c => c.classList.add('wj-row-hover'))
                        // крест-подсветка заголовков (Excel-like): заголовок строки (одна ячейка) +
                        // заголовок колонки — ТОЛЬКО нижняя (лист) ячейка, та же, где wijmo рисует
                        // индикацию выделения; не вся стопка сгруппированных шапок (2026/Q1/дата).
                        // Ячейка под курсором может быть ОБЪЕДИНЁННОЙ (merge) — подсвечиваем
                        // колонку НАЧАЛА объединённой области, а не колонку под мышью
                        let hc = c
                        try {
                            const mr = flex.getMergedRange(flex.cells, r, c)
                            hc = mergeBackHoverCol(this.mergeBack_info(flex.cells, r), c, mr)   // IE 2026 10 26 / ODOO-5800 (заказ Игоря 26.10: сдвинутая влево ячейка субъекта — подсветка заголовка исходной колонки и подсказка): было `if (mr) hc = mr.col` — у объединения «назад» корень = колонка дерева (Об'єкт); колонка значения, как у выделения (mergeBack_selCol)
                        } catch { /* merge manager мог не устояться */ }
                        // заголовок строки: только КРАЙНЯЯ ПРАВАЯ видимая ячейка стопки
                        // (как у колонок — лист), а не все колонки заголовка строки
                        const rowCells = [...host.querySelectorAll(`.wj-rowheaders .wj-cell[data-ghr="${r}"]`)]
                            .filter(el => el.offsetWidth > 0)
                        if (rowCells.length) {
                            rowCells.reduce((a, b) => (b.offsetLeft > a.offsetLeft ? b : a)).classList.add('wj-hover-header')
                        }
                        const colCells = [...host.querySelectorAll(`.wj-colheaders .wj-cell[data-ghc="${hc}"]`)]
                        let leaf = colCells.find(el => el.classList.contains('wj-header-number-row'))
                        if (!leaf && colCells.length) leaf = colCells.reduce((a, b) => (b.offsetTop > a.offsetTop ? b : a))
                        if (leaf) leaf.classList.add('wj-hover-header')
                    }
                })
                host.addEventListener('mouseleave', clearHover)
                host.addEventListener('mouseleave', () => this.tls_hover(flex, -1))   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: стили уровней дерева — опции A/B/C/E/F)
                host.addEventListener('keydown', (ev) => this.tls_key(flex, ev))   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: стили уровней дерева — опции A/B/C/E/F): Esc снимает фокус-режим
                host.addEventListener('mouseleave', () => this.parentHide_hover(flex, -1))   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p201 баланс — «Сигнали» типово, розкритий батьківський рядок без підсумків і сигналів (hover показує), підсумок рядка без сигналів — опція)
            }

            flex.mergeManager = new CustomMergeManager(flex, this)

            // задача 16: подсветка выделения в заголовках КОЛОНОК. wijmo ставит
            // wj-state-multi-selected только на ПОСЛЕДНЮЮ строку columnHeaders, а
            // create_stickyRows добавляет в конец невидимые служебные строки
            // (sticky/filter-шаблоны) — класс никогда не появлялся. Считаем
            // «последней» последнюю ВИДИМУЮ строку шапки.
            {
                const chdr = flex.columnHeaders
                const base_getSelectedState = chdr.getSelectedState.bind(chdr)
                const vueObj_hdr = this
                chdr.getSelectedState = (r, c, rng) => {
                    let st = base_getSelectedState(r, c, rng)
                    // IE 2026 09 17 / ODOO-… (заказ Игоря): выделена ячейка объединения «назад» — в шапке подсвечивается
                    // колонка её ЗНАЧЕНИЯ (merge_src), а не левый край объединения
                    const sel0 = flex.selection
                    const selCol0 = sel0 ? sel0.col : -1
                    const effCol = (selCol0 >= 0 && flex.activePanelType === wjGrid.CellType.Cell) ? vueObj_hdr.mergeBack_selCol(sel0.row, selCol0) : selCol0
                    if (effCol !== selCol0) {
                        const inCol = (x) => c === x || (rng && typeof rng.containsColumn === 'function' && rng.containsColumn(x))
                        let last0 = chdr.rows.length - 1
                        while (last0 > 0 && !chdr.rows[last0].visible) last0--
                        if (inCol(selCol0)) st = wjGrid.SelectedState.None
                        if (inCol(effCol) && (rng ? rng.bottomRow : r) === last0
                            && (flex.showSelectedHeaders & wjGrid.HeadersVisibility.Column)) st = wjGrid.SelectedState.Selected
                        return st
                    }
                    // выделена вся строка целиком — подсвечивать ВСЕ заголовки колонок
                    // бессмысленно: это ничего не уточняет, только перегружает раскраску
                    const sel = flex.selection
                    const allColumns = sel && sel.leftCol <= 0 && sel.rightCol >= flex.columns.length - 1
                    const rowMode = flex.selectionMode === wjGrid.SelectionMode.Row
                        || flex.selectionMode === wjGrid.SelectionMode.RowRange
                        || flex.selectionMode === wjGrid.SelectionMode.ListBox
                    if (allColumns || rowMode) return st
                    if (st === wjGrid.SelectedState.None
                        && flex.activePanelType === wjGrid.CellType.Cell
                        && (flex.showSelectedHeaders & wjGrid.HeadersVisibility.Column)
                        && (flex.selection.containsColumn(c) || (rng && flex.selection.intersectsColumn(rng)))) {
                        let last = chdr.rows.length - 1
                        while (last > 0 && !chdr.rows[last].visible) last--
                        if ((rng ? rng.bottomRow : r) === last) st = wjGrid.SelectedState.Selected
                    }
                    return st
                }
            }

            this.default_cellFactory = flex.cellFactory
            // R18 (dm 2026 08 04): дефолт фабрики применяется ЗДЕСЬ (момент создания грида) —
            // блок дефолтов attr.* выполняется позже и на выбор фабрики уже не влияет.
            // Сохранённое в viewParams `false` у 20+ записей — снапшот СТАРОГО дефолта
            // при любом сохранении вида, не осознанный выбор: при включённом флаге
            // scrollFactory игнорируем его (выключатели: кнопка Cell factory в сессии
            // либо window.fastEntry.set('scrollFactory', false) целиком).
            if (this.store?.fastEntry?.scrollFactory !== false) {
                this.attr.use_customCellFactory = true
            } else {
                this.attr.use_customCellFactory = this.attr.use_customCellFactory ?? false
            }
            if (this.attr.use_customCellFactory) {
                flex.cellFactory = new CustomCellFactory(flex, this)
            }
            if (this.groupPanel) {
                this.groupPanel.grid = flex
            }
            // if (this.attr.aggregateFooters) {
            //     flex.columnFooters.rows.push(new wjGrid.GroupRow())
            //     flex.bottomLeftCells.setCellData(0, 0, 'Σ')
            // }
            this.content_Changed({isVue:true})
            this.setSelectoinListener()
            this.rowDrag_install()   // IE 2026 09 09 / ODOO-…: Alt+захват строки — перетаскивание с подсветкой места падения
            this.rhResize_install()   // IE 2026 09 17 (замечание Игоря): ручка ширины колонок-групп шапки строк
            this.boolCell_install()   // IE 2026 09 10 / ODOO-…: пробел/буква на булевой ячейке — переключение
            this.cellForm_install()   // IE 2026 09 21 / ODOO-… (замечание Игоря: стрелка формы ячейки на выбранной ячейке, F4 — без входа в правку)
            this.set_frozenColumns()

            // scroll
            this.$nextTick(() => {
                // грид мог быть размонтирован до тика (ремоунт полос AttrTabGridLanes)
                const cellsHost  = flex.hostElement?.querySelector('[wj-part="root"]');
                if (!cellsHost) return;
                this._scrollFn = vueObj.onXScroll.bind(vueObj);
                cellsHost.addEventListener('scroll',  this._scrollFn, { capture: true, passive: true });
                this.__scrollHandlers = { cellsHost };
            });
        },
        bindGridHotkeys() {
            const flex = this.flex,
            vueObj = this;
            if (!flex || this._hotkeysBound) return;
            this._hotkeysBound = true;

            // IE 2026 08 19 / ODOO-5512 (заказ Игоря): Escape В РЕЖИМЕ РЕДАКТИРОВАНИЯ =
            // выйти из инпута и ВЕРНУТЬ старое значение (cancel; до 15.08 было «как
            // Enter»), и НЕ всплывать до платформенного «Escape = закрыть виджет».
            // Capture-фаза — раньше wijmo и обработчика виджета
            flex.hostElement.addEventListener("keydown", (e) => {
                if (e.key === 'Escape' && !e.altKey && flex.activeEditor) {
                    e.preventDefault()
                    e.stopPropagation()
                    flex.finishEditing(true) // true = cancel: старое значение
                }
            }, true)

            flex.hostElement.addEventListener("keydown", (e) => {
                // если сейчас открыт редактор ячейки — не мешаем вводу
                if (flex.activeEditor) return;

                const isMac = this.isMac;
                const mod = isMac ? e.metaKey : e.ctrlKey;
                const hotkey = this.store.normalizeHotkey(e);

                // Delete/Backspace: очистка выделенных ячеек. wijmo штатно чистит
                // обычные типы (через cellEditEnding2), но ПРОПУСКАЕТ те, у которых
                // beginningEdit отменён (AttrCSS/AttrJSON — редактор-дропдаун), а также
                // чекбоксы AttrBool (пустое форматированное значение не проходит
                // truthy-гейт wijmo). Такие ячейки очищаем сами через set_value.
                if ((e.key === 'Delete' || e.key === 'Backspace') && !mod && !e.altKey && !e.shiftKey) {
                    this.clearSelectedCellsFallback()
                    // без preventDefault: wijmo параллельно очистит обычные ячейки
                    // (для них beginningEdit не отменён) / удалит строки как раньше
                }

                // Undo / Redo стандартными сочетаниями, когда активна таблица:
                // Ctrl/Cmd+Z — отменить, Ctrl/Cmd+Shift+Z или Ctrl+Y — повторить.
                // Проверяем e.code (не e.key): на не-латинских раскладках key = 'я'.
                // В режиме РЕДАКТИРОВАНИЯ ячейки сюда не доходим (ранний return
                // выше) — сочетание достаётся редактору и отменяет ввод текста,
                // как в обычном поле; то же для полей дропдауна ячейки.
                if (mod && !e.altKey && (e.code === 'KeyZ' || e.code === 'KeyY')) {
                    const t = e.target
                    const inTextInput = !!t && (t.isContentEditable
                        || t.tagName === 'TEXTAREA'
                        || (t.tagName === 'INPUT' && !['checkbox', 'radio', 'button'].includes(t.type)))
                    if (!inTextInput) {
                        e.preventDefault()
                        e.stopPropagation()
                        if (e.code === 'KeyY' || e.shiftKey) this.redo_Click()
                        else this.undo_Click()
                        return
                    }
                }

                // IE 2026 09 23 / ODOO-341407: i18n (tooltip / title команд)
                const actions = {
                    'button-selector_Click': { name:'button-selector_Click', hotkey: 'Ctrl+/, Ctrl+Enter', autoGeneratedButton:true, 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'tooltip': t('Selector click'),command:'executeVueObjMethod', 'method':'selector_Click', cssClass:'pi pi-check-square' },

                    'button-up_Click': { name:'button-up_Click', hotkey: 'Alt ↑', autoGeneratedButton:true, 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'tooltip': t('Move up'),command:'executeVueObjMethod', 'method':'up_Click', 'cssClass':'pi pi-angle-up p-button-white p-button-text0' },
                    'button-down_Click': { name:'button-down_Click', hotkey: 'Alt ↓', autoGeneratedButton:true, 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'tooltip': t('Move down'),command:'executeVueObjMethod', 'method':'down_Click', 'cssClass':'pi pi-angle-down p-button-white p-button-text0' },
                    'button-left_tab_Click': { name:'button-left_tab_Click', hotkey: 'Alt ←', autoGeneratedButton:true, 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'tooltip': t('Move left'),command:'executeVueObjMethod', 'method':'left_tab_Click', 'cssClass':'pi pi-angle-double-left p-button-white p-button-text0' },
                    'button-right_tab_Click': { name:'button-right_tab_Click', hotkey: 'Alt →', autoGeneratedButton:true, 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'tooltip': t('Move right'),command:'executeVueObjMethod', 'method':'right_tab_Click', 'cssClass':'pi pi-angle-double-right p-button-white p-button-text0' },

                    // ✅ добавлено:
                    'button-new_Click': { name:'button-new_Click', hotkey:'Alt +', autoGeneratedButton:true, 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'tooltip': t('Add {name}', { name: this.attr.binding }), command:'executeVueObjMethod', method:'new_Click', cssClass:'pi pi-plus p-button-white p-button-text0' },
                    'button-clone_Click': { name:'button-clone_Click', hotkey:'Shift Alt ↓', autoGeneratedButton:true, 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'tooltip': t('Clone'), command:'executeVueObjMethod', method:'clone_Click', cssClass:'pi pi-clone p-button-white p-button-text0' },
                    'button-deleteRow_Click': { name:'button-deleteRow_Click', hotkey:'Alt -', autoGeneratedButton:true, 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'tooltip': t('Delete rows'), command:'executeVueObjMethod', method:'delete_Click', visible: !this.attr.isRecords, cssClass:'pi pi-minus p-button-white p-button-text0' },

                    'button-copyRows_Click': { 'attr_type':'AttrButton', 'cssClass':'pi p-button-white pi-copy', 'title': t('Copy rows (JSON)'), hotkey: 'Alt C', 'command': 'copyPaste', 'method':'copyItems', source_name:this.attr.name, 'binding':this.attr.binding },
                    'button-pasteRows_Click': { 'attr_type':'AttrButton', 'cssClass':'pi p-button-white pi-clipboard', 'title': t('Paste rows (JSON)'), hotkey: 'Alt V', 'command': 'copyPaste', 'method':'pasteItems', source_name:this.attr.name, 'binding':this.attr.binding },

                    // Open line
                    'button-openLine': { name:'button-openLine', 'hotKey': 'Alt F2', 'tooltip': t('Open line'), 'action_name':'action-front-openLine-2025-12-27',command:'widget_open', 'widget':'widget-row', '_activate':true, 'get_currentRow':true, 'get_Parent':true, 'open_in_children_widget':true, 'cssClass':'pi p-button-white pi-pencil', source_name:this.attr.name, 'binding':this.attr.binding, attrs:this.attr.attrs, widgetRow_params:this.attr.widgetRow_params }
                };

                if (hotkey === "Alt Enter") { // Alt Enter
                    this.store.runActionForHotKey(this.WIDGET, "Alt Enter", null, { onceEvent: e })   // IE 2026 10 29 / ODOO-5800 (ie-dm7: Alt+Enter — один select): App.vue (capture) уже выполнил клавишу на этом виджете — второго select нет
                } else if (hotkey === "Shift Alt Enter") { // Shift Alt Enter
                    this.store.runActionForHotKey(this.WIDGET, "Shift Alt Enter", null, { onceEvent: e })   // IE 2026 10 29 / ODOO-5800
                }

                // Open line
                if (e.altKey && e.key === "F2") {
                    e.preventDefault();
                    vueObj.store.executeStoreMethod(vueObj.WIDGET.vueObj, actions['button-openLine'], vueObj.attr);
                    return;
                }

                // Open view params (cog)
                if (e.altKey && e.key === "F1") {
                    e.preventDefault();
                    vueObj.onToggle_gridSettings();
                    return;
                }

                // 1) Комментарий (как в редакторах): Ctrl+/ или Cmd+/
                if (mod && e.key === "/") {
                    e.preventDefault();
                    vueObj.store.executeStoreMethod(vueObj.WIDGET.vueObj, { ...actions['button-selector_Click'], metaKey:true }, vueObj.attr);
                    return;
                }
                if (mod && e.key === "Enter") {
                    e.preventDefault();
                    vueObj.store.executeStoreMethod(vueObj.WIDGET.vueObj, { ...actions['button-selector_Click'] }, vueObj.attr);
                    return;
                }

                // ✅ 1.5) Добавить строку: Alt +
                // Важно: на части раскладок это приходит как '=' с shift, а на numpad как 'NumpadAdd'
                if (e.altKey && !e.ctrlKey && !e.metaKey && !e.shiftKey) {
                    if (e.key === "+" || e.key === "=" || e.code === "NumpadAdd" || e.code === "Equal") {
                        e.preventDefault();
                        vueObj.store.executeStoreMethod(vueObj.WIDGET.vueObj, actions['button-new_Click'], vueObj.attr);
                        return;
                    }
                }

                // ✅ 1.6) Удалить строки: Alt -
                if (e.altKey && !e.ctrlKey && !e.metaKey && !e.shiftKey) {
                    // console.log('e.key', e.key, e.code)
                    if (e.key === "-" || e.code === "NumpadSubtract" || e.code === "Minus") {
                        e.preventDefault();
                        vueObj.store.executeStoreMethod(vueObj.WIDGET.vueObj, actions['button-deleteRow_Click'], vueObj.attr);
                        return;
                    }
                }

                // ✅ 1.7) Клон вниз: Shift + Alt + ArrowDown
                // (недоступен, когда строки менять нельзя — как команда Clone в меню Copy)
                if (e.altKey && e.shiftKey && !e.ctrlKey && !e.metaKey) {
                    if (e.key === "ArrowDown") {
                        e.preventDefault();
                        if (!this.get_viewParam('isReadOnly') && !this.attr.readOnlyRows) {
                            vueObj.store.executeStoreMethod(vueObj.WIDGET.vueObj, actions['button-clone_Click'], vueObj.attr);
                        }
                        return;
                    }
                }

                // 2) Перемещение/сдвиг выделенных строк (как в CodeMirror):
                if (e.altKey && !e.ctrlKey && !e.metaKey && !e.shiftKey) {
                    if (e.key === "ArrowUp") {
                        e.preventDefault();
                        vueObj.store.executeStoreMethod(vueObj.WIDGET.vueObj, actions['button-up_Click'], vueObj.attr);
                        return;
                    
                    } else if (e.key === "ArrowDown") {
                        e.preventDefault();
                        vueObj.store.executeStoreMethod(vueObj.WIDGET.vueObj, actions['button-down_Click'], vueObj.attr);
                        return;
                    
                    } else if (e.key === "ArrowLeft") {
                        e.preventDefault();
                        vueObj.store.executeStoreMethod(vueObj.WIDGET.vueObj, actions['button-left_tab_Click'], vueObj.attr);
                        return;
                    
                    } else if (e.key === "ArrowRight") {
                        e.preventDefault();
                        vueObj.store.executeStoreMethod(vueObj.WIDGET.vueObj, actions['button-right_tab_Click'], vueObj.attr);
                        return;
                    
                    } else if (e.code === 'KeyC' || e.key === "ç") {
                        e.preventDefault();
                        e.stopPropagation();
                        vueObj.store.executeStoreMethod(vueObj.WIDGET.vueObj, actions['button-copyRows_Click'], vueObj.attr);
                        return;

                    } else if (e.code === 'KeyV' || e.key === "√") {
                        e.preventDefault();
                        e.stopPropagation();
                        vueObj.store.executeStoreMethod(vueObj.WIDGET.vueObj, actions['button-pasteRows_Click'], vueObj.attr);
                        return;
                    }
                }

                // Shift Alt C → copyItems (copyCell)
                if (e.altKey && e.shiftKey && !e.ctrlKey && !e.metaKey && e.code === 'KeyC') {
                    e.preventDefault();
                    e.stopPropagation();
                    vueObj.store.executeStoreMethod(vueObj.WIDGET.vueObj, { 'attr_type':'AttrButton', 'command':'copyPaste', 'method':'copyItems', method2:'copyCell', source_name:vueObj.attr.name, 'binding':vueObj.attr.binding }, vueObj.attr);
                    return;
                }

                // Ctrl Alt C → copyItems (copyCellFilters)
                if (e.altKey && mod && !e.shiftKey && e.code === 'KeyC') {
                    e.preventDefault();
                    e.stopPropagation();
                    vueObj.store.executeStoreMethod(vueObj.WIDGET.vueObj, { 'attr_type':'AttrButton', 'command':'copyPaste', 'method':'copyItems', method2:'copyCellFilters', source_name:vueObj.attr.name, 'binding':vueObj.attr.binding }, vueObj.attr);
                    return;
                }

                // Shift Ctrl Alt C → copyItems (copyCellAndWidgetsFilters)
                if (e.altKey && mod && e.shiftKey && e.code === 'KeyC') {
                    e.preventDefault();
                    e.stopPropagation();
                    vueObj.store.executeStoreMethod(vueObj.WIDGET.vueObj, { 'attr_type':'AttrButton', 'command':'copyPaste', 'method':'copyItems', method2:'copyCellAndWidgetsFilters', source_name:vueObj.attr.name, 'binding':vueObj.attr.binding }, vueObj.attr);
                    return;
                }

            }, true); // capture=true
        },


        onXScroll(evt) {
            // IE 2026 08 15 / ODOO-4997 (жалоба Игоря п.20): и БЕЗ кастомной
            // фабрики гант-полосы (дети ячеек) теряются при прокрутке — реюз
            // DOM-ячеек сносит их без переформатирования. После остановки
            // скролла на гант-виджете — один полный refresh (возвращает полосы)
            if (!this.attr.use_customCellFactory) {
                clearTimeout(this._scrollTimeout)
                this._scrollTimeout = window.$cg.setTimeout(this, "AttrGrid.onXScroll", () => {
                    if (this._hasGanttData === undefined) {
                        const kids = this.attr.childItemsPath || 'attrs'
                        let has = false
                        const scanG = (it) => {
                            if (it?.$gantt) { has = true; return }
                            for (const k of it?.[kids] || []) { scanG(k); if (has) return }
                        }
                        for (const r of (this.data000 || this.data || [])) { scanG(r); if (has) break }
                        this._hasGanttData = has
                    }
                    if (this._hasGanttData) this.flexRefresh()
                }, 120)
                return
            }
            if (this.attr.use_customCellFactory) {
                this.isScrolling = true
                const t   = evt.target;
                const dx  = t.scrollLeft - this.lastScroll.left;
                const dy  = t.scrollTop  - this.lastScroll.top;
                this.isScrollingX = Math.abs(dy) === 0;
                this.lastScroll.left = t.scrollLeft;
                this.lastScroll.top  = t.scrollTop;
                // if (!this.isScrollingX) {
                //     this.flex.cellFactory.unfixFromCurrentPlaceAll()
                // }

                clearTimeout(this._scrollTimeout);
                this._scrollTimeout = window.$cg.setTimeout(this, "AttrGrid.onXScroll", () => {
                    this.isScrolling = false
                    this.isScrollingX = false
                    if (this.flex.cellFactory?._deferred?.size) {
                        this.flex.cellFactory._flush?.();
                    }
                    if (this.deferred_formatItem.size) {
                        this.flex.cellFactory._flush_formatItem?.();
                    }
                    this.flex.cellFactory.unfixFromCurrentPlaceAll?.()
                    // IE 2026 08 15 / ODOO-4997 (жалоба Игоря п.20): гант-полосы —
                    // ДЕТИ ячеек, реюз ячеек при прокрутке их сносит, а отложенный
                    // догон не восстанавливает (219 → 0 полос после скролла
                    // вправо-влево). На гант-виджете после остановки скролла —
                    // один полный refresh видимых ячеек (возвращает все полосы)
                    if (this._hasGanttData === undefined) {
                        const kids = this.attr.childItemsPath || 'attrs'
                        let has = false
                        const scanG = (it) => {
                            if (it?.$gantt) { has = true; return }
                            for (const k of it?.[kids] || []) { scanG(k); if (has) return }
                        }
                        for (const r of (this.data000 || this.data || [])) { scanG(r); if (has) break }
                        this._hasGanttData = has
                    }
                    if (this._hasGanttData) this.flexRefresh()
                }, 50);
            }
        },
        calc_left(panel, col, paddingLeft) {
            let left = -this.flex.scrollPosition.x + (paddingLeft || 0);
            for (let col_ = 0; col_ < col; col_++) {
                left += panel.columns[col_].width || panel.columns[col_].renderWidth;
            }
            // left = Math.round(left * 2) / 2; 
            return left // .toFixed(0)
        },
        // IE 2026 09 04 / ODOO-336291 (mobile UX): B-24 settingsEditable — грид полей (AttrTabGrid: форма настроек / записи) редактируется и на телефоне:
        // исключение из readOnlyGrids; хост помечен data-mob-editable — режим просмотра (Widget.vue mobGridBrowseInit)
        // не перехватывает тапы по нему. Выкл: window.mobileUi.set('settingsEditable', false)
        mobileEditableGrid() {
            return this.store.mobileUi?.settingsEditable !== false && this.attr?.attr_type === 'AttrTabGrid'
        },
        // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк): граница frozen по значению attr.frozenColumns, уже сдвинутому колонками переводов (i18nFields_frozenShift), — ровно как её ставит грид:
        // телефон (B-22 stickyFirstCol — одна колонка), клэмп «граница не режет группу колонок» (только при головной незагруппированной зоне; ВСЕ колонки
        // в группах — карточка записи: юзер сознательно фризит внутри группы). Общая для сборки, set_frozenColumns и меню колонки (пункт, который клэмп обнулит, не показываем)
        // _fz — уже со сдвигом колонками переводов (i18nFields_frozenShift); сигнатура без хвоста — её находит tests/unit/i18nListCols.test.mjs
        frozenColumns_clamp(_fz, flex = this.flex) {
            if (!flex) return _fz
            if (this.store.mobileUi?.on) _fz = (this.store.mobileUi.stickyFirstCol !== false && _fz > 0) ? 1 : 0   // IE 2026 09 04 / ODOO-336291 (mobile UX): B-22 stickyFirstCol
            let _headZone = 0
            while (_headZone < flex.columns.length && !flex.columns[_headZone]?.parentGroup) _headZone++
            if (_fz > 0 && _fz < flex.columns.length && _headZone > 0) {
                const _chainOf = (i) => {
                    const st = new Set()
                    for (let g = flex.columns[i]?.parentGroup; g; g = g.parentGroup) st.add(g)
                    return st
                }
                const _sameGroup = (a, b) => {
                    if (a < 0 || b >= flex.columns.length) return null
                    const A = _chainOf(a)
                    for (let g = flex.columns[b]?.parentGroup; g; g = g.parentGroup) if (A.has(g)) return g
                    return null
                }
                let _guard = flex.columns.length
                while (_fz > 0 && _guard-- > 0 && _sameGroup(_fz - 1, _fz)) _fz--
            }
            return _fz
        },
        set_frozenColumns() {
            // живая правка параметра (View params → Frozen columns): пересчитать
            // клэмп и применить к гриду. Раньше биндинг шёл напрямую с
            // attr.frozenColumns (реактивно); после ввода frozenColumns_safe
            // значение из билда перекрывало новое — фиксация «не отрабатывала»
            const flex = this.flex
            if (flex) {
                // IE 2026 08 20 / ODOO-336291 (mobile UX) (#4190): на телефоне фиксация колонок съедает экран — отключена
                let _fz = this.i18nFields_frozenShift(this.attr.frozenColumns || 0)   // IE 2026 10 06 / ODOO-341407: + колонки переводов «(uk)/(ru)» левее границы (attr.frozenColumns не меняется)
                const _fz0 = _fz   // IE 2026 10 06 / ODOO-341407: граница до клэмпа (сдвиг колонками переводов — не клэмп)
                _fz = this.frozenColumns_clamp(_fz, flex)   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк): телефон и клэмп вынесены в frozenColumns_clamp
                if (_fz !== _fz0) {   // IE 2026 10 06 / ODOO-341407: было (this.attr.frozenColumns || 0)
                    // клэмп подвинул границу — видимая диагностика вместо тихого «не работает»
                    console.warn(`[frozen] w${this.WIDGET?.id ?? '?'} clamp: ${this.attr.frozenColumns} → ${_fz} (граница резала группу колонок)`)
                }
                this.frozenColumns_safe = _fz
                if (flex.frozenColumns !== _fz) flex.frozenColumns = _fz
            }
            // const breakPaddingLeft = 5, breakCollapseWidth = 12
            // const header_width = 55
            
            // // break-left
            // // frozenColumns - background
            // this.mask_left?.remove()
            // if (this.attr.frozenColumns) { 
            //     const rows = this.flex?.rows ?? [];
            //     const maxLevel = rows.length > 0
            //         ? Math.max(...rows.map(row => row.level ?? 0))
            //         : 0;

            //     const gridElement = this.$refs.attr_container // document.querySelector('.wj-flexgrid')
            //     if (gridElement) {
            //         this.mask_left = document.createElement('div')
            //         this.mask_left.className = 'grid-mask-left'
            //         this.mask_left.width = `${header_width + breakPaddingLeft + maxLevel * breakCollapseWidth}px`;
            //         gridElement.appendChild(this.mask_left)
            //     }
            // }
        },
        // ══ IE 2026 09 09 / ODOO-… (заказ Игоря): перетаскивание строк при зажатом Alt ══
        // Alt + захват ячейки → режим drag: едут строки диапазона выделения (если захваченная строка в нём), иначе
        // одна строка; вложенные — внутри родителя. Пока тянем — оверлеи в хосте грида показывают место падения:
        //   • между строками — линия вставки на уровне, выбранном по X (отступ дерева), и рамка ГРУППЫ
        //     (родитель + его видимые потомки), в которую попадёт элемент;
        //   • середина строки — рамка вокруг самой строки (+ её потомков) и линия на уровне ребёнка: строки станут
        //     подчинёнными этой строки, даже если детей у неё ещё нет (в конец её списка).
        // Перенос — теми же примитивами, что кнопки ↑ ↓ « » (cut_selectedRanges → splice → hist_push → refresh),
        // поэтому Ctrl+Z работает. Esc — отмена. Alt+клик без движения не трогаем (открытие по значению).
        // Недоступно: read-only грид (isReadOnly / readOnlyRows). IE 2026 09 10 / ODOO-…: в дереве по чипсу Parent (CHIP-Tree,
        // childItemsPath '_childs') перенос = смена реквизита parent + перенумерация order (rowDrag_dropTree, без Undo — как « »).
        // Выключатель: window.feSettings.set('fe.ux.rowDrag', false).
        rowDrag_install() {
            const flex = this.flex
            if (!flex?.hostElement || this._rowDragInstalled) return
            this._rowDragInstalled = true
            flex.hostElement.addEventListener('mousedown', (e) => this.rowDrag_mousedown(e), true)
            // клик, порождённый mouseup после переноса, не должен дойти ни до Alt+клика «открыть по значению», ни до wijmo
            flex.hostElement.addEventListener('click', (e) => {
                if (!this._rowDragSwallowClick) return
                this._rowDragSwallowClick = false
                e.preventDefault(); e.stopPropagation()
            }, true)
        },
        rowDrag_enabled() {
            if (!this.flex || !this.attr) return false
            try { if (this.store?.setting?.('fe.ux.rowDrag', true) === false) return false } catch (e) { /* нет настройки */ }
            // IE 2026 09 10 / ODOO-…: дерево настроек виджета (панель Settings tree) — строки read-only, перенос идёт через бэк (rowDrag_dropSettings)
            if (this.rowDrag_isSettingsList()) return true
            if (this.attr.readOnlyRows) return false
            // IE 2026 09 10 / ODOO-…: дерево по чипсу Parent (CHIP-Tree, _childs) — перенос меняет parent/order записей, как правка ячеек:
            // доступен, пока сам грид редактируемый (viewParam isReadOnly у списков записей true до первой правки)
            if (this.attr.childItemsPath === '_childs') return !this.flex.isReadOnly
            return !this.get_viewParam('isReadOnly')   // плоские строки / дерево attrs — как кнопки ↑ ↓ « »
        },
        rowDrag_isSettingsList() {
            return this.attr?.name === 'settings-list' && this.attr.childItemsPath === '_childs'
        },
        rowDrag_mousedown(e) {
            if (!e.altKey || e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey) return
            const flex = this.flex
            if (!this.rowDrag_enabled() || flex.activeEditor) return
            // не перехватываем только настоящие контролы (кнопка свёртки, чекбокс, поля ввода); иконка-ссылка и текст —
            // обычная точка захвата (клик по иконке после переноса гасится в rowDrag_install)
            if (e.target?.closest?.('button, .wj-elem-collapse, input, textarea, select')) return
            let ht
            try { ht = flex.hitTest(e) } catch (err) { return }
            if (!ht || ht.cellType !== wjGrid.CellType.Cell || ht.row < 0) return
            const row = flex.rows[ht.row]
            if (!row?.dataItem || row.visible === false) return
            // источник: диапазон выделения, если захваченная строка в нём, иначе — одна она
            let r1 = ht.row, r2 = ht.row
            const sel = flex.selectedRanges?.[0]
            if (sel?.isValid && sel.topRow <= ht.row && ht.row <= sel.bottomRow) { r1 = sel.topRow; r2 = sel.bottomRow }
            this._rowDragTC = this.rowDrag_treeCol()
            const picked = []
            for (let r = r1; r <= r2; r++) {
                const rw = flex.rows[r]
                if (rw?.dataItem && rw.visible !== false && rw.dataItem?._fe?.visible !== false) picked.push({ item: rw.dataItem, r })
            }
            // вложенные в другой выделенный элемент едут внутри родителя (как в hist_snapshotSelection)
            const top = picked.filter(p => !picked.some(o => o !== p && this.hist_contains(o.item, p.item)))
            if (!top.length) return
            e.preventDefault(); e.stopPropagation()
            const d = this._rowDrag = {
                r1, r2, row: ht.row, col: ht.col, items: top.map(p => p.item), titles: top.map(p => this.rowDrag_cellText(p.r)),
                x0: e.clientX, y0: e.clientY, x: e.clientX, y: e.clientY, started: false, target: null, raf: null,
            }
            d.onMove = (ev) => this.rowDrag_move(ev)
            d.onUp = (ev) => this.rowDrag_end(ev)
            d.onKey = (ev) => { if (ev.key === 'Escape') { ev.preventDefault(); ev.stopPropagation(); this.rowDrag_cancel() } }
            document.addEventListener('mousemove', d.onMove, true)
            document.addEventListener('mouseup', d.onUp, true)
            document.addEventListener('keydown', d.onKey, true)
        },
        rowDrag_move(ev) {
            const d = this._rowDrag
            if (!d) return
            d.x = ev.clientX; d.y = ev.clientY
            if (!d.started) {
                if (Math.abs(d.x - d.x0) + Math.abs(d.y - d.y0) < 4) return
                d.started = true
                document.body.classList.add('row-drag-active')
                this.rowDrag_ghost(true)
            }
            ev.preventDefault()
            if (!d.raf) d.raf = requestAnimationFrame(() => { d.raf = null; this.rowDrag_update() })
        },
        rowDrag_update() {
            const d = this._rowDrag, flex = this.flex
            if (!d || !d.started) return
            if (!flex?.hostElement?.isConnected) { this.rowDrag_cancel(); return }
            // автопрокрутка у верхнего/нижнего края области ячеек — пока курсор у края, крутим кадр за кадром
            let scrolled = false
            try {
                const rc = flex.hostElement.querySelector('[wj-part="root"]')?.getBoundingClientRect(), sp = flex.scrollPosition
                const cr = flex.cells.hostElement.getBoundingClientRect()
                const top = Math.max(cr.top, rc?.top ?? cr.top), bottom = Math.min(cr.bottom, rc?.bottom ?? cr.bottom)
                if (d.y < top + 22 && d.y > top - 60 && sp.y < 0) { flex.scrollPosition = { x: sp.x, y: Math.min(0, sp.y + 12) }; scrolled = true }
                else if (d.y > bottom - 22 && d.y < bottom + 60) { const before = sp.y; flex.scrollPosition = { x: sp.x, y: sp.y - 12 }; scrolled = flex.scrollPosition.y !== before }
            } catch (e) { /* грид перестраивается */ }
            try { d.target = this.rowDrag_target(d.x, d.y) } catch (e) { d.target = null }
            this.rowDrag_render(d.target)
            this.rowDrag_ghost()
            if (scrolled && !d.raf) d.raf = requestAnimationFrame(() => { d.raf = null; this.rowDrag_update() })
        },
        rowDrag_treeCol() {
            // кнопки дерева wijmo рисует в ПЕРВОЙ видимой колонке (см. ensureTreeColMinWidth) — там же отступ уровня
            const cols = this.flex.columns
            for (let c = 0; c < cols.length; c++) if (cols[c].visible !== false) return c
            return 0
        },
        rowDrag_rowRect(r) {
            const rc = this.flex.getCellBoundingRect(r, this._rowDragTC ?? this.rowDrag_treeCol())
            return { top: rc.top, bottom: rc.top + rc.height, left: rc.left }
        },
        rowDrag_lastDescendant(r) {
            // последняя ВИДИМАЯ строка поддерева r (или сама r)
            const rows = this.flex.rows, lv = rows[r].level ?? 0
            let last = r
            for (let i = r + 1; i < rows.length; i++) {
                if ((rows[i].level ?? 0) <= lv) break
                if (rows[i].visible !== false && rows[i].dataItem) last = i
            }
            return last
        },
        rowDrag_ancestorAt(r, level) {
            const rows = this.flex.rows
            for (let i = r; i >= 0; i--) if ((rows[i].level ?? 0) === level && rows[i].dataItem) return i
            return -1
        },
        rowDrag_cellText(r) {
            const flex = this.flex, c = this._rowDragTC ?? this.rowDrag_treeCol()
            let text
            try { text = flex.getCellData(r, c, false) } catch (e) { text = null }
            const attr_col = this.attr_by_binding?.[flex.columns[c]?.binding]
            if (attr_col?.attr_type === 'AttrLink' && text != null && typeof text !== 'object') {
                const V = { value: text }
                try { this.store.get_valueStr(this, V, attr_col); text = V.valueStr } catch (e) { /* как есть */ }
            }
            if (text && typeof text === 'object') text = text.valueStr ?? text.title ?? text.value ?? ''
            if (text == null || text === '') { const it = flex.rows[r]?.dataItem; text = it?.title ?? it?.name ?? it?.id ?? '' }
            return String(text).replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim().slice(0, 60)
        },
        rowDrag_target(x, y) {
            const flex = this.flex, rows = flex.rows, d = this._rowDrag
            const child = this.attr.childItemsPath
            let cr, root
            try { cr = flex.cells.hostElement.getBoundingClientRect(); root = flex.hostElement.querySelector('[wj-part="root"]')?.getBoundingClientRect() } catch (e) { return null }
            const area = root || cr
            if (x < area.left - 60 || x > area.right + 60 || y < area.top - 6 || y > area.bottom + 6) return null
            const lvl = (r) => (rows[r].level ?? 0)
            const isData = (r) => r >= 0 && r < rows.length && rows[r].visible !== false && !!rows[r].dataItem
            const prevVis = (r) => { for (let i = r - 1; i >= 0; i--) if (isData(i)) return i; return -1 }
            const nextVis = (r) => { for (let i = r + 1; i < rows.length; i++) if (isData(i)) return i; return -1 }
            let ht = null
            try { ht = flex.hitTest(x, y) } catch (e) { ht = null }
            const hitR = (ht && (ht.cellType === wjGrid.CellType.Cell || ht.cellType === wjGrid.CellType.RowHeader) && isData(ht.row)) ? ht.row : -1
            let A = -1, B = -1, into = -1, refRect = null
            if (hitR >= 0) {
                const rc = this.rowDrag_rowRect(hitR)
                refRect = rc
                const frac = (y - rc.top) / Math.max(1, rc.bottom - rc.top)
                if (child && frac >= 0.3 && frac <= 0.7) into = hitR
                else if (frac < 0.5) { B = hitR; A = prevVis(hitR) }
                else { A = hitR; B = nextVis(hitR) }
            } else {
                let lastR = -1
                for (let i = rows.length - 1; i >= 0; i--) if (isData(i)) { lastR = i; break }
                if (lastR < 0) return null
                const rc = this.rowDrag_rowRect(lastR)
                if (y >= rc.bottom) { A = lastR; B = -1; refRect = rc } else return null
            }
            const moved = d.items
            const isMoved = (item) => moved.includes(item) || moved.some(m => this.hist_contains(m, item))
            if (into >= 0) {
                const p = rows[into].dataItem
                const lastR = this.rowDrag_lastDescendant(into)
                return { kind: 'into', valid: !isMoved(p), parentR: into, parentItem: p, level: lvl(into) + 1, lastR,
                    title: this.rowDrag_cellText(into), left: refRect.left }
            }
            // граница между A (выше) и B (ниже): уровни-кандидаты, от глубокого к мелкому
            const la = A >= 0 ? lvl(A) : -1, lb = B >= 0 ? lvl(B) : -1
            let levels
            if (!child) levels = [0]
            else if (A < 0) levels = [Math.max(0, lb)]
            else if (B < 0) { levels = []; for (let L = la; L >= 0; L--) levels.push(L) }
            else if (lb > la) levels = [lb]
            else { levels = []; for (let L = la; L >= lb; L--) levels.push(L) }
            const ind = flex.treeIndent || 14
            let L = levels[0]
            if (levels.length > 1) {
                const want = Math.round((x - (refRect.left + 4)) / ind)
                L = Math.max(levels[levels.length - 1], Math.min(levels[0], want))
            }
            let anchorBefore = null, anchorAfter = null, parentR = -1
            if (B >= 0 && lb === L) anchorBefore = rows[B].dataItem
            else if (A >= 0) { const ar = this.rowDrag_ancestorAt(A, L); if (ar >= 0) anchorAfter = rows[ar].dataItem }
            if (L > 0) parentR = this.rowDrag_ancestorAt(A >= 0 ? A : B, L - 1)
            const parentItem = parentR >= 0 ? rows[parentR].dataItem : null
            let valid = !(parentItem && isMoved(parentItem)) && !(anchorBefore && isMoved(anchorBefore)) && !(anchorAfter && isMoved(anchorAfter))
                && !!(anchorBefore || anchorAfter || !child)
            if (valid && parentR < 0 && this.rowDrag_isSettingsList()) valid = false   // IE 2026 09 10 / ODOO-…: вне корня дерева настроек — нельзя
            const yLine = B >= 0 ? this.rowDrag_rowRect(B).top : this.rowDrag_rowRect(A).bottom
            const pos = anchorBefore ? t('before «{title}»', { title: this.rowDrag_cellText(B) }) : (anchorAfter ? t('after «{title}»', { title: this.rowDrag_cellText(this.rowDrag_ancestorAt(A, L)) }) : t('at the end'))   // IE 2026 09 23 / ODOO-341407: i18n
            return { kind: 'between', valid, level: L, parentR, parentItem, anchorBefore, anchorAfter, A, B, y: yLine, left: refRect.left,
                parentTitle: parentR >= 0 ? this.rowDrag_cellText(parentR) : '', pos }
        },
        rowDrag_els() {
            const host = this.flex.hostElement
            if (!this._rowDragEls || !this._rowDragEls.line.isConnected) {
                if (getComputedStyle(host).position === 'static') host.style.position = 'relative'
                const mk = (cls) => { const el = document.createElement('div'); el.className = cls; el.style.display = 'none'; host.appendChild(el); return el }
                this._rowDragEls = { group: mk('row-drag-group'), line: mk('row-drag-line') }
            }
            return this._rowDragEls
        },
        rowDrag_render(t) {
            const flex = this.flex, els = this.rowDrag_els()
            const hide = () => { els.group.style.display = 'none'; els.line.style.display = 'none' }
            if (!t) { hide(); return }
            const rows = flex.rows, ind = flex.treeIndent || 14
            const hostRect = flex.hostElement.getBoundingClientRect()
            const rootEl = flex.hostElement.querySelector('[wj-part="root"]')
            const rootRect = rootEl ? rootEl.getBoundingClientRect() : hostRect
            const cr = flex.cells.hostElement.getBoundingClientRect()
            // клиппинг: только область ячеек внутри видимой части (без шапки и полос прокрутки)
            const clipTop = Math.max(cr.top, rootRect.top), clipBottom = Math.min(cr.bottom, rootRect.top + (rootEl ? rootEl.clientHeight : rootRect.height))
            const rightAbs = rootRect.left + (rootEl ? rootEl.clientWidth : rootRect.width) - 2
            const lvl = (r) => (rows[r].level ?? 0)
            const placeBox = (el, top, bottom, left) => {
                top = Math.max(clipTop, top); bottom = Math.min(clipBottom, bottom)
                if (bottom - top < 4) { el.style.display = 'none'; return }
                el.style.display = ''
                el.style.top = (top - hostRect.top) + 'px'; el.style.height = (bottom - top) + 'px'
                el.style.left = (left - hostRect.left) + 'px'; el.style.width = Math.max(0, rightAbs - left) + 'px'
            }
            const placeLine = (y, left) => {
                if (y < clipTop - 1 || y > clipBottom + 1) { els.line.style.display = 'none'; return }
                els.line.style.display = ''
                els.line.style.top = (y - hostRect.top - 1) + 'px'
                els.line.style.left = (left - hostRect.left) + 'px'; els.line.style.width = Math.max(0, rightAbs - left) + 'px'
            }
            for (const el of [els.group, els.line]) el.classList.toggle('row-drag-invalid', !t.valid)
            els.group.classList.toggle('row-drag-into', t.kind === 'into')
            if (t.kind === 'into') {
                const r0 = this.rowDrag_rowRect(t.parentR), r1 = this.rowDrag_rowRect(t.lastR)
                placeBox(els.group, r0.top - 1, r1.bottom + 1, r0.left + ind * lvl(t.parentR))
                const row = rows[t.parentR]
                if (!row.hasChildren || !row.isCollapsed) placeLine(r1.bottom, r0.left + ind * t.level + 2)
                else els.line.style.display = 'none'
                return
            }
            if (t.parentR >= 0) {
                const r0 = this.rowDrag_rowRect(t.parentR), r1 = this.rowDrag_rowRect(this.rowDrag_lastDescendant(t.parentR))
                placeBox(els.group, r0.top - 1, Math.max(r1.bottom, t.y) + 1, r0.left + ind * lvl(t.parentR))
            } else els.group.style.display = 'none'
            placeLine(t.y, t.left + ind * t.level + 2)
        },
        rowDrag_ghost(create) {
            const d = this._rowDrag
            if (!d) return
            let g = this._rowDragGhost
            if (create || !g) {
                if (!g) { g = this._rowDragGhost = document.createElement('div'); g.className = 'row-drag-ghost'; document.body.appendChild(g) }
                const titles = d.titles.slice(0, 3).map(t => `<div>${wjcCore.escapeHtml(t || '…')}</div>`).join('')
                // IE 2026 09 23 / ODOO-341407: i18n (t здесь — цель перетаскивания, словарь — this.t)
                const more = d.items.length > 3 ? `<div class="rdg-more">${this.t('+{n} more', { n: d.items.length - 3 })}</div>` : ''
                g.innerHTML = `<div class="rdg-rows">${titles}${more}</div><div class="rdg-hint"></div>`
            }
            g.style.left = (d.x + 14) + 'px'; g.style.top = (d.y + 12) + 'px'
            const t = d.target, hint = g.querySelector('.rdg-hint')
            let text = this.t('No drop target')
            if (t && !t.valid) text = this.t('Cannot drop inside the dragged rows')
            else if (t?.kind === 'into') text = this.t('As children of «{title}»', { title: t.title })
            else if (t) text = (t.parentTitle ? this.t('Into «{title}»', { title: t.parentTitle }) : this.t('Top level')) + ' · ' + t.pos
            if (hint && hint.textContent !== text) hint.textContent = text
            g.classList.toggle('rdg-invalid', !t || !t.valid)
        },
        rowDrag_teardown() {
            const d = this._rowDrag
            if (!d) return
            document.removeEventListener('mousemove', d.onMove, true)
            document.removeEventListener('mouseup', d.onUp, true)
            document.removeEventListener('keydown', d.onKey, true)
            if (d.raf) cancelAnimationFrame(d.raf)
            document.body.classList.remove('row-drag-active')
            if (this._rowDragEls) { this._rowDragEls.group.style.display = 'none'; this._rowDragEls.line.style.display = 'none' }
            if (this._rowDragGhost) { this._rowDragGhost.remove(); this._rowDragGhost = null }
            this._rowDrag = null
        },
        rowDrag_swallowNextClick() {
            this._rowDragSwallowClick = true
            setTimeout(() => { this._rowDragSwallowClick = false }, 400)
        },
        rowDrag_cancel() {
            const started = !!this._rowDrag?.started
            this.rowDrag_teardown()
            if (started) this.rowDrag_swallowNextClick()
        },
        rowDrag_end(ev) {
            const d = this._rowDrag
            if (!d) return
            this.rowDrag_teardown()
            if (!d.started) {
                // Alt+клик без движения: выделить ячейку, как сделал бы wijmo (его mousedown мы перехватили)
                try { this.flex.select(new wjGrid.CellRange(d.row, d.col), true) } catch (e) { /* грид перестроен */ }
                return
            }
            ev?.preventDefault?.()
            this.rowDrag_swallowNextClick()
            const t = d.target
            if (!t || !t.valid) return
            this.rowDrag_drop(d, t)
        },
        async rowDrag_dropSettings(d, t) {
            // IE 2026 09 10 / ODOO-… (заказ Игоря): панель Settings tree — строки списка суть узлы parents_tree (id/segment); перенос идёт
            // тем же путём, что drag&drop в старом дереве дропдауна: store.move_settingsTreeNode → бэк move_record
            // (position inside/before/after; права проверяет бэк), в ответе — новое parents_tree → список перестраивается
            const flex = this.flex, W = this.WIDGET, wv = W?.attrs_vueObj?.WIDGET || W?.vueObj
            if (!wv || typeof this.store.move_settingsTreeNode !== 'function') return
            flex.selectedRanges = [new wjGrid.CellRange(d.r1, 0, d.r2, Math.max(0, flex.columns.length - 1))]
            const sel = this.treeSiblings_selected(this.treeParentItems_of(d.row)).filter(it => it?.id && !it.is_main)
            if (window.__rowDragDbg) console.warn('[rowDrag] settings drop', JSON.stringify({ kind: t.kind, sel: sel.map(x => x.id), parent: t.parentItem?.id, before: t.anchorBefore?.id, after: t.anchorAfter?.id, r: [d.r1, d.r2, d.row] }))   // диагностика: window.__rowDragDbg = true
            if (!sel.length) return
            const node = (it) => ({ id: it.id, segment: it.segment || it._node?.segment || W.record?.segment || 'WIDGET', title: it.title?.valueStr || it.title || it.id })
            let plan
            if (t.kind === 'into') plan = sel.map(it => [it, t.parentItem, 'inside'])
            else if (t.anchorBefore) plan = sel.map(it => [it, t.anchorBefore, 'before'])
            else if (t.anchorAfter) plan = [...sel].reverse().map(it => [it, t.anchorAfter, 'after'])
            else return
            for (const [it, target, position] of plan) {
                if (!target?.id || target === it) continue
                if (window.__rowDragDbg) console.warn('[rowDrag] move_settingsTreeNode', it.id, position, target.id)
                await this.store.move_settingsTreeNode(wv, node(it), node(target), position)
            }
            try { wv.settingsList_rebuild?.('settings') } catch (e) { /* панель могла закрыться */ }
        },
        rowDrag_dropTree(d, t) {
            // IE 2026 09 10 / ODOO-… (заказ Игоря): CHIP-Tree — дерево по чипсу Parent собирает фронт (build_treeByParent), строки в
            // data000 плоские. Перенос = смена реквизита parent у перенесённых строк (+ перенумерация order обоих
            // родителей — как кнопки « », treeReparent_): строки помечаются изменёнными, дискетка сохраняет parent/order,
            // после обновления иерархия та же. Между строками — позиция среди сиблингов (order = индекс + 1),
            // середина строки — в конец её детей. Undo нет (как у кнопок).
            const flex = this.flex
            const keyOf = (item) => String(item?.id ?? item?.name ?? '')
            flex.selectedRanges = [new wjGrid.CellRange(d.r1, 0, d.r2, Math.max(0, flex.columns.length - 1))]
            const oldArr = this.treeParentItems_of(d.row)
            const sel = this.treeSiblings_selected(oldArr)   // только сиблинги захваченной строки (как у кнопок)
            if (!sel.length) return
            const roots = flex.collectionView?.sourceCollection || this.data000
            let newArr, parentValue, anchorBefore = null, anchorAfter = null
            if (t.kind === 'into') {
                const p = t.parentItem
                if (!p || !keyOf(p)) return
                newArr = p._childs = p._childs || []
                parentValue = keyOf(p)
            } else {
                const p = t.parentItem
                if (p && !keyOf(p)) return
                newArr = p ? (p._childs = p._childs || []) : roots
                parentValue = p ? keyOf(p) : ''
                anchorBefore = t.anchorBefore; anchorAfter = t.anchorAfter
            }
            // индекс вставки — по массиву БЕЗ переносимых: treeReparent_ сначала изымает их (при oldArr === newArr индексы сдвигаются)
            const rest = newArr.filter(x => !sel.includes(x))
            let insertIdx = null
            if (anchorBefore) insertIdx = rest.indexOf(anchorBefore)
            else if (anchorAfter) insertIdx = rest.indexOf(anchorAfter) + 1
            if (insertIdx !== null && insertIdx < 0) insertIdx = null
            // плоский data000: переносимые — рядом с якорем, чтобы пересборка дерева без чипса Order показала их на месте падения
            const flat = this.data000
            if (Array.isArray(flat) && flat !== newArr && flat !== oldArr) {
                for (const it of sel) { const i = flat.indexOf(it); if (i >= 0) flat.splice(i, 1) }
                let fi = flat.length
                if (anchorBefore && flat.includes(anchorBefore)) fi = flat.indexOf(anchorBefore)
                else if (anchorAfter && flat.includes(anchorAfter)) fi = flat.indexOf(anchorAfter) + 1
                else if (t.kind === 'into' && flat.includes(t.parentItem)) {
                    const lastItem = flex.rows[this.rowDrag_lastDescendant(t.parentR)]?.dataItem
                    fi = (lastItem && flat.includes(lastItem) ? flat.indexOf(lastItem) : flat.indexOf(t.parentItem)) + 1
                }
                flat.splice(Math.min(fi, flat.length), 0, ...sel)
            }
            const parentItem = t.parentItem || null
            this.treeReparent_(sel, oldArr, newArr, insertIdx, parentValue)
            if (parentItem) this.$nextTick(() => this.$nextTick(() => {
                try {
                    const r = this.rows_indexOf(parentItem), row = r >= 0 ? this.flex.rows[r] : null
                    if (row?.hasChildren && row.isCollapsed) { row.isCollapsed = false; this.selected_items(sel) }
                } catch (e) { /* грид перестроен */ }
            }))
        },
        rowDrag_drop(d, t) {
            const flex = this.flex, child = this.attr.childItemsPath
            if (this.rowDrag_isSettingsList()) return this.rowDrag_dropSettings(d, t)   // IE 2026 09 10 / ODOO-…
            if (child === '_childs') return this.rowDrag_dropTree(d, t)   // IE 2026 09 10 / ODOO-…
            // выделение = диапазон источника (его режет cut_selectedRanges), дальше — как у кнопок ↑ ↓ « »
            flex.selectedRanges = [new wjGrid.CellRange(d.r1, 0, d.r2, Math.max(0, flex.columns.length - 1))]
            const fromPositions = this.hist_snapshotSelection()
            const moved = this.cut_selectedRanges()
            if (!moved.length) return
            let arr = null, index = null
            if (t.kind === 'into') {
                const p = t.parentItem
                if (!p[child]) p[child] = []
                arr = p[child]; index = arr.length
            } else if (t.anchorBefore) {
                const loc = this.hist_locate(t.anchorBefore)
                if (loc) { arr = loc.arr; index = loc.index }
            } else if (t.anchorAfter) {
                const loc = this.hist_locate(t.anchorAfter)
                if (loc) { arr = loc.arr; index = loc.index + 1 }
            } else if (!child) {
                arr = this.data000; index = arr.length
            }
            if (!arr || index === null) { this.hist_applyRows(fromPositions); this.refresh(moved, false); return }   // цель потеряна — вернуть как было
            arr.splice(index, 0, ...moved)
            // IE 2026 09 23 / ODOO-341407: i18n (t здесь — цель перетаскивания, словарь — this.t / this.tn)
            const n = moved.length > 1 ? this.tn(moved.length, '{n} row', '{n} rows') : this.t('row')
            this.hist_push({
                method: 'rows', kind: 'move', from: fromPositions, to: this.hist_positionsOf(moved),
                label: t.kind === 'into' ? this.t('Drag {what} into «{title}»', { what: n, title: t.title }) : (t.parentTitle ? this.t('Drag {what} into «{title}»', { what: n, title: t.parentTitle }) : this.t('Drag {what} (top level)', { what: n })),
            })
            const parentItem = t.parentItem || null
            this.refresh(moved)
            this.attr_set()
            if (this.WIDGET.widget === 'widget-selectors') {
                this.store.sync_WORKSPACE(this.WIDGET, '>>WORKSPACE')
            }
            this.run_attr_action_afterChange()
            // родитель-цель раскрыт — перенесённые строки видны сразу
            if (parentItem && child) this.$nextTick(() => this.$nextTick(() => {
                try {
                    const r = this.rows_indexOf(parentItem), row = r >= 0 ? this.flex.rows[r] : null
                    if (row?.hasChildren && row.isCollapsed) { row.isCollapsed = false; this.selected_items(moved) }
                } catch (e) { /* грид перестроен */ }
            }))
        },
        // ---- IE 2026 10 12 / ODOO-345618 (заказ Игоря: чекбокс у выделенной булевой ячейки) ----
        // Колонка AttrBool: wijmo рисует снятый чекбокс, formatItem (кэш-путь и formatItem_cells) его стирает — у false видна пустая ячейка, переключить мышью нечем.
        // Выделенная (активная: flex.selection.row/col) ячейка, которую можно править (грид / колонка / строка не только чтение — flex.canEditCell, роль не read-only,
        // is_editable: класс editable / открытый флажок согласования / условный формат isReadOnly / замок согласования), держит снятый input.wj-cell-check —
        // клик по нему переключает значение штатным путём wijmo (_click → beginningEdit → cellEditEnding), как у отмеченных. Ушло выделение — снова пусто.
        // Выбор ячейки formatItem не вызывает: selectionChanged → boolSel_sync точечно чинит старую и новую ячейку (не весь грид). Элемент помечен __boolSel —
        // переиспользованный wijmo под другую строку (прокрутка, кэш-путь) снимает свой input на следующем formatItem.
        // Выключатель fe.ux.boolSelectedCheckbox (по умолчанию ВКЛ; выкл — как до правки). Счётчик window.__boolSelectedCheckbox {on, off, sync}
        boolSel_on() { return this.fmtSetting('fe.ux.boolSelectedCheckbox', true) !== false },   // IE 2026 10 12 / ODOO-345618 (заказ Игоря: чекбокс у выделенной булевой ячейки)
        boolSel_cellOk(irow, icol) {   // IE 2026 10 12 / ODOO-345618 (заказ Игоря: чекбокс у выделенной булевой ячейки)
            const flex = this.flex
            if (!flex || irow < (this.headerRows || 0) || icol < 0 || this.attr?.isPrint || this.attr?.isPrintTemplate) return false
            const col = flex.columns[icol], row = flex.rows[irow]
            const attr_col = col ? this.attr_by_binding[col.binding] : null
            const dataItem = row?.dataItem
            if (!attr_col || !dataItem || attr_col.attr_type !== 'AttrBool' || attr_col.checkbox_always || attr_col.measure_in_dataItem) return false
            if (col.dataType !== wjcCore.DataType.Boolean || this.transpose_measure(attr_col, dataItem) || this.cellBlank(dataItem, col.binding)) return false
            { const _pp = this.approvalFlagPartial_of(dataItem, col.binding, flex.getCellData(irow, icol, false), irow); if (_pp && _pp.state !== 'none') return false }   // IE 2026 10 14 / ODOO-5800: «частично» / «все ✓» живого итога — свой чекбокс, снятый не подменяет
            if (flex.getCellData(irow, icol, false) === true) return false   // отмеченную рисует wijmo
            if (flex.isReadOnly || col.isReadOnly || row.isReadOnly === true || this.store.readonly_on() || this.archiveRo?.()) return false   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): + архив
            if (typeof flex.canEditCell === 'function' && !flex.canEditCell(irow, icol)) return false
            try { return !!this.is_editable({ row: irow, col: icol }) } catch (e) { return false }
        },
        boolSel_apply(e_cell, irow, icol) {   // IE 2026 10 12 / ODOO-345618 (заказ Игоря: чекбокс у выделенной булевой ячейки)
            const C = window.__boolSelectedCheckbox || (window.__boolSelectedCheckbox = { on: 0, off: 0, sync: 0 })
            const sel = this.flex?.selection
            const want = !!(sel && sel.row === irow && sel.col === icol) && this.boolSel_on() && this.boolSel_cellOk(irow, icol)
            let inp = e_cell.querySelector('input.wj-cell-check')
            // FB1c: ячейка в редакторе (F2 / ввод символа — wijmo кладёт свой input.wj-grid-editor) — свой чекбокс снимается, состояние остаётся:
            // formatItem после выхода из редактора вернёт его (скрин Игоря 12.10: два чекбокса в ячейке МД)
            const edRange = this.flex?.activeEditor ? this.flex.editRange : null   // IE 2026 10 12 / ODOO-345618 (заказ Игоря: чекбокс у выделенной булевой ячейки) — FB1c
            if (edRange && edRange.contains(irow, icol)) { if (inp && inp.classList.contains('bool-sel-chk')) { inp.remove(); C.edit = (C.edit || 0) + 1 } return }   // IE 2026 10 12 / ODOO-345618 (заказ Игоря: чекбокс у выделенной булевой ячейки) — FB1c
            if (want) {
                // FB1b: ячейку выделяют мышью (кнопка ещё нажата) — новый чекбокс только после click этого нажатия (boolSel_mouseDown), иначе click отметит его сразу
                if (!inp && this._boolSelHold && this._boolSelEl !== e_cell) { this._boolSelPending = true; C.defer = (C.defer || 0) + 1; return }   // IE 2026 10 12 / ODOO-345618 (заказ Игоря: чекбокс у выделенной булевой ячейки) — FB1b
                if (!inp) { inp = document.createElement('input'); inp.type = 'checkbox'; inp.className = 'wj-cell-check'; inp.tabIndex = -1; e_cell.insertBefore(inp, e_cell.firstChild) }
                inp.classList.add('bool-sel-chk')
                inp.checked = false; inp.indeterminate = false; inp.disabled = false
                wjcCore.addClass(e_cell, 'checkbox')
                e_cell.__boolSel = true
                this._boolSelEl = e_cell
                C.on++
                return
            }
            if (!e_cell.__boolSel) return
            e_cell.__boolSel = false
            if (this._boolSelEl === e_cell) this._boolSelEl = null
            // свой (снятый) чекбокс уходит; отмеченный — уже чекбокс wijmo этой строки (клик переключил / элемент переиспользован под true) — остаётся
            if (inp && inp.classList.contains('bool-sel-chk')) { inp.classList.remove('bool-sel-chk'); if (!inp.checked) { inp.remove(); C.off++ } }
        },
        boolSel_sync(flex) {   // IE 2026 10 12 / ODOO-345618 (заказ Игоря: чекбокс у выделенной булевой ячейки): selectionChanged — старая и новая ячейка, без перерисовки грида
            if (!flex?.hostElement) return
            const prev = this._boolSelEl
            const sel = flex.selection
            const key = (sel && sel.row >= 0 && sel.col >= 0) ? `${flex.cells.cellType}-${sel.row}-${sel.col}` : null
            const el = key ? this.divCells.get(key) : null
            const ok = el && el.isConnected && el.data_cell && el.data_cell.row === sel.row && el.data_cell.col === sel.col
            if (prev && prev !== el) { const dc = prev.data_cell; this.boolSel_apply(prev, dc ? dc.row : -1, dc ? dc.col : -1) }
            if (!ok) return
            if (!el.__boolSel && !this.boolSel_on()) return
            const C = window.__boolSelectedCheckbox || (window.__boolSelectedCheckbox = { on: 0, off: 0, sync: 0 })
            C.sync++
            this.boolSel_apply(el, sel.row, sel.col)
        },
        // FB1b: левая кнопка на гриде (capture на host — раньше mousedown wijmo, который меняет выделение) — «удержание»; снимается click (document, после
        // _click wijmo на host) или mouseup + rAF (click без перемещения диспатчится в той же задаче сразу после mouseup; протяжка / отпускание вне грида — click нет).
        // Отложенная вставка — boolSel_sync по текущему выделению. Не setTimeout от mousedown: кнопку могут держать сколько угодно
        boolSel_mouseDown(e) {   // IE 2026 10 12 / ODOO-345618 (заказ Игоря: чекбокс у выделенной булевой ячейки) — FB1b
            if (e.button !== 0 || !this.boolSel_on()) return
            const tok = {}
            this._boolSelHold = tok
            this._boolSelPending = false
            const release = () => {
                document.removeEventListener('click', onClick, false)
                document.removeEventListener('mouseup', onUp, true)
                if (this._boolSelHold !== tok) return
                this._boolSelHold = null
                if (!this._boolSelPending) return
                this._boolSelPending = false
                try { if (this.flex && !this.flex.disposed) this.boolSel_sync(this.flex) } catch (err) { /* грид в перестройке */ }
            }
            const onClick = () => release()
            const onUp = () => { document.removeEventListener('mouseup', onUp, true); requestAnimationFrame(release) }
            document.addEventListener('click', onClick, false)
            document.addEventListener('mouseup', onUp, true)
        },
        // ══ IE 2026 09 10 / ODOO-… (заказ Игоря): булевы ячейки — колонка AttrBool или строка AttrBool в AttrTabGrid (колонка Value = AttrMulti,
        // тип в значении-словаре V). Переключение: клик по чекбоксу, пробел / любая буква-цифра на ячейке, вставка текста
        // (true/false/1/0/yes/no — store.isTrue). Мультивыделение — как у колонок AttrBool: все булевы ячейки колонки
        // в выделении инвертируются по верхней. Правка идёт через set_value → undo, отметка изменённости, запись формы.
        // IE 2026 10 18 / ODOO-347310: AttrUrl — настоящая ссылка <a target=_blank> (открывается в новой вкладке, клик не выделяет ячейку);
        // AttrImageUrl — миниатюра из /api/object_image/ (blob через fetch с X-Database, см. utils/sourceImage.js), наведение — превью 256 px
        // IE 2026 10 23 / ODOO-5800 (заказ Игоря, скрин 1: «ярлыки, по которым мы провалимся в виджет списка этой ссылки (сегмента)»): ярлык в ячейке Segment грида Sources
        // карточки DS (utils/segLinkCell.js) — повторная вставка на кэш-пути не дублируется
        segLinkCell_render(e_cell) {
            if (!e_cell) return
            e_cell.classList.add(SEG_LINK_CELL_CLASS)   // IE 2026 10 24 / ODOO-348700 (заказ Игоря: ярлык не пропадает при вводе, текст на месте): класс ячейки — до проверки на повтор
            if (e_cell.querySelector('.' + SEG_LINK_CLASS)) return
            e_cell.insertAdjacentHTML('afterbegin', segLinkCell_html(t('Open the segment list')))   // IE 2026 10 23 / ODOO-348700 (заказ Игоря: ярлык слева от названия сегмента)
        },
        // IE 2026 10 23 / ODOO-5800: клик по ярлыку — виджет списка сегмента строки (как «Open source segment» меню виджета, но для сегмента строки)
        onOpenSegmentList__Click(data_cell) {
            const dataItem = this.flex?.rows?.[data_cell?.row]?.dataItem
            const widget_init = segLinkCell_widgetInit(segLinkCell_segment(dataItem))
            if (widget_init) this.store.widget_open(widget_init, this)
        },
        sourceCell_render(e_cell, attr_col, value) {
            if (value && typeof value === 'object') value = value.value
            if (attr_col.attr_type === 'AttrUrl') {
                e_cell.innerHTML = linkCellHtml(value, attr_col.linkText)
                return
            }
            const src = typeof value === 'string' ? value.trim() : ''
            if (!src) { e_cell.innerHTML = ''; return }
            const size = thumbSizeFor(this.flex?.rows?.defaultSize || 28, window.devicePixelRatio || 1)
            let img = e_cell.querySelector('img.cell-thumb')
            if (!img || img.dataset.src !== src) {
                e_cell.innerHTML = ''
                img = document.createElement('img')
                img.className = 'cell-thumb'
                img.alt = ''
                img.dataset.src = src
                e_cell.appendChild(img)
            }
            installThumbPreview(this.store)
            const ready = peekImage(this.store, src, size)
            if (ready) { if (img.src !== ready) img.src = ready; return }
            loadImage(this.store, src, size).then(u => { if (u && img.isConnected && img.dataset.src === src) img.src = u })
        },
        boolCell_render(e_cell, value) {   // boolCell v3
            wjcCore.addClass(e_cell, 'checkbox')
            let c2 = e_cell.querySelector('input[type=checkbox]')
            if (!c2) { c2 = document.createElement('input'); c2.type = 'checkbox'; c2.className = 'wj-cell-check'; c2.tabIndex = -1; e_cell.innerHTML = ''; e_cell.appendChild(c2) }
            c2.checked = this.store.isTrue(value && typeof value === 'object' ? value.value : value)
            c2.disabled = false
        },
        boolCell_info(irow, icol) {
            const flex = this.flex
            if (!flex || irow < 0 || icol < 0 || this.attr?.attr_type !== 'AttrTabGrid') return null   // boolCell v3: только гриды полей
            const col = flex.columns[icol], row = flex.rows[irow]
            const attr_col = col ? this.attr_by_binding[col.binding] : null
            const dataItem = row?.dataItem
            if (!attr_col || !dataItem) return null
            let isBool = attr_col.attr_type === 'AttrBool', V = null   // boolCell v2
            if (!isBool && attr_col.attr_type === 'AttrMulti' && !this.transpose_measure(attr_col, dataItem)) {
                try { V = this.store.check_AttrMulti(attr_col, dataItem) } catch (e) { V = null }
                isBool = V?.attr_type === 'AttrBool'
            }
            if (!isBool) return null
            let editable = !flex.isReadOnly && !col.isReadOnly && row.isReadOnly !== true
            if (editable) { try { editable = this.is_editable({ row: irow, col: icol }) } catch (e) { /* без условного формата */ } }
            return { dataItem, binding: col.binding, attr_col, editable, V }
        },
        boolCell_value(bc) {
            // словарь-значение AttrMulti (строка AttrTabGrid: dataItem.attr) — по value, не по valueStr
            const v = bc.V ? bc.V.value : this.store.get_value(bc.dataItem, bc.binding)
            return this.store.isTrue(v && typeof v === 'object' ? v.value : v)
        },
        boolCell_toggle(irow, icol, force) {
            const bc = this.boolCell_info(irow, icol)
            if (!bc || !bc.editable) return false
            const flex = this.flex, sel = flex.selectedRanges?.[0]
            const inRange = sel && sel.isValid && sel.topRow !== sel.bottomRow && sel.topRow <= irow && irow <= sel.bottomRow && sel.leftCol <= icol && icol <= sel.rightCol
            if (inRange) {
                // мультивыделение: все булевы ячейки колонки в выделении — по верхней (инверсия), как у колонок AttrBool
                const top = this.boolCell_info(sel.topRow, icol)
                const rangeVal = force != null ? !!force : !this.boolCell_value(top || bc)
                for (let r = sel.topRow; r <= sel.bottomRow; r++) {
                    const b = this.boolCell_info(r, icol)
                    if (!b || !b.editable || b.dataItem?._fe?.visible === false) continue
                    const ov = this.boolCell_value(b)
                    if (ov !== rangeVal) this.set_value(r, b.dataItem, b.binding, ov, rangeVal)
                }
            } else {
                const ov = this.boolCell_value(bc)
                const nv = force != null ? !!force : !ov
                if (ov !== nv) this.set_value(irow, bc.dataItem, bc.binding, ov, nv)
            }
            this.actionStack++
            this.flexRefresh()
            return true
        },
        boolCell_keydown(e) {
            // capture-фаза на хосте — раньше wijmo: пробел / одиночный символ на булевой ячейке = переключить, редактор не открывать
            const flex = this.flex
            if (!flex || flex.activeEditor || e.ctrlKey || e.metaKey || e.altKey) return
            const k = e.key
            if (!(k === ' ' || (typeof k === 'string' && k.length === 1 && /\S/.test(k)))) return
            const sel = flex.selection
            if (!sel || sel.row < 0 || sel.col < 0) return
            if (!this.boolCell_info(sel.row, sel.col)) return
            e.preventDefault(); e.stopPropagation()
            this.boolCell_toggle(sel.row, sel.col)
        },
        // ---- IE 2026 09 21 / ODOO-… (замечание Игоря: стрелка формы ячейки на выбранной ячейке, F4 — без входа в правку) ----
        // Форма ячейки (Dropdown.vue: ROW / CELL, METRICS, RULES, FORMATS …) у обычной ячейки выводилась только при входе в правку. Теперь:
        //   • у выбранной ячейки стрелка-шеврон видна сразу (formatItem_dropdownToggle / refresh_dropdownToggles, класс at-active) — клик открывает форму без правки;
        //   • F4 открывает / закрывает форму выбранной ячейки без правки (в правке клавишу не трогаем); Esc закрывает форму (App.handleKeydown: сначала форма).
        // Выключатели fe.ux.cellFormArrow, fe.ux.cellFormHotkey
        cellForm_arrowOn() { return this.store.setting('fe.ux.cellFormArrow', true) !== false && !this.attr?.isPrint && !this.attr?.isPrintTemplate && !this.attr?.cellForm_off },   // IE 2026 10 31 / ODOO-5800 (заказ Игоря: таблиця форми комірки — на AttrGrid)
        // IE 2026 09 26 / ODOO-… (замечания Игоря: форма ячейки): в ячейке с показанной формой нет стрелки-свёртки — форму закрывает ✕ формы (выключатель fe.ux.cellFormCloseAlways — прежняя стрелка-свёртка)
        cellForm_closeAlwaysOn() { return this.store.setting('fe.ux.cellFormCloseAlways', true) !== false },
        // ---- IE 2026 09 29 / ODOO-343342 (заказ Игоря: форма ячейки по 🏷) ----
        // Форма ячейки открывается кнопкой 🏷 в островке строки команд (не шевроном в ячейке): клик — форма выделенной ячейки как по F4, при открытой — закрытие как по ✕.
        // Шеврон скрыт CSS (.attr-grid.cellform-tagbtn), заглушка p203 (cell-form-here) остаётся. Выключатель fe.ux.cellFormTagBtn (по умолчанию true; false — шеврон как прежде); телефон не меняется.
        // Счётчики — window.cellFormTagBtn {clicks, opens, closes, empty}. Нет строки команд (hideCommandPanel) — кнопки нет, шеврон остаётся.
        cellFormTag_on() { try { return this.store.setting('fe.ux.cellFormTagBtn', true) !== false && !this.store.mobileUi?.on && this.cellForm_arrowOn() } catch (e) { return false } },
        cellFormTag_show() { return this.cellFormTag_on() && !this.attr?.hideCommandPanel },
        cellForm_onlyByButton() { try { return this.store.setting('fe.ux.cellFormOnlyByButton', true) !== false && !this.store.mobileUi?.on } catch (e) { return false } },   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: форма ячейки по 🏷): форма ячейки сама не открывается (клик, правка) — только 🏷 / F4 / шеврон; телефон — как прежде
        cellFormTag_open() { const d = this.store.dropdown; return !!d && cellForm_tagState({ visible: !!d.visible, mine: d.vueObj === this, suspended: !!d.cfSuspended, onlyByButton: this.cellForm_onlyByButton() }) !== 'closed' },   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: открытая форма следует за выделением) — FB6b: спрятанная, но открытая пользователем — кнопка подсвечена
        cellForm_suspendClear(d = this.store.dropdown) { if (!d || !d.cfSuspended) return false; d.cfSuspended = false; try { (d.vueObj || this).$forceUpdate?.(); this.$forceUpdate() } catch (e) { /* грид разрушен */ } return true },   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: открытая форма следует за выделением) — FB6b: снять признак (кнопка гаснет)
        cellFormTag_here() { const d = this.store.dropdown, f = this.flex, s = liveSelection(f); return !!(this.cellFormTag_open() && s && d.key === `${f.cells.cellType}-${s.row}-${s.col}`) },   // IE 2026 09 29 / ODOO-343342 (заказ Игоря: форма ячейки по 🏷): форма стоит именно на выбранной ячейке   // IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение) (p038): прежде выделение читалось напрямую — у разрушенного при смене «Заголовки» FlexGrid геттер бросал, рендер падал, новый грид не монтировался
        cellFormTag_off() { const f = this.flex; return !f || f.disposed || !f.rows || f.rows.length <= (this.headerRows || 0) },
        cellFormTag_click() {
            if (this.attr?.cellForm_off) return   // IE 2026 10 31 / ODOO-5800 (заказ Игоря: таблиця форми комірки — на AttrGrid): грид в самой форме ячейки — 🏷 / F4 форму не трогают
            const c = (window.cellFormTagBtn = window.cellFormTagBtn || { clicks: 0, opens: 0, closes: 0, empty: 0 })
            c.clicks++
            const flex = this.flex, dd = this.store.dropdown
            if (!flex || !dd || this.cellFormTag_off()) { c.empty++; return }
            if (!dd.visible && dd.vueObj === this && dd.cfSuspended) { dd.sessionClose?.(); this.cellForm_suspendClear(dd); c.closes++; try { flex.focus() } catch (e) { /* грид в перестройке */ } return }   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: открытая форма следует за выделением) — FB6b: 🏷 при спрятанной открытой форме — закрыть
            if (this.cellFormTag_here()) {
                dd.sessionClose?.(); dd.hide(); c.closes++
                try { flex.focus() } catch (e) { /* грид в перестройке */ }
                return
            }
            if (dd.visible && !this.cellFormTag_open()) dd.hide()   // форма другого грида; форма этого грида на другой ячейке переносится на выбранную (cellForm_toggle)
            const h = this.headerRows || 0
            let sel = flex.selection
            if (!sel || sel.row < h || sel.col < 0) {
                flex.select(new wjGrid.CellRange(h, Math.max(0, flex.columns.findIndex(col => col.visible))))
                sel = flex.selection
            }
            try { flex.focus() } catch (e) { /* грид в перестройке */ }
            if (this.cellForm_toggle(sel.row, sel.col)) {
                c.opens++
                // IE 2026 09 29 / ODOO-343342 (заказ Игоря: форма ячейки по 🏷): форма перенесена с другой ячейки — заглушка p203 встаёт на выбранную после показа формы
                for (const ms of [250, 700]) window.$cg.setTimeout(this, 'AttrGrid.cellFormTag_click', () => { if (this.flex && !this.flex.disposed) this.refresh_dropdownToggles() }, ms)
            }
        },
        // ---- IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка мыши — форма ячейки / строки / меню виджета) ----
        // contextmenu на хосте грида (cellForm_install): ячейка тела — форма ячейки как по 🏷 (правая кнопка приравнена к кнопке: снимает «закрыто пользователем»);
        // заголовок строки (панель rowHeaders) — виджет строки (widget-row) как карандаш заголовка / Alt F2. Поля ввода (редактор) не трогаем — браузерное меню.
        // Выключатель fe.ux.contextMenuActions (дефолт ВКЛ); телефон — нет. Счётчики window.ctxMenuActions {cell, cellKept, row, rowForm, header, skip}
        ctxMenu_on() { try { return this.store.setting('fe.ux.contextMenuActions', true) !== false && !this.store.mobileUi?.on } catch (e) { return false } },   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка мыши — форма ячейки / строки / меню виджета)
        ctxMenu_count(k) { const c = (window.ctxMenuActions = window.ctxMenuActions || { cell: 0, cellKept: 0, row: 0, rowForm: 0, header: 0, skip: 0, colHeader: 0, groupRow: 0 }); c[k] = (c[k] || 0) + 1 },   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк): + colHeader, groupRow   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка мыши — форма ячейки / строки / меню виджета)
        ctxMenu_grid(e) {   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка мыши — форма ячейки / строки / меню виджета)
            if (!this.ctxMenu_on() || e.defaultPrevented) return
            const flex = this.flex
            if (!flex || flex.disposed || this.attr?.isPrint || this.attr?.isPrintTemplate) return
            if (e.target?.closest?.('input:not([type=checkbox]):not([type=radio]):not([type=button]), textarea, select, [contenteditable="true"], .wj-dropdown-panel')) { this.ctxMenu_count('skip'); return }   // редактор / поле ввода — меню браузера (флажок строки — нет)
            let ht = null
            try { ht = flex.hitTest(e) } catch (err) { ht = null }
            if (ht && ht.panel === flex.columnHeaders) {   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк)
                if (ht.cellType !== wjGrid.CellType.ColumnHeader || ht.col < 0 || !flex.columns[ht.col]) return   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк)
                if (this.ctxMenu_colHeader(e, ht)) e.preventDefault()   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк)
                return   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк)
            }
            if (!ht || ht.row < (this.headerRows || 0) || !flex.rows[ht.row]) return
            // отчёт REPORT2: атрибуты строки (Object, Measure group …) — закреплённые колонки панели cells — это заголовок строки
            const rptHdr = ht.panel === flex.cells && ht.cellType === wjGrid.CellType.Cell && ht.col >= 0 && ht.col < (flex.frozenColumns || 0)
                && this.attr?.name === 'dataSheet' && this.WIDGET?.record?.segment === 'WIDGET-REPORT2'
            // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк): строка-группа (GroupRow с детьми: группа CollectionView или узел дерева) — по её заголовку (заголовок строки, атрибуты строки REPORT2,
            // ячейка с кнопкой свёртки) меню группы; ячейки данных строки-группы — по-прежнему форма ячейки
            const gRow = flex.rows[ht.row]   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк)
            if (gRow instanceof wjGrid.GroupRow && gRow.hasChildren && (rptHdr || (ht.panel === flex.rowHeaders && ht.cellType === wjGrid.CellType.RowHeader)   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк)
                || (ht.panel === flex.cells && !!(e.target?.closest?.('.wj-elem-collapse') || e.target?.closest?.('.wj-cell')?.querySelector?.('.wj-elem-collapse'))))) {   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк)
                if (this.ctxMenu_groupRow(e, ht, gRow)) e.preventDefault()   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк)
                return   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк)
            }
            if (ht.panel === flex.cells && ht.cellType === wjGrid.CellType.Cell && ht.col >= 0 && !rptHdr) {
                if (!this.cellForm_arrowOn() || this.cellFormTag_off()) return
                e.preventDefault()
                this.ctxMenu_cell(ht.row, ht.col)
            } else if (rptHdr || (ht.panel === flex.rowHeaders && ht.cellType === wjGrid.CellType.RowHeader)) {
                if (!flex.rows[ht.row].dataItem) return
                e.preventDefault()
                this.ctxMenu_row(ht.row)
            }
        },
        // ---- IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк) ----
        // Заголовок колонки (панель columnHeaders; заголовок группы колонок — ячейка шире одной колонки — не перехватываем): меню колонки у точки клика.
        // Пункты — только то, что у грида уже есть: сортировка (как клик по заголовку: sortingColumn / hierSort_* у дерева, sortDescriptions + sortedColumn у плоского),
        // фильтр колонки (FlexGridFilter.editColumnFilter — как воронка), закрепление до колонки / снятие (set_viewParam('frozenColumns') — как поле Frozen columns в ⚙),
        // ширина по содержимому (autoSizeColumn + set_width — как ресайз рукой: ширина запоминается в viewParams). Пунктов нет — меню браузера
        ctxMenu_colHeader(e, ht) {   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк)
            const flex = this.flex, col = flex.columns[ht.col]
            try { const mr = flex.getMergedRange(flex.columnHeaders, ht.row, ht.col, false); if (mr && mr.leftCol !== mr.rightCol) return false } catch (err) { /* без объединения */ }   // заголовок группы колонок
            const binding = col.binding, attr_col = binding ? this.attr_by_binding?.[binding] : null
            const items = []
            if (binding && flex.allowSorting && col.allowSorting !== false) {
                const cur = this.ctxMenu_colSortDir(binding)
                items.push({ title: t('Sort ascending'), cssClass: 'pi pi-sort-amount-up-alt', command: 'sortAsc', disabled: cur === 1 })
                items.push({ title: t('Sort descending'), cssClass: 'pi pi-sort-amount-down', command: 'sortDesc', disabled: cur === -1 })
                if (cur) items.push({ title: t('Clear sorting'), cssClass: 'pi pi-times', command: 'sortClear' })
            }
            if (this.filter && binding) items.push({ title: t('Filter…'), cssClass: 'pi pi-filter', command: 'filter' })
            if (!this.attr?.hideGridSettings) {
                const fz = flex.frozenColumns || 0, fzDef = this._frozenDefault ?? (this.attr?.frozenColumns || 0)   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк) (доработка пробы): по правилу клэмпа
                if (this.frozenColumns_clamp(this.i18nFields_frozenShift(this.ctxMenu_freezeN(ht.col)), flex) !== fz) items.push({ title: t('Freeze up to this column'), cssClass: 'pi pi-lock', command: 'freeze' })   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк): клэмп сделал бы пункт пустым — не показываем
                if (this.frozenColumns_clamp(this.i18nFields_frozenShift(fzDef), flex) !== fz) items.push({ title: t('Reset frozen columns'), cssClass: 'pi pi-lock-open', command: 'resetFrozen' })   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк): значение вида при открытии
            }
            if (attr_col && (flex.allowResizing & 1) && col.allowResizing !== false) items.push({ title: t('Fit width to content'), cssClass: 'pi pi-arrows-h', command: 'autoWidth' })
            if (!items.length) return false
            this.ctxMenu_openPop(e, { title: t('Column'), subtitle: this.ctxMenu_colName(col), icon: 'pi pi-table', items }, { kind: 'col', binding, icol: ht.col, hrow: ht.row })
            this.ctxMenu_count('colHeader')
            return true
        },
        // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк) (доработка пробы): attr.frozenColumns для «закрепить до колонки icol» — колонки переводов не считаются (i18nFields_frozenShift)
        ctxMenu_freezeN(icol) {
            const flex = this.flex
            let n = 0
            for (let i = 0; i <= icol; i++) if (!this.attr_by_binding?.[flex.columns[i]?.binding]?._i18nOf) n++
            return n
        },
        // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк) (доработка пробы 2): подзаголовок меню колонки — цепочка заголовков групп колонок (от верхней) и заголовок колонки, если он читаемый
        // («2026 · February · Qty»); заголовок-глиф (↩ у колонок периода) / пустой — только цепочка групп; binding не показывается никогда; групп нет — пусто
        ctxMenu_colName(col) {
            const clean = (v) => String(v ?? '').replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim()
            const readable = (v) => /[\p{L}\p{N}]/u.test(v)
            const parts = []
            for (let g = col.parentGroup; g; g = g.parentGroup) { const h = clean(g.header); if (readable(h)) parts.unshift(h) }
            const h = clean(col.header)
            if (readable(h)) parts.push(h)
            return parts.join(' · ').slice(0, 80)
        },
        // направление сортировки колонки сейчас: 1 / -1 / 0 (дерево — hierSort, плоский — sortDescriptions)
        ctxMenu_colSortDir(binding) {   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк)
            if (this.hierSort_isTree()) return this.hierSort?.binding === binding ? (this.hierSort.dir || 0) : 0
            const sd = this.flex?.collectionView?.sortDescriptions
            const d = sd ? Array.prototype.find.call(sd, x => x.property === binding) : null
            return d ? (d.ascending ? 1 : -1) : 0
        },
        // сортировка из меню — тем же путём, что клик по заголовку (sortingColumn у дерева; у плоского — штатный CollectionView и sortedColumn → чипс порядка)
        ctxMenu_colSort(col, dir, hrow) {   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк)
            const flex = this.flex, binding = col.binding
            if (this.hierSort_isTree()) {
                this.hierSort = dir ? { binding, dir, hrow } : {}
                this.hierSort_apply(binding, dir, col)
                this.hierSort_syncChip(flex, binding, dir)
                return
            }
            const cv = flex.collectionView
            if (!cv) return
            cv.deferUpdate(() => {
                cv.sortDescriptions.clear()
                if (dir) cv.sortDescriptions.push(new wjcCore.SortDescription(binding, dir > 0))
            })
            this.sortedColumn(flex, null)
        },
        // строка-группа: свернуть / развернуть ветку (row.isCollapsed — как кнопка свёртки), свернуть строки до её уровня и развернуть все (collapseGroupsToLevel — как бейджи
        // уровней в углу таблицы), форма ячейки строки (ctxMenu_cell — как 🏷 / правая кнопка по ячейке), виджет строки (ctxMenu_row — как правая кнопка по заголовку строки)
        ctxMenu_groupRow(e, ht, row) {   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк)
            const flex = this.flex
            const items = [{ title: row.isCollapsed ? t('Expand') : t('Collapse'), cssClass: row.isCollapsed ? 'pi pi-plus' : 'pi pi-minus', command: 'toggle' }]
            items.push({ title: t('Collapse rows to this level'), cssClass: 'pi pi-angle-double-up', command: 'toLevel' })
            items.push({ title: t('Expand all rows'), cssClass: 'pi pi-angle-double-down', command: 'expandAll' })
            const c0 = flex.columns.findIndex(c => c.visible)
            const fcol = (ht.panel === flex.cells && ht.col >= 0) ? ht.col : c0
            if (fcol >= 0 && this.cellForm_arrowOn() && !this.cellFormTag_off()) items.push({ title: t('Group form'), cssClass: 'pi pi-tags', command: 'groupForm' })
            const di = row.dataItem
            const dbl = this.dblclick_action
            if (di && !(di instanceof wjcCore.CollectionViewGroup) && ((dbl && dbl.command === 'widget_open' && (dbl.widget === 'widget-row' || dbl.widget === 'widget-record')) || this.get_openline_action())) {
                if (this.archiveRo?.()) items.push({ title: t('Open line (read-only)'), cssClass: 'pi pi-eye', command: 'openRow' })   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): архив, данные модели — ✎ → 👁 (ревью #110599)
                else items.push({ title: t('Open line'), cssClass: 'pi pi-pencil', command: 'openRow' })
            }
            const cellTxt = String(e.target?.closest?.('.wj-cell')?.textContent || '').replace(/\s+/g, ' ').trim()
            const title = (cellTxt || (di instanceof wjcCore.CollectionViewGroup ? String(di.name ?? '') : '')).slice(0, 80)
            this.ctxMenu_openPop(e, { title: t('Group'), subtitle: title, icon: 'pi pi-sitemap', items }, { kind: 'group', irow: ht.row, dataItem: di, fcol })
            this.ctxMenu_count('groupRow')
            return true
        },
        ctxMenu_openPop(e, pop, ctx) {   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк)
            const mp = this.$refs.ctxMenuPanel
            if (mp && mp.open) mp.hide({ focusBack: false })   // меню уже открыто (правая кнопка по другому заголовку) — заменить
            this.ctxMenuPop = pop
            this._ctxMenuCtx = ctx
            const at = { x: e.clientX, y: e.clientY }
            this.$nextTick(() => { const p = this.$refs.ctxMenuPanel; if (p && typeof p.show === 'function') p.show({ by: 'click', at }) })
        },
        ctxMenu_closed() { this.ctxMenuPop = { title: '', subtitle: '', icon: '', items: [] } },   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк)
        ctxMenu_pick(raw) {   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк)
            const ctx = this._ctxMenuCtx, flex = this.flex, cmd = raw?.command
            this._ctxMenuCtx = null
            if (!ctx || !cmd || !flex || flex.disposed) return
            if (ctx.kind === 'col') {
                const col = (flex.columns[ctx.icol]?.binding === ctx.binding) ? flex.columns[ctx.icol] : (ctx.binding ? flex.columns.getColumn(ctx.binding) : null)   // грид могли перестроить
                if (!col) return
                if (cmd === 'sortAsc') this.ctxMenu_colSort(col, 1, ctx.hrow)
                else if (cmd === 'sortDesc') this.ctxMenu_colSort(col, -1, ctx.hrow)
                else if (cmd === 'sortClear') this.ctxMenu_colSort(col, 0, ctx.hrow)
                else if (cmd === 'filter') { if (this.filter) this.filter.editColumnFilter(col) }
                else if (cmd === 'freeze') this.set_viewParam('frozenColumns', this.ctxMenu_freezeN(col.index))
                else if (cmd === 'resetFrozen') this.set_viewParam('frozenColumns', this._frozenDefault ?? 0)   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — колонка / группа строк) (доработка пробы)
                else if (cmd === 'autoWidth') {
                    const attr_col = this.attr_by_binding?.[col.binding]
                    const w = attr_col ? Math.round(this.autoSizeColumn(attr_col, 0, col)) : 0
                    if (w > 0) { col.width = w; this.set_width(col.index, w) }
                }
                return
            }
            if (ctx.kind === 'group') {
                let irow = ctx.irow
                if (flex.rows[irow]?.dataItem !== ctx.dataItem) irow = ctx.dataItem ? flex.rows.findIndex(r => r.dataItem === ctx.dataItem) : -1   // строки сдвинулись
                const row = irow >= 0 ? flex.rows[irow] : null
                if (!row) return
                if (cmd === 'toggle') { if (row.hasChildren) row.isCollapsed = !row.isCollapsed }
                else if (cmd === 'toLevel') flex.deferUpdate(() => flex.collapseGroupsToLevel(row.level ?? 0))
                else if (cmd === 'expandAll') {
                    let maxParent = 0
                    for (const r of flex.rows) if (r instanceof wjGrid.GroupRow && r.hasChildren && (r.level ?? 0) > maxParent) maxParent = r.level ?? 0
                    flex.deferUpdate(() => flex.collapseGroupsToLevel(maxParent + 1))
                } else if (cmd === 'groupForm') this.ctxMenu_cell(irow, ctx.fcol)
                else if (cmd === 'openRow') this.ctxMenu_row(irow)
            }
        },
        // ячейка: выделить её и открыть форму тем же путём, что 🏷 (cellFormTag_click -> cellForm_toggle); форма уже на ней — не закрывать
        ctxMenu_cell(row, col) {   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка мыши — форма ячейки / строки / меню виджета)
            const flex = this.flex, dd = this.store.dropdown
            if (!flex || !dd || this.attr?.cellForm_off) return   // IE 2026 10 31 / ODOO-5800 (заказ Игоря: таблиця форми комірки — на AttrGrid): грид в самой форме ячейки — правая кнопка форму не трогает
            const s0 = flex.selection
            if (!s0 || s0.row !== row || s0.col !== col || (flex.selectedRanges?.length || 0) > 1) flex.select(new wjGrid.CellRange(row, col))
            try { flex.focus() } catch (e) { /* грид в перестройке */ }
            if (this.cellFormTag_here()) { dd.sessionOpen?.(); this.ctxMenu_count('cellKept'); return }
            // IE 2026 10 12 / ODOO-343342 (заказ Игоря: форма ячейки по 🏷 не гаснет при ресайзе виджетов): повторное открытие формы через 450 / 1100 / 1900 мс снято — форму при ресайзе виджетов держит Dropdown.cellForm_keepOnResize / cellForm_follow
            if (dd.visible && !this.cellFormTag_open()) dd.hide()   // форма другого грида
            const sel = flex.selection
            if (sel && this.cellForm_toggle(sel.row, sel.col)) {
                this.ctxMenu_count('cell')
                for (const ms of [250, 700]) window.$cg.setTimeout(this, 'AttrGrid.ctxMenu_cell', () => { if (this.flex && !this.flex.disposed) this.refresh_dropdownToggles() }, ms)
            }
        },
        // заголовок строки: виджет строки (widget-row) — как карандаш заголовка (onHeader__Click: строка целиком + execute_dblclick), если действие двойного клика
        // открывает widget-row / widget-record (запись строки у списков relation_segment); иначе — «Open line» (Alt F2, get_openline_action); действия нет (AttrTabGrid) — форма ячейки первой видимой колонки строки (блок ROW)
        ctxMenu_row(row) {   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка мыши — форма ячейки / строки / меню виджета)
            const flex = this.flex
            const fire = (run) => {
                this.isRowHeaderClick = false
                this._skipSelectionWidgetOpen = true
                flex.selectedRanges = [new wjGrid.CellRange(row, 0, row, flex.columns.length - 1)]
                run()
                if (this.selectionChanged_timeout) { clearTimeout(this.selectionChanged_timeout); this.selectionChanged_timeout = null }
                setTimeout(() => { this._skipSelectionWidgetOpen = false }, 500)
                this.ctxMenu_count('row')
            }
            const dbl = this.dblclick_action
            if (dbl && ((dbl.command === 'widget_open' && (dbl.widget === 'widget-row' || dbl.widget === 'widget-record')) || dbl._openRecord)) { fire(() => this.execute_dblclick({}, true)); return }   // IE 2026 10 14 / ODOO-5800: и открытие записи строки динамического списка   // карандаш: строка / запись строки (relation_segment)
            const ol = this.get_openline_action()
            if (ol) { fire(() => this.store.executeStoreMethod(this.WIDGET.vueObj, { ...ol, _activate: true }, this.attr)); return }
            const c0 = flex.columns.findIndex(c => c.visible)
            if (c0 >= 0 && this.cellForm_arrowOn()) { this.ctxMenu_cell(row, c0); this.ctxMenu_count('rowForm') }
        },
        // ---- IE 2026 09 27 / ODOO-… (дефект p203: стрелки при открытой форме ячейки) ----
        // Заглушка на месте кнопки у ячейки с показанной формой (fe.ux.cellFormCloseAlways): кнопка остаётся в ячейке невидимой (класс cell-form-here, без значка
        // и подсказки). Её pointerdown (preventDefault, _make_dropdownToggleBtn) не пускает mousedown в wijmo, клик уходит в onRefToggle__Click (preventDefault клика —
        // wijmo._click правку не начинает): повторный клик в угол ячейки не входит в правку и не закрывает форму — фокус остаётся в гриде, стрелки / F4 работают.
        cellForm_shield(e_cell, dc, ref = null, btn = null) {
            btn = btn || e_cell?.querySelector?.('.cell-dropdown-toggle') || (e_cell ? this._make_dropdownToggleBtn(e_cell) : null)
            if (!btn || !dc) return null
            btn.classList.add('cell-form-here')
            btn.classList.remove('open', 'at-active')
            btn.title = ''
            if (btn.firstElementChild) btn.firstElementChild.className = 'pi'   // без значка; класс pi — клик по значку не считается кликом по ячейке (execute_click)
            if (e_cell?.classList) btn.classList.toggle('align-left', e_cell.classList.contains('wj-align-right'))
            if (ref != null) btn.dataset.ref = ref
            btn.data_cell = { irow: dc.irow ?? dc.row, row: dc.row, col: dc.col, col_binding: dc.col_binding }
            return btn
        },
        cellForm_unshield(btn) {
            btn.classList.remove('cell-form-here')
            btn.title = t('Cell form — F4')
        },
        // клик по заглушке: не закрытие и не правка — выбрать эту ячейку (форма могла остаться на прежней ячейке после перехода стрелками) и вернуть фокус в грид
        cellForm_shieldClick(cell) {
            const flex = this.flex
            if (!flex || flex.disposed) return
            const sel = flex.selection
            if (!sel || sel.row !== cell.row || sel.col !== cell.col) flex.select(new wjGrid.CellRange(cell.row, cell.col))
            try { if (!flex.hostElement.contains(document.activeElement)) flex.focus() } catch (e) { /* грид в перестройке */ }
            this._cellFormShieldClicks = (this._cellFormShieldClicks || 0) + 1   // для проб
        },
        cellForm_install() {
            const host = this.flex?.hostElement
            if (!host || this._cellFormKeyHost === host) return   // грид пересоздаётся при перечитывании — слушатель следует за текущим хостом
            this._cellFormKeyHost = host
            host.addEventListener('keydown', (e) => this.cellForm_keydown(e), true)
            host.addEventListener('click', (e) => this.signalTip_click(e), true)   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p231 підказка по сигналу — проблема як у формі комірки): клик по сигналу — форма ячейки на его проблеме
            this.signalTip_docInstall()   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: агрегат сигналов кругом в кнопке; проблемы подсказки в одну строку, клик — форма ячейки): клик по строке проблемы в подсказке, полный текст обрезанной строки
            // IE 2026 09 27 / ODOO-… (дефект p203: стрелки при открытой форме ячейки): заглушка на месте кнопки — wijmo не получает ни mousedown (выбор / фокус), ни click (правка по клику в выбранную ячейку): перехват на хосте,
            // потому что клон замороженной колонки (cloneFrozenCells) копирует кнопку без её обработчиков, а порядок слушателей click на хосте не гарантирован
            host.addEventListener('pointerdown', (e) => this.cellForm_shieldGuard(e), true)
            host.addEventListener('click', (e) => this.cellForm_shieldGuard(e), true)
            host.addEventListener('contextmenu', (e) => this.ctxMenu_grid(e))   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка мыши — форма ячейки / строки / меню виджета)
        },
        cellForm_shieldGuard(e) { if (e.target?.closest?.('.cell-form-here')) e.preventDefault() },
        cellForm_keydown(e) {
            if (e.key !== 'F4' || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return
            const flex = this.flex, sel = flex?.selection
            if (!flex || flex.activeEditor || !sel || sel.row < 0 || sel.col < 0) return   // в правке форма уже выведена — клавишу оставляем редактору
            if (this.store.setting('fe.ux.cellFormHotkey', true) === false) return
            e.preventDefault(); e.stopPropagation()
            this.cellForm_toggle(sel.row, sel.col)
        },
        cellForm_toggle(row, col) {
            const flex = this.flex, dropdown = this.store.dropdown
            if (!flex || !dropdown) return false
            const key = `${flex.cells.cellType}-${row}-${col}`
            if (dropdown.visible && dropdown.key === key) { dropdown.sessionClose?.(); dropdown.hide(); return false }   // IE 2026 09 26 / ODOO-… (замечания Игоря: форма ячейки): F4-закрытие — закрытие пользователем (память сеанса)
            dropdown.sessionOpen?.()   // IE 2026 09 26 / ODOO-… (замечания Игоря: форма ячейки): F4 открывает форму и возвращает её показ при выборе ячеек
            try { flex.scrollIntoView(row, col) } catch (e) { /* грид в перестройке */ }
            const open = () => {
                // у объединённой ячейки элемент зарегистрирован под корнем диапазона — берём отрисованный элемент ячейки
                const divCell = this.divCells.get(key) || flex.cells.getCellElement(row, col)
                if (!divCell || !divCell.isConnected) return false
                dropdown.mouse_isInside = true
                dropdown._keyOpenKey = key   // IE 2026 09 26 / ODOO-… (замечания Игоря: форма ячейки) (v3): F4 — форма показывается и без курсора над ячейкой (прикреплённая форма)
                const _er = flex.activeEditor && flex.editRange   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: форма ячейки по 🏷): 🏷 во время правки — форма с редактором (список значений, ввод)
                this._cellFormExplicit = true   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: форма ячейки по 🏷) — FB2b: явное открытие (🏷 / F4) — ворота правки cellForm_editOpens его пропускают
                try { this.dropdown_prepare({ row, col }, divCell, (_er && _er.row === row && _er.col === col) ? flex.activeEditor : null) } finally { this._cellFormExplicit = false }   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: форма ячейки по 🏷) — FB2b
                this._cellFormOpens = (this._cellFormOpens || 0) + 1
                return true
            }
            if (!open()) setTimeout(open, 80)   // ячейку только что прокрутили в кадр
            return true
        },
        boolCell_install() {
            const flex = this.flex
            if (!flex?.hostElement || this._boolCellInstalled) return
            this._boolCellInstalled = true
            flex.hostElement.addEventListener('keydown', (e) => this.boolCell_keydown(e), true)
        },
        setSelectoinListener() {
            const flex = this.flex

            flex.hostElement.addEventListener('mousedown', (e) => {
                this._lastMouseEvent = e
            })
            if (!flex.hostElement.__boolSelDown) { flex.hostElement.__boolSelDown = true; flex.hostElement.addEventListener('mousedown', (e) => this.boolSel_mouseDown(e), true) }   // IE 2026 10 12 / ODOO-345618 (заказ Игоря: чекбокс у выделенной булевой ячейки) — FB1b
            if (!flex.__frozenCloneSync) {   // IE 2026 10 15 / ODOO-5800: после каждой сборки клона замороженных wijmo (_updateFrozenCells — и полной, и копирования классов) — копии по строкам (frozenClone_sync)
                flex.__frozenCloneSync = true
                const _vm = this, _ufc = flex._updateFrozenCells
                if (typeof _ufc === 'function') flex._updateFrozenCells = function () { const r = _ufc.apply(this, arguments); _vm.frozenClone_sync(); return r }
            }

            flex.rowHeaders.hostElement.addEventListener('mousedown', () => {
                this.isRowHeaderClick = true
                
                if (this.isRowHeaderClick_timeout) { clearTimeout(this.isRowHeaderClick_timeout) }
                this.isRowHeaderClick_timeout = window.$cg.setTimeout(this, "AttrGrid.setSelectoinListener", () => {
                    this.isRowHeaderClick = false
                }, 400)
            })
        },
        groupPanelInitialized: function (grid) {
            this.groupPanel = grid;
            if (this.flex) {
                this.groupPanel.grid = this.flex;
            }
            this.groupPanel.hostElement.addEventListener('contextmenu', e => {
                let groupDescription = this.groupPanel.hitTest(e),
                    cv = this.groupPanel.collectionView;
                if (groupDescription) {
                    this.groupIndex = cv.groupDescriptions.indexOf(groupDescription);
                    this.menu.show(e);
                }
                e.preventDefault();
            })
        },
        gp_initializedMenu: function(menu) {
            this.menu = menu;
        },
        gp_itemClicked: function(menu) { // handle menu commands
            // let grid = this.flex,
                // cv = grid.collectionView,
                // groupIndex = this.groupIndex;
            switch (menu.selectedIndex) {
                case 0: // expand all
                    this.flex.collapseGroupsToLevel(this.groupIndex + 1);
                    break;
                case 1: // collapse all
                    this.flex.collapseGroupsToLevel(this.groupIndex);
                    break;
                
                // case 3: // sort asc
                // case 4: // sort desc
                // case 5: // no sort
                //     cv.deferUpdate(() => {
                //         cv.sortDescriptions.clear();
                //         if (menu.selectedIndex !== 5) {
                //             let binding = cv.groupDescriptions[groupIndex].propertyName;
                //             cv.sortDescriptions.push(new SortDescription(binding, menu.selectedIndex === 3));
                //         }
                //     });
                //     break;
                
                // case 7: // remove group
                //     cv.groupDescriptions.removeAt(groupIndex);
                //     break;
            }
        },
        onLoadFullItemsSource__Click(cell) {
            const vueObj = this
            const attr_col = vueObj.store.dropdown.attr_col
            // IE 2026 08 27 / ODOO-5800 (Igor: «не нажимается переход в список» в гриде фильтров отчёта):
            // у AttrMulti-колонки (Value = rightValue, collapseTo rightValue.valueStr) binding атрибута ≠ binding
            // колонки flex — поиск по attr_col.binding не находил колонку и обработчик молча выходил.
            // Колонка — по ячейке дропдауна (col / col_binding), затем по collapseTo, затем по binding
            const _cell = cell || vueObj.store.dropdown.parent_attr?.cell
            const cols = vueObj.flex.columns
            let col = (_cell && Number.isInteger(_cell.col) && cols[_cell.col]?.binding === _cell.col_binding) ? cols[_cell.col] : null
            if (!col && _cell?.col_binding) col = cols.find(c => c.binding === _cell.col_binding)
            if (!col && attr_col?.collapseTo) col = cols.find(c => c.binding === attr_col.collapseTo)
            if (!col && attr_col?.binding) col = cols.find(c => c.binding === attr_col.binding)
            if (!col) return
            col.dataMapEditor = 'AutoComplete'
            col.isRequired = false
            vueObj.store.get_itemsSource(vueObj, col, attr_col, { fetchMode: 'all' })
        },
        onOpenListItemsSource__Click() {
            const vueObj = this
            const dropdown = vueObj.store.dropdown
            const relation_segment = dropdown.V?.relation_segment || dropdown.attr_col?.relation_segment
            if (!relation_segment) return
            vueObj.store.executeStoreMethod(vueObj, {
                action_name: 'action-front-2026-06-24-openList-relation_segment',
                command: 'widget_open',
                widget: 'widget-list',
                fieldsMapping: [
                    { leftValue: 'doc.params.segment', rightValue: relation_segment },
                ],
            })
        },
        // IE 2026 09 26 / ODOO-5800 (замер gantt_payload, Bio: при открытом Ганте движений скрытая таблица того же списка заказывала словари по 93 830 строкам —
        // 3,8 с блокировки потока до отрисовки Ганта): fe.ux.gridDictPrefetchVisibleOnly (по умолчанию ВКЛ, utils/tabsLazy.js) — префетч только у грида ВИДИМОЙ
        // вкладки; грид скрытой вкладки получает словари обычным путём при первом показе (handleVisibility → content_Changed_afterTimeout → set_itemsSource).
        // Выбранная вкладка известна после initialized панели — у грида первого кадра виджета (панель ещё не инициализирована) решение откладывается на
        // один таймер (обновления данных за это время сливаются в один префетч). Выключено — прежний немедленный префетч. Замеры: tabsLazy.stats()
        prefetch_hiddenDicts_lazy() {
            if (!dictVisibleOnly_on(this.store)) return this.prefetch_hiddenDicts_timed()
            const decide = () => {
                const hidden = inHiddenTab(this)
                if (hidden === true) { tabsLazy_count('dictSkipped'); return }
                this.prefetch_hiddenDicts_timed(hidden)
            }
            if (inHiddenTab(this) !== null) return decide()
            if (this._dictPrefetchTimer) return
            this._dictPrefetchTimer = setTimeout(() => {
                this._dictPrefetchTimer = null
                if (this.$?.isUnmounted) return
                decide()
            }, 0)
        },
        prefetch_hiddenDicts_timed(hidden) {
            // IE 2026 09 26 / ODOO-5800: замер префетча — отдельно для скрытой вкладки (флаг выключен) и для видимой; у грида первого кадра вкладка
            // становится известна после initialized панели — отнесение замера откладывается на таймер
            const t0 = performance.now()
            this.prefetch_hiddenDicts()
            const ms = performance.now() - t0
            if (hidden === undefined) hidden = inHiddenTab(this)
            if (hidden === null) setTimeout(() => tabsLazy_count(inHiddenTab(this) === true ? 'dictHidden' : 'dictVisible', ms), 0)
            else tabsLazy_count(hidden ? 'dictHidden' : 'dictVisible', ms)
        },
        prefetch_hiddenDicts() {
            // tabDictPrefetch: грид смонтирован в скрытой вкладке — заказать те же
            // словари/тайтлы, что set_itemsSource + resolve_titlesByIds_ запросят
            // при первом показе (зеркало их условий). Повторные вызовы дёшевы:
            // get_itemsSource дедуплицирует по кэшу сегмента и _pending_ids
            const store = this.store
            // колонки — рекурсивно, с вложенными в группы (attr_by_binding, по
            // которому пойдёт resolve_titlesByIds_, — плоский по ВСЕМ уровням:
            // «Type → Link» = SEGMENTS-UNION, «Access rules → View» = ACCESS)
            const cols = []
            const walkCols = (list) => {
                for (const a of (list || [])) {
                    if (!a) continue
                    cols.push(a)
                    if (a.attrs?.length) walkCols(a.attrs)
                }
            }
            walkCols(this.attr?.attrs_columns || this.attr?.attrs || [])
            let allRows = null // лениво: собираем строки только если дошли до by_ids
            const getRows = () => {
                if (allRows) return allRows
                allRows = Array.isArray(this.data) ? this.data : []
                const childItemsPath = this.attr?.childItemsPath
                if (childItemsPath && allRows.length) {
                    const flat = []
                    const collect = (rows) => {
                        for (const row of rows) {
                            flat.push(row)
                            if (row[childItemsPath]?.length) collect(row[childItemsPath])
                        }
                    }
                    collect(allRows)
                    allRows = flat
                }
                return allRows
            }
            for (const attr_col of cols) {
                const t = attr_col?.attr_type
                if (t === 'AttrLink-2025' || t === 'AttrLin-2025') {
                    store.get_itemsSource(this, {}, attr_col, { fetchMode: 'all' })
                    continue
                }
                if (t !== 'AttrLink' && t !== 'AttrLinkChips') continue
                if (attr_col.use_itemsSourcesView || (attr_col.itemsSource && attr_col.itemsSource.length)) continue
                const _isStatusCol = this.isChipSegment(attr_col.relation_segment)   // IE 2026 09 18 / ODOO-5800: + GRADE
                if (store.fetchMode === 'by_ids' && attr_col.relation_segment
                        && t !== 'AttrLinkChips' && !_isStatusCol) {
                    const ids = [...new Set(
                        getRows()
                            .map(row => store.get_value(row, attr_col.binding))
                            .filter(id => id && !String(id).startsWith('=') && !String(id).startsWith('#'))
                    )]
                    if (ids.length) store.get_itemsSource(this, {}, attr_col, { ids })
                } else {
                    store.get_itemsSource(this, {}, attr_col, { fetchMode: 'all' })
                }
            }
            // AttrMulti: сегмент ссылки задаётся В ЗНАЧЕНИИ ячейки
            // (V.relation_segment — viewList: Link/Access rules), у колонки его
            // нет — собрать ids по сегментам из самих строк
            const multiBySeg = {}
            for (const attr_col of cols) {
                if (attr_col?.attr_type !== 'AttrMulti') continue
                for (const row of getRows()) {
                    const V = store.get_value(row, attr_col.binding)
                    const seg = V?.relation_segment || attr_col.relation_segment
                    if (V?.value && V.attr_type === 'AttrLink' && seg) {
                        (multiBySeg[seg] = multiBySeg[seg] || new Set()).add(V.value)
                    }
                }
            }
            for (const seg in multiBySeg) {
                const ids = [...multiBySeg[seg]].filter(id => id && !String(id).startsWith('=') && !String(id).startsWith('#'))
                if (ids.length) store.get_itemsSource(this, {}, { relation_segment: seg, attr_type: 'AttrLink' }, { ids })
            }
        },
        resolve_titlesByIds_() {
            const data = this.data000

            if (this.store.fetchMode !== 'by_ids') return;
            if (!data?.length) return;

            // R1 (fastEntry.holdTitles): на ПЕРВОМ пакете данных держим скелетон виджета,
            // пока Link-колонкам не приедет dataMap — без этого первый кадр мелькает
            // сырыми id. Последующие обновления грид не прячут: точечная подмена
            // терпимее, чем пропадание уже показанной таблицы
            const hold = (this.store.fastEntry.holdTitles && !this._had_first_data) ? new Set() : null
            this._had_first_data = true

            const childItemsPath = this.attr.childItemsPath
            let allRows = data
            if (childItemsPath) {
                allRows = []
                const collect = (rows) => {
                    for (const row of rows) {
                        allRows.push(row)
                        if (row[childItemsPath]?.length) collect(row[childItemsPath])
                    }
                }
                collect(data)
            }

            for (let binding in this.attr_by_binding) {
                const attr_col = this.attr_by_binding[binding];
                // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди): составной тип — id колонки пачкой: по одному by_ids-запросу на сегмент, до которого дошла очередь id
                const _mtlSegs = mtl_segments(attr_col, this.store)
                if (_mtlSegs) {
                    this.mtl_watch(_mtlSegs)
                    mtl_resolveMany(this.store, _mtlSegs, allRows.map(row => this.store.get_value(row, attr_col.binding)), this)
                    continue
                }
                // IE 2026 08 28 / ODOO-5800 (заказ Игоря): ссылка с relation_segment_binding — сегмент у каждой
                // строки свой (регистр тестов: doc.source_id из WIDGET-LIST/WIDGET-REPORT2/...). Единый dataMap
                // колонки невозможен: id группируем по сегменту СТРОКИ и докачиваем словари той же by_ids-очередью;
                // тайтл в ячейку кладёт formatItem (linkSegBinding_paint), перерисовка — по itemsSource_change_index
                if (attr_col.attr_type === 'AttrLink' && attr_col.relation_segment_binding && !attr_col.relation_segment) {
                    const bySeg = {}
                    for (const row of allRows) {
                        const id = this.store.get_value(row, attr_col.binding)
                        const seg = this.store.get_value(row, attr_col.relation_segment_binding)
                        if (!id || !seg || typeof seg !== 'string' || String(id).startsWith('=') || String(id).startsWith('#')) continue
                        (bySeg[seg] = bySeg[seg] || new Set()).add(id)
                    }
                    for (const seg in bySeg) {
                        (this._segBinding_segments = this._segBinding_segments || new Set()).add(seg)
                        this.store.get_itemsSource(this, {}, { attr_type: 'AttrLink', relation_segment: seg }, { ids: [...bySeg[seg]] })
                    }
                    continue
                }
                if (attr_col.attr_type === 'AttrLink' && attr_col.relation_segment) {
                    const ids = [...new Set(
                        allRows
                            .map(row => this.store.get_value(row, attr_col.binding))
                            .filter(id => id && !String(id).startsWith('=') && !String(id).startsWith('#'))
                    )]
                    if (ids.length) {
                        if (hold) {
                            const is = this.store.itemsSource[attr_col.relation_segment]
                            if (ids.some(id => !is?.ids?.[id] && !is?._missing_ids?.has(id))) {
                                hold.add(attr_col.relation_segment)
                            }
                        }
                        const col = this.flex.columns.find(c => c.binding === attr_col.binding)
                        this.store.get_itemsSource(this, col, attr_col, {ids})
                    }
                }
            }

            if (hold?.size) {
                this.titles_pending = hold
                // реестр удерживающих гридов: по нему waveGuard (R9) снимает холд,
                // когда словарь ответил пусто и вотчер itemsSource не сработает
                if (!this.store._titleHolders) this.store._titleHolders = new Set()
                this.store._titleHolders.add(this)
                const W = this.WIDGET
                W._gridTitlesPending = (W._gridTitlesPending || 0) + 1
                this._titles_hold_t0 = performance.now()
                if (this.store.fastEntry.timings) console.log(`[fastEntry:R1] hold ${W.id}: ${[...hold].join(', ')}`)
                // страховка: словарь завис/ошибка — показать как есть, не позже потолка
                this._titles_failsafe = setTimeout(() => this.titles_release('failsafe'), this.store.fastEntry.holdTitles_ms ?? this.store.setting('fe.ux.holdTitlesMs', 800))   // IE 2026 09 05 / ODOO-336330
            }
        },
        linkSegBinding_paint(e_cell, dataItem, col) {
            // IE 2026 08 28 / ODOO-5800 (заказ Игоря): AttrLink с relation_segment_binding — тайтл из словаря
            // сегмента СТРОКИ; словари качает resolve_titlesByIds_, недостающие id доезжают той же очередью
            const attr_col = col && this.attr_by_binding[col.binding]
            if (!attr_col || attr_col.attr_type !== 'AttrLink' || !attr_col.relation_segment_binding || attr_col.relation_segment) return
            if (!dataItem) return
            const value = this.store.get_value(dataItem, col.binding)
            if (!value || typeof value !== 'string') return
            const segment = this.store.get_value(dataItem, attr_col.relation_segment_binding)
            if (!segment || typeof segment !== 'string') return
            const title = this.store.itemsSource[segment]?.ids?.[value]?.title
            if (title && !e_cell.childElementCount && e_cell.textContent === value) {
                e_cell.textContent = title
            } else if (!title && this.store.fetchMode === 'by_ids') {
                // строка появилась позже пакета (дозагрузка/правка) — точечная докачка, очередь мержит id
                (this._segBinding_segments = this._segBinding_segments || new Set()).add(segment)
                this.store.get_itemsSource(this, {}, { attr_type: 'AttrLink', relation_segment: segment }, { fetchMode: 'by_ids', ids: [value] })
            }
        },
        // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди):
        // ячейка колонки составного типа: название из словаря сегмента, где id найден первым (сырой id — пока ждём / нигде нет); недостающие id
        // доспрашиваются той же очередью. Значение — прямым чтением dataItem (store.get_value — действие Pinia, не в цикле ячеек), вложенный binding — через стор
        // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди) · p048b:
        // строки-поля формы записи (AttrTabGrid): store.prepare_AttrMulti → mtl_valueMulti зовёт эту подписку; ответ словаря одного из сегментов —
        // пересобрать подписи строк (prepare_AttrMulti_all: название / пометка / стрелка) и перерисовать (flex.refresh чистит кэш formatItem —
        // cache_data_cells, кэш-путь не держит старый класс). Ответов несколько — одна пересборка за тик
        mtl_formWatch(segs) {
            if (!this._mtl_formSegs) this._mtl_formSegs = new Set()
            for (const s of segs) this._mtl_formSegs.add(s)
            if (this._mtl_formUnsub) return
            this._mtl_formUnsub = mtl_subscribe(this.store, (seg) => {
                if (this.$?.isUnmounted) { this._mtl_formUnsub?.(); this._mtl_formUnsub = null; return }
                if (!this._mtl_formSegs?.has(seg) || this._mtl_formT) return
                this._mtl_formT = setTimeout(() => {
                    this._mtl_formT = null
                    if (this.$?.isUnmounted || !this.flex?.hostElement) return
                    this.prepare_AttrMulti_all()
                    this.flexRefresh()
                }, 0)
            })
        },
        mtl_paint(e_cell, dataItem, col) {
            if (!col || !dataItem) return
            const segs = mtl_segments(this.attr_by_binding[col.binding], this.store)
            if (!segs) return
            const b = col.binding
            const value = (typeof b === 'string' && !b.includes('.')) ? dataItem[b] : this.store.get_value(dataItem, b)
            if (!value || typeof value !== 'string') return
            this.mtl_watch(segs)
            const r = mtl_resolve(this.store, segs, value, this)
            if (r.state === 'found' && r.title && !e_cell.childElementCount && e_cell.textContent === value) e_cell.textContent = r.title
        },
        // ответ словаря одного из сегментов колонок составного типа — перерисовать (пустой ответ вотчер itemsSource_change_index не будит)
        mtl_watch(segs) {
            if (this._mtl_lastSegs === segs && this._mtl_unsub) return
            this._mtl_lastSegs = segs
            if (!this._mtl_segments) this._mtl_segments = new Set()
            for (const s of segs) this._mtl_segments.add(s)
            if (this._mtl_unsub) return
            this._mtl_unsub = mtl_subscribe(this.store, (seg) => {
                if (this.$?.isUnmounted) { this._mtl_unsub?.(); this._mtl_unsub = null; return }   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди) · p048b: до появления flex подписку не снимать
                if (!this.flex?.hostElement) return
                if (this._mtl_segments?.has(seg)) this.flexRefresh()
            })
        },
        titles_release(reason) {
            // R1: снять удержание скелетона; идемпотентно — зовётся из watch
            // itemsSource_change_index, страховочного таймера и beforeUnmount
            if (!this.titles_pending) return
            this.titles_pending = null
            this.store._titleHolders?.delete(this)
            clearTimeout(this._titles_failsafe)
            const W = this.WIDGET
            if (W._gridTitlesPending > 0) W._gridTitlesPending--
            if (this.store.fastEntry.timings) {
                console.log(`[fastEntry:R1] release ${W.id} (${reason}) +${Math.round(performance.now() - this._titles_hold_t0)}ms`)
            }
        },
        onButtonOpen__Click(cell, e=null) {
            const vueObj = this
            let action = cell

            window.$cg.setTimeout(this, "AttrGrid.onButtonOpen__Click", () => {
            // this.$nextTick(() => {
                // IE 2026 08 20 / ODOO-5512: грид мог быть размонтирован до
                // срабатывания таймера (закрытие дропдауна настроек по клику)
                if (!this.flex?.hostElement || !this.flex.rows[cell.row]) return
                let value, itemOdoo, attr_col,
                dataItem = this.flex.rows[cell.row].dataItem,
                V = attr_col = this.attr_by_binding[cell.col_binding]

                if (this.attr.isPrintTemplate) {
                    // IE 2026 09 23 / ODOO-341407: i18n
                    const actionMenu = { 'tooltip': t('Open cell'), 'action_name':'action-front-openLine-2025-09-23-2',command:'widget_open', 'widget':'widget-row', 'type': 'widget-row-cell', '_activate':true, 'get_currentRow':true, 'get_Parent':true, 'open_in_children_widget':true, 'cssClass':'pi p-button-white pi-pencil',
                        'binding':vueObj.attr.binding, col_binding: attr_col?.binding, 'attrs':[] }
                    vueObj.store.executeStoreMethod(vueObj.WIDGET.vueObj, actionMenu, vueObj.attr)
                    return
                }

                let idSrc = dataItem   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #115712, слово Igor: relation_row — переход к шагу согласования) (ТЗ п.3): в карточке (AttrTabGrid, строки = поля) relation_id_binding / relation_row читаются из ЗАПИСИ, а не из строки таблицы полей
                if (attr_col.attr_type === 'AttrMulti') {
                    V = this.store.check_AttrMulti(attr_col, dataItem)

                    if (this.attr.attr_type === 'AttrTabGrid' && dataItem?.attr?.attr_type) {
                        idSrc = this.WIDGET.record || {}   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #115712, слово Igor: relation_row — переход к шагу согласования)
                        V = {...dataItem.attr}
                        if (V.relation_segment_binding) {
                            V.relation_segment = this.store.get_value(this.WIDGET.record, V.relation_segment_binding)
                            V.relation_segment_binding = null
                        }
                        if (V.relation_version_binding) {
                            V.relation_version = this.store.get_value(this.WIDGET.record, V.relation_version_binding)
                            V.relation_version_binding = null
                        }
                    }

                    value = V.value
                    itemOdoo = [V.value, V.valueStr]
                } else {
                    value = this.flex.getCellData(cell.row, cell.col)
                    itemOdoo = this.store.get_value(dataItem, attr_col.binding) // this.data000[cell.irow][V.binding]
                }

                // IE 2026 10 29 / ODOO-5800 (ie-dm7 #115712, слово Igor: relation_row — переход к шагу согласования): колонка (поле карточки) с relation_row — «→» / Alt+клик открывают строку табличной части другой записи; не действует — как было
                if (!action.createNew && this.relationRow_open(V, attr_col, idSrc, dataItem, action)) return
                if (action.createNew || (attr_col.attr_type === 'AttrMulti' && V.is_customValueWarning)) {
                    if (attr_col.attr_type === 'AttrMulti') {
                        if (V.is_customValueWarning && V.valueStr) {
                            this.store.widget_open({
                                record:{
                                    id: value, // 2025-08-11
                                    title: V.valueStr,
                                    segment:V['new-segment'] || V.relation_segment,
                                    version: V.relation_version,
                                    _meta: {
                                        // createNew:true, 2025-08-11
                                        collection: V.relation_collection,
                                        relation_binding:V.relation_binding,
                                    },
                                },
                                parent_record: dataItem,
                                parentAction: { 'action_name':'action-front-10', method: 'onButtonOpen__Click' },
                                externalLink_method: action.externalLink_method,
                            }, this.WIDGET.vueObj, this.set_newLink, [cell])
                            return
                        }
                    }
                    this.store.show_notification({text: t('Enter a new title to add it!')})   // IE 2026 09 23 / ODOO-341407: i18n
                } else if (!value) {
                    // this.store.choiceStart(this.WIDGET.vueObj, cell)
                } else if (V.attr_type === 'AttrLinkOdoo') {
                    const relation_id = V.relation_id_binding ? this.store.get_value(idSrc, V.relation_id_binding) : itemOdoo[0]   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #115712, слово Igor: relation_row — переход к шагу согласования): idSrc (было dataItem)
                    const relation_segment = V.relation_segment_binding ? this.store.get_value(dataItem, V.relation_segment_binding) : V.relation_segment
                    const relation_version = V.relation_version_binding ? this.store.get_value(dataItem, V.relation_version_binding) : V.relation_version
                    this.store.widget_open({
                        widget: 'widget-record',
                        record: {
                            id: relation_id,
                            // title из значения ячейки — шапка попапа сразу с названием, не с id
                            title: Array.isArray(itemOdoo) ? itemOdoo[1] : undefined,
                            _meta: {
                                // attr: {
                                    segment: relation_segment,
                                    collection: V.relation_collection,
                                    version: relation_version,
                                    relation_binding: V.relation_binding,
                                // }
                            },
                        },

                        parent_record: dataItem,
                        parentAction: { 'action_name':'action-front-2024-01-23-2', method: 'AttrLinkOdoo.onButtonOpen__Click' },
                        externalLink_method: action.externalLink_method,
                    }, this.WIDGET.vueObj)
                } else {
                    const relation_id = V.relation_id_binding ? this.store.get_value(idSrc, V.relation_id_binding) : value   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #115712, слово Igor: relation_row — переход к шагу согласования): idSrc (было dataItem)
                    let relation_segment = V.relation_segment_binding ? this.store.get_value(dataItem, V.relation_segment_binding) : V.relation_segment
                    if (!relation_segment && !V.relation_segment_binding) relation_segment = mtl_segmentOf(this.store, V, relation_id)   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди): открытие — в сегменте, где id найден
                    const relation_version = V.relation_version_binding ? this.store.get_value(dataItem, V.relation_version_binding) : V.relation_version

                    if (relation_segment) {
                        const ids = [relation_id]
                        const itemsSource = vueObj.store.get_itemsSource(vueObj, {}, V, {ids})
                        const sourceItem = itemsSource?.ids?.[relation_id]
                        relation_segment = sourceItem?.segment || relation_segment

                        this.store.widget_open({
                            record:{
                                id: relation_id,
                                // title из реестра/ячейки — шапка попапа сразу с названием, не с id
                                title: sourceItem?.title || V.valueStr || undefined,
                                _meta: {
                                    // attr: {
                                        segment:relation_segment,
                                        collection: V.relation_collection,
                                        version: relation_version,
                                        relation_binding:V.relation_binding,
                                    // }
                                },
                            },
                            parent_record: dataItem,
                            parentAction: { 'action_name':'action-front-10', method: 'onButtonOpen__Click' },
                            externalLink_method: action.externalLink_method,
                        }, this.WIDGET.vueObj)
                    } else {
                        this.execute_dblclick({}, true)
                    }
                }
            }, this.flex.activeEditor ? 400 : 50)
        },
        // IE 2026 10 29 / ODOO-5800 (ie-dm7 #115712, слово Igor: relation_row — переход к шагу согласования)
        // Цель relation_row ячейки: rr — у поля карточки (V = dataItem.attr) либо у колонки; rec — запись строки (в карточке — WIDGET.record). null — не действует
        relationRow_cellTarget(V, attr_col, rec) {
            if (!relationRow_flagOn((k, d) => this.store.setting(k, d))) return null
            const rr = V?.relation_row || attr_col?.relation_row
            if (!rr || !rec) return null
            return relationRow_target(rr, rec, (o, b) => this.store.get_value(o, b))
        },
        // открыть запись сегмента relation_row на вкладке path; строка — по row_match (mainStore.set_activeAttr); true — открыто, false — прежнее поведение
        relationRow_open(V, attr_col, rec, dataItem, action = {}) {
            const target = this.relationRow_cellTarget(V, attr_col, rec)
            if (!target) return false
            this.store.widget_open({
                record: { id: target.id, _meta: { segment: target.segment } },
                parent_record: rec,
                parentAction: { action_name: 'action-front-relation-row', method: 'onButtonOpen__Click', activeAttr: relationRow_activeAttr(target) },
                externalLink_method: action?.externalLink_method,
            }, this.WIDGET.vueObj)
            return true
        },
        // карточка выделенной строки — как карандаш строки (заголовок строки грида, action-front-openLine-2025-12-27); после отрисовки выделения
        relationRow_openSelected() {   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #115712, слово Igor: relation_row — переход к шагу согласования)
            window.$cg.setTimeout(this, 'AttrGrid.relationRow_openSelected', () => {
                if (!this.flex?.hostElement || !this.flex.selection || this.flex.selection.row < 0) return
                const actionMenu = { 'tooltip': t('Open line'), 'action_name':'action-front-openLine-2025-12-27', command:'widget_open', 'widget':'widget-row', '_activate':true, 'get_currentRow':true, 'get_Parent':true, 'open_in_children_widget':true, 'cssClass':'pi p-button-white pi-pencil', source_name:this.attr.name, 'binding':this.attr.binding, attrs:this.attr.attrs, widgetRow_params:this.attr.widgetRow_params }
                this.store.executeStoreMethod(this.WIDGET.vueObj, actionMenu, this.attr)
            }, 100)
        },
        set_newLink(WIDGET1, cell) {
            let attr_col,
            dataItem = this.flex.rows[cell.row].dataItem,
            V = attr_col = this.attr_by_binding[cell.col_binding]
            if (attr_col.attr_type === 'AttrMulti') {
                V = this.store.check_AttrMulti(attr_col, dataItem)
                
                const parent_attr = {...this.attr, attr_col:V, attr_col2:attr_col, cell:cell},
                chosenItem = WIDGET1.record
                
                this.store.set_itemsSource_newItem(V, {
                    id: WIDGET1.record.id,
                    title: WIDGET1.record.title,
                })

                this.choiceFinish(parent_attr, chosenItem)

                // V.value = WIDGET1.record.id
                // V.valueStr = WIDGET1.record.title
                // V.is_customValueWarning = false

            } else {
                V.value = WIDGET1.record.id
            }
        },
        onButtonSearch__Click(cell) {
            let search_value, V, itemOdoo,
            dataItem = this.flex.rows[cell.row].dataItem
            search_value = this.flex.getCellData(cell.row, cell.col)

            if (search_value) {
                this.store.globalSearch.show(search_value)
            }
        },
        onButtonCollapsed__Click(cell) {
            if (cell.irow) {
                let row_from = this.flex.rows[cell.irow].dataItem
                this.collapsed_rowGroup(cell.irow, !row_from.isCollapsed)
            } else {
                let attr_from = this.attr_by_binding[cell.col_binding]
                this.collapsed_columnGroup(cell.col_binding, !attr_from.isCollapsed)
            }
        },
        attrResize() {
            this.need_attrResize_afterTimeout = true
            if (!this.isVisible) {
                return
            }
            // if (!this.isVisible) return FIXEDIT Scroll bars are lost
            if (this.attrResize_timeout) { clearTimeout(this.attrResize_timeout) }
            this.attrResize_timeout = window.$cg.setTimeout(this, "AttrGrid.attrResize", () => {
                this.attrResize_afterTimeout()
                this.attrResize_timeout = null
            }, 1)
        },
        attrResize_afterTimeout() {
            this.need_attrResize_afterTimeout = false
            // if (!this.store.hide_console) console.log('attrResize')
                const elementForm = document.getElementById(`WIDGET${this.widget_id}`);
                // const elementForm = document.getElementById(`containerResize${this.attr.html_id}`)
                const elementFlex = this.$refs.attr_container
                const elementFlex_grid = document.getElementById(this.attr.html_id)
                // const elementTopLine = this.$refs.attr_top_line
                if (!elementForm || !elementFlex || !elementFlex_grid) {
                    return
                }
                const elementWidget_Rect = elementForm.getBoundingClientRect(),
                elementFlex_Rect = elementFlex.getBoundingClientRect(),
                elementFlex_grid_Rect = elementFlex_grid.getBoundingClientRect()
                // const elementTopLine_Rect = elementTopLine.getBoundingClientRect()
                if (elementFlex_Rect.height > 10) { // if mount all elements
                    // if (!this.attr.allow_formatItem) {
                    //     this.attr.allow_formatItem = true
                    //     this.flexRefresh()
                    // }

                    let newHeight = elementFlex_Rect.height
                    // закреплённая шапка (pinnedHeader): высота строго по контенту
                    // (видимые строки + шапка) — ветка растяжения (в т.ч. по
                    // newHeight===50) конкурировала с авто-высотой: мерцание при
                    // ресайзе и обрезанные строки (End date)
                    const inPinnedHeader = !!elementFlex.closest?.('.tab-panel-pinned')
                    if (inPinnedHeader) {
                        if (elementFlex.style.height) elementFlex.style.height = ''
                        const g = this.flex
                        if (g?.rows) {
                            const total = Math.ceil(g.rows.getTotalSize() + (g.columnHeaders?.height || 0)) + 3
                            const h = `${total}px`
                            if (elementFlex_grid.style.height !== h) elementFlex_grid.style.height = h
                        }
                        return
                    }
                    if (!this.attr.noResize || newHeight === 50) {
                        newHeight = Math.floor(elementWidget_Rect.bottom - elementFlex_Rect.top) // - 2
                        if (newHeight > elementWidget_Rect.height) {
                        // if (elementFlex_Rect.top < 0) {
                            // let visibleRect = this.getVisibleRect(elementFlex)
                            // newHeight = Math.floor(visibleRect.height) - 2
                            newHeight = 160
                        }
                        if (this.attr.size) {
                            newHeight = Math.round(newHeight * this.attr.size / 100)
                        }
                    } else {
                        // AttrTabGrid (noResize, авто-высота): wijmo даёт root высоту
                        // rows.getTotalSize(), но реальные ячейки на ~2px выше → ложный
                        // вертикальный скроллбар. Считаем высоту хоста точнее: сброс к
                        // авто, замер дефицита, добавляем его (+1 запас). Крупный дефицит
                        // (настоящий overflow) не трогаем — скроллбар там легитимен.
                        if (this.attr.attr_type === 'AttrTabGrid') {
                            const root = elementFlex_grid.querySelector('[wj-part="root"]')
                            if (root) {
                                if (elementFlex_grid.style.height) elementFlex_grid.style.height = ''
                                const deficit = root.scrollHeight - root.clientHeight
                                if (deficit > 0 && deficit <= 4) {
                                    elementFlex_grid.style.height = `${elementFlex_grid.offsetHeight + deficit + 1}px`
                                }
                            }
                        }
                        return
                    }
                    if (newHeight < (this.attr.minHeight||160)) {
                        newHeight = (this.attr.minHeight||160)
                    }
                    if (this.attr.maxHeight && newHeight > this.attr.maxHeight) {
                        newHeight = this.attr.maxHeight
                    } else if (newHeight > 1500) {
                        newHeight = 1500
                    }
                    if (this.attr.heightAdd) {
                        newHeight += this.attr.heightAdd
                    }
                    // if (this.get_viewParam('showGridSummaryLine')) {
                        // newHeight -= 20
                    // }
                    if (elementFlex.style.height !== `${newHeight}px`) { // elementFlex_Rect.height !== newHeight
                        elementFlex.style.height = `${newHeight}px`
                    }

                    let newHeight_grid = newHeight - Math.floor(elementFlex_grid_Rect.top - elementFlex_Rect.top)
                    if (elementFlex_grid.style.height !== `${newHeight_grid}px`) {
                        elementFlex_grid.style.height = `${newHeight_grid}px`

                        // // isMapped
                        // if (this.isMappedWidget_rows || this.isMappedWidget_cols) {
                        //     this.store.set_isMappedWidgets(this.WIDGET)
                        // }
                    }
                }
            // } else {
            //     this.attr.allow_formatItem = true
            // }
        },
        getVisibleRect(element) {
            let rect = element.getBoundingClientRect();
            let parent = element.parentElement;

            while (parent) {
                const parentRect = parent.getBoundingClientRect();
                const overflowStyle = window.getComputedStyle(parent).overflow;

                // Проверка стиля overflow родителя
                if (overflowStyle === 'hidden' || overflowStyle === 'auto' || overflowStyle === 'scroll') {
                    rect = {
                        top: Math.max(rect.top, parentRect.top),
                        right: Math.min(rect.right, parentRect.right),
                        bottom: Math.min(rect.bottom, parentRect.bottom),
                        left: Math.max(rect.left, parentRect.left),
                        width: Math.max(0, Math.min(rect.right, parentRect.right) - Math.max(rect.left, parentRect.left)),
                        height: Math.max(0, Math.min(rect.bottom, parentRect.bottom) - Math.max(rect.top, parentRect.top))
                    };
                }

                parent = parent.parentElement;
            }

            return rect;
        },
        collapsed_rowGroup(item_index, isCollapsed=true, justRefresh=false) {
            let item_from = this.data000[item_index]
            item_from.isCollapsed = isCollapsed
            let optionally_collapse = []
            for (let i=item_index+1; i<=item_from.collapseTo; i++) {
                let row = this.flex.rows[i]
                let dataItem = this.data000[i]
                if (row.visible !== !isCollapsed) {
                    row.visible = !isCollapsed
                }
                if (!justRefresh && !isCollapsed && 'isCollapsed' in dataItem) { //  && row.icol_group+1 === row_from.icol_group
                    if (dataItem.isCollapsed) {
                        i = dataItem.collapseTo
                    } else {
                        optionally_collapse.push(i)
                    }
                }
            }
            for (let i of optionally_collapse) {
                this.collapsed_rowGroup(i)
            }
        },
        collapsed_columnGroup(col_binding, isCollapsed=true, justRefresh=false) {
            // let attr_from = this.attr_by_binding[col_binding]
            // attr_from.isCollapsed = isCollapsed
            // for (let icol=attr_from.collapseFrom+1; icol<=attr_from.collapseTo; icol++) {
            //     let col = this.flex.columns[icol]
            //     if (col.visible !== !isCollapsed) {
            //         col.visible = !isCollapsed
            //     }
            // }
        },
        onMore_dropdown(cell, searchText) {
            let attr_col,
            dataItem = this.flex.rows[cell.row].dataItem,
            V = attr_col = this.attr_by_binding[cell.col_binding]
            if (attr_col.attr_type === 'AttrMulti') {
                V = this.store.check_AttrMulti(attr_col, dataItem)
            }
            const value = attr_col.attr_type === 'AttrMulti' ? V.value : this.flex.getCellData(cell.row, cell.col)

            this.store.open_widgetList_forAttr(value,
                {...this.attr, attr_col:V, attr_col2:attr_col, cell:cell},
                {'action_name':'action-front-9-1', method: 'AttrGrid.onСhoice__Click', params:{isChoise:true}},
                this,
                searchText
            )
        },
        onСhoice__Click(cell) {
            let value, attr_col,
            dataItem = this.flex.rows[cell.row].dataItem,
            V = attr_col = this.attr_by_binding[cell.col_binding]
            if (attr_col.attr_type === 'AttrMulti') {
                V = this.store.check_AttrMulti(attr_col, dataItem)

                value = V.value
            } else {
                value = this.flex.getCellData(cell.row, cell.col)
            }

            this.store.open_widgetList_forAttr(value, 
                {...this.attr, attr_col:V, attr_col2:attr_col, cell:cell}, 
                {'action_name':'action-front-9-1', method: 'AttrGrid.onСhoice__Click', params:{isChoise:true}}, 
                this
            )
        },
        choiceFinish(parent_attr, chosenItem) {
            let attr_col = parent_attr.attr_col2,
            cell = parent_attr.cell,
            dataItem = this.get_dataItem(cell.row, cell.col_binding, ''), // this.flex.rows[cell.row].dataItem,
            V = attr_col,
            oldVal = this.store.get_value(dataItem, cell.col_binding)

            // this.cellEditEnding2(cell, chosenItem.id, 'choiceFinish') 2024 12 08
            if (attr_col?.attr_type === RL_TYPE && this._rlCols?.[cell.col_binding]) {   // IE 2026 10 25 / ODOO-348925: AttrRowLink — выбор пишет ключ (<база>.<key_binding>), не title
                this.clearGhostTail()   // IE 2026 10 25 / ODOO-348925
                const _rlE = this._rlCols[cell.col_binding]   // IE 2026 10 25 / ODOO-348925
                this.rl_editCommit(cell.row, dataItem, _rlE, chosenItem?.id)   // IE 2026 10 25 / ODOO-348925
                if (this.flex.activeEditor) this.flex.activeEditor.value = rlShown(dataItem, _rlE.cfg, _rlE.src?.index, t).text   // IE 2026 10 25 / ODOO-348925: закрытие редактора тем же текстом — без второй правки
                return   // IE 2026 10 25 / ODOO-348925
            }   // IE 2026 10 25 / ODOO-348925
            this.clearGhostTail()   // IE 2026 10 10 / ODOO-341407 (Andrey via core #74395: grid autocomplete — detached value, Enter, arrows): выбранный пункт принят — серый хвост подсказки больше не нужен

            if (attr_col.attr_type === 'AttrMulti') {
                V = this.store.check_AttrMulti(attr_col, dataItem)
                oldVal = V.value

                this.store.reset_valueStr_translations(V) // i18n: значение меняется — переводы valueStr не актуальны
                V.value = chosenItem.id
                V.valueStr = chosenItem.title || chosenItem.id
                // IE 2026 10 29 / ODOO-5800 (ie-dm7 #116081, дефект Igor: процесна модель — id, не назва): выбранный пункт — в словарь сегмента: коммит редактора (Tab / уход фокуса) с его названием сопоставится с id
                if (linkIsRef(V) && linkTextToId_on(this.store)) this.store.itemsSource_addItem(this, V, chosenItem)   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #116081, дефект Igor: процесна модель — id, не назва)
                delete V.is_customValueWarning
                if (this.flex.activeEditor) {
                    this.flex.activeEditor.value = V.valueStr
                }

                this.relation_attr_set(V) // TODO set_value > undoStack

                this.flex.setCellData(cell.row, cell.col, V.valueStr)
            } else {
                // IE 2026 08 27 (Igor): выбранный пункт — в словарь сегмента, иначе ячейка показывает сырой id
                // (в словаре колонки только id из загруженных строк; тайтл был лишь у списка дропдауна)
                this.store.itemsSource_addItem(this, attr_col, chosenItem)
                this.flex.setCellData(cell.row, cell.col, chosenItem.id)
                
                this.store.set_value(dataItem, cell.col_binding, chosenItem.id) // 2026-01-15
                
                if (this.flex.activeEditor) {
                    this.flex.activeEditor.value = chosenItem.id
                }
            }
            // this.cellEditEnded2(cell) 2024 12 08
            if (!this.store.hide_console) console.log('choiceFinish')
            this.set_value(cell.row, dataItem, cell.col_binding, oldVal, chosenItem.id)
        },
        onEditFinish(parent_attr, value) {
            const vueObj = this,
            dropdown = vueObj.store.dropdown

            let attr_col = parent_attr.attr_col2,
            cell = parent_attr.cell,
            dataItem = this.get_dataItem(cell.row, cell.col_binding, ''), // this.flex.rows[cell.row].dataItem,
            V = attr_col

            // this.set_value(cell.row, dataItem, cell.col_binding, oldVal, value)

            this.cellEditEnding2(cell, value, 'onEditFinish')
            this.cellEditEnded2(cell)
            
            let valueAfter = dataItem ? this.store.get_value(dataItem, attr_col.binding) : null
            if (attr_col.attr_type === 'AttrMulti') {
                V = valueAfter
                valueAfter = V?.value
            }
            if (V?.format === 'bytes' && valueAfter != null && dropdown.divCell) {
                dropdown.divCell.innerHTML = `<span class="num-inner">${this.store.formatBytesText(valueAfter)}</span>`
            }
            if (value !== valueAfter) {
                dropdown.value = String(valueAfter)
            }
        },

        set_comment(parent_attr, comment) {
            let attr_col = parent_attr.attr_col2,
            cell = parent_attr.cell,
            dataItem = this.get_dataItem(cell.row, cell.col_binding, ''), // this.flex.rows[cell.row].dataItem,
            V = attr_col

            // IE 2026 08 19 / ODOO-5512 (заказ Игоря п.6): комментарий элемента —
            // в meta.appearance самого элемента (см. appearance_save; вызов идёт
            // на каждый ввод символа — сохранение дебаунсится внутри)
            if (this.attr.elements_appearance && dataItem?.id) {
                this.appearance_save(dataItem, { comment: comment || '' })
                this.flex.refreshRange(new wjGrid.CellRange(cell.row, 0, cell.row, this.flex.columns.length - 1))
                return
            }

            const raw_binding = attr_col.binding0.replace('data::', '')
            dataItem._cells = dataItem._cells || {}
            const _cells = this.store.get_value(dataItem, `_cells.${raw_binding}`) || {}
            this.store.set_value(dataItem, `_cells.${raw_binding}`, _cells)

            // const key = `${this.flex.cells.cellType}-${cell.row}-${cell.col}`,
            // divCell = this.divCells.get(key)
            // if (_cells.comment) {
            //     wjcCore.addClass(divCell, 'wj-has-notes')
            // } else {
            //     wjcCore.removeClass(divCell, 'wj-has-notes')
            // }

            let rowStack = {
                method: 'comment',
                actionStack: this.actionStack,
                irow: cell.row,
                icol: cell.col,
                $key: dataItem.$key,
                $item: dataItem, // undo/redo резолвит строку по ссылке
                col_binding: raw_binding,
            }

            rowStack.comment = _cells.comment || ''
            rowStack.newComment = _cells.comment = comment

            rowStack.comment__updated_at = _cells.comment__updated_at || ''
            rowStack.newComment__updated_at = _cells.comment__updated_at = this.store.formatUTC(new Date())

            rowStack.comment__updated_by = _cells.comment__updated_by || ''
            rowStack.newComment__updated_by = _cells.comment__updated_by = this.store.user.id

            this.setModified(dataItem)

            this.flex.refreshRange(new wjGrid.CellRange(cell.row, cell.col, cell.row, cell.col));

            // undoStack
            const last_rowStack = this.undoStack.at(-1)
            if (last_rowStack && last_rowStack.irow === rowStack.irow && last_rowStack.icol === rowStack.icol && last_rowStack.method === 'comment') {
                last_rowStack.newComment = rowStack.newComment
            } else {
                this.pushStack(rowStack)
                this.actionStack++
            }
        },
        appearance_histPush(dataItem, prev, label) {
            // IE 2026 08 20 (заказ Игоря): форматирование и комментарий — под undo/redo.
            // Снимок _appearance целиком (метод 'props' восстанавливает по пути);
            // посимвольный ввод комментария схлопывается в одну запись истории
            const next = this.store.deepCopy(dataItem._appearance || null)
            const last = this.undoStack?.[this.undoStack.length - 1]
            if (last && last.method === 'props' && last._apItem === dataItem && last.label === label) {
                last.cells[0].newValue = next
                return
            }
            this.hist_push({ method: 'props', _apItem: dataItem, label,
                cells: [{ item: dataItem, path: '_appearance', oldValue: prev, newValue: next }] })
        },
        appearance_save(dataItem, patch) {
            // IE 2026 08 19 / ODOO-5512 (заказ Игоря п.6): универсальное оформление
            // элементов списка — цвет/комментарий в meta.appearance САМОГО элемента
            // (метод бэка save_element_appearance). Локально применяется сразу;
            // отправка дебаунсится (комментарий печатается посимвольно) и НЕ
            // помечает запись виджета изменённой (кнопка Save не нужна)
            const id = dataItem?.id
            if (!id) return false
            const _prevSnap = this.store.deepCopy(dataItem._appearance || null)
            const app = { ...(dataItem._appearance || {}) }
            let changed = false
            for (const k of Object.keys(patch)) {
                const v = patch[k]
                if (v == null || v === '') { if (k in app) { delete app[k]; changed = true } }
                else if (app[k] !== v) { app[k] = v; changed = true }
            }
            if (!changed) return true
            dataItem._appearance = Object.keys(app).length ? app : null
            if (!this.attr.appearance_saveNow) {
                // IE 2026 08 20 (заказ Игоря): НЕ сохранять сразу — оформление
                // пишется К СТРОКЕ, список помечается изменённым, сохранит
                // дискетка таблицы (BE: update_data мержит _appearance строки
                // в meta.appearance записи)
                this.setModified(dataItem)
                this.appearance_histPush(dataItem, _prevSnap, 'comment' in patch ? t('Element comment') : t('Element color'))   // IE 2026 09 23 / ODOO-341407: i18n
                return true
            }
            // дропдаун настроек: своей дискетки нет — сохраняем сразу методом бэка
            this._appearancePending = this._appearancePending || new Map()
            const pend = this._appearancePending.get(id) || {}
            Object.assign(pend, patch)
            this._appearancePending.set(id, pend)
            if (this._appearanceTimeout) clearTimeout(this._appearanceTimeout)
            this._appearanceTimeout = setTimeout(() => {
                this._appearanceTimeout = null
                const items = [...this._appearancePending.entries()]
                this._appearancePending.clear()
                for (const [eid, ep] of items) {
                    this.store.executeStoreMethod(this.WIDGET.vueObj, {
                        command: 'executeWidgetMethod', method: 'save_element_appearance',
                        no_del_last_backend_action: true,
                        params: { id: eid, appearance: ep, segment: dataItem.segment || '' },
                        record_sendToBackend_exclude: ['_doc'],
                    }, this.attr)
                }
            }, 800)
            return true
        },
        set_color(colorPickerref) {
            const vueObj = this

            if (this.applyRowStyle) {
                this.set_rowStyleColor(colorPickerref)
                return
            }

            // const dropdown = vueObj.store.dropdown,
            // parent_attr = dropdown.parent_attr,
            // attr_col = parent_attr.attr_col2,
            // cell = parent_attr.cell
            // this.set_color2(colorPickerref, cell.row, cell.col)

            const range = this.get_selectedRange();
            if (!range) return;
            let { irow1, irow2, icol1, icol2 } = range;

            const histCells = [] // история Undo/Redo: одна группа на всю заливку
            for (let irow = irow1; irow <= irow2; irow++) {
                for (let icol = icol1; icol <= icol2; icol++) {
                    const entry = this.set_color2(colorPickerref, irow, icol)
                    if (entry) histCells.push(entry)
                }
            }
            if (histCells.length) {
                this.hist_push({
                    method: 'props', cells: histCells,
                    label: (this.applyFillColor ? t('Fill color') : t('Text color')) + ' (' + tn(histCells.length, '{n} cell', '{n} cells') + ')',   // IE 2026 09 23 / ODOO-341407: i18n
                })
            } else {
                this.actionStack++
            }
        },
        set_color2(colorPickerref, row, col) {
            const vueObj = this
            const col_binding = this.flex.columns[col].binding
            const dataItem = this.get_dataItem(row, col_binding, '')

            // IE 2026 08 19 / ODOO-5512 (заказ Игоря п.6): список элементов — цвет
            // пишется в meta.appearance САМОГО элемента (universal), а не в _cells
            // записи виджета (там терялся при обновлении списка); запись не
            // помечается изменённой — сохранение уходит сразу методом бэка
            if (this.attr.elements_appearance && dataItem?.id) {
                const _color = colorPickerref.value !== '#ffffff' ? String(colorPickerref.value) : ''
                this.appearance_save(dataItem, this.applyFillColor ? { backgroundColor: _color } : { color: _color })
                this.cellCache_drop(row, 0, this.flex.columns.length - 1)   // IE 2026 09 25 / ODOO-… (замечание Игоря: кнопки цвета строки в гриде формы)
                this.flex.refreshRange(new wjGrid.CellRange(row, 0, row, this.flex.columns.length - 1))
                return null
            }

            const raw_binding = col_binding.replace('data::', '')
            const style = this.store.get_value(dataItem, `_cells.${raw_binding}.fields[0].style`) || {}

            const colorProp = this.applyFillColor ? 'background-color' : 'color';
            const newValue = colorPickerref.value !== '#ffffff' ? `${colorPickerref.value}` : ''; // !important

            const oldValue = style[colorProp] || ''
            style[colorProp] = newValue;

            this.store.set_value(dataItem, `_cells.${raw_binding}.fields[0].style`, style)

            vueObj.setModified(dataItem)
            vueObj.cellCache_drop(row, col, col)   // IE 2026 09 25 / ODOO-… (замечание Игоря: кнопки цвета строки в гриде формы)
            vueObj.flex.refreshRange(new wjGrid.CellRange(row, col, row, col));

            // элемент группы Undo/Redo (собирает set_color)
            if (oldValue === newValue) return null
            return { item: dataItem, path: `_cells.${raw_binding}.fields[0].style.${colorProp}`, oldValue, newValue }
        },
        // IE 2026 09 25 / ODOO-… (замечание Игоря: кнопки цвета строки в гриде формы): «после их применения не вижу реакции, всё остаётся как было».
        // formatItem у уже отрисованной ячейки (панель cells, колонка > 0) идёт кэш-путём — className / cssText из cache_data_cells,
        // formatItem_cells (где применяется style из _cells.<binding>.fields[0] и _appearance строки) пропущен; refreshRange после записи
        // цвета перерисовывал ячейку старым cssText, и цвет появлялся только после полной перерисовки (refreshing → cache_data_cells.clear()).
        // Снимаем кэш затронутых ячеек панели данных — следующий formatItem идёт полным путём (как _flush0 отложенных ячеек: delete _cache.className)
        cellCache_drop(row, col1, col2) {
            const flex = this.flex
            if (!flex?.cells || !this.cache_data_cells) return
            const ct = flex.cells.cellType
            for (let c = Math.min(col1, col2); c <= Math.max(col1, col2); c++) {
                const _cache = this.cache_data_cells.get(`${ct}-${row}-${c}`)
                if (_cache) { delete _cache.className; delete _cache.cssText }
            }
        },
        set_rowStyleColor(colorPickerref) {
            // rowStyleButtons: цвет в поле style текущей/выделенных строк
            const color = colorPickerref.value !== '#ffffff' ? colorPickerref.value : '' // белый = сброс, как в set_color2
            this.rowStyle_applyToSelection(this.applyRowStyle, color)
        },
        rowStyle_applyToSelection(prop, value) {
            // печатная форма/шаблон: стиль пишется ПО ЯЧЕЙКАМ выделения —
            // в _cells.col_N.fields[0].style (его же читает рендер и Style-вкладка)
            const histCells = [] // история Undo/Redo: одна группа на применение стиля
            if (this.attr.isPrintTemplate || this.attr.isPrint || this.attr.use_commandPanelCell) {
                for (const range of this.flex.selectedRanges) {
                    const r1 = Math.min(range.row, range.row2), r2 = Math.max(range.row, range.row2)
                    const c1 = Math.min(range.col, range.col2), c2 = Math.max(range.col, range.col2)
                    for (let r = r1; r <= r2; r++) {
                        const row = this.flex.rows[r]
                        if (!row?.dataItem) continue
                        for (let c = c1; c <= c2; c++) {
                            const cb = this.get_attr_col(c)?.binding
                            if (!cb) continue
                            const ov = row.dataItem._cells = row.dataItem._cells || {}
                            const cell = ov[cb] = ov[cb] || {}
                            const fields = cell.fields = (Array.isArray(cell.fields) && cell.fields.length) ? cell.fields : [{}]
                            const f0 = fields[0] = fields[0] || {}
                            const st = f0.style = f0.style || {}
                            const oldValue = st[prop] ?? ''
                            if (value) st[prop] = value
                            else delete st[prop]
                            if (oldValue !== (value || '')) {
                                histCells.push({ item: row.dataItem, path: `_cells.${cb}.fields[0].style.${prop}`, oldValue, newValue: value || '' })
                            }
                        }
                        this.setModified(row.dataItem)
                    }
                }
                if (histCells.length) {
                    this.hist_push({ method: 'props', cells: histCells, label: value ? t('Style {prop}: {value}', { prop, value }) : t('Style {prop} reset', { prop }) })   // IE 2026 09 23 / ODOO-341407: i18n
                } else {
                    this.actionStack++
                }
                this.flexRefresh()
                return
            }
            // IE 2026 08 20 (заказ Игоря): список элементов (elements_appearance) —
            // свойство пишется в _appearance.style СТРОКИ (в запись уйдёт по
            // дискетке: BE мержит в meta.appearance элемента)
            if (this.attr.elements_appearance) {
                const idxs = new Set()
                for (const range of this.flex.selectedRanges) {
                    const r1 = Math.min(range.row, range.row2), r2 = Math.max(range.row, range.row2)
                    for (let r = r1; r <= r2; r++) idxs.add(r)
                }
                const histCells = []
                for (const irow of idxs) {
                    const di = this.flex.rows[irow]?.dataItem
                    if (!di?.id) continue
                    const prevSnap = this.store.deepCopy(di._appearance || null)
                    const app = { ...(di._appearance || {}) }
                    const st = { ...(app.style || {}) }
                    if (value) st[prop] = value
                    else delete st[prop]
                    if (Object.keys(st).length) app.style = st
                    else delete app.style
                    di._appearance = Object.keys(app).length ? app : null
                    this.setModified(di)
                    histCells.push({ item: di, path: '_appearance', oldValue: prevSnap, newValue: this.store.deepCopy(di._appearance) })
                }
                // IE 2026 08 20 (заказ Игоря): форматирование — под undo/redo
                if (histCells.length) this.hist_push({ method: 'props', cells: histCells, label: value ? t('Element style {prop}: {value}', { prop, value }) : t('Element style {prop} reset', { prop }) })   // IE 2026 09 23 / ODOO-341407: i18n
                this.flexRefresh()
                return
            }

            // rowStyleButtons: записать CSS-свойство в поле style текущей/выделенных строк
            const rowIndexes = new Set()
            for (const range of this.flex.selectedRanges) {
                const r1 = Math.min(range.row, range.row2)
                const r2 = Math.max(range.row, range.row2)
                for (let r = r1; r <= r2; r++) rowIndexes.add(r)
            }

            for (const irow of rowIndexes) {
                if (irow < this.headerRows) continue
                const row = this.flex.rows[irow]
                if (!row?.dataItem) continue
                if (row.dataItem._fe?.visible === false) continue

                const oldStyle = this.store.get_value(row.dataItem, 'style')
                const style = this.apply_rowStyleProp(oldStyle, prop, value)
                this.store.set_value(row.dataItem, 'style', style)
                this.setModified(row.dataItem)
                histCells.push({ item: row.dataItem, path: 'style', oldValue: oldStyle, newValue: style })
            }

            if (histCells.length) {
                this.hist_push({ method: 'props', cells: histCells, label: value ? t('Row style {prop}: {value}', { prop, value }) : t('Row style {prop} reset', { prop }) })   // IE 2026 09 23 / ODOO-341407: i18n
            } else {
                this.actionStack++
            }
            this.flexRefresh()
        },
        apply_rowStyleProp(style, prop, color) {
            if (style && typeof style === 'string') {
                // CSS-текст: заменить/дописать/удалить свойство, остальной текст не трогать
                const re = new RegExp(`(^|[;\\s])(${prop}\\s*:\\s*)[^;]*`, 'i')
                if (color) {
                    if (re.test(style)) return style.replace(re, `$1$2${color}`)
                    const trimmed = style.trim()
                    return `${trimmed}${trimmed.endsWith(';') ? '' : ';'} ${prop}: ${color};`
                }
                return style.replace(new RegExp(`(^|;)\\s*${prop}\\s*:[^;]*;?`, 'gi'), '$1').trim()
            }
            // словарь AttrCSS (канонический вид, см. CSS_parse/CSS_stringify)
            const dict = { ...(style || {}) }
            if (color) {
                dict[prop] = color
            } else {
                delete dict[prop]
            }
            return dict
        },
        set_rowStyleValue(action) {
            // пункт подменю Style со значением-пресетом; styleValue:'' — Reset (удалить свойство)
            this.rowStyle_applyToSelection(action.styleProp, this.rowStyle_normalizeValue(action.styleProp, action.styleValue))
        },
        rowStyle_normalizeValue(prop, value) {
            // числовые значения — с единицей px, если не указана другая (font-weight — без единицы)
            value = String(value ?? '').trim()
            const pxProps = ['font-size', 'border-bottom-width', 'border-right-width', 'padding-left', 'padding-right']
            if (value && pxProps.includes(prop) && /^-?\d+(\.\d+)?$/.test(value)) {
                value += 'px'
            }
            return value
        },
        onRowStyleCustom(event, action) {
            // подменю Style, пункт Custom...: ручной ввод значения (Enter — применить, Esc — отмена)
            const { left, bottom } = event.target.getBoundingClientRect()

            const combo = this.rowStyleCombo
            this.rowStyleComboProp = action.styleProp
            combo.itemsSource = action.presets || []
            combo.selectedIndex = -1
            combo.text = ''

            const he = combo.hostElement
            he.style.display = 'inline'
            he.style.left = left + 'px'
            he.style.top = bottom + 'px'
            combo.focus()
        },
        rowStyleCombo_apply(apply) {
            if (apply && this.rowStyleComboProp) {
                this.rowStyle_applyToSelection(this.rowStyleComboProp, this.rowStyle_normalizeValue(this.rowStyleComboProp, this.rowStyleCombo.text))
            }
            this.rowStyleComboProp = null
            this.rowStyleCombo.hostElement.style.display = 'none'
        },
        rowStyleComboInit(comboref) {
            const blurEvt = /firefox/i.test(window.navigator.userAgent) ? "blur" : "focusout";
            comboref.hostElement.addEventListener(blurEvt, () => {
                window.$cg.setTimeout(this, "AttrGrid.rowStyleComboInit", () => {
                    if (!comboref.containsFocus() && comboref.hostElement.style.display !== 'none') {
                        this.rowStyleComboProp = null
                        comboref.hostElement.style.display = 'none'
                    }
                }, 0);
            });
            comboref.hostElement.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                    this.rowStyleCombo_apply(true)
                } else if (e.key === 'Escape') {
                    this.rowStyleCombo_apply(false)
                }
            });

            this.rowStyleCombo = comboref;
        },
        rowStyleMenu_attrs() {
            // IE 2026 09 23 / ODOO-341407: i18n (подписи пунктов; пресеты — значения CSS)
            // подменю Style (rowStyleButtons): все пункты пишут в поле style строки
            const btn = (title, extra) => ({ autoGeneratedButton:true, 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, title, command:'executeVueObjMethod', 'cssClass':'p-button-white p-button-text0', ...extra })
            const colorItem = (title, styleProp) => btn(title, { 'method':'onRowStyleColor', styleProp, 'cssClass':'pi pi-palette p-button-white p-button-text0' })
            const listItem = (title, styleProp, presets) => ({ title, autoGeneratedButton:true, attrs: [
                ...presets.map(v => btn(v, { 'method':'set_rowStyleValue', styleProp, styleValue:v })),
                { title:'-' },
                btn(t('Custom...'), { 'method':'onRowStyleCustom', styleProp, presets }),
                btn(t('Reset'), { 'method':'set_rowStyleValue', styleProp, styleValue:'' }),
            ]})

            const borderStyles = ['solid', 'dashed', 'dotted', 'double', 'none'],
            widths = ['1px', '2px', '3px', '4px'],
            paddings = ['0px', '2px', '4px', '8px', '12px', '16px', '20px', '24px']

            return [
                colorItem(t('Row fore color'), 'color'),
                colorItem(t('Row fill color'), 'background-color'),
                { title:'-' },
                listItem(t('Font size'), 'font-size', ['10px', '11px', '12px', '13px', '14px', '16px', '18px', '20px', '24px']),
                listItem(t('Font weight'), 'font-weight', ['normal', '500', '600', 'bold']),
                { title:'-' },
                colorItem(t('Border bottom color'), 'border-bottom-color'),
                listItem(t('Border bottom style'), 'border-bottom-style', borderStyles),
                listItem(t('Border bottom width'), 'border-bottom-width', widths),
                colorItem(t('Border right color'), 'border-right-color'),
                listItem(t('Border right style'), 'border-right-style', borderStyles),
                listItem(t('Border right width'), 'border-right-width', widths),
                { title:'-' },
                listItem(t('Padding left'), 'padding-left', paddings),
                listItem(t('Padding right'), 'padding-right', paddings),
            ]
        },
        onCopyRawValue () {
            // копия СЫРОГО значения ячейки (dropdown.value), не отформатированного текста
            this.store.dropdown_copyRawValue()
        },
        // IE 2026 10 30 / ODOO-349799 (заказ Игоря 30.10: вкладка Addons открывается с включённым «Filter checked rows»): бэк объявляет у грида стартовые чипсы attr.CHIPS;
        // при ОТСУТСТВИИ массива doc.viewParams.<name>.CHIPS в записи кладём в него глубокую копию — без modified (образец tagsPanel_chips).
        // IE 2026 10 30 / ODOO-349799 (прогон s21 на Demo 6): пустой массив [] фронт заводит САМ ещё до данных (tagsPanel_chips → set_value([])), поэтому «пустой» = «нет»;
        // один раз на экземпляр грида (_chipsSeeded): пользователь снял все чипсы — в этом открытии дефолт не возвращается. Место — load_data (перед первым apply_CHIPS), не геттер CHIPS.
        chips_seedDefaults() {   // IE 2026 10 30 / ODOO-349799
            const rec = this.WIDGET?.record   // IE 2026 10 30 / ODOO-349799
            if (this._chipsSeeded || !rec || !this.attr?.name || !Array.isArray(this.attr.CHIPS) || !this.attr.CHIPS.length) return   // IE 2026 10 30 / ODOO-349799: один раз на экземпляр
            this._chipsSeeded = true   // IE 2026 10 30 / ODOO-349799
            const path = `doc.viewParams.${this.attr.name}.CHIPS`   // IE 2026 10 30 / ODOO-349799
            const cur = this.store.get_value(rec, path)   // IE 2026 10 30 / ODOO-349799
            if (Array.isArray(cur) && cur.length) return   // IE 2026 10 30 / ODOO-349799: свои чипсы записи есть — не трогаем; пустой массив = нет
            this.store.set_value(rec, path, JSON.parse(JSON.stringify(this.attr.CHIPS)), null, null, null, false)   // IE 2026 10 30 / ODOO-349799: копия, без modified
        },
        // ---- IE 2026 08 19 / ODOO-5512 (заказ Игоря): панель тегов ----
        tagsPanel_chips() {
            // чипсы грида живут в doc.viewParams.<name>.CHIPS (их же читает AttrChips
            // в режиме Embedded); нет — создаём из attr.CHIPS (дефолты), без modified
            const rec = this.WIDGET?.record
            if (!rec) return this.attr.CHIPS = this.attr.CHIPS || []
            let vp = this.store.get_value(rec, `doc.viewParams.${this.attr.name}.CHIPS`)
            if (!Array.isArray(vp)) {
                vp = Array.isArray(this.attr.CHIPS) ? this.attr.CHIPS : []
                this.store.set_value(rec, `doc.viewParams.${this.attr.name}.CHIPS`, vp, null, null, null, false)
            }
            return vp
        },
        tagsPanel_isActive(tag) {
            return this.tagsPanel_chips().some(c => c && (c.attr_type === 'CHIP-Tag' || c.segment === 'CHIP-Tag')
                && c.title === tag && c.use !== false && (c.meta?.use !== false))
        },
        tagsPanel_toggle(tag) {
            const CHIPS = this.tagsPanel_chips()
            const i = CHIPS.findIndex(c => c && (c.attr_type === 'CHIP-Tag' || c.segment === 'CHIP-Tag') && c.title === tag)
            if (i >= 0) CHIPS.splice(i, 1)
            else CHIPS.push({ segment: 'CHIP-Tag', title: tag, meta: { use: true, pi: 'pi-tag' }, doc: {} })
            if (typeof this.attr.tags_onToggle === 'function') {
                // локальные данные (встроенный список настроек) — хост перестроит строки
                this.attr.tags_onToggle()
                return
            }
            // widget-list: отбор по тегам применит бэк при select (CHIPS уедут с записью)
            this.store.executeStoreMethod(this.WIDGET.vueObj || this, { command: 'executeWidgetMethod', method: 'select', record_sendToBackend_exclude: ['_doc'] })
        },
        onClearCells () {
            // IE 2026 08 18 (заказ Игоря): снять ручные корректировки с выделенных ячеек —
            // из _cells.<колонка> убираем value/isNull/updated_at/updated_by (признак
            // «зафиксировано руками»); прочие данные ячейки (comment/fields/style/merge)
            // не трогаем. Значение в строке остаётся до пересчёта — его вернёт расчёт,
            // как только переопределения нет. Строки помечаются изменёнными: уходят
            // на бэк штатным Save (save_record копирует _cells строки целиком).
            const vueObj = this
            const dropdown = vueObj.store.dropdown
            dropdown.hide()
            if (!vueObj.flex) return
            const cells = vueObj.get_selectedRanges() || []
            let cleared = 0
            const touched = new Set()
            const _as = ++vueObj.actionStack // IE 2026 08 19: своя группа undo + пересчёт py-кода
            const touchedRows = new Map()
            let apprLocked = 0   // IE 2026 10 09 / ODOO-345618: ячейки строк, закрытых согласованием, — не очищаются
            for (const cell of cells) {
                const irow = cell?.irow
                if (irow == null || irow < 0) continue
                const dataItem = vueObj.flex.rows[irow]?.dataItem
                const col_binding = cell?.attr_col?.binding
                if (!dataItem || !col_binding || !dataItem._cells) continue
                // IE 2026 10 09 / ODOO-345618 (заказ Игоря: согласование на сегменте): очистка корректировок идёт мимо is_editable — закрытая строка (approval.locked) отклоняется
                // тем же отказом (красный флеш + одно уведомление с причиной); считаем только ячейки, где корректировка была (иначе отказ — на пустом месте)
                if (vueObj.approval_cellLock(dataItem, col_binding)) {   // IE 2026 10 09 / ODOO-345618 (F2): строка закрыта целиком либо ячейка помечена бэком в строке с data_locked (флажковый ввод)
                    const _c0 = dataItem._cells[String(col_binding).replace('data::', '')]
                    if (_c0 && typeof _c0 === 'object' && (('value' in _c0) || ('isNull' in _c0)) && cell.icol != null) { vueObj.readOnly_reject(irow, cell.icol, 'clearCells'); apprLocked++ }
                    continue
                }
                const raw_binding = String(col_binding).replace('data::', '')
                const c = dataItem._cells[raw_binding]
                if (!c || typeof c !== 'object') continue
                const hadOverride = ('value' in c) || ('isNull' in c)
                if (!hadOverride) continue
                const before = vueObj.store.deepCopy(c)
                for (const k of ['value', 'isNull', 'updated_at', 'updated_by', 'value_before']) delete c[k]
                if (!Object.keys(c).length) delete dataItem._cells[raw_binding]
                // в undo-стек — как правку ячейки (откат Ctrl+Z вернёт корректировку)
                vueObj.pushStack({
                    method: 'cells', actionStack: _as, irow, icol: cell.icol, col_binding, noMark: true,
                    $item: dataItem, cellsKey: raw_binding, val: before, newVal: null,
                })
                delete vueObj.changesStack[`${irow}:${col_binding}`] // прежняя метка правки — снять
                vueObj.setModified(dataItem)
                touched.add(dataItem)
                if (!touchedRows.has(dataItem)) touchedRows.set(dataItem, new Set())
                touchedRows.get(dataItem).add(col_binding)
                cleared++
            }
            if (cleared) {
                vueObj.cf_cache?.clear?.()
                vueObj.cache2_data_cells?.clear?.()
                for (const [it, bs] of touchedRows) vueObj.pyRecalc_queue(it, { actionStack: _as, bindings: bs })
                try { vueObj.flex.invalidate() } catch (e) { /* грид мог закрыться */ }
                vueObj.store.show_notification({ text: tn(cleared, 'Manual corrections cleared: {n} cell, recalculating — save the report to apply', 'Manual corrections cleared: {n} cells, recalculating — save the report to apply') })   // IE 2026 09 23 / ODOO-341407: i18n
            } else if (!apprLocked) {
                vueObj.store.show_notification({ text: t('No manual corrections in the selected cells'), status: 'warning' })
            }
        },
        onClearAllCells () {
            // IE 2026 08 18 / ODOO-5512 (заказ Игоря): снять ручные корректировки со ВСЕХ
            // строк отчёта — из каждой записи _cells.<ключ> убираем value/isNull/
            // updated_at/updated_by (comment/fields/style/merge не трогаем); одна группа
            // undo (Ctrl+Z возвращает всё разом); строки помечаются изменёнными —
            // уходят на бэк штатным Save; значения в гриде вернёт пересчёт
            const vueObj = this
            if (!vueObj.flex) return
            // IE 2026 08 19 (заказ Игоря): «значения по умолчанию, как до корректировок» —
            // сначала откатываем НЕСОХРАНЁННЫЕ правки сессии (вместе со связанными
            // изменениями py-кода: иначе очищенная ячейка пересчиталась бы от уже
            // изменённых итогов), затем снимаем сохранённые корректировки _cells и
            // пересчитываем. Откаченные правки остаются в redo
            let _guard = 0
            while (vueObj.undoStack.length && _guard++ < 500) {
                if (vueObj.changeStack(vueObj.undoStack, vueObj.redoStack, 'val') === false) break   // IE 2026 10 09 / ODOO-345618: группа с закрытой согласованием строкой не откатывается
            }
            const childPath = vueObj.attr.childItemsPath
            const rows = []
            const walk = (list, depth) => {
                if (!Array.isArray(list) || depth > 12) return
                for (const it of list) {
                    if (!it || typeof it !== 'object') continue
                    rows.push(it)
                    if (childPath && Array.isArray(it[childPath])) walk(it[childPath], depth + 1)
                }
            }
            walk(vueObj.data000, 0)
            let cleared = 0, rowsTouched = 0
            const actionStack = ++vueObj.actionStack
            const touchedRows = new Map() // dataItem -> Set(col_binding) — для пересчёта py-кода
            let apprLockedRows = 0   // IE 2026 10 09 / ODOO-345618: строки, закрытые согласованием, — корректировки не снимаются
            const _apprCellRows = new Set()   // IE 2026 10 09 / ODOO-345618 (F2): строки с ячейками, закрытыми бэком (data_locked)
            for (const dataItem of rows) {
                const cells = dataItem._cells
                if (!cells || typeof cells !== 'object') continue
                if (vueObj.approval_lock(dataItem)) { if (Object.keys(cells).some(k => cells[k] && typeof cells[k] === 'object' && (('value' in cells[k]) || ('isNull' in cells[k])))) apprLockedRows++; continue }
                let touched = false
                for (const key of Object.keys(cells)) {
                    const c = cells[key]
                    if (!c || typeof c !== 'object') continue
                    if (!(('value' in c) || ('isNull' in c))) continue
                    const col_binding = vueObj.attr_by_binding[key] ? key
                        : (vueObj.attr_by_binding[`data::${key}`] ? `data::${key}` : key)
                    // IE 2026 10 09 / ODOO-345618 (F2): флажковый ввод — строка с data_locked: корректировки закрытых бэком ячеек не снимаются (строка считается один раз)
                    if (vueObj.approval_cellLock(dataItem, col_binding)) { if (!_apprCellRows.has(dataItem)) { _apprCellRows.add(dataItem); apprLockedRows++ } continue }
                    const before = vueObj.store.deepCopy(c)
                    for (const k of ['value', 'isNull', 'updated_at', 'updated_by', 'value_before']) delete c[k]
                    if (!Object.keys(c).length) delete cells[key]
                    const attr_col = vueObj.attr_by_binding[col_binding] || {}
                    let irow = vueObj.rows_indexOf(dataItem)
                    if (irow == null || irow < 0) irow = -1
                    vueObj.pushStack({
                        method: 'cells', actionStack, irow, icol: attr_col.icol, col_binding, noMark: true, keepRedo: true,
                        $item: dataItem, cellsKey: key, val: before, newVal: null,
                    })
                    delete vueObj.changesStack[`${irow}:${col_binding}`] // прежняя метка правки — снять
                    if (!touchedRows.has(dataItem)) touchedRows.set(dataItem, new Set())
                    touchedRows.get(dataItem).add(col_binding)
                    touched = true
                    cleared++
                }
                if (touched) { vueObj.setModified(dataItem); rowsTouched++ }
            }
            if (cleared) {
                vueObj.cf_cache?.clear?.()
                vueObj.cache2_data_cells?.clear?.()
                // IE 2026 08 19 (заказ Игоря): очистка = пересчёт пользовательского кода —
                // ячейки получают значения по умолчанию, связанные изменения — той же
                // группой undo (бейджи), признак правки снят
                for (const [it, bs] of touchedRows) vueObj.pyRecalc_queue(it, { actionStack, bindings: bs })
                try { vueObj.flex.invalidate() } catch (e) { /* грид мог закрыться */ }
                vueObj.store.show_notification({ text: t('Manual corrections cleared: {cells} in {rows}, recalculating — save the report to apply (Ctrl+Z to undo)', { cells: tn(cleared, '{n} cell', '{n} cells'), rows: tn(rowsTouched, '{n} row', '{n} rows') }) })   // IE 2026 09 23 / ODOO-341407: i18n
            } else {
                vueObj.cf_cache?.clear?.()
                try { vueObj.flex.invalidate() } catch (e) { /* грид мог закрыться */ }
                vueObj.store.show_notification({ text: vueObj.redoStack.length ? t('Unsaved edits reverted (Ctrl+Y to redo); no saved manual corrections in this report') : t('No manual corrections in this report'), status: 'warning' })   // IE 2026 09 23 / ODOO-341407: i18n
            }
            // IE 2026 10 09 / ODOO-345618 (заказ Игоря: согласование на сегменте): закрытые строки пропущены — одно предупреждение с числом
            if (apprLockedRows) vueObj.store.show_notification({ text: tn(apprLockedRows, '{n} row is locked by approval — its manual corrections were not cleared', '{n} rows are locked by approval — their manual corrections were not cleared'), status: 'warning' })
        },
        onAddComment (action) {
            const vueObj = this,
            dropdown = vueObj.store.dropdown
            dropdown.showComment = this.attr.showComment = !dropdown.showComment
        },
        onEditValue (action) {
            const vueObj = this,
            dropdown = vueObj.store.dropdown
            dropdown.showValue = this.attr.showValue = !dropdown.showValue
        },
        onFillColor_dropdown (action) {
            const vueObj = this,
            dropdown = vueObj.store.dropdown
            dropdown.hide()

            let offset = this._cumulativeOffset(dropdown.divCell) // offset.left, top
            let he = this.colorPicker.hostElement;

            he.style.display = "inline";
            he.style.left = dropdown.position.left + "px";
            he.style.top = dropdown.position.top + "px"; //  - he.clientHeight - 5
            he.focus();

            this.applyFillColor = action.isFillColor;
            this.applyRowStyle = null;
        },
        onFillColor (event, action) {
            const vueObj = this
            const { left, bottom } = event.target.getBoundingClientRect()

            let he = this.colorPicker.hostElement;

            he.style.display = "inline";
            he.style.left = left + "px";
            he.style.top = bottom + "px"; //  - he.clientHeight - 5
            he.focus();

            this.applyFillColor = action.isFillColor;
            this.applyRowStyle = null;
        },
        onRowStyleColor (event, action) {
            // rowStyleButtons: тот же color picker, но запись идёт в поле style строки
            const { left, bottom } = event.target.getBoundingClientRect()

            let he = this.colorPicker.hostElement;

            he.style.display = "inline";
            he.style.left = left + "px";
            he.style.top = bottom + "px";
            he.focus();

            this.applyRowStyle = action.styleProp || (action.isFillColor ? 'background-color' : 'color');
        },
        colorPickerInit(colorPickerref) {
            const vueObj = this
            // if the browser is firefox, we should bind the blur event. (TFS #124387)
            // if the browser is IE, we should bind the focusout event. (TFS #124500)
            let blurEvt = /firefox/i.test(window.navigator.userAgent) ? "blur" : "focusout";
            // Hide the color picker control when it lost the focus.
            colorPickerref.hostElement.addEventListener(blurEvt, () => {
                window.$cg.setTimeout(this, "AttrGrid.colorPickerInit", () => {
                    if (!colorPickerref.containsFocus()) {
                        this.applyFillColor = false;
                        this.applyRowStyle = null;
                        colorPickerref.hostElement.style.display = "none";
                    }
                }, 0);
            });

            // Initialize the value changed event handler for the color picker control.
            colorPickerref.valueChanged.addHandler(() => {
                vueObj.set_color(colorPickerref)
            });

            this.colorPicker = colorPickerref;
        },
        _cumulativeOffset(element) {
            let top = 0,
                left = 0,
                scrollTop = 0,
                scrollLeft = 0;

            do {
                top += element.offsetTop || 0;
                left += element.offsetLeft || 0;
                scrollTop += element.scrollTop || 0;
                scrollLeft += element.scrollLeft || 0;
                element = element.offsetParent;
            } while (element && !(element instanceof HTMLBodyElement));

            scrollTop += document.body.scrollTop || document.documentElement.scrollTop;
            scrollLeft += document.body.scrollLeft || document.documentElement.scrollLeft;

            return {
                top: top - scrollTop,
                left: left - scrollLeft,
            };
        },

        findRowByGlobalIndex(data, index) {
            let flatList = [];

            const flattenData = (items) => {
                for (const item of items) {
                    flatList.push(item);
                    if (item.attrs && Array.isArray(item.attrs)) {
                        flattenData(item.attrs);
                    }
                }
            };

            flattenData(data);

            return flatList[index] || null
        },
        get_dataItem(irow, col_binding=null, newVal='') {
            if (!this.flex.rows[irow]?.dataItem){
                const dataItem = this.findRowByGlobalIndex(this.flex.itemsSource.items, irow)
                if (dataItem) { // LOOK pasting new records on bottom >> ...
                    return dataItem
                } else {
                    if (!this.store.hide_console) console.log('new row in get_dataItem()')
                    let dataItem = {}
                    if (this.attr.default_row) {
                        dataItem = structuredClone(this.attr.default_row)
                    }
                    if (col_binding) {
                        this.store.set_value(dataItem, col_binding, newVal)
                    }

                    dataItem._meta = dataItem._meta || {}
                    dataItem._meta.new = true
                    dataItem._meta.modified = true
                    dataItem._meta.calced = false
                    dataItem._meta.onAction = {def:'get_dataItem', sid:++this.lastAction_sid}

                    this.flex.itemsSource.addNew(dataItem)
                    this.flexRefresh()
                    this.set_AttrTabPanel_countItems()
                    // this.flex_check_isReadOnly()
                    return dataItem
                }
            }
            return this.flex.rows[irow].dataItem
        },
        // IE 2026 09 26 / ODOO-… (замечание Игоря: selector не меняет данные строки): «При изменении selector (или row.selector)
        // не помечать строку изменённой, т.к. это не меняет её данных, в отличие, например, от use». Флажок selector — выбор строки (селектор стола,
        // отбор мер, фильтр «= row.selector»): его переключение не ставит строке _meta.modified (жёлтая ячейка номера строки; Save списка шлёт на бэк
        // только строки с _meta.modified — строка с одним лишь флажком уходила как изменённая), не помечает запись и не пишется в стек отмены.
        // Исключение — грид правил Conditional format «All rules» (formatSel_grid): там Selector — настройка правила, сохраняемая с записью виджета.
        // Выключатель fe.ux.selectorNotModified (по умолчанию вкл; false — прежнее поведение)
        selector_noModified(binding) {
            return binding === 'selector' && !this.formatSel_grid() && this.store.setting('fe.ux.selectorNotModified', true) !== false
        },
        set_use(e, checked, binding,  r1_, r2_, hist=null) {
            let {topRow:r1, bottomRow:r2, leftCol:c1, rightCol:c2} = this.flex.selectedRanges[0]
            const _selNoMod = this.selector_noModified(binding)   // IE 2026 09 26 / ODOO-… (замечание Игоря: selector не меняет данные строки)
            if (r1_ !== null) {
                r1 = r1_
                r2 = r2_
            }

            for (let r0 = r1; r0 <= r2; r0++) {
                const row = this.flex.rows[r0]
                if (!row?.dataItem) continue
                if (row.dataItem._fe?.visible === false) continue
                if (this.rhLock_of(row.dataItem, binding)) continue   // IE 2026 09 26 / ODOO-… (заказ Игоря: doc.use в заголовках строк): заблокированная строка не меняется
                const oldValue = this.rhBool_value(row.dataItem, binding)   // IE 2026 10 23 / ODOO-5800
                let newValue
                if (e.ctrlKey || e.altKey || e.metaKey) {
                    checked = !checked
                    newValue = !oldValue
                } else {
                    newValue = checked
                }
                this.store.set_value(row.dataItem, binding, newValue, null, null, null, _selNoMod ? false : null)   // IE 2026 09 26 / ODOO-… (замечание Игоря: selector не меняет данные строки)
                if (hist && oldValue !== newValue) hist.push({ item: row.dataItem, path: binding, oldValue, newValue })
                if (binding !== 'selector') this.setModified(row.dataItem)
            }
        },
        // IE 2026 10 13 / ODOO-5800: кнопки командной панели виджета с enabled_when (действия над строками сигналов) — активны, только если в выделении этого
        // грида есть подходящая строка (utils/buttonsEnabledWhen); отложенно (протяжка выделения), только кнопки с binding этого грида. Флаг fe.ux.buttonsEnabledWhen
        ew_update() {
            clearTimeout(this._ewT)
            this._ewT = setTimeout(() => {
                try {
                    const W = this.WIDGET
                    const lists = [W?.attrs_vueObj?.WIDGET?.commandPanel, W?.groupMenu?.commandPanel]
                    // IE 2026 10 13 / ODOO-5800 (бот dev02, ieSIGM_003: шесть кнопок действий над строками сигналов живут в СОБСТВЕННОЙ командной панели грида —
                    // attr.groupMenu.commandPanel → this.commandPanel (те же объекты рендерит панель, меню «⋮» переполнения и actionMenu); списки виджета держат
                    // Documentation / Update data / Save Widget, и ew_update выходил раньше времени). Свои списки грида — без сверки binding (кнопка этого грида)
                    const own = [this.commandPanel, this.attr?.groupMenu?.commandPanel]
                    const has = l => Array.isArray(l) && l.some(c => c && c.enabled_when)
                    if (!lists.some(has) && !own.some(has)) return
                    if (!this.flex?.hostElement) return
                    const on = ew_on((k, d) => this.store.setting(k, d))
                    const rows = on ? ew_rows(this.flex) : []
                    ew_apply(own, rows, on, null)   // IE 2026 10 13 / ODOO-5800
                    ew_apply(lists, rows, on, this.attr?.binding || null)
                } catch (e) { /* грид в перестройке — кнопки останутся как были */ }
            }, 120)
        },
        toggleFeSelected() {
            this.ew_update()   // IE 2026 10 13 / ODOO-5800
            this.apprTr_update()   // IE 2026 10 16 / ODOO-5800
            this.showFeSelected = !this.showFeSelected
            if (!this.showFeSelected) {
                this.flex.rows.forEach(row => {
                    if (row.dataItem?._fe) row.dataItem._fe.selected = false
                })
            } else {
                this.update_feSelected()
            }
            this.rowHeaders()
            this.flexRefresh()
        },
        update_feSelected() {
            const selectedRows = new Set()
            for (const range of this.flex.selectedRanges) {
                const r1 = Math.min(range.row, range.row2)
                const r2 = Math.max(range.row, range.row2)
                // Only mark visible rows — a range can span rows hidden by an
                // active filter (e.g. select row 144..149 while only catalogs
                // are shown marks the hidden non-catalog rows in between).
                for (let r = r1; r <= r2; r++) {
                    if (this.flex.rows[r]?.isVisible) selectedRows.add(r)
                }
            }

            const rhCellType = this.flex.rowHeaders.cellType
            const col = this.rowHeaders_col_feSelected
            let selectedCount = 0, totalDataRows = 0

            this.flex.rows.forEach((row, irow) => {
                if (!row.dataItem) return
                totalDataRows++
                if (!row.dataItem._fe) row.dataItem._fe = {}
                const newVal = selectedRows.has(irow)
                row.dataItem._fe.selected = newVal
                if (newVal) selectedCount++

                // Directly update row cell checkbox
                const key = `${rhCellType}-${irow}-${col}`
                const divCell = this.divCells.get(key)
                if (divCell) {
                    const cb = divCell.querySelector('#onFeSelected__Click')
                    if (cb) cb.checked = newVal
                }
            })

            // Update header checkbox in topLeftCells
            const tlCellType = this.flex.topLeftCells.cellType
            const headerKey = `${tlCellType}-${this.columnNumberRow}-${col}`
            const headerDiv = this.divCells.get(headerKey)
            if (headerDiv) {
                const hcb = headerDiv.querySelector('#onFeSelectedAll__Click')
                if (hcb) {
                    hcb.checked = selectedCount === totalDataRows && totalDataRows > 0
                    hcb.indeterminate = selectedCount > 0 && selectedCount < totalDataRows
                }
                if (selectedCount === totalDataRows && totalDataRows > 0) {
                    headerDiv.style.backgroundColor = '#4a7c8a'
                } else if (selectedCount > 0) {
                    headerDiv.style.backgroundColor = '#ff8a00'
                } else {
                    headerDiv.style.backgroundColor = ''
                }
            }
        },
        selector_Click(action) {
            if (!this.attr.binding_forSelectorHotkeys) {
                return
            }
            let currentPosition = this.flex.selectedRanges[0].topRow,
            count = this.flex.selectedRanges[0].bottomRow - this.flex.selectedRanges[0].topRow + 1,
            dataItem = this.flex.rows[currentPosition]?.dataItem

            let binding = this.attr.binding_forSelectorHotkeys
            const cell = {
                irow: currentPosition,
                binding: binding,
            }
            const checked = !this.rhBool_value(dataItem, binding)   // IE 2026 10 23 / ODOO-5800
            const e = {
                metaKey: action.metaKey,
            }

            this.onSelector__Click(cell, checked, e)
        },
        onSelector__Click(cell, checked, e) {
            // IE 2026 11 01 / ODOO-350449 (заказ Игоря через ie-webscm7-2 #122315: легенда вимк., колонка прапорців у Числах, чіп як селектор): колонка-селектор встраивающего компонента (attr.selectorRow_state / attr.selectorRow_click — AttrHeatmapGrid): клик решает он
            // (чипс стола — один источник с основной вкладкой), строки грида и запись не меняются
            if (cell?.binding === 'selector' && typeof this.attr?.selectorRow_click === 'function') {
                const _di = this.get_dataItem(cell.irow)
                if (this.selectorRow_stateOf(_di) === null) return
                try { this.attr.selectorRow_click(_di, checked, e || {}, this) } catch (err) { console.warn('selectorRow_click', err) }
                try { this.flex.invalidate() } catch (err) { /* грид пересоздаётся */ }
                return
            }
            let targetRow = cell.irow,
            binding = cell.binding,
            attr_col = this.attr_by_binding[binding] || {},
            dataItem = this.get_dataItem(cell.irow),
            {topRow:r1, bottomRow:r2, leftCol:c1, rightCol:c2} = this.flex.selectedRanges[0],
            target_in_selectedRanges = (r1 <= targetRow && targetRow <= r2)

            // IE 2026 09 18 / ODOO-5800 (заказ Игоря: колонка use вкладки Metrics): поле use грид рисует системным чекбоксом в заголовках строк; у грида вкладки
            // Metrics он управляет чипсом метрик грида данных — без правки записи, стека отмены и признака «изменён»
            // IE 2026 09 19 / ODOO-5800 (Igor: Use вкладки Metrics = оформление метрики видно в таблице, состав чипса — колонка Selector): бэк отдаёт ОБА поля системными флажками заголовка строки —
            // selector (состав чипса метрик, в прежнем режиме эту роль играл use) и use (оформление метрики видно в таблице)
            if (this.attr?.metricChip_use && (binding === 'use' || binding === this.metricSel_binding())) {
                if (binding === this.metricSel_binding()) this.metricUse_selectorClick(targetRow, checked, e, target_in_selectedRanges ? [r1, r2] : null)
                else this.metricFmt_selectorClick(targetRow, checked, e, target_in_selectedRanges ? [r1, r2] : null)
                return
            }

            if (this.archiveRo_flag(binding, e, !checked)) return   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): флажок данных строки в архиве (данные модели) — не переключается (ревью #110599)
            // IE 2026 09 26 / ODOO-… (заказ Игоря: doc.use в заголовках строк): строка заблокирована (у языков — en) — флажок не переключается (ни диапазон,
            // ни «только эта», ни Ctrl+Enter): отказ с причиной из меты ячейки
            if (binding !== 'selector' && this.rhLock_of(dataItem, binding)) {
                try { e?.preventDefault?.() } catch (err) { /* событие уже отработало */ }
                if (e?.target?.type === 'checkbox') e.target.checked = !checked
                this.rhLock_reject(dataItem, binding)
                return
            }
            // история Undo/Redo: чекбокс rowHeaders (use и др.) идёт мимо
            // cellEditEnded — собираем правки сами, одной группой
            const histUse = binding !== 'selector' ? [] : null
            const _selNoMod = this.selector_noModified(binding)   // IE 2026 09 26 / ODOO-… (замечание Игоря: selector не меняет данные строки)
            const setV = (item, value) => {
                const oldValue = this.rhBool_value(item, binding)   // IE 2026 10 23 / ODOO-5800
                this.store.set_value(item, binding, value, null, null, null, _selNoMod ? false : null)
                if (histUse && oldValue !== value) histUse.push({ item, path: binding, oldValue, newValue: value })
            }

            if (e.altKey || e.ctrlKey || e.metaKey) {
                // solo mode: только кликнутая строка, у ОСТАЛЬНЫХ снимаем.
                // Чистим по всем данным виджета, а не по flex.rows: при активном
                // поиске/фильтре скрытые строки не попадают в flex.rows, их
                // selector оставался взведённым — apply собирал «одну + старые»
                // (репорт Igor, dev02 Sales: Cmd+клик при поисковом чипе)
                const _clearAll = (rows) => {
                    for (const row of rows || []) {
                        if (!row || typeof row !== 'object') continue
                        if (row !== dataItem && this.rhBool_value(row, binding) && !this.rhLock_of(row, binding)) {   // IE 2026 10 23 / ODOO-5800; IE 2026 09 26 / ODOO-… (заказ Игоря: doc.use в заголовках строк): заблокированные строки не снимаются
                            setV(row, false)
                            if (binding !== 'selector') this.setModified(row)
                        }
                        if (Array.isArray(row.attrs) && row.attrs.length) _clearAll(row.attrs)
                    }
                }
                _clearAll(this.WIDGET.record?._doc?.data)
                // локальные коллекции (не-REPORT2): dataItems грида могут быть не из _doc.data
                this.flex.rows.forEach(row => {
                    if (row.dataItem && row.dataItem !== dataItem && this.rhBool_value(row.dataItem, binding) && !this.rhLock_of(row.dataItem, binding)) {   // IE 2026 10 23 / ODOO-5800; IE 2026 09 26 / ODOO-… (заказ Игоря: doc.use в заголовках строк)
                        setV(row.dataItem, false)
                        if (binding !== 'selector') this.setModified(row.dataItem)
                    }
                })
                if (dataItem) {
                    setV(dataItem, checked)
                    if (binding !== 'selector') this.setModified(dataItem)
                }
            } else {
                if (!target_in_selectedRanges) {
                    r1 = r2 = targetRow
                }
                this.set_use(e, checked, binding, r1, r2, histUse)
            }
            if (histUse?.length) {
                const title = this.attr_by_binding[binding]?.title || binding
                this.hist_push({
                    method: 'props', cells: histUse,
                    label: histUse.length > 1   // IE 2026 09 23 / ODOO-341407: i18n
                        ? `${title}: ${tn(histUse.length, '{n} row', '{n} rows')} ${checked ? t('on') : t('off')}`
                        : `${title}: ${histUse[0].oldValue ? t('on') : t('off')} → ${histUse[0].newValue ? t('on') : t('off')}`,
                })
            }
            if (binding === 'use' && this.itemsSourcesView_grid()) {
                // §6.3: чекбокс use таблицы-реестра (rowHeaders-колонка, мимо cellEditEnded2)
                // управляет строками целевого грида
                const items = []
                if (e.altKey || e.ctrlKey || e.metaKey) {
                    this.flex.rows.forEach(row => {
                        if (row.dataItem && row.dataItem._fe?.visible !== false) items.push(row.dataItem)
                    })
                } else {
                    for (let r0 = r1; r0 <= r2; r0++) {
                        const row = this.flex.rows[r0]
                        if (row?.dataItem && row.dataItem._fe?.visible !== false) items.push(row.dataItem)
                    }
                }
                this.itemsSourcesView_use_apply(items)
            }
            if (binding === 'use' || this.rowHeaders_cols_pos.some(x => x.binding === binding)) {
                if (!_selNoMod) this.setModified()   // IE 2026 09 26 / ODOO-… (замечание Игоря: selector не меняет данные строки): selector колонкой position = 'rowHeaders' запись не помечает
                // чекбокс rowHeaders (use и др.) идёт мимо cellEditEnded —
                // атрибутный action_afterChange вызвать явно
                this.run_attr_action_afterChange()
            }
            this.set_AttrTabPanel_countItems()
            if (binding === 'selector' && this.formatSel_grid()) {   // IE 2026 09 20 / ODOO-5800 (Igor: колонка Selector и статистика грида Conditional format, чипс условного оформления CHIP-Format)
                const _solo = e.altKey || e.ctrlKey || e.metaKey
                this.formatSel_propagate(_solo ? targetRow : r1, _solo ? targetRow : r2, checked)
                this.formatSel_syncRecord(_solo ? 0 : r1, _solo ? this.flex.rows.length - 1 : r2)   // IE 2026 09 20 / ODOO-5800 (находка ie-dm7: Selector правила, переключённый на гриде скрытой вкладки, не доезжал до записи)
                this.formatSel_changed()
                this.formatSel_autoChip(_solo ? targetRow : r1, _solo ? targetRow : r2, checked, _solo)   // IE 2026 09 20 / ODOO-5800 (Igor 20.09: Selector правила и флажок правила в форме ячейки создают чипс оформления)
            }

            // selector
            if (attr_col.action_afterChange?.command === 'use_selectorMeasures') {
                this.use_selectorMeasures()
            } else if (attr_col.action_afterChange) {
                this.store.executeStoreMethod(this.WIDGET.vueObj, attr_col.action_afterChange, this.attr)
                // if (binding === 'selector') {
                //     this.store.executeStoreMethod(this, { 'command': 'onApplySelector__Click' }, this.attr)
                // }
            }

            this.flexRefresh()
            this.attr_set()
            if (this.WIDGET.widget === 'widget-selectors') {
                this.store.sync_WORKSPACE(this.WIDGET, '>>WORKSPACE')
            }
        },
        onSelectorKPI__Click(cell, checked) {
            // if (!this.store.hide_console) console.log(cell, checked)
            let row = this.flex.rows[cell.irow],
            dataItem = row.dataItem,
            cell_doc = dataItem[cell.binding_doc]

            cell_doc.selector = checked
            this.store.executeStoreMethod(this.WIDGET.vueObj, { 'command': 'onApplySelector__Click' }, this.attr)
        },
        onButtonKPI__Click(cell) {
            let row = this.flex.rows[cell.irow],
            dataItem = row.dataItem,
            cell_doc = dataItem[cell.binding_doc]

            this.store.executeStoreMethod(this.WIDGET.vueObj, cell_doc.action, this.attr)
        },
        pasting(flex, e) {
            // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): архивная ПМ — вставка выключена. Гейт динамический (beginningEdit / pasting / pastingCell / булев флажок), а не flex.isReadOnly при сборке:
            // смена модели держит стол (pmKeepView) — грид не пересобирается, и признак, поставленный при сборке, остался бы после возврата к текущей модели
            if (this.archiveRo?.()) { e.cancel = true; this.store.readonly_toast('', 'edit'); return }   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): только данные модели (ревью #110599)
            // шаблон печати: вставка скопированных ячеек ВМЕСТЕ с настройками
            if (this.attr.isPrintTemplate && this.printCells_paste(e)) {
                e.cancel = true
                return
            }
            if (e.data?.trimStart().startsWith('{') && e.data.includes('"segment"') && e.data.includes('"CHIP-')) {
                e.cancel = true
                this.pastingItems()
                return
            }

            const rowCount = e.data.split('\n').filter(line => line.trim() !== '').length;

            this.isPasting = true
            this.pasteBatch_begin(e) // IE 2026 09 04 / ODOO-336379: вставка — один батч + замер

            // LOOK to add new row
            for (let irow = e.row; irow < e.row + rowCount; irow++) {
                this.get_dataItem(irow)
            }
        },
        // ---------------- IE 2026 09 30 / ODOO-5800 (Igor: «выделить ячейки и вставить в Excel — лишние скрытые колонки; ожидаю вставку того, что было
        // видимым в области копирования, с учётом форматов»): copy takes only the VISIBLE rows / columns of the selection (collapsed column groups
        // such as Offset / DOS, rows hidden by chips or folded trees) and puts two representations into the clipboard: text/plain — TSV of raw
        // values (as before: grid → grid paste and text editors read it) and text/html — a <table> where numbers are raw values with the Excel
        // number format of the grid format (mso-number-format), texts are the cell text as shown (durations «8m», dates, links) and the cell
        // fill / colour / weight come from the same channels formatItem paints (row and cell classes, conditional rules, measure styles).
        // Switches: fe.ux.copyVisibleOnly (default on) and fe.ux.copyHtml (default on; off — text/plain only, as before) ----------------
        copyFlag_on(key) {
            const v = this.store.setting(key, true)
            return !(v === false || v === 'false' || v === 0)
        },
        copyHtml_supported() {
            return typeof ClipboardItem !== 'undefined' && typeof Blob !== 'undefined' && !!navigator.clipboard?.write
        },
        // wijmo Globalize format ('n0', 'n2', 'p1', 'f0', 'c2', 'd'…) → Excel number format for mso-number-format (escaped as Excel reads it
        // from HTML); null — no fixed mapping (scaled 'n0,' / general 'g' / exponent) → the formatted text goes as text
        copyCell_excelFormat(fmt) {
            const m = /^([a-z])(\d*)$/i.exec(String(fmt || '').trim())
            if (!m) return null
            const kind = m[1].toLowerCase(), prec = m[2] === '' ? null : +m[2]
            const dec = (p) => (p > 0 ? '\\.' + '0'.repeat(p) : '')
            switch (kind) {
                case 'n': case 'c': return '\\#\\,\\#\\#0' + dec(prec ?? 2)
                case 'f': return '0' + dec(prec ?? 2)
                case 'p': return '0' + dec(prec ?? 2) + '%'
                case 'd': return '0'
                default: return null
            }
        },
        // text of the cell as the grid shows it + number / Excel format for the HTML representation; mirrors formatItem: measure of the row
        // (measure_in_dataItem), transposed cell / row measure, aggregate of a collapsed column group, rule format (Δ% 'p0'), duration /
        // date formatters, hard zero «-», hideZero, link titles. → { text, num, xfmt, neg, measureT, cellT, value }
        copyCell_display(irow, icol, dataItem, attr_col, col, V) {
            const store = this.store, flex = this.flex
            const out = { text: '', num: null, xfmt: null, datefmt: null, neg: false, measureT: null, cellT: null, value: null }
            const tagsOff = (h) => String(h ?? '').replace(/<[^>]*>/g, '')
            const wjText = () => { const t = flex.getCellData(irow, icol, true); return t == null ? '' : String(t) }
            if (!dataItem || !attr_col) { out.text = wjText(); return out }
            if (this.cellBlank(dataItem, col.binding)) return out   // IE 2026 10 07 / ODOO-5800: погашенная ячейка (_DLRow.cells[binding].blank) — пустая в буфере, как ячейка без значения
            if (V.attr_type === 'AttrJSON' || V.attr_type === 'AttrCSS') { out.text = String(V.valueStr ?? ''); return out }
            let value = this.foldAgg_getValue(dataItem, attr_col.binding, attr_col)
            let cell_attr_type = attr_col.attr_type, cell_format = attr_col.format, unit = attr_col.unit
            let measureish = false
            if (attr_col.measure_in_dataItem) {
                const measure = dataItem.measure || this.get_measure_(dataItem)
                if (measure?.attr_type) { cell_attr_type = measure.attr_type; cell_format = measure.format; measureish = !!measure.format }
            }
            const measureT = this.transpose_measure(attr_col, dataItem)
            let cellT = null
            if (measureT) {
                measureish = true
                cellT = this.transpose_cellObject(value)
                if (cellT) value = cellT.value
                else if (this.attr.formatRowsAsColumns) value = measureT.value
                cell_attr_type = cellT?.attr_type || measureT.attr_type || cell_attr_type
                cell_format = cellT?.format || measureT.format || cell_format
                unit = cellT?.unit || measureT.unit || unit
            } else if (attr_col.attr_type === 'AttrMulti') {
                measureish = true
                const VM = store.get_value(dataItem, attr_col.binding)
                if (VM && typeof VM === 'object' && !Array.isArray(VM)) { cell_attr_type = VM.attr_type || cell_attr_type; value = VM.value }
                else { value = VM; cell_attr_type = (typeof VM === 'number') ? 'AttrNumber' : 'AttrStr' }
            }
            out.measureT = measureT; out.cellT = cellT; out.value = value
            // format / source of the rules and compare rows (cf_applyFormat): the row / cell format wins over the duration / date type
            const props = this.cf_formatProps(dataItem, col.binding, attr_col)
            if (props?.source != null) { value = this.cf_sourceValue(props.source, dataItem); cell_attr_type = 'AttrStr' }
            const isNumLike = typeof value === 'number' || (typeof value === 'string' && value.trim() !== '' && !isNaN(+value))
            if (props?.format && isNumLike) { cell_format = props.format; cell_attr_type = 'AttrNumber'; measureish = true }
            if (value === null || value === undefined || value === '') { out.text = ''; return out }
            if (String(cell_attr_type || '').startsWith('AttrLink')) {
                const its = this.itemsSource_by_binding[col.binding]
                let title = dataItem[`${attr_col.binding}-title`] || (cellT?.attr_type === 'AttrLink' && cellT.valueStr) || its?.ids?.[value]?.title || sigRow_refTitle(dataItem, attr_col.binding)   // IE 2026 10 04 / ODOO-5800 (fe-78)
                if (!title) { try { title = col.dataMap?.getDisplayValue(value) } catch (err) { title = null } }
                out.text = String(title || value)
                return out
            }
            if (cell_attr_type === 'AttrBool' || typeof value === 'boolean') { out.text = String(value); return out }
            if (cell_attr_type === 'AttrDate') {
                out.text = tagsOff(store.formatDateHTML(value, attr_col.utc_to_local))
                // ISO text is read as a date by Excel in any locale; the format keeps it shown as in the grid
                if (/^\d{4}-\d{2}-\d{2}$/.test(out.text)) out.datefmt = 'yyyy\\-mm\\-dd'
                else if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}(:\d{2})?$/.test(out.text)) out.datefmt = 'yyyy\\-mm\\-dd\\ hh:mm' + (out.text.length > 16 ? ':ss' : '')
                return out
            }
            if (cell_attr_type === 'AttrTime' && isNumLike) { out.text = store.formatTimeHTML(+value, { attr_type: cell_attr_type, format: cell_format, unit }); return out }
            if (cell_attr_type === 'AttrDays' && isNumLike) { out.text = store.formatDaysHTML(+value, { attr_type: cell_attr_type, format: cell_format }); return out }
            if (isNumLike && (cell_attr_type === 'AttrNumber' || col.dataType === wjcCore.DataType.Number)) {
                const n = +value
                if (measureish && n !== 0 && Math.abs(n) < 0.0001) { out.text = '-'; return out }   // hard zero (epsilon draft) — «-» as the grid draws it
                if (cell_format === 'bytes') { out.text = tagsOff(store.formatNumberHTML(n, { attr_type: cell_attr_type, format: cell_format })); return out }
                const fmt = cell_format || attr_col.format || col.format || 'n0'
                let shown = ''
                try { shown = String(wjcCore.Globalize.format(n, fmt)) } catch (err) { shown = String(n) }
                if (attr_col.hideZero && /^[-−]?0([.,]0+)?$/.test(shown.trim())) { out.text = ''; return out }
                out.neg = measureish && n < 0
                const xfmt = this.copyCell_excelFormat(fmt)
                if (xfmt) { out.num = n; out.xfmt = xfmt; out.text = String(n) } else out.text = shown
                return out
            }
            if (cellT || measureT) { out.text = String(value); return out }
            out.text = this.localized_cellValue(attr_col, dataItem) || wjText()
            if (planLabel_hasPh(out.text)) out.text = this.planLabelDate_text(out.text, dataItem)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана): копирование — текстовая форма даты
            return out
        },
        // classes and inline css of the cell — the channels formatItem paints (row: _DLRow, rules, AttrTabGrid field; column; measure;
        // cell: _DLRow.cells, rules / metric fill, MD). Heat fill (hslGroup) and DOM-only marks are not part of the copy
        copyCell_styleKeys(dataItem, attr_col, col, D) {
            const cls = [], css = []
            const push = (c) => { if (!c) return; for (const k of (Array.isArray(c) ? c : String(c).split(/\s+/))) if (k) cls.push(String(k)) }
            const style = (s) => { if (s) css.push(String(s)) }
            if (!dataItem || !attr_col) return { cls, css }
            const d = dataItem._DLRow
            const _dl2Blank = this.cellBlank(dataItem, col.binding)   // IE 2026 10 07 / ODOO-5800: у погашенной ячейки нет оформления САМОЙ ячейки (мета бэка, правила ячейки, MD); строчное и колоночное — остаётся
            const vo = this.cf_valuesOnlyAllowed(attr_col, D.value)
            if (d) {
                if (d.row_type === 'tab' || d.row_type === 'tabrow') push('row-dl-tab')
                if (d.memo && this.memoRows_on()) push('row-dl-memo')
                push(d.cssClass); push(d.cssClasses); style(d.cssStyle)
                if (vo) { push(d.cssClasses_vo); style(d.cssStyle_vo) }
            }
            if (this.attr.cf_rules) {
                const cfRow = this.cf_compute(dataItem, '', null)
                if (cfRow) { push(cfRow.cssClasses); style(cfRow.cssStyle); if (vo) { push(cfRow.cssClassesVO); style(cfRow.cssStyleVO) } }
            }
            if (this.attr.attr_type === 'AttrTabGrid' && dataItem.attr) {
                style(dataItem.attr.cssStyle)
                if (Array.isArray(dataItem.attr.cssClasses)) push(this.store.resolve_cssClasses(dataItem.attr.cssClasses))
                push(dataItem.attr.cssClass)
            }
            style(attr_col.cssStyle)
            if (!_dl2Blank) push(dataItem[`cssClass-${attr_col.binding}`])   // IE 2026 10 07 / ODOO-5800
            if (Array.isArray(attr_col.cssClasses)) push(this.store.resolve_cssClasses(attr_col.cssClasses))
            push(attr_col.cssClass)
            if ('level' in dataItem) push(attr_col[`cssClass-${dataItem.level}`])
            if (D.measureT) {
                style(D.measureT.cssStyle)
                if (Array.isArray(D.measureT.cssClasses)) push(this.store.resolve_cssClasses(D.measureT.cssClasses)); else push(D.measureT.cssClass)
                style(D.cellT?.cssStyle); push(D.cellT?.cssClass)
            }
            const cf_cell = _dl2Blank ? null : d?.cells?.[col.binding]   // IE 2026 10 07 / ODOO-5800
            if (cf_cell) { push(cf_cell.cssClasses); style(cf_cell.cssStyle) }
            if (!_dl2Blank && (this.attr.cf_rules || this.metricFill_state())) {   // IE 2026 10 07 / ODOO-5800
                const cfCell = this.cf_compute(dataItem, col.binding, attr_col)
                if (cfCell) { push(cfCell.cssClasses); style(cfCell.cssStyle) }
            }
            const md = dataItem.MD
            if (md) { style(md.rowStyle); if (!_dl2Blank) { push(md.cssClass?.[col.binding]); style(md.cellsStyle?.[col.binding]) } }   // IE 2026 10 07 / ODOO-5800
            if (D.neg) push('num-negative')
            return { cls, css }
        },
        // style of the HTML cell: measured on a hidden probe element inside the grid host — the rules of the classes live in the component CSS
        // and depend on the colour scheme. A rendered cell (visible in the viewport) lends the probe its own classes and inline style: they
        // carry what the DOM-only paths add (heat-map fill, inline colours), while the selection / hover state classes are dropped so the
        // selection tint is not copied; cells outside the viewport have no DOM — the computed keys alone. Only what differs from a plain
        // wj-cell is returned ({ bg, color, bold, italic, deco }); cache by class set + inline css
        // IE 2026 09 30 / ODOO-5800
        // IE 2026 10 01 / ODOO-5800 (Igor, Excel Mac: the «Uncovered» band row came out without a fill): the fill of a computed style — background-color
        // when it is not transparent, otherwise the colour of the background-image gradient (the band rows are painted with an inline
        // `background: linear-gradient(transparent 50%, rgb(232,191,191) 50%)`, whose background-color stays transparent): the first opaque colour
        // stop of the gradient is the colour the eye sees; no colour — 'rgba(0, 0, 0, 0)'
        copyCell_bgOf(s) {
            const bc = s.backgroundColor
            const a = this.alert_rgb(bc)
            if (a && a.a >= 0.01) return bc
            const img = String(s.backgroundImage || '')
            if (/gradient\(/.test(img)) {
                const m = img.match(/rgba?\([^)]*\)|#[0-9a-f]{3,8}\b/gi) || []
                for (const c of m) { const r = this.alert_rgb(c); if (r && r.a >= 0.01) return c }
            }
            return bc
        },
        copyCell_css(cls, css, el) {
            // IE 2026 10 01 / ODOO-5800 (Igor, Excel Mac: «применяется цвет текста, но не применяется фон»): a rendered cell is measured
            // DIRECTLY — getComputedStyle of the cell element with its selection / hover state classes taken off for the measurement (the
            // selection tint is not a fill), a transparent cell falls back to its row element (row-level fills), the text colour comes
            // from the node that holds the text (.cell-text-clip), not from the cell or its indicator marks
            let direct = null
            if (el) {
                try {
                    const state = [...el.classList].filter(k => /^wj-state-|^wj-chg-hovered$/.test(k))
                    state.forEach(k => el.classList.remove(k))
                    const s = getComputedStyle(el)
                    const textEl = el.querySelector('.cell-text-clip') || el
                    direct = { bg: this.copyCell_bgOf(s), color: getComputedStyle(textEl).color, weight: s.fontWeight, italic: s.fontStyle, deco: s.textDecorationLine || s.textDecoration }
                    const rowEl = el.parentElement
                    if (rowEl && rowEl.classList.contains('wj-row')) { const a = this.alert_rgb(direct.bg); if (!a || a.a < 0.01) direct.bg = this.copyCell_bgOf(getComputedStyle(rowEl)) }
                    state.forEach(k => el.classList.add(k))
                } catch (err) { direct = null }
            }
            if (el && !direct) {
                const skip = /^(wj-cell|wj-state-\S*|wj-frozen\S*|wj-align-\S*|wj-wrap|wj-chg-hovered|editable|search-alt-hit)$/
                cls = cls.concat(String(el.className || '').split(/\s+/).filter(k => k && !skip.test(k) && !cls.includes(k)))
                const box = /^(left|top|width|height|max-width|min-width|overflow|text-overflow|position|z-index|display|white-space|padding\S*|margin\S*|border\S*|line-height|visibility|cursor)$/
                css = css.concat(String(el.getAttribute('style') || '').split(';').map(d => d.trim()).filter(d => d && !box.test(d.split(':')[0].trim())))
            }
            const key = direct ? 'direct|' + Object.values(direct).join('|') : cls.join(' ') + '|' + css.join(';')   // IE 2026 10 01 / ODOO-5800: cache by the measured values
            if (key === '|') return null
            if (!this._copyCssCache) this._copyCssCache = new Map()
            if (this._copyCssCache.has(key)) return this._copyCssCache.get(key)
            let out = null
            try {
                const host = this.flex?.cells?.hostElement || this.flex?.hostElement || document.body
                const probe = (classes, inline) => {
                    const el = document.createElement('div')
                    el.className = 'wj-cell ' + classes
                    el.style.cssText = 'position:absolute;left:-10000px;top:-10000px;width:1px;height:1px;pointer-events:none;' + inline
                    host.appendChild(el)
                    const s = getComputedStyle(el)
                    const r = { bg: this.copyCell_bgOf(s), color: s.color, weight: s.fontWeight, italic: s.fontStyle, deco: s.textDecorationLine || s.textDecoration }   // IE 2026 10 01 / ODOO-5800: gradient band too
                    host.removeChild(el)
                    return r
                }
                if (!this._copyCssBase) this._copyCssBase = probe('', '')
                const base = this._copyCssBase, cur = direct || probe(cls.join(' '), css.join(';'))   // IE 2026 10 01 / ODOO-5800: rendered cell — measured directly; no DOM (virtualised) — the computed keys on a probe
                const hex = (c) => {
                    const rgb = this.alert_rgb(c)
                    if (!rgb || rgb.a < 0.01) return null   // transparent — the grid background, no fill
                    let { r, g, b, a } = rgb
                    if (a < 0.99) { const bb = this.alert_baseColor(); r = r * a + bb.r * (1 - a); g = g * a + bb.g * (1 - a); b = b * a + bb.b * (1 - a) }
                    return '#' + [r, g, b].map(x => Math.round(x).toString(16).padStart(2, '0')).join('')
                }
                const bold = (w) => w === 'bold' || +w >= 600
                const o = {}
                const bb = this.alert_baseColor(), baseHex = '#' + [bb.r, bb.g, bb.b].map(x => Math.round(x).toString(16).padStart(2, '0')).join('')
                if (cur.bg !== base.bg) { const h = hex(cur.bg); if (h && h !== hex(base.bg) && h !== baseHex) o.bg = h }   // the grid background itself is no fill
                if (cur.color !== base.color) { const h = hex(cur.color); if (h) o.color = h }
                if (bold(cur.weight) !== bold(base.weight)) o.bold = bold(cur.weight)
                if (cur.italic !== base.italic) o.italic = cur.italic
                if (cur.deco !== base.deco && /line-through|underline/.test(cur.deco || '')) o.deco = cur.deco
                out = Object.keys(o).length ? o : null
            } catch (err) { out = null }
            this._copyCssCache.set(key, out)
            return out
        },
        // the <table> for text/html: cells as { text, num, xfmt, datefmt, style } per row / column index of the selection; no headers — the area
        // as is. Fill and colour go both as CSS and as the legacy HTML attributes / tags (bgcolor, <font color>, <b>, align): the Mac Excel
        // importer reads the attributes where it drops the CSS shorthand (measured 30.09: fill lost, white text on a white cell)
        // IE 2026 10 01 / ODOO-5800 (Igor, Excel Mac: «применяется цвет текста, но не применяется фон»): the table is written in the dialect of
        // Excel's own clipboard HTML — a full document with the office / excel namespaces, ProgId Excel.Sheet and a <style> block where every
        // distinct cell style is a class (`.xlN{background:#…;mso-pattern:black none;color:#…;mso-number-format:…}`), exactly the form Excel
        // for Mac reads back from its own copies; the td keeps the inline style, bgcolor, <font>, <b>, align and x:num as well (any importer)
        copy_htmlTable(rows, sortedRows, sortedCols) {
            const esc = (s) => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
            if (this.copyFlag_on('fe.ux.copySheetsHtml')) return this.copy_htmlTableSheets(rows, sortedRows, sortedCols, esc)   // IE 2026 10 01 / ODOO-5800
            const classes = new Map()   // css text → class name
            const classOf = (css) => { let k = classes.get(css); if (!k) { k = 'xl' + (65 + classes.size); classes.set(css, k) } return k }
            const tr = []
            for (const r of sortedRows) {
                const td = []
                for (const c of sortedCols) {
                    const cell = rows[r]?.[c]
                    if (!cell) { td.push('<td></td>'); continue }
                    const st = [], at = [], cl = []
                    const isNum = cell.num !== null && !!cell.xfmt
                    if (isNum) { st.push(`mso-number-format:'${cell.xfmt}'`, 'text-align:right'); cl.push(`mso-number-format:"${cell.xfmt}"`, 'text-align:right'); at.push(`x:num="${cell.num}"`, 'align="right"') }   // x:num — the raw value for Excel (its own HTML carries numbers this way, independent of the locale decimal separator)
                    else if (cell.datefmt) { st.push(`mso-number-format:'${cell.datefmt}'`); cl.push(`mso-number-format:"${cell.datefmt}"`) }
                    else if (cell.text !== '') { st.push("mso-number-format:'\\@'"); cl.push('mso-number-format:"\\@"') }   // text stays text (Excel would guess dates / numbers)
                    const S = cell.style || {}
                    let inner = esc(cell.text)
                    if (S.bg) { st.push('background-color:' + S.bg, 'background:' + S.bg); cl.push('background:' + S.bg, 'mso-pattern:black none'); at.push(`bgcolor="${S.bg}"`) }
                    if (S.color) { st.push('color:' + S.color); cl.push('color:' + S.color); inner = `<font color="${S.color}">${inner}</font>` }
                    if (S.bold !== undefined) { st.push('font-weight:' + (S.bold ? 'bold' : 'normal')); cl.push('font-weight:' + (S.bold ? '700' : '400')); if (S.bold) inner = `<b>${inner}</b>` }
                    if (S.italic) { st.push('font-style:' + S.italic); cl.push('font-style:' + S.italic); if (S.italic === 'italic') inner = `<i>${inner}</i>` }
                    if (S.deco) { st.push('text-decoration:' + S.deco); cl.push('text-decoration:' + S.deco) }
                    if (cl.length) at.unshift(`class="${classOf(cl.join(';') + ';')}"`)
                    td.push(`<td${at.length ? ' ' + at.join(' ') : ''}${st.length ? ` style="${esc(st.join(';'))}"` : ''}>${inner}</td>`)
                }
                tr.push('<tr>' + td.join('') + '</tr>')
            }
            const style = ['td{padding:1px;mso-ignore:padding;mso-number-format:General;text-align:general;vertical-align:bottom;border:none;mso-background-source:auto;mso-pattern:auto;white-space:nowrap;}']
            for (const [css, k] of classes) style.push(`.${k}{${css}}`)
            return '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">'
                + '<head><meta http-equiv="Content-Type" content="text/html; charset=utf-8"><meta name="ProgId" content="Excel.Sheet"><meta name="Generator" content="Microsoft Excel 15">'
                + '<style><!--\n' + style.join('\n') + '\n--></style></head><body>'
                + '<table border="0" cellpadding="0" cellspacing="0" style="border-collapse:collapse"><tbody>' + tr.join('') + '</tbody></table></body></html>'
        },
        // IE 2026 10 01 / ODOO-5800 (Igor, Excel Mac: «по прежнему не вставляется фон»): the table in the form of the Google Sheets clipboard HTML —
        // the form Excel for Mac is known to paste WITH fills: a bare <table> (no Excel document / ProgId / class sheet), every cell styled
        // inline only, fill and colour FIRST as `background-color:#rrggbb;color:#rrggbb` (hex, no alpha — copyCell_css already blends the
        // alpha over the grid background), no `background` shorthand, no bgcolor / <font>; the Excel-only parts (mso-number-format with its
        // quoted escapes, x:num) go LAST, so an importer that stops at them has already read the fill and the colour.
        // Switch: fe.ux.copySheetsHtml (default on); off — the Excel-document dialect above
        copy_htmlTableSheets(rows, sortedRows, sortedCols, esc) {
            const tr = []
            for (const r of sortedRows) {
                const td = []
                for (const c of sortedCols) {
                    const cell = rows[r]?.[c]
                    const st = ['overflow:hidden', 'padding:2px 3px 2px 3px', 'vertical-align:bottom']
                    if (!cell) { td.push(`<td style="${st.join(';')};"></td>`); continue }
                    const S = cell.style || {}
                    if (S.bg) st.push('background-color:' + S.bg)
                    if (S.color) st.push('color:' + S.color)
                    if (S.bold !== undefined) st.push('font-weight:' + (S.bold ? 'bold' : 'normal'))
                    if (S.italic) st.push('font-style:' + S.italic)
                    if (S.deco) st.push('text-decoration:' + S.deco)
                    let at = ''
                    if (cell.num !== null && !!cell.xfmt) { st.push('text-align:right', `mso-number-format:'${cell.xfmt}'`); at = ` x:num="${cell.num}"` }
                    else if (cell.datefmt) st.push(`mso-number-format:'${cell.datefmt}'`)
                    else if (cell.text !== '') st.push("mso-number-format:'\\@'")
                    td.push(`<td style="${esc(st.join(';') + ';')}"${at}>${esc(cell.text)}</td>`)
                }
                tr.push('<tr style="height:21px;">' + td.join('') + '</tr>')
            }
            return '<meta charset="utf-8"><google-sheets-html-origin><style type="text/css"><!--td {border: 1px solid #cccccc;}br {mso-data-placement:same-cell;}--></style>'
                + '<table xmlns="http://www.w3.org/1999/xhtml" cellspacing="0" cellpadding="0" dir="ltr" border="1" style="font-size:10pt;font-family:Arial;border-collapse:collapse;border:none"><tbody>'
                + tr.join('') + '</tbody></table>'
        },
        // IE 2026 10 01 / ODOO-5800: both representations through the synchronous copy event (execCommand('copy') on a hidden textarea with a
        // one-shot copy listener that sets text/plain and text/html). The async navigator.clipboard.write sanitises text/html — it drops <head>,
        // <style> and the office namespaces, so the Excel dialect never reached the system clipboard that way. Returns false when the browser
        // refused (no user gesture / execCommand gone) — the caller falls back to the async API. Switch: fe.ux.copyRawClipboard (default on)
        copy_viaCopyEvent(text, html) {
            if (!this.copyFlag_on('fe.ux.copyRawClipboard') || typeof document.execCommand !== 'function') return false
            const active = document.activeElement
            const ta = document.createElement('textarea')
            ta.setAttribute('aria-hidden', 'true')
            ta.style.cssText = 'position:fixed;left:-10000px;top:-10000px;width:1px;height:1px;opacity:0;pointer-events:none'
            ta.value = text || ' '
            let set = false
            const onCopy = (ev) => {
                // IE 2026 10 02 / ODOO-5800 (заказ Игоря: копирование в Excel for Mac с заливкой — HTML-исходник в text/plain): html === null — ONLY text/plain is set (the Excel form);
                // the two-flavour copy always passes its html, for it nothing changes
                try { ev.clipboardData.setData('text/plain', text); if (html !== null) ev.clipboardData.setData('text/html', html); ev.preventDefault(); set = true } catch (err) { set = false }
            }
            let ok = false
            try {
                document.body.appendChild(ta)
                ta.addEventListener('copy', onCopy, { once: true })
                ta.focus(); ta.select()
                ok = document.execCommand('copy')
            } catch (err) { ok = false }
            try { ta.removeEventListener('copy', onCopy); ta.remove() } catch (err) { /* already gone */ }
            try { if (active && typeof active.focus === 'function') active.focus({ preventScroll: true }) } catch (err) { /* focus lost — the grid regains it on the next click */ }
            return ok && set
        },
        // both representations into the clipboard (ClipboardItem); fallback — text only
        copy_toClipboard(text, html) {
            if (html && this.copy_viaCopyEvent(text, html)) return   // IE 2026 10 01 / ODOO-5800: raw HTML (Excel dialect) — not sanitised
            if (html && this.copyHtml_supported()) {
                try {
                    const item = new ClipboardItem({ 'text/plain': new Blob([text], { type: 'text/plain' }), 'text/html': new Blob([html], { type: 'text/html' }) })
                    navigator.clipboard.write([item]).catch(() => navigator.clipboard.writeText(text).catch(() => {}))
                    return
                } catch (err) { /* ClipboardItem not constructible — text only */ }
            }
            try { navigator.clipboard.writeText(text).catch(() => {}) } catch (err) { /* no clipboard API (insecure context) */ }
        },
        // IE 2026 10 02 / ODOO-5800 (заказ Игоря: копирование в Excel for Mac с заливкой — HTML-исходник в text/plain): the selection walk of
        // copying() — ONE collector for Ctrl+C and the «Copy for Excel» command of the table menu: the visible cells of the selected ranges →
        // data (V per cell) and the internal buffer store.copiedData (the grid → grid paste reads it). The clipboard is written by the callers
        copy_collect(flex) {
            const data = []
            const seenCells = new Set()
            const visibleOnly = this.copyFlag_on('fe.ux.copyVisibleOnly')   // IE 2026 09 30 / ODOO-5800
            this._copyCssCache = null; this._copyCssBase = null   // IE 2026 09 30 / ODOO-5800: colours are measured per copy (scheme / styles may change)
            // IE 2026 10 16 / ODOO-5800 (Igor 16.10, «M03 Marketing plan · CF», строка «ACT 2026» в колонке «Показник», объединённой с соседними: Cmd+C даёт пустой буфер):
            // у объединения wijmo выделена ОДНА ячейка (обычно левая, пустая) — значение лежит в колонке-источнике (merge_src / первая непустая колонка
            // диапазона). Объединение идёт в буфер ОДИН раз, из колонки значения, в левой выделенной колонке диапазона; остальные его колонки в выделении
            // пропускаются (без пустых табов). Чистая логика — utils/copyMerged.js; выключатель fe.ux.copyMergedTrim (дефолт ВКЛ)
            const mergedTrim = this.copyFlag_on('fe.ux.copyMergedTrim')
            const _getMerged = (r, c) => { const rng = flex.mergeManager?.getMergedRange(flex.cells, r, c, true); return rng ? { col: rng.col, col2: rng.col2 } : null }
            const _getText = (r, c) => { const v = flex.cells.getCellData(r, c, true); return v == null ? '' : String(v) }
            const _prefSrc = (r, c) => this.cache_data_cells?.get(`${flex.cells.cellType}-${r}-${c}`)?.merge_src
            const ranges = [...flex.selectedRanges].sort((a, b) => Math.min(a.row, a.row2) - Math.min(b.row, b.row2))
            for (const range of ranges) {
            for (let irow = range.topRow; irow <= range.bottomRow; irow++) {
                if (visibleOnly && flex.rows[irow] && !flex.rows[irow].isVisible) continue   // IE 2026 09 30 / ODOO-5800: rows hidden by chips / folded trees
                // было rightCol..leftCol (right=max, left=min) — цикл не выполнялся
                // для диапазона шире одной колонки: мультиколоночная копия ячеек
                // не попадала во внутренний буфер (copiedData)
                for (let icol = range.leftCol; icol <= range.rightCol; icol++) {
                    let _m   // IE 2026 10 16 / ODOO-5800: { icol — куда класть, srcCol — откуда читать, mergeCol }
                    if (mergedTrim) { _m = copyMerged_cell(irow, icol, range, _getMerged, _getText, _prefSrc, seenCells); if (!_m) continue }   // IE 2026 10 16 / ODOO-5800
                    else {
                    if (seenCells.has(`${irow}-${icol}`)) continue
                    seenCells.add(`${irow}-${icol}`)
                    _m = { icol, srcCol: icol, mergeCol: null }   // IE 2026 10 16 / ODOO-5800
                    }
                    const _src = _m.srcCol   // IE 2026 10 16 / ODOO-5800
                    let col = flex.columns[_src],   // IE 2026 10 16 / ODOO-5800: колонка-источник значения (у обычной ячейки — она же)
                    binding = col.binding,
                    row = flex.rows[irow],
                    dataItem = row.dataItem,
                    attr_col = this.attr_by_binding[binding],
                    itemsSource = this.itemsSource_by_binding[binding]
                    if (visibleOnly && !col.isVisible) continue   // IE 2026 09 30 / ODOO-5800: collapsed column groups (Offset / DOS under a month), use=false, empty-by-chips
                    if (!attr_col) continue   // IE 2026 09 30 / ODOO-5800: column the report no longer describes (transient rebuild) — nothing to copy from it

                    // IE 2026 10 07 / ODOO-5800 (заказ Игоря: «Hidden» поля строки DL2 гасит ячейку своего уровня): погашенная ячейка (_DLRow.cells[binding].blank) в буфер идёт пустой —
                    // ни значения (оно в dataItem остаётся, но во внутренний буфер вставки между гридами не попадает), ни текста, ни типового разбора
                    const _dl2Blank = this.cellBlank(dataItem, binding)
                    const V = {
                        irow, icol: _m.icol, srcCol: _src, mergeCol: _m.mergeCol, binding,   // IE 2026 10 16 / ODOO-5800: место в буфере — левая выделенная колонка объединения; чтение — из колонки-источника
                        bindingStr: attr_col.title,
                        
                        value: _dl2Blank ? null : this.store.get_value(dataItem, binding),   // IE 2026 10 07 / ODOO-5800
                        valueStr: _dl2Blank ? '' : this.flex.getCellData(irow, _src),   // IE 2026 10 07 / ODOO-5800; IE 2026 10 16 / ODOO-5800: из колонки-источника
                        
                        attr_type: attr_col.attr_type,
                        relation_segment: attr_col.relation_segment,
                    }
                    if (planLabel_hasPh(V.valueStr)) V.valueStr = this.planLabelDate_text(V.valueStr, dataItem)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана): text/plain копирования и «Copy for Excel» — текстовая форма даты, не сырой токен
                    data.push(V)
                    if (_dl2Blank) continue   // IE 2026 10 07 / ODOO-5800

                    if (visibleOnly && dataItem && attr_col.raw_binding) {
                        // IE 2026 09 30 / ODOO-5800: the representative column of a collapsed group shows the aggregate of its leaves — that is what was visible
                        const _fold = this.foldAgg_value(dataItem, attr_col.binding0 || attr_col.binding, attr_col)
                        if (_fold) { V.value = _fold.v; V.valueStr = (_fold.v === null || _fold.v === undefined) ? '' : String(_fold.v) }
                    }

                    if (V.attr_type === 'AttrMulti') {
                        const V0 = this.store.get_value(dataItem, attr_col.binding)
                        Object.assign(V, V0)
                    } else if (String(V.attr_type || '').startsWith('AttrLink') && V.value && (itemsSource?.data?.length || col.dataMap)) {
                        // IE 2026 09 30 / ODOO-5800: title also from the column dataMap (report grids keep itemsSource_by_binding empty) — was: raw id
                        let _title = itemsSource?.ids?.[V.value]?.title
                        if (!_title) { try { _title = col.dataMap?.getDisplayValue(V.value) } catch (err) { _title = null } }
                        V.valueStr = _title || V.valueStr
                    } else if (V.attr_type === 'AttrJSON') {
                        V.valueStr = this.store.JS_stringify(V.value)
                    } else if (V.attr_type === 'AttrCSS') {
                        V.valueStr = this.store.CSS_stringify(V.value)
                    } else if (V.attr_type === 'AttrDays' && V.value != null && V.value !== '') {
                        // IE 2026 08 21 (баг Игоря): в буфер — «9m», а не сырые дни:
                        // parseDays при format:'m' читает голое число как месяцы (270 → 23y)
                        // IE 2026 09 24 / ODOO-341407: в буфер — канонический английский текст (его разбирает parseDays при вставке), не перевод
                        V.valueStr = this.store.formatDaysHTML(V.value, attr_col, { localize: false })
                    } else if (V.attr_type === 'AttrTime' && (attr_col.format === 'm' || attr_col.input_unit)
                            && V.value != null && V.value !== '' && Number.isFinite(+V.value)) {
                        // IE 2026 09 10 / ODOO-5800: DOS в секундах (format 'm' / input_unit) — в буфер «14m», а не сырые
                        // секунды: parseTime при вставке прочтёт голое число как месяцы/дни (2 592 000 → тысячи лет)
                        V.valueStr = this.store.formatTimeHTML(V.value, attr_col, { localize: false })   // IE 2026 09 24 / ODOO-341407: канон для parseTime, не перевод
                        V.copyText = true
                    }
                }
            }
            }

            this.store.copiedData = {
                items: this.copy_selectedItems(),
                data: data,
                name: this.attr.name,
            }

            // шаблон печати: настройки ячеек (_cells: fields/colspan/rowspan)
            // едут вместе с копией — вставка в шаблон восстановит их по смещениям
            if (this.attr.isPrintTemplate && data.length) {
                const topRow = Math.min(...data.map(V => V.irow))
                const leftCol = Math.min(...data.map(V => V.icol))
                const cells = data.map(V => ({
                    dRow: V.irow - topRow, dCol: V.icol - leftCol,
                    value: V.value ?? null,
                    ov: this.store.deepCopy(this.flex.rows[V.irow]?.dataItem?._cells?.[V.binding] ?? null),
                }))
                const probe = data.find(V => String(V.valueStr || '').trim())
                this.store.copiedData.printCells = { cells, textProbe: probe ? String(probe.valueStr).trim() : '' }
                // ЕДИНЫЙ формат буфера (просьба Игоря): ячейки шаблона кладутся
                // и узлами Cells-формата — вставка строками на вкладке Cells
                // или ячейками в другом месте шаблона
                this.store.copiedData.items = data
                    .map(V => this.printCellNode_of(V.irow, V.binding)).filter(Boolean)
                this.store.copiedData.printCellNodes = true
            }
            // вкладка Cells: строки списка — те же универсальные узлы-ячейки
            // (вставка в шаблоне применит их ячейками)
            if (this.printCellsTab_isActive()) {
                this.store.copiedData.printCellNodes = true
            }

            return data
        },
        // IE 2026 10 02 / ODOO-5800 (заказ Игоря: копирование в Excel for Mac с заливкой — HTML-исходник в text/plain): text/plain of a copy — TSV of
        // the raw values of the collected cells (moved out of copying() unchanged; the «Copy for Excel» memo keeps the same string)
        copy_matrix(data) {
            // IE 2026 10 16 / ODOO-5800: the same TSV (union of the columns, quoting) moved to utils/copyMerged.js; with fe.ux.copyMergedTrim the text of every cell is
            // trimmed (leading / trailing spaces, tabs, line breaks) — Igor 16.10
            return copyMerged_matrix(data, this.copyFlag_on('fe.ux.copyMergedTrim'))
        },
        // IE 2026 10 02 / ODOO-5800 (заказ Игоря: копирование в Excel for Mac с заливкой — HTML-исходник в text/plain): the collected cells as the
        // grid shows them — { text, num, xfmt, datefmt, style } per row / column index (moved out of copying() unchanged; the text/html
        // dialects and the Excel form are written from the same model)
        copy_cells(flex, data) {
            // IE 2026 09 30 / ODOO-5800: text/html — the visible cells as the grid shows them, numbers with the Excel format, cell styles
            const cells = {}
            const mergedTrim = this.copyFlag_on('fe.ux.copyMergedTrim')   // IE 2026 10 16 / ODOO-5800
            for (const V of data) {
                const _srcCol = V.srcCol ?? V.icol   // IE 2026 10 16 / ODOO-5800: merged cell — the column of its value (see copy_collect)
                const col = flex.columns[V.srcCol ?? V.icol], dataItem = flex.rows[V.irow]?.dataItem, attr_col = this.attr_by_binding[V.binding]   // IE 2026 10 16 / ODOO-5800
                let D, style = null
                try { D = this.copyCell_display(V.irow, _srcCol, dataItem, attr_col, col, V) } catch (err) { D = { text: String(V.valueStr ?? ''), num: null, xfmt: null } }   // IE 2026 10 16 / ODOO-5800
                if (mergedTrim) D.text = copyMerged_trim(D.text)   // IE 2026 10 16 / ODOO-5800
                let el = null; try { el = flex.cells.getCellElement(V.irow, V.icol) || (V.mergeCol != null ? flex.cells.getCellElement(V.irow, V.mergeCol) : null) } catch (err) { el = null }   // rendered cell (viewport only) — the truth for its classes / inline fill; IE 2026 10 16 / ODOO-5800: the merged cell is drawn at its left column
                try { const k = this.copyCell_styleKeys(dataItem, attr_col, col, D); style = this.copyCell_css(k.cls, k.css, el) } catch (err) { style = null }
                if (!cells[V.irow]) cells[V.irow] = {}
                cells[V.irow][V.icol] = { text: D.text, num: D.num, xfmt: D.xfmt, datefmt: D.datefmt || null, style }
            }
            return cells
        },
        copying(flex, e) {
            const copyHtml = this.copyFlag_on('fe.ux.copyHtml') && this.copyHtml_supported()   // IE 2026 09 30 / ODOO-5800
            const ownClipboard = !!navigator.clipboard?.writeText   // IE 2026 09 30 / ODOO-5800: no async clipboard (insecure context) — the wijmo path copies
            const data = this.copy_collect(flex)   // IE 2026 10 02 / ODOO-5800 (заказ Игоря: копирование в Excel for Mac с заливкой — HTML-исходник в text/plain): the selection walk — one collector, shared with «Copy for Excel»
            // IE 2026 10 02 / ODOO-5800 (заказ Игоря: копирование в Excel for Mac с заливкой — HTML-исходник в text/plain): toggle of this browser
            // «Ctrl+C copies for Excel» — the Excel form, text/plain only; off (default) or the clipboard refused — the copy below, as before
            if (data.length && this.copyExcel_ctrlC() && this.copyExcel_write(flex, data)) { e.cancel = true; return }

            // IE 2026 09 30 / ODOO-5800: own clipboard — special types (as before) or the HTML representation; otherwise the wijmo path
            // (formatted text, visible cells only) stays as it was
            const ownText = data.some(V => V.attr_type === 'AttrJSON' || V.attr_type === 'AttrCSS' || V.attr_type === 'AttrDays' || V.copyText) // IE 2026 08 21: AttrDays — свой текст буфера («9m»); IE 2026 09 10 / ODOO-5800: AttrTime с format 'm'/input_unit — тоже
            if (data.length && ownClipboard && (ownText || copyHtml)) {
                const { sortedRows, sortedCols, text } = this.copy_matrix(data)
                e.cancel = true
                let html = null
                if (copyHtml) html = this.copy_htmlTable(this.copy_cells(flex, data), sortedRows, sortedCols)
                this.copy_toClipboard(text, html)
            }
        },
        // ---------------- IE 2026 10 02 / ODOO-5800 (заказ Игоря: копирование в Excel for Mac с заливкой — HTML-исходник в text/plain) ----------------
        // «Copy for Excel»: the selection as the HTML source of a table in text/plain ONLY — the one form Excel for Mac pastes WITH the fills
        // (Igor's measurement 02.10, copytest2.html variant N4; any text/html flavour makes Excel take its lossy path). Two ways: the command
        // of the table menu ≡ (copyExcel_copy) and the toggle of this browser «Ctrl+C copies for Excel» (localStorage 'webscm.copyExcel').
        // Writer / reader / memo — src/utils/copyExcel.js. Switches: fe.ux.copyExcel (master, default on; off — no menu items, the toggle is
        // ignored, the paste hook passes everything through), fe.ux.copyExcelDefault (toggle of a browser that never chose, default off),
        // fe.ux.copyExcelBorders (border="1" as in the proven sample, default off — the grid has no such borders), fe.ux.copyExcelFormats
        // (x:num + mso-number-format, default on), fe.ux.copyExcelAscii (non-ASCII text as &#N;, default off). Counters: window._copyExcel
        copyExcel_on() { return this.copyFlag_on('fe.ux.copyExcel') },
        copyExcel_flag(key) { const v = this.store.setting(key, false); return v === true || v === 'true' || v === 1 },   // switches with the default OFF
        copyExcel_ctrlC() { return this.copyExcel_on() && copyExcel_toggleGet(this.copyExcel_flag('fe.ux.copyExcelDefault')) },
        // the collected cells → the Excel form → clipboard as text/plain ONLY (the same copy-event path; the async fallback writeText is
        // text/plain only as well) + the memo «string → its TSV» for our own paste. → { rows, cols } | null (nothing was written)
        copyExcel_write(flex, data) {
            const { sortedRows, sortedCols, text } = this.copy_matrix(data)
            let html = ''
            try {
                html = copyExcel_table(this.copy_cells(flex, data), sortedRows, sortedCols, {
                    borders: this.copyExcel_flag('fe.ux.copyExcelBorders'),
                    formats: this.copyFlag_on('fe.ux.copyExcelFormats'),
                    ascii: this.copyExcel_flag('fe.ux.copyExcelAscii'),
                })
            } catch (err) { copyExcel_count('errors'); html = '' }
            if (!html) return null
            let ok = this.copy_viaCopyEvent(html, null)
            if (!ok) {
                try { if (navigator.clipboard?.writeText) { navigator.clipboard.writeText(html).catch(() => {}); ok = true } } catch (err) { ok = false }
            }
            if (!ok) return null
            copyExcel_memoSet(html, text)
            return { rows: sortedRows.length, cols: sortedCols.length }
        },
        // command of the table menu ≡ «Copy for Excel»: the current selection (or the current cell) in the Excel form
        copyExcel_copy() {
            const flex = this.flex
            if (!flex || !this.copyExcel_on()) return
            let data = []
            try { if (flex.selection && flex.selection.isValid) data = this.copy_collect(flex) } catch (err) { copyExcel_count('errors'); data = [] }
            if (!data.length) { this.store.show_notification({ text: t('Copy for Excel: select cells first'), status: 'warning' }); return }
            const done = this.copyExcel_write(flex, data)
            if (done) this.store.show_notification({ text: t('Copied for Excel: {r} × {c}. Paste with Ctrl+V', { r: done.rows, c: done.cols }) })
            else this.store.show_notification({ text: t('Copy for Excel: the browser did not allow writing to the clipboard'), status: 'warning' })
        },
        // checkable item of the table menu ≡ «Ctrl+C copies for Excel» — per BROWSER (the clipboard problem belongs to the device: Mac + Excel)
        copyExcel_toggle() {
            if (!this.copyExcel_on()) return
            const on = !this.copyExcel_ctrlC()
            copyExcel_toggleSet(on)
            // the mark of the item — in the table menus of all the grids on the page (the toggle is one for the browser)
            for (const host of document.querySelectorAll('.wj-flexgrid')) {
                const g = host.__vueGrid
                if (g && typeof g.set_commandPanel === 'function') { try { g.set_commandPanel() } catch (err) { /* the grid is being rebuilt */ } }
            }
            this.store.show_notification({ text: on ? t('Ctrl+C in tables now copies for Excel (this browser)') : t('Ctrl+C in tables copies as usual') })
        },
        // our own paste: wijmo hands the clipboard text to flex.setClipString(text, rng) (Ctrl+V / Shift+Ins → Clipboard.paste → hidden
        // textarea → grid.setClipString; a multi-range selection calls it once per range) — read in the wijmo source and measured by the probe
        // p237_check. Here the text of our Excel form is replaced by its TSV (memo of the last copy, otherwise the parsed table) BEFORE wijmo
        // splits it into cells, so pasting / pastingCell receive the same values as from the TSV; any other text passes untouched
        copyExcel_pasteHook(flex) {
            if (!flex || flex._copyExcelHooked || typeof flex.setClipString !== 'function') return
            flex._copyExcelHooked = true
            const vueObj = this, setClip = flex.setClipString
            flex.setClipString = function (text, rng) {
                let clip = text
                try { if (vueObj.copyExcel_on()) clip = copyExcel_fromClip(text) } catch (err) { copyExcel_count('errors'); clip = text }
                return setClip.call(this, clip, rng)
            }
        },
        pastingCell(flex, e) {
            if (this.archiveRo?.()) { e.cancel = true; return }   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): архивная ПМ — вставка не правит ячейки (тост — в pasting)
            if (this._pasteStat && !this._pasteStat.ended) this._pasteStat.cells_offered++ // IE 2026 09 04 / ODOO-336379
            // IE 2026 09 10 / ODOO-… (заказ Игоря): вставка в булеву ячейку (колонка AttrBool / строка AttrBool в AttrTabGrid): текст → true/false
            {
                const bc = this.boolCell_info(e.row, e.col)
                if (bc) {
                    if (bc.editable) {
                        const nv = this.store.isTrue(e.data), ov = this.boolCell_value(bc)
                        if (ov !== nv) this.set_value(e.row, bc.dataItem, bc.binding, ov, nv)
                        clearTimeout(this._boolPasteRefresh)
                        this._boolPasteRefresh = setTimeout(() => { try { this.flexRefresh() } catch (err) { /* грид перестроен */ } }, 30)
                    }
                    e.cancel = true
                    return
                }
            }
            if (this.store.copiedData) {
                let V = this.store.copiedData.data.find(V => V.value === e.data)
                if (!V) {
                    V = this.store.copiedData.data.find(V => V.valueStr === e.data)
                }
                if (V) {
                    if (this.attr.name === 'viewWHERE #2025-12-23') { // || this.attr.name === 'fieldsMapping'
                        const irow = e.row,
                        row = flex.rows[irow],
                        dataItem = this.get_dataItem(irow)

                        dataItem.use = true
                        dataItem.leftValue = {
                            value: V.binding,
                            valueStr: V.bindingStr,
                            attr_type: 'AttrLink',
                        }
                        dataItem.condition = '='
                        dataItem.rightValue = {
                            value: V.value,
                            valueStr: V.valueStr,
                            attr_type: V.attr_type,
                            relation_segment: V.relation_segment,
                        }

                        const attr_col_left = this.attr_by_binding['leftValue.valueStr']
                        this.store.prepare_AttrMulti(this, attr_col_left, dataItem, [], true)

                        this.check_WHERE()

                        e.cancel = true
                        return
                    }

                    if (V.attr_type === 'AttrJSON' || V.attr_type === 'AttrCSS') {
                        this.cellEditEnding2(e, V.value, 'pastingCell')
                        this.saveVisibility()
                        this.need_restoreVisibility = true
                    }

                    const dropdown = this.store.dropdown
                    if (dropdown.visible) {
                        this.dropdown_showForActiveCell()
                    }
                }
            }

            this.cellEditEnding2(e, e.data, 'pastingCell')

            this.saveVisibility()
            this.need_restoreVisibility = true
        },
        async pastingItems() {
            try {
                const text = await navigator.clipboard.readText();
                this.store.pasteAction(this.WIDGET.vueObj, {method: 'pasteItems', source_name:this.attr.name, 'binding':this.attr.binding}, text)

            } catch (err) {
                console.error("Err clickboard:", err);
                this.store.show_notification({ text: t('Clipboard error: {error}', { error: err.message }), status: 'error' })   // IE 2026 09 23 / ODOO-341407: i18n
            }
        },
        insertAction(answer=null) {
            let currentPosition = this.flex.selectedRanges[0].topRow,
            col = this.flex.selectedRanges[0].leftCol,
            attr_col = this.get_attr_col(col),
            dataItem = this.flex.rows[currentPosition]?.dataItem,
            parentItems = this.get_parentItems(currentPosition),
            irowItem = parentItems.indexOf(dataItem),
            items

            if (answer?.attrs) {
                items = answer.attrs

            } else if (this.store.copiedData) {
                items = this.store.deepCopy(this.store.copiedData.items)
            }
            if (items) {
                this.setModified(items, true)
                if (this.attr.isPrintTemplate) {
                    const raw_binding = attr_col.binding0.replace('data::', '')
                    dataItem._cells = dataItem._cells || {}
                    const _cells = this.store.get_value(dataItem, `_cells.${raw_binding}`) || {}
                    this.store.set_value(dataItem, `_cells.${raw_binding}`, _cells)
            
                    _cells.fields = items
                    this.flex.refreshRange(new wjGrid.CellRange(currentPosition, col, currentPosition, col));

                } else {
                    this.rowIds_insert(items)
                    parentItems.splice(irowItem + 1, 0, ...items)
                    this.hist_push({
                        method: 'rows', kind: 'paste',
                        from: null, to: this.hist_positionsOf(items),
                        label: tn(items.length, 'Paste {n} row', 'Paste {n} rows'),   // IE 2026 09 23 / ODOO-341407: i18n
                    })
                    this.set_itemsSource()
                    this.selected_items(items)
                }
                // вставка строк — изменение данных грида (Paste rows,
                // вставка виджетов из «Copy widgets as JSON»)
                this.run_attr_action_afterChange()
                this.useCount_apply()
            }
            this.check_WHERE()
            if (this.WIDGET.widget === 'widget-selectors') {
                this.store.sync_WORKSPACE(this.WIDGET, '>>WORKSPACE')
            }
        },
        prepare_printTemplate() {
            if (!this.attr.isPrintTemplate && !this.attr.isPrint) return
            let need_refresh = false
            this.flex.deferUpdate(() => {

                // clear AttrGrid (секции мульти-вертикальной таблицы не трогаем —
                // их attrs = вложенные строки шаблона, а не превью AttrGrid-ячейки)
                for(let row of this.flex.rows) {
                    if (row.dataItem?.attr_type === 'AttrGrid') continue
                    delete row.dataItem.attrs
                }
            
                for(let irow=0; irow < this.flex.rows.length; irow++) {
                    const row = this.flex.rows[irow]
                    for (let icol=0; icol < this.flex.columns.length; icol++) {
                        const _cells = this.get_cells(null, irow, icol)
                        const cell_field = _cells?.fields?.[0]
                        if (!cell_field) continue

                        // values
                        if (this.attr.isPrintTemplate) {
                            // НЕ пишем title в данные: это затирало статический текст
                            // ячейки (напр. титул 'Bill of Materials') и метило запись
                            // modified при простом открытии — сохранение уносило порчу
                            // в БД. Подпись ячейки рисует formatItem: title||binding||source
                        }
                        
                        if (!cell_field?.binding) continue
                        
                        // AttrGrid
                        if (cell_field?.attr_type === 'AttrGrid') { // transform cell_field.attrs >> dataItem.attrs
                            const grid2 = row.dataItem.attrs = row.dataItem.attrs || []
                            
                            // AttrGrid >> header
                            let icol2 = 0, header_rows_length = 0, fields2 = []
                            const set_header = (fields, irow2=0) => {
                                if (irow2 + 1 > header_rows_length) header_rows_length = irow2 + 1
                                for (let field of fields) {
                                    if (field.use === false) continue
                                    const _cells2 = { fields: [field], _isHeader: true }
                                    this.set_value2(grid2, irow2, icol2, field.title, field, true, _cells2)
                                    
                                    fields2.push(field)
                                    need_refresh = true

                                    if (field.attrs?.length) {
                                        if (field.binding) {
                                            const field2 = {...field, title:'↑'}
                                            const _cells2 = { fields: [field], _isHeader: true }
                                            this.set_value2(grid2, irow2 + 1, icol2, field2.title, field2, true, _cells2)
                                            icol2++ 
                                        }
                                        let icol3 = icol2
                                        set_header(field.attrs, irow2 + 1)

                                        // merge left
                                        if (icol3 < icol2) {
                                            _cells2.merge = 'root'
                                            while (icol3 < icol2) {
                                                let _cells3 = this.get_cells(grid2, irow2, icol3, {})
                                                _cells3.merge = 'left'

                                                icol3++
                                            }
                                        }
                                    } else {
                                        icol2++
                                    }
                                }
                            }
                            set_header(cell_field.attrs)

                            // merge up
                            if (header_rows_length > 1) {
                                for (let icol2 = 0; icol2 <= fields2.length; icol2++) {
                                    for (let irow2 = 0; irow2 < header_rows_length; irow2++) {
                                        const _cells2 = this.get_cells(grid2, irow2, icol2, {})
                                        if (_cells2.merge) continue

                                        for (let irow3 = irow2 + 1; irow3 < header_rows_length; irow3++) {
                                            let _cells3 = this.get_cells(grid2, irow3, icol2, {})
                                            if (_cells3.merge) break

                                            _cells2.merge = 'root'
                                            _cells3.merge = 'up'
                                        }
                                    }
                                }
                            }

                            // AttrGrid >> values
                            if (this.attr.isPrint) {
                                const grid_data = this.store.get_value(this.WIDGET.record, cell_field.binding) || []
        
                                const store = this.store
                                const fieldsCount = fields2.length
                                let grid2_irow = header_rows_length - 1

                                if (Array.isArray(grid_data) && grid_data.length) {
                                    const rowsStack = [grid_data]
                                    const indexStack = [0]

                                    while (rowsStack.length) {
                                        const currentRows = rowsStack[rowsStack.length - 1]
                                        let currentIndex = indexStack[indexStack.length - 1]

                                        if (currentIndex >= currentRows.length) {
                                            rowsStack.pop()
                                            indexStack.pop()
                                            continue
                                        }

                                        indexStack[indexStack.length - 1] = currentIndex + 1
                                        const row_data = currentRows[currentIndex]

                                        grid2_irow++
                                        for (let icol2 = 0; icol2 < fieldsCount; icol2++) {
                                            const field = fields2[icol2]
                                            const value = store.get_value(row_data, field.binding)
                                            const _cells2 = { fields: [field] } // TODO optimase
                                            this.set_value2(grid2, grid2_irow, icol2, value, field, false, _cells2)
                                        }

                                        const childAttrs = row_data.attrs
                                        if (childAttrs && childAttrs.length) {
                                            rowsStack.push(childAttrs)
                                            indexStack.push(0)
                                        }
                                    }
                                }
                            }

                        } else {
                            if (this.attr.isPrint) {
                                // значение: сначала из САМОЙ строки (серверный print_expand
                                // кладёт значения элементов табличной части по пути биндинга),
                                // затем из записи; undefined — не затирать (например _index,
                                // уже разложенный сервером в col_N)
                                let value = this.store.get_value(this.flex.rows[irow].dataItem, cell_field.binding)
                                if (value === undefined) {
                                    value = this.store.get_value(this.WIDGET.record, cell_field.binding)
                                }
                                if (value !== undefined) {
                                    this.set_value2(null, irow, icol, value, cell_field)
                                }
                            }
                        }
                    }
                }

            })
            if (need_refresh) this.refresh(null, false, false)
        },
        rowAdded(flex, e) {
            let dataItem = this.flex.rows[e.row].dataItem

            dataItem._meta = dataItem._meta || {}
            dataItem._meta.new = true
            dataItem._meta.modified = true
            dataItem._meta.calced = false
            dataItem._meta.onAction = {def:'rowAdded', sid:++this.lastAction_sid}

            for (let binding in (this.attr.default_row || {})) {
                if (!(binding in dataItem)) {
                    this.store.set_value(dataItem, binding, structuredClone(this.attr.default_row[binding]))
                }
            }

            if (this.rowHeaders_col_use !== null && this.store.get_value(dataItem, 'use') == null) {
                this.store.set_value(dataItem, 'use', true)
            }
            for (const { binding } of this.rowHeaders_cols_pos) {
                if (this.attr_by_binding[binding]?.attr_type === 'AttrBool' && this.store.get_value(dataItem, binding) == null) {
                    this.store.set_value(dataItem, binding, true)
                }
            }
            this.rowIds_newRow(dataItem)

            this.flexRefresh()
            this.attr_set()
            this.set_AttrTabPanel_countItems()
            if (this.WIDGET.widget === 'widget-selectors') {
                this.store.sync_WORKSPACE(this.WIDGET, '>>WORKSPACE')
            }
        },
        resizedColumn(flex, e) {
            // редактор шаблона (секция '_doc.printTemplate[i].attrs'): ширина
            // колонки хранится в строках-ячейках канона doc.printCells (модель
            // Игоря 2026-07-25) — пишем в узлы этой колонки секции
            if (this.attr?.isPrintTemplate) {
                const m = String(this.attr.binding || '').match(/^_doc\.printTemplate\[(\d+)\]\.attrs$/)
                const colB = flex?.columns?.[e.col]?.binding
                if (m && colB && colB.startsWith('col_')) {
                    const secIdx = parseInt(m[1])
                    const colNum = parseInt(colB.slice(4)) || 0
                    const w = Math.round(flex.columns[e.col].renderWidth || flex.columns[e.col].width || 0)
                    const rec = this.WIDGET.record
                    const cells = this.store.get_value(rec, 'doc.printCells')
                    const sec = Array.isArray(cells) ? cells[secIdx] : null
                    if (sec && Array.isArray(sec.attrs) && w > 0) {
                        let wrote = false
                        const apply = (nodes) => {
                            for (const n of nodes || []) {
                                if (!this.store.isinstance_dict(n)) continue
                                if (Array.isArray(n.attrs)) { apply(n.attrs); continue }
                                if ((parseInt(n.col) || 0) === colNum) {
                                    this.store.set_value(n, 'width', w)
                                    wrote = true
                                }
                            }
                        }
                        apply(sec.attrs)
                        if (wrote) {
                            // запись изменилась (канон) + синхронизируем ширину в
                            // текущей матричной копии, чтобы write-back её не потерял
                            this.WIDGET.record._meta = this.WIDGET.record._meta || {}
                            this.WIDGET.record._meta.modified = true
                            const tplSec = this.store.get_value(rec, `_doc.printTemplate[${secIdx}]`)
                            if (tplSec) {
                                this.store.set_value(tplSec, `_cells._section.widths.${colB}`, w)
                            }
                        }
                    }
                }
            }
            // IE 2026 09 17: ресайз колонки панели заголовков строк (если wijmo его пришлёт) — своя ширина, не колонки данных с тем же индексом
            if (e?.panel && (e.panel === flex.topLeftCells || e.panel === flex.rowHeaders)) {
                const rh = (this.rowHeaders_cols_pos || []).find(x => x.col_idx === e.col)
                const rhCol = flex.rowHeaders.columns[e.col]   // IE 2026 10 08 / ODOO-5800
                if (rh && rhCol) {   // IE 2026 10 08 / ODOO-5800: и здесь видимая ширина (сырой 0 не сохранялся, а колонка без minWidth пропадала с экрана)
                    const w = gridColWidth_visible(rhCol)   // IE 2026 10 08 / ODOO-5800
                    if (rhCol.width !== w) rhCol.width = w   // IE 2026 10 08 / ODOO-5800
                    this.rhCol_setWidth(rh.binding, w)   // IE 2026 10 08 / ODOO-5800
                }
                return
            }
            const col = this.flex.columns[e.col]
            // IE 2026 10 08 / ODOO-5800: wijmo отдаёт СЫРОЙ размер (_MouseHandler._SZ_MIN = 0): «до упора» влево — 0, левее minWidth — 1…24, а рисует
            // не уже minWidth (25). Сохранённый 0 при пересборке после Save читался как «ширины нет» → автоширина. Запоминаем ВИДИМУЮ ширину
            // (utils/gridColWidth.js) и ставим её колонке; чтение сохранённого 0 не меняется — старые нули остаются автошириной
            const w = gridColWidth_visible(col)   // IE 2026 10 08 / ODOO-5800
            if (col.width !== w) col.width = w   // IE 2026 10 08 / ODOO-5800
            this.set_width(e.col, w)   // IE 2026 10 08 / ODOO-5800: было col.width
        },
        // ---------- IE 2026 09 17 (замечание Игоря «зачем такая широкая колонка групп — считай автоширину по содержимому, ручную
        // ширину запоминай с сохранением виджета, как у обычных колонок»): колонки панели заголовков строк (группы AttrTabHeader _dlhdr_*) ----------
        rhCol_autoWidth(attr_rh) {
            const binding = attr_rh?.binding
            if (!binding) return attr_rh?.width || 25
            const vals = new Set()
            let n = 0
            const walk = (rows) => {
                for (const r of rows || []) {
                    if (n++ > 5000 || vals.size > 200) return
                    const v = r ? r[binding] : null
                    if (v != null && v !== '') vals.add(String(v))
                    const kids = this.attr?.childItemsPath ? r?.[this.attr.childItemsPath] : null
                    if (kids) walk(kids)
                }
            }
            walk(this.data000)
            if (!vals.size) return attr_rh.width || 25   // данных ещё нет — дефолт; пересчёт после прихода данных (rhCol_autoSize)
            const host = this.flex?.hostElement
            const cs = host ? getComputedStyle(host) : null
            const cv = this._rhMeasureCanvas = this._rhMeasureCanvas || document.createElement('canvas')
            const ctx = cv.getContext('2d')
            ctx.font = `600 ${cs?.fontSize || '13px'} ${cs?.fontFamily || 'sans-serif'}`   // .row-dl-tabhdr — font-weight 600
            let max = 0
            for (const t of vals) max = Math.max(max, ctx.measureText(t).width)
            return Math.max(24, Math.min(240, Math.ceil(max) + 16))
        },
        rhCol_autoSize() {
            const flex = this.flex
            if (!flex?.rowHeaders) return
            for (const p of (this.rowHeaders_cols_pos || [])) {
                if (!String(p.binding || '').startsWith('_dlhdr_')) continue
                if (this.viewParam_attrs?.[p.binding]?.width) continue   // пользовательская ширина — не трогаем
                const attr_rh = this.attr_by_binding?.[p.binding]
                const col = flex.rowHeaders.columns[p.col_idx]
                if (!attr_rh || !col) continue
                const w = this.rhCol_autoWidth(attr_rh)
                if (Math.round(col.width) !== w) col.width = w
            }
        },
        rhCol_setWidth(binding, width) {   // как set_width обычной колонки: viewParams виджета → сохраняется с виджетом
            width = Math.round(width)
            if (!binding || !(width > 0)) return
            if (this.viewParam_attrs[binding]?.width !== width) {
                this.viewParam_attrs[binding] = this.viewParam_attrs[binding] || {}
                this.viewParam_attrs[binding].width = width
                this.store.set_viewParam(this.WIDGET, this.attr.name, 'attr_by_binding', this.viewParam_attrs, this.attr)
                this.set_commandPanel()   // пункт Restore default sizes
            }
        },
        // wijmo не даёт тянуть ширину колонок панели заголовков строк — своя ручка: правый край ячейки колонки-группы (±5px) в панелях
        // topLeft / rowHeaders, курсор col-resize; перетаскивание меняет ширину, отпускание — сохраняет её в viewParams виджета
        rhResize_install() {
            const flex = this.flex
            if (!flex?.hostElement || this._rhResizeInstalled) return
            this._rhResizeInstalled = true
            const host = flex.hostElement
            const hitCol = (e) => {
                if (!(this.rowHeaders_cols_pos || []).length) return null
                let ht
                try { ht = flex.hitTest(e) } catch (err) { return null }
                if (!ht || !(ht.panel === flex.topLeftCells || ht.panel === flex.rowHeaders) || ht.col < 0) return null
                const p = this.rowHeaders_cols_pos.find(x => x.col_idx === ht.col)
                if (!p) return null
                const cellEl = ht.panel.getCellElement(Math.max(0, ht.row), ht.col)
                if (!cellEl) return null
                const r = cellEl.getBoundingClientRect()
                if (Math.abs(e.clientX - r.right) > 5) return null
                return { col: flex.rowHeaders.columns[ht.col], binding: p.binding }
            }
            host.addEventListener('mousemove', (e) => {
                if (this._rhResize) return
                const on = !!hitCol(e)
                if (on !== !!this._rhResizeHover) { this._rhResizeHover = on; host.classList.toggle('rh-col-resize', on) }
            })
            host.addEventListener('mouseleave', () => { if (this._rhResizeHover) { this._rhResizeHover = false; host.classList.remove('rh-col-resize') } })
            host.addEventListener('mousedown', (e) => {
                if (e.button !== 0) return
                const h = hitCol(e)
                if (!h) return
                e.preventDefault(); e.stopPropagation()
                const start = { x: e.clientX, w: h.col.width }
                this._rhResize = h
                const onMove = (ev) => { h.col.width = Math.max(20, Math.round(start.w + ev.clientX - start.x)) }
                const onUp = () => {
                    document.removeEventListener('mousemove', onMove, true)
                    document.removeEventListener('mouseup', onUp, true)
                    this._rhResize = null
                    this.rhCol_setWidth(h.binding, h.col.width)
                }
                document.addEventListener('mousemove', onMove, true)
                document.addEventListener('mouseup', onUp, true)
            }, true)
        },
        set_width(icol, width) {
            const col = this.flex.columns[icol],
            attr_col = this.attr_by_binding[col.binding]
            if (!attr_col) {
                return
            }
            // IE 2026 10 06 / ODOO-341407 (заказ Игоря п.2, DESIGN Р7): колонка переводов «… (uk)» — личная опция вида: ширина только в памяти грида (переживает
            // пересборку колонок), в doc.viewParams не пишется — ресайз не метит запись виджета изменённой
            if (attr_col._i18nOf) {
                attr_col.width = width
                if (!this._i18nColWidths) this._i18nColWidths = {}
                this._i18nColWidths[attr_col.binding] = width
                return
            }

            if (this.viewParam_attrs[attr_col.binding]?.width !== width) {
                this.viewParam_attrs[attr_col.binding] = this.viewParam_attrs[attr_col.binding] || {}
                this.viewParam_attrs[attr_col.binding].width = width
                this.store.set_viewParam(this.WIDGET, this.attr.name, 'attr_by_binding', this.viewParam_attrs, this.attr)
                // задача 17: первый пользовательский ресайз включает пункт Restore default sizes
                this.set_commandPanel()
            }
        },
        resizedRow(flex, e) {
            const irow = e.row,
            row = this.flex.rows[irow]
            this.set_height({irow, height:row.height})
        },
        set_height({ dataItem = null, irow = null, height = null } = {}) {
            if (height == null) return;

            if (!dataItem) {
                const row = this.flex.rows[irow]
                dataItem = row.dataItem
            }
            dataItem._cells = dataItem._cells || {}
            const _cells_row = dataItem._cells._row = dataItem._cells?._row || {}
            _cells_row.height = height

            this.printTpl_afterChange() // высота строки эфемерного шаблона → канон

            // задача 17: первый пользовательский ресайз включает пункт Restore default sizes
            this.set_commandPanel()
        },
        // ---------- задача 17: Restore default sizes (ширины колонок + высоты строк) ----------
        restoreDefaultSizes_hasChanges() {
            if (Object.values(this.viewParam_attrs || {}).some(v => v && v.width !== undefined)) return true
            let found = false
            const walk = (rows) => {
                for (const r of rows || []) {
                    if (found) return
                    if (r?._cells?._row?.height != null) { found = true; return }
                    if (this.attr.childItemsPath && r?.[this.attr.childItemsPath]) walk(r[this.attr.childItemsPath])
                }
            }
            walk(this.data000)
            return found
        },
        restoreDefaultSizes() {
            // сброс пользовательских ширин: удаляем только .width (isCollapsed и др. не трогаем)
            const cleaned = {}
            for (const [binding, v] of Object.entries(this.viewParam_attrs || {})) {
                if (!v) continue
                const { width, ...rest } = v
                if (Object.keys(rest).length) cleaned[binding] = rest
            }
            this.viewParam_attrs = cleaned
            this._i18nColWidths = null   // IE 2026 10 06 / ODOO-341407: и ширины колонок переводов «(uk)» (только память грида; пункт меню они не включают — ресайз личной колонки запись не метит)
            // клон — гарантируем запись и modified (set_viewParam no-op при том же объекте)
            this.store.set_viewParam(this.WIDGET, this.attr.name, 'attr_by_binding', { ...cleaned }, this.attr)
            // сброс пользовательских высот строк
            const walk = (rows) => {
                for (const r of rows || []) {
                    if (r?._cells?._row) {
                        delete r._cells._row.height
                        if (!Object.keys(r._cells._row).length) delete r._cells._row
                        if (!Object.keys(r._cells).length) delete r._cells
                    }
                    if (this.attr.childItemsPath && r?.[this.attr.childItemsPath]) walk(r[this.attr.childItemsPath])
                }
            }
            walk(this.data000)
            if (this.flex?.rows) {
                for (const row of this.flex.rows) row.height = null
            }
            // пересборка: колонки получают дефолтные ширины (attr_col.width / autoSize),
            // строки — defaultSize; set_commandPanel внутри погасит пункт меню
            this.content_Changed_afterTimeout()
        },
        // IE 2026 08 19 / ODOO-5512 (заказ Игоря): в гриде реквизитов (AttrTabGrid,
        // cssClass attrs-tab-grid) группы Field/Value по умолчанию СВЁРНУТЫ, и это
        // состояние не персистится: раскрытие «под капот» (Field/Type/Link/Raw
        // value) — разовый взгляд, а не настройка записи. Раньше раскрытие писалось
        // в record.doc.viewParams.<grid>.attr_by_binding.<collapseTo>.isCollapsed,
        // запись становилась modified и при сохранении отчёта уезжала в БД — открывая
        // такой отчёт, ВСЕ видели лишние колонки (в dm_preprod так лежит >80 отчётов
        // и >160 источников). Сохранённые значения теперь игнорируются, чистить БД
        // не требуется; ширины колонок персистятся по-прежнему
        foldPersist_enabled() {
            // IE 2026 08 20 (заказ Игоря): attr.foldPersist === false — свёртка строк
            // не персистится (таблица настроек: по умолчанию всегда развёрнута)
            if (this.attr?.foldPersist === false) return false
            return !String(this.attr?.cssClass || '').includes('attrs-tab-grid')
        },
        foldColsPersist_enabled() {
            // IE 2026 08 21 (скрины Игоря): гейт 20.08 про СТРОКИ настроечных таблиц
            // зацепил и КОЛОНКИ — ручная свёртка колоночной группы (Value) в форме
            // настроек не переживала пересборку грида (выкл/вкл заголовков) и
            // «разворачивалась сама». Колонкам персист возвращаем; строки — как были
            return this.attr?.foldPersist !== false
        },
        // IE 2026 09 05 / ODOO-336330 (заказ Игоря): свёртка/развёртка узла дерева — одной перерисовкой.
        // wijmo после клика рендерит строки отложенным invalidate БЕЗ refreshing: ячейки шли по кэш-пути
        // formatItem с кэшем ПРЕЖНИХ строк тех же индексов (ключ кэша — индекс строки), затем ResizeObserver
        // грида давал полный refresh (сброс кэша), а высоты строк-начал секций (+10px зазор,
        // formatItem_cells_break) менялись уже в нём → ещё один invalidate → третий проход. Здесь, ДО первой
        // отрисовки: высоты секций выставляются сразу (sectionHeights_sync — логика autoSizeRows) и кэш ячеек
        // сбрасывается, чтобы первый проход был полным. Bulk-свёртки (collapseGroupsToLevel внутри
        // deferUpdate, flex.isUpdating) не трогаем. Счётчики: this._collapseOnePass.
        // Выкл: window.fastEntry.set('collapseOnePass', false)
        groupCollapsedChanged(flex, e) {
            this.sigPie_schedule()   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: агрегат сигналов кругом в кнопке; проблемы подсказки в одну строку, клик — форма ячейки): раскрытие / свёртка — другие видимые строки
            if (this._infl && this.store?.setting?.('fe.ux.cellBasisDeepest', true) !== false) this.influence_reschedule()   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p204 підсвітка залежних комірок — у розкритого батька лише точна дочірня комірка)
            this._groupDup = null   // IE 2026 09 23 / ODOO-… (заказ Игоря: итог группы = единственный потомок): свёрнутая группа — как есть, раскрытая — повторы заново
            if (this.store?.fastEntry?.collapseOnePass === false) return
            // IE 2026 10 25 / ODOO-348878 (заказ Игоря: высота строк после «свернуть все»): массовая свёртка (collapseGroupsToLevel внутри deferUpdate) — один пересчёт высот
            // после окончания обновления, тем же путём, что ручной toggle (collapseBulk_run); выключатель fe.ux.gridCollapseAllHeights выкл — как было (пропуск)
            if (gcaPlan({ hasFlex: !!flex, isUpdating: !!flex?.isUpdating, print: !!(this.attr?.isPrint || this.attr?.isPrintTemplate), delivery: !!this.attr?.use_delivery, on: () => this.gca_on() }) === 'bulk') {
                gcaSchedule(this._gcaSt || (this._gcaSt = { queued: false }), { isUpdating: () => !!flex.isUpdating, run: () => this.collapseBulk_run(flex) })
                return
            }
            if (!flex || flex.isUpdating || this.attr?.isPrint || this.attr?.isPrintTemplate) return
            const t0 = performance.now()
            const changed = this.sectionHeights_sync(flex)
            this.refreshing()
            const st = this._collapseOnePass || (this._collapseOnePass = { calls: 0, heightsChanged: 0, ms: 0 })
            st.calls++; st.heightsChanged += changed; st.ms += performance.now() - t0
        },
        // высоты строк-начал секций (зазор +10px) для ВИДИМЫХ строк — синхронно, одним deferUpdate.
        // Значения — РОВНО как их потом выставит formatItem_cells_break (иначе он выставит своё → ещё один
        // invalidate): начало секции = (высота строки лэйаута || defaultSize) + зазор, даже когда зазор 0;
        // прочие строки — высота лэйаута или сброс в null (как autoSizeRows: иначе +10px оставался
        // навсегда у строки, переставшей быть началом секции после разворота)
        sectionHeights_sync(flex = this.flex) {
            if (!this.attr.use_delivery || !flex) return 0
            const rows = flex.rows, defaultSize = rows.defaultSize
            const breakTop = (this.attr.borders === 'None' || this.treeLines_noGaps()) ? 0 : 10
            let changed = 0
            flex.deferUpdate(() => {
                let iPrev = -1
                for (let i = 0; i < rows.length; i++) {
                    const row = rows[i]
                    if (row.visibleIndex === -1) continue
                    const sectionStart = iPrev > 0 && row.level < rows[iPrev].level
                    const dataItem = row.dataItem
                    const rowH = dataItem?._DLRow?.height || dataItem?._cells?._row?.height || 0
                    let newHeight = null
                    if (sectionStart) newHeight = (rowH || defaultSize) + breakTop
                    else if (rowH) newHeight = rowH
                    if (newHeight !== null) { if (row.height !== newHeight) { row.height = newHeight; changed++ } }
                    else if (row.height !== null) { row.height = null; changed++ }
                    iPrev = i
                }
            })
            return changed
        },
        columnGroupCollapsedChanged(flex, e) {
            try { this.yearTotals_sync() } catch (err) { /* грид пересоздаётся */ }   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p217 кнопка Σ — річні підсумки за опцією, типово вимкнено): свёрнутый год показывает свой итог независимо от Σ, развёрнутый — по Σ
            this._foldHdrBlank = null   // состав гасимых подписей зависит от свёртки
            this.cf_cache?.clear()      // условное оформление считалось по агрегатам старой свёртки
            // раскрытие/свёртка руками не должны сдвигать грид по горизонтали
            this.foldCols_keepScroll(flex, () => {})
            // АН 2026 08 14: программная свёртка (foldDefault_reapplyLive при
            // построении) — кэши выше сброшены, но состояние НЕ персистим и
            // drill-down не запускаем: это не действие пользователя, а запись
            // в viewParams делала виджет modified сразу после рендера
            if (this._foldSilent) return
            const _grp = e?.getColumn ? e.getColumn(true) : null
            if (this.foldMem_isForm() && _grp) {   // IE 2026 09 17: форма настроек — ручная свёртка в сеансовую память, запись не трогаем
                const p = this.foldGroupPath(flex, _grp)
                if (p) this.foldMem_set(`fold::${p}`, _grp.isCollapsed)
                return
            }
            // раскрытие группы показывает следующий уровень свёрнутым (drill-down)
            if (this.foldDefault_level('fold_cols_level')) {
                if (_grp && _grp.columns?.length && !_grp.isCollapsed) this.foldCols_drillOne(flex, _grp)
            }
            // свёрнутость ГРУППЫ пишем по стабильному пути: binding у групп
            // генерённый (n5), а ключ по колонке-представителю неоднозначен
            // (месяц и его первая неделя делят один лист) — из-за этого ручное
            // раскрытие не восстанавливалось и параметр сворачивал его обратно
            if (_grp && _grp.columns?.length && this.foldPersist_enabled()) {
                const p = this.foldGroupPath(flex, _grp)
                const key = p && `fold::${p}`
                if (key && this.viewParam_attrs[key]?.isCollapsed !== _grp.isCollapsed) {
                    this.viewParam_attrs[key] = { ...this.viewParam_attrs[key], isCollapsed: _grp.isCollapsed }
                    // клон — гарантируем запись и modified (set_viewParam no-op при том же объекте)
                    this.store.set_viewParam(this.WIDGET, this.attr.name, 'attr_by_binding', { ...this.viewParam_attrs }, this.attr)
                }
            }
            const col = this.flex.columns[e.col],
            attr_col = this.attr_by_binding[col.binding]
            if (!attr_col) {
                return
            }

            if (this.foldPersist_enabled() && this.viewParam_attrs[attr_col.binding]?.isCollapsed !== col.isCollapsed) {
                this.viewParam_attrs[attr_col.binding] = this.viewParam_attrs[attr_col.binding] || {}
                this.viewParam_attrs[attr_col.binding].isCollapsed = col.isCollapsed
                this.store.set_viewParam(this.WIDGET, this.attr.name, 'attr_by_binding', this.viewParam_attrs, this.attr)
            }
        },
        pastedCell(flex, e) {
            this.cellEditEnded2(e)
            if (!this._pasteBatch) this.flex_check_isReadOnly() // IE 2026 09 04 / ODOO-336379: в батче — один раз в pasteBatch_end
        },
        // IE 2026 09 04 / ODOO-336379 (Игорь: «M03, вставка 12 ячеек — до 30 с на слабых компьютерах»):
        // вставка — ОДИН батч, как undo (_undoBatch, ODOO-4997): внутри батча set_value НЕ делает на
        // каждую ячейку attr_set / инвалидацию py-CSS и условного формата / refreshCells /
        // flex_check_isReadOnly / decomp_syncAncestors+flexRefresh — всё это один раз в pasteBatch_end
        // (wijmo зовёт pasted после цикла pastingCell). Факт по коду wijmo 5.20261: цикл вставки идёт
        // ВНУТРИ flex.deferUpdate → flex.isUpdating=true → refreshCells() из set_value и раньше был
        // no-op (FlexGrid.refreshCells: this.isUpdating || … ), реальная перерисовка одна — по endUpdate
        // (invalidate); счётчики refreshCells real/no-op в замере это показывают.
        // Флаг paste_batch (дефолт ВКЛ, общее хранилище perf-flags): window.gridPerf.set('paste_batch', false)
        // — прежнее поведение байт-в-байт. Замер каждой вставки: консоль «[gridPerf] paste …» и
        // window.gridPerf.stats() (sync-часть + afterEdit(py) + волны py-CSS + autoSize + total до затихания).
        pasteBatch_begin(e) {
            const on = this.store.gridPerf_on ? this.store.gridPerf_on('paste_batch', this.WIDGET) : true // IE 2026 09 05 / ODOO-336379: + выключатель записи (Params → Frontend)
            const stat = {
                t0: performance.now(), batch: on, grid: this.attr?.name || this.attr?.binding || '',
                rows_src: e?.data ? String(e.data).split('\n').filter(l => l.trim() !== '').length : 0,
                cells_offered: 0, cells_changed: 0, set_value_ms: 0,
                attr_set_calls: 0, refreshCells_calls: 0, refreshCells_noop: 0, decomp_sync_calls: 0,
                sync_ms: null, end_ms: 0, ended: null,
                py_calls: 0, py_ms: 0, css_calls: 0, css_ms: 0, css_waves: 0, views: 0, autosize_ms: 0, corrchip_ms: 0,
                total_ms: null, settled: false, last_activity: 0,
            }
            this._pasteStat = stat
            if (on) {
                this._pasteBatch = stat
                this._pasteBatchDecomp = null
            }
            // страховка: wijmo не позовёт pasted (отмена/исключение внутри цикла) — закрыть батч следующим тиком
            clearTimeout(this._pasteBatchT)
            this._pasteBatchT = setTimeout(() => this.pasteBatch_end('timeout'), 0)
        },
        pasted(flex, e) {
            this.pasteBatch_end('pasted')
        },
        pasteBatch_end(reason) {
            clearTimeout(this._pasteBatchT)
            this._pasteBatchT = null
            const b = this._pasteStat
            if (!b || b.ended) return
            b.ended = reason
            const t1 = performance.now()
            if (this._pasteBatch === b) {
                this._pasteBatch = null
                if (b.cells_changed) {
                    // отложенное из set_value / cellEditEnding2 / pastedCell — один раз на вставку
                    // IE 2026 09 04 / ODOO-336379 (флаг css_invalidate_scoped): py-CSS только строк вставки и их предков
                    this.css_invalidate_rows((b.rows && this.cssPerf_scoped()) ? [...b.rows].flatMap(it => this.css_ancestors(it)) : null, 'paste')
                    this.cf_cache?.clear()
                    this._foldAggCache = null
                    this._rowStyleStats = null
                    const dec = this._pasteBatchDecomp
                    this._pasteBatchDecomp = null
                    if (dec?.size) {
                        for (const [item, bset] of dec) {
                            this.decomp_syncAncestors(item, [...bset])
                            b.decomp_sync_calls++
                        }
                        this.flexRefresh()
                    }
                    this.attr_set()
                    b.attr_set_calls++
                    this.flex_check_isReadOnly()
                    // перерисовка: endUpdate wijmo уже взвёл invalidate — синхронный refreshCells не дублируем
                    if (this.flex?.hostElement && !this.flex.isUpdating) this.flex.invalidate()
                }
            }
            b.end_ms = Math.round((performance.now() - t1) * 10) / 10
            b.sync_ms = Math.round((performance.now() - b.t0) * 10) / 10
            b.last_activity = performance.now()
            this._gridPerfCur = b
            this.store.gridPerf_push?.(b)
            console.log(`[gridPerf] paste: cells=${b.cells_offered} (changed ${b.cells_changed}), batch=${b.batch ? 'on' : 'off'}, sync=${b.sync_ms} ms (set_value ${Math.round(b.set_value_ms)} ms, attr_set ×${b.attr_set_calls}, refreshCells real ×${b.refreshCells_calls} / no-op ×${b.refreshCells_noop}, end ${b.end_ms} ms) — waiting for afterEdit(py) / css / view to settle`)
            this.gridPerf_settle(b)
        },
        gridPerf_touch(kind, ms) {
            const b = this._gridPerfCur
            if (!b || b.settled) return
            b.last_activity = performance.now()
            if (kind === 'py') { b.py_calls++; b.py_ms += ms }
            else if (kind === 'css') { b.css_calls++; b.css_ms += ms }
            else if (kind === 'cssWave') { b.css_waves++ }
            else if (kind === 'view') { b.views++ }
            else if (kind === 'autosize') { b.autosize_ms += ms }
            else if (kind === 'corrchip') { b.corrchip_ms += ms }
        },
        gridPerf_settle(b) {
            // затихание: очереди afterEdit(py) и py-CSS пусты и ≥400 мс без активности (view/py/css); потолок 60 с
            clearTimeout(this._gridPerfSettleT)
            const tick = () => {
                if (this._gridPerfCur !== b || b.settled) return
                const now = performance.now()
                const busy = !!(this.cache_process_dataItem_py?.size || this.process_dataItem_py__start_WORKIING
                    || this.cache2_data_cells__call?.size || this.formatItem_cells_calcCSS_py__start_WORKIING)
                const timeout = now - b.t0 > 60000
                if ((!busy && now - b.last_activity >= 400) || timeout) {
                    b.settled = true
                    b.total_ms = Math.round(b.last_activity - b.t0)
                    for (const k of ['set_value_ms', 'py_ms', 'css_ms', 'autosize_ms', 'corrchip_ms']) b[k] = Math.round(b[k])
                    console.log(`[gridPerf] paste settled: cells=${b.cells_offered}, refreshCells=${b.refreshCells_calls}, set_value=${b.set_value_ms} ms, afterEdit(py)=${b.py_ms} ms ×${b.py_calls} (scope=${b.py_scope || '-'}, skus ${b.py_skus || 0}/${b.py_skus_total || 0}), css waves=${b.css_waves} (${b.css_calls} cells, ${b.css_ms} ms), autosize=${b.autosize_ms} ms, corrchip=${b.corrchip_ms} ms, views=${b.views}, css memo=${b.css_memo_hits || 0}/${(b.css_memo_hits || 0) + (b.css_memo_miss || 0)}, inv rows=${b.css_inv_rows || 0}${b.css_inv_all ? ' (+all ' + b.css_inv_all + ')' : ''}, frozenClip=${b.css_frozen_batches || 0}×/${b.css_frozen_cells || 0} cells, total=${b.total_ms} ms${timeout ? ' (timeout)' : ''}`)
                    this._gridPerfCur = null
                    return
                }
                this._gridPerfSettleT = window.$cg?.setTimeout ? window.$cg.setTimeout(this, 'AttrGrid.gridPerfSettle', tick, 250) : setTimeout(tick, 250)
            }
            this._gridPerfSettleT = window.$cg?.setTimeout ? window.$cg.setTimeout(this, 'AttrGrid.gridPerfSettle', tick, 250) : setTimeout(tick, 250)
        },
        saveVisibility() {
            // this.columnsVisibility = []
            // this.rowsVisibility = []
            
            // for (let col of this.flex.columns) {
            //     this.columnsVisibility.push(col.visible)
            // }
            // for (let row of this.flex.rows) {
            //     this.rowsVisibility.push(row.visible)
            // }
        },
        restoreVisibility() {
            // for (let icol in this.columnsVisibility) {
            //     if (this.flex.columns[icol].visible !== this.columnsVisibility[icol]) {
            //         this.flex.columns[icol].visible = this.columnsVisibility[icol]
            //     }
            // }
            // for (let irow in this.rowsVisibility) {
            //     if (this.flex.rows[irow].isVisible !== this.rowsVisibility[irow]) {
            //         this.flex.rows[irow].isVisible = this.rowsVisibility[irow]
            //     }
            // }

            // this.columnsVisibility = []
            // this.rowsVisibility = []
        },
        itemsSourceChanged(flex, e) {
            this._dateBar = null   // IE 2026 09 22 (заказ Игоря): шкалы полос дат — заново по новому набору строк
            this._groupDup = null   // IE 2026 09 23 / ODOO-… (заказ Игоря: итог группы = единственный потомок)
            // IE 2026 09 22 (замечание Игоря): после перечитывания виджета-селектора (его запрос идёт без строки собственного Set-поля —
            // workspace_params_for) флаги отбора строк по чипсам стола ставит фронт, до отрисовки нового набора строк
            if (this.attr?.name === 'dataSheet' && this.WIDGET) { try { this.store.selectorFlags_refresh(this.WIDGET) } catch (err) { /* нет записи / полей */ } }
            this.flex_check_isReadOnly()
            // панель полей открыта по ⚙ из легенды чарта — довести до строки поля
            this.$nextTick(() => this.legendGotoField())
        },
        // IE 2026 09 14 / ODOO-5800: выбранная строка панели полей (doc.viewList) → store (чарт ведёт к ней стрелку легенды)
        legendFieldSelectionPublish(d) {
            if (this.attr?.binding !== 'doc.viewList' || !this.WIDGET?.id) return
            const binding = d?.binding || null
            const cur = this.store.legend_field_selection
            if (cur && cur.widget_id === this.WIDGET.id && cur.binding === binding) return
            this.store.legend_field_selection = { widget_id: this.WIDGET.id, binding, ts: Date.now() }
        },
        // ODOO-4440: выделить и показать строку поля, запрошенную легендой чарта
        legendGotoField() {
            const g = this.store.legend_goto_field
            if (!g || this.attr?.binding !== 'doc.viewList' || !this.flex) return
            const rows = this.flex.rows || []
            for (let i = 0; i < rows.length; i++) {
                const d = rows[i].dataItem
                if (!d || d.binding !== g.binding) continue
                this.store.legend_goto_field = null
                // строка может сидеть в свёрнутом Tab-узле — раскрыть предков
                for (let j = i - 1, lvl = rows[i].level ?? 0; j >= 0 && lvl > 0; j--) {
                    const rj = rows[j]
                    if ((rj.level ?? 0) < lvl) {
                        lvl = rj.level ?? 0
                        if (rj.isCollapsed) rj.isCollapsed = false
                    }
                }
                // IE 2026 09 14 / ODOO-5800 (замечание Игоря): только выделить ячейку поля (колонка Title), окно строки
                // не открывать — при необходимости его откроют вручную; выбор публикуется для стрелки легенды
                const colTitle = this.flex.columns.getColumn ? this.flex.columns.getColumn('title') : null
                this.flex.select(new wjGrid.CellRange(i, colTitle ? colTitle.index : 1), true)
                this.legendFieldSelectionPublish(d)
                return
            }
        },
        value_multi_click(cell) {
            if (this.value_multi_inEdit.row !== null) {
                if (!this.store.hide_console) console.log('To select, first complete the edit')
                return
            }

            this.value_multi_inEdit = cell
            let dataItem = this.flex.rows[cell.irow].dataItem,
            value = this.store.get_value(dataItem, cell.binding)
            this.flex.setCellData(cell.row, cell.col, value.values[this.value_multi_inEdit.ivalue].title)

            // if (!this.store.hide_console) console.log(this.flex.onBeginningEdit(new wjGrid.CellRangeEventArgs(this.flex, new wjGrid.CellRange(cell.row, cell.col))))
        },
        beginningEdit(flex, e) {
            if (this.archiveRo?.()) { e.cancel = true; this.store.readonly_toast('', 'edit'); return }   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): архивная ПМ — редактор не открываем, тост «Archive is read-only: editing is disabled» (гейт динамический: стол при смене модели не пересобирается)
            // IE 2026 09 29 / ODOO-342781: роль «только чтение» — редактор ячейки не открываем, тост «Read-only access: editing is disabled» (при flex.isReadOnly wijmo до сюда не доходит — страховка на случай снятого флага)
            if (this.store.readonly_on()) { e.cancel = true; this.store.readonly_toast('', 'edit'); return }
            this.editKeep_armStart(e.row, e.col)   // IE 2026 10 14 / ODOO-5800: refresh(false) wijmo в startEditing замороженной колонки — точечно (отмена правки ниже — взвод истечёт сам)
            // IE 2026 09 17 / ODOO-… (заказ Игоря, merge «назад»): двойной клик по пустой части перед значением —
            // редактируем ячейку значения, а не пустую под ней.
            // IE 2026 09 18 (замечание Игоря: «залипание после попытки открыть ячейку»): wijmo редактирует ВЕРХНЮЮ-ЛЕВУЮ
            // ячейку объединения — при merge «назад» это колонка дерева, редактор вставал не туда и не закрывался.
            // На время правки строка исключается из объединения «назад» (_mergeBackEditRow → mergeBack_extend),
            // ячейки перерисовываются, и редактор открывается ровно на ячейке значения.
            {
                const mb = this.mergeBack_info(flex.cells, e.row)
                if (mb && e.col >= mb.startCol && e.col <= mb.k && !(this._mergeBackEditRow === e.row && e.col === mb.k)) {
                    // флаг — синхронно: второй startEditing двойного клика (wijmo шлёт его с физической колонкой)
                    // должен видеть строку уже «в правке», а не начинать всё заново
                    if (this._mergeBackEditRow !== e.row) { this._mergeBackEditRow = e.row; this._mergeBackEditRendered = null }
                    e.cancel = true
                    const row = e.row, k = mb.k
                    window.$cg.setTimeout(this, 'AttrGrid.mergeBackEdit', () => {
                        try {
                            if (this._mergeBackEditRow !== row) return
                            if (flex.activeEditor && flex.editRange && flex.editRange.row === row && flex.editRange.col === k) return   // редактор уже на ячейке значения
                            if (this._mergeBackEditRendered !== row) { flex.refresh(false); this._mergeBackEditRendered = row }   // строка без объединения «назад» — у ячейки значения свой элемент
                            flex.select(new wjGrid.CellRange(row, k), true)
                            flex.startEditing(true, row, k)
                            if (!flex.activeEditor) this.mergeBack_editDone(flex)   // редактор не открылся (read-only) — вернуть объединение
                        } catch (err) { this.mergeBack_editDone(flex) }
                    }, 0)
                    return
                }
            }
            const col = flex.columns[e.col]
            const attr_col = this.attr_by_binding[col.binding]
            if (this.planLabelDate_editLocked?.(flex, e.row, e.col)) { e.cancel = true; return }   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана): подпись с токеном — только чтение (клик по выделенной ячейке не открывает редактор, Ctrl+C — через copy_collect)
            if (attr_col?.attr_type === 'AttrGrid') {
                e.cancel = true
                return
            }
            // IE 2026 09 21 / ODOO-5800 (итоги строк-групп по отбору): в ячейке показан итог по видимым строкам, а не значение строки данных — правка разложилась бы по ВСЕМ
            // подчинённым, включая спрятанные отбором; отменяем ввод с пояснением
            if (this._ftMap && attr_col) {
                const _ftf = this.foldAgg_value(flex.rows[e.row]?.dataItem, attr_col.binding0 || col.binding, attr_col)
                if (_ftf && _ftf.ft) {
                    e.cancel = true
                    this.store.show_notification({ text: t('This total is recalculated by the rows that match the filter - remove the row filter to edit it'), status: 'warning', timeout: 7000 })   // IE 2026 09 23 / ODOO-341407: i18n
                    return
                }
            }
            // IE 2026 09 02 / ODOO-11316 (заказ Игоря): ячейка Value в таблице фильтров,
            // значение которой отчёт подставляет сам («in selector» / вычисляемый Source
            // без manual) — правка руками не имеет смысла: отменяем ввод (значение
            // остаётся прежним) и красным флешем с затуханием показываем, что нельзя.
            const _av = this.autoValue_isAuto(flex.rows[e.row]?.dataItem, col.binding)
            if (_av.rowAuto && _av.valueCell && !_av.isChild) {
                e.cancel = true
                this.autoValue_rejectFlash(e.row, col.binding)
                return
            }
            // IE 2026 08 19 / ODOO-5512 (заказ Игоря): AttrTags — ячейка значений
            // редактируется своим чипс-редактором (input внутри ячейки), а не
            // wijmo-редактором: иначе набор текста затирал чипсы
            if (this.attr.attr_type === 'AttrTabGrid' && col.binding === 'attr.valueStr'
                    && flex.rows[e.row]?.dataItem?.attr?.attr_type === 'AttrTags') {
                e.cancel = true
                return
            }
            // IE 2026 10 06 / ODOO-341407 (заказ Игоря п.2, В2): строка перевода формы только для чтения («(en)» — английская база; режим «только чтение») — без редактора
            if (this.attr.attr_type === 'AttrTabGrid' && col.binding === 'attr.valueStr'
                    && this.i18nFields_rowReadOnly(flex.rows[e.row]?.dataItem)) {   // IE 2026 10 06 / ODOO-341407: + «(en)» по _i18nOf.en (общая проверка с вставкой / очисткой)
                e.cancel = true
                return
            }
            // IE 2026 10 06 / ODOO-341407 (заказ Игоря п.2, DESIGN Р5): колонка переводов списка «… (uk)» у строки без контейнера перевода (без meta / doc) — без
            // редактора: update_data бэка заменил бы meta записи целиком
            if (attr_col?._i18nOf && !this.i18nFields_rowEditable(flex.rows[e.row]?.dataItem, attr_col)) {
                e.cancel = true
                return
            }
            if (attr_col?.attr_type === 'AttrJSON' || attr_col?.attr_type === 'AttrCSS') {
                e.cancel = true
                if (!this.store.dropdown.visible) {
                    const key = `${flex.cells.cellType}-${e.row}-${e.col}`
                    const divCell = this.divCells.get(key)
                    if (divCell) this.dropdown_prepare(e, divCell, null, false)
                }
                return
            }
            // transpose: параметры ячейки (объект-значение) > строки (row.measure)
            const measureT = this.transpose_measure(attr_col, flex.rows[e.row]?.dataItem)
            const cellT = measureT ? this.transpose_cellObject(this.store.get_value(flex.rows[e.row].dataItem, col.binding)) : null
            if (measureT && (cellT?.isReadOnly ?? measureT.isReadOnly)) {
                e.cancel = true
                return
            }
            // conditional format: isReadOnly задания запрещает редактирование
            // ячейки, вид остаётся обычным (не cell-info)
            if (this.cf_formatProps(flex.rows[e.row]?.dataItem, col.binding, attr_col)?.isReadOnly) {
                e.cancel = true
                // IE 2026 10 14 / ODOO-345618 (заказ Игоря: флажки по порядку без Save) — FL4d: ячейка с пометкой согласования бэка (cells[b]: isReadOnly + noedit-approval-* / no-right) отклоняется здесь, до readOnly_reject ниже, —
                // и клик по БЮМ без ПМ молчал (бой, ie-dm-app7 ev29). Тост с причиной по коду пометки (readOnly_reason: order → «requires … first», прочие — message бэка);
                // обычные CF-read-only ячейки — как были, без тоста. Флажок, открытый живым порядком (FL4), сюда не попадает: cf_formatProps снял isReadOnly
                const _fdm = flex.rows[e.row]?.dataItem
                if (_fdm && approvalFlagMark(_fdm, col.binding)) this.readOnly_reject(e.row, e.col, 'beginningEdit')
                return
            }
            // IE 2026 09 04 / ODOO-336379 (Игорь: тормоза на флажках согласования M03): нередактируемую
            // по правилу отчёта (use_editable / css-класс editable) ячейку отклоняем ЗДЕСЬ, до открытия
            // редактора. Профиль отклонённого клика по чекбоксу: три полные перерисовки грида —
            // wijmo startEditing и finishEditing (по ~0,8 с на 340 видимых строках, ~2,5 с на 1000)
            // и наш flexRefresh ради флеша; отказ в beginningEdit убирает первые две, чекбокс
            // визуально не переключается, уведомление — сразу (тот же readOnly_reject, что и на коммите).
            if (this.cssPerf_on('reject_in_beginning_edit') && !this.is_editable(e)) {
                e.cancel = true
                this.readOnly_reject(e.row, e.col, 'beginningEdit')
                return
            }
            this.cell_oldVal = this.flex.getCellData(e.row, e.col)
            if (cellT) {
                // старым значением считаем value объекта, иначе выход из редактора без правок даст ложное изменение
                this.cell_oldVal = cellT.value
            }

            // i18n: в ячейке показан перевод — старым значением считаем его,
            // иначе закрытие редактора без правок породит ложное изменение
            const translated = this.localized_cellValue(attr_col, flex.rows[e.row]?.dataItem)
            if (translated) {
                this.cell_oldVal = translated
            }
        },
        prepareCellForEdit(flex, e) { // this after formatItem
            let vueObj = this,
            // e.data есть только при старте редактирования ОТ СОБЫТИЯ; при
            // программном flex.startEditing его нет (значение всё равно
            // перезаписывается ниже из divCells) — не роняем редактор
            divCell = e.data?.target,
            activeEditor,
            col = flex.columns[e.col],
            attr_col = vueObj.attr_by_binding[col.binding]
            // FB1c: редактор открывается на выделенной булевой ячейке со своим (FB1) чекбоксом — снять его до появления редактора wijmo
            try { const _bsEl = flex.cells.getCellElement(e.row, e.col), _bs = _bsEl && _bsEl.querySelector('input.bool-sel-chk'); if (_bs) { _bs.remove(); const _C = window.__boolSelectedCheckbox; if (_C) _C.edit = (_C.edit || 0) + 1 } } catch (err) { /* ячейка вне видимой области */ }   // IE 2026 10 12 / ODOO-345618 (заказ Игоря: чекбокс у выделенной булевой ячейки) — FB1c

            // if cloneFrozenCells
            const key = `${flex.cells.cellType}-${e.row}-${e.col}`
            divCell = this.divCells.get(key)

            this.ghostText = document.createElement("span");
            this.ghostText.className = "ghost-text";
            // const currentPadding = parseFloat(divCell.style['padding-left']) || 2;
            // this.ghostText_additionalPadding = 36
            // this.ghostText.style['padding-left'] = `${currentPadding + (this.ghostText_additionalPadding||0)}px`;

            if (divCell && vueObj.flex.activeEditor) {
                activeEditor = vueObj.flex.activeEditor
                const dataItem = flex.rows[e.row]?.dataItem
                const V = (attr_col?.attr_type === 'AttrMulti' && dataItem)
                    ? this.store.check_AttrMulti(attr_col, dataItem)
                    : attr_col

                if (attr_col?.attr_type === 'AttrBool') { // in a report with groupings >> the checkbox does not change state when pressing the space bar
                    activeEditor.setAttribute('type', 'checkbox');
                    // activeEditor.checked = true;
                }

                activeEditor.readOnly = !this.is_editable(e);

                // i18n: пользователь редактирует показанный перевод
                const translated = this.localized_cellValue(attr_col, dataItem)
                if (translated && activeEditor.type !== 'checkbox') {
                    activeEditor.value = translated
                }

                // transpose: в редакторе — значение из ячейки-объекта {value, ...}
                if (this.transpose_measure(attr_col, dataItem)) {
                    const cellT = this.transpose_cellObject(this.store.get_value(dataItem, col.binding))
                    if (cellT && activeEditor.type !== 'checkbox') {
                        activeEditor.value = cellT.value ?? ''
                    }
                }

                if (V?.format === 'bytes') {
                    const raw = parseFloat(activeEditor.value)
                    if (!isNaN(raw)) activeEditor.value = this.store.formatBytesText(raw)
                }

                // IE 2026 09 10 / ODOO-5800 (заказ Игоря): DOS хранится в СЕКУНДАХ, вводится днями (input_unit 'd') —
                // в редакторе значение в ЕДИНИЦАХ ВВОДА («422», как показывал AttrDays), а не сырые секунды.
                // Тип/единица — у поля (форма записи) или у меры строки (transpose)
                if (activeEditor.type !== 'checkbox') {
                    const _dA = (V?.attr_type === 'AttrTime') ? this.durationAttr_merge(attr_col, V)
                        : this.editCell_durationAttr(dataItem, col.binding, attr_col)
                    const _u = _dA?.attr_type === 'AttrTime' ? this.store.inputUnit_seconds(_dA.input_unit) : null
                    if (_u) {
                        const _cellT = this.transpose_measure(attr_col, dataItem)
                            ? this.transpose_cellObject(this.store.get_value(dataItem, col.binding)) : null
                        const raw = _cellT ? _cellT.value : (attr_col?.attr_type === 'AttrMulti' ? V?.value : this.store.get_value(dataItem, col.binding))
                        if (raw != null && raw !== '' && Number.isFinite(+raw)) {
                            activeEditor.value = String(Math.round(+raw / _u * 1000) / 1000)
                            // cell_oldVal остаётся СЫРЫМ (секунды): он уходит в undo-стек и бейджи изменений;
                            // «без правок» распознаём по тексту редактора в cellEditEnding2 (durEdit)
                            this.durEdit = { row: e.row, col: e.col, text: activeEditor.value }
                        }
                    }
                }

                // col.dataMapEditor === 'AutoComplete'
                // activeEditor.setAttribute('autocomplete', 'off');
                // activeEditor.minLength = 21
                // const host = activeEditor.closest('.wj-control');
                // const ac = host ? wjcCore.Control.getControl(host) : null;

                // divCell.insertBefore(this.ghostText, activeEditor)

                // 1. Создаём обёртку
                const wrapper = document.createElement('div');
                wrapper.className = 'cell-wrapper';
                wrapper.style.position = 'relative';

                // 2. Убираем input из DOM, если он уже вставлен
                if (activeEditor.parentNode) {
                    activeEditor.parentNode.removeChild(activeEditor);
                }

                // 3. Добавляем в обёртку: сначала ghostText, потом input
                wrapper.appendChild(this.ghostText);
                wrapper.appendChild(activeEditor);

                // 4. Вставляем wrapper вместо прямой вставки input
                divCell.appendChild(wrapper);

                // 5. Выравниваем ghost text по тексту инпута
                const cs = window.getComputedStyle(activeEditor)
                this.ghostText.style.paddingLeft = cs.paddingLeft
                this.ghostText.style.paddingTop = cs.paddingTop
                this.ghostText.style.top = '0'

                // // dropdown open on '=' or starting typing
                // let newVal = activeEditor.value
                // const dropdown = vueObj.store.dropdown
                // if (dropdown.visible) {
                //     if (dropdown.value !== newVal) {
                //         dropdown.value = newVal
                //     }
                //     if ((newVal || '').startsWith('=') && !dropdown.showValue) {
                //         dropdown.showValue = true
                //     }
                // }
            }
            if (activeEditor && this._colorCols) this.colorEd_open(e.row, e.col, activeEditor)   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: цвета как на слайде — редактор цвета ColorPicker)
            if (divCell) this.dropdown_prepare(e, divCell, activeEditor)
        },
        cellEditEnding(flex, e) {
            const dropdown = this.store.dropdown
            if (dropdown.preventBlur) {
                dropdown.preventBlur = false;
                e.cancel = true;
                this.clearGhostTail()   // IE 2026 10 10 / ODOO-341407 (Andrey via core #74395: grid autocomplete — detached value, Enter, arrows): правка отменена кликом по списку — хвост подсказки («Поря» + серое «док») не оставляем
                return;
            }
            // IE 2026 08 19 / ODOO-5512 (заказ Игоря): Escape (finishEditing(true)) —
            // wijmo приходит с e.cancel=true: значение НЕ применяем, ячейка остаётся
            // со старым (раньше введённое применялось и по Escape)
            if (e.cancel) {
                this.ghostText = null
                return
            }

            let newVal = ''
            if (this.flex.activeEditor) {
                if (this.flex.activeEditor.type === 'checkbox') { // 'checked' in this.flex.activeEditor
                    newVal = this.flex.activeEditor.checked
                } else {
                    newVal = this.flex.activeEditor.value
                }
            }
            this.cellEditEnding2(e, newVal, 'cellEditEnding')
            this.ghostText = null
            if (!e.cancel) this.editKeep_arm(e.row, e.col)   // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL3; IE 2026 10 14 / ODOO-5800: + колонка
        },
        rowEditEnding(flex, e) {
            // console.log('rowEditEnding')
        },
        rowEditEnded(flex, e) {
            // console.log('rowEditEnded')
        },
        cellEditEnded(flex, e) {
            if (this.colorEd.open) this.colorEd_close()   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: цвета как на слайде — редактор цвета ColorPicker): правка закончена (и по Esc) — палитру убрать
            if (!e.cancel) this._dateBar = null   // IE 2026 09 22 (заказ Игоря): правка даты — шкалы полос заново
            if (!e.cancel) {
                this.cellEditEnded2(e)
            }
            this.mergeBack_editDone(flex)   // IE 2026 09 18: правка закончена (и по Escape) — объединение «назад» возвращается
        },
        // снять исключение строки из объединения «назад» после правки и перерисовать
        // IE 2026 09 24 / ODOO-… (замечание Игоря: подписи строк в xlsx при объединении «назад»): на время выгрузки xlsx / pdf объединение «назад» выключается (затвор в CustomMergeManager.mergeBack_extend, как у
        // строки в правке). Конвертеры wijmo берут значение из ВЕРХНЕЙ ЛЕВОЙ ячейки диапазона — у расширенного влево диапазона это пустая ячейка
        // дерева, а ячейку значения (k) они считают покрытой: подписи строк уровня 2 («PO. Замовлення: відвантаження від постачальника»,
        // «Ex-Delta» …) в файле пустели. Без расширения подпись уходит в СВОЮ колонку с объединением вправо над пустыми колонками-измерениями —
        // как выгружалось до merge «назад». Снятие флага — refresh(false) своим таймером (как mergeBack_editDone; не invalidate), чтобы экран
        // вернул объединение, если перерисовывался во время выгрузки
        mergeBack_exportOff(on) {
            const was = !!this._mergeBackExportOff
            this._mergeBackExportOff = !!on
            if (on || !was) return
            const f = this.flex
            window.$cg.setTimeout(this, 'AttrGrid.mergeBackExportOff', () => {
                try { if (f && !this._mergeBackExportOff && !f.activeEditor) f.refresh(false) } catch (err) { /* грид мог быть пересоздан */ }
            }, 0)
        },
        mergeBack_editDone(flex) {
            if (this._mergeBackEditRow == null) return
            this._mergeBackEditRow = null
            this._mergeBackEditRendered = null
            const f = flex || this.flex
            // не invalidate(): его отложенный refresh бил по редактору, который двойной клик успевал открыть заново
            window.$cg.setTimeout(this, 'AttrGrid.mergeBackEditDone', () => {
                try { if (f && !f.activeEditor && this._mergeBackEditRow == null) f.refresh(false) } catch (err) { /* грид мог быть пересоздан */ }
            }, 0)
        },
        is_editable(e) {
            const flex = this.flex,
            col = flex.columns[e.col],
            attr_col = this.attr_by_binding[col.binding]

            let is_editable = true // this.attr['custom-isReadOnly'] || false
            if (this.attr.use_editable) {
                is_editable = /\beditable\b/.test(attr_col.cssClass || '')
                if (!is_editable) {
                    const {key2, _cache2} = this.get_cache2(e)
                    // const key = `${flex.cells.cellType}-${e.row}-${e.col}`;
                    // let _cache = this.cache_data_cells.get(key);
                    if (_cache2) {
                        is_editable = /\beditable\b/.test(_cache2.css_user || '')
                    }
                }
                if (!is_editable) {
                    const key = `${flex.cells.cellType}-${e.row}-${e.col}`,
                    divCell = this.divCells.get(key)
                    is_editable = /\beditable\b/.test(divCell?.className || '')
                }
                // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL4: класс editable python-хука M03 берётся из кэша ячейки и после правки флажка ниже остаётся прежним
                // («noedit-approval-order», замер dev 10.10) — флажок, который живой порядок открыл (approvalFlag_open: пометка бэка «по порядку», флажки ниже стоят, право на шаг), редактируем
                if (!is_editable && col?.binding != null) {
                    const _fdi = flex.rows[e.row]?.dataItem
                    // IE 2026 10 14 / ODOO-345618 (заказ Игоря: флажки по порядку без Save) — FL4c: класс noedit-approval-order от python-хука отчёта (пометки cells[] бэка нет) — тот же живой порядок (hookOrder)
                    const _hk = !!_fdi && !approvalFlagMark(_fdi, col.binding) && /\bnoedit-approval-order\b/.test((attr_col?.cssClass || '') + ' ' + (this.get_cache2(e)?._cache2?.css_user || '') + ' ' + (this.divCells.get(`${flex.cells.cellType}-${e.row}-${e.col}`)?.className || ''))
                    if (_fdi && this.approvalFlag_open(_fdi, col.binding, _hk)) is_editable = true
                    // IE 2026 10 18 / ODOO-5800 (Igor, остаток: снять БЮМ сразу после снятия МД): класс noedit-approval-locked правила CF (DOM / кэш ячейки), посчитанный при поставленном флажке выше, —
                    // устарел, если живые значения флажков шагов выше уже сняты (utils/m03FlagsLocal.m03FlagLiveDecision); пометки бэка нет (без политики). Выключатель fe.ux.m03FlagsLocal (дефолт ВКЛ)
                    if (!is_editable && _fdi && this.m03Flags_on() && this.approval_on() && !approvalFlagMark(_fdi, col.binding) && this.m03Flag_lockedClass(e, attr_col)) {
                        const _ld = m03FlagLiveDecision(col.binding, this.fmtPerf('apprSteps', () => this.approvalFlag_steps()), (b) => this.fmtGetValue(_fdi, b))
                        if (_ld && _ld.editable) is_editable = true
                    }
                }
            }
            // IE 2026 10 18 / ODOO-5800 (Igor, скрин: частичный ПМ бренда, а БЮМ на SKU поставился): порядок по агрегату измерения шага — сильнее живого порядка своей строки
            if (is_editable && col?.binding != null) {
                const _ag = this.m03Flag_aggOrder(e.row, col.binding)
                if (_ag && !_ag.ok) is_editable = false
            }
            // conditional format: isReadOnly задания запрещает редактирование
            // ячейки — покрывает и вставку/коммит (cellEditEnding2), и дропдауны
            if (is_editable) {
                const dataItem = flex.rows[e.row]?.dataItem
                if (dataItem && this.cf_formatProps(dataItem, col.binding, attr_col)?.isReadOnly) {
                    is_editable = false
                }
                // IE 2026 10 09 / ODOO-345618 (заказ Игоря: согласование на сегменте): замок согласования строки (approval.locked) или её подчинённых — ввод, вставка, Delete, форма ячейки
                if (is_editable && dataItem && this.approval_lock(dataItem)) is_editable = false
                // IE 2026 10 06 / ODOO-341407 (ревью U9): строка перевода формы только для чтения («… (en)») — вставка и очистка отклоняются с отказом
                // (readOnly_reject), как редактор в beginningEdit
                if (is_editable && this.attr.attr_type === 'AttrTabGrid' && this.i18nFields_rowReadOnly(dataItem)) {
                    is_editable = false
                }
            }
            return is_editable
        },
        cellEditEnding2(e, newVal, parent_method) {
            if (!this.store.hide_console) console.log('cellEditEnding2')
            newVal = this.colorEd_commitValue(e, newVal)   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: цвета как на слайде — редактор цвета ColorPicker): цвет — '#RRGGBB' (ввод, вставка, выбор)
            // IE 2026 08 18 (заказ Игоря п.2): следующее действие снимает
            // свежесть предыдущего — вместо таймера с перерисовкой
            this.flash_end()
            // вложенный binding (attr.attr_type и т.п.) на «сырой» строке без
            // промежуточной структуры: wijmo Binding.setValue не создаёт объекты
            // пути — значение (редактор/вставка/выбор) молча терялось
            {
                const _b = this.flex.columns[e.col]?.binding
                const _di = this.flex.rows[e.row]?.dataItem
                if (_b && _b.includes('.') && _di) {
                    const _parent = _b.slice(0, _b.lastIndexOf('.'))
                    if (this.store.get_value(_di, _parent) == null) {
                        this.store.set_value(_di, _parent, {}, null, null, null, false)
                    }
                }
                // значение введено в *.valueStr мульти-словаря (строки параметров),
                // а тип — дефолтный AttrLink БЕЗ источника резолва: тип по значению,
                // число/текст (просьба Игоря). Отложенно: синхронная цепочка коммита
                // раскладывает value/valueStr после этого хука
                if (_b && /\.valueStr$/.test(_b) && _di) {
                    const _pbT = _b.slice(0, -9)
                    setTimeout(() => {
                        const V = this.store.get_value(_di, _pbT)
                        if (V && this.store.isinstance_dict(V)
                                && (!V.attr_type || V.attr_type === 'AttrLink')
                                && !V.relation_segment
                                && !(Array.isArray(V.itemsSource) && V.itemsSource.length)
                                && V.value != null && V.value !== ''
                                && String(V.value) === String(V.valueStr ?? V.value)) {
                            const _sv = String(V.value).trim()
                            const _num = _sv !== '' && !isNaN(+_sv.replace(',', '.'))
                            V.attr_type = _num ? 'AttrNumber' : 'AttrStr'
                            V.component = V.attr_type
                            if (_num) V.value = +_sv.replace(',', '.')
                            this.flex?.invalidate?.()
                        }
                    }, 150)
                }
            }
            let oldVal = this.flex.getCellData(e.row, e.col),
            col = this.flex.columns[e.col],
            attr_col = this.attr_by_binding[col.binding],
            irow = e.row, // this.flex.collectionView.currentPosition,
            col_binding = col.binding,
            newValStr = null,
            isNull = null

            if (parent_method === 'pastingCell') {
                this.pastedVal = newVal
            } else {
                this.pastedVal = null
            }

            // oldVal if dell cell
            if (this.cell_oldVal!=null) {
                oldVal = this.cell_oldVal
            }
            this.cell_oldVal = null

            // IE 2026 09 10 / ODOO-5800: редактор длительности открыт с текстом в единицах ввода («422» при секундах
            // в ячейке, prepareCellForEdit) — тот же текст на выходе = правок нет (parseTime дал бы «почти те же»
            // секунды с шумом float и ложную правку)
            const _durEdit = this.durEdit
            this.durEdit = null
            if (_durEdit && _durEdit.row === e.row && _durEdit.col === e.col && parent_method === 'cellEditEnding'
                    && String(newVal ?? '').trim() === _durEdit.text) {
                e.cancel = true
                return
            }

            // IE 2026 09 21 / ODOO-5800 (Igor, скрин чипса Corrections: «когда я анализирую ячейки и открываю их формы дропдаун, то часто по итогу наблюдаю, что отчёт изменился —
            // см. чипс корректировок, хотя это не так»): ПУСТАЯ ячейка побывала в режиме редактирования (форма ячейки по F4 / стрелке, двойной щелчок) и редактор закрылся
            // НЕТРОНУТЫМ — пустой текст числовой колонки ниже превращался в 0 и уходил правкой пользователя «пусто → 0» (запись undo-стека, чипс Corrections, жёлтый Save;
            // воспроизведение: handoff-tools/2026-09-21/phantom_corr/pw_phantom_corr.js). Пусто → пустой текст редактора = правки нет. Намеренный ноль вводится цифрой «0»
            // (текст не пуст) и остаётся правкой. Выключатель fe.ux.editEmptyNoop (false — прежнее поведение)
            if (parent_method === 'cellEditEnding' && (oldVal === null || oldVal === undefined || oldVal === '')
                    && typeof newVal === 'string' && newVal.trim() === ''
                    && this.store.setting('fe.ux.editEmptyNoop', true) !== false) {
                e.cancel = true
                return
            }

            // IE 2026 09 25 / ODOO-5800 (D1, разбор ie-fado7 по fe-2026-09-25-39: PO 8→0, превью автоплана положило оценку +8 в ту же ячейку —
            // показано «8»; ввод «8» для отката отбрасывался как «без изменений» РАНЬШЕ снятия оценки (ниже, sim_stripVirtual): запрос
            // отката не уходил, правка −8 оставалась в сессии, леджер +8, чип Corrections горел): «без изменений» — против значения БЕЗ
            // оценки (текущая правка сессии / база), а не против показанного. Ввод, равный базе, идёт обычным путём отката: снятие оценки,
            // правка «обратно к исходному» = no-op цепочки (pushStack), запрос превью с обратной дельтой, пустой ответ снимает леджер.
            // Выключатель fe.sim.revertOverEstimate (false — прежнее сравнение с показанным значением)
            let _realVal = null
            if (this._simVirtual?.size && attr_col && ['AttrNumber', 'AttrMulti'].includes(attr_col.attr_type)
                    && this.sim_flag('revertOverEstimate')) {
                _realVal = this.sim_virtualPeek(this.flex.rows[e.row]?.dataItem, attr_col.binding0 || col_binding, col_binding)
            }
            if (_realVal !== null ? this.sim_sameNumber(_realVal, newVal) : oldVal == newVal) {
                e.cancel = true
                return
            }

            let dataItem = this.get_dataItem(irow, col_binding, newVal)

            if (!this.is_editable(e)) {
                // restore val
                this.flex.setCellData(e.row, e.col, oldVal)
                e.cancel = true
                // IE 2026 09 04 / ODOO-335315 (Игорь: флажок МД в M03 «сам снимается»): отказ
                // не молчит — красный флеш + одно предупреждение на действие + строка TERMINAL с причиной
                this.readOnly_reject(e.row, e.col, parent_method)
                return
            }


            // IE 2026 10 25 / ODOO-348925: AttrRowLink — введённый / вставленный текст → ключ строки источника, пишется <база>.<key_binding> (title не хранится); не найдено — отказ
            if (attr_col?.attr_type === RL_TYPE && this._rlCols?.[col_binding]) {   // IE 2026 10 25 / ODOO-348925
                e.cancel = true   // IE 2026 10 25 / ODOO-348925
                this.rl_editCommit(irow, dataItem, this._rlCols[col_binding], newVal)   // IE 2026 10 25 / ODOO-348925
                return   // IE 2026 10 25 / ODOO-348925
            }   // IE 2026 10 25 / ODOO-348925
            // let dataItem = {}
            // if (this.flex.rows[irow]) {
            //     dataItem = this.flex.rows[irow].dataItem // this.flex.collectionView.items[irow], 
            // } else {
            //     this.store.set_value(dataItem, col_binding, newVal)
            // }

            let V = attr_col
            if (attr_col.attr_type === 'AttrMulti') {
                V = this.store.check_AttrMulti(attr_col, dataItem)
            }

            // prepare newVal (convert to type)
            if (V.attr_type === 'AttrNumber') {
                // IE 2026 09 10 / ODOO-5800: ячейка-длительность по мере СТРОКИ (transpose / measure_in_dataItem —
                // DOS-строки отчётов) в колонке-числе: текст парсим как длительность по параметрам меры
                // («30» = дни при input_unit 'd', «2m» = 2 месяца), иначе в секунды DOS уходило голое число
                const _durAttr = (typeof newVal === 'string' && attr_col.attr_type !== 'AttrMulti')
                    ? this.editCell_durationAttr(dataItem, col_binding, attr_col) : null
                // ИЕ 2026 08 13: «жёсткий ноль» — X/x/х/Х или «-» в числовой ячейке.
                // В документ уходит эпсилон 0.0000001: он проходит документы,
                // агрегаты и алгоритмы штатно (гейт «не автопланировать до даты
                // последнего драфта» срабатывает сам), итогов не искажает.
                // Отображение: |v| < 0.0001 рисуется как «-» (см. formatItem).
                if (typeof newVal === 'string' && /^[xхXХ-]$/.test(newVal.trim())) {
                    newVal = 0.0000001
                } else
                if (_durAttr?.attr_type === 'AttrTime') {
                    newVal = this.store.parseTime(newVal, _durAttr) // IE 2026 09 10 / ODOO-5800
                } else
                if (V?.format === 'bytes' && typeof newVal === 'string') {
                    newVal = this.store.parseBytes(newVal)
                } else if (typeof newVal === 'string' && newVal.trim().endsWith('%')) {
                    newVal = parseFloat(newVal.replace('%', '').replace(',', '.').trim());
                    if (!isNaN(newVal)) {
                        newVal = newVal / 100;
                    }
                } else if (typeof newVal === 'string') {
                    const _sv = newVal.replaceAll(' ', '').replace(',', '.').trim()
                    const newVal_ = +_sv || 0 // Math.max(0,+newVal)
                    if (!newVal_ && _sv !== '' && _sv !== '0' && Number.isNaN(+_sv)) {
                        // ИЕ 2026 08 13: любое НЕ-число (x, «-», текст) — «жёсткий ноль»:
                        // раньше фронт молча превращал его в 0/пусто
                        newVal = 0.0000001
                    } else {
                        if (!newVal_ && newVal !== '0') {
                            isNull = false
                        }
                        newVal = newVal_
                    }
                }
            } else if (V.attr_type === 'AttrStr') {
                newVal = '' + newVal
            } else if (V.attr_type === 'AttrBool') {
                this.AttrLink_oldVal = oldVal
                if (attr_col.attr_type === 'AttrMulti') {
                    newVal = this.store.isTrue(newVal)
                }
            } else if (V.attr_type === 'AttrDate') {
                let date = this.store.parseDateString(newVal)
                if (date) {
                    newVal = wjcCore.Globalize.formatDate(date, 'yyyy-MM-dd') // input.value.toISOString()
                } else {
                    newVal = null
                }
            } else if (V.attr_type === 'AttrTime') {
                if (typeof newVal === 'string') {
                    // IE 2026 09 10 / ODOO-5800 (заказ Игоря): DOS в секундах — параметры ввода (format 'm', input_unit 'd')
                    // берём у самого поля: в форме записи колонка Value — AttrMulti, тип/формат приходят из описания
                    // поля (V), у колонки их нет — «30» в minDOS уходило бы 30 секундами
                    newVal = this.store.parseTime(newVal, this.durationAttr_merge(attr_col, V))
                    // newVal = +newVal.replaceAll(' ', '').replace(',', '.').trim() || 0 // Math.max(0,+newVal)
                }
            } else if (V.attr_type === 'AttrDays') {
                if (typeof newVal === 'string') {
                    newVal = this.store.parseDays(newVal, attr_col)
                }
            } else if (V.attr_type === 'AttrJSON') {
                if (typeof newVal === 'string') {
                    try { newVal = this.store.JS_parse(newVal) } catch(e) { e.cancel = true; return }
                }
            } else if (V.attr_type === 'AttrCSS') {
                if (typeof newVal === 'string') {
                    const _cssDict = newVal.split('\n').reduce((acc, line) => {
                        const colonIdx = line.indexOf(':')
                        if (colonIdx > 0) {
                            const prop = line.slice(0, colonIdx).trim()
                            const val = line.slice(colonIdx + 1).trim().replace(/;$/, '')
                            if (prop && val) acc[prop] = val
                        }
                        return acc
                    }, {})
                    // IE 2026 09 04 / ODOO-336283: поле, хранящее CSS СТРОКОЙ (Style строки лэйаута), остаётся строкой —
                    // тип берём по текущему значению поля; словарные поля (колонки грида) — словарь как раньше
                    // пустое значение — строка только у строки формы (AttrTabGrid); колонка грида полей остаётся словарём
                    const _wasString = typeof V.value === 'string' || ((V.value == null || V.value === '') && this.attr?.attr_type === 'AttrTabGrid')
                    newVal = _wasString ? this.store.CSS_toLine(_cssDict) : _cssDict
                }
            } else if (V.attr_type === 'AttrLink') {
                this.AttrLink_oldVal = oldVal

                if (attr_col.attr_type === 'AttrMulti') {
                    this.store.reset_valueStr_translations(V) // i18n: значение меняется — переводы valueStr не актуальны
                    if (newVal === '') {
                        V.value = ''
                        V.valueStr = newVal = ''
                        delete V.is_customValueWarning
                    } else {
                        let parentsList = this.get_parentsList(irow, attr_col)
                        if (this.store.is_eval(newVal)) {
                            V.value = newVal
                            V.valueStr = newVal
                            delete V.is_customValueWarning
                        } else {
                            let valueMulti = this.store.get_valueMulti_byStr(this, newVal, V, attr_col, oldVal, parentsList)
                            // IE 2026 10 29 / ODOO-5800 (ie-dm7 #116081, дефект Igor: процесна модель — id, не назва): ссылка на сегмент (форма AttrTabGrid: колонка значений с customValueWarning) — несопоставленный текст
                            // НЕ становится значением (прежде «if (!V.value) V.value = newVal»: пустое поле получало название); id — только однозначный пункт
                            // словаря или ответа name_search; иначе прежнее значение записи + предупреждение. Выключатель fe.data.linkTextToId
                            const _ltiRef = valueMulti === null && linkIsRef(V) && !linkIsFormula(newVal) && linkTextToId_on(this.store)   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #116081, дефект Igor: процесна модель — id, не назва)
                            if (_ltiRef) {   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #116081, дефект Igor: процесна модель — id, не назва)
                                this.linkText_commit(V, newVal, irow, dataItem, col_binding, oldVal)   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #116081, дефект Igor: процесна модель — id, не назва)
                            } else if (valueMulti === null && !(this.store.itemsSource[V.relation_segment]?.data || []).length) { // customValue 2025 01 12
                                if (!V.value) V.value = newVal
                                V.valueStr = newVal
                            } else if (valueMulti === null && attr_col.customValueWarning) {
                                if (!V.value) V.value = newVal
                                V.valueStr = newVal
                                V.is_customValueWarning = !!newVal
                            } else if (valueMulti === null) {
                                V.valueStr = newVal
                                V.is_customValueWarning = !!newVal
                                const _seg = V.relation_segment || attr_col.relation_segment
                                if (_seg && this.store.itemsSource[_seg]?.fetchMode === 'by_ids') {
                                    const _irow = irow, _dataItem = dataItem, _binding = col_binding, _oldVal = oldVal, _newVal = newVal, _V = V
                                    this.store.async_name_search(this, _seg, _newVal, (newItems) => {
                                        const resolved = newItems.find(i => i.title === _newVal || i.code === _newVal || String(i.id) === String(_newVal) || (Array.isArray(i.titles_alt) && i.titles_alt.includes(_newVal)))   // IE 2026 09 25 / ODOO-341407: и название на другом языке
                                        if (resolved) {
                                            _V.value = resolved.id
                                            _V.valueStr = resolved.title
                                            delete _V.is_customValueWarning
                                            this.set_value(_irow, _dataItem, _binding, _oldVal, resolved.id, true, null)
                                        }
                                    })
                                }
                            } else {
                                V.value = valueMulti.value
                                V.valueStr = newVal = valueMulti.valueStr
                                delete V.is_customValueWarning
                            }
                        }
                    }
                    newVal = V.value
                    newValStr = V.valueStr
                } else if (newVal) { // V.relation_segment && parent_method === 'pastingCell' &&
                        let valueMulti = this.store.get_valueMulti_byStr(this, newVal, attr_col, attr_col, oldVal)
                        if (valueMulti !== null) {
                            newVal = valueMulti.value
                        } else {
                            const _seg = attr_col.relation_segment
                            if (_seg && this.store.itemsSource[_seg]?.fetchMode === 'by_ids') {
                                const _irow = irow, _dataItem = dataItem, _binding = col_binding, _oldVal = oldVal, _newVal = newVal
                                this.store.async_name_search(this, _seg, _newVal, (newItems) => {
                                    const resolved = newItems.find(i => i.title === _newVal || i.code === _newVal || String(i.id) === String(_newVal) || (Array.isArray(i.titles_alt) && i.titles_alt.includes(_newVal)))   // IE 2026 09 25 / ODOO-341407: и название на другом языке
                                    if (resolved) {
                                        this.set_value(_irow, _dataItem, _binding, _oldVal, resolved.id, true, null)
                                    }
                                })
                            }
                        }
                }
            }
            this.newVal = newVal

            e.cancel = true    // is bad for pasting in new row, else if rem >> bad for convert value from '25,0%' to .25

            // refresh prepered value
            if (V.attr_type!='AttrBool' && parent_method !== 'choiceFinish') {
                if (attr_col.attr_type === 'AttrMulti') {
                    if (newValStr === null) {
                        newValStr = newVal
                    }
                    if (parent_method === 'pastingCell') {
                        if (e.data !== newValStr) {
                            e.data = newValStr
                        }
                    } if (parent_method === 'cellEditEnding' && this.flex.activeEditor) {
                        if (this.flex.activeEditor.value !== newValStr) {
                            this.flex.activeEditor.value = newValStr
                        }
                    }
                } else if (attr_col.attr_type === 'AttrLink') {
                    if (this.flex.activeEditor) {
                        this.flex.activeEditor.value = newVal
                    } else { // on paste
                        // this.flex.setCellData(e.row, e.col, newVal)
                        e.cancel = true
                    }
                }
            }

            // check
            if (attr_col.attr_type !== 'AttrMulti' && ['AttrBool'].includes(V.attr_type)) {
                e.cancel = false
                return
            }
            // IE 2026 09 25 / ODOO-5800 (D1/D3, разбор ie-fado7: ввод «8» в ячейку, где 0 пользователя + 8 оценки автоплана, уходил дельтой
            // −9492 против оценки): в ячейке (или её листьях) лежит оценка автоплана превью — введённое число относится к РЕАЛЬНЫМ документам:
            // оценка снимается (значение и леджер), исходное значение правки — без неё. Выключатель fe.sim.virtualMark
            if (V.attr_type === 'AttrNumber' && this._simVirtual?.size && this.sim_flag('virtualMark')) {
                const _stripped = this.sim_stripVirtual(dataItem, attr_col?.binding0 || col_binding, col_binding)
                if (_stripped !== null) oldVal = _stripped
            }
            if (oldVal === newVal && isNull === null) {
                return
            } else if (irow < this.headerRows || e.col < this.headerColumns) {
                return
            } else if (V.attr_type === 'AttrNumber') {
                if (isNaN(newVal)) {
                    return
                }
            }

            // агрегатная ячейка (строка-группа / свёрнутый период): число
            // раскладывается по детальным ячейкам, они и уходят на бэк
            if (V.attr_type === 'AttrNumber'
                    && this.decomp_cellEdit(irow, dataItem, attr_col, col_binding, newVal)) {
                this.actionStack++
                return
            }

            this.set_value(irow, dataItem, col_binding, oldVal, newVal, true, isNull)

            // ИЕ 2026 08 13: обратная сторона декомпозиции — правка детальной
            // ячейки на лету пересчитывает итоги строк-групп той же колонки
            if (V.attr_type === 'AttrNumber'
                    && this.store.get_value(this.WIDGET?.record, 'doc.params.decompose_cell_edit')) {
                if (this._pasteBatch) { // IE 2026 09 04 / ODOO-336379: в батче вставки — подбивка итогов один раз (pasteBatch_end)
                    const _m = (this._pasteBatchDecomp = this._pasteBatchDecomp || new Map())
                    if (!_m.has(dataItem)) _m.set(dataItem, new Set())
                    _m.get(dataItem).add(attr_col?.binding0 || col_binding)
                } else {
                this.decomp_syncAncestors(dataItem, [attr_col?.binding0 || col_binding])
                this._foldAggCache = null
                this._rowStyleStats = null // АН 2026 08 15 / ODOO-4997
                this.flexRefresh()
                }
            }

            // онлайн-превью баланса: смещение строки остатков после правки
            if (V.attr_type === 'AttrNumber') {
                // binding0 — исходный датный биндинг колонки (raw_binding — имя
                // поля без даты, 'quantity' — по нему дату правки не взять)
                this.balancePreview_afterEdit(dataItem,
                    [attr_col?.binding0 || col_binding], oldVal, newVal)
            }

            // IE 2026 08 18: вспышка обычной правки (и её косвенных итогов)
            this.flash_start(this.flash_ofAction(this.actionStack))

            this.actionStack++
        },
        cellEditEnded2(e) {
            if (!this.store.hide_console) console.log('cellEditEnded2')
            let newVal = this.flex.getCellData(e.row, e.col), // this.flex.activeEditor.value
            col = this.flex.columns[e.col],
            attr_col = this.attr_by_binding[col.binding],
            irow = e.row, // this.flex.collectionView.currentPosition, 
            // dataItem = this.flex.rows[irow].dataItem, // this.flex.collectionView.items[irow], 
            col_binding = col.binding

            let dataItem = {}
            if (this.flex.rows[irow]) {
                dataItem = this.flex.rows[irow].dataItem // this.flex.collectionView.items[irow], 
            }


            let V = attr_col
            if (attr_col.attr_type === 'AttrMulti') {
                return // 2024 12 08
            }

            if (!['AttrBool'].includes(V.attr_type)) {
                return
            }
            
            if (!newVal) {
                newVal = this.newVal
            }

            if (V.attr_type === 'AttrBool') {
                newVal = this.store.isTrue(newVal)
            }

            // check
            if (this.AttrLink_oldVal === newVal) {
                return
            } else if (irow < this.headerRows || e.col < this.headerColumns) {
                return
            }

            if (!this.flex.rows[irow]) {
                this.store.set_value(dataItem, col_binding, newVal)
            }

            // AttrBool: apply to selected range like `use`, Alt = only clicked row
            const mouseEvt = this._lastMouseEvent
            const {topRow: r1, bottomRow: r2} = this.flex.selectedRanges[0] || {}
            const target_in_range = r1 != null && r1 <= irow && irow <= r2
            if (target_in_range && r1 !== r2) {
                if (mouseEvt?.altKey) {
                    // Alt: set only clicked, clear others in range
                    for (let r0 = r1; r0 <= r2; r0++) {
                        const row = this.flex.rows[r0]
                        if (!row?.dataItem) continue
                        if (row.dataItem._fe?.visible === false) continue
                        const targetVal = r0 === irow ? newVal : false
                        // для кликнутой ячейки редактор уже записал значение — старое берём ДО правки
                        const oldV = r0 === irow
                            ? this.store.isTrue(this.AttrLink_oldVal)
                            : this.store.isTrue(this.store.get_value(row.dataItem, col_binding))
                        if (oldV !== targetVal) {
                            // через set_value — правка попадает в undo-стек одной группой
                            this.set_value(r0, row.dataItem, col_binding, oldV, targetVal)
                        }
                    }
                } else {
                    // пробел/клик по мультивыделению булевых — инвертируем ВСЕ, отталкиваясь
                    // от значения верхней левой ячейки выделения (её значение ДО правки):
                    // если правилась она сама — берём старое значение, иначе текущее
                    const tlDataItem = this.flex.rows[r1]?.dataItem
                    const tlPre = (r1 === irow)
                        ? this.store.isTrue(this.AttrLink_oldVal)
                        : this.store.isTrue(this.store.get_value(tlDataItem, col_binding))
                    const rangeVal = !tlPre
                    for (let r0 = r1; r0 <= r2; r0++) {
                        const row = this.flex.rows[r0]
                        if (!row?.dataItem) continue
                        if (row.dataItem._fe?.visible === false) continue
                        // для кликнутой ячейки редактор уже записал значение — старое берём ДО правки
                        const oldV = r0 === irow
                            ? this.store.isTrue(this.AttrLink_oldVal)
                            : this.store.isTrue(this.store.get_value(row.dataItem, col_binding))
                        if (oldV !== rangeVal) {
                            // через set_value — правка попадает в undo-стек одной группой
                            this.set_value(r0, row.dataItem, col_binding, oldV, rangeVal)
                        }
                    }
                }
                this.flexRefresh()
            } else {
                this.set_value(irow, dataItem, col_binding, this.AttrLink_oldVal, newVal)
            }
            this.actionStack++

            if (this.itemsSourcesView_grid() && col_binding === 'use') {
                // §6.3: чекбокс use таблицы-реестра управляет строками целевого грида
                const items = []
                if (target_in_range && r1 !== r2) {
                    for (let r0 = r1; r0 <= r2; r0++) {
                        const row = this.flex.rows[r0]
                        if (row?.dataItem && row.dataItem._fe?.visible !== false) items.push(row.dataItem)
                    }
                } else {
                    items.push(dataItem)
                }
                this.itemsSourcesView_use_apply(items)
            }
        },
        clearSelectedCellsFallback() {
            // очистка выделенных ячеек по Delete/Backspace для типов, которые wijmo
            // не чистит сам (AttrCSS/AttrJSON — beginningEdit отменён; AttrBool — пустое
            // форматированное значение). Идёт через set_value → undo-стек + _cells.
            const flex = this.flex
            if (!flex?.selectedRanges?.length) return false
            const SPECIAL = new Set(['AttrCSS', 'AttrJSON', 'AttrBool'])
            const headerRows = this.headerRows || 0, headerCols = this.headerColumns || 0
            let any = false
            for (const rng of flex.selectedRanges) {
                if (!rng?.isValid) continue
                for (let r = Math.max(rng.topRow, headerRows); r >= 0 && r <= rng.bottomRow; r++) {
                    const row = flex.rows[r]
                    if (!row?.dataItem) continue
                    if (row.dataItem._fe?.visible === false) continue
                    // строка выделена целиком — её wijmo удалит сам (_deleteSel),
                    // очищать ячейки не нужно (иначе двойное действие)
                    if (row.isSelected) continue
                    for (let c = Math.max(rng.leftCol, headerCols); c <= rng.rightCol; c++) {
                        const col = flex.columns[c]
                        const attr_col = this.attr_by_binding[col?.binding]
                        if (!attr_col) continue
                        if (col.isReadOnly || attr_col.isReadOnly) continue
                        if (!this.is_editable({ row: r, col: c })) { this.readOnly_reject(r, c, 'clearCells'); continue } // IE 2026 09 04 / ODOO-335315
                        const oldVal = this.store.get_value(row.dataItem, col.binding)
                        // ИЕ 2026 08 13: числовые ячейки данных wijmo здесь тоже НЕ чистит
                        // (Игорь: Delete на ячейке отчёта не делал ничего). Delete = ввод 0:
                        // группа раскладывается decompose'ом, деталь — тем же set_value,
                        // что и обычный ввод (undo/_cells/подсветка штатные).
                        let V = attr_col
                        if (attr_col.attr_type === 'AttrMulti') V = this.store.check_AttrMulti(attr_col, row.dataItem)
                        if (V?.attr_type === 'AttrNumber' && !SPECIAL.has(attr_col.attr_type)) {
                            if (oldVal == null || oldVal === '' || +oldVal === 0) continue
                            if (!this.decomp_cellEdit(r, row.dataItem, attr_col, col.binding, 0)) {
                                this.set_value(r, row.dataItem, col.binding, oldVal, 0)
                                // ИЕ 2026 08 13: как при вводе 0 — итоги предков на лету
                                if (this.store.get_value(this.WIDGET?.record, 'doc.params.decompose_cell_edit')) {
                                    this.decomp_syncAncestors(row.dataItem, [attr_col?.binding0 || col.binding])
                                }
                            }
                            any = true
                            continue
                        }
                        if (!SPECIAL.has(attr_col.attr_type)) continue
                        const isBool = attr_col.attr_type === 'AttrBool'
                        // уже пусто — пропускаем (лишняя запись в undo не нужна)
                        if (isBool ? !this.store.isTrue(oldVal) : (oldVal == null || oldVal === '')) continue
                        this.set_value(r, row.dataItem, col.binding, oldVal, isBool ? false : null)
                        any = true
                    }
                }
            }
            if (any) {
                this._foldAggCache = null
                this._rowStyleStats = null // АН 2026 08 15 / ODOO-4997
                this.actionStack++
                // перерисовка после синхронного прохода wijmo (иначе рассинхрон индексов)
                window.$cg.setTimeout(this, 'AttrGrid.clearSelectedCellsFallback', () => this.flexRefresh(), 0)
            }
            return any
        },
        // ---------- задача 14 ч.1: счётчик найденных ячеек + навигация по совпадениям ----------
        gridSearchNav_schedule() {
            clearTimeout(this._gridNav_t)
            // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска): при живом поиске длительность обхода (счётчик / ‹ ›) — в window.gridLiveSearchStat.navMs / navMax
            this._gridNav_t = window.$cg.setTimeout(this, 'AttrGrid.gridSearchNav', () => {
                const _lt0 = this.liveChip?.title ? performance.now() : 0   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска)
                this.gridSearchNav_recompute()
                const _st = _lt0 && window.gridLiveSearchStat   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска)
                if (_st) { _st.navMs = performance.now() - _lt0; if (!(_st.navMax >= _st.navMs)) _st.navMax = _st.navMs }   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска)
            }, 150)
        },
        gridSearchNav_recompute() {
            const flex = this.flex
            if (!flex?.hostElement) return
            this.metricNav_recompute()   // IE 2026 09 18 / ODOO-5800 (заказ Игоря «чипс-метрик»): счётчик и остановки чипса метрик — свой список
            this.formatNav_recompute()   // IE 2026 09 20 / ODOO-5800 (Igor: колонка Selector и статистика грида Conditional format, чипс условного оформления CHIP-Format)
            this.gridSearchHeaders_sync()   // IE 2026 10 24 / ODOO-348692 (заказ Игоря: подсветка шапки не снималась после снятия чипса поиска)
            const searchChips = this.CHIPS_view.filter(c => c.segment === 'CHIP-Search' && c.meta?.use !== false)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска)
            if (!searchChips.length && this._gridNavRowCur != null) this.gridSearchRowNum_setCur(null)   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки): чипсов нет — рамку с номера строки снять
            if (!searchChips.length) { this._gridNav = null; if (this._gridNavHeadCur) this.gridSearchHeaders_setCur(null); return }   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок): чипсов нет — рамку с ячейки шапки снять
            // IE 2026 09 12 / ODOO-… (заказ Игоря): режим опечаток (_fuzzy) привязан к тексту чипса — текст изменили, режим снимаем
            // (перефильтровка — ниже, по обычному пути); текстовый термин — набор частей через пробел
            let _fzReset = false
            for (const chip of searchChips) {
                if (chip._fuzzy && chip._fuzzyFor !== String(chip.title || '').trim()) { delete chip._fuzzy; delete chip._fuzzyFor; _fzReset = true }
                // IE 2026 09 25 / ODOO-… (замечание Игоря: поиск в таблице по названиям на других языках): режим «на другом языке» привязан к тексту чипса и месту Table — текст сменили / чипс стал входным → снимаем
                if (chip._alt && (chip._altFor !== String(chip.title || '').trim() || (this.chipPlace_on() && chipPlace_isInput(chip)))) { delete chip._alt; delete chip._altFor; _fzReset = true }
                // IE 2026 10 02 / ODOO-345043 (заказ Игоря: поиск — лишний символ в запросе): отметка последней ступени привязана к тексту чипса — текст сменили, отметку снимаем (на отбор не влияет)
                if (chip._extra && chip._extraFor !== String(chip.title || '').trim()) { delete chip._extra; delete chip._extraFor; delete chip._extraFrom }
            }
            if (_fzReset) { this.apply_CHIPS(null, {}); this.$refs.chips?.$forceUpdate(); this.gridSearchNav_schedule(); return }
            // '='-выражения позиционно не ищем (eval), только текстовые термины
            const terms = []
            let styleKeys = []   // IE 2026 09 18 / ODOO-…: чипс отбора по стилям — переходы по ячейкам с этими стилями
            for (const [_ci, c] of searchChips.entries()) {   // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс): номер чипса — в каждой части
                const t0 = String(c.title || '').trim()
                if (t0.startsWith('style:')) { styleKeys = this.styleFilter_parse(t0); continue }
                if (!t0 || t0.startsWith('=')) continue
                // IE 2026 09 21 / ODOO-… (замечание Игоря: фраза поиска целиком главнее частей): чипс в режиме фразы — одна «часть» = фраза
                const _ph = this.searchPhrase_active(c, t0)
                if (_ph) { terms.push({ t: _ph.text, phrase: _ph, tier: 0, ci: _ci }); continue }   // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс)
                for (const p of searchTerms(t0)) terms.push({ t: p, tier: c._fuzzy || 0, ci: _ci })   // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс)
            }
            const list = []
            let owners = null, _chipIdx = [], _termsBy = {}   // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс): owners[i] — чипсы, которым принадлежит list[i] (только когда частей запроса у двух и более чипсов)
            if (styleKeys.length && !terms.length) {
                const MAXS = this.store.setting('fe.grid.searchNavMaxRows', 500)
                outerS:
                for (let r = 0; r < flex.rows.length; r++) {
                    const row = flex.rows[r], dataItem = row.dataItem
                    if (!dataItem || row.visible === false) continue
                    const rk = this.styleKeys_row(dataItem)
                    if (styleKeys.some(k => rk.all.includes(k))) { list.push({ r, c: 0 }); if (list.length >= MAXS) break; continue }   // стиль всей строки — одна остановка
                    for (let c = 0; c < flex.columns.length; c++) {
                        const col = flex.columns[c], attr_col = col.binding ? this.attr_by_binding[col.binding] : null
                        if (!attr_col || !col.isVisible) continue
                        const own = this.styleKeys_cellOwn(dataItem, col.binding, attr_col)
                        let hit = styleKeys.some(k => own.includes(k))
                        if (!hit && rk.vo.length && this.cf_isDataCol(attr_col)) { const v = this.store.get_value(dataItem, col.binding); hit = !(v == null || v === '') && styleKeys.some(k => rk.vo.includes(k)) }
                        if (hit) { list.push({ r, c }); if (list.length >= MAXS) break outerS }
                    }
                }
            }
            if (terms.length) {
                const MAX = this.store.setting('fe.grid.searchNavMaxRows', 500) // ограничение стоимости на больших отчётах; IE 2026 09 05 / ODOO-336330
                for (const t of terms) (_termsBy[t.ci] = _termsBy[t.ci] || []).push(t)   // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс)
                _chipIdx = Object.keys(_termsBy).map(Number)   // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс)
                if (_chipIdx.length > 1) owners = []   // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс)
                const _rowNumOn = this.gridSearchRowNum_on()   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
                let _rnC0 = 0   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки): первая видимая колонка — в неё встаёт выбор на остановке по номеру строки
                if (_rowNumOn) for (let c = 0; c < flex.columns.length; c++) if (flex.columns[c].isVisible) { _rnC0 = c; break }   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
                const _altCols = this.searchAlt_navCols(searchChips)   // IE 2026 09 25 / ODOO-… (замечание Игоря: поиск в таблице по названиям на других языках): колонки-ссылки (только в режиме «на другом языке»)
                // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок): сначала остановки в ШАПКЕ (ряд за рядом сверху вниз, слева направо), затем данные; тот же лимит
                if (this.gridSearchHeaders_on()) {   // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс)
                    const _hc = this.gridSearch_headerCells()   // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс)
                    const _hk = owners ? _chipIdx.map(ci => new Set(headerNav_stops(_hc, _termsBy[ci], MAX).map(h => h.r + ':' + h.c))) : null   // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс)
                    for (const _h of headerNav_stops(_hc, terms, MAX)) { list.push(_h); if (owners) owners.push(_chipIdx.filter((ci, k) => _hk[k].has(_h.r + ':' + _h.c))) }   // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс)
                }   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
                outer:
                for (let r = 0; r < flex.rows.length; r++) {
                    const row = flex.rows[r]
                    if (!row.dataItem) continue
                    if (row.visible === false) continue // скрытые строки не считаем
                    if (_rowNumOn) {   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки): остановка по номеру строки — перед остановками её ячеек
                        const _nt = rowNum_text(r, this.attr.rowIndexOffset)   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
                        if (rowNum_hitTerms(_nt, terms)) {   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
                            list.push({ r, c: _rnC0, rowHead: true })   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
                            if (owners) owners.push(_chipIdx.filter(ci => rowNum_hitTerms(_nt, _termsBy[ci])))   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
                            if (list.length >= MAX) break outer   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
                        }   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
                    }   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
                    for (let c = 0; c < flex.columns.length; c++) {
                        if (!flex.columns[c].isVisible) continue   // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс): скрытая колонка остановок не даёт (в DOM её ячеек нет)
                        let txt = ''
                        try { txt = String(flex.getCellData(r, c, true) ?? '').toLowerCase() } catch (e) { continue }
                        const _hit = this.gridSearchNav_cellHit(terms, row, c, txt, _altCols)   // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс): три пути попадания (текст ячейки, показанное название `<binding>-title`, название на другом языке) — одним методом, им же считаются части каждого чипса
                        //   // IE 2026 10 04 / ODOO-5800 (fe-71): ячейка показывает `<binding>-title` — счётчик / ‹ › и по показанному тексту
                        // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс): путь «название на другом языке» — в gridSearchNav_cellHit   // IE 2026 09 25 / ODOO-… (замечание Игоря: поиск в таблице по названиям на других языках): ячейка-ссылка, найденная по названию на другом языке
                        if (_hit) {
                            list.push({ r, c })
                            if (owners) owners.push(_chipIdx.filter(ci => this.gridSearchNav_cellHit(_termsBy[ci], row, c, txt, _altCols)))   // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс)
                            if (list.length >= MAX) break outer
                        }
                    }
                }
            }
            // IE 2026 09 21 / ODOO-… (замечание Игоря: фраза поиска целиком главнее частей): режим фразы не дал ни одной ячейки (фраза есть только в строках,
            // спрятанных другими отборами) — обратно к поиску по частям; решение держится, пока не сменится текст или данные
            if (!list.length && terms.some(t => t.phrase)) {
                let _flipped = false
                for (const chip of searchChips) { const raw = chip._raw || chip; if (raw._phrase === true) { raw._phrase = false; _flipped = true } }
                if (_flipped) { this.apply_CHIPS(null, {}); try { flex.invalidate() } catch (e) { /* грид разрушен */ } this.$refs.chips?.$forceUpdate(); this.gridSearchNav_schedule(); return }
            }
            // IE 2026 09 10 / ODOO-… (заказ Игоря): ни одного совпадения — текст, возможно, набран не в той раскладке:
            // пробуем кандидаты (EN↔RU, RU↔UK, смешанные) по ВСЕМ строкам; нашли — меняем текст самого чипса и
            // перефильтровываем (результат показывается уже для сконвертированного текста). Один раз на текст
            if (!list.length && terms.length) {
                for (const chip of searchChips) {
                    const t0 = String(chip.title || '').trim()
                    if (!t0 || t0.startsWith('=') || t0.startsWith('style:') || chip._layoutConvFrom === t0 || chip._live) continue   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска): живой текст не переписывается, пока набирается
                    if (this.chipPlace_on() && chipPlace_isInput(chip)) continue   // IE 2026 09 19 / ODOO-5800 (пункт 3 Игоря: чипсы таблицы на входе выборки): текст входного чипса фронт сам не переписывает (это новый запрос к бэку)
                    const cand = layoutCandidates(t0).find(c => this.gridSearch_hasTerms(searchTerms(c)))   // IE 2026 09 12 / ODOO-…: все части в одной строке
                    if (cand) {
                        chip._layoutConvFrom = t0
                        chip.title = cand
                        if (chip.meta?.titleHTML) delete chip.meta.titleHTML
                        this.apply_CHIPS(null, {})
                        this.$refs.chips?.$forceUpdate()
                        this.gridSearchNav_schedule()
                        return
                    }
                }
                // IE 2026 09 12 / ODOO-… (заказ Игоря): и в другой раскладке ничего — «интеллектуальный» поиск: допускаем опечатки в одной-двух
                // буквах (fuzzyK по длине части; числа и короткие части — без допуска). Все части находятся приближённо хоть
                // в каких-то строках — включаем режим опечаток чипса (_fuzzy) и перефильтровываем; совпадения подсвечиваются
                // особо (wj-state-match-fuzzy), на чипсе — знак ≈
                for (const chip of searchChips) {
                    const t0 = String(chip.title || '').trim()
                    if (!t0 || t0.startsWith('=') || t0.startsWith('style:') || chip._fuzzy || chip._live) continue   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска): живой текст — без ступеней (их получит чипс по Enter)
                    if (this.chipPlace_on() && chipPlace_isInput(chip)) continue   // IE 2026 09 19 / ODOO-5800 (пункт 3 Игоря: чипсы таблицы на входе выборки): отбор входного чипса сделал бэк — ступени опечаток по загруженным строкам не включаем
                    const parts = searchTerms(t0)
                    const maxTier = Math.max(0, ...parts.map(fuzzyMaxTier))
                    if (!maxTier) continue
                    // IE 2026 09 12 / ODOO-… (уточнение Игоря): по ступеням — 1) одна гласная, 2) одна любая буква, 3) две буквы; есть результат
                    // на ступени — дальше не усложняем. На каждой ступени: как набрано, затем кандидаты другой раскладки
                    let fzTitle = '', fzTier = 0
                    for (let tier = 1; tier <= Math.min(maxTier, FUZZY_TIERS) && !fzTitle; tier++) {
                        if (this.gridSearch_hasTerms(parts, tier)) { fzTitle = t0; fzTier = tier; break }
                        const cand = layoutCandidates(t0).find(c => this.gridSearch_hasTerms(searchTerms(c), tier))
                        if (cand) { fzTitle = cand; fzTier = tier }
                    }
                    if (fzTitle) {
                        if (fzTitle !== t0) {
                            chip._layoutConvFrom = t0
                            chip.title = fzTitle
                            if (chip.meta?.titleHTML) delete chip.meta.titleHTML
                        }
                        chip._fuzzy = fzTier
                        chip._fuzzyFor = fzTitle
                        this.apply_CHIPS(null, {})
                        this.$refs.chips?.$forceUpdate()
                        this.gridSearchNav_schedule()
                        return
                    }
                }
            }
            // IE 2026 09 25 / ODOO-… (замечание Игоря: поиск в таблице по названиям на других языках): ни одной строки на показанных названиях (и раскладка, и опечатки пусты) — та же лестница по названиям записей ссылочных ячеек
            // на ДРУГИХ языках (titles_alt словаря); нашлось — режим «на другом языке» чипса (_alt = язык, _altFor = текст; ступень опечаток / раскладка —
            // как у обычной лестницы) и перефильтровка. Один раз на текст; входные чипсы и служебные запросы — мимо (searchAlt_decide)
            if (!list.length && terms.length && this.searchAlt_on()) {
                for (const chip of searchChips) {
                    const dec = chip._live ? null : this.searchAlt_decide(chip)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска)
                    if (!dec) continue
                    const t0 = String(chip.title || '').trim()
                    if (dec.title !== t0) { chip._layoutConvFrom = t0; chip.title = dec.title; if (chip.meta?.titleHTML) delete chip.meta.titleHTML }
                    if (dec.tier) { chip._fuzzy = dec.tier; chip._fuzzyFor = dec.title } else { delete chip._fuzzy; delete chip._fuzzyFor }
                    chip._alt = dec.langs || 'other'
                    chip._altFor = dec.title
                    this._phraseMemo = null   // решение «есть ли фраза» — заново, уже с названиями на других языках
                    this.apply_CHIPS(null, {})
                    try { flex.invalidate() } catch (e) { /* грид разрушен */ }
                    this.$refs.chips?.$forceUpdate()
                    this.gridSearchNav_schedule()
                    return
                }
            }
            // IE 2026 10 02 / ODOO-345043 (заказ Игоря: поиск — лишний символ в запросе): ПОСЛЕДНЯЯ СТУПЕНЬ — ни показанные тексты (раскладка, опечатки), ни названия на других
            // языках не дали строк: в тексте чипса, возможно, лишний символ (utils/searchMatch.searchLadderExtra — части без букв и цифр и такие же знаки по краям
            // частей не учитываются; затем один лишний знак). Нашлось — текст чипса переписывается найденным (как при смене раскладки), на чипсе знак ≈ с подписью
            // шага (_extra = 7 | 8, _extraFor = текст, _extraFrom = что было набрано); ступень опечаток / режим «на другом языке» нового текста включит обычная
            // лестница следующим проходом
            if (!list.length && terms.length && this.searchExtra_on()) {
                for (const chip of searchChips) {
                    const dec = chip._live ? null : this.searchExtra_decide(chip)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска)
                    if (!dec) continue
                    chip._extraFrom = chip._layoutConvFrom = String(chip.title || '').trim()
                    chip.title = dec.title
                    if (chip.meta?.titleHTML) delete chip.meta.titleHTML
                    chip._extra = dec.step
                    chip._extraFor = dec.title
                    this.apply_CHIPS(null, {})
                    try { flex.invalidate() } catch (e) { /* грид разрушен */ }
                    this.$refs.chips?.$forceUpdate()
                    this.gridSearchNav_schedule()
                    return
                }
            }
            const idx = Math.min(this._gridNav?.index || 0, Math.max(0, list.length - 1))
            // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс): подсписки остановок по чипсам (Map чипс → номера в list); чипс без своих частей (=…, style:, пустой) ходит по всему списку
            let subs = null
            if (owners && _chipIdx.length > 1) { subs = new Map(); for (const [ci, a] of navSubs_build(owners, _chipIdx)) subs.set(searchChips[ci], a) }   // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс)
            if (this._gridNavRowCur != null) { const _m = list[idx]; if (!(_m && _m.rowHead && _m.r === this._gridNavRowCur)) this.gridSearchRowNum_setCur(null) }   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки): список сменился — рамку с чужого номера снять
            this._gridNav = { list, index: idx, subs }   // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс): + subs
            if (this._gridNavHeadCur) { const _m = list[idx]; if (!(_m && _m.head && _m.r === this._gridNavHeadCur.hr && _m.c === this._gridNavHeadCur.c)) this.gridSearchHeaders_setCur(null) }   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок): список сменился — рамку с чужой ячейки снять
            // multi-lane (полоса _laneN): чип ОБЩИЙ на все полосы — не перетираем matchCount
            // друг друга (бейдж моргал 0↔N), а суммируем вклады полос; навигация — у полосы 1
            const laneM = /_lane(\d+)$/.exec(this.attr?.html_id || '')
            for (const chip of searchChips) {
                if (laneM) {
                    const by = chip._laneMatch = chip._laneMatch || {}
                    by[laneM[0]] = list.length
                    chip.matchCount = Object.values(by).reduce((a, b) => a + b, 0)
                    if (laneM[1] === '1') chip.matchIndex = list.length ? idx : 0
                } else if (subs && subs.get(chip)) {   // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс): свой подсписок — счётчик и позиция по нему
                    const sub = subs.get(chip)
                    chip.matchCount = sub.length
                    chip.matchIndex = sub.length ? navPos_clamp(chip.matchIndex, sub.length) : 0
                } else {
                    chip.matchCount = list.length
                    chip.matchIndex = list.length ? idx : 0
                }
            }
            this.$refs.chips?.$forceUpdate()
        },
        // ---- IE 2026 09 21 / ODOO-… (замечание Игоря: фраза поиска целиком главнее частей) ----
        // Текст поиска из нескольких слов сначала ищется как ФРАЗА (utils/searchMatch.js: слова в заданном порядке, между ними пробелы). Фраза есть хоть в одной
        // строке данных — чипс работает в режиме фразы: отбор строк, подсветка и счётчик только по ней («LLC» в «Vaga-Farm LLC» не подсвечивается и не считается);
        // фразы нет — прежний поиск по частям. Решение кладётся на сам чипс (_phrase / _phraseFor — как _fuzzy), его читают подсветка (mainStore.
        // check_CHIPS_highlighted), счётчик и отбор; пересчитывается при смене текста или данных. Многополосные формы (_laneN) — без режима фразы: чипс общий на
        // полосы, решение одной полосы ломало бы другую. Выключатель fe.ux.searchPhraseFirst
        searchPhrase_decide(chip) {
            const raw = chip?._raw || chip
            if (!raw) return null
            const t0 = String(raw.title || '').trim()
            const ph = (!raw._fuzzy && !/_lane\d+$/.test(this.attr?.html_id || '') && this.store.setting('fe.ux.searchPhraseFirst', true) !== false) ? searchPhrase(t0) : null
            if (!ph) {
                if (raw._phrase !== undefined) delete raw._phrase
                if (raw._phraseFor !== undefined) delete raw._phraseFor
                return null
            }
            const src = this.flex?.itemsSource?.sourceCollection || this.flex?.itemsSource || null, n = this.flex?.rows?.length || 0
            const _alt = this.searchAlt_chipOn(raw)   // IE 2026 09 25 / ODOO-… (замечание Игоря: поиск в таблице по названиям на других языках): в режиме «на другом языке» фраза ищется и по названиям записей на других языках
            if (!this._phraseMemo) this._phraseMemo = new Map()
            const m = this._phraseMemo.get(t0)
            if (!(m && m.src === src && m.n === n && m.alt === _alt && raw._phraseFor === t0 && typeof raw._phrase === 'boolean')) {
                const on = this.gridSearch_phraseExists(ph, _alt)
                // решение сменилось (перечитали данные, фраза появилась / пропала) — подсветка ячеек живёт в отрисованных ячейках: перерисовать
                if (raw._phrase !== on) { const _was = raw._phrase; raw._phrase = on; if (typeof _was === 'boolean') { try { this.flex.invalidate() } catch (e) { /* грид ещё не готов */ } } }
                if (raw._phraseFor !== t0) raw._phraseFor = t0
                if (this._phraseMemo.size > 20) this._phraseMemo.clear()
                this._phraseMemo.set(t0, { src, n, alt: _alt })
            }
            return raw._phrase === true ? ph : null
        },
        searchPhrase_active(chip, t0) {
            const raw = chip?._raw || chip
            return (raw && raw._phrase === true && raw._phraseFor === t0) ? searchPhrase(t0) : null
        },
        // есть ли фраза хоть в одной строке ДАННЫХ — по тем же текстам, по которым отбирает apply_CHIPS (строка, valueStr, название из словаря; у чисел и дат
        // пробелов нет). Проход по ВСЕМ строкам с ранним выходом: значения читаются из сырой строки по разобранному пути (без действий стора — 10 тыс. строк
        // списка проходятся за десятки миллисекунд); строки, выключенные раскладкой / группой строк, и compare-строки не считаются.
        // ⚠ Замер (tools/probes/phrasebench_diag.mjs, список 10 444 × 59): разобранный путь колонки стор отдаёт РЕАКТИВНЫМ прокси — проход по нему стоил 477 мс
        // против 26 мс на сыром массиве, поэтому путь берётся через toRaw
        gridSearch_phraseExists(ph, alt = false) {   // IE 2026 09 25 / ODOO-… (замечание Игоря: поиск в таблице по названиям на других языках): alt — и по названиям записей на других языках (titles_alt)
            const flex = this.flex
            if (!flex?.hostElement || !ph) return false
            if (this.gridSearch_headPhrase(ph)) return true   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок): фраза в заголовке колонки — есть
            const t0 = performance.now()
            const grouped = !!flex.itemsSource?.groupDescriptions?.length
            const IS = toRaw(this.store.itemsSource) || {}
            const cols = []
            for (const binding in this.attr_by_binding) {
                const a = toRaw(this.attr_by_binding[binding])
                if (!a || !a.binding) continue
                const b = a.attr_type === 'AttrLinkOdoo' ? a.binding + '[1]' : a.binding
                cols.push({ b, path: toRaw(this.store._parse_binding(b)), multi: a.attr_type === 'AttrMulti', rel: (typeof a.relation_segment === 'string' && a.relation_segment) ? a.relation_segment : '' })
            }
            let found = false, seen = 0
            outer:
            for (let r = 0; r < flex.rows.length; r++) {
                const row = flex.rows[r], dataItem = row.dataItem
                if (!dataItem || dataItem._variant) continue
                if (grouped && row.getCellRange) continue
                if (dataItem._DLRow?.hide || dataItem._ogHide) continue
                const raw = toRaw(dataItem)
                seen++
                for (let i = 0; i < cols.length; i++) {
                    const c = cols[i]
                    const v = rowEmpty_value(raw, c.b, c.path)
                    let text = ''
                    if (c.multi) text = (v && typeof v === 'object') ? String(v.valueStr ?? v.value ?? '') : ''
                    else if (c.rel) { const it = IS[c.rel]?.ids?.[v]; text = it ? String(it.title || it.id || '') : (typeof v === 'string' ? v : ''); if (alt && it && Array.isArray(it.titles_alt) && it.titles_alt.some(x => phraseTest(x, ph))) { found = true; break outer } }   // IE 2026 09 25 / ODOO-… (замечание Игоря: поиск в таблице по названиям на других языках): и названия на других языках
                    else if (typeof v === 'string') text = v
                    if (text && phraseTest(text, ph)) { found = true; break outer }
                    { const _st = shownTitle_of(raw, c.b); if (_st && this.shownTitle_on() && phraseTest(_st, ph)) { found = true; break outer } }   // IE 2026 10 04 / ODOO-5800 (fe-71): и показанный текст `<binding>-title`
                }
            }
            window._searchPhrase = { text: ph.text, found, rows: seen, ms: Math.round((performance.now() - t0) * 10) / 10, n: ((window._searchPhrase && window._searchPhrase.n) || 0) + 1 }
            return found
        },
        // IE 2026 09 10 / ODOO-…: найдётся ли термин хоть в одной строке ДАННЫХ — по тем же значениям, по которым
        // apply_CHIPS прячет строки (значения колонок: valueStr словаря, заголовок ссылки, строка), включая скрытые
        // сейчас строки (их спрятал сам чипс). Групповые строки не считаем — они всегда видимы и не фильтруются
        gridSearch_hasTerm(term, tier = 0) {   // IE 2026 09 12 / ODOO-…: tier — ступень опечаток (0 — точно)
            return this.gridSearch_hasTerms(term ? [String(term)] : [], tier)
        },
        // IE 2026 09 12 / ODOO-…: есть ли строка ДАННЫХ, в которой найдены ВСЕ части (каждая — хоть в какой-то ячейке строки; fuzzy —
        // приближённо, допуск fuzzyK). Именно так фильтрует apply_CHIPS (AND по строке), поэтому конвертация раскладки
        // и режим опечаток включаются только когда это даст хотя бы одну строку
        gridSearch_hasTerms(terms, tier = 0, alt = false) {   // IE 2026 09 25 / ODOO-… (замечание Игоря: поиск в таблице по названиям на других языках): alt — и по названиям записей на других языках (titles_alt)
            const flex = this.flex
            if (!flex?.hostElement || !terms?.length) return false
            { const _hh = this.gridSearch_headHit(terms, tier); if (_hh.size) { terms = headerExclude_terms(terms, _hh); if (!terms.length) return true } }   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок): части, найденные в заголовках колонок, — найдены для всех строк
            const _tier = tier === true ? FUZZY_TIERS : (tier | 0)
            const MAX = this.store.setting('fe.grid.searchNavMaxRows', 500) * 4
            const grouped = !!flex.itemsSource?.groupDescriptions?.length
            // IE 2026 09 12 / ODOO-…: строки, которые apply_CHIPS всё равно спрячет (скрытые раскладкой, пустые при включённом «глазе»,
            // выключенные use), не считаем — иначе заголовок объекта без чисел включал режим ≈ с нулём строк
            const _hide_empty = this._hide_empty(), _cols = _hide_empty ? this.columns() : null
            let seen = 0
            for (let r = 0; r < flex.rows.length; r++) {
                const row = flex.rows[r], dataItem = row.dataItem
                if (!dataItem || dataItem._variant) continue
                if (grouped && row.getCellRange) continue
                if (dataItem._DLRow?.hide || dataItem._ogHide) continue   // IE 2026 09 17: строки выключенной Option group
                if (_hide_empty && (this.isEmpty(dataItem, _cols) || this._use_off(dataItem))) continue
                if (++seen > MAX) break
                const texts = []
                for (const binding in this.attr_by_binding) {
                    const attr_col = this.attr_by_binding[binding]
                    let value = this.store.get_value(dataItem, attr_col.binding), text = ''
                    if (attr_col.attr_type === 'AttrMulti') text = value ? String(value.valueStr ?? value.value ?? '') : ''
                    else if (attr_col.relation_segment) {
                        const item0 = this.store.itemsSource[attr_col.relation_segment]?.ids?.[value]
                        text = item0 ? String(item0.title || item0.id || '') : (typeof value === 'string' ? value : '')
                        if (alt && item0) { const _lows = gridSearchAlt_lows(item0); if (_lows) texts.push(..._lows) }   // IE 2026 09 25 / ODOO-… (замечание Игоря: поиск в таблице по названиям на других языках): и названия на других языках
                    } else text = value == null ? '' : String(value)
                    if (text) texts.push(text.toLowerCase())
                    { const _st = shownTitle_of(dataItem, attr_col.binding).toLowerCase(); if (_st && _st !== text.toLowerCase() && this.shownTitle_on()) texts.push(_st) }   // IE 2026 10 04 / ODOO-5800 (fe-71): и показанный текст `<binding>-title` (сырое значение — как было)
                }
                if (texts.length && terms.every(t => texts.some(x => _tier ? !!fuzzyFindTier(x, t, _tier) : x.includes(t)))) return true
            }
            return false
        },
        // ---- IE 2026 10 02 / ODOO-345043 (заказ Игоря: поиск — лишний символ в запросе) ----
        // Последняя ступень поиска по таблице (gridSearchNav_recompute, после названий на других языках). Решение — по текстам строк ДАННЫХ, собранным один раз
        // (gridSearch_rowTexts — те же строки и тексты, что у gridSearch_hasTerms), общей функцией utils/searchMatch.searchLadderExtra; пусто на показанных
        // текстах — то же с названиями записей на других языках. Один раз на текст и данные (_extraMemo); входные чипсы, служебные запросы и многополосные формы
        // (чипс общий на полосы) — мимо. Выключатель fe.search.extraSymbolTier (дефолт вкл.). Замер последнего решения — window._searchExtra
        searchExtra_on() { return this.store.setting('fe.search.extraSymbolTier', true) !== false && !/_lane\d+$/.test(this.attr?.html_id || '') },
        // решение для чипса: null — ступень не идёт либо ничего; иначе { title — текст, по которому найдено, step — 7 | 8 }
        searchExtra_decide(chip) {
            const t0 = String(chip.title || '').trim()
            if (!t0 || t0.startsWith('=') || t0.startsWith('style:') || t0.startsWith('>> ') || chip._alt || chip._fuzzy || chip._extra) return null
            if (chip.meta?.use === false || (this.chipPlace_on() && chipPlace_isInput(chip))) return null
            const src = this.flex?.itemsSource?.sourceCollection || this.flex?.itemsSource || null, n = this.flex?.rows?.length || 0
            if (!this._extraMemo) this._extraMemo = new Map()
            const memo = this._extraMemo.get(t0)
            if (memo && memo.src === src && memo.n === n) return null   // по этим же данным уже искали — пусто
            const t1 = performance.now()
            const terms0 = searchTerms(t0)
            let dec = null, rowsN = 0
            for (const alt of (this.searchAlt_on() ? [false, true] : [false])) {
                const rows = this.gridSearch_rowTexts(alt)
                rowsN = rows.length
                if (rows.some(cells => rowMatchTerms(cells, terms0, 0))) break   // текст чипса в данных есть (строки прячет другой отбор) — менять его нечего
                const m = searchLadderExtra(rows, t0, { phrase: false })
                if (m) { dec = { title: m.conv, step: m.tier }; break }
            }
            window._searchExtra = { text: t0, found: !!dec, title: dec ? dec.title : '', step: dec ? dec.step : 0, rows: rowsN, ms: Math.round((performance.now() - t1) * 10) / 10, n: ((window._searchExtra && window._searchExtra.n) || 0) + 1 }
            if (!dec) { if (this._extraMemo.size > 20) this._extraMemo.clear(); this._extraMemo.set(t0, { src, n }) }
            return dec
        },
        // тексты строк ДАННЫХ в нижнем регистре — те же строки и тексты, по которым решает gridSearch_hasTerms (alt — и названия записей на других языках)
        gridSearch_rowTexts(alt = false) {
            const flex = this.flex, out = []
            if (!flex?.hostElement) return out
            const MAX = this.store.setting('fe.grid.searchNavMaxRows', 500) * 4
            const grouped = !!flex.itemsSource?.groupDescriptions?.length
            const _hide_empty = this._hide_empty(), _cols = _hide_empty ? this.columns() : null
            let seen = 0
            for (let r = 0; r < flex.rows.length; r++) {
                const row = flex.rows[r], dataItem = row.dataItem
                if (!dataItem || dataItem._variant) continue
                if (grouped && row.getCellRange) continue
                if (dataItem._DLRow?.hide || dataItem._ogHide) continue
                if (_hide_empty && (this.isEmpty(dataItem, _cols) || this._use_off(dataItem))) continue
                if (++seen > MAX) break
                const texts = []
                for (const binding in this.attr_by_binding) {
                    const attr_col = this.attr_by_binding[binding]
                    let value = this.store.get_value(dataItem, attr_col.binding), text = ''
                    if (attr_col.attr_type === 'AttrMulti') text = value ? String(value.valueStr ?? value.value ?? '') : ''
                    else if (attr_col.relation_segment) {
                        const item0 = this.store.itemsSource[attr_col.relation_segment]?.ids?.[value]
                        text = item0 ? String(item0.title || item0.id || '') : (typeof value === 'string' ? value : '')
                        if (alt && item0) { const _lows = gridSearchAlt_lows(item0); if (_lows) texts.push(..._lows) }
                    } else text = value == null ? '' : String(value)
                    if (text) texts.push(text.toLowerCase())
                    { const _st = shownTitle_of(dataItem, attr_col.binding).toLowerCase(); if (_st && _st !== text.toLowerCase() && this.shownTitle_on()) texts.push(_st) }   // IE 2026 10 04 / ODOO-5800 (fe-71): и показанный текст `<binding>-title` (сырое значение — как было)
                }
                if (texts.length) out.push(texts)
            }
            return out
        },
        // ---- IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок) ----
        // Чипс поиска таблицы ищет и в ЗАГОЛОВКАХ КОЛОНОК (все ряды шапки: группы «2025», месяцы, подписи мер, номера колонок): остановки ‹ › сначала по шапке
        // (ряд за рядом сверху вниз, слева направо), затем по данным; найденная часть подсвечена в ячейке шапки (formatItem → gridSearchHeaders_cellPaint), текущая
        // остановка шапки — класс wj-state-match-cur (ячейку шапки выбрать нельзя — только прокрутка колонки в вид, gridSearchHeaders_goto). Часть запроса / фраза,
        // найденная хоть в одном заголовке, считается найденной для ВСЕХ строк: apply_CHIPS её в AND по строке не включает (все части в шапке — строки не прячутся),
        // лестница (gridSearch_hasTerms / gridSearch_phraseExists) считает её найденной. Чистая логика — utils/gridSearchHeaders.js (юнит handoff-files/grid-search-headers-2026-10-23).
        // Выключатель fe.ux.gridSearchHeaders (дефолт вкл.; выкл — поведение как прежде)
        gridSearchHeaders_on() { return this.store.setting('fe.ux.gridSearchHeaders', true) !== false },   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
        // тексты ячеек шапки (нижний регистр, объединённые диапазоны один раз, без скрытых рядов / колонок / подписей) — кэш по числу колонок и видимых колонок, эпохе irefresh, рядам шапки
        gridSearch_headerCells() {   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            const flex = this.flex   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            if (!flex?.hostElement || !this.gridSearchHeaders_on()) return []   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            const hrows = flex.columnHeaders?.rows   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            if (!hrows?.length) return []   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            let nVis = 0   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            for (let c = 0; c < flex.columns.length; c++) if (flex.columns[c].isVisible) nVis++   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            const key = `${flex.columns.length}|${nVis}|${this.irefresh}|${hrows.length}|${this.columnNumberRow}|${this.stickyScrollStart}`   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            const memo = this._hdrCellsMemo   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            if (memo && memo.key === key) return memo.list   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            const blankMap = this.foldHdr_blankMap()   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            const list = headerCells_collect(flex, {   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
                columnNumberRow: this.columnNumberRow,   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
                stickyScrollStart: this.stickyScrollStart,   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
                blankLevels: (binding) => (blankMap && blankMap.get(binding)) || null,   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок): подписи дат, погашенные свёрткой (foldHdr_blankCell)
                hiddenTitle: (binding, raw) => { const a = this.attr_by_binding[binding]; return !!(a?.hideTitle && a?.raw_binding && raw === String(a.title || '').trim()) },   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок): Hide title меры
            })   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            this._hdrCellsMemo = { key, list }   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            return list   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
        },   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
        // части запроса (как в apply_CHIPS / gridSearch_hasTerms), найденные хоть в одном заголовке, — Set; tier — ступень опечаток
        gridSearch_headHit(terms, tier = 0) {   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            if (!this.gridSearchHeaders_on() || !terms?.length) return new Set()   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            return headerHit_terms(this.gridSearch_headerCells(), terms, tier === true ? FUZZY_TIERS : (tier | 0))   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
        },   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
        gridSearch_headPhrase(ph) { return !!ph && this.gridSearchHeaders_on() && headerHit_phrase(this.gridSearch_headerCells(), ph) },   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
        // подсветка найденного в ячейке шапки + класс текущей остановки (formatItem, ветка columnHeaders — шапка идёт полным путём, кэша className у неё нет)
        gridSearchHeaders_cellPaint(e_cell, hr, c) {   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            const flex = this.flex   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            if (!flex || !e_cell) return   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            const on = this.gridSearchHeaders_on()   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            // текущая остановка: объединённая ячейка (группа колонок) рисуется для каждой колонки диапазона тем же элементом — сверяем с левой верхней
            const cur = on ? this._gridNavHeadCur : null   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            let isCur = false   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            if (cur) {   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
                let rng = null   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
                try { rng = flex.getMergedRange(flex.columnHeaders, hr, c, false) } catch (e) { rng = null }   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
                isCur = cur.hr === (rng ? rng.topRow : hr) && cur.c === (rng ? rng.leftCol : c)   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            }   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            if (isCur !== e_cell.classList.contains('wj-state-match-cur')) wjcCore.toggleClass(e_cell, 'wj-state-match-cur', isCur)   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            // подсветка найденной части: только текстовый узел подписи (стрелка hierSort, глиф свёртки, иконки — не трогаем); повторный вызов — по своему span
            const span = e_cell.querySelector(':scope > .hdr-search-hl')   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            let node = null   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            if (!span) for (const n of e_cell.childNodes) if (n.nodeType === Node.TEXT_NODE && n.textContent.trim()) { node = n; break }   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            const raw = span ? span.textContent : (node ? node.textContent : '')   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            if (!raw) return   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            let html = ''   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            if (on && this.CHIPS_view.length) {   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска)
                const esc = raw.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
                html = this.store.check_CHIPS_highlighted(this.WIDGET, esc, this.CHIPS_view, true) || ''   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска)
            }   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            if (html) {   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
                if (span) { if (span.innerHTML !== html) span.innerHTML = html }   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
                else { const s = document.createElement('span'); s.className = 'hdr-search-hl'; s.innerHTML = html; node.replaceWith(s) }   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            } else if (span) span.replaceWith(document.createTextNode(raw))   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок): чипс снят — обратно текстовый узел
        },   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
        // IE 2026 10 24 / ODOO-348692 (заказ Игоря: подсветка шапки не снималась после снятия чипса поиска): подпись активных чипсов поиска сменилась — перерисовать грид (шапка рисуется formatItem; чипс, найденный только в шапке, строки не меняет — сама перерисовка не случится)
        gridSearchHeaders_sync() {   // IE 2026 10 24 / ODOO-348692 (заказ Игоря: подсветка шапки не снималась после снятия чипса поиска)
            const sig = headerSearch_sig(this.CHIPS_view, this.gridSearchHeaders_on() || this.gridSearchRowNum_on())   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки): перерисовка и при одном номере строки   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска)
            if (sig === (this._gridHeadSig || '')) return   // IE 2026 10 24 / ODOO-348692 (заказ Игоря: подсветка шапки не снималась после снятия чипса поиска)
            this._gridHeadSig = sig   // IE 2026 10 24 / ODOO-348692 (заказ Игоря: подсветка шапки не снималась после снятия чипса поиска)
            const flex = this.flex   // IE 2026 10 24 / ODOO-348692 (заказ Игоря: подсветка шапки не снималась после снятия чипса поиска)
            if (!flex?.hostElement) return   // IE 2026 10 24 / ODOO-348692 (заказ Игоря: подсветка шапки не снималась после снятия чипса поиска)
            try { flex.invalidate() } catch (e) { /* грид разрушен */ }   // IE 2026 10 24 / ODOO-348692 (заказ Игоря: подсветка шапки не снималась после снятия чипса поиска)
        },
        // текущая остановка шапки: null — снять (класс с ячеек панели шапки снимается сразу, formatItem далее держит состояние)
        gridSearchHeaders_setCur(cur) {   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            const prev = this._gridNavHeadCur   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            this._gridNavHeadCur = cur || null   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            const host = this.flex?.columnHeaders?.hostElement   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            if (host && (prev || cur)) for (const el of host.querySelectorAll('.wj-cell.wj-state-match-cur')) wjcCore.removeClass(el, 'wj-state-match-cur')   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            if (cur) this.gridSearchHeaders_curPaint()   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
        },   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
        gridSearchHeaders_curPaint() {   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            const cur = this._gridNavHeadCur, panel = this.flex?.columnHeaders   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            if (!cur || !panel) return   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            let el = null   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            try { el = panel.getCellElement(cur.hr, cur.c) } catch (e) { el = null }   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            if (el && !el.classList.contains('wj-state-match-cur')) wjcCore.addClass(el, 'wj-state-match-cur')   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
        },   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
        // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки): чипс поиска ищет и по НОМЕРУ СТРОКИ в заголовке строки (точное равенство полному номеру; «124» — строка 124, «1» не цепляет 10..199): строка не прячется
        // (apply_CHIPS), номер — остановка ‹ › (выбирается первая видимая ячейка строки), подсвечен в заголовке строки (formatItem) и обведён на текущей остановке.   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
        // Чистая логика — utils/gridSearchRowNum.js. Выключатель fe.ux.gridSearchRowNumbers (дефолт вкл.; выкл — поведение как прежде)   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
        gridSearchRowNum_on() { return this.store.setting('fe.ux.gridSearchRowNumbers', true) !== false && this.rowNumberColumn !== null },   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
        gridSearchRowNum_hit(num) {   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
            if (!this.CHIPS_view.length || !this.gridSearchRowNum_on()) return false   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска)
            return rowNum_chipTerms(this.CHIPS_view, (c, t0) => this.searchPhrase_active(c, t0)).has(String(num))   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска)
        },   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
        gridSearchRowNum_setCur(r) {   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки): текущая остановка по номеру строки (null — снять; класс с ячеек заголовков строк снимается сразу, formatItem далее держит состояние)
            this._gridNavRowCur = r == null ? null : r   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
            const host = this.flex?.rowHeaders?.hostElement   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
            if (host) for (const el of host.querySelectorAll('.wj-cell.wj-state-match-cur')) wjcCore.removeClass(el, 'wj-state-match-cur')   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
            if (r != null) { this.gridSearchRowNum_curPaint(); requestAnimationFrame(() => this.gridSearchRowNum_curPaint()) }   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки): ячейка после прокрутки рисуется через кадр
        },   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
        gridSearchRowNum_curPaint() {   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
            const r = this._gridNavRowCur, panel = this.flex?.rowHeaders   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
            if (r == null || !panel || this.rowNumberColumn === null) return   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
            let el = null   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
            try { el = panel.getCellElement(r, this.rowNumberColumn) } catch (e) { el = null }   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
            if (el && !el.classList.contains('wj-state-match-cur')) wjcCore.addClass(el, 'wj-state-match-cur')   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
        },   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
        // переход ‹ › на остановку шапки: колонку — в вид (scrollIntoView с отрицательной строкой прокручивает только по горизонтали), ячейку — рамкой
        gridSearchHeaders_goto(m) {   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            this.gridSearchHeaders_setCur({ hr: m.r, c: m.c })   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            try { this.flex.scrollIntoView(-1, m.c) } catch (e) { /* грид разрушен */ }   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            this.gridSearchHeaders_curPaint()   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            requestAnimationFrame(() => this.gridSearchHeaders_curPaint())   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок): ячейка после прокрутки рисуется через кадр
        },   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
        // ---- IE 2026 09 25 / ODOO-… (замечание Игоря: поиск в таблице по названиям на других языках) ----
        // Когда вся лестница на показанных текстах (фраза → части → раскладка → опечатки) не дала ни одной строки (gridSearchNav_recompute), грид проходит
        // ту же лестницу по titles_alt словарных элементов ссылочных ячеек (utils/gridSearchAlt.js); решение — на чипсе (_alt = язык совпавших названий
        // en | uk | ru | other, _altFor = текст), как _fuzzy / _phrase; его читают отбор (apply_CHIPS), фраза (searchPhrase_decide), счётчик / ‹ › (nav),
        // метка ячеек (formatItem → search-alt-hit), подсказка ячейки (cellTooltip_html) и значок / подпись чипса (AttrChips.chipAltOn). Сброс — при смене
        // текста чипса и при переводе чипса на место Input (бэк ищет по всем языкам сам). Выключатель fe.ux.gridSearchOtherLangs
        // ---- IE 2026 10 04 / ODOO-5800 (fe-71): показанный текст ячейки из поля строки `<binding>-title` (utils/shownTitle.js) ----
        // Грид вкладки Metrics (_doc.metrics_stats): колонки Signal / Reason показывают `metric-title` / `reason-title`. Выключатель fe.grid.shownTitle (дефолт ВКЛ;
        // выкл. — как до fe-71: текст только при первой отрисовке, поиск / сортировка по прежним значениям, подсказка только по Alt / Show tooltips)
        shownTitle_on() { return this.store.setting('fe.grid.shownTitle', true) !== false },
        // ---- // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана) (utils/planLabelDate.js) ----
        // Подпись строки плана Баланса (plan_label) несёт токен «{approval_at:<ISO UTC>}» (контракт v2, ie-dm7 #110241) либо голый «{approval_at}» + поле строки approval_at (v1). Ячейка (оба пути formatItem, любая колонка,
        // где текст подписи виден, — и дерево) показывает дату store.formatDateHTML(approval_at, true) — местное время пользователя; подсказка / копирование / xlsx —
        // её текстовая форма. Без плейсхолдера ничего не делается (одна проверка indexOf текста ячейки). Выключатель fe.ux.m03StampDateFormat (дефолт ВКЛ; выкл — ISO как есть)
        planLabelDate_opts(html) { return { on: this.store.setting(PLAN_LABEL_DATE_FLAG, true) !== false, fmt: (v, u, o) => this.store.formatDateHTML(v, u, o), html } },   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана)
        planLabelDate_text(text, dataItem) { return planLabel_copyText(String(text), planLabel_approvalAt(dataItem), this.planLabelDate_opts(false)) },   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана): единый хелпер текста буфера
        planLabelDate_editLocked(flex, row, col) {   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана)
            try { return planLabel_editLocked(flex.getCellData(row, col, false), this.store.setting(PLAN_LABEL_DATE_FLAG, true) !== false) } catch (e) { return false }   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана)
        },   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана)
        planLabelDate_hook(flex) {   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана): getClipString + copy в редакторе (бой 27.10: клик по выделенной ячейке открыл редактор, Ctrl+C в нём — сырой токен)
            try { planLabel_hookGrid(flex, () => this.planLabelDate_opts(false), () => { const r = flex.editRange?.row ?? flex.selection?.row; return planLabel_approvalAt(flex.rows?.[r]?.dataItem) }) } catch (e) { /* грид без крючков — копия как была */ }   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана)
        },   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана)
        planLabelDate_cellApply(e_cell, dataItem) {   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана)
            if (!e_cell) return
            if (e_cell.title && planLabel_hasPh(e_cell.title)) e_cell.title = this.planLabelDate_text(e_cell.title, dataItem)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана): нативная подсказка обрезанной ячейки
            const tc = e_cell.textContent
            if (!tc || tc.indexOf('{') < 0 || !planLabel_hasPh(tc) || e_cell.querySelector('input')) return   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана)
            const at = planLabel_approvalAt(dataItem), opts = this.planLabelDate_opts(true)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана)
            // текстовые узлы с плейсхолдером заменяются HTML подписи; глиф свёртки дерева, спейсер и прочие элементы ячейки остаются на месте
            const nodes = [], w = document.createTreeWalker(e_cell, NodeFilter.SHOW_TEXT)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана)
            for (let n = w.nextNode(); n; n = w.nextNode()) if (planLabel_hasPh(n.nodeValue)) nodes.push(n)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана)
            for (const n of nodes) {   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана)
                const box = document.createElement('span')   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана)
                box.innerHTML = planLabel_fill(n.nodeValue, at, opts)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана)
                n.replaceWith(...box.childNodes)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана)
            }   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана)
        },   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана)
        // formatItem, оба пути. cachePath — кэш-путь: текст ячейки переписан wijmo, `-title` ставится заново (в полном пути его ставит formatItem_cells_innerHTML).
        // Подсказка бэка (_DLRow.cells[binding].tooltip) у такой ячейки видна ВСЕГДА, не только по Alt / Show tooltips: показанный текст заменил значение, и подсказка —
        // единственное место, где прежнее значение читается (как у полос ганта). Элементы ячеек wijmo переиспользует — отметка __shownTip снимает подсказку,
        // когда элемент достался другой ячейке
        // IE 2026 10 05 / ODOO-5800 (fe-85) (Igor 05.10, п. 3 «да»: подсказка с числами при наведении на причину в гриде сигналов; ревью cause detail): строка бэка
        // reason_detail — подсказка ячейки «Причина» строки грида сигналов. formatItem, ОБА пути (cachePath — кэш-путь: formatItem_cells не вызывается, а элемент ячейки
        // wijmo переиспользует под другую строку). Обычный режим — нативный title (ставится и снимается своей отметкой: utils/signalModel.sigCell_setCauseDetail).
        // Show tooltips — строка идёт в шапку карточки wijmo (cellTooltip_html), нативный title не ставится (иначе две подсказки сразу); карточку полного пути
        // регистрирует сам formatItem_cells, на кэш-пути она перерегистрируется здесь (отметка __cdCard — элемент несёт карточку со строкой чисел).
        // Поля нет / строка группы / выключатель fe.signals.causeDetail — подсказки нет, своя прежняя снимается
        causeDetail_cellApply(e_cell, dataItem, attr_col, isGroup, row, col, cachePath) {
            if (!e_cell) return ''
            const tx = (dataItem && attr_col && !isGroup && !this.cellBlank(dataItem, attr_col.binding)) ? sigRow_causeDetail(dataItem, attr_col.binding, () => this.store.setting(CAUSE_DETAIL_KEY, true)) : ''   // IE 2026 10 07 / ODOO-5800: погашенная ячейка (Hidden своего уровня) — подсказки с числами причины нет
            // IE 2026 10 06 / ODOO-5800 (fe-88) (второе ревью cause detail): решение — чистая функция utils/signalModel.sigCell_causeDetailPlan (проверена поведением);
            // 'clear' — режим Show tooltips выключили, а элемент остался с карточкой: по Alt было две подсказки, после прокрутки — числа чужой строки
            const plan = sigCell_causeDetailPlan(tx, this.store.showTooltip, cachePath, e_cell.__cdCard)
            sigCell_setCauseDetail(e_cell, plan.title)
            if (plan.card === 'set') tooltip.setTooltip(e_cell, this.cellTooltip_html(this.flex.cells, row, col) || null)
            else if (plan.card === 'clear') tooltip.setTooltip(e_cell, null)
            e_cell.__cdCard = plan.hasCard
            return tx
        },
        shownTitle_cellApply(e_cell, dataItem, attr_col, row, col, cachePath) {
            if (!e_cell || !attr_col) return
            // IE 2026 10 25 / ODOO-348878 (ревью AttrCrossGrid, п.4): Show tooltips + кэш-путь formatItem. Полный formatItem_cells подсказку ячейки ставит, а кэш-путь его пропускает, и переиспользованный
            // wijmo элемент несёт подсказку ДРУГОЙ ячейки (проба dev после прокрутки: 8 из 21 ячеек шахматки показывали чужую — и у пустых ячеек тоже). Ячейке, чья строка сама даёт текст
            // подсказки (dataItem.MD.tooltip[binding] — считается на лету, поэтому всегда своя), подсказку перерегистрируем здесь же. Выключатель fe.ux.cellTipCachePath (дефолт ВКЛ)
            const _mdTip = dataItem && dataItem.MD && dataItem.MD.tooltip   // IE 2026 10 25 / ODOO-348878
            if (cachePath && this.store.showTooltip && _mdTip && typeof _mdTip === 'object' && attr_col.binding in _mdTip && this.store.setting('fe.ux.cellTipCachePath', true) !== false) {   // IE 2026 10 25 / ODOO-348878
                tooltip.setTooltip(e_cell, this.cellTooltip_html(this.flex.cells, row, col) || null)   // IE 2026 10 25 / ODOO-348878
            }
            const shown = this.cellBlank(dataItem, attr_col.binding) ? '' : shownTitle_of(dataItem, attr_col.binding)   // IE 2026 10 07 / ODOO-5800: погашенная ячейка — показанного текста и его подсказки нет (чужая подсказка элемента снимается ниже)
            if (!shown && !e_cell.__shownTip) return
            const on = this.shownTitle_on()
            if (cachePath && shown && on && !e_cell.querySelector('input')) this.store.updateCellText(e_cell, shown)
            const tip = (shown && on) ? shownTitle_tip(dataItem, attr_col.binding) : ''
            if (!tip && !e_cell.__shownTip) return
            const full = !!this.store.showTooltip
            // Show tooltips + полный путь: подсказку (с этой строкой бэка в шапке) только что поставил formatItem_cells — остаётся отметка
            if (!(full && !cachePath)) tooltip.setTooltip(e_cell, full ? (this.cellTooltip_html(this.flex.cells, row, col) || null) : (tip ? escHtml(tip) : null))
            e_cell.__shownTip = !!tip
        },
        searchAlt_on() { return this.store.setting('fe.ux.gridSearchOtherLangs', true) !== false && !/_lane\d+$/.test(this.attr?.html_id || '') },
        // чипс в режиме «на другом языке»: решение принято для этого же текста, чипс не входной
        searchAlt_chipOn(chip) {
            const raw = chip?._raw || chip
            if (!raw || raw.segment !== 'CHIP-Search' || !raw._alt || raw._altFor !== String(raw.title || '').trim()) return false
            return !(this.chipPlace_on() && chipPlace_isInput(raw))
        },
        // задания метки ячеек / подсказки — по одному на чипс в режиме «на другом языке»: { terms, tier, phrase } (и при «Show rows without matches»)
        searchAlt_specs() {
            if (!this.searchAlt_on()) return null
            const out = []
            for (const chip of this.CHIPS || []) {
                const raw = chip._raw || chip
                if (!raw || raw.meta?.use === false || !this.searchAlt_chipOn(raw)) continue
                const t0 = String(raw.title || '').trim()
                const spec = gridSearchAlt_spec({ title: t0, tier: raw._fuzzy || 0, phrase: raw._phrase === true && raw._phraseFor === t0 })
                if (spec && (spec.phrase || spec.terms.length)) out.push(spec)
            }
            return out.length ? out : null
        },
        // решение ступени для чипса: null — ступень не идёт (служебный запрос, входной чипс, уже в режиме, строки на показанных названиях есть — их прячет
        // другой отбор) либо по названиям на других языках тоже ничего; иначе { title, tier, phrase, langs }
        searchAlt_decide(chip) {
            const t0 = String(chip.title || '').trim()
            if (!t0 || t0.startsWith('=') || t0.startsWith('style:') || t0.startsWith('>> ') || chip._alt || chip._fuzzy) return null
            if (chip.meta?.use === false || (this.chipPlace_on() && chipPlace_isInput(chip))) return null
            const ph0 = searchPhrase(t0)
            if ((ph0 && this.gridSearch_phraseExists(ph0)) || this.gridSearch_hasTerms(searchTerms(t0), 0)) return null
            const dec = gridSearchAlt_ladder(t0, (terms, tier, ph) => ph ? this.gridSearch_phraseExists(ph, true) : this.gridSearch_hasTerms(terms, tier, true))
            if (!dec) return null
            dec.langs = this.searchAlt_langs(dec)
            return dec
        },
        // язык совпавших названий (подпись чипса): проход по строкам данных (как gridSearch_hasTerms), до 40 разных названий
        searchAlt_langs(dec) {
            const spec = gridSearchAlt_spec(dec), flex = this.flex, texts = []
            if (!flex?.hostElement || !spec) return gridSearchAlt_langs(texts)
            const grouped = !!flex.itemsSource?.groupDescriptions?.length
            const MAX = this.store.setting('fe.grid.searchNavMaxRows', 500) * 4
            const cols = []
            for (const binding in this.attr_by_binding) { const a = this.attr_by_binding[binding]; if (a && a.binding && typeof a.relation_segment === 'string' && a.relation_segment && a.attr_type !== 'AttrMulti') cols.push(a) }
            let seen = 0
            outer:
            for (let r = 0; r < flex.rows.length && cols.length; r++) {
                const row = flex.rows[r], dataItem = row.dataItem
                if (!dataItem || dataItem._variant) continue
                if (grouped && row.getCellRange) continue
                if (dataItem._DLRow?.hide || dataItem._ogHide) continue
                if (++seen > MAX) break
                for (const a of cols) {
                    const item0 = this.searchAlt_itemOf(dataItem, a)
                    const m = item0 ? gridSearchAlt_matched(item0, [spec]) : null
                    if (m && !texts.includes(m.text)) { texts.push(m.text); if (texts.length >= 40) break outer }
                }
            }
            return gridSearchAlt_langs(texts)
        },
        // элемент словаря ссылочной ячейки (значение — id; мульти-значение / массив — первый id)
        searchAlt_itemOf(dataItem, attr_col, value = undefined) {
            if (!dataItem || !attr_col || !attr_col.relation_segment) return null
            let v = value
            if (v === undefined) { try { v = this.store.get_value(dataItem, attr_col.binding) } catch (e) { v = null } }
            if (Array.isArray(v)) v = v[0]
            if (v && typeof v === 'object') v = v.value ?? v.id
            if (v === undefined || v === null || v === '' || typeof v === 'object') return null
            return this.store.itemsSource[attr_col.relation_segment]?.ids?.[v] || null
        },
        // formatItem (оба пути): ячейка-ссылка, найденная по названию на другом языке (любая часть / фраза чипса в одном из названий) — класс search-alt-hit;
        // класс живёт в кэше className ячейки — снимается здесь же, когда режим кончился
        searchAlt_cellMark(e_cell, dataItem, attr_col, value) {
            let hit = false
            const specs = this._altMark
            if (specs && dataItem && attr_col && attr_col.relation_segment && !this.cellBlank(dataItem, attr_col.binding)) {   // IE 2026 10 07 / ODOO-5800: погашенная ячейка — метки «найдено на другом языке» нет
                const item0 = this.searchAlt_itemOf(dataItem, attr_col, value)
                const lows = item0 ? gridSearchAlt_lows(item0) : null
                hit = !!lows && specs.some(s => gridSearchAlt_hit(lows, s.terms, s.tier, s.phrase))
            }
            if (hit) { if (!e_cell.classList.contains('search-alt-hit')) e_cell.classList.add('search-alt-hit') }
            else if (e_cell.classList.contains('search-alt-hit')) e_cell.classList.remove('search-alt-hit')
            return hit
        },
        // подсказка ячейки: «<имя> (English)» — совпавшее название на другом языке; '' — ячейка не найдена ступенью
        searchAlt_matchedOf(dataItem, attr_col, value = undefined) {
            const specs = this._altMark
            if (!specs) return ''
            const item0 = this.searchAlt_itemOf(dataItem, attr_col, value)
            const m = item0 ? gridSearchAlt_matched(item0, specs) : null
            return m ? `${m.text} (${gridSearchAlt_langName(m.lang)})` : ''
        },
        // счётчик / ‹ ›: колонки-ссылки по индексу колонки грида — только когда есть чипс в режиме «на другом языке» (иначе null — прежний проход)
        searchAlt_navCols(searchChips) {
            if (!(searchChips || []).some(c => this.searchAlt_chipOn(c))) return null
            const flex = this.flex, out = new Array(flex.columns.length).fill(null)
            let any = false
            for (let c = 0; c < flex.columns.length; c++) {
                const col = flex.columns[c], a = col.binding ? this.attr_by_binding[col.binding] : null
                if (a && typeof a.relation_segment === 'string' && a.relation_segment && a.attr_type !== 'AttrMulti') { out[c] = a; any = true }
            }
            return any ? out : null
        },
        searchAlt_navHit(dataItem, attr_col, terms) {
            const item0 = this.searchAlt_itemOf(dataItem, attr_col)
            const lows = item0 ? gridSearchAlt_lows(item0) : null
            return !!lows && terms.some(t => gridSearchAlt_hit(lows, t.phrase ? [] : [t.t], t.tier || 0, t.phrase || null))
        },
        // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс): попадание ячейки (r, c) в части запроса tms — тремя путями, как раньше в gridSearchNav_recompute
        gridSearchNav_cellHit(tms, row, c, txt, _altCols) {
            if (!!txt && tms.some(t => t.phrase ? !!phraseFind(txt, t.phrase) : (t.tier ? !!fuzzyFindTier(txt, t.t, t.tier) : txt.includes(t.t)))) return true
            if (this.shownTitle_on()) { const _st = shownTitle_of(row.dataItem, this.flex.columns[c]?.binding).toLowerCase(); if (_st && tms.some(t => t.phrase ? !!phraseFind(_st, t.phrase) : (t.tier ? !!fuzzyFindTier(_st, t.t, t.tier) : _st.includes(t.t)))) return true }   // IE 2026 10 04 / ODOO-5800 (fe-71): ячейка показывает `<binding>-title`
            if (_altCols && _altCols[c] && this.searchAlt_navHit(row.dataItem, _altCols[c], tms)) return true
            return false
        },
        // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска): набор в полосе чипсов (AttrChips, с паузой) — живой поиск: текст в виртуальный чипс, один проход отбора
        // (строк не прячет) и перерисовка видимых ячеек (подсветка); счётчик / ‹ › — штатно gridSearchNav_schedule. apply = false — текст снят Enter-ом, проход
        // сделает пришедший следом update:modelValue. Замер — window.gridLiveSearchStat { n, ms, max, last, rows }
        onLiveSearch(text, { apply = true } = {}) {
            if (!liveChip_set(this.liveChip, text) || !apply) return
            const t0 = performance.now()
            try { this.apply_CHIPS() } catch (e) { /* грид ещё не готов — отбор применится с приходом данных */ }
            try { this.flex?.invalidate() } catch (e) { /* грид разрушен */ }
            const ms = performance.now() - t0
            const st = window.gridLiveSearchStat = window.gridLiveSearchStat || { n: 0, ms: 0, max: 0, last: 0, rows: 0 }
            st.n++; st.ms += ms; st.last = ms; if (ms > st.max) st.max = ms; st.rows = this.flex?.rows?.length || 0
        },
        onChipSearchNav({ index, dir }) {
            // IE 2026 09 18 / ODOO-5800 (заказ Игоря «чипс-метрик»): стрелки чипса метрик ходят по своему списку (строки с отметками отобранных правил)
            const _navChip = this.$refs.chips?.visibleChips?.[index]
            // IE 2026 09 20 / ODOO-5800 (чипс условного оформления): его стрелки ходят по ячейкам, окрашенным отобранными правилами
            const _navSeg = _navChip ? (_navChip._raw || _navChip).segment : ''
            if (_navSeg === 'CHIP-Format') { this.formatNav_step(dir); return }
            const nav = (_navSeg === 'CHIP-Metric') ? this._gridNavMetric : this._gridNav
            // IE 2026 10 05 / ODOO-5800 (fe-88) (замер ботом dev02 fe-84: первый клик › после флажка Selector — сразу «2/5»): шаг чипса метрик — utils/metricChip.metricNav_step:
            // обход не начат (metricNav_recompute, started = false) — › ведёт на первую остановку, ‹ — на последнюю, дальше по кругу. Шаг поиска — как был
            const _n = nav?.list?.length || 0, _mNav = !!_n && nav === this._gridNavMetric   // IE 2026 10 05 / ODOO-5800
            const _navRaw = _navChip ? (_navChip._raw || _navChip) : null   // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс)
            const _sub = (!_mNav && _n && nav === this._gridNav && _navRaw) ? (nav.subs?.get(_navRaw) || null) : null   // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс): у чипса поиска свой подсписок остановок
            if (_sub && !_sub.length) return   // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс)
            const _pos = _sub ? navStep(_navRaw.matchIndex, dir, _sub.length) : -1   // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс)
            const _to = !_n ? 0 : (_sub ? _sub[_pos] : (_mNav ? metricNav_step(nav.index, dir, _n, nav.started !== false) : (nav.index + dir + _n) % _n))   // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс): + _sub   // IE 2026 10 05 / ODOO-5800
            if (nav === this._gridNavMetric && nav?.list?.length) {
                const next = nav.list[_to]   // IE 2026 10 05 / ODOO-5800
                if (next.c == null) {
                    let c0 = 0
                    for (let c = 0; c < this.flex.columns.length; c++) if (this.flex.columns[c].isVisible) { c0 = c; break }
                    next.c = this.metricNav_col(this.flex.rows[next.r]?.dataItem, this._metricFilterDoc || _navChip.doc, c0)
                }
            }
            if (!nav?.list?.length) return
            nav.index = _to   // IE 2026 10 05 / ODOO-5800
            if (_mNav) nav.started = true   // IE 2026 10 05 / ODOO-5800: обход начат — счётчик показывает номер остановки
            const m = nav.list[nav.index]
            if (nav === this._gridNavMetric || !m.head) this.navRow_reveal(m.r)   // IE 2026 09 20 / ODOO-5800: остановка чипса метрик под свёрнутой группой — раскрыть её предков; IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс): и остановка чипса поиска (не в шапке)
            if (this._gridNavRowCur != null || (m.rowHead && !m.head)) this.gridSearchRowNum_setCur(m.rowHead && !m.head ? m.r : null)   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки): остановка по номеру строки — рамка на номере; иная остановка — рамку снять
            if (m.head) this.gridSearchHeaders_goto(m)   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок): остановка в шапке — прокрутка колонки в вид и рамка ячейки шапки (выбрать её нельзя)
            else {   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
                if (this._gridNavHeadCur) this.gridSearchHeaders_setCur(null)   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок): рамку с ячейки шапки снять
                this.flex.select(new wjGrid.CellRange(m.r, m.c), true)
                this.flex.scrollIntoView(m.r, m.c)
            }   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
            for (const chip of (this.CHIPS || [])) {
                if (chip.segment !== 'CHIP-Search') continue   // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс)
                if (!_sub) { chip.matchIndex = nav.index; continue }   // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс)
                if (chip === _navRaw) { chip.matchIndex = _pos; continue }   // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс): позиция нажатого чипса — в его подсписке
                const _s2 = nav.subs.get(chip)   // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс)
                if (!_s2) chip.matchIndex = nav.index   // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс): чипс без своих частей — по общему списку
                else { const _k = _s2.indexOf(_to); if (_k >= 0) chip.matchIndex = _k }   // IE 2026 10 24 / ODOO-348818 (заказ Игоря: › чипса поиска раскрывает свёрнутые узлы, счётчик на свой чипс): чужой чипс, которому принадлежит и эта остановка, — на ней же
            }
            if (nav === this._gridNavMetric) { this._hitNavKind = 'metric'; this._metricHitCur = (nav.cells && !m.whole && m.c != null) ? { r: m.r, c: m.c } : null; this.metricHit_schedule() }   // IE 2026 09 20 / ODOO-5800 (Igor: переходы чипса метрик по ячейкам, подсветка параметра ячейки и подпадающих ячеек по наведению на чипс)
            if (nav === this._gridNavMetric) {   // IE 2026 09 19 / ODOO-5800 (заказ Игоря «глобальный чипс-метрик»: приём чипса отчётом): позиция ‹ › — у чипса метрик (своего или зеркала)
                for (const chip of (this.CHIPS || [])) if (chip.segment === 'CHIP-Metric') chip.matchIndex = nav.index
                const _mir = this.metricMirror_chip(); if (_mir) _mir.matchIndex = nav.index
            }
            this.$refs.chips?.$forceUpdate()
        },
        // ------------------ вкладка-реестр tab-itemsSourcesView (§6) -----------------------------------
        itemsSourcesView_grid() {
            // грид-реестр вкладки popup-а: 'source' (§6) | 'target' (ит.4 §3 — подстановка
            // target-поля) | '' — обычный грид
            if (this.attr?.name === 'grid-itemsSourcesView') return 'source'
            if (this.attr?.name === 'grid-itemsSourcesView-target') return 'target'
            return ''
        },
        itemsSourcesView_prepare() {
            // §6.2: данные грида-реестра — копия реестра владельца (правила §3, ит.4 §2/§3);
            // перестраивается при замене реестра владельца (сравнение по ссылке)
            // или смене явно выбранного корня
            const store = this.store, WIDGET = this.WIDGET
            const is_target = this.itemsSourcesView_grid() === 'target'
            if (is_target && this.attr.binding === '_doc.itemsSourcesView') {
                // ит.4 §3: бэк даёт обеим вкладкам-реестрам один binding — копия
                // target-реестра хранится отдельно от копии вкладки source-полей
                this.attr.binding = '_doc.itemsSourcesView_target'
            }
            const ctx = store.get_itemsSourcesView_ctx(this)
            if (ctx && ctx.owner === WIDGET) {
                // виджет сам владеет живым реестром — не затирать его локальной копией
                // (потеря use-флагов источников невосстановима до замены реестра бэком)
                return
            }
            // локальный источник (select.binding, напр. doc.viewList) — источником
            // копии служит сам массив записи; он правится на месте, поэтому
            // пересборка отслеживается по ссылке, числу строк и составу
            // включённых (use) строк (ит.5: переключение use длину не меняет)
            const registry = ctx ? (ctx.selectRows || ctx.owner.record._doc?.itemsSourcesView) : null
            const copy_key = is_target ? 'itemsSourcesView_target' : 'itemsSourcesView'
            const src_key = is_target ? '_isv_copy_source_target' : '_isv_copy_source'
            const sel_key = is_target ? '_isv_copy_select_target' : '_isv_copy_select'
            const select_now = ctx?.select ? (ctx.select.roots || ctx.select.binding || ctx.selectSegment) : ''
            let copy = WIDGET.record?._doc?.[copy_key]
            if (registry && (!Array.isArray(copy) || !copy.length || WIDGET[src_key] !== registry
                || WIDGET[sel_key] !== select_now
                || (ctx?.selectRows && (WIDGET[src_key + '_n'] !== ctx.selectRows.length
                    || WIDGET[src_key + '_sig'] !== ctx.selectSig)))) {
                copy = JSON.parse(JSON.stringify(store.get_itemsSourcesView_sources(ctx)))
                for (const source of copy) {
                    this.itemsSourcesView_annotate(source.attrs)
                }
                WIDGET[src_key] = registry
                WIDGET[src_key + '_n'] = ctx?.selectRows?.length
                WIDGET[src_key + '_sig'] = ctx?.selectSig
                WIDGET[sel_key] = select_now
                WIDGET.record._doc = WIDGET.record._doc || {}
                WIDGET.record._doc[copy_key] = copy
            }
            if (Array.isArray(copy)) {
                this.itemsSourcesView_recalc_use(copy)
            }
        },
        itemsSourcesView_annotate(rows, prefix='', prefixTitle='') {
            // плоские id/title строк копии реестра (правило store.flatten_itemsSourcesView:
            // префикс добавляют детям только узлы AttrGrid) — для сопоставления и создания
            // строк WHERE-грида (§6.3, случай view-конфига)
            const lang = this.store.get_lang()
            for (const r of rows || []) {
                const translated = lang ? r['title_' + lang] : ''
                const r_title = (typeof translated === 'string' && translated) || r.title || r.binding || ''
                let id = '', title = ''
                if (r.binding) {
                    id = prefix ? `${prefix}.${r.binding}` : r.binding
                    title = prefixTitle ? `${prefixTitle} . ${r_title}` : r_title
                    r._isv_id = id
                    r._isv_title = title || id
                }
                if ((r.attrs || []).length) {
                    if (r.attr_type === 'AttrGrid' && id) {
                        this.itemsSourcesView_annotate(r.attrs, id, title || id)
                    } else {
                        this.itemsSourcesView_annotate(r.attrs, prefix, prefixTitle)
                    }
                }
            }
        },
        itemsSourcesView_mode(flag) {
            // режим привязки на узле грида: 'row' | 'where' | 'source_field' | 'order';
            // true (легаси) → 'row'; флаг на ячейке (leftValue/binding) к режиму отношения не имеет
            return (typeof flag === 'string') ? flag : (flag ? 'row' : '')
        },
        itemsSourcesView_target_bindings() {
            // ит.4 §3: целевые колонки подстановки из конфига itemsSourcesView_target
            const select = this.store.get_itemsSourcesView_select(this)
            const tb = select?.target_bindings
            return (Array.isArray(tb) && tb.length) ? tb : ['target_field']
        },
        itemsSourcesView_target_key(row, mode) {
            // ключ строки целевого грида по правилу режима (ит.2 §1)
            if (mode === 'where') return row?.leftValue?.value
            if (mode === 'source_field') return row?.source_field?.value
            if (mode === 'target_field') {
                // ит.4 §3: первая из target_bindings; Multi-колонка → value, строковая — как есть
                const v = row?.[this.itemsSourcesView_target_bindings()[0]]
                return (v && typeof v === 'object') ? v.value : v
            }
            if (mode === 'order') {
                // binding — Multi; легаси-конфиги хранят его строкой
                return (row?.binding && typeof row.binding === 'object') ? row.binding.value : row?.binding
            }
            return row?.binding
        },
        get_itemsSourcesView_target(ensure = false) {
            // вкладка-реестр приходит только в view-попапе грида (ит.3 §5.1) —
            // целевая таблица = грид непосредственного родителя, из которого открыт попап.
            // Каскад (ит.3 §5.2): родитель может быть Row-popup-ом — данные грида берём
            // из vueObj.data (отображаемый массив, напр. record._record.fields строки
            // data_layout2) или через attr_get (редирект биндингов widget-row)
            const store = this.store, WIDGET = this.WIDGET
            const binding = WIDGET.record?._meta?.binding
            if (WIDGET.widget !== 'widget-row' || !binding || WIDGET.parentWIDGET?.id === undefined) return null
            const parentWIDGET = store.findWidget(WIDGET.parentWIDGET.id)?.WIDGET
            if (!parentWIDGET) return null
            const attr = store.get_field0(parentWIDGET.view, binding) || null
            let vueObj = parentWIDGET.vueObj?.get_vueObj?.(binding) || null
            if (!vueObj?.setModified) vueObj = null
            let data0 = (Array.isArray(vueObj?.data) && vueObj.data.length && vueObj.data)
                || (attr ? store.attr_get(parentWIDGET, attr) : store.get_value(parentWIDGET.record, binding))
            if (ensure && attr && !Array.isArray(data0)) {
                // целевой массив записи отсутствует (новая строка-правило без fields;
                // пересборка агрегата удаляет пустой ключ, оставляя vueObj.data
                // отвязанным) — добавление ушло бы в массив-сироту; создать,
                // как content_Changed_main при инициализации грида
                store.attr_set(parentWIDGET, attr, [], null, null, false)
                data0 = store.attr_get(parentWIDGET, attr)
            }
            const data = Array.isArray(data0) ? data0 : []
            let mode
            if (this.itemsSourcesView_grid() === 'target') {
                // ит.4 §3: target-таблица сопоставляется по target_field выделенной строки
                mode = 'target_field'
            } else {
                mode = this.itemsSourcesView_mode(attr?.use_itemsSourcesView
                    || WIDGET.record?._record?.use_itemsSourcesView)
                if (!mode) {
                    // fallback: флаг на колонках (leftValue) или строки-условия → WHERE-вариант
                    const has_col_flag = (attrs) => (attrs || []).some(a => a.use_itemsSourcesView || has_col_flag(a.attrs))
                    mode = (has_col_flag(attr?.attrs) || (Array.isArray(data) && data.some(r => r?.leftValue !== undefined)))
                        ? 'where' : 'row'
                }
            }
            return { attr, vueObj, data, mode }
        },
        itemsSourcesView_recalc_use(rows, target=null) {
            // use — фронтовый маркер «поле используется в целевом гриде», не хранится;
            // сопоставление: ключ строки целевого грида (по режиму) == плоский id строки реестра
            target = target || this.get_itemsSourcesView_target()
            const mode = target?.mode || 'row'
            const used = new Set()
            const collect = (rr, deep) => {
                for (const r of Array.isArray(rr) ? rr : []) {
                    const key = this.itemsSourcesView_target_key(r, mode)
                    if (key && r.use !== false) used.add(key)
                    if (deep) collect(r.attrs, deep)
                }
            }
            // 'row': иерархия целевого грида; 'where'/'source_field'/'order': только верхний уровень
            collect(target?.data, mode === 'row')
            const mark = (rr) => {
                for (const r of Array.isArray(rr) ? rr : []) {
                    r.use = used.has(r._isv_id || r.binding)
                    mark(r.attrs)
                }
            }
            mark(rows)
        },
        itemsSourcesView_use_apply(items) {
            // установка use — включить строку целевого грида или добавить новую
            // (под выделенной, иначе в конец); снятие — только use: false, строки не удаляются
            // (ensure — только при включении: на снятие контейнер не создаётся)
            const target = this.get_itemsSourcesView_target(items.some(it => this.store.isTrue(it?.use)))
            if (!target) return
            const { vueObj: target_vueObj, data: target_data, mode } = target
            const mark_modified = (row, new_=false) => {
                if (target_vueObj) {
                    target_vueObj.setModified(row, new_)
                } else {
                    row._meta = row._meta || {}
                    row._meta.modified = true
                    if (new_) row._meta.new = true
                }
            }
            const walk = (rr, cb) => { for (const r of Array.isArray(rr) ? rr : []) { cb(r); walk(r.attrs, cb) } }
            const find_matches = (item) => {
                const key = item._isv_id || item.binding
                const matches = []
                if (mode === 'row') {
                    walk(target_data, r => { if (this.itemsSourcesView_target_key(r, mode) === key) matches.push(r) })
                } else {
                    // только верхний уровень: attrs строк WHERE — под-условия чипсов
                    for (const r of target_data) {
                        if (this.itemsSourcesView_target_key(r, mode) === key) matches.push(r)
                    }
                }
                return matches
            }
            const new_row = (item) => {
                const id = item._isv_id || item.binding
                const title = item._isv_title || item.title || id
                if (mode === 'where') {
                    // строка-условие по полю реестра
                    const leftValue = { value: id, valueStr: title }
                    if (item.attr_type) leftValue.attr_type = item.attr_type
                    if (item.relation_segment) leftValue.relation_segment = item.relation_segment
                    const row_where = { use: true, leftValue, condition: '=' }
                    if (item.attr_type || item.relation_segment) {
                        // title, тип и сегмент подбора значения справа — из поля реестра
                        row_where.rightValue = { title }
                        if (item.attr_type) row_where.rightValue.attr_type = item.attr_type
                        if (item.relation_segment) row_where.rightValue.relation_segment = item.relation_segment
                    }
                    return row_where
                }
                if (mode === 'source_field') {
                    // заполняются только source_field.value / source_field.valueStr (Multi)
                    const source_field = { value: id, valueStr: title }
                    if (item.attr_type) source_field.attr_type = item.attr_type
                    if (item.relation_segment) source_field.relation_segment = item.relation_segment
                    return { use: true, source_field }
                }
                if (mode === 'order') {
                    // строка сортировки: binding — Multi, направление не задано
                    const binding = { value: id, valueStr: title }
                    if (item.attr_type) binding.attr_type = item.attr_type
                    if (item.relation_segment) binding.relation_segment = item.relation_segment
                    return { use: true, binding, direction: '' }
                }
                if (item._isv_link) {
                    // expandLinkFields §5: lazy-загруженное поле справочника — в целевой грид
                    // переносится композитный ->-биндинг + attr_type/relation_segment, без поддерева
                    const row_link = { use: true, binding: id, title }
                    if (item.attr_type) row_link.attr_type = item.attr_type
                    if (item.relation_segment) row_link.relation_segment = item.relation_segment
                    return row_link
                }
                // 'row': полная копия строки реестра (deep copy, включая вложенные attrs);
                // служебные ключи вычищаются, use восстанавливается в true по всему поддереву;
                // row_id не переносится (локальный источник — строки записи, копия
                // с ключом источника дублировала бы row_id внутри записи)
                const row_new = JSON.parse(JSON.stringify(item))
                const clean = (r) => {
                    delete r._isv_id; delete r._isv_title; delete r._fe; delete r._meta
                    delete r.row_id
                    if (r._isv_link_loaded) {
                        // lazy-загруженные поля справочника (expandLinkFields) — не часть строки
                        delete r.attrs
                    }
                    delete r._isv_link; delete r._isv_link_loaded; delete r._isv_link_loading
                    r.use = true
                    for (const child of r.attrs || []) clean(child)
                }
                clean(row_new)
                return row_new
            }

            let changed = false
            if (mode === 'target_field') {
                // ит.4 §3: не добавлять строку, а подставить поле в текущую (выделенную)
                // строку целевого грида; целевая колонка — активная ячейка целевого грида,
                // если она из target_bindings, иначе первая из списка; снятие — очистить
                // целевые колонки строк, где первая из target_bindings содержит id
                // (value/valueStr = '', строки не удаляются)
                const bindings = this.itemsSourcesView_target_bindings()
                const find_col = (attrs, binding) => {
                    for (const a of attrs || []) {
                        if (a.binding === binding) return a
                        const found = find_col(a.attrs, binding)
                        if (found) return found
                    }
                    return null
                }
                const target_flex = target_vueObj?.flex?.hostElement ? target_vueObj.flex : null
                const selected = target_flex?.selectedItems?.[0] || target_flex?.selectedRows?.[0]?.dataItem
                const active_binding = target_flex ? target_flex.columns[target_flex.selection?.col]?.binding : ''
                const col_binding = bindings.includes(active_binding) ? active_binding : bindings[0]
                // формат подстановки по типу колонки (§4a: колонки могут быть в группе Source)
                const col_attr = find_col(target.attr?.attrs, col_binding)
                const is_multi = col_attr ? col_attr.attr_type === 'AttrMulti' : true
                for (const item of items) {
                    const id = item?._isv_id || item?.binding
                    if (!id) continue
                    if (this.store.isTrue(item.use)) {
                        if (!selected || !target_data.includes(selected)) continue // некуда подставлять
                        selected[col_binding] = is_multi
                            ? { value: id, valueStr: item._isv_title || item.title || id,
                                attr_type: 'AttrLink', relation_segment: '' }
                            : id
                        mark_modified(selected)
                        changed = true
                    } else {
                        for (const r of target_data) {
                            const first = r?.[bindings[0]]
                            if (((first && typeof first === 'object') ? first.value : first) !== id) continue
                            for (const b of bindings) {
                                const v = r[b]
                                if (v && typeof v === 'object') {
                                    v.value = ''
                                    v.valueStr = ''
                                } else if (v !== undefined && v !== '') {
                                    r[b] = ''
                                }
                            }
                            mark_modified(r)
                            changed = true
                        }
                    }
                }
            } else
            for (const item of items) {
                if (!item?._isv_id && !item?.binding) continue
                const matches = find_matches(item)
                const actual = matches.some(r => r.use !== false)
                if (this.store.isTrue(item.use) && !actual) {
                    if (matches.length) {
                        // строка уже есть, но выключена — только включаем, новую не добавляем
                        for (const r of matches) { r.use = true; mark_modified(r) }
                    } else {
                        const row_new = new_row(item)
                        const selected = target_vueObj?.flex?.hostElement ? target_vueObj.flex.selectedItems?.[0] : null
                        const i = selected ? target_data.indexOf(selected) : -1
                        if (i >= 0) {
                            target_data.splice(i + 1, 0, row_new)
                        } else {
                            target_data.push(row_new)
                        }
                        target_vueObj?.rowIds_newRow?.(row_new) // как new_Click: ключ строке (row_ids)
                        mark_modified(row_new, true)
                    }
                    changed = true
                } else if (!this.store.isTrue(item.use) && actual) {
                    for (const r of matches) {
                        if (r.use !== false) { r.use = false; mark_modified(r) }
                    }
                    changed = true
                }
            }
            if (changed) {
                target_vueObj?.content_Changed()
                // как new_Click: attr_set-хук целевого грида — useCount и write-back
                // сводных таблиц (aggAll_sourceChanged). Без него строка, добавленная
                // в копию агрегата (попап строки сводной: Row → View, грид полей
                // правила), терялась при следующей пересборке агрегата из источников
                target_vueObj?.attr_set?.()
                if (mode === 'where') {
                    target_vueObj?.check_WHERE?.() // нормализация строк WHERE (только у viewWHERE)
                }
                // целевой грид попапа строки сводной читает копию агрегата:
                // write-back (100мс) + rebuild (200мс) могут заменить контейнер
                // копии (строки без row_id не keyed) — перечитать данные после,
                // иначе грид останется на отвязанном массиве
                const fb = target_vueObj?.aggAll_fullBinding?.() || ''
                if ((target_vueObj?.aggAll_summaryGrids?.() || [])
                    .some(s => s !== target_vueObj && fb.startsWith(s.attr.binding))) {
                    setTimeout(() => target_vueObj?.content_Changed?.(), 350)
                }
            }
            // отобразить фактическое состояние целевого грида (§6.2)
            this.itemsSourcesView_recalc_use(this.data, target)
            this.flexRefresh()
        },
        // ------------------ expandLinkFields: lazy-раскрытие Link-полей (->) ---------------------------
        expandLinkFields_row(dataItem) {
            // строка раскрываема lazy-запросом get_link_fields — поле с заполненным
            // relation_segment; служебные сегменты (SEGMENTS*, DATA-SOURCE*) корневых
            // строк источников — обычное дерево с уже загруженными attrs
            if (!this.attr.expandLinkFields) return false
            const segment = dataItem?.relation_segment
            if (!segment || typeof segment !== 'string') return false
            if (segment.startsWith('SEGMENTS') || segment.startsWith('DATA-SOURCE')) return false
            return true
        },
        expandLinkFields_Click(cell) {
            // клик по кнопке lazy-раскрытия: запросить поля сегмента-справочника и добавить
            // их дочерними строками (локально, в копию реестра — на бэкенд не уходит);
            // повторный клик по строке с уже загруженными attrs — обычный разворот без запроса
            const row = this.flex.rows[cell.irow]
            const dataItem = row?.dataItem
            if (!dataItem || dataItem._isv_link_loading) return
            if ((dataItem.attrs || []).length) {
                if (row.hasChildren) row.isCollapsed = !row.isCollapsed
                return
            }
            if (!this.expandLinkFields_row(dataItem)) return
            dataItem._isv_link_loading = true
            this.flexRefresh()
            this.store.async_get_link_fields(this, dataItem.relation_segment, (fields) => {
                delete dataItem._isv_link_loading
                if (!Array.isArray(fields) || !fields.length) {
                    this.flexRefresh()
                    return
                }
                const base = dataItem._isv_id || dataItem.binding
                const baseTitle = dataItem._isv_title || dataItem.title || base
                this.expandLinkFields_annotate(fields, base, baseTitle)
                dataItem._isv_link_loaded = true
                dataItem.attrs = fields
                this.itemsSourcesView_recalc_use(fields)
                this.expandLinkFields_rebuild(dataItem)
            })
        },
        expandLinkFields_annotate(rows, prefix, prefixTitle, sep='->') {
            // композиция ->-биндинга (§5): дети Link-поля получают плоский id
            // `{биндинг родителя}->{binding}`; группа #meta и обычные группировки передают
            // префикс детям как есть, вложенные AttrGrid — по общему правилу '.'
            const lang = this.store.get_lang()
            for (const r of rows || []) {
                r._isv_link = true // маркер lazy-загруженного поля (правила выбора §5)
                const translated = lang ? r['title_' + lang] : ''
                const r_title = (typeof translated === 'string' && translated) || r.title || r.binding || ''
                let id = '', title = ''
                if (r.binding && !String(r.binding).startsWith('#')) {
                    id = `${prefix}${sep}${r.binding}`
                    title = `${prefixTitle}${sep === '->' ? ' -> ' : ' . '}${r_title}`
                    r._isv_id = id
                    r._isv_title = title || id
                }
                if ((r.attrs || []).length) {
                    if (r.attr_type === 'AttrGrid' && id) {
                        this.expandLinkFields_annotate(r.attrs, id, title || id, '.')
                    } else {
                        this.expandLinkFields_annotate(r.attrs, prefix, prefixTitle, sep)
                    }
                }
            }
        },
        expandLinkFields_rebuild(expandItem) {
            // перестроить дерево строк с новыми детьми; свёрнутость сохраняется по dataItem
            // (set_itemsSource хранит её по индексам строк — после вставки они смещаются),
            // раскрытая Link-строка разворачивается
            const collapsed = new Set()
            for (const r of this.flex.rows) {
                if (r.hasChildren && r.isCollapsed && r.dataItem) collapsed.add(r.dataItem)
            }
            this.set_itemsSource()
            this.flex.deferUpdate(() => {
                for (const r of this.flex.rows) {
                    if (!r.hasChildren || !r.dataItem) continue
                    const isCollapsed = r.dataItem === expandItem ? false : collapsed.has(r.dataItem)
                    if (r.isCollapsed !== isCollapsed) r.isCollapsed = isCollapsed
                }
            })
            this.flexRefresh()
        },
        openItemsSourcesView_Click() {
            // кнопка командной панели: открыть view-popup грида сразу на вкладке-реестре;
            // повторный клик при открытом popup-е на этой вкладке — закрыть popup
            // привязка (пунктир) — к кнопке, как у шестерёнки (selectedCog)
            const btnEl = window.event?.target ? (wjcCore.closest(window.event.target, 'button') || window.event.target) : null
            const widgetEl = document.getElementById('WIDGET' + this.WIDGET.id)
            let x, y
            if (btnEl?.getBoundingClientRect && widgetEl) {
                const cr = btnEl.getBoundingClientRect()
                const wr = widgetEl.getBoundingClientRect()
                x = cr.left - wr.left + cr.width / 2
                y = cr.top - wr.top + cr.height / 2
            }
            let WRow = this.store.get_childrenWidget(this.WIDGET, 'widget-row')
            if (!WRow || WRow._softClosed) {
                WRow = this.store.get_widgetRow() // popup мог сменить родителя
            }
            if (WRow && !WRow._softClosed && WRow.parentAction?.type === 'widget-row-viewParams' && WRow.record?._meta?.binding === this.attr.binding) {
                // вкладка-реестр активна == её грид видим (isVisible ведёт v-visible)
                const reg_vueObj = WRow.vueObj?.get_vueObj?.('grid-itemsSourcesView')
                if (reg_vueObj?.isVisible) {
                    this.store.widget_close(WRow.id)
                    return
                }
                // popup открыт на другой вкладке — активировать его и вкладку-реестр,
                // перепривязать пунктир к кнопке
                if (x != null) {
                    WRow.record._meta.x = x
                    WRow.record._meta.y = y
                    this.store.addEdgeWidgetRow(this.WIDGET, WRow, WRow.record._meta)
                    this.PAGE?.vueObj?.refreshe_svg?.()
                }
                this.store.set_activeAttr(WRow.view, { binding: 'tab-itemsSourcesView' }, WRow)
                this.store.widget_activate(WRow, 'openItemsSourcesView_Click', true, true)
                WRow.vueObj?.content_Changed()
                return
            }
            const actionMenu = {
                command: 'widget_open',
                'widget': 'widget-row',
                'type': 'widget-row-viewParams',
                'source_attr_type': 'AttrGrid',
                '_activate': true,
                'binding': this.attr.binding,
                'source_name': this.attr.name,
                'get_Parent': true,
                'open_in_children_widget': true,
                'widgetRow_params': {
                    'top_pct': 0.2,
                    'left_pct': 0.2,
                    'width_pct': 0.8,
                    'height_pct': 0.8,
                },
                selectedCog: {
                    x,
                    y,
                },
                activeAttr: { binding: 'tab-itemsSourcesView' },
            }
            this.store.executeStoreMethod(this.WIDGET.vueObj, actionMenu, this.attr)
        },
        itemsSourcesView_position() {
            // ит.2 §2: спозиционировать таблицу-реестр на строке, соответствующей
            // выделенной строке основной (целевой) таблицы; нет соответствия — не менять
            if (!this.flex?.hostElement || !this.isVisible || !this.flex.rows?.length) {
                // грид ещё не готов/не показан — повторить при показе (handleVisibility)
                // и ограниченным таймером (первое открытие popup-а: строки строятся позже)
                this._isv_need_position = true
                this._isv_position_tries = (this._isv_position_tries || 0) + 1
                if (this._isv_position_tries <= 10) {
                    clearTimeout(this._isv_position_timer)
                    this._isv_position_timer = setTimeout(() => {
                        if (this._isv_need_position) this.itemsSourcesView_position()
                    }, 200)
                }
                return
            }
            this._isv_need_position = false
            this._isv_position_tries = 0
            const target = this.get_itemsSourcesView_target()
            if (!target) return
            const target_flex = target.vueObj?.flex?.hostElement ? target.vueObj.flex : null
            const selected = target_flex?.selectedItems?.[0] || target_flex?.selectedRows?.[0]?.dataItem
            const key = this.itemsSourcesView_target_key(selected, target.mode)
            if (!key) return
            let found = null
            const walk = (rr) => {
                for (const r of Array.isArray(rr) ? rr : []) {
                    if (found) return
                    if ((r._isv_id || r.binding) === key) { found = r; return }
                    walk(r.attrs)
                }
            }
            walk(this.data)
            if (!found) return
            const irow = this.flex.rows.findIndex(r => r.dataItem === found)
            if (irow < 0) return
            // развернуть свёрнутых родителей, чтобы строка была видима
            let level = this.flex.rows[irow].level || 0
            for (let i = irow - 1; i >= 0 && level > 0; i--) {
                const r = this.flex.rows[i]
                if ((r.level || 0) < level) {
                    if (r.isCollapsed) r.isCollapsed = false
                    level = r.level || 0
                }
            }
            this.flex.select(new wjGrid.CellRange(irow, 0), true)
        },
        get_cell(irow, icol) {
            const get_attr_row = (irow) =>  {
                let row = this.flex.rows[irow],
                dataItem = row.dataItem,
                attr_row = {}
                    
                attr_row.level = row.level
                if (dataItem.MD && dataItem.MD['full_index-data_layaut']) {
                    attr_row['full_index-data_layaut'] = dataItem.MD['full_index-data_layaut']
                }
                attr_row = {
                    ...attr_row,
                    ...dataItem,
                }
                delete attr_row.attrs
                // for (let binding of this.attr.row_bindings) {
                //     if (binding in dataItem) {
                //         attr_row[binding] = dataItem[binding]
                //     }
                // }

                return attr_row
            }

            const { attrs, ...attr_col } = this.get_attr_col(icol) || {}
            let parentAttr = this.parentAttr_by_idAttr[attr_col.idAttr]

            let maxIter = 15;
            while (parentAttr && maxIter-- > 0) {
                const { attrs, ...parentAttr2 } = parentAttr;
                (attr_col.parents_ = attr_col.parents_ || []).push(parentAttr2);
                parentAttr = this.parentAttr_by_idAttr[parentAttr.idAttr];
            }
            
            if (irow === -1) {
                return {
                    icol: icol,
                    irow: irow,
                    attr_col: attr_col,
                    dataItem: null,
                    value: null,
                }
            }
       
       
            let row = this.flex.rows[irow],
                dataItem = structuredClone(row.dataItem),
                attr_row = get_attr_row(irow)

            // scan parents_
            let irow2 = irow,
                level2 = row.level
            while (irow2 > 0 && level2 > 0) {
                irow2--
                let row2 = this.flex.rows[irow2]
                if (row2.level === level2 - 1) {
                    const attr_row2 = get_attr_row(irow2);
                    (attr_row.parents_ = attr_row.parents_ || []).push(attr_row2);

                    if (attr_row2._DLRow?.where) {
                        dataItem._DLRow = dataItem._DLRow || {}
                        dataItem._DLRow.where = [...(dataItem._DLRow.where || []), ...attr_row2._DLRow.where]
                    }
                    
                    level2--
                }
            }

            return {
                icol: icol,
                irow: irow,
                attr_col: attr_col,
                dataItem: dataItem,
                // attr_row: attr_row,
                value: this.flex.getCellData(irow, icol), 
            }
        },
        set_value(irow, dataItem, col_binding, oldVal, newVal, changeStack=true, isNull=null, indirect=false) {
            const vueObj = this;
            this._esDataVer = (this._esDataVer || 0) + 1   // IE 2026 10 29 / ODOO-5800 (webscm #114418: долгая задача 0,86 с после Shift+F3 — скан пустых колонок соседнего грида): правка данных — кэш вердиктов пустых колонок недействителен
            // IE 2026 09 18 / ODOO-5800 (заказ Игоря: колонка use вкладки Metrics) — не правка записи, а управление чипсом метрик грида данных:
            // ни стека отмены, ни признака изменённой записи; итоговые use вернёт metricUse_sync по новому отбору чипса
            if (this.attr?.metricChip_use && dataItem?.key && (col_binding === this.metricSel_binding() || (col_binding === 'use' && this.metricFmt_on()))) {
                // IE 2026 09 19 / ODOO-5800 (Igor: Use вкладки Metrics = оформление метрики видно в таблице, состав чипса — колонка Selector)
                dataItem[col_binding] = this.store.isTrue(newVal)
                if (col_binding === this.metricSel_binding()) this.metricUse_schedule(); else this.metricFmt_schedule()
                return
            }
            // let oldVal = dataItem[col_binding],
            let attr_col = this.attr_by_binding[col_binding] || {}
            const _pbT0 = (this._pasteStat && !this._pasteStat.ended) ? performance.now() : 0 // IE 2026 09 04 / ODOO-336379: замер вставки

            if (oldVal == newVal && isNull === null) {
                return
            }
            // IE 2026 10 06 / ODOO-341407 (заказ Игоря п.2, DESIGN Р5): колонка переводов списка «… (uk)» — строка без контейнера перевода (без meta / doc) не пишется
            // и вставкой / очисткой диапазона (beginningEdit их не видит): update_data бэка заменил бы meta записи целиком
            if (attr_col._i18nOf && !this.i18nFields_rowEditable(dataItem, attr_col)) {
                return
            }
            // IE 2026 10 06 / ODOO-341407 (ревью U9): строка перевода формы только для чтения («… (en)») — ни истории отмены, ни значения, ни признака
            // «изменено» (setModified ниже метил запись без правки данных: жёлтый Save, noupdate предопределённой при Save)
            if (this.attr.attr_type === 'AttrTabGrid' && this.i18nFields_rowReadOnly(dataItem)) {
                return
            }

            // if (col_binding==='selector') {
            //     this.flex.rows[irow].isSelected = newVal
            // }

            // undoStack
            let rowStack0 = null // IE 2026 08 19: снимок _cells до/после — для точного отката признака правки
            // IE 2026 09 26 / ODOO-5800 (fe.sim.undoBaseNoStep): косвенные записи ответа симуляции на откат до базы — без записи в undo-стек
            if (changeStack && indirect && this._simNoHistory) changeStack = false
            if (changeStack && col_binding!='visibleChart' && col_binding!=='selector' && col_binding!='visibleChart') {
                let rowStack = {
                    method: 'val',
                    actionStack: this.actionStack,
                    irow: irow,
                    icol: attr_col.icol,
                    $key: dataItem.$key,
                    $item: dataItem, // undo/redo резолвит строку по ссылке (индексы плывут)
                    col_binding: col_binding,

                    val: oldVal,
                    newVal: newVal,
                    // measure: dataItem.measure||attr_col.measure||'', 2025-08-14
                    // date: dataItem.date||attr_col.date||'',
                }
                if (this.pastedVal !== null) {
                    rowStack.pastedVal = this.pastedVal
                }
                // косвенная правка (агрегаты декомпозиции): живёт в undo/redo и
                // подсветке изменённых, но на бэк при записи отчёта НЕ уходит
                if (indirect) {
                    rowStack.indirect = true
                }
                // IE 2026 08 18 (заказ Игоря п.2): метка времени нужна вспышке;
                // ОТЛОЖЕННОГО refresh больше нет — свежесть снимает действие
                rowStack.ts = Date.now()
                // IE 2026 08 15 / ODOO-4997 (заказ Игоря): «связанная» правка
                // (детали декомпозиции, сим-применения) — НА БЭК уходит (не
                // indirect), но стилем и в истории отделяется от ячейки,
                // которую пользователь правил рукой
                if (this._relatedEdits && !indirect) rowStack.related = true
                if (!indirect && (this.attr.use_cells || attr_col.use_cells)) {
                    const _rb0 = String(col_binding).replace('data::', '')
                    const _c0 = this.store.get_value(dataItem, `_cells.${_rb0}`)
                    rowStack.cellsBefore = _c0 ? this.store.deepCopy(_c0) : null
                }
                this.pushStack(rowStack)
                rowStack0 = rowStack
            }

            // set new value
            let V = attr_col
            if (attr_col.attr_type === 'AttrMulti') {
                V = this.store.check_AttrMulti(attr_col, dataItem)

                if (V.value !== newVal)   {
                    this.store.reset_valueStr_translations(V)
                    V.value = V.valueStr = newVal
                }
                this.relation_attr_set(V)
                if (V.source_field && !V.manual) {
                    V.manual = true
                }
            } else if (attr_col.nestedAttrMulti) {
                const bindingAttrMulti = this.store.get_bindingAttrMulti(attr_col.binding),
                attr_col_V = this.attr_by_binding[bindingAttrMulti]
                V = this.store.check_AttrMulti(attr_col_V, dataItem)
                
                if (attr_col.binding.endsWith('value')) {
                    V.value = V.valueStr = newVal
                    // const refresh_value = (this.attr.attr_type !== 'AttrGrid')
                    if (V.binding) {
                        V.value = this.store.attr_set(this.WIDGET, V, V.value)
                    }
                    if (V.source_field && !V.manual) {
                        V.manual = true
                    }
                } else if (attr_col.binding.endsWith('attr_type')) {
                    V.attr_type = newVal
                } else if (attr_col.binding.endsWith('binding')) {
                    V.binding = newVal
                    
                    if (V.binding) {
                        const attr_ = this.store.get_field0(this.WIDGET.view, V.binding, 'binding')
                        if (attr_?.attr_type) {
                            V.attr_type = attr_.attr_type
                            V.component = attr_.component || attr_.attr_type
                        }
                        if (attr_?.relation_segment) {
                            V.relation_segment = attr_.relation_segment
                        }
                        if (attr_?.title) {
                            V.title = attr_.title
                        } else if (!V.title) {
                            V.title = V.binding
                        }

                        const refresh_value = (this.attr.attr_type !== 'AttrGrid' || !V.value) // 'doc.params.fieldsMapping'
                        if (refresh_value) {
                            V.value = this.store.attr_get(this.WIDGET, V)
                        }
                    }
                } else if (attr_col.binding.endsWith('relation_segment')) {
                    V.relation_segment = newVal
                }

                this.store.prepare_AttrMulti(this, attr_col_V, dataItem, [], true)

            } else {
                // indirect: без _meta.modified — косвенная правка на бэк не уходит
                // IE 2026 09 24 / ODOO-341407 (F2, дизайн-док A2): translate-колонка под uk/ru пишет ТОЛЬКО перевод {binding}_{lang}
                // (строки-записи: meta.title_{lang}) — английская база не затирается (бэк вложенные строки не восстанавливает); под en — база
                const _lang = attr_col.translate ? this.store.get_lang() : ''
                // IE 2026 09 25 / ODOO-341407 (этап 2 переводов данных 1С): под en строка-запись (_doc.*, колонка title), показанная английским вариантом
                // meta.title_en (запись справочника с не английской базой), — правка идёт в этот вариант, база из загрузки не меняется
                const _enVar = !_lang && attr_col.translate && attr_col.binding === 'title' && String(this.attr?.binding || '').startsWith('_doc.')
                    && typeof dataItem?.meta?.title_en === 'string' && dataItem.meta.title_en !== '' && typeof newVal === 'string'
                if (_lang && typeof newVal === 'string') {
                    this.store.set_value(dataItem, this.i18n_rowLangBinding(col_binding, attr_col.binding, _lang), newVal, null, null, null, indirect ? false : null)
                    this.store.i18n_autoUnmark(dataItem, this.i18n_rowLangBinding(col_binding, attr_col.binding, _lang))   // IE 2026 10 06 / ODOO-341407 (DESIGN §3.4 п.5): правленый перевод — уже не словарный (meta._i18n_auto)
                } else if (_enVar) {
                    this.store.set_value(dataItem, this.i18n_rowLangBinding(col_binding, attr_col.binding, 'en'), newVal, null, null, null, indirect ? false : null)
                } else {
                    this.store.set_value(dataItem, col_binding, newVal, null, null, null, indirect ? false : null) // dataItem[col_binding] = newVal
                    if (attr_col._i18nOf) this.store.i18n_autoUnmark(dataItem, col_binding)   // IE 2026 10 06 / ODOO-341407 (п.2): колонка переводов «… (uk)» пишет свой ключ (meta.title_uk / doc.x_uk); правленый словарный — снять из meta._i18n_auto
                }
            }

            if (['leftValue.valueStr', 'condition'].includes(col_binding)) { // !== 'rightValue.source_field'
                this.check_WHERE()
                // IE 2026 09 03 / ODOO-11316 (замечание Игоря): смена condition меняет
                // авто-статус строки И её детей — перерисовать, чтобы тинт переоценился
                if (col_binding === 'condition' && this.attr?.name === 'viewWHERE') this.flexRefresh()
            }

            if (!indirect) this.setModified(dataItem)
            if (!indirect) this.approvalPartial_afterEdit(col_binding, irow, dataItem)   // IE 2026 10 14 / ODOO-5800 (Igor): правка флажка документа — итоги перерисовать (app7 #84309: только предки)
            if (!indirect) this.m03Flags_afterEdit(col_binding, irow, dataItem, newVal)   // IE 2026 10 18 / ODOO-5800 (Igor, п. 4): флажок БЮМ / МД поставлен — каскад на загруженные строки тех же измерений (fe.ux.m03Cascade)
            if (!indirect) this.planFlags_afterEdit(col_binding, irow, dataItem, newVal)   // IE 2026 10 19 / ODOO-5800 (plan flags, Igor 19.10): флажок уровня плана на строке-группе — каскад на листья поддерева, итоги перерисовать (fe.ux.planFlags)
            // поле с Source-мэппингом на запись владельца (= workspace.*): признак
            // modified основному виджету (значение пишет бэкенд по fieldsMapping)
            if (!indirect) this.store.markSourceMappingModified(this.WIDGET, V)

            // превью оформления: правка источников строки перерисовывает ячейку-превью
            this.formatPreview_afterEdit(irow, col_binding, dataItem)

            if (this.attr.isPrintTemplate) {
                // модель печати: контент ячейки задаёт fields[0] — binding (поле)
                // или source (текст/формула). Ввод текста в ячейку с полем меняет
                // подпись (title), в остальных — source; значение col_N не дублируем
                const f0p = `_cells.${col_binding}.fields[0]`
                const f0v = this.store.get_value(dataItem, f0p) || {}
                if (f0v.binding) {
                    this.store.set_value(dataItem, `${f0p}.title`, newVal)
                } else {
                    this.store.set_value(dataItem, `${f0p}.source`, newVal)
                    if (f0v.title) this.store.set_value(dataItem, `${f0p}.title`, null)
                    if (dataItem[col_binding] != null) this.store.set_value(dataItem, col_binding, null)
                }
            }

            // 👁-попап превью ('*-cells' widget-row): правка пишется сквозняком
            // в грид шаблона; вкладка Cells — канон doc.printCells ХРАНИМЫЙ,
            // правка уже в нём — только инвалидация визуалки Template
            if (this.cellsList_isActive()) {
                this.cellsList_writeBack(dataItem, col_binding, oldVal, newVal)
            } else if (this.printCellsTab_isActive()) {
                this.printCellsTab_afterWB()
            }

            if (!indirect && (this.attr.use_cells || attr_col.use_cells)) { // >> viewParams.dataSheet.use_cells
                const raw_binding = col_binding.replace('data::', '')
                this.store.set_value(dataItem, `_cells.${raw_binding}.value`, newVal)
                if (isNull !== false) {
                    isNull = (newVal === null || newVal === '' || newVal === 0)
                }
                this.store.set_value(dataItem, `_cells.${raw_binding}.isNull`, isNull)

                this.store.set_value(dataItem, `_cells.${raw_binding}.updated_at`, this.store.formatUTC(new Date()))
                this.store.set_value(dataItem, `_cells.${raw_binding}.updated_by`, this.store.user.id)
                // IE 2026 08 19 / ODOO-5512 (заказ Игоря): значение ДО первой ручной
                // корректировки едет вместе с _cells на бэк — после сохранения и
                // перестроения отчёта дропдаун ячейки показывает «было N»; повторные
                // правки той же ячейки исходное не затирают
                const _cb = rowStack0?.cellsBefore
                if (!_cb || !(('value' in _cb) || ('isNull' in _cb))) {
                    this.store.set_value(dataItem, `_cells.${raw_binding}.value_before`, oldVal === undefined ? null : oldVal)
                }
                if (rowStack0 && 'cellsBefore' in rowStack0) {
                    const _c1 = this.store.get_value(dataItem, `_cells.${raw_binding}`)
                    rowStack0.cellsAfter = _c1 ? this.store.deepCopy(_c1) : null
                }
            }

            // IE 2026 09 02 / ODOO-11316 (заказ Игоря, M03): следим за введённым руками
            // значением — пересчёт (afterEdit-рейс или любой другой отскок) может его
            // перебить (год выводится из месяцев, ручные корректировки в приоритете).
            // Оценка: сразу по ответу afterEdit-рейса И страховочным таймером — отскок
            // случается и вне рейса (select-эхо). Захват — только правки РУКАМИ на
            // гридах с ячеечными правками (use_cells) или afterEdit-методом.
            if (!indirect && col_binding !== 'selector') this.cellPassport_refreshUnsaved(dataItem)   // IE 2026 10 22 / ODOO-5800 (unsaved): открытая форма ячейки — паспорт с правкой
            if (!indirect && col_binding !== 'selector' && typeof newVal === 'number'
                    && (this.attr.executeWidgetMethod_afterEdit || this.get_viewParam('use_cells'))) {
                const wl = (this._afterEditWatch = this._afterEditWatch || [])
                const prev = wl.findIndex(x => x.item === dataItem && x.binding === col_binding)
                if (prev >= 0) wl.splice(prev, 1)   // повторная правка той же ячейки — следим за свежим вводом
                wl.push({
                    item: dataItem, binding: col_binding,
                    entered: newVal,
                    title: attr_col?.title || col_binding,
                })
                clearTimeout(this._afterEditWatchT)
                // IE 2026 09 02 (замечание Игоря «в одном кадре»): таймер — только тихая
                // уборка устоявшихся правок; само перебитие ловится в afterEdit_scheduleCheck
                this._afterEditWatchT = window.$cg.setTimeout(this, 'AttrGrid.afterEditWatch',
                    () => { this._afterEditWatch = [] }, 6000)
                // и сразу взводим проверку-по-затиханию (если updatedView больше не придёт)
                this.afterEdit_scheduleCheck()
            }

            // MANUF-BATCH
            if (!indirect && this.attr.executeWidgetMethod_afterEdit && col_binding !== 'selector') {
                let cell = this.get_cell(irow, attr_col.icol)
                cell.oldVal = oldVal

                const key_stack = `${irow}:${col_binding}`
                this.backendStack[key_stack] = cell
                this.processBackend()                                
            }

            if (col_binding=='visibleChart') {
                let visibleChart = newVal
                let attrChart= this.store.get_field(this.WIDGET.view, 'dataChart')
                if (attrChart) {
                    let flexChart = this.WIDGET.attrs_vueObj[attrChart.id].flex
                    for (let series of flexChart.series) {
                        if (series.binding==dataItem.measure) {
                            series.visibility = visibleChart ? 0 : 2 // hide
                            break
                        }
                    }
                    for (let m of this.WIDGET.record.doc.measures||[]) {
                        if (m.measure==dataItem.measure) {
                            m.visibleChart = visibleChart
                            break
                        }
                    }
                }
                return
            }

            // transpose: двусторонняя синхронизация _doc.data <-> doc.data
            if (this.attr.transpose && this.attr.binding_transpose) {
                this.transpose_syncToSource(dataItem, col_binding, newVal)
            } else if (dataItem?.date_binding) {
                this.transpose_syncFromSource(dataItem, col_binding, newVal)
            }

            if (this.attr.refreshAttr_AfterChange) {
                let attr_vueObj = this.WIDGET.vueObj.get_vueObj?.(this.attr.refreshAttr_AfterChange)
                if (attr_vueObj.refresh) {
                    attr_vueObj.refresh()
                }
            }
            if (this.WIDGET.widget === 'widget-selectors') {
                this.store.sync_WORKSPACE(this.WIDGET, '>>WORKSPACE')
            }

            if (attr_col.attr_type === 'AttrNumber') {
                let _quantity = attr_col.binding_quantity,
                    _sum = attr_col.binding_sum,
                    _price = attr_col.binding_price,
                    _calculation = attr_col.type_of_quantity_calculation

                // calculate
                if (_sum && _quantity && _price) {
                    if (_calculation=='sum=quantity*price') {
                        if (col_binding==_quantity || col_binding==_price) {
                            // sum=quantity*price
                            dataItem[_sum] = (dataItem[_quantity] * dataItem[_price]).toFixed(0)
                        } else if (col_binding==_sum) {
                            if (dataItem[_price]) {
                                // quantity=sum/price
                                dataItem[_quantity] = (dataItem[_sum] / dataItem[_price]).toFixed(0)
                            } else if (dataItem[_quantity]) {
                                // price=sum/quantity
                                dataItem[_price] = (dataItem[_sum] / dataItem[_quantity]).toFixed(3)
                            }
                        }
                    }
                } else if (_sum && _quantity) {
                    if (_calculation=='sum=quantity*price') {
                        if (col_binding==_quantity) {
                            let old_quantity = oldVal
                            if (dataItem[_sum] && old_quantity) {
                                let price = dataItem[_sum] / old_quantity
                                // sum=quantity*price
                                dataItem[_sum] = (dataItem[_quantity] * price).toFixed(0)
                            }
                        } else if (col_binding==_sum) {
                            let old_sum = oldVal
                            if (old_sum && dataItem[_quantity]) {
                                let price = old_sum / dataItem[_quantity]
                                if (price) {
                                    // quantity=sum/price
                                    dataItem[_quantity] = (dataItem[_sum] / price).toFixed(0)
                                }
                            }
                        }
                    }
                }
            }

            // selector
            if (!(attr_col.attr_type === 'AttrMulti' && V.binding)) {
                if (!V.is_customValueWarning) { // TODO check relation_attr_set(V) {....
                    if (V.action_afterChange) {
                        this.$nextTick(() => {
                            this.store.executeStoreMethod(this.WIDGET.vueObj, {
                                ...V.action_afterChange,
                                actioinFrom_attr: V,
                            }, this.attr)
                        })
                    } else if (attr_col.action_afterChange) {
                        this.$nextTick(() => {
                            this.store.executeStoreMethod(this.WIDGET.vueObj, {
                                ...attr_col.action_afterChange,
                                actioinFrom_attr: V,
                            }, this.attr)
                        })
                    }

                    if (this.attr.action_afterChange) {
                        this.$nextTick(() => {
                            this.store.executeStoreMethod(this.WIDGET.vueObj, {
                                ...this.attr.action_afterChange,
                                actioinFrom_attr: V,
                            }, this.attr)
                        })
                    }
                }
            }

            if (attr_col.no_process_dataItem !== true) {
                if (!dataItem._fe) {
                    dataItem._fe = {key: ++ vueObj.cache_index}
                }
                if (this.cache_process_dataItem_py__used!==-1) {
                    this.cache_process_dataItem_py.set(dataItem._fe.key, dataItem)
                    // IE 2026 08 18 / ODOO-5512: контекст правки для регистрации
                    // СВЯЗАННЫХ изменений py-кода (та же группа actionStack, свои
                    // ячейки-триггеры не перезаписывать); ключ — как у очереди
                    const _ctx = (this._pyEditCtx = this._pyEditCtx || new Map()).get(dataItem._fe.key)
                    if (_ctx && _ctx.actionStack === this.actionStack) _ctx.bindings.add(col_binding)
                    else this._pyEditCtx.set(dataItem._fe.key, { actionStack: this.actionStack, bindings: new Set([col_binding]) })

                    this.process_dataItem_py__start_t0 = performance.now()
                    if (!this.process_dataItem_py__start_WORKIING) {
                        this.process_dataItem_py__start_WORKIING = true;
                        this.process_dataItem_py__start()
                    }
                }

                this.process_dataItem(dataItem)

                if (this.WIDGET?.record?.doc?.params?.autoSave) {
                    // this.autoSave()
                }
            }

            // IE 2026 08 27 (Igor): ячейка вернулась к исходному — снять пометку правки (после штампа _cells выше)
            if (rowStack0 && rowStack0._noop) {
                this.noop_unmark(rowStack0)
            }
            // refresh CSS
            // this.cache2_data_cells.clear() // TODO clear only row
            // IE 2026 09 04 / ODOO-336379: в батче вставки (paste_batch) инвалидация py-CSS / условного
            // формата, attr_set и перерисовка — один раз в pasteBatch_end, а не на каждую ячейку
            const _pb = this._pasteBatch
            if (!_pb) {
                // IE 2026 09 04 / ODOO-336379 (флаг css_invalidate_scoped): py-CSS правленой строки и её предков, не всего грида
                this.css_invalidate_rows(this.cssPerf_scoped() ? this.css_ancestors(dataItem) : null, 'edit')
                this.cf_cache?.clear() // conditional_format: значения строки изменились
                this.alertChild_invalidate(dataItem) // IE 2026 09 17: строка могла стать (перестать быть) алертом   // IE 2026 10 14 / ODOO-5800: точечно — она и предки, не вся карта (fe.ux.alertChildKeep)
            } else {
                (_pb.rows || (_pb.rows = new Set())).add(dataItem) // IE 2026 09 04 / ODOO-336379: строки вставки — для строчной инвалидации в pasteBatch_end
            }
            // IE 2026 08 15 / ODOO-4997 (жалоба Игоря «undo очень долгий»):
            // в БАТЧЕ undo/redo (серия детальных правок декомпозиции) полную
            // перерисовку и write-back НЕ делаем на каждую ячейку — один раз
            // в конце батча (changeStack_); замер: undo месячной декомпозиции
            // был 54 с (83 × refreshCells + attr_set)
            if (!this._undoBatch && !_pb) {
                // this.flex.refreshRange(new wjGrid.CellRange(irow, 0, irow, this.flex.columns.length - 1));
                if (_pbT0) { if (this.flex?.isUpdating) this._pasteStat.refreshCells_noop++; else this._pasteStat.refreshCells_calls++ }
                if (!this.editRefresh_rows(irow, dataItem)) this.flex.refreshCells();   // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL2: строка правки и её предки, не весь грид
                this.attr_set()
                if (_pbT0) this._pasteStat.attr_set_calls++
            }
            if (_pbT0) { this._pasteStat.cells_changed++; this._pasteStat.set_value_ms += performance.now() - _pbT0 }
        },
        // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL2 (Igor: «флажок раньше ставился мгновенно»): set_value после правки ОДНОЙ ячейки перерисовывал весь видимый грид
        // (refreshCells: замер dev02 M03 45×91, коммит флажка ApprovedPM — 400–500 мс из 1,7–2,1 с; две другие полные перерисовки — штатные wijmo:
        // finishEditing → refresh(false) и commitEdit → invalidate). Значение меняется в строке правки, итоги — у её предков: перерисовываются только они
        // (~90 мс). Полный refreshCells, как прежде, если: выключатель fe.ux.gridEditRefreshRow = false; грид в обновлении (isUpdating — refreshCells и так
        // пустой); за позицией irow другая строка; у грида пользовательский process_dataItem (code-eval-fe правит любые строки). Счётчик window.__gridEditRefreshRow
        // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL3 (Igor: «должно быть кеширование + см. моё кеширование formatItem»). После правки одной ячейки wijmo дважды
        // перерисовывает весь грид: finishEditing -> refresh(false) и (Enter / уход со строки) commitEdit -> collectionChanged(Change) -> invalidate -> refresh(true);
        // каждый раз refreshing() сдвигал эпоху irefresh и чистил кэш ячеек — все ~640 видимых ячеек шли через formatItem (400–650 мс на перерисовку, M03 dev02).
        // Теперь для этих двух перерисовок (fe.ux.gridEditKeepCache, по умолчанию вкл): эпоха не сдвигается, кэш чистится только у строк правки, её предков и
        // потомков (и у панелей шапки / подвала), ячейки прочих строк, уже отрисованные в этой эпохе, wijmo-фабрика пропускает (как кэш formatItem
        // CustomCellFactory: data_cell row/col/irefresh), переключая только классы выделения. Взвод: editKeep_arm (cellEditEnding, без отмены) и
        // editKeep_onCommit (collectionChanged Change той же строки); любая иная перерисовка — полный сброс, как раньше (editKeep_take).
        // Полный сброс и без взвода, если (editKeep_block): выключатель; печать; process_dataItem в code-eval-fe; py-CSS не строчный (cssPerf_scoped = false);
        // у грида правила условного оформления (attr.cf_rules: наследование значений от предков, cf_parentOf — правило может читать итог предка, а значит
        // зависеть от правки в соседней ветке), заливка от метрик или статистика правил (cf_stats — по колонке); группировки wijmo (groupDescriptions —
        // итоги групп не по дереву); пакет вставки / undo; merge «назад» в правке. На проходе — снова полный, если с взвода изменились строки (число / dataItem
        // по позициям), колонки (число / binding) или размеры (getTotalSize строк и колонок: autoSizeRows), сменился разрыв колонок (breakCarry_update).
        // Счётчик: window.__gridEditKeepCache {keep, full, skip, why}
        editKeep_on() {
            return this.store.setting('fe.ux.gridEditKeepCache', true) !== false
        },
        editKeep_block() {
            const flex = this.flex, a = this.attr || {}
            if (!flex || !this.editKeep_on()) return 'off'
            if (a.isPrint || a.isPrintTemplate) return 'print'
            const code = a['code-eval-fe'] || (a.binding === '_doc.data' ? this.WIDGET?.record?.doc?.params?.['code-eval-fe'] : '') || ''
            if (code && String(code).includes('process_dataItem')) return 'process_dataItem'
            if (this._undoBatch || this._pasteBatch || this._mergeBackEditRow != null) return 'batch'
            // IE 2026 10 14 / ODOO-5800 (Igor: остаток замирания при клике по флажку согласования в 1coh_001): с fe.ux.boolEditKeepRefresh (дефолт ВКЛ) правила оформления и
            // заливка от метрик НЕ блокируют точечный проход — условия правил читают только поля своей строки (#value / #cell.* — своя ячейка, остальные — ключи
            // строки; cfRulesFields) и, при fe.ux.cfInheritParent, поле ближайшего предка; строки, которые наследуют правленую колонку, добавляет editKeep_scope.
            // Заливка от метрик (metric_data записи) и статистика правил (cf_stats бэка) правкой ячейки не меняются
            const _bek = this.boolEditKeep_on()
            const cf = a.cf_rules
            if (!_bek && cf && (Array.isArray(cf) ? cf.length : Object.keys(cf).length)) return 'cf_rules'
            try { if (!_bek && (this.metricFill_state() || this.cfStats_map())) return 'cf_metrics' } catch (e) { return 'cf_metrics' }
            if (flex.collectionView?.groupDescriptions?.length) return 'groups'
            // IE 2026 10 14 / ODOO-5800: py-CSS «не строчный» блокирует, только если функция <attr>__get_cssClass вообще есть (cssPerf_hasPyCss): без неё cssPerf_rowLocal
            // отвечает false (found && local), и грид 1coh_001 без py-CSS шёл полным проходом по ложной причине (замер dev02 pfperf2: why css_global)
            try { if (!this.cssPerf_scoped() && (!_bek || this.cssPerf_hasPyCss())) return 'css_global' } catch (e) { return 'css_global' }
            return ''
        },
        editKeep_stat(kind, why) {
            const c = (window.__gridEditKeepCache = window.__gridEditKeepCache || { keep: 0, full: 0, skip: 0, why: {} })
            c[kind] = (c[kind] || 0) + 1
            if (why) c.why[why] = (c.why[why] || 0) + 1
        },
        boolEditKeep_on() { return boolEditKeep_flagOn((k, d) => this.store.setting(k, d)) },   // IE 2026 10 14 / ODOO-5800
        // строки, чьё отображение зависит от правленой: она сама, её предки (итоги, сводки) и потомки (наследование, пометки строки-алерта) — utils/gridEditKeep.editKeep_scopeRows.
        // IE 2026 10 14 / ODOO-5800: с правилами оформления (fe.ux.boolEditKeepRefresh) — плюс строки, которые НАСЛЕДУЮТ правленую колонку от предка (поля нет в строке,
        // fe.ux.cfInheritParent: правило читает итог изменившегося предка), если условия правил вообще читают эту колонку (cfRulesFields); плюс строки объединённого
        // диапазона ячейки (merge «назад» / mergeColumns). icol — колонка правки (без неё — как раньше)
        editKeep_scope(irow, icol) {
            const flex = this.flex, rows = flex.rows
            let lacks = null
            try {
                const rules = this.attr?.cf_rules
                const binding = icol != null && icol >= 0 ? flex.columns[icol]?.binding : ''
                if (rules && binding && this.boolEditKeep_on() && this.cf_inheritOn()) {
                    if (this._cfFieldsFor !== rules) { this._cfFieldsFor = rules; this._cfFields = cfRulesFields(rules) }
                    if (this._cfFields.has(binding)) lacks = (item) => { const v = item ? this.store.get_value(item, binding, CF_ABSENT) : CF_ABSENT; return v === CF_ABSENT || v === undefined }
                }
            } catch (e) { lacks = null }
            const set = editKeep_scopeRows(rows, irow, lacks)
            if (icol != null && icol >= 0) { try { editKeep_addRange(set, flex.getMergedRange(flex.cells, irow, icol)) } catch (e) { /* без объединения */ } }
            return set
        },
        editKeep_sig() {
            const flex = this.flex, cols = flex.columns
            let b = ''
            for (let i = 0; i < cols.length; i++) b += (cols[i].binding || '') + '|'
            return `${flex.rows.length}:${cols.length}:${flex.rows.getTotalSize()}:${cols.getTotalSize()}:${b}`
        },
        // взвод: правка ячейки закончена (cellEditEnding без отмены) — ближайшая перерисовка в этом же обработчике (finishEditing -> refresh(false))
        editKeep_arm(irow, icol) {   // IE 2026 10 14 / ODOO-5800: + icol (область по колонке правки)
            this._editKeep = null
            try {
                const why = this.editKeep_block()
                if (why) { if (why !== 'off') this.editKeep_stat('full', why); return }
                const rows = this.flex.rows, item = rows[irow]?.dataItem
                if (!item) return
                if (icol == null || icol < 0) icol = this.flex.editRange?.col ?? -1
                const ek = { phase: 'finish', item, row: irow, col: icol, scope: this.editKeep_scope(irow, icol), items: Array.from(rows, r => r.dataItem), sig: this.editKeep_sig(), t: performance.now() }
                this._editKeep = ek
                queueMicrotask(() => { if (ek.phase === 'finish') ek.phase = 'wait' })   // refresh(false) finishEditing — в том же стеке; позже — только через commit
            } catch (e) { this._editKeep = null }
        },
        // IE 2026 10 14 / ODOO-5800 (Igor: остаток замирания при клике по флажку согласования): взвод на refresh(false) wijmo в startEditing — _EditHandler._updateEditorCell
        // перерисовывает ВЕСЬ грид, если колонка правки заморожена (клон замороженных). Данные ещё не менялись: область — строка правки (с предками / потомками и
        // объединением), взвод живёт только до конца стека beginningEdit (микрозадача): редактор не открылся / перерисовки не было — ничего не меняется.
        // Выключатель fe.ux.boolEditKeepRefresh (дефолт ВКЛ). Счётчик window.__gridEditKeepCache.start
        editKeep_armStart(irow, icol) {
            if (!this.boolEditKeep_on() || this._editKeep?.phase === 'commit') return
            this._editKeep = null
            try {
                const why = this.editKeep_block()
                if (why) { if (why !== 'off') this.editKeep_stat('full', why); return }
                const rows = this.flex.rows, item = rows[irow]?.dataItem
                if (!item) return
                const ek = { phase: 'start', item, row: irow, col: icol, scope: this.editKeep_scope(irow, icol), items: Array.from(rows, r => r.dataItem), sig: this.editKeep_sig(), t: performance.now() }
                this._editKeep = ek
                queueMicrotask(() => { if (ek.phase === 'start' && this._editKeep === ek) this._editKeep = null })
            } catch (e) { this._editKeep = null }
        },
        // взвод второй перерисовки: commitEdit строки правки -> collectionChanged(Change) -> invalidate wijmo (таймер _toInv). Проход — только по ЭТОМУ таймеру:
        // другой invalidate сменит _toInv, синхронный refresh/обработчики того же стека придут до ek.ready (setTimeout 0 раньше таймера wijmo 10 мс)
        editKeep_onCommit(e) {
            const ek = this._editKeep
            if (!ek || ek.phase !== 'wait' || !e || e.action !== wjcCore.NotifyCollectionChangedAction.Change || e.item !== ek.item) return
            if (performance.now() - ek.t > 30000 || this.flex?._toInv == null) { this._editKeep = null; return }
            ek.phase = 'commit'; ek.toInv = this.flex._toInv; ek.ready = false
            setTimeout(() => { ek.ready = true }, 0)
        },
        editKeep_abort(why) {   // проход отменён после editKeep_take: эпоха сдвигается, дальше refreshing() — полный
            this.editKeep_stat('full', why)
            const st = window.__gridEditKeepCache; if (st) st.keep--
            this.irefresh++
        },
        // из refreshing(): точечный ли это проход; взвод расходуется в любом случае
        editKeep_take() {
            const ek = this._editKeep
            if (!ek) return null
            const flex = this.flex
            let ok = false, why = ''
            try {
                if (ek.phase === 'finish' || ek.phase === 'start') ok = true   // IE 2026 10 14 / ODOO-5800: start — refresh(false) startEditing (editKeep_armStart)
                else if (ek.phase === 'commit') ok = ek.ready && flex._toInv != null && flex._toInv === ek.toInv
                if (!ok) why = 'other_refresh'
                else {
                    why = this.editKeep_block()
                    if (!why && this.editKeep_sig() !== ek.sig) why = 'layout'
                    if (!why) { const rows = flex.rows; for (let i = 0; i < rows.length; i++) if (rows[i].dataItem !== ek.items[i]) { why = 'rows'; break } }
                    ok = !why
                }
            } catch (e) { ok = false; why = 'error' }
            if (ek.phase === 'finish' && ok) { ek.phase = 'wait'; ek.sig = this.editKeep_sig() }   // ждём commit этой строки
            else this._editKeep = null
            if (!ok) { if (why !== 'off') this.editKeep_stat('full', why); return null }
            this.editKeep_stat(ek.phase === 'start' ? 'start' : 'keep')
            // IE 2026 10 14 / ODOO-5800: объединённый диапазон ячейки правки ПОСЛЕ записи значения (merge «назад» / mergeColumns читают данные) — его строки в область
            if (ek.col != null && ek.col >= 0) { try { editKeep_addRange(ek.scope, flex.getMergedRange(flex.cells, ek.row, ek.col)) } catch (e) { /* без объединения */ } }
            return ek.scope
        },
        // точечный проход: кэш ячеек — только строк правки / предков / потомков и всех панелей кроме данных; их DOM-ячейки помечены «не отрисованы в эпохе»
        editKeep_pass(scope) {
            const flex = this.flex
            const cellT = String(flex.cells.cellType) + '-'
            for (const k of [...this.cache_data_cells.keys()]) {
                const ks = String(k)
                if (!ks.startsWith(cellT)) { this.cache_data_cells.delete(k); continue }
                const r = +ks.slice(cellT.length, ks.indexOf('-', cellT.length))
                if (scope.has(r)) this.cache_data_cells.delete(k)
            }
            for (const el of flex.hostElement.querySelectorAll('.wj-cell')) {
                const dc = el.data_cell
                if (dc && scope.has(dc.row)) dc.irefresh = -1
            }
            this._editKeepGen = (this._editKeepGen || 0) + 1
            this.editKeep_wrapFactory()
            this._editKeepPass = true
            queueMicrotask(() => { this._editKeepPass = false })   // страховка; штатно — в начале updatedView
        },
        // пропуск ячейки, уже отрисованной в этой эпохе за той же позицией и колонкой (строки и колонки сверены в editKeep_take): содержимое и классы те же,
        // меняется только выделение (Enter переводит курсор) — классы состояния, как в переработке ячеек wijmo (GridPanel._renderCell, recycle)
        editKeep_wrapFactory() {
            const flex = this.flex, cf = flex.cellFactory
            if (!cf || cf.__editKeep === this) return
            const orig = cf.updateCell, vm = this, SS = wjGrid.SelectedState
            cf.updateCell = function (panel, r, c, cell, rng) {
                if (vm._editKeepPass && cell && panel === vm.flex?.cells) {
                    const dc = cell.data_cell
                    if (dc && dc.row === r && dc.col === c && dc.irefresh === vm.irefresh && dc.col_binding === panel.columns[c]?.binding) {
                        const u = panel.getSelectedState(r, c, rng)
                        wjcCore.toggleClass(cell, 'wj-state-active', u === SS.Cursor || u === SS.Active)
                        wjcCore.toggleClass(cell, 'wj-state-selected', u === SS.Cursor)
                        wjcCore.toggleClass(cell, 'wj-state-multi-selected', u === SS.Selected)
                        if (typeof vm.frozenCell_fixStale === 'function') vm.frozenCell_fixStale(panel, c, cell)   // IE 2026 10 15 / ODOO-5800: замороженная колонка — геометрия из состояния штампа в текущее (в правке / нет, прокрутка)
                        const st = window.__gridEditKeepCache; if (st) st.skip++
                        return
                    }
                }
                return orig.apply(this, arguments)
            }
            cf.__editKeep = this
        },
        editRefresh_rows(irow, dataItem) {
            try {
                const flex = this.flex
                if (!flex || flex.isUpdating || this.store.setting('fe.ux.gridEditRefreshRow', true) === false) return false
                if (irow == null || irow < 0 || !dataItem || flex.rows[irow]?.dataItem !== dataItem) return false
                const code = this.attr['code-eval-fe'] || (this.attr.binding === '_doc.data' ? this.WIDGET?.record?.doc?.params?.['code-eval-fe'] : '') || ''
                if (code && String(code).includes('process_dataItem')) return false
                const last = flex.columns.length - 1
                if (last < 0) return false
                const rows = flex.rows
                // IE 2026 10 14 / ODOO-5800 (Igor: остаток замирания при клике по флажку согласования): строка правки и предки — прямым updateCell отрисованных ячеек (fe.ux.boolEditKeepRefresh);
                // refreshRange строки стоил 170–200 мс (wijmo пересобирает клон замороженных целиком; замер dev02 1coh_001 pfperf). Не вышло — прежний путь ниже
                if (this.boolEditKeep_on()) {
                    const anc = []
                    let lv = rows[irow].level
                    for (let i = irow - 1; i >= 0 && lv > 0; i--) { if (rows[i].level < lv) { anc.push(i); lv = rows[i].level } }
                    if (this.editRefresh_cells([irow, ...anc])) { window.__gridEditRefreshRow = (window.__gridEditRefreshRow || 0) + 1; return true }
                }
                flex.refreshRange(new wjGrid.CellRange(irow, 0, irow, last))
                // предки (их py-CSS сброшен css_invalidate_rows) — отложенно, одной пачкой: refreshRange строки стоит 55–135 мс, строка + 3 предка ≈ полный
                // refreshCells. Если до таймера грид перерисовался целиком (refreshing() сдвинул irefresh: Enter → commitEdit → invalidate) — предки уже свежие
                let lvl = rows[irow].level   // строка-группа дерева (GroupRow) — уровень; плоская строка — undefined: предков нет
                const pend = this._editAncPending || (this._editAncPending = new Map())
                for (let i = irow - 1; i >= 0 && lvl > 0; i--) { if (rows[i].level < lvl) { pend.set(i, rows[i].dataItem); lvl = rows[i].level } }
                if (pend.size) {
                    const k = this.irefresh, g = this._editKeepGen   // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL3: точечный проход (editKeep_pass) тоже перерисовал предков
                    window.$cg.setTimeout(this, 'editRefreshAnc', () => {
                        const todo = [...pend]; pend.clear()
                        try {
                            const fl = this.flex
                            if (!fl || this.irefresh !== k || this._editKeepGen !== g) return
                            const l = fl.columns.length - 1
                            for (const [r, it] of todo) if (fl.rows[r]?.dataItem === it) fl.refreshRange(new wjGrid.CellRange(r, 0, r, l))
                        } catch (e) { /* грид закрыт */ }
                    }, 60)
                }
                window.__gridEditRefreshRow = (window.__gridEditRefreshRow || 0) + 1
                return true
            } catch (e) { return false }
        },
        // IE 2026 10 14 / ODOO-5800: перерисовать отрисованные ячейки строк rowsIdx (замороженные колонки + видимый диапазон viewRange) прямым cellFactory.updateCell с заменой
        // копии в клоне замороженных (approvalPartial_cloneCell), как approvalPartial_refreshCells; объединённые ячейки — один раз по верхней левой. false — редактор
        // открыт / клон не сходится / грид закрыт: вызывающий идёт прежним путём (refreshRange). Счётчик window.__gridEditRefreshCells {rows, cells, fail}
        editRefresh_cells(rowsIdx) {
            const st = (window.__gridEditRefreshCells = window.__gridEditRefreshCells || { rows: 0, cells: 0, fail: 0 })
            try {
                const flex = this.flex
                if (!flex || !flex.hostElement || flex.activeEditor || !rowsIdx || !rowsIdx.length) { st.fail++; return false }
                const cells = flex.cells, cf = flex.cellFactory
                if (!cf || typeof cf.updateCell !== 'function') { st.fail++; return false }
                let vr = null
                try { vr = flex.viewRange } catch (e) { vr = null }
                if (!vr) { st.fail++; return false }
                const cols = editRefresh_cols(vr, flex.frozenColumns || 0)
                const clone = this.editRefresh_cloneMap(flex)   // копии .wj-frozen в клоне — один обход на вызов (approvalPartial_cloneCell ищет на каждую ячейку)
                if (clone === false) { st.fail++; return false }
                const seen = new Set()
                for (const r of rowsIdx) {
                    if (r < vr.row || r > vr.row2) continue
                    for (const c of cols) {
                        let rng = null
                        try { rng = flex.getMergedRange(cells, r, c) } catch (e) { rng = null }
                        const r0 = rng && !rng.isSingleCell ? rng.row : r, c0 = rng && !rng.isSingleCell ? rng.col : c
                        const key = r0 + ':' + c0
                        if (seen.has(key)) continue
                        seen.add(key)
                        let el = null
                        try { el = cells.getCellElement(r0, c0) } catch (e) { el = null }
                        if (!el) continue
                        cf.updateCell(cells, r0, c0, el, rng)
                        if (clone && el.classList.contains('wj-frozen')) {
                            const old = clone.get(el)
                            if (!old) { st.fail++; return false }
                            const nu = this.editRefresh_cloneOf(el, old)   // IE 2026 10 14 / ODOO-5800 (pfperf3): с индексом ячейки wijmo
                            clone.fct.replaceChild(nu, old)
                            clone.set(el, nu)
                        }
                        st.cells++
                    }
                    st.rows++
                }
                return true
            } catch (e) { st.fail++; return false }
        },
        // IE 2026 10 14 / ODOO-5800: карта «ячейка .wj-frozen → её копия в клоне замороженных» ([wj-part="fcells"] _fCt — копии по порядку, как строит wijmo _updateFrozenCells);
        // null — клона нет (нечего менять), false — клон не сходится с .wj-frozen (вызывающий идёт прежним путём)
        editRefresh_cloneMap(flex) {
            const fct = flex._fCt, ect = flex._eCt
            if (!fct || !ect || !fct.childElementCount) return null
            const fro = ect.querySelectorAll('.wj-frozen')
            if (fct.childElementCount !== fro.length) return false
            const m = new Map()
            m.fct = fct
            for (let k = 0; k < fro.length; k++) m.set(fro[k], fct.children[k])
            return m
        },
        // IE 2026 10 15 / ODOO-5800 (Igor 15.10, бой fe-2026-10-14-15, 1coh_001: после ✓ПМ и клика по БЮМ левая панель замороженных разъехалась со строками — подписи на
        // несколько строк ниже чисел, часть строк пустые): у wijmo top ячейки замороженной колонки зависит от состояния правки (CellFactory.updateCell: без editRange
        // top = pos + scrollY, в правке top = pos, left = pos + scrollX), а клон собирается копированием ячейки (_updateFrozenCells: cloneNode). Ячейка, нарисованная в
        // одном состоянии и не перерисованная в другом (кэш-путь CustomCellFactory «уже отрисована в эпохе», точечный проход editKeep, прямой updateCell editRefresh_cells /
        // approvalPartial_refreshCells), несёт чужой top — её копия встаёт на scrollY ниже строки. Абсолютно пересчитать нельзя (поверх wijmo FE двигает top/left: breakTop
        // секций, отступ дерева), поэтому ячейка несёт штамп состояния, в котором её считал wijmo (frozenCell_stamp после super.updateCell), а пропущенная перерисовкой
        // ячейка сдвигается из состояния штампа в текущее (frozenCell_fixStale: вход CustomCellFactory.updateCell и пропуск editKeep_wrapFactory); клон после каждой
        // сборки wijmo выравнивается по штампам оригиналов (frozenClone_sync, обёртка _updateFrozenCells в init), копия при точечной замене — так же (frozenClone_copyPos).
        // utils/frozenClone; выключатель fe.ux.frozenCloneSync (дефолт ВКЛ). Только левые замороженные колонки панели данных без замороженных строк и RTL (у прочих
        // wijmo кладёт top-for-clone / left-for-clone — не трогаем). Счётчик window.__frozenCloneSync {pass, fixed, cells, stale, skip}
        // IE 2026 10 25 / ODOO-348925 (заказ Игоря: заголовок группы колонок по align): align группы колонок в её заголовке (свёрнутой и развёрнутой). Выключатель fe.ux.colgroupHeaderAlign (дефолт ВКЛ).
        // Группа — элемент flex.getColumnGroups() (живой ColumnGroup) с вложенными колонками, её прямоугольник _rng (row, col..col2; скрытые колонки свёрнутой группы входят);
        // align — columnGroup.align (attr.align). Только center / right: без align и left — прежнее поведение (подпись группы слева, липнет при прокрутке).
        colgroupHdr_on() { try { return this.store.setting('fe.ux.colgroupHeaderAlign', true) !== false } catch (e) { return true } },
        colgroupHdr_align(rng, row, col) {
            try {
                if (!this.colgroupHdr_on()) return ''
                const cgs = this.flex?.getColumnGroups?.()   // живые группы (flex.columnGroups отдаёт описания без _rng)
                if (!cgs || !cgs.length) return ''
                let m = this._cgHdr
                if (!m || m.src !== cgs) {
                    m = this._cgHdr = { src: cgs, rows: new Map() }
                    const walk = (gs) => { for (const g of gs || []) { if (g && g.columns && g.columns.length) { const r = g._rng; if (r) { const a = m.rows.get(r.row) || []; a.push({ g, c1: Math.min(r.col, r.col2), c2: Math.max(r.col, r.col2) }); m.rows.set(r.row, a) } walk(g.columns) } } }
                    walk(cgs)
                }
                const r0 = rng ? rng.row : row, c0 = rng ? rng.col : col
                const hit = (m.rows.get(r0) || []).find(x => c0 >= x.c1 && c0 <= x.c2)
                const al = hit ? String(hit.g.align || '').toLowerCase() : ''
                return al === 'center' || al === 'right' ? al : ''
            } catch (e) { return '' }
        },
        frozenClone_on() { try { return frozenCloneSync_flagOn((k, d) => this.store.setting(k, d)) } catch (e) { return true } },
        frozenCell_isFz(panel, col) {   // ячейка замороженной (левой) колонки панели данных — наш случай
            const flex = this.flex
            return !!flex && !!panel && panel === flex.cells && flex.frozenColumns > 0 && col < flex.frozenColumns && !flex.frozenRows && !flex.rightToLeft
        },
        frozenCell_cur(flex) { return frozenCell_state(flex.editRange, flex.scrollPosition) },
        frozenCell_stamp(panel, col, cell) {   // после super.updateCell (CustomCellFactory._process): состояние, в котором wijmo посчитал геометрию ячейки
            try { if (cell && this.frozenCell_isFz(panel, col) && this.frozenClone_on()) cell[FROZEN_STAMP_KEY] = this.frozenCell_cur(this.flex) } catch (e) { /* без штампа — как раньше */ }
        },
        frozenCell_fixStale(panel, col, cell) {   // ячейка, которую перерисовка пропускает: геометрия — сдвигом из состояния штампа в текущее; true — сдвинута
            try {
                const st = cell && cell[FROZEN_STAMP_KEY]
                if (!st || !this.frozenCell_isFz(panel, col) || !this.frozenClone_on()) return false
                const cur = this.frozenCell_cur(this.flex), d = frozenCell_delta(st, cur)
                if (!d || (!d.top && !d.left)) return false
                frozenCell_shift(cell.style, d)
                cell[FROZEN_STAMP_KEY] = cur
                const S = (window.__frozenCloneSync = window.__frozenCloneSync || { pass: 0, fixed: 0, cells: 0, stale: 0, skip: 0 }); S.stale++
                return true
            } catch (e) { return false }
        },
        frozenClone_copyPos(el, nu) {   // копия el в клоне (editRefresh_cloneOf): top/left — как у el в состоянии «без правки» при текущей прокрутке; false — штампа нет (позиция старой копии)
            try {
                const st = el && el[FROZEN_STAMP_KEY], flex = this.flex
                if (!st || !flex || !nu || !nu.style || !this.frozenClone_on()) return false
                const cur = this.frozenCell_cur(flex), d = frozenCell_delta(st, { edit: false, sx: cur.sx, sy: cur.sy })
                nu.style.top = ((parseFloat(el.style.top) || 0) + d.top) + 'px'
                nu.style.left = Math.round((parseFloat(el.style.left) || 0) + d.left) + 'px'
                return true
            } catch (e) { return false }
        },
        frozenClone_sync() {   // после сборки клона wijmo (обёртка _updateFrozenCells в init): копии — по штампам оригиналов; число поправленных
            try {
                const flex = this.flex, fct = flex && flex._fCt, ect = flex && flex._eCt
                if (!fct || !ect || !fct.childElementCount || !this.frozenCell_isFz(flex.cells, 0) || !this.frozenClone_on()) return 0
                const S = (window.__frozenCloneSync = window.__frozenCloneSync || { pass: 0, fixed: 0, cells: 0, stale: 0, skip: 0 })
                const n = frozenClone_fix(fct.children, ect.querySelectorAll('.wj-frozen'), FROZEN_STAMP_KEY, this.frozenCell_cur(flex))
                S.pass++; S.cells += fct.childElementCount
                if (n < 0) S.skip++; else S.fixed += n
                return n < 0 ? 0 : n
            } catch (e) { return 0 }
        },
        // transpose: рекурсивный поиск строки (иерархия через childItemsPath)
        transpose_findRow(rows, match, childItemsPath = 'attrs') {
            for (const row of rows || []) {
                if (match(row)) {
                    return row
                }
                if (Array.isArray(row[childItemsPath])) {
                    const found = this.transpose_findRow(row[childItemsPath], match, childItemsPath)
                    if (found) {
                        return found
                    }
                }
            }
            return null
        },
        // transpose: правка в транспонированном гриде (_doc.data) → грид-источник (doc.data);
        // строка = мера (row.measure.binding), колонка = период (binding == date_binding строки источника)
        transpose_syncToSource(dataItem, col_binding, newVal) {
            const measure_binding = dataItem?.measure?.binding
            if (!measure_binding) {
                return
            }
            const attr_source = this.store.get_field(this.WIDGET.view, this.attr.binding_transpose)
            const binding_source = attr_source?.binding || this.attr.binding_transpose
            const data_source = this.store.get_value(this.WIDGET.record, binding_source)
            if (!Array.isArray(data_source)) {
                return
            }
            const rowD = this.transpose_findRow(data_source, row => row.date_binding === col_binding, attr_source?.childItemsPath || 'attrs')
            if (!rowD) {
                return // строки периода нет — ячейка вне горизонта данных, новую не создаём
            }
            if (rowD[measure_binding] !== newVal) {
                rowD[measure_binding] = newVal
                this.WIDGET.vueObj?.get_vueObj?.(attr_source?.name || binding_source)?.flexRefresh?.()
            }
        },
        // transpose: правка в гриде-источнике (doc.data) → транспонированные гриды (_doc.data),
        // у которых binding_transpose указывает на это поле
        transpose_syncFromSource(dataItem, col_binding, newVal) {
            for (const attrT of this.store.get_fieldAll(this.WIDGET.view, true, 'transpose')) {
                if (!attrT.binding_transpose || attrT === this.attr) {
                    continue
                }
                if (this.store.get_field(this.WIDGET.view, attrT.binding_transpose) !== this.attr) {
                    continue
                }
                const dataT = this.store.get_value(this.WIDGET.record, attrT.binding)
                if (!Array.isArray(dataT)) {
                    continue
                }
                const rowT = this.transpose_findRow(dataT, row => row.measure?.binding === col_binding, attrT.childItemsPath || 'attrs')
                if (rowT && rowT[dataItem.date_binding] !== newVal) {
                    rowT[dataItem.date_binding] = newVal
                    this.WIDGET.vueObj?.get_vueObj?.(attrT.name || attrT.binding)?.flexRefresh?.()
                }
            }
        },
        // transpose: row.measure — дубль параметров колонки для ячеек-значений (колонок-периодов);
        // служебные колонки и заголовок мер (measure.*) не переопределяются
        transpose_measure(attr_col, dataItem) {
            // formatRowsAsColumns (widget-row): строка = колонка источника (dataItem.attr) —
            // ячейка значения форматируется её параметрами, тем же пайплайном, что transpose
            if (this.attr.formatRowsAsColumns && this.attr.attr_type === 'AttrTabGrid') {
                const binding_col = attr_col?.binding
                return ((binding_col === 'attr.valueStr' || binding_col === 'attr' || binding_col === 'attr.value') && dataItem?.attr)
                    ? dataItem.attr : null
            }
            if (!this.attr.transpose || !dataItem?.measure) {
                return null
            }
            const binding = attr_col?.binding || ''
            if (!binding || binding.startsWith('measure') || ['selector', 'visibleChart', 'use', 'title'].includes(binding)) {
                return null
            }
            return dataItem.measure
        },
        // transpose: значение-объект {value, attr_type, cssStyle, ...} — параметры ячейки (высший приоритет)
        transpose_cellObject(value) {
            return (value && typeof value === 'object' && !Array.isArray(value) && 'value' in value) ? value : null
        },
        // IE 2026 09 05 / ODOO-336330: пустое поле формы настроек (AttrTabGrid, ячейка значения) показывает кодовый
        // дефолт (attr.placeholder) серым курсивом. Именно placeholder, а не attr.default: default бэк
        // материализует в doc записи (attrs.prepare_attrs), и он уехал бы в doc.params при сохранении;
        // placeholder — только отрисовка. Контент не в кэше (_cache.className/cssText) — вызывается и на
        // быстром пути formatItem, иначе плейсхолдер пропадал у строк, прокрученных в кадр повторно
        placeholder_apply(e_cell, dataItem, col_binding) {
            if (this.attr?.attr_type !== 'AttrTabGrid' || col_binding !== 'attr.valueStr') return
            const A = dataItem?.attr
            if (!A || typeof A !== 'object' || A.placeholder === undefined || A.placeholder === null || A.placeholder === '') return
            if (!this.store.isEmpty(A.value) || e_cell.querySelector('input') || e_cell.querySelector('.cell-placeholder')) return
            if (String(e_cell.textContent || '').trim()) return
            const ph = document.createElement('span')
            ph.className = 'cell-placeholder'
            ph.textContent = String(A.placeholder)
            e_cell.appendChild(ph)
        },
        attr_set() {
            let meta = this.WIDGET.record._meta
            if (meta.type === 'widget-row-viewParams') {
                this.store.attr_set(this.WIDGET, this.attr, this.data)
            }
            this.useCount_apply()
            this.aggAll_sourceChanged() // сводная таблица правил: write-back/пересборка
        },
        // useCount: счётчик активных строк грида в поле строки-владельца
        // (useCount_binding/useCount_source на конфиг-узле AttrGrid; зеркало бэка
        // common_modules/attrs.py > count_use_rows / useCount_apply). Живой пересчёт
        // между запросами — бэк проставляет те же значения при каждом select
        countUseRows(rows, child = 'attrs') {
            let n = 0
            for (const r of rows ?? []) {
                if (!r || r.use === false) continue // use=false отсекает всё поддерево
                n += 1 + this.countUseRows(r[child], child)
            }
            return n
        },
        useCount_count(rows, gridNode) {
            const child = gridNode.childItemsPath || 'attrs'
            const source = gridNode.useCount_source
            if (!source) {
                return this.countUseRows(rows, child)
            }
            // сумма активных строк вложенного грида row[source] по активным строкам rows
            const walk = (rr) => {
                let s = 0
                for (const r of rr ?? []) {
                    if (!r || r.use === false) continue
                    s += this.countUseRows(r[source]) + walk(r[child])
                }
                return s
            }
            return walk(rows)
        },
        useCount_apply(depth = 0) {
            const attr = this.attr
            if (typeof attr?.binding !== 'string' || !attr.binding) return
            const parentGrid = this.useCount_parentGrid()
            if (attr.useCount_binding && !attr.binding.startsWith('_')) {
                const [owner, key] = this.store.attr_get_link(this.WIDGET, { binding: attr.binding })
                if (this.store.isinstance_dict(owner)) {
                    const n = this.useCount_count(owner[key], attr)
                    if (n) {
                        owner[attr.useCount_binding] = n
                    } else {
                        delete owner[attr.useCount_binding] // 0 — ключ снимается, ячейка-индикатор пустая
                    }
                    parentGrid?.flex?.invalidate() // ячейки-индикаторы строки-владельца
                }
            }
            // изменение этого грида меняет счётчик грида-владельца: его useCount_source
            // (правка правила в попапе поля -> индикатор Cond. format/F в гриде лэйаута)
            // или его иерархия childItemsPath
            const parentAttr = parentGrid?.attr
            if (depth < 5 && parentAttr?.useCount_binding
                && (parentAttr.useCount_source === attr.binding || (parentAttr.childItemsPath || 'attrs') === attr.binding)) {
                parentGrid.useCount_apply(depth + 1)
            }
        },
        useCount_parentGrid() {
            // грид родительского виджета, отображающий строку-владельца данных этого грида
            const meta = this.WIDGET.record?._meta
            if (this.WIDGET.widget !== 'widget-row' || !meta?.binding
                || meta.type === 'widget-row-viewParams' || this.WIDGET.parentWIDGET?.id === undefined) return null
            const parentWIDGET = this.store.findWidget(this.WIDGET.parentWIDGET.id)?.WIDGET
            let vueObj = meta.name ? parentWIDGET?.vueObj?.get_vueObj?.(meta.name) : null
            if (vueObj?.attr?.binding !== meta.binding) {
                vueObj = parentWIDGET?.vueObj?.get_vueObj?.(meta.binding)
            }
            return (vueObj?.flex && vueObj.attr?.binding === meta.binding) ? vueObj : null
        },
        useCount_findDecl(binding) {
            // декларация useCount может быть не на колонке-узле с чипсами, а на
            // одноимённом AttrGrid-узле карточки строки этого грида (attr.view;
            // как в findFieldBranches: attrs у грида — колонки, view — карточка
            // строки). BFS по view+attrs — менее вложенный узел приоритетнее
            // (не зацепить одноимённый грид из карточки вложенной строки,
            // например conditional_format внутри fields)
            const bfs = (attrs) => {
                let level = [...(attrs || [])]
                while (level.length) {
                    const next = []
                    for (const a of level) {
                        if (!a) continue
                        if (a.binding === binding && a.attr_type === 'AttrGrid' && a.useCount_binding) {
                            return a
                        }
                        if (Array.isArray(a.view)) next.push(...a.view)
                        if (Array.isArray(a.attrs)) next.push(...a.attrs)
                    }
                    level = next
                }
                return null
            }
            return bfs(this.attr?.view) || bfs(this.attr?.attrs) || bfs(this.WIDGET?.view)
        },
        useCount_cellApply(dataItem, attr_col) {
            // правка чипсов в AttrGrid-ячейке (⊗ / добавление / DnD — мимо attr_set):
            // attr_col — конфиг-узел вложенного грида, dataItem — строка-владелец
            if (!dataItem || !attr_col?.binding) return
            const decl = attr_col.useCount_binding ? attr_col : this.useCount_findDecl(attr_col.binding)
            if (decl) {
                const n = this.useCount_count(this.store.get_value(dataItem, attr_col.binding), decl)
                if (n) {
                    dataItem[decl.useCount_binding] = n
                } else {
                    delete dataItem[decl.useCount_binding]
                }
                this.flex?.invalidate() // ячейки-индикаторы этой же строки
            }
            // вложенные данные изменились — собственный счётчик этого грида
            // (useCount_source: чипс правила в колонке Conditional format грида fields
            // -> _cf_fields строки лэйаута; или иерархия childItemsPath)
            const attr = this.attr
            if (attr?.useCount_binding
                && (attr.useCount_source === attr_col.binding || (attr.childItemsPath || 'attrs') === attr_col.binding)) {
                this.useCount_apply()
            }
        },
        // row_ids: постоянные ключи строк табличных частей (row_ids: true на
        // конфиг-узле AttrGrid; зеркало бэка common_modules/attrs.py >
        // row_ids_apply). row_id — 12 hex, хранится в строке, уникален в
        // пределах всей записи корневого виджета (на строку ссылаются другие
        // таблицы — source_row_id сводной таблицы правил усл. оформления).
        // Существующий валидный ключ не перегенерируется (рвутся ссылки);
        // исключение — клонирование: у всех клонов ключи новые
        rowId_isValid(id) {
            return typeof id === 'string' && /^[0-9a-f]{12}$/.test(id)
        },
        rowId_new(have) {
            let id
            do {
                id = crypto.randomUUID
                    ? crypto.randomUUID().replace(/-/g, '').slice(0, 12)
                    : Array.from(crypto.getRandomValues(new Uint8Array(6)), b => b.toString(16).padStart(2, '0')).join('')
            } while (have.has(id))
            have.add(id)
            return id
        },
        rowIds_record() {
            // запись корневого виджета: данные грида widget-row слинкованы
            // в неё по цепочке parentWIDGET (см. attr_get_link)
            let WIDGET = this.WIDGET, iter = 0
            while (WIDGET?.widget === 'widget-row' && WIDGET.parentWIDGET?.id !== undefined && iter++ < 20) {
                const parent = this.store.findWidget(WIDGET.parentWIDGET.id)?.WIDGET
                if (!parent) break
                WIDGET = parent
            }
            return WIDGET?.record
        },
        rowIds_have(exclude = null) {
            // занятые ключи записи; exclude — объекты строк этого грида
            // (rowIds_check раздаёт их ключи заново — сами себя не «занимают»)
            const have = new Set(), seen = new WeakSet()
            const walk = (node) => {
                if (Array.isArray(node)) {
                    for (const n of node) walk(n)
                    return
                }
                if (!this.store.isinstance_dict(node) || seen.has(node)) return
                seen.add(node)
                if (typeof node.row_id === 'string' && !exclude?.has(node)) {
                    have.add(node.row_id)
                }
                for (const k in node) {
                    if (k.startsWith('_')) continue // рантайм/копии (_meta, _fe, _doc, _childs)
                    walk(node[k])
                }
            }
            walk(this.rowIds_record()?.doc)
            walk(this.data)
            return have
        },
        rowIds_contains(node) {
            // есть ли в поддереве хоть один row_id (строки вложенных
            // ключуемых гридов — даже если сам грид не ключуется)
            if (Array.isArray(node)) return node.some(n => this.rowIds_contains(n))
            if (!this.store.isinstance_dict(node)) return false
            if ('row_id' in node) return true
            for (const k in node) {
                if (!k.startsWith('_') && this.rowIds_contains(node[k])) return true
            }
            return false
        },
        rowIds_walk(node, have, regenerate, seen = new WeakSet()) {
            // существующие ключи поддерева, включая вложенные ключуемые гриды:
            // клон (regenerate) — все новые; вставка — новые только
            // невалидным/занятым (вставка вырезанного ключ сохраняет)
            if (Array.isArray(node)) {
                for (const n of node) this.rowIds_walk(n, have, regenerate, seen)
                return
            }
            if (!this.store.isinstance_dict(node) || seen.has(node)) return
            seen.add(node)
            if ('row_id' in node) {
                if (regenerate || !this.rowId_isValid(node.row_id) || have.has(node.row_id)) {
                    node.row_id = this.rowId_new(have)
                } else {
                    have.add(node.row_id)
                }
            }
            for (const k in node) {
                if (k === 'row_id' || k.startsWith('_')) continue
                this.rowIds_walk(node[k], have, regenerate, seen)
            }
        },
        rowIds_newRow(dataItem_new, clone = false) {
            // new_Click/rowAdded: ключ добавленной строке; клону — новые ключи
            // по всему поддереву (подчинённые строки, правила conditional_format
            // склонированного поля)
            const need_own = !!this.attr.row_ids
            const need_clone = clone && this.rowIds_contains(dataItem_new)
            if (!need_own && !need_clone) return
            const have = this.rowIds_have()
            if (need_clone) {
                this.rowIds_walk(dataItem_new, have, true)
            }
            if (need_own && !this.rowId_isValid(dataItem_new.row_id)) {
                dataItem_new.row_id = this.rowId_new(have)
            }
        },
        rowIds_insert(items) {
            // insertAction (вставка из буфера/copiedData): занятые в записи или
            // невалидные ключи — новые (have собран до вставки: ключи
            // вырезанных строк уже свободны и сохраняются), отсутствующие
            // у строк иерархии грида — дозаполнить
            if (!Array.isArray(items)) return
            const need_own = !!this.attr.row_ids
            if (!need_own && !this.rowIds_contains(items)) return
            const have = this.rowIds_have()
            this.rowIds_walk(items, have, false)
            if (!need_own) return
            const child = this.attr.childItemsPath || 'attrs'
            const ensure = (rows) => {
                for (const r of rows ?? []) {
                    if (!this.store.isinstance_dict(r)) continue
                    if (!this.rowId_isValid(r.row_id)) {
                        r.row_id = this.rowId_new(have)
                    }
                    ensure(r[child])
                }
            }
            ensure(items)
        },
        rowIds_check() {
            // при получении записи: наличие и уникальность по всей записи —
            // для записей, открытых мимо select, и гридов, которые бэк не
            // обходит (правила усл. оформления полей DS). Идемпотентно:
            // валидный уникальный ключ сохраняется. Сводные таблицы
            // (agg_sources) не проверяются: их строки — копии строк
            // источников, совпадение ключей с doc легитимно и обязательно
            // (keyed-связь aggAll_build/writeBack); row_ids: true на сводном
            // гриде нужен клону (rowIds_newRow). Identity-режим ("All"
            // отжата) — this.data сама таблица источника, проверка нужна
            if (!this.attr.row_ids || !Array.isArray(this.data)
                || (this.aggAll_isSummary() && !this.aggAll_identityMode())) return
            const child = this.attr.childItemsPath || 'attrs'
            const own = new WeakSet()
            const collect = (rows) => {
                for (const r of rows ?? []) {
                    if (!this.store.isinstance_dict(r) || own.has(r)) continue
                    own.add(r)
                    collect(r[child])
                }
            }
            collect(this.data)
            const have = this.rowIds_have(own)
            const seen = new WeakSet() // CHIP-Tree (_childs): строка и в плоском списке, и ребёнком
            const assign = (rows) => {
                for (const r of rows ?? []) {
                    if (!this.store.isinstance_dict(r) || seen.has(r)) continue
                    seen.add(r)
                    if (!this.rowId_isValid(r.row_id) || have.has(r.row_id)) {
                        r.row_id = this.rowId_new(have)
                    } else {
                        have.add(r.row_id)
                    }
                    assign(r[child])
                }
            }
            assign(this.data)
        },
        // --- Сводные таблицы (общий механизм agg_sources на конфиг-узле
        // AttrGrid; конфиг — бэк, config_widgets.py). Потребители: сводная
        // таблица правил условного оформления (_doc.conditional_format_all)
        // и сводная таблица полей лэйаута (_doc.viewList_all). Хранение
        // и применение данных остаются на местах: агрегат — только
        // представление, собирается фронтом (aggAll_build), правки
        // выкапируются в таблицы-источники (aggAll_writeBack). _doc не
        // сохраняется и бэком не заполняется. Ключ соответствия — row_id
        aggAll_isSummary() {
            return Array.isArray(this.attr.agg_sources) && this.attr.agg_sources.length > 0
        },
        aggAll_mainIsrc() {
            // основной источник — без '[]' в binding (собственные строки
            // записи, Report у cf-all); нет такого — первый источник
            const i = this.attr.agg_sources.findIndex(s => !String(s.binding || '').includes('[]'))
            return i >= 0 ? i : 0
        },
        aggAll_isExtraRow(row) {
            // строка дополнительного источника (скрыта при отжатом "All");
            // строки без _aggAll_isrc (новые) — основной источник
            return this.store.isinstance_dict(row) && row._aggAll_isrc !== undefined
                && row._aggAll_isrc !== this.aggAll_mainIsrc()
        },
        aggAll_mainDef() {
            // основной источник, если он — таблица записи (без '[]');
            // у viewList-all такого нет → null
            const def = this.attr.agg_sources?.[this.aggAll_mainIsrc()]
            return String(def?.binding || '').includes('[]') ? null : def
        },
        aggAll_identityMode() {
            // "All" отжата и основной источник — таблица записи: грид
            // показывает и правит её напрямую (this.data — сам массив
            // источника, без копий, write-back не нужен)
            return this.aggAll_isSummary() && !this.aggAll_showAll && !!this.aggAll_mainDef()
        },
        aggAll_extraCount() {
            // строки доп. источников (появятся при нажатии "All") — счёт по
            // источникам: this.data при отжатом "All" агрегат не содержит
            let n = 0
            const main = this.aggAll_mainIsrc()
            this.aggAll_walkSources(({ isrc, container }) => {
                if (isrc === main) return
                for (const r of container ?? []) {
                    if (this.store.isinstance_dict(r)) n++
                }
            })
            return n
        },
        aggAll_updateAllButton() {
            // состояние и badge кнопки "All" без пересборки панели
            const btn = (this.commandPanel || []).find(a => a.name === 'button-aggAll_showAll')
            if (btn) {
                btn.active = this.aggAll_showAll
                btn.countItems = this.aggAll_extraCount()
                // IE 2026 09 23 / ODOO-341407: i18n
                btn.tooltip = this.aggAll_showAll ? t('Main source rows only') : t('Rows from all sources')
            }
        },
        aggAll_showAll_toggle() {
            if (!this.aggAll_isSummary()) return
            this.aggAll_showAll = !this.aggAll_showAll
            // полная пересборка: источник данных (таблица основного
            // источника ↔ агрегат, content_Changed_main), колонки
            // ('v-if': 'agg_sources' — Stored in видна только при нажатом
            // "All") и фильтр строк set_itemsSource
            this.content_Changed_main()
            if (this.flex) {
                this.flex.deferUpdate(() => {
                    this.load_data()
                    this.rowHeaders()
                })
            }
            this.aggAll_updateAllButton()
        },
        aggAll_walkSources(cb) {
            // контейнеры в порядке agg_sources / строк-владельцев; '[]' в
            // binding — по строкам таблицы, включая подчинённые (attrs) на
            // каждом уровне; нумерация в пути — плоский обход таблицы без
            // учёта иерархии, с 1. Путь дополняется ключом контейнера
            // ('data_layout2[3].fields'), когда контейнеры источников
            // различаются (fields/values) — иначе он один и очевиден
            // (conditional_format: 'data_layout2[3]')
            const record = this.rowIds_record()
            if (!record) return
            // ключ контейнера — последний сегмент binding (и для источника
            // без '[]': 'doc.params.conditional_format' → 'conditional_format')
            const contKeyOf = (b) => String(b || '').split('[].').pop().split('.').pop()
            const contKeys = new Set(this.attr.agg_sources.map(s => contKeyOf(s.binding)))
            const withContKey = contKeys.size > 1
            for (let isrc = 0; isrc < this.attr.agg_sources.length; isrc++) {
                const def = this.attr.agg_sources[isrc]
                const segs = String(def.binding || '').split('[].')
                const contKey = contKeyOf(def.binding)
                // отображаемые имена уровней пути — из title источника
                // ('View.Fields' → 'View[1].Fields[2]'); лишний сегмент title
                // именует контейнер ('View.Fields' для '...data_layout2[].fields'
                // → 'View[1].Fields'); без title — имена из binding
                const titleSegs = String(def.title || '').split('.').filter(Boolean)
                if (segs.length === 1) {
                    cb({ def, isrc, segs, contKey, owner: null, ownerChain: [], ownerPath: titleSegs.join('.') || t('Report'),   // IE 2026 09 23 / ODOO-341407: i18n
                        container: this.store.get_value(record, segs[0]) })
                    continue
                }
                const tableName0 = segs[0].split('.').pop()
                const contTitle = titleSegs[segs.length - 1]
                const walkLevel = (rows, ilevel, chain, pathPrefix) => {
                    const tableKey = titleSegs[ilevel] || (ilevel === 0 ? tableName0 : segs[ilevel])
                    let n = 0
                    const flat = (rr) => {
                        for (const row of rr ?? []) {
                            if (!this.store.isinstance_dict(row)) continue
                            n++
                            const path = `${pathPrefix}${tableKey}[${n}]`
                            if (ilevel === segs.length - 2) {
                                cb({ def, isrc, segs, contKey, owner: row, ownerChain: [...chain, row],
                                    ownerPath: contTitle ? `${path}.${contTitle}` : (withContKey ? `${path}.${contKey}` : path),
                                    container: row[contKey] })
                            } else {
                                walkLevel(row[segs[ilevel + 1]], ilevel + 1, [...chain, row], path + '.')
                            }
                            flat(row.attrs)
                        }
                    }
                    flat(rows)
                }
                walkLevel(this.store.get_value(record, segs[0]), 0, [], '')
            }
        },
        aggAll_syncRule(src, oldByKey, strip = null) {
            // копия строки с переиспользованием прежнего объекта по row_id
            // (реактивность, фокус и раскрытие строк не теряются); вложенные
            // ключуемые гриды (attrs, conditional_format, fields, ...) —
            // рекурсивно тем же keyed-алгоритмом, in place в существующий
            // массив: открытые гриды держат на него ссылку
            const copy = structuredClone(src)
            if (strip) {
                for (const k of strip) delete copy[k]
            }
            const row = (typeof src.row_id === 'string' && oldByKey.get(src.row_id)) || {}
            for (const k in row) {
                if (!(k in copy)) delete row[k]
            }
            for (const k in copy) {
                const isKeyedGrid = Array.isArray(copy[k])
                    && copy[k].some(it => this.store.isinstance_dict(it) && typeof it.row_id === 'string')
                if (isKeyedGrid) {
                    const next = copy[k].map(it => this.store.isinstance_dict(it)
                        ? this.aggAll_syncRule(it, oldByKey, strip) : it)
                    if (Array.isArray(row[k])) {
                        row[k].splice(0, row[k].length, ...next)
                    } else {
                        row[k] = next
                    }
                } else {
                    row[k] = copy[k]
                }
            }
            return row
        },
        aggAll_collectByKey(rows, map = new Map()) {
            // строки по row_id, включая вложенные ключуемые гриды (attrs,
            // conditional_format, ...) — для keyed-reuse в aggAll_syncRule
            for (const r of rows ?? []) {
                if (!this.store.isinstance_dict(r)) continue
                if (typeof r.row_id === 'string' && !map.has(r.row_id)) {
                    map.set(r.row_id, r)
                }
                for (const k in r) {
                    if (!k.startsWith('_') && Array.isArray(r[k])) {
                        this.aggAll_collectByKey(r[k], map)
                    }
                }
            }
            return map
        },
        aggAll_build() {
            // пересборка агрегата из источников (keyed по row_id);
            // true — состав/содержимое изменились
            if (!this.aggAll_isSummary() || this._aggAll_writingBack) return false
            const record = this.rowIds_record()
            if (!record) return false
            let aggr = this.store.get_value(record, this.attr.binding)
            if (!Array.isArray(aggr)) {
                this.store.set_value(record, this.attr.binding, [])
                aggr = this.store.get_value(record, this.attr.binding)
            }
            const before = JSON.stringify(aggr)
            const oldByKey = this.aggAll_collectByKey(aggr)
            const rows = []
            const _cfStats = this.cfStats_map()   // IE 2026 09 20 / ODOO-5800 (Igor: колонка Selector и статистика грида Conditional format, чипс условного оформления CHIP-Format): статистика правил по row_id
            this.aggAll_walkSources(({ isrc, contKey, owner, ownerPath, container }) => {
                for (const rule of container ?? []) {
                    if (!this.store.isinstance_dict(rule)) continue
                    const row = this.aggAll_syncRule(rule, oldByKey)
                    if (_cfStats && owner && typeof rule.row_id === 'string') cfStats_applyRow(row, _cfStats.get(rule.row_id))   // правило вложенного источника цифр в себе не несёт
                    // служебные поля группы Source — только на строках агрегата;
                    // контейнер write-back определяется парой
                    // (source_row_id, source_grid)
                    row.source_row_id = owner?.row_id || ''
                    row.source_grid = contKey
                    row.source_title = owner ? (owner.title ?? '') : ''
                    // путь + Title строки-источника через тире ('Fields[1]-Object')
                    row.source_row_title = row.source_title ? `${ownerPath}-${row.source_title}` : ownerPath
                    row.source_binding = owner ? (owner.binding ?? '') : ''
                    row._aggAll_isrc = isrc // источник строки (переход source_link)
                    rows.push(row)
                }
            })
            aggr.splice(0, aggr.length, ...rows)
            return JSON.stringify(aggr) !== before
        },
        aggAll_writeBack() {
            // агрегат → источники: keyed-замена правил контейнеров, состав/
            // порядок/содержимое которых изменились, в порядке следования в
            // агрегате; source_* в источник не копируются. Пустой
            // source_row_id — правила отчёта (туда же попадают новые строки).
            // В identity-режиме сюда попадают только правки копии агрегата
            // (aggAll_afterChange(aggregate_edit)) — правки самого грида идут
            // прямо в источник и write-back не планируют
            if (!this.aggAll_isSummary() || this._aggAll_writingBack) return
            const record = this.rowIds_record()
            const aggr = this.store.get_value(record || {}, this.attr.binding)
            if (!record || !Array.isArray(aggr)) return
            this._aggAll_writingBack = true
            try {
                // ключи новым строкам агрегата (row_ids на агрегате не
                // объявлен — _doc бэк не обходит); have учитывает и агрегат
                // (rowIds_have обходит this.data)
                const have = this.rowIds_have()
                const ensure = (rr) => {
                    for (const r of rr ?? []) {
                        if (!this.store.isinstance_dict(r)) continue
                        if (!this.rowId_isValid(r.row_id)) {
                            r.row_id = this.rowId_new(have)
                        }
                        ensure(r.attrs)
                    }
                }
                ensure(aggr)

                const SOURCE_KEYS = ['source_row_id', 'source_grid', 'source_row_title', 'source_title', 'source_binding', '_aggAll_isrc']
                // контейнер = пара (source_row_id, source_grid); строка без
                // обоих — в дефолтный контейнер: источник без '[]' (Report
                // у cf-all; у viewList-all его нет — добавление отключено,
                // allowAddNew: false)
                const defaultDef = this.attr.agg_sources.find(s => !String(s.binding || '').includes('[]'))
                const defaultKey = defaultDef ? '|' + String(defaultDef.binding).split('.').pop() : null
                const groups = new Map()
                for (const row of aggr) {
                    if (!this.store.isinstance_dict(row)) continue
                    const rid = typeof row.source_row_id === 'string' ? row.source_row_id : ''
                    let key = rid + '|' + (row.source_grid || '')
                    if (key === '|' && defaultKey) {
                        key = defaultKey
                    }
                    if (!groups.has(key)) groups.set(key, [])
                    groups.get(key).push(row)
                }
                const changedBindings = new Set()
                this.aggAll_walkSources(({ segs, contKey, owner, ownerChain, container }) => {
                    if (owner && !owner.row_id) return // владелец без ключа — не матчится
                    const key = (owner?.row_id || '') + '|' + contKey
                    const desired = groups.get(key) ?? []
                    groups.delete(key)
                    const cur = Array.isArray(container) ? container : []
                    const curJson = JSON.stringify(cur)
                    const oldByKey = this.aggAll_collectByKey(cur)
                    // IE 2026 09 20 / ODOO-5800 (Igor: колонка Selector и статистика грида Conditional format, чипс условного оформления CHIP-Format): расчётные поля статистики, подмешанные строкам вложенных
                    // источников, в правила записи не уезжают
                    const _strip = (owner && this.formatSel_grid()) ? [...SOURCE_KEYS, ...CF_STATS_KEYS, '_DLRow'] : SOURCE_KEYS
                    const next = desired.map(r => this.aggAll_syncRule(r, oldByKey, _strip))
                    if (JSON.stringify(next) === curJson) return
                    // замена содержимого in place: гриды-источники держат
                    // ссылку на массив контейнера
                    if (Array.isArray(container)) {
                        container.splice(0, container.length, ...next)
                    } else if (next.length) {
                        if (owner) {
                            this.store.set_value(owner, contKey, next)
                        } else {
                            this.store.set_value(record, segs[0], next)
                        }
                    } else {
                        return
                    }
                    changedBindings.add(segs[0])
                    this.aggAll_recount(segs, ownerChain)
                })
                if (changedBindings.size) {
                    // обновить живые гриды-источники этого виджета
                    for (const binding of changedBindings) {
                        const vueObj = this.WIDGET.vueObj?.get_vueObj?.(binding)
                        if (vueObj?.content_Changed && vueObj !== this) {
                            vueObj.content_Changed()
                        }
                    }
                    // другие сводные таблицы виджета смотрят на те же источники
                    for (const summary of this.aggAll_summaryGrids()) {
                        if (summary !== this) {
                            summary.aggAll_scheduleRebuild()
                        }
                    }
                }
            } finally {
                this._aggAll_writingBack = false
            }
            // пересборка возвращает порядок по источникам (перестановка под
            // чужой источник — строка возвращается на место) и обновляет
            // нумерацию source_row_title
            this.aggAll_rebuild()
        },
        aggAll_countRules(rows) {
            // сумма активных правил conditional_format по активным строкам
            // полей/мер, с иерархией attrs (зеркало useCount_count с
            // useCount_source)
            let s = 0
            for (const r of rows ?? []) {
                if (!r || r.use === false) continue
                s += this.countUseRows(r.conditional_format) + this.aggAll_countRules(r.attrs)
            }
            return s
        },
        aggAll_recount(segs, ownerChain) {
            // счётчики-индикаторы (зеркало useCount, см. countUseRows):
            // контейнер правил (conditional_format) — _cf_count на
            // строке-владельце и _cf_fields/_cf_values на строке лэйаута;
            // контейнер полей/мер (fields/values, viewList-all) —
            // _cf_fields/_cf_values строки лэйаута от суммы правил полей
            const owner = ownerChain[ownerChain.length - 1]
            if (!owner) return
            const contKey = segs[segs.length - 1]
            if (contKey === 'fields' || contKey === 'values') {
                // _cf_count строк полей: их правила могли правиться через
                // попап строки агрегата (мимо useCount гридов-источников)
                const recountRows = (rr) => {
                    for (const r of rr ?? []) {
                        if (!this.store.isinstance_dict(r)) continue
                        const n = this.countUseRows(r.conditional_format)
                        if (n) {
                            r._cf_count = n
                        } else {
                            delete r._cf_count
                        }
                        recountRows(r.attrs)
                    }
                }
                recountRows(owner[contKey])
                const cnt = this.aggAll_countRules(owner[contKey])
                if (cnt) {
                    owner['_cf_' + contKey] = cnt
                } else {
                    delete owner['_cf_' + contKey]
                }
                return
            }
            const n = this.countUseRows(owner[contKey])
            if (n) {
                owner._cf_count = n
            } else {
                delete owner._cf_count
            }
            if (segs.length > 2) {
                const layoutRow = ownerChain[0], tableKey = segs[1]
                const cnt = this.aggAll_countRules(layoutRow[tableKey])
                if (cnt) {
                    layoutRow['_cf_' + tableKey] = cnt
                } else {
                    delete layoutRow['_cf_' + tableKey]
                }
            }
        },
        aggAll_rebuild() {
            // пересборка агрегата + обновление UI, если изменился
            if (!this.aggAll_isSummary()) return
            if (this.flex?.activeEditor) { // не дёргать грид под редактором
                this.aggAll_scheduleRebuild()
                return
            }
            if (this.aggAll_build() && this.flex) {
                if (this.aggAll_identityMode()) {
                    // вид не зависит от агрегата (this.data — сам массив
                    // источника): set_itemsSource не нужен — он возвращал
                    // выделение на selectedRanges_BEFORE (спрыгивание после
                    // "+"); refresh — на случай внешних правок источника
                    this.flex.collectionView?.refresh()
                    this.apply_CHIPS()
                } else {
                    // выделение не должно спрыгивать на строку последнего
                    // mousedown (restore selectedRanges_BEFORE в set_itemsSource)
                    try {
                        this.selectedRanges_BEFORE = this.selBefore_snap(this.flex.selectedRanges)   // IE 2026 09 27 / ODOO-5800: снимок с binding колонок
                    } catch (e) { /* flex may not be ready */ }
                    this.flex.deferUpdate(() => {
                        this.set_itemsSource()
                    })
                }
                this.aggAll_updateAllButton() // badge: число строк доп. источников
            }
        },
        aggAll_afterChange(aggregate_edit = false) {
            // правка агрегата (строки грида, попап правила) → write-back
            if (!this.aggAll_isSummary()) return
            if (this.aggAll_identityMode() && !aggregate_edit) {
                // правка ушла прямо в таблицу-источник — write-back не
                // нужен, только пересборка агрегата (badge, режим "All")
                this.aggAll_scheduleRebuild()
                return
            }
            // aggregate_edit: правка легла в копию агрегата (гриды/скаляры
            // попапа строки сводной резолвятся через _meta.binding в
            // _doc.*_all) — и в identity-режиме нужен write-back, иначе
            // пересборка из источников её затрёт
            clearTimeout(this._aggAll_wbTimer)
            this._aggAll_wbTimer = setTimeout(() => this.aggAll_writeBack(), this.store.setting('fe.ux.aggWriteBackMs', 100))   // IE 2026 09 05 / ODOO-336330
        },
        aggAll_scheduleRebuild() {
            clearTimeout(this._aggAll_rbTimer)
            this._aggAll_rbTimer = setTimeout(() => this.aggAll_rebuild(), 200)
        },
        aggAll_summaryGrids() {
            // vueObj сводных гридов корневого виджета (у REPORT2 их два:
            // conditional_format-all и viewList-all)
            let WIDGET = this.WIDGET, iter = 0
            while (WIDGET?.widget === 'widget-row' && WIDGET.parentWIDGET?.id !== undefined && iter++ < 20) {
                const parent = this.store.findWidget(WIDGET.parentWIDGET.id)?.WIDGET
                if (!parent) break
                WIDGET = parent
            }
            const summaries = []
            for (const vueObj of Object.values(WIDGET?.attrs_vueObj || {})) {
                if (vueObj?.attr?.agg_sources && vueObj.aggAll_isSummary?.()) {
                    summaries.push(vueObj)
                }
            }
            return summaries
        },
        aggAll_fullBinding() {
            // binding этого грида относительно корневой записи (цепочка
            // widget-row, как в attr_get_link)
            let WIDGET = this.WIDGET, binding = this.attr.binding || '', iter = 0
            while (WIDGET?.widget === 'widget-row' && WIDGET.parentWIDGET?.id !== undefined && iter++ < 20) {
                const meta = WIDGET.record?._meta
                if (!meta?.binding) break
                binding = meta.binding + '.' + (meta.iroot ?? '') + '.' + binding
                WIDGET = this.store.findWidget(WIDGET.parentWIDGET.id)?.WIDGET
            }
            return binding
        },
        aggAll_sourceChanged() {
            // из attr_set любого грида: правка агрегата (в т.ч. гриды попапа
            // строки сводной таблицы) → его write-back; правка источников /
            // строк-владельцев → пересборка агрегатов
            const summaries = this.aggAll_summaryGrids()
            if (!summaries.length) return
            const fullBinding = this.aggAll_fullBinding()
            for (const summary of summaries) {
                if (summary === this || fullBinding.startsWith(summary.attr.binding)) {
                    // summary !== this: правка пришла из грида попапа строки
                    // сводной (биндинг резолвится в копию агрегата)
                    summary.aggAll_afterChange(summary !== this)
                } else if (!summary._aggAll_writingBack) {
                    summary.aggAll_scheduleRebuild()
                }
            }
        },
        aggAll_findOwnerChain(segs, row_id) {
            // цепочка строк-владельцев до строки с row_id (поиск по ключу,
            // не по номеру из source_row_title)
            const record = this.rowIds_record()
            let found = null
            const walkLevel = (rows, ilevel, chain) => {
                const isLast = ilevel === segs.length - 2
                const flat = (rr) => {
                    for (const row of rr ?? []) {
                        if (found) return
                        if (!this.store.isinstance_dict(row)) continue
                        if (isLast && row.row_id === row_id) {
                            found = [...chain, row]
                            return
                        }
                        if (!isLast) {
                            walkLevel(row[segs[ilevel + 1]], ilevel + 1, [...chain, row])
                        }
                        flat(row.attrs)
                    }
                }
                flat(rows)
            }
            walkLevel(this.store.get_value(record, segs[0]), 0, [])
            return found
        },
        aggAll_selectByRowId(hostWIDGET, binding, row_id, tries = 10) {
            if (!row_id) return
            const vueObj = hostWIDGET?.vueObj?.get_vueObj?.(binding)
            const flex = vueObj?.flex
            if (flex) {
                const irow = flex.rows.findIndex(r => r.dataItem?.row_id === row_id)
                if (irow >= 0) {
                    flex.select(new wjGrid.CellRange(irow, 0), true)
                    return
                }
            }
            if (tries > 0) {
                window.$cg.setTimeout(this, 'AttrGrid.aggAll_selectByRowId', () => {
                    this.aggAll_selectByRowId(hostWIDGET, binding, row_id, tries - 1)
                }, 250)
            }
        },
        aggAll_sourceItem(irow) {
            // строка для перехода (source_link): клик/ячейка могли прийти по
            // дочерней строке (attrs) — подняться к корневому правилу
            // (source_* только на корневых)
            let item = this.flex.rows[irow]?.dataItem, guard = 0
            while (item && !item.source_row_title && guard++ < 20) {
                const p = this.get_parentPosition(irow)
                if (p == null || p < 0) break
                irow = p
                item = this.flex.rows[irow]?.dataItem
            }
            return item?.source_row_title ? item : null
        },
        onAggSourceOpen__Click(cell) {
            // кнопка перехода в дропдауне (колонки Source сводной таблицы)
            const item = this.aggAll_sourceItem(cell.row)
            if (item) {
                this.aggAll_openSource(item)
            }
        },
        aggAll_openSource(dataItem) {
            // переход к источнику (source_link): источник без '[]' (правила
            // отчёта) — активация его грида; остальные — каскад widget-row
            // до строки-владельца с активной вкладкой контейнера и
            // выделением строки-источника по её row_id
            const def = this.attr.agg_sources?.[dataItem?._aggAll_isrc]
            if (!def) return
            const segs = String(def.binding).split('[].')
            if (!dataItem.source_row_id) {
                this.store.set_activeAttr(this.WIDGET.view, { binding: segs[0] }, this.WIDGET)
                this.aggAll_selectByRowId(this.WIDGET, segs[0], dataItem.row_id)
                return
            }
            const chain = this.aggAll_findOwnerChain(segs, dataItem.source_row_id)
            if (!chain) {
                this.store.show_notification({ text: t('Source row not found: {title}', { title: dataItem.source_row_title }), status: 'error' })   // IE 2026 09 23 / ODOO-341407: i18n
                return
            }
            this.aggAll_openCascade(this.WIDGET, segs, chain, 0, dataItem.row_id)
        },
        aggAll_openCascade(hostWIDGET, segs, chain, ilevel, targetRowId) {
            const gridNode = this.store.get_field(hostWIDGET.view || [], ilevel === 0 ? segs[0] : segs[ilevel])
            if (!gridNode || !hostWIDGET.vueObj) return
            const isLast = ilevel === segs.length - 2
            const contKey = segs[segs.length - 1]
            const dataItem = chain[ilevel]
            const data = ilevel === 0
                ? this.store.get_value(this.rowIds_record(), segs[0])
                : (chain[ilevel - 1]?.[segs[ilevel]] ?? [])
            const iroot = this.store.iroot(dataItem, data, gridNode.childItemsPath || 'attrs')
            this.store.executeStoreMethod(hostWIDGET.vueObj, {
                command: 'widget_open', widget: 'widget-row', _activate: true,
                get_currentRow: true, get_Parent: true, open_in_children_widget: true,
                selectedRow: { dataItem, iroot },
                source_name: gridNode.name, binding: gridNode.binding,
                attrs: gridNode.attrs, widgetRow_params: gridNode.widgetRow_params,
                // сразу активная вкладка: контейнер (правила / Fields /
                // Values) — на последнем уровне, вложенная таблица —
                // на промежуточных
                activeAttr: { binding: isLast ? contKey : segs[ilevel + 1] },
            }, gridNode)
            // view попапа грузится с бэка — дождаться и продолжить:
            // следующий уровень каскада или выделение строки-цели
            const nextBinding = isLast ? contKey : segs[ilevel + 1]
            this.aggAll_await(() => {
                const WRow = (hostWIDGET.widget === 'widget-row')
                    ? this.store.get_childrenWidget(hostWIDGET, 'widget-row')
                    : this.store.get_widgetRow()
                return (WRow?.vueObj && this.store.get_field(WRow.view || [], nextBinding)) ? WRow : null
            }, (WRow) => {
                if (isLast) {
                    this.aggAll_selectByRowId(WRow, contKey, targetRowId)
                } else {
                    this.aggAll_openCascade(WRow, segs, chain, ilevel + 1, targetRowId)
                }
            })
        },
        aggAll_await(getter, cb, tries = 24) {
            const v = getter()
            if (v) {
                cb(v)
            } else if (tries > 0) {
                window.$cg.setTimeout(this, 'AttrGrid.aggAll_await', () => {
                    this.aggAll_await(getter, cb, tries - 1)
                }, 250)
            }
        },
        // --- Лёгкий вид гридов полей (lightView: 'light' | 'full' на
        // конфиг-узле AttrGrid; бэк ставит флаг на гриды с колонками
        // attrs_field, значение — вид по умолчанию). В лёгком виде — только
        // колонка Title (дерево) с чипсами-префиксами типа и индикатором
        // ссылочных полей, без линий строк. Текущий вид — viewParam
        // lightView (персист как у остальных свойств грида); приоритет
        // сохранённой настройки над флагом даёт store.get_viewParam
        lightView_enabled() {
            return !!this.attr.lightView
        },
        lightView_on() {
            return this.lightView_enabled() && this.get_viewParam('lightView', 'full') === 'light'
        },
        lightView_apply() {
            if (!this.lightView_enabled() || !this.flex) return
            const light = this.lightView_active = this.lightView_on()
            this.flex.deferUpdate(() => {
                for (const col of this.flex.columns) {
                    if (col.binding === 'title') {
                        // Title — на весь грид; ширина полного вида
                        // сохраняется и восстанавливается при переключении
                        if (light) {
                            if (col._lightView_width0 === undefined) {
                                col._lightView_width0 = col.width
                            }
                            col.width = '*'
                        } else if (col._lightView_width0 !== undefined) {
                            col.width = col._lightView_width0
                            col._lightView_width0 = undefined
                        }
                        col.visible = true
                    } else {
                        col.visible = !light && !this.attr_by_binding[col.binding]?._ogHide && !this.attr_by_binding[col.binding]?._ytHide   // IE 2026 10 22 / ODOO-5800: колонки выключенной группы опций остаются спрятаны; // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p217 кнопка Σ — річні підсумки за опцією, типово вимкнено): + итог года, спрятанный Σ
                    }
                }
                if (!light) {
                    // полный вид показал все колонки — вернуть скрытия
                    // apply_CHIPS_columns (пустые при non-empty-widget,
                    // колонки группировки CHIPS)
                    this.apply_CHIPS_columns(false)
                }
            })
            if (this.flex.hostElement) {
                wjcCore.toggleClass(this.flex.hostElement, 'attr-grid-lightview', light)
            }
        },
        lightView_toggle() {
            if (!this.lightView_enabled()) return
            this.set_viewParam('lightView', this.lightView_on() ? 'full' : 'light')
        },
        runUserCode(code, context = {}) {
            const keys = Object.keys(context);
            const values = Object.values(context);

            try {
                const result = new Function(...keys, code)(...values);
                return { result, error: null };
            } catch (err) {
                console.error('Error in user code:', err);
                this.store.show_notification({ text: t('Error in user code: {error}', { error: err.message }), status: 'error' })   // IE 2026 09 23 / ODOO-341407: i18n
                return { result: null, error: err };
            }
        },
        async attr_loadPyodide() {
            if (!this.attr?.name) return;
            // IE 2026 08 18 / ODOO-5512 (M03: «Update data» гасил раскраску и правку):
            // модуль пересоздавался на КАЖДЫЙ select — в окне между destroy и
            // готовностью нового модуля get_cssClass_py = null, formatItem успевал
            // либо выключить py-раскраску насовсем (cache2_data_cells__call__used = -1),
            // либо посчитать классы фолбэком (пусто). Код виджета от select не
            // меняется — пересобираем модуль только при смене кода (сигнатура по
            // _import_modules + code-eval вкладки), иначе оставляем живой
            const _im = this.WIDGET?.record?._import_modules || {}
            let _sig = ''
            try {
                _sig = JSON.stringify(Object.keys(_im).sort().map(k => [k, (_im[k] || '').length, (_im[k] || '').slice(0, 200)]))
                    + '|' + String(this.attr?.['code-eval'] || '').length
            } catch (e) { _sig = String(Math.random()) }
            if (this._pyMod && this._pySig === _sig && !this.attr_loadPyodide_promise) {
                return
            }
            // IE 2026 08 18 / ODOO-5512: две загрузки ПОДРЯД (mount + первый select)
            // шли параллельно: обе создавали модуль, проигравшая выходила по
            // «_pyMod !== mod», а её .then обнулял attr_loadPyodide_promise ВЫИГРАВШЕЙ —
            // formatItem_cells_calcCSS_py__start видел «промиса нет, функции нет,
            // модуль есть» и выключал py-раскраску насовсем (used = -1). Теперь:
            // тот же код уже грузится — вернуть его промис; другой код — грузить
            // ПОСЛЕ текущей загрузки, промис снимает только его владелец
            if (this.attr_loadPyodide_promise && this._pySig === _sig) {
                return this.attr_loadPyodide_promise
            }
            this._pySig = _sig
            const prev = this.attr_loadPyodide_promise || Promise.resolve()
            const p = prev.catch(() => {}).then(() => {
                this.store.attr_destroyPyodide(this)
                return this.store.attr_loadPyodide(this)
            }).catch((e) => { console.error(e) }).then(() => {
                if (this.attr_loadPyodide_promise === p) this.attr_loadPyodide_promise = null
                this.pyCss_afterLoad()
                this.pyWorker_warm() // IE 2026 09 05 / ODOO-336379: ленивый прогрев воркеров pyodide (после первой отрисовки, в idle)
            })
            this.attr_loadPyodide_promise = p
            return p
        },
        pyCss_afterLoad() {
            // IE 2026 08 18 / ODOO-5512: модуль готов — если раскраска была выключена
            // (used = -1) или классы считались фолбэком до готовности функции,
            // включить очередь и пересчитать классы видимых ячеек
            if (typeof this.get_cssClass_py !== 'function') return
            const wasOff = this.cache2_data_cells__call__used === -1
            this.cache2_data_cells__call__used = 0
            this.css_invalidate_all('pyload') // IE 2026 09 04 / ODOO-336379
            // IE 2026 09 04 / ODOO-336379: модуль готов — перерисовать видимые ячейки ВСЕГДА, не только после «выключено»:
            // пока модуль пересобирался (select с _import_modules), formatItem уже сложил ячейки данных в очередь,
            // __start сбросил её (css_calc=false) как «ожидание» — без принудительного refresh эти ячейки ждали
            // случайной перерисовки (десятки секунд) или не считались вовсе (M03 весь read-only)
            if (this.flex?.hostElement) {
                try { this.flex.refreshCells(false, true) } catch (e) { this.flexRefresh() }
            }
            this._pyCssRetry = 0
        },
        // IE 2026 09 04 / ODOO-336379: функция раскраски ожидается по коду виджета (code-eval / модули),
        // но ещё не собрана — повторить попытку, а не выключать py-раскраску насовсем
        pyCss_expected() {
            try {
                const srcs = [String(this.attr?.['code-eval'] || ''), ...Object.values(this.WIDGET?.record?._import_modules || {}).map(v => String(v || ''))]
                return srcs.some(t => t.includes('__get_cssClass'))
            } catch (e) { return false }
        },
        pyCss_scheduleRetry() {
            const n = (this._pyCssRetry = (this._pyCssRetry || 0) + 1)
            if (n > 20) return
            if (this._pyCssRetryT) clearTimeout(this._pyCssRetryT)
            this._pyCssRetryT = window.$cg.setTimeout(this, 'AttrGrid.pyCssRetry', () => {
                this._pyCssRetryT = null
                if (typeof this.get_cssClass_py === 'function') { this.pyCss_afterLoad(); return }
                if (this.attr_loadPyodide_promise) { this.attr_loadPyodide_promise.then(() => { if (typeof this.get_cssClass_py !== 'function') this.pyCss_scheduleRetry() }); return }
                this.pyCss_scheduleRetry()
            }, 500 * Math.min(n, 4))
        },
        async process_dataItem_py__start() {
            const vueObj = this, maxDelay = 50, DEBOUNCE_MS = 100

            if (this.attr_loadPyodide_promise) await this.attr_loadPyodide_promise;
            if (!this.dataItem__afterEdit) {
                // this.process_dataItem_py__start_WORKIING = false; не нужно, т.к. нет смыcла в дальнейших вызовах
                this.cache_process_dataItem_py.clear()
                vueObj.cache_process_dataItem_py__used = -1

                return;
            }

            let wait = DEBOUNCE_MS
            while (wait > 0) {
                await this.store.sleep(wait);
                wait = DEBOUNCE_MS - (performance.now() - this.process_dataItem_py__start_t0)
            }

            vueObj.cache_process_dataItem_py__used = 1

            // if (this.process_dataItem_py_timerId) { clearTimeout(this.process_dataItem_py_timerId) }
            // this.process_dataItem_py_timerId = window.$cg.setTimeout(this, "AttrGrid.process_dataItem_py__start", async () => {
                let t0 = performance.now();
                try {
                    while (vueObj.cache_process_dataItem_py.size) {
                        // IE 2026 09 05 / ODOO-336379 (флаг py_worker): весь хвост очереди — одним пакетом в воркер(ы) pyodide;
                        // правки, пришедшие за время расчёта, копятся в очереди и уходят следующим пакетом. OFF — прежний
                        // построчный синхронный путь ниже байт-в-байт
                        if (this.pyWorker_on()) {
                            const jobs = []
                            for (const [key, dataItem] of vueObj.cache_process_dataItem_py) jobs.push({ key, dataItem, ctx: this._pyEditCtx?.get(key) || null })
                            vueObj.cache_process_dataItem_py.clear()
                            for (const j of jobs) this._pyEditCtx?.delete(j.key)
                            const t1 = performance.now()
                            await this.pyRecalc_batch(jobs)
                            this.gridPerf_touch('py', performance.now() - t1)
                            t0 = performance.now()
                            continue
                        }
                        // IE 2026 09 05 / ODOO-336379 (флаг afterEdit_scope_multi): накопившиеся строки пакета (вставка
                        // блока через несколько SKU) — один вызов python на группу «блок уровня 0 + действие»:
                        // каждый правленый SKU считается отдельно, предки пересуммируются один раз
                        if (vueObj.cache_process_dataItem_py.size > 1 && this.cssPerf_on('afterEdit_scope_multi')) {
                            const items = []
                            for (const [k, di] of vueObj.cache_process_dataItem_py) items.push({ key: k, dataItem: di, ctx: this._pyEditCtx?.get(k) || null })
                            vueObj.cache_process_dataItem_py.clear()
                            for (const it of items) this._pyEditCtx?.delete(it.key)
                            console.log('process_dataItem_py__start (multi)'); let t1 = performance.now();
                            const nCalls = this.process_dataItem_py_multi(items)
                            console.log('process_dataItem_py__start ', performance.now() - t1, this._pyLastScope ? `scope=${this._pyLastScope.scope} skus=${this._pyLastScope.skus}/${this._pyLastScope.total}` : '', `rows=${items.length} calls=${nCalls}`);
                            this.gridPerf_touch('py', performance.now() - t1)
                            if (performance.now() - t0 > maxDelay) { await this.store.sleep(10); t0 = performance.now() }
                            continue
                        }
                        const key = this.cache_process_dataItem_py.keys().next().value;
                        let dataItem = vueObj.cache_process_dataItem_py.get(key);

                        vueObj.cache_process_dataItem_py.delete(key);
                        const _ctx = this._pyEditCtx?.get(key) || null
                        this._pyEditCtx?.delete(key)

                        console.log('process_dataItem_py__start'); let t1 = performance.now();
                        this.process_dataItem_py(dataItem, _ctx)
                        console.log('process_dataItem_py__start ', performance.now() - t1, this._pyLastScope ? `scope=${this._pyLastScope.scope} skus=${this._pyLastScope.skus}/${this._pyLastScope.total}` : ''); // IE 2026 09 04 / ODOO-336379: область пересчёта
                        this.gridPerf_touch('py', performance.now() - t1) // IE 2026 09 04 / ODOO-336379

                        if (performance.now() - t0 > maxDelay) {
                            console.log(`process_dataItem_py__start rest ${vueObj.cache_process_dataItem_py.size}`);
                            await this.store.sleep(10);
                            t0 = performance.now();
                        }
                    }
                } finally {
                    this.process_dataItem_py__start_WORKIING = false;
                }
            // }, DEBOUNCE_MS)
        },
        async formatItem_cells_calcCSS_py__start() {
            const vueObj = this, maxDelay = 100, DEBOUNCE_MS = 10

            if (this.attr_loadPyodide_promise) await this.attr_loadPyodide_promise;
            if (!this.get_cssClass_py) {
                // IE 2026 08 18 / ODOO-5512: -1 («py-раскраски нет») — только когда
                // модуля действительно нет (нет кода/нужной функции). Если модуль
                // ещё грузится или упал временно — вернуть очередь в пересчёт и
                // дать formatItem повторить попытку позже, а не выключать навсегда
                // IE 2026 09 04 / ODOO-336379: «ожидание» и когда функция ожидается по коду (модуль пересобирается
                // или собрался без неё временно) — иначе гонка select↔пересборка выключала раскраску насовсем (-1)
                const _pending = !!this.attr_loadPyodide_promise
                    || !!(this.WIDGET?.record?._import_modules && Object.keys(this.WIDGET.record._import_modules).length && !this._pyMod)
                    || this.pyCss_expected()
                for (const _q of vueObj.cache2_data_cells__call.values()) {
                    if (_q?._cache2) { _q._cache2.css_calc = false; _q._cache2.css_promise = null }
                }
                vueObj.cache2_data_cells__call.clear()
                vueObj.cache2_data_cells__call__used = _pending ? 0 : -1
                this.formatItem_cells_calcCSS_py__start_WORKIING = false;
                if (_pending) this.pyCss_scheduleRetry()
                return;
            }
            
            let wait = DEBOUNCE_MS
            // while (wait > 0 || vueObj.cache_process_dataItem_py.size) {
                await this.store.sleep(wait);
                // wait = DEBOUNCE_MS - (performance.now() - this.formatItem_cells_calcCSS_py__start_t0)
            // } 

            vueObj.cache2_data_cells__call__used = 1
            // IE 2026 09 04 / ODOO-336379: паспорт волны py-CSS (window.gridPerf.css(n))
            this._cssWave = { t0: performance.now(), queued: vueObj.cache2_data_cells__call.size, cells: 0, py: 0, memo_hits: 0, memo_miss: 0, batches: 0 }

            // IE 2026 09 05 / ODOO-336379 (флаг css_py_batch, дефолт ВКЛ): вся волна — одним python-вызовом на пачку
            // ячеек (цикл по ячейкам внутри python, мост JS↔Python один раз), поштучный путь остаётся фолбэком
            if (this.cssPerf_on('css_py_batch') && typeof this.get_cssClass_py === 'function' && this._pyMod) {
                await this.cssWave_runBatched(maxDelay)
                this.gridPerf_touch('cssWave', 0)
                this.cssWave_end()
                this.formatItem_cells_calcCSS_py__start_WORKIING = false;
                return
            }

            // if (this.formatItem_cells_calcCSS_py_timerId) { clearTimeout(this.formatItem_cells_calcCSS_py_timerId) }
            // this.formatItem_cells_calcCSS_py_timerId = window.$cg.setTimeout(this, "AttrGrid.formatItem_cells_calcCSS_py__start", async () => {
                let t0 = performance.now(), wait1 = 0, iter = 0;
                while (vueObj.cache2_data_cells__call.size) {
                    // const key2 = this.cache2_data_cells__call.keys().next().value;
                    let key2; for (const k of this.cache2_data_cells__call.keys()) key2 = k;

                    let {dataItem, attr_col, _cache2, key, row, col} = vueObj.cache2_data_cells__call.get(key2);
                    
                    _cache2.t0 = performance.now()

                    const css = this.formatItem_cells_calcCSS_py(dataItem, attr_col, _cache2)
                    this.formatItem_cells_setCSS(key, key2, row, col, css)
                    // IE 2026 09 04 / ODOO-336379: метка актуальности с учётом строчной (css_invalidate_scoped)
                    if (_cache2) _cache2.css_relevance = Math.max(_cache2.css_relevance || 0, this.css_rowRel(dataItem))
                    if (this._cssWave) this._cssWave.cells++

                    vueObj.cache2_data_cells__call.delete(key2);
                    this.gridPerf_touch('css', performance.now() - _cache2.t0) // IE 2026 09 04 / ODOO-336379

                    const tTimeout1 = performance.now();
                    while (performance.now() - t0 > maxDelay || vueObj.cache_process_dataItem_py.size) {
                        if (performance.now() - tTimeout1 > 5000) break;
                        console.log(`formatItem_cells_calcCSS_py__start rest ${vueObj.cache2_data_cells__call.size}`);
                        await this.store.sleep(wait1);
                        wait1 = 2
                        t0 = performance.now();
                        if (vueObj.cache_process_dataItem_py.size && iter > 10) {
                            // IE 2026 09 05 / ODOO-336379: раньше здесь ОЧИЩАЛАСЬ очередь python-пересчёта (force clear) — правка оставалась
                            // без пересчёта (замечено на 8-й из 8 быстрых правок в построчном пути). Волна CSS просто перестаёт ждать:
                            // очередь дорабатывает свой планировщик process_dataItem_py__start.
                            console.warn('formatItem_cells_calcCSS_py__start: python queue still busy, stop waiting (queue kept)', vueObj.cache_process_dataItem_py.size)
                            break
                        }
                        iter++
                    }
                }
                this.gridPerf_touch('cssWave', 0) // IE 2026 09 04 / ODOO-336379: волна py-CSS завершена
                this.cssWave_end()

                this.formatItem_cells_calcCSS_py__start_WORKIING = false;
                // this.flex?.refreshCells();
            // }, DEBOUNCE_MS)
        },
        async formatItem_cells__start() {
            const vueObj = this, maxDelay = 50, DEBOUNCE_MS = 10

            let wait = DEBOUNCE_MS
            const tTimeout2 = performance.now();
            while (wait > 0 || vueObj.cache_process_dataItem_py.size) {
                if (performance.now() - tTimeout2 > 5000) break;
                await vueObj.store.sleep(wait||DEBOUNCE_MS);
                if (vueObj.formatItem_cells__start_t0) {
                    wait = DEBOUNCE_MS - (performance.now() - vueObj.formatItem_cells__start_t0)
                    vueObj.formatItem_cells__start_t0 = null;
                } else {
                    wait = 0
                }
            }

            let t0 = performance.now();
            while (vueObj.cache1_data_cells__call.size) {
                const key = vueObj.cache1_data_cells__call.keys().next().value;
                let {e} = vueObj.cache1_data_cells__call.get(key);
                
                vueObj.formatItem_cells(e)
                // e.cell.style.backgroundColor = 'lightgreen';
                vueObj.cache1_data_cells__call.delete(key);

                if (vueObj.formatItem_cells__start_t0) {
                    t0 = vueObj.formatItem_cells__start_t0;
                    vueObj.formatItem_cells__start_t0 = null;
                }

                const tTimeout3 = performance.now();
                while (performance.now() - t0 > maxDelay || vueObj.cache_process_dataItem_py.size) {
                    if (performance.now() - tTimeout3 > 5000) break;
                    console.log(`formatItem_cells__start rest ${vueObj.cache1_data_cells__call.size}`);
                    await vueObj.store.sleep(3);
                    t0 = performance.now();
                }
            }

            vueObj.formatItem_cells__start_WORKIING = false;
        },

        process_dataItem_py(dataItem, editCtx=null, opts=null) {
            const WIDGET = this.WIDGET;
            try {
                const mod = this._pyMod
                if (!mod) return           // модуль уничтожен/не загружен (пересоздание виджета)
                const irow = this.rows_indexOf(dataItem); // для получения data0 M03
                const data0 = this.get_data0(irow);
                // IE 2026 09 04 / ODOO-336379 (Игорь: отклик 3–5 с на правку — python-пересчёт всего бренда/БЮ):
                // область пересчёта = правленый SKU + строки-агрегаты его предков (флаг afterEdit_scope_sku);
                // null → прежний полный пересчёт блока уровня 0
                // IE 2026 09 05 / ODOO-336379: opts.forceFull — в пакете есть правка агрегатной строки: полный блок один раз
                const scope = (opts && opts.forceFull) ? null : this.afterEdit_scope(dataItem, irow, data0)
                const snapItems = scope ? scope.snapItems : data0
                // IE 2026 08 18 / ODOO-5512 (заказ Игоря): снимок значений блока ДО
                // пользовательского кода — после него разница регистрируется как
                // связанные изменения (бейдж дельты, трассировка по наведению)
                const _snap = (editCtx && !this._undoApplying && !this._undoBatch)
                    ? this.pyDerived_snapshot(snapItems) : null

                // актуальный контекст в модуль (а не в globals)
                mod.__dict__.set('data', this.data);
                mod.__dict__.set('dataItem', dataItem);
                mod.__dict__.set('widget', WIDGET?.record || {});
                mod.__dict__.set('WIDGET', WIDGET || {});

                mod.__dict__.set('data0', data0);
                // IE 2026 09 04 / ODOO-336379 (флаг css_invalidate_scoped): сигнатуры строк блока ДО пересчёта —
                // после него py-CSS пересчитывается только у строк, чьё содержимое реально изменилось
                const _cssSnap = this.cssPerf_scoped() ? this.cssSig_snapshot(snapItems) : null
    
                const parentPosition = this.get_parentPosition(irow)
                let parentRow;
                if (parentPosition >= 0) {
                    parentRow = this.flex.rows[parentPosition].dataItem;
                }
                mod.__dict__.set('parentRow', parentRow); // S03

                let result
                let used = 'brand'
                if (scope) {
                    // IE 2026 09 04 / ODOO-336379: SKU считается НАСТОЯЩЕЙ calculate_report_M03 модуля на синтетическом
                    // корне с одним ребёнком, предки пересуммируются шагами 1–3 calc_GruopGroups через модульный
                    // calc_record_aggr_M03 (хелпер __ie_afterEdit_scoped, см. afterEdit_scope_fn); любая ошибка → полный пересчёт
                    try {
                        const fn = this.afterEdit_scope_fn(mod)
                        result = this.exec("process_dataItem_py", fn, scope.fakeRoots, scope.chain)
                        used = 'sku'
                    } catch (err) {
                        console.warn('[gridPerf] afterEdit scope=sku failed, falling back to the full block recalculation:', String(err))
                        this._scopeFailed = mod
                        result = this.exec("process_dataItem_py", this.dataItem__afterEdit)
                    }
                } else {
                    result = this.exec("process_dataItem_py", this.dataItem__afterEdit);
                    this._scopeWarmMod = mod   // полный пересчёт блока состоялся — дальше можно сужать
                }
                const _total = this.afterEdit_scope_countSku(data0)
                this._pyLastScope = { scope: used, skus: used === 'sku' ? 1 : _total, total: _total }
                const b = this._gridPerfCur
                if (b && !b.settled) { b.py_scope = used; b.py_skus = (b.py_skus || 0) + this._pyLastScope.skus; b.py_skus_total = this._pyLastScope.total }

                // если вдруг вернулся PyProxy — конвертируем
                if (result && typeof result.toJs === 'function') {
                    const jsVal = result.toJs();
                    result.destroy?.();
                    result = jsVal;
                }

                if (_snap) this.pyDerived_register(_snap, dataItem, editCtx)

                // перерисовать грид
                // IE 2026 09 04 / ODOO-336379: инвалидация py-CSS — по строкам, изменённым пересчётом (+ правленая и предки)
                this.css_invalidate_rows(_cssSnap ? this.cssSig_changed(_cssSnap, dataItem) : null, 'afterEdit')
                this.cf_cache?.clear() // conditional_format: user-код мог изменить данные
                this.flex?.invalidate();
                return result;

            } catch (err) {
                console.error(String(err));
                this.store.show_notification({ text: err.message, status: 'error' })
                this.dataItem__afterEdit = null;
            }
        },
        // IE 2026 09 05 / ODOO-336379 (флаг afterEdit_scope_multi): пакет строк очереди afterEdit — один вызов python
        // на группу «блок уровня 0 + действие (actionStack)»: синтетический корень со ВСЕМИ правлеными SKU группы
        // (каждый считается настоящей calculate_report_M03 модуля), предки — объединение цепочек, пересуммирование
        // один раз снизу вверх. Агрегатная правка (decomposition) / непрогретый модуль / гард сужения в группе —
        // один полный пересчёт блока на группу. Не M03-сигнатура (afterEdit_scope_ok) или строка вне грида — построчно,
        // как прежде. Возвращает число python-вызовов; _pyLastScope — сводка по пакету
        process_dataItem_py_multi(items) {
            const mod = this._pyMod
            let calls = 0
            const agg = { skus: 0, total: 0, kinds: [], last: null }
            const take = () => {
                calls++
                const ls = this._pyLastScope   // сводка ЭТОГО вызова (перед вызовом обнуляется)
                this._pyLastScope = null
                if (!ls) return
                agg.last = ls
                agg.skus += ls.skus || 0; agg.total += ls.total || 0
                if (!agg.kinds.includes(ls.scope)) agg.kinds.push(ls.scope)
            }
            const one = (it) => { this._pyLastScope = null; this.process_dataItem_py(it.dataItem, it.ctx); take() }
            const canBatch = !!(mod && this.attr?.childItemsPath && this.afterEdit_scope_ok())
            if (!canBatch) { for (const it of items) one(it); return calls }
            const groups = [], single = []
            for (const it of items) {
                let irow = -1, data0 = null
                try { irow = this.rows_indexOf(it.dataItem); if (irow >= 0) data0 = this.get_data0(irow) } catch (e) { data0 = null }
                if (!(irow >= 0) || !Array.isArray(data0) || data0.length !== 1 || !data0[0]) { single.push(it); continue }
                it.irow = irow; it.data0 = data0
                const as = it.ctx ? it.ctx.actionStack : null   // связанные изменения регистрируются в СВОЮ группу отката
                let g = groups.find(gg => gg.root === data0[0] && gg.actionStack === as)
                if (!g) { g = { root: data0[0], actionStack: as, items: [] }; groups.push(g) }
                g.items.push(it)
            }
            for (const it of single) one(it)
            for (const g of groups) {
                if (g.items.length === 1) { one(g.items[0]); continue }
                const scopes = g.items.map(it => this.afterEdit_scope(it.dataItem, it.irow, it.data0))
                if (scopes.some(sc => !sc)) {
                    // блок общий для группы — полный пересчёт покрывает все её строки
                    this._pyLastScope = null; this.process_dataItem_py(g.items[0].dataItem, g.items[0].ctx, { forceFull: true }); take()
                    continue
                }
                this._pyLastScope = null; this.process_dataItem_py_scoped(g.items, scopes); take()
            }
            this._pyLastScope = calls > 1 ? { scope: agg.kinds.join('+'), skus: agg.skus, total: agg.total } : agg.last
            return calls
        },
        // IE 2026 09 05 / ODOO-336379: суженный пересчёт группы строк (все scope != null, один блок, одно действие)
        process_dataItem_py_scoped(items, scopes) {
            const WIDGET = this.WIDGET
            const mod = this._pyMod
            const first = items[0]
            const childPath = this.attr.childItemsPath
            try {
                const skus = []
                const chainLv = new Map()   // предок → { level, snap }
                for (const sc of scopes) {
                    if (!skus.includes(sc.sku)) skus.push(sc.sku)
                    sc.chain.forEach((rec, i) => { if (!chainLv.has(rec)) chainLv.set(rec, { level: sc.chainLevels[i], snap: sc.chainSnaps[i] }) })
                }
                // предки — глубокие раньше: родитель пересуммируется после всех своих изменившихся детей
                const chainSorted = [...chainLv.keys()].sort((a, b) => chainLv.get(b).level - chainLv.get(a).level)
                const snapItems = [...skus, ...chainSorted.map(rec => chainLv.get(rec).snap)]
                const ctx = first.ctx
                const _snap = (ctx && !this._undoApplying && !this._undoBatch) ? this.pyDerived_snapshot(snapItems) : null

                mod.__dict__.set('data', this.data)
                mod.__dict__.set('dataItem', first.dataItem)
                mod.__dict__.set('widget', WIDGET?.record || {})
                mod.__dict__.set('WIDGET', WIDGET || {})
                mod.__dict__.set('data0', first.data0)
                const _cssSnap = this.cssPerf_scoped() ? this.cssSig_snapshot(snapItems) : null
                const parentPosition = this.get_parentPosition(first.irow)
                mod.__dict__.set('parentRow', parentPosition >= 0 ? this.flex.rows[parentPosition].dataItem : undefined)

                let result, used = 'multi', fellBack = false
                try {
                    const fn = this.afterEdit_scope_fn(mod)
                    result = this.exec("process_dataItem_py_multi", fn, [{ [childPath]: skus }], chainSorted)
                } catch (err) {
                    console.warn('[gridPerf] afterEdit scope=multi failed, falling back to the full block recalculation:', String(err))
                    this._scopeFailed = mod
                    result = this.exec("process_dataItem_py_multi", this.dataItem__afterEdit)
                    this._scopeWarmMod = mod
                    used = 'brand'; fellBack = true
                }
                const _total = this.afterEdit_scope_countSku(first.data0)
                this._pyLastScope = { scope: used, skus: used === 'multi' ? skus.length : _total, total: _total }
                const b = this._gridPerfCur
                if (b && !b.settled) { b.py_scope = used; b.py_skus = (b.py_skus || 0) + this._pyLastScope.skus; b.py_skus_total = this._pyLastScope.total }

                if (result && typeof result.toJs === 'function') {
                    const jsVal = result.toJs()
                    result.destroy?.()
                    result = jsVal
                }

                if (_snap) this.pyDerived_register(_snap, first.dataItem, ctx)

                let cssRows = null
                if (_cssSnap && !fellBack) {
                    cssRows = []
                    for (const it of items) cssRows.push(...this.css_ancestors(it.dataItem))
                    for (const [rec, sig] of _cssSnap) if (this.cssSig_hash(rec) !== sig) cssRows.push(rec)
                }
                this.css_invalidate_rows(cssRows, 'afterEdit')   // null → все строки (полный пересчёт после отката)
                this.cf_cache?.clear()
                this.flex?.invalidate()
                return result
            } catch (err) {
                console.error(String(err))
                this.store.show_notification({ text: err.message, status: 'error' })
                this.dataItem__afterEdit = null
            }
        },
        // IE 2026 09 05 / ODOO-336379 (флаг afterEdit_warm_idle): прогрев — полный python-проход первого блока уровня 0
        // в простое после загрузки модуля/данных, чтобы первая правка пользователя шла сразу scope=sku, а не ждала
        // «прогревочный» полный пересчёт 1,6–8 с (afterEdit_scope_warm). Только отчёты с python-afterEdit M03-сигнатуры
        // (afterEdit_scope_ok) и деревом; без регистрации связанных изменений (ctx нет) — Corrections/undo не трогает
        pyWarm_wanted() {
            const mod = this._pyMod
            if (!mod || this._pyWarmFailed === mod) return false
            if (!this.cssPerf_on('afterEdit_warm_idle') || !this.cssPerf_on('afterEdit_scope_sku') || !this.cssPerf_on('afterEdit_scope_warm')) return false
            if (typeof this.dataItem__afterEdit !== 'function') return false
            if (this._scopeWarmMod === mod || this._scopeFailed === mod) return false
            if (!this.attr?.childItemsPath) return false
            return this.afterEdit_scope_ok()
        },
        pyWarm_schedule(delay) {
            try {
                if (this._pyWarmT) { clearTimeout(this._pyWarmT); this._pyWarmT = null }
                if (this._pyWarmIdle && typeof window.cancelIdleCallback === 'function') { window.cancelIdleCallback(this._pyWarmIdle); this._pyWarmIdle = null }
                if (delay === undefined) this._pyWarmTries = 0   // новая загрузка модуля — счётчик попыток заново
                if (!this.pyWarm_wanted()) return
                const mod = this._pyMod
                const run = () => { this._pyWarmIdle = null; this.pyWarm_run(mod) }
                const idle = () => {
                    this._pyWarmT = null
                    if (typeof window.requestIdleCallback === 'function') this._pyWarmIdle = window.requestIdleCallback(run, { timeout: 15000 })
                    else this._pyWarmT = window.$cg?.setTimeout ? window.$cg.setTimeout(this, 'AttrGrid.pyWarm', run, 1500) : setTimeout(run, 1500)
                }
                const ms = delay === undefined ? 1000 : delay
                this._pyWarmT = window.$cg?.setTimeout ? window.$cg.setTimeout(this, 'AttrGrid.pyWarm', idle, ms) : setTimeout(idle, ms)
            } catch (e) { /* прогрев не критичен */ }
        },
        pyWarm_run(mod) {
            if (!mod || this._pyMod !== mod || !this.pyWarm_wanted()) return
            const n = (this._pyWarmTries = (this._pyWarmTries || 0) + 1)
            if (n > 40) return
            let root = null
            try {
                // занято: грузится модуль, идёт правка/вставка, очереди python и py-CSS не пусты, открыт редактор — позже
                const busy = !!(this.attr_loadPyodide_promise || this.cache_process_dataItem_py?.size || this.process_dataItem_py__start_WORKIING
                    || this.cache2_data_cells__call?.size || this.formatItem_cells_calcCSS_py__start_WORKIING
                    || (this._gridPerfCur && !this._gridPerfCur.settled) || this.flex?.activeEditor || this.flex?.isUpdating)
                const rows = busy ? null : this.flex?.rows
                if (rows) for (let i = 0; i < rows.length; i++) { const r = rows[i]; if (r && r.level === 0 && r.dataItem && r.hasChildren) { root = r; break } }
                if (rows && rows.length && !root) return   // данные есть, но дерева нет — греть нечего
            } catch (e) { root = null }
            if (!root) { this.pyWarm_schedule(Math.min(1000 * n, 5000)); return }   // данных ещё нет / занято — следующая попытка
            // IE 2026 09 05 / ODOO-336379 (флаг py_worker): прогрев — полный проход блока в воркере pyodide, главный поток
            // свободен (в главном потоке проход блокировал UI на 1,6–8 с после открытия, ×4 на слабом CPU). Воркер ещё
            // грузится — подождать (до ~15 с), воркер недоступен/упал — главный поток, как раньше
            if (this.pyWorker_on()) {
                const pool = this.pyWorker_pool(), spec = this.pyWorker_spec()
                const ready = pool ? pool.readyFor(spec, 1) : []
                if (ready.length) { this._pyWarmPromise = this.pyWarm_runWorker(mod, root, n).finally(() => { this._pyWarmPromise = null }); return }
                if (pool && n <= 15) { this.pyWorker_warm(); this.pyWarm_schedule(1000); return }
            }
            // IE 2026 09 05 / ODOO-336379: прогрев на ГЛАВНОМ потоке — только по флагу afterEdit_warm_main (дефолт ВЫКЛ).
            // Бенч 05.09 (матрица 1, бандл без воркера): проход бренда 7,5 с (×4 — до 40 с) в idle блокировал UI и попадал
            // в соседние действия (открытие +8 с, вставка 12 ячеек +4 с на 0fU_001 после переключения варианта). Без воркера
            // первая правка платит за проход сама (как до шага 3) — предсказуемо, без внезапных заморозок.
            if (!this.store.perf_flag_widget(this.WIDGET, 'afterEdit_warm_main', false)) return
            this.pyWarm_runMain(mod, root, n)
        },
        pyWarm_runMain(mod, root, n) {
            const WIDGET = this.WIDGET
            const data0 = [root.dataItem]
            const t0 = performance.now()
            try {
                mod.__dict__.set('data', this.data)
                mod.__dict__.set('dataItem', root.dataItem)
                mod.__dict__.set('widget', WIDGET?.record || {})
                mod.__dict__.set('WIDGET', WIDGET || {})
                mod.__dict__.set('data0', data0)
                mod.__dict__.set('parentRow', undefined)
                const _cssSnap = this.cssPerf_scoped() ? this.cssSig_snapshot(data0) : null
                let result = this.exec("pyWarm", this.dataItem__afterEdit)
                if (result && typeof result.toJs === 'function') { const jsVal = result.toJs(); result.destroy?.(); result = jsVal }
                this._scopeWarmMod = mod   // полный пересчёт блока состоялся — правки дальше суженные
                const ms = Math.round((performance.now() - t0) * 10) / 10
                this.css_invalidate_rows(_cssSnap ? this.cssSig_changed(_cssSnap, root.dataItem) : null, 'warm')
                this.cf_cache?.clear()
                this.flex?.invalidate()
                const d = root.dataItem
                const title = String(d['Бренд-title'] || d['БЮ-title'] || d['Страна-title'] || d.title || d._fe?.key || '').slice(0, 60)
                const skus = this.afterEdit_scope_countSku(data0)
                this.store.gridPerf_warmPush?.({ t: Date.now(), grid: this.attr?.name || '', block: title, skus, ms, tries: n })
                console.log(`[gridPerf] warm: ${ms} ms (idle, block ${title || '?'}, skus ${skus}, try ${n})`)
            } catch (err) {
                this._pyWarmFailed = mod
                console.warn('[gridPerf] warm failed (the first edit will run the full block recalculation):', String(err))
            }
        },
        // IE 2026 09 05 / ODOO-336379: прогрев в воркере — копия блока → <attr>__afterEdit в воркере → диф на живые строки
        // (стоп-гард по старому значению: ячейка, правленная пользователем за время прохода, не перетирается). Правки, пришедшие
        // за время прохода, ждут его окончания (pyRecalc_batch: await _pyWarmPromise) — иначе два дифа одного блока перекрылись бы
        async pyWarm_runWorker(mod, root, n) {
            const WIDGET = this.WIDGET, childPath = this.attr?.childItemsPath
            const data0 = [root.dataItem]
            const t0 = performance.now()
            let handled = false
            try {
                const pool = this.pyWorker_pool(), spec = this.pyWorker_spec()
                const byKey = new Map(), nextKey = () => ++this.cache_index
                const roots = pyWorker_copyRows(data0, childPath, nextKey, byKey)
                const _cssSnap = this.cssPerf_scoped() ? this.cssSig_snapshot(data0) : null
                const widget = this.pyWorker_widgetCopy()
                const msg = { mode: 'block', roots, childPath, widget, WIDGET: { id: WIDGET?.id, title: WIDGET?.title, widget: WIDGET?.widget, widget_class: WIDGET?.widget_class, record: widget },
                    rights: { ...(this.store.user?.rights || {}) }, dataItemKey: root.dataItem?._fe?.key ?? null, parentRowKey: null }
                const tCopy = performance.now() - t0
                const res = await pool.recalc(spec, msg, null, 1)
                if (this._pyMod !== mod) return   // виджет пересоздан за время прохода
                if (!res || res.structural) throw new Error(res ? 'structural change in the block (rows added/removed)' : 'empty result')
                handled = true
                const ta = performance.now()
                const st = pyWorker_applyDiff(res.diff, byKey)
                this._scopeWarmMod = mod   // полный пересчёт блока состоялся — правки дальше суженные
                const ms = Math.round((performance.now() - t0) * 10) / 10
                this.css_invalidate_rows(_cssSnap ? this.cssSig_changed(_cssSnap, root.dataItem) : null, 'warm')
                this.cf_cache?.clear()
                this.flex?.invalidate()
                const d = root.dataItem
                const title = String(d['Бренд-title'] || d['БЮ-title'] || d['Страна-title'] || d.title || d._fe?.key || '').slice(0, 60)
                const skus = this.afterEdit_scope_countSku(data0)
                const rec = { t: Date.now(), grid: this.attr?.name || '', block: title, skus, ms, tries: n, via: 'worker#' + res.worker, worker_ms: res.ms?.total || 0, compute_ms: res.ms?.compute || 0,
                    copy_ms: Math.round(tCopy), apply_ms: Math.round(performance.now() - ta), applied: st.applied, stale: st.stale, diffs: (res.diff || []).length }
                this.store.gridPerf_warmPush?.(rec)
                console.log(`[gridPerf] warm: ${ms} ms (idle, block ${title || '?'}, skus ${skus}, try ${n}, via ${rec.via}: compute ${rec.compute_ms} ms in the worker, copy ${rec.copy_ms} ms, apply ${rec.apply_ms} ms — ${st.applied} cells, stale ${st.stale}; main thread ≈ ${rec.copy_ms + rec.apply_ms} ms)`)
            } catch (err) {
                if (handled || this._pyMod !== mod) return
                console.warn('[gridPerf] warm in the worker failed, main thread:', String(err))
                this.pyWarm_runMain(mod, root, n)
            }
        },
        // IE 2026 09 04 / ODOO-336379: область python-пересчёта после правки. Возвращает null (полный блок) либо
        // { fakeRoots: [{attrs:[skuNode]}], chain: [предки снизу вверх до уровня 0], snapItems } — только когда:
        // флаг afterEdit_scope_sku, код виджета = M03 (тело <attr>__afterEdit — ровно calculate_report_M03({}, data0)),
        // отпечаток блока агрегации calc_GruopGroups модуля совпадает с тем, что воспроизводит хелпер, правка внутри
        // узла SKU (doc.«Сводная Номенклатура») и по флагу afterEdit_scope_warm уже был один полный пересчёт блока
        afterEdit_scope(dataItem, irow, data0) {
            try {
                if (!this.cssPerf_on('afterEdit_scope_sku')) return null
                const mod = this._pyMod
                if (!mod || this._scopeFailed === mod) return null
                if (!this.attr?.childItemsPath || !Array.isArray(data0) || data0.length !== 1) return null
                if (!this.afterEdit_scope_ok()) return null
                if (this.cssPerf_on('afterEdit_scope_warm') && this._scopeWarmMod !== mod) return null
                const rows = this.flex?.rows
                const row = rows?.[irow]
                if (!row || !(row.level > 0)) return null
                const isSku = (it) => !!(it && ((it.doc && it.doc['Сводная Номенклатура']) || it['doc.Сводная Номенклатура'])) // IE 2026 09 04 / ODOO-336379: плоский ключ строк M03
                const childPath = this.attr.childItemsPath
                // предки по уровням дерева грида: ближайший узел SKU, над ним — цепочка до уровня 0
                let level = row.level, sku = null
                const chain = [], chainLevels = []   // IE 2026 09 05 / ODOO-336379: уровни предков — порядок пересуммирования в multi-SKU
                for (let i = irow - 1; i >= 0 && level > 0; i--) {
                    const r = rows[i]
                    if (!r || !(r.level < level)) continue
                    level = r.level
                    const it = r.dataItem
                    if (!sku) { if (isSku(it)) sku = it; else return null }   // правка не внутри SKU (агрегатная строка) → полный
                    else { chain.push(it); chainLevels.push(level) }
                    if (level === 0) break
                }
                if (!sku || !chain.length || chain[chain.length - 1] !== data0[0]) return null
                for (const rec of chain) if (!rec || !Array.isArray(rec[childPath])) return null
                const groupRows = (rec) => rec[childPath].filter(it => it && !isSku(it) && !((it.doc && it.doc['Бренд']) || it['doc.Бренд'])) // IE 2026 09 04 / ODOO-336379
                const chainSnaps = chain.map(rec => ({ [childPath]: groupRows(rec) }))
                const snapItems = [sku, ...chainSnaps]
                return { sku, chain, chainLevels, chainSnaps, fakeRoots: [{ [childPath]: [sku] }], snapItems }
            } catch (e) {
                return null
            }
        },
        afterEdit_scope_countSku(data0) {
            let n = 0
            const childPath = this.attr?.childItemsPath
            const walk = (list, depth) => {
                if (!Array.isArray(list) || depth > 12) return
                for (const it of list) {
                    if (!it || typeof it !== 'object') continue
                    if ((it.doc && it.doc['Сводная Номенклатура']) || it['doc.Сводная Номенклатура']) { n++; continue } // IE 2026 09 04 / ODOO-336379
                    if (childPath && Array.isArray(it[childPath])) walk(it[childPath], depth + 1)
                }
            }
            walk(data0, 0)
            return n
        },
        // проверка применимости (кэш по сигнатуре кода): тело <attr>__afterEdit и отпечаток блока агрегации модуля
        afterEdit_scope_ok() {
            const sig = this._pySig || ''
            if (this._scopeOk !== undefined && this._scopeOkSig === sig) return this._scopeOk
            let ok = false
            try {
                const name = `${this.attr?.name}__afterEdit`
                const esc = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
                const srcs = [String(this.attr?.['code-eval'] || ''), ...Object.values(this.WIDGET?.record?._import_modules || {}).map(v => String(v || ''))]
                const re = new RegExp('def\\s+' + esc + '\\s*\\([^)]*\\)\\s*:[^\\n]*\\n([\\s\\S]*?)(?=\\n\\S|$)')
                let body = null
                for (const src of srcs) { const m = re.exec(src); if (m) { body = m[1]; break } }
                const lines = (body || '').split('\n').map(l => l.replace(/#.*$/, '').trim()).filter(Boolean)
                const bodyOk = lines.length === 1 && /^calculate_report_M03\(\s*\{\s*\}\s*,\s*data0\s*\)$/.test(lines[0])
                // отпечаток блока calc_GruopGroups (без комментариев и пустых строк) — ровно то, что воспроизводит хелпер
                let sigOk = false
                for (const src of srcs) {
                    const a = src.indexOf('    def calc_GruopGroups(record):')
                    if (a < 0) continue
                    const b = src.indexOf('    for record in data:', a)
                    if (b < 0) continue
                    const norm = src.slice(a, b).split('\n').map(l => l.split('#')[0].replace(/\s+$/, '')).filter(l => l.trim()).join('\n')
                    sigOk = this.afterEdit_scope_hash(norm) === 0x85897ca0
                    break
                }
                ok = bodyOk && sigOk
                if (!ok) console.warn(`[gridPerf] afterEdit_scope_sku: not applicable (afterEdit body ${bodyOk ? 'ok' : 'differs'}, module block ${sigOk ? 'ok' : 'differs'}) — full block recalculation`)
            } catch (e) { ok = false }
            this._scopeOk = ok; this._scopeOkSig = sig
            return ok
        },
        afterEdit_scope_hash(str) {   // FNV-1a 32 по UTF-8
            const bytes = new TextEncoder().encode(str)
            let h = 0x811c9dc5
            for (const c of bytes) { h ^= c; h = Math.imul(h, 0x01000193) >>> 0 }
            return h >>> 0
        },
        // хелпер в пространстве имён модуля виджета (ставится лениво, модуль 0hO_001 не меняется):
        // SKU — настоящей calculate_report_M03 на синтетическом корне; предки — шаги 1–3 calc_GruopGroups
        // IE 2026 09 05 / ODOO-336379: исходник хелперов суженного пересчёта — общий для главного pyodide (afterEdit_scope_fn)
        // и воркеров pyodide (py.worker.js, сообщение load: helperSrc) — семантика пересуммирования предков одна
        afterEdit_scope_src() {
            return `
def __ie_reaggr_level(P, record):
    # IE 2026 09 04 / ODOO-336379: шаги 1–3 calc_GruopGroups (0hO_001) для одного уровня без пересчёта детей
    prefix = P['prefix']
    forecast_year = P['forecast_year']
    group_data = []
    childs = []
    keys = {}
    for row in get_value(record, 'attrs'):
        if get_value(row, 'doc.Сводная Номенклатура'):
            childs.append(row)
        elif get_value(row, 'doc.Бренд'):
            childs.append(row)
        else:
            group_data.append(row)
            key = f"{get_value(row, prefix+'measure','')}-{get_value(row, prefix+'year','')}"
            keys[key] = row
    for row_group in group_data:
        for month in range(1, 13):
            set_value(row_group, f"{prefix}quantity_M{month:02d}", 0)
            set_value(row_group, f"{prefix}usd_M{month:02d}", 0)
            set_value(row_group, f"{prefix}price_usd_M{month:02d}", 0)
        set_value(row_group, prefix+'isPrice', '')
    for child in childs:
        for month in range(1, 13):
            for row in get_value(child, 'attrs', []):
                binding_quantity_M = f"{prefix}quantity_M{month:02d}"
                binding_usd_M = f"{prefix}usd_M{month:02d}"
                key = f"{get_value(row, prefix+'measure','')}-{get_value(row, prefix+'year','')}"
                row_group = keys.get(key)
                if row_group:
                    value = get_value(row, binding_quantity_M, 0)
                    set_value(row_group, binding_quantity_M, value, add=True)
                    value = get_value(row, binding_usd_M, 0)
                    set_value(row_group, binding_usd_M, value, add=True)
    for row in group_data:
        measure = get_value(row, prefix+'measure','')
        year = int(get_value(row, prefix+'year','') or 0)
        if measure == "LBE" and year >= forecast_year:
            for month in range(1, 13):
                binding_quantity_M = f"{prefix}quantity_M{month:02d}"
                binding_usd_M = f"{prefix}usd_M{month:02d}"
                binding_price_M = f"{prefix}price_usd_M{month:02d}"
                quantity = get_value(row, binding_quantity_M, 0)
                usd = get_value(row, binding_usd_M, 0)
                price = round(usd / quantity, 2) if quantity else 0
                set_value(row, binding_price_M, price)
    P['data'] = group_data
    calc_record_aggr_M03(P, 'quantity', calcAll=True)
    calc_record_aggr_M03(P, 'usd', calcAll=True)

def __ie_afterEdit_scoped(fake_roots, chain):
    # IE 2026 09 04 / ODOO-336379: SKU — настоящей calculate_report_M03 (calc_record_M03_2 + set_title + set_isPrice
    # модуля) на корне с одним ребёнком; затем предки снизу вверх — только пересуммирование
    calculate_report_M03({}, fake_roots)
    P = {}
    P['prefix'] = 'data::'
    date_forecast_from_M03 = P['date_forecast_from_M03'] = get_value(widget, 'params.date_forecast_from_M03')
    P['forecast_month'] = int(date_forecast_from_M03[5:7])
    P['forecast_year'] = int(date_forecast_from_M03[:4])
    n = 0
    for record in chain:
        __ie_reaggr_level(P, record)
        n += 1
    return n

def __ie_reaggr_chain(chain):
    # IE 2026 09 05 / ODOO-336379: SKU уже пересчитаны в воркере (диф применён) — предки снизу вверх, один раз на запись
    P = {}
    P['prefix'] = 'data::'
    date_forecast_from_M03 = P['date_forecast_from_M03'] = get_value(widget, 'params.date_forecast_from_M03')
    P['forecast_month'] = int(date_forecast_from_M03[5:7])
    P['forecast_year'] = int(date_forecast_from_M03[:4])
    n = 0
    for record in chain:
        __ie_reaggr_level(P, record)
        n += 1
    return n
`
        },
        afterEdit_scope_fn(mod) {
            if (this._pyScopeFn && this._pyScopeFnMod === mod) return this._pyScopeFn
            const src = this.afterEdit_scope_src()
            this.store.pyodide.runPython(src, { globals: mod.__dict__ })
            const fn = mod.__dict__.get('__ie_afterEdit_scoped')
            if (typeof fn !== 'function') throw new Error('__ie_afterEdit_scoped is not installed')
            const fnChain = mod.__dict__.get('__ie_reaggr_chain') // IE 2026 09 05 / ODOO-336379
            this._pyScopeFn = fn; this._pyScopeFnMod = mod
            this._pyReaggrFn = typeof fnChain === 'function' ? fnChain : null
            return fn
        },
        pyRecalc_queue(dataItem, ctx=null) {
            // IE 2026 08 19 / ODOO-5512 (заказ Игоря): пересчёт пользовательского кода
            // (afterEdit) для строки без правки ячейки — после очистки корректировок и
            // после undo/redo; ctx = {actionStack, bindings} — регистрировать связанные
            // изменения той же группой (null — не регистрировать)
            if (!dataItem || this.cache_process_dataItem_py__used === -1) return
            if (!dataItem._fe) dataItem._fe = { key: ++this.cache_index }
            if (!dataItem._fe.key) dataItem._fe.key = ++this.cache_index
            this.cache_process_dataItem_py.set(dataItem._fe.key, dataItem)
            if (ctx) (this._pyEditCtx = this._pyEditCtx || new Map()).set(dataItem._fe.key, ctx)
            else this._pyEditCtx?.delete(dataItem._fe.key)
            this.process_dataItem_py__start_t0 = performance.now()
            if (!this.process_dataItem_py__start_WORKIING) {
                this.process_dataItem_py__start_WORKIING = true
                this.process_dataItem_py__start()
            }
        },
        // ===== IE 2026 09 05 / ODOO-336379: python-пересчёт после правки в Web Worker (флаг py_worker, дефолт ВКЛ) и пул
        // воркеров для пакета правок по нескольким SKU (флаг py_worker_pool, дефолт ВКЛ). Единый вход — pyRecalc_batch(jobs):
        // реализации main (как раньше, построчно) | worker | pool. Область — как у afterEdit_scope: SKU (fakeRoots, предки
        // пересуммируются ОДИН раз в главном потоке хелпером __ie_reaggr_chain) либо полный блок уровня 0 (<attr>__afterEdit
        // в воркере). Копия блока → воркер → диф изменённых ячеек → применение к живым строкам (стоп-гард по старому
        // значению) → pyDerived_register/css_invalidate_rows как в process_dataItem_py. Любая ошибка/структурный диф/
        // неготовый воркер → главный поток. Выключатели: window.gridPerf.set('py_worker', false) / ('py_worker_pool', false);
        // JSON вместо structured clone для замера — ('py_worker_json', true). Паспорта: window.gridPerf.py(n), .workers()
        pyWorker_on() {
            try {
                if (!this.cssPerf_on('py_worker') || !pyWorker_supported()) return false
                const pp = this.store.profiling_params
                if (pp?.use && pp.type === 'fe_exec') return false   // профилирование python — только в главном потоке
                if (!this._pyMod || typeof this.dataItem__afterEdit !== 'function' || !this._pyModName) return false
                if (!this.attr?.childItemsPath) return false
                return this.afterEdit_scope_ok()   // код M03: <attr>__afterEdit = calculate_report_M03({}, data0), блок агрегации известен
            } catch (e) { return false }
        },
        pyWorker_pool() {
            return this.store.pyWorkerPool ? this.store.pyWorkerPool() : null
        },
        pyWorker_count() {
            const pool = this.pyWorker_pool()
            if (!pool) return 0
            return this.cssPerf_on('py_worker_pool') ? pool.size : 1
        },
        pyWorker_spec() {
            const modules = { ...(this.WIDGET?.record?._import_modules || {}) }
            if (this.attr?.['code-eval']) modules.attr = this.attr['code-eval']
            const afterEditName = `${this.attr?.name}__afterEdit`
            // helperSrc — хелперы суженного пересчёта (__ie_reaggr_chain: предки в воркере), тот же исходник, что в главном потоке
            return { modName: this._pyModName, sig: this._pySig || '', modules, afterEditName, skuFn: 'calculate_report_M03', helperSrc: this.afterEdit_scope_src(), fnNames: [afterEditName, '__ie_worker_sku', '__ie_reaggr_chain'] }
        },
        pyWorker_warm(limit = 1) {
            // ленивый прогрев: после готовности модуля и первой отрисовки, в idle — не блокирует UI; воркеры по одному,
            // модуль отчёта — во все (pyWorkerPool.warm)
            // IE 2026 09 05 / ODOO-336379: по умолчанию греем ОДИН воркер. Каждый тянет pyodide (~9 МБ wasm + 9 МБ stdlib),
            // и прогрев всего пула при открытии стоил +4–5 с к open_total (бенч, матрица 2: step6 20,6 с против 15,8 с у
            // одиночного воркера). Остальные догреваются, когда реально пришёл пакет по нескольким SKU (pyRecalc_batch).
            try {
                if (!this.pyWorker_on()) return
                const spec = this.pyWorker_spec(), n = Math.min(this.pyWorker_count(), Math.max(1, limit))
                if (!n) return
                const go = () => { try { this.pyWorker_pool()?.warm(spec, n) } catch (e) { console.warn('[gridPerf] py worker: warm failed', String(e)) } }
                if (typeof requestIdleCallback === 'function') requestIdleCallback(go, { timeout: 4000 })
                else setTimeout(go, 1500)
            } catch (e) { /* без воркера — считает главный поток */ }
        },
        pyWorker_widgetCopy() {
            // «widget» для python в воркере: запись виджета без тяжёлых полей (data/_data/_doc/_import_modules/undoStack)
            const raw = toRaw(this.WIDGET?.record || {})
            const SKIP = new Set(['data', '_data', '_doc', '_import_modules', '_cells', 'attrs', 'undoStack', 'redoStack', '_meta', '_fe'])
            const out = {}
            for (const k of Object.keys(raw)) {
                if (SKIP.has(k)) continue
                if (k === 'doc' && raw.doc && typeof raw.doc === 'object') {
                    const d = toRaw(raw.doc), doc = {}
                    for (const dk of Object.keys(d)) { if (dk === 'data' || dk === 'viewParams' || dk === '_cells') continue; doc[dk] = pyWorker_plain(d[dk]) }
                    out.doc = doc
                    continue
                }
                out[k] = pyWorker_plain(raw[k])
            }
            return out
        },
        async pyRecalc_main(jobs) {
            // реализация «sequential (main)»: построчно, как process_dataItem_py__start до воркера
            let t0 = performance.now()
            for (const j of jobs) {
                const t1 = performance.now()
                this.process_dataItem_py(j.dataItem, j.ctx)
                console.log('process_dataItem_py__start ', performance.now() - t1, this._pyLastScope ? `scope=${this._pyLastScope.scope} skus=${this._pyLastScope.skus}/${this._pyLastScope.total}` : '', 'via=main')
                if (performance.now() - t0 > 50) { await this.store.sleep(10); t0 = performance.now() }
            }
        },
        async pyRecalc_batch(jobs) {
            if (this._pyWarmPromise) { try { await this._pyWarmPromise } catch (e) { /* прогрев сам сообщил */ } }   // IE 2026 09 05 / ODOO-336379: не перекрывать дифы одного блока
            const pool = this.pyWorker_pool()
            const spec = this.pyWorker_spec()
            const nWorkers = this.pyWorker_count()
            const ready = pool ? pool.readyFor(spec, nWorkers) : []
            // IE 2026 09 05 / ODOO-336379: пакет по нескольким SKU — догреть пул до нужного размера (при открытии грелся один)
            if (nWorkers > 1 && jobs.length > 1 && ready.length < nWorkers) this.pyWorker_warm(nWorkers)
            if (!ready.length) {
                if (!this._pyWorkerNotReadyLogged) { this._pyWorkerNotReadyLogged = true; console.log('[gridPerf] py: worker not ready (warming up) — main thread recalculation') }
                this.pyWorker_warm()
                return this.pyRecalc_main(jobs)
            }
            const mod = this._pyMod, WIDGET = this.WIDGET, childPath = this.attr.childItemsPath
            const useJson = !!this.store.perf_flag('py_worker_json', false)
            const T = { t0: performance.now(), copy: 0, wall: 0, compute: 0, computeMax: 0, diffMs: 0, cloneMs: 0, parseMs: 0, apply: 0, reaggr: 0, register: 0, jobs: jobs.length, reqs: 0, groups: 0, sku: 0, block: 0, single: 0, fallback: 0, stale: 0, applied: 0, diffs: 0, bytes: 0,
                reaggr_main: 0, reaggr_worker: 0, reaggr_copy: 0, reaggr_wall: 0, reaggr_worker_ms: 0, chain: 0, workers: new Set(), cssRows: [], cssAll: false, scopes: [], skus: 0, total: 0 }
            const isSku = (it) => !!(it && ((it.doc && it.doc['Сводная Номенклатура']) || it['doc.Сводная Номенклатура']))
            const isBrand = (it) => !!(it && ((it.doc && it.doc['Бренд']) || it['doc.Бренд']))
            const nextKey = () => ++this.cache_index
            const widget = this.pyWorker_widgetCopy()
            const WIDGET_lite = { id: WIDGET?.id, title: WIDGET?.title, widget: WIDGET?.widget, widget_class: WIDGET?.widget_class, record: widget }
            const rights = { ...(this.store.user?.rights || {}) }
            const r0 = (x) => Math.round(x || 0)
            const parentKey = (irow) => { const pp = this.get_parentPosition(irow); return pp >= 0 ? (this.flex.rows[pp]?.dataItem?._fe?.key ?? null) : null }
            // 1. группы — ровно как process_dataItem_py_multi главного потока: (блок уровня 0, действие actionStack) в порядке
            //    очереди; строка вне грида / без блока — главный поток; агрегатная правка в группе — полный блок один раз на группу.
            //    Группы одного блока считаются ПОСЛЕДОВАТЕЛЬНО (копия берётся после применения предыдущей — результат байт-в-байт
            //    как у последовательных проходов главного потока), SKU одной группы — параллельно по воркерам пула, блоки — параллельно
            const single = [], blocks = new Map()
            for (const job of jobs) {
                let irow = -1, data0 = null
                try { irow = this.rows_indexOf(job.dataItem); if (irow >= 0) data0 = this.get_data0(irow) } catch (e) { data0 = null }
                if (!(irow >= 0) || !Array.isArray(data0) || data0.length !== 1 || !data0[0]) { single.push(job); continue }
                job.irow = irow; job.data0 = data0
                const as = job.ctx ? job.ctx.actionStack : null
                let blk = blocks.get(data0[0])
                if (!blk) { blk = { root: data0[0], data0, groups: [] }; blocks.set(data0[0], blk) }
                let g = blk.groups.find(gg => gg.actionStack === as)
                if (!g) { g = { actionStack: as, jobs: [], skus: new Map(), block: false }; blk.groups.push(g) }
                g.jobs.push(job)
                const scope = this.afterEdit_scope(job.dataItem, irow, data0)
                if (!scope) g.block = true
                else if (!g.skus.has(scope.sku)) g.skus.set(scope.sku, { scope, job })
            }
            for (const job of single) { T.single++; this.process_dataItem_py(job.dataItem, job.ctx) }
            const applyRes = (r, byKey) => {
                const st = pyWorker_applyDiff(r.diff, byKey)
                T.applied += st.applied; T.stale += st.stale; T.diffs += (r.diff || []).length
                T.compute += r.ms.compute; T.diffMs += r.ms.diff; T.cloneMs += r.ms.clone; T.parseMs += r.ms.parse
                T.computeMax = Math.max(T.computeMax, r.ms.total); T.workers.add(r.worker)
                return st
            }
            const fallback = (g, res, kind) => {
                T.fallback++
                console.warn(`[gridPerf] py worker: ${res && res.ok ? 'structural change in the block (rows added/removed)' : String(res && res.err)} — main thread recalculation for this ${kind}`)
                for (const j of g.jobs) this.process_dataItem_py(j.dataItem, j.ctx)
            }
            const after = (g, snap, cssSnap, ctxJob, used, data0, r, nSku) => {
                const tg = performance.now()
                if (snap && ctxJob) this.pyDerived_register(snap, ctxJob.dataItem, ctxJob.ctx)
                if (cssSnap) T.cssRows.push(...this.cssSig_changed(cssSnap, g.jobs[0].dataItem)); else T.cssAll = true
                const _total = this.afterEdit_scope_countSku(data0)
                const skus = used === 'sku' ? nSku : _total
                T.skus += skus; T.total += _total; if (!T.scopes.includes(used)) T.scopes.push(used)
                const b = this._gridPerfCur
                if (b && !b.settled) { b.py_scope = used; b.py_skus = (b.py_skus || 0) + skus; b.py_skus_total = _total; b.py_worker_jobs = (b.py_worker_jobs || 0) + 1; b.py_worker_ms = (b.py_worker_ms || 0) + (r?.ms?.compute || 0) }
                console.log('process_dataItem_py__start ', r?.wall || 0, `scope=${used} skus=${skus}/${_total}`, `via=worker#${r?.worker} (compute ${r?.ms?.compute} ms${nSku > 1 ? ', ' + nSku + ' sku' : ''})`)
                T.register += performance.now() - tg
            }
            const chainOrder = (lv) => [...lv.keys()].sort((x, y) => lv.get(y) - lv.get(x))   // глубокие раньше
            const reaggrMain = (order) => {
                try {
                    this.afterEdit_scope_fn(mod)
                    if (typeof this._pyReaggrFn !== 'function') throw new Error('__ie_reaggr_chain is not installed')
                    mod.__dict__.set('widget', WIDGET?.record || {})
                    mod.__dict__.set('WIDGET', WIDGET || {})
                    const res = this.exec('pyRecalc_batch', this._pyReaggrFn, order)
                    if (res && typeof res.destroy === 'function') res.destroy()
                    T.chain += order.length; T.reaggr_main++
                    return true
                } catch (err) {
                    console.warn('[gridPerf] py worker: ancestors re-aggregation failed:', String(err))
                    this._scopeFailed = mod
                    return false
                }
            }
            const runBlock = async (blk) => {
                const chainLv = new Map(), chainSnaps = new Map()   // предок → уровень / снимок строк-агрегатов (объединение цепочек SKU-групп блока)
                let firstCtxJob = null, anySku = false
                for (const g of blk.groups) {
                    if (this._pyMod !== mod) return
                    const gJob = g.jobs[0], ctxJob = g.jobs.find(j => j.ctx) || null
                    if (!firstCtxJob && ctxJob) firstCtxJob = ctxJob
                    T.groups++
                    if (g.block) {
                        const byKey = new Map(), tc = performance.now()
                        const roots = pyWorker_copyRows(blk.data0, childPath, nextKey, byKey)
                        const json = useJson ? JSON.stringify(roots) : null
                        if (json) T.bytes += json.length
                        const msg = { mode: 'block', roots, childPath, widget, WIDGET: WIDGET_lite, rights, dataItemKey: gJob.dataItem?._fe?.key ?? null, parentRowKey: parentKey(gJob.irow) }
                        T.copy += performance.now() - tc
                        const snap = (ctxJob && !this._undoApplying && !this._undoBatch) ? this.pyDerived_snapshot(blk.data0) : null
                        const cssSnap = this.cssPerf_scoped() ? this.cssSig_snapshot(blk.data0) : null
                        T.reqs++; T.block++
                        const ts = performance.now()
                        const res = await pool.recalc(spec, msg, json, nWorkers).then(r => ({ ok: true, r }), err => ({ ok: false, err }))
                        T.wall += performance.now() - ts
                        if (this._pyMod !== mod) return
                        if (!res.ok || !res.r || res.r.structural) { fallback(g, res, 'block'); continue }
                        const ta = performance.now(); applyRes(res.r, byKey); T.apply += performance.now() - ta
                        this._scopeWarmMod = mod   // полный пересчёт блока состоялся — дальше можно сужать
                        after(g, snap, cssSnap, ctxJob, 'brand', blk.data0, res.r, 0)
                        continue
                    }
                    const reqs = [], snapItems = [], tc = performance.now()
                    for (const [sku, { scope, job }] of g.skus) {
                        const byKey = new Map()
                        const roots = [{ _fe: { key: '__root__' }, [childPath]: pyWorker_copyRows([sku], childPath, nextKey, byKey) }]
                        const json = useJson ? JSON.stringify(roots) : null
                        if (json) T.bytes += json.length
                        reqs.push({ byKey, json, msg: { mode: 'sku', roots, childPath, widget, WIDGET: WIDGET_lite, rights, dataItemKey: job.dataItem?._fe?.key ?? null, parentRowKey: parentKey(job.irow) } })
                        snapItems.push(sku)
                        scope.chain.forEach((rec, k) => { if (!chainLv.has(rec)) { chainLv.set(rec, scope.chainLevels?.[k] ?? (scope.chain.length - k)); chainSnaps.set(rec, scope.chainSnaps?.[k]) } })
                    }
                    T.copy += performance.now() - tc
                    const snap = (ctxJob && !this._undoApplying && !this._undoBatch) ? this.pyDerived_snapshot(snapItems) : null
                    const cssSnap = this.cssPerf_scoped() ? this.cssSig_snapshot(snapItems) : null
                    T.reqs += reqs.length; T.sku += reqs.length
                    const ts = performance.now()
                    const results = await Promise.all(reqs.map(rq => pool.recalc(spec, rq.msg, rq.json, nWorkers).then(r => ({ ok: true, r }), err => ({ ok: false, err }))))
                    T.wall += performance.now() - ts
                    if (this._pyMod !== mod) return
                    const bad = results.find(r => !r.ok || !r.r || r.r.structural)
                    if (bad) { fallback(g, bad, 'sku'); continue }
                    const ta = performance.now(); for (let i = 0; i < reqs.length; i++) applyRes(results[i].r, reqs[i].byKey); T.apply += performance.now() - ta
                    anySku = true
                    after(g, snap, cssSnap, ctxJob, 'sku', blk.data0, results[0].r, reqs.length)
                }
                // 2. предки SKU — один раз на блок, снизу вверх, в воркере (копия блока: полное поддерево правленых брендов,
                //    у прочих — только строки-агрегаты); ошибка/нет воркера → тот же хелпер __ie_reaggr_chain в главном pyodide
                if (!anySku || !chainLv.size || this._pyMod !== mod) return
                const tr = performance.now()
                const order = chainOrder(chainLv)
                const chainItems = order.map(rec => chainSnaps.get(rec)).filter(Boolean)
                const snap = (firstCtxJob && !this._undoApplying && !this._undoBatch) ? this.pyDerived_snapshot(chainItems) : null
                const cssSnap = this.cssPerf_scoped() ? this.cssSig_snapshot(chainItems) : null
                const byKey = new Map()
                let roots = null
                const tc = performance.now()
                try { roots = pyWorker_copyScope(blk.root, new Set(order), childPath, { isSku, isBrand, nextKey, byKey }) } catch (e) { roots = null }
                const chainKeys = order.map(rec => rec?._fe?.key)
                T.reaggr_copy += performance.now() - tc
                let ok = false
                // IE 2026 09 05 / ODOO-336379 (флаг py_worker_reaggr, дефолт ВКЛ): пересуммирование предков — вторым запросом
                // в воркер со своей копией цепочки. Замер 05.09 (матрица 3, CF ×1): сам расчёт 31–52 мс, а обмен с воркером
                // 1,5–1,9 мс×10² на правку — половина приходится на этот второй round-trip. OFF — предков пересуммирует
                // главный поток (≈400 мс занятости, но без ожидания воркера); что выгоднее, решается замером A/B.
                const reaggrInWorker = this.cssPerf_on('py_worker_reaggr')
                if (reaggrInWorker && roots && !chainKeys.some(k => k == null || !byKey.has(k))) {
                    const res = await pool.reaggr(spec, { roots, childPath, chainKeys, widget, WIDGET: WIDGET_lite, rights }, nWorkers).then(r => ({ ok: true, r }), err => ({ ok: false, err }))
                    if (this._pyMod !== mod) return
                    if (res.ok && res.r && !res.r.structural) {
                        const st = pyWorker_applyDiff(res.r.diff, byKey)
                        T.applied += st.applied; T.stale += st.stale; T.diffs += (res.r.diff || []).length
                        T.reaggr_worker_ms = Math.max(T.reaggr_worker_ms, res.r.ms?.total || 0); T.reaggr_wall = Math.max(T.reaggr_wall, res.r.wall || 0)
                        T.chain += order.length; T.reaggr_worker++; T.workers.add(res.r.worker)
                        ok = true
                    } else console.warn(`[gridPerf] py worker: ancestors re-aggregation in the worker failed (${res.ok ? 'structural change' : String(res.err)}) — main thread`)
                }
                if (!ok && !reaggrMain(order)) { for (const g of blk.groups) if (!g.block) for (const j of g.jobs) this.process_dataItem_py(j.dataItem, j.ctx); T.fallback++ }
                T.reaggr += performance.now() - tr
                const tg = performance.now()
                if (snap && firstCtxJob) this.pyDerived_register(snap, firstCtxJob.dataItem, firstCtxJob.ctx)
                if (cssSnap) T.cssRows.push(...this.cssSig_changed(cssSnap, (firstCtxJob || blk.groups[0].jobs[0]).dataItem)); else T.cssAll = true
                T.register += performance.now() - tg
            }
            await Promise.all([...blocks.values()].map(runBlock))
            if (this._pyMod !== mod) return   // виджет пересоздан за время расчёта — результаты не применяем
            // 3. py-CSS по изменённым строкам, счётчики, перерисовка
            const tg0 = performance.now()
            if (blocks.size) this.css_invalidate_rows(T.cssAll ? null : T.cssRows, 'afterEdit')
            this._pyLastScope = T.scopes.length ? { scope: T.scopes.join('+'), skus: T.skus, total: T.total } : this._pyLastScope
            this.cf_cache?.clear()
            this.flex?.invalidate()
            T.register += performance.now() - tg0
            T.total_ms = performance.now() - T.t0
            const transfer = Math.max(0, r0(T.copy) + r0(T.wall - T.computeMax))
            const mode = nWorkers > 1 ? 'pool' : 'worker'
            const rec = { t: Date.now(), mode, workers: T.workers.size, workers_avail: ready.length, jobs: T.jobs, groups: T.groups, reqs: T.reqs, sku: T.sku, block: T.block, single: T.single, fallback: T.fallback,
                total_ms: r0(T.total_ms), worker_ms: r0(T.wall), transfer_ms: transfer, copy_ms: r0(T.copy), compute_ms: r0(T.computeMax), compute_sum_ms: r0(T.compute), clone_ms: r0(T.cloneMs), parse_ms: r0(T.parseMs), diff_ms: r0(T.diffMs),
                apply_ms: r0(T.apply), reaggr_ms: r0(T.reaggr), reaggr_via: T.reaggr_worker ? (T.reaggr_main ? 'worker+main' : 'worker') : (T.reaggr_main ? 'main' : ''), reaggr_copy_ms: r0(T.reaggr_copy), reaggr_wall_ms: r0(T.reaggr_wall), reaggr_worker_ms: r0(T.reaggr_worker_ms),
                register_ms: r0(T.register), main_ms: r0(T.copy + T.apply + T.reaggr_copy + T.register + (T.reaggr_main ? T.reaggr - T.reaggr_wall : 0)), diffs: T.diffs, applied: T.applied, stale: T.stale, chain: T.chain, json: useJson, json_kb: useJson ? Math.round(T.bytes / 1024) : 0 }
            console.log(`[gridPerf] py: worker=${rec.worker_ms} ms transfer=${rec.transfer_ms} ms compute=${rec.compute_ms} ms apply=${r0(T.apply + T.reaggr + T.register)} ms (${mode}: workers ${rec.workers}/${rec.workers_avail}, jobs ${rec.jobs} → groups ${rec.groups}: sku ${rec.sku}, block ${rec.block}, single ${rec.single}, fallback ${rec.fallback}; copy ${rec.copy_ms} ms, worker clone/compute/diff ${rec.clone_ms}/${rec.compute_sum_ms}/${rec.diff_ms} ms, apply ${rec.apply_ms} ms (${rec.applied} cells, stale ${rec.stale}), ancestors ${rec.chain} in ${rec.reaggr_ms} ms via ${rec.reaggr_via || '-'} (copy ${rec.reaggr_copy_ms} ms, worker ${rec.reaggr_worker_ms} ms), register ${rec.register_ms} ms, total ${rec.total_ms} ms, main thread ≈ ${rec.main_ms} ms${useJson ? ', json ' + rec.json_kb + ' KB' : ''})`)
            if (this.store.gridPerf_pyPush) this.store.gridPerf_pyPush(rec)
        },
        pyDerived_snapshot(items) {
            // IE 2026 08 18 / ODOO-5512: значения ячеек-колонок грида по строкам
            // блока (дерево по childItemsPath); только скаляры, только привязки колонок
            const snap = new Map()
            const childPath = this.attr.childItemsPath
            const byBinding = this.attr_by_binding || {}
            // только скалярные колонки: мульти-словари/вложенные привязки (AttrMulti,
            // nestedAttrMulti) откатом через set_value не восстанавливаются (падал
            // check_AttrMulti на undo очистки корректировок, 19.08)
            const bindings = Object.keys(byBinding).filter(b => byBinding[b] && byBinding[b].icol != null && !b.startsWith('_')
                && byBinding[b].attr_type !== 'AttrMulti' && !byBinding[b].nestedAttrMulti && !/\.(valueStr|value|attr_type|binding|relation_segment)$/.test(b))
            const walk = (list, depth) => {
                if (!Array.isArray(list) || depth > 12) return
                for (const it of list) {
                    if (!it || typeof it !== 'object') continue
                    const vals = {}
                    for (const b of bindings) {
                        const v = it[b]
                        if (v === null || v === undefined || typeof v === 'number' || typeof v === 'string' || typeof v === 'boolean') vals[b] = v
                    }
                    snap.set(it, vals)
                    if (childPath && Array.isArray(it[childPath])) walk(it[childPath], depth + 1)
                }
            }
            walk(items, 0)
            return snap
        },
        pyDerived_register(snap, dataItem, editCtx) {
            // IE 2026 08 18 / ODOO-5512 (заказ Игоря): ячейки, которые поменял
            // пользовательский код после правки, — «связанные» изменения той же
            // группы (actionStack): в changesStack как indirect (фон не трогают,
            // бейдж дельты, подсветка группы по наведению, откат вместе с правкой);
            // сама правленная ячейка (и другие триггеры группы) не перезаписывается
            if (!snap || !editCtx) return
            const same = (a, b) => (a === b) || (a == null && b == null)
                || (typeof a === 'number' && typeof b === 'number' && Math.abs(a - b) < 1e-9)
            const ts = Date.now()
            let n = 0
            for (const [item, vals] of snap) {
                for (const b in vals) {
                    const nv = item[b]
                    if (nv !== null && nv !== undefined && typeof nv === 'object') continue
                    if (same(vals[b], nv)) continue
                    if (item === dataItem && editCtx.bindings?.has(b)) continue
                    const irow = this.rows_indexOf(item)
                    if (irow == null || irow < 0) continue
                    const attr_col = this.attr_by_binding[b] || {}
                    const key = `${irow}:${b}`
                    const prev = this.changesStack[key]
                    // ручную правку той же группы не затираем связанной
                    if (prev && prev.actionStack === editCtx.actionStack && (prev.user || (!prev.indirect && !prev.related))) continue
                    this.pushStack({
                        method: 'val', indirect: true, pyDerived: true, actionStack: editCtx.actionStack,
                        irow, icol: attr_col.icol, $key: item.$key, $item: item, col_binding: b,
                        val: vals[b], newVal: nv, ts,
                    })
                    n++
                }
            }
            if (n) {
                this._foldAggCache = null
                // вспышка — по всей группе действия: и правленная рукой ячейка,
                // и связанные с ней (иначе новая пачка гасит вспышку правки)
                this.flash_start(this.flash_ofAction(editCtx.actionStack))
            }
        },
        exec(whoCalledMe, fn, ...args) {
            const pyodide = this.store.pyodide;
            const profiling_params = this.store.profiling_params;
            const WIDGET = this.WIDGET;

            const profiling = profiling_params.use && profiling_params.type === 'fe_exec'
            let t0, profiling_params_py;
            if (profiling) {
                profiling_params_py = pyodide.toPy(profiling_params)
                pyodide.globals.get('start')(profiling_params_py);
                t0 = performance.now();
            }

            // вызов python-функции из модуля виджета
            let result = fn(...args);

            if (profiling) {
                const delay = (performance.now() - t0)

                const res = pyodide.globals.get('stop')(profiling_params_py)
                const profile_result = res.toJs({ dict_converter: Object.fromEntries });

                WIDGET.record._doc.line_summary = profile_result.line_summary
                WIDGET.record._doc.call_summary = profile_result.call_summary
                
                const call_tree = [{
                    name: whoCalledMe,
                    file: "AttrGrid",
                    // line: 0,
                    widget_id: this.widget_id,
                    binding: this.attr.binding,
                    total_ms: delay,
                    self_ms: delay,
                    calls: 1,
                    attrs: profile_result.call_tree,
                }]
                WIDGET.record._doc.call_tree = mergeTrees(WIDGET.record._doc.call_tree||[], call_tree);

                if (this.exec_timeout) { clearTimeout(this.exec_timeout) }
                this.exec_timeout = window.$cg.setTimeout(this, "AttrGrid.exec", () => {
                    // WIDGET.vueObj.content_Changed()
                    WIDGET.vueObj?.content_Changed_attr_vueObj?.('_doc.line_summary')
                    WIDGET.vueObj?.content_Changed_attr_vueObj?.('_doc.call_summary')
                    WIDGET.vueObj?.content_Changed_attr_vueObj?.('_doc.call_tree')
                }, 500)

                res.destroy();
                profiling_params_py.destroy();
            }

            return result;
        },
        process_dataItem(dataItem) {
            let code = this.attr['code-eval-fe'] || ''
            const params = this.WIDGET.record?.doc?.params
            if (!code && this.attr.binding === '_doc.data') {
                code = params?.['code-eval-fe'] || ''
            }
            if (!code || !code.includes('process_dataItem')) {
                return;
            }

            const fullCode = `
            ${code}
            process_dataItem(data, dataItem)
            `
            const evalParams = {
                widget: this.WIDGET.record,
                data: this.data000,
                dataItem: dataItem,
                params: params,
                getValue: this.store.get_value.bind(this.store), // TODEL 2025-06-11
                get_value: this.store.get_value.bind(this.store),
            };

            const { result, error } = this.runUserCode(fullCode, evalParams)

            // if (!this.store.hide_console) console.log('eval result >>>>', evalParams.dataItem); 
        },

        formatItem_cells_setCSS(key, key2, row, col, css) {
            const vueObj = this;
            let _cache2 = vueObj.cache2_data_cells.get(key2);
            if (_cache2) {
                const cell = vueObj.divCells.get(key)
                // IE 2026 09 23 / ODOO-5800 (Igor через ie-engine7: «колонки Grade — ожидаю просто визуализацию бейджи»): ячейке с пилюлей (STATUS* / GRADE,
                // has-status-chip) классы заливки от python-хука не кладём — цвет несёт пилюля. Иначе волна хука (formatItem_cells_calcCSS_py, после
                // первого кадра) красила ячейку ПОД пилюлей / текстом, а кэш-путь applyStatusChip заливку снимал — два вида одной колонки в одной
                // сессии (список Inventory Policy 17D_001: хук отдаёт cell-background-orange у Warning). Выключатель fe.ux.chipDropsHookFill (дефолт ВКЛ)
                if (css && cell && cell.classList.contains('has-status-chip') && vueObj.chipDropsHookFill()) css = vueObj.chipFill_strip(css)
                if (_cache2.css_user) {
                    wjcCore.removeClass(cell, _cache2.css_user)
                }
                _cache2.css_user = css || '';
                _cache2.css_relevance = vueObj.css_relevance;
                _cache2.css_promise = null;

                if (cell?.isConnected && cell.data_cell.row === row && cell.data_cell.col === col) {
                    if (_cache2.css_user) {
                        wjcCore.addClass(cell, _cache2.css_user)
                        // _cache2.className = cell.className
        
                        // vueObj.show_formatItem_cells_calcC SS_py = true
                        if (vueObj.show_formatItem_cells_calcCSS_py) {
                            vueObj.count_formatItem_cells_calcCSS_py = (vueObj.count_formatItem_cells_calcCSS_py||0) + 1
                            console.log('css calc set', vueObj.count_formatItem_cells_calcCSS_py, key2, performance.now() - _cache2.t0)
                            const bgColor = `hsl(${round(vueObj.count_formatItem_cells_calcCSS_py)}, 100%, 85%)`
                            cell.style.setProperty('background-color', bgColor, 'important');
                        }
                    }
                }
            }
        },
        // ================= IE 2026 09 04 / ODOO-336379: волны py-CSS — флаги window.gridPerf =================
        // css_invalidate_scoped — инвалидация py-CSS по строкам (правленая + предки; после python-пересчёта — только
        //   строки, чьё содержимое изменилось), а не всего грида: раньше каждая правка давала ≥2 полные волны
        //   (тысячи python-вызовов); css_memo_rowsig — мемо get_cssClass по хэшу содержимого строки + колонка;
        //   frozen_clip_batch — одна rAF на волну для проверки переполнения фиксированных ячеек; css_py_raw — в
        //   python уходит сырой (toRaw) объект строки без реактивных геттеров Vue. Дефолты ВКЛ; OFF — прежнее поведение.
        // Оба «строчных» механизма работают только при cssPerf_rowLocal() == true: по тексту <attr>__get_cssClass
        //   функция не читает другие строки (data / data0 / parentRow / WIDGET / rows / get_row / get_dataRows);
        //   иначе — глобальная инвалидация и без мемо, как раньше (для M03 dataSheet__get_cssClass — строчная).
        cssPerf_on(name) {
            return this.fmtPerf('g:' + name, () => this.store.gridPerf_on ? this.store.gridPerf_on(name, this.WIDGET) : true)   // IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL5 // IE 2026 09 05 / ODOO-336379: + выключатель записи (Params → Frontend)
        },
        cssPerf_scoped() {
            return this.cssPerf_on('css_invalidate_scoped') && this.cssPerf_rowLocal()
        },
        cssPerf_rowLocal() {
            const sig = this._pySig || ''
            if (this._cssRowLocal !== undefined && this._cssRowLocalSig === sig) return this._cssRowLocal
            let local = false, found = false
            try {
                const name = `${this.attr?.name}__get_cssClass`
                const srcs = [String(this.attr?.['code-eval'] || ''), ...Object.values(this.WIDGET?.record?._import_modules || {}).map(v => String(v || ''))]
                const esc = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
                const re = new RegExp('def\\s+' + esc + '\\s*\\([^)]*\\)\\s*:[^\\n]*\\n([\\s\\S]*?)(?=\\n\\S|$)')
                for (const src of srcs) {
                    const m = src.match(re)
                    if (!m) continue
                    found = true
                    const body = m[1].replace(/#[^\n]*/g, '')
                    local = !/(^|[^\w'".:])(data|data0|parentRow|WIDGET|rows|store)(?![\w:])|get_row\s*\(|get_dataRows\s*\(/.test(body)
                    break
                }
            } catch (e) { local = false }
            this._cssRowLocal = found && local
            this._cssRowLocalFound = found   // IE 2026 10 14 / ODOO-5800: есть ли py-функция вообще (editKeep_block: без неё «не строчный» CSS не блокирует точечный проход)
            this._cssRowLocalSig = sig
            if (found && !local) console.log(`[gridPerf] css: ${this.attr?.name}__get_cssClass reads other rows — scoped invalidation and memo are off for this grid`)
            return this._cssRowLocal
        },
        cssPerf_hasPyCss() {   // IE 2026 10 14 / ODOO-5800: у грида есть python-функция <attr>__get_cssClass (по тексту code-eval / модулей; кэш — cssPerf_rowLocal)
            this.cssPerf_rowLocal()
            return !!this._cssRowLocalFound
        },
        cssRel_next() {
            this._cssSeq = Math.max(this._cssSeq || 0, this.css_relevance || 0) + 1
            return this._cssSeq
        },
        css_invalidate_all(why) {
            // глобальная инвалидация py-CSS (прежний css_relevance++) + сброс мемо, сигнатур и строчных меток
            if (this.cssPerf_on('css_invalidate_scoped')) this.css_relevance = this.cssRel_next()
            else this.css_relevance++
            this._cssMemo?.clear?.()
            this._cssSigCache?.clear?.()
            this._cssRowRel?.clear?.()
            this.cssPerf_stat('inv_all', 1)
        },
        css_invalidate_rows(items, why) {
            // строчная инвалидация: только строки items получают новую метку; остальные ячейки остаются актуальными
            if (!this.cssPerf_scoped()) { this.css_invalidate_all(why); return }
            const m = this._cssRowRel || (this._cssRowRel = new Map())
            const seq = this.cssRel_next()
            const seen = new Set()
            for (const it of items || []) {
                const k = it?._fe?.key
                if (k && !seen.has(k)) { seen.add(k); m.set(k, seq) }
            }
            if (!seen.size) { this.css_relevance = seq; this.cssPerf_stat('inv_all', 1); return } // строки не известны — все, как раньше
            this.cssPerf_stat('inv_rows', seen.size)
        },
        css_rowRel(dataItem) {
            const m = this._cssRowRel
            return m ? (m.get(dataItem?._fe?.key) || 0) : 0
        },
        css_ancestors(dataItem) {
            // правленая строка + её предки по дереву (childItemsPath): у них могли измениться агрегаты
            const out = [dataItem]
            try {
                if (!this.attr?.childItemsPath || !this.flex) return out
                let irow = this.rows_indexOf(dataItem), guard = 0
                while (irow >= 0 && guard++ < 32) {
                    const ip = this.get_parentPosition(irow)
                    if (ip < 0) break
                    const it = this.flex.rows[ip]?.dataItem
                    if (it) out.push(it)
                    irow = ip
                }
            } catch (e) { /* строки нет в гриде — только она сама */ }
            return out
        },
        cssSig_hash(dataItem) {
            // хэш содержимого строки (без служебного _fe и дочерних строк; повтор ссылки/цикл — пропуск)
            const childPath = this.attr?.childItemsPath
            const seen = new WeakSet()
            let s
            try {
                s = JSON.stringify(toRaw(dataItem), function (k, v) {
                    if (k === '_fe' || (childPath && k === childPath) || typeof v === 'function') return undefined
                    if (v && typeof v === 'object') { const r = toRaw(v); if (seen.has(r)) return undefined; seen.add(r); return r }
                    return v
                })
            } catch (e) { return null }
            if (!s) return null
            let h1 = 0x811c9dc5, h2 = 0x050c5d1f
            for (let i = 0; i < s.length; i++) {
                const c = s.charCodeAt(i)
                h1 = Math.imul(h1 ^ c, 0x01000193)
                h2 = Math.imul(h2 ^ c, 0x2f0b13c7)
            }
            return (h1 >>> 0).toString(36) + '.' + (h2 >>> 0).toString(36) + '.' + s.length.toString(36)
        },
        cssSig_row(dataItem) {
            // сигнатура строки с кэшем по эпохе (общая метка + строчная): один JSON на строку за эпоху, не на ячейку
            const k = dataItem?._fe?.key
            if (!k) return null
            const epoch = Math.max(this.css_relevance || 0, this.css_rowRel(dataItem))
            const c = this._cssSigCache || (this._cssSigCache = new Map())
            const e = c.get(k)
            if (e && e.epoch === epoch && e.item === dataItem) return e.sig
            const sig = this.cssSig_hash(dataItem)
            if (c.size > 30000) c.clear()
            c.set(k, { epoch, sig, item: dataItem })
            return sig
        },
        cssSig_col(attr_col) {
            // сигнатура колонки: скалярные свойства описателя (binding, measure, date, …), кэш по объекту
            const w = this._cssColSig || (this._cssColSig = new WeakMap())
            let s = w.get(attr_col)
            if (s === undefined) {
                try {
                    const o = {}
                    for (const k of Object.keys(attr_col || {})) { const v = attr_col[k]; if (v == null || (typeof v !== 'object' && typeof v !== 'function')) o[k] = v }
                    s = JSON.stringify(o)
                } catch (e) { s = String(attr_col?.binding || '') }
                w.set(attr_col, s)
            }
            return s
        },
        cssSig_snapshot(items) {
            // сигнатуры строк блока (дерево по childItemsPath) до python-пересчёта
            const snap = new Map()
            const childPath = this.attr?.childItemsPath
            const walk = (list, depth) => {
                if (!Array.isArray(list) || depth > 12) return
                for (const it of list) {
                    if (!it || typeof it !== 'object') continue
                    snap.set(it, this.cssSig_hash(it))
                    if (childPath && Array.isArray(it[childPath])) walk(it[childPath], depth + 1)
                }
            }
            walk(Array.isArray(items) ? items : [items], 0)
            return snap
        },
        cssSig_changed(snap, dataItem) {
            // строки блока, чьё содержимое изменил пересчёт (+ правленая строка и её предки)
            const out = this.css_ancestors(dataItem)
            for (const [it, sig] of snap) {
                if (this.cssSig_hash(it) !== sig) out.push(it)
            }
            return out
        },
        cssPerf_stat(kind, n = 1, ms = 0) {
            const s = this._cssStats || (this._cssStats = {})
            s[kind] = (s[kind] || 0) + n
            if (ms) s[kind + '_ms'] = Math.round(((s[kind + '_ms'] || 0) + ms) * 10) / 10
            const b = this._gridPerfCur
            if (b && !b.settled) {
                b['css_' + kind] = (b['css_' + kind] || 0) + n
                if (ms) b['css_' + kind + '_ms'] = Math.round(((b['css_' + kind + '_ms'] || 0) + ms) * 10) / 10
            }
            const w = this._cssWave
            if (w && kind !== 'inv_rows' && kind !== 'inv_all') w[kind] = (w[kind] || 0) + n
        },
        cssWave_end() {
            const w = this._cssWave
            if (!w) return
            this._cssWave = null
            w.ms = Math.round((performance.now() - w.t0) * 10) / 10
            w.scoped = this.cssPerf_scoped()
            w.memo = this.cssPerf_on('css_memo_rowsig') && !!this.cssPerf_rowLocal()
            w.row_local = !!this.cssPerf_rowLocal()
            w.batch = this.cssPerf_on('css_py_batch') // IE 2026 09 05 / ODOO-336379
            w.grid = this.attr?.name || ''
            this.store.gridPerf_cssPush?.(w)
            if (this._gridPerfCur || w.cells >= 200) {
                console.log(`[gridPerf] css wave: cells=${w.cells} (queued ${w.queued}), py=${w.py}${w.batches ? ' (batches ' + w.batches + ')' : ''}, memo hits=${w.memo_hits || 0}, ${w.ms} ms, scoped=${w.scoped ? 'on' : 'off'}, memo=${w.memo ? 'on' : 'off'}, batch=${w.batch ? 'on' : 'off'}, rowLocal=${w.row_local}`)
            }
        },
        // IE 2026 09 10 / ODOO-… (замечание Игоря): ячейка длительности / дней (колонка Offset «2.1m») в узкой колонке — если полный
        // текст не влезает, показать округлённый («2m», precision 0); при расширении колонки — снова полный (formatItem
        // перерисовывает ячейки при смене ширины). Полный текст хранится в data-full-text (data-fit-text = что показано —
        // защита от переиспользованной ячейки): ховер-подсказка показывает его, как у обрезанной ячейки.
        // Замер — canvas measureText шрифтом ячейки (без layout); доступная ширина — renderWidth колонки минус паддинги
        durFit_apply(e_cell, value, fmtAttr, kind, col) {
            const full = (e_cell.textContent || '').trim()
            if (e_cell.dataset.fitText) { delete e_cell.dataset.fitText; delete e_cell.dataset.fullText }
            if (!full || full.length < 3 || full === '∞' || full === '-∞') return
            const width = (col && col.renderWidth) || e_cell.clientWidth
            if (!width) return
            const avail = width - this.durFit_pad(e_cell)
            if (this.durFit_width(full) <= avail) return
            const short = kind === 'time'
                ? this.store.formatTimeHTML(value, fmtAttr, { precision: 0 })
                : this.store.formatDaysHTML(value, fmtAttr, { precision: 0 })
            const shortText = String(short ?? '').replace(/<[^>]*>/g, '').trim()
            if (!shortText || shortText === full) return
            if (this.durFit_width(shortText) > avail) return   // и короткий не влезает — обрезка браузером + подсказка
            e_cell.innerHTML = short
            e_cell.dataset.fullText = full
            e_cell.dataset.fitText = shortText
        },
        durFit_pad(e_cell) {
            if (this._durFitPad == null) {
                const cs = getComputedStyle(e_cell)
                this._durFitPad = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0) + 2
                this._durFitFont = cs.font || `${cs.fontStyle} ${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`
            }
            return this._durFitPad
        },
        durFit_width(text) {
            if (!_durFitCtx) _durFitCtx = document.createElement('canvas').getContext('2d')
            _durFitCtx.font = this._durFitFont || '12px sans-serif'
            return _durFitCtx.measureText(text).width
        },
        // ---- IE 2026 10 12 / ODOO-335099 (заказ Андрея через dm #72941, RP1; MRV_001 «Введення плану активностей»: 4 закреплённые колонки, 5 уровней дерева — обход «закрепить 5»):
        // заголовок строки-группы обрезался границей закреплённой области (maxWidth + frozenClip). При прокрутке 0 основной экземпляр ячейки группы (панель cells)
        // показывает текст дальше — поверх пустых незакреплённых ячеек строки, до первой непустой (clip-path по --gho-r); если клон замороженных (.wj-frozen-clone,
        // лежит поверх) уже есть — текст продолжает он, основной режется как раньше. При прокрутке > 0 атрибута хоста нет — прежняя обрезка, на данные не наезжает.
        // Выключатель fe.ux.groupHeaderOverflow (по умолчанию ВКЛ; выкл — как до правки). Счётчик window.__groupHeaderOverflow {on, off, sync} ----
        groupHeaderOverflow_paint(e_cell, flex, rows, e_row, e_col, range, isXlsxExport) {   // IE 2026 10 12 / ODOO-335099
            const had = !isXlsxExport && e_cell.hasAttribute?.('data-gho')   // IE 2026 10 12 / ODOO-335099
            const fz = flex.frozenColumns || 0   // IE 2026 10 12 / ODOO-335099
            const row = rows[e_row]   // IE 2026 10 12 / ODOO-335099
            const c2 = range ? range.col2 : e_col   // IE 2026 10 12 / ODOO-335099: конец объединения ячейки группы
            const want = !isXlsxExport && fz > 0 && e_col < fz && c2 >= fz - 1 && !!row?.hasChildren && e_cell.style   // IE 2026 10 12 / ODOO-335099: строка-группа, ячейка доходит до границы
                && this.fmtSetting('fe.ux.groupHeaderOverflow', true) !== false   // IE 2026 10 12 / ODOO-335099
            const C = window.__groupHeaderOverflow || (window.__groupHeaderOverflow = { on: 0, off: 0, sync: 0 })   // IE 2026 10 12 / ODOO-335099
            if (!want) { if (had) { e_cell.removeAttribute('data-gho'); e_cell.style.removeProperty('--gho-r'); C.off++ } return }   // IE 2026 10 12 / ODOO-335099
            const cols = flex.columns   // IE 2026 10 12 / ODOO-335099
            const frozenW = cols.getFrozenSize ? cols.getFrozenSize() : cols.slice(0, fz).reduce((s, c) => s + (c.renderWidth || 0), 0)   // IE 2026 10 12 / ODOO-335099
            const rootCol = cols[range ? range.col : e_col]   // IE 2026 10 12 / ODOO-335099: левый край — как у frozenClip (style.left + компенсация прокрутки, не левее колонки)
            const visLeft = parseFloat(e_cell.style.left || '') + (flex.scrollPosition?.x || 0)   // IE 2026 10 12 / ODOO-335099
            const colLeft = Number.isFinite(rootCol?.pos) ? rootCol.pos : 0   // IE 2026 10 12 / ODOO-335099
            const cellLeft = Number.isFinite(visLeft) ? Math.max(colLeft, visLeft) : colLeft   // IE 2026 10 12 / ODOO-335099
            const viewW = Math.max(0, (flex.clientSize?.width || 0) - frozenW)   // IE 2026 10 12 / ODOO-335099: дальше видимой области не тянуть
            const ext = gho_extent({ n: cols.length, frozen: fz, c2, maxExt: viewW || Infinity,   // IE 2026 10 12 / ODOO-335099
                width: (j) => (cols[j]?.visible === false ? 0 : (cols[j]?.renderWidth || 0)),   // IE 2026 10 12 / ODOO-335099
                empty: (j) => { const v = flex.cells.getCellData(e_row, j, true); return v === '' || v == null },   // IE 2026 10 12 / ODOO-335099
                span: (j) => { const m = flex.getMergedRange(flex.cells, e_row, j); return m ? m.col2 : j } })   // IE 2026 10 12 / ODOO-335099: merge «назад» тянет значение влево
            if (ext < 1) { if (had) { e_cell.removeAttribute('data-gho'); e_cell.style.removeProperty('--gho-r'); C.off++ } return }   // IE 2026 10 12 / ODOO-335099
            const r = gho_clipRight(parseFloat(e_cell.style.width) || 0, cellLeft, frozenW, ext) + 'px'   // IE 2026 10 12 / ODOO-335099
            if (!had) e_cell.setAttribute('data-gho', '1')   // IE 2026 10 12 / ODOO-335099
            if (e_cell.style.getPropertyValue('--gho-r') !== r) e_cell.style.setProperty('--gho-r', r)   // IE 2026 10 12 / ODOO-335099
            C.on++   // IE 2026 10 12 / ODOO-335099
        },   // IE 2026 10 12 / ODOO-335099
        groupHeaderOverflow_sync(flex) {   // IE 2026 10 12 / ODOO-335099: атрибут хоста «прокрутка 0» — из scrollPositionChanged (сразу) и updatedView; пишется только при смене
            const host = flex?.hostElement   // IE 2026 10 12 / ODOO-335099
            if (!host) return   // IE 2026 10 12 / ODOO-335099
            const on = !!flex.frozenColumns && Math.abs(flex.scrollPosition?.x || 0) < 0.5 && this.store.setting('fe.ux.groupHeaderOverflow', true) !== false   // IE 2026 10 12 / ODOO-335099
            const cl = on && !!flex._fCt?.childElementCount   // IE 2026 10 12 / ODOO-335099: клон замороженных есть — текст рисует он (CSS), основной экземпляр режется как раньше
            if (host.hasAttribute('data-gho-clone') !== cl) host.toggleAttribute('data-gho-clone', cl)   // IE 2026 10 12 / ODOO-335099
            if (on) this.groupHeaderOverflow_dedupe(cl ? flex._fCt : flex.cells?.hostElement)   // IE 2026 10 12 / ODOO-335099
            if (host.hasAttribute('data-gho-x0') === on) return   // IE 2026 10 12 / ODOO-335099
            host.toggleAttribute('data-gho-x0', on)   // IE 2026 10 12 / ODOO-335099
            const C = window.__groupHeaderOverflow || (window.__groupHeaderOverflow = { on: 0, off: 0, sync: 0 }); C.sync++   // IE 2026 10 12 / ODOO-335099
        },   // IE 2026 10 12 / ODOO-335099
        // IE 2026 10 12 / ODOO-335099: объединение строки-группы, заходящее за границу закреплённых (MRV_001 при 4 закреплённых: [0..4]), wijmo рисует ДВУМЯ одинаковыми
        // элементами (проход закреплённых и проход прокручиваемых колонок; оба .wj-frozen, оба клонируются) — перетекать должен один, иначе текст за концом
        // объединения двоится (проба 12.10 на dev02). ПОСЛЕДНИЙ в панели по месту (top|left) — верхний слой — data-gho="1", прежние повторы — "2"
        // (CSS их не выпускает; верхний «1» без maxWidth закрывает их фоном — иначе у границы видно «…» нижнего)
        groupHeaderOverflow_dedupe(panelEl) {   // IE 2026 10 12 / ODOO-335099
            if (!panelEl) return   // IE 2026 10 12 / ODOO-335099
            const seen = new Set()   // IE 2026 10 12 / ODOO-335099
            const els = panelEl.querySelectorAll(':scope > .wj-cell[data-gho], :scope > .wj-row > .wj-cell[data-gho]')   // IE 2026 10 12 / ODOO-335099
            for (let i = els.length - 1; i >= 0; i--) {   // IE 2026 10 12 / ODOO-335099: с конца — верхний слой первым
                const el = els[i]   // IE 2026 10 12 / ODOO-335099
                const k = el.style.top + '|' + el.style.left   // IE 2026 10 12 / ODOO-335099
                const v = seen.has(k) ? '2' : '1'   // IE 2026 10 12 / ODOO-335099
                seen.add(k)   // IE 2026 10 12 / ODOO-335099
                if (el.getAttribute('data-gho') !== v) el.setAttribute('data-gho', v)   // IE 2026 10 12 / ODOO-335099
            }   // IE 2026 10 12 / ODOO-335099
        },   // IE 2026 10 12 / ODOO-335099
        frozenClip_enqueue(cell, maxW, spill) {
            const q = this._frozenClipQ || (this._frozenClipQ = new Map())
            q.set(cell, { maxW, spill })
            if (this._frozenClipRaf) return
            this._frozenClipRaf = requestAnimationFrame(() => { this._frozenClipRaf = null; this.frozenClip_flush() })
        },
        frozenClip_flush() {
            // сначала ВСЕ чтения (scrollWidth/clientWidth — один layout), потом все записи
            const q = this._frozenClipQ
            if (!q || !q.size) return
            this._frozenClipQ = null
            const t0 = performance.now()
            const need = [], own = []   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #114076: двойной тултип в колонке ответственного): own — не обрезанные ячейки со своей подсказкой (снимается)
            for (const [cell, p] of q) {
                if (!cell.isConnected) continue
                if (cell.scrollWidth > Math.min(p.maxW, cell.clientWidth || p.maxW) + 1) need.push([cell, p])
                else if (cell.__fzTitle) own.push([cell, p])   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #114076: двойной тултип в колонке ответственного)
            }
            const ownOn = this.store.setting(FROZEN_TITLE_FLAG, true) !== false   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #114076: двойной тултип в колонке ответственного)
            for (const [cell, p] of need) {
                cell.style.overflow = 'hidden'
                cell.style.textOverflow = 'ellipsis'
                frozenTitle_apply(cell, cell.textContent, true, p.spill, ownOn)   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #114076: двойной тултип в колонке ответственного): было «if (!cell.title) title = text» — элемент, переиспользованный wijmo под другую строку, оставался с подсказкой прежней
            }
            for (const [cell, p] of own) frozenTitle_apply(cell, cell.textContent, false, p.spill, ownOn)   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #114076: двойной тултип в колонке ответственного)
            this.cssPerf_stat('frozen_batches', 1, performance.now() - t0)
            this.cssPerf_stat('frozen_cells', q.size)
        },
        // IE 2026 09 05 / ODOO-336379 (флаг css_py_batch): волна py-CSS пачками — один python-вызов на пачку ячеек.
        // Хелпер ставится лениво в пространство имён модуля виджета (код отчёта/модуль не меняются): внутри
        // python цикл по ячейкам зовёт тот же <attr>__get_cssClass(data, dataItem, attr_col), как и поштучный путь,
        // с теми же модульными dataItem/attr_col; исключение в одной ячейке → '' для неё + одно предупреждение
        // на волну; ошибка самого батча → поштучный фолбэк для пачки.
        cssBatch_fn(mod) {
            if (this._pyCssBatchFn && this._pyCssBatchFnMod === mod) return this._pyCssBatchFn
            const src = `
def __ie_get_cssClass_batch(fn, data, items, cols):
    # IE 2026 09 05 / ODOO-336379: пачка ячеек одним вызовом; модульные dataItem/attr_col — как в поштучном пути
    g = globals()
    out = []
    err = None
    n = len(items)
    for i in range(n):
        it = items[i]
        col = cols[i]
        g['dataItem'] = it
        g['attr_col'] = col
        try:
            r = fn(data, it, col)
            out.append('' if r is None else str(r))
        except Exception as e:
            out.append('')
            if err is None:
                err = repr(e)
    return [out, err]
`
            this.store.pyodide.runPython(src, { globals: mod.__dict__ })
            const fn = mod.__dict__.get('__ie_get_cssClass_batch')
            if (typeof fn !== 'function') throw new Error('__ie_get_cssClass_batch is not installed')
            this._pyCssBatchFn = fn; this._pyCssBatchFnMod = mod
            return fn
        },
        // считает CSS для пачки записей очереди: мемо-попадания — из кэша, остальное — одним python-вызовом;
        // возвращает массив классов по порядку entries либо null (батч не удался → поштучный путь)
        cssBatch_compute(entries) {
            const mod = this._pyMod
            if (!mod || typeof this.get_cssClass_py !== 'function') return null
            const useMemo = this.cssPerf_on('css_memo_rowsig') && this.cssPerf_rowLocal()
            const _raw = this.cssPerf_on('css_py_raw')
            const res = new Array(entries.length)
            const items = [], cols = [], idx = [], memoKeys = []
            for (let i = 0; i < entries.length; i++) {
                const e = entries[i][1]
                let memoKey = null
                if (useMemo) {
                    const _rs = this.cssSig_row(e.dataItem)
                    if (_rs) {
                        memoKey = this.cssSig_col(e.attr_col) + '|' + _rs
                        const _hit = this._cssMemo?.get(memoKey)
                        if (_hit !== undefined) { this.cssPerf_stat('memo_hits', 1); if (this._cssWave) this._cssWave.memo_hits++; res[i] = _hit; continue }
                    }
                }
                items.push(_raw ? toRaw(e.dataItem) : e.dataItem)
                cols.push(e.attr_col)
                idx.push(i); memoKeys.push(memoKey)
            }
            if (!items.length) return res
            let out = null
            try {
                const fn = this.cssBatch_fn(mod)
                const _data = _raw ? toRaw(this.data000) : this.data000
                mod.__dict__.set('data', _data)
                mod.__dict__.set('widget', this.WIDGET?.record || {})
                mod.__dict__.set('WIDGET', this.WIDGET || {})
                if (this._cssWave) { this._cssWave.py++; this._cssWave.batches++ }
                out = this.exec("formatItem_cells_calcCSS_py_batch", fn, this.get_cssClass_py, _data, items, cols)
                const pair = (out && typeof out.toJs === 'function') ? out.toJs() : out
                const list = Array.isArray(pair) ? pair[0] : null
                const err = Array.isArray(pair) ? pair[1] : null
                if (!list || list.length !== items.length) throw new Error('batch result size mismatch')
                if (err && !this._cssWave?.batch_err) {
                    if (this._cssWave) this._cssWave.batch_err = String(err)
                    console.warn(`[gridPerf] css batch: ${this.attr?.name}__get_cssClass raised in some cells — those cells get no class: ${String(err).slice(0, 200)}`)
                }
                let _m = null
                for (let j = 0; j < idx.length; j++) {
                    const css = list[j] == null ? '' : String(list[j])
                    res[idx[j]] = css
                    if (memoKeys[j]) {
                        _m = _m || this._cssMemo || (this._cssMemo = new Map())
                        if (_m.size > 60000) _m.clear()
                        _m.set(memoKeys[j], css)
                        this.cssPerf_stat('memo_miss', 1)
                    }
                }
                return res
            } catch (err) {
                console.warn('[gridPerf] css batch failed, per-cell fallback:', err?.toString?.() || err)
                return null
            } finally {
                try { if (out && typeof out.destroy === 'function') out.destroy() } catch (e) { /* proxy already gone */ }
            }
        },
        async cssWave_runBatched(maxDelay) {
            const vueObj = this, CHUNK = 600
            let t0 = performance.now(), wait1 = 0, iter = 0
            while (vueObj.cache2_data_cells__call.size) {
                // пачка с хвоста очереди (тот же LIFO-порядок, что у поштучного пути)
                const entries = []
                const keys = Array.from(vueObj.cache2_data_cells__call.keys())
                for (let i = keys.length - 1; i >= 0 && entries.length < CHUNK; i--) entries.push([keys[i], vueObj.cache2_data_cells__call.get(keys[i])])
                const tChunk = performance.now()
                const computed = this.cssBatch_compute(entries)
                for (let i = 0; i < entries.length; i++) {
                    const [key2, e] = entries[i]
                    if (!e) { vueObj.cache2_data_cells__call.delete(key2); continue }
                    const { dataItem, attr_col, _cache2, key, row, col } = e
                    if (_cache2) _cache2.t0 = tChunk
                    const css = computed ? computed[i] : this.formatItem_cells_calcCSS_py(dataItem, attr_col, _cache2)
                    this.formatItem_cells_setCSS(key, key2, row, col, css)
                    if (_cache2) _cache2.css_relevance = Math.max(_cache2.css_relevance || 0, this.css_rowRel(dataItem))
                    if (this._cssWave) this._cssWave.cells++
                    vueObj.cache2_data_cells__call.delete(key2)
                }
                this.gridPerf_touch('css', performance.now() - tChunk)
                const tTimeout1 = performance.now()
                while (performance.now() - t0 > maxDelay || vueObj.cache_process_dataItem_py.size) {
                    if (performance.now() - tTimeout1 > 5000) break
                    await this.store.sleep(wait1)
                    wait1 = 2
                    t0 = performance.now()
                    if (vueObj.cache_process_dataItem_py.size && iter > 10) {
                        // IE 2026 09 05 / ODOO-336379: раньше здесь ОЧИЩАЛАСЬ очередь python-пересчёта (force clear) — правка оставалась
                        // без пересчёта (замечено на 8-й из 8 быстрых правок в построчном пути). Волна CSS просто перестаёт ждать:
                        // очередь дорабатывает свой планировщик process_dataItem_py__start.
                        console.warn('formatItem_cells_calcCSS_py__start: python queue still busy, stop waiting (queue kept)', vueObj.cache_process_dataItem_py.size)
                        break
                    }
                    iter++
                }
            }
        },
        // IE 2026 09 04 / ODOO-336379 (флаг css_memo_rowsig): мемо результата get_cssClass по хэшу строки + колонка —
        // только для строчных функций CSS (cssPerf_rowLocal), сброс на любой глобальной инвалидации.
        // Флаг css_py_raw: сырой (toRaw) объект строки в python — без реактивных геттеров Vue на каждое чтение.
        formatItem_cells_calcCSS_py(dataItem, attr_col, _cache) {
            let _memoKey = null
            try {
                const mod = this._pyMod
                if (!mod) return           // модуль уничтожен/не загружен (пересоздание виджета)
                // R11: функция могла не собраться (движок ещё грузится/упал) —
                // тихий фолбэк вместо TypeError на каждой ячейке
                if (typeof this.get_cssClass_py !== 'function') {
                    this.get_cssClass_py = null
                    return this.formatItem_cells_calcCSS?.(dataItem, attr_col, _cache)
                }
                if (this.cssPerf_on('css_memo_rowsig') && this.cssPerf_rowLocal()) {
                    const _rs = this.cssSig_row(dataItem)
                    if (_rs) {
                        _memoKey = this.cssSig_col(attr_col) + '|' + _rs
                        const _hit = this._cssMemo?.get(_memoKey)
                        if (_hit !== undefined) { this.cssPerf_stat('memo_hits', 1); return _hit }
                    }
                }
                const _raw = this.cssPerf_on('css_py_raw')
                const _dataItem = _raw ? toRaw(dataItem) : dataItem
                const _data = _raw ? toRaw(this.data000) : this.data000

                // Инжектим актуальные данные в модульный namespace
                mod.__dict__.set('data', _data); // pyodide.toPy(this.data000)
                mod.__dict__.set('dataItem', _dataItem);
                mod.__dict__.set('attr_col', attr_col);
                mod.__dict__.set('widget', this.WIDGET?.record || {});
                mod.__dict__.set('WIDGET', this.WIDGET || {});

                // const irow = this.rows_indexOf(dataItem); // для получения data0 M03
                // const data0 = this.get_data0(irow);
                // mod.__dict__.set('data0', data0);

                // Вызываем python-функцию из модуля
                // Вариант 1: напрямую через PyProxy функции
                if (this._cssWave) this._cssWave.py++
                const result = this.exec("formatItem_cells_calcCSS_py", this.get_cssClass_py, _data, _dataItem, attr_col);
                if (_memoKey && (result == null || typeof result === 'string')) {
                    const _m = this._cssMemo || (this._cssMemo = new Map())
                    if (_m.size > 60000) _m.clear()
                    _m.set(_memoKey, result == null ? '' : result)
                    this.cssPerf_stat('memo_miss', 1)
                }

                return result;
            } catch (err) {
                console.error(err?.toString?.() || err);
                this.store.show_notification({ text: err.message, status: 'error' })
                this.get_cssClass_py = null;
                return this.formatItem_cells_calcCSS?.(dataItem, attr_col, _cache);
            }
        },
        formatItem_cells_calcCSS(dataItem, attr_col, _cache) {
            let code = this.attr['code-eval-fe'] || ''
            const params = this.WIDGET.record?.doc?.params
            if (!code && this.attr.binding === '_doc.data') {
                code = params?.['code-eval-fe'] || ''
            }
            if (!code || !code.includes(' process_cssClass(')) {
                return;
            }

            const fullCode = `
                ${code}
                return process_cssClass(data, dataItem, attr_col);
            `

            const evalParams = {
                widget: this.WIDGET.record,
                data: this.data000,
                dataItem: dataItem,
                attr_col: attr_col,
                params: params,
                getValue: this.store.get_value.bind(this.store), // TODEL 2025-06-11
                get_value: this.store.get_value.bind(this.store),
            };

            const { result, error } = this.runUserCode(fullCode, evalParams)
            return result
        },

        check_WHERE() {
            if (this.attr.name === 'viewWHERE') { // || this.attr.name === 'fieldsMapping'
                this.$nextTick(() => {
                    const newDataitems = []
                    for (let childDataItem of this.data000) {
                        this.check_rowWHERE(null, childDataItem, newDataitems)
                    }

                    this.selectedRanges_BEFORE = this.selBefore_snap(this.flex.selectedRanges)   // IE 2026 09 27 / ODOO-5800: снимок с binding колонок
                    this.set_itemsSource()
                    this.refresh(newDataitems, false, false)
                })
            }
        },
        check_rowWHERE(parentDataItem, dataItem, newDataitems) {
            const attr_col_left = this.attr_by_binding['leftValue.valueStr']
            const attr_col_right = this.attr_by_binding['rightValue.valueStr']
            const left = this.store.check_AttrMulti(attr_col_left, dataItem)
            const right = this.store.check_AttrMulti(attr_col_right, dataItem)
            let change_itemSource = false
            
            dataItem.use = dataItem.use ?? true

            // // TEMP 2025 01
            // if (dataItem.condition === 'where_text') {
            //     dataItem.leftValue = {
            //         value: '#where_text',
            //         valueStr: 'Custom query text',
            //         attr_type: 'AttrStr',
            //     }
            //     dataItem.condition = '='
            // }

            // parent
            if (parentDataItem) {
                if (['in', '!in'].includes(parentDataItem.condition)) {
                    if (left.value) {
                        left.value = ''
                        left.valueStr = ''
                    }
                    if (dataItem.condition) {
                        dataItem.condition = ''
                    }
                    if (dataItem.attrs?.length) {
                        delete dataItem.attrs
                        change_itemSource = true
                    }

                    right.attr_type = parentDataItem.rightValue?.attr_type
                    right.relation_segment = parentDataItem.rightValue?.relation_segment

                    this.store.prepare_AttrMulti(this, attr_col_right, dataItem, [], true)

                    return
                }
            }
            
            // AND, OR
            const isGroup = ['#and', '#or'].includes(left.value) || ['and', 'or'].includes(dataItem.condition)
            if (isGroup) {
                if (dataItem.condition !== 'and' && dataItem.condition !== 'or') {
                    dataItem.condition = left.value.replace('#', '')
                    left.value = ''
                    left.valueStr = ''
                }

                // if (right.value) {
                //     right.value = ''
                //     right.valueStr = ''
                // }

                dataItem.attrs = dataItem.attrs || []
                if (!dataItem.attrs.length) {
                    const newDataitem = {}
                    dataItem.attrs.push(newDataitem)
                    newDataitems.push(newDataitem)
                    change_itemSource = true
                }
            }

            // left
            if (left.value === '#where_text' || dataItem.condition === 'where_text') {
                dataItem.condition = 'where_text'
                if (left.value === '#where_text') {
                    left.value = ''
                    left.valueStr = ''
                }
                right.attr_type = 'AttrStr'

            } else if (left.value && !isGroup) {
                if (!dataItem.condition) {
                    dataItem.condition = '='
                }

                const left_itemSource = attr_col_left.itemsSource?.find(item => item.id === left.value)
                if (left_itemSource){
                    if (right.attr_type !== left_itemSource.attr_type && right.attr_type !== 'AttrList') {
                        // if (right.attr_type) console.log('SET ', right.attr_type, left_itemSource.attr_type)

                        // !!err if AttrList >> AttrStr
                        right.attr_type = left_itemSource.attr_type
                    }
                    right.relation_segment = left_itemSource.relation_segment

                    this.store.prepare_AttrMulti(this, attr_col_right, dataItem, [], true)
                }
            }

            // condition
            if (['in', '!in'].includes(dataItem.condition)) {
                dataItem.attrs = dataItem.attrs || []
            
                if (right.value) {
                    const newDataitem = { use:true, rightValue:{...right} }
                    dataItem.attrs.unshift(newDataitem)
                    newDataitems.push(newDataitem)
                    change_itemSource = true

                    right.value = ''
                    right.valueStr = ''
                }

                if (!dataItem.attrs.length) {
                    const newDataitem = {}
                    dataItem.attrs.push(newDataitem)
                    newDataitems.push(newDataitem)
                    change_itemSource = true
                }
            }

            // =
            if (dataItem.condition === '=') {
                if (dataItem.attrs?.length) {
                    if (!right.value) {
                        right.value = dataItem.attrs[0].rightValue.value
                        right.valueStr = dataItem.attrs[0].rightValue.valueStr
                    }
                    delete dataItem.attrs
                    change_itemSource = true
                }
            }

            if (change_itemSource) {
                // this.refresh()
            }

            if (dataItem.attrs?.length) {
                for (let childDataItem of dataItem.attrs) {
                    this.check_rowWHERE(dataItem, childDataItem, newDataitems)
                }
            }
        },

        // ---------------------- AttrTabGrid ----------------------------------
        attrsTabGrid_from_attrs(attrs, rows, parentsList=[], i18nCtx) {
            let attr_col = {binding:'attr'}
            if (i18nCtx === undefined) i18nCtx = this.i18nFields_formCtx()   // IE 2026 10 06 / ODOO-341407 (заказ Игоря п.2): опция «Show translation fields» — один раз на сборку строк (вложенные группы получают тот же)
            attrs.forEach(attr => {
                if (!this.isHidden(attr)) {
                    let V = {
                        ...attr,
                        attrs: [], // del
                        // title
                        // value
                        // valueStr
                    },
                    
                    dataItem = {}
                    this.store.set_value(dataItem, attr_col.binding, V) // 2026-01-15 untill >>  [attr_col.binding]: V
                    
                    rows.push(dataItem)

                    // CSS-CLASS: ссылки классов поля-строки — в очередь одного батча get_cssClasses
                    this.store.queue_cssClasses_fromAttr(V)

                    // if (attr.isMapped && this.isMappedWidget_cols) {
                    //     dataItem.cssClass = 'mapped-cels'
                    // }

                    this.store.prepare_AttrMulti(this, attr_col, dataItem, parentsList)

                    if (this.attr.formatRowsAsColumns && !V.attr_type && typeof V.value === 'number') {
                        // колонки-меры источника (например _doc.data) приходят без attr_type:
                        // числовое значение → AttrNumber, иначе формат строки-колонки
                        // не применится (пайплайн transpose_measure)
                        V.attr_type = 'AttrNumber'
                    }

                    if (V.attr_type === 'AttrJSON') {
                        const _jv = jsonFieldValue_parse(V.value)   // IE 2026 10 24 / ODOO-348823
                        if (_jv.obj) {   // IE 2026 10 24 / ODOO-348823
                            V.valueStr = ''
                            dataItem.cssClass = 'row-label'
                            dataItem.MD = dataItem.MD || {}
                            dataItem.MD.cssClass = {'attr.title':'row-label-title json-key'}
                            dataItem.attrs = []
                            this.attrsTabGrid_from_JSON(_jv.obj, dataItem.attrs)   // IE 2026 10 24 / ODOO-348823
                        } else {   // IE 2026 10 24 / ODOO-348823
                            V.valueStr = _jv.text   // IE 2026 10 24 / ODOO-348823
                        }   // IE 2026 10 24 / ODOO-348823
                    
                    } else if (V.attr_type === 'AttrTags') {
                        // IE 2026 08 19 / ODOO-5512 (заказ Игоря): AttrTags — таблица
                        // {use,title,...} хранится в элементе, но рисуется СПИСКОМ ЧИПСОВ
                        // в ячейке значений (блок чипсов formatItem_cells); детей-строк
                        // не разворачиваем. Колонки строки (attrs) ВОЗВРАЩАЕМ: в них
                        // описание колонки-подписи с itemsSource словаря — без него
                        // подбор (chipSelection_show) не из чего строить
                        V.valueStr = ''
                        V.attrs = attr.attrs || []
                        dataItem.MD = dataItem.MD || {}
                        dataItem.MD.cssClass = {'attr.title':'row-label-title json-key'}

                    } else if (V.attr_type === 'AttrGrid') {
                        const _jv = jsonFieldValue_parse(V.value)   // IE 2026 10 24 / ODOO-348823
                        if (_jv.obj) {   // IE 2026 10 24 / ODOO-348823
                            V.valueStr = ''
                            dataItem.cssClass = 'row-label'
                            dataItem.MD = dataItem.MD || {}
                            dataItem.MD.cssClass = {'attr.title':'row-label-title json-key'}
                            dataItem.attrs = []
                            this.attrsTabGrid_from_JSON(_jv.obj, dataItem.attrs)   // IE 2026 10 24 / ODOO-348823
                        } else {   // IE 2026 10 24 / ODOO-348823
                            V.valueStr = _jv.text   // IE 2026 10 24 / ODOO-348823
                        }   // IE 2026 10 24 / ODOO-348823
                    
                    } else if (attr.attrs?.length) { // AttrList
                        dataItem.cssClass = 'row-label'
                        dataItem.MD = dataItem.MD || {}
                        dataItem.MD.cssClass = {'attr.title':'row-label-title'}
                        dataItem.attrs = []
                        parentsList.unshift(attr)
                        this.attrsTabGrid_from_attrs(attr.attrs, dataItem.attrs, parentsList, i18nCtx)   // IE 2026 10 06 / ODOO-341407: + i18nCtx
                        parentsList.shift()
                    }
                    if (i18nCtx) this.i18nFields_formRows(attr, rows, parentsList, i18nCtx, dataItem)   // IE 2026 10 07 / ODOO-341407: + dataItem — строка-основа; IE 2026 10 06 / ODOO-341407 (заказ Игоря п.2): за translate-полем — строки «<поле> (uk)/(ru)» (под uk / ru первой — «(en)», только чтение)
                }
            })
        },
        // ---- IE 2026 10 06 / ODOO-341407 (заказ Игоря п.2, DESIGN i18n_fields_ui §3.2): строки переводов в формах (AttrTabGrid: форма записи, вкладка «Інфо»,
        // форма строки widget-row) при личной опции виджета «Show translation fields» (store.i18nFields_on — по сегменту данных, вид не меняется) ----
        // контекст сборки строк | null: опция включена, грид — форма (не печать; formatRowsAsColumns — строки из колонок данных — только у формы строки-записи списка), у записи-владельца
        // (store.i18n_linkBinding: у формы строки — запись родителя) есть сегмент. Своя проверка вместо i18n_gridApplies: тот молчит при WIDGET.isReadOnly,
        // а смотреть переводы в режиме «только чтение» нужно (строки тогда только для чтения)
        i18nFields_formCtx() {
            const store = this.store, W = this.WIDGET
            if (this.attr?.attr_type !== 'AttrTabGrid' || this.attr.isPrint || this.attr.isPrintTemplate || !W) return null
            if (!store.i18nFields_on(W)) return null
            const link = store.i18n_linkBinding(W, '')
            if (!link.record?.segment) return null
            // IE 2026 10 06 / ODOO-341407 (проверка round 2, C6.row-rows: форма Alt+F2 строки списка была без строк «(uk)/(ru)»): formatRowsAsColumns — строки
            // формы из колонок данных; полями записи они являются только у формы строки-ЗАПИСИ списка (widget-row над _doc.data.N виджета-списка) — там
            // строки переводов строятся (контейнер перевода — у строки); у формы строки отчёта / DS — нет, как раньше
            const row = i18nFields_listRowOf(link)
            if (this.attr.formatRowsAsColumns && !row) return null
            const langs = store.i18n_fieldLangs()
            if (!langs.length) return null
            return {
                row,                                     // строка-запись списка: поле без контейнера перевода в строке — без строк (formRowsFor)
                langs,                                   // включённые в базе, без en: «(uk)», «(ru)»
                withEn: !!store.get_lang(),              // решение Игоря В2: под uk / ru — строка «(en)» с английской базой, только чтение (у формы строки не строится)
                nested: !!link.nested,                   // форма строки записи: путь относительно строки (путь родителя допишет attr_get)
                rowPath: link.nested ? link.binding : '',   // IE 2026 10 06 / ODOO-341407 (ревью U9): путь строки (_doc.data.3 — title → meta.title_<L>, как читает attr_get; doc.viewList.3 — title_<L>)
                readOnly: !!(W.isReadOnly || link.WIDGET?.isReadOnly || store.readonly_on()),
                record: link.record,                     // (en) названия — meta.title_en; словарный meta.title_<L> (meta._i18n_auto) — серым
                existing: i18nFields_bindingsOf(this.attr.attrs),   // явные поля вида «Title (uk)/(ru)» (SOLUTION / SOLUTION-RULE, решение В4) — без дубля
                localize: (b, L, raw) => store.localize_binding(b, L, raw),
            }
        },
        // строки переводов поля attr (узел вида) — сразу за его строкой; описания строк — utils/i18nFields.formRowsFor (V._i18nOf неперечисляемое: в данные
        // и в вид не попадает). Значение — тем же prepare_AttrMulti (attr_get: translate у V нет — сырой ключ записи-владельца)
        // IE 2026 10 07 / ODOO-341407: + baseItem (строка-основа поля)
        i18nFields_formRows(attr, rows, parentsList, ctx, baseItem) {
            const attr_col = { binding: 'attr' }
            const Vs = i18nFields_formRowsFor(attr, ctx)   // IE 2026 10 07 / ODOO-341407
            // IE 2026 10 07 / ODOO-341407 (решение Игоря «2а»): у поля со строками переводов пустая ОСНОВНАЯ строка тоже не прячется (при включённой опции
            // «Show translation fields» видна тройка «Підказка / (uk) / (ru)»); признак неперечисляемый — в данные формы не попадает; читают isEmpty и отбор «непустые»
            if (Vs.length && baseItem && typeof baseItem === 'object') Object.defineProperty(baseItem, '_i18nBase', { value: true, enumerable: false, writable: true, configurable: true })   // IE 2026 10 07 / ODOO-341407
            for (const V of Vs) {   // IE 2026 10 07 / ODOO-341407: было for (const V of i18nFields_formRowsFor(attr, ctx))
                const dataItem = {}
                this.store.set_value(dataItem, attr_col.binding, V)
                if (V._i18nOf.auto) dataItem.MD = { cssClass: { 'attr.valueStr': 'i18n-auto' } }   // словарный перевод предопределённой записи, в записи не сохранён (подсказка — V.tooltip)
                rows.push(dataItem)
                this.store.prepare_AttrMulti(this, attr_col, dataItem, parentsList)
            }
        },
        // IE 2026 10 06 / ODOO-341407 (ревью U9: вставка / Delete в «Назва (en)» метили запись изменённой без правки данных): строка перевода формы только
        // для чтения — «(en)» (английская база) или поле / виджет только для чтения. Её не правят ни редактор, ни вставка, ни очистка диапазона
        i18nFields_rowReadOnly(dataItem) {
            const V = dataItem?.attr
            return !!(V?._i18nOf && (V.isReadOnly || V._i18nOf.en))
        },
        // правка строки формы, связанная с переводами (из relation_attr_set). true — запись сделана здесь (или отклонена), false — обычный attr_set:
        //  - строка «<поле> (uk)» — пишет свой ключ (attr_set: _meta.modified → Save), правка словарного meta.title_<L> снимает его из meta._i18n_auto;
        //    «(en)» / только чтение — не пишется, строка возвращается к значению записи;
        //  - основная translate-строка под uk / ru (решение Игоря В3, выключатель fe.i18n.formEditTranslation, по умолчанию вкл.) — ТОЛЬКО перевод
        //    (title записи → meta.title_<L>, doc.x → doc.x_<L>, meta.comment → meta.comment_<L>, поле строки конфигурации → <binding>_<L>), база не трогается —
        //    как F2 грида и F1 шапки. Иначе бэк при Save уводил правку базы в перевод ПОВЕРХ правки строки «(uk)» (views.py), а поле вне fields_map сегмента
        //    (meta.comment «Інфо») под uk ложилось в английскую базу. Формы параметров вида / чипса (widget-row-viewParams / -chip) — как раньше
        // Строки формы — снимки (prepare_AttrMulti): после правки соседние строки того же поля пересобираются (i18nFields_formRebuild)
        i18nFields_formSet(V) {
            const store = this.store, W = this.WIDGET
            const of = V?._i18nOf
            if (of) {
                if (V.isReadOnly || of.en) { this.i18nFields_formRebuild(); return true }
                store.attr_set(W, V, V.value)
                const link = store.i18n_linkBinding(W, V.binding)   // запись-владелец и полный путь (у формы строки — doc.viewList.3.title_uk)
                store.i18n_autoUnmark(link.record, link.binding)
                this.i18nFields_listRowTouch(link, V.binding)   // IE 2026 10 06 / ODOO-341407: форма Alt+F2 строки списка — строка в Save списка
                this.i18nFields_formRebuild()
                return true
            }
            const lang = store.get_lang()
            if (!lang || !V?.translate || !i18nFields_isTranslatable(V) || typeof V.value !== 'string' || V.raw_binding) return false   // текстовое поле (AttrStr / AttrStrMulti), путь не служебный; размножение на диапазон ячеек (raw_binding) — как раньше
            if (store.setting(I18N_FLAG_FORM_EDIT, true) === false) return false
            const type = W?.record?._meta?.type
            if (type === 'widget-row-viewParams' || type === 'widget-row-chip') return false
            const link = store.i18n_linkBinding(W, V.binding)
            // IE 2026 10 06 / ODOO-341407 (ревью U9): записи ещё нет в базе — правка в базу, как раньше (бэк уводит в перевод только у записи с id; пустое название
            // стало бы номером); строки «(en)/(uk)» при опции перечитываются после записи
            if (i18nFields_newRecordBaseEdit(link.record, link.binding)) {
                store.attr_set(W, V, V.value)   // то же, что прежний путь relation_attr_set (база + sync_translation)
                if (store.i18nFields_on(W)) this.i18nFields_formRebuild()
                return true
            }
            const rowPath = i18nFields_rowPathOf(link, V.binding)   // IE 2026 10 06 / ODOO-341407 (ревью U9): карточка Alt+F2 строки списка — '_doc.data.3': title → meta.title_<L>, как читает attr_get
            const path = i18nFields_fieldPath(V.binding, lang, { nested: link.nested, rowPath, localize: (b, L, raw) => store.localize_binding(b, L, raw) })   // относительно записи формы (attr_set допишет путь родителя)
            if (!path) return false
            store.attr_set(W, { ...V, binding: path, translate: false }, V.value)
            if (!link.nested && V.binding === 'title') W.title = store.i18n_record_title(link.record) || W.title   // шапка — название на языке интерфейса (как attr_set для 'title'); перевод снят — база
            if (!link.nested || rowPath) store.i18n_autoUnmark(link.record, rowPath ? rowPath + '.' + path : path)   // IE 2026 10 06 / ODOO-341407: путь от записи-владельца (было link.binding + '_' + lang у строки)
            this.i18nFields_listRowTouch(link, V.binding)   // IE 2026 10 06 / ODOO-341407: форма Alt+F2 строки списка — строка в Save списка
            // пустой перевод — основная строка покажет базу; путь виден другой строкой (опция / явное поле вида) — та строка перечитывается
            const shown = (rows) => (rows || []).some(r => r?.attr?.binding === path || shown(r?.attrs))
            if (V.value === '' || store.i18nFields_on(W) || shown(this.data)) this.i18nFields_formRebuild()
            return true
        },
        // IE 2026 10 06 / ODOO-341407 (round 3): перевод, записанный формой Alt+F2 строки-записи списка (widget-row над _doc.data.N), ложится в строку
        // записи-владельца по служебному пути '_doc.data.N…' — set_value его не метит (is_serviceBinding), а Save списка отправляет только строки с
        // _meta.modified (get_record_to_transfer). Строка метится через грид списка (setModified: строка, жёлтый Save) — как правка в самом списке.
        // true — строка помечена; поле самой записи / строки конфигурации — false (их метит attr_set)
        i18nFields_listRowTouch(link, binding) {
            const rowPath = i18nFields_rowPathOf(link, binding)
            const row = rowPath ? i18nFields_listRowOf({ ...link, binding: rowPath }) : null
            if (!row) return false
            const grid = link.WIDGET?.vueObj?.get_vueObj?.('_doc.data')
            if (grid?.setModified) {
                grid.setModified(row)
                try { grid.flex?.invalidate?.() } catch (e) { /* грид в перестройке */ }
            } else {
                row._meta = row._meta || {}
                row._meta.modified = true
            }
            return true
        },
        // пересборка строк формы из памяти (без запроса): после $nextTick; пока открыт редактор ячейки или форма ячейки этого грида — позже
        // (те же условия, что у живой смены языка: строки-объекты под открытой формой ячейки не подменяем)
        i18nFields_formRebuild(n = 0) {
            this.$nextTick(() => {
                if (this.$?.isUnmounted || this.attr?.attr_type !== 'AttrTabGrid') return
                if (this.flex?.activeEditor || (this.store.dropdown?.visible && this.store.dropdown.vueObj === this)) {
                    if (n < 40) window.$cg.setTimeout(this, 'AttrGrid.i18nFields_formRebuild', () => this.i18nFields_formRebuild(n + 1), 300)
                    return
                }
                try { this.content_Changed({ isVue: true }) } catch (e) { console.warn('i18n fields: form rebuild', e) }
            })
        },
        // ---- IE 2026 10 06 / ODOO-341407 (заказ Игоря п.2, DESIGN i18n_fields_ui §3.4): колонки переводов в таблице данных виджета-списка — за translate-колонкой
        // «<колонка> (uk)», «<колонка> (ru)» (включённые в базе языки без en; колонки (en) нет: binding title занят базовой колонкой) при личной опции виджета
        // «Show translation fields» (store.i18nFields_on — по сегменту данных). Вид (attr.attrs, doc.viewList) и doc.viewParams не меняются ----
        // грид — таблица данных списка записей: WIDGET-LIST, сегмент данных не витрина DS (строки DS без meta / doc записи); отчёт, DS, формы, печать — нет
        i18nFields_isListGrid() {
            const a = this.attr, rec = this.WIDGET?.record
            if (!a || a.binding !== '_doc.data' || a.attr_type === 'AttrTabGrid' || a.isPrint || a.isPrintTemplate) return false
            if (String(rec?.segment || '') !== 'WIDGET-LIST') return false
            return !String(rec?.doc?.params?.segment || '').startsWith('DATA-SOURCE')
        },
        // колонки грида с колонками переводов (load_data, до сканирования колонок): НОВЫЙ массив или тот же (опция выкл / добавлять нечего). Описания —
        // utils/i18nFields.listColsFor: путь перевода выводится из binding колонки по правилу таблицы (i18n_rowLangBinding → store.localize_binding: title →
        // meta.title_<L>, doc.x → doc.x_<L>, meta.comment → meta.comment_<L>; префиксы не зашиты), только у видимых translate-колонок и только если хоть у одной
        // загруженной строки есть контейнер перевода (у строк DS / noExtraFields / aggregateSelect meta / doc нет — правка заменила бы meta записи, DESIGN Р5).
        // _i18nListCols — число колонок переводов (formatItem красит словарные значения только при них)
        i18nFields_listCols(cols) {
            this._i18nListCols = 0
            const store = this.store, W = this.WIDGET
            if (!Array.isArray(cols) || !cols.length || !this.i18nFields_isListGrid() || !store.i18nFields_on(W)) return cols
            const childPath = this.attr.column_childItemsPath || ''
            const out = i18nFields_listColsFor(cols, {
                langs: store.i18n_fieldLangs(),
                rows: Array.isArray(this.data) ? this.data : [],
                isHidden: (c) => this.isHidden(c),
                readOnly: !!(W.isReadOnly || store.readonly_on()),
                childPath,
                localize: (b, L, raw) => this.i18n_rowLangBinding(b, raw, L),
            })
            if (out === cols) return cols
            // ширина, заданная ресайзом колонки перевода (только память грида, set_width), — поверх ширины базовой колонки
            const widths = this._i18nColWidths
            const walk = (arr) => {
                for (const c of arr || []) {
                    if (c?._i18nOf) {
                        this._i18nListCols++
                        if (widths && widths[c.binding]) c.width = widths[c.binding]
                    } else if (childPath && Array.isArray(c?.[childPath])) walk(c[childPath])
                }
            }
            walk(out)
            return out
        },
        // граница замороженной зоны с колонками переводов: attr.frozenColumns (сохраняемый параметр, не меняется) считает колонки вида — колонки «(uk)/(ru)»,
        // вставленные левее границы, сдвигают её вправо (за последней замороженной колонкой вида её переводы остаются в прокручиваемой части)
        i18nFields_frozenShift(fz) {
            const cols = this.flex?.columns
            if (!(fz > 0) || !this._i18nListCols || !cols) return fz
            let n = 0, i = 0
            for (; i < cols.length && n < fz; i++) if (!this.attr_by_binding?.[cols[i]?.binding]?._i18nOf) n++
            return fz + (i - n)
        },
        // строку можно править в колонке перевода: у неё есть контейнер перевода (meta / doc — первый сегмент пути перевода колонки-основы)
        i18nFields_rowEditable(dataItem, attr_col) {
            const of = attr_col?._i18nOf
            if (!of) return true
            return i18nFields_rowHasBox(dataItem, of.binding, { localize: (b, L, raw) => this.i18n_rowLangBinding(b, raw, L) })
        },
        // ячейка колонки перевода со словарным переводом предопределённой записи (meta._i18n_auto: в записи не сохранён) — серым, с подсказкой; сверка по
        // факту классов (кэш-путь formatItem переписывает className снимком), подсказка снимается только своя
        i18nFields_cellPaint(e_cell, dataItem, col) {
            const attr_col = col?.binding ? this.attr_by_binding?.[col.binding] : null
            const auto = !!(attr_col?._i18nOf && dataItem && i18nFields_isAuto(dataItem, attr_col.binding))
            const cl = e_cell.classList
            if (auto !== cl.contains('i18n-auto')) { if (auto) cl.add('i18n-auto'); else cl.remove('i18n-auto') }
            if (auto) { e_cell.title = t(I18N_TIP_AUTO); e_cell.__i18nAuto = true }
            else if (e_cell.__i18nAuto) { e_cell.removeAttribute('title'); e_cell.__i18nAuto = false }
        },
        // IE 2026 10 06 / ODOO-341407 (ревью U9: в узкой колонке подписей формы «Назва (en)/(uk)/(ru)» резались в одинаковое «Назва…» — язык не виден):
        // подпись строки перевода — имя поля (режется многоточием) и « (uk)» (не режется). Текст подписи прежний (решение Игоря В2), меняется только
        // место обрезки; полная подпись — подсказкой. Меняется только текстовый узел подписи (глиф / отступ дерева остаются); подпись разметкой
        // (подсветка поиска) — обычная обрезка
        i18nFields_labelPaint(e_cell, dataItem) {
            const of = dataItem?.attr?._i18nOf
            if (!of || !e_cell || e_cell.querySelector('.i18n-label')) return
            const sfx = ' (' + of.lang + ')'
            // IE 2026 10 06 / ODOO-341407 (проверка round 2, C6.label: «Назва (uk)» резался без языка): у ячейки с оверлеями (линии групп формы) formatItem уже
            // перенёс содержимое во внутренний .cell-text-clip (formatItem_cells: клип текста узкой колонки) — подпись ищется и там, отступ — левее неё в том же узле
            const box = e_cell.querySelector(':scope > .cell-text-clip') || e_cell
            let tn = null, pad = 0
            for (const n of box.childNodes) {
                if (n.nodeType === 3 && n.nodeValue && n.nodeValue.endsWith(sfx)) { tn = n; break }
                if (n.nodeType === 1) pad += typeof n.getBoundingClientRect === 'function' ? Math.ceil(n.getBoundingClientRect().width) : (n.offsetWidth || 0)   // отступ / глиф дерева левее подписи (IE 2026 10 06 / ODOO-341407: дробная ширина — вверх, иначе обёртка шире остатка строки)
            }
            if (!tn || tn.nodeValue.length <= sfx.length) return
            const wrap = document.createElement('span'), name = document.createElement('span'), lang = document.createElement('span')
            wrap.className = 'i18n-label'
            name.className = 'i18n-label-name'
            lang.className = 'i18n-label-lang'
            name.textContent = tn.nodeValue.slice(0, -sfx.length)
            lang.textContent = sfx
            wrap.title = tn.nodeValue
            if (pad) wrap.style.maxWidth = `calc(100% - ${pad}px)`
            wrap.append(name, lang)
            tn.replaceWith(wrap)
        },
        // опция переключена — колонки списка пересобираются из памяти (load_data, без select); правки строк до Save (удалённые строки, история отмены,
        // подсветка правок, признак «изменено») load_data сбрасывает как при новых данных — здесь данные те же, состояние правки сохраняется.
        // Пока открыт редактор ячейки или форма ячейки этого грида — позже; скрытый грид — при показе (need_content_Changed_afterTimeout)
        i18nFields_listRebuild(n = 0) {
            this.$nextTick(() => {
                if (this.$?.isUnmounted || !this.flex?.hostElement || !this.i18nFields_isListGrid()) return
                if (this.flex.activeEditor || (this.store.dropdown?.visible && this.store.dropdown.vueObj === this)) {
                    if (n < 40) window.$cg.setTimeout(this, 'AttrGrid.i18nFields_listRebuild', () => this.i18nFields_listRebuild(n + 1), 300)
                    return
                }
                // IE 2026 10 06 / ODOO-341407 (ревью U9: переключение при скрытом гриде теряло несохранённые удаления строк и историю отмены): скрытый грид —
                // своя пометка, при показе (handleVisibility) пересборка идёт ЭТИМ же методом, с сохранением состояния правки; общий
                // need_content_Changed_afterTimeout звал голый load_data, который его сбрасывает
                if (!this.isVisible) { this._i18nRebuildOnShow = true; return }
                this._i18nRebuildOnShow = false
                const keep = { deletedItems: this.deletedItems, undo: [...this.undoStack], redo: [...this.redoStack], changesStack: this.changesStack, modified: this.modified }
                try {
                    this.content_Changed_afterTimeout({ isVue: true })
                } catch (e) {
                    console.warn('i18n fields: list columns rebuild', e)
                } finally {
                    this.deletedItems = keep.deletedItems
                    this.undoStack.length = 0; for (const a of keep.undo) this.undoStack.push(a)   // load_data чистит стеки на месте — возвращаем в те же массивы
                    this.redoStack.length = 0; for (const a of keep.redo) this.redoStack.push(a)
                    this.changesStack = keep.changesStack
                    this.modified = keep.modified
                }
            })
        },
        attrsTabGrid_from_JSON(valueJSON, rows) {
            let attr_col = {binding:'attr'}
            for (let key in valueJSON) {
                let value = valueJSON[key],
                V = {
                    title: key,
                    value: value,
                    valueStr: `${value}`,
                },
                dataItem = { 
                    // [attr_col.binding]: V,
                    MD: { cssClass: {'attr.title':'json-key2'} },
                }
                this.store.set_value(dataItem, attr_col.binding, V) // 2026-01-15 untill >>  [attr_col.binding]: V
                
                rows.push(dataItem)

                if (Array.isArray(valueJSON)) {
                    V.title = `[${V.title}]`
                    dataItem.MD = { cssClass: {'attr.title':'json-array-key'} }
                }

                if (typeof value === 'object' && value !== null) {
                    V.valueStr = ''
                    dataItem.cssClass = 'row-label'
                    dataItem.MD.cssClass['attr.valueStr'] = 'json-value-title'
                    dataItem.attrs = []
                    this.attrsTabGrid_from_JSON(value, dataItem.attrs)
                } else {
                    // dataItem.MD = { cssClass: {'attr.valueStr':'json-value'} }
                }
            }
        },
        attrsTabGrid_to_JSON(dataItems, colValue='value', showEmpty=true, keyTitle={}) {
            let attr_col = {binding:'attr'},
            valueJSON = {}
            if (Array.isArray(dataItems)) {
                for (let i in dataItems) {
                    let dataItem = dataItems[i],
                    V = this.store.get_value(dataItem, attr_col.binding),
                    key = V.shortTitle || V.title,
                    value = V[colValue]
                    
                    if (dataItem[this.attr.childItemsPath]?.length) {
                        value = this.attrsTabGrid_to_JSON(dataItem[this.attr.childItemsPath], colValue)
                    }

                    if (V?.attr_type === 'AttrDate' && value) {
                        value = this.store.formatDateHTML(value, V.utc_to_local)
                    } else if (V?.attr_type === 'AttrTime' && value) {
                        value = this.store.formatTimeHTML(value, V) // IE 2026 09 10 / ODOO-5800: формат/единица — у поля (attr_col здесь заглушка)
                    } else if (V?.attr_type === 'AttrDays' && value) {
                        value = this.store.formatDaysHTML(value, attr_col)
                    } else if (V?.attr_type === 'AttrNumber' && value && V?.format === 'bytes') {
                        value = this.store.formatNumberHTML(value, V)
                    } else if (V?.attr_type === 'AttrNumber' && value) {
                        value = value // this.store.formatNumberHTML(value, attr_col)
                    }

                    if (value || showEmpty) {
                        valueJSON[key] = value
                    }
                }
            } else {
                for (let dataItem in dataItems) {
                    let V = this.store.get_value(dataItem, attr_col.binding),
                    key = V.shortTitle || V.title,
                    value = V.value

                    valueJSON[key] = value

                    if (dataItem[this.attr.childItemsPath]?.length) {
                        valueJSON[key] = this.attrsTabGrid_to_JSON(dataItem[this.attr.childItemsPath], colValue)
                    }
                }
            }
            return valueJSON
        },
        // IE 2026 10 29 / ODOO-5800 (ie-dm7 #116081, дефект Igor: процесна модель — id, не назва): коммит текста в ссылочное поле строки AttrMulti (форма AttrTabGrid): однозначный пункт словаря → id; иначе значение
        // записи остаётся прежним (V.value из записи, а не из подписи), текст — подписью с предупреждением, и name_search сегмента:
        // однозначный ответ (или пункт, уже долитый в словарь прежним поиском — кэш async_name_search отвечает []) пишет id
        linkText_commit(V, text, irow, dataItem, col_binding, oldVal) {
            const seg = V.relation_segment
            const IS = this.store.itemsSource[seg]
            const hit = linkResolveText(IS?.data, text)
            if (hit) {
                V.value = hit.id
                V.valueStr = hit.title
                delete V.is_customValueWarning
                return true
            }
            if (V.binding) {
                const cur = this.store.attr_get(this.WIDGET, V)
                V.value = cur == null ? '' : cur
            }
            V.valueStr = text
            V.is_customValueWarning = !!text
            this.linkText_counter = (this.linkText_counter || 0) + 1   // счётчик для проб: несопоставленный текст ссылки не записан
            if (IS && seg) {
                const _irow = irow, _dataItem = dataItem, _binding = col_binding, _oldVal = oldVal, _V = V, _text = text
                this.store.async_name_search(this, seg, _text, (newItems) => {
                    const r = linkResolveText(newItems, _text) || linkResolveText(this.store.itemsSource[seg]?.data, _text)
                    if (String(_V.valueStr ?? '') !== String(_text)) return   // подпись уже сменили — ответ устарел
                    if (!r) { this.linkText_warn(_text); return }
                    _V.value = r.id
                    _V.valueStr = r.title
                    delete _V.is_customValueWarning
                    this.set_value(_irow, _dataItem, _binding, _oldVal, r.id, true, null)
                    this.flex?.invalidate?.()
                })
            } else {
                this.linkText_warn(text)
            }
            return false
        },
        // IE 2026 10 29 / ODOO-5800 (ie-dm7 #116081, дефект Igor: процесна модель — id, не назва): страховка записи (relation_attr_set) — текст, однозначно совпавший с названием пункта словаря сегмента (а не id), пишется его id
        linkText_fixRef(V) {
            if (!linkIsRef(V) || !linkTextToId_on(this.store)) return false
            const _lr = linkLegacyResolve(this.store.itemsSource?.[V.relation_segment], V.value)
            if (!_lr) return false
            V.value = _lr.id
            V.valueStr = _lr.title
            delete V.is_customValueWarning
            return true
        },
        linkText_warn(text) {
            try { this.store.show_notification({ text: t('No item of the list matches “{text}” — the value is not saved. Pick it from the list.', { text: String(text) }), status: 'warning' }) } catch (e) { console.warn('linkText_warn', e) }
        },
        relation_attr_set(V) {
            if (V?.binding) {
                this.linkText_fixRef?.(V)   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #116081, дефект Igor: процесна модель — id, не назва)
                if (this.attr?.attr_type === 'AttrTabGrid' && this.i18nFields_formSet(V)) return   // IE 2026 10 06 / ODOO-341407 (заказ Игоря п.2, В3): строка перевода «… (uk)» / основная translate-строка под uk / ru — только перевод
                if (V?.attr_type === 'AttrLinkOdoo') {
                    this.store.attr_set(this.WIDGET, V, [V.value, V.valueStr || V.value])
                }
                this.store.attr_set(this.WIDGET, V, V.value)
                this.dl2_bandStyle_prefill(V)
            } 
        },
        // IE 2026 09 04 / ODOO-336283 (заказ Игоря): стиль полосы — в поле Style строки лэйаута. При выборе
        // Row type = Tab / Tab row в форме строки (widget-row, AttrTabGrid) пустое поле Style получает CSS-дефолт
        // полосы (зелёная нижняя половина строки; тот же дефолт подставляет бэк при отрисовке, если поле пусто),
        // дальше пользователь правит его редактором. Значение — строка CSS (форма показывает и пишет строку)
        dl2_bandStyle_prefill(V) {
            try {
                if (this.attr.attr_type !== 'AttrTabGrid' || V?.binding !== 'attr_type') return
                if (!['AttrTab', 'AttrTabRow'].includes(V.value)) return
                const rec = this.WIDGET?.record
                if (!rec) return
                const cur = rec.style
                const empty = cur == null || cur === '' || (typeof cur === 'object' && !Object.keys(cur).length)
                if (!empty) return
                // IE 2026 09 04 / ODOO-336283: Style строки лэйаута хранится СТРОКОЙ CSS (как и до -29), не словарём
                const def = `background: ${this.DL2_BAND_STYLE_DEFAULT}`
                const styleRow = [...(this.flex?.rows || [])].map(r => r.dataItem).find(d => d?.attr?.binding === 'style')
                const styleAttr = styleRow?.attr || { binding: 'style', attr_type: 'AttrCSS' }
                this.store.attr_set(this.WIDGET, styleAttr, def)
                if (styleRow?.attr) {
                    styleRow.attr.value = def
                    styleRow.attr.valueStr = def
                }
                this.flex?.invalidate?.()
            } catch (e) { console.warn('dl2_bandStyle_prefill', e) }
        },
        // checks_AttrMulti() {
        //     return {
        //         title:'',
        //         value:'',
        //         valueStr:'',
        //         attr_type:'AttrStr',
        //         attr_type:'AttrStr',
        //     }
        // },

        updateFieldsMapping_Click(test_now=null) {
            // из командной панели метод вызывается с объектом кнопки первым
            // аргументом — датой считаем только строку (из testFieldsMapping_Run)
            if (typeof test_now !== 'string') test_now = null
            // пересчёт значений fieldsMapping на бэке тем же алгоритмом, что при
            // открытии виджета, включая строки с флагом On START (test_now —
            // переопределение «текущей даты» из диалога Test)
            const action = {
                command: 'executeWidgetMethod',
                method: 'update_fieldsMapping',
                actions_after: [{
                    command: 'executeVueObjMethod',
                    method: 'updateFieldsMapping_Ended',
                    source_name: this.attr.name,
                    binding: this.attr.binding,
                }],
            }
            if (test_now) action.params = { test_now }
            this.store.executeStoreMethod(this.WIDGET.vueObj, action, this.attr)
        },
        updateFieldsMapping_Ended(action) {
            if (action.fieldsMapping) {
                this.store.updateAttrs(this.data, action.fieldsMapping)
                this.flex.invalidate()
                this.content_Changed()
            }
        },
        testFieldsMapping_Click() {
            // диалог Test: «текущая дата» по умолчанию — now в UTC
            this.fmTestNow = new Date().toISOString().replace('T', ' ').slice(0, 19)
            this.showFmTestDialog = true
        },
        testFieldsMapping_Run() {
            this.showFmTestDialog = false
            this.updateFieldsMapping_Click(this.fmTestNow)
        },
        processBackend() {
            if (!this.store.hide_console) console.log('processBackend()')
            if (!this.backendProcessed && !this.store.isEmpty(this.backendStack)) {
                let selectedRanges = []
                for (let key in this.backendStack) {
                    selectedRanges.push(this.backendStack[key])
                }

                const action = {
                    command: 'executeWidgetMethod',
                    method: this.attr.executeWidgetMethod_afterEdit, // 'save_cell',
                    actions_after: [{
                        command: 'executeVueObjMethod',
                        method: 'processBackend_Ended',
                        binding: this.attr.binding,
                    }],
                }

                // TODO
                if (this.attr.executeWidgetMethod_afterEdit === 'afterEdit') {
                    Object.assign(action, {
                        widget_sendToBackend_exclude: ['view'],
                        record: {
                            _doc: {
                                data: this.data,
                            },
                            params: this.WIDGET.record.params,
                        },
                    })
                } else {
                    Object.assign(action, {
                        record_sendToBackend_exclude: ['_doc'],
                        selectedRanges: selectedRanges,
                    })
                }
                
                this.store.executeStoreMethod(this.WIDGET.vueObj, action, this.attr)

                this.backendProcessed = true
                this.backendStack = {}
            }
        },
        afterEdit_scheduleCheck() {
            // IE 2026 09 02 / ODOO-11316: проверка перебития по ЗАТИХАНИЮ обновлений
            // вида — таймер перевзводится каждым updatedView и срабатывает, когда
            // перестроения (в т.ч. фронт-декомпозиция года/месяцев) прекратились.
            // Так cur сравнивается с введённым в УСТОЯВШЕМСЯ состоянии, а не на
            // промежуточном кадре пересчёта → нет ложного флеша и моргания.
            clearTimeout(this._afterEditSettleT)
            this._afterEditSettleT = window.$cg.setTimeout(this, 'AttrGrid.afterEditSettle',
                () => { try { this.afterEdit_notifyOverridden() } catch { /* данные могли перестраиваться */ } }, 140)
        },
        afterEdit_notifyOverridden() {
            // IE 2026 09 02 / ODOO-11316 (заказ Игоря, M03 «кво возвращается»): пересчёт
            // заменил введённое руками значение (год выводится из месяцев; ручная
            // корректировка месяца в приоритете) — говорим об этом человеку, а не молчим.
            // Вывод — стандартным дуэтом платформы (как ход задачи, замечание Игоря):
            // плашка в углу ВИДЖЕТА + глобальный тост + строка в TERMINAL виджета.
            // UI-текст по правилу №12 — английский.
            const flight = this._afterEditWatch || []
            if (!flight.length) return
            const fmt = (v) => (typeof v === 'number' && isFinite(v)) ? v.toLocaleString('en-US') : String(v)
            const replaced = [], keep = []
            for (const w of flight) {
                const cur = parseFloat(this.store.get_value(w.item, w.binding))
                const ent = parseFloat(w.entered)
                if (!isFinite(ent) || !isFinite(cur)) continue
                if (Math.abs(cur - ent) <= Math.max(0.5, Math.abs(ent) * 1e-6)) { keep.push(w); continue }
                // guard от ложных (undo/redo): при перебитии пересчётом корректировка
                // (_cells) хранит введённое; undo откатывает и её — тогда молчим
                const raw0 = String(w.binding || '').replace(/^data::/, '')
                const cells0 = w.item && w.item._cells
                if (cells0 && cells0[raw0] && Math.abs(parseFloat(cells0[raw0].value) - ent) > 1e-9) continue
                replaced.push({ ...w, cur, ent })
            }
            this._afterEditWatch = keep   // неотскочившие ждут своего кадра (уборка — таймером)
            if (!replaced.length) return
            clearTimeout(this._afterEditWatchT)
            const w = replaced[0]
            const rawb = String(w.binding || '').replace(/^data::/, '')
            const base = rawb.replace(/_(Y|YTD|YTG|M\d\d)$/, '')
            const cellKeys = Object.keys(w.item?._cells || {})
            // семейство меры: и своя ветка, и парная abs↔pct (корректировка месяца
            // quantity_M08 перебивает и ввод в quantity_pct_*: месяцы зафиксированы)
            const bases = [base]
            if (/_pct$/.test(base)) bases.push(base.replace(/_pct$/, ''))
            else bases.push(base + '_pct')
            const months = [...new Set(cellKeys.filter(k => bases.some(b => new RegExp('^' + b + '_M\\d\\d$').test(k)))
                .map(k => k.slice(-3)))].sort()
            const yearCorr = /_M\d\d$/.test(rawb) && bases.some(b => cellKeys.includes(b + '_Y'))
            // IE 2026 09 23 / ODOO-341407: i18n
            let reason
            if (months.length && !/_M\d\d$/.test(rawb)) {
                reason = tn(months.length, 'manual correction in month cell {months} takes precedence', 'manual corrections in month cells {months} take precedence', { months: months.join(', ') })
            } else if (yearCorr) {
                reason = t('a manual correction in the yearly cell takes precedence')
            } else {
                reason = t('the cell is derived from other cells')
            }
            const more = replaced.length > 1 ? ' ' + tn(replaced.length - 1, '(+{n} more cell)', '(+{n} more cells)') : ''
            // красный флеш перебитых ячеек (моргнул и затухает — заказ Игоря)
            const fkeys = new Set()
            for (const r of replaced) {
                const irow = this.rows_indexOf(r.item)
                if (irow >= 0) fkeys.add(`${irow}:${r.binding}`)
            }
            if (fkeys.size) {
                this._flashOverride = { keys: fkeys, ts: Date.now() }
                window.$cg.setTimeout(this, 'AttrGrid.flashOverrideEnd', () => { this._flashOverride = null }, 2600)
                this.flexRefresh()
            }
            const text = t('"{title}": entered {entered} was replaced by the recalculated {current} — {reason}. Clear the correction to apply your value.', { title: w.title, entered: fmt(w.ent), current: fmt(w.cur), reason }) + more
            const W = this.WIDGET
            if (W?.notification) {
                // плашка в углу виджета (стандартный notification-widget; TERMINAL ставит её
                // только для error/critical/success/pending — warning ставим сами)
                W.notification.header = ''
                W.notification.text = text
                W.notification.status = 'warning'
                W.notification.visible = true
            }
            if (W) {
                W.TERMINAL = (W.TERMINAL ? W.TERMINAL + '\n' : '') + text
            }
            this.store.show_notification({ text, status: 'warning' })
        },
        processBackend_Ended(action) {
            if (!this.store.hide_console) console.log('processBackend_Ended()')
            this.backendProcessed = false
            if (!this.store.isEmpty(this.backendStack)) {
                this.processBackend()
            } else {
                if (action.data) {
                    // this.data = action.data
                    // this.store.attr_set(this.WIDGET, this.attr, this.data, null, null, false)
                    // this.data.splice(0, this.data.length, ...action.data);
                    this.store.updateAttrs(this.data, action.data)

                    this.flex.invalidate()
                    // IE 2026 09 02 / ODOO-11316 (заказ Игоря, M03): пересчёт мог перебить
                    // введённое руками значение — сказать об этом, а не молчать
                    this.afterEdit_notifyOverridden()
                    // this.set_itemsSource()
                    // this.content_Changed()
                } else {
                    this.store.executeStoreMethod(this.WIDGET.vueObj, { 
                        command: 'executeWidgetMethod',
                        method: 'select', 
                        updateDoc_ifChanged:true,
                        record_sendToBackend_exclude: ['_doc'],
                        actions_after: [{
                            command: 'updateRelatedWidgets', 
                            // updateDoc_ifChanged: true,
                        }],
                    }, this.attr)
                }
            }
        },
        aggregateFront() {
            // + formulas
            console.time("aggregateFront"); let countFormulas = 0
            for (let attr_col of this.columns()) {
                if (attr_col.aggregateFront) {
                    let col_binding = attr_col.binding
                    for (let i=0; i<this.data000.length; i++) {
                        let dataItem = this.data000[i]
                        if (dataItem.levelGroup>0 && dataItem.levelGroup<99) {
                            // sum()
                            // this.flex.setCellData(i, 2, "=sum(B2:D4)")
                            let i_next = i + 1,
                                sum = 0
                            while(i_next < this.data000.length && dataItem.levelGroup !== this.data000[i_next].levelGroup) {
                                if (this.data000[i_next].levelGroup === 0) {
                                    sum += +this.data000[i_next][col_binding]
                                }
                                i_next++
                                countFormulas++
                            }
                            dataItem[col_binding] = sum
                        }
                    }
                }
            }
            console.timeEnd("aggregateFront"); if (!this.store.hide_console) console.log(`countFormulas: ${countFormulas}`)
        },
        undo_Click() {
            this.changeStack(this.undoStack, this.redoStack)
            this.modified = !!this.undoStack.length   // IE 2026 08 27 (Igor): пустой стек — не «изменено»
            this.saveState_sync()
            this.gridSave_schedule()   // IE 2026 10 13 / ODOO-5800
        },
        redo_Click() {
            this.changeStack(this.redoStack, this.undoStack, 'newVal')
            this.modified = !!this.undoStack.length
            this.saveState_sync()
            this.gridSave_schedule()   // IE 2026 10 13 / ODOO-5800
        },
        // IE 2026 08 27 (Igor): после undo/redo — состояние Save по факту правок: нет правленых ячеек и структурных
        // записей в undo-стеке → «без изменений» (Save неактивна); есть — активна
        // IE 2026 08 27 (Igor): прямые правки пользователя, оставшиеся в changesStack; если их нет — производные
        // остатки (indirect/related) вычищаются, чтобы не держать «изменено»
        _userChanges_left() {
            const all = Object.entries(this.changesStack || {})
            const user = all.filter(([, rs]) => rs && ((rs.method === 'val' && !rs.indirect && !rs.related) || (rs.method === 'aggEdit' && rs.user)))
            // IE 2026 09 25 / ODOO-5800 (D3, проба 25.09: ответ симуляции пересчитал агрегатную ячейку правки — её запись в changesStack
            // заместилась косвенной, «правок пользователя нет», changesStack вычищался, и следующая правка теряла базу цепочки — Save горел
            // после отката 60→0→60): пока чипс Corrections (undo-стек) видит правки, changesStack не вычищается. Выключатель fe.sim.revertLeaves
            if (!user.length && all.length && this.sim_flag('revertLeaves')) {
                let chip = []
                try { chip = this.corrChip_cells() } catch (e) { chip = [] }
                if (chip.length) return chip.map(g => g.entries[g.entries.length - 1])
            }
            if (!user.length && all.length) for (const [k] of all) delete this.changesStack[k]
            return user.map(([, rs]) => rs)
        },
        saveState_sync() {
            const structural = this.undoStack.some(a => a && a.col_binding == null)
            const changes = this._userChanges_left().length > 0 || this.gridEditMode_dirty()   // IE 2026 10 14 / ODOO-5800: правки строк динамического списка — тоже изменения
            if (!structural && !changes) {
                if (this.modified || this._roCaptured) this.noop_unmodified()
                else this.set_commandPanel()
            } else {
                if (!this.modified) this.modified = true
                this.set_commandPanel()
            }
        },
        pushStack(rowStack) {
            const startStack_length = this.undoStack.length + this.redoStack.length
            this.undoStack.push(rowStack)

            // IE 2026 08 19: noMark — в undo-стеке, но без метки «правлено» на ячейке
            // (очистка корректировок: ячейка возвращается к значению по умолчанию)
            if (rowStack.col_binding != null && !rowStack.noMark) {
                // IE 2026 08 21 / ODOO-5512 (баг Игоря «пишет что уменьшились остатки»):
                // сим-корректировка сервера ложится ПОВЕРХ локального превью той же
                // ячейки — метка/бейдж считают НАКОПЛЕННУЮ дельту от исходного
                // значения цепочки (val0), а не шаг последней записи; вернулась к
                // исходному — метка снимается совсем (undo-история не трогается)
                const _key = `${rowStack.irow}:${rowStack.col_binding}`
                if (rowStack.indirect || rowStack.related) {
                    const _prev = this.changesStack[_key]
                    if (_prev) rowStack.val0 = _prev.val0 !== undefined ? _prev.val0 : _prev.val
                }
                // IE 2026 09 25 / ODOO-5800 (D3, проба 25.09): база цепочки АГРЕГАТНОЙ правки — из предыдущей aggEdit той же ячейки в
                // undo-стеке (запись changesStack агрегата заместилась косвенной синхронизацией ответа симуляции и исчезла при no-op):
                // возврат агрегата к исходному итогу (60→0→60) — no-op, Save гаснет. Выключатель fe.sim.revertLeaves
                if (rowStack.method === 'aggEdit' && rowStack.user && this.sim_flag('revertLeaves')) {
                    for (let i = this.undoStack.length - 2; i >= 0; i--) {
                        const a = this.undoStack[i]
                        if (a && a.method === 'aggEdit' && a.user && a.$item === rowStack.$item && a.col_binding === rowStack.col_binding) {
                            rowStack.val0 = a.val0 !== undefined ? a.val0 : a.val
                            break
                        }
                    }
                }
                // IE 2026 08 27 (Igor): универсально для гридов, списков и формы записи — прямая правка, вернувшая
                // ячейку к ИСХОДНОМУ значению (первой правки цепочки), снимает пометку сразу: метка _cells
                // возвращается к снимку до первой правки, запись changesStack удаляется, а если правленых ячеек
                // не осталось — снимаются флаги modified строки, записи и виджета (Save гаснет). Undo-история не
                // трогается. Флаг fastEntry.saveSkipNoop (дефолт ВКЛ)
                let _noop = false
                if (rowStack.method === 'val' && !rowStack.indirect && !rowStack.related
                        && this.store.fastEntry?.saveSkipNoop !== false) {
                    const _prev = this.changesStack[_key]
                    // IE 2026 08 27 (критика Игоря, M03: «5 → 13,9% → 5 не остаётся»): исходное значение цепочки
                    // наследуем только от ПРЯМОЙ правки пользователя. Если ячейку успел пересчитать производный
                    // код (indirect/related/pyDerived), база для no-op — то, что пользователь видел перед вводом
                    // (rowStack.val), а не устаревшее сохранённое значение: ввод, равный старому сохранённому,
                    // должен остаться ручной правкой со штампом, иначе пересчёт снова его затирает
                    const _prevUser = _prev && _prev !== rowStack && _prev.method === 'val' && !_prev.indirect && !_prev.related
                    if (_prevUser) {
                        rowStack.val0 = _prev.val0 !== undefined ? _prev.val0 : _prev.val
                        rowStack.cells0 = _prev.cells0 !== undefined ? _prev.cells0 : (_prev.cellsBefore ?? null)
                    } else {
                        rowStack.val0 = rowStack.val
                        rowStack.cells0 = rowStack.cellsBefore ?? null
                    }
                    _noop = this._valSame(rowStack.val0, rowStack.newVal)
                }
                if (_noop) {
                    delete this.changesStack[_key]
                    rowStack._noop = true   // снятие пометки — в конце set_value, ПОСЛЕ штампа _cells (см. noop_unmark)
                } else if ((rowStack.indirect || rowStack.related) && this.chgNet_isZero(rowStack)) {
                    delete this.changesStack[_key]
                } else {
                    this.changesStack[_key] = rowStack
                }
            }
            // keepRedo — очистка корректировок после отката правок сессии: откаченные
            // правки остаются в redo (Ctrl+Y вернёт их после Ctrl+Z очистки)
            // IE 2026 09 25 / ODOO-5800: _simKeepRedo — записи ответа симуляции на откат / повтор (sim_applyChanges, fe.sim.undoGroup)
            if (!rowStack.keepRedo && !this._simKeepRedo) this.redoStack.length = 0
            if (!startStack_length) {
                this.set_commandPanel()
            }
            this.corrChip_schedule() // IE 2026 08 19 / ODOO-5512: чипс корректировок
        },
        // ---- IE 2026 08 19 / ODOO-5512 (заказ Игоря): чипс «Corrections» над таблицей —
        // кэш undo/redo на виду: бейдж с числом правленных ячеек, ←/→ переход между
        // ними, ⊗ — откат всех несохранённых корректировок (они остаются в redo) ----
        corrChip_schedule() {
            if (this._corrChipTimer) return
            this._corrChipTimer = setTimeout(() => {
                this._corrChipTimer = null
                const _t = this._gridPerfCur ? performance.now() : 0 // IE 2026 09 04 / ODOO-336379: замер чипа корректировок
                this.corrChip_update()
                if (_t) this.gridPerf_touch('corrchip', performance.now() - _t)
            }, 80)
        },
        corrChip_cells() {
            // правленные РУКОЙ ячейки (без связанных/косвенных), уникально, в порядке правок
            const out = []
            for (const a of this.undoStack) {
                if (!a || a.col_binding == null || !a.$item) continue
                const user = (a.method === 'val' && !a.indirect && !a.related) || (a.method === 'aggEdit' && a.user)
                if (!user) continue
                // уникальность — по ссылке на строку + привязке
                const found = out.find(x => x.item === a.$item && x.binding === a.col_binding)
                if (found) { found.entries.push(a); continue }
                out.push({ item: a.$item, binding: a.col_binding, entries: [a] })
            }
            // IE 2026 08 27 (Igor): ячейка, вернувшаяся к исходному значению, — не правка
            return out.filter(g => !this._valSame(g.entries[0].val0 !== undefined ? g.entries[0].val0 : g.entries[0].val, g.entries[g.entries.length - 1].newVal))
        },
        corrChip_update() {
            const W = this.WIDGET
            if (!W || this.attr?.attr_type === 'AttrTabGrid' || this.attr?.isPrintTemplate) return
            // только основная таблица отчёта/списка
            if (!(this.attr?.name === 'dataSheet' || this.attr?.binding === '_doc.data' || this.gridEditMode_applies)) return   // IE 2026 10 14 / ODOO-5800: и у динамического списка в режиме редактирования
            const list = (W._dd_info_chips = Array.isArray(W._dd_info_chips) ? W._dd_info_chips : [])
            const _chipKey = this.attr?.binding || ''   // IE 2026 10 14 / ODOO-5800: чипс per-binding — у записи несколько гридов на вкладках (AttrChips показывает чипс только на своём гриде)
            const old = list.find(c => c && c._corr && (c._binding || '') === _chipKey)   // IE 2026 10 14 / ODOO-5800
            const cells = this.corrChip_cells()
            if (!cells.length) {
                if (old) list.splice(list.indexOf(old), 1)
                this._corrNavIdx = -1
                return
            }
            const flex = this.flex
            const fmt = (v) => (v === null || v === undefined || v === '' || (typeof v === 'number' && Number.isNaN(v))) ? '—' : (typeof v === 'number' ? this.store.formatCount(v) : String(v))
            const rows = []
            for (const c of cells.slice(0, 40)) {
                const irow = this.rows_indexOf(c.item)
                let rt = ''
                if (flex && irow >= 0) for (let ci = 0; ci < Math.min(6, flex.columns.length) && !rt; ci++) { const el = flex.cells.getCellElement(irow, ci); rt = el ? String(el.textContent || '').replace(/\s+/g, ' ').trim() : '' }
                const attr_col = this.attr_by_binding?.[c.binding]
                const m = /^(\d{4}-\d{2}-\d{2})/.exec(String(c.binding))
                const ct = m ? m[1] : (attr_col?.title || c.binding)
                const first = c.entries[0], last = c.entries[c.entries.length - 1]
                rows.push([`${rt || t('row {n}', { n: irow + 1 })} · ${ct}`, `${fmt(first.val)} → ${fmt(last.newVal)}`])   // IE 2026 09 23 / ODOO-341407: i18n
            }
            const vueObj = this
            const chip = old || { _corr: true, _binding: _chipKey, pi: 'pi-pencil', cssClass: 'chip-unsaved-edits chip-corrections' }   // IE 2026 10 14 / ODOO-5800: _binding
            chip.title = t('Corrections')   // IE 2026 09 23 / ODOO-341407: i18n
            chip.count = cells.length
            chip.tooltip = [[t('Unsaved corrections'), String(cells.length)], ...rows]
            chip.nav = cells.length > 1
            chip.onNav = (dir) => vueObj.corrChip_nav(dir)
            chip.onClear = () => vueObj.corrChip_clear()
            if (!old) list.push(chip)
            if (this._corrNavIdx >= cells.length) this._corrNavIdx = cells.length - 1
        },
        // IE 2026 08 23 / ODOO-5884 (заказ Игоря): переход ←/→ по строкам с Δ-подстроками сравнения
        // с предыдущей процессной моделью (чипс «Δ vs …», бейдж = _compare_info.rows_dev)
        compareNav_targets() {
            // IE 2026 10 05 / ODOO-5800 (fe-87): обход вынесен в utils/compareRows.compareNav_targetsOf. Прежний признак «у ребёнка есть row_type» считал остановкой корень
            // блока с полосами раскладки (row_type 'tabrow') и группу с итогом 'Total'; с правкой бэка «Differences only» неизменённые строки остаются в данных
            // спрятанными (_DLRow.hide) — спрятанная строка остановкой не бывает. Остановка — строка с под-строками сравнения либо со своими cmp_cells
            // (IE 2026 08 24 / ODOO-5884: режим «Mark changes»). Выключатель fe.ux.compareServiceRows (false — прежний обход)
            return compareNav_targetsOf(this.data, 'attrs', this.store.setting('fe.ux.compareServiceRows', true) !== false)   // IE 2026 10 05 / ODOO-5800 (fe-87)
        },
        compareNav(dir) {
            const targets = this.compareNav_targets()
            if (!targets.length || !this.flex) return
            let i = (this._cmpNavIdx ?? -1) + (dir >= 0 ? 1 : -1)
            if (i >= targets.length) i = 0
            if (i < 0) i = targets.length - 1
            this._cmpNavIdx = i
            const irow = this.rows_indexOf(targets[i])
            if (irow < 0) return
            try {
                const icol = Math.max(0, this.flex.selection?.col ?? 0)
                this.flex.select(irow, icol)
                this.flex.scrollIntoView(irow, icol)
            } catch (e) { /* строка вне текущего набора */ }
        },
        corrChip_nav(dir) {
            const cells = this.corrChip_cells()
            if (!cells.length || !this.flex) return
            const n = cells.length
            let i = (this._corrNavIdx ?? -1) + (dir >= 0 ? 1 : -1)
            if (i >= n) i = 0
            if (i < 0) i = n - 1
            this._corrNavIdx = i
            const c = cells[i]
            const irow = this.rows_indexOf(c.item)
            let icol = -1
            for (let k = 0; k < this.flex.columns.length; k++) if (this.flex.columns[k].binding === c.binding) { icol = k; break }
            if (irow < 0 || icol < 0) return
            try {
                this.flex.select(irow, icol)
                this.flex.scrollIntoView(irow, icol)
            } catch (e) { /* ячейка вне текущего набора строк */ }
        },
        corrChip_clear() {
            // все несохранённые корректировки — откат (группы остаются в redo)
            let n = 0
            while (this.undoStack.length && n++ < 1000) { if (this.changeStack(this.undoStack, this.redoStack, 'val') === false) { n--; break } }   // IE 2026 10 09 / ODOO-345618: закрытая согласованием строка — стоп (отказ уже показан)
            if (!n && this.undoStack.length) { this.corrChip_update(); return }   // IE 2026 10 09 / ODOO-345618: ничего не откачено — «All reverted» не пишем
            this.store.show_notification({ text: tn(n, 'All unsaved corrections reverted ({n} action; Ctrl+Y to redo)', 'All unsaved corrections reverted ({n} actions; Ctrl+Y to redo)'), status: 'info' })   // IE 2026 09 23 / ODOO-341407: i18n
            this.corrChip_update()
        },
        changeStack(fromStack, toStack, nameVal='val') {
            this._esDataVer = (this._esDataVer || 0) + 1   // IE 2026 10 29 / ODOO-5800 (webscm #114418: долгая задача 0,86 с после Shift+F3 — скан пустых колонок соседнего грида): undo / redo
            // IE 2026 10 09 / ODOO-345618 (заказ Игоря: согласование на сегменте): Undo / Redo / откат всех правок идут мимо is_editable — группа, затрагивающая закрытую
            // согласованием строку, не применяется (false — вызывающие циклы останавливаются); без данных согласования у строк ничего не меняется
            if (this.approval_stackBlocked(fromStack)) return false
            this._editKeep = null   // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — FL3: undo / redo — перерисовки полные
            if (fromStack.length) {
                // подавить запись «правок» синхронизации карточки строки во время undo/redo
                this._undoApplying = true
                try {
                this.changeStack_(fromStack, toStack, nameVal)
                } finally {
                    // рефреши доделываются асинхронно — держим флаг чуть дольше
                    window.$cg.setTimeout(this, 'AttrGrid.undoApplying', () => { this._undoApplying = false }, 400)
                }
            }
        },
        changeStack_(fromStack, toStack, nameVal='val') {
            // IE 2026 10 14 / ODOO-5800 (app7 #84472, ev33 на 20 тыс. строк: Ctrl+Z 4,8 с): группа только из правок ячеек — точечный путь (undoKeep_take): кэш итогов сбрасывают
            // только предки (approvalPartial_afterEdit в set_value), без deferUpdate (endUpdate → invalidate — полный проход) и без flexRefresh — строки правки с предками и
            // потомками перерисовывает undoKeep_refresh. Выключатель fe.ux.undoKeepRefresh
            const _keep = this.undoKeep_take(fromStack)
            this._undoKeep = _keep
            if (!_keep) this._apprPartialCache = null   // IE 2026 10 14 / ODOO-5800 (Igor): живой итог флага — Undo / Redo
            // IE 2026 08 18 (заказ Игоря п.5): отмена/повтор — тоже действие,
            // свежесть предыдущего снимаем, свою пачку соберём в changeStack__
            this.flash_end()
            this._undoTouched = []
            // IE 2026 08 15 / ODOO-4997: undo/redo — ОДНИМ батчем. Флаг
            // _undoBatch гасит по-ячеечные refreshCells()+attr_set() внутри
            // set_value (54 с → мс на месячной декомпозиции), deferUpdate —
            // одна перерисовка wijmo; в конце: один attr_set + сброс кэшей
            // агрегатов свёрнутых групп и полос (значения строк изменились)
            this._undoBatch = true
            try {
                const run = () => this.changeStack__(fromStack, toStack, nameVal)
                if (!_keep && this.flex?.deferUpdate) this.flex.deferUpdate(run)   // IE 2026 10 14 / ODOO-5800: точечный путь — без deferUpdate
                else run()
            } finally {
                this._undoBatch = false
            }
            this.attr_set()
            this._foldAggCache = null
            this._rowStyleStats = null
            this.cf_cache?.clear()
            // IE 2026 08 19 / ODOO-5512: после отката/повтора — пересчёт пользовательского
            // кода по затронутым строкам (без регистрации связанных: их вернул сам откат)
            if (this._undoPyRows?.size) {
                for (const item of this._undoPyRows.keys()) this.pyRecalc_queue(item, null)
                this._undoPyRows = null
            }
            // IE 2026 08 19 / ODOO-5512: симуляция на бэке — обратные/прямые дельты
            // правок пользователя из откаченной/повторённой группы (только очередь,
            // без локального превью: ячейки уже вернул сам откат)
            this.corrChip_schedule() // IE 2026 08 19: чипс корректировок
            if (this._undoSimEdits?.length) {
                const list = this._undoSimEdits; this._undoSimEdits = null
                this._simQueueFromUndo = true   // IE 2026 09 25 / ODOO-5800: ответ на эти правки — в группу вершины стека (sim_applyChanges, fe.sim.undoGroup)
                try {
                    for (const u of list) {
                        try { this.balancePreview_afterEdit(u.it, [u.b], u.from, u.to, { queueOnly: true }) } catch (e) { /* вне симуляции */ }
                    }
                } finally {
                    this._simQueueFromUndo = false
                }
            }
            if (_keep) { this._undoKeep = null; this.undoKeep_refresh(_keep) }   // IE 2026 10 14 / ODOO-5800: после сброса кэшей агрегатов — точечная перерисовка
            else this.flexRefresh()
        },
        // IE 2026 10 14 / ODOO-5800: undo / redo группы правок ячеек идёт точечно, если: выключатель fe.ux.undoKeepRefresh не снят; грид на месте и не в обновлении; верхняя группа стека — только
        // правки ячеек со строкой по ссылке (utils/gridEditKeep.undoKeep_group); нет полос строк (aggregateFront пересчитывает много строк); точечный проход вообще
        // допустим (editKeep_block: печать, process_dataItem, группировки wijmo, нестрочный py-CSS — полный). Возврат {entries} либо null. Счётчик window.__gridUndoKeep {keep, full, why}
        undoKeep_take(fromStack) {
            const st = (window.__gridUndoKeep = window.__gridUndoKeep || { keep: 0, full: 0, why: {} })
            const no = (why) => { st.full++; st.why[why] = (st.why[why] || 0) + 1; return null }
            try {
                if (!undoKeep_flagOn((k, d) => this.store.setting(k, d))) return no('off')
                const flex = this.flex
                if (!flex || !flex.hostElement || flex.isUpdating || flex.activeEditor) return no('grid')
                const entries = undoKeep_group(fromStack)
                if (!entries) return no('group')
                if (this.rowLevelGroup_ranges_length) return no('rowLevelGroup')
                const why = this.editKeep_block()
                if (why) return no(why)
                st.keep++
                return { entries, touched: null }
            } catch (e) { return no('error') }
        },
        // перерисовка после точечного undo / redo: строки правки, их предки и потомки (editKeep_scope — как при вводе, с наследуемыми колонками правил) прямым updateCell
        // отрисованных ячеек (editRefresh_cells); не вышло (строки не найдены / клон замороженных не сошёлся) — прежний полный flexRefresh
        undoKeep_refresh(keep) {
            try {
                const flex = this.flex
                const rows = new Set()
                for (const t of keep.touched || []) {
                    const irow = t.item ? this.rows_indexOf(t.item) : t.irow
                    if (irow == null || irow < 0 || !flex.rows[irow]) continue
                    let icol = -1
                    try { icol = flex.columns.getColumn(t.binding)?.index ?? -1 } catch (e) { icol = -1 }
                    for (const r of this.editKeep_scope(irow, icol)) rows.add(r)
                }
                if (!rows.size) { this.flexRefresh(); return false }
                if (!this.editRefresh_cells([...rows])) { this.flexRefresh(); return false }
                return true
            } catch (e) { this.flexRefresh(); return false }
        },
        changeStack__(fromStack, toStack, nameVal='val') {
            {
                let actionStack = fromStack[fromStack.length-1].actionStack,
                    structural = false,
                    collapsedToRestore = null
                while (fromStack.length && actionStack === fromStack[fromStack.length-1].actionStack) {
                    let a = fromStack.pop()

                    // структурные действия и групповые правки свойств —
                    // отдельные ветки (см. hist_push): строки резолвим по
                    // ССЫЛКЕ на dataItem, а не по индексу (индексы плывут
                    // после вставки/удаления/сортировки/фильтра)
                    if (a.method === 'rows') {
                        this.hist_undoRows(a, nameVal)
                        structural = true
                        if (a.collapsed) collapsedToRestore = a.collapsed
                        toStack.push(a)
                        continue
                    } else if (a.method === 'props') {
                        if (a.collapsed) collapsedToRestore = a.collapsed
                        for (const c of a.cells) {
                            this.store.set_value(c.item, c.path, nameVal === 'val' ? c.oldValue : c.newValue)
                            this.setModified(c.item)
                        }
                        if (typeof a.afterApply === 'function') a.afterApply(nameVal)   // IE 2026 10 15 / ODOO-5512 (chip undo): the entry re-commits what lives outside the row objects (AttrTags row → record)
                        // чипсы полей: пересчёт счётчиков ячейки-владельца
                        for (const cw of a.cellOwners || []) {
                            this.useCount_cellApply(cw.item, cw.attr_col)
                        }
                        structural = true
                        toStack.push(a)
                        continue
                    }

                    // ячейка: строка по ссылке (fallback — сохранённый индекс)
                    let dataItem = a.$item || this.flex.rows[a.irow]?.dataItem
                    if (!dataItem) { toStack.push(a); continue }
                    let irow = a.$item ? this.rows_indexOf(a.$item) : a.irow
                    if (irow < 0) irow = a.irow
                    // IE 2026 08 18 / ODOO-5512: датные привязки вложенные ('2027-02-01.quantity')
                    // — dataItem[binding] давал undefined, и откат правки ПУСТОЙ ячейки
                    // (val=undefined) глох на «oldVal == newVal» в set_value: Ctrl+Z
                    // не убирал введённое значение
                    let oldVal = this.store.get_value(dataItem, a.col_binding)

                    const raw_binding = a.col_binding.replace('data::', '')
                    dataItem._cells = dataItem._cells || {}
                    const _cells = this.store.get_value(dataItem, `_cells.${raw_binding}`) || {}
                    this.store.set_value(dataItem, `_cells.${raw_binding}`, _cells)

                    if (a.method === 'val') {
                        this.set_value(irow, dataItem, a.col_binding, oldVal, a[nameVal], false, null, a.indirect)
                        // IE 2026 08 19 / ODOO-5512: леджер симуляции — вместе со значением
                        if (a.simLedger) this.sim_ledgerAdd(dataItem, a.col_binding, nameVal === 'val' ? -a.simLedger : a.simLedger, false)
                        // правка пользователя (не связанная/косвенная) — бэк-симуляции
                        // нужна обратная (undo) / прямая (redo) дельта, иначе его сессия
                        // транзакций расходится с экраном
                        if (!a.indirect && !a.related) (this._undoSimEdits = this._undoSimEdits || []).push({ it: dataItem, b: a.col_binding, from: nameVal === 'val' ? a.newVal : a.val, to: nameVal === 'val' ? a.val : a.newVal })
                        // IE 2026 08 19 / ODOO-5512 (заказ Игоря): откат правки возвращает и
                        // ПРИЗНАК ручной корректировки (_cells value/isNull/updated_*) к
                        // состоянию до правки — иначе после Ctrl+Z ячейка оставалась «правленой»
                        if ('cellsBefore' in a) {
                            const _snap = nameVal === 'val' ? a.cellsBefore : a.cellsAfter
                            dataItem._cells = dataItem._cells || {}
                            if (_snap && typeof _snap === 'object') dataItem._cells[raw_binding] = this.store.deepCopy(_snap)
                            else delete dataItem._cells[raw_binding]
                        }
                        if (!a.indirect && this.attr_by_binding?.[a.col_binding]?.no_process_dataItem !== true) (this._undoPyRows = this._undoPyRows || new Map()).set(dataItem, a.col_binding)   // IE 2026 10 14 / ODOO-5800: колонка без python-пересчёта (как в set_value) — не в очередь (app7 #84472: третий полный проход из pyRecalc_batch)
                    } else if (a.method === 'aggEdit') {
                        // маркер правки агрегатной ячейки: данные восстанавливают
                        // детальные/косвенные строки группы, здесь только подсветка
                        // IE 2026 08 19: агрегатная правка пользователя — обратная дельта в симуляцию
                        this._undoSimEdits = this._undoSimEdits || []
                        // IE 2026 09 25 / ODOO-5800 (Ctrl+Z после 60→0 в агрегате PO, 1fxa_001: экран к базе, а обратная дельта уходила с
                        // АГРЕГАТНОЙ строкой — без субъекта, balancePreview_afterEdit брал субъект первого листа остатка блока, 98795ad4 Vilniaus
                        // вместо d58e88f0 BW, и сессия превью на бэке расходилась с экраном): откат / повтор шлёт дельты тех же ЛИСТЬЕВ раскладки,
                        // что ушли при вводе (decomp_cellEdit → simLeaves), — контекст правки строится как при вводе: субъект листа, measure_type /
                        // alert (fe.sim.editContext), мера. Выключатель fe.sim.undoContext (false — прежняя дельта агрегатной строки)
                        if (Array.isArray(a.simLeaves) && this.sim_flag('undoContext')) {
                            for (const w of a.simLeaves) this._undoSimEdits.push({ it: w.it, b: w.b, from: nameVal === 'val' ? w.to : w.from, to: nameVal === 'val' ? w.from : w.to })
                        } else {
                            this._undoSimEdits.push({ it: dataItem, b: a.col_binding, from: nameVal === 'val' ? a.newVal : a.val, to: nameVal === 'val' ? a.val : a.newVal })
                        }
                    } else if (a.method === 'color') {
                        _cells.color = nameVal === 'val' ? a.color : a.newColor
                    } else if (a.method === 'backgroundColor') {
                        _cells.backgroundColor = nameVal === 'val' ? a.backgroundColor : a.newBackgroundColor
                    } else if (a.method === 'comment') {
                        _cells.comment = nameVal === 'val' ? a.comment : a.newComment
                    } else if (a.method === 'cells') {
                        // IE 2026 08 18: очистка ручных корректировок (onClearCells) —
                        // undo возвращает снимок _cells ячейки целиком, redo снова снимает
                        const snap = nameVal === 'val' ? a.val : a.newVal
                        // IE 2026 08 18 / ODOO-5512: ключ _cells — как записан (у
                        // onClearAllCells бывают legacy-ключи с префиксом data::)
                        const cellsKey = a.cellsKey || raw_binding
                        if (snap && typeof snap === 'object') {
                            dataItem._cells[cellsKey] = this.store.deepCopy(snap)
                        } else {
                            const c0 = dataItem._cells[cellsKey]
                            if (c0) { for (const k of ['value', 'isNull', 'updated_at', 'updated_by', 'value_before']) delete c0[k]; if (!Object.keys(c0).length) delete dataItem._cells[cellsKey] }
                        }
                        this.setModified(dataItem)
                        ;(this._undoPyRows = this._undoPyRows || new Map()).set(dataItem, a.col_binding)
                    }

                    // IE 2026 08 19: пустой словарь _cells.<колонка> после отката — убрать
                    // (иначе каждый undo плодил {} по всем связанным колонкам)
                    if (dataItem._cells && dataItem._cells[raw_binding] && typeof dataItem._cells[raw_binding] === 'object'
                            && !Object.keys(dataItem._cells[raw_binding]).length) {
                        delete dataItem._cells[raw_binding]
                    }

                    if (a.col_binding != null) {
                        // IE 2026 08 18: затронутые ячейки — для вспышки после
                        // применения (строки резолвим по ССЫЛКЕ, индексы плывут)
                        (this._undoTouched = this._undoTouched || []).push(
                            { item: a.$item, irow: a.irow, binding: a.col_binding })
                    }
                    toStack.push(a)
                }
                if (this.rowLevelGroup_ranges_length) {
                    this.aggregateFront()
                }
                if (structural) {
                    // как после самой операции: перестройка грида + write-back
                    // канона (иерархия/печать) + пересчёт зависимостей
                    this.refresh()
                    this.attr_set()
                    if (this.WIDGET.widget === 'widget-selectors') {
                        this.store.sync_WORKSPACE(this.WIDGET, '>>WORKSPACE')
                    }
                    this.run_attr_action_afterChange()
                    // подсветка изменённых ячеек и свёрнутость дерева — после
                    // пересборки строк (восстановленные строки создаются заново)
                    this.$nextTick(() => this.$nextTick(() => {
                        this.initialized_stackСhanges()
                        if (collapsedToRestore) this.hist_restoreCollapsed(collapsedToRestore)
                    }))
                } else {
                    this.initialized_stackСhanges()
                }
                // IE 2026 08 18 (заказ Игоря п.5): вспышка по ячейкам, которые
                // отмена/повтор только что изменили — включая агрегатную
                if (this._undoTouched && this._undoTouched.length) {
                    const touched = this._undoTouched
                    this._undoTouched = null
                    if (this._undoKeep) this._undoKeep.touched = touched.slice()   // IE 2026 10 14 / ODOO-5800: строки точечной перерисовки (undoKeep_refresh)
                    this.flash_start(touched)
                }
                if (!this._undoKeep) this.flexRefresh()   // IE 2026 10 14 / ODOO-5800: точечный путь перерисовывает сам (changeStack_)
                this.useCount_apply() // undo/redo мимо attr_set (в т.ч. возврат use)
            }
        },
        // ---- Undo/Redo: структурные действия (вставка/удаление/перемещение/
        // иерархия строк), групповые правки свойств и выпадающая история ----
        hist_push(entry) {
            // одно ДЕЙСТВИЕ пользователя = одна группа в стеке
            entry.actionStack = this.actionStack
            if ((entry.method === 'rows' || entry.method === 'props') && !entry.collapsed) {
                // свёрнутость дерева на момент действия (снимок мог быть снят ДО
                // операции — hist_snapshotSelection): undo возвращает строки
                // в том же виде, в каком они были свёрнуты
                entry.collapsed = this._histCollapsed || this.hist_collapsedSnapshot()
            }
            this._histCollapsed = null
            this.pushStack(entry)
            this.actionStack++
            this.modified = !!this.undoStack.length
            this.gridSave_schedule()   // IE 2026 10 13 / ODOO-5800: строки добавлены / перенесены / удалены — полоса Save ленивого грида
        },
        hist_collapsedSnapshot() {
            // ВСЕ свёрнутые узлы дерева (в т.ч. вложенные в свёрнутые — они
            // остаются в flex.rows невидимыми), по ссылке на dataItem
            if (!this.attr.childItemsPath || !this.flex?.rows) return null
            const set = new Set()
            for (const row of this.flex.rows) {
                if (row?.hasChildren && row.isCollapsed && row.dataItem) set.add(row.dataItem)
            }
            return set
        },
        hist_restoreCollapsed(set) {
            if (!set || !this.attr.childItemsPath || !this.flex?.rows) return
            this.flex.deferUpdate(() => {
                for (const row of this.flex.rows) {
                    if (!row?.hasChildren || !row.dataItem) continue
                    const want = set.has(row.dataItem)
                    if (row.isCollapsed !== want) {
                        try { row.isCollapsed = want } catch (e) { /* не tree-строка */ }
                    }
                }
            })
        },
        hist_locate(item, items=null) {
            // положение элемента в дереве данных: {arr, index}
            if (items === null) {
                // IE 2026 09 26 / ODOO-… (дефект: undo после Alt+drag в подчинённые): строка ищется по ссылке, как пришла,
                // а не нашлась — по СЫРОМУ объекту. Записи стека отмены читаются из реактивного undoStack (p.item — прокси Vue), а данные грида
                // бывают сырыми (массив записи под markRaw): indexOf(прокси) по сырому массиву = −1 — undo не изымал строку с места переноса
                // и вставлял её ещё и на прежнее место (дубль). Выключатель fe.ux.histLocateRaw
                const root = this.data000
                if (!Array.isArray(root)) return null
                const loc = this.hist_locate(item, root)
                if (loc || !item || typeof item !== 'object' || this.store.setting('fe.ux.histLocateRaw', true) === false) return loc
                const raw = toRaw(item)
                return raw !== item ? this.hist_locate(raw, root) : null
            }
            if (!Array.isArray(items)) return null
            const index = items.indexOf(item)
            if (index >= 0) return { arr: items, index }
            if (this.attr.childItemsPath) {
                for (const it of items) {
                    const sub = it?.[this.attr.childItemsPath]
                    if (sub?.length) {
                        const found = this.hist_locate(item, sub)
                        if (found) return found
                    }
                }
            }
            return null
        },
        hist_positionsOf(items) {
            const out = []
            for (const item of items || []) {
                const loc = this.hist_locate(item)
                if (loc) out.push({ item, arr: loc.arr, index: loc.index })
            }
            return out
        },
        hist_contains(root, target) {
            // target — потомок root по childItemsPath?
            const child = this.attr.childItemsPath
            if (!child) return false
            for (const it of root?.[child] || []) {
                if (it === target || this.hist_contains(it, target)) return true
            }
            return false
        },
        hist_snapshotSelection() {
            // позиции строк, которые заберёт cut_selectedRanges (видимые строки
            // первого диапазона выделения) — снимок ДО операции
            this._histCollapsed = this.hist_collapsedSnapshot() // свёрнутость ДО удаления/переноса
            let items = []
            const rng = this.flex.selectedRanges[0]
            if (!rng) return items
            for (let irow = rng.topRow; 0 <= irow && irow <= rng.bottomRow; irow++) {
                const row = this.flex.rows[irow]
                if (!row?.dataItem) continue
                if (row.visible === false || row.dataItem?._fe?.visible === false) continue
                items.push(row.dataItem)
            }
            // вложенные в другой выделенный элемент не снимаем: они путешествуют
            // ВНУТРИ родителя (cut режет только верхние), иначе restore их дублирует
            items = items.filter(it => !items.some(other => other !== it && this.hist_contains(other, it)))
            return this.hist_positionsOf(items)
        },
        hist_applyRows(list) {
            // вернуть строки на записанные позиции: сначала изъять по ссылке,
            // затем вставить по возрастанию индекса (не сдвигая соседей)
            for (const p of list) {
                const loc = this.hist_locate(p.item)
                if (loc) loc.arr.splice(loc.index, 1)
            }
            for (const p of [...list].sort((x, y) => x.index - y.index)) {
                p.arr.splice(Math.min(p.index, p.arr.length), 0, p.item)
            }
        },
        hist_removeRows(list) {
            for (const p of list) {
                const loc = this.hist_locate(p.item)
                if (loc) loc.arr.splice(loc.index, 1)
            }
        },
        hist_undoRows(a, nameVal) {
            // a.from — позиции ДО действия, a.to — ПОСЛЕ (null = строк не было)
            const target = nameVal === 'val' ? a.from : a.to
            const items = (a.from || a.to || []).map(p => p.item)
            if (target) {
                this.hist_applyRows(target)
            } else {
                this.hist_removeRows(nameVal === 'val' ? a.to : a.from)
            }
            // удаление/архивация: флаги и реестр deletedItems симметрично
            if (a.kind === 'delete' || a.kind === 'archive') {
                const undoDelete = nameVal === 'val'
                for (const p of a.from || []) {
                    const rec = p.item
                    if (!rec.id) continue
                    if (a.archived) {
                        rec.meta = rec.meta || {}
                        rec.meta.archived = !rec.meta.archived
                    } else if (undoDelete) {
                        if (rec._meta) delete rec._meta.delete
                    } else {
                        rec._meta = rec._meta || {}
                        rec._meta.delete = true
                    }
                }
                if (undoDelete) {
                    const set = new Set(items)
                    this.deletedItems = this.deletedItems.filter(x => !set.has(x))
                } else {
                    this.deletedItems = [...this.deletedItems, ...items]
                }
            }
        },
        history_valText(v) {
            if (v === null || v === undefined || v === '') return '(empty)'
            let s = String(v)
            if (s.length > 18) s = s.slice(0, 17) + '…'
            return `"${s}"`
        },
        history_labelOf(group) {
            // user-friendly подпись группы действий (одно действие пользователя)
            const a = group[0]
            if (a.label) return a.label
            const colTitle = (b) => {
                const attr_col = this.attr_by_binding?.[b] || this.attr_by_binding?.['data::' + b]
                return attr_col?.title || b || ''
            }
            // IE 2026 09 23 / ODOO-341407: i18n (подписи истории Undo/Redo)
            if (a.method === 'comment') return t('Comment on "{column}"', { column: colTitle(a.col_binding) })
            // IE 2026 08 19 / ODOO-5512 (заказ Игоря): очистка ручных корректировок —
            // своё событие истории (ячейки + связанные пересчёты py-кода той же группы)
            if (group.some(x => x.method === 'cells')) {
                const n = group.filter(x => x.method === 'cells').length
                const related = group.length - n
                return tn(n, 'Clear manual corrections: {n} cell', 'Clear manual corrections: {n} cells') + (related ? ' ' + t('(+{n} related)', { n: related }) : '')
            }
            if (a.method === 'val' || a.method === 'aggEdit') {
                if (group.length === 1) {
                    return t('Edit "{column}": {from} → {to}', { column: colTitle(a.col_binding), from: this.history_valText(a.val), to: this.history_valText(a.newVal) })
                }
                // IE 2026 08 15 / ODOO-4997 (заказ Игоря): одна пользовательская
                // правка + связанные корректировки (декомпозиция, итоги предков,
                // сим-каскад) — ОДНО событие с понятной подписью
                const users = group.filter(x => x.user || (!x.indirect && !x.related && x.method === 'val'))
                const related = group.length - users.length
                if (users.length === 1) {
                    const u = users[0]
                    return t('Edit "{column}": {from} → {to}', { column: colTitle(u.col_binding), from: this.history_valText(u.val), to: this.history_valText(u.newVal) })
                        + (related ? ' ' + t('(+{n} related)', { n: related }) : '')
                }
                const base = a.pastedVal != null ? tn(users.length || group.length, 'Paste {n} cell', 'Paste {n} cells')
                    : tn(users.length || group.length, 'Edit {n} cell', 'Edit {n} cells')
                return base + (related && users.length ? ' ' + t('(+{n} related)', { n: related }) : '')
            }
            if (a.method === 'color' || a.method === 'backgroundColor') return t('Format cells')
            return t('Change ({n})', { n: group.length })
        },
        history_groups(stack) {
            // группы стека (top-first), максимум 15 — для выпадающего списка
            const groups = []
            for (let i = stack.length - 1; i >= 0 && groups.length < 15; i--) {
                const g = [stack[i]]
                while (i > 0 && stack[i-1].actionStack === stack[i].actionStack) { g.push(stack[--i]) }
                groups.push({ actionStack: g[0].actionStack, label: this.history_labelOf(g), count: g.length })
            }
            return groups
        },
        undoHistory_Click(action) { this.historyOpen('undo') },
        redoHistory_Click(action) { this.historyOpen('redo') },
        historyOpen(mode) {
            if (this.historyMenu.show && this.historyMenu.mode === mode) {
                this.historyMenu.show = false
                return
            }
            const stack = mode === 'undo' ? this.undoStack : this.redoStack
            const items = this.history_groups(stack)
            if (!items.length) {
                this.store.show_notification({ text: mode === 'undo' ? this.t('Nothing to undo') : this.t('Nothing to redo'), status: 'info' })   // IE 2026 09 23 / ODOO-341407: i18n (this.t: ниже в функции объявлена const t)
                return
            }
            // позиция — под кнопкой-стрелкой (клик синхронный: window.event ещё жив)
            let style = {}
            const ev = window.event
            const t = ev?.target ? (ev.target.closest?.('.p-button') || ev.target) : null
            if (t?.getBoundingClientRect) {
                const r = t.getBoundingClientRect()
                style = { position: 'fixed', left: Math.round(r.left) + 'px', top: Math.round(r.bottom + 2) + 'px' }
            } else {
                const host = this.$refs.commandPanelMenu
                const r = host?.getBoundingClientRect?.()
                style = r ? { position: 'fixed', left: Math.round(r.left) + 'px', top: Math.round(r.bottom + 2) + 'px' } : {}
            }
            this.historyMenu = { show: true, mode, items, hover: -1, style }
        },
        historyApply(i) {
            const mode = this.historyMenu.mode
            this.historyMenu.show = false
            for (let k = 0; k <= i; k++) {
                if (mode === 'undo') this.undo_Click()
                else this.redo_Click()
            }
        },
        execute_click(e) {
            // IE 2026 09 04 / ODOO-336331: грид снят/пересоздан (хост не в DOM) — hitTest бросит TypeError на getBoundingClientRect(null)
            if (!this.flex || !this.flex.hostElement || !this.flex.hostElement.isConnected) return
            let ht = null
            try { ht = this.flex.hitTest(e) } catch (err) { return }
            let row, col, e_cell, data_cell;
            if (ht && ht.panel) { //  && ht.cellType === wjGrid.CellType.Cell
                // e.target.dataset <<< can be used
                row = ht.row;
                col = ht.col;
                
                const {key, _cache} = this.get_cache(ht)
                e_cell = this.divCells.get(key)
                if (!e_cell) {
                    // merged cells: hitTest returns the physical col under the cursor,
                    // but the cell (and its data_cell) is stored under the merge anchor
                    // col — fall back to the actual clicked DOM cell
                    e_cell = e.target?.closest?.('.wj-cell')
                }
                data_cell = e_cell?.data_cell
            }
            // IE 2026 09 04 / ODOO-336331 (заказ Игоря): один обработчик на событие (нативный слушатель хоста + @click обёртки)
            if (e?.__agClickDone) return
            if (e) { try { e.__agClickDone = true } catch (err) { /* frozen event */ } }
            this.setSelectors_clickTry(e, ht, row, col)   // IE 2026 10 25 / ODOO-348730: клик по уже выделенной строке без фишки — «Set selectors» (wijmo не поднимает selectionChanged)
            // IE 2026 09 04 / ODOO-336331 (заказ Игоря): колонки со своим обработчиком клика (attr.cellClick_bindings) —
            // ДО цепочки веток cell-link / e.target.id (внутренние элементы ячейки с id уводили клик в неё): список
            // вариантов — колонка-флаг Default ставит/снимает основной вариант
            // IE 2026 09 10 / ODOO-…: клик по чекбоксу строки AttrBool в AttrTabGrid (ячейка AttrMulti) — переключить значение
            if (ht?.cellType === wjGrid.CellType.Cell && ht?.panel === this.flex?.cells && row >= 0 && col >= 0
                    && this.attr_by_binding[this.flex.columns[col]?.binding]?.attr_type === 'AttrMulti'
                    && e?.target?.matches?.('input[type=checkbox]') && this.boolCell_info(row, col)) {
                e.preventDefault()
                this.boolCell_toggle(row, col)
                return
            }
            if (this.attr.cellClick_method && ht?.cellType === wjGrid.CellType.Cell && ht?.panel === this.flex?.cells
                    && row >= 0 && this.flex.rows[row]?.dataItem
                    && (this.attr.cellClick_bindings || []).includes(String(this.flex.columns[col]?.binding || '').split('.')[0])) {
                try { this.attr.cellClick_method(String(this.flex.columns[col]?.binding || ''), this.flex.rows[row].dataItem, this, e) }
                catch (err) { console.warn('cellClick_method', err) }
                return
            }
            // IE 2026 09 30 / ODOO-343433: клик по строке отчёта (doc.params.row_click) → страница того же стола с чипсом из значения строки; занятые клики (ссылки, кнопки, редактор,
            // ячейки, доступные для правки, Alt / Ctrl / Shift) остаются за прежним поведением
            if (row >= 0 && ((ht?.cellType === wjGrid.CellType.Cell && ht?.panel === this.flex?.cells && col >= 0)
                    || (ht?.cellType === wjGrid.CellType.RowHeader && ht?.panel === this.flex?.rowHeaders)) && this.rowClickGoto_try(e, row, col, ht.cellType === wjGrid.CellType.RowHeader)) return
            // IE 2026 09 18 / ODOO-5800 (заказ Игоря: колонка use вкладки Metrics): грид вкладки приходит с бэка только для чтения (иначе панель получает
            // Copy / Undo / Redo, а правка взводит «изменён» у записи) — флажок Use ловим своим кликом, как All / Me списка настроек
            if (this.attr?.metricChip_use && ht?.cellType === wjGrid.CellType.Cell && ht?.panel === this.flex?.cells && row >= 0
                    && String(this.flex.columns[col]?.binding || '') === this.metricSel_binding() && this.flex.rows[row]?.dataItem?.key) {   // IE 2026 09 19 / ODOO-5800 (Igor: Use вкладки Metrics = оформление метрики видно в таблице, состав чипса — колонка Selector)
                try { e?.preventDefault?.() } catch (err) { /* frozen event */ }
                this.metricUse_click(row)
                return
            }

            // сводная таблица правил: колонки Source (source_link) — переход к
            // строке-источнику (грид правил отчёта / каскад widget-row) как в
            // ссылочном поле: Alt+клик или кнопка перехода в дропдауне
            // (onAggSourceOpen__Click); ставим ДО общего Alt+Click по значению
            if (e.altKey && e.button === 0 && !e.ctrlKey && !e.metaKey && !e.shiftKey
                && ht?.cellType === wjGrid.CellType.Cell && row >= this.headerRows
                && this.aggAll_isSummary() && !this.flex.activeEditor) {
                const attr_colSrc = this.attr_by_binding[this.flex.columns?.[col]?.binding]
                if (attr_colSrc?.source_link) {
                    const itemSrc = this.aggAll_sourceItem(row)
                    if (itemSrc) {
                        e.preventDefault()
                        e.stopPropagation()
                        this.aggAll_openSource(itemSrc)
                        return
                    }
                }
            }

            // ✅ Alt + Click: открыть по значению ячейки v2
            // ставим ДО обработки кнопок, но после получения data_cell
            if (
                e.altKey &&
                e.button === 0 &&                 // ЛКМ
                !e.ctrlKey && !e.metaKey && !e.shiftKey &&
                data_cell &&
                ht?.cellType === wjGrid.CellType.Cell &&
                row >= this.headerRows && col >= this.headerColumns &&   // если у тебя есть headerRows/headerColumns
                // !e.target?.id &&                  // не клик по кнопкам
                !e.target?.classList?.contains('cell-link') && // не иконка ссылки
                !e.target?.classList?.contains('pi')           // не Prime icon
            ) {
                // если открыт редактор — не мешаем
                if (this.flex.activeEditor) return;

                // merged cell: hitTest даёт физическую колонку под курсором,
                // а значение/binding лежат в корневой (anchor) ячейке range
                let vrow = row, vcol = col
                const mrg = this.flex.mergeManager?.getMergedRange(ht.panel, row, col, true)
                if (mrg) { vrow = mrg.topRow; vcol = mrg.leftCol }
                // IE 2026 09 18 (замечание Игоря): при merge «назад» корень объединения — колонка дерева, а значение
                // и ссылка живут в колонке k (mergeBack_info) — открываем её, иначе Alt+Click по объединению молчал
                const mbCol = this.mergeBack_redirect(this.flex, vrow, vcol)
                if (mbCol >= 0) vcol = mbCol

                const gridCol = this.flex.columns?.[vcol];
                const binding = gridCol?.binding;
                const attr_col = this.attr_by_binding?.[binding];

                if (binding && attr_col) {
                    const rowObj = this.flex.rows?.[vrow];
                    const dataItem = rowObj?.dataItem;

                    // value
                    let value = dataItem ? this.store.get_value(dataItem, binding) : null;

                    // AttrMulti
                    if (attr_col.attr_type === 'AttrMulti') {
                        const V = this.store.check_AttrMulti(attr_col, dataItem);
                        value = V?.value;
                    }

                    // если есть что открывать
                    if (value) {
                        e.preventDefault();
                        e.stopPropagation();

                        // Вариант A: использовать существующий open по data_cell
                        // (если onButtonOpen__Click умеет открыть по binding/колонке)
                        this.onButtonOpen__Click({ ...data_cell, row: vrow, col: vcol, irow: vrow, col_binding: binding }, e);

                        // Вариант B: если у тебя есть отдельный метод открытия по значению:
                        // this.openFromCellValue({ row, col, binding, attr_col, value, dataItem, data_cell }, e);

                        return;
                    }
                }
            }

            // IE 2026 11 02 / ODOO-349799 (cell-icons): иконка по значению — ДО ветки cell-link (у неё тот же класс): без Alt — список (icon_method), с Alt — запись
            if (e.target.id === CELL_ICON_ID && data_cell && this.cellIcons_on() && this.cellIcon_click(data_cell, e)) {
                e.preventDefault()
                e.stopPropagation()
                return
            }
            if (e.target.classList.contains("cell-link") && data_cell) {
                // data_cell = e.target.parentElement.data_cell
                // if (!data_cell) {
                //     data_cell = e.target.parentElement.parentElement.data_cell
                // }
                this.onButtonOpen__Click(data_cell, e)
                // IE 2026 08 20 / ODOO-5512 (заказ Игоря): из списка настроек
                // элемент открывается в отдельном виджете — дропдаун выбора
                // настройки при этом сразу закрывается; задержка больше
                // отложенных таймеров грида (open 0мс, mousedown 100мс), чтобы
                // они дообработали клик до размонтирования грида
                if (this.attr?.name === 'settings-list') {
                    const wv = this.WIDGET?.attrs_vueObj?.WIDGET
                    if (wv) setTimeout(() => { wv.showDropdown = false }, 200)
                }
                e.preventDefault()

            // IE 2026 09 28 / ODOO-342342 (приёмка Д8): у самой ячейки wijmo свой id («g-2-cell-13-0») — клик по тексту ячейки без вложенного элемента
            // уходил в ветку кнопок с id и гас там (ни одна кнопка не совпала), до cellClick_dblclick / rowHeaderClick_dblclick не доходил
            } else if (e.target.id && data_cell && !e.target.classList?.contains('wj-cell')) {
                // data_cell = wjcCore.closest(e.target, '.data-cell')?.data_cell
                // if (data_cell) {
            
                if (e.target.id === "onButtonCole.target.idlapsed__Click") {
                    this.onButtonCollapsed__Click(data_cell)
                } else if (e.target.id === "onExpandLinkFields__Click") {
                    this.expandLinkFields_Click(data_cell)
                } else if (e.target.id === "onButtonOpen__Click") {
                    this.onButtonOpen__Click(data_cell, e)
                } else if (e.target.id === "onOpenSegmentList__Click") {   // IE 2026 10 23 / ODOO-5800 (заказ Игоря, скрин 1): ярлык «список сегмента»
                    this.onOpenSegmentList__Click(data_cell)
                } else if (e.target.id === "onButtonSearch__Click") {
                    this.onButtonSearch__Click(data_cell)
                } else if (e.target.id === "onRefToggle__Click") {
                    this.onRefToggle__Click(data_cell, e)
                } else if (e.target.id === "onButtonShowDroppedDown__Click") {
                    this.onButtonShowDroppedDown__Click(data_cell, e)
                } else if (e.target.id === "onValue_multi__Click") {
                    this.value_multi_click(data_cell)
                } else if (e.target.id === "onСhoice__Click") {
                    this.onСhoice__Click(data_cell)
                } else if (e.target.id === "onFeSelectedAll__Click") {
                    const someSelected = this.flex.rows.some(r => r.dataItem?._fe?.selected)
                    if (someSelected) {
                        this.flex.selectedRanges = [new wjGrid.CellRange(-1, -1, -1, -1)]
                    } else {
                        const lastRow = this.flex.rows.length - 1
                        const c1 = this.flex.selectedRanges[0]?.leftCol ?? 0
                        const c2 = this.flex.selectedRanges[0]?.rightCol ?? 0
                        this.flex.selectedRanges = [new wjGrid.CellRange(0, c1, lastRow, c2)]
                    }
                } else if (e.target.id === "onFeSelected__Click") {
                    const checkbox = e.target
                    const irow = data_cell.irow
                    const c1 = this.flex.selectedRanges[0]?.leftCol ?? 0
                    const c2 = this.flex.selectedRanges[0]?.rightCol ?? 0
                    if (checkbox.checked) {
                        const newRanges = [...this.flex.selectedRanges, new wjGrid.CellRange(irow, c1, irow, c2)]
                        this.flex.selectedRanges = newRanges
                    } else {
                        const newRanges = []
                        for (const range of this.flex.selectedRanges) {
                            const r1 = Math.min(range.row, range.row2), r2 = Math.max(range.row, range.row2)
                            const rc1 = Math.min(range.col, range.col2), rc2 = Math.max(range.col, range.col2)
                            if (r2 < irow || r1 > irow) {
                                newRanges.push(new wjGrid.CellRange(r1, rc1, r2, rc2))
                            } else {
                                if (r1 < irow) newRanges.push(new wjGrid.CellRange(r1, rc1, irow - 1, rc2))
                                if (r2 > irow) newRanges.push(new wjGrid.CellRange(irow + 1, rc1, r2, rc2))
                            }
                        }
                        if (!newRanges.length) newRanges.push(new wjGrid.CellRange(irow, c1, irow, c1))
                        this.flex.selectedRanges = newRanges
                    }
                } else if (e.target.id === "onSelectorAll__Click") {
                    const binding = e.target.dataset.binding
                    // клик по «выбрать/снять всё» убирает подсказку и глушит её до
                    // СЛЕДУЮЩЕГО наведения: ячейка перерисовывается под курсором,
                    // и без этого меню всплывает снова поверх только что нажатой кнопки
                    this.selectorAllMenu_suppress(binding)
                    if (this.archiveRo_flag(binding, e)) return   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): «выбрать всё» флажков данных в архиве (данные модели) — не переключает (ревью #110599)
                    // IE 2026 09 18 / ODOO-5800 (заказ Игоря: колонка use вкладки Metrics): «выбрать / снять все» у грида вкладки Metrics — тоже через чипс метрик
                    if (this.attr?.metricChip_use && (binding === 'use' || binding === this.metricSel_binding())) {   // IE 2026 09 19 / ODOO-5800 (Igor: Use вкладки Metrics = оформление метрики видно в таблице, состав чипса — колонка Selector)
                        // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5 [ДЕФЕКТ, defects-found.md]: row.visible !== false — как metricUse_selectorClick / metricFmt_selectorClick этого файла;
                        // без него строки, спрятанные чипсом поиска, тоже отмечались / снимались
                        const someOn = this.flex.rows.some(r => r.dataItem && r.visible !== false && this.store.isTrue(r.dataItem[binding]))
                        for (const r of this.flex.rows) if (r.dataItem?.key && r.visible !== false) r.dataItem[binding] = !someOn
                        this.flexRefresh()
                        if (binding === this.metricSel_binding()) this.metricUse_schedule(); else this.metricFmt_schedule()
                        return
                    }
                    // IE 2026 09 26 / ODOO-… (заказ Игоря: doc.use в заголовках строк): флажки данных (use, position / positionNew) — только видимые незаблокированные
                    // строки, один шаг отмены, грид помечается изменённым; selector и выключатель fe.ux.gridRowHeaderFlags = false — прежний проход ниже
                    if (this.rhSelectAll(e, binding)) return
                    // ИЕ 2026-08-14: состояние читаем ТЕМ ЖЕ способом, что и отрисовка
                    // чекбокса в шапке (store.get_value). Сырое dataItem[binding] может
                    // быть обёрткой ({value:false} — истинный объект!), и тогда клик
                    // «снимал» уже снятое: галочки стоят, а повторный клик ничего не даёт
                    // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5 [ДЕФЕКТ, defects-found.md]: только строки, которые показывает чипс поиска / фильтр (dataItem._fe.visible — как set_use при клике
                    // по диапазону); раньше отмечались и спрятанные строки (для selector они уходили в чипс стола). Строки свёрнутых групп отбором не спрятаны — отмечаются
                    const _shown = (r) => !!r.dataItem && r.dataItem._fe?.visible !== false
                    const someChecked = this.flex.rows.some(r => _shown(r) && this.rhBool_value(r.dataItem, binding))   // IE 2026 10 23 / ODOO-5800
                    const checked = !someChecked
                    e.target.checked = checked
                    const _selNoMod = this.selector_noModified(binding)   // IE 2026 09 26 / ODOO-… (замечание Игоря: selector не меняет данные строки)
                    this.flex.rows.forEach(row => {
                        if (_shown(row)) this.store.set_value(row.dataItem, binding, checked, null, null, null, _selNoMod ? false : null)
                    })
                    if (binding === 'selector' && this.formatSel_grid()) { this.formatSel_syncRecord(0, this.flex.rows.length - 1); this.formatSel_changed(); this.formatSel_autoChip(0, this.flex.rows.length - 1, checked, false) }   // IE 2026 09 20 / ODOO-5800 (Igor: колонка Selector и статистика грида Conditional format, чипс условного оформления CHIP-Format)
                    if (binding === 'use' && this.itemsSourcesView_grid()) {
                        // §6.3: чекбокс use в шапке (выбрать все, мимо onSelector__Click)
                        // управляет строками целевого грида
                        const items = []
                        this.flex.rows.forEach(row => {
                            if (_shown(row)) items.push(row.dataItem)   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5: те же строки, что отмечены выше (как клик по диапазону)
                        })
                        this.itemsSourcesView_use_apply(items)
                    }
                    const attr_col = this.attr_by_binding[binding] || {}
                    if (attr_col.action_afterChange?.command === 'use_selectorMeasures') {
                        this.use_selectorMeasures()
                    } else if (attr_col.action_afterChange) {
                        this.store.executeStoreMethod(this.WIDGET.vueObj, attr_col.action_afterChange, this.attr)
                    }
                    this.flexRefresh()
                    this.attr_set()
                    if (this.WIDGET.widget === 'widget-selectors') {
                        this.store.sync_WORKSPACE(this.WIDGET, '>>WORKSPACE')
                    }
                } else if (e.target.id === "onSelector__Click") {
                    let checkbox = e.target
                    this.onSelector__Click(data_cell, checkbox.checked, e)
                } else if (e.target.id === "onSelectorKPI__Click") {
                    let checkbox = e.target
                    if (checkbox.checked) {
                        checkbox.classList = ["attr-KPI-selector attr-KPI-selector-on wj-control"]
                    } else {
                        checkbox.classList = ["attr-KPI-selector wj-control"]
                    }
                    this.onSelectorKPI__Click(data_cell, checkbox.checked)
                } else if (e.target.id === "onButtonKPI__Click") {
                    this.onButtonKPI__Click(data_cell)
                } else if (e.target.id === "onHeader__Click") {
                    this.isRowHeaderClick = false
                    this._skipSelectionWidgetOpen = true
                    this.flex.selectedRanges = [new wjGrid.CellRange(data_cell.irow, 0, data_cell.irow, this.flex.columns.length-1)]
                    this.execute_dblclick({}, true)
                    // Cancel any pending selectionChanged timeout to prevent double widget_open
                    if (this.selectionChanged_timeout) { clearTimeout(this.selectionChanged_timeout); this.selectionChanged_timeout = null }
                    setTimeout(() => { this._skipSelectionWidgetOpen = false }, 500)
                }
            } else if (this.attr.rowHeaderClick_dblclick && ht?.panel === this.flex?.rowHeaders
                    && row >= 0 && this.flex.rows[row]?.dataItem && this.dblclick_action) {
                // IE 2026 08 19 / ODOO-5512 (заказ Игоря п.2): клик по ЯЧЕЙКЕ заголовка
                // строки (не только по карандашу onHeader__Click) = действие дабл-клика
                // (первая команда — выбор); опционально per-attr (список настроек)
                this.isRowHeaderClick = false
                this._skipSelectionWidgetOpen = true
                this.flex.selectedRanges = [new wjGrid.CellRange(row, 0, row, this.flex.columns.length - 1)]
                this.execute_dblclick({}, true)
                if (this.selectionChanged_timeout) { clearTimeout(this.selectionChanged_timeout); this.selectionChanged_timeout = null }
                setTimeout(() => { this._skipSelectionWidgetOpen = false }, 500)
            } else if (this.attr.cellClick_dblclick && ht?.cellType === wjGrid.CellType.Cell && ht?.panel === this.flex?.cells
                    && row >= 0 && this.flex.rows[row]?.dataItem && this.dblclick_action
                    && !e.target?.classList?.contains('cell-link') && !e.target?.closest?.('.cell-link')
                    && !e.target?.classList?.contains('pi') && !e.target?.closest?.('.wj-elem-collapse')
                    && !(typeof e.target.className === 'string' && e.target.className.includes('glyph'))
                    && (this.attr.cellClick_dblclick === true
                        || (Array.isArray(this.attr.cellClick_dblclick)
                            // биндинг колонки AttrMulti — 'title.valueStr': сравниваем и с первым звеном
                            && (this.attr.cellClick_dblclick.includes(String(this.flex.columns[col]?.binding || ''))
                                || this.attr.cellClick_dblclick.includes(String(this.flex.columns[col]?.binding || '').split('.')[0]))))) {
                // IE 2026 08 26 / ODOO-5800 (заказ Игоря): одиночный клик по ТЕКСТУ ячейки перечисленных колонок
                // (список настроек: Title) = действие дабл-клика — выбор настройки, как через заголовок строки;
                // иконка-ссылка и глиф дерева сохраняют своё поведение
                this.isRowHeaderClick = false
                this._skipSelectionWidgetOpen = true
                this.flex.selectedRanges = [new wjGrid.CellRange(row, 0, row, this.flex.columns.length - 1)]
                this.execute_dblclick({}, true)
                if (this.selectionChanged_timeout) { clearTimeout(this.selectionChanged_timeout); this.selectionChanged_timeout = null }
                setTimeout(() => { this._skipSelectionWidgetOpen = false }, 500)
            }

            if (!(typeof e.target.className === 'string' && e.target.className.includes('glyph')) && !e.target.classList?.contains('pi')) {
                // IE 2026 09 22 / ODOO-5800 (Igor: «показывать форму-дропдаун при первом клике по ячейке, не обязательно заходить внутрь в инпут;
                // опция для таблицы, по умолчанию вкл для основной таблицы отчётов»): обычный клик по ячейке данных (без Ctrl / Shift / Alt —
                // выделение диапазона и открытие по значению остаются как были) открывает форму ячейки, как шеврон / F4
                const fromClick = e.button === 0 && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey
                    && ht?.cellType === wjGrid.CellType.Cell && ht?.panel === this.flex?.cells && row >= 0 && col >= 0 && this.cellForm_onClickOn()
                this.dropdown_showForActiveCell(fromClick ? { fromClick: true } : null)
            }

            // auto_open widget-row при клике на грид
            if (this.attr.widgetRow_params?.auto_open && !this.store.get_childrenWidget(this.WIDGET, 'widget-row')) {
                const col = this.flex.columns[this.flex.selection.col]
                const attr_col = col ? this.attr_by_binding[col.binding] : null
                // IE 2026 09 23 / ODOO-341407: i18n
                const actionMenu = { 'tooltip': t('Open line'), 'action_name':'action-front-openLine-2025-12-27', command:'widget_open', 'widget':'widget-row', '_noActivate':true, 'get_currentRow':true, 'get_Parent':true, 'open_in_children_widget':true, 'cssClass':'pi p-button-white pi-pencil', source_name:this.attr.name, 'binding':this.attr.binding, attrs:this.attr.attrs, widgetRow_params:this.attr.widgetRow_params }
                if (attr_col?.attr_type === 'AttrGrid') {
                    actionMenu.activeAttr = { binding: attr_col.binding }
                }
                this.store.executeStoreMethod(this.WIDGET.vueObj, actionMenu, this.attr)
            }
        },
        execute_dblclick(m, force=false) {
            if (!force && this.attr?.binding === CM_ROWS_BINDING && this.compareMerge_dblclick(m)) return   // IE 2026 10 31 / ODOO-349799 (PR3): двойной клик по строке «Changes» — к ячейке формы
            // IE 2026 10 11 / ODOO-345618 (выбор пользователя в «Edit in a grid»): в списке, открытом для ВЫБОРА (parentAction.params.isChoise — ☰ / «Open list» выпадашки ячейки),
            // двойной клик по строке данных = выделить строку + Choice (dblclick_action бэка, command 'onChoice'). Флаг fe.ux.pickerDblClick (дефолт ВКЛ);
            // выключен / не режим выбора / не строка данных — прежнее поведение (нативный dblclick ничего не делает)
            if (!force && m && typeof m.clientX === 'number' && this.flex) {
                let pickerDblClick = true
                try { pickerDblClick = this.store.setting('fe.ux.pickerDblClick', true) !== false } catch (e) { pickerDblClick = true }
                const isChoise = !!this.WIDGET?.parentAction?.params?.isChoise
                let ht = null
                if (pickerDblClick && isChoise) { try { ht = this.flex.hitTest(m) } catch (e) { ht = null } }
                const row = ht ? ht.row : -1
                const isDataRow = !!ht && row >= 0 && (ht.panel === this.flex.cells || ht.panel === this.flex.rowHeaders) && !!this.flex.rows[row]?.dataItem
                if (picker_dblClickChooses({ pickerDblClick, isChoise, action: this.dblclick_action, isDataRow })) {
                    this._skipSelectionWidgetOpen = true
                    this._pickerChoiceAt = (typeof m.timeStamp === 'number' ? m.timeStamp : performance.now())   // IE 2026 10 11 / ODOO-345618: защита от повторного Choice (свой детектор + нативный dblclick)
                    this.flex.selectedRanges = [new wjGrid.CellRange(row, 0, row, this.flex.columns.length - 1)]
                    if (this.selectionChanged_timeout) { clearTimeout(this.selectionChanged_timeout); this.selectionChanged_timeout = null }
                    setTimeout(() => { this._skipSelectionWidgetOpen = false }, 500)
                    force = true
                }
            }
            if (force) {
                let vueObj = this.WIDGET.vueObj,
                    col = this.flex.columns[this.flex.selection.col],
                    attr_col = this.attr_by_binding[col?.binding]
                    
                if (this.get_viewParam('isReadOnly') || attr_col?.isReadOnly || attr_col?.is_dblclick || force) {
                    // this.store.get_dblclick_action(vueObj, this.attr)
                    if (this.dblclick_action) {
                        this.dblclick_action.binding = this.attr.binding // TEMP 2024 12
                        // явный жест (карандаш в заголовке строки / dblclick) —
                        // активность переходит к widget-row, в т.ч. для экшенов с бэка
                        if (this.dblclick_action.widget === 'widget-row' && !this.dblclick_action._noActivate) {
                            this.dblclick_action._activate = true
                        }
                        this.store.executeStoreMethod(vueObj, this.dblclick_action, this.attr)
                    }
                }
            }
        },
        onClick(action) {
            let vueObj = this.WIDGET.vueObj

            // Let's leave only the modified lines
            if (action.method === 'save') {
                const [doc, binding] = this.store.attr_get_link(this.WIDGET, this.attr)
                const indexes = new Set(this.undoStack.map(row => row.i))
                doc[binding] = [...doc[binding].filter((row, index) => indexes.has(index)).map(row => row)]
            }

            vueObj.store.executeStoreMethod(vueObj, action, this.attr)
        },
        get_data0(irow) {
            if (this.attr.childItemsPath) {
                let row = this.flex.rows[irow]
                if (row?.level > 0) {
                    let iparent = irow
                    while (iparent >= 0) {
                        if (this.flex.rows[iparent].level === 0) {
                            return [ this.flex.rows[iparent].dataItem ]
                        }
                        iparent--
                    }
                } else {
                    return [ row.dataItem ]
                }
            }
            return this.data000 // this.flex.collectionView.items
        },
        get_parentItems(irow) {
            if (this.attr.childItemsPath) {
                let row = this.flex.rows[irow]
                if (row?.level > 0) {
                    let iparent = irow
                    while (iparent >= 0) {
                        if (row.level-1 === this.flex.rows[iparent].level) {
                            return this.flex.rows[iparent].dataItem[this.attr.childItemsPath]
                        }
                        iparent--
                    }
                }
            }
            return this.data000 // this.flex.collectionView.items
        },
        get_parentPosition(irow) {
            if (this.attr.childItemsPath) {
                let row = this.flex.rows[irow]
                if (row?.level > 0) {
                    let iparent = irow
                    while (iparent >= 0) {
                        if (row.level-1 === this.flex.rows[iparent].level) {
                            return iparent
                        }
                        iparent--
                    }
                }
            }
            return -1
        },
        get_parentsList(irow, attr_col, parentsList=null) {
            if (!attr_col.hierarchy) {
                return []
            }
            if (!parentsList) {
                parentsList = []
            }
            let parentPosition = this.get_parentPosition(irow)
            if (parentPosition >= 0) {
                let parentRow = this.flex.rows[parentPosition]
                parentsList.push( this.store.get_value(parentRow.dataItem, attr_col.binding) )

                this.get_parentsList(parentPosition, attr_col, parentsList)
            }
            return parentsList
        },
        rows_indexOf(dataItem, start_irow=0) {
            if (dataItem) {
                dataItem['$findMarker'] = 1
                for (let irow = start_irow; irow < this.flex.rows.length; irow++) {
                    if (this.flex.rows[irow]?.dataItem?.['$findMarker'] === dataItem['$findMarker']) {
                        delete dataItem['$findMarker']
                        return irow
                    }
                }
                delete dataItem['$findMarker']
                return -1
            } else {
                return this.flex.rows.length - 1
            }
        },
        new_Click(e, clone=false, currentPosition=null) {
            // allowAddNew: false — добавление отключено (у сводных таблиц без
            // дефолтного контейнера, viewList-all); клонирование разрешено
            if (this.attr.allowAddNew === false && !clone) return
            // set_nonEmptyWidget
            if (this.attr_nonEmptyWidget?.active) {
                this.attr_nonEmptyWidget.active = false
                this.store.set_nonEmptyWidget(this.WIDGET)
            }

            if (currentPosition === null) {
                currentPosition = Math.max(0, this.flex.selectedRanges[0].topRow) // this.flex.collectionView.currentPosition // e.row
            }
            let dataItem_new = {}
            // престройка вложенных путей колонок (attr.attr_type и т.п.):
            // «сырая» строка без промежуточных объектов ломала запись значений,
            // вставку и per-row резолв поля (подбор значения, дропдаун типа)
            for (const c of this.columns()) {
                const b = String(c?.binding || '')
                const i = b.lastIndexOf('.')
                if (i > 0) {
                    const parent = b.slice(0, i)
                    if (this.store.get_value(dataItem_new, parent) == null) {
                        this.store.set_value(dataItem_new, parent, {}, null, null, null, false)
                    }
                }
            }
            let parentItems = this.get_parentItems(currentPosition)
            let dataItem = {}
            let insertIndex
            if (currentPosition !== null) {
                dataItem = this.flex.rows[currentPosition]?.dataItem
                const irowItem = parentItems.indexOf(dataItem)

                this.initialized_stackСhanges()

                // this.flex.collectionView.items.splice(currentPosition+1, 0, dataItem_new)
                insertIndex = irowItem + 1
                parentItems.splice(insertIndex, 0, dataItem_new)
            } else {
                parentItems.push(dataItem_new)
                insertIndex = parentItems.length - 1
            }

            if (clone) {
                // this.store.validate_newRecord(this.WIDGET, 'clone')

                let dataItem_dublicate = structuredClone(dataItem)
                for (let col_binding in dataItem_dublicate) {
                    if (col_binding === 'id' || col_binding === 'meta' || col_binding === '_meta' || col_binding === '_fe') { // predefined, noupdate
                        continue
                    } else if (col_binding=='title'){
                        dataItem_new[col_binding] = this.store.increment_name(dataItem_dublicate[col_binding])
                    } else {
                        dataItem_new[col_binding] = dataItem_dublicate[col_binding]
                    }
                    // if (dataItem_new[col_binding] && dataItem_new[col_binding]!='0') { >> error if this object and isPrintTemplate
                    //     this.set_value(currentPosition, dataItem_new, col_binding, '', dataItem_new[col_binding])
                    // }
                }
            }
            if (this.rowHeaders_col_use !== null && this.store.get_value(dataItem_new, 'use') == null) {
                this.store.set_value(dataItem_new, 'use', true)
            }
            for (const { binding } of this.rowHeaders_cols_pos) {
                if (this.attr_by_binding[binding]?.attr_type === 'AttrBool' && this.store.get_value(dataItem_new, binding) == null) {
                    this.store.set_value(dataItem_new, binding, true)
                }
            }
            this.rowIds_newRow(dataItem_new, clone)

            // история Undo/Redo: вставка/клонирование строки — одно действие
            this.hist_push({
                method: 'rows', kind: clone ? 'clone' : 'insert',
                from: null,
                to: [{ item: dataItem_new, arr: parentItems, index: insertIndex }],
                label: clone ? t('Clone row') : t('Insert row'),   // IE 2026 09 23 / ODOO-341407: i18n
            })

            this.setModified(dataItem_new, true)
            this.refresh([dataItem_new])
            this.attr_set()
            if (this.WIDGET.widget === 'widget-selectors') {
                this.store.sync_WORKSPACE(this.WIDGET, '>>WORKSPACE')
            }
            this.$nextTick(() => {
                this.set_AttrTabPanel_countItems()
            })
        },
        // shift_undoStack удалён: индексы в стеке больше не сдвигаются —
        // строки резолвятся по ссылке ($item), см. initialized_stackСhanges
        initialized_stackСhanges() {
            // changesStack: подсветка изменённых ячеек. Текущий irow строки
            // резолвим ПО ССЫЛКЕ на dataItem (после вставки/удаления/сортировки
            // сохранённые индексы устаревают)
            tooltip.dispose()
            this.changesStack = {}
            const itemRow = new Map()
            if (this.flex?.rows) {
                for (let r = 0; r < this.flex.rows.length; r++) {
                    const di = this.flex.rows[r]?.dataItem
                    if (di && !itemRow.has(di)) itemRow.set(di, r)
                }
            }
            for (let i = 0; i < this.undoStack.length; i++) {
                let rowStack = this.undoStack[i]
                if (rowStack.col_binding == null) continue // структурные записи не подсвечивают ячейку
                if (rowStack.$item && itemRow.has(rowStack.$item)) {
                    rowStack.irow = itemRow.get(rowStack.$item)
                }
                // IE 2026 08 19 / ODOO-5512: очистка ручной корректировки (method 'cells',
                // noMark) — не метка, а СНЯТИЕ метки: более ранняя правка той же ячейки
                // после очистки не подсвечивается (иначе после redo очистки ячейка
                // снова показывала синий уголок и бейдж по снимку _cells)
                if (rowStack.method === 'cells' || rowStack.noMark) {
                    delete this.changesStack[`${rowStack.irow}:${rowStack.col_binding}`]
                    continue
                }
                // IE 2026 08 21 / ODOO-5512: пересборка повторяет логику pushStack —
                // цепочка сим/косвенных правок несёт накопленную дельту (val0),
                // нулевой итог метку не ставит
                if (rowStack.indirect || rowStack.related) {
                    const _prev = this.changesStack[`${rowStack.irow}:${rowStack.col_binding}`]
                    if (_prev) rowStack.val0 = _prev.val0 !== undefined ? _prev.val0 : _prev.val
                    if (this.chgNet_isZero(rowStack)) {
                        delete this.changesStack[`${rowStack.irow}:${rowStack.col_binding}`]
                        continue
                    }
                }
                // IE 2026 08 27 (Igor): прямая правка, вернувшая ячейку к исходному (val0 первой правки цепочки), —
                // не пометка и после undo/redo (пересборка повторяет логику pushStack)
                if (rowStack.method === 'val' && !rowStack.indirect && !rowStack.related
                        && this.store.fastEntry?.saveSkipNoop !== false) {
                    const _prevD0 = this.changesStack[`${rowStack.irow}:${rowStack.col_binding}`]
                    // IE 2026 08 27 (Igor, M03): база — только от прямой правки пользователя (см. pushStack)
                    const _prevD = (_prevD0 && _prevD0.method === 'val' && !_prevD0.indirect && !_prevD0.related) ? _prevD0 : null
                    const _v0 = _prevD ? (_prevD.val0 !== undefined ? _prevD.val0 : _prevD.val)
                                       : (rowStack.val !== undefined ? rowStack.val : rowStack.val0)
                    rowStack.val0 = _v0
                    if (this._valSame(_v0, rowStack.newVal)) {
                        delete this.changesStack[`${rowStack.irow}:${rowStack.col_binding}`]
                        continue
                    }
                }
                this.changesStack[`${rowStack.irow}:${rowStack.col_binding}`] = rowStack
            }
            // IE 2026 08 27 (Igor): правленых ячеек не осталось (в т.ч. после undo до исходного) — снять modified
            // записи/виджета, Save гаснет; структурные правки (строки) в undo-стеке — остаёмся «изменено»
            if (this.store.fastEntry?.saveSkipNoop !== false && !this._userChanges_left().length
                    && !this.undoStack.some(a => a && a.col_binding == null) && (this.modified || this._roCaptured) && !this.gridEditMode_dirty()) {   // IE 2026 10 14 / ODOO-5800
                this.noop_unmodified()
            }
        },
        // ---- IE 2026 08 18 / ODOO-4997 (заказ Игоря): угловой бейдж с дельтой,
        // вспышка по действию (без таймеров), сводка при массовом пересчёте и
        // трассировка связи «агрегат ↔ детали» по наведению ----
        // IE 2026 08 27 / ODOO-11316 (an-dm, Алексей; кейс 6183: клик None→None по ApprovedPM затёр метку Янюк
        // 26.08): no-op ячейки — итог цепочки правок равен исходному значению («поставил галку → тут же снял») —
        // в сохранение не уходят целиком: ни значение, ни метка _cells (возвращается снимок до первой правки),
        // ни признак изменённости (changesStack). Undo-история не трогается. Флаг fastEntry.saveSkipNoop (дефолт ВКЛ).
        // IE 2026 08 27 (Igor): равенство значений ячейки «до/после» для no-op (пусто/null/undefined — одно и то же,
        // числа — с допуском, остальное — строкой)
        _valSame(a, b) {
            const e = v => v === null || v === undefined || v === ''
            if (e(a) && e(b)) return true
            if (e(a) !== e(b)) return false
            if (typeof a === 'boolean' || typeof b === 'boolean') return this.store.isTrue(a) === this.store.isTrue(b)
            if (typeof a === 'number' || typeof b === 'number') {
                const na = parseFloat(a), nb = parseFloat(b)
                if (Number.isFinite(na) && Number.isFinite(nb)) return Math.abs(na - nb) < 1e-9
            }
            return a === b || String(a) === String(b)
        },
        // IE 2026 08 27 (Igor): ячейка вернулась к исходному — снять пометку правки и, если правок не осталось,
        // флаги modified строки/записи/виджета
        // IE 2026 08 27 (Igor): правленых ячеек не осталось — виджет/запись «без изменений»: modified снимается,
        // isReadOnly возвращается к значению до первой правки (жёлтый Save в панели гаснет, как до правок)
        noop_unmodified() {
            this.modified = false
            const rec = this.WIDGET?.record
            if (rec?._meta?.modified && !String(this.attr?.binding || '').startsWith('_')) rec._meta.modified = false
            if (this._roCaptured) {
                if (this._roBefore === undefined) {
                    const _vp = this.WIDGET?.record?.doc?.viewParams?.[this.attr?.name]
                    if (_vp && typeof _vp === 'object' && 'isReadOnly' in _vp) delete _vp.isReadOnly
                } else {
                    this.set_viewParam('isReadOnly', this._roBefore, true)
                }
                this._roCaptured = false
            }
            this.set_commandPanel?.()
        },
        noop_unmark(rowStack) {
            const item = rowStack.$item || this.get_dataItem2(null, rowStack.irow)
            if (item && item._cells && typeof item._cells === 'object') {
                const raw = String(rowStack.col_binding).replace('data::', '')
                if (rowStack.cells0) item._cells[raw] = this.store.deepCopy(rowStack.cells0)
                else delete item._cells[raw]
                if (!Object.keys(item._cells).length) delete item._cells
            }
            // IE 2026 08 27 (Igor, M03: «100 → удалить: чипс ушёл, а Save активна»): «правок не осталось» — по ПРЯМЫМ
            // правкам пользователя (как чипс Corrections); производные (indirect/related) остатки пересчёта сами по себе
            // изменением не считаются и вычищаются
            const left = this._userChanges_left()
            if (item?._meta?.modified && !left.some(rs => rs && rs.$item === item)) item._meta.modified = false
            if (!left.length && !this.gridEditMode_dirty()) {   // IE 2026 10 14 / ODOO-5800: у динамического списка остались правки строк (добавленная / удалённая) — режим не снимать
                this.noop_unmodified()
            }
            // перерисовать ячейку: стиль «правлено» берётся из _cells при форматировании
            const key = this.flex?.cells ? `${this.flex.cells.cellType}-${rowStack.irow}-${rowStack.icol}` : null
            if (key && this.cache_data_cells?.delete) this.cache_data_cells.delete(key)
            // IE 2026 10 14 / ODOO-5800 (app7 #84309: клик ✓ПМ — три полных перерисовки грида, одна отсюда): invalidate всего грида не нужен — set_value следом перерисовывает
            // строку правки (editRefresh_rows / refreshCells), а в пачке (undo / вставка) грид перерисовывается в конце пачки; кэш ячейки выше уже сброшен.
            // Выключатель fe.ux.gridNoopUnmarkCellRefresh (дефолт ВКЛ; выкл — invalidate, как до правки)
            if (this.store.setting('fe.ux.gridNoopUnmarkCellRefresh', true) === false) this.flex?.invalidate?.()
        },
        undoStack_forSave() {
            const stack = this.undoStack.filter(rs => rs && rs.col_binding != null && rs.irow >= 0 && !rs.indirect)
            if (this.store.fastEntry?.saveSkipNoop === false) return stack
            const same = (a, b) => this._valSame(a, b)
            const groups = new Map()
            for (const rs of stack) {
                const key = `${rs.$key ?? rs.irow}:${rs.col_binding}`
                let g = groups.get(key)
                if (!g) { g = { first: rs, last: rs, entries: [] }; groups.set(key, g) }
                g.last = rs; g.entries.push(rs)
            }
            const drop = new Set()
            let n = 0
            for (const g of groups.values()) {
                const val0 = g.first.val0 !== undefined ? g.first.val0 : g.first.val
                if (!same(val0, g.last.newVal)) continue
                const item = g.first.$item || this.get_dataItem2(null, g.first.irow)
                if (item && item._cells && typeof item._cells === 'object') {
                    const raw = String(g.first.col_binding).replace('data::', '')
                    if (g.first.cellsBefore) item._cells[raw] = this.store.deepCopy(g.first.cellsBefore)
                    else delete item._cells[raw]
                    if (!Object.keys(item._cells).length) delete item._cells
                }
                delete this.changesStack[`${g.first.irow}:${g.first.col_binding}`]
                for (const rs of g.entries) drop.add(rs)
                n++
            }
            if (n) {
                if (!this.store.hide_console) console.log(`undoStack_forSave: ${n} no-op cell(s) dropped (ODOO-11316)`)
                this.corrChip_schedule?.()
                this.flex?.invalidate?.()
            }
            return stack.filter(rs => !drop.has(rs))
        },
        chgNet_isZero(rowStack) {
            // IE 2026 08 21 / ODOO-5512: итог цепочки правок ячейки нулевой?
            const num = v => {
                if (v === null || v === undefined || v === '') return null
                const n = typeof v === 'number' ? v
                    : parseFloat(String(v).replace(/[\s\u00a0]/g, '').replace(',', '.'))
                return Number.isFinite(n) ? n : null
            }
            const a = num(rowStack.val0 !== undefined ? rowStack.val0 : rowStack.val)
            const b = num(rowStack.newVal)
            if (a === null || b === null) return false
            return Math.abs(b - a) < 1e-9
        },
        chgDelta_date(a, b) {
            // IE 2026 09 10 / ODOO-… (замечание Игоря): правка ячейки-даты (2026-01-01 → 2025-01-01) показывала бейдж «−1» — parseFloat брал год;
            // для дат дельта считается календарём: −1y / +3m / +15d (до двух старших частей: +1y 2m), тултип — точные даты.
            // undefined — не даты (обычный числовой путь), null — без бейджа
            const toD = (v) => {
                if (v instanceof Date) return isNaN(v) ? null : Date.UTC(v.getFullYear(), v.getMonth(), v.getDate())
                if (typeof v !== 'string') return null
                const m = /^\s*(\d{4})-(\d{2})-(\d{2})(?:[T ]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]\d{2}:?\d{2})?)?\s*$/.exec(v)
                if (!m) return null
                const t = Date.UTC(+m[1], +m[2] - 1, +m[3])
                return Number.isFinite(t) ? t : null
            }
            const empty = (v) => v === null || v === undefined || v === ''
            const da = toD(a), db = toD(b)
            if (da === null || db === null) {
                if ((da !== null && empty(b)) || (db !== null && empty(a))) return null   // дата ↔ пусто: числовой дельты нет
                return undefined
            }
            if (da === db) return null
            const up = db > da, s = new Date(Math.min(da, db)), e = new Date(Math.max(da, db))
            let y = e.getUTCFullYear() - s.getUTCFullYear(), mo = e.getUTCMonth() - s.getUTCMonth(), d = e.getUTCDate() - s.getUTCDate()
            if (d < 0) { mo -= 1; d += new Date(Date.UTC(e.getUTCFullYear(), e.getUTCMonth(), 0)).getUTCDate() }   // дней в месяце перед месяцем e
            if (mo < 0) { y -= 1; mo += 12 }
            const parts = []   // IE 2026 09 24 / ODOO-341407: единицы под язык интерфейса (бейдж — только показ; en — как было: «+1y 2m»)
            if (y) parts.push(durUnit(y, 'y'))
            if (mo) parts.push(durUnit(mo, 'm'))
            if (d) parts.push(durUnit(d, 'd'))
            return { text: (up ? '+' : '\u2212') + parts.slice(0, 2).join(' '), up }
        },
        chgDelta(rowStack, isPct=false) {
            const _dd = this.chgDelta_date(rowStack.val0 !== undefined ? rowStack.val0 : rowStack.val, rowStack.newVal)   // IE 2026 09 10 / ODOO-… (замечание Игоря): даты — календарём
            if (_dd !== undefined) return _dd
            const num = v => {
                if (v === null || v === undefined || v === '') return null
                const n = typeof v === 'number' ? v
                    : parseFloat(String(v).replace(/[\s\u00a0]/g, '').replace(',', '.'))
                return Number.isFinite(n) ? n : null
            }
            // IE 2026 08 21 / ODOO-5512: базой дельты служит начало ЦЕПОЧКИ правок
            // ячейки (val0), если оно есть — бейдж показывает итог, а не последний шаг
            const a = num(rowStack.val0 !== undefined ? rowStack.val0 : rowStack.val), b = num(rowStack.newVal)
            if (a === null && b === null) return null
            const d = (b === null ? 0 : b) - (a === null ? 0 : a)
            if (!d) return null
            const abs = Math.abs(d)
            let short
            if (isPct) {
                // IE 2026 08 18 / ODOO-5512 (Игорь): процентная ячейка хранит долю
                // (0.0511) — дельту показываем в процентных пунктах, а не «−0»
                const pp = abs * 100
                short = (pp >= 10 ? String(Math.round(pp)) : String(Math.round(pp * 100) / 100)) + '%'
            } else if (abs >= 1000) {
                short = this.store.formatCount(Math.round(abs))
            } else if (abs < 0.01) {
                short = Number(abs.toPrecision(2)).toString() // 0.0024, не «0»
            } else {
                short = String(Math.round(abs * 100) / 100)
            }
            return { text: (d > 0 ? '+' : '\u2212') + short, up: d > 0 }
        },
        badgePillFlip_apply(e_cell, e_row) {
            // IE 2026 08 24 / ODOO-5884 (замечание Игоря): у первой видимой строки hover-таблетка бейджа
            // уходила ПОД шапку таблицы — у верхнего края разворачиваем её ВНИЗ ячейки
            try {
                if (e_row != null && this.flex && e_row <= (this.flex.viewRange?.topRow ?? 0)) wjcCore.addClass(e_cell, 'badge-pill-flip')
                else wjcCore.removeClass(e_cell, 'badge-pill-flip')
            } catch (e) { /* viewRange может быть недоступен на раннем рендере */ }
        },
        // IE 2026 09 10 / ODOO-5800: параметры длительности для parseTime/formatTimeHTML — описание поля (V) поверх
        // колонки: формат, единица хранения и единица ввода берутся у поля, если у него заданы
        durationAttr_merge(attr_col, V) {
            if (!V || V === attr_col) return attr_col
            return {
                ...attr_col,
                attr_type: V.attr_type || attr_col?.attr_type,
                format: V.format ?? attr_col?.format,
                unit: V.unit ?? attr_col?.unit,
                input_unit: V.input_unit ?? attr_col?.input_unit,
            }
        },
        // IE 2026 09 10 / ODOO-5800: ячейка, типизированная СТРОКОЙ как длительность (мера строки measure_in_dataItem,
        // transpose-мера / объект-значение) при колонке другого типа — описание для парсинга ввода, как в formatItem;
        // null, если тип задаёт сама колонка или строка не длительность
        editCell_durationAttr(dataItem, col_binding, attr_col) {
            let src = null
            try {
                if (attr_col?.measure_in_dataItem) {
                    const m = dataItem?.measure || this.get_measure_(dataItem)
                    if (m?.attr_type) src = m
                }
                const mT = this.transpose_measure(attr_col, dataItem)
                if (mT) {
                    const cellT = this.transpose_cellObject(this.store.get_value(dataItem, col_binding))
                    src = (cellT?.attr_type ? cellT : null) || (mT.attr_type ? mT : null) || src
                }
            } catch (e) { return null }
            if (!src || (src.attr_type !== 'AttrTime' && src.attr_type !== 'AttrDays')) return null
            return this.durationAttr_merge(attr_col, src)
        },
        cmpCellType(dataItem, col_binding) {
            // IE 2026 08 25 / ODOO-5884: тип и единица ячейки для бейджей сравнения — как в formatItem/выделении:
            // колонка → мера строки (measure_in_dataItem) → transpose-мера
            let type = null, unit = null, format = null
            try {
                const base = String(col_binding || '').split('.')[0]
                const attr_col = this.attr_by_binding?.[col_binding] || this.attr_by_binding?.[base]
                type = attr_col?.attr_type; unit = attr_col?.unit; format = attr_col?.format
                if (attr_col?.measure_in_dataItem) {
                    const m = dataItem?.measure || this.get_measure_(dataItem)
                    if (m?.attr_type) { type = m.attr_type; unit = m.unit; format = m.format || format }
                }
                const mT = this.transpose_measure(attr_col, dataItem)
                if (mT) { type = mT.attr_type || type; unit = mT.unit || unit; format = mT.format || format }
                // поле внутри ячейки-контейнера ('2026-07-01.offset'): длительности живут в offset/duration
                const fld = String(col_binding || '').split('.').slice(1).join('.')
                if (fld && /(^|\.)(offset|duration|lead_time|cycle)$/i.test(fld)) type = type || 'AttrTime'
            } catch (e) { /* тип не определён — обычное число */ }
            return { type, unit, format }
        },
        cmpBadge_apply(e_cell, dataItem, col_binding, e_row) {
            // IE 2026 08 24 / ODOO-5884 (заказ Игоря): режим «Mark changes» — отклонение от сравниваемой
            // процессной модели бейджем в САМОЙ ячейке (индиго); ручные правки текущей сессии приоритетнее
            const cc = dataItem?._DLRow?.cmp_cells
            const d = (cc && col_binding && !this.cellBlank(dataItem, col_binding)) ? cc[col_binding] : null   // IE 2026 10 07 / ODOO-5800: у погашенной ячейки отклонения от модели сравнения не показываем — значения нет
            const clear = () => { e_cell.removeAttribute('data-cmp-delta'); wjcCore.removeClass(e_cell, 'cmp-cell-badge') }
            if (!d) { clear(); return }
            if (e_cell.hasAttribute('data-chg-delta')) { clear(); return }
            if (d.text) {
                // IE 2026 08 26 / ODOO-5800 (замечание Игоря): нечисловое отличие (модель пополнения, статус,
                // ссылка) — бейдж «≠», в тултипе значение сравниваемой модели (title ссылки, если резолвится)
                e_cell.setAttribute('data-cmp-delta', '\u2260')
                wjcCore.addClass(e_cell, 'cmp-cell-badge')
                this.badgePillFlip_apply(e_cell, e_row)
                const pv = (d.prev === null || d.prev === undefined || d.prev === '') ? '\u2014' : String(d.prev_title || d.prev)
                e_cell.title = t('Compared model: {value}', { value: pv })   // IE 2026 09 23 / ODOO-341407: i18n
                this.cmpGhostValue_apply(e_cell, dataItem, pv, false)   // IE 2026 10 30 / ODOO-5800 (compare: ghost cell shows prev value)
                return
            }
            const abs = Math.abs(d.delta)
            // IE 2026 08 25 / ODOO-5884 (замечание Игоря «отклонение в натуральном выражении»): дельту и
            // значение сравниваемой модели показываем В ЕДИНИЦАХ ЯЧЕЙКИ — длительности (AttrTime/AttrDays,
            // в ячейке '28m' / '7d') форматируем тем же formatTimeHTML, а не сырыми секундами
            const cmpFmt = (v) => {
                const t = this.cmpCellType(dataItem, col_binding)
                if (t.type === 'AttrTime') return this.store.formatTimeHTML(t.unit === 'ms' ? v / 1000 : v, { format: t.format })
                if (t.type === 'AttrDays') return this.store.formatTimeHTML(v * 86400, { format: t.format })
                // IE 2026 08 25 / ODOO-5884 (замечание Игоря): короткое user-friendly значение в бейдже —
                // 6765 → «6.8K», 17 240 → «17K», 1 240 000 → «1.2M» (store.formatCount сокращает только от 100K)
                if (v >= 1e9) return (v / 1e9).toFixed(1) + 'B'
                if (v >= 1e6) return (v / 1e6).toFixed(1) + 'M'
                if (v >= 1e4) return Math.round(v / 1e3) + 'K'
                if (v >= 1e3) return (v / 1e3).toFixed(1) + 'K'
                return String(Math.round(v * 100) / 100)
            }
            const short = cmpFmt(abs)
            e_cell.setAttribute('data-cmp-delta', (d.delta > 0 ? '+' : '\u2212') + short)
            wjcCore.addClass(e_cell, 'cmp-cell-badge')
            this.badgePillFlip_apply(e_cell, e_row)
            const rel = (d.rel === null || d.rel === undefined) ? '' : ' (' + (d.rel > 0 ? '+' : '\u2212') + Math.round(Math.abs(d.rel) * 1000) / 10 + '%)'
            // IE 2026 08 25 / ODOO-5884 (замечание Игоря): в бейдже — короткое user-friendly значение (+7K),
            // в расшифровке (тултип) — ТОЧНЫЕ числа: значение сравниваемой модели и сама дельта
            const exact = (v) => {
                const t = this.cmpCellType(dataItem, col_binding)
                if (t.type === 'AttrTime') return this.store.formatTimeHTML(t.unit === 'ms' ? v / 1000 : v, { format: t.format })
                if (t.type === 'AttrDays') return this.store.formatTimeHTML(v * 86400, { format: t.format })
                const neg = v < 0, r = Math.round(Math.abs(v) * 100) / 100
                const [i_, f_] = String(r).split('.')
                return (neg ? '\u2212' : '') + i_.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + (f_ ? ',' + f_ : '')
            }
            const prevTxt = (d.prev === null || d.prev === undefined) ? '\u2014'
                : (typeof d.prev === 'number' ? exact(d.prev) : String(d.prev))
            e_cell.title = t('Compared model: {value}', { value: prevTxt + rel + '   \u0394 ' + (d.delta > 0 ? '+' : '') + exact(d.delta) })   // IE 2026 09 23 / ODOO-341407: i18n
            // IE 2026 10 30 / ODOO-5800 (compare: ghost cell shows prev value): у строки-призрака текущего значения нет — в ячейке само значение сравниваемой модели
            // (длительности exact() уже отдаёт разметкой formatTimeHTML — без экранирования)
            if (dataItem?._DLRow?.cmp_prev_only) {   // IE 2026 10 30 / ODOO-5800 (compare: ghost cell shows prev value)
                const _gt = this.cmpCellType(dataItem, col_binding).type   // IE 2026 10 30 / ODOO-5800 (compare: ghost cell shows prev value)
                this.cmpGhostValue_apply(e_cell, dataItem, prevTxt, _gt === 'AttrTime' || _gt === 'AttrDays')   // IE 2026 10 30 / ODOO-5800 (compare: ghost cell shows prev value)
            }
        },
        cmpGhostValue_apply(e_cell, dataItem, text, isHtml) {
            // IE 2026 10 30 / ODOO-5800 (compare: ghost cell shows prev value) (письмо ie-dm7 #118069, ожидание Игоря «40 000 в самой ячейке»):
            // строка есть только в сравниваемой модели (_DLRow.cmp_prev_only) → текущее значение пусто, wijmo рисует пустую ячейку, а бейдж
            // отклонения и тултип значения не заменяют. Пустую ячейку призрака заполняем значением сравниваемой модели зачёркнутым
            // (класс cmp-prev-only-value; серый курсив — от строки row-compare-prev-only). Непустую ячейку (под-строки ≡ prev / Δ / Δ%,
            // подмена содержимого правилом) не трогаем. Вызывается с каждого пути отрисовки (в т.ч. кэш-пути formatItem): контент в кэше не живёт
            if (!dataItem?._DLRow?.cmp_prev_only) return false
            if (text === null || text === undefined || text === '' || text === '\u2014') return false
            if (String(e_cell.textContent || '').trim() !== '') return false
            e_cell.innerHTML = '<span class="cmp-prev-only-value">' + (isHtml ? String(text) : wjcCore.escapeHtml(String(text))) + '</span>'
            return true
        },
        cowBadge_apply(e_cell, dataItem, col_binding, e_row) {
            // IE 2026 08 24 / ODOO-5884 (заказ Игоря): дифф-бейджи «Branch copy против рабочей версии» у полей
            // формы записи — как бейджи текущих правок, но своим (индиго) цветом; данные — WIDGET.cow.field_deltas
            const fd = this.WIDGET?.cow?.mode === 'copy' ? this.WIDGET.cow.field_deltas : null
            if (!fd) return
            if (col_binding !== 'attr.valueStr' && col_binding !== 'attr.value') return
            const b = dataItem?.attr?.binding
            const d = b && fd[b]
            const clear = () => { e_cell.removeAttribute('data-cow-delta'); wjcCore.removeClass(e_cell, 'cow-diff-badge') }
            if (!d) { clear(); return }
            // текущая несохранённая правка приоритетнее — веточный бейдж не перекрывает
            if (e_cell.hasAttribute('data-chg-delta')) { clear(); return }
            e_cell.setAttribute('data-cow-delta', d.text)
            wjcCore.addClass(e_cell, 'cow-diff-badge')
            this.badgePillFlip_apply(e_cell, e_row)
            e_cell.title = t('Working version: {value}', { value: d.working === '' ? '\u2014' : d.working })   // IE 2026 09 23 / ODOO-341407: i18n
        },
        // ---- IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: подсветка изменений записи из аудита) ----
        // Форма «Audit restore» (WIDGET.audit_diff от бэка): изменённые поля шапки (AttrTabGrid, ключ attr.binding) и ячейки / строки
        // табличных частей (грид с attr.binding ТЧ, индекс строки — позиция в массиве записи) против следующей (по умолчанию) или
        // предыдущей версии; режимы badges | diff | full. Строки записи НЕ меняются: скрытие — набором объектов контекста (иначе
        // служебный ключ уехал бы в Restore). Контекст пересобирается при смене разницы / режима / стороны / набора строк.
        auditDiff_ctx() {
            const diff = this.WIDGET?.audit_diff
            if (!diff || typeof diff !== 'object') { this._adfCtx = null; return null }
            const tabGrid = this.attr?.attr_type === 'AttrTabGrid'
            const src = tabGrid ? this.data : (this.flex?.collectionView?.sourceCollection || null)
            let stored = null
            const c = this._adfCtx
            if (c && c.diff === diff && c.src === src && c.view_user === diff.view_user && c.against_user === diff.against_user && c.gen === (diff._adfGen || 0)) return c.on ? c : null
            try { stored = window.localStorage?.getItem(ADF_VIEW_KEY) } catch (e) { stored = null }
            const on = adf_on((k, d) => this.store.setting(k, d))
            const against = adf_againstOf(diff)
            const view = adf_viewOf(diff, stored)
            const idx = on ? adf_index(adf_block(diff, against), against) : null
            const table = tabGrid ? null : String(this.attr?.binding || '')
            const ctx = { diff, src, view_user: diff.view_user, against_user: diff.against_user, gen: diff._adfGen || 0, on: !!(on && idx?.ok),
                tabGrid, table, against, view, idx, rowIdx: null, hide: null, firstCol: null }
            if (ctx.on && !tabGrid && Array.isArray(src) && idx.table(table)) {
                ctx.rowIdx = new WeakMap()
                src.forEach((r, i) => { if (r && typeof r === 'object') ctx.rowIdx.set(r, i) })
                if (idx.isResized(table)) ctx.firstCol = (this.flex?.columns || []).find(col => col.visible)?.binding || null
            }
            if (ctx.on && view === 'diff') {
                ctx.hide = tabGrid ? adf_tabRowsHidden(src, idx, view) : (ctx.rowIdx ? adf_tableRowsHidden(src, idx, table, view) : null)
            }
            this._adfCtx = ctx
            return ctx.on ? ctx : null
        },
        auditDiff_hidden(dataItem) {
            if (!dataItem || typeof dataItem !== 'object') return false
            const c = this.auditDiff_ctx()
            return !!c?.hide?.has(dataItem)
        },
        // IE 2026 10 31 / ODOO-349799 (заказ Игоря: переход ‹ › по изменениям аудита): строка / колонка / вкладка с изменением не считаются пустыми, пока активно сравнение
        // (isEmpty, apply_CHIPS_columns, check_attrTab) — как nonEmpty_keepRows; режим «Hide empty rows, columns, tabs» их не прячет
        auditDiff_keepRow(dataItem) {
            if (!dataItem || typeof dataItem !== 'object') return false
            const c = this.auditDiff_ctx()
            if (!c) return false
            if (c.tabGrid) return !!c.idx.field(dataItem.attr?.binding)
            const i = c.rowIdx?.get(dataItem)
            return i !== undefined && !!c.idx.rowState(c.table, i)
        },
        auditDiff_keepCol(binding) {
            const c = this.auditDiff_ctx()
            return !!(c && !c.tabGrid && binding && c.idx.colChanged(c.table, binding))
        },
        auditDiff_keepTab() {
            const c = this.auditDiff_ctx()
            return !!(c && !c.tabGrid && c.idx.table(c.table))
        },
        auditDiffBadge_apply(e_cell, dataItem, col_binding, e_row) {
            const had = e_cell.classList.contains('audit-diff-badge') || e_cell.classList.contains('audit-row-added') || e_cell.classList.contains('audit-row-removed')
            const ctx = this.WIDGET?.audit_diff ? this.auditDiff_ctx() : null
            const clearBadge = () => {
                if (!e_cell.classList.contains('audit-diff-badge')) return
                e_cell.removeAttribute('data-adf-delta'); wjcCore.removeClass(e_cell, 'audit-diff-badge')
                if (e_cell.__adfTip) { e_cell.title = ''; e_cell.__adfTip = false }
            }
            if (!ctx) { if (had) { clearBadge(); wjcCore.removeClass(e_cell, 'audit-row-added audit-row-removed') } return }
            let d = null, rowCls = ''
            if (ctx.tabGrid) {
                if (col_binding === 'attr.valueStr' || col_binding === 'attr.value') d = ctx.idx.field(dataItem?.attr?.binding)
            } else {
                const i = ctx.rowIdx?.get(dataItem)
                if (i !== undefined) {
                    const st = ctx.idx.rowState(ctx.table, i)
                    if (st === 'added' || st === 'removed') rowCls = 'audit-row-' + st
                    d = ctx.idx.cell(ctx.table, i, col_binding)
                    if (!d && st === 'resized' && i === 0 && col_binding && col_binding === ctx.firstCol) d = { nested: true, resized: ctx.idx.isResized(ctx.table) }
                }
            }
            wjcCore.removeClass(e_cell, 'audit-row-added audit-row-removed')
            if (rowCls) wjcCore.addClass(e_cell, rowCls)
            // текущая несохранённая правка приоритетнее (в форме аудита правок не бывает — запись только для чтения)
            if (!d || e_cell.hasAttribute('data-chg-delta')) { clearBadge(); return }
            e_cell.setAttribute('data-adf-delta', adf_badgeText(d))
            wjcCore.addClass(e_cell, 'audit-diff-badge')
            this.badgePillFlip_apply(e_cell, e_row)
            e_cell.title = d.resized ? adf_resizedText(d.resized) : adf_tipText(d, ctx.against)
            e_cell.__adfTip = true
        },
        // смена режима / стороны (Widget.vue auditDiff_setView / auditDiff_setAgainst): контекст заново, проход видимости, перерисовка
        auditDiff_refresh() {
            this._adfCtx = null
            if (!this.flex) return
            for (const r of this.flex.rows || []) { const d = r?.dataItem; if (d?._fe) d._fe.visible = undefined }
            try { this.apply_CHIPS() } catch (e) { /* грид в перестройке */ }
            try { this.flex.invalidate() } catch (e) { /* грид в перестройке */ }
        },
        // переход к цели навигации ‹ › / записи списка «Full comparison»: true — цель в этом гриде найдена и выделена (или показано, что поле скрыто)
        // IE 2026 10 31 / ODOO-349799 (заказ Игоря): вкладки-контейнеры (включая вложенные панели) открывает форма (Widget.auditDiff_goto → auditDiff_openTabs); здесь —
        // поиск строки / колонки, выделение после отрисовки (nextTick + повтор после раскладки показанной вкладки), подсветка ячейки (flash).
        // Колонка выключена настройкой вида или строка поля спрятана — уведомление «Field X is hidden in this view», колонки / поля не включаем
        auditDiff_goto(target) {
            const ctx = this.WIDGET?.audit_diff ? this.auditDiff_ctx() : null
            if (!ctx || !target || !this.flex) return false
            const rows = this.flex.rows || [], cols = this.flex.columns || []
            let r = -1, c = -1, hidden = null
            const quiet = !!target.silent   // IE 2026 10 31 / ODOO-349799: повторный проход Widget.auditDiff_goto после пересборки грида — без уведомлений; target.changed — выделение пришлось ставить
            if (ctx.tabGrid) {
                if (target.kind !== 'field') return false
                // проба dev02 31.10: цель-перевод (title_uk) — строка «Title (uk)» (binding meta.title_uk), если опция «Show translation fields» включена; иначе основное поле + подсказка
                const want = target.i18n?.rowBinding
                let i18nHidden = null
                r = want ? rows.findIndex(x => x?.dataItem?.attr?.binding === want) : -1
                if (r < 0 && want && target.i18n.strict) return false   // IE 2026 10 31 / ODOO-349799: строки «(uk)» включены, но не в этой полосе / гриде — основное поле не брать (его строка может лежать в соседней полосе)
                if (r < 0) {
                    r = rows.findIndex(x => x?.dataItem?.attr?.binding === target.binding)
                    if (r >= 0 && want) i18nHidden = (rows[r].dataItem?.attr?.title || target.binding) + ' (' + target.i18n.lang + ')'
                }
                c = cols.findIndex(x => x.binding === 'attr.valueStr' || x.binding === 'attr.value')
                if (r < 0) {
                    // поле формы есть в описании (attr.attrs), а строки в гриде нет — спрятано видом; строки ещё не построены (rows пуст) — пусть форма повторит
                    if (!rows.length) return false
                    const path = adf_attrPath(this.attr?.attrs, (a) => a.binding === target.binding && a.attr_type !== 'AttrGrid', { noDescend: ADF_FIELD_NODESCEND })
                    if (!path) return false
                    hidden = path[path.length - 1]
                    if (!quiet) this.store.show_notification({ text: adf_hiddenText(hidden.title || hidden.binding), status: 'info' })   // IE 2026 10 31 / ODOO-349799
                    return true
                }
                if (i18nHidden && !quiet) this.store.show_notification({ text: adf_i18nHiddenText(i18nHidden), status: 'info' })   // IE 2026 10 31 / ODOO-349799
            } else {
                if (target.table !== ctx.table || !ctx.rowIdx) return false
                r = rows.findIndex(x => x?.dataItem && ctx.rowIdx.get(x.dataItem) === target.row)
                if (target.col) {
                    c = cols.findIndex(x => x.binding === target.col || String(x.binding || '').split('.')[0] === target.col)
                    if (c >= 0 && cols[c].visible === false) { hidden = cols[c].header || target.col; c = -1 }
                }
                if (c < 0) c = cols.findIndex(x => x.visible)
            }
            if (r < 0) return false
            if (c < 0) c = 0
            this.auditDiff_expandTo(rows, r)   // проба dev02 31.10: строка в свёрнутой группе (вкладка-группа SFTP формы / группа ТЧ) — раскрыть предков, не считать скрытой
            if (rows[r].visible === false) {   // строка спрятана отбором (чипс, выключенная use) — сообщить, не включать
                if (quiet) return true   // IE 2026 10 31 / ODOO-349799
                const di = rows[r].dataItem
                this.store.show_notification({ text: adf_hiddenText(ctx.tabGrid ? (di?.attr?.title || target.binding) : t('{table} · row {row}', { table: ctx.table.replace(/^_?doc\./, ''), row: target.row + 1 })), status: 'info' })
                return true
            }
            if (quiet) {   // IE 2026 10 31 / ODOO-349799: выделение уже на цели — ничего не делаем; иначе (грид пересобран) ставим его заново, с подсветкой
                let at = null
                try { at = this.flex.selection } catch (e) { /* грид в перестройке */ }
                if (at && at.row === r && at.col === c && at.row2 === r && at.col2 === c) return true
                target.changed = true
            } else {
                if (hidden) this.store.show_notification({ text: adf_hiddenText(hidden), status: 'info' })
                this.auditDiff_showTab()
            }
            const binding = cols[c]?.binding
            const go = () => {
                try { this.flex.select(new wjGrid.CellRange(r, c), true); this.flex.scrollIntoView(r, c) } catch (e) { /* грид в перестройке */ }
            }
            this.$nextTick(() => {
                go()
                try { if (binding) this.flash_start([{ irow: r, binding }]) } catch (e) { /* подсветка не обязательна */ }
            })
            setTimeout(go, this.store.setting('fe.ux.auditRecordDiff.gotoSettleMs', 80))   // после раскладки только что показанной вкладки
            return true
        },
        // IE 2026 10 31 / ODOO-349799 (PR3, заказ Игоря «как в 1С»): связь строк вкладки «Changes» (binding _doc.compare_changes; строка несёт target бэка) с формой —
        // Widget.compareMerge_* (флаг fe.ux.compareMerge.linkRows). Смена выделения указателем (клик / тап; не клавиши, не возврат выделения, не шина страницы):
        // в гриде «Changes» — строка → форма (кроме колонки Use: пользователь ставит флажки; пауза gotoDelayMs, двойной клик её отменяет);
        // в гриде формы с разницей (WIDGET.audit_diff) — одиночная ячейка с изменением → запомнить цель (позиция ‹ ›, строка «Changes»)
        compareMerge_form() { const f = this.WIDGET?.attrs_vueObj?.WIDGET; return (f && typeof f.compareMerge_mark === 'function') ? f : null },
        compareMerge_selHook(flex) {
            const form = this.compareMerge_form()
            if (!form || !cm_on((k, d) => this.store.setting(k, d))) return
            if (!this.selUser_now() || this._selRestore || this.isFrom_selectionWorkspace || !cm_pointerEvt(this._selUserEvt)) return
            const sr = flex?.selectedRanges?.[0]
            if (!sr || sr.row < 0 || sr.col < 0 || sr.row !== sr.row2 || sr.col !== sr.col2) return
            const di = flex.rows?.[sr.row]?.dataItem, col = flex.columns?.[sr.col]
            if (!di || typeof di !== 'object') return
            if (this.attr?.binding === CM_ROWS_BINDING) {
                if (col?.binding === 'use' || this.store.setting('fe.ux.compareMerge.gotoOnSelect', true) === false) return
                clearTimeout(this._cmGoTimer)
                this._cmGoTimer = setTimeout(() => { if (flex?.hostElement) form.compareMerge_gotoRow(di) }, this.store.setting('fe.ux.compareMerge.gotoDelayMs', 200))
                return
            }
            if (!this.WIDGET?.audit_diff) return
            const target = cm_targetOf(this.auditDiff_ctx(), di, col?.binding)
            if (target) form.compareMerge_mark(target)
        },
        // двойной клик по строке данных «Changes» (execute_dblclick): к ячейке формы сразу; true — обработано
        compareMerge_dblclick(m) {
            const form = this.compareMerge_form()
            if (!form || !this.flex || !cm_on((k, d) => this.store.setting(k, d))) return false
            let ht = null
            try { ht = (m && typeof m.clientX === 'number') ? this.flex.hitTest(m) : null } catch (e) { ht = null }
            const r = ht ? ht.row : this.flex.selection?.row
            const di = (r >= 0 && (!ht || ht.panel === this.flex.cells || ht.panel === this.flex.rowHeaders)) ? this.flex.rows[r]?.dataItem : null
            if (!di || typeof di !== 'object' || di instanceof wjcCore.CollectionViewGroup) return false
            clearTimeout(this._cmGoTimer)
            form.compareMerge_gotoRow(di)
            return true
        },
        // строка «Changes» по ключу цели (Widget.compareMerge_selectRow): одиночное выделение первой видимой колонки после Use, без подсветки; программно —
        // selectionChanged пропускается (ignore_selectionChanged). false — строк ещё нет (ленивая вкладка монтируется); нет такой строки — true, повторять нечего
        compareMerge_selectByKey(key, scroll = false) {
            const flex = this.flex, rows = flex?.rows || []
            if (!flex || !key || !rows.length) return false
            const r = rows.findIndex(x => x?.dataItem && adf_targetKey(cm_rowTarget(x.dataItem)) === key)
            if (r < 0) return true
            const cols = flex.columns || []
            let c = cols.findIndex(x => x.visible && x.binding !== 'use')
            if (c < 0) c = Math.max(0, cols.findIndex(x => x.visible))
            const at = flex.selection
            if (!(at && at.row === r && at.col === c && at.row2 === r && at.col2 === c)) {
                this.ignore_selectionChanged = true
                try { flex.select(new wjGrid.CellRange(r, c), scroll) } catch (e) { /* грид в перестройке */ } finally { this.ignore_selectionChanged = false }
            }
            if (scroll) { try { flex.scrollIntoView(r, c) } catch (e) { /* скрытая вкладка */ } }
            return true
        },
        // IE 2026 10 31 / ODOO-349799: свёрнутые группы над строкой r (tree-грид формы: AttrTab-группа в AttrTabGrid; группы ТЧ: GroupRow) — раскрыть; true — что-то раскрыли
        auditDiff_expandTo(rows, r) {
            const lv = (x) => (x && typeof x.level === 'number' && x.level >= 0) ? x.level : null
            let need = lv(rows[r]), opened = false
            if (need === null) need = Infinity
            for (let i = r - 1; i >= 0 && need > 0; i--) {
                const g = rows[i]
                if (!g || !(g.hasChildren || (typeof wjGrid !== 'undefined' && wjGrid.GroupRow && g instanceof wjGrid.GroupRow))) continue
                const l = lv(g)
                if (l === null || l >= need) continue
                if (g.isCollapsed) { try { g.isCollapsed = false; opened = true } catch (e) { /* не tree-строка */ } }
                need = l
            }
            return opened
        },
        // вкладки, в которых лежит грид, — сделать активными (все панели по пути, включая вложенные; как cascadeInd_open); нет пути — ближайшая панель
        auditDiff_showTab() {
            const form = this.WIDGET?.attrs_vueObj?.WIDGET
            if (form && typeof form.auditDiff_openTabs === 'function' && this.attr_id != null) {   // IE 2026 10 31 / ODOO-349799
                const path = adf_attrPath(this.WIDGET?.view, (a) => a.id === this.attr_id)
                if (path) { form.auditDiff_openTabs(adf_tabSteps(path)); return }
            }
            const pa = this.parent_attr
            if (!pa) return
            for (const v of Object.values(this.WIDGET?.attrs_vueObj || {})) {
                const i = (v?.tabPanel && ('tabAttrs' in v) && Array.isArray(v.tabAttrs)) ? v.tabAttrs.indexOf(pa) : -1
                if (i >= 0 && v.tabPanel.selectedIndex !== i) { v.tabPanel.selectedIndex = i; return }
            }
        },
        chgBadge_apply(e_cell, rowStack) {
            // процентность — по формату колонки (pN) или по тексту самой ячейки
            const attr_col = this.attr_by_binding?.[rowStack.col_binding]
            const fmt = String(attr_col?.format || '')
            const isPct = /^p\d*$/i.test(fmt) || /%/.test(e_cell.textContent || '')
            const d = this.chgDelta(rowStack, isPct)
            if (!d) { this.chgBadge_clear(e_cell); return }
            e_cell.setAttribute('data-chg-delta', d.text)
            wjcCore.addClass(e_cell, d.up ? 'chg-badge-up' : 'chg-badge-down')
            wjcCore.removeClass(e_cell, d.up ? 'chg-badge-down' : 'chg-badge-up')
            if (rowStack.actionStack != null) {
                e_cell.setAttribute('data-chg-grp', String(rowStack.actionStack))
            }
        },
        ddNode_attach(e_cell, dataItem, col_binding, e_row, e_col) {
            // IE 2026 08 19 / ODOO-5512 (заказ Игоря): линия к расшифровочному виджету
            // идёт от ЯЧЕЙКИ — при отрисовке ячейки-якоря (строка с _fe['@@dd_node'] и
            // её колонка) перевешиваем node.div на живой элемент (ячейки переиспользуются)
            const dd = dataItem?._fe?.['@@dd_node']
            if (!dd || dd.binding !== col_binding) return
            const node = this.PAGE?.nodes_svg?.[dd.key]
            if (!node) return
            if (node.div !== e_cell || node.row !== e_row || node.col !== e_col) {
                node.div = e_cell
                node.row = e_row
                node.col = e_col
                node.join = 'top-left' // из верхнего левого угла выделения (Игорь 19.08)
                this.PAGE.vueObj?.refreshe_svg?.()
            }
        },
        chgBadge_clear(e_cell) {
            if (e_cell.hasAttribute('data-chg-delta')) e_cell.removeAttribute('data-chg-delta')
            if (e_cell.hasAttribute('data-chg-grp')) e_cell.removeAttribute('data-chg-grp')
            wjcCore.removeClass(e_cell, 'chg-badge-up')
            wjcCore.removeClass(e_cell, 'chg-badge-down')
        },
        flash_start(list) {
            if (!list || !list.length) return
            const keys = new Set()
            const seen = new Map() // строка (по ссылке) -> колонки: счёт ЯЧЕЕК
            for (const it of list) {
                if (typeof it === 'string') { keys.add(it); continue }
                let irow = it.item != null ? this.rows_indexOf(it.item) : it.irow
                if (irow == null || irow < 0) irow = it.irow
                keys.add(`${irow}:${it.binding}`)
                const k = it.item || irow
                let cols = seen.get(k)
                if (!cols) seen.set(k, cols = new Set())
                cols.add(it.binding)
            }
            let n = 0
            for (const cols of seen.values()) n += cols.size
            if (!n) n = keys.size
            if (!keys.size) return
            const visible = this.flash_countVisible(keys)
            const quiet = visible > 30 // больше трёх десятков в кадре — только сводка
            this._flashBatch = { keys, ts: Date.now(), quiet, n }
            if (quiet || n >= 5) this.flash_summary(n)
        },
        flash_countVisible(set) {
            const flex = this.flex
            if (!flex || !flex.columns) return 0
            let rc = null
            try { rc = flex.viewRange } catch (e) { rc = null }
            const vis = new Set()
            for (const c of flex.columns) {
                if (c.isVisible !== false && (c.renderWidth == null || c.renderWidth > 0)) vis.add(String(c.binding))
            }
            let n = 0
            for (const k of set) {
                const i = k.indexOf(':')
                if (i < 0) continue
                if (rc) {
                    const r = +k.slice(0, i)
                    if (r < rc.topRow || r > rc.bottomRow) continue
                }
                if (vis.has(k.slice(i + 1))) n++
            }
            return n
        },
        flash_applyDirect() {
            // IE 2026 09 04 / ODOO-336379: применить красный флеш _flashOverride к уже отрисованным
            // ячейкам напрямую (без перерисовки грида). Возвращает число ячеек; -1 — нет грида
            const fo = this._flashOverride
            const flex = this.flex
            if (!fo || !flex?.cells) return -1
            let n = 0
            for (const key of fo.keys) {
                const i = key.indexOf(':')
                if (i < 0) continue
                const irow = +key.slice(0, i), binding = key.slice(i + 1)
                const col = flex.columns.getColumn ? flex.columns.getColumn(binding) : null
                if (!col) continue
                const e_cell = this.divCells.get(`${flex.cells.cellType}-${irow}-${col.index}`)
                if (e_cell) { this.flash_apply(e_cell, key); n++ }
            }
            return n
        },
        flash_apply(e_cell, key_stack) {
            // IE 2026 09 02 / ODOO-11316 (заказ Игоря): перебитая пересчётом ячейка —
            // КРАСНАЯ вспышка с затуханием, приоритетнее обычной жёлтой
            const fo = this._flashOverride
            if (fo && fo.keys.has(key_stack)) {
                const age = Date.now() - fo.ts
                if (age < 2400) {
                    e_cell.style.animationDelay = `-${age}ms`
                    wjcCore.addClass(e_cell, 'wj-cell-flash-override')
                    wjcCore.removeClass(e_cell, 'wj-cell-flash')
                    return
                }
            }
            wjcCore.removeClass(e_cell, 'wj-cell-flash-override')
            const fb = this._flashBatch
            if (fb && !fb.quiet && fb.keys.has(key_stack)) {
                const age = Date.now() - fb.ts
                if (age < 1400) { // 90 нарастание + 400 удержание + 910 затухание
                    // отрицательная задержка: ячейка, доехавшая прокруткой позже,
                    // продолжает анимацию с нужной фазы, а не мигает заново
                    e_cell.style.animationDelay = `-${age}ms`
                    wjcCore.addClass(e_cell, 'wj-cell-flash')
                    return
                }
            }
            if (e_cell.style.animationDelay) e_cell.style.animationDelay = ''
            wjcCore.removeClass(e_cell, 'wj-cell-flash')
        },
        autoValue_isAuto(dataItem, col_binding) {
            // IE 2026 09 03 / ODOO-11316 (заказ Игоря): СТРОКА таблицы фильтров
            // (вид name=='viewWHERE', doc.params.WHERE), значение которой отчёт подставляет
            // САМ (condition 'in selector' / '!in selector' — из селектора стола; либо
            // вычисляемый Source без ручной корректировки). Сигналы:
            //   rowAuto  — строка авто-значения (тинтуем ВСЕ её ячейки);
            //   isChild  — ПОДЧИНЁННАЯ строка (attrs) in-selector родителя: тинтуем тоже
            //              (замечание Игоря 03.09) — в детях лежат значения, скопированные
            //              бэком из селекторов; правку детей НЕ блокируем;
            //   valueCell — col_binding = колонка Value (rightValue.*) — по ней запрет
            //              ручной правки (только у родителя).
            if (!dataItem) return { auto: false, rowAuto: false, valueCell: false, isChild: false, tip: '' }
            // гейт: только вид фильтров — в других таблицах rightValue легитимно правится
            if ((this.attr && this.attr.name) !== 'viewWHERE') return { auto: false, rowAuto: false, valueCell: false, isChild: false, tip: '' }
            const _inSel = (r) => /in selector/.test(String((r || {}).condition || ''))
            const rv = dataItem.rightValue
            const srcAuto = rv && typeof rv === 'object' && rv.source_field && !rv.manual
            let rowAuto = !!(_inSel(dataItem) || srcAuto)
            let isChild = false
            if (!rowAuto) {
                // ребёнок in-selector родителя: ищем строку, чьи attrs содержат dataItem
                const pools = [Array.isArray(this.data) ? this.data : null,
                               this.flex?.collectionView?.sourceCollection]
                for (const pool of pools) {
                    if (!Array.isArray(pool)) continue
                    const parent = pool.find(pr => pr && Array.isArray(pr.attrs) && pr.attrs.includes(dataItem))
                    if (parent) { isChild = true; rowAuto = _inSel(parent); break }
                }
                if (!rowAuto) return { auto: false, rowAuto: false, valueCell: false, isChild: false, tip: '' }
            }
            const valueCell = /^rightValue(\.|$)/.test(String(col_binding || ''))
            const tip = srcAuto && !_inSel(dataItem) && !isChild   // IE 2026 09 23 / ODOO-341407: i18n
                ? t('This value is recomputed from Source at run time (no manual override) — no need to edit it here')
                : t('This filter row takes its value from the workspace selector at run time — no need to enter a value')
            return { auto: true, rowAuto: true, valueCell, isChild, tip }
        },
        autoValue_apply(e_cell, dataItem, col_binding) {
            // тинтуем каждую отрисованную ячейку авто-строки (Field / If / Value / Selector)
            const { rowAuto, valueCell, tip } = this.autoValue_isAuto(dataItem, col_binding)
            if (rowAuto) {
                wjcCore.addClass(e_cell, 'wj-cell-autovalue')
                // подсказку вешаем на ячейку Value (если она есть) и на условие «in selector»
                if (valueCell || String(col_binding || '') === 'condition') {
                    e_cell.setAttribute('data-autovalue-tip', '1')
                    e_cell.setAttribute('title', tip)
                }
            } else if (e_cell.classList.contains('wj-cell-autovalue')) {
                wjcCore.removeClass(e_cell, 'wj-cell-autovalue')
                if (e_cell.getAttribute('data-autovalue-tip')) {
                    e_cell.removeAttribute('data-autovalue-tip')
                    e_cell.removeAttribute('title')
                }
            }
        },
        autoValue_rejectFlash(irow, col_binding) {
            // IE 2026 09 02 / ODOO-11316 (заказ Игоря): попытка правки авто-ячейки Value —
            // красный флеш с затуханием (тот же механизм, что у перебитого ввода M03),
            // значение при этом не меняется (правка отменена в beginningEdit)
            this._flashOverride = { keys: new Set([`${irow}:${col_binding}`]), ts: Date.now() }
            window.$cg.setTimeout(this, 'AttrGrid.flashOverrideEnd', () => { this._flashOverride = null }, 2600)
            this.flexRefresh()
            const W = this.WIDGET
            const text = t('This value is set automatically at run time — it cannot be edited here.')   // IE 2026 09 23 / ODOO-341407: i18n
            if (W?.notification) {
                W.notification.header = ''
                W.notification.text = text
                W.notification.status = 'warning'
                W.notification.visible = true
            }
            this.store.show_notification({ text, status: 'warning' })
        },
        // IE 2026 09 04 / ODOO-335315 (заказ Игоря): грид отклонил правку как нередактируемую
        // (cellEditEnding2 / очистка Delete / вставка) — раньше молча возвращал старое значение
        // (флажок «сам снимался»). Теперь: тот же дуэт, что у перебитого ввода и авто-ячейки Value
        // (красный флеш + плашка виджета + тост + строка TERMINAL), ОДНО уведомление на действие
        // пользователя (вставка 12 ячеек / read-only роль — не шквал), причина — из класса
        // noedit-<code>, который отдаёт python отчёта рядом с editable, иначе эвристика для колонок
        // согласования M03 (порядок ПМ → БЮМ → МД, право access-Approved*), иначе нейтральный текст.
        // Выключатель без рестарта: window.rejectNotify.set(false) (perf-flags 'reject_notify').
        readOnly_reason(irow, icol) {
            const flex = this.flex, col = flex?.columns?.[icol]
            const attr_col = col ? this.attr_by_binding[col.binding] : null
            const title = attr_col?.title || col?.header || col?.binding || ''
            const dataItem = flex?.rows?.[irow]?.dataItem
            const q = (t) => `"${t}"`
            // IE 2026 10 09 / ODOO-345618 (заказ Игоря: согласование на сегменте): замок согласования — причина бэка (approval.reason) текстом, как у прочих отказов
            const _apl = dataItem ? this.approval_lock(dataItem) : null
            if (_apl) return { code: 'approval-lock', text: `${q(title)}: ${approvalLockReason(_apl.reason, _apl)}`, title }
            // IE 2026 10 18 / ODOO-5800 (Igor, скрин: частичный ПМ бренда, а БЮМ на SKU поставился): порядок по агрегату — «BUM approval requires PM approval of the whole brand» / «MD … of the whole business unit»
            if (dataItem && col) {
                const _ag = this.m03Flag_aggOrder(irow, col.binding)
                if (_ag && !_ag.ok) return { code: 'approval-order-agg', text: t(m03AggregateOrderText(col.binding) || '{title} is read-only in the current state', { title: q(title) }), title }
            }
            // (а) класс-причина от python отчёта (те же источники, что у is_editable)
            let code = null
            const pick = (cls) => { const m = /\bnoedit-([a-z][a-z0-9-]*)\b/.exec(cls || ''); if (m && !code) code = m[1] }
            pick(attr_col?.cssClass)
            try {
                const { _cache2 } = this.get_cache2({ row: irow, col: icol })
                pick(_cache2?.css_user)
            } catch { /* кэша нет — строка ещё не отрисована */ }
            pick(this.divCells.get(`${flex?.cells?.cellType}-${irow}-${icol}`)?.className)
            // IE 2026 10 14 / ODOO-345618 (заказ Игоря: флажки по порядку без Save) — FL4b: причина — по пометке ячейки от бэка (cells[b]: код FLAG_CODE_* + message вердикта), а не по классу DOM: ORDER, открытый живым порядком строки
            // (approvalFlag_open — флажки ниже уже стоят в памяти, Save ещё не было), — отказа нет (null, без тоста); ORDER без живых флажков — «сначала …» по живым значениям строки;
            // прочие коды (no-right / approval-locked / approval-button / approval-branch) — текст вердикта бэка, если он есть, иначе прежние строки по коду
            let _fl4Missing = null
            if (dataItem && col) {
                const _mk = approvalFlagMark(dataItem, col.binding)
                if (_mk) {
                    if (_mk.code === 'approval-order' && this.approvalFlag_open(dataItem, col.binding)) return null
                    code = _mk.code
                    if (_mk.code === 'approval-order') _fl4Missing = approvalFlagOrderMissing(dataItem, col.binding, this.fmtPerf('apprSteps', () => this.approvalFlag_steps())   /* IE 2026 10 18 / ODOO-5800: шаги и без политики (fe.ux.m03FlagsLocal) */, (b) => this.fmtGetValue(dataItem, b))
                    else if (_mk.message) return { code: _mk.code, text: `${q(title)}: ${_mk.message}`, title }
                } else if (code === 'approval-order') {   // IE 2026 10 14 / ODOO-345618 (заказ Игоря: флажки по порядку без Save) — FL4c: класс ORDER от python-хука без пометки бэка — живой порядок: открыт → отказа нет; иначе «сначала …» по живым значениям
                    if (this.approvalFlag_open(dataItem, col.binding, true)) return null
                    _fl4Missing = approvalFlagOrderMissing(dataItem, col.binding, this.fmtPerf('apprSteps', () => this.approvalFlag_steps())   /* IE 2026 10 18 / ODOO-5800: шаги и без политики (fe.ux.m03FlagsLocal) */, (b) => this.fmtGetValue(dataItem, b))
                } else if (code === 'approval-locked' && this.m03Flags_on() && this.approval_on()) {   // IE 2026 10 18 / ODOO-5800 (Igor, остаток: снять БЮМ сразу после снятия МД): класс LOCKED правила CF без пометки бэка — по живым значениям строки: флажки выше сняты → отказа нет; иначе «после …» только по тем, что стоят
                    const _ld = m03FlagLiveDecision(col.binding, this.fmtPerf('apprSteps', () => this.approvalFlag_steps()), (b) => this.fmtGetValue(dataItem, b))
                    if (_ld && _ld.editable) return null
                    if (_ld && _ld.reason) code = _ld.reason + ':' + (_ld.reason === 'approval-locked' ? _ld.later : _ld.missing).join(',')
                }
            }
            // IE 2026 10 09 / ODOO-345618 (F2): флажковый ввод — ячейка данных закрыта замком по данным (бэк: noedit-locked + approval.data_locked строки): причина — по approval строки, а не прежний текст M03 «the row is approved»
            if (!code || code === 'locked') {
                const _adl = dataItem && col ? approvalCellDataLock(dataItem, col.binding, this.attr.childItemsPath || '') : null
                if (_adl) return { code: 'approval-lock', text: `${q(title)}: ${approvalLockReason(_adl.reason, _adl)}`, title }
            }
            // (б) эвристика для колонок согласования M03 — когда python классов не отдаёт
            const raw = String(col?.binding || '').replace(/^data::/, '')
            const ORDER = ['ApprovedPM', 'ApprovedBUM', 'ApprovedMD']
            const idx = ORDER.indexOf(raw)
            const colTitle = (b) => this.attr_by_binding[`data::${b}`]?.title || this.attr_by_binding[b]?.title || b
            const val = (b) => dataItem ? (this.store.get_value(dataItem, `data::${b}`) ?? this.store.get_value(dataItem, b)) : null
            if (!code && idx >= 0 && dataItem) {
                const missing = ORDER.slice(0, idx).filter(b => !val(b))
                const later = ORDER.slice(idx + 1).filter(b => val(b))
                if (this.store.checkAccess_py?.('access-BrandMngt_RO', false)) code = 'no-right'
                else if (missing.length) code = 'approval-order:' + missing.join(',')
                else if (later.length) code = 'approval-locked:' + later.join(',')
                else if (!this.store.checkAccess_py?.(`access-${raw}`)) code = 'no-right'
            }
            // (в) текст (UI по-английски; титулы колонок — данные лэйаута, как есть)
            // IE 2026 09 23 / ODOO-341407: i18n
            const list = (bs) => bs.map(b => q(colTitle(b))).join(' ' + t('and') + ' ')
            let text
            const [c0, arg] = String(code || '').split(':')
            switch (c0) {
                case 'approval-order': {
                    const prev = arg ? arg.split(',') : (_fl4Missing && _fl4Missing.length ? _fl4Missing : ORDER.slice(0, Math.max(idx, 0)))   // IE 2026 10 14 / ODOO-345618 (заказ Игоря: флажки по порядку без Save) — FL4b: по живым значениям
                    text = tn(prev.length, 'Approval {title} requires {list} approval first', 'Approval {title} requires {list} approvals first', { title: q(title), list: list(prev) })
                    break
                }
                case 'approval-locked': {
                    const next = arg ? arg.split(',') : ORDER.slice(idx + 1)
                    text = tn(next.length, 'Approval {title} cannot be changed after the {list} approval', 'Approval {title} cannot be changed after the {list} approvals', { title: q(title), list: list(next) })
                    break
                }
                case 'no-right':
                    text = idx >= 0 ? t('You have no right to change the {title} approval', { title: q(title) }) : t('You have no right to edit {title} in this row', { title: q(title) })
                    break
                case 'approval-button':   // IE 2026 10 09 / ODOO-345618 (F2, бэк FLAG_CODE_BUTTON): отметка не несёт обязательный комментарий / категорию
                    text = t('{title}: the mark needs a comment or a category — use the Approval menu of the row', { title: q(title) })
                    break
                case 'approval-branch':   // бэк FLAG_CODE_BRANCH: ветка what-if
                    text = t('{title}: approval actions are not available in a what-if branch — approve in the working version', { title: q(title) })
                    break
                case 'locked':
                    text = t('{title}: the row is approved — changing it requires the next approval right', { title: q(title) })
                    break
                case 'period':
                    text = t('{title} is outside the editable period', { title: q(title) })
                    break
                default:
                    text = t('{title} is read-only in the current state', { title: q(title) })
            }
            return { code: c0 || 'read-only', text, title }
        },
        // IE 2026 09 29 / ODOO-342781: роль «только чтение» — при flex.isReadOnly wijmo не зовёт beginningEdit, поэтому попытку правки (двойной клик, F2, ввод с клавиатуры,
        // чекбокс) ловим у обработчика правки грида: startEditing вернул false — тост «Read-only access: editing is disabled» (один на серию, store.readonly_toast).
        // Редактор не открывается в любом случае; без _edtHdl (другая версия wijmo) тоста нет, грид остаётся только для чтения
        roEdit_hook(flex) {
            try {
                const store = this.store
                if (!store.readonly_on() || !flex || flex._roEditHooked) return
                const eh = flex._edtHdl
                if (!eh || typeof eh.startEditing !== 'function') return
                const orig = eh.startEditing
                eh.startEditing = function () {
                    const r = orig.apply(this, arguments)
                    if (!r && store.readonly_on()) store.readonly_toast('', 'edit')
                    return r
                }
                flex._roEditHooked = true
            } catch (e) { /* без тоста: грид всё равно только для чтения (flex.isReadOnly) */ }
        },
        readOnly_reject(irow, icol, parent_method) {
            try {
                if (this.store.rejectNotify_on && !this.store.rejectNotify_on()) return
                const col = this.flex?.columns?.[icol]
                if (!col) return
                const r = this.readOnly_reason(irow, icol)
                if (!r) return   // IE 2026 10 14 / ODOO-345618 (заказ Игоря: флажки по порядку без Save) — FL4b: причины нет (флажок открыт живым порядком) — без тоста
                const agg = this._rejectAgg || (this._rejectAgg = { keys: new Set(), items: [], t: null, t0: performance.now() }) // IE 2026 09 04 / ODOO-336379: t0 для строки замера
                agg.keys.add(`${irow}:${col.binding}`)
                agg.items.push({ irow, binding: col.binding, parent_method, ...r })
                // красный флеш с затуханием — как у перебитого ввода; ключи копятся за действие
                this._flashOverride = { keys: new Set(agg.keys), ts: Date.now() }
                window.$cg.setTimeout(this, 'AttrGrid.flashOverrideEnd', () => { this._flashOverride = null }, 2600)
                // агрегатор: вставка/очистка диапазона приходят по ячейкам за миллисекунды — одно уведомление
                clearTimeout(agg.t)
                agg.t = setTimeout(() => { try { this.readOnly_rejectFlush() } catch { /* грид мог перестроиться */ } }, 250)
            } catch { /* уведомление не должно ломать отказ правки */ }
        },
        readOnly_rejectFlush() {
            const agg = this._rejectAgg
            this._rejectAgg = null
            if (!agg || !agg.items.length) return
            // IE 2026 09 05 / ODOO-336379: считаем УНИКАЛЬНЫЕ ячейки, а не события отказа — одна ячейка могла прийти
            // несколько раз (beginningEdit + cellEditEnding + повтор ввода), и уведомление писало «5 cells» на одну правку
            const seen = new Set()
            const items = agg.items.filter(it => { const k = `${it.irow}:${it.binding}`; if (seen.has(k)) return false; seen.add(k); return true })
            const n = items.length
            const byText = new Map()
            for (const it of items) byText.set(it.text, (byText.get(it.text) || 0) + 1)
            let text
            if (n === 1) {
                text = items[0].text
            } else {
                const reasons = [...byText.entries()].sort((a, b) => b[1] - a[1]).slice(0, 2)
                    .map(([t, c]) => `${t}${byText.size > 1 ? ` (${c})` : ''}`).join('; ')
                text = tn(n, '{n} cell is read-only and was not changed — {reasons}', '{n} cells are read-only and were not changed — {reasons}', { reasons })   // IE 2026 09 23 / ODOO-341407: i18n
            }
            // IE 2026 09 04 / ODOO-336379: флеш отклонённых ячеек — прямо в их DOM-элементах (flash_apply по
            // divCells), а не полной перерисовкой грида (flexRefresh = formatItem по всем видимым ячейкам,
            // ~1,2 с на 340 строках / ~3 с на 1000); при следующей штатной перерисовке formatItem сам
            // повторит класс по _flashOverride, пока флеш не отыграл. Флаг reject_flash_direct.
            const _direct = this.cssPerf_on('reject_flash_direct')
            const _flashed = _direct ? this.flash_applyDirect() : -1
            if (!_direct || _flashed < 0) this.flexRefresh()
            try {
                const _ms = Math.round(performance.now() - (agg.t0 || performance.now()))
                const _paths = [...new Set(agg.items.map(it => it.parent_method))].join(',')
                console.log(`[gridPerf] reject: cells=${n}, path=${_paths}, flash=${_direct && _flashed >= 0 ? 'direct(' + _flashed + ')' : 'refresh'}, agg=${_ms} ms`)
                if (this.store.gridPerf_rejectPush) this.store.gridPerf_rejectPush({ t: Date.now(), cells: n, path: _paths, flash: _direct && _flashed >= 0 ? 'direct' : 'refresh', agg_ms: _ms })
            } catch { /* замер не должен ломать уведомление */ }
            const W = this.WIDGET
            if (W?.notification) {
                W.notification.header = ''
                W.notification.text = text
                W.notification.status = 'warning'
                W.notification.visible = true
            }
            if (W) {
                W.TERMINAL = (W.TERMINAL ? W.TERMINAL + '\n' : '') + t('Rejected edit:') + ' ' + text   // IE 2026 09 23 / ODOO-341407: i18n
            }
            this.store.show_notification({ text, status: 'warning' })
        },
        flash_end() {
            // свежесть снимает ДЕЙСТВИЕ, а не таймер: перерисовка не нужна —
            // анимация уже доиграла (forwards), новые отрисовки её не поставят
            this._flashBatch = null
        },
        flash_ofAction(actionStack) {
            // ячейки, затронутые текущим действием (детали, итоги предков и
            // маркер агрегатной ячейки лежат одной группой в undo-стеке).
            // Строку отдаём ССЫЛКОЙ — как и для undo/redo, иначе счёт разный
            const list = []
            for (let i = this.undoStack.length - 1; i >= 0; i--) {
                const a = this.undoStack[i]
                if (a.actionStack !== actionStack) break
                if (a.col_binding != null) {
                    list.push({ item: a.$item, irow: a.irow, binding: a.col_binding })
                }
            }
            return list
        },
        flash_summary(n) {
            const host = this.flex?.hostElement
            if (!host) return
            let el = host.querySelector('.wj-chg-summary')
            if (!el) {
                el = document.createElement('div')
                el.className = 'wj-chg-summary'
                host.appendChild(el)
            }
            // IE 2026 08 19 / ODOO-5512: UI-строки — только английский
            el.textContent = tn(n, '{n} value recalculated', '{n} values recalculated')   // IE 2026 09 23 / ODOO-341407: i18n
            el.classList.remove('show')
            void el.offsetWidth
            el.classList.add('show')
        },
        trace_init() {
            if (this._traceInit || !this.flex?.hostElement) return
            this._traceInit = true
            const host = this.flex.hostElement
            // IE 2026 08 18 / ODOO-5512: клон замороженных ячеек (.wj-frozen-clone,
            // aria-hidden) у Wijmo КЛИКАБЕЛЕН (`.wj-frozen-clone .wj-cell{pointer-events:auto}`)
            // — клик по глифу свёртки попадал в КНОПКУ КЛОНА, браузер фокусировал её
            // и писал в консоль «Blocked aria-hidden on an element because its
            // descendant retained focus». Снимаем ФОКУС по mousedown, сам клик
            // (свёртка/выделение) Wijmo отрабатывает по hitTest как раньше
            host.addEventListener('mousedown', (e) => {
                const t = e.target
                // ТОЛЬКО кнопки внутри клона: [tabindex] у клона есть у любой ячейки
                // (копия активной), preventDefault на них глушил выделение ячеек
                // замороженных колонок (клик по 27/2 не выделял ячейку — Игорь 18.08)
                if (t && t.closest && t.closest('.wj-frozen-clone button')) {
                    e.preventDefault()
                    // фокус — гриду (как при клике по обычной ячейке), а не туда,
                    // где он был до клика (поле поиска, чипсы)
                    try { if (this.flex && !this.flex.containsFocus()) this.flex.focus() } catch (err) { /* noop */ }
                }
            }, true)
            host.addEventListener('mouseover', (e) => {
                const cell = e.target && e.target.closest ? e.target.closest('.wj-cell') : null
                const grp = cell ? cell.getAttribute('data-chg-grp') : null
                if (grp === this._traceGrp) return
                this.trace_clear()
                if (!grp) return
                this._traceGrp = grp
                const list = host.querySelectorAll(`.wj-cell[data-chg-grp="${grp}"]`)
                for (const c of list) wjcCore.addClass(c, 'wj-chg-linked')
                wjcCore.addClass(cell, 'wj-chg-hovered')
            })
            host.addEventListener('mouseleave', () => this.trace_clear())
        },
        trace_clear() {
            if (!this._traceGrp) return
            this._traceGrp = null
            const host = this.flex?.hostElement
            if (!host) return
            for (const c of host.querySelectorAll('.wj-chg-linked, .wj-chg-hovered')) {
                wjcCore.removeClass(c, 'wj-chg-linked')
                wjcCore.removeClass(c, 'wj-chg-hovered')
            }
        },
        clone_Click(e) {
            let irow = 1
            if (this.flex.selectedRows.length && this.flex.selectedRows[0].index >= this.headerRows) {
                this.new_Click(e,true)
            }
        },
        // action_afterChange уровня атрибута-грида: не только правка ячейки,
        // но и перенос/перестановка/группировка/удаление строк, чекбокс use
        // (нужно, в т.ч., гриду «Page widgets» — be ит.4 п.1)
        run_attr_action_afterChange() {
            // эфемерный редактор шаблона печати: изменение данных грида →
            // write-back в канон doc.printTemplate (покрывает delete/up/down,
            // вставку строк и пр. структурные операции)
            this.printTpl_afterChange()
            // вкладка Cells: вставленные строки-узлы → ячейки канона
            if (this.printCellsTab_isActive()) this.printCellsTab_applyInserted()
            if (this.attr.action_afterChange) {
                this.$nextTick(() => {
                    this.store.executeStoreMethod(this.WIDGET.vueObj, {
                        ...this.attr.action_afterChange,
                    }, this.attr)
                })
            }
        },
        printTpl_afterChange() {
            // мост к координатору MVT: визуальная таблица настроек печати —
            // ЭФЕМЕРНАЯ проекция (_doc.printTemplate), правки проецируются в
            // канонический doc.printTemplate (AttrGridGroup > printTpl_*)
            if (!this.attr?.isPrintTemplate) return
            const b = String(this.attr.binding || '').replace(/\[\d+\]\.attrs$/, '')
            if (!b.startsWith('_doc.')) return
            this.WIDGET?._mvtObjs?.[b]?.printTpl_afterChange?.()
        },
        left_tab_Click(e) {
            let currentPosition = this.flex.selectedRanges[0].topRow,
            parentPosition = this.get_parentPosition(currentPosition)

            if (this.attr.childItemsPath === '_childs') {
                // IE 2026 08 20 (заказ Игоря): CHIP-Tree — на уровень вверх со сменой parent
                const row = this.flex.rows[currentPosition]
                if (!row || row.level === 0 || parentPosition < 0) return
                const parentItem = this.flex.rows[parentPosition].dataItem
                const oldArr = parentItem?.['_childs'] || []
                const sel = this.treeSiblings_selected(oldArr)
                if (!sel.length) return
                const grandArr = this.treeParentItems_of(parentPosition)
                const binding = (this.applied_chipTree || [])[0] || 'parent'
                const parentValue = this.store.get_value(parentItem, binding) || ''
                this.treeReparent_(sel, oldArr, grandArr, grandArr.indexOf(parentItem) + 1, parentValue)
                return
            }
            if (parentPosition >= 0) {
                let parentRow = this.flex.rows[parentPosition],
                parentItem = parentRow.dataItem,
                parentItems0 = this.get_parentItems(parentPosition),
                irowParentItem = parentItems0.indexOf(parentItem)

                const fromPositions = this.hist_snapshotSelection()
                let movedItems = this.cut_selectedRanges()
                parentItems0.splice(irowParentItem + 1, 0, ...movedItems)

                this.hist_push({
                    method: 'rows', kind: 'outdent',
                    from: fromPositions, to: this.hist_positionsOf(movedItems),
                    label: t('Move {what} left (up a level)', { what: movedItems.length > 1 ? tn(movedItems.length, '{n} row', '{n} rows') : t('row') }),   // IE 2026 09 23 / ODOO-341407: i18n
                })

                this.refresh(movedItems)
                this.attr_set()
                if (this.WIDGET.widget === 'widget-selectors') {
                    this.store.sync_WORKSPACE(this.WIDGET, '>>WORKSPACE')
                }
                this.run_attr_action_afterChange()
            }
        },
        right_tab_Click(e) {
            let currentPosition = this.flex.selectedRanges[0].topRow,
            new_parentPosition = currentPosition - 1,
            currentRow = this.flex.rows[currentPosition],
            new_parentRow

            if (this.attr.childItemsPath === '_childs') {
                // IE 2026 08 20 (заказ Игоря): CHIP-Tree — на уровень вниз: новым
                // родителем становится предыдущий сиблинг, реквизит parent строк
                // обновляется (сохранит дискетка — иерархия переживает обновление)
                const parentItems = this.treeParentItems_of(currentPosition)
                const sel = this.treeSiblings_selected(parentItems)
                if (!sel.length) return
                const idx = parentItems.indexOf(sel[0])
                if (idx <= 0) return // выше нет сиблинга-родителя
                const prev = parentItems[idx - 1]
                if (!prev || sel.includes(prev)) return
                prev._childs = prev._childs || []
                const parentValue = String(prev.id ?? prev.name ?? '')
                if (!parentValue) return
                this.treeReparent_(sel, parentItems, prev._childs, null, parentValue)
                return
            }

            while (new_parentPosition >= 0) {
                new_parentRow = this.flex.rows[new_parentPosition]
                if (new_parentRow.level === currentRow.level) {
                    break
                }
                new_parentPosition --
            }

            if (new_parentPosition >= 0) {
                let parentItem = new_parentRow.dataItem

                const fromPositions = this.hist_snapshotSelection()
                let movedItems = this.cut_selectedRanges()
                if (!parentItem[ this.attr.childItemsPath ]) {
                    parentItem[ this.attr.childItemsPath ] = []
                }
                parentItem[ this.attr.childItemsPath ].push(...movedItems)

                this.hist_push({
                    method: 'rows', kind: 'indent',
                    from: fromPositions, to: this.hist_positionsOf(movedItems),
                    label: t('Move {what} right (down a level)', { what: movedItems.length > 1 ? tn(movedItems.length, '{n} row', '{n} rows') : t('row') }),   // IE 2026 09 23 / ODOO-341407: i18n
                })

                this.refresh(movedItems)
                this.attr_set()
                if (this.WIDGET.widget === 'widget-selectors') {
                    this.store.sync_WORKSPACE(this.WIDGET, '>>WORKSPACE')
                }
                this.run_attr_action_afterChange()
            }
        },
        get_selectedRange() {
            const sel = this.flex.selectedRanges[0];
            if (!sel) return null;

            let { row: irow1, row2: irow2, col: icol1, col2: icol2 } = sel;

            // нормализуем порядок
            if (irow1 > irow2) [irow1, irow2] = [irow2, irow1];
            if (icol1 > icol2) [icol1, icol2] = [icol2, icol1];

            return { irow1, irow2, icol1, icol2 };
        },

        // ---- вкладка «Print cells» (DS настройки печати): по-ячеечный список
        // КАНОНА doc.printTemplate. Проекция — '_doc.printCells' (эфемерная,
        // строит фронт), правки пишутся ДАННЫМИ прямо в канон (data-ветка
        // cellsList_writeBack) — визуалка может быть не смонтирована ----------
        printCellsTab_isActive() {
            // вкладка Cells: ХРАНИМЫЙ канон печати doc.printCells (модель Игоря
            // 2026-07-25) — прямое редактирование, без эфемерной проекции
            return String(this.attr?.name || '').endsWith('-cells')
                && String(this.attr?.binding || '') === 'doc.printCells'
        },
        printCellsTab_canonRows() {
            // строки канона плоско (секции раскрыты): глобальный Row = индекс+1
            const canon = this.store.get_value(this.WIDGET.record, 'doc.printTemplate') || []
            const secs = canon.filter(r => r && r.attr_type === 'AttrGrid')
            if (secs.length && secs.length === canon.length) {
                return { flat: canon.flatMap(s => s.attrs || []), secs: canon }
            }
            return { flat: canon, secs: null }
        },
        printCellsTab_build() {
            // подготовка ХРАНИМОГО канона doc.printCells: нормализация целостности
            // нормализация
            // целостности (свободные верхние строки оборачиваются в секцию-грид).
            // Изменения чтения запись modified не метят
            const rec = this.WIDGET.record
            if (!rec) return
            const mvt = this.WIDGET._mvtObjs?.['_doc.printTemplate']
                || Object.values(this.WIDGET._mvtObjs || {}).find(m => m?.printCells_fromMatrix)
            const cells = this.store.get_value(rec, 'doc.printCells')
            if (Array.isArray(cells) && cells.length && mvt) {
                const norm = mvt.printCells_normalize(cells)
                // нормализация меняла состав верхнего уровня? (обёртки секций)
                if (norm.length !== cells.length || norm.some((s, i2) => s !== cells[i2])) {
                    this.store.set_value(rec, 'doc.printCells', norm, null, null, null, false)
                }
            }
        },
        printCellNode_of(irow, colB) {
            // узел-ячейка Cells-формата из ячейки грида шаблона (единый буфер
            // копирования Template↔Cells); _ov/_val — полные настройки для
            // вставки 1-в-1 внутри шаблона
            const di = this.flex.rows[irow]?.dataItem
            if (!di || !String(colB || '').startsWith('col_')) return null
            const ov = di._cells?.[colB]
            const f = ((ov || {}).fields || [])[0] || {}
            const sv = typeof di[colB] === 'string' ? di[colB].trim() : ''
            const srcText = f.source != null ? String(f.source) : ((sv && sv !== ' ') ? sv : '')
            return {
                title: f.title ?? '',
                binding: f.binding ?? '',
                source_field: srcText ? { value: srcText } : null,
                attr_type: f.attr_type || 'AttrStr',
                format: f.format,
                relation_segment: f.relation_segment,
                style: f.style ? this.store.deepCopy(f.style) : undefined,
                row: irow + 1, // row ЛОКАЛЬНЫЙ в секции (модель printCells)
                col: parseInt(colB.slice(4)) || 0,
                colspan: ov?.colspan ?? null,
                rowspan: ov?.rowspan ?? null,
                _ov: this.store.deepCopy(ov ?? null),
                _val: di[colB] ?? null,
            }
        },
        printCellNode_apply(di, colB, node) {
            // применить узел-ячейку к строке шаблона (данные): полные настройки
            // из _ov (копия того же шаблона) или реконструкция из полей узла
            let ov = null
            if (node._ov) {
                ov = this.store.deepCopy(node._ov)
            } else {
                const f = {}
                if (node.binding) f.binding = node.binding
                const sv = node.source_field?.value ?? node.source
                if (!node.binding && sv != null && sv !== '') f.source = String(sv)
                if (node.title) f.title = node.title
                if (node.attr_type && node.attr_type !== 'Source' && !(node.attr_type === 'AttrStr' && !node.binding)) f.attr_type = node.attr_type
                if (node.format) f.format = node.format
                if (node.relation_segment) f.relation_segment = node.relation_segment
                if (node.style) f.style = this.store.deepCopy(node.style)
                ov = { fields: [f] }
                const cs = parseInt(node.colspan), rs = parseInt(node.rowspan)
                if (cs > 1) ov.colspan = cs
                if (rs > 1) ov.rowspan = rs
            }
            this.store.set_value(di, colB, node._ov !== undefined && node._ov !== null ? (node._val ?? null) : null)
            this.store.set_value(di, `_cells.${colB}`, ov)
        },
        printCellsTab_applyInserted() {
            // канон хранимый: вставленные строки УЖЕ в doc.printCells — только
            // чистим служебные поля буфера (_ov/_val) и инвалидируем Template
            if (!this.printCellsTab_isActive()) return
            let touched = false
            const walk = (nodes) => {
                for (const n of nodes || []) {
                    if (!this.store.isinstance_dict(n)) continue
                    if ('_ov' in n) { delete n._ov; touched = true }
                    if ('_val' in n) { delete n._val; touched = true }
                    if (Array.isArray(n.attrs)) walk(n.attrs)
                }
            }
            walk(this.store.get_value(this.WIDGET.record, 'doc.printCells'))
            this.printCellsTab_afterWB()
        },
        printCellsTab_afterWB() {
            // канон doc.printCells правится НАПРЯМУЮ (хранимый) — здесь только
            // инвалидация эфемерной визуалки: вкладка Template пересоберёт
            // матрицу при своём показе (или кнопкой 🔄)
            const rec = this.WIDGET.record
            const mvt = this.WIDGET._mvtObjs?.['_doc.printTemplate']
            if (mvt) {
                mvt._printTpl_built = false
                mvt._printTpl_srcRef = undefined
            }
            if (rec?._doc && rec._doc.printTemplate) {
                delete rec._doc.printTemplate
            }
            this.flex?.invalidate()
        },
        cellsList_build() {
            // сборка attr-строк ячеек ЭТОЙ секции/грида (для 👁; Row — сквозной)

            // глазок настроек печати: список ячеек шаблона конфиг-виджетом
            // (widget-row-viewParams, как настройки колонок грида) — каждая
            // ячейка = attr-строка; координаты/объединения — ключами (колонки
            // Print settings в view_FIELD)
            const mk = (irow, cb, o, di) => {
                const f = (Array.isArray(o?.fields) && o.fields[0]) || {}
                // статический текст ячейки (титул, подписи-лейблы) — сам себе title
                const sv = di ? di[cb] : undefined
                const staticText = (typeof sv === 'string' && sv.trim() && sv.trim() !== ' ') ? sv.trim() : ''
                // статический текст в ЗНАЧЕНИИ col_N (старая модель) показываем
                // в Source; правка Source мигрирует его в fields[0].source
                const srcText = f.source != null ? String(f.source) : staticText
                return {
                    title: f.title ?? '',
                    binding: f.binding ?? '',
                    // статический текст/формула — ТОЛЬКО source_field.value
                    source_field: srcText ? { value: srcText } : null,
                    attr_type: f.attr_type || 'AttrStr', // статический текст — тоже AttrStr (типа 'Source' в справочнике нет)
                    format: f.format,
                    relation_segment: f.relation_segment,
                    row: irow + 1 + (this.attr.rowIndexOffset || 0),
                    col: parseInt(cb.slice(4)) || 0,
                    colspan: o?.colspan ?? null,
                    rowspan: o?.rowspan ?? null,
                }
            }
            // ячейки строки: непустые статические col_N И col_N из _cells
            const colsOf = (di, ov) => {
                const keys = new Set()
                for (const k of Object.keys(ov || {})) if (k.startsWith('col_')) keys.add(k)
                for (const k of Object.keys(di || {})) {
                    if (k.startsWith('col_') && typeof di[k] === 'string' && di[k].trim() && di[k].trim() !== ' ') keys.add(k)
                }
                return [...keys].sort((a, b) => (parseInt(a.slice(4)) || 0) - (parseInt(b.slice(4)) || 0))
            }
            const cellAttrs = []
            this.flex.rows.forEach((row, irow) => {
                const di = row.dataItem
                if (!di) return
                const ov = di._cells || {}
                const tablePart = di.tablePart || di.repeat
                if (tablePart) {
                    cellAttrs.push({
                        title: t('Table part'), attr_type: 'AttrGrid', binding: tablePart,   // IE 2026 09 23 / ODOO-341407: i18n
                        row: irow + 1 + (this.attr.rowIndexOffset || 0),
                        attrs: colsOf(null, ov).map(cb => mk(irow, cb, ov[cb], null)),
                    })
                } else {
                    for (const cb of colsOf(di, ov)) cellAttrs.push(mk(irow, cb, ov[cb], di))
                }
            })
            return cellAttrs
        },
        print_cellsList_Click() {
            const cellAttrs = this.cellsList_build()
            const cellsAttr = {
                name: (this.attr.name || 'printTemplate') + '-cells',
                title: t('Print cells'),   // IE 2026 09 23 / ODOO-341407: i18n
                binding: this.attr.binding,
                attrs: cellAttrs,
            }
            // вызов зеркалит ⚙ настроек колонок (openItemsSourcesView):
            // vueObj виджета + get_Parent/open_in_children_widget/widgetRow_params
            this.store.executeStoreMethod(this.WIDGET.vueObj, {
                command: 'widget_open',
                widget: 'widget-row',
                type: 'widget-row-viewParams',
                source_attr_type: 'AttrGrid',
                '_activate': true,
                binding: this.attr.binding,
                source_name: cellsAttr.name,
                get_Parent: true,
                open_in_children_widget: true,
                widgetRow_params: { top_pct: 0.2, left_pct: 0.2, width_pct: 0.8, height_pct: 0.8 },
            }, cellsAttr)
        },
        sync_cellsListSelection(WRow, irow, colBinding) {
            // шаблон печати → список ячеек (👁): выделить строку списка по
            // координатам выбранной ячейки (row/col), внутрь табличной части — по col
            const listGrid = WRow.vueObj?.get_vueObj?.('attrs')
            if (!listGrid?.flex) return
            const colN = parseInt(String(colBinding || '').slice(4)) || 0
            const _off = this.attr.rowIndexOffset || 0
            const rows = listGrid.flex.rows
            let target = -1, rowOnly = -1
            for (let i = 0; i < rows.length; i++) {
                const a = rows[i].dataItem?.attr || rows[i].dataItem
                if (!a || a.row !== irow + 1 + _off) continue
                if (rowOnly < 0) rowOnly = i
                if (a.col === colN) { target = i; break }
            }
            if (target < 0) target = rowOnly
            if (target < 0) return
            // строка внутри свёрнутой табличной части — раскрыть родителя
            const rowT = rows[target]
            if (rowT.isVisible === false) {
                for (let i = target - 1; i >= 0; i--) {
                    if (rows[i].hasChildren && rows[i].level < (rowT.level ?? 0)) {
                        if (rows[i].isCollapsed) rows[i].isCollapsed = false
                        break
                    }
                }
            }
            listGrid.ignore_selectionChanged = true
            listGrid.flex.select(new wjGrid.CellRange(target, 0), true)
            listGrid.ignore_selectionChanged = false
        },
        headerTooltip_over(ev) {
            // флаг Show tooltips ВЫКЛЮЧЕН (штатные тултипы раздражали постоянством):
            // 1) титул не поместился в узкий заголовок — быстрая подсказка с ПОЛНЫМ
            //    тайтлом (~350мс); 2) удержание мыши ~1.5с — полный тултип
            //    (Title/Field/Field type...), как при включённом флаге
            if (this.store.showTooltip || altTooltip.held) return   // IE 2026 09 07 / ODOO-337259: при зажатом Alt подсказку ведёт altTooltip
            // IE 2026 09 20 / ODOO-337259 (Игорь: «тултип исчезает, ещё не доведя до него»): подсказка доживает после Alt — курсор идёт к ней через соседние ячейки;
            // ни гасить её (элемент подсказки у wijmo общий), ни заводить карточку соседней ячейки на это время нельзя
            if (altTooltip.lingering()) return
            let cell = ev.target?.closest?.('.wj-colheaders .wj-cell')
            let isData = false
            if (!cell) {
                // ЯЧЕЙКИ ДАННЫХ: обрезанный текст — то же «бесшовное продолжение»
                // (просьба Игоря, по аналогии с узкими заголовками); spill-ячейки
                // (текст и так рисуется поверх соседей) и редактор не трогаем
                // frozen-колонки рендерятся клон-панелью (.wj-frozen-clone) вне
                // [wj-part="cells"] — обрезанные ячейки там тоже подсказываем
                cell = ev.target?.closest?.('[wj-part="cells"] .wj-cell, .wj-frozen-clone .wj-cell')
                isData = !!cell
                // блокер — только активный редактор и spill (текст и так поверх
                // соседей); постоянные input'ы редактируемых ячеек не мешают
                if (isData && (this.flex?.activeEditor || cell.classList.contains('spill')
                        || cell.classList.contains('spill_data'))) {
                    this.headerTooltip_hide()
                    return
                }
            }
            if (!cell || !this.flex?.hostElement?.contains(cell)) {
                this.headerTooltip_hide()
                return
            }
            if (cell === this._htCell) return
            const r = cell.getBoundingClientRect()
            // колонку определяем и для ЯЧЕЙКИ ДАННЫХ: без неё у строк не было
            // тултипа поля вовсе (жалоба Андрея — в зоне строк подсказок нет)
            const ht = this.flex.hitTest(r.left + r.width / 2, r.top + r.height / 2)
            // IE 2026 09 18 / ODOO-… (замечание Игоря: «ожидаю, что не будет мельканий»): грид перерисовал ячейки (элемент под
            // курсором новый, место и текст те же) — показанное «продолжение» остаётся, а не гаснет на 300 мс
            const _htKey = ht ? `${ht.cellType}:${ht.row}:${ht.col}:${(cell.textContent || '').trim()}` : ''
            if (_htKey && _htKey === this._htKey && this._htOverlay?.isConnected) {
                const r0 = this._htRect
                if (r0 && Math.abs(r0.left - r.left) < 0.5 && Math.abs(r0.top - r.top) < 0.5 && Math.abs(r0.width - r.width) < 0.5) { this._htCell = cell; return }
            }
            this.headerTooltip_hide()
            this._htCell = cell
            this._htKey = _htKey
            this.hdrHover_sync(isData ? cell : null, isData ? ht : null)   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку): слои обрезанных заголовков колонки / строки ячейки данных
            const col = (ht && ht.col >= 0) ? this.flex.columns[(isData && ht.panel === this.flex.cells) ? this.mergeBack_cellCol(ht.row, ht.col) : ht.col] : null   // IE 2026 10 26 / ODOO-5800 (заказ Игоря 26.10: сдвинутая влево ячейка субъекта — подсветка заголовка исходной колонки и подсказка): объединение «назад» — поле колонки значения
            const attr_col = col ? this.attr_by_binding[col.binding] : null
            // полный текст — из САМОЙ ячейки (CSS-обрезка не трогает textContent):
            // hitTest по колонке давал титул нижнего ряда (группа «Lead time»
            // показывала «Count SKU»)
            // IE 2026 09 10 / ODOO-… (замечание Игоря): округлённая длительность (durFit_apply) — подсказка с ПОЛНЫМ текстом («2.1m» при показанном «2m»)
            const _fitFull = (cell.dataset?.fitText && (cell.textContent || '').trim() === cell.dataset.fitText) ? cell.dataset.fullText : ''
            const title = _fitFull || (cell.textContent || '').trim()
            // полный тултип (1.5с) — только для нижнего ряда шапки (там attr_col свой)
            const _lastHdrRow = (this.flex.columnHeaders?.rows?.length || 1) - 1
            const _isLeafHdr = isData || !ht || ht.row === _lastHdrRow
            const esc = s => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            // текст обрезан (узкая колонка) — показать тайтл целиком;
            // обрезка бывает и во вложенном элементе шапки
            // пороги с запасом: субпиксельные округления (ретина) давали
            // ложные 1-2px «обрезки» на мержах/чипсах. Высота — только у
            // ПЕРЕНОСИМОГО текста (wordWrap-колонки, white-space не nowrap):
            // чипсы/бейджи внутри обычных ячеек всегда выше строки по
            // scrollHeight. Вложенные элементы проверяются только в шапке
            // (deep) — в данных они шумят (бейджи, спаны-подсветки)
            const _trWide = el => el.scrollWidth > el.clientWidth + 2
            // IE 2026 09 10 / ODOO-… (замечание Игоря): обрезка на 1–2 px (порог +2 её прятал: колонка чуть шире — «2.1…» видно,
            // а подсказки нет) — точный замер текста Range'ем против внутренней ширины ячейки (дробные px, без округлений
            // scrollWidth); только для ячеек данных с текстом
            const _trPrecise = el => {
                if (!el.firstChild) return false
                try {
                    const rg = document.createRange(); rg.selectNodeContents(el)
                    const w = rg.getBoundingClientRect().width
                    const cs = getComputedStyle(el); const r = el.getBoundingClientRect()
                    const inner = r.width - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0) - (parseFloat(cs.borderLeftWidth) || 0) - (parseFloat(cs.borderRightWidth) || 0)
                    return w > inner + 0.5
                } catch (e) { return false }
            }
            const _truncated = (el0, deep) => {
                if (_trWide(el0) || _fitFull || (!deep && _trPrecise(el0))) return true
                // вертикальная обрезка — только у ЧИСТО текстовых ячеек (кроме
                // служебных кнопки-дропдауна/иконок): бейджи и чипсы выше строки
                // по scrollHeight при полностью видимом тексте (ws у них тоже
                // normal — white-space не отличает)
                // wordWrap-ячейки оборачивают контент в .cell-text-clip —
                // настоящий overflow на нём, а не на самой ячейке
                const _clip = el0.querySelector(':scope > .cell-text-clip')
                if (_clip && (_trWide(_clip)
                    || _clip.scrollHeight > Math.max(_clip.clientHeight + 6, _clip.clientHeight * 1.8))) return true
                const _onlyText = ![...el0.children].some(ch2 =>
                    !ch2.matches('button, i, .cell-dropdown-toggle, .pi, .cell-text-clip'))
                // порог ~2 строки: line-height контента бывает выше строки грида
                // (26px в 16px-ячейке) и давал ложную «обрезку» одной строки
                if (_onlyText && el0.scrollHeight > Math.max(el0.clientHeight + 6, el0.clientHeight * 1.8)) return true
                if (deep) {
                    for (const el of el0.querySelectorAll('*')) {
                        // служебные элементы (кнопка-дропдаун, иконки) не текст
                        if (el.matches('button, i, .cell-dropdown-toggle, .pi')) continue
                        if (_trWide(el)) return true
                    }
                }
                return false
            }
            // ячейка данных: обрезка — по прямоугольникам видимого текста и «пилюль» против коробки обрезки (utils/cellPeek.js); scrollWidth и Range всего
            // содержимого у ячеек с абсолютными слоями (капсулы теплокарты, полоса группы) и спрятанным цветом текстом давали «обрезку» при целиком видимом содержимом.
            // Выключатель fe.ux.cellPeekTruncatedOnly (false — прежние замеры)   // IE 2026 11 04 / ODOO-350449 (замечание Игоря: продолжение ячейки при наведении — только при обрезке и не поверх содержимого)
            const _peekOnly = isData && cellPeek_on((k, d) => this.store.setting(k, d))   // IE 2026 11 04 / ODOO-350449 (замечание Игоря: продолжение ячейки при наведении — только при обрезке и не поверх содержимого)
            if (title && (_peekOnly ? (!!_fitFull || cellPeek_truncated(cell)) : _truncated(cell, !isData))) {   // IE 2026 11 04 / ODOO-350449 (замечание Игоря: продолжение ячейки при наведении — только при обрезке и не поверх содержимого)
                // IE 2026 09 22 / ODOO-5800 (замечание Игоря, скрин: после «продолжения» обрезанного текста спустя время всплывала ещё и нативная
                // подсказка браузера с тем же текстом — title ставят _frozenClip / frozenClip_flush у обрезанных фиксированных ячеек): пока текст
                // показывает продолжение, нативный title лишний — снимаем его с ячейки под курсором. Выключатель fe.ux.clipOverlayDropTitle
                if (isData && this.store.setting('fe.ux.clipOverlayDropTitle', true) !== false) {
                    const _nt = cell.getAttribute('title')
                    if (_nt && _nt.trim() === title) cell.removeAttribute('title')
                }
                // «бесшовное продолжение» обрезанного титула: текст ложится поверх
                // ячеек справа с лёгким размытым фоном (временный, только на ховере)
                // IE 2026 09 18 / ODOO-… (замечание Игоря: «текст поверх текущей ячейки чуть сдвинут вниз — ожидаю пиксель в пиксель»):
                // оверлей строит общий помощник clipOverlay — фон, цвет и шрифт самой ячейки, оформление вложенных элементов,
                // положение текста по замеру первой буквы (а не по отступам), рамка тенью; задержка — fe.ux.clipOverlayDelayMs
                this._htTimer1 = setTimeout(() => {
                    if (!cell.isConnected || this._htCell !== cell) return
                    // слои ячейки (капсула, полоса, SVG, абсолютные элементы) не закрываются: над ними в подложке «окна»   // IE 2026 11 04 / ODOO-350449 (замечание Игоря: продолжение ячейки при наведении — только при обрезке и не поверх содержимого)
                    const ov = clipOverlay_show(cell, { text: _fitFull || '', className: 'clip-overlay header-title-overlay', keep: _peekOnly ? cellPeek_layers(cell) : null })   // IE 2026 11 04 / ODOO-350449 (замечание Игоря: продолжение ячейки при наведении — только при обрезке и не поверх содержимого)
                    if (!ov) return
                    this._htOverlay = ov
                    this._htRect = cell.getBoundingClientRect()
                    // подсветка одинакового текста (CSS highlights живут на диапазонах ячейки) — повторить на оверлее
                    try {
                        const hl = clipOverlay_textRanges(ov, cellMatch_textsIn(cell))
                        if (hl.length) { this._htHlKey = this._htHlKey || ('clip-' + this.sameValue_busKey()); cellMatch_ranges(this._htHlKey, hl, hl.length); this._htHl = true }
                    } catch (e) { /* без подсветки */ }
                    // подсказка временная: автоскрытие, даже если мышь осталась
                    this._htTimer3 = setTimeout(() => {
                        if (this._htOverlay === ov) this.headerTooltip_overlayDrop()
                    }, 5000)
                }, this.store.setting('fe.ux.clipOverlayDelayMs', 300))
            }
            // НЕ листовой ряд шапки (неделя «12W», месяц): attr группы ищется по
            // (первый-биндинг-группы, ряд) — hitTest по ЛЕВОМУ краю мерж-ячейки
            let attr_hdr = attr_col
            if (!_isLeafHdr && ht && !isData) {
                const _htL = this.flex.hitTest(r.left + 2, r.top + r.height / 2)
                const _colL = (_htL && _htL.col >= 0) ? this.flex.columns[_htL.col] : null
                attr_hdr = _colL ? (this.attr_by_bindingColumnGroup?.[`${_colL.binding}-${_htL.row}`] || null) : null
            }
            if (attr_hdr && (_isLeafHdr || (attr_hdr.date && attr_hdr.date_next))) {
                const attr_col = attr_hdr
                const doc = {}   // IE 2026 09 23 / ODOO-341407: i18n (ключи карточки — подписи)
                if (attr_col.title) doc[t('Title')] = attr_col.title
                // колонка-период (неделя «9W», месяц, квартал): показываем календарные
                // границы — из шапки иначе не понять, какие даты внутри.
                // У листов значений (↩/Pallets) своих дат нет — берём у родительской
                // группы (неделя/месяц); для частичной недели (month_breaks) границы
                // уже обрезаны месяцем
                let _dAttr = attr_col
                if (!(_dAttr.date && _dAttr.date_next)) {
                    const _p = this.parentAttr_by_idAttr?.[attr_col.idAttr]
                    if (_p?.date && _p?.date_next) _dAttr = _p
                }
                // IE 2026 09 22 / ODOO-5800 (замечание Игоря, скрин: подсказка «Period: 01.10.2026 — 31.10.2026» над ячейкой данных — «здесь она лишняя»): границы периода —
                // только в шапке; у ячейки данных период виден по заголовку колонки и по форме ячейки. Выключатель fe.ux.cellTipNoPeriod (false — как раньше)
                if (_dAttr.date && _dAttr.date_next && !(isData && this.store.setting('fe.ux.cellTipNoPeriod', true) !== false)) {
                    const _d = v => { const t = new Date(v); return isNaN(t) ? String(v)
                        : `${String(t.getDate()).padStart(2,'0')}.${String(t.getMonth()+1).padStart(2,'0')}.${t.getFullYear()}` }
                    const _last = new Date(_dAttr.date_next); _last.setDate(_last.getDate() - 1)
                    doc[t('Period')] = `${_d(_dAttr.date)} — ${_d(_last)}`
                }
                if (!isData) {
                    // в ШАПКЕ — полная карточка поля; на СТРОКЕ достаточно
                    // подсказки поля: техника (binding/тип/справочник) там шум
                    if (attr_col.binding) doc[t('Field')] = attr_col.binding
                    if (attr_col.attr_type) doc[t('Field type')] = attr_col.attr_type
                    if (attr_col.relation_segment) doc[t('Relation segment')] = attr_col.relation_segment
                    if (attr_col.relation_binding) doc[t('Relation field')] = attr_col.relation_binding
                }
                if (attr_col.tooltip) doc[t('Tooltip')] = attr_col.tooltip
                if (isData && !attr_col.tooltip) delete doc[t('Title')]  // нечего показывать
                // IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции): карточка поля по долгому наведению (~1,5 с) — только в режиме Show tooltips и при fe.ux.hoverTooltips=true
                // (прежнее поведение); иначе карточку даёт зажатый Alt (altTooltip → cellTooltip); «продолжение» обрезанного текста выше — как было
                if (Object.keys(doc).length && altTooltip.hoverExplainOn()) {
                    this._htTimer2 = setTimeout(() => {
                        if (!cell.isConnected || this._htCell !== cell) return
                        if (altTooltip.lingering()) return   // IE 2026 09 20 / ODOO-337259: таймер карточки заведён до Alt — доживающую подсказку не перерисовываем
                        // IE 2026 09 18 / ODOO-… (замечание Игоря: «без мельканий»): «продолжение» обрезанного текста остаётся —
                        // карточка поля встаёт над / под ячейкой и текста ячейки не несёт; раньше продолжение гасло через 1,5 с
                        headerTip.show(cell, this.store.tooltip_html(doc))
                    }, 1500)
                }
            }
        },
        headerTooltip_hide() {
            if (this._htTimer1) { clearTimeout(this._htTimer1); this._htTimer1 = null }
            if (this._htTimer2) { clearTimeout(this._htTimer2); this._htTimer2 = null }
            if (this._htTimer3) { clearTimeout(this._htTimer3); this._htTimer3 = null }
            this.headerTooltip_overlayDrop()
            this._htKey = ''
            if ((this._hhOvs && this._hhOvs.length) || this._hhTimer) requestAnimationFrame(() => { if (!this._htCell) this.hdrHover_drop() })   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку): уход с грида — слои снять; смена ячейки — hdrHover_sync сам решит
            if (this._htCell) {
                this._htCell = null
                if (!altTooltip.lingering()) headerTip.hide()   // IE 2026 09 20 / ODOO-337259: доживающую после Alt подсказку ведёт altTooltip (mouseleave грида = курсор ушёл НА подсказку)
            }
        },
        // IE 2026 09 18 / ODOO-…: снять «продолжение» обрезанного текста вместе с его подсветкой
        headerTooltip_overlayDrop() {
            if (this._htOverlay) { this._htOverlay.remove(); this._htOverlay = null }
            if (this._htHl) { this._htHl = false; try { cellMatch_ranges(this._htHlKey, null) } catch (e) { /* реестр пуст */ } }
            this._htRect = null
        },
        // ---- IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку): «При ховере над ячейкой таблицы, если её заголовок содержит три точки, нужно показывать содержимое их, как будто навели
        // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку): на эти три точки … троеточие может быть в нескольких уровнях заголовка колонки — во всех … то же и с заголовком строки». Наведение на
        // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку): ЯЧЕЙКУ ДАННЫХ (headerTooltip_over → hdrHover_sync) ставит «продолжение» (utils/clipOverlay, как при наведении на саму обрезанную ячейку)
        // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку): на КАЖДУЮ обрезанную ячейку шапки её колонки (все ряды сверху вниз, объединённая группа — одним слоем) и на обрезанный заголовок строки
        // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку): (ячейки панели rowHeaders с текстом + замороженные колонки; видимый экземпляр замороженной — копия в клоне .wj-frozen-clone, индекс wijmo на
        // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку): элементе). Условия и задержка — как у существующего продолжения: Show tooltips выкл, Alt не зажат, fe.ux.clipOverlayDelayMs, автоснятие 5 с;
        // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку): при переходе в соседнюю ячейку той же колонки / строки её слои остаются, слои другой — снимаются и ставятся сразу (без задержки).
        // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку): Стоимость: замер DOM только при смене ячейки (mouseover, не mousemove); обрезанные ячейки шапки — кэш по колонке, пока элементы живы.
        // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку): Выключатель fe.ux.hoverTruncatedHeaders (дефолт ВКЛ; выкл — как раньше: продолжение только у ячейки под курсором). Счётчики window.__hdrHover ----
        hdrHover_on() { return this.store.setting('fe.ux.hoverTruncatedHeaders', true) !== false },   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
        hdrHover_stat() { return window.__hdrHover || (window.__hdrHover = { shows: 0, measures: 0, hits: 0, drops: 0 }) },   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
        hdrHover_clipped(el, deep) {   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку): ячейка обрезана многоточием — пороги как у headerTooltip_over (+2 px, вложенные элементы — только в шапке)
            if (!el || !el.isConnected || !(el.textContent || '').trim()) return false   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            if (el.classList.contains('spill') || el.classList.contains('spill_data')) return false   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку): разлитый текст и так виден
            const wide = x => x.scrollWidth > x.clientWidth + 2   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            if (wide(el) || el.classList.contains('hdr-clip-start')) return true   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку): hdr-clip-start — замер hdrClip_check
            const clip = el.querySelector(':scope > .cell-text-clip')   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку): wordWrap-ячейка — overflow на обёртке
            if (clip && wide(clip)) return true   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            if (deep) for (const x of el.querySelectorAll('*')) { if (x.matches('button, i, .cell-dropdown-toggle, .pi')) continue; if (wide(x)) return true }   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            return false   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
        },   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
        hdrHover_colCells(c) {   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку): обрезанные ячейки шапки колонки c, ряды сверху вниз; getCellElement отдаёт элемент объединённого диапазона — повтор не берём
            const ch = this.flex?.columnHeaders   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            if (!ch || c < 0) return []   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            const cache = this._hhColCache || (this._hhColCache = new Map())   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            const hit = cache.get(c)   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            if (hit && hit.every(el => el.isConnected)) { this.hdrHover_stat().hits++; return hit }   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            const out = [], seen = new Set()   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            const n = ch.rows ? ch.rows.length : 0   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            for (let hr = 0; hr < n; hr++) {   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
                let el = null   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
                try { el = ch.getCellElement(hr, c) } catch (e) { el = null }   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
                if (!el || seen.has(el)) continue   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
                seen.add(el); this.hdrHover_stat().measures++   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
                if (this.hdrHover_clipped(el, true)) out.push(el)   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            }   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            if (cache.size > 500) cache.clear()   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            cache.set(c, out)   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            return out   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
        },   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
        hdrHover_rowCells(r, c) {   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку): обрезанные заголовки строки r: ячейки rowHeaders с текстом и замороженные колонки (кроме колонки c самой ячейки)
            const flex = this.flex   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            if (!flex || r < 0) return []   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            const out = []   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            const rh = flex.rowHeaders, nrh = rh?.columns ? rh.columns.length : 0   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            for (let k = 0; k < nrh; k++) {   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
                let el = null   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
                try { el = rh.getCellElement(r, k) } catch (e) { el = null }   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
                this.hdrHover_stat().measures++   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
                if (el && !out.includes(el) && this.hdrHover_clipped(el, false)) out.push(el)   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            }   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            const fz = flex.frozenColumns || 0   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            if (fz > 0) {   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
                let K = null; try { K = wjGrid.GridPanel._INDEX_KEY } catch (e) { K = null }   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку): индекс wijmo на элементе — есть и у копии в клоне (_updateFrozenCells)
                const clones = (K && flex._fCt) ? Array.from(flex._fCt.children) : []   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
                for (let k = 0; k < fz && k < flex.columns.length; k++) {   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
                    if (k === c || flex.columns[k].visible === false) continue   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
                    let el = null   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
                    for (const cl of clones) { const a = cl[K]; if (a && a.row === r && (a.col === k || (a.rng && a.rng.contains(r, k)))) { el = cl; break } }   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
                    if (!el) { try { el = flex.cells.getCellElement(r, k) } catch (e) { el = null } }   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку): клона нет — основной экземпляр
                    this.hdrHover_stat().measures++   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
                    if (el && !out.includes(el) && this.hdrHover_clipped(el, false)) out.push(el)   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
                }   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            }   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            return out   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
        },   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
        hdrHover_sync(cell, ht) {   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку): новая ячейка под курсором (headerTooltip_over): чужие слои снять, свои показать
            if (this._hhTimer) { clearTimeout(this._hhTimer); this._hhTimer = null }   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            const flex = this.flex   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            const isData = !!(cell && ht && flex && ht.panel === flex.cells && ht.row >= 0 && ht.col >= 0)   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            if (!isData || !this.hdrHover_on()) { this.hdrHover_drop(); return }   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            const col = this.mergeBack_cellCol(ht.row, ht.col), row = ht.row   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)   // IE 2026 10 26 / ODOO-5800 (заказ Игоря 26.10: сдвинутая влево ячейка субъекта — подсветка заголовка исходной колонки и подсказка): объединение «назад» — колонка значения
            const shown = !!(this._hhOvs && this._hhOvs.length)   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            this.hdrHover_drop(col, row, cell)   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку): слои той же колонки / строки остаются
            const live = !!(this._hhOvs && this._hhOvs.length)   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            const delay = shown && live ? 0 : +this.store.setting('fe.ux.clipOverlayDelayMs', 300) || 0   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку): уже «в режиме продолжения» — без задержки
            const run = () => {   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
                this._hhTimer = null   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
                if (!cell.isConnected || this._htCell !== cell) return   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
                this.hdrHover_show(row, col)   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            }   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            if (delay > 0) this._hhTimer = setTimeout(run, delay); else run()   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
        },   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
        hdrHover_show(row, col) {   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку): поставить слои на обрезанные заголовки колонки col и строки row (уже стоящие — не дублировать)
            const ovs = this._hhOvs || (this._hhOvs = [])   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            const have = new Set(ovs.map(o => o.el))   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            const put = (el, kind) => {   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
                if (have.has(el)) return   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
                let ov = null   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
                try { ov = clipOverlay_show(el, { className: 'clip-overlay header-title-overlay hdr-hover-overlay' }) } catch (e) { ov = null }   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
                if (ov) { ovs.push({ el, ov, kind }); have.add(el); this.hdrHover_stat().shows++ }   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            }   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            for (const el of this.hdrHover_colCells(col)) put(el, 'col')   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            for (const el of this.hdrHover_rowCells(row, col)) put(el, 'row')   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            this._hhCol = col; this._hhRow = row   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            if (this._hhTimer3) clearTimeout(this._hhTimer3)   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            this._hhTimer3 = setTimeout(() => { this._hhTimer3 = null; this.hdrHover_drop() }, 5000)   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку): как у продолжения ячейки — временная подсказка
        },   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
        hdrHover_drop(keepCol, keepRow, cell) {   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку): снять слои; keepCol / keepRow — слои этой колонки / строки оставить (кроме слоя на самой ячейке cell: у неё своё продолжение)
            if (this._hhTimer) { clearTimeout(this._hhTimer); this._hhTimer = null }   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            const rest = []   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            for (const o of (this._hhOvs || [])) {   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
                const keep = o.kind === 'col' ? (keepCol != null && this._hhCol === keepCol) : (keepRow != null && this._hhRow === keepRow)   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
                if (keep && o.el.isConnected && o.el !== cell && o.ov.isConnected) rest.push(o)   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
                else { try { o.ov.remove() } catch (e) { /* слой уже снят */ } this.hdrHover_stat().drops++ }   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            }   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            this._hhOvs = rest   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            if (!(keepCol != null && this._hhCol === keepCol)) this._hhCol = null   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            if (!(keepRow != null && this._hhRow === keepRow)) this._hhRow = null   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
            if (!rest.length && this._hhTimer3) { clearTimeout(this._hhTimer3); this._hhTimer3 = null }   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
        },   // IE 2026 10 23 / ODOO-348693 (заказ Игоря: полный заголовок при наведении на ячейку)
        // ---- IE 2026 09 24 / ODOO-341407 (заказ Игоря): карточка «Translations» (store.i18n_card_open) у строки грида — translate-колонки
        // строк записи (параметр стола attr.title, колонка списка doc.viewList, строка раскладки data_layout2, поле DS attrs), у поля формы
        // записи (AttrTabGrid: флаг translate / Multilingual) и у колонки таблицы данных (строка-источник в записи, как «Go to DL») ----
        // биндинг перевода в строке грида: строки-записи (_doc.*: title → meta.title_{lang}), строки конфигурации записи — суффикс рядом с ключом
        i18n_rowLangBinding(col_binding, raw_binding, lang) {
            if (String(this.attr?.binding || '').startsWith('_doc.')) return this.store.localize_binding(col_binding, lang, raw_binding)
            return col_binding + '_' + lang
        },
        i18n_isDataGrid() {
            const seg = String(this.WIDGET?.record?.segment || '')
            return this.attr?.binding === '_doc.data' && (seg === 'WIDGET-REPORT2' || seg === 'WIDGET-LIST' || seg.startsWith('DATA-SOURCE'))
        },
        i18n_gridApplies() {
            // IE 2026 09 24 / ODOO-341407 (проверка dev02: в форме строки колонки (widget-row) у формы ячейки не было кнопки «Translations»):
            // своей записи-сегмента у формы строки нет — переводы пишутся в запись-владельца (store.i18n_linkBinding), по ней и проверяем
            const seg = this.WIDGET?.record?.segment || (this.WIDGET?.widget === 'widget-row' ? this.store.i18n_linkBinding(this.WIDGET, '').record?.segment : '')
            if (this.WIDGET?.isReadOnly || !seg || this.attr?.isPrint || this.attr?.isPrintTemplate) return false
            if (this.attr.attr_type === 'AttrTabGrid') return true
            if (this.i18n_isDataGrid()) return true
            return !String(this.attr.binding || '').startsWith('_doc.') && (this.columns() || []).some(c => c && c.translate)
        },
        // поля карточки: [{ key, label, multiline, basePath, langPaths }] по translate-колонкам грида (или по полю формы); nested — поле строки записи
        i18n_fieldsOf(prefix, cols, nested) {
            const store = this.store, fields = []
            for (const c of cols) {
                if (!c?.binding) continue
                const basePath = prefix ? prefix + '.' + c.binding : c.binding
                const langPaths = {}
                for (const L of store.i18n_otherLangs()) {
                    langPaths[L.id] = nested ? basePath + '_' + L.id : store.localize_binding(basePath, L.id, c.binding)
                }
                fields.push({ key: c.binding, label: c.title || c.binding, multiline: c.attr_type === 'AttrStrMulti' || /(^|\.)(tooltip|comment)$/.test(c.binding), basePath, langPaths })
            }
            return fields
        },
        // цель карточки для строки / ячейки: { label, record, fields[, attr_col, row] } | null
        // IE 2026 09 25 / ODOO-341407 (этап 2 переводов данных 1С): кнопка «Translations» формы ЯЧЕЙКИ в колонке Title списка (WIDGET-LIST) — название ЗАПИСИ
        // строки (записи справочника из 1С правятся здесь: ручной перевод уходит в хранилище I18N-OVERRIDE, i18n_values_set); заголовок
        // колонки — пункт ≡ таблицы «Translations…» (как раньше)
        // IE 2026 10 06 / ODOO-341407 (заказ Игоря п.1): то же для ЛЮБОЙ колонки с флагом translate («Multilingual») — переводы ЗНАЧЕНИЯ ячейки (поле записи
        // строки), не заголовка колонки; колонка без флага и виртуальная «… (uk)» (_i18nOf) — без кнопки. Путь перевода выводится из binding колонки по
        // правилу грида i18n_rowLangBinding (store.localize_binding): title → meta.title_<L>, meta.comment → meta.comment_<L>, doc.x → doc.x_<L>.
        // Строка без контейнера перевода (DS / noExtraFields: без meta / doc) не правится — update_data бэка заменил бы meta записи целиком (DESIGN Р5).
        // Цели без attr_col — i18n_open.afterApply заголовок колонки не переписывает, только перерисовывает грид
        i18n_rowFieldTarget(dataItem, attr_col) {
            const W = this.WIDGET, b = attr_col?.binding
            if (typeof b !== 'string' || !b || !attr_col.translate || attr_col._i18nOf) return null
            if (String(W?.record?.segment || '') !== 'WIDGET-LIST') return null
            if (!dataItem?.id || !dataItem.segment || dataItem._meta?.new) return null
            if (!i18nFields_rowHasBox(dataItem, b, { localize: (bb, L, raw) => this.i18n_rowLangBinding(bb, raw, L) })) return null
            const langPaths = {}
            for (const L of this.store.i18n_fieldLangs()) langPaths[L.id] = this.i18n_rowLangBinding(b, b, L.id)
            const shown = this.store.get_value_localized(dataItem, 'title') || dataItem.title || dataItem.id
            return { label: this.t('Record') + ': ' + shown, record: dataItem, rowRecord: true,
                fields: [{ key: b, label: attr_col.title || b, multiline: attr_col.attr_type === 'AttrStrMulti' || /(^|\.)(tooltip|comment)$/.test(b), basePath: b, langPaths }] }
        },
        i18n_targetFor(dataItem, attr_col, opts = {}) {
            const store = this.store, W = this.WIDGET
            if (!W?.record) return null
            if (this.attr.attr_type === 'AttrTabGrid') {
                const f = dataItem?.attr
                if (!f?.binding || f._i18nOf || String(f.binding).startsWith('_') || !(f.translate || ['title', 'tooltip', 'comment', 'doc.tooltip'].includes(f.binding))) return null   // IE 2026 10 06 / ODOO-341407: виртуальная строка «… (uk)» / «(en)» (_i18nOf) — без карточки
                const link = store.i18n_linkBinding(W, f.binding)
                if (!link.record?.segment) return null
                const prefix = link.binding.slice(0, link.binding.length - f.binding.length).replace(/\.$/, '')
                // IE 2026 10 06 / ODOO-341407 (проверка round 2, C6.row-card-apply): форма Alt+F2 строки над данными (_doc.*) — цель карточки САМА строка-запись
                // списка, как у кнопки ячейки списка (i18n_rowFieldTarget): i18n_values_set уходит её записи (POLICY …, путь от строки: title → meta.title_<L>),
                // «только в форму» — по правке / новизне строки. Было — запись виджета-списка ('_doc.data.3.meta.title_ru' у WIDGET-LIST: бэк «path is not
                // allowed») и её признак modified. Строка не запись (отчёт, DS) или без контейнера перевода — карточки нет (писать некуда)
                if (link.nested && prefix.startsWith('_')) {
                    const row = i18nFields_listRowOf({ ...link, binding: prefix })
                    if (!row || !i18nFields_rowHasBox(row, f.binding)) return null
                    return { label: this.t('Field') + ': ' + (f.title || f.binding), record: row, rowRecord: true, fields: this.i18n_fieldsOf('', [f], false), WIDGET: link.WIDGET }
                }
                // IE 2026 10 06 / ODOO-341407 (ревью U9): строка-запись реестра под карточкой Alt+F2 (_doc.data.3) — пути правилом store.localize_binding (title →
                // meta.title_<L>, как читает attr_get поля и колонка списка), а не суффиксом строки конфигурации ('_doc.data.3.title_uk' никто не читал)
                const nestedCfg = link.nested && !prefix.startsWith('_')
                return { label: this.t('Field') + ': ' + (f.title || f.binding), record: link.record, fields: this.i18n_fieldsOf(prefix, [f], nestedCfg), WIDGET: link.WIDGET }   // IE 2026 09 24 / ODOO-341407: WIDGET — виджет записи-владельца (перерисовка его гридов после Apply)
            }
            if (this.i18n_isDataGrid()) {
                // IE 2026 10 06 / ODOO-341407 (заказ Игоря п.1): форма ячейки — только значение translate-колонки строки-записи (отчёт, DS, колонка без
                // флага — кнопки нет, фолбэка на заголовок нет); ≡ таблицы «Translations…» (без cell) — заголовок колонки, как раньше
                return opts.cell ? this.i18n_rowFieldTarget(dataItem, attr_col) : this.i18n_columnTarget(attr_col)
            }
            if (String(this.attr.binding || '').startsWith('_doc.')) return null
            const all = (this.columns() || []).filter(c => c && c.translate && c.binding)
            // IE 2026 10 06 / ODOO-341407 (заказ Игоря п.1): форма ячейки — одно поле, кликнутая translate-колонка (другая колонка — без кнопки);
            // ≡ «Translations…» — все translate-колонки строки, как раньше
            const cols = opts.cell ? ((attr_col?.translate && attr_col.binding && !attr_col._i18nOf) ? [attr_col] : []) : all
            if (!cols.length || !dataItem) return null
            const root = store.attr_get(W, this.attr)
            const segs = store.i18n_pathOf(root, dataItem)
            if (!segs) return null
            const link = store.i18n_linkBinding(W, this.attr.binding)
            if (!link.record?.segment) return null
            const prefix = link.binding + segs.map(s => '.' + s).join('')
            const b = String(this.attr.binding || '') + '|' + String(this.attr.name || '')
            const kind = b.includes('fieldsMapping') ? this.t('Parameter') : b.includes('viewList') ? this.t('Column')
                : b.includes('data_layout2') ? this.t('Layout row') : (b.includes('attrs') ? this.t('Field') : this.t('Row'))
            const titleCol = all.find(c => /(^|\.)title$/.test(c.binding)) || cols[0]   // IE 2026 10 06 / ODOO-341407: подпись строки — по её названию и из ячейки «Tooltip»
            const title = store.get_value(dataItem, titleCol.binding) || dataItem.binding || dataItem.attr?.binding || ''
            return { label: kind + ': ' + title, record: link.record, fields: this.i18n_fieldsOf(prefix, cols, true) }
        },
        // колонка таблицы данных → строка-источник записи: отчёт — строка раскладки по row_id (как goto_dl2_row), список — doc.viewList по
        // binding, DS — attrs по binding; порождённые колонки (даты, меры transpose) источника не имеют — карточки нет
        i18n_columnTarget(attr_col) {
            const store = this.store, W = this.WIDGET, record = W?.record
            if (!record?.segment || !attr_col?.binding) return null
            const seg = String(record.segment)
            let prefix = '', row = null
            if (seg === 'WIDGET-REPORT2') {
                const row_id = attr_col.row_id
                const dl2 = store.get_value(record, 'doc.params.data_layout2')
                if (!row_id || !Array.isArray(dl2)) return null
                let found = null
                const walk = (nodes, path) => {
                    for (let i = 0; i < (nodes || []).length; i++) {
                        const node = nodes[i]
                        if (!node || typeof node !== 'object') continue
                        if (node.row_id === row_id) { found = { row: node, path: path + '.' + i }; return }
                        for (const tbl of ['fields', 'values']) {
                            const idx = (node[tbl] || []).findIndex(r => r?.row_id === row_id)
                            if (idx >= 0) { found = { row: node[tbl][idx], path: path + '.' + i + '.' + tbl + '.' + idx }; return }
                        }
                        walk(node.attrs, path + '.' + i + '.attrs')
                        if (found) return
                    }
                }
                walk(dl2, 'doc.params.data_layout2')
                if (!found) return null
                prefix = found.path; row = found.row
            } else if (seg === 'WIDGET-LIST') {
                const list = store.get_value(record, 'doc.viewList')
                const idx = Array.isArray(list) ? list.findIndex(f => f && (f.binding === attr_col.binding || f.binding0 === attr_col.binding)) : -1
                if (idx < 0) return null
                prefix = 'doc.viewList.' + idx; row = list[idx]
            } else if (seg.startsWith('DATA-SOURCE')) {
                const list = Array.isArray(record.attrs) ? record.attrs : null
                const idx = list ? list.findIndex(f => f && f.binding === attr_col.binding) : -1
                if (idx < 0) return null
                prefix = 'attrs.' + idx; row = list[idx]
            } else return null
            const cols = [{ binding: 'title', title: this.t('Title'), attr_type: 'AttrStr' }, { binding: 'tooltip', title: this.t('Tooltip'), attr_type: 'AttrStrMulti' }]
            return { label: this.t('Column') + ': ' + (row.title || attr_col.title || attr_col.binding), record, fields: this.i18n_fieldsOf(prefix, cols, true), attr_col, row }
        },
        i18n_open(target, anchorEl) {
            if (!target) { this.store.show_notification({ text: this.t('Translations: no translatable field in this row'), status: 'warning' }); return false }
            const vueObj = this
            return this.store.i18n_card_open({
                ...target, anchorEl, readOnly: !!this.WIDGET?.isReadOnly,
                afterApply: (res) => {
                    // колонка таблицы данных: заголовок в шапке = перевод текущего языка / словарь / база (вью локализует бэк при открытии — правим на месте)
                    // IE 2026 10 06 / ODOO-341407 (п.1): у цели ячейки (поле записи строки, i18n_rowFieldTarget) attr_col нет — заголовок не трогаем;
                    // invalidate ниже перерисует и колонку, и её «(uk)/(ru)» из строки, которую карточка уже обновила в памяти
                    if (target.attr_col) {
                        const lang = vueObj.store.get_lang()
                        const f = res.fields?.find(x => x.key === 'title')
                        const title = f ? ((lang && (f.stored?.[lang] || f.dict?.[lang])) || f.base) : ''
                        if (title) {
                            target.attr_col.title = title
                            try { const col = vueObj.flex?.columns?.getColumn?.(target.attr_col.binding); if (col) col.header = title } catch (e) { /* колонка не найдена */ }
                        }
                    }
                    try { vueObj.flex?.invalidate?.() } catch (e) { /* грид в перестройке */ }
                    // IE 2026 09 24 / ODOO-341407 (проверка dev02: после Apply поле формы «Tooltip» держало прежний текст до перечитывания виджета):
                    // строки AttrTabGrid — копии узлов вида со снапшотом значения (attrsTabGrid_from_attrs → prepare_AttrMulti: V.value = attr_get) —
                    // пересобираем строки формы, значение перечитается по правилу отображения текущего языка ({binding}_{lang} → база)
                    if (!target.attr_col && vueObj.attr?.attr_type === 'AttrTabGrid') {
                        try { vueObj.content_Changed({ isVue: true }) } catch (e) { console.warn('i18n card: form rebuild', e) }
                    }
                    // поле формы строки (widget-row над строкой конфигурации: колонка, параметр) — гриды записи-владельца показывают перевод строки
                    if (target.WIDGET && target.WIDGET !== vueObj.WIDGET) {
                        for (const v of Object.values(target.WIDGET.attrs_vueObj || {})) { try { v?.flex?.invalidate?.() } catch (e) { /* грид в перестройке */ } }
                    }
                    // IE 2026 09 24 / ODOO-341407 (проба dev02: Apply из вкладки INFO / формы ячейки поля «Название» оставлял шапку на английском):
                    // поле «Название» САМОЙ записи виджета — шапка сразу на текущем языке и узлы вью с binding 'title', как после карточки из меню
                    // виджета (Widget.vue i18n_titles_open): перевод текущего языка (title_localized ответа) → словарь → английская база
                    const W = vueObj.WIDGET
                    const fTitle = (!target.attr_col && W && target.record === W.record) ? res.fields?.find(x => x.basePath === 'title') : null
                    if (fTitle) {
                        W.title = (typeof res.answer?.title_localized === 'string' && res.answer.title_localized) || vueObj.store.i18n_record_title(W.record, fTitle.dict || null) || W.title
                        const sync = (attrs) => { for (const a of attrs || []) {
                            if (a && a.binding === 'title' && ('value' in a || 'valueStr' in a || a.attr_type)) { a.value = W.title; a.valueStr = W.title }
                            if (a?.attrs) sync(a.attrs)
                        } }
                        sync(W.view)
                        W.vueObj?.content_Changed?.()
                    }
                },
            })
        },
        // кнопка «Translations» формы ячейки (Dropdown → executeVueObjMethod → владелец формы)
        i18n_cell_open() {
            const dd = this.store.dropdown
            if (!dd) return
            // IE 2026 09 24 / ODOO-341407 (проверка dev02: глобус формы ячейки поля INFO у виджета-списка карточку не открывал): кнопка ячейки
            // не несёт binding — executeVueObjMethod резолвит вызов в грид '_doc.data' виджета (метод есть у любого AttrGrid), а не во владельца
            // формы ячейки; переадресуем владельцу (dropdown_prepare: dropdown.vueObj — грид, открывший форму, в т.ч. полоса AttrTabGridLanes)
            const owner = dd.vueObj
            if (owner && owner !== this && typeof owner.i18n_cell_open === 'function') return owner.i18n_cell_open()
            const target = this.i18n_targetFor(dd.dataItem, dd.attr_col, { cell: true })   // IE 2026 09 25 / ODOO-341407: форма ячейки
            const anchorEl = dd.divCell?.isConnected ? dd.divCell : this.$el
            dd.hide?.(false, true)
            this.i18n_open(target, anchorEl)
        },
        // пункт «Translations…» меню ≡ таблицы — активная строка / выделенная колонка таблицы данных
        i18n_menu_open() {
            const flex = this.flex, sel = flex?.selection
            if (!flex || !sel || sel.row < 0) { this.store.show_notification({ text: this.t('Translations: select a row first'), status: 'warning' }); return }
            const dataItem = flex.rows[sel.row]?.dataItem
            const col = sel.col >= 0 ? flex.columns[sel.col] : null
            const attr_col = col ? this.attr_by_binding[col.binding] : null
            if (this.i18n_isDataGrid() && !attr_col) { this.store.show_notification({ text: this.t('Translations: select a column first'), status: 'warning' }); return }
            let anchorEl = null
            try { anchorEl = flex.cells.getCellElement(sel.row, Math.max(sel.col, 0)) } catch (e) { anchorEl = null }
            this.i18n_open(this.i18n_targetFor(dataItem, attr_col), anchorEl || this.$el)
        },
        // IE 2026 09 07 / ODOO-337259: карточка колонки для подсказки шапки — общая для formatItem
        // (Show tooltips) и показа по Alt (cellTooltip_html)
        columnHeader_tooltipDoc(attr_col) {
            const doc = {}   // IE 2026 09 23 / ODOO-341407: i18n (ключи карточки — подписи)
            if (attr_col.title) doc[t('Title')] = attr_col.title
            if (attr_col.binding) doc[t('Field')] = attr_col.binding
            if (attr_col.attr_type) doc[t('Field type')] = attr_col.attr_type
            if (attr_col.relation_segment) doc[t('Relation segment')] = attr_col.relation_segment
            if (attr_col.relation_binding) doc[t('Relation field')] = attr_col.relation_binding
            if (attr_col.tooltip) doc[t('Tooltip')] = attr_col.tooltip
            if (attr_col.default !== undefined && attr_col.default !== null && attr_col.default !== '') doc[t('Default')] = attr_col.default
            // IE 2026 09 24 / ODOO-341407: переводы названия колонки (✎ = хранится на строке-источнике записи, ◌ = словарь / нет);
            // правка — ≡ таблицы → Translations… (IE 2026 10 06 / ODOO-341407: кнопка «Translations» формы ячейки правит перевод ЗНАЧЕНИЯ ячейки, не заголовка)
            try {
                const _tgt = this.i18n_isDataGrid() ? this.i18n_columnTarget(attr_col) : null
                if (_tgt?.row) doc[t('Translations')] = this.store.i18n_otherLangs().map(l => l.id + ' ' + (_tgt.row['title_' + l.id] ? '✎' : '◌')).join(' · ')
            } catch (e) { /* колонка без строки-источника */ }
            // период колонки (неделя/месяц): свои даты, у листов значений (↩/Pallets) — от родительской
            // группы; для частичной недели (month_breaks) даты уже обрезаны
            let _dAttr = attr_col
            if (!(_dAttr.date && _dAttr.date_next)) {
                const _p = this.parentAttr_by_idAttr?.[attr_col.idAttr]
                if (_p?.date && _p?.date_next) _dAttr = _p
            }
            if (_dAttr.date && _dAttr.date_next) {
                const _fd = v => { const t = new Date(v); return isNaN(t) ? String(v)
                    : `${String(t.getDate()).padStart(2,'0')}.${String(t.getMonth()+1).padStart(2,'0')}.${t.getFullYear()}` }
                const _last = new Date(_dAttr.date_next); _last.setDate(_last.getDate() - 1)
                doc[t('Period')] = `${_fd(_dAttr.date)} — ${_fd(_last)}`
            }
            return doc
        },
        // IE 2026 09 26 / ODOO-… (заказ Игоря: doc.use в заголовках строк). Igor 26.09: «Покажи-настрой колонку "doc.use" с визуализацией в разделе заголовков
        // строк как скрине2». Флажок-колонка в заголовках строк — полноценное поле данных строки. Колонка уходит в заголовки строк по position
        // 'rowHeaders' (прежний ключ — настройка поля «Position → Row headers»: View-list-fields списка, форма поля) либо по positionNew 'rowHeaders' —
        // ключу для форм, общих с боевым контуром: прежний фронт его не знает и показывает обычную колонку, этот — флажок в заголовке строки. Блокировка
        // строки — те же каналы, что у ячейки данных (cf_formatProps: _DLRow.isReadOnly, _DLRow.cells[binding].isReadOnly, правила оформления с
        // isReadOnly): флажок не переключается ни кликом, ни диапазоном, ни «только эта» (Alt / Ctrl), ни общим флажком шапки, ни Ctrl+Enter; вид и
        // причина — из меты ячейки. Общий флажок шапки — только видимые незаблокированные строки, один шаг отмены, строки и грид помечаются
        // изменёнными, как клик по строке. selector (выбор строки, не данные) механизм не трогает. Выключатель fe.ux.gridRowHeaderFlags (false —
        // positionNew не действует: колонка, как у прежнего фронта; блокировок нет; общий флажок шапки — прежний проход)
        rhFlags_on() {
            try { return this.store.setting('fe.ux.gridRowHeaderFlags', true) !== false } catch (e) { return true }
        },
        rhBool_noWrite() {
            // IE 2026 10 23 / ODOO-5800: умолчание флажков заголовков строк не пишется в данные
            return rhBool_implicit(this.store.setting(RH_BOOL_FLAG, true))
        },
        rhBool_def(binding) {
            // IE 2026 10 23 / ODOO-5800: умолчание показа флажка по binding (use — включено; selector — undefined)
            if (binding === 'use') return true   // IE 2026 10 23 / ODOO-5800
            return this.rowHeaders_cols_pos.find(x => x.binding === binding)?.def   // IE 2026 10 23 / ODOO-5800
        },
        rhBool_value(dataItem, binding) {
            // IE 2026 10 23 / ODOO-5800: эффективное значение флажка (нет ключа = умолчание колонки)
            return rhBool_checked(this.store.get_value(dataItem, binding), this.rhBool_def(binding))   // IE 2026 10 23 / ODOO-5800
        },
        // IE 2026 11 01 / ODOO-350449 (заказ Игоря через ie-webscm7-2 #122315: легенда вимк., колонка прапорців у Числах, чіп як селектор): флажок строки колонки-селектора от встраивающего компонента: null — у строки флажка нет, иначе true / false
        selectorRow_stateOf(dataItem) {
            if (typeof this.attr?.selectorRow_state !== 'function' || !dataItem) return null
            try { const v = this.attr.selectorRow_state(dataItem); return v === null || v === undefined ? null : !!v } catch (err) { return null }
        },
        rhBool_checkedOf(dataItem, binding, e_col) {
            // IE 2026 10 23 / ODOO-5800: состояние флажка с неявным умолчанием (нет ключа = умолчание колонки)
            const def = e_col === this.rowHeaders_col_use ? true : (this.rowHeaders_cols_pos.find(x => x.col_idx === e_col)?.def ?? this.rhBool_def(binding))   // IE 2026 10 23 / ODOO-5800
            return rhBool_checked(this.store.get_value(dataItem, binding), def)   // IE 2026 10 23 / ODOO-5800
        },
        rhPos_is(attr_col) {
            if (!attr_col) return false
            if (attr_col.position === 'rowHeaders') return true
            return attr_col.positionNew === 'rowHeaders' && this.rhFlags_on()
        },
        // мета блокировки строки для флажка binding (null — строка не заблокирована): _DLRow.cells[binding] (у языков — en: isReadOnly, cssClasses, tooltip)
        rhLock_of(dataItem, binding) {
            if (!this._rhFlagsOn || !dataItem || !binding || binding === 'selector') return null
            const props = this.cf_formatProps(dataItem, binding, this.attr_by_binding?.[binding])
            if (!props?.isReadOnly) return null
            return dataItem._DLRow?.cells?.[binding] || dataItem._DLRow || {}
        },
        rhLock_reject(dataItem, binding) {
            const meta = this.rhLock_of(dataItem, binding) || {}
            const title = this.attr_by_binding?.[binding]?.title || binding
            const text = meta.tooltip ? String(meta.tooltip) : t('{title} is read-only in the current state', { title })
            try { this.store.show_notification({ text, status: 'warning' }) } catch (e) { /* уведомление не должно ломать отказ */ }
        },
        // подсказка ячейки-флажка заголовка строки (Alt — cellTooltip_html, Show tooltips — formatItem): название и подсказка колонки + причина блокировки
        rhTip_html(row, col) {
            if (!this._rhFlagsOn || !this.flex) return ''
            const attr = this.rowHeaders_attr(col)
            if (!attr || attr.binding === 'selector') return ''
            // флажок — колонка use и колонки position / positionNew, которые formatItem рисует чекбоксом (без attr_type или AttrBool); текстовые
            // колонки заголовков строк (группа AttrTabHeader, Type сравнения) — не флажки, строк флажка у них нет (v2)
            const _pos = (this.rowHeaders_cols_pos || []).find(x => x.col_idx === col)
            if (!(col === this.rowHeaders_col_use || (_pos && (!_pos.attr_type || _pos.attr_type === 'AttrBool')))) return ''
            const isFlagCol = !!_pos   // колонка position / positionNew — всегда с названием; use — только у заблокированной строки (объяснение U5 его называет)
            const lk = this.rhLock_of(this.flex.rows[row]?.dataItem, attr.binding)
            if (!isFlagCol && !lk) return ''
            const esc = (s) => this.store.escapeHtml(String(s))
            let html = `<b>${esc(attr.title || attr.binding || '')}</b>`
            if (attr.tooltip) html += `<br>${esc(attr.tooltip)}`
            if (lk?.tooltip) html += `<br><i class="pi pi-lock"></i> ${esc(lk.tooltip)}`
            return html
        },
        // общий флажок шапки (onSelectorAll__Click) у флажков данных: true — обработано здесь
        rhSelectAll(e, binding) {
            if (!this._rhFlagsOn || !binding || binding === 'selector' || !this.flex) return false
            const store = this.store
            const rows = this.flex.rows.filter(r => r.dataItem && r.visible !== false && r.dataItem._fe?.visible !== false)
            const locked = new Set(rows.filter(r => this.rhLock_of(r.dataItem, binding)))
            const free = rows.filter(r => !locked.has(r))
            if (!free.length) {
                if (locked.size) this.rhLock_reject([...locked][0].dataItem, binding)
                this.flexRefresh()
                return true
            }
            const checked = !free.some(r => this.rhBool_value(r.dataItem, binding))   // IE 2026 10 23 / ODOO-5800
            if (e?.target) e.target.checked = checked
            const hist = []
            for (const r of free) {
                const oldValue = this.rhBool_value(r.dataItem, binding)   // IE 2026 10 23 / ODOO-5800
                if (oldValue === checked) continue
                store.set_value(r.dataItem, binding, checked)
                hist.push({ item: r.dataItem, path: binding, oldValue, newValue: checked })
                this.setModified(r.dataItem)
            }
            if (hist.length) {
                const title = this.attr_by_binding?.[binding]?.title || binding
                this.hist_push({ method: 'props', cells: hist, label: `${title}: ${tn(hist.length, '{n} row', '{n} rows')} ${checked ? t('on') : t('off')}` })
                this.setModified()
                this.run_attr_action_afterChange()
            }
            if (binding === 'use' && this.itemsSourcesView_grid()) this.itemsSourcesView_use_apply(free.map(r => r.dataItem))
            const attr_col = this.attr_by_binding?.[binding] || {}
            if (attr_col.action_afterChange?.command === 'use_selectorMeasures') this.use_selectorMeasures()
            else if (attr_col.action_afterChange) store.executeStoreMethod(this.WIDGET.vueObj, attr_col.action_afterChange, this.attr)
            this.set_AttrTabPanel_countItems()
            this.flexRefresh()
            this.attr_set()
            if (this.WIDGET.widget === 'widget-selectors') store.sync_WORKSPACE(this.WIDGET, '>>WORKSPACE')
            return true
        },
        // IE 2026 09 07 / ODOO-337259: attr колонки-заголовка строк (selector / use / position=rowHeaders) по индексу
        rowHeaders_attr(colIdx) {
            if (colIdx === this.rowHeaders_col_selector) return this.columns().find(a => a.binding === 'selector') || null
            if (colIdx === this.rowHeaders_col_use) return this.columns().find(a => a.binding === 'use') || null
            const p = (this.rowHeaders_cols_pos || []).find(p => p.col_idx === colIdx)
            return p ? (this.attr_by_binding[p.binding] || null) : null
        },
        // IE 2026 09 07 / ODOO-337259: подсказка ячейки под мышью по запросу (зажатый Alt, см. utils/altTooltip):
        // { content, inst } — тот же текст, что formatItem регистрирует при включённом Show tooltips
        cellTooltip(cell, x, y) {
            const flex = this.flex
            if (!flex || !cell?.isConnected) return null
            let ht = null
            // IE 2026 10 31 / ODOO-5800 (заказ Игоря: Alt-довідка в одноколонковій формі): ячейка — по самому элементу под курсором (индекс, который wijmo пишет элементу при отрисовке), а не по точке.
            // flex.hitTest(x, y) считает строку от controlRect — прямоугольника хоста, который wijmo кэширует (_rcBounds) и сбрасывает только на mouseenter / mousedown /
            // ресайзе / перерисовке грида. Сдвиг грида без них (прокрутка окна формы колесом над гридом, перенос строки над гридом) оставлял старый прямоугольник:
            // точка попадала на строку ниже или выше — в одноколоночной форме вкладки Info под «Підказка» показывалось поле meta.predefined («Наперед визначені»).
            // Клон замороженной ячейки (.wj-frozen-clone) индекса не несёт — для него точка с обновлённым прямоугольником и в координатах страницы, как ждёт wijmo
            try { const _he = flex.hitTest(cell); if (_he && _he.panel && _he.row >= 0 && _he.col >= 0) ht = _he } catch (e) { ht = null }   // IE 2026 10 31 / ODOO-5800 (заказ Игоря: Alt-довідка в одноколонковій формі)
            if (!ht) {   // IE 2026 10 31 / ODOO-5800 (заказ Игоря: Alt-довідка в одноколонковій формі)
                try { flex._rcBounds = null; ht = flex.hitTest(new wjcCore.Point(x + (window.pageXOffset || 0), y + (window.pageYOffset || 0))) } catch (e) { return null }   // IE 2026 10 31 / ODOO-5800 (заказ Игоря: Alt-довідка в одноколонковій формі)
            }
            // IE 2026 09 30 / ODOO-343343 (заказ Игоря: начало плана штриховкой — объяснение по Alt у флажков): курсор в маске «начала плана» шапки (флажок) — объяснение начала плана вместо подсказки ячейки шапки под маской
            { const _pst = this.planStart_headerTip(cell, x, y); if (_pst) return _pst }
            { const _psb = this.planStart_bandTip(x, y); if (_psb) return _psb }   // IE 2026 09 30 / ODOO-343343 (заказ Игоря: штриховка начала плана — одним элементом)
            if (!ht || !ht.panel || ht.row < 0 || ht.col < 0) return null
            // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5: el — сама ячейка (строка «Marks»), target — элемент под курсором внутри неё (стрелка формы, кнопка «→», флажки заголовков строк)
            let target = null
            try { const t0 = document.elementFromPoint(x, y); if (t0 && cell.contains(t0)) target = t0 } catch (e) { target = null }
            const content = this.cellTooltip_html(ht.panel, ht.row, ht.col, { alt: true, el: cell, target })   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U1: путь Alt — с объяснением записи ссылки
            // IE 2026 09 28 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5 (доводка 28.09): у заголовков строк / угла шапки подсказка — правее колонки заголовков (rect), а не над / под ячейкой:
            // иначе объяснение флажка ложилось на флажки соседних строк, и Alt+клик по другому флажку попадал в подсказку (metricuse dev02).
            // Выключатель fe.ux.uiHelpRowHeaderAside (false — как было)
            let rect = null
            if (content && (ht.panel === flex.rowHeaders || ht.panel === flex.topLeftCells) && this.store.setting?.('fe.ux.uiHelpRowHeaderAside', true) !== false) {
                try { const cr = cell.getBoundingClientRect(), pr = ht.panel.hostElement.getBoundingClientRect(); rect = new wjcCore.Rect(pr.right + 4, cr.top, 420, cr.height) } catch (e) { rect = null }
            }
            if (content && ht.panel === flex.cells) sigCell_holdCauseDetail(cell)   // IE 2026 10 05 / ODOO-5800 (fe-85) (ревью cause detail): карточка по Alt несёт строку чисел причины — нативная подсказка ячейки на это время снимается
            return content ? { content, inst: tooltip, rect } : null
        },
        // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5: объяснение элемента ВНУТРИ ячейки под курсором (opts.target) — главнее подсказки самой ячейки (вложенный элемент, как звезда в пункте
        // панели): стрелка формы ячейки; в заголовках строк — кнопка «→» / команда строки, флажки selector / use, флажок «отметить»; в углу шапки — флажки
        // «выбрать все». '' — элемента нет (подсказка ячейки как обычно). Заглушка на месте стрелки у ячейки с показанной формой (cell-form-here) невидима — без объяснения
        uiHelp_cellSub(panel, row, col, opts = {}) {
            const tgt = opts && opts.target, flex = this.flex
            if (!tgt || typeof tgt.closest !== 'function' || !flex || !uiHelp_enabled()) return ''
            if (panel === flex.cells) {
                const btn = tgt.closest('.cell-dropdown-toggle')
                if (!btn || btn.classList.contains('cell-form-here')) return ''
                return uiHelp_html('grid.cellFormArrow', { state: btn.classList.contains('open') ? 'open' : 'closed' })
            }
            if (panel === flex.rowHeaders) {
                if (tgt.closest('#onHeader__Click')) return uiHelp_html('grid.rowHeader.open', { state: (this.dblclick_action?.command === 'widget_open' || this.dblclick_action?._openRecord) ? 'open' : 'command' })   // IE 2026 10 14 / ODOO-5800
                if (tgt.id === 'onFeSelected__Click') return uiHelp_html('grid.rowHeader.feSelected')
                if (tgt.id === 'onSelector__Click') {
                    const b = String(opts.el?.data_cell?.binding || ''), leaf = b.split('.').pop()   // поле строки бывает с путём (doc.use)
                    const metric = !!this.attr?.metricChip_use
                    if (metric && leaf !== 'use' && b === this.metricSel_binding()) return uiHelp_html('grid.rowHeader.selector', { state: 'metricsTab' })
                    if (leaf === 'use') return uiHelp_html('grid.rowHeader.use', { state: metric ? 'metricsTab' : null })
                    if (leaf === 'selector') return uiHelp_html('grid.rowHeader.selector', { state: this.formatSel_grid() ? 'formatRules' : 'workspace' })
                }
                return ''
            }
            if (panel === flex.topLeftCells) {
                if (tgt.id === 'onSelectorAll__Click') return uiHelp_html('grid.rowHeader.selectAll', { state: tgt.checked ? 'all' : (tgt.indeterminate ? 'some' : 'none') })
                if (tgt.id === 'onFeSelectedAll__Click') return uiHelp_html('grid.rowHeader.feSelected')
            }
            return ''
        },
        // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5: хвост объяснения полосы суммы выделения (директива на <p>, хук after) — сама сводка: число, среднее, минимум, максимум
        summaryLine_helpTail() { return this.currentSelectionHTML ? '<br>' + this.currentSelectionHTML : '' },
        // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5: строка «Marks» — какие отметки несёт наведённая ячейка el и что они значат (utils/uiHelp/grid.js, grid.mark.*). Правила по el.classList /
        // el.dataset — тот же канал, что красит ячейку в хвосте formatItem; у замороженных колонок el — клон .wj-frozen-clone с теми же классами. Не более 6 строк
        cellMarks(panel, row, col, el, dataItem, attr_col, isData) {
            const marks = []
            if (!el || !el.classList) return marks
            const flex = this.flex
            const has = (cls) => el.classList.contains(cls)
            const push = (key, state, detail) => { if (marks.length < 6) marks.push({ key, state, detail }) }
            if (el.__stkTip && has('stk')) push('grid.mark.stockCell', null, el.__stkTip)   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: виды ячеек запаса под ключ — Z5 по умолчанию; BE ie-dm7 stock_cells_batch): вход, приход, расход, выход, зона, пороги
            // format — правило оформления / именованный стиль (фронт: cf_appliedForCell без заливки от метрик — она ниже своей строкой; бэк: классы ячейки через реестр CSS-CLASS)
            try {
                const col_binding = attr_col?.binding
                const ap = (isData && col_binding && typeof this.cf_appliedForCell === 'function') ? (this.cf_appliedForCell(dataItem, col_binding, attr_col) || []).filter(a => a && !a._metricFill) : []
                // IE 2026 10 31 / ODOO-5800 (заказ Игоря: Alt-довідка в одноколонковій формі) (замечание Игоря: «Оформлення» у всех полей подряд): метка — только у сработавшего правила (ap) или у классов условного оформления бэка
                // (мета ячейки _DLRow.cells[binding].cssClasses / MD.cssClass[binding]), стоящих на элементе. Структурные классы колонки и строки формы (cell-title, cell-value, editable…)
                // больше не дают «Formatting»: раньше брались все классы элемента из реестра CSS-CLASS
                const _cfCls = []   // IE 2026 10 31 / ODOO-5800 (заказ Игоря: Alt-довідка в одноколонковій формі)
                if (isData && col_binding && !this.cellBlank(dataItem, col_binding)) {   // IE 2026 10 31 / ODOO-5800 (заказ Игоря: Alt-довідка в одноколонковій формі)
                    const _cc = dataItem?._DLRow?.cells?.[col_binding]?.cssClasses; if (Array.isArray(_cc)) _cfCls.push(..._cc)   // IE 2026 10 31 / ODOO-5800 (заказ Игоря: Alt-довідка в одноколонковій формі)
                    const _md = dataItem?.MD?.cssClass?.[col_binding]; if (_md) _cfCls.push(_md)   // IE 2026 10 31 / ODOO-5800 (заказ Игоря: Alt-довідка в одноколонковій формі)
                }
                const _fd = formatMarkDetail(ap, _cfCls, [...el.classList], (n) => this.store?.cssClass_info?.(n))   // IE 2026 10 31 / ODOO-5800 (заказ Игоря: Alt-довідка в одноколонковій формі)
                if (_fd !== null) push('grid.mark.format', null, _fd)   // IE 2026 10 31 / ODOO-5800 (заказ Игоря: Alt-довідка в одноколонковій формі)
            } catch (e) { /* оформление недоступно */ }
            // metricFill — заливка от метрики ячейки
            try {
                const st = typeof this.metricFill_state === 'function' ? this.metricFill_state() : null
                const ts = st && typeof this.metricFill_cellTasks === 'function' ? this.metricFill_cellTasks(st, dataItem, attr_col?.binding, attr_col) : null
                if (ts && ts.length) push('grid.mark.metricFill', null, ts[0].title)
            } catch (e) { /* метрики недоступны */ }
            // groupDup — повтор итога группы
            if ((has('gt-dup-dim') || has('gt-dup-hover') || has('gt-dup-arrow')) && flex && panel === flex.cells && this.groupDup_state(flex).ph && parentHide_isRow(flex.rows[row], this.groupDup_state(flex).phKeep)) push('grid.mark.parentHide')   // // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p232 сигнал батьківського рядка лишається, якщо підлеглі — інша міра); IE 2026 11 02 / ODOO-350449 (заказ Игоря: p201 баланс — «Сигнали» типово, розкритий батьківський рядок без підсумків і сигналів (hover показує), підсумок рядка без сигналів — опція)
            else if (has('gt-dup-dim') || has('gt-dup-hover') || has('gt-dup-arrow')) push('grid.mark.groupDup', has('gt-dup-dim') ? 'dim' : (has('gt-dup-hover') ? 'hover' : 'arrow'))
            // infl / inflUnc — подсветка влияния на остаток
            if (el.dataset?.infl) {
                if (has('cell-infl-plus-unc') || has('cell-infl-minus-unc')) push('grid.mark.inflUnc', has('cell-infl-plus-unc') ? 'plus' : 'minus')
                else { const d = el.dataset.infl; push('grid.mark.infl', d === '=' ? 'base' : (d === '+' ? 'plus' : (d === '\u2212' || d === '-' ? 'minus' : null))) }
            }
            // alertChild — строка под алертом (Uncovered, Expired…)
            if (has('cell-alert-child')) push('grid.mark.alertChild')
            // edit / manualCorrection / note / compare / branchCopy
            if (has('wj-has-stack-error')) push('grid.mark.edit', 'error')
            else if (has('wj-has-stack-indirect')) push('grid.mark.edit', 'indirect', el.dataset?.chgDelta)
            else if (has('wj-has-stack')) push('grid.mark.edit', 'user', el.dataset?.chgDelta)
            if (has('wj-has-cell-data') || has('wj-has-override')) push('grid.mark.manualCorrection')
            if (has('wj-has-notes')) push('grid.mark.note')
            if (has('cmp-cell-badge')) push('grid.mark.compare', null, el.dataset?.cmpDelta)
            if (has('cow-diff-badge')) push('grid.mark.branchCopy', null, el.dataset?.cowDelta)
            if (has('audit-diff-badge')) push('grid.mark.auditDiff', null, el.dataset?.adfDelta)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: подсветка изменений записи из аудита)
            // empty / zero
            if (has('cell-empty')) push('grid.mark.empty')
            if (has('cell-zero')) push('grid.mark.zero', 'hidden')
            // mergeBack — значение перенесено к началу строки
            if (has('merge-back')) {
                try { const mb = flex && this.mergeBack_info ? this.mergeBack_info(flex.cells, row) : null; push('grid.mark.mergeBack', null, mb ? flex.columns[mb.k]?.header : null) } catch (e) { push('grid.mark.mergeBack') }
            }
            // breakGap / direction — разрыв колонок / стрелка направления
            try { const m = attr_col && typeof this.breakMode === 'function' ? this.breakMode(attr_col) : null; if (m) push('grid.mark.breakGap', m) } catch (e) { /* без разрыва */ }
            if (has('cell-dir-from')) push('grid.mark.direction', 'from')
            else if (has('cell-dir-to-double')) push('grid.mark.direction', 'to_double')
            else if (has('cell-dir-both')) push('grid.mark.direction', 'both')
            else if (has('cell-dir-to')) push('grid.mark.direction', 'to')
            // dateBar
            const _db = el.querySelector?.(':scope > .cell-date-bar')
            if (_db) {
                if (_db.classList.contains('is-tick')) push('grid.mark.dateBar', 'tick')
                else if (_db.classList.contains('is-bar')) push('grid.mark.dateBar', 'bar')
                else push('grid.mark.dateBar', (_db.classList.contains('is-open-r') || _db.classList.contains('is-open-l')) ? 'open' : 'pair')
            }
            // sameValue / sameDoc / metricHit
            if (has('cell-same-value')) push('grid.mark.sameValue')
            if (has('cell-same-doc-anchor')) push('grid.mark.sameDoc', 'anchor')
            else if (has('cell-same-doc-same')) push('grid.mark.sameDoc', 'same', this._sameDoc?.n != null ? String(this._sameDoc.n) : null)
            if (has('metric-hit-cur-cell')) push('grid.mark.metricHit', 'current')
            else if (has('metric-hit-cell')) push('grid.mark.metricHit', 'hit')
            // filterDim — приглушено отбором по стилям / метрикам / оформлению
            if (has('style-filter-dim')) push('grid.mark.filterDim', (this._styleFilterKeys && this._styleFilterKeys.length) ? 'styles' : (this._metricFilterDoc ? 'metrics' : ((this._formatFilterIds && this._formatFilterIds.length) ? 'formatting' : null)))
            // tabRow / memoRow — полосы раскладки
            if (has('row-dl-tab')) { const bandCls = [...el.classList].find(c => c.startsWith('band-')); push('grid.mark.tabRow', bandCls ? 'band' : 'tab', bandCls ? this.store?.cssClass_info?.(bandCls)?.title : null) }
            if (has('row-dl-memo')) push('grid.mark.memoRow')
            // statusChip / currentBadge
            if (has('has-status-chip')) push('grid.mark.statusChip', null, el.querySelector?.('.status-chip')?.textContent)
            // IE 2026 10 09 / ODOO-345618 (заказ Игоря: согласование на сегменте): пилюля статуса согласования в заголовке строки-группы — кто, когда, кого ждём, сколько детей утверждено
            if (has('appr-pill-host')) { const _ap = this.approval_of(dataItem); if (_ap) push('approval.mark.pill', null, approvalTip(_ap, { userTitle: (u) => this.approval_userTitle(u) })) }
            if (has('ra-pill-host')) push('ruleApproval.pill', null, el.querySelector?.('.ra-pill')?.dataset?.raText)   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128579: согласование правил MAP-*, этап C)
            if (has('pa-pill-host')) push('planApproval.pill', null, el.querySelector?.('.pa-pill')?.dataset?.paText)   // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B)
            const _cur = el.querySelector?.('.cell-badge-current')
            if (_cur) push('grid.mark.currentBadge', null, _cur.textContent)
            // filterTotal — итог по отбору
            if (has('ft-total')) push('grid.mark.filterTotal', 'total')
            else if (has('ft-stale')) push('grid.mark.filterTotal', 'stale')
            // heat / negative / dataBar
            try { if (attr_col?.hslGroup && el.style?.backgroundColor) push('grid.mark.heat') } catch (e) { /* нет тепловой заливки */ }
            if (has('cell-neg-value') || has('num-negative')) push('grid.mark.negative')
            if (el.__rsBg === 1) push('grid.mark.dataBar', el.querySelector?.('.rs-col-bar') ? 'columns' : 'bars')
            // autoValue / customValue / exprValue / useOff / cascadeDirty / compareRow / dimHighlight
            if (has('wj-cell-autovalue')) push('grid.mark.autoValue')
            if (has('custom-value-warning')) push('grid.mark.customValue')
            if (has('eval-text')) push('grid.mark.exprValue', 'expression')
            else if (has('custom-text')) push('grid.mark.exprValue', 'literal')
            if (has('use-false')) push('grid.mark.useOff')
            if (has('row-cascade-dirty')) push('grid.mark.cascadeDirty')
            if (has('row-compare')) push('grid.mark.compareRow')
            if (has('dim-highlight')) push('grid.mark.dimHighlight')
            // selFrame — рамка выделения: только у выделенной ячейки грида данных (у гридов форм своя рамка); selFrame — вычисляемое свойство ('' = Classic)
            if ((has('wj-state-selected') || has('wj-state-multi-selected')) && typeof this.selFrame_isDataGrid === 'function' && this.selFrame_isDataGrid()) push('grid.mark.selFrame', this.selFrame || 'classic')
            return marks.slice(0, 6)
        },
        // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5: строки «Marks» — подпись и по строке на метку: • название — текущее состояние (или что делать) (подробность)
        // IE 2026 10 31 / ODOO-5800 (заказ Игоря: Alt-довідка в одноколонковій формі) (замечание Игоря: «слишком много текста»): opts.short — строка метки в подсказке ячейки по Alt: название — состояние (подробность), без объяснения
        // what / click реестра (оно остаётся в реестре объяснений); полная форма — у объяснения штриховки начала плана (planStart_*Tip), где метка — единственный текст
        cellMarks_html(list, opts = {}) {
            if (!list || !list.length) return ''
            const rows = list.map(m => {
                if (!m || !m.key) return ''
                const e = uiHelp_entry(m.key, { state: m.state || null })
                if (!e) return ''
                if (opts && opts.short) {   // IE 2026 10 31 / ODOO-5800 (заказ Игоря: Alt-довідка в одноколонковій формі)
                    const _txt = markLineText(e.now, m.detail)   // IE 2026 10 31 / ODOO-5800 (заказ Игоря: Alt-довідка в одноколонковій формі)
                    if (!_txt && !e.title) return ''   // IE 2026 10 31 / ODOO-5800 (заказ Игоря: Alt-довідка в одноколонковій формі)
                    return '<br>\u2022 <b class=\'tooltip-text\'>' + escHtml(e.title || '') + '</b>' + (_txt ? ' \u2014 ' + escHtml(_txt) : '')   // IE 2026 10 31 / ODOO-5800 (заказ Игоря: Alt-довідка в одноколонковій формі)
                }
                const txt = e.now || e.what || e.click || ''
                if (!txt && !e.title) return ''
                return '<br>\u2022 <b class=\'tooltip-text\'>' + escHtml(e.title || '') + '</b>' + (txt ? ' \u2014 ' + escHtml(txt) : '') + (m.detail ? ' (' + escHtml(String(m.detail)) + ')' : '')
            }).filter(Boolean)
            if (!rows.length) return ''
            return '<br><b class=\'tooltip-header ui-help-marks\'>' + escHtml(t('Marks')) + ':</b>' + rows.join('')
        },
        // IE 2026 09 23 / ODOO-… (заказ Игоря: кнопки в подсказках): действие кнопки подсказки ссылочной ячейки — кнопка-стрелка ячейки (открыть) либо она же с externalLink_method
        // (ссылка в буфер / новая вкладка) — тот же путь, что у панели CELL формы ячейки (Open / Copy to clipboard / Open record in new tab)
        tipCell_action(cell, act) {
            const method = act === 'copy' ? 'copyToClipboard' : (act === 'newtab' ? 'openInNewTab' : undefined)
            if (act !== 'open' && !method) return false
            this.onButtonOpen__Click({ ...cell, externalLink_method: method })
            return true
        },
        // IE 2026 09 07 / ODOO-337259: текст подсказки ячейки (panel, row, col) — единая точка для formatItem
        // и показа по Alt. Каналы: карточка колонки (шапка), attr колонки-заголовка строк, мера transpose
        // (tooltip + Default), KPI (cf/MD), тултип cf/MD, поле-строка AttrTabGrid (с любой колонки строки)
        // или мульти-значение ячейки, рекомендация cells_binding, комментарий согласования
        // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U1: opts.alt — показ по Alt (cellTooltip): в подсказку ссылочной ячейки идёт и объяснение самой записи
        // (поставщики записей ядра); статичная подсказка Show tooltips (formatItem) — без него (запекается при отрисовке)
        // IE 2026 11 01 / ODOO-350449 (заказ Игоря: кругові діаграми за статусами у клітинках REPORT2, опції зрізу і їх розміщення): подсказка ячейки с пирогом статусов — разбивка по статусам (цветные метки, значения, доли) перед прочими каналами
        cellTooltip_html(panel, row, col, opts = {}) {
            let sigTip = ''   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p231 підказка по сигналу — проблема як у формі комірки): Alt над сигналом вида «Сигнали» — проблемы ячейки видом блока PROBLEMS формы (signalTip_htmlAt), метка сигнала из Marks снимается
            if (this.flex && panel === this.flex.cells && opts && opts.alt) { try { sigTip = this.signalTip_htmlAt(row, col, opts) } catch (e) { sigTip = '' } }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p231 підказка по сигналу — проблема як у формі комірки)
            const base = this.cellTooltip_htmlBase(panel, row, col, sigTip ? { ...opts, marksSkip: SIGNAL_TIP_SKIP_MARKS } : opts)   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p231 підказка по сигналу — проблема як у формі комірки)
            if (!this.flex || panel !== this.flex.cells || !this.cellView_on()) return base   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T1): любой вид ячеек, не только пирог статусов
            let pt = sigTip   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p231 підказка по сигналу — проблема як у формі комірки)
            if (!pt) { try { pt = this.cellView_tipAt(row, col) } catch (e) { pt = '' } }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p231 підказка по сигналу — проблема як у формі комірки)
            return pt ? pt + (base ? '<br>' + base : '') : base
        },
        cellTooltip_htmlBase(panel, row, col, opts = {}) {
            const flex = this.flex, store = this.store
            if (!flex) return ''
            // IE 2026 11 01 / ODOO-350449 (заказ Игоря: теплова карта на базі таблиці — порівняльна вкладка): подсказка ячейки данных от встраивающего компонента (attr.cellTip_html(row, col, vueObj, opts) → html | ''); пусто — штатная
            if (panel === flex.cells && typeof this.attr?.cellTip_html === 'function') {
                let _h = ''
                try { _h = this.attr.cellTip_html(row, col, this, opts) || '' } catch (e) { _h = '' }
                if (_h) return _h
            }
            if (panel === flex.columnHeaders) {
                // служебные ряды шапки (фильтр / номера / sticky / маппинг) — без карточки, как в formatItem
                if (row === this.columnNumberRow || row === this.stickyScrollStart
                    || (this.isMappedWidget_rows && row === this.isMappedWidget_rows)) return ''
                const colObj = flex.columns[col]
                const attr_col = colObj ? this.attr_by_binding[colObj.binding] : null
                if (!attr_col) return ''
                let html = store.tooltip_html(this.columnHeader_tooltipDoc(attr_col))
                // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U3: колонка со своим attr.uiHelp (сеттинги списка настроек Default for all / Default for me — Widget.settingsList_makeAttr) — строки объяснения после нативного tooltip колонки
                if (attr_col.uiHelp && uiHelp_enabled()) html += uiHelp_rowsHtml(attr_col.uiHelp, {}, ['what', 'click', 'affects', 'stored'])
                return html
            }
            if (panel === flex.topLeftCells) {
                const _sub = opts && opts.alt ? this.uiHelp_cellSub(panel, row, col, opts) : ''   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5: флажки «выбрать все» под курсором
                if (_sub) return _sub
                const attr = this.rowHeaders_attr(col)
                let html = attr ? String(attr.tooltip || attr.title || '') : ''
                // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5: правый край ячейки-заголовка группы строк (AttrTabHeader) тянется — элемента у ручки нет (класс rh-col-resize на ХОСТЕ грида,
                // пока курсор у края); только путь Alt
                if (opts && opts.alt && uiHelp_enabled() && flex.hostElement?.classList?.contains('rh-col-resize')) html += uiHelp_rowsHtml('grid.rowHeader.groupColResize', {}, ['what', 'click'])
                return html.replace(/^<br>/, '')
            }
            // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5 [ДЕФЕКТ, defects-found.md]: у заголовков строк подсказки не было вовсе — по Alt: элемент под курсором (кнопка «→» / команда строки, флажки
            // selector / use / «отметить»), ручка ширины колонки групп, иначе метки строки (новая / изменённая, строка сравнения)
            if (panel === flex.rowHeaders) {
                // IE 2026 09 26 / ODOO-… (заказ Игоря: doc.use в заголовках строк): флажок-колонка заголовков строк (use / position / positionNew) — название,
                // подсказка колонки и причина блокировки строки ПЕРЕД объяснением элемента (U5) и строкой «Marks»; без объяснений — одни строки флажка
                const _rhTip = this.rhTip_html(row, col)
                const _rhJoin = (s) => (_rhTip && s) ? _rhTip + '<br>' + s : (_rhTip || s)
                if (!opts || !opts.alt || !uiHelp_enabled()) return _rhTip
                const _sub = this.uiHelp_cellSub(panel, row, col, opts)
                if (_sub) return _rhJoin(_sub)
                if (flex.hostElement?.classList?.contains('rh-col-resize')) return uiHelp_html('grid.rowHeader.groupColResize')
                const el = opts.el
                if (!el || !el.classList) return _rhTip
                const marks = []
                if (el.classList.contains('new')) marks.push({ key: 'grid.mark.rowState', state: 'new' })
                else if (el.classList.contains('modified')) marks.push({ key: 'grid.mark.rowState', state: 'modified' })
                if (el.classList.contains('row-compare-header')) marks.push({ key: 'grid.mark.compareRow', state: null })
                return _rhJoin(marks.length ? this.cellMarks_html(marks, { short: true }).replace(/^<br>/, '') : '')   // IE 2026 10 31 / ODOO-5800 (заказ Игоря: Alt-довідка в одноколонковій формі)
            }
            if (panel !== flex.cells) return ''
            // IE 2026 11 02 / ODOO-349799 (group-header-value): строка-группа wijmo по Alt — полная информация о группе (поле, значение, число элементов, цепочка родителей); заголовок в ячейке — только значение
            if (opts && opts.alt && this.groupHeaderValue_on() && flex.rows[row] instanceof wjGrid.GroupRow) { const _grpTip = this.groupHeader_tip(row); if (_grpTip) return _grpTip }
            if (opts && opts.alt) { const _sub = this.uiHelp_cellSub(panel, row, col, opts); if (_sub) return _sub }   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5: стрелка формы ячейки под курсором
            const dataItem = flex.rows[row]?.dataItem
            if (!dataItem) return ''
            let ecol = col
            if (this.mergeColumnBlocksColMap && col < this.mergeColumnBlocksTotal) {
                const _block = this.mergeColumnBlocksColMap[col]
                if (_block?.start === col && _block.logCol !== col) ecol = _block.logCol
            }
            // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2: merge «назад» — ячейка, покрытая значением колонки справа (пустые измерения перед значением, корень объединения
            // в колонке дерева, пустые колонки после значения в том же объединении), описывает колонку ЗНАЧЕНИЯ k — как Alt+клик (mergeBack_redirect): подсказка, ссылка,
            // кнопки и объяснение записи — её, а не пустой физической колонки под курсором
            let _mbTip = ''   // IE 2026 10 26 / ODOO-5800 (заказ Игоря 26.10: сдвинутая влево ячейка субъекта — подсветка заголовка исходной колонки и подсказка): строка «Колонка «X»: значение» у ячейки объединения «назад» (только путь Alt)
            if (panel === flex.cells) {
                const _mb = this.mergeBack_info(flex.cells, row)
                if (_mb) {
                    let _c = col
                    // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2 v3: getMergedRange только в области измерений (граница — как в mergeBack_info)
                    if (_c > _mb.k && _c < Math.max(this.mergeColumnBlocksTotal || 0, this.mergeColumns || 0)) { try { const _mr = flex.mergeManager?.getMergedRange(panel, row, col, true); if (_mr && _mr.leftCol >= _mb.startCol && _mr.leftCol <= _mb.k) _c = _mb.startCol } catch (e) { /* без объединения */ } }
                    if (_c >= _mb.startCol && _c < _mb.k) ecol = _mb.k
                    if (opts && opts.alt && mergeBackIsShifted(_mb, _c)) { let _v = ''; try { _v = panel.getCellData(row, _mb.k, true) } catch (e) { _v = '' } _mbTip = mergeBackTipHtml(flex.columns[_mb.k]?.header, _v, t) }   // IE 2026 10 26 / ODOO-5800 (заказ Игоря 26.10: сдвинутая влево ячейка субъекта — подсветка заголовка исходной колонки и подсказка)
                }
            }
            const colObj = flex.columns[ecol]
            if (!colObj) return ''
            const col_binding = colObj.binding
            const attr_col = this.attr_by_binding[col_binding]
            const isData = row >= this.headerRows
            // IE 2026 10 07 / ODOO-5800 (заказ Игоря: «Hidden» поля строки DL2 гасит ячейку своего уровня): у погашенной ячейки (_DLRow.cells[binding].blank) подсказки нет — ни меты бэка (тултип / KPI),
            // ни записи ссылки (Title / ID / сегмент / кнопки открытия), ни пояснений значения: подсказка не должна выдавать скрытое значение
            if (isData && this.cellBlank(dataItem, col_binding)) return ''
            const doc = {}
            let header = ''
            const _has = v => v !== undefined && v !== null && v !== ''
            // transpose: подсказка строки-меры + её значение по умолчанию (attr.default),
            // чтобы при пустом поле было видно, что реально применится
            // АН 2026 10 25 / ODOO-347310: ячейка названия меры (колонка measure.title транспонированного грида — data_layout_transpose; title — на всякий случай) — та же подсказка меры, что у её значений
            // (transpose_measure колонку title исключает намеренно — для форматирования; подсказке она нужна)
            const measureT = attr_col ? (this.transpose_measure(attr_col, dataItem)
                || (this.attr.transpose && (attr_col.binding === 'measure.title' || attr_col.binding === 'title') && dataItem.measure ? dataItem.measure : null)) : null
            if (measureT && (measureT.tooltip || _has(measureT.default))) {
                const defaultT = _has(measureT.default) ? t('Default: {value}', { value: measureT.default }) : ''   // IE 2026 09 23 / ODOO-341407: i18n
                doc[measureT.title || measureT.binding] = [measureT.tooltip, defaultT].filter(Boolean).join('<br/>')
            }
            const KPIs = this.attr.KPIs
            const cf_cell = isData ? dataItem._DLRow?.cells?.[col_binding] : null
            const _pp = isData ? this.approvalFlagPartial_of(dataItem, col_binding, this.store.get_value(dataItem, col_binding), row) : null   // IE 2026 10 14 / ODOO-5800 (Igor): живой итог строки row
            const _ppTip = _pp && _pp.state === 'part' ? approvalFlagPartialTip(_pp) : ''   // IE 2026 10 14 / ODOO-5800
            if (cf_cell) {
                if (cf_cell.tooltip) header = approvalPartialCellTip(approvalCellTip(String(cf_cell.tooltip), this.approval_lock(dataItem) || this.approval_of(dataItem), { userTitle: (u) => this.approval_userTitle(u) }), _pp && _pp.state === 'part' ? _pp : null)   // IE 2026 10 14 / ODOO-5800: «Approved partially: N of M» — по-русски / по-украински   // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — FE1-gtip FE1 (T-03): «Locked by approval: …» — по-русски / по-украински
                if (cf_cell.KPIs_record && KPIs) {
                    for (const KPI in cf_cell.KPIs_record) if (KPIs[KPI]) doc[KPIs[KPI].title] = ''
                }
            }
            // IE 2026 10 14 / ODOO-5800 (Igor): подсказка живого итога — первой строкой; устаревшая строка бэка «Approved partially: …» без живого «частично» снимается
            if (_pp && String(header).startsWith('Approved partially:') && !_ppTip) header = String(header).includes('\n') ? String(header).slice(String(header).indexOf('\n') + 1) : ''
            if (_ppTip && !String(header).startsWith(_ppTip)) header = _ppTip + (header ? '\n' + header : '')
            // IE 2026 09 21 / ODOO-5800 (итоги строк-групп по отбору): в ячейке — итог по видимым строкам; в подсказке — что это и сколько по всем строкам
            if (isData && this._ftMap && attr_col) {
                const _ftf = this.foldAgg_value(dataItem, attr_col.binding0 || col_binding, attr_col)
                if (!(_ftf && _ftf.ft) && this._ftStale?.get(toRaw(dataItem))?.has(attr_col.binding0 || col_binding)) doc[t('Total')] = FT_STALE_HINT()   // IE 2026 09 23 / ODOO-341407: i18n — ленивая подсказка
                if (_ftf && _ftf.ft) {
                    const _all = this.store.get_value(dataItem, col_binding)
                    const _n = Number(_all)
                    doc[t('Total')] = FT_HINT() + ((_all !== null && _all !== undefined && _all !== '' && !Number.isNaN(_n) && attr_col.attr_type === 'AttrNumber')
                        ? ' ' + t('(all rows: {value})', { value: wjcCore.Globalize.format(_n, attr_col.format || 'n0') }) : '')   // IE 2026 09 23 / ODOO-341407: i18n
                }
            }
            // IE 2026 10 05 / ODOO-5800 (fe-85) (ревью cause detail): числа проверки причины строки грида сигналов (reason_detail бэка) — строкой шапки карточки: при
            // Show tooltips и по Alt показывается карточка wijmo, нативный title ячейке в это время не ставится / снимается (две подсказки сразу)
            if (isData && attr_col) {
                const _cdTip = sigRow_causeDetail(dataItem, attr_col.binding, () => store.setting(CAUSE_DETAIL_KEY, true))
                if (_cdTip) header = header ? `${header}<br>${escHtml(_cdTip)}` : escHtml(_cdTip)
            }
            const MD = isData ? dataItem.MD : null
            if (MD) {
                const mdTip = MD.tooltip?.[col_binding]
                if (mdTip) header = header ? `${header}<br>${mdTip}` : String(mdTip)
                if (MD.KPIs_doc?.[col_binding] && KPIs) {
                    for (const KPI in MD.KPIs_doc[col_binding]) if (KPIs[KPI]) doc[KPIs[KPI].title] = ''
                }
            }
            // поле-строка формы (AttrTabGrid: подсказка поля видна с любой колонки строки)
            // или мульти-значение ячейки (ссылка: id ↔ титул)
            let V = null, isMulti = false
            if (this.attr.attr_type === 'AttrTabGrid' && dataItem.attr && typeof dataItem.attr === 'object') {
                V = dataItem.attr
            } else if (attr_col?.attr_type === 'AttrMulti') {
                const v = this.foldAgg_getValue(dataItem, attr_col.binding, attr_col)
                if (v && typeof v === 'object') { V = v; isMulti = true }
            }
            // строка-группа формы (AttrTab без binding и tooltip) — без карточки: один «Field type» — шум
            if (V && (V.tooltip || V.binding)) {   // IE 2026 09 23 / ODOO-341407: i18n (ключи карточки — подписи)
                if (V.tooltip) doc[t('Tooltip')] = V.tooltip
                if (_has(V.placeholder)) doc[t('Default')] = V.placeholder
                if ((isMulti || V.relation_segment) && V.value && V.value !== V.valueStr) doc[t('ID')] = V.value
                if (V.binding) doc[t('Field')] = V.binding
                if (V.attr_type && V.binding) doc[t('Field type')] = V.attr_type
                if (V.relation_segment) doc[t('Relation segment')] = V.relation_segment
                if (V.relation_binding) doc[t('Relation field')] = V.relation_binding
            }
            // IE 2026 09 23 / ODOO-… (заказ Игоря: кнопки в подсказках): ссылочная ячейка (колонка с relation_segment и значением; мультиссылка — первый id): Title / ID / Relation segment
            // в карточке и кнопки открыть / ссылка в буфер / новая вкладка (tipCell_action → onButtonOpen__Click); пустая ячейка — без подсказки, как было
            let _tipLink = null
            // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2: запись ячейки (_recLink) — строки объяснения записи в пути Alt и «Edit description» админу — не зависит от выключателя
            // кнопок fe.ux.tooltipActions; строки Title / ID / Relation segment и кнопки — как были (только при кнопках)
            let _recLink = null
            const _tipOn = store.tipActions_on()
            // webscm 2026 10 23 / ODOO-348737 (Андрей: «тултипы по одовским полям не отображаются»): ссылка Odoo (AttrLinkOdoo, many2one записи DataHub) в таблице — та же
            // карточка ссылки, что у AttrLink (Title / ID / Relation segment, кнопки открыть / ссылка / новая вкладка); значение — [id, name] (колонка показывает name,
            // binding[1]), название — из самого значения; пустая ссылка Odoo — false: не ссылка (раньше Alt над ячейкой показывал подсказку всей таблицы)
            const _odooLink = attr_col?.attr_type === 'AttrLinkOdoo'
            if (isData && attr_col && attr_col.relation_segment && (['AttrLink', 'AttrMulti', 'AttrLinkChips'].includes(attr_col.attr_type) || _odooLink)) {
                const _raw = (isMulti && V) ? V.value : this.foldAgg_getValue(dataItem, attr_col.binding, attr_col)
                let _id = _raw
                if (Array.isArray(_id)) _id = _id[0]
                if (_id && typeof _id === 'object') _id = _id.value ?? _id.id
                if (_id !== undefined && _id !== null && _id !== '' && _id !== false && typeof _id !== 'object') {
                    _id = String(_id)
                    _recLink = { id: _id, segment: String(attr_col.relation_segment || '') }   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2
                }
                if (_recLink && _tipOn) {
                    let _title = (isMulti && V) ? String(V.valueStr || '') : ''
                    if (!_title && _odooLink && Array.isArray(_raw)) _title = String(_raw[1] ?? '')   // webscm 2026 10 23 / ODOO-348737
                    if (!_title) { try { _title = String(store.get_itemsSource(this, {}, attr_col, { fetchMode: 'justGet' })?.ids?.[_id]?.title || '') } catch (e) { _title = '' } }
                    if (_title && _title !== _id && !(t('Title') in doc)) doc[t('Title')] = _title
                    if (!(t('ID') in doc)) doc[t('ID')] = _id
                    if (!(t('Relation segment') in doc)) doc[t('Relation segment')] = attr_col.relation_segment
                    _tipLink = { row, col: ecol, irow: row, col_binding, id: _id, segment: String(attr_col.relation_segment || '') }   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U1: id / segment — объяснение
                }
            }
            // IE 2026 09 23 / ODOO-… (заказ Игоря: кнопки в подсказках) · v2: строка-поле формы (AttrTabGrid) со ссылкой (Parent, Variant of …): кнопки у любой колонки строки, действие — по колонке
            // значения attr.valueStr (тот же путь, что кнопка-стрелка строки: onButtonOpen__Click → V = dataItem.attr)
            // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2: запись строки-поля формы (AttrTabGrid, колонка attr.valueStr) и мульти-значения со своим сегментом (строки Settings tree / Variants:
            // { value, valueStr, pi, relation_segment })
            // webscm 2026 10 23 / ODOO-348737: пустая ссылка Odoo (false) — не запись «false» (карточка поля формы предлагала «Add description» несуществующей записи)
            if (!_recLink && isData && V && V.relation_segment && V.value !== undefined && V.value !== null && V.value !== '' && V.value !== false && typeof V.value !== 'object' && (this.attr.attr_type === 'AttrTabGrid' || isMulti)) _recLink = { id: String(V.value), segment: String(V.relation_segment) }
            // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U3: колонка со своим attr.uiHelp без своего _tipLink (напр. Title списка настроек — AttrMulti без relation_segment НА КОЛОНКЕ)
            const _uiHelpColKey = !_tipLink && attr_col?.uiHelp ? attr_col.uiHelp : ''
            // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U3: бейдж «Current» в списке настроек (Widget.settingsList_rebuild кладёт dataItem.badge/badge_class/badge_title,
            // formatItem рисует span.cell-badge строкой — директиву вешать некуда; строки объяснения — здесь же, в подсказке ячейки Title (та же ячейка, где сам бейдж)
            const _uiHelpBadgeKey = isData && ((V && typeof V === 'object' && V.badge_class === 'cell-badge-current') || dataItem?.badge_class === 'cell-badge-current') ? 'widget.settings.list.current' : ''   // накат 26.09: бейдж лежит на ЗНАЧЕНИИ ячейки Title (dataItem.title.badge_class), не на строке
            if (!_tipLink && isData && this.attr.attr_type === 'AttrTabGrid' && V && V.relation_segment && V.value && typeof V.value !== 'object' && _tipOn) {
                const _vcol = flex.columns.findIndex(c => c.binding === 'attr.valueStr')
                if (_vcol >= 0) _tipLink = { row, col: _vcol, irow: row, col_binding: 'attr.valueStr', id: String(V.value), segment: String(V.relation_segment || '') }   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U1
            }
            // IE 2026 09 25 / ODOO-… (замечание Игоря: поиск в таблице по названиям на других языках): ячейка-ссылка найдена по названию записи на другом языке — «Matched: <имя> (English)»
            if (this._altMark && isData && attr_col && attr_col.relation_segment) { const _am = this.searchAlt_matchedOf(dataItem, attr_col, (isMulti && V) ? V.value : undefined); if (_am) doc[t('Matched')] = _am }
            let html = store.tooltip_html(doc, header)
            // рекомендация cells_binding — поверх остального (её же formatItem регистрирует безусловно)
            if (this.attr.cells_binding && isData && ecol >= this.headerColumns) {
                const cb_cell = this.cells_binding_map?.[row - this.headerRows + 1]?.[ecol - this.headerColumns + 1]
                if (cb_cell?.comment) {
                    const value = attr_col ? this.foldAgg_getValue(dataItem, attr_col.binding, attr_col) : null
                    const recVal = cb_cell.value != null ? cb_cell.value : ''
                    const curVal = value != null ? String(value) : ''
                    html = `<b>${t('Recommendation:')}</b> ${recVal}` + (curVal ? `<br/><b>${t('Current value:')}</b> ${curVal}` : '') + `<br/><br/>${cb_cell.comment}`   // IE 2026 09 23 / ODOO-341407: i18n
                }
            }
            // комментарий согласования (elements_appearance) — в первой колонке, поверх всего
            const _appRow = this.attr.elements_appearance && dataItem._appearance
            if (_appRow?.comment && ecol === 0) html = String(_appRow.comment)
            // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U1: ссылочная ячейка — строки объяснения (что это, как открыть; utils/uiHelp/grid.js) — к Title / ID / Relation segment,
            // перед кнопками; объяснение самой записи от поставщиков записей (точка расширения R2) — только в пути Alt; выключатель fe.ux.uiHelp — как было
            if ((_tipLink || _recLink || _uiHelpColKey || _uiHelpBadgeKey) && uiHelp_enabled()) {
                let _help = _tipLink ? uiHelp_rowsHtml('grid.cellLink', {}, ['what', 'click']) : (_uiHelpColKey ? uiHelp_rowsHtml(_uiHelpColKey, {}, ['what', 'click']) : '')
                if (_uiHelpBadgeKey) _help += uiHelp_rowsHtml(_uiHelpBadgeKey, { state: String((V && typeof V === 'object' && V.badge) || dataItem?.badge || '').includes('\u00b7') ? 'variant' : 'current' }, ['what', 'why', 'now'])
                // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2: объяснение записи ячейки (About / Purpose / How to use) и «Edit description» админу — в пути Alt, перед кнопками
                if (opts && opts.alt && _recLink) {
                    _help += uiHelp_recordRowsHtml(_recLink.id, _recLink.segment, { grid: true, widget: this.WIDGET?.id })
                    let _ttl = String(doc[t('Title')] || (V && V.valueStr) || '')
                    if (!_ttl && attr_col && attr_col.relation_segment) { try { _ttl = String(store.get_itemsSource(this, {}, attr_col, { fetchMode: 'justGet' })?.ids?.[_recLink.id]?.title || '') } catch (e) { _ttl = '' } }
                    _help += recordHelp.editHtml({ ..._recLink, title: _ttl || _recLink.id })
                    // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2 v2: строки записи у ячейки без своих строк (строка Settings tree / Variants, ссылка при выключенных кнопках): Title / ID / Relation segment
                    // записи — иначе пустая подсказка уходит к владельцу выше (виджет) и объяснение записи, пришедшее позже, к ячейке не возвращается
                    if (!html) { const _d = {}; if (_ttl && _ttl !== _recLink.id) _d[t('Title')] = _ttl; _d[t('ID')] = _recLink.id; if (_recLink.segment) _d[t('Relation segment')] = _recLink.segment; html = store.tooltip_html(_d) }
                }
                if (_help) html += html ? _help : _help.replace(/^<br>/, '')
            }
            // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5: строка «Marks» — только путь Alt (opts.el — наведённая ячейка; Show tooltips запекает статичный текст при отрисовке), перед кнопками
            if (opts && opts.alt && opts.el && uiHelp_enabled()) {
                let _marks = this.cellMarks(panel, row, ecol, opts.el, dataItem, attr_col, isData)
                if (_marks && Array.isArray(opts.marksSkip) && opts.marksSkip.length) _marks = _marks.filter(m => !opts.marksSkip.includes(m && m.key))   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p231 підказка по сигналу — проблема як у формі комірки): подсказка с проблемами ячейки — без метки сигнала
                const _mh = _marks && _marks.length ? this.cellMarks_html(_marks, { short: true }) : ''   // IE 2026 10 31 / ODOO-5800 (заказ Игоря: Alt-довідка в одноколонковій формі)
                if (_mh) html += html ? _mh : _mh.replace(/^<br>/, '')
            }
            if (_tipLink) {   // IE 2026 09 23 / ODOO-… (заказ Игоря: кнопки в подсказках)
                const _tok = tipActions_bind((act) => this.tipCell_action(_tipLink, act), `cell:${this.attr?.html_id || this.attr?.id || this.attr?.name || ''}:${this.WIDGET?.id}:${row}:${ecol}`)
                html += tipActions_html(recordActions({ cb: _tok }, { openTitle: t('Open') }))
            }
            if (_mbTip) html = _mbTip + (html ? '<br>' + html.replace(/^<br>/, '') : '')   // IE 2026 10 26 / ODOO-5800 (заказ Игоря 26.10: сдвинутая влево ячейка субъекта — подсветка заголовка исходной колонки и подсказка)
            return html
        },
        print_mvtView_Click() {
            // кнопка режима превью печати: склеенные секции <-> отдельные секции
            // (грид секции — ребёнок AttrGridGroup)
            let p = this.$parent
            while (p && !p.mvt_toggleGlued) p = p.$parent
            p?.mvt_toggleGlued?.()
        },
        cellsList_isActive() {
            // грид «Print cells» (👁): widget-row-viewParams с именем '*-cells'
            return this.WIDGET.widget === 'widget-row'
                && this.WIDGET.record?._meta?.type === 'widget-row-viewParams'
                && String(this.WIDGET.record?._meta?.name || '').endsWith('-cells')
                && this.attr.name === 'attrs'
        },
        cellsList_tplGrid(globalRow = null) {
            // видимый грид шаблона печати в родительском виджете (клоны полос
            // регистрируются под тем же именем — берём с колонками и в DOM)
            const gridName = String(this.WIDGET.record?._meta?.name || '')
            const baseName = gridName.slice(0, -('-cells'.length))
            const parentWIDGET = this.store.findWidget(this.WIDGET.parentWIDGET?.id)?.WIDGET
            const okGrid = v => v?.flex?.hostElement && v.flex.columns?.length && v.flex.hostElement.offsetParent
            let tpl = parentWIDGET?.vueObj?.get_vueObj?.(baseName)
            if (!okGrid(tpl)) {
                tpl = Object.values(parentWIDGET?.attrs_vueObj || {}).find(v => v?.attr?.name === baseName && okGrid(v)) || tpl
            }
            if (!okGrid(tpl)) {
                // секции мульти-вертикальной таблицы: гриды не в attrs_vueObj —
                // через координатор (WIDGET._mvtObjs); секцию выбираем по
                // СКВОЗНОМУ номеру строки (globalRow), иначе по имени/первую
                for (const mvt of Object.values(parentWIDGET?._mvtObjs || {})) {
                    const refs = (mvt.sectionRefs || []).filter(r => okGrid(r))
                    let ref = refs.find(r => r?.attr?.name === baseName)
                    if (!ref && globalRow) {
                        ref = refs.find(r => {
                            const off = r.attr?.rowIndexOffset || 0
                            return globalRow > off && globalRow <= off + (r.flex?.rows?.length || 0)
                        })
                    }
                    if (!ref && refs.length) ref = refs[0]
                    if (ref) { tpl = ref; break }
                }
            }
            return tpl?.flex ? tpl : null
        },
        cellsList_writeBack(listItem, col_binding, oldVal, newVal) {
            // 👁/вкладка Print cells → шаблон: правка строки списка ячеек
            // применяется к ячейке шаблона (статический текст / _cells.col_N).
            // dataMode (вкладка Print cells): правим строки КАНОНА
            // doc.printTemplate напрямую — визуалка может быть не смонтирована
            const dataMode = this.printCellsTab_isActive()
            const _gRow = parseInt(col_binding === 'row' ? oldVal : listItem.row) || 0
            const revert = (msg) => {
                this.store.set_value(listItem, col_binding, oldVal)
                if (msg) this.store.show_notification({ text: msg, status: 'warning' })
                this.flexRefresh()
            }
            let tpl = null, _tplOff = 0, rowsCount = 0, tplDi = null, flatRows = null
            if (dataMode) {
                flatRows = this.printCellsTab_canonRows().flat
                rowsCount = flatRows.length
                tplDi = flatRows[_gRow - 1]
            } else {
                tpl = this.cellsList_tplGrid(_gRow)
                if (!tpl) return
                _tplOff = tpl.attr.rowIndexOffset || 0
                rowsCount = tpl.flex.rows.length
                tplDi = tpl.flex.rows[_gRow - _tplOff - 1]?.dataItem
            }
            const oldRow = _gRow - _tplOff
            if (!tplDi) return revert(t('Template row not found'))   // IE 2026 09 23 / ODOO-341407: i18n (и ниже — тексты revert/warn)
            const done = () => {
                if (dataMode) {
                    this.printCellsTab_afterWB()
                } else {
                    tpl.setModified(tplDi)
                    tpl.flex.invalidate()
                }
            }

            // строка-СЕКЦИЯ канона (AttrGrid с attrs БЕЗ binding):
            // правится только Title (имя секции), остальное — в самом шаблоне
            if (listItem.attr_type === 'AttrGrid' && Array.isArray(listItem.attrs) && !listItem.binding) {
                if (col_binding !== 'title') return revert(t('Section rows: edit cells inside the section instead'))
                if (!dataMode) return revert(t('Section title is editable on the print settings tab'))
                const { secs } = this.printCellsTab_canonRows()
                let off = 0, target = null
                for (const s of secs || []) {
                    if (off + 1 === (parseInt(listItem.row) || 0)) { target = s; break }
                    off += (s.attrs || []).length
                }
                if (!target) return revert(t('Section not found'))
                this.store.set_value(target, 'title', String(newVal || '').replace(/^§\s*/, ''))
                this.printCellsTab_afterWB()
                return
            }

            // строка «Table part»: редактируется только binding (путь табличной части)
            if (listItem.attr_type === 'AttrGrid' && Array.isArray(listItem.attrs) && listItem.binding) {
                if (col_binding === 'binding') {
                    const key = ('repeat' in tplDi && tplDi.repeat) ? 'repeat' : 'tablePart'
                    this.store.set_value(tplDi, key, newVal)
                } else if (col_binding !== 'title') {
                    return revert(t('Move the whole table part row in the template itself'))
                }
                done()
                return
            }

            const oldCol = parseInt(col_binding === 'col' ? oldVal : listItem.col) || 0
            const colKey = 'col_' + oldCol
            const ovAll = tplDi._cells || {}
            const isChildOfTablePart = !!(tplDi.tablePart || tplDi.repeat)
            const fieldPath = k => `_cells.${k}.fields[0]`
            const f0 = (ovAll[colKey] && Array.isArray(ovAll[colKey].fields) && ovAll[colKey].fields[0]) || {}
            // статический текст в значении col_N (старая модель): любая правка
            // контентных колонок мигрирует его в fields[0].source
            const migrateStatic = () => {
                const sv = tplDi[colKey]
                if (typeof sv === 'string' && sv.trim() && !f0.binding && f0.source == null) {
                    this.store.set_value(tplDi, `${fieldPath(colKey)}.source`, sv.trim())
                    this.store.set_value(tplDi, colKey, null)
                    return true
                }
                return false
            }

            switch (col_binding) {
                case 'title':
                    migrateStatic()
                    this.store.set_value(tplDi, `${fieldPath(colKey)}.title`, newVal || null)
                    break
                case 'binding':
                    this.store.set_value(tplDi, `${fieldPath(colKey)}.binding`, newVal || null)
                    break
                case 'source':
                case 'source_field':
                case 'source_field.value':
                case 'source_field.valueStr': {
                    // группа Source (source_field.value) — статический текст /
                    // '='-формула ячейки; значение может прийти объектом AttrMulti
                    let sv = newVal
                    if (sv && typeof sv === 'object') sv = sv.value ?? sv.valueStr ?? ''
                    const migrated = migrateStatic()
                    this.store.set_value(tplDi, `${fieldPath(colKey)}.source`, sv ?? '')
                    if (!migrated && typeof tplDi[colKey] === 'string' && tplDi[colKey]) {
                        this.store.set_value(tplDi, colKey, null)
                    }
                    break
                }
                case 'attr_type':
                    this.store.set_value(tplDi, `${fieldPath(colKey)}.attr_type`, (newVal === 'Source' || (newVal === 'AttrStr' && !f0.binding)) ? null : newVal)
                    break
                case 'relation_segment':
                    this.store.set_value(tplDi, `${fieldPath(colKey)}.relation_segment`, newVal || null)
                    break
                case 'format':
                    this.store.set_value(tplDi, `${fieldPath(colKey)}.format`, newVal || null)
                    break
                case 'colspan':
                case 'rowspan': {
                    const n = parseInt(newVal)
                    this.store.set_value(tplDi, `_cells.${colKey}.${col_binding}`, (n && n > 1) ? n : null)
                    break
                }
                case 'row':
                case 'col': {
                    const newRow = (parseInt(col_binding === 'row' ? newVal : listItem.row) || 0) - _tplOff
                    const newCol = parseInt(col_binding === 'col' ? newVal : listItem.col) || 0
                    if (isChildOfTablePart && col_binding === 'row') return revert(t('Cells of a table part stay in its row'))
                    if (newRow < 1 || newRow > rowsCount || newCol < 1 || newCol > 49) return revert(t('Out of template range (section)'))
                    if (dataMode) {
                        // data-перенос по строкам КАНОНА (двойник printCell_move)
                        if (!this.printCellsTab_moveCell(tplDi, colKey, flatRows[newRow - 1], 'col_' + newCol)) {
                            return revert(null)
                        }
                    } else {
                        // перенос: текст + все настройки _cells (общий printCell_move,
                        // он же обслуживает drag ячейки в самом шаблоне)
                        if (!tpl.printCell_move(oldRow - 1, colKey, newRow - 1, 'col_' + newCol)) {
                            return revert(null) // предупреждение показал printCell_move
                        }
                    }
                    break
                }
                default:
                    return
            }
            done()
        },
        printCellsTab_moveCell(di1, colB1, di2, colB2) {
            // data-двойник printCell_move: перенос текста и ПОЛНЫХ настроек
            // _cells между строками КАНОНА (вкладка Print cells)
            const warn = (t) => { this.store.show_notification({ text: t, status: 'warning' }); return false }
            if (!di1 || !di2) return warn(t('Template row not found'))   // IE 2026 09 23 / ODOO-341407: i18n
            if (di1.attr_type === 'AttrGrid') return warn(t('Section row is not a movable cell'))
            if (di2.attr_type === 'AttrGrid') return warn(t('Cannot move into a section row'))
            if (di1 === di2 && colB1 === colB2) return false
            const text = di1[colB1]
            const ovCell = di1._cells?.[colB1]
            if (text == null && !ovCell) return warn(t('Nothing to move'))
            const occupied = (typeof di2[colB2] === 'string' && di2[colB2].trim()) || di2._cells?.[colB2]
            if (occupied) return warn(t('Target cell is not empty'))
            this.store.set_value(di1, colB1, null)
            if (ovCell) this.store.set_value(di1, `_cells.${colB1}`, null)
            if (typeof text === 'string' && text) this.store.set_value(di2, colB2, text)
            if (ovCell) this.store.set_value(di2, `_cells.${colB2}`, this.store.deepCopy(ovCell))
            return true
        },
        printCells_paste(e) {
            // вставка ячеек шаблона печати из copiedData.printCells (Ctrl+V):
            // статический текст + ПОЛНЫЕ настройки _cells по смещениям диапазона.
            // Чужой текст в буфере (textProbe не совпал) — обычная текстовая вставка
            const pc = this.store.copiedData?.printCells
            if (!pc || !pc.cells?.length) {
                if (this.printCells_pasteNodes(e)) return true // узлы Cells-формата (копия строк вкладки Cells)
                return this.printCells_pasteData(e) // копия ячеек ОБЫЧНОГО грида → статический текст
            }
            const txt = String(e.data ?? '').trim()
            if (txt && (!pc.textProbe || !String(e.data).includes(pc.textProbe))) return false
            const sel = this.flex.selection
            const baseRow = e.range?.topRow ?? e.row ?? sel?.topRow ?? 0
            const baseCol = e.range?.leftCol ?? e.col ?? sel?.leftCol ?? 0
            let applied = 0
            for (const c of pc.cells) {
                const di = this.flex.rows[baseRow + c.dRow]?.dataItem
                const colB = this.flex.columns[baseCol + c.dCol]?.binding
                if (!di || !colB || !colB.startsWith('col_')) continue
                if (di.attr_type === 'AttrGrid') continue // не в строку-секцию
                this.store.set_value(di, colB, c.value ?? null)
                this.store.set_value(di, `_cells.${colB}`, c.ov ? this.store.deepCopy(c.ov) : null)
                this.setModified(di)
                applied++
            }
            if (applied) {
                this.actionStack++
                this.flex.invalidate()
            }
            return applied > 0
        },
        printCells_pasteData(e) {
            // вставка в шаблон копии ячеек ОБЫЧНОГО грида (VIEW/список, Ctrl+C):
            // каждая скопированная ячейка становится статическим текстом шаблона
            // по смещениям диапазона (просьба Игоря: строки VIEW → ячейки Template)
            const cd = this.store.copiedData
            if (!Array.isArray(cd?.data) || !cd.data.length) return false
            // чужой текст в системном буфере — обычная текстовая вставка
            const txt = String(e.data ?? '').trim()
            const probe = cd.data.find(V => String(V.valueStr ?? '').trim())
            if (txt && probe && !String(e.data).includes(String(probe.valueStr).trim())) return false
            const top = Math.min(...cd.data.map(V => V.irow)),
                left = Math.min(...cd.data.map(V => V.icol))
            const sel = this.flex.selection
            const baseRow = e.range?.topRow ?? e.row ?? sel?.topRow ?? 0
            const baseCol = e.range?.leftCol ?? e.col ?? sel?.leftCol ?? 0
            let applied = 0
            for (const V of cd.data) {
                const di = this.flex.rows[baseRow + (V.irow - top)]?.dataItem
                const colB = this.flex.columns[baseCol + (V.icol - left)]?.binding
                if (!di || !colB || !colB.startsWith('col_')) continue
                if (di.attr_type === 'AttrGrid') continue // не в строку-секцию
                const sv = String(V.valueStr ?? V.value ?? '').trim()
                if (!sv) continue
                this.store.set_value(di, colB, sv)
                this.store.set_value(di, `_cells.${colB}`, null)
                this.setModified(di)
                applied++
            }
            if (applied) {
                this.actionStack++
                this.flex.invalidate()
            }
            return applied > 0
        },
        printCells_pasteNodes(e) {
            // вставка узлов-ячеек Cells-формата (единый буфер: копия строк
            // вкладки Cells или ячеек шаблона) — в позицию выделения по
            // СМЕЩЕНИЯМ row/col скопированного набора
            const cd = this.store.copiedData
            if (!cd?.printCellNodes || !Array.isArray(cd.items) || !cd.items.length) return false
            const nodes = cd.items.filter(n => this.store.isinstance_dict(n)
                && (parseInt(n.col) || 0) > 0
                && (n.binding || n.source_field || n.title))
            if (!nodes.length) return false
            // чужой текст в системном буфере — обычная вставка
            const txt = String(e.data ?? '').trim()
            if (txt && !nodes.some(n => [n.title, n.binding, n.source_field?.value]
                .some(v => v && txt.includes(String(v))))) return false
            const sel = this.flex.selection
            const baseRow = e.range?.topRow ?? e.row ?? sel?.topRow ?? 0
            const baseCol = e.range?.leftCol ?? e.col ?? sel?.leftCol ?? 0
            const minRow = Math.min(...nodes.map(n => parseInt(n.row) || 1))
            const minCol = Math.min(...nodes.map(n => parseInt(n.col) || 1))
            let applied = 0
            for (const n of nodes) {
                const di = this.flex.rows[baseRow + ((parseInt(n.row) || 1) - minRow)]?.dataItem
                const colB = this.flex.columns[baseCol + ((parseInt(n.col) || 1) - minCol)]?.binding
                if (!di || !colB || !colB.startsWith('col_')) continue
                if (di.attr_type === 'AttrGrid') continue
                this.printCellNode_apply(di, colB, n)
                this.setModified(di)
                applied++
            }
            if (applied) {
                this.actionStack++
                this.flex.invalidate()
            }
            return applied > 0
        },
        printCell_move(irow1, colB1, irow2, colB2) {
            // перенос ячейки шаблона ВМЕСТЕ с настройками (_cells): drag за
            // рамку выделения или смена Row/Col в списке ячеек (👁)
            const flex = this.flex
            const di1 = flex.rows[irow1]?.dataItem, di2 = flex.rows[irow2]?.dataItem
            const warn = (t) => { this.store.show_notification({ text: t, status: 'warning' }); return false }
            if (!di1 || !di2) return warn(t('Template row not found'))   // IE 2026 09 23 / ODOO-341407: i18n
            if (di1.attr_type === 'AttrGrid') return warn(t('Section row is not a movable cell'))
            if (di2.attr_type === 'AttrGrid') return warn(t('Cannot move into a section row'))
            if (irow1 === irow2 && colB1 === colB2) return false
            const text = di1[colB1]
            const ovCell = di1._cells?.[colB1]
            if (text == null && !ovCell) return warn(t('Nothing to move'))
            const occupied = (typeof di2[colB2] === 'string' && di2[colB2].trim()) || di2._cells?.[colB2]
            if (occupied) return warn(t('Target cell is not empty'))
            this.store.set_value(di1, colB1, null)
            if (ovCell) this.store.set_value(di1, `_cells.${colB1}`, null)
            if (typeof text === 'string' && text) this.store.set_value(di2, colB2, text)
            if (ovCell) this.store.set_value(di2, `_cells.${colB2}`, this.store.deepCopy(ovCell))
            this.setModified(di1)
            if (di2 !== di1) this.setModified(di2)
            this.actionStack++
            flex.invalidate()
            return true
        },
        // ---- drag ячейки шаблона печати (за рамку выделенной ячейки, как в Excel) ----
        printCellDrag_init() {
            this.flex.hostElement.addEventListener('pointerdown', this.printCellDrag_down, true)
        },
        printCellDrag_down(ev) {
            if (ev.button !== 0 || this._pcDrag) return
            const flex = this.flex
            if (!flex?.hostElement) return
            const ht = flex.hitTest(ev)
            if (!ht || ht.cellType !== wjGrid.CellType.Cell) return
            const sel = flex.selection
            if (!sel?.isValid || sel.row !== sel.row2 || sel.col !== sel.col2) return
            if (ht.row !== sel.row || ht.col !== sel.col) return
            const cellEl = ev.target.closest?.('.wj-cell')
            if (!cellEl) return
            const r = cellEl.getBoundingClientRect()
            const edge = 5
            const nearEdge = ev.clientX - r.left <= edge || r.right - ev.clientX <= edge
                || ev.clientY - r.top <= edge || r.bottom - ev.clientY <= edge
            if (!nearEdge) return
            const di = flex.rows[ht.row]?.dataItem
            const colB = flex.columns[ht.col]?.binding
            if (!di || !colB || !colB.startsWith('col_')) return
            if (di.attr_type === 'AttrGrid') return
            if (di[colB] == null && !di._cells?.[colB]) return // пустую не таскаем
            ev.preventDefault()
            ev.stopPropagation()
            const ghost = document.createElement('div')
            ghost.className = 'print-cell-ghost'
            ghost.textContent = (cellEl.textContent || '').trim() || '⬚'
            document.body.appendChild(ghost)
            this._pcDrag = { fromRow: ht.row, fromColB: colB, ghost, targetEl: null, toRow: null, toCol: null }
            this._pcMove = (e2) => this.printCellDrag_move(e2)
            this._pcUp = (e2) => this.printCellDrag_up(e2)
            document.addEventListener('pointermove', this._pcMove, true)
            document.addEventListener('pointerup', this._pcUp, true)
            this.printCellDrag_move(ev)
        },
        printCellDrag_move(ev) {
            const d = this._pcDrag
            if (!d) return
            d.ghost.style.left = (ev.clientX + 10) + 'px'
            d.ghost.style.top = (ev.clientY + 12) + 'px'
            if (d.targetEl) { d.targetEl.classList.remove('print-drag-target'); d.targetEl = null }
            d.toRow = d.toCol = null
            const ht = this.flex.hitTest(ev)
            if (ht && ht.cellType === wjGrid.CellType.Cell) {
                d.toRow = ht.row
                d.toCol = ht.col
                const el = document.elementFromPoint(ev.clientX, ev.clientY)?.closest('.wj-cell')
                if (el && this.flex.hostElement.contains(el)) {
                    el.classList.add('print-drag-target')
                    d.targetEl = el
                }
            }
        },
        printCellDrag_up() {
            const d = this._pcDrag
            if (!d) return
            document.removeEventListener('pointermove', this._pcMove, true)
            document.removeEventListener('pointerup', this._pcUp, true)
            d.ghost.remove()
            if (d.targetEl) d.targetEl.classList.remove('print-drag-target')
            this._pcDrag = null
            if (d.toRow == null) return
            const toColB = this.flex.columns[d.toCol]?.binding
            if (!toColB || !toColB.startsWith('col_')) return
            if (d.toRow === d.fromRow && toColB === d.fromColB) return
            if (this.printCell_move(d.fromRow, d.fromColB, d.toRow, toColB)) {
                this.flex.select(new wjGrid.CellRange(d.toRow, d.toCol), true)
            }
        },
        merge_Click(e) {
            const range = this.get_selectedRange();
            if (!range) return;
            let { irow1, irow2, icol1, icol2 } = range;

            // // если выделена одна ячейка — ничего не делаем
            // if (irow1 === irow2 && icol1 === icol2) return;

            // if (!this.store.get_value(this.flex.rows[irow1].dataItem, `_cells.${this.get_attr_col(icol1).binding}.merge`)) {
            //     for (let irow = irow1; irow <= irow2; irow++) {
            //         this.store.set_value(this.flex.rows[irow].dataItem, `_cells.${this.get_attr_col(icol1).binding}.merge`, 'up')
            //         for (let icol = icol1 + 1; icol <= icol2; icol++) {
            //             this.store.set_value(this.flex.rows[irow].dataItem, `_cells.${this.get_attr_col(icol).binding}.merge`, 'left')
            //         }
            //     }
            //     this.store.set_value(this.flex.rows[irow1].dataItem, `_cells.${this.get_attr_col(icol1).binding}.merge`, 'root')
            // } else {
            //     for (let irow = irow1; irow <= irow2; irow++) {
            //         for (let icol = icol1; icol <= icol2; icol++) {
            //             this.store.set_value(this.flex.rows[irow].dataItem, `_cells.${this.get_attr_col(icol).binding}.merge`, null)
            //         }
            //     }
            // }
            this.set_merge(null, irow1, irow2, icol1, icol2)

            this.flex.invalidate()
        },
        set_merge(rows=null, irow1, irow2, icol1, icol2) {
            // объединение ячеек печати: colspan/rowspan на корневой (верхней левой)
            // ячейке — их читает CustomMergeManager (isPrint/isPrintTemplate).
            // Повторное нажатие на корне объединения — снять (toggle).
            const dataItem1 = this.get_dataItem2(rows, irow1)
            const rootBinding = this.get_attr_col(icol1).binding
            const curCS = parseInt(this.store.get_value(dataItem1, `_cells.${rootBinding}.colspan`)) || 1
            const curRS = parseInt(this.store.get_value(dataItem1, `_cells.${rootBinding}.rowspan`)) || 1
            const hasSpan = curCS > 1 || curRS > 1
            // одна ячейка без объединения — нечего делать
            if (irow1 === irow2 && icol1 === icol2 && !hasSpan) return;

            const merging = !hasSpan && (irow2 > irow1 || icol2 > icol1)
            const newCS = merging ? icol2 - icol1 + 1 : null,
                newRS = merging ? irow2 - irow1 + 1 : null
            if (merging) {
                this.store.set_value(dataItem1, `_cells.${rootBinding}.colspan`, newCS)
                this.store.set_value(dataItem1, `_cells.${rootBinding}.rowspan`, newRS)
            } else {
                this.store.set_value(dataItem1, `_cells.${rootBinding}.colspan`, null)
                this.store.set_value(dataItem1, `_cells.${rootBinding}.rowspan`, null)
            }
            // история Undo/Redo: merge/unmerge — одно действие
            this.hist_push({
                method: 'props',
                cells: [
                    { item: dataItem1, path: `_cells.${rootBinding}.colspan`, oldValue: hasSpan ? curCS : null, newValue: newCS },
                    { item: dataItem1, path: `_cells.${rootBinding}.rowspan`, oldValue: hasSpan ? curRS : null, newValue: newRS },
                ],
                label: merging ? t('Merge cells') : t('Unmerge cells'),   // IE 2026 09 23 / ODOO-341407: i18n
            })
            this.printTpl_afterChange() // объединение ячеек эфемерного шаблона → канон
        },
        treeSiblings_selected(parentItems) {
            // выделенные dataItem'ы, являющиеся сиблингами в parentItems
            const sel = []
            const r1 = this.flex.selectedRanges[0].topRow, r2 = this.flex.selectedRanges[0].bottomRow
            for (let ir = Math.min(r1, r2); ir <= Math.max(r1, r2); ir++) {
                const di = this.flex.rows[ir]?.dataItem
                if (di && parentItems.includes(di) && !sel.includes(di)) sel.push(di)
            }
            return sel
        },
        treeParentItems_of(irow) {
            if (this.flex.rows[irow].level > 0) return this.get_parentItems(irow)
            return this.flex.collectionView?.sourceCollection || this.get_parentItems(irow)
        },
        treeReparent_(sel, oldArr, newArr, insertIdx, parentValue) {
            // IE 2026 08 20 / ODOO-5512 (заказ Игоря): CHIP-Tree дерево — left/right
            // меняют уровень И РЕКВИЗИТ parent строк (+ перенумерация order обоих
            // родителей): после сохранения дискеткой и обновления иерархия та же
            const binding = (this.applied_chipTree || [])[0] || 'parent'
            for (const it of sel) { const i = oldArr.indexOf(it); if (i >= 0) oldArr.splice(i, 1) }
            newArr.splice(insertIdx == null ? newArr.length : insertIdx, 0, ...sel)
            for (const it of sel) {
                this.store.set_value(it, binding, parentValue ?? '')
                this.setModified(it)
            }
            const renum = (arr) => arr.forEach((row, i) => { if (row && row.order !== i + 1) { row.order = i + 1; this.setModified(row) } })
            renum(oldArr)
            renum(newArr)
            this.refresh(sel)
            this.attr_set()
            this.run_attr_action_afterChange()
        },
        treeMove_inParent(dataItem, currentPosition, count, dir) {
            // IE 2026 08 20 / ODOO-5512 (Игорь: «down_Click — вижу одинаковое
            // название»): в CHIP-Tree дереве (childItemsPath '_childs', дерево
            // собирает ФРОНТ) cut_selectedRanges резал строку и из плоского
            // data000, и из _childs родителя — собирал её ДВАЖДЫ и splice
            // вставлял две копии. Для таких деревьев двигаем ВНУТРИ массива
            // родителя и перенумеровываем order сиблингов — его сохранит
            // дискетка (update_data пишет order), select пересортирует
            const parentItems = this.treeParentItems_of(currentPosition)
            const sel = this.treeSiblings_selected(parentItems)
            if (!sel.length) return true // не сиблинги — движение не определено
            const idx = parentItems.indexOf(sel[0])
            if (dir > 0 ? idx + sel.length >= parentItems.length : idx <= 0) return true
            parentItems.splice(idx, sel.length)
            parentItems.splice(dir > 0 ? idx + 1 : idx - 1, 0, ...sel)
            parentItems.forEach((row, i) => {
                if (row && row.order !== i + 1) {
                    row.order = i + 1
                    this.setModified(row)
                }
            })
            this.refresh(sel)
            this.attr_set()
            this.run_attr_action_afterChange()
            return true
        },
        up_Click(e) {
            let currentPosition = this.flex.selectedRanges[0].topRow,
            count = this.flex.selectedRanges[0].bottomRow - this.flex.selectedRanges[0].topRow + 1,
            dataItem = this.flex.rows[currentPosition]?.dataItem

            if (dataItem && this.attr.childItemsPath === '_childs') {
                return this.treeMove_inParent(dataItem, currentPosition, count, -1)
            }
            if (dataItem) {
                let parentItems = this.get_parentItems(currentPosition),
                irowItem = parentItems.indexOf(dataItem)

                if (irowItem - 1 >= 0) {
                    const fromPositions = this.hist_snapshotSelection()
                    let movedItems = this.cut_selectedRanges()
                    parentItems.splice(irowItem - 1, 0, ...movedItems)

                    this.hist_push({
                        method: 'rows', kind: 'move',
                        from: fromPositions, to: this.hist_positionsOf(movedItems),
                        label: t('Move {what} up', { what: movedItems.length > 1 ? tn(movedItems.length, '{n} row', '{n} rows') : t('row') }),   // IE 2026 09 23 / ODOO-341407: i18n
                    })

                    this.refresh(movedItems)
                    this.attr_set()
                    if (this.WIDGET.widget === 'widget-selectors') {
                        this.store.sync_WORKSPACE(this.WIDGET, '>>WORKSPACE')
                    }
                    this.run_attr_action_afterChange()
                }
            }
        },
        down_Click(e) {
            let currentPosition = this.flex.selectedRanges[0].topRow,
            count = this.flex.selectedRanges[0].bottomRow - this.flex.selectedRanges[0].topRow + 1,
            dataItem = this.flex.rows[currentPosition]?.dataItem

            if (dataItem && this.attr.childItemsPath === '_childs') {
                return this.treeMove_inParent(dataItem, currentPosition, count, 1)
            }
            if (dataItem) {
                let parentItems = this.get_parentItems(currentPosition),
                irowItem = parentItems.indexOf(dataItem)

                if (irowItem + count < parentItems.length) {
                    const fromPositions = this.hist_snapshotSelection()
                    let movedItems = this.cut_selectedRanges()
                    parentItems.splice(irowItem + 1, 0, ...movedItems)

                    this.hist_push({
                        method: 'rows', kind: 'move',
                        from: fromPositions, to: this.hist_positionsOf(movedItems),
                        label: t('Move {what} down', { what: movedItems.length > 1 ? tn(movedItems.length, '{n} row', '{n} rows') : t('row') }),   // IE 2026 09 23 / ODOO-341407: i18n
                    })

                    this.refresh(movedItems)
                    this.attr_set()
                    if (this.WIDGET.widget === 'widget-selectors') {
                        this.store.sync_WORKSPACE(this.WIDGET, '>>WORKSPACE')
                    }
                    this.run_attr_action_afterChange()
                }
            }
        },
        selected_items(items) {
            if (items.length) {
                let selectedRanges = [],
                min_irow = null,
                max_irow = null
                for (let item of items) {
                    let irow = this.rows_indexOf(item)
                    if (min_irow === null || min_irow > irow) {
                        min_irow = irow
                    }
                    if (max_irow === null || max_irow < irow) {
                        max_irow = irow
                    }
                }
                if (min_irow >= 0 && max_irow >= 0) {
                    selectedRanges.push(new wjGrid.CellRange(min_irow,0,max_irow,this.column_left))
                    this.flex.selectedRanges = selectedRanges
                }
            }
        },
        delete_Click(action) {
            let currentPosition = this.flex.selectedRanges[0].topRow,
            fromPositions = this.hist_snapshotSelection(), // позиции ДО изъятия — для Undo
            deletedItems = this.cut_selectedRanges()

            for (let record of deletedItems) {
                if (record.id) {
                    if (action.archived) {
                        record.meta = record.meta || {}
                        record.meta.archived = !record.meta.archived // !this.WIDGET.record.doc.params?.showArchived
                    } else {
                        record._meta = record._meta || {}
                        record._meta.delete = true
                    }
                }
            }

            this.deletedItems = [...this.deletedItems, ...deletedItems]

            if (fromPositions.length) {
                this.hist_push({
                    method: 'rows', kind: action.archived ? 'archive' : 'delete',
                    from: fromPositions, to: null, archived: !!action.archived,
                    label: action.archived ? tn(fromPositions.length, 'Archive/Restore {n} row', 'Archive/Restore {n} rows') : tn(fromPositions.length, 'Delete {n} row', 'Delete {n} rows'),   // IE 2026 09 23 / ODOO-341407: i18n
                })
            }
            this.initialized_stackСhanges()
            this.refresh()
            this.attr_set()
            this.set_AttrTabPanel_countItems()
            if (this.WIDGET.widget === 'widget-selectors') {
                this.store.sync_WORKSPACE(this.WIDGET, '>>WORKSPACE')
            }
            this.run_attr_action_afterChange()
            this.gridSave_schedule()   // IE 2026 10 13 / ODOO-5800: удалённые строки — в счёт полосы Save ленивого грида

            // selected_items
            window.$cg.setTimeout(this, "AttrGrid.delete_Click", () => {
                const newPosition = currentPosition < this.flex.rows.length-1 ? currentPosition : this.flex.rows.length - 2
                if (newPosition >= 0) {
                    this.selected_items([ this.flex.rows[newPosition].dataItem ])
                }
            }, 10)
        },
        copy_selectedItems() {
            const seenRows = new Set()
            let copyItems = [], level = null
            const ranges = [...this.flex.selectedRanges].sort((a, b) => Math.min(a.row, a.row2) - Math.min(b.row, b.row2))
            for (const range of ranges) {
                const r1 = Math.min(range.row, range.row2), r2 = Math.max(range.row, range.row2)
                for (let irow = r1; 0 <= irow && irow <= r2; irow++) {
                    if (seenRows.has(irow)) continue
                    seenRows.add(irow)
                    const row = this.flex.rows[irow]
                    if (row.dataItem !== null && (level === null || level === row.level)) {
                        copyItems.push(row.dataItem)
                        level = row.level
                    }
                }
            }
            return copyItems
        },
        cut_selectedRanges() {
            this.del_cutMarker()
            for (let irow = this.flex.selectedRanges[0].topRow; 0 <= irow && irow <= this.flex.selectedRanges[0].bottomRow; irow++) {
                const row = this.flex.rows[irow]
                if (row.dataItem !== null) {
                    // диапазон выделения — АБСОЛЮТНЫЕ индексы: между видимыми строками
                    // могут сидеть скрытые фильтром (hide empty / отбор) — их не двигаем,
                    // иначе Move left/right утаскивал невидимые строки и перемешивал
                    // дерево (реальный кейс: layout-редактор, «use не в тех строчках»)
                    if (row.visible === false || row.dataItem?._fe?.visible === false) continue
                    row.dataItem['$cutMarker'] = 1
                }
            }

            return this.cut_byMarker()
        },
        del_cutMarker() {
            for (let row of this.flex.rows) {
                if (row.dataItem?.['$cutMarker']) {
                    delete row.dataItem['$cutMarker']
                }
            }
        },
        // IE 2026 09 16: снять устаревшие маркеры вырезания со строк данных (в глубину по childItemsPath); возвращает число снятых
        cutMarker_stripStale(rows, depth = 0) {
            if (!Array.isArray(rows) || depth > 64) return 0
            const kidsPath = this.attr?.childItemsPath || 'attrs'
            let n = 0
            for (const row of rows) {
                if (!row || typeof row !== 'object') continue
                if ('$cutMarker' in row) { delete row['$cutMarker']; n++ }
                const kids = row[kidsPath]
                if (Array.isArray(kids) && kids.length) n += this.cutMarker_stripStale(kids, depth + 1)
            }
            return n
        },
        cut_byMarker(items=null, cutItems=null) {
            if (items === null) items = this.data000 // this.flex.collectionView.items
            if (cutItems === null) cutItems = []

            for (let irow = 0; irow < items.length; irow++) {
                if (items[irow]['$cutMarker']) {
                    cutItems.push(...items.splice(irow, 1))
                    irow--
                } else if (this.attr.childItemsPath && items[irow][this.attr.childItemsPath]?.length) {
                    this.cut_byMarker(items[irow][this.attr.childItemsPath], cutItems)
                }
            }
            return cutItems
        },
        iroot(item) {
            return this.store.iroot(item, this.data000, this.attr.childItemsPath)
        },
        get_viewParam(param, defaultValue) {
            if (!this.WIDGET?.record) return defaultValue
            if (param === 'isReadOnly' && this.gridEditMode_applies) {   // IE 2026 10 14 / ODOO-5800 (Igor: динамические списки — как виджет списка): read-only по умолчанию; явное viewParams.isReadOnly — как есть (attr.isReadOnly бэка не в счёт)
                return gridEditMode_readOnly(this.store.get_value(this.WIDGET.record, `doc.viewParams.${this.attr.name}.isReadOnly`, undefined), true, defaultValue)   // IE 2026 10 14 / ODOO-5800
            }
            if (param === 'allowResizing') {
                const headersVisibility = this.get_viewParam('headersVisibility','All')
                if (!['All', 'Columns'].includes(headersVisibility)) {
                    return 'ColumnsAllCells'
                } else {
                    return 'Both'
                }
            }

            return this.store.get_viewParam(this.WIDGET, this.attr.name, param, defaultValue, this.attr)
        },
        // IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение) (слово Igor #104835): штатный headersVisibility; грид шахматки (attr.headersNumbersOnly) — подписи колонок всегда, параметр управляет только нумерацией (utils/crossGridLook.cgHeadersWijmo)
        headersVisibility_eff() {
            const v = this.get_viewParam('headersVisibility', 'All')
            return this.attr && this.attr.headersNumbersOnly ? cgHeadersWijmo(v) : v
        },
        set_viewParam(param, value, justSet=false, set_modified=null) {
            const flex = this.flex
            const refreshParams = [
                'use_delivery', 'use_customCellFactory', 'allow_formatItem',
                'show_performance',
                'tree_lines', 'tree_lines_dotted', // IE 2026 08 27 / ODOO-5800: линии дерева — перерисовка
                
                'allowDragging', 'showEmpty', 'hideEmptyRows',
                'showFilter', 'rowsHeight', 'autoRowHeights', 'allowAddNew',
                'nonEmpty_ignore_use', // IE 2026 09 18 / ODOO-5800 (Igor): «Keep rows without Use» — строки без Use не прячутся фильтром «непустые»
            ];

            if (param === 'attrs') {
                this.attr.attrs = value

                if (this.attr.attr_type === 'AttrTabGrid') {
                    this.content_Changed_main()
                }
                this.content_Changed_afterTimeout()
                return
            }

            if (param === 'isReadOnly' && this.gridEditMode_applies) {   // IE 2026 10 14 / ODOO-5800: сравнение с СЫРЫМ viewParams — attr.isReadOnly=false бэка маскировал запись false (store.set_viewParam сверяется с ним); режим — не данные записи (modified не ставится)
                const _rawRO = this.store.get_value(this.WIDGET.record, `doc.viewParams.${this.attr.name}.isReadOnly`, undefined)   // IE 2026 10 14 / ODOO-5800
                if (_rawRO !== value) this.store.set_value(this.WIDGET.record, `doc.viewParams.${this.attr.name}.isReadOnly`, value, null, null, null, false)   // IE 2026 10 14 / ODOO-5800
            }
            this.store.set_viewParam(this.WIDGET, this.attr.name, param, value, this.attr, set_modified)
            if (justSet) return;

            if (param === 'use_customCellFactory') {
                if (this.attr.use_customCellFactory) {
                    flex.cellFactory = new CustomCellFactory(flex, this);
                } else {
                    flex.cellFactory = this.default_cellFactory // new wjcCore.ControlFactory(flex);
                }
            }
            if (param === 'virtualizationThreshold_rows' || param === 'virtualizationThreshold_cols') {
                flex.virtualizationThreshold = [
                    this.attr.virtualizationThreshold_rows || 0,
                    this.attr.virtualizationThreshold_cols || 0,
                ]
            }
            if (param === 'show_performance') {
                this.use_performance = value
                if (!this.attr.show_performance) {
                    let count = 0, time = 0
                    for (let p in this.performance_data) {
                        count += this.performance_data[p].count || 0
                        time += this.performance_data[p].time || 0
                    }
                    console.log(`Performance-cells: ${time.toFixed(0)} / ${count} = ${(time/count).toFixed(3)} ms average, max ${this.performance_maxTime.toFixed(0)} ms`)
                    console.log(`Performance-view: (${(this.performanceView.time - time).toFixed(0)} + ${time.toFixed(0)}) / ${this.performanceView.count} = ${(this.performanceView.time/(this.performanceView.count||1)).toFixed(3)} ms average, max ${this.performanceView.maxTime.toFixed(0)} ms`)

                    this.performance_data = {}
                    this.performance_maxTime = 2

                    this.performanceView = {
                        t0: null,
                        count: 0,
                        time: 0,
                        maxTime: 0,
                        cells_count: 0,
                        cells_time: 0,
                    }
                }
            }
            
            if (param === 'showCommandPanel') { // TODO hideCommandPanel
                this.set_commandPanel()
            }
            if (param === 'aggregateFooters') {
                this.attr.aggregateFooters = value
                this.aggregateFooters()
            }
            if (param === 'headersVisibility') {
                this.visibility = false
                nextTick(() => {
                    this.visibility = true
                })
            }
            if (param === 'rowsHeight') {
                this.autoSizeRows()
            }
            if (param === 'tree_lines' || param === 'tree_lines_dotted') { // IE 2026 08 27 / ODOO-5800
                // IE 2026 08 27 / ODOO-5800: смена режима линий — пересчёт высот (зазоры секций)
                this._treeLinesMode = null; this._treeLinesNoGaps = null
                this._frameGlyph = null
                this.autoSizeRows()
            }
            if (param === 'autoRowHeights') {
                this.autoSizeRows()
            }
            if (param === 'readOnlyRows') {
                this.set_commandPanel()
            }
            if (param === 'nonEmpty_ignore_use') { // IE 2026 09 18 / ODOO-5800: кэш «строка выключена по use» и фильтр «непустые» — заново
                this._unusedByUse = null
                this._use_off_cache = null
                this.apply_CHIPS()
            }
            if (param === 'frozenColumns') {
                this.set_frozenColumns()
            }
            if (param === 'lightView') {
                // мгновенно, без перезапроса данных: только видимость
                // колонок, стили и иконка кнопки-тумблера
                this.lightView_apply()
                this.set_commandPanel()
            }
            if (param === 'isReadOnly' && flex?.hostElement?.isConnected) {
                // IE 2026 08 20 / ODOO-336291 (mobile UX): мобильный профиль держит грид read-only
                // и здесь — этот вотчер прогоняется при применении viewParams и сбрасывал гейт
                flex.isReadOnly = !!(this.store.mobileUi?.on && this.store.mobileUi.readOnlyGrids && !this.mobileEditableGrid()) // IE 2026 09 04 / ODOO-336291 (mobile UX): B-24
                    || (false && value)
                    || this.store.readonly_on()   // IE 2026 09 29 / ODOO-342781: роль «только чтение» — гейт не снимается и через viewParams

                if (!value) {
                    flex.selectionMode = this.attr.selectionMode || this.store.setting('fe.grid.selectionMode', 'MultiRange')

                    // // show Id, type
                    // for (let col of this.flex.columns) {
                    //     let attr_col = this.attr_by_binding[col.binding]
                    //     if (attr_col.binding === 'id' || attr_col.binding === 'segment' || attr_col.binding === 'company') {
                    //         col.visible = true
                    //         attr_col.visible = true
                    //     }
                    // }

                    this.flex_check_isReadOnly()
                }
                this.set_commandPanel()
            }

            if (refreshParams.includes(param)) {
               this.flexRefresh();
            }

            this.set_commandsActive()
        },

        flex_check_isReadOnly() { 
            // need if set childItemsPath
            if (this.attr.childItemsPath) {
                let isChanged = false
                this.flex.rows.forEach(row => {
                    if (row.isReadOnly !== false) {
                        row.isReadOnly = false
                        isChanged = true
                    }
                })
                if (isChanged) {
                    // console.log(`flex_check_isReadOnly: refresh ${this.attr.binding}`)
                }
            }
        },

        // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T1)
        // Вид ячеек отчёта (кнопки опций вида, mainStore.cellView_toggle): активный вид — WIDGET._cellView (строка; прежний WIDGET._cellViews — запасной путь,
        // алиас status_pie → status_zones). В ячейке-дате — круг слева (слои режима из src/utils/cellViews/*, рендер src/utils/cellRing.js: площадь ∝ доле от
        // max группы шкалы, кольцо сигналов по классам _DLRow), число справа; узкая колонка (< 2 × макс. диаметра) — только круг, число — в Alt-подсказке.
        // Кеш слоёв — WeakMap по объекту ячейки + ключ «вид | мера | версия ответа»; шкала (max групп) — один раз на ответ. Флаги fe.ux.cellViews,
        // fe.ux.cellView.<режим>, fe.ux.cellViewRing (ВЫКЛ — прежний пирог 13 px без кольца); у status_zones — и прежний fe.ux.cellStatusPie
        cellView_active() {
            const k = cellView_activeOf(this.WIDGET)
            if (!k) return ''
            const rd = (key, d) => this.fmtSetting(key, d)
            if (!cellView_flagOn(rd, k)) return ''
            if (k === STATUS_ZONES_VIEW && this.fmtSetting(CELL_PIE_FLAG, true) === false) return ''
            return k
        },
        cellView_on() {
            return !!this.cellView_active()
        },
        cellView_refresh(dataChanged = false) {   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T2): dataChanged — в ячейки слиты отложенные спутники вида (mainStore.cellView_takeAnswer): кеш слоёв и шкалы устарел
            if (dataChanged) { this._cellViewVer = (this._cellViewVer || 0) + 1; this._cellRingScale = null }
            this._cellShapeOpt = null; this._cellAreaCols = null; this._cellAreaRow = null   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: форма Стовпчики та Запас площею — T15): форма кнопки, даты и строки площади — заново
            try { this.gridRows_sync(); this.gridRows_apply(this.flex) } catch (e) { /* грид пересоздаётся */ }   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p183: перемикач «Рядки: Компактні / Високі» у таблиці REPORT2, як у Heatmap (grid)): смена вида ячеек — «Високі» один раз
            try { this.flex?.invalidate() } catch (e) { /* грид пересоздаётся */ }
            this.sigPie_schedule()   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: агрегат сигналов кругом в кнопке; проблемы подсказки в одну строку, клик — форма ячейки)
            try { this.sigPrefetch_cancel() } catch (e) { /* очереди нет */ }   // IE 2026 11 03 / ODOO-350449 (Игорь: предзагрузка цепочек сигналов; BE ie-dm7 #1009): смена вида / данных видов — очередь заново (updatedView после invalidate)
        },
        // группа шкалы ячейки: _DLRow.scale_group строки, иначе вид по формату (строка / ячейка _DLRow сильнее колонки) — { group, kind, unit }
        cellView_scaleInfo(dataItem, binding) {
            const fmt = this.cf_rowFormat(dataItem, binding) || this.attr_by_binding?.[binding]?.format || ''
            return cellRing_scaleGroup(dataItem?._DLRow?.scale_group, fmt, dataItem?.measure_type)
        },
        // max групп шкалы по строкам ответа (все строки грида, и свёрнутые — круги не прыгают при раскрытии); пересчёт — новый ответ / число строк / колонок
        cellView_scaleMap() {
            const flex = this.flex
            if (!flex) return {}
            const ver = this._cellViewVer || 0, nr = flex.rows.length, nc = flex.columns.length
            const c = this._cellRingScale
            if (c && c.ver === ver && c.nr === nr && c.nc === nc) return c.map
            const cols = []
            const fillOn = cellChart_fillOn((key, d) => this.fmtSetting(key, d))   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p190 діаграми в клітинках — на всю висоту рядка, компактні й високі)
            for (const col of flex.columns) {
                if (fillOn && col.isVisible === false) continue   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p190 діаграми в клітинках — на всю висоту рядка, компактні й високі): скрытые колонки-даты (isVisible: visible = true, но скрыты группой колонок, renderWidth 0) (служебные меры, напр. offset — лаг в мс, max 2 589 408 000) в шкалу не входят — иначе max группы qty гигантский и любой круг — минимум 6 px
                const b = cellPie_bindingOf(col.binding); if (b) cols.push({ binding: col.binding, date: b.date, measure: b.measure })
            }
            const items = []
            for (const r of flex.rows) if (r?.dataItem && typeof r.dataItem === 'object') items.push(r.dataItem)
            const map = cellRing_scale(items, (di) => {
                const out = []
                for (const cc of cols) {
                    const cell = di[cc.date]
                    if (!cell || typeof cell !== 'object') continue
                    const v = Number(cell[cc.measure])
                    if (!Number.isFinite(v) || !v) continue
                    const info = this.cellView_scaleInfo(di, cc.binding)
                    info.value = v
                    out.push(info)
                }
                return out
            })
            this._cellRingScale = { ver, nr, nc, map, stamp: (c?.stamp || 0) + 1 }
            window.__cellView = window.__cellView || { calc: 0, scale: 0 }
            window.__cellView.scale++
            return map
        },
        // слои активного вида для ячейки (кеш WeakMap по объекту ячейки-даты) + сигналы колец по классам _DLRow → { layers, value, signals, view } | null
        cellView_of(dataItem, binding, row) {
            const view = this.cellView_active()
            if (!view) return null
            const b = cellPie_bindingOf(binding)
            if (!b || !dataItem || typeof dataItem !== 'object') return null
            const cell = dataItem[b.date]
            const isCell = !!cell && typeof cell === 'object'
            const cp = this.attr?.childItemsPath
            const ctx = { t, row, childrenOf: (di) => (cp && Array.isArray(di?.[cp]) ? di[cp] : []), classColor: (cls) => this.alert_classColor(cls) }   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T3 Склад): цвет ребёнка по фону cell-background-*
            ctx.stats = cellView_statsOf(toRaw(this.WIDGET?.record?._doc))   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T9b): статистика видов (delta_30d: no snapshot) — и в ключ кеша через cacheKey
            ctx.palette = cellView_paletteOf(toRaw(this.WIDGET?.record?._doc))   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: p149 fix2-fe): цвета статусов из stats.palette бэка
            if (view === SIGNALS_VIEW) ctx.cellClasses = this.cellView_cellClasses(dataItem, binding)   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p198 вид «Сигнали» — проблемні сигнали шарами кола, фон лише від lead time / циклу поповнення / зон запасу)
            if (view === SIGNALS_VIEW) ctx.emptyDot = this.fmtSetting(SIGNALS_EMPTY_FLAG, true) !== false   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p212 сигнал проблеми видно і в дочірніх рядках (порожня комірка), прив'язка дефіциту/попиту до міри руху): ячейка без значения — точка постоянного диаметра
            if (view === 'composition') Object.assign(ctx, this.cellView_childCtx(view))   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by): фиксированные колонки, текст ячейки, split_by
            const entry = cellView_get(view)
            let extra = ''
            if (typeof entry?.cacheKey === 'function') {
                try { extra = String(entry.cacheKey(dataItem, { ...ctx, binding, date: b.date, measure: b.measure, cell: isCell ? cell : null }) ?? '') } catch (e) { extra = '' }
            }
            const key = `${view}|${b.measure}|${this._cellViewVer || 0}|${extra}`
            const v = isCell ? cell[b.measure] : undefined
            let m = null
            if (isCell) {
                const wm = this._cellViewCache || (this._cellViewCache = new WeakMap())
                m = wm.get(cell)
                if (!m) { m = new Map(); wm.set(cell, m) }
                const hit = m.get(key)
                if (hit && hit.v === v) return hit.res
            }
            const res = cellView_layersOf(view, dataItem, binding, ctx)
            if (res) {
                const dlr = dataItem._DLRow
                res.signals = res.signals.concat(cellRing_signalsOf(dlr?.cells?.[binding]?.cssClasses, dlr?.cssClasses))
            }
            if (m) m.set(key, { v, res })
            window.__cellView = window.__cellView || { calc: 0, scale: 0 }
            window.__cellView.calc++
            return res
        },
        // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by)
        // ctx режима «By child rows» (composition): heads — колонки слева от первой периодной (видимые, с binding, без служебных: `_*` / `#*`, флажки),
        // textOf — текст ячейки, как его показывает грид (`<binding>-title`, dataMap, справочник, формат числа), splitBy / splitTitle — колонка split_by
        // строки опции активной кнопки. Кеш — по числу колонок, версии ответа и варианту кнопки
        cellView_childCtx(view) {
            const flex = this.flex
            if (!flex) return {}
            const W = this.WIDGET, ver = this._cellViewVer || 0, nc = flex.columns.length, fz = flex.frozenColumns || 0, cv = W?._cellViewVar || ''
            const c = this._cellViewChild
            if (c && c.view === view && c.ver === ver && c.nc === nc && c.fz === fz && c.cv === cv) return c.ctx
            const heads = []
            let firstDate = flex.columns.findIndex(col => !!cellPie_bindingOf(col?.binding))
            if (firstDate < 0) firstDate = fz
            for (let i = 0; i < firstDate; i++) {
                const col = flex.columns[i], b = String(col?.binding || '')
                if (!col || !col.visible || !b || b.startsWith('_') || b.startsWith('#')) continue
                const ac = this.attr_by_binding?.[b]
                if (ac?.attr_type === 'AttrBool' || col.dataType === wjcCore.DataType.Boolean) continue
                heads.push({ binding: b, title: String(ac?.title || col.header || b) })
            }
            let splitBy = ''
            try {
                const btns = (this.store.optionGroup_panelButtons?.(W) || []).filter(x => cellViewBtn_is(x) && cellViewBtn_id(x) === view)
                const btn = btns.find(x => cv && cellViewBtn_variant(x) === cv) || btns.find(x => x.active) || btns[0]
                splitBy = composition_splitByOf(btn, W?.record?.doc?.params?.option_groups)
            } catch (e) { splitBy = '' }
            const sh = heads.find(h => h.binding === splitBy)
            const splitTitle = splitBy ? String(sh?.title || this.attr_by_binding?.[splitBy]?.title || flex.getColumn(splitBy)?.header || splitBy) : ''
            const ctx = { heads, textOf: (di, b) => this.cellView_cellText(di, b), splitBy, splitTitle }
            this._cellViewChild = { view, ver, nc, fz, cv, ctx }
            return ctx
        },
        // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by): текст ячейки строки по binding — как его показывает грид
        cellView_cellText(di, binding) {
            if (!di || typeof di !== 'object' || !binding) return ''
            if (this.shownTitle_on()) { const st = shownTitle_of(di, binding); if (st) return String(st) }
            const v = this.store.get_value(di, binding)
            if (v === null || v === undefined || v === '') return ''
            const col = this.flex?.getColumn(binding), ac = this.attr_by_binding?.[binding]
            if (col?.dataMap) { try { const d = col.dataMap.getDisplayValue(v); if (d !== null && d !== undefined && d !== '') return String(d) } catch (e) { /* карта не готова */ } }
            if (ac?.attr_type === 'AttrMulti') return String(v?.valueStr ?? v?.value ?? '')
            if (ac?.relation_segment) { const it = this.store.itemsSource?.[ac.relation_segment]?.ids?.[v]; if (it) return String(it.title || it.id || '') }
            if (typeof v === 'object') return String(v.title ?? v.valueStr ?? v.value ?? '')
            if (typeof v === 'number') { try { return wjcCore.Globalize.format(v, ac?.format || col?.format || 'n0') } catch (e) { return String(v) } }
            return String(v)
        },
        // слои → геометрия круга под размер ячейки (кеш на объекте результата: ширина колонки, высота строки, режим, отметка шкалы)
        cellView_build(res, dataItem, binding, col) {
            if (!res) return null
            const cellW = col?.renderWidth || col?.width || 0
            const cellH = this.flex?.rows?.defaultSize || 24
            const legacy = !cellRing_flagOn((key, d) => this.fmtSetting(key, d))
            const sc = legacy ? {} : this.cellView_scaleMap()
            const fill = !legacy && cellChart_fillOn((key, d) => this.fmtSetting(key, d))   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p190 діаграми в клітинках — на всю висоту рядка, компактні й високі)
            const k = `${cellW}|${cellH}|${legacy ? 1 : 0}|${legacy ? 0 : (this._cellRingScale?.stamp || 0)}|${fill ? 'f' : ''}`   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p190 діаграми в клітинках — на всю висоту рядка, компактні й високі)
            if (res.__ring && res.__ring.k === k) return res.__ring.out
            const info = this.cellView_scaleInfo(dataItem, binding)
            const scale = { max: sc[info.group]?.max || 0, kind: info.kind, unit: info.unit }
            const rowMax = fill ? this.cellView_rowMax(dataItem, info.group) : 0   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p190 — розмір кола від максимуму рядка, 60…100 %)
            const out = cellRing_build(res.layers, scale, res.signals, { cellW, cellH }, { value: res.value, sizeValue: res.sizeValue, legacy, fixedDiameter: res.fixedDiameter, fill, rowMax, concentric: !!res.concentric, gaps: pieGaps_on((key, d) => this.fmtSetting(key, d)) })   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p211 контрастні кольори категорій і білий роздільник між секторами кіл): белые разделители секторов (fe.ux.pieSliceGaps)   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T9b): размер по sizeValue (max(cur, prev) / max за 30 дней), over-100 — по value   // IE 2026 11 01 / ODOO-350449 (T12: крапка фіксованого діаметра)
            Object.defineProperty(res, '__ring', { value: { k, out }, writable: true, configurable: true, enumerable: false })
            return out
        },
        // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p190 — розмір кола від максимуму рядка, 60…100 %)
        // максимум строки для размера круга: max |значения| по видимым колонкам-датам строки (isVisible — скрытые группой колонок и служебные offset не входят)
        // в той же группе шкалы; кеш WeakMap по строке на версию ответа и число колонок
        cellView_rowMax(dataItem, group) {
            if (!dataItem || typeof dataItem !== 'object' || !this.flex) return 0
            const ver = this._cellViewVer || 0, nc = this.flex.columns.length
            const wm = this._cellRowMax || (this._cellRowMax = new WeakMap())
            let e = wm.get(dataItem)
            if (!e || e.ver !== ver || e.nc !== nc) { e = { ver, nc, m: new Map() }; wm.set(dataItem, e) }
            if (e.m.has(group)) return e.m.get(group)
            let mx = 0
            for (const col of this.flex.columns) {
                if (col.isVisible === false) continue
                const b = cellPie_bindingOf(col.binding)
                if (!b) continue
                const cell = dataItem[b.date]
                const v = (cell && typeof cell === 'object') ? Math.abs(Number(cell[b.measure])) : 0
                if (!(v > mx) || !Number.isFinite(v)) continue
                if (this.cellView_scaleInfo(dataItem, col.binding).group !== group) continue
                mx = v
            }
            e.m.set(group, mx)
            return mx
        },
        // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p198 вид «Сигнали» — проблемні сигнали шарами кола, фон лише від lead time / циклу поповнення / зон запасу)
        // классы оформления ячейки-даты для вида signals: каналы, которыми formatItem красит ячейку (мета _DLRow.cells[b], строка _DLRow: cssClass / cssClasses /
        // «Values only» cssClasses_vo, правила оформления фронта cf_compute — ячейка и строка, cssClass-<b>, классы плана planCell_classes) + классы, снятые с
        // элемента ячейки этим видом (cellView_signalsFill запоминает их до снятия: канал, которого здесь нет, не теряет сигнал на кеш-пути formatItem)
        cellView_cellClasses(dataItem, binding) {
            const out = []
            if (!dataItem || typeof dataItem !== 'object' || !binding) return out
            const add = (v) => { if (Array.isArray(v)) { for (const c of v) if (c) out.push(String(c)) } else if (v) out.push(...String(v).split(/\s+/).filter(Boolean)) }
            const dlr = dataItem._DLRow
            const pb = cellPie_bindingOf(binding), cv = pb ? dataItem[pb.date] : null
            const vo = !!pb && cv && typeof cv === 'object' && cv[pb.measure] != null && cv[pb.measure] !== ''   // «Values only» строки — только у непустой ячейки (как cf_valuesOnlyAllowed в formatItem)
            add(dlr?.cells?.[binding]?.cssClasses)
            add(dlr?.cssClass); add(dlr?.cssClasses); if (vo) add(dlr?.cssClasses_vo)
            add(dataItem[`cssClass-${binding}`])
            try {
                if (this.attr?.cf_rules || this.metricFill_state()) {
                    const cf = this.cf_compute(dataItem, binding, this.attr_by_binding?.[binding])
                    if (cf) add(cf.cssClasses)
                }
                if (this.attr?.cf_rules) {
                    const cr = this.cf_compute(dataItem, '', null)
                    if (cr) { add(cr.cssClasses); if (vo) add(cr.cssClassesVO) }
                }
            } catch (e) { /* правила ещё не готовы */ }
            try { if (this.planLevels_on()) add(planCell_classes(dataItem, binding)) } catch (e) { /* без плана */ }
            const rec = this._cellSigSeen?.get(dataItem)
            if (rec && rec.ver === (this._cellViewVer || 0) && rec.m.has(binding)) add(rec.m.get(binding))
            return out
        },
        // вид signals: заливка ячейки от проблемных сигналов не рисуется — снимаются классы signals_suppress (проблемные и их двойники cell-background-<тон>,
        // если тон не держит зона запаса); фон горизонтов (cell-lt / cell-rc) и зон запаса остаётся. Оба пути formatItem (кеш-путь переписал className
        // снимком). Выключатель fe.ux.cellViewSignals (ВЫКЛ — заливка прежняя, круги сигналов рисуются)
        cellView_signalsFill(e_cell, dataItem, col) {
            if (!e_cell || !dataItem || !cellPie_bindingOf(col?.binding)) return
            if (this.fmtSetting(SIGNALS_FLAG, true) === false) return
            const drop = signals_suppress(e_cell.classList)
            if (!drop.length) return
            const ver = this._cellViewVer || 0
            const wm = this._cellSigSeen || (this._cellSigSeen = new WeakMap())
            let rec = wm.get(dataItem)
            if (!rec || rec.ver !== ver) { rec = { ver, m: new Map() }; wm.set(dataItem, rec) }
            const prev = rec.m.get(col.binding)
            const all = prev ? Array.from(new Set([...prev, ...drop])) : drop
            if (!prev || all.length !== prev.length) rec.m.set(col.binding, all)   // слои ячейки — заново: запомненные классы входят в cacheKey вида
            for (const c of drop) e_cell.classList.remove(c)
            window.__cellView = window.__cellView || { calc: 0, scale: 0 }
            window.__cellView.sigFill = (window.__cellView.sigFill || 0) + 1
        },
        cellView_clear(e_cell) {
            if (!e_cell.__cellRing && !e_cell.classList.contains('has-cell-ring')) return
            e_cell.querySelector(':scope > .cell-ring')?.remove()
            e_cell.classList.remove('has-cell-ring', 'cell-ring-only')
            e_cell.style.removeProperty('--cell-ring-pad')
            e_cell.__cellRing = false
        },
        cellView_apply(e_cell, dataItem, col, isXlsxExport, row) {
            if (!e_cell) return
            e_cell.__cfrMark = null   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: ореол вокруг сигнальных меток в цветной ячейке): метка ячейки для ореола (ставят ветки круга / столбиков ниже)
            let out = null
            let shape = 'circle', area = null   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: форма Стовпчики та Запас площею — T15): форма ячейки (круг / столбики / площадь запаса)
            if (!isXlsxExport && this.cellView_active() === SIGNALS_VIEW) this.cellView_signalsFill(e_cell, dataItem, col)   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p198 вид «Сигнали» — проблемні сигнали шарами кола, фон лише від lead time / циклу поповнення / зон запасу)
            if (!isXlsxExport && this.cellView_on() && !this.parentHide_ringOff(row)) {   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p201 баланс — «Сигнали» типово, розкритий батьківський рядок без підсумків і сигналів (hover показує), підсумок рядка без сигналів — опція): раскрытая строка-группа — без кругов до наведения
                const b = cellPie_bindingOf(col?.binding)   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: форма Стовпчики та Запас площею — T15)
                shape = b ? this.cellShape_of(dataItem, b) : 'circle'   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: форма Стовпчики та Запас площею — T15)
                if (shape === 'area') area = this.cellArea_of(dataItem, col, b)   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: форма Стовпчики та Запас площею — T15)
                else {
                    const res = this.cellView_of(dataItem, col?.binding, row)
                    out = res ? (shape === 'bars' ? this.cellView_buildBars(res, dataItem, col?.binding, col) : this.cellView_build(res, dataItem, col?.binding, col)) : null   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: форма Стовпчики та Запас площею — T15)
                }
            }
            if (!area) this.cellArea_clear(e_cell)   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: форма Стовпчики та Запас площею — T15)
            if (shape !== 'bars' || !out) this.cellBars_clear(e_cell)   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: форма Стовпчики та Запас площею — T15)
            if (shape !== 'circle') this.cellView_clear(e_cell)   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: форма Стовпчики та Запас площею — T15)
            if (area) { if (!e_cell.querySelector('input')) this.cellArea_put(e_cell, area); return }   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: форма Стовпчики та Запас площею — T15)
            if (!out) { this.cellView_clear(e_cell); return }
            if (shape === 'bars') { if (!e_cell.querySelector('input')) this.cellBars_put(e_cell, out); return }   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: форма Стовпчики та Запас площею — T15)
            if (e_cell.querySelector('input')) return   // идёт редактирование
            let span = e_cell.querySelector(':scope > .cell-ring')
            if (!span) { span = document.createElement('span'); span.className = 'cell-ring'; e_cell.insertBefore(span, e_cell.firstChild) }
            if (span.__bg !== out.bg) { span.style.background = out.bg; span.__bg = out.bg }
            const geo = `${out.diameter}|${out.dMax}`
            if (span.__geo !== geo) {
                span.style.width = span.style.height = out.diameter + 'px'
                span.style.left = (4 + out.dMax / 2) + 'px'   // центр слота макс. диаметра; узкая колонка — по центру ячейки (CSS)
                span.__geo = geo
            }
            const ring = out.ring ? `${out.ring.inset ? 'inset ' : ''}0 0 0 ${out.ring.width}px ${out.ring.color}` : ''   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p190 діаграми в клітинках — на всю висоту рядка, компактні й високі): p190 — кольцо внутрь круга (круг на всю высоту строки)
            if (span.__ring !== ring) { span.style.boxShadow = ring; span.__ring = ring }
            const pad = (out.dMax + 8) + 'px'
            if (e_cell.style.getPropertyValue('--cell-ring-pad') !== pad) e_cell.style.setProperty('--cell-ring-pad', pad)
            if (out.only !== e_cell.classList.contains('cell-ring-only')) e_cell.classList.toggle('cell-ring-only', out.only)
            if (!e_cell.classList.contains('has-cell-ring')) e_cell.classList.add('has-cell-ring')
            e_cell.__cellRing = true
            e_cell.__cfrMark = { kind: 'c', d: out.diameter, dMax: out.dMax, only: !!out.only }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: ореол вокруг сигнальных меток в цветной ячейке): геометрия span.cell-ring (left 4 + dMax/2, top 50 %)
        },
        // IE 2026 11 01 / ODOO-350449 (заказ Игоря: форма Стовпчики та Запас площею — T15)
        // Форма вида ячеек (src/utils/cellShape.js): переключатель панели (WIDGET._cellShape) → _DLRow.shape → shape кнопки активного вида → circle;
        // area — только строке запаса (cellArea_isStockRow). Флаги fe.ux.cellViewBars / fe.ux.cellViewArea (дефолт ВКЛ). Кеши — по версии ответа _cellViewVer
        cellShape_optionList(view) {
            try {
                const btn = (this.store.optionGroup_panelButtons?.(this.WIDGET) || []).find(x => cellViewBtn_is(x) && cellViewBtn_id(x) === view)
                return cellShape_parse(btn?.shape)
            } catch (e) { return [] }
        },
        cellShape_opt() {
            const view = this.cellView_active(), ver = this._cellViewVer || 0
            const c = this._cellShapeOpt
            if (c && c.view === view && c.ver === ver) return c
            this._cellShapeOpt = { view, ver, list: this.cellShape_optionList(view), flags: cellShape_flags((k, d) => this.fmtSetting(k, d)) }
            return this._cellShapeOpt
        },
        cellShape_of(dataItem, b) {
            const o = this.cellShape_opt()
            const override = this.WIDGET?._cellShape
            const rowShape = dataItem?._DLRow?.shape
            if (!override && !rowShape && !o.list.length) return 'circle'
            return cellShape_resolve({ override, row: rowShape, option: o.list, flags: o.flags, isStock: () => this.cellArea_rowInfo(dataItem, b.measure).stock })
        },
        // клик по форме в переключателе: выбор формы для всех строк; повторный клик по выбранной — снова по опции / строке
        cellShape_click(shape) {
            const W = this.WIDGET
            if (!W) return
            W._cellShape = cellShape_next(W._cellShape, shape)
            this.cellView_refresh()
        },
        // слои → геометрия столбиков (кеш на объекте результата, как __ring у круга)
        cellView_buildBars(res, dataItem, binding, col) {
            if (!res) return null
            const cellW = col?.renderWidth || col?.width || 0
            const cellH = this.flex?.rows?.defaultSize || 24
            const sc = this.cellView_scaleMap()
            const fill = cellChart_fillOn((key, d) => this.fmtSetting(key, d))   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p190 діаграми в клітинках — на всю висоту рядка, компактні й високі)
            const k = `${cellW}|${cellH}|${this._cellRingScale?.stamp || 0}|${fill ? 'f' : ''}`   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p190 діаграми в клітинках — на всю висоту рядка, компактні й високі)
            if (res.__bars && res.__bars.k === k) return res.__bars.out
            const info = this.cellView_scaleInfo(dataItem, binding)
            const scale = { max: sc[info.group]?.max || 0, kind: info.kind, unit: info.unit }
            const out = cellBars_build(res.layers, scale, res.signals, { cellW, cellH }, { value: res.value, fixedDiameter: res.fixedDiameter, fill })   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p190 діаграми в клітинках — на всю висоту рядка, компактні й високі)
            Object.defineProperty(res, '__bars', { value: { k, out }, writable: true, configurable: true, enumerable: false })
            return out
        },
        cellBars_put(e_cell, out) {
            let span = e_cell.querySelector(':scope > .cell-bars')
            if (!span) { span = document.createElement('span'); span.className = 'cell-bars'; e_cell.insertBefore(span, e_cell.firstChild) }
            const sig = cellBars_sig(out)
            if (span.__sig !== sig) {
                span.innerHTML = cellBars_html(out)
                span.style.width = out.slot + 'px'
                span.style.height = (out.hMax + 3) + 'px'
                span.__sig = sig
            }
            const pad = (out.slot + 8) + 'px'
            if (e_cell.style.getPropertyValue('--cell-bars-pad') !== pad) e_cell.style.setProperty('--cell-bars-pad', pad)
            if (out.only !== e_cell.classList.contains('cell-bars-only')) e_cell.classList.toggle('cell-bars-only', out.only)
            if (!e_cell.classList.contains('has-cell-bars')) e_cell.classList.add('has-cell-bars')
            e_cell.__cellBars = true
            e_cell.__cfrMark = { kind: 'b', slot: out.slot, h: out.hMax + 3, only: !!out.only }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: ореол вокруг сигнальных меток в цветной ячейке): геометрия span.cell-bars (left 4, высота hMax + 3, по центру)
        },
        cellBars_clear(e_cell) {
            if (!e_cell.__cellBars && !e_cell.classList.contains('has-cell-bars')) return
            e_cell.querySelector(':scope > .cell-bars')?.remove()
            e_cell.classList.remove('has-cell-bars', 'cell-bars-only')
            e_cell.style.removeProperty('--cell-bars-pad')
            e_cell.__cellBars = false
        },
        // даты колонок меры по порядку (видимые колонки грида; кеш — версия ответа и число колонок)
        cellArea_dates(measure) {
            const flex = this.flex
            if (!flex) return []
            const ver = this._cellViewVer || 0, nc = flex.columns.length
            let c = this._cellAreaCols
            if (!c || c.ver !== ver || c.nc !== nc) {
                const by = {}
                for (const col of flex.columns) {
                    if (col.visible === false) continue
                    const b = cellPie_bindingOf(col.binding)
                    if (!b) continue
                    const arr = by[b.measure] || (by[b.measure] = [])
                    if (!arr.includes(b.date)) arr.push(b.date)
                }
                for (const m of Object.keys(by)) by[m].sort()
                c = this._cellAreaCols = { ver, nc, by }
            }
            return c.by[measure] || []
        },
        // строка запаса и шкала строки (max остатка по датам меры) — кеш WeakMap по объекту строки
        cellArea_rowInfo(dataItem, measure) {
            if (!dataItem || typeof dataItem !== 'object') return { stock: false, max: 0 }
            const ver = this._cellViewVer || 0, nc = this.flex?.columns?.length || 0
            const wm = this._cellAreaRow || (this._cellAreaRow = new WeakMap())
            let e = wm.get(dataItem)
            if (!e || e.ver !== ver || e.nc !== nc) { e = { ver, nc, m: new Map() }; wm.set(dataItem, e) }
            let r = e.m.get(measure)
            if (!r) {
                const dates = this.cellArea_dates(measure)
                let dlScale   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: форма Стовпчики та Запас площею — T15b): правило свёртки строки DL (наследуется от родителя) — запасное распознавание строки запаса без спутников
                try { dlScale = this.foldAgg_dlScale(dataItem._DLRow?.row_id) } catch (err) { dlScale = undefined }
                r = { stock: cellArea_isStockRow(dataItem, measure, dates, { dlScale }), max: cellArea_rowMax(cellArea_values(dataItem, measure, dates)) }   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: форма Стовпчики та Запас площею — T15b)
                e.m.set(measure, r)
            }
            return r
        },
        // кусок площади ячейки-даты строки запаса: середина с прошлым периодом → значение → середина со следующим; заливка — зона месяца
        cellArea_of(dataItem, col, b) {
            if (!b || !dataItem || typeof dataItem !== 'object') return null
            const info = this.cellArea_rowInfo(dataItem, b.measure)
            if (!info.stock) return null
            const nb = cellArea_neighbors(this.cellArea_dates(b.measure), b.date)
            const val = (d) => {
                const c = d ? dataItem[d] : null
                const v = (c && typeof c === 'object') ? c[b.measure] : undefined
                return (v === null || v === undefined || v === '' || !Number.isFinite(Number(v))) ? null : Number(v)
            }
            const cell = dataItem[b.date]
            const dlr = dataItem._DLRow
            const color = cellArea_zoneColor((cell && typeof cell === 'object') ? cell.zone_val : null, b.measure, cellRing_signalsOf(dlr?.cells?.[col?.binding]?.cssClasses, dlr?.cssClasses))
            const o = this.cellShape_opt()   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p208 форма «Площа» — від запасу на початок періоду до запасу на кінець, стик між комірками)
            if (o.oc === undefined) o.oc = cellArea_openCloseOn((k, d) => this.fmtSetting(k, d))   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p208 форма «Площа» — від запасу на початок періоду до запасу на кінець, стик між комірками)
            if (o.oc) return cellArea_segmentOC({ open: val(b.date), close: val(nb.next), max: info.max, w: col?.renderWidth || col?.width || 0, h: this.flex?.rows?.defaultSize || 24, color })   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p208 форма «Площа» — від запасу на початок періоду до запасу на кінець, стик між комірками)
            return cellArea_segment({ prev: val(nb.prev), value: val(b.date), next: val(nb.next), max: info.max,
                w: col?.renderWidth || col?.width || 0, h: this.flex?.rows?.defaultSize || 24, color })
        },
        cellArea_put(e_cell, seg) {
            const html = cellArea_svg(seg)
            let el = e_cell.querySelector(':scope > .cell-area')
            if (!el) { el = document.createElement('span'); el.className = 'cell-area'; e_cell.insertBefore(el, e_cell.firstChild) }
            if (el.__html !== html) { el.innerHTML = html; el.__html = html }
            if (!e_cell.classList.contains('has-cell-area')) e_cell.classList.add('has-cell-area')
            e_cell.__cellArea = true
        },
        cellArea_clear(e_cell) {
            if (!e_cell.__cellArea && !e_cell.classList.contains('has-cell-area')) return
            e_cell.querySelector(':scope > .cell-area')?.remove()
            e_cell.classList.remove('has-cell-area')
            e_cell.__cellArea = false
        },
        cellView_tipAt(row, col) {
            const flex = this.flex
            const r = flex?.rows[row]
            const dataItem = r?.dataItem
            const column = flex?.columns[col]
            const view = this.cellView_active()
            if (!view || !column) return ''
            const res = this.cellView_of(dataItem, column.binding, r)
            if (!res) return this.cellView_emptyTipAt(view, dataItem, column)   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T9b)
            const b = cellPie_bindingOf(column.binding)
            const attr_col = this.attr_by_binding[column.binding]
            const fmt = (v) => { try { return wjcCore.Globalize.format(Number(v), this.cf_rowFormat(dataItem, column.binding) || attr_col?.format || 'n0') } catch (e) { return String(v) } }
            const head = [b?.date, attr_col?.title || column.header].filter(Boolean).join(' · ')
            const cell = b ? dataItem?.[b.date] : null
            const rowMax = this.cellView_build(res, dataItem, column.binding, column)?.rowMax || 0   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p190 — розмір кола від максимуму рядка, 60…100 %): «Максимум рядка» в подсказке
            return cellView_tipHtml(view, res, { t, fmt, head, value: (cell && typeof cell === 'object') ? cell[b.measure] : undefined, ctx: { row: r }, rowMax })
        },
        // ---- IE 2026 11 03 / ODOO-350449 (заказ Игоря: p231 підказка по сигналу — проблема як у формі комірки) ----
        // Alt над сигналом вида «Сигнали»: проблемы ячейки тем же видом, что блок PROBLEMS формы (бейдж оценки + строка-цепочка, utils/signalTipProblems), данные — story
        // ответа cell_passport (params.story = 1, тот же отбор ячейки, что у формы: cellPassport_storyParams); у строки грида проблем нет — запрос лениво при первом Alt над
        // ячейкой, кэш по отбору ячейки (_sigTip), до ответа — «…», ответ перерисовывает показанную подсказку (altTooltip.refresh). Проблем нет / ошибка / не ячейка-дата — ''
        // (прежняя подсказка вида). Клик по сигналу — форма ячейки, строка проблемы раскрыта и прокручена (signalTip_click → signalTip_focusApply).
        // Выключатель fe.ux.signalTipProblems (дефолт ВКЛ); счётчики window.__sigTip
        signalTip_isOn() { return signalTip_on((k, d) => this.store.setting(k, d)) },
        signalTip_stat(k) { const w = window.__sigTip || (window.__sigTip = { loads: 0, hits: 0, answers: 0, errors: 0, clicks: 0, focus: 0 }); w[k] = (w[k] || 0) + 1 },
        // сигналы ячейки (row, col) вида «Сигнали»: { dataItem, column, res, kinds } либо null
        signalTip_cellAt(row, col) {
            const flex = this.flex
            if (!flex || this.cellView_active() !== SIGNALS_VIEW || !this.signalTip_isOn()) return null
            const r = flex.rows[row], column = flex.columns[col], dataItem = r?.dataItem
            if (!dataItem || !column || !cellPie_bindingOf(column.binding)) return null
            const res = this.cellView_of(dataItem, column.binding, r)
            const kinds = res && Array.isArray(res.signalKinds) ? res.signalKinds : []
            return kinds.length ? { dataItem, column, res, kinds } : null
        },
        // запрос story ячейки — тот же отбор, что у паспорта формы (cellPassport_load): where строки и предков, месяц / месяцы периода, отбор полосы, подчинённые строки группы; null — паспорта у ячейки нет
        cellPassport_storyParams(dataItem, col_binding, irow) {
            if (this.store.setting('fe.ux.cellPassport', true) === false || !this.cellStory_on()) return null
            if (!cellPassport_reportAllowed({ widget_class: this.WIDGET?.widget_class, metric_data: this.WIDGET?.record?._doc?.metric_data,
                anyReport: this.store.setting('fe.ux.cellPassportAnyReport', true) !== false })) return null
            const _periodOn = this.store.setting('fe.ux.cellPassportPeriodTotals', true) !== false
            const _per = cellPassport_periodOf(col_binding, _periodOn ? (this.flex?.columns || []).map(c => String(c?.binding || '').slice(0, 10)).filter(x => /^\d{4}-\d{2}-\d{2}$/.test(x)) : null, _periodOn)
            if (!_per || !dataItem) return null
            const where = [], seen = new Set()
            const _blkOn = this.store.setting('fe.ux.cellPassportBlockMeasure', true) !== false
            const _wbRows = this.store.setting(CELL_PASSPORT_WHERE_BLOCK_FLAG, true) !== false ? [] : null
            this.cellPassport_rowWhere(dataItem, irow, where, seen, _blkOn, _wbRows)
            if (!where.length) return null
            const params = { where, month: _per.month }
            if (_per.months) params.months = _per.months
            if (_wbRows) { const _wb = cellPassport_whereBlockOf(_wbRows); if (_wb.length) params.where_block = _wb }
            if (this.store.setting('fe.cellForm.groupRows', true) !== false) { const _grp = this.cellPassport_group(dataItem, where); if (_grp) params.group = _grp }
            params.story = 1
            return params
        },
        // строки подсказки по ответу: story → нормализация (как cellStory_apply), критический вердикт по story (формула грида есть только у выбранной ячейки), story_chains — как CellStory.rows
        signalTip_rowsOfRaw(raw) {
            try { story_refsApply(raw, sigNames_fromRules(this.attr?.metric_rules)) } catch (e) { /* названия бэка остаются */ }
            const check = story_stockCheck(raw)
            const st = story_normalize(raw)
            let crit = null
            try { crit = story_verdict(st, null, check) } catch (e) { crit = null }
            return signalTip_rows(story_chains(st, crit, check, ''))
        },
        signalTip_load(key, params, cacheIn) {
            const cache = cacheIn || this._sigTip || (this._sigTip = new Map())   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: агрегат сигналов кругом в кнопке; проблемы подсказки в одну строку, клик — форма ячейки): кеш версии данных (signalTip_cacheFor)
            if (cache.size > Math.max(300, this._sigTipCap || 0)) cache.clear()   // IE 2026 11 03 / ODOO-350449 (Игорь: предзагрузка цепочек сигналов; BE ie-dm7 #1009): потолок кеша — два экрана ячеек предзагрузки
            cache.set(key, { state: 'loading', rows: [], at: Date.now() })
            this.signalTip_stat('loads')
            try {
                this.store.executeWidgetMethod({ WIDGET: this.WIDGET }, { command: 'executeWidgetMethod', method: 'cell_passport', params,
                    record_sendToBackend_exclude: ['_doc'], widget_sendToBackend_exclude: ['view'], no_del_last_backend_action: true,
                    _response_callback: (answer) => {
                        if (answer) { answer.command = ''; delete answer.updates }   // ответ нужен только подсказке — не updateDoc записи виджета (как у паспорта формы)
                        let rows = [], ok = true
                        try { rows = this.signalTip_rowsOfRaw(answer?.cell_passport?.story) } catch (e) { rows = []; ok = false }
                        cache.set(key, { state: ok ? 'ok' : 'error', rows, at: Date.now() })
                        this.signalTip_stat(ok ? 'answers' : 'errors')
                        this.signalTip_refreshShown(key)
                    } })
            } catch (e) { cache.set(key, { state: 'error', rows: [], at: Date.now() }); this.signalTip_stat('errors') }
        },
        // ответ пришёл, а подсказка этой ячейки на экране — перерисовать её (дожитие после Alt не прерывается)
        signalTip_refreshShown(key) {
            const el = altTooltip._el
            if (!el || !el.isConnected || el.__sigTipKey !== key || !this.flex?.hostElement?.contains(el)) return
            const rc = el.getBoundingClientRect()
            const r = this.cellTooltip(el, rc.left + rc.width / 2, rc.top + rc.height / 2)
            if (r && r.content) altTooltip.refresh({ el, inst: r.inst, content: r.content, rect: r.rect || undefined })
        },
        signalTip_htmlAt(row, col, opts = {}) {
            const c = this.signalTip_cellAt(row, col)
            if (!c) return ''
            const params = this.cellPassport_storyParams(c.dataItem, c.column.binding, row)
            if (!params) return ''
            // IE 2026 11 03 / ODOO-350449 (заказ Игоря: агрегат сигналов кругом в кнопке; проблемы подсказки в одну строку, клик — форма ячейки): мгновенно (fe.ux.signalTipInstant) — кеш ответов по ячейке на версию данных отчёта (record._doc + версия видов; перечитали — пуст),
            // строки сразу из сигналов круга ячейки, ответ story дополняет их на месте (signalTip_mergeRows); ошибка / нет ответа — строки сигналов
            const rd = (k, d) => this.store.setting(k, d)
            const instant = signalsAgg_flagOn(rd, TIP_INSTANT_FLAG), oneLine = signalsAgg_flagOn(rd, TIP_ONE_LINE_FLAG)
            const key = instant ? signalTip_cacheKey(params) : JSON.stringify(params)
            if (opts && opts.el) opts.el.__sigTipKey = key
            const cache = instant ? this.signalTip_cache() : (this._sigTip || (this._sigTip = new Map()))   // IE 2026 11 03 / ODOO-350449 (Игорь: предзагрузка цепочек сигналов; BE ie-dm7 #1009): тот же кеш версии данных, что у предзагрузки (signalTip_cache)
            let hit = cache.get(key)
            hit = this.sigPrefetch_tipHit(key, params, cache, hit, opts)   // IE 2026 11 03 / ODOO-350449 (Игорь: предзагрузка цепочек сигналов; BE ie-dm7 #1009): цепочка в полёте у пакета — ждём его ответа, не дольше 1,5 с, затем одиночный вызов; счётчики попаданий
            if (hit && hit.state === 'loading' && !hit.batch && Date.now() - hit.at > 20000) { hit = { state: 'error', rows: [], at: Date.now() }; cache.set(key, hit) }   // ответа нет 20 с — прежняя подсказка   // IE 2026 11 03 / ODOO-350449 (Игорь: предзагрузка цепочек сигналов; BE ie-dm7 #1009): пометка пакета — своим ожиданием (sigPrefetch_tipHit)
            if (!hit) { this.signalTip_load(key, params, cache); hit = cache.get(key) } else this.signalTip_stat('hits')
            let rows = hit ? hit.rows : [], state = hit ? hit.state : 'error', note = ''
            if (instant) {
                let out = null
                try { out = this.cellView_build(c.res, c.dataItem, c.column.binding, c.column) } catch (e) { out = null }
                const kinds = Array.isArray(out?.layers) && out.layers.length ? out.layers.map(l => l.key) : c.kinds
                const sigRows = signalTip_signalRows(kinds, t, { share: out?.share })
                note = signalTip_noteOf(state, rows)   // IE 2026 11 03 / ODOO-350449 (замечание Игоря: мгновенная подсказка сигнала явно говорит о подгрузке проблем): «Loading problems…» / «No problem details» / из кеша — итог без строки
                rows = state === 'ok' ? signalTip_mergeRows(sigRows, rows) : sigRows
                if (state === 'error') state = 'ok'
            } else if (!hit || hit.state === 'error') return ''
            const b = cellPie_bindingOf(c.column.binding), attr_col = this.attr_by_binding[c.column.binding]
            const head = [b?.date, attr_col?.title || c.column.header].filter(Boolean).join(' · ')
            const cell = b ? c.dataItem[b.date] : null
            const v = (cell && typeof cell === 'object') ? cell[b.measure] : undefined
            let valueText = ''
            if (v !== undefined && v !== null && v !== '') { try { valueText = wjcCore.Globalize.format(Number(v), this.cf_rowFormat(c.dataItem, c.column.binding) || attr_col?.format || 'n0') } catch (e) { valueText = String(v) } }
            return signalTip_html({ t, head, valueText, rows, state, oneLine, note, cell: { grid: String(this.$.uid), row, col } })   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: агрегат сигналов кругом в кнопке; проблемы подсказки в одну строку, клик — форма ячейки)
        },
        // клик по кружку-сигналу: выделить ячейку и открыть форму (тем же путём, что 🏷 / F4; уже открыта на ней — не закрывать), строка проблемы — раскрыть, когда story в форме
        signalTip_click(e) {
            if (!e || e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey) return
            // кружок — pointer-events: none (клик приходит в саму ячейку): попадание — точка клика внутри прямоугольника кружка (+2 px)
            const cellEl = e.target?.closest?.('.wj-cell')
            const ring = cellEl ? cellEl.querySelector(':scope > .cell-ring') : null
            if (!ring || !this.flex) return
            const rb = ring.getBoundingClientRect()
            if (!(e.clientX >= rb.left - 2 && e.clientX <= rb.right + 2 && e.clientY >= rb.top - 2 && e.clientY <= rb.bottom + 2)) return
            let ht = null
            try { ht = this.flex.hitTest(cellEl) } catch (err) { ht = null }
            if (!ht || ht.panel !== this.flex.cells || ht.row < 0 || ht.col < 0) return
            const c = this.signalTip_cellAt(ht.row, ht.col)
            if (!c) return
            const row = ht.row, col = ht.col, kinds = c.kinds.slice()
            window.$cg.setTimeout(this, 'AttrGrid.signalTip_click', () => this.signalTip_open(row, col, kinds), 0)
        },
        signalTip_open(row, col, kinds, problem = '') {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: агрегат сигналов кругом в кнопке; проблемы подсказки в одну строку, клик — форма ячейки): problem — ключ строки, по которой кликнули в подсказке
            const flex = this.flex, dd = this.store.dropdown
            if (!flex || flex.disposed || !dd || this.attr?.cellForm_off) return
            this.signalTip_stat('clicks')
            const key = `${flex.cells.cellType}-${row}-${col}`
            dd._sigTipFocus = { key, kinds, problem, at: Date.now() }
            const s0 = flex.selection
            if (!s0 || s0.row !== row || s0.col !== col || (flex.selectedRanges?.length || 0) > 1) flex.select(new wjGrid.CellRange(row, col))
            if (dd.visible && dd.key === key && dd.vueObj === this) { dd.sessionOpen?.(); this.signalTip_focusApply(dd); return }
            if (dd.visible && dd.vueObj !== this && !this.cellFormTag_open()) dd.hide()   // форма другого грида
            this.cellForm_toggle(row, col)
        },
        // раскрыть строку проблемы, к которой ведёт клик по сигналу: те же строки, что у формы (story_chains по story и вердикту формы), память 'storyRow:<ключ>' — как щелчок
        // по проблеме в форме; блок PROBLEMS свёрнут — раскрыть; прокрутить к строке. story ещё не пришёл — ждать (зовётся и из ответа паспорта)
        signalTip_focusApply(dd) {
            const f = dd && dd._sigTipFocus
            if (!f) return false
            if (dd.key !== f.key || Date.now() - f.at > 30000 || !dd.visible) { if (Date.now() - f.at > 30000) dd._sigTipFocus = null; return false }
            if (dd.cell_passport_loading) return false
            dd._sigTipFocus = null
            let rows = []
            try { rows = signalTip_rows(story_chains(dd.cell_story, dd.stockVerdict, dd.stockCheck, '')) } catch (e) { rows = [] }
            const foc = signalTip_focusOf((f.problem && rows.find(r => r && r.key === f.problem)) || signalTip_pick(rows, f.kinds))   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: агрегат сигналов кругом в кнопке; проблемы подсказки в одну строку, клик — форма ячейки)
            if (!foc) return false
            try { if (typeof dd.blkOpen === 'function' && !dd.blkOpen('storyChain')) dd.blkToggle?.('storyChain') } catch (e) { /* без блока */ }
            dd.blkMemSet?.(foc.mem, foc.value)
            this.signalTip_stat('focus')
            this.$nextTick(() => requestAnimationFrame(() => {
                try {
                    const root = dd.$el && dd.$el.nodeType === 1 ? dd.$el : (dd.$el?.parentElement || document)
                    const sel = `.dropdown-story-chain [data-problem="${foc.key}"]`
                    const rowEl = root.querySelector(sel) || document.querySelector(sel)
                    const card = rowEl ? (rowEl.parentElement?.querySelector(`.dropdown-story-expand[data-problem="${foc.key}"]`) || rowEl) : null
                    if (card) card.scrollIntoView({ block: 'nearest' })
                    if (rowEl && rowEl !== card) rowEl.scrollIntoView({ block: 'nearest' })
                } catch (e) { /* форма закрыта */ }
            }))
            return true
        },
        // ---- IE 2026 11 03 / ODOO-350449 (заказ Игоря: агрегат сигналов кругом в кнопке; проблемы подсказки в одну строку, клик — форма ячейки) ----
        // Клик по строке проблемы / причины в подсказке над сигналом (строки sig-tip-prow с data-problem, адрес ячейки — data-sig-* корня подсказки) открывает форму
        // ячейки на этой проблеме тем же путём, что клик по сигналу (signalTip_open → signalTip_focusApply); строка сигнала 'sig:<вид>' — первая строка формы этого вида.
        // Обрезанная строка («…») по наведению раскрывается целиком (класс sig-tip-prow-full) — только если scrollWidth > clientWidth. Выключатель fe.ux.cellTipProblemsOneLine
        signalTip_docInstall() {
            if (this._sigTipDoc) return
            const uid = String(this.$.uid)
            const onClick = (e) => { try { this.signalTip_tipClick(e, uid) } catch (err) { /* подсказка ушла */ } }
            const onOver = (e) => { try { this.signalTip_tipOver(e, uid) } catch (err) { /* подсказка ушла */ } }
            if (signalsAgg_flagOn((k, d) => this.store.setting(k, d), SIGNAL_TIP_DOC_SHARED_FLAG)) { this._sigTipDoc = { off: signalTipDoc_register(document, uid, { click: onClick, over: onOver }) }; return }   // IE 2026 11 03 / ODOO-350449 (webscm #128539: одна пара слушателей document на все гриды): одна пара на документ (utils/signalTipDoc.js), событие — гриду своей подсказки
            document.addEventListener('click', onClick, true)
            document.addEventListener('mouseover', onOver, true)
            this._sigTipDoc = { onClick, onOver }
        },
        signalTip_tipRow(e, uid) {
            const rowEl = e?.target?.closest?.('.sig-tip-1l .sig-tip-prow[data-problem]')
            const root = rowEl ? rowEl.closest('.sig-tip') : null
            return root && root.getAttribute('data-sig-grid') === uid ? { rowEl, root } : null
        },
        signalTip_tipClick(e, uid) {
            if (!e || e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey) return
            const h = this.signalTip_tipRow(e, uid)
            if (!h || !signalsAgg_flagOn((k, d) => this.store.setting(k, d), TIP_ONE_LINE_FLAG)) return
            const row = Number(h.root.getAttribute('data-sig-row')), col = Number(h.root.getAttribute('data-sig-col'))
            const c = Number.isInteger(row) && Number.isInteger(col) ? this.signalTip_cellAt(row, col) : null
            if (!c) return
            e.preventDefault(); e.stopPropagation()
            const pk = h.rowEl.getAttribute('data-problem') || ''
            let kinds = c.kinds.slice(), problem = pk
            if (pk.startsWith('sig:')) { const k = pk.slice(4); kinds = [k, ...kinds.filter(x => x !== k)]; problem = '' }
            try { altTooltip._hide() } catch (err) { /* подсказки нет */ }
            // IE 2026 11 03 / ODOO-350449 (заказ Игоря: проблемы подсказки в одну строку — и строки story): клик был в подсказке (вне грида) — фокус у body, а F4 слушает keydown хоста грида: вернуть фокус гриду, чтобы F4 закрывал форму, как после клика по сигналу
            window.$cg.setTimeout(this, 'AttrGrid.signalTip_tipClick', () => { this.signalTip_open(row, col, kinds, problem); try { if (this.flex && !this.flex.hostElement.contains(document.activeElement)) this.flex.focus() } catch (err) { /* грид в перестройке */ } }, 0)
        },
        signalTip_tipOver(e, uid) {
            const h = this.signalTip_tipRow(e, uid)
            const prev = this._sigTipFull
            if (prev && (!h || prev !== h.rowEl)) { prev.classList.remove('sig-tip-prow-full'); this._sigTipFull = null }
            if (!h || h.rowEl === this._sigTipFull) return
            if (signalsAgg_isTruncated(h.rowEl)) { h.rowEl.classList.add('sig-tip-prow-full'); this._sigTipFull = h.rowEl }
        },
        // Диаграмма-агрегат в кнопке «Сигнали»: режим — выключатель fe.ux.signalsPieAggregate, активный вид «Сигнали», форма «Кола» (или переключателя формы нет).
        // Счёт — по строкам грида (данные collectionView после фильтров и раскрытия: Row.isVisible) × видимым колонкам периода, виды ячейки — те же, что у её круга
        // (слои cellView_build: сигналы классов + over-100 от шкалы); дебаунс 300 мс; модель меняется только при смене чисел — кнопка не перерисовывается зря. Счётчики window.__sigPie
        sigPie_on() { return signalsAgg_flagOn((k, d) => this.store.setting(k, d), SIGNALS_PIE_FLAG) },
        sigPie_modeOn() {
            if (!this.sigPie_on() || this.cellView_active() !== SIGNALS_VIEW) return false
            const ui = this.cellShape_ui
            const a = Array.isArray(ui) ? ui.find(x => x && x.active) : null
            return !a || a.key === 'circle'
        },
        sigPie_slot(attrM) {
            try { return cellViewBtn_id(attrM) === SIGNALS_VIEW && this.sigPie_modeOn() } catch (e) { return false }
        },
        // ---- IE 2026 11 03 / ODOO-350449 (Игорь: предзагрузка цепочек сигналов; BE ie-dm7 #1009) ----
        // Пакетная предзагрузка цепочек (story) подсказки сигнала: после отрисовки видимых строк (updatedView, дебаунс PREFETCH_DEBOUNCE_MS) в простое браузера
        // (signalsAgg_idle) — ячейки видимого диапазона (+ экран снизу) с сигналом вида «Сигнали», отбор — тот же cellPassport_storyParams, ключ — тот же
        // signalTip_cacheKey, кеш — тот же signalTip_cache (версия данных). Порции по PREFETCH_PORTION, budget_ms PREFETCH_BUDGET_MS, одна порция в полёте на грид.
        // Очередь стора: executeWidgetMethod не ставит запросы в очередь — каждый вызов сразу ajax, не-poll считается в store._primary_inflight (P0), и новый
        // запрос виджета без no_del_last_backend_action обрывает его _activeRequest. Поэтому порция уходит, только когда стор свободен (sigPrefetch_busy: P0,
        // словари P1, отложенная P2, loading виджета — Save / select, живой _activeRequest), иначе повтор через PREFETCH_BUSY_RETRY_MS; сама порция — background: true
        // (ревью: не в P0 и не _activeRequest — не держит P2 и чужие гриды) + no_del_last_backend_action (не обрывает чужой запрос, не ставит loading); работа пользователя,
        // начавшаяся при порции в полёте, порцию не обрывает (дорабатывает в пределах budget_ms), но следующая ждёт её конца (sigPrefetch_mayStart).
        // Прокрутка / смена вида / закрытие — очередь снята; ответ другой версии данных отброшен. Нет метода / state 'off' / ошибки подряд — выкл до перезагрузки.
        // Выключатель fe.ux.signalChainsPrefetch (дефолт ВЫКЛ до прогона 20 Alt, ie-dm7 #128809); счётчики window.__sigPrefetchStats
        // IE 2026 11 03 / ODOO-350449 (заказ Игоря: виды ячеек запаса под ключ — Z5 по умолчанию; BE ie-dm7 stock_cells_batch)
        // Виды ячеек строк запаса Баланса (utils/stockCells.js). Загрузка — метод виджета stock_cells_batch по строкам запаса видимого экрана (+ экран снизу,
        // дети видимой группы ≤ 12) порциями STOCK_PORTION, фоновым запросом (background: true — не P0, не _activeRequest; как предзагрузка сигналов), одна порция
        // в полёте на грид; стор занят работой пользователя — порция ждёт. Кеш строк — по версии данных строк (_sigTipVer: растёт, только когда load_data собрал
        // другие строки) и полям запроса (Z4 — ещё нормы в днях); ответ другой версии отброшен. Прокрутка снимает отложенную порцию. Нет метода / state 'off' /
        // ошибки подряд — слой выключен до перезагрузки, ячейки как сейчас. Рисование — stockCell_after (пост-шаг formatItem_fast, оба пути): класс stk и
        // переменные --stk-img / --stk-h (фон-слой SVG), кеш слоя по ключу (вид, режим группы, источник зоны, значения, пороги, ширина, высота).
        // Опции: fe.ux.stockCellView (def z5) · fe.ux.stockGroupMode (def f) · fe.ux.stockZoneSource (def zone); window.stockCells.get/set('visibleOnly') · .stats
        stk_opts() {
            const ep = this.store._settingsEpoch, ov = this.store._settingsOverride, c = this._stkOpts
            if (c && c.ep === ep && c.ov === ov) return c.o
            const o = stockCells_opts((k, d) => this.store.setting(k, d))
            this._stkOpts = { ep, ov, o }
            return o
        },
        stk_index() {
            const data = gridSave_toRaw(this.data), ver = this._sigTipVer || 0
            const c = this._stkIdx
            if (c && c.data === data && c.ver === ver) return c
            let map = new Map()
            try { if (this.attr?.childItemsPath && Array.isArray(data)) map = stockRows_index(data, this.attr.childItemsPath, gridSave_toRaw) } catch (e) { map = new Map() }
            this._stkIdx = { data, ver, map, nc: -1, measure: '', dates: [] }
            return this._stkIdx
        },
        // мера колонок-дат, на которой рисуется слой (quantity, иначе первая мера дат) и даты окна запроса
        stk_cols() {
            const idx = this.stk_index(), cols = this.flex?.columns || [], nc = cols.length
            if (idx.nc === nc) return idx
            const ms = [], ds = new Set()
            for (const col of cols) { const b = cellPie_bindingOf(col?.binding); if (!b) continue; ds.add(b.date); if (!ms.includes(b.measure)) ms.push(b.measure) }
            idx.nc = nc; idx.measure = ms.includes('quantity') ? 'quantity' : (ms[0] || ''); idx.dates = [...ds].sort()
            return idx
        },
        stk_on() {
            if (stockCells_isOff()) return false
            const flex = this.flex
            if (!flex || flex.disposed || !this.isVisible || this.WIDGET?.close) return false
            if (!this.attr?.childItemsPath || this.attr?.name === 'heatmapGrid' || this.attr?.isPrint || this.attr?.isPrintTemplate) return false
            if (this.stk_opts().view === 'now') return false
            return this.stk_index().map.size > 0
        },
        stk_state() {
            const st = this._stk || (this._stk = { ver: '', data: null, cache: new Map(), tries: new Map(), memo: new Map(), inflight: null, t: null, idle: null, dead: false, errors: 0 })
            const idx = this.stk_index(), ver = `${idx.ver}|${stockCells_fields(this.stk_opts().view).join(',')}`
            if (st.ver !== ver || st.data !== idx.data) { st.ver = ver; st.data = idx.data; st.cache = new Map(); st.tries = new Map(); st.memo = new Map(); st.inflight = null }
            return st
        },
        stk_schedule(delay = STOCK_DEBOUNCE_MS) {
            const st = this._stk
            if (st && st.dead) return
            if (st) { if (st.t) { clearTimeout(st.t); st.t = null } if (st.idle) { st.idle(); st.idle = null } }
            if (!this.stk_on()) return
            const s2 = this.stk_state()
            s2.t = setTimeout(() => {
                s2.t = null
                s2.idle = signalsAgg_idle(() => { s2.idle = null; try { this.stk_run() } catch (e) { /* грид перестраивается */ } }, 1500)
            }, delay)
        },
        stk_cancel(dead = false) {
            const st = this._stk
            if (!st) return
            if (st.t) { clearTimeout(st.t); st.t = null }
            if (st.idle) { st.idle(); st.idle = null }
            if (dead) st.dead = true
        },
        stk_run() {
            const st = this.stk_state()
            if (st.dead || !this.stk_on()) return
            if (st.inflight) { if (Date.now() - st.inflight.at < STOCK_BUDGET_MS + 20000) return; st.inflight = null }   // ответ потерян — не держим грид
            if (!sigPrefetch_mayStart(this.sigPrefetch_storeBusy())) { stockCells_stat('busySkips'); this.stk_schedule(600); return }
            const flex = this.flex, idx = this.stk_index()
            let infos = []
            if (stockCells_fe.get('visibleOnly') !== false) {
                let vr = null
                try { vr = flex.viewRange } catch (e) { vr = null }
                if (!vr) return
                const top = Math.max(0, vr.topRow), last = Math.min(flex.rows.length - 1, vr.bottomRow + Math.max(0, vr.bottomRow - vr.topRow + 1))
                for (let r = top; r <= last; r++) {
                    const inf = idx.map.get(gridSave_toRaw(flex.rows[r]?.dataItem))
                    if (!inf) continue
                    infos.push(inf)
                    if (!inf.leaf && inf.kids.length <= 12) for (const k of inf.kids) { const ki = idx.map.get(k); if (ki) infos.push(ki) }
                }
            } else infos = [...idx.map.values()]
            const portion = stockRows_portion(infos, STOCK_PORTION, (p) => st.cache.has(p) || (st.tries.get(p) || 0) > STOCK_RETRY_MAX)
            if (portion.length) this.stk_send(st, portion)
        },
        stk_send(st, rows) {
            const req = { ver: st.ver, paths: rows.map(r => r.path), at: Date.now(), done: false }
            st.inflight = req
            const t0 = performance.now()
            stockCells_stat('portions'); stockCells_stat('rows', rows.length)
            const done = (answer, how) => {
                if (req.done) return
                req.done = true
                if (st.inflight === req) st.inflight = null
                if (how === 'abort') { stockCells_stat('aborted'); if (!st.dead) this.stk_schedule(600); return }
                if (how === 'error') {
                    stockCells_stat('errors'); st.errors++
                    if (st.errors >= STOCK_ERRORS_OFF) { stockCells_off('error'); stockCells_stat('off') } else if (!st.dead) this.stk_schedule(600)
                    return
                }
                if (st.dead || this._stk !== st || st.ver !== req.ver || st.data !== this.stk_index().data) { stockCells_stat('stale'); if (!st.dead) this.stk_schedule(0); return }   // ответ на устаревшую версию строк
                const r = stockCells_merge(st.cache, req.paths, answer)
                if (r.off) { stockCells_off(r.state || 'off'); stockCells_stat('off'); this.stk_repaint(); return }
                st.errors = 0
                for (const p of r.retry) st.tries.set(p, (st.tries.get(p) || 0) + 1)
                const b = stockCells_answerOf(answer)
                STOCK_STATS.msSum += performance.now() - t0; STOCK_STATS.beMsSum += Number(b?.stats?.ms) || 0
                stockCells_stat('cells', Number(b?.stats?.cells) || 0); stockCells_stat('truncated', r.retry.length)
                stockCells_stat('missing', b?.missing && typeof b.missing === 'object' ? Object.keys(b.missing).length : 0)
                if (r.ok.length) this.stk_repaint()
                this.stk_schedule(0)
            }
            try {
                const o = this.stk_opts()
                this.store.executeWidgetMethod({ WIDGET: this.WIDGET }, { command: 'executeWidgetMethod', method: STOCK_CELLS_METHOD,
                    params: stockCells_params(rows, this.stk_cols().dates, stockCells_fields(o.view), STOCK_BUDGET_MS),
                    record_sendToBackend_exclude: ['_doc'], widget_sendToBackend_exclude: ['view'], no_del_last_backend_action: true, quiet_errors: true,
                    background: true,   // не P0 и не _activeRequest (mainStore.executeWidgetMethod), как порция предзагрузки сигналов
                    ...readLight_fields(STOCK_CELLS_METHOD, this.WIDGET.record, (k, d) => this.store.setting(k, d)),   // IE 2026 11 03 / ODOO-350449 (ie-dm7 #128926: порции 15, бюджет 5 с, группы только по Alt, лёгкий запрос): тот же лёгкий запрос, что у порции сигналов (utils/readMethodLight.js; fe.data.readMethodsLight)
                    _response_callback: (answer) => {
                        if (answer) { answer.command = ''; delete answer.updates }   // ответ нужен только слою — не updateDoc записи виджета
                        done(answer, 'ok')
                    },
                    _onResponse: (answer) => { if (answer === null) done(null, 'error') },
                    _onAbort: () => done(null, 'abort') })
            } catch (e) { done(null, 'error') }
        },
        stk_repaint() { try { this.flex?.invalidate() } catch (e) { /* грид пересоздаётся */ } },
        // слой ячейки (row, col) | null — нет строки запаса / данных / вид «как сейчас»
        // IE 2026 11 04 / ODOO-350449 (проба -224 p263): cellH — высота самой ячейки (inline-стиль после formatItem): у строки, открывающей секцию (break-top), row.height = строка + зазор 10 px,
        // а ячейка сдвинута вниз на зазор и ниже строки на те же 10 px — по renderHeight (27) полоса была 10 px и линия Z5 заходила на цифры 17-px ячейки
        stk_layerAt(flex, row, col, cellH) {   // IE 2026 11 04 / ODOO-350449 (проба -224 p263)
            const st = this._stk
            if (!st || stockCells_isOff()) return null
            const o = this.stk_opts()
            if (o.view === 'now') return null
            this.stk_state()
            if (!st.cache.size) return null
            const column = flex.columns[col], b = cellPie_bindingOf(column?.binding)
            if (!b) return null
            const idx = this.stk_cols()
            if (b.measure !== idx.measure) return null
            const inf = idx.map.get(gridSave_toRaw(flex.rows[row]?.dataItem))
            if (!inf) return null
            const rowCells = st.cache.get(inf.path)
            const raw = rowCells ? rowCells[b.date] : null
            if (!raw) return null
            const isGroup = !inf.leaf && inf.kids.length > 0
            const kidsRaw = isGroup ? inf.kids.map(k => { const ki = idx.map.get(k); const kc = ki ? st.cache.get(ki.path) : undefined; return kc === undefined ? undefined : (kc[b.date] || null) }) : null
            const size = { w: column.renderWidth || column.width || 110, h: (cellH > 0 ? cellH : 0) || flex.rows[row]?.renderHeight || flex.rows.defaultSize || 24 }   // IE 2026 11 04 / ODOO-350449 (проба -224 p263)
            const rsc = st.rsc && st.rsc.cache === st.cache ? st.rsc.map : (st.rsc = { cache: st.cache, map: new Map() }).map   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: виды ячеек запаса — общая шкала строки): шкала строки — один раз на версию ячеек строки (кеш по path; сброс кеша ответа — сброс шкал)
            let rse = rsc.get(inf.path)
            if (!rse || rse.cells !== rowCells) { rse = { cells: rowCells, rs: stockRow_scale(rowCells) }; rsc.set(inf.path, rse) }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: виды ячеек запаса — общая шкала строки)
            const nb = { isGroup, total: !!inf.total, kidsRaw, rowScale: rse.rs }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: виды ячеек запаса — общая шкала строки): шкалы нет (нет месяцев) — ячейка по своей шкале; ответ строки приходит целиком, перерисовка — stk_repaint
            nb.prevRaw = rowCells[stock_prevMonth(b.date)] || null   // IE 2026 11 03 / ODOO-350449 (проба p259: стык после дефицита — сброс к 0 пунктиром): end_raw < 0 предыдущего месяца — «сброс к 0» у левого края
            const key = stockCell_key(raw, o, size, nb)
            let L = st.memo.get(key)
            if (L === undefined) {
                stockCells_stat('memoMiss')
                L = stockCell_layer(raw, o, size, nb)
                if (L) L.tip = stockCell_tip(raw, o)
                if (st.memo.size > STOCK_MEMO_MAX) st.memo.clear()
                st.memo.set(key, L)
            } else stockCells_stat('memoHit')
            return L
        },
        stk_clear(cell) {
            cell.classList.remove('stk', 'stk-g'); cell.style.removeProperty('--stk-img'); cell.style.removeProperty('--stk-h')   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р6/Р7): + stk-g
            cell.__stk = null; cell.__stkTip = ''
        },
        // пост-шаг КАЖДОГО formatItem ячейки данных (полный и кэш-путь: кэш-путь копирует className / стиль снимка — слой ставится и снимается заново)
        stockCell_after(flex, e, r) {
            const cell = e?.cell
            if (!cell || !flex || e.panel !== flex.cells) return r
            let L = null
            try { L = this.stk_layerAt(flex, e.row, e.col, parseFloat(cell.style.height) || 0) } catch (err) { L = null }   // IE 2026 11 04 / ODOO-350449 (проба -224 p263): высота ячейки, не строки (зазор секции)
            if (!L) { if (cell.__stk || cell.classList.contains('stk')) this.stk_clear(cell); return r }
            if (cell.__stk !== L.img || cell.style.getPropertyValue('--stk-img') !== L.img) { cell.style.setProperty('--stk-img', L.img); cell.style.setProperty('--stk-h', L.bandH + 'px'); cell.__stk = L.img }
            if (!cell.classList.contains('stk')) cell.classList.add('stk')
            if (cell.classList.contains('stk-g') !== !!L.quiet) cell.classList.toggle('stk-g', !!L.quiet)   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р6/Р7): строка-итог / группа — цифры без белого ореола
            cell.__stkTip = L.tip || ''
            return r
        },
        signalTip_cache() {
            const ver = sigTip_stableVerOn((k, d) => this.store.setting(k, d)) && sigPrefetch_flagOn((k, d) => this.store.setting(k, d)) ? 's' + (this._sigTipVer || 0) : (this._cellViewVer || 0)   // IE 2026 11 03 / ODOO-350449 (ie-dm7 #128809, проба p250: порция 8, повтор truncated, дефолт ВЫКЛ, без ожидания пакета): версия данных строк, не версия видов (signalChainsPrefetch SIGNAL_TIP_STABLE_VER_FLAG; только при включённой предзагрузке — без неё ключ прежний, кеш сбрасывается на любой load_data)
            return signalTip_cacheFor(this._sigTipSt || (this._sigTipSt = {}), toRaw(this.WIDGET?.record?._doc) || null, ver, this._sigTipCap || 300)   // IE 2026 11 03 / ODOO-350449 (ie-dm7 #128809, проба p250: порция 8, повтор truncated, дефолт ВЫКЛ, без ожидания пакета)
        },
        sigPrefetch_on() {
            if (sigPrefetch_isOff() || !sigPrefetch_flagOn((k, d) => this.store.setting(k, d))) return false
            const flex = this.flex
            if (!flex || flex.disposed || !this.isVisible || this.WIDGET?.close) return false
            if (this.cellView_active() !== SIGNALS_VIEW || !this.signalTip_isOn()) return false
            return signalsAgg_flagOn((k, d) => this.store.setting(k, d), TIP_INSTANT_FLAG)
        },
        sigPrefetch_state() {
            return this._sigPf || (this._sigPf = { queue: [], retry: [], groups: [], tries: new Map(), map: null, tried: new Set(), sig: '', inflight: null, t: null, idle: null, dead: false })   // IE 2026 11 03 / ODOO-350449 (ie-dm7 #128809, проба p250: порция 8, повтор truncated, дефолт ВЫКЛ, без ожидания пакета): retry — truncated {key, params}, groups — отложенные групповые
        },
        sigPrefetch_schedule(delay = PREFETCH_DEBOUNCE_MS) {
            const pf = this.sigPrefetch_state()
            if (pf.dead) return
            if (pf.t) { clearTimeout(pf.t); pf.t = null }
            if (pf.idle) { pf.idle(); pf.idle = null }
            if (!this.sigPrefetch_on()) return
            pf.t = setTimeout(() => {
                pf.t = null
                pf.idle = signalsAgg_idle(() => { pf.idle = null; try { this.sigPrefetch_run() } catch (e) { /* грид перестраивается */ } }, PREFETCH_IDLE_TIMEOUT_MS)
            }, delay)
        },
        // dead — грид закрывается: больше не планировать, ответ порции в полёте отбросить
        sigPrefetch_cancel(dead = false) {
            const pf = this._sigPf
            if (!pf) return
            if (pf.t) { clearTimeout(pf.t); pf.t = null }
            if (pf.idle) { pf.idle(); pf.idle = null }
            pf.queue = []; pf.retry = []; pf.groups = []; pf.sig = ''   // IE 2026 11 03 / ODOO-350449 (ie-dm7 #128809, проба p250: порция 8, повтор truncated, дефолт ВЫКЛ, без ожидания пакета): прокрутка / смена вида / закрытие — и повтор truncated, и отложенные групповые
            if (dead) pf.dead = true   // IE 2026 11 03 / ODOO-350449 (ie-dm7 #128809, проба p250: порция 8, повтор truncated, дефолт ВЫКЛ, без ожидания пакета): таймеров ожидания пакета подсказкой больше нет
        },
        sigPrefetch_storeBusy() {
            const st = this.store, W = this.WIDGET
            const ar = W?._activeRequest
            return { primary: st._primary_inflight || 0,   // IE 2026 11 03 / ODOO-350449 (Игорь: предзагрузка цепочек сигналов; BE ie-dm7 #1009; ревью: порция не в P0): свой запрос в P0 не считается — P0 > 0 только работа пользователя / виджетов
                dicts: Object.keys(st._itemsSource_active || {}).length + Object.keys(st._itemsSource_queue || {}).length,
                deferred: (st._deferred_actions || []).length, loading: !!W?.loading, activeXhr: !!(ar && ar.readyState !== 4) }
        },
        sigPrefetch_run() {
            const pf = this.sigPrefetch_state()
            if (pf.dead || !this.sigPrefetch_on()) return
            if (pf.inflight) {
                if (Date.now() - pf.inflight.at < PREFETCH_BUDGET_MS + 20000) return   // ответ порции сам запланирует следующую
                sigPrefetch_release(pf.inflight.map, pf.inflight.keys); pf.inflight.done = true; pf.inflight = null   // ответ потерян (204 / закрытие) — не держим грид
            }
            if (!sigPrefetch_mayStart(this.sigPrefetch_storeBusy())) { sigPrefetch_stat('busySkips'); this.sigPrefetch_schedule(PREFETCH_BUSY_RETRY_MS); return }   // IE 2026 11 03 / ODOO-350449 (Игорь: предзагрузка цепочек сигналов; BE ie-dm7 #1009; ревью: порция не в P0): работа пользователя (P0 / P1 / P2 / loading) — новую порцию не слать; текущую (если в полёте) не обрываем
            const flex = this.flex
            let vr = null
            try { vr = flex.viewRange } catch (e) { vr = null }
            if (!vr) return
            const cache = this.signalTip_cache()
            if (pf.map !== cache) { pf.map = cache; pf.queue = []; pf.retry = []; pf.groups = []; pf.tries = new Map(); pf.tried = new Set(); pf.sig = '' }   // другая версия данных — заново   // IE 2026 11 03 / ODOO-350449 (ie-dm7 #128809, проба p250: порция 8, повтор truncated, дефолт ВЫКЛ, без ожидания пакета)
            if (!sigPrefetch_pending(pf)) {   // IE 2026 11 03 / ODOO-350449 (ie-dm7 #128809, проба p250: порция 8, повтор truncated, дефолт ВЫКЛ, без ожидания пакета)
                const sig = [vr.topRow, vr.bottomRow, vr.leftCol, vr.rightCol, flex.rows.length, flex.columns.length].join(',')
                if (pf.sig === sig) return   // этот экран уже пройден
                pf.sig = sig
                pf.queue = sigPrefetch_rangeCells(vr, flex.rows.length)
                this._sigTipCap = sigPrefetch_cap(pf.queue.length)
            }
            const resolve = (row, col) => {
                const column = flex.columns[col]
                if (!column || column.isVisible === false) return null
                const c = this.signalTip_cellAt(row, col)
                if (!c) return null
                const params = this.cellPassport_storyParams(c.dataItem, c.column.binding, row)
                return params ? { key: signalTip_cacheKey(params), params } : null
            }
            const size = sigPrefetch_portionSize(pf.adapt, (k, d) => this.store.setting(k, d))   // IE 2026 11 04 / ODOO-350449 (webscm #129836: адаптивная порция предзагрузки по времени бэка на ячейку): оценка грида (pf.adapt), флаг выключен — PREFETCH_PORTION
            const portion = sigPrefetch_nextPortion(pf, size, resolve, cache, pf.tried)   // IE 2026 11 04 / ODOO-350449 (webscm #129836: адаптивная порция предзагрузки по времени бэка на ячейку) (было PREFETCH_PORTION)
            // IE 2026 11 03 / ODOO-350449 (ie-dm7 #128809, проба p250: порция 8, повтор truncated, дефолт ВЫКЛ, без ожидания пакета): сначала retry, затем очередь   // IE 2026 11 03 / ODOO-350449 (ie-dm7 #128926: порции 15, бюджет 5 с, группы только по Alt, лёгкий запрос): групповые — мимо пакета, только по Alt
            if (portion.length) this.sigPrefetch_send(pf, cache, portion)
        },
        sigPrefetch_send(pf, cache, portion) {
            const keys = portion.map(p => p.key)
            sigPrefetch_mark(cache, keys)
            const t0 = performance.now()
            const req = { keys, map: cache, at: Date.now(), done: false }
            pf.inflight = req
            sigPrefetch_stat('portions'); sigPrefetch_stat('cells', keys.length)
            const next = (delay) => { if (!pf.dead) this.sigPrefetch_schedule(delay) }
            const done = (answer, how) => {
                if (req.done) return
                req.done = true
                if (pf.inflight === req) pf.inflight = null
                if (how === 'abort') { sigPrefetch_release(cache, keys); sigPrefetch_stat('aborted'); pf.sig = ''; next(PREFETCH_BUSY_RETRY_MS); return }   // оборвал запрос пользователя (select / Save) — экран дошлётся
                if (how === 'error') {
                    sigPrefetch_release(cache, keys); sigPrefetch_stat('errors')
                    pf.errors = (pf.errors || 0) + 1
                    if (pf.errors >= PREFETCH_ERRORS_OFF) { sigPrefetch_off('error'); sigPrefetch_stat('off') } else { pf.sig = ''; next(PREFETCH_BUSY_RETRY_MS) }
                    return
                }
                if (pf.dead || this.signalTip_cache() !== cache) { sigPrefetch_release(cache, keys); sigPrefetch_stat('stale'); if (!pf.dead) next(0); return }   // ответ на устаревшую версию данных
                const r = sigPrefetch_merge(cache, keys, answer, (story) => this.signalTip_rowsOfRaw(story))
                if (r.off) { sigPrefetch_off(sigPrefetch_answerOf(answer) ? 'state off' : 'no method'); sigPrefetch_stat('off'); for (const k of keys) this.signalTip_refreshShown(k); return }
                pf.errors = 0
                const b = sigPrefetch_answerOf(answer)
                sigPrefetch_stat('chains', r.ok.length)
                sigPrefetch_stat('missing', Object.keys(b.missing || {}).length)
                sigPrefetch_stat('truncated', Array.isArray(b.truncated) ? b.truncated.length : 0)
                sigPrefetch_statPortion(performance.now() - t0, b.ms)
                const adaptOn = sigPrefetch_adaptiveOn((k, d) => this.store.setting(k, d))   // IE 2026 11 04 / ODOO-350449 (webscm #129836: адаптивная порция предзагрузки по времени бэка на ячейку)
                if (adaptOn) pf.adapt = sigPrefetch_adaptPortion(pf.adapt, { beMs: b.ms, sent: keys.length, truncated: Array.isArray(b.truncated) ? b.truncated.length : 0 }, PREFETCH_BUDGET_MS)   // IE 2026 11 04 / ODOO-350449 (webscm #129836: адаптивная порция предзагрузки по времени бэка на ячейку): оценка ms на ячейку — EMA по порциям этого грида
                sigPrefetch_statAdapt(adaptOn ? pf.adapt : { size: PREFETCH_PORTION })   // IE 2026 11 04 / ODOO-350449 (webscm #129836: адаптивная порция предзагрузки по времени бэка на ячейку)
                for (const k of r.dropped) pf.tried.add(k)   // missing / не пришли — одиночный путь, пакетом больше не шлём в этой версии
                if (r.retry && r.retry.length) {   // IE 2026 11 03 / ODOO-350449 (ie-dm7 #128809, проба p250: порция 8, повтор truncated, дефолт ВЫКЛ, без ожидания пакета): truncated — штатно (бюджет), {key, params} в начало pf.retry (pf.queue — координаты [row, col])
                    const rq = sigPrefetch_requeue(pf, portion, r.retry, pf.tries)
                    sigPrefetch_stat('retried', rq.back); sigPrefetch_stat('retryGaveUp', rq.gaveUp.length)
                    for (const k of rq.gaveUp) pf.tried.add(k)   // повторы исчерпаны — одиночный путь
                }
                for (const k of keys) this.signalTip_refreshShown(k)
                if (sigPrefetch_pending(pf)) next(0)   // IE 2026 11 03 / ODOO-350449 (ie-dm7 #128809, проба p250: порция 8, повтор truncated, дефолт ВЫКЛ, без ожидания пакета)
            }
            try {
                this.store.executeWidgetMethod({ WIDGET: this.WIDGET }, { command: 'executeWidgetMethod', method: SIGNAL_CHAINS_METHOD,
                    params: { cells: portion.map(p => sigPrefetch_cellOf(p.key, p.params)), limit: PREFETCH_PORTION, budget_ms: PREFETCH_BUDGET_MS },
                    record_sendToBackend_exclude: ['_doc'], widget_sendToBackend_exclude: ['view'], no_del_last_backend_action: true, quiet_errors: true,
                    background: true,   // IE 2026 11 03 / ODOO-350449 (Игорь: предзагрузка цепочек сигналов; BE ie-dm7 #1009; ревью: порция не в P0): не P0 (_primary_inflight) и не _activeRequest (mainStore.executeWidgetMethod, request_isBackground)
                    ...readLight_fields(SIGNAL_CHAINS_METHOD, this.WIDGET.record, (k, d) => this.store.setting(k, d)),   // IE 2026 11 03 / ODOO-350449 (ie-dm7 #128926: порции 15, бюджет 5 с, группы только по Alt, лёгкий запрос): запись без раскладки / колонок / оформления, без fast_entry (utils/readMethodLight.js; fe.data.readMethodsLight)
                    _response_callback: (answer) => {
                        if (answer) { answer.command = ''; delete answer.updates }   // ответ нужен только подсказке — не updateDoc записи виджета (как у одиночного cell_passport)
                        done(answer, 'ok')
                    },
                    _onResponse: (answer) => { if (answer === null) done(null, 'error') },
                    _onAbort: () => done(null, 'abort') })
            } catch (e) { done(null, 'error') }
        },
        // запись кеша подсказки над ячейкой key: попадание из предзагрузки / порция в полёте — одиночный вызов сразу (без ожидания пакета; ответ пакета
        // одиночный не перетирает — sigPrefetch_merge) / промах; → запись, с которой подсказка продолжает (null — одиночный вызов)   // IE 2026 11 03 / ODOO-350449 (ie-dm7 #128809, проба p250: порция 8, повтор truncated, дефолт ВЫКЛ, без ожидания пакета)
        sigPrefetch_tipHit(key, params, cache, hit, opts = {}) {
            const once = (k) => { const el = opts && opts.el; if (!el) return; if (el.__sigPfStat === k + key) return; el.__sigPfStat = k + key; sigPrefetch_stat(k) }
            if (hit && hit.state === 'ok' && hit.pf) { once('tipHits'); return hit }
            if (sigPrefetch_inBatch(hit)) { if (cache.get(key) === hit) cache.delete(key); once('tipInflight'); return null }   // IE 2026 11 03 / ODOO-350449 (ie-dm7 #128809, проба p250: порция 8, повтор truncated, дефолт ВЫКЛ, без ожидания пакета)
            if (!hit && !sigPrefetch_isOff() && this._sigPf) once('tipMisses')
            return hit
        },
        sigPie_schedule() {
            clearTimeout(this._sigPieT)
            if (!this.sigPie_on()) { if (this.sigPie) this.sigPie = null; return }
            const run = () => { this._sigPieIdle = null; try { this.sigPie_compute() } catch (e) { this.sigPie = null } }
            if (this._sigPieIdle) { this._sigPieIdle(); this._sigPieIdle = null }
            this._sigPieT = setTimeout(() => { this._sigPieT = null; if (this.sigPie_cachedOn()) this._sigPieIdle = signalsAgg_idle(run, 500); else run() }, 300)   // IE 2026 11 03 / ODOO-350449 (webscm #128539: круг сигналов — кеш по версии данных, расчёт в простое)
        },
        sigPie_compute() {
            const flex = this.flex
            if (!flex || flex.disposed || !this.sigPie_modeOn()) { if (this.sigPie) this.sigPie = null; return }
            const cols = []
            for (const col of flex.columns) if (col && col.isVisible !== false && cellPie_bindingOf(col.binding)) cols.push(col)
            if (this.sigPie_cachedOn()) { this.sigPie_computeCached(flex, cols); return }   // IE 2026 11 03 / ODOO-350449 (webscm #128539: круг сигналов — кеш по версии данных, расчёт в простое)
            const lists = []
            for (const r of flex.rows) {
                const di = r?.dataItem
                if (!di || typeof di !== 'object' || r.isVisible === false) continue
                for (const col of cols) {
                    const res = this.cellView_of(di, col.binding, r)
                    if (!res || !Array.isArray(res.signalKinds) || !res.signalKinds.length) continue
                    let out = null
                    try { out = this.cellView_build(res, di, col.binding, col) } catch (e) { out = null }
                    lists.push(Array.isArray(out?.layers) && out.layers.length ? out.layers.map(l => l.key) : res.signalKinds)
                }
            }
            const m = signalsAgg_model(signalsAgg_count(lists), t)
            const w = window.__sigPie || (window.__sigPie = { calc: 0, changes: 0 })
            w.calc++
            if ((m?.sig || '') !== (this.sigPie?.sig || '') || (m?.cells || 0) !== (this.sigPie?.cells || 0)) { this.sigPie = m ? markRaw(m) : null; w.changes++ }
        },
        // IE 2026 11 03 / ODOO-350449 (webscm #128539: круг сигналов — кеш по версии данных, расчёт в простое): охват прежний (развёрнутые строки × видимые колонки периода),
        // отпечаток версии и кеш видов ячейки — utils/signalsAggregate.signalsAgg_scan; виды ячейки — те же cellView_of + cellView_build. Выключатель fe.ux.signalsPieCached
        sigPie_cachedOn() { return signalsAgg_flagOn((k, d) => this.store.setting(k, d), SIGNALS_PIE_CACHED_FLAG) },
        sigPie_computeCached(flex, cols0) {
            try { if (cellRing_flagOn((key, d) => this.fmtSetting(key, d))) this.cellView_scaleMap() } catch (e) { /* шкала не готова */ }   // шкала (over-100) — до base, иначе её штамп сменится внутри прохода
            const cols = []
            for (const col of cols0) { const b = cellPie_bindingOf(col.binding); if (b) cols.push({ binding: col.binding, date: b.date, measure: b.measure, col }) }
            const ui = this.cellShape_ui, a = Array.isArray(ui) ? ui.find(x => x && x.active) : null
            const base = [this.cellView_active(), a?.key || '', this._cellViewVer || 0, this._cellRingScale?.stamp || 0, cellRing_flagOn((key, d) => this.fmtSetting(key, d)) ? 1 : 0, cols.map(c => c.binding).join(',')].join('|')
            const st = this._sigPieState || (this._sigPieState = {})
            const t0 = performance.now()
            const r = signalsAgg_scan(st, flex.rows, cols, base, (di, c, row) => {
                const res = this.cellView_of(di, c.binding, row)
                if (!res || !Array.isArray(res.signalKinds) || !res.signalKinds.length) return null
                let out = null
                try { out = this.cellView_build(res, di, c.binding, c.col) } catch (e) { out = null }
                return Array.isArray(out?.layers) && out.layers.length ? out.layers.map(l => l.key) : res.signalKinds
            })
            const w = window.__sigPie || (window.__sigPie = { calc: 0, changes: 0 })
            w.calc++; w.hits = (w.hits || 0) + (r.hit ? 1 : 0); w.misses = (w.misses || 0) + r.misses; w.lastMs = Math.round((performance.now() - t0) * 10) / 10
            const m = signalsAgg_model(r.agg, t)   // и при совпавшем отпечатке: круг мог быть снят сменой вида — модель из прежнего агрегата
            if ((m?.sig || '') !== (this.sigPie?.sig || '') || (m?.cells || 0) !== (this.sigPie?.cells || 0)) { this.sigPie = m ? markRaw(m) : null; w.changes++ }
        },
        sigPie_tip() {
            const fmt = (n) => { try { return wjcCore.Globalize.format(Number(n), 'n0') } catch (e) { return String(n) } }
            return signalsAgg_tipHtml(this.sigPie, t, fmt)
        },
        // клик по диаграмме — как по самой кнопке «Сигнали»
        sigPie_click(e) {
            const btn = e?.currentTarget?.parentElement?.querySelector?.('.commandPanel-buttons, button')
            if (btn) btn.click()
        },
        // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T9b): подсказка ячейки-даты без круга — вид ждёт данных бэка («Computing data for the view …») или режиму есть что сказать
        // (delta_30d: «Snapshots not taken yet» при stats.delta_30d = 'no snapshot'); не ячейка-дата — ''
        cellView_emptyTipAt(view, dataItem, column) {
            const b = cellPie_bindingOf(column?.binding)
            if (!b || !dataItem || typeof dataItem !== 'object') return ''
            const e = cellView_get(view)
            const stats = cellView_statsOf(toRaw(this.WIDGET?.record?._doc))
            let ready = true
            if (e?.needsData) {
                if (this.WIDGET?._cellViewWait === e.key) ready = false
                else if (stats.length && typeof this.store?.cellView_dataReady === 'function') { try { ready = this.store.cellView_dataReady(this.WIDGET, e.key) !== false } catch (err) { ready = true } }   // старый бэк (нет cell_views_stats) — отложенного расчёта нет, «считаем» не пишем
            }
            const note = cellView_emptyNoteAt(view, { t, ready, stats })
            if (!note) return ''
            const attr_col = this.attr_by_binding[column.binding]
            return cellView_emptyTipHtml(note, { head: [b.date, attr_col?.title || column.header].filter(Boolean).join(' · ') })
        },
        // прежние имена вида «status_pie» — тонкие обёртки (совместимость: mainStore.cellView_refreshGrids, внешние вызовы)
        cellPie_on() { return this.cellView_active() === STATUS_ZONES_VIEW },
        // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p191 — опції виглядів однією склеєною групою кнопок, як «Міра» теплокарти): классы склеенной группы кнопки панели (utils/cellViewState.optionSeg_classes); выключатель fe.ux.optionGroupSegments
        optionSeg_cls(index) {
            try {
                if (!optionSeg_on((k, d) => this.store.setting(k, d))) return null
                return optionSeg_classes(this.commandPanel, index, this.commandPanelMaxVisible)
            } catch (e) { return null }
        },
        cellPie_refresh() { this.cellView_refresh() },
        // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p183: перемикач «Рядки: Компактні / Високі» у таблиці REPORT2, як у Heatmap (grid))
        // Высота строк REPORT2 (utils/gridRows.js): переключатель «Рядки» — только у грида с колонками-датами и кнопками видов ячеек в панели виджета, флаг fe.ux.gridRowsSwitch (ВЫКЛ —
        // переключателя нет, высота штатная). Режим — WIDGET._gridRows (память виджета, общий для его гридов), ручной выбор — WIDGET._gridRowsTouched, последний виденный вид — WIDGET._gridRowsView.
        // Высота — rows.defaultSize (кеш formatItem не задет: ячейки перерисовывает invalidate), центрирование текста — CSS по классу контейнера grid-rows-tall
        gridRows_avail() {
            const W = this.WIDGET
            if (!W || !gridRows_flagOn((k, d) => this.fmtSetting(k, d))) return false
            if (!Object.keys(this.attr_by_binding || {}).some(k => cellPie_bindingOf(k))) return false
            try { return (this.store.optionGroup_panelButtons?.(W) || []).some(b => cellViewBtn_is(b) || cellPie_isViewButton(b)) } catch (e) { return false }
        },
        gridRows_mode() {
            return this.gridRows_avail() ? gridRows_norm(this.WIDGET?._gridRows) : 'compact'
        },
        // смена активного вида ячеек пользователем (WIDGET._cellViewUserSeq, mainStore.cellView_toggle): вид с кругами один раз включает «Високі», если переключатель не трогали; «Числа» — без изменений.
        // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p183: перемикач «Рядки: Компактні / Високі» у таблиці REPORT2, як у Heatmap (grid)): вид по умолчанию при открытии и перестроение грида высоту не меняют (только запоминается вид)
        gridRows_sync() {
            const W = this.WIDGET
            if (!W || !this.gridRows_avail()) return
            let init = null
            try { init = gridRows_initial(W._gridRows, W._gridRowsTouched, this.store.optionGroup_panelButtons?.(W) || [], (k, d) => this.fmtSetting(k, d)) } catch (e) { init = null }   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p201 — «Рядки» натиснута типово: високі рядки в звіті з видами комірок)
            if (init) W._gridRows = init   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p201 — «Рядки» натиснута типово: високі рядки в звіті з видами комірок): первое открытие — «Високі» по умолчанию отчёта
            const v = this.cellView_active()
            const st = gridRows_syncState({ view: W._gridRowsView, rows: W._gridRows, touched: W._gridRowsTouched, seq: W._gridRowsSeq }, v, W._cellViewUserSeq)
            if (W._gridRowsView !== st.view) W._gridRowsView = st.view
            if (W._gridRowsSeq !== st.seq) W._gridRowsSeq = st.seq
            if (gridRows_norm(W._gridRows) !== st.rows) W._gridRows = st.rows
        },
        // высота строк по режиму: штатная (последнее значение, поставленное не нами) ↔ GRID_TALL_ROW_H; inLoad — внутри load_data (присвоение без deferUpdate и прокрутки)
        gridRows_apply(flex, inLoad = false) {
            const rows = flex && flex.rows
            if (!rows) return
            const cur = rows.defaultSize
            if (!flex.__gridRowsSetH || cur !== flex.__gridRowsSetH) { flex.__gridRowsH0 = cur; flex.__gridRowsSetH = 0 }
            const want = gridRows_height(this.gridRows_mode(), flex.__gridRowsH0)
            if (!want || want === cur) return
            flex.__gridRowsSetH = want === flex.__gridRowsH0 ? 0 : want
            if (inLoad) { rows.defaultSize = want; this.gridRows_rowHeights(flex, cur, want); return }   // IE 2026 11 02 / ODOO-350449 (сводна перевірка main на dev02: p199 — якір при scroll 0, повернення висоти рядків, перемалювання колонок «Всього», Alt-підказка «Рядки»)
            const snap = gridRows_anchorFlagOn((k, d) => this.fmtSetting(k, d)) ? this.gridRows_anchorSnap(flex) : null   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p197 перемикач «Рядки» — зберегти виділення і якір прокрутки на центрі виділеної клітинки)
            const sp = flex.scrollPosition
            flex.deferUpdate(() => { rows.defaultSize = want; this.gridRows_rowHeights(flex, cur, want) })   // IE 2026 11 02 / ODOO-350449 (сводна перевірка main на dev02: p199 — якір при scroll 0, повернення висоти рядків, перемалювання колонок «Всього», Alt-підказка «Рядки»): свои высоты начал секций (штатная + зазор) — от новой штатной
            if (snap) { this.gridRows_anchorRestore(flex, snap); return }   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p197 перемикач «Рядки» — зберегти виділення і якір прокрутки на центрі виділеної клітинки)
            if (sp && sp.y) flex.scrollPosition = { x: sp.x, y: gridRows_scrollY(sp.y, cur, want) }
        },
        // IE 2026 11 02 / ODOO-350449 (сводна перевірка main на dev02: p199 — якір при scroll 0, повернення висоти рядків, перемалювання колонок «Всього», Alt-підказка «Рядки»)
        // свои высоты строк (row.height), выведенные из штатной (начало секции: штатная + зазор 0 / 10 — formatItem / autoSizeRows), — от новой штатной (utils/gridRows.gridRows_rowHeight);
        // высота строки лэйаута (_DLRow.height) и прочие — как есть. Раньше они оставались прежними до отрисовки строки: 27 → 44 у строк, отрисованных в «Високі», после возврата
        // к «Компактні» оставались 44, пока строку не перерисуют (строки 266 / 345 баланса); видимые — менялись уже после расчёта якоря (сдвиг ячейки)
        gridRows_rowHeights(flex, hOld, hNew) {
            const rows = flex && flex.rows
            if (!rows || !(hOld > 0) || !(hNew > 0) || hOld === hNew) return 0
            let n = 0
            for (let i = 0; i < rows.length; i++) {
                const r = rows[i]
                if (r.height == null) continue
                const h = gridRows_rowHeight(r.height, hOld, hNew, autoSizeRows_rowH(r.dataItem))
                if (h != null && h !== r.height) { r.height = h; n++ }
            }
            return n
        },
        // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p197 перемикач «Рядки» — зберегти виділення і якір прокрутки на центрі виділеної клітинки)
        // снимок до смены высоты: выделение (строки — по dataItem, колонки — по binding) и якорь прокрутки (utils/gridRows.gridRows_anchorPick: видимая выделенная ячейка — центр её строки, иначе верх первой видимой строки)
        gridRows_anchorSnap(flex) {
            try {
                const rows = flex.rows, cols = flex.columns, sel = flex.selection, n = rows.length
                const selOk = !!sel && sel.row >= 0 && sel.row < n && sel.col >= 0 && sel.col < cols.length
                const pick = gridRows_anchorPick(selOk ? { row: sel.row } : null, flex.viewRange)
                if (!pick || pick.row >= n) return null
                const a = rows[pick.row]
                const r2 = selOk ? Math.min(Math.max(sel.row2, 0), n - 1) : -1, c2 = selOk ? Math.min(Math.max(sel.col2, 0), cols.length - 1) : -1
                return {
                    sp: flex.scrollPosition, row: pick.row, frac: pick.frac, pos: a.pos, size: a.renderSize, item: a.dataItem, hdr: flex.columnHeaders?.height || 0,   // IE 2026 11 02 / ODOO-350449 (сводна перевірка main на dev02: p199 — якір при scroll 0, повернення висоти рядків, перемалювання колонок «Всього», Alt-підказка «Рядки»)
                    sel: selOk ? { row: sel.row, col: sel.col, row2: r2, col2: c2, item: rows[sel.row].dataItem, item2: rows[r2].dataItem, b: cols[sel.col].binding, b2: cols[c2].binding } : null,
                }
            } catch (e) { return null }
        },
        // после смены высоты: раскладка сразу (иначе браузер обрежет scrollTop по старой высоте), выделение — то же (по dataItem / binding), прокрутка — якорь на той же экранной высоте; горизонталь — прежняя
        gridRows_anchorRestore(flex, snap) {
            try {
                flex.refresh(true)
                const rows = flex.rows, cols = flex.columns
                const rowOf = (item, i) => { if (item == null || rows[i]?.dataItem === item) return i; for (let k = 0; k < rows.length; k++) if (rows[k].dataItem === item) return k; return i }
                const colOf = (b, i) => { if (!b || cols[i]?.binding === b) return i; const c = cols.getColumn(b); return c ? c.index : i }
                const q = snap.sel
                if (q) {
                    const r = rowOf(q.item, q.row), r2 = rowOf(q.item2, q.row2), c = colOf(q.b, q.col), c2 = colOf(q.b2, q.col2), s = flex.selection
                    if (!s || s.row !== r || s.col !== c || s.row2 !== r2 || s.col2 !== c2) flex.select(new wjGrid.CellRange(r, c, r2, c2), false)
                }
                const set = () => {
                    const a = rows[rowOf(snap.item, snap.row)]
                    if (!a) return
                    const max = Math.max(0, (flex.scrollSize?.height || 0) - (flex.clientSize?.height || 0))
                    const y = gridRows_anchorScrollY(snap.sp.y, snap, { pos: a.pos, size: a.renderSize, hdr: flex.columnHeaders?.height || 0 }, snap.frac, max)   // IE 2026 11 02 / ODOO-350449 (сводна перевірка main на dev02: p199 — якір при scroll 0, повернення висоти рядків, перемалювання колонок «Всього», Alt-підказка «Рядки»)
                    const cur = flex.scrollPosition
                    if (Math.abs(cur.y - y) > 0.5 || Math.abs(cur.x - snap.sp.x) > 0.5) flex.scrollPosition = { x: snap.sp.x, y }
                }
                set()
                // IE 2026 11 02 / ODOO-350449 (сводна перевірка main на dev02: p199 — якір при scroll 0, повернення висоти рядків, перемалювання колонок «Всього», Alt-підказка «Рядки»): прокрутка от верха (y = 0) показывает sticky-полосу группы (строка шапки, защёлка set_stickyRows — через 210 мс): шапка растёт на строку, панель ячеек
                // уезжает вниз — ячейка сдвигалась на 17,5–18,5 px. Полосу считаем сразу (тот же расчёт, что по таймеру) и ставим прокрутку ещё раз с новой высотой шапки
                const hdr0 = flex.columnHeaders?.height || 0
                try { if (typeof this.set_stickyRows_afterTimeout === 'function') this.set_stickyRows_afterTimeout() } catch (e) { /* полосы нет */ }
                if ((flex.columnHeaders?.height || 0) !== hdr0) { try { flex.refresh(true) } catch (e) { /* грид пересоздан */ } set() }
                requestAnimationFrame(() => { try { if (flex.hostElement) set() } catch (e) { /* грид пересоздан */ } })   // после invalidate из cellView_refresh — сверить ещё раз
            } catch (e) { /* грид пересоздаётся */ }
        },
        // клик по «Компактні / Високі»: ручной выбор (виды ячеек его больше не меняют) — все гриды виджета
        gridRows_click(key) {
            const W = this.WIDGET
            if (!W) return
            W._gridRowsTouched = true
            const next = gridRows_norm(key)
            if (W._gridRows === next) return
            W._gridRows = next
            const grids = new Set([this, ...Object.values(W.attrs_vueObj || {})])
            for (const g of grids) {
                if (g && g.flex && typeof g.gridRows_apply === 'function') { try { g.cellView_refresh() } catch (e) { /* грид пересоздаётся */ } }
            }
        },
        cellPie_of(dataItem, binding) { return this.cellPie_on() ? this.cellView_of(dataItem, binding) : null },
        cellPie_apply(e_cell, dataItem, col, isXlsxExport) { this.cellView_apply(e_cell, dataItem, col, isXlsxExport) },
        cellPie_tipAt(row, col) { return this.cellPie_on() ? this.cellView_tipAt(row, col) : '' },
        set_commandPanel() {
            let eval_params = {}
            eval_params['attr'] = this.attr
            try { this.store.cellView_syncButtons?.(this.WIDGET) } catch (e) { /* без вида ячеек */ }   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: кругові діаграми за статусами у клітинках REPORT2, опції зрізу і їх розміщення): кнопки вида — по состоянию виджета

            let commandPanel = []

            // IE 2026 09 23 / ODOO-341407: i18n (title / tooltip кнопок командной панели и меню таблицы — до конца сборки actionMenu)
            if (this.attr['custom-isReadOnly']) {
                const command_disableReadOnly = { name:'button-disableReadOnly', 'binding':`doc.viewParams.${this.attr.name}.isReadOnly`, checkValue:false, default:true, 'title': t('Custom (disable read only)'),command:'set_viewParam', 'cssClass':'pi pi-user-edit p-button-white p-button-text0 mr-1' }
                // const command_disableReadOnly = { name:'button-disableReadOnly', 'viewParam':`${this.attr.name}.isReadOnly`, checkValue:false, default:true, 'title': 'Custom (disable read only)',command:'set_viewParam', 'cssClass':'pi pi-user-edit p-button-white p-button-text0 mr-1' }
                commandPanel.push(command_disableReadOnly)
                this.store.set_commandActive(this, command_disableReadOnly)
            }

            // лёгкий/полный вид грида полей (lightView) — тумблер с постоянной
            // иконкой; active (вжата) — полный вид (все колонки), отжата — лёгкий
            if (this.lightView_enabled()) {
                const light = this.lightView_on()
                commandPanel.push({ name:'button-lightView_toggle', autoGeneratedButton:true, 'attr_type':'AttrButton',
                    source_name:this.attr.name, 'binding':this.attr.binding,
                    'tooltip': light ? t('Full view (all columns)') : t('Light view (Title only)'),
                    command:'executeVueObjMethod', 'method':'lightView_toggle', active:!light,
                    'cssClass': 'pi pi-table p-button-white p-button-text0' , uiHelp: 'grid.cmd.lightView', uiHelpState: () => (light ? 'light' : 'full') })
            }

            // fieldsMapping: Update — пересчитать и применить значения тем же алгоритмом,
            // что при открытии виджета (включая строки с флагом On START);
            // Test — то же, но относительно введённой в диалоге «текущей даты»
            if (this.attr.name === 'fieldsMapping') {
                // минимум 2 фикс-колонки (Field + Value): сохранённое состояние виджета
                // может нести старый view с frozenColumns=1 поверх серверного дефолта
                if ((this.attr.frozenColumns || 0) < 2) {
                    this.attr.frozenColumns = 2
                    if (this.flex) this.flex.frozenColumns = 2
                }
                commandPanel.push({ name:'button-updateFieldsMapping', autoGeneratedButton:true, 'attr_type':'AttrButton',
                    source_name:this.attr.name, 'binding':this.attr.binding,
                    'title': t('Update'), 'showCommandTitle':true,
                    'tooltip': t('Update: evaluate and apply the values with the same algorithm as on widget open, including rows flagged "On START"'),
                    command:'executeVueObjMethod', 'method':'updateFieldsMapping_Click',
                    'cssClass': 'pi pi-sync p-button-white p-button-text0' , uiHelp: 'grid.cmd.fieldsMapping', uiHelpState: 'update' })   // IE 2026 09 13 / ODOO-… (иконки)
                commandPanel.push({ name:'button-testFieldsMapping', autoGeneratedButton:true, 'attr_type':'AttrButton',
                    source_name:this.attr.name, 'binding':this.attr.binding,
                    'title': t('Test'), 'showCommandTitle':true,
                    'tooltip': t('Test: same as Update, but relative to a "current date" you enter in the dialog (rows flagged "On START" are evaluated too)'),
                    command:'executeVueObjMethod', 'method':'testFieldsMapping_Click',
                    'cssClass': 'pi pi-calendar-clock p-button-white p-button-text0' , uiHelp: 'grid.cmd.fieldsMapping', uiHelpState: 'test' })
            }

            // сводная таблица (agg_sources): тумблер "All" — строки всех
            // источников, отжат (по умолчанию) — только основного; badge —
            // число строк доп. источников, добавляемых нажатием
            if (this.aggAll_isSummary()) {
                commandPanel.push({ name:'button-aggAll_showAll', autoGeneratedButton:true, 'attr_type':'AttrButton',
                    source_name:this.attr.name, 'binding':this.attr.binding,
                    'title': t('All'), 'showCommandTitle':true, countItems: this.aggAll_extraCount(),
                    'tooltip': this.aggAll_showAll ? t('Main source rows only') : t('Rows from all sources'),
                    command:'executeVueObjMethod', 'method':'aggAll_showAll_toggle', active:this.aggAll_showAll,
                    'cssClass': 'p-button-white p-button-text0' , uiHelp: 'grid.cmd.aggAll' })
            }

            // IE 2026 09 19 / ODOO-5800 (заказ Игоря «глобальный чипс-метрик»: постановка из виджетов): отчёт метрик (params.selector_map, строки несут grade / metric / reason) —
            // «Set metrics chip»: метрики выделенных строк становятся отбором глобального чипса метрик стола
            if (this.metricSet_offered()) {
                commandPanel.push({ name:'button-metricChipSet', autoGeneratedButton:true, 'attr_type':'AttrButton',
                    source_name:this.attr.name, 'binding':this.attr.binding,
                    'tooltip': t('Set metrics chip: the workspace metrics chip takes the metrics of the selected rows (Shift / Ctrl + click adds them to the current chip)'),
                    command:'executeVueObjMethod', 'method':'metricSet_click',
                    'cssClass': 'pi pi-bullseye p-button-white p-button-text0' , uiHelp: 'grid.cmd.metricChipSet' })
            }

            // IE 2026 08 18 / ODOO-5512 (заказ Игоря): снять ручные корректировки
            // _cells (value/isNull) — кнопка командной панели ПЕРЕД undo (19.08:
            // место по заказу Игоря). 19.08 (заказ Игоря): действует на ВЫДЕЛЕННЫЕ
            // ячейки (как команда тулбара ячейки onClearCells), одной группой undo/
            // redo, с пересчётом py-кода; видимость — по опции use_cells (Settings →
            // Corrections → Recalculation). isReadOnly грида не гейт: в M03 грид
            // read-only, правятся только editable-ячейки; права проверит Save
            const clearAllBtn = ((this.attr.use_cells || this.get_viewParam('use_cells')) && !this.attr.isPrintTemplate)
                ? { name:'button-clearCells', autoGeneratedButton:true, 'attr_type':'AttrButton',
                    source_name:this.attr.name, 'binding':this.attr.binding,
                    'tooltip': t('Clear manual corrections in the selected cells and recalculate (Ctrl+Z to undo; save the report to apply)'),
                    command:'executeVueObjMethod', 'method':'onClearCells',
                    'cssClass': 'pi pi-eraser p-button-white p-button-text0' , uiHelp: 'grid.cmd.clearCells' }
                : null

            const copyCellFilters = true
            // Clone создаёт строку — когда строки менять нельзя (isReadOnly/readOnlyRows),
            // в меню Copy остаются только копирующие команды
            const canModifyRows = !this.get_viewParam('isReadOnly') && !this.attr.readOnlyRows
            const copyCommands = [
                {title:t('Copy'), attr_type:'AttrMenu', autoGeneratedButton:true, uiHelp: 'grid.cmd.copy', 'cssClass':'pi p-button-white pi-copy', attrs:[
                    ...(canModifyRows ? [
                        { name:'button-clone_Click', hotkey: `Shift Alt ↓`, autoGeneratedButton:true, 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'tooltip': t('Clone'),command:'executeVueObjMethod', 'method':'clone_Click', 'cssClass':'pi pi-clone p-button-white p-button-text0' },
                        { autoGeneratedButton:true},
                    ] : []),
                    { name:'button-copyRows_Click', hotkey: 'Alt C', 'attr_type':'AttrButton', 'cssClass':'pi p-button-white pi-copy', 'title': t('Copy rows'), 'command': 'copyPaste', 'method':'copyItems', source_name:this.attr.name, 'binding':this.attr.binding },
                    { name:'button-copyRows_Click', hotkey: 'Shift Alt C', 'attr_type':'AttrButton', 'cssClass':'pi p-button-white pi-copy', 'title': t('... cell'), 'command': 'copyPaste', 'method':'copyItems', method2:'copyCell', source_name:this.attr.name, 'binding':this.attr.binding },
                    ...(copyCellFilters ? [{ name:'button-copyRows_Click', hotkey: 'Ctrl Alt C', 'attr_type':'AttrButton', 'cssClass':'pi p-button-white pi-copy', 'title': t('... cell filters'), 'command': 'copyPaste', 'method':'copyItems', method2:'copyCellFilters', source_name:this.attr.name, 'binding':this.attr.binding }] : []),
                    ...(copyCellFilters ? [{ name:'button-copyRows_Click', hotkey: 'Shift Ctrl Alt C', 'attr_type':'AttrButton', 'cssClass':'pi p-button-white pi-copy', 'title': t('... cell&widget filters'), 'command': 'copyPaste', 'method':'copyItems', method2:'copyCellAndWidgetsFilters', source_name:this.attr.name, 'binding':this.attr.binding }] : []),
                    ...(copyCellFilters ? [{ name:'button-copyRows_Click', hotkey: '', 'attr_type':'AttrButton', 'cssClass':'pi p-button-white pi-copy', 'title': t('... values'), 'command': 'copyPaste', 'method':'copyItems', method2:'copyCellValues', source_name:this.attr.name, 'binding':this.attr.binding }] : []),
                    { autoGeneratedButton:true},
                    ...(copyCellFilters ? [{ name:'button-copyRows_Click', 'attr_type':'AttrButton', 'cssClass':'pi p-button-white pi-copy', 'title': t('Deep copy'), 'command': 'copyPaste', 'method':'copyItems', method2:'deepCopy', source_name:this.attr.name, 'binding':this.attr.binding }] : []),
                ]},
            ]

            // вкладка-реестр доступна: режим привязки на узле грида + реестр у владельца
            // (ит.4 §2: при явном выборе корня ctx == null, если корень не разрешается)
            const show_itemsSourcesView_button = !this.itemsSourcesView_grid()
                && !!this.itemsSourcesView_mode(this.attr.use_itemsSourcesView)
                && !!this.store.get_itemsSourcesView_ctx(this)

            if (!this.get_viewParam('isReadOnly')) {
                if (!this.attr.readOnlyRows) {
                    commandPanel = [ ...commandPanel,
                        ...(show_itemsSourcesView_button ? [{ name:'button-itemsSourcesView', autoGeneratedButton:true, 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'tooltip': t('Source fields'), command:'executeVueObjMethod', 'method':'openItemsSourcesView_Click', 'cssClass':'pi pi-list-check p-button-white p-button-text0' , uiHelp: 'grid.cmd.sourceFields' }] : []),
                        ...(this.attr.allowAddNew === false ? [] : [{ name:'button-new_Click', hotkey: `Alt +`, autoGeneratedButton:true, 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'tooltip': t('Add {name}', { name: this.attr.binding }),command:'executeVueObjMethod', 'method':'new_Click', 'cssClass':'pi pi-plus p-button-white p-button-text0' , uiHelp: 'grid.cmd.add' }]),

                        ...copyCommands,
                        { name:'button-insert_Click', hotkey: `Alt V`, autoGeneratedButton:true, 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'tooltip':t('Insert copied rows'),'command':'executeVueObjMethod', 'method':'pastingItems', 'cssClass':'pi pi-clipboard p-button-white p-button-text0' , uiHelp: 'grid.cmd.insert' },

                        { name:'button-deleteRow_Click', hotkey: `Alt -`, autoGeneratedButton:true, 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'tooltip': t('Delete rows'),command:'executeVueObjMethod', 'method':'delete_Click', visible:!this.attr.isRecords, 'cssClass':'pi pi-minus p-button-white p-button-text0' , uiHelp: 'grid.cmd.delete', uiHelpState: 'rows' },
                        { name:'button-deleteRecord_Click', autoGeneratedButton:true, 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'tooltip': t('Delete records'),command:'executeVueObjMethod', 'method':'delete_Click', visible:!!this.attr.isRecords, 'cssClass':'pi pi-trash p-button-white p-button-text0' , uiHelp: 'grid.cmd.delete', uiHelpState: 'records' },
                        
                        { name:'button-archive_Click', autoGeneratedButton:true, 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'tooltip': t('Archive/Restore rows'),command:'executeVueObjMethod', 'method':'delete_Click', 'archived':true, visible:!!this.attr.visibleBtnArchived, 'cssClass':'pi pi-box p-button-white p-button-text0' , uiHelp: 'grid.cmd.delete', uiHelpState: 'archive' },
                        // { name:'button-restore_Click', autoGeneratedButton:true, 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'tooltip': 'Restore rows',command:'executeVueObjMethod', 'method':'delete_Click', 'archived':true, visible:!!this.attr.visibleBtnArchived && this.WIDGET.record.doc.params?.showArchived, 'cssClass':'pi pi-box crossing-out p-button-white p-button-text0' },
                        
                        { autoGeneratedButton:true},
                        { name:'button-up_Click', hotkey: 'Alt ↑', autoGeneratedButton:true, 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'tooltip': t('Move up'),command:'executeVueObjMethod', 'method':'up_Click', 'cssClass':'pi pi-angle-up p-button-white p-button-text0' , uiHelp: 'grid.cmd.move', uiHelpState: 'up' },
                        { name:'button-down_Click', hotkey: 'Alt ↓', autoGeneratedButton:true, 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'tooltip': t('Move down'),command:'executeVueObjMethod', 'method':'down_Click', 'cssClass':'pi pi-angle-down p-button-white p-button-text0' , uiHelp: 'grid.cmd.move', uiHelpState: 'down' },
                    ]
                    if (this.attr.childItemsPath) {
                        commandPanel = [ ...commandPanel,
                            { name:'button-left_tab_Click', hotkey: 'Alt ←', autoGeneratedButton:true, 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'tooltip': t('Move left'),command:'executeVueObjMethod', 'method':'left_tab_Click', 'cssClass':'pi pi-angle-double-left p-button-white p-button-text0' , uiHelp: 'grid.cmd.move', uiHelpState: 'left' },
                            { name:'button-right_tab_Click', hotkey: 'Alt →', autoGeneratedButton:true, 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'tooltip': t('Move right'),command:'executeVueObjMethod', 'method':'right_tab_Click', 'cssClass':'pi pi-angle-double-right p-button-white p-button-text0' , uiHelp: 'grid.cmd.move', uiHelpState: 'right' },
                        ]
                    }
                    if (this.attr.use_commandPanelCell) {
                        commandPanel = [ ...commandPanel,
                            ...(commandPanel.length ? [{ autoGeneratedButton:true}] : []),
                            { name:'button-merge_Click', autoGeneratedButton:true, 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'tooltip': t('Merge'),command:'executeVueObjMethod', 'method':'merge_Click', 'cssClass':'pi pi-expand p-button-white p-button-text0' , uiHelp: 'grid.cmd.style' },
                            // палитра стилей ячейки — то же меню, что над списком полей
                            // (пишет в _cells.col_N.fields[0].style выделенных ячеек)
                            { name:'button-cellStyle-menu', title:t('Style'), attr_type:'AttrMenu', autoGeneratedButton:true, 'tooltip': t('Cell style'), 'cssClass':'pi p-button-white pi-palette', attrs: this.rowStyleMenu_attrs() , uiHelp: 'grid.cmd.style' },
                        ]
                    }
                } else {
                    commandPanel = [ ...commandPanel,
                        ...copyCommands,
                    ]

                }
                if (this.attr.rowStyleButtons) {
                    // подменю Style — быстрый ввод CSS-свойств в поле style строки
                    commandPanel = [ ...commandPanel,
                        ...(commandPanel.length ? [{ autoGeneratedButton:true}] : []),
                        { name:'button-rowStyle-menu', title:t('Style'), attr_type:'AttrMenu', autoGeneratedButton:true, 'tooltip': t('Row style (style)'), 'cssClass':'pi p-button-white pi-palette', attrs: this.rowStyleMenu_attrs() , uiHelp: 'grid.cmd.style' },
                    ]
                }
                // if (this.modified) {
                    commandPanel = [ ...commandPanel,
                        ...(commandPanel.length ? [{ autoGeneratedButton:true}] : []),
                        ...(clearAllBtn ? [clearAllBtn] : []),
                        { name:'button-undo_Click', hotkey: this.isMac ? 'Cmd Z' : 'Ctrl Z', autoGeneratedButton:true, 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'tooltip': t('Undo'),command:'executeVueObjMethod', 'method':'undo_Click', 'cssClass':'pi pi-undo p-button-white p-button-text0' , uiHelp: 'grid.cmd.undo' },
                        { name:'button-undoHistory', autoGeneratedButton:true, 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'tooltip': t('Undo history (last actions)'),command:'executeVueObjMethod', 'method':'undoHistory_Click', 'cssClass':'pi pi-chevron-down p-button-white p-button-text0 history-caret' , uiHelp: 'grid.cmd.history', uiHelpState: 'undo' },
                        { name:'button-redo_Click', hotkey: this.isMac ? 'Cmd Shift Z' : 'Ctrl Y', autoGeneratedButton:true, 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'tooltip': t('Redo'),command:'executeVueObjMethod', 'method':'redo_Click', 'cssClass':'pi pi-refresh p-button-white p-button-text0' , uiHelp: 'grid.cmd.redo' },
                        { name:'button-redoHistory', autoGeneratedButton:true, 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'tooltip': t('Redo history (undone actions)'),command:'executeVueObjMethod', 'method':'redoHistory_Click', 'cssClass':'pi pi-chevron-down p-button-white p-button-text0 history-caret' , uiHelp: 'grid.cmd.history', uiHelpState: 'redo' },
                    ]
                // }
            }
            // грид read-only (M03: правятся только editable-ячейки) — блока undo нет,
            // кнопка очистки корректировок всё равно нужна
            if (clearAllBtn && !commandPanel.includes(clearAllBtn)) commandPanel.push(clearAllBtn)
            if (this.rowLevelGroup_ranges_length) {
                commandPanel = [ ...commandPanel,
                    { autoGeneratedButton:true, 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'tooltip': t('Group all'), 'showCommandTitle':true, 'title': t('Group all'),command:'executeVueObjMethod', 'method':'groupAll', 'cssClass':'pi p-button-white p-button-text0' , uiHelp: 'grid.cmd.groupAll', uiHelpState: 'group' },
                    { autoGeneratedButton:true, 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'tooltip': t('Ungroup all'), 'showCommandTitle':true, 'title': t('Ungroup all'),command:'executeVueObjMethod', 'method':'ungroupAll', 'cssClass':'pi p-button-white p-button-text0', uiHelp: 'grid.cmd.groupAll', uiHelpState: 'ungroup' },   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5 [ДЕФЕКТ, defects-found.md]: title был «Group all» на ОБЕИХ кнопках (копипаста) — tooltip уже был правильный
                ]
            }

            // IE 2026 10 09 / ODOO-345618 (заказ Игоря: согласование на сегменте): подменю «Approval» (Submit / Recall / Approve / Return / Reopen / Skip / History / Start cycle / Close cycle /
            // Monitor) — только у основной таблицы записи с doc._approval (бэк ставит её у виджетов с политикой согласования); команды — методы виджета approval_* с выбором строк, как sop_*
            const _apprMenu = this.approval_menu()
            if (_apprMenu) commandPanel = [ ...commandPanel, ...(commandPanel.length ? [{ autoGeneratedButton:true}] : []), _apprMenu ]
            this.apprTr_update()   // IE 2026 10 16 / ODOO-5800: панель списка единиц — кнопки по переходам WORKFLOW v2 выделенной единицы (данные перечитаны, выделение могло сохраниться)
            // IE 2026 10 09 / ODOO-345618 (заказ Игоря: согласование — звено «ответственный»): кнопка «Mine» у отчёта по сигналам (источник DS::Signals) — чипс стола
            // responsible_users ilike <id пользователя> в память (utils/cellResponsible: как чипс «Object» блока OBJECTS, без Save); повторный клик снимает. Флаг fe.ux.signalsResponsible
            const _mineBtn = this.signalsMine_button()
            if (_mineBtn) commandPanel = [ ...commandPanel, ...(commandPanel.length ? [{ autoGeneratedButton:true}] : []), _mineBtn ]
            const _raBtn = this.ruleApproval_button()   // IE 2026 11 03 / ODOO-5800 (ie-dm7 #128579: согласование правил MAP-*, этап C): кнопка «Approval» со сводкой в панели грида списка MAP-* (настройка doc.params.approval.rules)
            if (_raBtn) commandPanel = [ ...commandPanel, ...(commandPanel.length ? [{ autoGeneratedButton:true}] : []), _raBtn ]
            const _paBtn = this.planApproval_button()   // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B): кнопка «Plan approval» шапки Баланса
            const _paHead = this.planApproval_headerRowOn()   // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239): в ряду шапки отчёта (WIDGET._paHeaderBtn), выключатель — в панели грида
            this.planApproval_headerSync(_paHead ? _paBtn : null)
            if (_paBtn && !_paHead) commandPanel = [ ...commandPanel, ...(commandPanel.length ? [{ autoGeneratedButton:true}] : []), _paBtn ]

            // IE 2026 10 14 / ODOO-5800 (Igor: правка динамических списков как у виджета списка): read-only → «Edit in a grid» (+ «Open record»), режим правки → Save (N, жёлтая) / Cancel
            if (this.gridEditMode_applies) {
                const _em = gridEditMode_buttons({ applies: true, readOnly: !!this.get_viewParam('isReadOnly'), count: this.gridSave_countNow(), saving: this.gridSave_saving, attrName: this.attr.name, binding: this.attr.binding, open: this.gridEditMode_openOffered(), t })
                if (_em.length) commandPanel = [ ...commandPanel, ...(commandPanel.length ? [{ autoGeneratedButton:true }] : []), ..._em ]
            }
            let need_separator = commandPanel.length
            const _menuOnly = []   // IE 2026 09 19 / ODOO-…: команды «только в меню таблицы ≡»
            // IE 2026 08 27 (Igor): кнопка Save списка/отчёта — неактивная и не жёлтая, пока изменений нет
            const _hasChanges = this.hasChangesForSave()
            if (this.attr.groupMenu?.commandPanel) {
                this.attr.groupMenu.commandPanel.forEach(attrButton => {
                    // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5 (накат 28.09): запасное объяснение серверной кнопки таблицы; «Edit in a grid» (set_viewParam …isReadOnly) — своё: снять режим «только чтение»
                    if (attrButton.uiHelpFallback === undefined && !attrButton.autoGeneratedButton) attrButton.uiHelpFallback = (attrButton.command === 'set_viewParam' && /\.isReadOnly$/.test(String(attrButton.binding || ''))) ? 'grid.cmd.readOnlyOff' : 'grid.commandPanel.backend'
                    const v_if = attrButton['v-if'] // { 'v-if': v_if, ...attrButton } = attrButton
                    if (!attrButton.autoGeneratedButton) {
                        const visible_ = this.store.eval_value(this.WIDGET, v_if, eval_params)
                        if (attrButton.visible != visible_) {
                            attrButton.visible = visible_
                        }
                        if (attrButton.method === 'save' && attrButton.command === 'executeWidgetMethod') {
                            if (attrButton._cssClass0 === undefined) attrButton._cssClass0 = attrButton.cssClass || ''
                            attrButton.disabled = !_hasChanges
                            attrButton.cssClass = _hasChanges ? attrButton._cssClass0
                                : attrButton._cssClass0.replace(/p-button-yellow/g, 'p-button-white').replace(/\bp-button-main\b/g, '').replace(/\s+/g, ' ').trim()
                        }
                        // IE 2026 09 19 / ODOO-… (замечание Игоря: «убери команды из командной панели, оставь в меню таблицы»): команда с
                        // признаком menuOnly в панель не идёт — остаётся пунктом меню таблицы ≡ (правый верхний угол)
                        if (attrButton.menuOnly) { _menuOnly.push(attrButton); return }
                        if (need_separator) {
                            commandPanel.push({autoGeneratedButton:true})
                            need_separator = false
                        }
                        commandPanel.push(attrButton)
                    }
                })
            }
            this.store.prepare_attrs(commandPanel, this.attr.html_id + (++this.ind_commandPanel))

            if (_menuOnly.length) this.store.prepare_attrs(_menuOnly, this.attr.html_id + 'mo' + this.ind_commandPanel)
            this.actionMenu = this.store.actionMenu_from_commandPanel(_menuOnly.length ? [...commandPanel, ..._menuOnly] : commandPanel, this.archiveRo?.() ? this.WIDGET : null)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): запись прячется только у запертого архивом грида данных модели; вкладки настроек — с Save (ревью #110599)
            if (this.attr.binding_forSelectorHotkeys) {
                this.actionMenu.push(this.store.prepare_actionMenu({ name:'button-selector_Click', hotkey: 'Ctrl+/, Ctrl+Enter', autoGeneratedButton:true, 'attr_type':'AttrButton', source_name:this.attr.name, 'binding':this.attr.binding, 'tooltip': t('Selector click'),command:'executeVueObjMethod', 'method':'selector_Click', cssClass:'pi pi-check-square' }))
                this.actionMenu.push(this.store.prepare_actionMenu({'title':'-'}))
            }

            this.actionMenu.push(this.store.prepare_actionMenu({ 'attr_type':'AttrButton', 'cssClass':'pi p-button-white pi-file-excel', 'title': t('Export (XLSX)'), 'command': 'copyPaste', method: 'exportGrid', 'params':{'format':'xlsx'}, source_name:this.attr.name, 'binding':this.attr.binding }))
            // IE 2026 09 24 / ODOO-… (заказ Игоря: выгрузка без скрытых строк и колонок): команда по умолчанию выгружает только видимые строки и колонки; эта — всё, скрытые остаются скрытыми в Excel
            this.actionMenu.push(this.store.prepare_actionMenu({ 'attr_type':'AttrButton', 'cssClass':'pi p-button-white pi-file-excel', 'title': t('Export (XLSX) · including hidden rows and columns'), 'tooltip': t('Exports all rows and columns; hidden ones stay hidden in Excel'), 'command': 'copyPaste', method: 'exportGrid', 'params':{'format':'xlsx', 'hidden': true}, source_name:this.attr.name, 'binding':this.attr.binding }))
            // IE 2026 10 02 / ODOO-5800 (заказ Игоря: копирование в Excel for Mac с заливкой — HTML-исходник в text/plain): «Copy for Excel» — выделение
            // HTML-исходником таблицы в text/plain (единственная форма, которую Excel for Mac вставляет С заливками) и отмечаемый пункт — переключатель
            // браузера «Ctrl+C copies for Excel» (отмечен — pi-check-square, нет — pi-stop). Общий выключатель fe.ux.copyExcel (false — пунктов нет)
            if (this.copyExcel_on()) {
                const _cx = this.copyExcel_ctrlC()
                this.actionMenu.push(this.store.prepare_actionMenu({ 'attr_type':'AttrButton', 'cssClass':'pi p-button-white pi-copy', 'title': t('Copy for Excel'), 'tooltip': t('Copies the selected cells in the form Excel pastes with fills, colours and number formats: the HTML source of the table as plain text (Excel for Mac needs it). WebSCM tables paste it back as the same values'), 'command': 'executeVueObjMethod', method: 'copyExcel_copy', source_name:this.attr.name, 'binding':this.attr.binding }))
                this.actionMenu.push(this.store.prepare_actionMenu({ 'attr_type':'AttrButton', 'cssClass':'pi p-button-white ' + (_cx ? 'pi-check-square' : 'pi-stop'), 'title': t('Ctrl+C copies for Excel'), 'tooltip': t('Switch of this browser: when on, Ctrl+C in tables copies in the same form as «Copy for Excel»; when off — the usual copy'), 'command': 'executeVueObjMethod', method: 'copyExcel_toggle', active: _cx, source_name:this.attr.name, 'binding':this.attr.binding }))
            }
            this.actionMenu.push(this.store.prepare_actionMenu({ 'attr_type':'AttrButton', 'cssClass':'pi p-button-white pi-file-pdf', 'title': t('Export (PDF)'), 'command': 'copyPaste', method: 'exportGrid', 'params':{'format':'pdf'}, source_name:this.attr.name, 'binding':this.attr.binding }))
            this.actionMenu.push(this.store.prepare_actionMenu({'title':'-'}))
            this.actionMenu.push(this.store.prepare_actionMenu({ 'attr_type':'AttrButton', 'cssClass':'pi p-button-white pi-list-check', 'title': t('Mark selected rows'), 'command': 'executeVueObjMethod', method: 'toggleFeSelected', source_name:this.attr.name, 'binding':this.attr.binding }))
            this.actionMenu.push(this.store.prepare_actionMenu({'title':'-'}))
            this.actionMenu.push(this.store.prepare_actionMenu({ 'attr_type':'AttrButton', 'cssClass':'pi p-button-white pi-copy', 'title': t('Copy rows (JSON)'), hotkey: 'Alt C', 'command': 'copyPaste', 'method':'copyItems', source_name:this.attr.name, 'binding':this.attr.binding }))
            this.actionMenu.push(this.store.prepare_actionMenu({ 'attr_type':'AttrButton', 'cssClass':'pi p-button-white pi-clipboard', 'title': t('Paste rows (JSON)'), hotkey: 'Alt V', 'command': 'copyPaste', 'method':'pasteItems', source_name:this.attr.name, 'binding':this.attr.binding }))
            this.actionMenu.push(this.store.prepare_actionMenu({'title':'-'}))
            this.actionMenu.push(this.store.prepare_actionMenu({ 'attr_type':'AttrButton', 'cssClass':'pi p-button-white pi-file-export', 'title': t('Export rows (JSON)'), 'command': 'copyPaste', method: 'exportItems', 'params':{'format':'json'}, source_name:this.attr.name, 'binding':this.attr.binding }))
            this.actionMenu.push(this.store.prepare_actionMenu({ 'attr_type':'AttrButton', 'cssClass':'pi p-button-white pi-file-import', 'title': t('Import rows (JSON)'), 'command': 'copyPaste', method: 'importItems', 'params':{'format':'json'}, source_name:this.attr.name, 'binding':this.attr.binding }))
            this.actionMenu.push(this.store.prepare_actionMenu({'title':'-'}))
            // задача 17: сброс пользовательских ширин колонок/высот строк; активен только
            // при наличии изменений (disabled рендерится cssClass-row, клик гасится в menuNodeClicked)
            {
                const _hasSizes = this.restoreDefaultSizes_hasChanges()
                this.actionMenu.push(this.store.prepare_actionMenu({ 'attr_type':'AttrButton', 'cssClass':'pi p-button-white pi-arrows-h', 'title': t('Restore default sizes'), 'command': 'executeVueObjMethod', method: 'restoreDefaultSizes', source_name:this.attr.name, 'binding':this.attr.binding, disabled: !_hasSizes, 'cssClass-row': _hasSizes ? '' : 'menu-item-disabled' }))
                this.actionMenu.push(this.store.prepare_actionMenu({'title':'-'}))
            }
            // IE 2026 09 24 / ODOO-341407: «Translations…» — карточка переводов активной строки (параметр, колонка, строка раскладки, поле формы)
            // или выделенной колонки таблицы данных
            if (this.i18n_gridApplies()) {
                this.actionMenu.push(this.store.prepare_actionMenu({ 'attr_type':'AttrButton', 'cssClass':'pi p-button-white pi-globe', 'title': t('Translations…'), 'command': 'executeVueObjMethod', method: 'i18n_menu_open', source_name:this.attr.name, 'binding':this.attr.binding, _key: 'Translations…' }))
                this.actionMenu.push(this.store.prepare_actionMenu({'title':'-'}))
            }

            for (let attrButton of this.attr.groupMenu?.actionMenu || []) {
                const v_if = attrButton['v-if'] // { 'v-if': v_if, ...attrButton } = attrButton
                const visible_ = this.store.eval_value(this.WIDGET, v_if, eval_params)
                if (attrButton.visible != visible_) {
                    attrButton.visible = visible_
                }
                const lastAddedAttr = this.actionMenu.length > 0 ? this.actionMenu[this.actionMenu.length - 1] : null
                if (attrButton.visible && (!lastAddedAttr || lastAddedAttr.title !== attrButton.title && this.store.checkAccess(attrButton, this.archiveRo?.() ? this.WIDGET : null))) {   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): запись прячется только у запертого архивом грида данных модели; вкладки настроек — с Save (ревью #110599)
                    this.actionMenu.push(this.store.prepare_actionMenu(attrButton))
                }
            }

            // if (!this.store.hide_console) console.log(commandPanel)
            // this.attr.groupMenu = this.attr.groupMenu || {}
            // this.attr.groupMenu.commandPanel =
            this.store.updateCommandPanelInPlace(this.commandPanel, commandPanel)
            if (this.gridEditMode_applies) this.ew_update()   // IE 2026 10 14 / ODOO-5800: «Open record» активна только при строке с id (enabled_when)
            this._cpItemWidths = null
            this.commandPanelMaxVisible = Infinity
            this.commandPanelAreaWidth = null
            this.commandPanelMenuWidth = null
            this.$nextTick(() => {
                const container = this.$refs.commandPanelMenu
                const topLine = this.$refs.attr_top_line
                if (!container || !topLine) return
                this._cpItemWidths = Array.from(container.children).map(el => el.offsetWidth)
                if (!this.commandPanelResizeObserver) {
                    this.commandPanelResizeObserver = new ResizeObserver(() => this.updateCommandPanelOverflow())
                }
                this.commandPanelResizeObserver.unobserve(container)
                this.commandPanelResizeObserver.observe(topLine)
                const chipsEl = topLine.querySelector('.grid-chips')
                if (chipsEl) this.commandPanelResizeObserver.observe(chipsEl)
                this.updateCommandPanelOverflow()
            })
        },
        get_measure(measure) {
            for (let m of this.WIDGET.record.doc.measures) {
                if (m.measure==measure) {
                    return m
                }
            }
            return null
        },
        get_attr_col(icol, with_date=false) {
            if (icol >= 0 && icol < this.flex.columns.length) {
                let col = this.flex.columns[icol]
                let attr_col = this.attr_by_binding[col.binding]

                if (with_date && !attr_col?.date && attr_col) {
                    let parentAttr = this.parentAttr_by_idAttr[attr_col.idAttr]

                    let maxIter = 15;
                    while (parentAttr && maxIter-- > 0) {
                        if (parentAttr.date) {
                            attr_col = parentAttr
                            break
                        }
                        parentAttr = this.parentAttr_by_idAttr[parentAttr.idAttr];
                    }
                }

                return attr_col
            }
            return null
        },
        get_attrsIndex(colBinding) {
            // IE 2026 10 23 / ODOO-348708 (заказ Игоря): binding колонки грида встречается и у ребёнка вложенного грида (conditional_format.template и колонка template) —
            // сначала ищем среди колонок самого грида, ребёнка вложенного берём, только если колонки нет; индекс — по-прежнему номер строки дерева окна (utils/fieldsColnum.js)
            return colnum_attrsIndex(this.attr.attrs, colBinding)
        },
        sync_attrsTableSelection(WRow, colBinding, colBinding2) {
            if (!colBinding || !WRow?.vueObj) return
            const idx1 = this.get_attrsIndex(colBinding)
            if (idx1 < 0) return
            const idx2 = colBinding2 ? this.get_attrsIndex(colBinding2) : idx1
            const r1 = Math.min(idx1, idx2 >= 0 ? idx2 : idx1)
            const r2 = Math.max(idx1, idx2 >= 0 ? idx2 : idx1)
            const attrs_vueObj = WRow.vueObj.get_vueObj('attrs')
            if (attrs_vueObj?.flex) {
                attrs_vueObj.ignore_selectionChanged = true
                attrs_vueObj.flex.selection = new wjGrid.CellRange(r1, 0, r2, attrs_vueObj.flex.columns.length - 1)
                attrs_vueObj.flex.scrollIntoView(r1, 0)
                attrs_vueObj.ignore_selectionChanged = false
            }
        },

        //---------------------------------   SELECTION  ---------------------------------
        // IE 2026 08 17 / ODOO-4997 (заказ Игоря): участие виджета в обмене
        // ВЫДЕЛЕНИЕМ — два универсальных списка полей через запятую в настройках
        // виджета (Params → Selection):
        //   doc.params.selection_set_fields — что ОТДАЁМ (триггерим) при выделении,
        //   doc.params.selection_get_fields — что ПРИНИМАЕМ.
        // В списках — датные меры основной таблицы (IN, OUT, date …) И измерения
        // (subject, object, workcenter …). Измерения — канал wscm-dim-highlight
        // (гейты в dimHighlight_onNav / applyDimHighlight), период — канал
        // selectionWorkspace.selectedDates (selDate_set / selDate_get). СТРОГО:
        // ПУСТОЙ список = таблица не отдаёт и не принимает ни измерения, ни
        // период (IE 2026 08 18 — раньше пустой список падал на флаги вида).
        // Действует ТОЛЬКО на основной таблице (dataSheet). Старые ключи
        // selection_*_date_fields читаются как фолбэк до миграции be-2026-08-17-1.
        sel_fields(kind) {
            if (this.attr?.name !== 'dataSheet') return null
            // IE 2026 08 18 / ODOO-4997: строки табличной части selection_fields с
            // флагом Selection set/get; в список идут Field (матч колонок этой
            // таблицы) и Source (имя шины, в т.ч. слово date)
            const rows = this.store.selFields_rows(this.WIDGET).filter(r => r[kind === 'set' ? 'selection_set' : 'selection_get'])
            if (!rows.length) return null
            const list = []
            for (const r of rows) {
                for (const n of [r.binding, r.source]) {
                    const x = String(n || '').trim()
                    if (x && !list.includes(x)) list.push(x)
                }
            }
            return list.length ? list : null
        },
        // измерения из списка (всё, что не является мерой-колонкой таблицы) —
        // заготовка под обмен выделением по subject/object; потребителя пока нет
        selDims_fields(kind) {
            const list = this.sel_fields(kind)
            if (!list) return null
            const dims = list.filter(f => f !== 'date' && !this.selDate_fieldIsColumn(f))
            return dims.length ? dims : null
        },
        selDate_fields(kind) {
            return this.sel_fields(kind)
        },
        selDate_fieldIsColumn(f) {
            // поле из списка — датная мера ЭТОЙ таблицы (есть такая колонка)
            try {
                for (let icol = 0; icol < (this.flex?.columns?.length || 0); icol++) {
                    const ac = this.get_attr_col(icol, true)
                    if (ac?.date && this.selDate_colInFields(ac, [f])) return true
                }
            } catch { /* грид ещё не готов */ }
            return false
        },
        selDate_colInFields(attr_col, list) {
            // колонка относится к перечисленному полю: мера колонки (raw_binding)
            // либо её binding/имя поля; служебное слово 'date' — любая датная колонка
            if (!list) return true
            if (list.includes('date') && attr_col?.date) return true
            const cand = [attr_col?.raw_binding, attr_col?.binding0, attr_col?.binding, attr_col?.name]
                .filter(Boolean).map(String)
            return cand.some(c => list.some(f => c === f || c.endsWith('.' + f) || c.endsWith('::' + f)))
        },
        selDate_set() {
            const list = this.selDate_fields('set')
            if (list) {
                // публикуем период, только если выделена колонка перечисленного поля
                try {
                    const sel = this.flex?.selectedRanges?.[0]
                    const col = sel?.col
                    if (col === undefined || col < 0) return false
                    // IE 2026 09 10 / ODOO-… (замечание Игоря): строки-даты (вкладка данных графика / DS) — период несёт СТРОКА,
                    // публикуем при 'date' в Set fields из любой колонки (раньше только из датной колонки, и отчёт не перепрыгивал)
                    if (list.includes('date') && sel.row >= 0 && this.flex.rows[sel.row]?.dataItem?.date) return true
                    return this.selDate_colInFields(this.get_attr_col(col, true), list)
                } catch { return false }
            }
            return false // пустой Set fields — период не отдаём (строго)
        },
        selDate_get() {
            const list = this.selDate_fields('get')
            if (list) {
                // принимаем период, только если в списке есть датная мера этой
                // таблицы (или 'date'); список из одних измерений период не включает
                return list.includes('date') || list.some(f => this.selDate_fieldIsColumn(f))
            }
            return false // пустой Get fields — период не принимаем (строго)
        },
        // IE 2026 09 26 / ODOO-5800 (ie-demo7: ⊗ на чипсе Period не держится, пока выделена ячейка месяца): после перечитывания данных грид возвращает
        // прежнее выделение (selectedRanges_BEFORE); сеттер wijmo синхронно зовёт selectionChanged, и тот публиковал период выделенной ячейки
        // в чипс стола заново — снятый пользователем чипс возвращался. Возврат помечается (_selRestore): selectionChanged передаёт пометку
        // (_restore рядом с selectedDates), mainStore.setSelectionWorkspace_date период из неё в чипс не ставит (fe.ux.periodSelSkipRestore)
        selRestore_apply() {
            let ranges = this.selectedRanges_BEFORE
            // IE 2026 09 26 / ODOO-5800 (pageerror при сужении отчёта — смена чипса / периода убрала колонку, где стояло выделение): прежнее
            // выделение возвращалось как есть, и wijmo рисовал выделение за пределами новых колонок. Диапазон вне текущих строк / колонок не
            // возвращается (его ячейки больше нет): остальные диапазоны — как были; не осталось ни одного — выделение остаётся тем, куда
            // его поставил сам грид. Выключатель fe.ux.gridSelOutOfRange (дефолт ВКЛ); счётчик — window.gridSelOutOfRange
            // IE 2026 09 27 / ODOO-5800 (ie-webscm7 #46296; ie-dm-app7 на проде: DM 1EiJ_001, ⊗ Object — 85 колонок до и после, счётчик restore 2–3): отбрасывание
            // по СТРОКАМ было лишним — выделение на строке за концом новой выборки (было 375 строк, стало 282) уезжало в первую строку, а до 26.09 wijmo сам
            // прижимал его к последней строке (FlexGrid.select), без ошибок. По строкам диапазон больше не отбрасывается — как до 26.09. Колонка ищется по
            // binding в уже ПЕРЕСТРОЕННОМ гриде (снимок binding'ов — selBefore_snap, в момент снимка выделения): на своём месте — как было; на другом месте
            // (часть колонок ушла) — диапазон переезжает к ней (счётчик moved); колонки больше нет — диапазон не возвращается (restore, как 26.09: сужение
            // отчёта, pageerror «dataMap»); без снимка (колонка без binding) — проверка по индексу
            if (Array.isArray(ranges) && this.flex && this.store.setting('fe.ux.gridSelOutOfRange', true) !== false) {
                const cols = this.flex.columns, nc = cols.length, bind = ranges._bind
                const colOf = (c, b) => {
                    if (b === undefined || b === null) return c < nc ? c : null
                    if (cols[c]?.binding === b) return c
                    const i = cols.findIndex(x => x?.binding === b)
                    return i >= 0 ? i : null
                }
                const out = []
                let dropped = 0, moved = 0
                ranges.forEach((r, k) => {
                    if (!r) { dropped++; return }
                    const c1 = colOf(r.col, bind?.[k]?.[0]), c2 = colOf(r.col2, bind?.[k]?.[1])
                    if (c1 === null || c2 === null) { dropped++; return }
                    if (c1 === r.col && c2 === r.col2) { out.push(r); return }
                    moved++
                    out.push(new wjGrid.CellRange(r.row, c1, r.row2, c2))
                })
                if (moved) this.selOutOfRange_count('moved')
                if (dropped) {
                    this.selOutOfRange_count('restore')
                    if (!out.length) return
                }
                if (dropped || moved) ranges = out
            }
            this._selRestore = true
            try { this.flex.selectedRanges = ranges } finally { this._selRestore = false }
        },
        selOutOfRange_count(kind) {
            // IE 2026 09 26 / ODOO-5800: замер fe.ux.gridSelOutOfRange — сколько раз сработала защита (merge / restore / format)
            // IE 2026 09 27 / ODOO-5800: + moved — диапазон возвращён на колонку с тем же binding, стоящую на другом месте
            try {
                const c = (window.gridSelOutOfRange = window.gridSelOutOfRange || { merge: 0, restore: 0, format: 0, moved: 0 })
                c[kind] = (c[kind] || 0) + 1
            } catch (e) { /* без замера */ }
        },
        // IE 2026 09 27 / ODOO-5800: снимок прежнего выделения (selectedRanges_BEFORE) вместе с binding колонок, на которых оно стоит СЕЙЧАС, — до перестройки
        // колонок; selRestore_apply по нему находит ту же колонку в перестроенном гриде. Снимок — неперечисляемое поле массива (_bind): сравнения
        // JSON.stringify(selectedRanges_BEFORE) и сеттер wijmo его не видят. Действует только при fe.ux.gridSelOutOfRange (дефолт ВКЛ)
        selBefore_snap(ranges) {
            try {
                const cols = this.flex?.columns
                if (Array.isArray(ranges) && cols) {
                    Object.defineProperty(ranges, '_bind', { value: ranges.map(r => r ? [cols[r.col]?.binding, cols[r.col2]?.binding] : null), configurable: true, writable: true })
                }
            } catch (e) { /* без снимка — проверка по индексу */ }
            return ranges
        },
        // IE 2026 09 27 / ODOO-5800 (сброс выделения при доливе словаря): перепривязка источника из-за долива словаря (наблюдатель 'store.itemsSource_change_index' →
        // need_set_itemsSource → apply_CHIPS → set_itemsSource) сбрасывает строку выделения и возвращает selectedRanges_BEFORE — снимок последнего
        // клика / загрузки: выбор стрелками или программой (flex.select) откатывался к нему. Перед перепривязкой — снимок ТЕКУЩЕГО выделения,
        // как aggAll_rebuild; тем же selBefore_snap (binding'и колонок). Диапазоны копируются: дополнительные (Ctrl-выделение) wijmo отдаёт живыми.
        // Перестройка уже ждёт возврата своего снимка (_selRestorePending — nextTick в set_itemsSource) — текущее выделение сброшено wijmo,
        // снимок не трогаем. Выключатель fe.ux.gridSelKeepOnRebind (дефолт ВКЛ); счётчики window.gridSelKeep {snap, pending}
        selKeep_snap() {
            if (this.store.setting('fe.ux.gridSelKeepOnRebind', true) === false) return
            const _cnt = (k) => { try { const c = (window.gridSelKeep = window.gridSelKeep || { snap: 0, pending: 0 }); c[k] = (c[k] || 0) + 1 } catch (e) { /* без замера */ } }
            if (this._selRestorePending) { _cnt('pending'); return }
            try {
                const cur = this.flex?.selectedRanges
                if (!Array.isArray(cur) || !cur.length) return
                this.selectedRanges_BEFORE = this.selBefore_snap(cur.map(r => (r && typeof r.clone === 'function') ? r.clone() : r))
                _cnt('snap')
            } catch (e) { /* грид не готов — прежний снимок */ }
        },
        getSelectionWorkspace_date() {
            if (!this.isVisible || !this.data000?.length || !this.flex.columns.length) return
            // при смене базы activeWORKSPACE обнуляется, а IntersectionObserver виджета
            // прежней базы ещё срабатывает — читать selectionWorkspace уже не с чего
            if (!this.store.activeWORKSPACE) return
            let WORKSPACE = this.store.activeWORKSPACE,
                selectedDates = WORKSPACE.selectionWorkspace?.selectedDates
            
            if (selectedDates && this.selDate_get()) {
                this.isFrom_selectionWorkspace = true
                // конец диапазона — последний день периода col2 (date_next — искл.
                // граница): иначе неделя из соседнего отчёта выделяет в днях только
                // свой первый день
                let _date2 = selectedDates.col2?.date
                const _dn2 = selectedDates.col2?.date_next
                if (_dn2) {
                    const _t = new Date(_dn2)
                    if (!isNaN(_t)) {
                        _t.setDate(_t.getDate() - 1)
                        const _s = `${_t.getFullYear()}-${String(_t.getMonth() + 1).padStart(2, '0')}-${String(_t.getDate()).padStart(2, '0')}`
                        if (!_date2 || _s > _date2) _date2 = _s
                    }
                }
                this.setSelection(selectedDates.col1?.date, _date2)
                this.isFrom_selectionWorkspace = false
            } else if (this.selectedRanges_BEFORE && (this.selectedRanges_BEFORE?.[0].row2 || this.selectedRanges_BEFORE?.[0].col2)) { // this.attr.selectedRanges_dontChange ||
                if (this.flex.rows.length && this.selectedRanges_BEFORE[0].row !== -1 && JSON.stringify(this.flex.selectedRanges) !== JSON.stringify(this.selectedRanges_BEFORE)) {
                    // preserve scroll: restoring an off-screen selection makes Wijmo scroll it into view
                    const _sp = this.flex.scrollPosition
                    const _spx = _sp.x, _spy = _sp.y
                    this.selRestore_apply()   // IE 2026 09 26 / ODOO-5800: возврат прежнего выделения — не выбор пользователя (чипс периода)
                    this.flex.scrollPosition = new wjcCore.Point(_spx, _spy)
                } else if (this.scrollPosition && this.scrollPosition.y !== this.flex.scrollPosition.y) {
                    this.flex.scrollPosition = this.scrollPosition
                }
                // sticky-полоса группы: восстановление скролла после перестройки
                // может попасть В ТОЧНОСТИ в прежнюю позицию — событие скролла
                // тогда не эмитится, и пересозданная скрытой sticky-строка шапки
                // осталась бы невидимой при глубокой позиции (пропадал «липкий
                // заголовок группы»). Явный пересчёт обязателен — НЕ удалять.
                this.set_stickyRows()
            } else if (this.attr.selectedRanges_byDefault) {
                let range = this.attr.selectedRanges_byDefault[0],
                    r1 = this.headerRows,
                    c1 = 0
                if (range.measure) {
                    for (let row of this.flex.rows) {
                        if (row.dataItem && row.dataItem.measure==range.measure) {
                            r1 = row.index
                            break
                        }
                    }
                }
                if (range.binding) {
                    for (let col of this.flex.columns) {
                        if (col.binding && col.binding==range.binding) {
                            c1 = col.index
                            break
                        }
                    }
                }
                this.flex.selectedRanges = [new wjGrid.CellRange(r1, c1, r1, c1)]
            } else { // if (this.flex.selectionMode==5) { // ListBox
                const leftCol = this.flex.columns.length - 1 // this.attr.frozenColumns||0
                if (this.attr.selectRowID) {
                    if (!this.store.hide_console) console.log('selectedRows')
                    for (let row of this.flex.rows) {
                        if (row.dataItem && row.dataItem.id==this.attr.selectRowID) {
                            // this.flex.selectedRows = [row]    if (this.flex.selectionMode==5) { // ListBox
                            this.flex.selectedRanges = [new wjGrid.CellRange(row.index,0,row.index,leftCol)] // cell
                            break
                        }
                    }
                } else if (this.WIDGET.record?.params?.record_id) {
                    if (!this.store.hide_console) console.log('selectedRows')
                    for (let row of this.flex.rows) {
                        if (row.dataItem && row.dataItem.id==this.WIDGET.record.doc.params?.record_id) {
                            // this.flex.selectedRows = [row]    if (this.flex.selectionMode==5) { // ListBox
                            this.flex.selectedRanges = [new wjGrid.CellRange(row.index,0,row.index,leftCol)] // cell
                            break
                        }
                    }
                } else if (this.attr.attr_type === 'AttrTabGrid') {
                    if (!(this.flex.selectedRanges.length && this.flex.selectedRanges.col)) {
                        let irow = this.flex.frozenRows||0
                        while (irow < this.flex.rows.length && !this.flex.getCellData(irow, leftCol)) {
                            irow++
                        }
                        this.flex.selectedRanges = [new wjGrid.CellRange(irow,leftCol,irow,leftCol)] // cell
                    }
                } else { // byDefault
                    // this.flex.selectedRanges = [new wjGrid.CellRange(this.headerRows,0,this.headerRows,this.column_left)] // line
                    if (!(this.flex.selectedRanges.length)) { // REM 2015 05 13   && this.flex.selectedRanges.col >> bad for params.data_layout2
                        this.flex.selectedRanges = [new wjGrid.CellRange(this.flex.frozenRows||0,0,this.flex.frozenRows||0,leftCol)] // cell
                    }
                }
            }
        },
        setSelection(date1, date2) {
            if (this.flex?.rows) {
                const _sel0 = this.flex.selectedRanges?.[0]
                let irow1 = _sel0?.row,
                    irow2 = _sel0?.row2,
                    icol1 = _sel0?.col,
                    icol2 = _sel0?.col2
                // выделения ещё не было, а строки есть — берём первую строку с
                // данными, чтобы даты из соседнего отчёта было к чему применить
                if ((irow1 == null || irow1 < 0) && this.flex.rows.length) {
                    let _r = this.flex.frozenRows || 0
                    while (_r < this.flex.rows.length && !this.flex.rows[_r].dataItem) _r++
                    if (_r < this.flex.rows.length) { irow1 = _r; irow2 = _r }
                }
                
                if (this.flex?.rows?.[0]?.dataItem?.date) { // date-in-rows
                    // IE 2026 09 10 / ODOO-… (замечание Игоря): у строк данных (DS / вкладка данных графика) нет date_next —
                    // период строки считаем до даты следующей строки; конец периода отчёта (последний день месяца) раньше
                    // не попадал ни в одну строку и row2 оставался от ПРЕЖНЕГО выделения (выделялись строки 45–47 вместо
                    // одной). Не нашли ни начала, ни конца — выделение не трогаем; нашли одно — вторую границу приравниваем
                    const _rows = this.flex.rows
                    let _r1 = null, _r2 = null
                    for (let _i = 0; _i < _rows.length; _i++) {
                        const row = _rows[_i], _d = row.dataItem?.date
                        if (!_d) continue
                        let _dn = row.dataItem?.date_next
                        if (!_dn) {
                            for (let _j = _i + 1; _j < _rows.length; _j++) { const _d2 = _rows[_j].dataItem?.date; if (_d2) { _dn = _d2; break } }
                        }
                        // точное совпадение или попадание даты в период строки [date, date_next); последняя строка — без верхней границы
                        const _inRow = (dt) => dt != null && (_d === dt || (_d <= dt && (!_dn || dt < _dn)))
                        if (_r1 === null && _inRow(date1)) _r1 = row.index
                        if (_inRow(date2)) _r2 = row.index
                    }
                    if (_r1 === null && _r2 === null) return
                    irow1 = _r1 !== null ? _r1 : _r2
                    irow2 = _r2 !== null ? _r2 : irow1
                } else { // date-in-cols
                    const with_date = true
                    let _icol1Found = false
                    for (let icol = 0; icol<this.flex.columns.length; icol++) {
                        let attr_col = this.get_attr_col(icol, with_date)
                        // у служебных колонок attr может отсутствовать — раньше сюда
                        // не доходили (падение на пустом selectedRanges выше)
                        if (attr_col?.date) {
                            // начало — ПЕРВАЯ колонка периода: без этого цикл доезжает
                            // до последней субколонки даты (невидимой Duration) и
                            // видимое выделение теряет начало диапазона
                            if (!_icol1Found && attr_col.date <= date1 && date1 < attr_col.date_next) {
                                icol1 = icol
                                _icol1Found = true
                            }
                            if (attr_col.date <= date2 && date2 < attr_col.date_next) {
                                icol2 = icol
                            }
                        }
                    }
                }

                if (irow1 == null || irow1 < 0) return
                if (irow2 == null || irow2 < 0) irow2 = irow1
                if (icol1 == null || icol1 < 0) icol1 = 0
                if (icol2 == null || icol2 < 0) icol2 = icol1
                this.flex.selectedRanges = [new wjGrid.CellRange(irow1, icol1, irow2, icol2)]
                // if (icol1 !== null && icol2 !== null) {
                //     if (icol1 > icol2) {
                //         [icol1, icol2] = [icol2, icol1]
                //     }
                //     this.flex.selectedRanges = [new wjGrid.CellRange(irow1, icol1, irow2, icol2)]
                // } else if (icol1 !== null) {
                //     this.flex.selectedRanges = [new wjGrid.CellRange(irow1, icol1, irow2, icol1)]
                // } else if (icol2 !== null) {
                //     this.flex.selectedRanges = [new wjGrid.CellRange(irow1, icol2, irow2, icol2)]
                // }
            }
        },
        showGridSummaryLine() {
            let vueObj = this,
            flex = vueObj.flex

            if (this.get_viewParam('showGridSummaryLine') && flex.selectedRanges.length) {
                const sel = flex.selectedRanges[0];
                const nums = []   // «плоские» числа (AttrNumber и т.п.)
                const secs = []   // длительности, приведённые к СЕКУНДАМ (AttrTime/AttrDays)
                
                // // measureWeightedAverage 'M_baseLine'
                // if (sel.row==sel.row2 && sel.col!=sel.col2 && flex.rows[sel.row] && flex.rows[sel.row].dataItem && flex.rows[sel.row].dataItem.measure) {
                //     let measureDoc = vueObj.get_measure(flex.rows[sel.row].dataItem.measure).measureDoc
                //     if (measureDoc && measureDoc.params && measureDoc.params.cssStyle_condition=='cssStyle-CONDITIONS-FA') {
                //         for (let irow = 0; irow < flex.rows.length; irow++) {
                //             if (flex.rows[irow].dataItem && flex.rows[irow].dataItem.measure=='M_baseLine') {
                //                 itemWeight = flex.rows[irow].dataItem
                //                 break
                //             }
                //         }
                //     }
                //     if (measureDoc && measureDoc.params && measureDoc.params.measureWeightedAverage) {
                //         for (let irow = 0; irow < flex.rows.length; irow++) {
                //             if (flex.rows[irow].dataItem && flex.rows[irow].dataItem.measure==measureDoc.params.measureWeightedAverage) {
                //                 itemWeight = flex.rows[irow].dataItem
                //                 break
                //             }
                //         }
                //     }
                // }

                for (let irow = Math.min(sel.row,sel.row2); irow <= Math.max(sel.row,sel.row2); irow++) {
                    if (!flex.rows[irow]?.isVisible) continue
                    const dataItem = flex.rows[irow].dataItem
                    for (let icol = Math.min(sel.col,sel.col2); icol <= Math.max(sel.col,sel.col2); icol++) {
                        const col = flex.columns[icol]
                        if (irow < 0 || icol < 0 || !col) continue
                        // ячейки, скрытые свёрткой группы, в сумму НЕ идут: их значения
                        // уже учтены в агрегате видимой колонки-представителя, иначе итог
                        // задваивается (ИЕ 2026-08-12: 2 662 вместо 1 880 по неделям марта).
                        // Свёрнутые колонки остаются visible=true, скрытость видна ТОЛЬКО по
                        // isVisible (проверено на стенде) — строки выше фильтруются так же
                        if (col.isVisible === false) continue
                        // тип ячейки: колонка → мера строки (measure_in_dataItem) → transpose,
                        // как в formatItem — чтобы отличить число от длительности (AttrTime)
                        const attr_col = this.attr_by_binding[col.binding]
                        let type = attr_col?.attr_type, unit = attr_col?.unit
                        // свёрнутая группа: в выделение идёт её агрегат (в ячейке
                        // показан он же), а не значение колонки-представителя —
                        // иначе скрытые дни выпадают из суммы (ИЕ 2026-08-11)
                        let raw = this.foldAgg_getValue(dataItem, col.binding, attr_col)
                        if (attr_col?.measure_in_dataItem) {
                            const m = dataItem?.measure || this.get_measure_(dataItem)
                            if (m?.attr_type) { type = m.attr_type; unit = m.unit }
                        }
                        const measureT = this.transpose_measure(attr_col, dataItem)
                        if (measureT) {
                            const cellT = this.transpose_cellObject(raw)
                            if (cellT) raw = cellT.value
                            else if (this.attr.formatRowsAsColumns) raw = measureT.value
                            type = cellT?.attr_type || measureT.attr_type || type
                            unit = measureT?.unit || unit
                        }
                        const n = parseFloat(raw)
                        if (isNaN(n)) continue   // текст/пусто — не участвует в сумме
                        // длительности приводим к СЕКУНДАМ (единый формат для суммы через
                        // formatTimeHTML): AttrTime raw=сек (unit ms → /1000); AttrDays raw=дни → ×86400
                        if (type === 'AttrTime') {
                            secs.push(unit === 'ms' ? n / 1000 : n)
                        } else if (type === 'AttrDays') {
                            secs.push(n * 86400)
                        } else {
                            nums.push(n)
                        }
                    }
                }
                // среди выделенных смешаны число и длительность → суммируем ТОЛЬКО числа;
                // только длительности → считаем и форматируем как время
                const asTime = secs.length > 0 && nums.length === 0
                const vals = asTime ? secs : nums
                const count = vals.length
                if (count > 1) {
                    const sum = vals.reduce((a, b) => a + b, 0)
                    const avg = sum / count
                    const min = vals.reduce((a, b) => Math.min(a, b), Infinity)
                    const max = vals.reduce((a, b) => Math.max(a, b), -Infinity)
                    // полноразрядный user-friendly формат (пробел-разделители тысяч, до 2 знаков)
                    const grp = v => {
                        const neg = v < 0; const r = Math.round(Math.abs(v) * 100) / 100
                        const [i, f] = String(r).split('.')
                        return (neg ? '-' : '') + i.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + (f ? ',' + f : '')
                    }
                    const fmt = asTime ? (v => vueObj.store.formatTimeHTML(v)) : grp
                    const shortSum = asTime ? vueObj.store.formatTimeHTML(sum) : vueObj.store.formatCount(Math.round(sum))
                    const rowHTML = (label, val) => `<b class='tooltip-header-1'>\t${label}:</b> <b class='tooltip-text'> ${val}</b>`
                    // tooltip: количество / среднее / мин / макс / сумма — полными знаками
                    vueObj.currentSelectionHTML =   // IE 2026 09 23 / ODOO-341407: i18n
                        rowHTML(t('Cnt'), grp(count)) +
                        rowHTML(t('Avg'), fmt(avg)) +
                        rowHTML(t('Min'), fmt(min)) +
                        rowHTML(t('Max'), fmt(max)) +
                        rowHTML('&Sigma;', fmt(sum))
                    // на самой линии — лаконичный знак суммы Σ (значение компактно)
                    vueObj.currentSelectionHTML_base = `<b class='tooltip-header-1'>&Sigma;</b> <b class='tooltip-text'> ${shortSum}</b>`
                } else {
                    vueObj.currentSelectionHTML = ''
                    vueObj.currentSelectionHTML_base = ''
                }
            }
        },
        get_selectedRanges() {
            let selectedRanges = []
            const seenCells = new Set()
            for (let range of this.flex.selectedRanges) {
                const rowStart = Math.min(range.row, range.row2)
                const rowEnd = Math.max(range.row, range.row2)
                const colStart = Math.min(range.col, range.col2)
                const colEnd = Math.max(range.col, range.col2)

                for (let irow = rowStart; irow <= rowEnd; irow++) {
                    for (let icol = colStart; icol <= colEnd; icol++) {
                        // merged-ячейка: берём корень merge-диапазона, а не координату клика
                        let irow0 = irow, icol0 = icol
                        if (irow >= 0) {
                            const merged = this.flex.getMergedRange(this.flex.cells, irow, icol, false)
                            if (merged) {
                                irow0 = merged.topRow
                                icol0 = merged.leftCol
                            }
                        }
                        const key = `${irow0}-${icol0}`
                        if (seenCells.has(key)) continue
                        seenCells.add(key)
                        selectedRanges.push(this.get_cell(irow0, icol0))
                    }
                }
            }
            return selectedRanges
        },
        // Rows marked via "Mark selected rows" (toggleFeSelected → _fe.selected).
        // Sent to backend as request.feSelected when an action sets get_feSelected.
        get_feSelected() {
            const rows = []
            for (const row of this.flex.rows) {
                const d = row.dataItem
                // row.isVisible guard: never send rows hidden by an active filter,
                // even if they were marked before the filter was applied.
                if (row.isVisible && d && d._fe && d._fe.selected && d.id) {
                    rows.push({ id: d.id, segment: d.segment })
                }
            }
            return rows
        },
        // Current/active row (respects the active filter). Sent as request.currentRow
        // when an action sets get_currentRow. Used as the default target when no
        // rows are marked — avoids selectedRanges which can span filter-hidden rows.
        get_currentRow() {
            let d = this.flex.collectionView && this.flex.collectionView.currentItem
            if (!(d && d.id)) {
                const r = this.flex.selection ? this.flex.selection.row : -1
                if (r >= 0 && this.flex.rows[r]) d = this.flex.rows[r].dataItem
            }
            return (d && d.id) ? [{ id: d.id, segment: d.segment }] : []
        },
        // IE 2026 11 03 / ODOO-349799 (group-records): выделена строка-ГРУППА (CollectionViewGroup без id) — currentRow пуст, группу отдаём отдельным ключом запроса currentGroup {level, value} (та же пара, что клик по иконке группы)
        get_currentGroup() {   // IE 2026 11 03 / ODOO-349799 (group-records)
            const r = this.flex && this.flex.selection ? this.flex.selection.row : -1   // IE 2026 11 03 / ODOO-349799 (group-records)
            const row = r >= 0 ? this.flex.rows[r] : null   // IE 2026 11 03 / ODOO-349799 (group-records)
            if (!(row instanceof wjGrid.GroupRow) || !row.dataItem) return null   // IE 2026 11 03 / ODOO-349799 (group-records)
            const g = row.dataItem   // IE 2026 11 03 / ODOO-349799 (group-records)
            const gBind = String(g.groupDescription?.propertyName ?? '')   // IE 2026 11 03 / ODOO-349799 (group-records)
            const attr_col = this.attr_by_binding?.[gBind] || groupLevel_attr(this.attr_by_binding, this.groupBindings_list(), Number.isInteger(row.level) ? row.level : 0, null)   // IE 2026 11 03 / ODOO-349799 (group-records)
            const p = groupIcon_params(attr_col, g)   // IE 2026 11 03 / ODOO-349799 (group-records)
            return p.level && p.value != null ? { level: p.level, value: p.value } : null   // IE 2026 11 03 / ODOO-349799 (group-records)
        },
        // IE 2026 10 11 / ODOO-345618: в списке выбора (parentAction.params.isChoise) двойной клик по ячейке закреплённой колонки (Title) нативный dblclick не даёт:
        // после первого клика wijmo перерисовывает клон frozen-ячеек, второй клик приходит на другой элемент (замер dev02: mousedown/click ×2 без dblclick; по Email — dblclick есть).
        // Поэтому на хосте грида (фаза захвата) считаем два клика подряд сами (utils/gridPicker.picker_clickStep) и вызываем тот же execute_dblclick, что и нативный dblclick.
        // Вне режима выбора / при fe.ux.pickerDblClick=false обработчик ничего не делает — Title ведёт себя как прежде.
        pickerDbl_hook(flex) {
            const host = flex?.hostElement
            if (!host || host._pickerDblHooked) return
            host._pickerDblHooked = true
            host.addEventListener('click', (e) => {
                let pickerDblClick = true
                try { pickerDblClick = this.store.setting('fe.ux.pickerDblClick', true) !== false } catch (err) { pickerDblClick = true }
                const isChoise = !!this.WIDGET?.parentAction?.params?.isChoise
                const cur = { t: e.timeStamp, x: e.clientX, y: e.clientY, button: e.button }
                const st = picker_clickStep({ pickerDblClick, isChoise, last: this._pickerLastClick || null, cur, recentChoiceAt: this._pickerChoiceAt || 0 })
                this._pickerLastClick = st.last
                if (!st.chosen) return
                if (this.flex?.activeEditor) { try { this.flex.finishEditing(true) } catch (err) { /* редактор уже закрыт */ } }
                this.execute_dblclick(e)
            }, true)
        },
        // IE 2026 09 27 / ODOO-5800 (Igor 27.09: «делай»; разбор ie-demo7 25.09; совет ie-webscm7 #47789): «Set selectors»
        // (doc.params.setSelectors_AfterSelectionChanged) ставил чипсы стола на ЛЮБУЮ смену выделения, в том числе программную: возврат
        // выделения после перечитывания (set_itemsSource → selRestore_apply), выделение по умолчанию после загрузки, selectRow. На Demo
        // (Schedules, 0dM_001 / 0Bx_001) чипсы стола подменялись первой строкой отчёта (PROD-006 / Empty ⚠). Признак ПОЛОЖИТЕЛЬНЫЙ: событие
        // ввода на хосте грида (мышь / клавиатура / касание; фаза захвата — раньше обработчиков wijmo) запоминается, и смена выделения
        // считается выбором пользователя, только пока это событие ещё диспетчеризуется (eventPhase ≠ NONE). Протяжку выделения мышью
        // wijmo ведёт слушателями документа — их метим до отпускания кнопки. Программные пути перечислять не нужно: всё, что вне ввода
        // пользователя, — программное (_selRestorePending / selKeep_snap не используются и не меняются)
        selUser_hook(flex) {
            const host = flex?.hostElement
            if (!host || host._selUserHooked) return
            host._selUserHooked = true
            // вложенное событие (синтетический click внутри mousedown) не отнимает пометку у ещё идущего внешнего
            const mark = (e) => { const p = this._selUserEvt; if (!(p && p.eventPhase !== 0)) this._selUserEvt = e }
            for (const type of ['pointerdown', 'pointerup', 'mousedown', 'mouseup', 'click', 'dblclick', 'contextmenu', 'touchstart', 'touchend', 'keydown', 'keypress']) {
                host.addEventListener(type, mark, true)
            }
            host.addEventListener('mousedown', (e) => {
                if (e.button !== 0) return
                const drag = (ev) => {
                    mark(ev)
                    if (ev.type !== 'mouseup') return
                    document.removeEventListener('mousemove', drag, true)
                    document.removeEventListener('mouseup', drag, true)
                }
                document.addEventListener('mousemove', drag, true)
                document.addEventListener('mouseup', drag, true)
            }, true)
        },
        // смена выделения идёт внутри события ввода пользователя на этом гриде (selUser_hook)
        selUser_now() {
            const e = this._selUserEvt
            return !!e && e.eventPhase !== 0   // 0 = Event.NONE: событие уже отработало
        },
        // строки выделения (первый диапазон) — то, по чему Set selectors ставит флажки строк
        selRows_key(flex) {
            const r = flex?.selectedRanges?.[0]
            return (r && r.row >= 0) ? Math.min(r.row, r.row2) + ':' + Math.max(r.row, r.row2) : ''
        },
        // Set selectors в таймере selectionChanged: пропустить ли смену выделения. mark — строки выбора пользователя, взятые синхронно в
        // selectionChanged (или перенесённые с ещё ждавшего таймера); к срабатыванию таймера строки выделения должны остаться теми же.
        // Выключатель fe.ux.setSelectorsUserOnly (дефолт ВКЛ; false — как раньше, любое выделение; URL ?fe.ux.setSelectorsUserOnly=false или
        // window.feSettings.set). Замер: window.setSelectorsUserOnly {user — сработал на выбор пользователя, skip — пропущено программное, off — флаг выкл}
        setSelUser_skip(mark, flex) {
            const c = (window.setSelectorsUserOnly = window.setSelectorsUserOnly || { user: 0, skip: 0, off: 0 })
            const rows = this.selRows_key(flex)
            let skip = false
            if (this.store.setting('fe.ux.setSelectorsUserOnly', true) === false) c.off++
            else if (mark && mark === rows) c.user++
            else { c.skip++; skip = true }
            c.last = { widget: this.WIDGET?.widget || '', mark, rows, skip }
            return skip
        },
        // IE 2026 10 25 / ODOO-348730 (DataHub, список Connectors: клик по первой строке после загрузки не ставил фишку): блок «Set selectors» — строки первого диапазона
        // выделения получают selector = true, прочие false, при изменении — onApplySelector__Click. Зовут таймер selectionChanged (как раньше) и клик по уже выделенной строке
        setSelectors_fromSelection(flex) {
            const row1_ = flex.selectedRanges[0].row,
            row2_ = flex.selectedRanges[0].row2,
            row1 = Math.min(row1_, row2_),
            row2 = Math.max(row1_, row2_)

            let changed = false
            for (const row of flex.rows) {
                let set_selector = null
                if (row.dataItem?.selector && !(row1 <= row.index && row.index <= row2)) {
                    set_selector = false
                } else if (!row.dataItem?.selector && (row1 <= row.index && row.index <= row2)) {
                    set_selector = true
                }

                if (set_selector !== null) {
                    row.dataItem.selector = set_selector
                    
                    const key = `${flex.rowHeaders.cellType}-${row.index}-${this.col_selector.index}`,
                    divCell = this.divCells.get(key)
                    if (divCell?.data_cell?.irow === row.index) {
                        const checkbox = divCell.querySelector('input[type="checkbox"]')
                        if (checkbox) {
                            checkbox.checked = set_selector
                        }
                    }

                    changed = true
                }
            }
            if (changed) {
                this.store.executeStoreMethod(this.WIDGET.vueObj, { 'command': 'onApplySelector__Click' }, this.attr)
            }
        },
        // IE 2026 10 25 / ODOO-348730: клик ЛКМ по строке, которая уже выделена (wijmo selectionChanged не поднимает), а её фишка не стоит, — тот же блок «Set selectors».
        // Фишка уже стоит — ничего; чекбокс, заголовок, кнопки / глифы, правка ячейки, ждущий таймер selectionChanged — без изменений (utils/setSelectorsClick.js).
        // Флаг fe.ux.setSelectorsClickCurrent (дефолт ВКЛ). Замер: window.setSelectorsUserOnly.clickCurrent. true — блок вызван
        setSelectors_clickTry(e, ht, row, col) {
            try {
                const flex = this.flex
                if (!flex || !this.attr?.setSelectors_AfterSelectionChanged) return false
                const area = (ht?.cellType === wjGrid.CellType.Cell && ht?.panel === flex.cells && col >= 0) ? 'cell'
                    : (ht?.cellType === wjGrid.CellType.RowHeader && ht?.panel === flex.rowHeaders) ? 'rowHeader' : ''
                const sr = flex.selectedRanges?.[0]
                const dataItem = (row >= 0) ? flex.rows[row]?.dataItem : null
                const go = setSelectors_clickCurrent({ flagOn: setSelectorsClickCurrent_on((k, d) => this.store.setting(k, d)), setSelectors: true,
                    hasChannel: setSelectors_hasChannel(this.WIDGET?.record?.doc?.params), hasSelectorCol: !!this.col_selector && this.rowHeaders_col_selector !== null,
                    button: e?.button, ctrlKey: !!e?.ctrlKey, metaKey: !!e?.metaKey, shiftKey: !!e?.shiftKey, altKey: !!e?.altKey,
                    area, onSelectorCol: area === 'rowHeader' && col === this.rowHeaders_col_selector, row, selRow: sr?.row, selRow2: sr?.row2,
                    isDataRow: !!dataItem && typeof dataItem === 'object', chipOn: dataItem?.selector === true, editing: !!flex.activeEditor,
                    timerPending: !!this.selectionChanged_timeout && this._selChgPending === true, busyTarget: setSelectors_busyTarget(e?.target),
                    dblclickAttr: !!(this.attr.rowHeaderClick_dblclick || this.attr.cellClick_dblclick) })
                if (!go) return false
                const c = (window.setSelectorsUserOnly = window.setSelectorsUserOnly || { user: 0, skip: 0, off: 0 })
                c.clickCurrent = (c.clickCurrent || 0) + 1
                this.setSelectors_fromSelection(flex)
                return true
            } catch (err) { console.warn('setSelectors_clickTry', err); return false }
        },
        selectionChanging(flex, e) {
            // if (!this.store.hide_console) console.log('selectionChanging 1')
            if (this.isRowHeaderClick) {
                e.cancel = true
            }
            // IE 2026 09 17 / ODOO-… (заказ Игоря, merge «назад»): клик по пустой части перед значением строки —
            // выделяем ячейку значения (e.range у wijmo — копия, поэтому отменяем и выбираем заново)
        },
        // ---- IE 2026 10 12 / ODOO-343342 (заказ Игоря: форма ячейки по 🏷 не гаснет при перепривязке данных) ----
        // Причина (проба FB5b со стеками, R1h_001): перечитывание данных (load_data) даёт selectionChanged трижды — itemsSource → _syncSelection: [0, col]
        // (ignore_selectionChanged); _cvCollectionChanged → _syncSelection: [последняя строка, col] (_selRestorePending); selRestore_apply: прежнее выделение
        // (_selRestore). Первая строка selectionChanged прятала непривязанную форму уже на первом — форма по 🏷 гасла через 4–5,5 с после загрузки страницы.
        // Решение — utils/cellFormGate.cellForm_selAction: форма, выведенная пользователем (Dropdown.cellForm_held), на событиях перепривязки остаётся (defer),
        // возврат выделения / таймер покоя сверяют итог с выделением до перепривязки (_cfSelPrev, cellForm_sameSelection): то же — форма остаётся и
        // переставляется к ячейке (Dropdown.cellForm_follow), другое — прячется. Смена выделения пользователем — прячет сразу, как прежде.
        // Событие ЧУЖОГО грида страницы (его перепривязка при загрузке) форму другого грида не прячет; выбор пользователя в нём (selUser_now) — прячет, как прежде.
        // Флаг fe.ux.cellFormKeepOnResize (false — прежнее). Счётчики window.cellFormKeep.selEv / selDefer / selKeep / selHide / selForeign. true — форму не прятать
        cellForm_selCur(flex) {
            const s = flex?.selection
            return (s && s.row >= 0 && s.col >= 0) ? { row: s.row, col: s.col, row2: s.row2, col2: s.col2, dataItem: flex.rows?.[s.row]?.dataItem } : null
        },
        // ---- IE 2026 10 12 / ODOO-343342 (заказ Игоря: открытая форма следует за выделением) ----
        // Заказ: пока форма открыта пользователем (🏷 / F4 / шеврон / правая кнопка), она следует за выбранной ячейкой при смене выделения ЛЮБЫМ способом пользователя
        // (клик, стрелки, Tab, Enter, PageUp / Down, Home / End, протяжка); закрыл Esc / ✕ — снова только по кнопке. Прежде selectionChanged прятал НЕпривязанную форму всегда,
        // следование было только у привязанной (fe.ux.cellFormFollowKeys), а клик при fe.ux.cellFormOnlyByButton скрытую форму не возвращал. Решение — cellFormGate.cellForm_selFollow /
        // cellForm_followTarget; переезд — в dropdown_showForActiveCell_afterTimeout (_cfFollow). Флаг — fe.ux.cellFormOnlyByButton (false — прежнее прятание). Счётчик window.cellFormKeep.selFollow
        cellForm_followSel(flex) {
            const dd = this.store.dropdown
            if (!dd || !flex) return false
            let held = false, user = false
            try { held = !!dd.visible && !!dd.cellForm_held?.() } catch (e) { held = false }
            try { user = !!this.selUser_now?.() } catch (e) { user = false }
            if (dd.cfSuspended && user && (dd.visible || dd.vueObj !== this)) this.cellForm_suspendClear(dd)   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: открытая форма следует за выделением) — FB6b: выбор в другом гриде / форма показана иначе — признак снят
            const on = cellForm_selFollow({ onlyByButton: this.cellForm_onlyByButton(), visible: !!dd.visible, pinned: !!dd.pinned, sameGrid: dd.vueObj === this, held,
                transient: !!this.ignore_selectionChanged || (this._selRestorePending || 0) > 0, restore: !!this._selRestore, user, suspended: !!dd.cfSuspended })   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: открытая форма следует за выделением) — FB6b: suspended
            if (!on) { this._cfFollow = null; return false }
            const sr = flex.selectedRanges?.[0] || flex.selection
            let one = !!sr && sr.row === sr.row2 && sr.col === sr.col2
            if (sr && !one) { try { const mr = flex.getMergedRange(flex.cells, sr.row, sr.col); one = !!mr && mr.row === Math.min(sr.row, sr.row2) && mr.row2 === Math.max(sr.row, sr.row2) && mr.col === Math.min(sr.col, sr.col2) && mr.col2 === Math.max(sr.col, sr.col2) } catch (e) { /* грид в перестройке */ } }
            const m = /-(\d+)-(\d+)$/.exec(String(dd.key || ''))
            this._cfFollow = cellForm_followTarget(sr ? { row: sr.row, col: sr.col, row2: sr.row2, col2: sr.col2 } : null, one, m ? { row: +m[1], col: +m[2] } : null)
            this.cellForm_selCount('selFollow')
            return true
        },
        // переезд формы на ячейку выделения (из dropdown_showForActiveCell_afterTimeout). true — обработано
        cellForm_followApply(fw) {
            const flex = this.flex, dd = this.store.dropdown
            if (!fw || !flex || flex.disposed || !dd || !(dd.visible || dd.cfSuspended) || dd.pinned || dd.vueObj !== this) return false   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: открытая форма следует за выделением) — FB6b: и спрятанная с признаком
            const _vis = !!dd.visible   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: открытая форма следует за выделением) — FB6b
            const _sus = (applicable) => { const r = cellForm_followResult({ applicable, visible: !!dd.visible }); if (r.suspended) { dd.cfSuspended = true; this.cellForm_selCount('selSuspend') } else dd.cfSuspended = false; if (r.hide) dd.hide(); if (r.suspended !== _vis) try { this.$forceUpdate() } catch (e) { /* грид разрушен */ } return true }   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: открытая форма следует за выделением) — FB6b
            if (fw.act === 'stay') return _vis ? true : _sus(false)   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: открытая форма следует за выделением) — FB6b
            if (fw.act === 'hide') return _sus(false)   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: открытая форма следует за выделением) — FB6b
            let row = fw.row, col = fw.col, divCell = null
            if (row < 0 || col < 0) { const tg = this.cellForm_target(flex); if (tg) { row = tg.row; col = tg.col; divCell = tg.divCell } }
            else { try { divCell = this.divCells.get(`${flex.cells.cellType}-${row}-${col}`) || flex.cells.getCellElement(row, col) } catch (e) { divCell = null } }
            if (!(row >= 0 && col >= 0) || !divCell || !divCell.isConnected) return _sus(false)   // ячейка ушла за край / не отрисована   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: открытая форма следует за выделением) — FB6b: признак остаётся
            const key = `${flex.cells.cellType}-${row}-${col}`
            if (_vis && dd.key === key && dd.divCell === divCell) return true
            dd.mouse_isInside = true
            if (!_vis) dd.key = null   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: открытая форма следует за выделением) — FB6b: спрятанная — dropdown_prepare строит форму заново (без «already prepared»)
            dd._keyOpenKey = key   // как 🏷 / F4: форма показывается без курсора над ячейкой, признак «выведена пользователем» (cellForm_held) переезжает с ней
            this.dropdown_prepare({ row, col }, divCell, null, true)
            return _sus(dd.key === key)   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: открытая форма следует за выделением) — FB6b: к этой ячейке форма не применима (пустой объединённый блок) — спрятать, признак оставить
        },
        cellForm_selCount(k) { const c = (window.cellFormKeep = window.cellFormKeep || { keep: 0, drop: 0, follow: 0, hide: 0 }); c[k] = (c[k] || 0) + 1 },
        cellForm_phantomKeep(flex) {
            const cur = this.cellForm_selCur(flex)
            const restore = !!this._selRestore
            const transient = !!this.ignore_selectionChanged || (this._selRestorePending || 0) > 0
            const prev = this._cfSelPrev
            if (!transient || restore) this._cfSelPrev = cur   // выделение до перепривязки — события перепривязки его не перезаписывают
            const dd = this.store.dropdown
            if (!dd || !dd.visible || dd.pinned || !dd.vueObj) return false
            let keepOn = false, held = false
            try { keepOn = !!dd.cellForm_keepOn?.(); held = keepOn && !!dd.cellForm_held?.() } catch (e) { /* форма в перестройке */ }
            if (!held) return false
            if (dd.vueObj !== this) {   // форма другого грида
                let user = false
                try { user = !!this.selUser_now?.() } catch (e) { /* без признака — программное */ }
                const keepF = cellForm_selAction({ keepOn, held, foreign: true, user }) === 'keep'
                if (keepF) this.cellForm_selCount('selForeign')
                return keepF
            }
            this.cellForm_selCount('selEv')
            const act = cellForm_selAction({ keepOn, held, transient, restore, same: cellForm_sameSelection(prev, cur) })
            if (act === 'defer') {
                this.cellForm_selCount('selDefer')
                if (!this._cfSelDefer) this._cfSelDefer = { prev, n: 0 }   // выделение до первой перепривязки
                this.cellForm_selSettle()
                return true
            }
            const base = this._cfSelDefer ? this._cfSelDefer.prev : prev
            this._cfSelDefer = null
            if (act === 'keep' || (restore && cellForm_sameSelection(base, cur))) { this.cellForm_selKeep(dd, cur); return true }
            this.cellForm_selCount('selHide')
            return false
        },
        // форма остаётся: строка та же по id, объект новый (перечитанные данные) — форма держит новый объект (иначе Dropdown.cellForm_anchor сочтёт строку ушедшей);
        // ячейка сдвинулась после перерисовки — форма едет к ней
        cellForm_selKeep(dd, cur) {
            this.cellForm_selCount('selKeep')
            if (cur?.dataItem && dd.dataItem && dd.dataItem !== cur.dataItem && cellForm_itemId(dd.dataItem) != null && cellForm_itemId(dd.dataItem) === cellForm_itemId(cur.dataItem)) dd.dataItem = cur.dataItem
            window.$cg.setTimeout(this, 'AttrGrid.cellForm_selKeep', () => {
                try {
                    if (!dd.visible || dd.pinned || dd.vueObj !== this || !this.flex || this.flex.disposed) return
                    const p = dd.calc_position()
                    if (p && (p.top_calc !== dd.position?.top_calc || p.left_calc !== dd.position?.left_calc)) dd.cellForm_follow?.()
                } catch (e) { /* грид в перестройке — место поправит Dropdown.check_position */ }
            }, 60)
        },
        // таймер покоя: перепривязка закончилась без возврата выделения (оно уже на месте или не вернулось) — сверить итог с выделением до перепривязки
        cellForm_selSettle() {
            if (this._cfSelSettleT) clearTimeout(this._cfSelSettleT)
            this._cfSelSettleT = window.$cg.setTimeout(this, 'AttrGrid.cellForm_selSettle', () => {
                this._cfSelSettleT = null
                const D = this._cfSelDefer
                if (!D) return   // решил возврат выделения или выбор пользователя
                const flex = this.flex, dd = this.store.dropdown
                if (!flex || flex.disposed || !dd) { this._cfSelDefer = null; return }
                if ((this.ignore_selectionChanged || (this._selRestorePending || 0) > 0) && ++D.n < 10) { this.cellForm_selSettle(); return }   // перепривязка ещё идёт
                this._cfSelDefer = null
                const cur = this.cellForm_selCur(flex)
                this._cfSelPrev = cur
                if (!dd.visible || dd.pinned || dd.vueObj !== this) return
                if (cellForm_sameSelection(D.prev, cur)) this.cellForm_selKeep(dd, cur)
                else { this.cellForm_selCount('selHide'); dd.hide() }
            }, 600)
        },
        selectionChanged(flex, e) {
            let vueObj = this
            if (!flex?.hostElement) return // грид уже disposed (закрытие/переключение вкладки)
            vueObj.ew_update()   // IE 2026 10 13 / ODOO-5800: активность кнопок с enabled_when по новому выделению
            vueObj.apprTr_update()   // IE 2026 10 16 / ODOO-5800: кнопки монитора единиц по переходам WORKFLOW v2 выделенной единицы
            // IE 2026 09 22 / ODOO-5800 (Igor, п. 5): отсоединённая форма при смене выделения не закрывается — dropdown_showForActiveCell ниже переведёт её на новую ячейку
            const _cfKeep = vueObj.cellForm_phantomKeep(flex)   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: форма ячейки по 🏷 не гаснет при перепривязке данных): то же выделение (перепривязка данных) — форму, выведенную пользователем, не прятать
            const _cfFollow = !_cfKeep && vueObj.cellForm_followSel(flex)   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: открытая форма следует за выделением): форма, выведенная пользователем, при смене выделения пользователем переезжает, а не прячется
            const _cfForeign = !_cfKeep && !_cfFollow && vueObj.store.dropdown.vueObj !== vueObj && !!vueObj.store.dropdown.cellForm_keepForeign?.()   // IE 2026 10 12 / ODOO-5800 (заказ Игоря: форма ячейки не закрывается при открытии из неё записей): выделение сменилось в ЧУЖОМ гриде (открытая из формы запись) — форму, которую держит пользователь, не прятать
            if (_cfForeign) vueObj.store.dropdown.cellForm_keepCount?.('foreignKeep')   // IE 2026 10 12 / ODOO-5800 (заказ Игоря: форма ячейки не закрывается при открытии из неё записей)
            // IE 2026 10 31 / ODOO-5800 (заказ Игоря: таблиця форми комірки — на AttrGrid) (проба dev02 fe-2026-10-31-14: форма пузыря гасла — первое выделение вложенного грида при загрузке строк звало hide):
            // грид, стоящий в самой форме ячейки (attr.cellForm_off), сменой своего выделения форму не прячет
            if (!(vueObj.store.dropdown.pinned && vueObj.store.dropdown.vueObj === vueObj) && !_cfKeep && !_cfFollow && !_cfForeign && !vueObj.attr?.cellForm_off) vueObj.store.dropdown.hide()   // IE 2026 10 12 / ODOO-5800 (заказ Игоря: форма ячейки не закрывается при открытии из неё записей): && !_cfForeign   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: открытая форма следует за выделением): && !_cfFollow
            try { vueObj.boolSel_sync(flex) } catch (e) { /* грид в перестройке */ }   // IE 2026 10 12 / ODOO-345618 (заказ Игоря: чекбокс у выделенной булевой ячейки)
            try { vueObj.tls_selChanged(flex) } catch (e) { /* грид в перестройке */ }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: стили уровней дерева — опции A/B/C/E/F): ветка текущей строки (guides) / корень фокуса (focus)
            vueObj.refresh_dropdownToggles()
            if (vueObj.ignore_selectionChanged) return
            try { vueObj.compareMerge_selHook(flex) } catch (e) { /* связь «Changes» ↔ форма не обязательна */ }   // IE 2026 10 31 / ODOO-349799 (PR3): строка «Changes» → форма; ячейка с бейджем → строка
            if (_cfFollow) vueObj.dropdown_showForActiveCell()   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: открытая форма следует за выделением): переезд — в dropdown_showForActiveCell_afterTimeout (_cfFollow; клик по ячейке зовёт его же)
            // IE 2026 10 07 / ODOO-5800 (Igor: «форма дропдаун не привязывается к ячейкам из фиксированных колонок»): отсоединённая форма переезжает на новую ячейку и при смене
            // выделения С КЛАВИАТУРЫ (стрелки, Tab, Home / End): раньше её звал только клик (execute_click), а строка выше намеренно её не закрывает, — форма оставалась на прежней
            // ячейке (рамка, линия и заголовок на ней), выделение уходило дальше. Только выбор одной ячейки, не той, что форма уже показывает. Выключатель fe.ux.cellFormFollowKeys
            try {
                const _dd = vueObj.store.dropdown, _sr = flex.selectedRanges?.[0]
                if (_dd.pinned && _dd.visible && _dd.vueObj === vueObj && _sr && _sr.row >= 0 && _sr.col >= 0 && !flex.activeEditor && vueObj.store.setting('fe.ux.cellFormFollowKeys', true) !== false) {
                    // одна ячейка или целый объединённый блок (mergeColumns: выделение блока = весь его диапазон) — не протяжка диапазона
                    const _mr = (_sr.row === _sr.row2 && _sr.col === _sr.col2) ? null : flex.getMergedRange(flex.cells, _sr.row, _sr.col)
                    const _one = (_sr.row === _sr.row2 && _sr.col === _sr.col2) || (_mr && _mr.row === Math.min(_sr.row, _sr.row2) && _mr.row2 === Math.max(_sr.row, _sr.row2) && _mr.col === Math.min(_sr.col, _sr.col2) && _mr.col2 === Math.max(_sr.col, _sr.col2))
                    const _tg = _one ? vueObj.cellForm_target(flex) : null
                    if (_tg && _dd.key !== `${flex.cells.cellType}-${_tg.row}-${_tg.col}`) vueObj.dropdown_showForActiveCell()
                }
            } catch (e) { /* грид в перестройке — форма останется на своей ячейке */ }
            // IE 2026 08 18 / ODOO-5555: источник смены выделения для расшифровки —
            // синхронно (флаг isFrom_selectionWorkspace живёт только внутри setSelection,
            // а обработчик ниже отложен): выделение, пришедшее с шины страницы
            // (период/подсветка от другого виджета), обновление целей не запускает
            vueObj._dd_fromWorkspace = !!vueObj.isFrom_selectionWorkspace

            if (vueObj.itemsSourcesView_mode(vueObj.attr.use_itemsSourcesView) && !vueObj.itemsSourcesView_grid()) {
                // ит.2 §2: перепозиционировать таблицы-реестры в открытом view-попапе этого грида
                let WRow = vueObj.store.get_childrenWidget(vueObj.WIDGET, 'widget-row')
                if (!WRow || WRow._softClosed) {
                    WRow = vueObj.store.get_widgetRow() // popup мог сменить родителя
                }
                const row_vueObj = (WRow && !WRow._softClosed
                    && WRow.parentAction?.type === 'widget-row-viewParams'
                    && WRow.record?._meta?.binding === vueObj.attr.binding)
                    ? WRow.vueObj : null
                row_vueObj?.get_vueObj?.('grid-itemsSourcesView')?.itemsSourcesView_position?.()
                row_vueObj?.get_vueObj?.('grid-itemsSourcesView-target')?.itemsSourcesView_position?.()
            }

            if (vueObj.showFeSelected) vueObj.update_feSelected()

            // IE 2026 09 14 / ODOO-5800: панель полей — выбранная строка поля для стрелки легенды чарта
            if (vueObj.attr?.binding === 'doc.viewList' && flex.selection && flex.selection.row >= 0) {
                vueObj.legendFieldSelectionPublish(flex.rows[flex.selection.row]?.dataItem)
            }
            // IE 2026 09 14 / ODOO-5800 (заказ Игоря): подсветка ячеек, влияющих на выбранную (опция отчёта)
            try { vueObj.influence_update(flex) } catch (e) { if (window.__simDebug) console.log('influence:', e) }
            // IE 2026 09 22 / ODOO-5800 (Igor): ячейки, чьи данные из тех же документов, что и выделенная
            try { vueObj.sameDoc_update(flex) } catch (e) { if (window.__simDebug) console.log('sameDoc:', e) }
            // IE 2026 09 17 / ODOO-… (заказ Игоря): выделена ячейка целиком — ячейки с таким же текстом подсвечиваются целиком
            try { vueObj.sameValue_update(flex) } catch (e) { if (window.__simDebug) console.log('sameValue:', e) }

            // АН 2026 08 15 / ODOO-4997 (заказ Игоря): обратный канал подсветки —
            // навигация по ячейкам подсвечивает узлы в графе/бабле страницы
            vueObj.dimHighlight_onNav(flex)

            // vueObj.dropdown_showForActiveCell()
            
            if (vueObj.selDate_set() && flex.selectedRanges?.length && !vueObj.isFrom_selectionWorkspace) {
                if (!this.store.hide_console) console.log('selectionChanged 2')
                const with_date = true
                let col1 = flex.selectedRanges[0].col,
                    col2 = flex.selectedRanges[0].col2,
                    attr_col1 = vueObj.get_attr_col(col1, with_date),
                    attr_col2 = vueObj.get_attr_col(col2, with_date),
                    item_row1 = flex.rows[flex.selectedRanges[0].row]?.dataItem,
                    item_row2 = flex.rows[flex.selectedRanges[0].row2]?.dataItem
                if (item_row1?.date) { // date-in-rows
                    vueObj.store.setSelectionWorkspace_date(vueObj.WIDGET,{
                        selectedDates:{
                            col1: item_row1, 
                            col2: item_row2,
                        },
                        _restore: !!vueObj._selRestore,   // IE 2026 09 26 / ODOO-5800: возврат прежнего выделения после перечитывания (selRestore_apply) — чипс периода не ставит
                    })
                } else if (attr_col1?.date || attr_col2?.date) { // date-in-cols
                    while (!attr_col1?.date && col1 < col2) {
                        attr_col1 = vueObj.get_attr_col(++col1, with_date)
                    }

                    // АН 2026 08 15 / ODOO-4997 (замечание Игоря п.2): выделенная
                    // колонка СВЁРНУТОЙ группы дат (месяц/квартал) передаётся
                    // ПЕРИОДОМ целиком (первая..последняя дата группы), а не первой
                    // датой — Chart подсвечивает весь март
                    try {
                        const f1 = vueObj.dimHl_foldDates(col1, attr_col1)
                        const f2 = (flex.selectedRanges[0].col === flex.selectedRanges[0].col2)
                            ? f1 : vueObj.dimHl_foldDates(col2, attr_col2)
                        if (f1) attr_col1 = { ...attr_col1, date: f1.from }
                        if (f2) attr_col2 = { ...(attr_col2 || attr_col1), date: f2.to }
                    } catch (e) { /* свёрток нет — обычные даты */ }

                    vueObj.store.setSelectionWorkspace_date(vueObj.WIDGET,{
                        selectedDates:{
                            col1: attr_col1,
                            col2: attr_col2,
                        },
                        _restore: !!vueObj._selRestore,   // IE 2026 09 26 / ODOO-5800: возврат прежнего выделения после перечитывания (selRestore_apply) — чипс периода не ставит
                    })
                }
            }

            vueObj.showGridSummaryLine()

            if (vueObj.attr.setSelectionInAttr_AfterSelectionChanged) {
                let attr_vueObj = vueObj.WIDGET.vueObj.get_vueObj(vueObj.attr.setSelectionInAttr_AfterSelectionChanged)
                if (attr_vueObj && flex && flex.selectedRanges.length) {
                    if (!this.store.hide_console) console.log('setSelectionInAttr_AfterSelectionChanged')
                    let attr_col1 = vueObj.get_attr_col(flex.selectedRanges[0].col),
                        attr_col2 = vueObj.get_attr_col(flex.selectedRanges[0].col2)
                    if (attr_col1 && !attr_col1.x1Chart) {
                        attr_col1 = null
                    }
                    if (attr_col2 && !attr_col2.x1Chart) {
                        attr_col2 = null
                    }
                    if (attr_col1) {
                        attr_vueObj.setSelection(Math.min(attr_col1.x1Chart, attr_col2.x1Chart), Math.max(attr_col1.x2Chart, attr_col2.x2Chart))
                        // if (!this.store.hide_console) console.log(Math.min(attr_col1.x1Chart, attr_col2.x1Chart))
                        // if (!this.store.hide_console) console.log(Math.max(attr_col1.x2Chart, attr_col2.x2Chart))
                    }
                }
            }

            // IE 2026 09 27 / ODOO-5800: выбор пользователя для Set selectors — синхронно, пока идёт его событие (selUser_hook); возврат выделения
            // (selRestore_apply) и выделение с шины страницы — не выбор. К таймеру — замыканием: выбор, ещё ждущий таймера, переживает следующую
            // программную смену выделения (перечитывание вернуло выделение), таймер сверит строки (setSelUser_skip)
            const setSelMark = (vueObj.selUser_now() && !vueObj._selRestore && !vueObj.isFrom_selectionWorkspace)
                ? vueObj.selRows_key(flex) : ((this.selectionChanged_timeout && vueObj._setSelMark) || null)
            vueObj._setSelMark = setSelMark
            // IE 2026 10 13 / ODOO-5800: смена выделения из перестройки грида фоновым обновлением (не выбор пользователя) — форму строки не перецеплять; ждущий таймер
            // с НЕфоновой сменой (pendingFree) свою перецепку сохраняет. Флаг fe.ux.pollKeepsRowForm
            const rfHold = rowForm_holdRetarget({ hold: vueObj._rowFormHold === true,
                user: vueObj.selUser_now() && !vueObj._selRestore && !vueObj.isFrom_selectionWorkspace,
                pendingFree: !!this.selectionChanged_timeout && vueObj._rowFormPendingFree === true,
                flagOn: pollKeepsRowForm_on((k, d) => vueObj.store.setting(k, d)) })
            vueObj._rowFormPendingFree = !rfHold
            if (this.selectionChanged_timeout) { clearTimeout(this.selectionChanged_timeout) }
            vueObj._selChgPending = true   // IE 2026 10 25 / ODOO-348730: таймер selectionChanged ждёт — клик по строке его не опережает (setSelectors_clickTry)
            const WRow_global = vueObj.store.get_widgetRow()
            const globalViewParams_meta = (WRow_global && !WRow_global._softClosed && WRow_global.record?._meta?.type === 'widget-row-viewParams') ? WRow_global.record._meta : null
            // поколение открытия Row на момент планирования: если к срабатыванию
            // таймера Row успел открыться/переехать (seq изменился), значит его уже
            // ведёт другой грид — не перецепляем его на своё выделение (гонка)
            const openSeq0 = vueObj.store.widgetRow_openSeq
            this.selectionChanged_timeout = window.$cg.setTimeout(this, "AttrGrid.selectionChanged", () => {
                vueObj._setSelMark = null   // IE 2026 09 27 / ODOO-5800: выбор пользователя доставлен в этот таймер (setSelMark)
                vueObj._selChgPending = false   // IE 2026 10 25 / ODOO-348730
                vueObj._rowFormPendingFree = false   // IE 2026 10 13 / ODOO-5800: ждущей смены больше нет
                if (vueObj._skipSelectionWidgetOpen) return
                if (!flex?.hostElement) return // грид уже disposed (таймер пережил unmount)
                const rowStale = vueObj.store.widgetRow_openSeq !== openSeq0
                // IE 2026 10 13 / ODOO-5800: фоновая смена (rfHold) или грид не на экране (скрытая вкладка: fe.ux.rowFormSkipInternal) — форму строки не перецеплять и не перерисовывать
                const rfSkip = rowForm_retargetSkip({ held: rfHold, hidden: rowForm_gridHidden(flex.hostElement),
                    skipInternalOn: rowFormSkipInternal_on((k, d) => vueObj.store.setting(k, d)) })
                // const WRow = store.get_widgetRow()
                const WRow = vueObj.store.get_childrenWidget(vueObj.WIDGET, 'widget-row')
                if (WRow && !WRow._softClosed) {
                    const iroot_ = vueObj.WIDGET.vueObj.get_selectedRow(vueObj.attr.binding)?.iroot || null
                    const attr_col = vueObj.get_attr_col(flex.selectedRanges[0].col)
                    const range = this.get_selectedRange()
                    const _meta = WRow.record._meta
                    // IE 2026 09 06 / ODOO-335246 (Igor): карточка, открытая с диаграммы (AttrGraph) по своему источнику,
                    // не перецепляется на текущую строку чужого грида после синхронизации выделения
                    if (WRow.parentAction?.source_attr_type === 'AttrGraph' && _meta?.binding !== vueObj.attr.binding) return
                    if (WRow.parentAction?.source_attr_type === 'AttrCrossGrid' && _meta?.binding !== vueObj.attr.binding) return   // IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — форма ячейки со строками и правкой): карточку из формы ячейки шахматки не перецепляет грид другой таблицы (и сама шахматка, _doc.<имя>)

                    if (rfSkip) {   // IE 2026 10 13 / ODOO-5800: замер — window.rowFormRetargetSkip {background, hidden}
                        const c = (window.rowFormRetargetSkip = window.rowFormRetargetSkip || { background: 0, hidden: 0 }); c[rfSkip] = (c[rfSkip] || 0) + 1
                    }
                    if (iroot_ !== null && attr_col?.binding && !rowStale && !rfSkip) {   // IE 2026 10 13 / ODOO-5800: + !rfSkip
                        if (_meta.type === 'widget-row-viewParams') {
                            // секция мульти-вертикальной таблицы = ТОТ ЖЕ шаблон:
                            // doc.printTemplate[N].attrs ~ doc.printTemplate, иначе клик
                            // по ячейке переоткрывал 👁-список плоским от имени секции
                            const _normB = b => String(b || '').replace(/\[\d+\]\.attrs$/, '')
                            if (_normB(_meta.binding) !== _normB(vueObj.attr.binding) || WRow.parentWIDGET?.id !== vueObj.WIDGET.id) {
                                const actionMenu = { command: 'widget_open', 'widget': 'widget-row', 'type': 'widget-row-viewParams', '_noActivate':true, 'binding': vueObj.attr.binding, 'source_name': vueObj.attr.name, 'get_Parent': true, 'open_in_children_widget': true }
                                vueObj.store.executeStoreMethod(vueObj.WIDGET.vueObj, actionMenu, vueObj.attr)
                            } else {
                                if (vueObj.attr.isPrintTemplate && String(_meta.name || '').endsWith('-cells')) {
                                    // список ЯЧЕЕК печати (👁): позиция по координатам row/col,
                                    // колоночная синхронизация ниже — для других viewParams-попапов
                                    vueObj.sync_cellsListSelection(WRow, flex.selectedRanges[0].row, attr_col.binding)
                                } else if (vueObj.attr.attr_type === 'AttrTabGrid') {
                                    const sr1 = flex.selectedRanges[0].row, sr2 = flex.selectedRanges[0].row2
                                    const sdi1 = sr1 >= 0 ? flex.rows[sr1]?.dataItem : null
                                    const sdi2 = sr2 >= 0 ? flex.rows[sr2]?.dataItem : null
                                    vueObj.sync_attrsTableSelection(WRow, sdi1?.attr?.binding || sdi1?.binding, sdi2?.attr?.binding || sdi2?.binding)
                                } else {
                                    const col2 = vueObj.get_attr_col(flex.selectedRanges[0].col2)
                                    vueObj.sync_attrsTableSelection(WRow, attr_col.binding, col2?.binding)
                                }
                            }
                        } else if (_meta.type === 'widget-row-cell') { // this.attr.isPrintTemplate   // IE 2026 09 23 / ODOO-341407: i18n (tooltip)
                            if (_meta.iroot !== iroot_ || _meta.col_binding !== attr_col?.binding) {
                                const actionMenu = { 'tooltip': t('Open cell'), 'action_name':'action-front-openLine-2025-09-23',command:'widget_open', 'widget':'widget-row', 'type': 'widget-row-cell', '_noActivate':true, 'get_currentRow':true, 'get_Parent':true, 'open_in_children_widget':true, 'cssClass':'pi p-button-white pi-pencil', 'binding':vueObj.attr.binding, col_binding: attr_col?.binding, 'attrs':[], range }
                                if (attr_col?.attr_type === 'AttrGrid') {
                                    actionMenu.activeAttr = { binding: attr_col.binding }
                                }
                                vueObj.store.executeStoreMethod(vueObj.WIDGET.vueObj, actionMenu, vueObj.attr)
                            } else if (attr_col?.attr_type === 'AttrGrid' && WRow.view) {
                                vueObj.store.set_activeAttr(WRow.view, { binding: attr_col.binding })
                                WRow.vueObj?.content_Changed()
                            }
                        } else {
                            if (_meta.iroot !== iroot_) {
                                const actionMenu = { 'tooltip': t('Open line'), 'hotKey': 'Alt F2', 'action_name':'action-front-openLine-2024-11-30',command:'widget_open', 'widget':'widget-row', '_noActivate':true, 'get_currentRow':true, 'get_Parent':true, 'open_in_children_widget':true, 'cssClass':'pi p-button-white pi-pencil', 'binding':vueObj.attr.binding, attrs:vueObj.attr.attrs }
                                if (attr_col?.attr_type === 'AttrGrid') {
                                    actionMenu.activeAttr = { binding: attr_col.binding }
                                }
                                vueObj.store.executeStoreMethod(vueObj.WIDGET.vueObj, actionMenu, vueObj.attr)
                            } else if (attr_col?.attr_type === 'AttrGrid' && WRow.view) {
                                vueObj.store.set_activeAttr(WRow.view, { binding: attr_col.binding })
                                WRow.vueObj?.content_Changed()
                            }
                        }
                    }
                } else if (vueObj.WIDGET.widget === 'widget-row' && vueObj.WIDGET.record?._meta?.type === 'widget-row-viewParams' && vueObj.attr.name === 'attrs' && flex.selectedRanges?.length) {
                    const sel = flex.selectedRanges[0]
                    const r1 = Math.min(sel.row, sel.row2), r2 = Math.max(sel.row, sel.row2)
                    const di1 = r1 >= 0 ? flex.rows[r1]?.dataItem : null
                    const di2 = r2 >= 0 ? flex.rows[r2]?.dataItem : null
                    // список ЯЧЕЕК печати (👁): позиционирование по координатам row/col
                    // ячейки, а не по колонке — колоночную логику ниже не трогаем
                    const gridName = vueObj.WIDGET.record._meta.name
                    if (typeof gridName === 'string' && gridName.endsWith('-cells')) {
                        const cellA = di1?.attr || di1
                        const parentWIDGET = vueObj.store.findWidget(vueObj.WIDGET.parentWIDGET?.id)?.WIDGET
                        const baseName = gridName.slice(0, -('-cells'.length))
                        // клоны полос регистрируются под тем же именем — берём видимый с колонками
                        const okGrid = v => v?.flex?.hostElement && v.flex.columns?.length && v.flex.hostElement.offsetParent
                        let tplGrid_vueObj = parentWIDGET?.vueObj?.get_vueObj?.(baseName)
                        if (!okGrid(tplGrid_vueObj)) {
                            tplGrid_vueObj = Object.values(parentWIDGET?.attrs_vueObj || {}).find(v => v?.attr?.name === baseName && okGrid(v)) || tplGrid_vueObj
                        }
                        if (tplGrid_vueObj?.flex && cellA?.row) {
                            const rr = cellA.row - 1
                            let cc = tplGrid_vueObj.flex.selectedRanges?.[0]?.col ?? 0
                            if (cellA.col) {
                                const idx = [...tplGrid_vueObj.flex.columns].findIndex(c2 => c2.binding === 'col_' + cellA.col)
                                if (idx >= 0) cc = idx
                            }
                            if (rr >= 0 && rr < tplGrid_vueObj.flex.rows.length) {
                                tplGrid_vueObj.ignore_selectionChanged = true
                                tplGrid_vueObj.flex.selection = new wjGrid.CellRange(rr, cc)
                                tplGrid_vueObj.flex.scrollIntoView(rr, cc)
                                tplGrid_vueObj.ignore_selectionChanged = false
                            }
                        }
                        return
                    }
                    const colBinding1 = di1?.binding || di1?.attr?.binding
                    const colBinding2 = di2?.binding || di2?.attr?.binding
                    if (colBinding1) {
                        const parentWIDGET = vueObj.store.findWidget(vueObj.WIDGET.parentWIDGET?.id)?.WIDGET
                        const gridName = vueObj.WIDGET.record._meta.name
                        const parentGrid_vueObj = parentWIDGET?.vueObj?.get_vueObj(gridName)
                        if (parentGrid_vueObj?.flex) {
                            if (parentGrid_vueObj.attr?.attr_type === 'AttrTabGrid') {
                                // flex жив, но rows/columns нет у диспознутого/не смонтированного
                                // грида (родительский виджет стоит на другом табе) — Array.from
                                // ронял открытие карточки строки (ODOO-3720)
                                const rows = parentGrid_vueObj.flex.rows || []
                                const row1 = Array.from(rows).find(r => r.dataItem?.attr?.binding === colBinding1 || r.dataItem?.binding === colBinding1)
                                const row2 = colBinding2 ? Array.from(rows).find(r => r.dataItem?.attr?.binding === colBinding2 || r.dataItem?.binding === colBinding2) : row1
                                if (row1 != null) {
                                    const rMin = Math.min(row1.index, row2?.index ?? row1.index)
                                    const rMax = Math.max(row1.index, row2?.index ?? row1.index)
                                    const currentCol = parentGrid_vueObj.flex.selectedRanges?.[0]?.col ?? 0
                                    parentGrid_vueObj.ignore_selectionChanged = true
                                    parentGrid_vueObj.flex.selection = new wjGrid.CellRange(rMin, currentCol, rMax, currentCol)
                                    parentGrid_vueObj.flex.scrollIntoView(rMin, 0)
                                    parentGrid_vueObj.ignore_selectionChanged = false
                                }
                            } else {
                                const cols = parentGrid_vueObj.flex.columns || []
                                const col1 = Array.from(cols).find(c => c.binding === colBinding1)
                                const col2 = colBinding2 ? Array.from(cols).find(c => c.binding === colBinding2) : col1
                                if (col1 != null) {
                                    const cMin = Math.min(col1.index, col2?.index ?? col1.index)
                                    const cMax = Math.max(col1.index, col2?.index ?? col1.index)
                                    parentGrid_vueObj.ignore_selectionChanged = true
                                    const currentRow = parentGrid_vueObj.flex.selectedRanges?.[0]?.row ?? 0
                                    parentGrid_vueObj.flex.selection = new wjGrid.CellRange(currentRow, cMin, currentRow, cMax)
                                    parentGrid_vueObj.flex.scrollIntoView(currentRow, cMin)
                                    parentGrid_vueObj.ignore_selectionChanged = false
                                }
                            }
                        }
                    }
                } else if (!rowStale && vueObj.store.activeWIDGET === vueObj.WIDGET && globalViewParams_meta && vueObj.WIDGET.widget !== 'widget-row' && (String(globalViewParams_meta.binding || '').replace(/\[\d+\]\.attrs$/, '') !== String(vueObj.attr.binding || '').replace(/\[\d+\]\.attrs$/, '') || WRow_global.parentWIDGET?.id !== vueObj.WIDGET.id)) {
                    // только грид, с которым пользователь взаимодействует прямо сейчас
                    // (activeWIDGET), вправе перецепить общий viewParams-Row на себя —
                    // иначе фоновый грид уводит только что открытый чужой Row (звено A)
                    const attr_col = vueObj.get_attr_col(flex.selectedRanges[0].col)
                    if (attr_col?.binding) {
                        const actionMenu = { command: 'widget_open', 'widget': 'widget-row', 'type': 'widget-row-viewParams', 'binding': vueObj.attr.binding, 'source_name': vueObj.attr.name, 'get_Parent': true, 'open_in_children_widget': true }
                        vueObj.store.executeStoreMethod(vueObj.WIDGET.vueObj, actionMenu, vueObj.attr)
                    }
                } else if (!rowStale && vueObj.attr.widgetRow_params?.auto_open && vueObj.store.activeWIDGET === vueObj.WIDGET) {
                    const col = flex.columns[flex.selectedRanges[0]?.col]
                    const attr_col = col ? vueObj.attr_by_binding[col.binding] : null
                    // _noActivate: обновление Row вслед за выделением — не красть
                    // активность у грида, по которому пользователь кликает
                    // IE 2026 09 23 / ODOO-341407: i18n
                    const actionMenu = { 'tooltip': t('Open line'), 'action_name':'action-front-openLine-2025-12-27', command:'widget_open', 'widget':'widget-row', '_noActivate':true, 'get_currentRow':true, 'get_Parent':true, 'open_in_children_widget':true, 'cssClass':'pi p-button-white pi-pencil', 'binding':vueObj.attr.binding, attrs:vueObj.attr.attrs, widgetRow_params:vueObj.attr.widgetRow_params }
                    if (attr_col?.attr_type === 'AttrGrid') {
                        actionMenu.activeAttr = { binding: attr_col.binding }
                    }
                    vueObj.store.executeStoreMethod(vueObj.WIDGET.vueObj, actionMenu, vueObj.attr)
                }
            
                // IE 2026 09 27 / ODOO-5800: только выбор пользователя, не программное выделение (setSelUser_skip, fe.ux.setSelectorsUserOnly)
                if (vueObj.attr.setSelectors_AfterSelectionChanged && !vueObj.setSelUser_skip(setSelMark, flex)) {
                    vueObj.setSelectors_fromSelection(flex)   // IE 2026 10 25 / ODOO-348730: блок вынесен в метод — его же зовёт клик по уже выделенной строке (setSelectors_clickTry)
                }

                // IE 2026 08 18 / ODOO-5555 (заказ Игоря): расшифровочные виджеты с
                // refresh открыты на странице — спросить у бэка фильтры новой ячейки
                // (open/drilldown_refresh, без спиннера и без отмены текущих запросов);
                // бэк вернёт where_key — фронт обновит цели только при изменении
                vueObj.drilldownWidgets_onSelection(flex)
            }, 200)
        },
        // IE 2026 09 30 / ODOO-343433: клик по строке основного грида отчёта → store.pageGotoChip (конфиг doc.params.row_click, utils/pageGotoChip.js). По умолчанию
        // (trigger 'row_header') — обычный ЛКМ по заголовку строки (номер слева): одиночный клик по ячейке (форма ячейки ROW/CELL) остаётся как был; trigger 'cell' — клик по
        // ячейке данных (колонка row_click.column либо любая; не по ячейке, доступной для правки, если колонка не названа). Не по итогу / строке сравнения / полосе, не по
        // ссылке-иконке, кнопке, флажку, глифу дерева и полю ввода, не при открытом редакторе, не с Alt / Ctrl / Shift (открытие по значению, выделение диапазона).
        // true — клик обработан
        rowClickGoto_try(e, row, col, isHeader = false) {
            if (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return false
            if (this.attr?.name !== 'dataSheet' && this.attr?.binding !== '_doc.data') return false
            const flex = this.flex
            const cfg = pageGotoChip_config(this.WIDGET?.record?.doc?.params)
            if (!cfg || !flex || flex.activeEditor) return false
            if ((cfg.trigger === 'cell') === isHeader) return false   // заголовок строки — trigger row_header; ячейка данных — cell
            const tg = e.target
            if (tg?.closest?.('button, input, textarea, select, .cell-link, .cell-source-link, img.cell-thumb, .wj-elem-collapse, .pi, [id^="on"]') || (typeof tg?.className === 'string' && tg.className.includes('glyph'))) return false
            const rowObj = flex.rows[row], dataItem = rowObj?.dataItem
            if (!dataItem || rowObj.visible === false || !pageGotoChip_rowIsData(dataItem)) return false
            const binding = isHeader ? '' : String(flex.columns[col]?.binding || '')
            if (!pageGotoChip_columnOk(cfg, binding)) return false
            if (!isHeader && !cfg.column) {
                let editable = false
                try { editable = !flex.isReadOnly && !this.get_viewParam('isReadOnly') && this.is_editable({ row, col }) } catch (err) { editable = false }
                if (editable) return false
            }
            e.preventDefault?.()
            let display   // подпись значения — то, что показано в ячейке колонки row_binding (id → «ITEM-003»)
            try {
                const ci = flex.columns.findIndex(c => String(c.binding || '') === cfg.row_binding)
                const txt = ci >= 0 ? String(flex.getCellData(row, ci, true) ?? '').trim() : ''
                if (txt) display = txt
            } catch (err) { /* без подписи — id */ }
            // IE 2026 09 30 / ODOO-343433: переход — ПОСЛЕ того, как событие клика доиграет: наш слушатель стоит на хосте грида, а activateWidget / clickWidget виджета-источника
            // (focusIn, @click оболочки) идут следом в том же событии и через widget_activate возвращали store.activeWORKSPACE на стол источника — переход на уже загруженный другой
            // стол «съедался». Замер: активации виджета — в пределах 10 мс от клика, дальше их нет; таймер 0 = следующая задача после диспетчеризации клика (без магических мс)
            const store = this.store, WIDGET = this.WIDGET
            setTimeout(() => { try { store.pageGotoChip(WIDGET, cfg, dataItem, display) } catch (err) { console.warn('pageGotoChip', err) } }, 0)
            return true
        },
        drilldownWidgets_onSelection(flex) {
            const vueObj = this
            const W = vueObj.WIDGET
            if (!W?.record?.doc?.params?.drilldown_widgets?.length) return
            if (vueObj.attr.name !== 'dataSheet' && vueObj.attr.binding !== '_doc.data') return
            if (vueObj.store.activeWIDGET !== W) return // только грид, по которому кликает пользователь
            if (W.loading) return // отчёт сам перестраивается — фильтры ячейки спросим после
            if (vueObj._dd_fromWorkspace) return // выделение пришло с шины страницы, не от пользователя
            const sel = flex?.selection
            if (!sel || sel.row < 0 || sel.col < 0) return
            const key = `${sel.row}:${sel.col}:${sel.row2}:${sel.col2}`
            if (vueObj._dd_lastSel === key) return // та же ячейка — фильтры не менялись
            vueObj._dd_lastSel = key
            if (!vueObj.store.drilldown_hasOpenTargets(W)) return
            vueObj.store.executeStoreMethod(W.vueObj, {
                command: 'executeWidgetMethod', method: 'open', method2: 'drilldown_refresh',
                get_selectedRanges: true, record_sendToBackend_exclude: ['_doc'],
                binding: '_doc.data', source_name: vueObj.attr.name,
                no_del_last_backend_action: true, // без спиннера/отмены запросов отчёта
            }, vueObj.attr)
        },

        use_selectorMeasures() {
            if (this.WIDGET.record?.params?.use_selectorMeasures && this.attr.use_selectorMeasures) {
                let selectedMeasures = {}
                this.flex.rows.forEach((item, index) => {
                    if (item.dataItem?.measure) {
                        selectedMeasures[item.dataItem.measure] = item.dataItem.selector
                    }
                })
                
                this.store.use_selectorMeasures(this.WIDGET, selectedMeasures)
            }
        },

        //--------------------------------- dropdown ---------------------------------
        // IE 2026 09 22 / ODOO-5800 (Igor: «показывать форму-дропдаун при первом клике по ячейке … опция для таблицы, по умолчанию вкл для основной
        // таблицы отчётов»): опция грида cellForm_onClick (настройки таблицы › Rows › «Cell form on click»; без сохранённого значения — вкл у главной
        // таблицы отчёта WIDGET-REPORT2 / dataSheet, выкл у остальных гридов). Выключатель на всё приложение fe.ux.cellFormOnClick
        // IE 2026 09 22 / ODOO-5800 (Igor, п. 5: «сделай открытие в свободном виде — по умолчанию для основной таблицы отчётов (т. е. это настройка элемента)»): режим отсоединённой
        // формы ячейки — viewParams <грид>.cellForm_detached; без сохранённого значения — вкл только у главной таблицы отчёта; выключатель на всё приложение fe.ux.cellFormDetached
        cellForm_detachedOn() {
            if (this.store.setting('fe.ux.cellFormDetached', true) === false || this.attr?.isPrint || this.attr?.isPrintTemplate) return false
            const def = this.attr?.name === 'dataSheet' && this.WIDGET?.record?.segment === 'WIDGET-REPORT2'
            const v = this.get_viewParam('cellForm_detached', def)
            return v === true || v === 'true'
        },
        // ссылка на ячейку в шапке отсоединённой формы: измерения строки (первые непустые колонки до колонок-дат) · период / заголовок колонки
        cellForm_anchorText(irow, icol) {
            const flex = this.flex; if (!flex) return ''
            const parts = []
            for (let c = 0; c < flex.columns.length && parts.length < 3; c++) {
                const col = flex.columns[c]; if (!col.visible || /^\d{4}-\d{2}-\d{2}/.test(col.binding || '')) continue
                const v = String(flex.getCellData(irow, c, true) ?? '').trim(); if (v && !/^[\d\s.,%−-]+$/.test(v)) parts.push(v.length > 24 ? v.slice(0, 23) + '…' : v)   // числа (итоги, номера) — не измерения
            }
            const col = flex.columns[icol]; const b = String(col?.binding || ''); const m = /^(\d{4}-\d{2})/.exec(b)
            const colT = m ? m[1] : String(col?.header || b).replace(/\s+/g, ' ').trim().slice(0, 24)
            let val = String(flex.getCellData(irow, icol, true) ?? '').trim()   // IE 2026 09 24 / ODOO-5800: let — под отбором подменяется показанным итогом (ниже)
            // IE 2026 09 24 / ODOO-5800 (Igor: форма на 58:27 под поиском «PSP Pharma Ltd» — в якоре был итог по всем строкам 31 633): getCellData читает значение строки данных;
            // в ячейке группы под отбором показан итог по отбору — якорь пишет его же и итог по всем строкам в скобках (подпись та же, что в подсказке ячейки). Опция fe.ux.filterTotalsAllPaths
            const _fs = this.filterTotals_shown(flex.rows[irow]?.dataItem, b)
            const _fa = _fs ? this.attr_by_binding[b] : null
            if (_fa && _fa.attr_type === 'AttrNumber') {
                const _fmt = (x) => { const n = Number(x); return (x === null || x === undefined || x === '' || Number.isNaN(n)) ? '' : wjcCore.Globalize.format(n, _fa.format || col?.format || 'n0') }
                const _all = _fmt(_fs.all)
                val = [_fmt(_fs.v), _all ? t('(all rows: {value})', { value: _all }) : ''].filter(Boolean).join(' ')
            }
            return [parts.join(' / '), colT, val].filter(Boolean).join(' · ')
        },
        cellForm_onClickOn() {
            if (this.store.setting('fe.ux.cellFormOnClick', true) === false || this.attr?.isPrint || this.attr?.isPrintTemplate) return false
            const def = this.attr?.name === 'dataSheet' && this.WIDGET?.record?.segment === 'WIDGET-REPORT2'
            const v = this.get_viewParam('cellForm_onClick', def)
            return v === true || v === 'true'
        },
        // IE 2026 10 07 / ODOO-5800 (Igor: форма на замороженной атрибутной ячейке не идёт за стрелками): выделение внутри объединённого блока (mergeColumns: ячейки строки объединены по колонкам, wijmo ставит
        // курсор на колонку под мышью / стрелкой, например 5) не имеет своего элемента в divCells (элемент — под корнем диапазона), а значение (название строки) лежит не в корне — поэтому форма никуда не переезжала. Цель — колонка диапазона, в которой есть
        // значение (сначала выбранная, потом слева направо), элемент — корень диапазона. Не объединённая ячейка — как прежде (свой элемент в divCells)
        cellForm_target(flex) {
            const sel = flex?.selectedRanges?.[0]; if (!sel) return null
            const type = flex.cells.cellType, row = Math.max(sel.row, sel.row2); let col = Math.min(sel.col, sel.col2)
            if (row < 0 || col < 0) return null
            let divCell = this.divCells.get(`${type}-${row}-${col}`)
            {   // и когда у корня диапазона свой элемент (колонка 0), а значение лежит в другой колонке блока (название строки в колонке 1)
                try {
                    const mr = flex.getMergedRange(flex.cells, row, col)
                    if (mr && mr.col2 > mr.col) {
                        const di = flex.rows[row]?.dataItem
                        const has = (c) => { const at = this.attr_by_binding[flex.columns[c]?.binding]; if (!di || !at) return false; let v = this.store.get_value(di, at.binding); if (at.attr_type === 'AttrMulti') v = v?.value; return !(v == null || v === '') }
                        const cands = [col]; for (let c = mr.col; c <= mr.col2; c++) if (c !== col) cands.push(c)
                        col = cands.find(has) ?? col
                        divCell = this.divCells.get(`${type}-${row}-${col}`) || this.divCells.get(`${type}-${row}-${mr.col}`) || divCell || flex.cells.getCellElement(row, col)
                    }
                } catch (e) { /* грид в перестройке */ }
            }
            return { row, col, divCell: divCell && divCell.isConnected ? divCell : null }
        },
        dropdown_showForActiveCell(opts = null) {
            const vueObj = this,
            dropdown = vueObj.store.dropdown

            if (dropdown.showForActiveCell_timerId) { clearTimeout(dropdown.showForActiveCell_timerId) }
            dropdown.showForActiveCell_timerId = window.$cg.setTimeout(this, "AttrGrid.dropdown_showForActiveCell", () => {
                this.dropdown_showForActiveCell_afterTimeout(opts)
                dropdown.showForActiveCell_timerId = null
            }, 100)
        },
        dropdown_showForActiveCell_afterTimeout(opts = null) {
            let vueObj = this,
            flex = vueObj.flex,
            isActiveWidget = vueObj.store.activeWIDGET === vueObj.WIDGET && !vueObj.WIDGET.hidden

            // не открываем dropdown автоматически при простом клике/выделении ячейки —
            // только если он уже открыт (перемещение на новую ячейку) или идёт редактирование.
            // Закрытый dropdown пользователь открывает кнопкой-шевроном (onRefToggle__Click).
            // IE 2026 09 22 / ODOO-5800: клик по ячейке при включённой опции cellForm_onClick — открываем (fromClick)
            const fromClick = !!(opts && opts.fromClick)
            {   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: открытая форма следует за выделением): форма, выведенная пользователем, переезжает за выделением (AttrGrid.cellForm_followSel)   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: открытая форма следует за выделением) — FB6b: до ворот «скрытую не показывать» — спрятанная с признаком показывается снова
                const _fw = vueObj._cfFollow; vueObj._cfFollow = null
                if (_fw && vueObj.cellForm_followApply(_fw)) return
            }
            const _ddHere = cellForm_visibleHere({ visible: !!vueObj.store.dropdown.visible, sameGrid: vueObj.store.dropdown.vueObj === vueObj, keepForeign: !!vueObj.store.dropdown.cellForm_keepForeign?.() })   // IE 2026 10 12 / ODOO-5800 (заказ Игоря: форма ячейки не закрывается при открытии из неё записей): форма другого грида, оставленная открытой, здесь «не открыта» — смена выделения её не перетягивает; явное открытие переводит единственную форму сюда
            if (!_ddHere && !flex.activeEditor && !fromClick) return   // IE 2026 10 12 / ODOO-5800 (заказ Игоря: форма ячейки не закрывается при открытии из неё записей): _ddHere вместо store.dropdown.visible
            if (!_ddHere && vueObj.cellForm_onlyByButton()) return   // IE 2026 10 12 / ODOO-5800 (заказ Игоря: форма ячейки не закрывается при открытии из неё записей): _ddHere вместо store.dropdown.visible   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: форма ячейки по 🏷): форму открывает только 🏷 (fe.ux.cellFormOnlyByButton); открытая следует за выделением
            // IE 2026 09 30 / ODOO-343433 (решение Igor, вариант B): явный клик мышью по ячейке — явное намерение, форма открывается снова даже после Esc / ✕;
            // память сеанса (sessionClosed) по-прежнему гасит только автоматический показ (стрелки, переезд выделения); F4 / 🏷 / ✕ — как прежде
            // IE 2026 10 10 / ODOO-5800 (КРИТИЧНОЕ Igor): при флаге fe.ux.cellFormReopenByButton (дефолт ВКЛ) клик память сеанса НЕ снимает — форму, закрытую ✕ / F4 / Esc, открывает только кнопка «Cell form» или F4
            if (cellForm_clickReopens({ fromClick, activeEditor: !!flex.activeEditor, singleCell: cellForm_isSingleCell(flex.selectedRanges?.[0]), reopenByButton: this.store.setting('fe.ux.cellFormReopenByButton', true) !== false })) vueObj.store.dropdown.sessionOpen?.()   // IE 2026 10 10 / ODOO-5800
            // IE 2026 09 26 / ODOO-… (замечания Игоря: форма ячейки): форму закрыл пользователь (✕ / Esc / F4) — в этом сеансе выбор других ячеек её не показывает: ни клик по ячейке (опция «Cell form on click»),
            // ни переезд показанной правкой формы за выделением (прячется, если выделение ушло на другую ячейку); показывают стрелка раскрытия в ячейке и F4
            // (Dropdown.sessionOpen). Правка ячейки — как прежде (её путь — dropdown_prepare с редактором, не этот)
            if ((!flex.activeEditor || this.store.setting('fe.ux.cellFormReopenByButton', true) !== false) && vueObj.store.dropdown.sessionClosed_on?.()) {   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: форма ячейки по 🏷): и в правке ячейки
                const dd = vueObj.store.dropdown, sr = flex.selectedRanges?.[0]
                if (dd.visible && dd.vueObj === vueObj && sr && dd.key !== `${flex.cells.cellType}-${Math.max(sr.row, sr.row2)}-${Math.min(sr.col, sr.col2)}`) dd.hide()
                return
            }

            // dropdown
            if (!flex.disposed && flex.selectedRanges.length && isActiveWidget && vueObj.isVisible) {
                let sel = flex.selectedRanges[0],
                // IE 2026 10 07 / ODOO-5800: ячейка блока mergeColumns (замороженные атрибутные колонки) — цель формы это колонка со значением внутри объединённого диапазона, элемент — корень диапазона
                tg = this.cellForm_target(flex) || { row: -1, col: -1, divCell: null },
                row = tg.row,
                col = tg.col,
                divCell = tg.divCell

                if (row >= 0 && col >= 0 && divCell) {
                    if (fromClick && !_ddHere) {   // IE 2026 10 12 / ODOO-5800 (заказ Игоря: форма ячейки не закрывается при открытии из неё записей): _ddHere вместо store.dropdown.visible
                        if (sel.row !== sel.row2 || sel.col !== sel.col2) return   // протяжка диапазона — не клик по ячейке
                        // как шеврон / F4: форма выводится без правки (dropdown_prepare требует «курсор внутри»)
                        vueObj.store.dropdown.mouse_isInside = true
                        vueObj._cellFormOpens = (vueObj._cellFormOpens || 0) + 1
                    }
                    vueObj.dropdown_prepare({row, col}, divCell, null, true)
                }
            }
        },
        dropdown_prepare(e, divCell, activeEditor=null, check_mouse_isInside=false) {
            // IE 2026 10 31 / ODOO-5800 (заказ Игоря: таблиця форми комірки — на AttrGrid): грид, показанный внутри самой формы ячейки (расшифровка пузыря Heatmap, attr.cellForm_off), форму не открывает —
            // она одна на приложение, и её занятие ячейкой этого грида заменило бы содержимое формы, в которой грид стоит
            if (this.attr?.cellForm_off) return
            const vueObj = this,
            dropdown = vueObj.store.dropdown,
            flex = vueObj.flex

            let col = flex.columns[e.col],
            irow = e.row,
            col_binding = col.binding,
            row = flex.rows[irow],
            dataItem = row.dataItem,
            cell = { 
                irow: irow,
                col_binding: col_binding,
                row: e.row,
                col: e.col
            },
            attr_col = vueObj.attr_by_binding[col_binding],
            V = attr_col,
            value = dataItem ? this.store.get_value(dataItem, attr_col.binding) : null
            if (dataItem && this.rl_is(attr_col)) value = rlShown(dataItem, this._rlCols[attr_col.binding].cfg, this._rlCols[attr_col.binding].src?.index, t).text   // IE 2026 10 25 / ODOO-348925: AttrRowLink — текст листа, не ключ
            if (attr_col.attr_type === 'AttrMulti') {
                V = value
                value = V?.value
                // новая (пустая) строка: значения ещё нет, V = null, а ниже
                // читаются V.relation_* — редактор должен открыться пустым, не падать
                if (!V) V = {}
            }
            // в блоке mergeColumns открываем dropdown только для непустой (ведущей) ячейки
            // IE 2026 10 10 / ODOO-5800 (Igor: «при клике по ячейке в фиксированных колонках форма не перепривязывается — остаётся на прежней строке»; dev02 M03, строка
            // «STR 2028 / M% (1.2)»): правило считало блоком ВСЕ колонки до mergeColumns (8 замороженных) в КАЖДОЙ строке — в SKU-строке замороженные ячейки не объединены,
            // и клик по пустой из них (чекбокс PM без значения, пустые Brand / Nomenclature) обрывал dropdown_prepare до show(): закреплённая форма оставалась у прежней
            // ячейки, присоединённая — пряталась. Теперь пустая ячейка не открывает форму только внутри РЕАЛЬНО объединённого диапазона (getMergedRange шире одной
            // колонки); отдельная пустая ячейка — как в прокручиваемых колонках. Чистая часть — utils/cellFormGate.cellForm_emptyMergedSkip. Выключатель fe.ux.cellFormEmptyFrozen (дефолт ВКЛ; выкл — как раньше)
            {   // IE 2026 10 10 / ODOO-5800
                let _span = 1   // IE 2026 10 10 / ODOO-5800
                try { const _mr = flex.getMergedRange(flex.cells, e.row, e.col); if (_mr) _span = _mr.col2 - _mr.col + 1 } catch (err) { _span = 1 }   // IE 2026 10 10 / ODOO-5800
                if (cellForm_emptyMergedSkip({ col: e.col, mergeCols: Math.max(vueObj.mergeColumnBlocksTotal || 0, vueObj.mergeColumns || 0), value, mergedSpan: _span,
                        nonMergedOpens: this.store.setting('fe.ux.cellFormEmptyFrozen', true) !== false })) return   // IE 2026 10 10 / ODOO-5800
            }   // IE 2026 10 10 / ODOO-5800
            // AttrBool редактируется чекбоксом — dropdown без редактора значения. IE 2026 09 07 / ODOO-5512 (заказ Игоря):
            // инфо-режим (COMMENT / CORRECTION «кто и когда менял» / FORMATS, панели ROW/CELL) — открывается шевроном
            // на ячейке или переездом уже открытого dropdown, но НЕ сам по себе при клике по чекбоксу (wijmo стартует
            // редактор-чекбокс на клик); выключатель — perf-флаг dropdown_bool (дефолт ВКЛ; выкл = как раньше, без dropdown)
            const isBoolInfo = (attr_col.attr_type === 'AttrMulti' ? V?.attr_type : attr_col.attr_type) === 'AttrBool'
            if (isBoolInfo) {
                if (!this.store.perf_flag('dropdown_bool', true)) return
                if (activeEditor && !dropdown.visible) return
                activeEditor = null
            }
            if (this.attr.attr_type === 'AttrTabGrid' && col_binding === 'attr.valueStr' && dataItem?.attr?.attr_type) {
                V = {...dataItem.attr}
                if (V.relation_segment_binding) {
                    V.relation_segment = this.store.get_value(this.WIDGET.record, V.relation_segment_binding)
                    V.relation_segment_binding = null
                }
                if (V.relation_version_binding) {
                    V.relation_version = this.store.get_value(this.WIDGET.record, V.relation_version_binding)
                    V.relation_version_binding = null
                }
                value = V.value
            }
            if (!activeEditor && !isBoolInfo) {   // IE 2026 09 07 / ODOO-5512: чекбокс — режим показа задаёт вызывающий (шеврон / переезд)
                check_mouse_isInside = true
            }

            if (row.isReadOnly !== false) {
                // row.isReadOnly = false
                this.flex_check_isReadOnly()
            }

            const isChangeActiveEditor = dropdown.activeEditor !== activeEditor
            const key = `${this.flex.cells.cellType}-${cell.row}-${cell.col}`
            if (dropdown.key === key && dropdown.divCell === divCell && dropdown.visible && !isChangeActiveEditor) {
                return // already prepared
            }

            dropdown.key = key

            let _cells = null
            if (dataItem?._cells) {
                const raw_binding = col_binding.replace('data::', '')
                _cells = this.store.get_value(dataItem, `_cells.${raw_binding}`)
            }
            dropdown.comment = _cells?.comment || ''
            // IE 2026 08 19 / ODOO-5512 (заказ Игоря п.6): комментарий элемента —
            // из meta.appearance самого элемента (universal appearance списка)
            if (this.attr.elements_appearance && dataItem?._appearance?.comment) {
                dropdown.comment = dataItem._appearance.comment
            }
            if (this.attr.cells_binding && irow >= this.headerRows && e.col >= this.headerColumns) {
                const data_row = irow - this.headerRows + 1
                const data_col = e.col - this.headerColumns + 1
                const cb_cell = this.cells_binding_map[data_row]?.[data_col]
                if (cb_cell?.comment) {
                    dropdown.comment = dropdown.comment
                        ? `${cb_cell.comment}\n\n${dropdown.comment}`
                        : cb_cell.comment
                }
            }
            dropdown.showComment = this.attr.showComment || !!dropdown.comment
            dropdown.isReadOnly = this.get_viewParam('isReadOnly')
            
            
            dropdown.widget_id = this.widget_id
            dropdown.WIDGET = this.WIDGET
            // this.WIDGET.vueObj.get_vueObj.dropdown = this
            dropdown.binding = this.attr.binding
            dropdown.vueObj = vueObj
            dropdown.dataItem = dataItem
            dropdown.valueStr = divCell.innerText
            dropdown.showValue = this.attr.showValue // || !!dropdown.value
            dropdown.valueHTML = ''
            dropdown.itemsSource = []
            dropdown.V = V
            dropdown.attr_col = attr_col
            // IE 2026 09 19 / ODOO-5800 (Igor): формат, связанный с метрикой, показывается МЕТРИКОЙ с флажком чипса метрик (блок METRICS),
            // в блоке FORMATS остаются только форматы без метрики
            const _cfApplied = vueObj.cf_appliedForCell(dataItem, col_binding, attr_col)
            const _previewOf = (classes) => (classes || []).map(c => cfClassDeltaCss(c, vueObj.flex?.hostElement)).join('')
            dropdown.cell_metrics = vueObj.metricCell_list(dataItem, col_binding, attr_col, _cfApplied)
                .map(m => ({ ...m, _previewCss: _previewOf(m.cssClasses) }))
            // IE 2026 09 20 / ODOO-5800 (Igor: «для каждой ячейки иметь привязку к применимым правилам … показать в форме drilldown — применимые правила»): блок RULES — не больше 12 строк, остальное числом
            // IE 2026 09 22 / ODOO-5800 (Igor, скрин: «в ячейке 76/29 форму можно только скрыть — как ни щёлкаю, не срабатывает»): ошибка при сборе блока RULES (ReferenceError в подсказке
            // правила состояния «horizon») обрывала dropdown_prepare до show() — блок RULES в страховке: ошибка в консоль, форма открывается без него
            try { const _cellRules = vueObj.cellRules_forCell(dataItem, col_binding, attr_col); dropdown.cell_rules = _cellRules.slice(0, 12); dropdown.cell_rules_more = Math.max(0, _cellRules.length - 12)
                dropdown.cell_rules_lists = vueObj.cellRules_lists(_cellRules)
                dropdown.cell_rules_current = vueObj.store.setting('fe.ux.cellRulesCurrent', true) !== false }   // IE 2026 09 21 / ODOO-5800 (Igor: бейдж current у правила, по которому выполнены движения ячейки)   // IE 2026 09 20 / ODOO-5800 (Igor через ie-dm7 #32448: команда «открыть список правил» блока RULES формы ячейки)
            catch (e) { console.error('cell form: RULES skipped:', e); dropdown.cell_rules = []; dropdown.cell_rules_more = 0; dropdown.cell_rules_lists = [] }
            const _metricKeys = new Set(dropdown.cell_metrics.map(m => metricKey_base(m.key)))   // IE 2026 09 19 / ODOO-5800 (Igor: измерение horizon в ключе метрики): задание несёт основу ключа
            const _fmtAuto = vueObj.formatAuto_on(), _fmtDoc = _fmtAuto ? vueObj.formatAuto_chipDoc() : null   // IE 2026 09 20 / ODOO-5800 (Igor 20.09: Selector правила и флажок правила в форме ячейки создают чипс оформления)
            dropdown.cf_applied = _cfApplied.filter(t => !(t.metric_key && _metricKeys.has(t.metric_key)))
                .map(t => ({ ...t, _previewCss: _previewOf(t.cssClasses), chip: _fmtAuto && !!t.rule_id, on: !!t.rule_id && formatChip_has(_fmtDoc, t.rule_id) }))
            vueObj.cellPassport_load(dropdown, dataItem, col_binding, irow)   // IE 2026 09 21 / ODOO-5800 (Igor: «стоя на любой ячейке … что здесь произошло»): паспорт ячейки по запросу
            dropdown.correction_info = vueObj.correctionInfo_forCell(dataItem, col_binding, attr_col, irow, _cells, divCell?.innerText || '')
            dropdown.infl_formula = ''; vueObj.influence_toDropdown()   // IE 2026 09 19 / ODOO-… (замечание Игоря: формула расчёта остатка — внутри формы ячейки, когда форма выведена)
            // IE 2026 09 22 / ODOO-5800 (Igor): документы-источники ячейки (спутник doc_ids хвоста doc_links) и число ячеек с теми же документами
            dropdown.cell_docs = vueObj.sameDoc_on() ? vueObj.sameDoc_titles(dataItem, col_binding) : []
            // IE 2026 10 05 / ODOO-5800 (fe-83; проверка dev02: до ответа паспорта 0,8–1,3 с стоял прежний бейдж «Отказ»): паспорт в пути — бейдж статуса документов не показывается
            // (заглушка), статус придёт ответом паспорта (cellPassport_load выше уже выставил cell_passport_loading). Выключатель fe.cellForm.docStatusWait
            dropdown.cell_docs = cellDocs_wait(dropdown.cell_docs, dropdown.cell_passport_loading, vueObj.store.setting(DOC_STATUS_WAIT_FLAG, true))
            dropdown.cell_docs_same = vueObj._sameDoc && vueObj._sameDoc.anchor?.it === dataItem ? vueObj._sameDoc.n : 0
            // IE 2026 09 25 / ODOO-5800 (Igor: «показать-перейти … как в чипсе поиска "<>"»): остановки ‹ › блока DOCUMENTS — с нуля для этой ячейки (число — по видимым строкам грида)
            dropdown.sameNav_pos = 0
            dropdown.sameNav_total = dropdown.cell_docs_same ? (vueObj.sameDocNav_list()?.list.length || 0) : 0
            // IE 2026 09 22 / ODOO-5800 (Igor, п. 5): режим отсоединённой формы для этого грида и ссылка на ячейку в её шапке
            dropdown.pin_init?.(vueObj)
            dropdown.anchor_cell = { row: irow, col: e.col }
            dropdown.anchor_text = vueObj.cellForm_anchorText(irow, e.col)
            dropdown.parent_attr = {...vueObj.attr, attr_col:V, attr_col2:attr_col, cell:cell}
            dropdown.cg_cell = (vueObj.attr?.cg_matrix && typeof vueObj.$parent?.cgRowCards === 'function') ? { owner: vueObj.$parent, vm: dataItem, col: attr_col?.binding || '' } : null   // IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — форма ячейки со строками и правкой): ячейка шахматки — блок «Рядок / Вузол / Колонка» у обёртки AttrCrossGrid
            dropdown.items = []
            dropdown.cmOptions_dropdown = null
            dropdown.dropdown_type = 'AttrStrMulti'
            dropdown.items_can_loadFull = false
            dropdown.items_show_list = false

            const _idSrc = (this.attr.attr_type === 'AttrTabGrid' && col_binding === 'attr.valueStr' && dataItem?.attr?.attr_type) ? (this.WIDGET.record || {}) : dataItem   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #115712, слово Igor: relation_row — переход к шагу согласования) (ТЗ п.3)
            dropdown.relation_id = V.relation_id_binding ? this.store.get_value(_idSrc, V.relation_id_binding) : V.value   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #115712, слово Igor: relation_row — переход к шагу согласования): _idSrc (было dataItem)
            dropdown.relation_row = this.relationRow_cellTarget(V, attr_col, _idSrc)   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #115712, слово Igor: relation_row — переход к шагу согласования): «→» — переход к строке табличной части другой записи
            dropdown.relation_segment = V.relation_segment_binding ? this.store.get_value(dataItem, V.relation_segment_binding) : V.relation_segment
            dropdown.relation_version = V.relation_version_binding ? this.store.get_value(dataItem, V.relation_version_binding) : V.relation_version

            // IE 2026 09 04 / ODOO-336283 (заказ Игоря): в форме записи (AttrTabGrid) тип редактора — по типу ПОЛЯ
            // (V.attr_type), а не колонки значений: поле Style (AttrCSS) открывается полноценным CSS-редактором
            // с палитрой/карандашом, как колонка Style в гриде полей
            // IE 2026 09 10 / ODOO-… (заказ Игоря): и для даты / длительности — календарь и составной выбор в дропдауне
            let _editorType = (this.attr.attr_type === 'AttrTabGrid' && col_binding === 'attr.valueStr' && (V?.attr_type === 'AttrJSON' || V?.attr_type === 'AttrCSS' || V?.attr_type === 'AttrDate' || V?.attr_type === 'AttrTime'))
                ? V.attr_type : attr_col.attr_type
            // IE 2026 09 10 / ODOO-… (замечание Игоря): грид Params / Fields mapping (AttrGrid, колонка-AttrMulti «attr»:
            // строка — само поле со своим типом; Игорь открыл шеврон на Start date отчёта — календаря не было):
            // для даты / длительности редактор тоже по типу ПОЛЯ, значение — сырое attr.value
            if (this.attr.attr_type !== 'AttrTabGrid' && (col_binding === 'attr' || col_binding === 'attr.valueStr')
                    && (dataItem?.attr?.attr_type === 'AttrDate' || dataItem?.attr?.attr_type === 'AttrTime')) {
                _editorType = dataItem.attr.attr_type
                if (attr_col.attr_type !== 'AttrMulti') value = dataItem.attr.value
            }
            // ячейка, типизированная СТРОКОЙ как длительность (мера отчёта / transpose) — как в cellEditEnding2
            let _durAttrDD = null
            if (_editorType !== 'AttrTime') {
                try { _durAttrDD = this.editCell_durationAttr(dataItem, col_binding, attr_col) } catch (e) { _durAttrDD = null }
                if (_durAttrDD?.attr_type === 'AttrTime') _editorType = 'AttrTime'
            }
            if (_editorType === 'AttrJSON') {
                dropdown.dropdown_type = 'AttrJSON'
                dropdown.value = value // vueObj.store.JS_stringify(value || {}, 3)
                dropdown.cmOptions_dropdown = { mode: { name: 'javascript', json: true }, theme: 'neo', lineNumbers: true, smartIndent: true, indentUnit: 4, styleActiveLine: true }
                dropdown.showValue = true
                dropdown.showComment = false
            } else if (_editorType === 'AttrCSS') {
                dropdown.dropdown_type = 'AttrCSS'
                dropdown.value = value // Object.entries(value || {}).map(([k, v]) => `${k}: ${v};`).join('\n')
                dropdown.cmOptions_dropdown = { mode: 'css', theme: 'neo', lineNumbers: true, smartIndent: true, indentUnit: 4, styleActiveLine: true }
                dropdown.showValue = true
                dropdown.showComment = false
            } else if ((_editorType === 'AttrDate' || _editorType === 'AttrTime') && !String(value ?? '').startsWith('=')) {
                // IE 2026 09 10 / ODOO-… (заказ Игоря): ячейка даты — календарь с подсветкой текущего значения; ячейка
                // длительности (AttrTime, секунды) — месяцы / дни / часы / минуты; выбор пишет значение через onEditFinish
                // (тот же путь, что ручной ввод: cellEditEnding2 → parseDate / parseTime)
                dropdown.dropdown_type = _editorType
                dropdown.value = value == null ? '' : String(value)
                dropdown.durationAttr = _editorType === 'AttrTime' ? (_durAttrDD || this.durationAttr_merge(attr_col, V)) : null
                dropdown.showValue = true
            } else {
                dropdown.value = String(value)
            }
            if (isBoolInfo) {
                // IE 2026 09 07 / ODOO-5512: чекбокс — без редактора значения (единственный редактор — сам чекбокс)
                dropdown.showValue = false
                dropdown.showValueHTML = false
            }

            if (String(value || '').startsWith('=') && !dropdown.showValue) {
                dropdown.showValue = true
            }

            // console.log(divCell)

            const old_divCell = dropdown.divCell,
            old_activeEditor = dropdown.activeEditor
            dropdown.divCell = divCell
            dropdown.activeEditor = activeEditor
            dropdown.is_editable = this.is_editable(e)

            this.dropdown_setItems(null, value)
            this.dropdown_menu(e)

            // dropdown.hide() 2025-12-24

            // mouseenter
            if (dropdown.divCell !== old_divCell) {
                if (old_divCell) {
                    try {
                        old_divCell.removeEventListener('mouseenter', dropdown.mouseenter)
                    } catch (error) { 
                        console.error(error) 
                        this.store.show_notification({ text: error.message, status: 'error' })
                    }
                }
                dropdown.divCell.addEventListener('mouseenter', dropdown.mouseenter)
            }

            // mouseleave
            if (dropdown.divCell !== old_divCell) {
                if (old_divCell) {
                    try {
                        old_divCell.removeEventListener('mouseleave', dropdown.mouseleave)
                    } catch (error) { 
                        console.error(error) 
                        this.store.show_notification({ text: error.message, status: 'error' })
                    }
                }
                dropdown.divCell.addEventListener('mouseleave', dropdown.mouseleave)
            }

            // input
            if (isChangeActiveEditor) {
                if (old_activeEditor && dropdown.input) {
                    try {
                        old_activeEditor.removeEventListener('input', dropdown.input)
                    } catch (error) { 
                        console.error(error) 
                        this.store.show_notification({ text: error.message, status: 'error' })
                    }
                }
                dropdown.input = null
                // dropdown.onSelect = null
                // dropdown.onEditFinish = null
                // dropdown.set_comment = null
                
                if (dropdown.activeEditor) {
                    dropdown.valueStr = dropdown.activeEditor.value

                    dropdown.input = (event) => vueObj.dropdown_setItems(event)
                    dropdown.activeEditor.addEventListener('input', dropdown.input.bind(vueObj))

                }
            }

            const isChangeAttr = dropdown.parent_Vue !== this
            if (isChangeAttr) {
                dropdown.parent_Vue = this

                dropdown.onSelect = (item) => {
                    vueObj.choiceFinish(dropdown.parent_attr, item)
                }
                dropdown.onMore = (searchText) => {
                    vueObj.onMore_dropdown(dropdown.parent_attr.cell, searchText)
                }
                dropdown.onLoadFull = () => {
                    vueObj.onLoadFullItemsSource__Click(dropdown.parent_attr.cell)
                }
                dropdown.onOpenList = () => {
                    vueObj.onOpenListItemsSource__Click()
                }
                dropdown.onEditFinish = (value) => {
                    vueObj.onEditFinish(dropdown.parent_attr, value)
                }
                dropdown.set_comment = (comment) => {
                    vueObj.set_comment(dropdown.parent_attr, comment)
                }
            }

            // keydown
            if (isChangeActiveEditor) {
                if (old_activeEditor && dropdown.input) {
                    try {
                        old_activeEditor.removeEventListener('keydown', dropdown.keydown)
                    } catch (error) { 
                        console.error(error) 
                        this.store.show_notification({ text: error.message, status: 'error' })
                    }
                }
                dropdown.keydown = null
             
                if (dropdown.activeEditor) {
                    dropdown.keydown = (event) => vueObj.dropdown_keydown(event)
                    dropdown.activeEditor.addEventListener('keydown', dropdown.keydown.bind(vueObj))
                    // }, { once: true })
                }
            }

            // blur
            if (isChangeActiveEditor) {
                if (old_activeEditor) {
                    try {
                        old_activeEditor.removeEventListener('blur', dropdown.blur)
                    } catch (error) { 
                        console.error(error) 
                        this.store.show_notification({ text: error.message, status: 'error' })
                    }
                }
                if (dropdown.activeEditor) {
                    dropdown.activeEditor.addEventListener('blur', dropdown.blur)
                }
            }

            // For bytes format: always show raw numeric value in dropdown
            if (V?.format === 'bytes' && value != null && typeof value === 'number') {
                dropdown.value = String(value)
            }

            // IE 2026 10 12 / ODOO-343342 (заказ Игоря: форма ячейки по 🏷): вход в правку (dblclick, F2, ввод символа) форму сам не открывает — только 🏷 (fe.ux.cellFormOnlyByButton; выкл — прежнее
            // автооткрытие, но форму, закрытую пользователем, правка не открывает: fe.ux.cellFormReopenByButton). Исключение — подбор значений ссылочной ячейки
            // (тот же признак, что у списка dropdown_setItems: AttrLink / AttrMulti со справочником): список подбора — в форме, он открывается как прежде.
            // Слушатели редактора (ввод, ↓ / Enter списка) привязаны выше — ↓ в редакторе по-прежнему открывает список явно (dropdown_keydown)
            if (activeEditor) {   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: форма ячейки по 🏷)
                // IE 2026 10 15 / ODOO-345813 (заказ Игоря: Scope в новой строке грида списка окон — список по клику): подбор — и у колонки со статическим списком
                // (attr.itemsSource / use_itemsSourcesView), не только relation_segment — тот же признак, по которому dropdown_setItems строит список; флаг fe.ux.cellFormPickStaticList
                const _refPick = cellForm_refPick({ dropdownType: dropdown.dropdown_type, editable: !!dropdown.is_editable, attrType: this.rl_is(attr_col) ? 'AttrLink' : attr_col.attr_type,   // IE 2026 10 15 / ODOO-345813; IE 2026 10 25 / ODOO-348925: AttrRowLink — подбор как у ссылки
                    relationSegment: V?.relation_segment || attr_col?.relation_segment || '',   // IE 2026 10 15 / ODOO-345813
                    itemsSourceLen: (Array.isArray(V?.itemsSource) ? V.itemsSource.length : 0) || (Array.isArray(attr_col?.itemsSource) ? attr_col.itemsSource.length : 0),   // IE 2026 10 15 / ODOO-345813
                    itemsSourcesView: !!(V?.use_itemsSourcesView || attr_col?.use_itemsSourcesView),   // IE 2026 10 15 / ODOO-345813
                    staticList: this.store.setting('fe.ux.cellFormPickStaticList', true) !== false })   // IE 2026 10 15 / ODOO-345813
                if (!cellForm_editOpens({ visible: !!dropdown.visible, refPick: _refPick, explicit: !!vueObj._cellFormExplicit, onlyByButton: vueObj.cellForm_onlyByButton(),
                        sessionClosed: !!dropdown.sessionClosed_on?.(), reopenByButton: this.store.setting('fe.ux.cellFormReopenByButton', true) !== false })) {   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: форма ячейки по 🏷)
                    vueObj._cellFormEditKept = (vueObj._cellFormEditKept || 0) + 1   // счётчик для проб   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: форма ячейки по 🏷)
                    return   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: форма ячейки по 🏷)
                }   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: форма ячейки по 🏷)
            }   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: форма ячейки по 🏷)
            dropdown.show(check_mouse_isInside)
            // chevron is refreshed by the dropdown.visible/key watcher in mounted()
        },
        dropdown_menu(e) {
            const vueObj = this,
            dropdown = vueObj.store.dropdown,
            flex = vueObj.flex,
            V = dropdown.V,
            attr_col = dropdown.attr_col,
            value = dropdown.value

            //--------------------------------- record ---------------------------------
            dropdown.commandPanel_row = []
            // let dblclick_action = this.get_dblclick_action(false)
            // if (dblclick_action) {
            //     dblclick_action = { ...dblclick_action, title: '' } // TEMP
            //     dropdown.commandPanel_row.push(dblclick_action)
            // }

            for (const attrMenu of this.WIDGET.groupMenu?.commandPanel || []) {
                if (attrMenu.binding === this.attr.binding && (attrMenu.dblClick || attrMenu.isRowCommand)) {
                    dropdown.commandPanel_row.push(attrMenu)
                }
            }
            for (const attrMenu of this.attr.groupMenu?.commandPanel || []) {
                if (attrMenu.dblClick || attrMenu.isRowCommand) {
                    dropdown.commandPanel_row.push(attrMenu)
                }
            }

            for (const attrMenu of this.WIDGET.groupMenu?.actionMenu || []) {
                if (attrMenu.binding === this.attr.binding && (attrMenu.dblClick || attrMenu.isRowCommand)) {
                    dropdown.commandPanel_row.push(attrMenu)
                }
            }
            for (const attrMenu of this.attr.groupMenu?.actionMenu || []) {
                if (attrMenu.dblClick || attrMenu.isRowCommand) {
                    dropdown.commandPanel_row.push(attrMenu)
                }
            }

            let get_openline_action = this.get_openline_action()
            if (get_openline_action) {
                dropdown.commandPanel_row.push(get_openline_action)
            }
            // IE 2026 10 09 / ODOO-345618 (F2): пункт «Approval» панели ROW — действия этой строки (approval.actions бэка), каждое над единицей строки; у строк вне цикла пункта нет
            const _apprRowMenu = this.approval_rowMenu(flex?.rows?.[e.row]?.dataItem)
            if (_apprRowMenu) dropdown.commandPanel_row.push(_apprRowMenu)

            if (this.attr.childItemsPath && this.attr.attr_type !== 'AttrTabGrid') {
                // IE 2026 09 23 / ODOO-341407: i18n (tooltip кнопок дропдауна — до конца сборки commandPanel_cell)
                dropdown.commandPanel_row.push({'tooltip': t('Show child items for the selected row'), 'attr_type':'AttrButton',command:'executeVueObjMethod', 'method':'onSet_parentDataItem', 'cssClass':'pi-sign-in'})
            }

            // if (dropdown.commandPanel_row.length) {
            //     dropdown.commandPanel_row.push({autoGeneratedButton:true})
            // }

            //--------------------------------- cell ---------------------------------
            dropdown.commandPanel_cell = []
            if (!String(value).startsWith('#') && !String(value).startsWith('=')) {
                // if (flex.getCellData(e.row, e.col)) { // attr_col.buttons?.search && 
                //     dropdown.commandPanel_cell.push({'tooltip': 'Search', 'attr_type':'AttrButton',command:'executeVueObjMethod', 'method':'onButtonSearch__Click', 'cssClass':'pi-search'})
                // }

                const relation_segment = dropdown.relation_segment
                if (dropdown.relation_row && e.row >= this.headerRows) {   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #115712, слово Igor: relation_row — переход к шагу согласования): у колонки relation_row и строка подходит — одна «→» с подсказкой, куда ведёт
                    dropdown.commandPanel_cell.push({'tooltip': t('Open'), 'attr_type':'AttrButton', command:'executeVueObjMethod', 'method':'onButtonOpen__Click', 'cssClass':'pi-arrow-right',
                        uiHelp: 'grid.cellForm.cell.openRelationRow', uiHelpVars: relationRow_helpVars(dropdown.relation_row)})
                } else if (V && (relation_segment || V.attr_type === 'AttrMulti' || V.attr_type === 'AttrLink' || V.attr_type === 'AttrLinkOdoo') && e.row >= this.headerRows ) {
                    let pi = 'pi-arrow-right'
                    if (relation_segment && (relation_segment.startsWith('SEGMENTS') || relation_segment.startsWith('DATA-SOURCE'))) {
                        // pi = 'pi-folder'
                        dropdown.commandPanel_cell.push({name:'button-Records-cell1', 'tooltip': t('Records'), 'binding':'_doc.data', 'action_name':'action-front-20241125',uiHelp: 'grid.cellForm.cell.records',command:'widget_open', 'widget':'widget-list', 'cssClass':'pi p-button-white pi-folder-open',
                            fieldsMapping:[
                                {'leftValue':'doc.params.segment', 'rightValue':value},
                            ],
                        })
                    }
                    if (V.buttons?.none) {
                        // pass
                    } else if (V.isReadOnly || dropdown.isReadOnly || V.attr_type === 'AttrLinkOdoo') {
                        if (flex.getCellData(e.row, e.col)) {
                            dropdown.commandPanel_cell.push({'tooltip': t('Open'), 'attr_type':'AttrButton',command:'executeVueObjMethod', 'method':'onButtonOpen__Click', 'cssClass':pi, uiHelp: 'grid.cellForm.cell.open'})
                            dropdown.commandPanel_cell.push({'tooltip': t('Copy to clipboard'), 'attr_type':'AttrButton',command:'executeVueObjMethod', 'method':'onButtonOpen__Click', externalLink_method:'copyToClipboard', 'cssClass':"pi pi-copy", uiHelp: 'grid.cellForm.cell.copyLink'})
                            dropdown.commandPanel_cell.push({'tooltip': t('Open record in new tab'), 'attr_type':'AttrButton',command:'executeVueObjMethod', 'method':'onButtonOpen__Click', externalLink_method:'openInNewTab', 'cssClass':"pi pi-external-link", uiHelp: 'grid.cellForm.cell.newTab'})
                        }
                    } else if (!V.relation_segment) {
                        wjcCore.addClass(e.cell, 'attr-doc2')
                        // if (V.buttons?.show_popupTab || attr_col.buttons?.show_popupTab) {
                        //     dropdown.commandPanel_cell.push({'tooltip': 'Select', 'attr_type':'AttrButton',command:'executeVueObjMethod', 'method':'onButtonShowDroppedDown__Click', 'cssClass':'pi-angle-down'})
                        // }
                    } else {
                        // if (!dropdown.isReadOnly) {
                        //     if (V.buttons?.show_popupTab || attr_col.buttons?.show_popupTab || V.attr_type === 'AttrLink') {
                        //         dropdown.commandPanel_cell.push({'tooltip': 'Select', 'attr_type':'AttrButton',command:'executeVueObjMethod', 'method':'onButtonShowDroppedDown__Click', 'cssClass':'pi-angle-down'})
                        //     }
                        // }
                        if (flex.getCellData(e.row, e.col)) {
                            dropdown.commandPanel_cell.push({'tooltip': t('Open'), 'attr_type':'AttrButton',command:'executeVueObjMethod', 'method':'onButtonOpen__Click', 'cssClass':pi, uiHelp: 'grid.cellForm.cell.open'})
                            dropdown.commandPanel_cell.push({'tooltip': t('New', null, 'button'), 'attr_type':'AttrButton',command:'executeVueObjMethod', 'method':'onButtonOpen__Click', 'createNew':true, 'cssClass':'pi pi-plus', uiHelp: 'grid.cellForm.cell.new'})   // IE 2026 09 24 / ODOO-341407: контекстный ключ словаря (ревизия омонимов)
                            dropdown.commandPanel_cell.push({'tooltip': t('Copy to clipboard'), 'attr_type':'AttrButton',command:'executeVueObjMethod', 'method':'onButtonOpen__Click', externalLink_method:'copyToClipboard', 'cssClass':"pi pi-copy", uiHelp: 'grid.cellForm.cell.copyLink'})
                            dropdown.commandPanel_cell.push({'tooltip': t('Open record in new tab'), 'attr_type':'AttrButton',command:'executeVueObjMethod', 'method':'onButtonOpen__Click', externalLink_method:'openInNewTab', 'cssClass':"pi pi-external-link", uiHelp: 'grid.cellForm.cell.newTab'})
                        }
                    }
                }

                // сводная таблица правил: колонки Source (source_link) — переход
                // к строке-источнику, как кнопка Open ссылочного поля
                if (attr_col?.source_link && this.aggAll_isSummary() && e.row >= this.headerRows) {
                    dropdown.commandPanel_cell.push({'tooltip': t('Open source row'), 'attr_type':'AttrButton', command:'executeVueObjMethod', 'method':'onAggSourceOpen__Click', 'cssClass':'pi-arrow-right', uiHelp: 'grid.cellForm.cell.openSource'})
                }

                // if (!dropdown.isReadOnly) {
                    if (this.attr.isPrintTemplate) {
                        dropdown.commandPanel_cell.push({ 'tooltip': t('Open cell'), 'action_name':'action-front-openLine-2025-09-23',command:'widget_open', 'widget':'widget-row', 'type': 'widget-row-cell', '_activate':true, 'get_currentRow':true, 'get_Parent':true, 'open_in_children_widget':true, 'cssClass':'pi p-button-white pi-pencil', source_name:this.attr.name, 'binding':this.attr.binding, col_binding: attr_col?.binding, 'attrs':[] })
                    }
                    
                    // }
            }

            if (!this.attr.isPrintTemplate) {
                dropdown.commandPanel_cell.push({'tooltip': t('Fore color'), 'title':'A', 'attr_type':'AttrButton', command:'executeVueObjMethod', 'method':'onFillColor_dropdown', 'showCommandTitle':true, uiHelp: 'grid.cellForm.cell.color', uiHelpState: 'fore'})
                dropdown.commandPanel_cell.push({'tooltip': t('Fill color'), 'attr_type':'AttrButton', command:'executeVueObjMethod', 'method':'onFillColor_dropdown', 'isFillColor':true, 'cssClass':'pi-palette', uiHelp: 'grid.cellForm.cell.color', uiHelpState: 'fill'})
            }

            // IE 2026 08 18 (заказ Игоря): очистка ручных корректировок (_cells value/isNull)
            // и самого признака корректировки в ВЫДЕЛЕННЫХ ячейках — только у гридов
            // с переопределениями (use_cells) и не в режиме только-чтение
            if (this.attr.use_cells && !dropdown.isReadOnly && !this.attr.isPrintTemplate) {
                dropdown.commandPanel_cell.push({'tooltip': t('Clear manual corrections in selected cells'), 'attr_type':'AttrButton', command:'executeVueObjMethod', 'method':'onClearCells', 'cssClass':'pi-eraser', uiHelp: 'grid.cellForm.cell.clearCorrections'})
            }
            // IE 2026 09 24 / ODOO-341407: карточка «Translations» — translate-колонки строк записи (параметр, колонка списка, строка раскладки),
            // поля формы с флагом Multilingual и колонки таблицы данных (строка-источник в записи)
            // IE 2026 10 06 / ODOO-341407 (заказ Игоря п.1): только в колонке с флагом translate, перевод ЗНАЧЕНИЯ ячейки; видимость — той же целью, что
            // открывает i18n_cell_open ({ cell: true }), иначе кнопка показывалась по одной цели, а открывала другую
            if (e.row >= this.headerRows && this.i18n_gridApplies() && this.i18n_targetFor(dropdown.dataItem, attr_col, { cell: true })) {
                dropdown.commandPanel_cell.push({'tooltip': t('Translations'), 'attr_type':'AttrButton', command:'executeVueObjMethod', 'method':'i18n_cell_open', 'cssClass':'pi-globe', uiHelp: 'grid.cellForm.cell.translations'})
            }
            dropdown.commandPanel_cell.push({'tooltip': t('Copy raw value (⌥⌘C)'), 'attr_type':'AttrButton', command:'executeVueObjMethod', 'method':'onCopyRawValue', 'cssClass':'pi-clone', uiHelp: 'grid.cellForm.cell.copyRaw'})
            dropdown.commandPanel_cell.push({'tooltip': t('Add comment'), 'attr_type':'AttrButton', command:'executeVueObjMethod', 'method':'onAddComment', 'cssClass':'pi-comment', uiHelp: 'grid.cellForm.cell.comment'})
            dropdown.commandPanel_cell.push({'tooltip': t('Edit value'), 'attr_type':'AttrButton', command:'executeVueObjMethod', 'method':'onEditValue', 'cssClass':'pi-angle-double-down', uiHelp: 'grid.cellForm.cell.editValue'})
        },
        dropdown_setItems(e, value) {
            const vueObj = this,
            dropdown = vueObj.store.dropdown,
            V = dropdown.V,
            attr_col = dropdown.attr_col,
            irow = dropdown.parent_attr.cell.irow

            if (dropdown.dropdown_type !== 'AttrStrMulti') {
                return
            }

            // dropdown.itemsSource_segment = vueObj.get_itemsSource_segment(attr_col, V)
            this.currentSuggestion = ""

            const activeEditor = e?.target
            let newVal = activeEditor?.value || value
            let oldVal = dropdown.value
            if ((attr_col.attr_type === 'AttrMulti' || attr_col.attr_type === 'AttrLink' || this.rl_is(attr_col)) && dropdown.is_editable) {   // IE 2026 10 25 / ODOO-348925: + AttrRowLink — список из строк источника
                // console.log('dropdown_setItems', newVal)
                let parentsList = vueObj.get_parentsList(irow, attr_col)

                let searchText = newVal || ''
                if (activeEditor?.selectionStart && activeEditor?.selectionEnd) {
                    searchText = searchText.substring(0, activeEditor.selectionStart)
                }

                // Если Wijmo сделал inline-completion (selectionEnd > selectionStart) —
                // стрипаем хвост из activeEditor.value, отдаём его нашему ghost-тексту.
                if (activeEditor && activeEditor.selectionEnd > activeEditor.selectionStart
                        && searchText.length < (activeEditor.value || '').length) {
                    activeEditor.value = searchText
                    activeEditor.setSelectionRange(searchText.length, searchText.length)
                    newVal = searchText
                }

                const _isrc = vueObj.store.get_itemsSource(vueObj, {}, attr_col, {fetchMode:'justGet'})
                    || vueObj.store.get_itemsSource(vueObj, {}, V, {fetchMode:'justGet'})
                const maxItems = _isrc?.fetchMode === 'by_ids' ? 10 : (_isrc?.data?.length ?? 100)
                let [items, itemsSource] = vueObj.store.get_itemsSource_byStr(vueObj, searchText, V, attr_col, oldVal, parentsList, maxItems)
                let _smallAllOn = true
                try { _smallAllOn = vueObj.store.setting('fe.ux.linkDropdownSmallAll', true) !== false } catch (err) { _smallAllOn = true }   // IE 2026 10 28 / ODOO-5800 (просьба ie-dm7: выпадающий список ссылки при открытии — полный для малых сегментов): выключатель
                const _fullMax = linkDropdown_fullMax(itemsSource, _smallAllOn, maxItems)   // IE 2026 10 28 / ODOO-5800 (просьба ie-dm7: выпадающий список ссылки при открытии — полный для малых сегментов): сегмент весь в кэше (проба name_search) — все пункты, не 10
                if (_fullMax) [items, itemsSource] = vueObj.store.get_itemsSource_byStr(vueObj, searchText, V, attr_col, oldVal, parentsList, _fullMax)
                dropdown.items = items
                dropdown.hi = -1   // IE 2026 10 10 / ODOO-341407 (Andrey via core #74395: grid autocomplete — detached value, Enter, arrows): список обновлён — подсветка сброшена
                dropdown.itemsSource = itemsSource || []

                // footer "N more" count — only for AttrLink/AttrMulti with a list, not formula cells
                const isFormula = String(newVal || '').startsWith('=') || String(newVal || '').startsWith('#')
                if (!isFormula && itemsSource?.data && searchText) {
                    const sl = searchText.toLowerCase()
                    const totalMatching = itemsSource.data.filter(item =>
                        (item.title != null && String(item.title).toLowerCase().includes(sl)) ||
                        (Array.isArray(item.titles_alt) && item.titles_alt.some(v => String(v).toLowerCase().includes(sl))) ||   // IE 2026 09 25 / ODOO-341407: названия на других языках
                        (item.code != null && String(item.code).toLowerCase().includes(sl)) ||
                        String(item.id).toLowerCase().includes(sl)
                    ).length
                    dropdown.items_more_count = Math.max(0, totalMatching - (items?.length || 0))
                } else {
                    dropdown.items_more_count = 0
                }
                const relation_segment = V?.relation_segment || attr_col?.relation_segment
                dropdown.items_can_loadFull = !!(relation_segment && !isFormula &&
                    itemsSource?.fetchMode === 'by_ids' &&
                    !linkDropdown_isComplete(itemsSource, _smallAllOn) &&   // IE 2026 10 28 / ODOO-5800 (просьба ie-dm7: выпадающий список ссылки при открытии — полный для малых сегментов): малый сегмент весь в кэше — «+» и догрузка не нужны
                    vueObj.store.itemsSource[relation_segment]?.fetchMode !== 'all')
                // The ☰ "go to list" button stays available for any relation attribute,
                // even once the full itemsSource has been received (fetchMode === 'all').
                dropdown.items_show_list = !!(relation_segment && !isFormula)

                // IE 2026 10 28 / ODOO-5800 (просьба ie-dm7: выпадающий список ссылки при открытии — полный для малых сегментов): пустой ввод
                // (открытие списка или стёртый текст) — одна проба name_search без текста на сегмент за сеанс; меньше лимита — сегмент весь в кэше,
                // список перерисовывается со всеми записями. Прежде открытие показывало только id, уже пришедшие со страницей (fetchMode 'by_ids')
                if (linkDropdown_shouldProbe({ on: _smallAllOn, searchText, isFormula, itemsSource })) {
                    const _probeIS = itemsSource, _probeAttr = attr_col, _probeKey = dropdown.key   // IE 2026 10 28 / ODOO-5800 (p079c): ключ ячейки формы — сверка в ответе
                    linkDropdown_probeStart(_probeIS)
                    if (typeof window !== 'undefined') window.__linkDropdownSmallAll = window.__linkDropdownSmallAll || { probes: 0, small: 0, large: 0 }
                    if (typeof window !== 'undefined') window.__linkDropdownSmallAll.probes++
                    vueObj.store.async_name_search(vueObj, _probeIS.segment, '', (newItems, answer) => {
                        const small = linkDropdown_probeSettle(_probeIS, newItems, LINK_DROPDOWN_PROBE_LIMIT, answer)   // IE 2026 10 28 / ODOO-5800 (p079b): ошибка бэка — прежнее поведение
                        if (typeof window !== 'undefined' && window.__linkDropdownSmallAll) window.__linkDropdownSmallAll[small ? 'small' : 'large']++
                        // IE 2026 10 28 / ODOO-5800 (p079c): без условия visible — замер dev02: ответ пробы через ~120 мс, форма видима только через ~220 мс
                        // (show по таймеру 100 мс), и перерисовка на первом открытии не срабатывала; сверка — та же ячейка (ключ формы) и тот же атрибут
                        const _dd = vueObj.store.dropdown
                        if (small && _dd && _dd.attr_col === _probeAttr && _dd.key === _probeKey && _dd.dropdown_type === 'AttrStrMulti') {
                            const _ae = vueObj.store.dropdown.activeEditor   // текст редактора, если он есть; проба ушла при пустом вводе — иначе '' (dropdown.value пустой ячейки — строка 'undefined')
                            vueObj.dropdown_setItems(null, typeof _ae?.value === 'string' ? _ae.value : '')
                        }
                    }, LINK_DROPDOWN_PROBE_LIMIT)
                }

                if (e !== null && itemsSource?.fetchMode === 'by_ids' && searchText.length >= 2 && !itemsSource.ids?.[searchText]) {
                    clearTimeout(vueObj._name_search_timer)
                    const seg = itemsSource.segment
                    const searchSnapshot = searchText
                    vueObj._name_search_timer = setTimeout(() => {
                        vueObj.store.async_name_search(vueObj, seg, searchSnapshot, () => {
                            if (vueObj.store.dropdown.visible) {
                                vueObj.dropdown_setItems(null, vueObj.store.dropdown.value)
                            }
                        })
                    }, 300)
                }

                if (dropdown.useValueHTML) {
                    if (String(newVal)?.startsWith('=') && dropdown.valueStr && String(newVal) === '=' + String(dropdown.valueStr)) {
                        // newVal = `= get_value(row, '${dropdown.value}')`
                        // if (e) {
                        //     activeEditor.value = newVal
                        // }
                        this.$nextTick(() => {
                            dropdown.show(false, true)
                        })
                    }

                    if (String(newVal)?.startsWith('=')) {
                        // if (!dropdown.showValueHTML) {
                            dropdown.set_showValueHTML()
                        // }
                    } else if (dropdown.showValueHTML) {
                        dropdown.showValueHTML = false
                    }
                }
                dropdown.value = String(newVal)
                dropdown.valueStr = newVal

                if (dropdown.items?.length) {
                    const CHIPS = []
                    for (const value of String(newVal).split(' ')) {
                        CHIPS.push({
                            segment: 'CHIP-Search',
                            title: value
                        })
                    }
                    for (const item of dropdown.items) {
                        // let title = item.title
                        // if (item.code && !title.includes(item.code)) title += '; ' + item.code
                        // if (item.id && !title.includes(item.id)) title += '; ' + item.id
                        item.highlightedTitle = vueObj.store.check_CHIPS_highlighted(this.WIDGET, item.title, CHIPS)
                        item.highlightedID = vueObj.store.check_CHIPS_highlighted(this.WIDGET, item.id, CHIPS)
                        // IE 2026 09 25 / ODOO-341407 (этап 2 переводов данных 1С, поиск по всем языкам): найдено по названию на другом языке (titles_alt строки
                        // справочника) — этот вариант подписью справа вместо id: видно, почему строка в списке
                        const _low = String(newVal || '').trim().toLowerCase()
                        if (_low && Array.isArray(item.titles_alt) && !String(item.title || '').toLowerCase().includes(_low)) {
                            const _hit = item.titles_alt.find(v => String(v).toLowerCase().includes(_low))
                            if (_hit) item.highlightedID = vueObj.store.check_CHIPS_highlighted(this.WIDGET, String(_hit), CHIPS)
                        }
                    }
                }

                if (this.ghostText) {
                    const match = dropdown.items?.find(item => item.title.toLowerCase().startsWith(String(newVal).toLowerCase()));
                    if (match) {
                        this.currentSuggestion = match.title;
                        const typed = String(newVal)
                        const tail = match.title.substring(typed.length)
                        this.ghostText.innerHTML = ''
                        if (tail) {
                            const prefix = document.createElement('span')
                            prefix.style.color = 'transparent'
                            prefix.textContent = typed
                            this.ghostText.appendChild(prefix)
                            this.ghostText.appendChild(document.createTextNode(tail))
                        }
                    } else {
                        this.currentSuggestion = "";
                        this.ghostText.innerHTML = "";
                    }
                }
            } else {
                dropdown.value = String(newVal)
                dropdown.valueStr = newVal
            }

            if (String(newVal)?.startsWith('=')) {
                dropdown.set_showValueHTML()
            }

            // WIDGET.popupTab.vueObj_selection.CHIPS = valueStr.split(' ')
            // WIDGET.popupTab.vueObj_selection.apply_CHIPS()
        },
        // // IE 2026 10 10 / ODOO-341407 (Andrey via core #74395: grid autocomplete — detached value, Enter, arrows): серый хвост подсказки автодополнения (span.ghost-text) убрать
        clearGhostTail() {
            try {
                if (this.ghostText) this.ghostText.innerHTML = ''
                this.currentSuggestion = ''
            } catch (e) { void e /* span уже снят вместе с редактором */ }
        },
        dropdown_keydown(e) {
            const vueObj = this,
            dropdown = vueObj.store.dropdown
            if (e.key === 'Escape') {
                dropdown.hide()
            } else if (!vueObj.autocompleteKeys_on()) {
                // выключатель fe.grid.autocompleteKeys = false: прежнее поведение (↓ сразу принимает первый пункт)
                if (e.key === 'ArrowDown') {
                    if (dropdown.visible && dropdown.items?.length) {
                        e.preventDefault()
                        e.stopPropagation()
                        dropdown.selectItem(dropdown.items[0])
                    }
                }
            } else if (e.isComposing) {
                return
            } else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                // // IE 2026 10 10 / ODOO-341407 (Andrey via core #74395: grid autocomplete — detached value, Enter, arrows): ↓/↑ двигают подсветку, не принимая пункт; ↓ при закрытом списке открывает его с подсветкой первого пункта
                if (dropdown.dropdown_type !== 'AttrStrMulti' || !dropdown.is_editable) return
                const ae = dropdown.activeEditor || e.target
                if (!dropdown.items?.length) {
                    if (e.key !== 'ArrowDown') return
                    try { vueObj.dropdown_setItems(null, ae?.value || '') } catch (err) { console.warn('autocomplete: open list failed', err) }
                    if (!dropdown.items?.length) return   // пунктов нет (не ссылочная колонка / пустой справочник) — клавиша как прежде
                }
                e.preventDefault()
                e.stopPropagation()
                if (!dropdown.visible) dropdown.show(false)
                dropdown.hi = moveHighlight(dropdown.hi, dropdown.items.length, e.key === 'ArrowUp' ? -1 : 1)
                vueObj.$nextTick(() => {
                    try { document.querySelector('.dropdown .list-container li.hi')?.scrollIntoView({ block: 'nearest' }) } catch (err) { void err /* список закрыт */ }
                })
            } else if (e.key === 'Enter') {
                // // IE 2026 10 10 / ODOO-341407 (Andrey via core #74395: grid autocomplete — detached value, Enter, arrows): Enter коммитит только подсвеченный пункт или точное совпадение набранного с названием; иначе ввод и список остаются открытыми
                // IE 2026 10 10 / ODOO-341407 (замер на dev, B3/B3b): пустой список совпадений и колонка с customValueWarning (binding сортировки раскладки) — тоже удерживаем:
                // иначе wijmo по Enter коммитил первое префиксное совпадение либо сырой текст («Str» → AttrStr). Своё значение по-прежнему фиксируется Tab / уходом из ячейки
                if (!dropdown.visible || dropdown.dropdown_type !== 'AttrStrMulti' || !dropdown.is_editable) return
                const attr_col = dropdown.attr_col
                const _rlEnter = vueObj.rl_is(attr_col)   // IE 2026 10 25 / ODOO-348878 (заказ Игоря: подбор RowLink — Enter и закреплённые колонки) (p041): лист AttrRowLink — Enter тоже перехватывается (прежде уходил в wijmo: сырой текст «тра» → отказ, ячейка пустая)
                if (attr_col?.attr_type !== 'AttrMulti' && attr_col?.attr_type !== 'AttrLink' && !_rlEnter) return   // IE 2026 10 25 / ODOO-348878 (заказ Игоря: подбор RowLink — Enter и закреплённые колонки) (p041)
                const ae = dropdown.activeEditor || e.target
                const typed = String(ae?.value ?? '')
                const picked = dropdown.items?.length ? (_rlEnter ? rlPickOnEnter(dropdown.items, dropdown.hi, typed) : pickOnEnter(dropdown.items, dropdown.hi, typed)) : null   // IE 2026 10 25 / ODOO-348878 (заказ Игоря: подбор RowLink — Enter и закреплённые колонки) (p041): у AttrRowLink — ещё пункт серой подсказки и единственный пункт
                if (picked) {
                    e.preventDefault()
                    e.stopPropagation()
                    e.stopImmediatePropagation()
                    dropdown.selectItem(dropdown.items[picked.index])   // choiceFinish пишет значение в строку и в журнал правок
                    // значение уже записано: правку закрываем без разбора строки (по названию однозначно не найти, если у двух пунктов одинаковое)
                    vueObj.$nextTick(() => { try { vueObj.flex.finishEditing(true) } catch (err) { void err /* редактор уже закрыт */ } })
                    return
                }
                const t = typed.trim()
                const cur = String(dropdown.V?.valueStr ?? '').trim().toLowerCase()
                // пустое поле (очистка значения), формула и неизменённый текст — прежний путь
                if (!t || t.startsWith('=') || t.startsWith('#') || t.toLowerCase() === cur) return
                e.preventDefault()
                e.stopPropagation()
                e.stopImmediatePropagation()
            }
        },

        //---------------------------------
        onSet_parentDataItem(cell, e) {
            let attr_col,
            dataItem = this.flex.rows[cell.row].dataItem,
            V = attr_col = this.attr_by_binding[cell.col_binding]
            if (attr_col.attr_type === 'AttrMulti') {
                V = this.store.check_AttrMulti(attr_col, dataItem)
            }

            this.parentDataItem_iroot = this.iroot(dataItem)

            this.parentDataItem = dataItem
            let parentDataItem_title = ''
            for (let col of this.flex.columns) {
                let attr_col = this.attr_by_binding[col.binding],
                value = this.store.get_value(this.parentDataItem, attr_col.binding),
                title = ''
                if ( attr_col.attr_type === 'AttrMulti' ) {
                    title = value?.value
                } else {
                    title = value
                }
                if (title) {
                    parentDataItem_title = title
                    break
                }
            }
            this.CHIPS = this.CHIPS.filter(chip => !String(chip.title).startsWith('>> '))
            this.CHIPS.push({
                use: true,
                attr_type:'CHIP-GridNode', 
                pi: 'pi-sign-in',
                title:'>> ' + parentDataItem_title
            })

            this.set_itemsSource()
        },
        // IE 2026 08 20 / ODOO-336291 (mobile UX) (#4193): открыть dropdown ТЕКУЩЕЙ ячейки по кнопке правого стека
        mobileOpenCellDropdown() {
            if (!this.store.mobileUi?.on) return
            if (!this._mobInActiveWidget()) return
            const flex = this.flex
            const sel = flex?.selection
            if (!flex || !sel || sel.row < 0 || sel.col < 0) return
            // 21.08: у виджета НЕСКОЛЬКО AttrGrid (вьюхи, фикс-колонки) — тик слышат
            // все, и второй инстанс с тем же key закрывал открытый dropdown; работает
            // только грид ПОСЛЕДНЕЙ селекции (uid из mobileCellSync)
            if (this.store.mobileCell?.grid !== this.$.uid) return
            // 21.08: прямой вызов по selection — рабочий путь (див ячейки в divCells);
            // синтетический клик по тогглу диспетчер грида не принимал
            const key = `${flex.cells.cellType}-${sel.row}-${sel.col}`
            if (this.divCells?.get(key)) {
                // тап был по кнопке: store.mouseX/Y указывают на неё, а Dropdown.show/hide
                // проверяют «мышь внутри ячейки» — переносим виртуальную мышь в ячейку
                const dc = this.divCells.get(key)
                if (dc) {
                    const r = dc.getBoundingClientRect()
                    this.store.mouseX = r.left + r.width / 2
                    this.store.mouseY = r.top + r.height / 2
                }
                try { flex.focus() } catch (e) { void e /* грид в перестройке */ }
                this.onRefToggle__Click({ row: sel.row, col: sel.col },
                    { preventDefault() {}, stopPropagation() {} })
                window.mobTapDone?.('cellMenu') // IE 2026 09 04 / ODOO-336291 (mobile UX): P-31
                return
            }
            // fallback: клик по штатному тогглу активной ячейки
            const toggle = this._mobActiveCellEl()?.querySelector('.cell-dropdown-toggle')
            if (toggle) {
                const t = toggle.firstElementChild || toggle
                const r = t.getBoundingClientRect()
                t.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true,
                    clientX: r.left + r.width / 2, clientY: r.top + r.height / 2 }))
            }
        },
        // IE 2026 08 20 / ODOO-336291 (mobile UX), 21.08: DOM активной ячейки
        _mobActiveCellEl() {
            const host = this.flex?.hostElement
            return host?.querySelector('.wj-cells .wj-cell.wj-state-active')
                || host?.querySelector('.wj-cells .wj-cell.wj-state-selected')
        },
        // 21.08: что умеет активная ячейка — для кнопок правого стека (Cell menu /
        // открыть ссылку-документ). Кнопки в ячейке рисует штатный formatItem.
        _mobInActiveWidget() {
            // виджет грида активен ЛИБО грид лежит в DOM активного (дочерние сабгриды)
            return this.WIDGET === this.store.activeWIDGET
                || !!this.flex?.hostElement?.closest?.('.widget-mob-active')
        },
        mobileCellSync() {
            if (!this.store.mobileUi?.on) return
            if (!this._mobInActiveWidget()) return
            const flex = this.flex
            // 21.08: selectionChanged синхронно стреляет и у соседних гридов виджета
            // (фикс-колонки) — состояние пишет только грид С ФОКУСОМ (грид тапа)
            if (!flex || typeof flex.containsFocus !== 'function' || !flex.containsFocus()) return
            // и только ВИДИМЫЙ грид: фокус може оказаться у скрытого двойника вьюхи
            if (!flex.hostElement || flex.hostElement.getBoundingClientRect().width < 4) return
            const sel = flex?.selection
            const has = !!(flex && sel && sel.row >= 0 && sel.col >= 0)
            let isRef = false, canOpen = false
            if (has) {
                const cellEl = this._mobActiveCellEl()
                isRef = !!cellEl?.querySelector('.cell-dropdown-toggle')
                canOpen = !!cellEl?.querySelector('#onButtonOpen__Click')
                if (!canOpen) {
                    // IE 2026 08 21 (скрин Игоря 19:57): ссылочная ячейка без кнопки
                    // в DOM — открываемость как у Alt+клика: колонка-ссылка с значением
                    try {
                        const col = flex.columns?.[sel.col]
                        const attr_col = col && this.attr_by_binding?.[col.binding]
                        if (attr_col && (attr_col.relation_segment
                                || String(attr_col.attr_type || '').startsWith('AttrLink')
                                || attr_col.attr_type === 'AttrMulti')) {
                            const dataItem = flex.rows?.[sel.row]?.dataItem
                            let value = dataItem ? this.store.get_value(dataItem, col.binding) : null
                            if (attr_col.attr_type === 'AttrMulti') value = this.store.check_AttrMulti(attr_col, dataItem)?.value
                            canOpen = !!value
                        }
                    } catch (e) { /* грид в перестройке */ }
                }
            }
            // grid: uid инстанса — тик обрабатывает ТОЛЬКО грид последней селекции
            const prev = this.store.mobileCell
            this.store.mobileCell = { wid: this.WIDGET.id, grid: this.$.uid, has, isRef, canOpen, row: sel?.row, col: sel?.col }
            // IE 2026 09 04 / ODOO-336291 (mobile UX): P-31 — замер только при реальной смене состояния (страховочный таймер 150 мс не в счёт)
            if (!prev || prev.grid !== this.$.uid || prev.row !== sel?.row || prev.col !== sel?.col || prev.isRef !== isRef || prev.canOpen !== canOpen) window.mobTapDone?.('cellTap')
        },
        // 21.08: открыть ссылку/документ из активной ячейки — та же кнопка, что в
        // ячейке (Alt+клик на десктопе): клик идёт через штатный диспетчер грида
        mobileOpenCellLink() {
            if (!this.store.mobileUi?.on) return
            if (!this._mobInActiveWidget()) return
            if (this.store.mobileCell?.grid !== this.$.uid) return
            const btn = this._mobActiveCellEl()?.querySelector('#onButtonOpen__Click')
            if (btn) { btn.click(); return }
            // IE 2026 08 21: кнопки в ячейке нет — открываем как Alt+клик десктопа
            const flex = this.flex, sel = flex?.selection
            if (!sel || sel.row < 0 || sel.col < 0) return
            const mrg = flex.mergeManager?.getMergedRange(flex.cells, sel.row, sel.col, true)
            const vrow = mrg ? mrg.topRow : sel.row, vcol = mrg ? mrg.leftCol : sel.col
            const binding = flex.columns?.[vcol]?.binding
            if (!binding || !this.attr_by_binding?.[binding]) return
            this.onButtonOpen__Click({ row: vrow, col: vcol, irow: vrow, col_binding: binding })
        },
        // IE 2026 08 20 / ODOO-336291 (mobile UX) (баг от ie-webscm7-2): слот-иконка pi-bars
        // вне wijmo-хоста — тап не открывал actionMenu; открываем контрол программно
        mobileActionMenuTap(e) {
            if (!this.store.mobileUi?.on) return
            const host = e.currentTarget.querySelector('.wj-menu')
            const ctrl = host && wjcCore.Control.getControl(host)
            if (!ctrl) return
            e.stopPropagation()
            if (!ctrl._mobTapWired) {
                ctrl._mobTapWired = true
                ctrl.isDroppedDownChanged.addHandler(() => { if (!ctrl.isDroppedDown) ctrl._mobClosedTs = Date.now() })
            }
            // wijmo мог закрыть панель по mousedown ЭТОГО же тапа — это «было открыто»
            const wasOpen = ctrl.isDroppedDown || (Date.now() - (ctrl._mobClosedTs || 0) < 400)
            const want = !wasOpen
            setTimeout(() => { ctrl.isDroppedDown = want }, 30)
        },
        onRefToggle__Click(cell, e) {
            e.preventDefault()
            e.stopPropagation()
            const dropdown = this.store.dropdown
            const key = `${this.flex.cells.cellType}-${cell.row}-${cell.col}`
            if (dropdown.visible && dropdown.key === key) {
                // IE 2026 09 27 / ODOO-… (дефект p203: стрелки при открытой форме ячейки): клик по заглушке на месте кнопки (форма показана на этой ячейке) — не закрытие и не правка; программный вызов (мобильная Cell menu) — как прежде
                if (e?.target?.closest?.('.cell-form-here')) { this.cellForm_shieldClick(cell); return }
                dropdown.sessionClose?.()   // IE 2026 09 26 / ODOO-… (замечания Игоря: форма ячейки): стрелка-свёртка (выключатель fe.ux.cellFormCloseAlways) — закрытие пользователем
                dropdown.hide()
                return
            }
            const divCell = this.divCells.get(key)
            if (!divCell) return
            dropdown.sessionOpen?.()   // IE 2026 09 26 / ODOO-… (замечания Игоря: форма ячейки): стрелка раскрытия в ячейке — форма снова показывается при выборе ячеек
            this.flex.select(new wjGrid.CellRange(cell.row, cell.col))
            dropdown.mouse_isInside = true
            this.dropdown_prepare({ row: cell.row, col: cell.col }, divCell, null)
        },
        onButtonShowDroppedDown__Click(cell, e) {
            let attr_col,
            dataItem = this.flex.rows[cell.row].dataItem,
            V = attr_col = this.attr_by_binding[cell.col_binding]
            if (attr_col.attr_type === 'AttrMulti') {
                V = this.store.check_AttrMulti(attr_col, dataItem)
            }

            this.show_popupTab(V, attr_col, cell, e)

            // // dataMapEditor
            // // let col = this.column_by_binding[cell.col_binding]
            // // col.isDroppedDown = !col.isDroppedDown
        },
        show_popupTab(V, attr_col, cell, e) {
            if (this.PAGE.WIDGET_selection) {
                this.show_popupTab2(this.PAGE.WIDGET_selection, V, attr_col, cell, e)
            } else {
                this.store.widget_open({
                    widget: 'widget-selection',
                    parentAction: { 'action_name':'action-front-2024-11-03', method: 'show_popupTab' },
                }, this.WIDGET.vueObj, this.show_popupTab2, [V, attr_col, cell, e])
            }
        },
        get_itemsSource_segment(attr_col, V) {
            if (this.attr.name === 'fields-target-source') {
                if (attr_col.itemsSource_source?.segment_binding === 'params.target_segment') {
                    return this.WIDGET.record.doc.params?.target_segment
                } else if (attr_col.itemsSource_source?.segment_binding === 'params.source_segment') {
                    return this.WIDGET.record.doc.params?.source_segment
                }
            }
            return V.relation_segment || ''
        },
        show_popupTab2(WIDGET_selection, V, attr_col, cell, e) {
            // widget: 'widget-selection'
            let itemsSource = this.store.get_itemsSource(this, {}, V, { fetchMode: 'justGet' })
            if (!itemsSource?.data && V !== attr_col) {
                itemsSource = this.store.get_itemsSource(this, {}, attr_col, { fetchMode: 'justGet' })
            }
            WIDGET_selection.itemsSource_segment = this.get_itemsSource_segment(attr_col, V)
            
            let itemsSource_types = this.store.get_itemsSource_bySegment('ATTR')
            
            let selection_data = itemsSource.data
            if (this.attr.name === 'fields-target-source') {
                if (attr_col.itemsSource_source?.segment_binding === 'params.target_segment') {
                    selection_data = this.WIDGET.record.doc.target_fields || []
                } else if (attr_col.itemsSource_source?.segment_binding === 'params.source_segment') {
                    selection_data = this.WIDGET.record.doc.source_fields || []
                }
            }
            if (!WIDGET_selection.record._doc) {
                WIDGET_selection.record._doc = {}
            }
            if (WIDGET_selection.record._doc?.dataSheet !== selection_data && selection_data) {
                WIDGET_selection.record._doc.dataSheet = selection_data
            }

            let vueObj_selection = WIDGET_selection.vueObj.get_vueObj('selection-list')
            if (vueObj_selection) {
                vueObj_selection.content_Changed()
                // vueObj_selection.set_itemsSource()
                // vueObj_selection.refresh()

                let valueStr = this.flex.getCellData(cell.row, cell.col) || ''
                vueObj_selection.CHIPS = []
                for (const value of valueStr.split(' ')) {
                    vueObj_selection.CHIPS.push({
                        segment:'CHIP-Search', 
                        title:value
                    })
                }

                vueObj_selection.apply_CHIPS()
            }
            
            if (WIDGET_selection.record._doc?.dataTypes !== itemsSource_types.data) {
                WIDGET_selection.record._doc.dataTypes = itemsSource_types.data
            }

            let vueObj_types = WIDGET_selection.vueObj.get_vueObj('selection-types')
            if (vueObj_types) {
                vueObj_types.set_itemsSource()
                // vueObj_types.refresh()
            }
            
            // let wj_cell = wjcCore.closest(e.target, '.wj-cell')

            WIDGET_selection['@@data'] = {
                parent_attr: {...this.attr, attr_col:V, attr_col2:attr_col, cell:cell},
                parent_attr_vueObj: this,
                // owner: wj_cell,
            }
            WIDGET_selection.title = t('Selection for {title}', { title: attr_col.title + ' : ' + V.title })   // IE 2026 09 23 / ODOO-341407: i18n
            WIDGET_selection.itemsSource_segment_title = attr_col.title + ' : ' + V.title
        },
        // ---------------- иерархическая сортировка (дерево строк) ----------------
        sortingColumn(flex, e) {
            // одноуровневый отчёт (у корней нет детей) сортирует ШТАТНЫЙ движок —
            // менять привычное поведение обычных списков незачем
            if (!this.hierSort_isTree()) return
            const col = flex.columns[e.col]
            const binding = col?.binding
            if (!binding) return
            e.cancel = true
            // такты по повторному клику: по возрастанию -> по убыванию -> без
            // сортировки (возврат к порядку, который посчитал сервер)
            const prev = this.hierSort || {}
            const dir = prev.binding !== binding ? 1 : (prev.dir === 1 ? -1 : (prev.dir === -1 ? 0 : 1))
            // АН 2026 08 08: hrow — ярус многоярусной шапки (год→квартал→месяц→
            // мера), по которому кликнули: стрелка направления рисуется на нём
            this.hierSort = dir ? { binding, dir, hrow: e.row } : {}
            this.hierSort_apply(binding, dir, col)
            this.hierSort_syncChip(flex, binding, dir)
        },
        hierSort_syncChip(flex, binding, dir) {
            // порядок корней отдаём штатному CollectionView (уровни уже переставлены
            // нашим проходом) — только ради того, чтобы штатный setChipOrder увидел
            // выбор и нарисовал/сохранил чипс сортировки
            const cv = flex.collectionView
            if (cv) {
                cv.sortDescriptions.clear()
                if (dir) cv.sortDescriptions.push(new wjcCore.SortDescription(binding, dir > 0))
            }
            this.$refs.chips?.setChipOrder(this)
        },
        hierSort_arrowRow(panel) {
            // АН 2026 08 08: ряд шапки для стрелки направления — кликнутый ярус
            // (hrow), пока он остаётся обычным видимым рядом титулов; иначе нижний
            // видимый ряд титулов. Служебные ряды не годятся: номера колонок
            // (columnNumberRow), mapped-ряд, sticky-ряды в конце (частью скрытые)
            const service = (r) => r === this.columnNumberRow
                || (this.isMappedWidget_rows && r === this.isMappedWidget_rows)
                || (this.stickyScrollStart != null && r >= this.stickyScrollStart)
            const hrow = this.hierSort?.hrow
            if (hrow != null && hrow >= 0 && hrow < panel.rows.length
                    && panel.rows[hrow].visible && !service(hrow)) return hrow
            let last = panel.rows.length - 1
            while (last > 0 && (!panel.rows[last].visible || service(last))) last--
            return last
        },
        hierSort_isTree() {
            const path = this.attr.childItemsPath
            if (!path) return false
            const roots = this.flex?.itemsSource?.sourceCollection || []
            return roots.some(row => (row?.[path] || []).length)
        },
        hierSort_restore() {
            // выбор переживает пересборку источника (обновление отчёта, смена чипсов)
            // источник истины — чипс порядка: он сохраняется с виджетом, поэтому
            // после переоткрытия сортировка по уровням восстанавливается сама
            const fromChip = (this.$refs.chips?.getChipOrder(true) || [])[0]
            const saved = fromChip ? { binding: fromChip[0], dir: fromChip[1] === 'DESC' ? -1 : 1 }
                                   : (this.hierSort?.dir ? this.hierSort : null)
            if (!saved?.binding || !saved?.dir || !this.hierSort_isTree()) return
            // АН 2026 08 08: сохранённый биндинг может отсутствовать в новой
            // выборке (сменился период/набор колонок) — тогда сортировку не
            // восстанавливаем, остаётся серверный порядок; guard вместо падения
            const col = this.flex?.columns?.getColumn?.(saved.binding)
            if (!col && this.flex?.columns?.length) return
            this.hierSort = { binding: saved.binding, dir: saved.dir }
            this.hierSort_apply(saved.binding, saved.dir, col)
        },
        hierSort_apply(binding, dir, col) {
            const path = this.attr.childItemsPath
            const roots = this.flex?.itemsSource?.sourceCollection
            if (!path || !roots) return
            this.hierSort_stampOrder(roots, path)
            const cmp = this.hierSort_comparator(binding, dir, col)
            this.hierSort_sortLevel(roots, path, cmp)
            this.flex.collectionView?.refresh?.()
            this.flex.invalidate()
        },
        hierSort_stampOrder(rows, path) {
            // исходный серверный порядок запоминаем ОДИН раз и вне enumerable-полей:
            // третьим кликом к нему возвращаемся, а в запись он уехать не должен
            rows.forEach((row, i) => {
                if (row && row.__ord0 === undefined) {
                    Object.defineProperty(row, '__ord0', { value: i, writable: true, enumerable: false })
                }
                this.hierSort_stampOrder(row?.[path] || [], path)
            })
        },
        hierSort_isAttached(row) {
            // строки сравнения (≡ prev / Δ / Δ%) и декоративные merge-строки не
            // самостоятельны — они относятся к предыдущей строке и едут за ней
            const cls = row?._DLRow?.cssClasses
            return !!(row?._DLRow?.mergeRow || (Array.isArray(cls) && cls.includes('row-compare')))
        },
        hierSort_sortLevel(rows, path, cmp) {
            const blocks = []
            for (const row of rows) {
                if (blocks.length && this.hierSort_isAttached(row)) blocks[blocks.length - 1].tail.push(row)
                else blocks.push({ leader: row, tail: [] })
            }
            // АН 2026 08 08 / #54: итоговые строки (Totals) не сортируются — остаются
            // на своём краю группы (первая позиция = start, остальные = end)
            const hierSort_isTotal = (b) => b.leader?._DLRow?.row_type === 'Total'
            const pinnedStart = (blocks.length && hierSort_isTotal(blocks[0])) ? [blocks.shift()] : []
            const pinnedEnd = []
            for (let i = blocks.length - 1; i >= 0; i--) {
                if (hierSort_isTotal(blocks[i])) pinnedEnd.unshift(blocks.splice(i, 1)[0])
            }
            blocks.sort((a, b) => cmp(a.leader, b.leader))
            const orderedBlocks = [...pinnedStart, ...blocks, ...pinnedEnd]
            rows.length = 0
            for (const block of orderedBlocks) {
                rows.push(block.leader)
                for (const row of block.tail) rows.push(row)
            }
            for (const row of rows) {
                const childs = row?.[path]
                if (childs && childs.length) this.hierSort_sortLevel(childs, path, cmp)
            }
        },
        hierSort_value(row, binding) {
            if (row === null || row === undefined) return null
            const key = String(binding)
            // АН 2026 08 08: сначала биндинг как ПЛОСКИЙ ключ — Total-колонки
            // периодов ('_total::2026::quantity_year') содержат '::' и не являются
            // путём через точку; split('.') по такому ключу дал бы неверный путь
            if (Object.prototype.hasOwnProperty.call(row, key)) return row[key]
            // биндинг колонки меры отчёта — вложенный путь ('2026-02-01.quantity')
            let value = row
            for (const part of key.split('.')) {
                if (value === null || value === undefined) return null
                value = value[part]
            }
            return value
        },
        hierSort_comparator(binding, dir, col) {
            if (!dir) return (a, b) => (a?.__ord0 ?? 0) - (b?.__ord0 ?? 0)
            const titleKey = `${binding}_title`   // АН 2026 08 08: серверный титул ссылки (BE 9dac7368)
            const key = (row) => {
                let value = this.hierSort_value(row, binding)
                // измерение-ссылка сортируется по ВИДИМОМУ титулу — тем же правилом,
                // что и серверный порядок уровней, иначе порядки разъезжаются.
                // АН 2026 08 08: титул чаще приезжает отдельным полем строки
                // <binding>_title (так бэкенд отдаёт порядок уровней) — он
                // приоритетнее dataMap; dataMap — запасной путь, потом сырое значение
                const rowTitle = row?.[titleKey]
                if (rowTitle !== null && rowTitle !== undefined && rowTitle !== '') {
                    value = rowTitle
                } else if (col?.dataMap && value !== null && value !== undefined && value !== '') {
                    const title = col.dataMap.getDisplayValue(value)
                    if (title !== null && title !== undefined && title !== '') value = title
                }
                if (value === null || value === undefined || value === '') return [0, 0, '']
                if (typeof value === 'number' && isFinite(value)) return [1, value, '']
                if (typeof value === 'boolean') return [1, value ? 1 : 0, '']
                // numericSort: строка-число — в числовую корзину (кейс DOS: "9970.5")
                if (typeof value === 'string' && value.trim() !== ''
                        && this.store.fastEntry?.numericSort !== false) {
                    const n = Number(value)
                    if (!Number.isNaN(n)) return [1, n, '']
                }
                return [2, 0, String(value).toLowerCase()]
            }
            return (a, b) => {
                const ka = key(a), kb = key(b)
                // АН 2026 08 08: строки — через localeCompare (кириллица титулов)
                let res = ka[0] - kb[0] || ka[1] - kb[1] || ka[2].localeCompare(kb[2])
                if (!res) res = (a?.__ord0 ?? 0) - (b?.__ord0 ?? 0)   // стабильность
                return dir > 0 ? res : -res
            }
        },
        sortedColumn(flex, e) {
            this.$refs.chips?.setChipOrder(this)
            // this.apply_CHIPS(null, {fast:true}) << setChipOrder
        },
        select(CHIPS) { // TODO selectChipType(index, type) >>
            this.CHIPS = CHIPS
            this.store.executeStoreMethod(this.WIDGET.vueObj, { 
                command: 'executeWidgetMethod',
                method: 'select', 
                record_sendToBackend_exclude: ['_doc'],
            }, this.attr)
        },

        // ------------------ AttrGrid cell как chips -----------------
        tagsRow_commit(tagsAttr, arr) {
            // IE 2026 08 19 / ODOO-5512 (заказ Игоря): AttrTags — записать массив тегов
            // в ЗАПИСЬ по binding строки (attr_set резолвит widget-row → родителя и
            // помечает запись изменённой); новая ссылка массива — set_value видит правку
            // служебный _meta строк (setModified) в запись не тащим — в doc.tags
            // должны лежать чистые {use, title, ...}
            const copy = tagIds_commit(arr)   // IE 2026 10 05 / ODOO-5800 (fe-80): элемент-id остаётся строкой (раньше разворачивался в {0: 'u', 1: 'n', …})
            // IE 2026 10 15 / ODOO-5512 (chip undo): the cell keeps the SAME row objects (arr) — the undo/redo entries of ⊗ / Backspace point at them; before, the cell was redrawn from the copy,
            // so undo flipped a stale object and the chip stayed hidden (dev02 15.10: Backspace → Ctrl+Z, probe-tag use:0). The record still gets the clean copy (no _meta)
            tagsAttr.value = arr   // IE 2026 10 15 / ODOO-5512
            this.store.attr_set(this.WIDGET, tagsAttr, copy, null, null, false)
        },
        chipLabelAttr(attr_col) {
            // колонка-подпись табличной части: первая не-bool с binding
            // (для строк {use, cssClass} — cssClass)
            return (attr_col?.attrs || []).find(a => a?.binding && a.attr_type !== 'AttrBool') || attr_col?.attrs?.[0]
        },
        chipRemove_apply(field, ctx) {   // IE 2026 10 15 / ODOO-5512
            // IE 2026 10 15 / ODOO-5512 (ie-engine7 14.10 via ie-webscm7 #86527): hide a chip of an AttrGrid cell — ONE path for the ⊗ button and for Backspace in the empty chip input
            // (Backspace used to do valueC.pop(): the last array row went away, even a hidden use:false one, with no undo entry and no setModified).
            // ctx = { flex, e_cell, dataItem, attr_colC, valueC, _tagsRow, _idsAttr, _idsRO } — the same object the chip input gets (chipInput_bind). → true if the chip was hidden.
            const vueObj = this
            const { flex, dataItem, attr_colC, valueC, _tagsRow } = ctx
            const idx = valueC.indexOf(field)
            if (idx !== -1 && tagIds_isScalar(field)) {   // IE 2026 10 05 / ODOO-5800 (fe-80): элемент — id записи, а не строка таблицы: убрать из списка (field.use у строки не ставится)
                tagIds_remove(valueC, field)
                if (_tagsRow) vueObj.tagsRow_commit(_tagsRow, valueC)
                flex.invalidate()
                vueObj.setModified()
                return true
            }
            if (idx !== -1) {
                // valueC.splice(idx, 1);
                // история Undo/Redo: снятие чипса поля
                const entry = {   // IE 2026 10 15 / ODOO-5512 (chip undo)
                    method: 'props',
                    cells: [{ item: field, path: 'use', oldValue: field.use, newValue: false }],
                    cellOwners: [{ item: dataItem, attr_col: attr_colC }],   // IE 2026 10 15 / ODOO-5512: undo reads cw.attr_col (changeStack_) — the key was attr_colC, so useCount_cellApply(item, undefined) returned at once and the owner counter stayed stale after undo
                    label: t('Remove field "{name}"', { name: vueObj.chipLabel(field, attr_colC) }),   // IE 2026 09 23 / ODOO-341407: i18n
                }
                // IE 2026 10 15 / ODOO-5512: AttrTags row — the record gets a clean copy of the rows (tagsRow_commit); undo/redo flips the row object of the cell, so the record is re-committed after it
                if (_tagsRow) entry.afterApply = () => vueObj.tagsRow_commit(_tagsRow, Array.isArray(_tagsRow.value) ? _tagsRow.value : valueC)
                vueObj.hist_push(entry)   // IE 2026 10 15 / ODOO-5512
                field.use = false;
                if (_tagsRow) vueObj.tagsRow_commit(_tagsRow, valueC)
                vueObj.useCount_cellApply(dataItem, attr_colC)
                flex.invalidate();
                vueObj.setModified(field);
                const WRow_ = vueObj.store.get_childrenWidget(vueObj.WIDGET, 'widget-row')
                if (WRow_?.vueObj && WRow_.record?._meta?.col_binding === attr_colC?.binding) {
                    WRow_.vueObj.content_Changed()
                }
                return true
            }
            return false
        },
        chipInput_bind(input, ctx) {   // IE 2026 10 15 / ODOO-5512
            // IE 2026 10 15 / ODOO-5512 (ie-engine7 14.10 via ie-webscm7 #86527): handlers of the chip input of an AttrGrid cell (record pick-list, Enter = own text, Del = selected tag,
            // Backspace = hide the last visible chip, read-only / hidden input) — ONE function for formatItem_cells and for the formatItem cache path, where the input
            // created after a scroll (14cc970435, b631ce589) had no handlers at all (Enter did nothing). Bound once per element (cellChips_bindOnce) → true when bound now.
            const vueObj = this
            if (!cellChips_bindOnce(input)) return false
            const { flex, dataItem, attr_colC, valueC, _tagsRow, _idsAttr, _idsRO } = ctx
            const chip_commit = (row) => {
                input.value = ''
                vueObj.setModified(row)
                vueObj.useCount_cellApply(dataItem, attr_colC)
                flex.invalidate()
                const WRow_add = vueObj.store.get_childrenWidget(vueObj.WIDGET, 'widget-row')
                if (WRow_add?.vueObj && WRow_add.record?._meta?.col_binding === attr_colC?.binding) {
                    WRow_add.vueObj.content_Changed()
                }
            }
            const chip_add = (newItem) => {
                if (_tagsRow) {
                    valueC.push(newItem)
                    vueObj.tagsRow_commit(_tagsRow, valueC)
                    chip_commit(newItem)
                    return
                }
                if (dataItem && vueObj.store.get_value(dataItem, attr_colC.binding) !== valueC) {
                    // ячейка была пустой — привязываем созданный массив к строке
                    vueObj.store.set_value(dataItem, attr_colC.binding, valueC)
                }
                valueC.push(newItem)
                chip_commit(newItem)
            }
            // Link-колонка табличной части (например cssClasses → CSS-CLASS):
            // добавление чипса — выбор записи из itemsSource сегмента
            const chipField1 = _idsAttr || vueObj.chipLabelAttr(attr_colC)   // IE 2026 10 05 / ODOO-5800 (fe-80): список id — подбор из записей сегмента
            const use_selection = chipField1?.attr_type === 'AttrLink' && (chipField1.relation_segment || (Array.isArray(chipField1.itemsSource) && chipField1.itemsSource.length))
            input.addEventListener('mousedown', (ev) => {
                const ht = flex.hitTest(ev)
                if (ht.row >= 0 && ht.col >= 0) {
                    flex.select(new wjGrid.CellRange(ht.row, ht.col))
                }
                ev.stopPropagation()
            })
            input.addEventListener('click', (ev) => ev.stopPropagation())
            if (use_selection) {
                const selection_show = () => vueObj.chipSelection_show(input, chipField1, valueC, item => {
                    if (_idsAttr) {   // IE 2026 10 05 / ODOO-5800 (fe-80): в список id добавляется id записи, не строка {use, …}
                        if (tagIds_add(valueC, item.id)) { vueObj.tagsRow_commit(_tagsRow, valueC); input.value = ''; vueObj.setModified(); flex.invalidate() }
                        return
                    }
                    // строка с этим id уже есть, но выключена — включаем, не дублируем
                    const existing = valueC.find(row => row?.use === false
                        && vueObj.store.get_value(row, chipField1.binding) === item.id)
                    if (existing) {
                        existing.use = true
                        chip_commit(existing)
                    } else {
                        chip_add({ use: true, [chipField1.binding]: item.id })
                    }
                })
                input.addEventListener('focus', selection_show)
                input.addEventListener('input', selection_show)
                input.addEventListener('blur', () => vueObj.chipSelection_hide())
            }
            input.addEventListener('keydown', (ev) => {
                ev.stopPropagation()
                if (_tagsRow && ev.key === 'Delete' && vueObj._tagsSelected) {
                    // IE 2026 08 19 (заказ Игоря): Del удаляет выделенный тег
                    const f = vueObj._tagsSelected
                    vueObj._tagsSelected = null
                    tagIds_remove(valueC, f)   // IE 2026 10 05 / ODOO-5800 (fe-80): id записи убирается из списка, строка таблицы — use = false (как было)
                    vueObj.tagsRow_commit(_tagsRow, valueC)
                    vueObj.setModified(tagIds_isScalar(f) ? null : f)   // IE 2026 10 05 / ODOO-5800 (fe-80)
                    flex.invalidate()
                    return
                }
                if (use_selection && vueObj.chipSelection_keydown(ev)) return
                if (ev.key === 'Enter' && input.value.trim() && !_idsAttr   // IE 2026 10 05 / ODOO-5800 (fe-80): в список id свой текст не добавляется — только запись сегмента (подбор)
                    && (_tagsRow || vueObj.chipInput_allowed(attr_colC))) {   // IE 2026 10 14 / ODOO-335246: свой текст — только в текстовую колонку-подпись с плоским binding
                    const val = input.value.trim()
                    const newItem = { use: true }
                    const field1 = chipField1
                    if (field1?.binding) {
                        newItem[field1.binding] = val
                    } else {
                        newItem.title = val
                        newItem.binding = val
                    }
                    chip_add(newItem)
                }
                if (ev.key === 'Backspace' && input.value === '') {   // IE 2026 10 15 / ODOO-5512: was valueC.pop() (80414ef54) — dropped the last ARRAY row, even a hidden use:false one, with no undo entry and no setModified
                    const iLast = cellChips_lastVisible(valueC)   // IE 2026 10 15 / ODOO-5512: the last VISIBLE chip, the same path as its ⊗; no visible chip — nothing
                    if (iLast !== -1) vueObj.chipRemove_apply(valueC[iLast], ctx)   // IE 2026 10 15 / ODOO-5512
                }
            })
            if (_idsRO) { input.readOnly = true; input.style.display = 'none' }   // IE 2026 10 05 / ODOO-5800 (fe-80): вычисляемый список — без поля добавления
            // IE 2026 10 14 / ODOO-335246: свой текст писать некуда (подпись — числовая колонка или binding с точкой: у грида отбора
            // attrs_viewWHERE это F_order, AttrNumber — Enter давал строку {use: true, order: '<текст>'}) — поля ввода нет, Backspace строк не снимает
            else if (!_tagsRow && !vueObj.chipInput_allowed(attr_colC)) { input.readOnly = true; input.style.display = 'none' }
            return true
        },
        chipInput_allowed(attr_col) {
            // IE 2026 10 14 / ODOO-335246: свой текст из ячейки-грида (Enter) пишется в колонку-подпись строкой {use, <binding>: текст} —
            // только если она текстовая и binding плоский; подбор записей (Link) и прежний путь {title, binding} — как были.
            // use колонки не смотрим: его на лету снимает скрытие пустых колонок — с ним пропадало поле у Fields / To fields (проверка dev02 14.10)
            const f = this.chipLabelAttr(attr_col)
            if (!f?.binding) return true
            if (f.attr_type === 'AttrLink' && (f.relation_segment || (Array.isArray(f.itemsSource) && f.itemsSource.length))) return true
            return f.attr_type !== 'AttrBool' && f.attr_type !== 'AttrNumber' && !String(f.binding).includes('.')
        },
        chipLabel(field, attr_col) {
            // подпись чипса: title строки, иначе значение колонки-подписи;
            // ссылку (AttrLink) резолвим в title записи через itemsSource
            // (неизвестные id догружаются батчем by_ids, перерисовка — по watch)
            // IE 2026 10 05 / ODOO-5800 (fe-80; prod_check18 A — «Cannot use 'in' operator to search for 'undefined' in uncovered_demand», стек get_value): элемент —
            // id записи (строка), колонок таблицы у поля нет: раньше сюда шёл get_value('<id>', undefined). Название — из словаря сегмента (догрузка by_ids)
            if (tagIds_isScalar(field)) {
                const link = tagIds_linkAttr(attr_col)
                if (!link) return String(field)
                ;(this._tagIds_segments = this._tagIds_segments || new Set()).add(link.relation_segment)
                const its = this.store.get_itemsSource(this, {}, link, { fetchMode: 'by_ids', ids: [String(field)] })
                return tagIds_title(field, its?.ids)
            }
            // IE 2026 10 08 / ODOO-341407: чипс поля / меры строки раскладки DL2 — название на языке пользователя, как подпись колонки отчёта (свой title_{lang} → словарь бэка → title)
            const dl2 = this.dl2Titles_label(field, this.dl2Titles_gridPath() + '.' + (attr_col?.binding || ''))
            if (dl2) return dl2
            if (field?.title) return field.title
            const field1 = this.chipLabelAttr(attr_col)
            let text = tagIds_label(field, field1?.binding, (o, b) => this.store.get_value(o, b)) || ''   // IE 2026 10 05 / ODOO-5800 (fe-80): колонки-подписи нет — пусто, без get_value(…, undefined)
            if (text && field1?.attr_type === 'AttrLink' && field1.relation_segment) {
                const itemsSource = this.store.get_itemsSource(this, {}, field1, { fetchMode: 'by_ids', ids: [text] })
                text = itemsSource?.ids?.[text]?.title || text
            }
            return text
        },
        chipSelection_show(input, field1, value, onSelect) {
            // выпадающий список добавления чипса — записи itemsSource Link-колонки
            // табличной части, фильтр по вводу, группировка по item.group
            this.chipSelection_hide()
            const itemsSource = this.store.get_itemsSource(this, {}, field1, { fetchMode: 'all' })
            const search = (input.value || '').trim().toLowerCase()
            const usedIds = new Set((value || []).map(row => tagIds_key(row, field1.binding, (o, b) => this.store.get_value(o, b))))   // IE 2026 10 05 / ODOO-5800 (fe-80): элемент списка — и строка таблицы, и id
            let items = (itemsSource?.data || []).filter(item =>
                !usedIds.has(item.id)
                && (!search
                    || String(item.title ?? '').toLowerCase().includes(search)
                    || String(item.id ?? '').toLowerCase().includes(search))
            )
            if (!items.length) return
            if (items.some(item => item.group || item.doc?.group)) {
                // сортировка по группе (stable — порядок внутри группы сохраняется)
                items = [...items].sort((a, b) => String(a.group || a.doc?.group || '').localeCompare(String(b.group || b.doc?.group || '')))
            }
            const menu = document.createElement('div')
            menu.className = 'chip-selection-menu'
            menu.addEventListener('mousedown', (ev) => ev.stopPropagation())
            const itemEls = []
            let lastGroup = null
            for (const item of items.slice(0, 200)) {
                const group = item.group || item.doc?.group || ''
                if (group && group !== lastGroup) {
                    const groupEl = document.createElement('div')
                    groupEl.className = 'chip-selection-menu-group'
                    groupEl.textContent = group
                    menu.appendChild(groupEl)
                }
                lastGroup = group
                const itemEl = document.createElement('div')
                itemEl.className = 'chip-selection-menu-item'
                itemEl.textContent = item.title || item.id
                itemEl.addEventListener('mousedown', (ev) => {
                    // mousedown раньше blur инпута: preventDefault сохраняет фокус,
                    // выбор не теряется
                    ev.preventDefault()
                    ev.stopPropagation()
                    this.chipSelection_hide()
                    onSelect(item)
                })
                itemEl._chipItem = item
                itemEls.push(itemEl)
                menu.appendChild(itemEl)
            }
            const rect = input.getBoundingClientRect()
            menu.style.left = rect.left + 'px'
            menu.style.top = rect.bottom + 'px'
            overlayRoot().appendChild(menu)   // IE 2026 09 23 / ODOO-… (замечание Игоря: панели-меню в Full screen): полноэкран документа — меню в body, полноэкран виджета — в нём
            this._chipSelection = { menu, itemEls, onSelect, active: -1 }
        },
        chipSelection_hide() {
            if (!this._chipSelection) return
            this._chipSelection.menu.remove()
            this._chipSelection = null
        },
        chipSelection_keydown(ev) {
            // навигация по открытому списку; true — событие обработано
            const sel = this._chipSelection
            if (!sel) return false
            if (ev.key === 'ArrowDown' || ev.key === 'ArrowUp') {
                ev.preventDefault()
                sel.active = ev.key === 'ArrowDown'
                    ? (sel.active + 1) % sel.itemEls.length
                    : (sel.active <= 0 ? sel.itemEls.length - 1 : sel.active - 1)
                sel.itemEls.forEach((el, i) => el.classList.toggle('active', i === sel.active))
                sel.itemEls[sel.active].scrollIntoView({ block: 'nearest' })
                return true
            }
            if (ev.key === 'Escape') {
                this.chipSelection_hide()
                return true
            }
            if (ev.key === 'Enter') {
                const el = sel.itemEls[sel.active >= 0 ? sel.active : 0]
                if (el) {
                    this.chipSelection_hide()
                    sel.onSelect(el._chipItem)
                    return true
                }
            }
            return false
        },

        // ------------------ CHIPS -----------------------------------
        // после клика по «выбрать/снять всё» подсказку не показываем, пока курсор
        // не уйдёт с кнопки. Отслеживаем уход по document.mouseover (а не по
        // mouseleave самой кнопки): grid перерисовывает ячейку сразу после клика,
        // старый элемент со своими слушателями исчезает, а новый под неподвижным
        // курсором получил бы mouseenter от первого же микро-движения
        selectorAllMenu_suppress(binding) {
            this.selectorAllMenu_hide(true)
            this._selectorAllMenu_suppressed = binding
            if (this._selectorAllMenu_unsuppress) return
            const onOver = (ev) => {
                const t = ev.target
                if (t instanceof Element && t.closest?.('.selector-all, .selector-all-menu')) return
                this.selectorAllMenu_unsuppress()
            }
            document.addEventListener('mouseover', onOver, true)
            this._selectorAllMenu_unsuppress = () => {
                document.removeEventListener('mouseover', onOver, true)
                this._selectorAllMenu_unsuppress = null
                this._selectorAllMenu_suppressed = null
            }
        },
        selectorAllMenu_unsuppress() {
            this._selectorAllMenu_unsuppress?.()
        },
        selectorAllMenu_show(checkbox, binding) {
            if (this._selectorAllMenu_suppressed === binding) return
            if (altTooltip.held) return   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5 (накат 28.09): при зажатом Alt над флажком — его объяснение, мини-меню по наведению не всплывает (правило кнопок-триггеров)
            clearTimeout(this._selectorAllMenu_hideTimer)
            this._selectorAllMenu_hideTimer = null
            if (this._selectorAllMenu) {
                if (this._selectorAllMenu.dataset.binding === binding) return
                this.selectorAllMenu_hide(true)
            }
            const menu = document.createElement('div')
            menu.className = 'selector-all-menu'
            menu.dataset.binding = binding
            const item = document.createElement('div')
            item.className = 'selector-all-menu-item'
            item.innerHTML = '<i class="pi pi-filter"></i><span></span>'
            item.lastElementChild.textContent = t('Filter checked rows ({expr})', { expr: '= row.' + binding })   // IE 2026 09 23 / ODOO-341407: i18n
            uiHelp.bind(item, { key: 'grid.rowHeader.selectAllMenu' })   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5 (накат 28.09): снимается вместе с меню (selectorAllMenu_hide)
            item.onclick = () => {
                this.selectorAllMenu_hide(true)
                this.filter_checkedRows(binding)
            }
            menu.appendChild(item)
            menu.addEventListener('mouseenter', () => {
                clearTimeout(this._selectorAllMenu_hideTimer)
                this._selectorAllMenu_hideTimer = null
            })
            menu.addEventListener('mouseleave', () => this.selectorAllMenu_hide())
            const rect = checkbox.getBoundingClientRect()
            menu.style.left = rect.left + 'px'
            menu.style.top = rect.bottom + 'px'
            overlayRoot().appendChild(menu)   // IE 2026 09 23 / ODOO-… (замечание Игоря: панели-меню в Full screen): полноэкран документа — меню в body, полноэкран виджета — в нём
            this._selectorAllMenu = menu
        },
        selectorAllMenu_hide(immediate=false) {
            clearTimeout(this._selectorAllMenu_hideTimer)
            this._selectorAllMenu_hideTimer = null
            if (!this._selectorAllMenu) return
            if (immediate) {
                this._selectorAllMenu.querySelectorAll('[data-help]').forEach(el => uiHelp.unbind(el))   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5 (накат 28.09)
                this._selectorAllMenu.remove()
                this._selectorAllMenu = null
            } else {
                this._selectorAllMenu_hideTimer = setTimeout(() => {
                    this._selectorAllMenu?.querySelectorAll('[data-help]').forEach(el => uiHelp.unbind(el))   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5 (накат 28.09)
                    this._selectorAllMenu?.remove()
                    this._selectorAllMenu = null
                }, 250)
            }
        },
        filter_checkedRows(binding) {
            const title = `= row.${binding}`
            const chip = this.CHIPS.find(c => c.segment === 'CHIP-Search' && String(c.title).trim() === title)
            if (chip) {
                if (chip.meta?.use === false) chip.meta.use = true
                this.apply_CHIPS()
                return
            }
            // titleHTML — юзерфрендли-заголовок, показывается в приоритете над title (условием)
            // IE 2026 09 26 / ODOO-… (заказ Игоря: doc.use в заголовках строк): у поля с путём (doc.use) — название колонки («Enabled», а не «is Doc.use»)
            const _fcTitle = String(binding).includes('.') ? (this.attr_by_binding?.[binding]?.title || binding) : binding.charAt(0).toUpperCase() + binding.slice(1)
            const titleHTML = t('is {title}', { title: _fcTitle })
            const newChip = { segment: 'CHIP-Search', title, meta: { use: true, pi: 'pi-search', titleHTML } }
            const chipsVue = this.$refs.chips
            if (chipsVue) {
                chipsVue.chipsRaw.push(newChip)
                chipsVue.emitChips()
            } else {
                this.CHIPS = [...this.CHIPS, newChip]
                this.apply_CHIPS()
            }
        },
        apply_CHIPS(e=null, {check_nonEmptyWidget=true, recheck_tab=true, level=0, topRow=0, bottomRow=0, need_set_itemsSource=false, fast=false, emptyScanReuse=false}={}) {   // IE 2026 10 29 / ODOO-5800 (webscm #114418: долгая задача 0,86 с после Shift+F3 — скан пустых колонок соседнего грида): emptyScanReuse — проход только из-за словаря
            const vueObj = this
            // IE 2026 11 02 / ODOO-350449 (дефект Игоря через ie-webscm7-2 #124878: p196 фільтр чіпа пошуку в таблиці теплокарти однаковий для «Числа» і «Кола»)
            // дерево (childItemsPath) на fast-проходе: кэш _fe.visible узла не отличает «совпал сам» от «поднят найденным потомком» (подъём предков пишет тот же
            // _fe.visible = true), и узел из кэша открывал ВСЕХ детей (set_visible_to_chids_level): таблица теплокарты после Enter — 177 из 434 строк вместо 4;
            // а заново судить только узлы нельзя — кэшированные листья предков не поднимают (замер: 2 строки без групп). Грид, попросивший это
            // (attr.fastPass_treeParents — вкладка «Heatmap (grid)», флаг fe.ux.heatmapGridSearchFilter), всегда идёт полным проходом (сотни строк)
            if (fast && this.attr?.childItemsPath && this.attr.fastPass_treeParents === true) fast = false
            this._unusedByUse = null // use-пустота: use мог переключиться — пересчитать
            this._rowEmptyPass = null   // R21 / R22 (IE 2026 09 20 / ODOO-…): новый проход фильтра — план колонок и память «строка пуста» заново
            let CHIPS = [],
                // грид мог ещё не смонтироваться (лейны multi-grid: watcher общих CHIPS
                // стреляет при открытии виджета ДО initialized) — ниже штатный выход
                rows = this.flex?.rows,
                parentDataItem_chip = null

            if (!rows || !rows.length) {
                if (recheck_tab) this.check_attrTab(this.data)
                return false
            }
            this.optionGroup_initHidden()   // IE 2026 09 17 / ODOO-…: строки выключенных precache-групп — спрятать при приходе данных
            this.yearTotals_sync()   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p217 кнопка Σ — річні підсумки за опцією, типово вимкнено): колонки годового итога — по кнопке Σ и свёрнутости года (после пересборки колонок visible = true)
            if (!level) this.metricDict_frontSync()   // IE 2026 09 19 / ODOO-5800 (словарь метрик «в сеансе»): группы строк спрятали / вернули все строки с отметками метрик — до сверки зеркала
            if (!level) this.metricMirror_ensure()   // IE 2026 09 19 / ODOO-5800: зеркало глобального чипса метрик — словарь метрик мог прийти только сейчас
            if (this.attr?.metricChip_use) this.metricUse_sync()   // IE 2026 09 18 / ODOO-5800 (заказ Игоря: колонка use вкладки Metrics): пришли данные вкладки — use по чипсу грида данных

            const _cpOn = this.chipPlace_on()   // IE 2026 09 19 / ODOO-5800 (пункт 3 Игоря: чипсы таблицы на входе выборки)
            let _styleKeys = []   // IE 2026 09 18 / ODOO-…: отбор по стилям (чипс «style:…»)
            let _metricDoc = null   // IE 2026 09 18 / ODOO-5800 (заказ Игоря «чипс-метрик»): отбор по отметкам правил-метрик (чипс CHIP-Metric)
            let _metricDim = false   // IE 2026 10 07 / ODOO-5800: флаг чипса «Dim other formatting» (нет поля = выключен)
            let _formatDoc = null   // IE 2026 09 20 / ODOO-5800 (Igor: колонка Selector и статистика грида Conditional format, чипс условного оформления CHIP-Format)
            const _chipsV = this.CHIPS_view   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска): + живой чипс (showAllLines — строк не прячет; режим фразы решается и для него)
            for (let i = 0; i < _chipsV.length; i++) {
                const chip = _chipsV[i],
                chip_title = chip.title.trim().toLowerCase()
                if (chip_title.startsWith('>> ')) {
                    parentDataItem_chip = chip_title
                    // pass
                } else if (chip.segment === 'CHIP-Metric') {
                    // IE 2026 09 18 / ODOO-5800 (заказ Игоря «чипс-метрик»): строка видна, если у неё есть отметка правила-метрики (_DLRow.metrics), проходящая
                    // правило ((Grade) и (Metric)) или (Grade + Metric + Reason); пустой чипс не отбирает ничего; «показать строки
                    // без найденных» — только приглушение и переходы
                    if (chip.meta?.use !== false && this.metricChip_on() && !metricChip_isEmpty(chip.doc)) {
                        _metricDoc = chip.doc
                        _metricDim = (chip._raw || chip).dimOtherFormats === true   // IE 2026 10 07 / ODOO-5800
                        if (!(chip._raw || chip).showAllLines) CHIPS.push({ segment: 'CHIP-Search', title: '', _metric: chip.doc })
                    }
                } else if (chip.segment === 'CHIP-Format') {
                    // IE 2026 09 20 / ODOO-5800 (Igor: колонка Selector и статистика грида Conditional format, чипс условного оформления CHIP-Format):
                    // строка видна, если у неё есть отметка отобранного правила (_DLRow.formats); пустой чипс не отбирает ничего; «Show rows without
                    // matches» — только приглушение и переходы
                    if (chip.meta?.use !== false && this.formatChip_on() && !formatChip_isEmpty(chip.doc)) {
                        _formatDoc = chip.doc
                        if (!(chip._raw || chip).showAllLines) CHIPS.push({ segment: 'CHIP-Search', title: '', _format: chip.doc })
                    }
                } else if (chip.segment === 'CHIP-Where') {
                    // IE 2026 09 19 / ODOO-5800 (пункт 3 Игоря: чипсы таблицы на входе выборки): место действия Table у чипса-фильтра — бэк условия к выборке не добавляет,
                    // загруженные строки отбирает грид (check_CHIPS, ветка _where). Input (умолчание) — отбор сделал бэк, грид не вмешивается
                    if (_cpOn && chip.meta?.use !== false && chipPlace_of(chip) === 'table') {
                        const _w = this.chipWhere_known(chip.doc?.WHERE)
                        if (_w.length) CHIPS.push({ segment: 'CHIP-Search', title: '', _where: _w })
                    }
                } else if (chip.segment === 'CHIP-Search' && String(chip.title || '').startsWith('style:')) {
                    // IE 2026 09 18 / ODOO-… (заказ Игоря): отбор по стилям — строка видна, если отобранный стиль есть у неё
                    // или у любой её ячейки (check_CHIPS, ветка _style); «показать строки без найденных» — только приглушение
                    if (chip.meta?.use !== false) {
                        _styleKeys = this.styleFilter_parse(chip.title)
                        if (_styleKeys.length && !(chip._raw || chip).showAllLines) CHIPS.push({ segment: 'CHIP-Search', title: chip.title, _style: _styleKeys })
                    }
                } else if (chip.segment === 'CHIP-Search') {
                    // IE 2026 09 21 / ODOO-… (замечание Игоря: фраза поиска целиком главнее частей): решение «режим фразы» нужно и подсветке, и счётчику —
                    // принимается до проверки «прятать ли строки» (чипс с «Show rows without matches» и входной чипс строк не прячут, но подсвечивают)
                    const _ph = chip_title.startsWith('=') ? null : this.searchPhrase_decide(chip)
                    // ч.2: чекбокс «показать строки без найденных» — search-чипс не участвует
                    // в скрытии строк (в hide-массив не кладём), но подсветка остаётся —
                    // formatItem красит по this.CHIPS независимо от этого массива
                    // IE 2026 09 19 / ODOO-5800 (пункт 3 Игоря: чипсы таблицы на входе выборки): ВХОДНОЙ чипс поиска строк не прячет — отбор сделал бэк (он находит запись
                    // и по коду / id словаря, а грид сверяет только показанное название); остаются подсветка, счётчик и ‹ ›
                    if (!(chip._raw || chip).showAllLines && !(_cpOn && chipPlace_isInput(chip))) {
                        if (chip_title.startsWith('=')) {
                            // выражения (= row.field) не приводить к lowercase — регистр значим при eval
                            CHIPS.push({ segment:'CHIP-Search', title: chip.title.trim() })
                        } else {
                            // IE 2026 09 12 / ODOO-… (заказ Игоря): текст через пробел — разные части, каждая ищется отдельно (AND по строке,
                            // как несколько чипсов); _fuzzy — режим опечаток (gridSearchNav_recompute включает при пустом
                            // результате), check_CHIPS ищет приближённо
                            const _fz = (chip._raw || chip)._fuzzy || 0   // ступень опечаток (0 — точно)
                            const _al = this.searchAlt_chipOn(chip) ? { _alt: true } : null   // IE 2026 09 25 / ODOO-… (замечание Игоря: поиск в таблице по названиям на других языках): режим «на другом языке» — и в отпечатке чипсов (смена режима перерисовывает ячейки)
                            // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок): фраза / часть, найденная в заголовке колонки, — найдена для всех строк: в AND по строке не идёт (все части в шапке — строки не прячутся)
                            if (_ph) { if (!this.gridSearch_headPhrase(_ph)) CHIPS.push({ segment: 'CHIP-Search', title: _ph.text, _phrase: _ph, ..._al }) }   // фраза целиком — один отбор, части не ищутся; IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
                            else for (const _term of headerExclude_terms(searchTerms(chip_title), this.gridSearch_headHit(searchTerms(chip_title), _fz))) CHIPS.push({ segment:'CHIP-Search', title: _term, _fuzzy: _fz, ..._al })   // IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок)
                        }
                    }
                }
            }

            // IE 2026 09 19 / ODOO-5800 (заказ Игоря «глобальный чипс-метрик»: приём чипса отчётом): своего действующего чипса метрик нет — отбор идёт по зеркалу глобального чипса (accept table / both)
            if (!_metricDoc) {
                const _mir = this.metricMirror_chip()
                if (_mir && !metricChip_isEmpty(_mir.doc)) { _metricDoc = _mir.doc; _metricDim = _mir.dimOtherFormats === true /* IE 2026 10 07 / ODOO-5800 */; if (!_mir.showAllLines) CHIPS.push({ segment: 'CHIP-Search', title: '', _metric: _mir.doc }) }
            }
            // IE 2026 09 18 / ODOO-5800 (чипс метрик в отчёте-дереве): строгий отбор. Общее правило дерева «потомки совпавшей строки видны» (нашёл группу —
            // видишь её содержимое) для метрик размывает результат: у итоговой строки страны отметка Low есть, и вместе с ней
            // показывались все её склады без Low (замер Purchase Balance dev02: из 72 видимых строк 20 — такие потомки). Под чипсом
            // метрик видны только строки с отметкой и их предки. Выключатель fe.ux.metricChipStrictTree
            // IE 2026 10 05 / ODOO-5800 (fe-86): строки прячет не только чипс метрик (поиск, условие Table, стиль, оформление, «>> ») — отметка для счёта ячеек сигнала в строках
            // выключенных опций (metricNav_recompute → metricNavHidden_exact); служебный «непустые» сюда ещё не добавлен
            if (!level) this._hideChipsOther = metricNav_otherHiding(CHIPS, parentDataItem_chip)   // IE 2026 10 05 / ODOO-5800
            // IE 2026 10 31 / ODOO-349799 (живая проверка Игоря: «Enabled in this database» / «is Use» на вкладке Addons записи не прятали строки — корень Core проходил выражение,
            // и все потомки показывались без оценки): под чипсом-выражением «= row.<поле>» дерево отбирается строго — каждая строка сама, предки показанной оживают (utils/treeStrict, fe.ux.exprChipStrictTree)
            const _metricStrict = treeStrict_of(CHIPS, (k, d) => this.store.setting(k, d))   // IE 2026 09 20 / ODOO-5800: и чипс условного оформления   // IE 2026 10 31 / ODOO-349799: и чипс-выражение
            const _altOn = CHIPS.some(c => c._alt)   // IE 2026 09 25 / ODOO-… (замечание Игоря: поиск в таблице по названиям на других языках): строки отбираются и по названиям записей ссылочных ячеек на других языках
            if (!level) this._altMark = this.searchAlt_specs()   // задания метки ячеек (formatItem) и подсказки — и при «Show rows without matches»
            // IE 2026 09 18 / ODOO-…: набор отобранных стилей сменился — перерисовать (приглушение ячеек данных без этих стилей)
            if (!level) {
                const _sk = _styleKeys.join('\u241F')
                this._styleFilterDim = this.store.setting('fe.ux.gridStyleFilterDim', true) !== false
                if (_sk !== (this._styleFilterKeys || []).join('\u241F')) { this._styleFilterKeys = _styleKeys; try { this.flex.invalidate() } catch (e) { /* грид ещё не готов */ } }
                // IE 2026 09 18 / ODOO-5800 (заказ Игоря «чипс-метрик»): отбор чипса метрик сменился — перерисовать (приглушение ячеек вне отобранных правил)
                // IE 2026 09 19 / ODOO-5800 (Igor: флаг чипса «Show other formatting»): флаг снят — в таблице остаётся оформление только ключей чипса
                { const _only = this.metricFmt_onlyDoc(), _ok = _only ? metricChip_sig(_only) : '', _first = this._metricOnlySig === undefined
                  if (_first || _ok !== this._metricOnlySig) { this._metricOnlySig = _ok; this._metricOnlyDoc = _only ? metricChip_copy(_only) : null; if (!_first || _ok) this.metricFmt_changed(!_first) } }
                // IE 2026 09 20 / ODOO-5800 (Igor: колонка Selector и статистика грида Conditional format, чипс условного оформления CHIP-Format): отбор чипса оформления и его флаг «Show other formatting»
                // IE 2026 09 20 / ODOO-5800 (приёмка этапа 3 ie-dm7: флаг чипса оформления там, где оформляет бэк; облегчённый cf_stats; названия метрик правил):
                // состояние при открытии (сохранённый чипс со снятым флагом) бэк уже учёл; флаг либо отбор при снятом флаге сменил пользователь — у виджета с
                // оформлением на бэке данные перечитываются с паузой (бэк объявил, что читает флаг чипса оформления: attr.format_other_formats)
                { const _fo = this.formatFmt_onlyDoc(), _fs = _fo ? formatChip_sig(_fo) : '', _firstF = this._formatOnlySig === undefined
                  if (_firstF || _fs !== this._formatOnlySig) { this._formatOnlySig = _fs; this._formatOnlyDoc = _fo ? formatChip_copy(_fo) : null; if (!_firstF || _fs) this.metricFmt_changed(!_firstF && !!this.attr?.format_other_formats) } }
                { const _fk = _formatDoc ? formatChip_sig(_formatDoc) : ''
                  if (_fk !== (this._formatFilterSig || '')) { this._formatFilterSig = _fk; this._formatFilterDoc = _formatDoc ? formatChip_copy(_formatDoc) : null; this._formatFilterIds = _formatDoc ? formatChip_ids(_formatDoc) : null; try { this.flex.invalidate() } catch (e) { /* грид ещё не готов */ } } }
                // IE 2026 10 07 / ODOO-5800 (Igor 07.10: флаг чипса «приглушить другие оформления», по умолчанию выключен): ячейки вне отбора чипса сигналов приглушаются только с флагом.
                // Выключатель fe.ux.metricChipDimFlag (дефолт ВКЛ; false — приглушение всегда, как до 07.10)
                { const _dm = !!_metricDoc && (_metricDim || this.store.setting('fe.ux.metricChipDimFlag', true) === false)
                  if (_dm !== !!this._metricDim) { this._metricDim = _dm; try { this.flex.invalidate() } catch (e) { /* грид ещё не готов */ } } }
                const _mk = _metricDoc ? metricChip_sig(_metricDoc) : ''
                if (_mk !== (this._metricFilterSig || '')) { this._metricFilterSig = _mk; this._metricFilterDoc = _metricDoc ? metricChip_copy(_metricDoc) : null; this._metricCssByKey = null; try { this.flex.invalidate() } catch (e) { /* грид ещё не готов */ } this.metricUse_notify() }
            }
            // ч.1: счётчик найденных ячеек + навигация — пересчёт с дебаунсом после
            // применения фильтра (покрывает все return-пути apply_CHIPS)
            this.gridSearchHeaders_sync()   // IE 2026 10 24 / ODOO-348692 (заказ Игоря: подсветка шапки не снималась после снятия чипса поиска)
            this.gridSearchNav_schedule()

            this.groupHeader_apply()   // IE 2026 11 02 / ODOO-349799 (group-header-value): опция чипа «Field and count» — без пересборки источника (биндинги те же), сеттер wijmo перерисует сам
            if (this.$refs.chips && (this.need_set_itemsSource || !this.$refs.chips.compareChipOrder(this) || !this.$refs.chips.compareChipGroup(this) || !this.$refs.chips.compareChipTree(this) || !this.$refs.chips?.compareGridFilter(this, this.filter))) {
                // пересортировка из-за дозагрузки itemsSource (titles приехали с бэка) —
                // не действие пользователя: вьюпорт не должен прыгать к выделенной строке,
                // которую сортировка унесла на новое место
                const preserveScroll = this.need_set_itemsSource
                const _sp = preserveScroll ? this.flex.scrollPosition : null
                // IE 2026 09 27 / ODOO-5800 (сброс выделения при доливе словаря): set_itemsSource ниже сбрасывает строку выделения и возвращает selectedRanges_BEFORE — снимок
                // последнего клика / загрузки; выбор стрелками или программой откатывался к нему. Снимок ТЕКУЩЕГО выделения (как aggAll_rebuild),
                // fe.ux.gridSelKeepOnRebind
                if (preserveScroll) this.selKeep_snap()   // IE 2026 09 27 / ODOO-5800 (сброс выделения при доливе словаря)
                this.need_set_itemsSource = false
                fast = false
                this.set_itemsSource()
                if (preserveScroll) {
                    const _spx = _sp.x, _spy = _sp.y
                    this.$nextTick(() => {
                        if (!this.flex?.hostElement) return
                        if (this.flex.scrollPosition.x !== _spx || this.flex.scrollPosition.y !== _spy) {
                            this.flex.scrollPosition = new wjcCore.Point(_spx, _spy)
                        }
                    })
                }
            }

            if (this.parentDataItem && !parentDataItem_chip) {
                this.parentDataItem = null
                this.parentDataItem_iroot = null
                this.set_itemsSource()
                return
            }

            if (!level) {
                // IE 2026 09 30 / ODOO-5800: быстрый проход (flexRefresh_afterTimeout после смены видимости колонок) не судит уже оценённые
                // строки (_fe.visible задан) — их счёт остаётся, иначе бейдж глаза терял скрытые строки (замер: глаз выкл→вкл — 26 вместо 49)
                if (!fast) this.count_empty_rows = 0   // IE 2026 09 30 / ODOO-5800
                this.apply_CHIPS_columns(recheck_tab, emptyScanReuse)   // IE 2026 10 29 / ODOO-5800 (webscm #114418: долгая задача 0,86 с после Shift+F3 — скан пустых колонок соседнего грида)
            }
            // IE 2026 09 21 / ODOO-5800 (Igor: под чипсом-фильтром строк итоги групп — по видимым строкам): действует ли прячущий чипс таблицы (служебный «непустые» не в счёт)
            const _ftHiding = CHIPS.length > 0
            if (this._hide_empty()) {
                CHIPS.push({
                    segment:'CHIP-Search', 
                    title:'non-empty'
                })
            }

            // if (!this.store.hide_console) console.log(CHIPS)
            if (!bottomRow) { bottomRow = rows.length-1 }

            if (!level) {
                this.CHIPS_saveToWHERE()
            }

            if (!CHIPS.length) {
                for (let i = topRow; i <= bottomRow; i++) {
                    let row = rows[i],
                    dataItem = row.dataItem,
                    visible = true

                    if (dataItem?._DLRow?.hide || dataItem?._ogHide || (this.WIDGET?.audit_diff && this.auditDiff_hidden(dataItem))) {   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: подсветка изменений записи из аудита): «Differences only» формы аудита
                        //  || dataItem?.use === false + set_nonEmptyWidget TODO; IE 2026 09 17: _ogHide — Option group выключена на фронте
                        visible = false
                    }

                    if (row.visible !== visible) {
                        row.visible = visible
                    }
                    if (dataItem) {
                        if (!dataItem._fe) {
                            dataItem._fe = {key: ++ vueObj.cache_index}
                        }
                        if (dataItem._fe.visible !== visible) {
                            dataItem._fe.visible = visible
                        }
                    }
                }
                if (!level) this.filterTotals_recompute(false)   // IE 2026 09 21 / ODOO-5800: отбора нет — итоги по отбору снять
                return true
            }
            // let visible0 = false
            let rows_root = [], lastlevel = -1, set_visible_to_chids_level = null, hide_children_level = null
            const _hide_empty = this._hide_empty()
            const _fastGroupRevive = fast && fastPassGroupRevive_on(this.store)   // IE 2026 11 01 / ODOO-349799 (sort-tree): только быстрый проход — полный поднимает предков сам
            const _rowNumOn = this.gridSearchRowNum_on()   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
            this._use_off_cache = new WeakMap() // «выключенное поддерево» действительно только на этот проход
            for (let i = topRow; i <= bottomRow; i++) {
                let row = rows[i],
                dataItem = row.dataItem

                if (hide_children_level !== null && row.level > hide_children_level) {
                    let visible = false

                    if (row.visible !== visible) {
                        row.visible = visible
                    }
                    if (dataItem) {
                        if (!dataItem._fe) {
                            dataItem._fe = {key: ++ vueObj.cache_index}
                        }
                        if (dataItem._fe.visible !== visible) {
                            dataItem._fe.visible = visible
                        }
                    }
                } else if (set_visible_to_chids_level !== null && row.level > set_visible_to_chids_level
                           && !(_hide_empty && dataItem && this.isEmpty(dataItem, this.columns()))
                           && !(_hide_empty && this._use_off(dataItem))) {
                    let visible = true

                    if (dataItem?._DLRow?.hide || dataItem?._ogHide || (this.WIDGET?.audit_diff && this.auditDiff_hidden(dataItem))) {   // IE 2026 09 17: + Option group выключена на фронте; // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: подсветка изменений записи из аудита)
                        visible = false
                    }

                    if (this.attr.childItemsPath) {
                        rows_root[row.level] = row
                    }

                    if (row.visible !== visible) {
                        row.visible = visible
                    }
                    if (dataItem) {
                        if (!dataItem._fe) {
                            dataItem._fe = {key: ++ vueObj.cache_index}
                        }
                        if (dataItem._fe.visible !== visible) {
                            dataItem._fe.visible = visible
                        }
                    }
                } else if (dataItem && (!fast || dataItem?._fe?.visible === undefined)) {
                    let visible = false
                    if (this.flex.itemsSource.groupDescriptions.length && row.getCellRange) {
                        visible = true // group rows always visible
                    } else {
                        // несколько чипсов: AND ПО СТРОКЕ — каждый термин найден хоть
                        // в какой-то ячейке (раньше требовалось, чтобы ВСЕ термины были
                        // в ОДНОЙ ячейке: «биогая»+«Украина» в разных колонках → пусто)
                        const _chipHits = CHIPS.length > 1 ? new Array(CHIPS.length).fill(false) : null
                        if (_rowNumOn && !dataItem._variant) { const _nt = rowNum_text(i, this.attr.rowIndexOffset); for (let k = 0; k < CHIPS.length; k++) if (rowNum_hideHit(CHIPS[k], _nt)) { if (_chipHits) _chipHits[k] = true; else visible = true } }   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки): термин равен номеру строки в заголовке строки — для этой строки найден
                        // compare-строки (_variant) не участвуют в поиске: ведём к основным
                        // IE 2026 09 30 / ODOO-343436: строка итога (totals:'start'|'end', _variant 'Total') под фильтром непустых видна всегда — раньше цикл пропускался и visible оставался false
                        if (gridTotalRow_is(dataItem)) visible = true
                        else if (!dataItem._variant) for (let binding in this.attr_by_binding) { // of this.columns()
                            let attr_col = this.attr_by_binding[binding],
                            V = attr_col
                            // if (!attr_col.skip_check_nonEmptyWidget) { TODO LOOK M03 data::measure_title
                            { const _st = shownTitle_of(dataItem, attr_col.binding); if (_st && this.shownTitle_on()) visible ||= this.check_CHIPS(dataItem, _st.toLowerCase(), CHIPS, V, _chipHits) }   // IE 2026 10 04 / ODOO-5800 (fe-71): отбор и по показанному тексту `<binding>-title`; ниже — по прежнему значению (сырое тоже находится)
                                if (attr_col.attr_type === 'AttrMulti') {
                                    V = this.store.get_value(dataItem, attr_col.binding)
                                    if (V) {
                                        visible ||= this.check_CHIPS(dataItem, String(V?.valueStr).toLowerCase() || '', CHIPS, V, _chipHits)
                                    }
                                } else if (attr_col.attr_type === 'AttrLinkOdoo') {
                                    let value = this.store.get_value(dataItem, attr_col.binding + '[1]')
                                    visible ||= this.check_CHIPS(dataItem, String(value).toLowerCase() || '', CHIPS, V, _chipHits)
                                } else {
                                    let value = this.store.get_value(dataItem, attr_col.binding)
                                    if (V.relation_segment) {
                                        let item0 = this.store.itemsSource[V.relation_segment]?.ids?.[value]
                                        if (item0) {
                                            visible ||= this.check_CHIPS(dataItem, (item0.title || item0.id || '').toLowerCase(), CHIPS, V, _chipHits)
                                            // IE 2026 09 25 / ODOO-… (замечание Игоря: поиск в таблице по названиям на других языках): и названия элемента на других языках (titles_alt словаря) — каждая часть может найтись в показанном тексте либо в названии
                                            if (!visible && _altOn) { const _lows = gridSearchAlt_lows(item0); if (_lows) for (const _x of _lows) { visible ||= this.check_CHIPS(dataItem, _x, CHIPS, V, _chipHits); if (visible) break } }
                                        } else if (value != null && value !== '' && typeof value === 'string') {
                                            // значение ВНЕ словаря (литерал в данных отчёта,
                                            // напр. measure_type='LBE' при relation MEASURE) —
                                            // иначе строка вовсе не участвовала в поиске
                                            visible ||= this.check_CHIPS(dataItem, value.toLowerCase(), CHIPS, V, _chipHits)
                                        }
                                    } else if (V.attr_type === 'AttrStr' && value && typeof value === 'string') {
                                        visible ||= this.check_CHIPS(dataItem, value.toLowerCase() || '', CHIPS, V, _chipHits)
                                    } else if ((V.attr_type === 'AttrDays' && Math.abs(Number(value)) === 999 * 30)
                                            || (V.attr_type === 'AttrTime' && Math.abs(Number(value)) === 999 * 30 * 24 * 3600)) {
                                        // sentinel-бесконечность: ищется по "∞", "999", "inf"
                                        visible ||= this.check_CHIPS(dataItem, `${Number(value) < 0 ? '-' : ''}∞ 999 inf`, CHIPS, V, _chipHits)
                                    } else {
                                        visible ||= this.check_CHIPS(dataItem, String(value).toLowerCase() || '', CHIPS, V, _chipHits)
                                    }
                                }
                            // }
                            if (visible) {
                                break
                            }
                            if (_chipHits && _chipHits.every(Boolean)) {
                                visible = true // все термины найдены (по разным ячейкам)
                                break
                            }
                        }
                        if (!visible && _chipHits && _chipHits.every(Boolean)) visible = true
                        // IE 2026 09 20 / ODOO-5800: оформленное правилом ПУСТОЕ поле карточки (cardCf_keepRow) остаётся видимым под фильтром «непустые»
                        // (его чипс 'non-empty' до пустой ячейки значения не доходит); при поисковых чипсах — обычный отбор
                        if (!visible && (this.cardCf_keepRow(dataItem) || (this.attr.attr_type === 'AttrTabGrid' && (dataItem?.attr?._i18nOf || dataItem?._i18nBase || dataItem?.attr?.nonEmpty_keepRow))) && CHIPS.every(ch => ch && ch.title === 'non-empty')) visible = true   // IE 2026 10 06 / ODOO-341407: + пустая строка перевода формы «… (uk)»; IE 2026 10 07 / ODOO-341407: + пустая основа с такими строками; IE 2026 10 28 / ODOO-349799: + строка с признаком бэка nonEmpty_keepRow («Predefined (custom)», ревью PR #176)
                    }
                    // if (row.getCellRange) {
                    //     let rng = row.getCellRange()
                    //     if (visible) {
                    //         for (let j = rng.topRow; j <= rng.bottomRow; j++) {
                    //             rows[j].visible = true
                    //         }
                    //     } else {
                    //         rows[i].visible = this.apply_CHIPS(null, {... false, level+1, rng.topRow + 1, rng.bottomRow)
                    //         // for (let j = rng.topRow + 1; j <= rng.bottomRow; j++) {
                    //         //     let item2 = rows[j].dataItem,
                    //         //         visible2 = false
                    //         //     for (let ifilter = 0; ifilter < CHIPS.length; ifilter++) {
                    //         //         visible2 ||= item2.object && item2.object.toLowerCase().indexOf(CHIPS[ifilter]) >= 0
                    //         //     }
                    //         //     rows[j].visible = visible2
                    //         //     visible = visible || visible2
                    //         // }
                    //         // rows[i].visible = visible
                    //     }
                    //     visible0 ||= rows[i].visible
                    //     i = rng.bottomRow
                    // } else {

                    let curentlevel

                    if (this.flex.itemsSource.groupDescriptions.length) {
                        if (row.getCellRange) {
                            curentlevel = dataItem.level
                            rows_root[curentlevel] = row
                            lastlevel = curentlevel
                        } else {
                            curentlevel = lastlevel + 1
                        }
                    } else if (this.attr.childItemsPath) {
                        curentlevel = row.level
                        rows_root[curentlevel] = row
                    }

                    if (dataItem?._DLRow?.hide || dataItem?._ogHide || (this.WIDGET?.audit_diff && this.auditDiff_hidden(dataItem))) {   // IE 2026 09 17: + Option group выключена на фронте; // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: подсветка изменений записи из аудита)
                        visible = false
                    }

                    if (visible && _hide_empty && dataItem && this.isEmpty(dataItem, this.columns())) {
                        visible = false
                        this.count_empty_rows++
                    }

                    // выключенная строка и родитель, у которого выключены ВСЕ дети,
                    // уходят вместе с поддеревом — до оживления предков ниже, чтобы
                    // скрытый родитель не вытащил за собой всю ветку
                    if (visible && _hide_empty && this._use_off(dataItem)) {
                        visible = false
                        this.count_empty_rows++
                    }

                    if (visible) {
                        for (let level0 = 0; level0 < curentlevel; level0++) {
                            if (!rows_root[level0]) continue
                            let parentDataItem = rows_root[level0].dataItem
                            if (_hide_empty && this._use_off(parentDataItem)) continue
                            if (rows_root[level0].visible !== visible) {
                                rows_root[level0].visible = visible
                            }
                            if (parentDataItem?._fe && parentDataItem._fe.visible !== visible) {
                                parentDataItem._fe.visible = visible
                            }
                        }
                    }

                    if (row.visible !== visible) {
                        row.visible = visible
                    }

                    if (dataItem) {
                        if (!dataItem._fe) {
                            dataItem._fe = {key: ++ vueObj.cache_index}
                        }
                        if (dataItem._fe.visible !== visible) {
                            dataItem._fe.visible = visible
                        }
                    }
                    
                    if (visible && this.attr.childItemsPath && !_metricStrict) {
                        set_visible_to_chids_level = curentlevel
                        hide_children_level = null
                    } else {
                        set_visible_to_chids_level = null
                        if (_hide_empty && this.attr.childItemsPath && this._use_off(dataItem)) {
                            hide_children_level = curentlevel
                        } else if (hide_children_level !== null && curentlevel <= hide_children_level) {
                            hide_children_level = null
                        }
                    }

                } else {
                    let visible = true
                    if (dataItem) visible = dataItem?._fe?.visible || false
                    if (row.visible !== visible) {
                        row.visible = visible
                    }
                    // IE 2026 11 01 / ODOO-349799 (sort-tree): сгруппированный грид на fast-проходе — вести rows_root и по кэшированным строкам, и видимой
                    // строкой данных оживлять группы-родители: после сортировки wijmo пересобрал группы, они судятся заново как «пустые» (глаз
                    // «Hide empty rows»), а кэшированные строки данных их не поднимали — таблица пустела (dev02 01.11, Configuration + чипс Count).
                    // utils/gridFastPassGroups.js; выключатель fe.ux.gridFastPassGroupRevive (по умолчанию ВКЛ)
                    if (_fastGroupRevive && this.flex.itemsSource.groupDescriptions.length) {
                        if (row.getCellRange) lastlevel = fastPass_groupSeen(rows_root, row, dataItem?.level)
                        else if (visible) fastPass_reviveParents(rows_root, lastlevel, (p) => _hide_empty && this._use_off(p))
                    }
                    // на fast-проходе (после вставки/переупорядочивания) строка берётся
                    // из кэша видимости — уровни всё равно надо вести, иначе ребёнок,
                    // у которого кэша ещё нет, всплывёт как «ребёнок видимого родителя»
                    if (this.attr.childItemsPath) {
                        if (visible && !_metricStrict) {
                            set_visible_to_chids_level = row.level
                            hide_children_level = null
                        } else {
                            set_visible_to_chids_level = null
                            if (_hide_empty && this._use_off(dataItem)) {
                                hide_children_level = row.level
                            } else if (hide_children_level !== null && row.level <= hide_children_level) {
                                hide_children_level = null
                            }
                        }
                    }
                }
            }
            
            // колоночный value/condition-фильтр tree-грида накладывается ПОВЕРХ
            // видимости от чипсов — здесь, а не отдельным вызовом: любой apply_CHIPS
            // (смена чипсов, refresh) сохраняет фильтр, гонки с filterChanged нет
            if (!level) this.treeFilter_overlay()
            // IE 2026 09 22 / ODOO-… (замечание Игоря): полосы «Tab row (flat stripe)» под прячущими чипсами следуют за строками своего блока
            if (!level && _ftHiding) this.bandRows_follow(rows, topRow, bottomRow)
            // IE 2026 09 21 / ODOO-5800 (Igor: «При чипсе-фильтре строк без флага "Show rows without matches" нужно пересчитывать итоги»): видимость строк определена —
            // итоги строк-групп по видимым строкам (только показ; fe.ux.filterTotalsRecalc)
            if (!level) this.filterTotals_recompute(_ftHiding)

            if (!level && !this.attr.showEmpty && check_nonEmptyWidget) {
                this.store.check_nonEmptyWidget(this.WIDGET)
            }
            // return visible0

            if (!(_.isEqual(CHIPS||[], this.prev_CHIPS||[]))) {
                this.prev_CHIPS = CHIPS
                if (this.isVisible) {
                    // this.$nextTick(() => {
                        this.flex.refreshCells()
                    // })
                }
            }

            let selectedRanges_row, selectedRanges_col
            try {
                selectedRanges_row = this.flex.selectedRanges?.[0]?.row
                selectedRanges_col = this.flex.selectedRanges?.[0]?.col
            } catch (error) {
                // console.error('Error in apply_CHIPS:', error)
                // this.store.show_notification({ text: error.message, status: 'error' })
            }
            if (selectedRanges_row) {
                // Keep the viewport where the user left it. Only re-scroll to the selection
                // when it is already inside the visible viewport. If the selection is off-screen
                // (user scrolled away, then toggled a selector/checkbox), do NOT jump to it —
                // neither vertically nor horizontally. 2026-07-03
                let vr = null
                try { vr = this.flex.viewRange } catch { vr = null }
                const rowVisible = vr && selectedRanges_row >= vr.topRow && selectedRanges_row <= vr.bottomRow
                if (rowVisible) {
                    this.flex.scrollIntoView(selectedRanges_row, selectedRanges_col ?? -1);
                }
            }
        },
        apply_CHIPS_columns(recheck_tab=true, emptyScanReuse=false) {   // IE 2026 10 29 / ODOO-5800 (webscm #114418: долгая задача 0,86 с после Shift+F3 — скан пустых колонок соседнего грида)
            let groupDescriptions = this.$refs.chips?.getChipGroup()||[]
            this.count_empty_columns = 0
            // lightView: в лёгком виде колонки скрыты самим видом — не трогаем;
            // скрытия пересчитает lightView_apply при переключении в полный
            if (!this.attr.showEmpty && this.data000?.length && this.attr.attr_type !== 'AttrTabGrid' && !this.lightView_active) {
                let isChange
                // IE 2026 10 29 / ODOO-5800 (webscm #114418: долгая задача 0,86 с после Shift+F3 — скан пустых колонок соседнего грида):
                // вердикт «колонка пуста» — из прошлого прохода, если этот проход вызван только словарём и ключ данных тот же (utils/gridEmptyScan.js);
                // флаг fe.ux.gridEmptyScanCache выкл — каждая колонка сканируется, как раньше
                const _esPass = this._hide_empty() ? emptyScan_begin(this._emptyScanCache, this.emptyScan_key(groupDescriptions), { on: gridEmptyScan_on(this.store), reuse: emptyScanReuse, grid: this.attr?.name || this.attr?.binding || '' }) : null   // IE 2026 10 29 / ODOO-5800 (webscm #114418: долгая задача 0,86 с после Shift+F3 — скан пустых колонок соседнего грида)
                for (let col of this.flex.columns) {
                    let isGroupDescriptions = groupDescriptions.find(binding => binding === col.binding)
                    let attr_col = this.attr_by_binding[col.binding]
                    if (!attr_col) {
                        continue
                    }
                    if (attr_col._ogHide || attr_col._ytHide || attr_col._hmTotHide) {   // IE 2026 10 22 / ODOO-5800: колонка выключенной группы опций — спрятана на фронте, в счёт пустых не идёт; // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p217 кнопка Σ — річні підсумки за опцією, типово вимкнено): + итог года, спрятанный Σ   // IE 2026 11 03 / ODOO-350449 (s143): + «Всього» раскрытой группы таблицы теплокарты (_hmTotHide, heatmapGrid_groupTotalsSync) — без неё проход ставил колонку видимой, теплокарта прятала, и так каждые ~0,4 с (клик попадал в соседнюю колонку)
                        if (col.visible) { col.visible = false; isChange = true }
                        continue
                    }
                    // IE 2026 09 30 / ODOO-5800 (Igor: «опция в отчёте, по которой показывать все колонки всегда (даже если они пустые)»):
                    // при doc.params.show_all_columns пустые колонки не прячутся и в бейдж глаза не считаются (он показывает, сколько
                    // скрыто); ранее спрятанные возвращает ветка hide_beacose_empty ниже. Строки и вкладки — по-прежнему (apply_CHIPS, check_attrTab)
                    if (this._hide_empty() && !this.showAllColumns_on() && (attr_col.visible !== false || attr_col.hide_beacose_empty) && attr_col.binding !== 'use' && attr_col.binding !== 'selector' && !attr_col.skip_check_nonEmptyWidget && !attr_col.showEmpty) {   // IE 2026 09 30 / ODOO-5800
                        const _esScan = () => {   // IE 2026 10 29 / ODOO-5800 (webscm #114418: долгая задача 0,86 с после Shift+F3 — скан пустых колонок соседнего грида): прежний скан колонки, без изменений
                        let isEmpty = true, _esCells = 0   // IE 2026 10 29 / ODOO-5800 (webscm #114418: долгая задача 0,86 с после Shift+F3 — скан пустых колонок соседнего грида)
                        const isBoolCol = attr_col?.attr_type === 'AttrBool'
                        for (let row of this.flex.rows) {
                            if (row.dataItem) {
                                _esCells++   // IE 2026 10 29 / ODOO-5800 (webscm #114418: долгая задача 0,86 с после Shift+F3 — скан пустых колонок соседнего грида)
                                // IE 2026 08 16 / ODOO-4997 (заказ Игоря): колонка-
                                // представитель СВЁРНУТОЙ группы дат показывает
                                // агрегат группы — пустоту проверяем по нему, а не
                                // по сырому значению первой даты (свёрнутый 2026
                                // прятался при пустом январе, но непустых итогах)
                                let val = this.foldAgg_getValue(row.dataItem, col.binding, attr_col)
                                // *.valueStr — виртуальный (дисплейный) путь: в данных
                                // хранится только *.value (напр. source_field печати) —
                                // пустой valueStr не признак пустоты, проверяем value
                                if (this.store.isEmpty(val) && String(col.binding || '').endsWith('.valueStr')) {
                                    val = this.store.get_value(row.dataItem, col.binding.slice(0, -9) + '.value')
                                }
                                // массив, где все строки use=false (правила Conditional format),
                                // рендерится пустым (чипсы скрывают use=false) — ячейка пустая
                                if (!this.store.isEmpty(val) && !(isBoolCol && val === false)
                                    && !(Array.isArray(val) && !this.countUseRows(val))) {
                                    isEmpty = false
                                    break
                                }
                            }
                        }
                        return { empty: isEmpty, cells: _esCells }   // IE 2026 10 29 / ODOO-5800 (webscm #114418: долгая задача 0,86 с после Shift+F3 — скан пустых колонок соседнего грида)
                        }
                        const isEmpty = (this.WIDGET?.audit_diff && this.auditDiff_keepCol(col.binding)) ? false   // IE 2026 10 31 / ODOO-349799: колонка с изменённой ячейкой не пустая, пока активно сравнение версий
                            : (_esPass ? emptyScan_column(_esPass, col.binding, _esScan) : _esScan().empty)   // IE 2026 10 29 / ODOO-5800 (webscm #114418: долгая задача 0,86 с после Shift+F3 — скан пустых колонок соседнего грида)

                        if (isEmpty) {
                            this.count_empty_columns++
                        }
                        const setVisible = !isEmpty && !isGroupDescriptions
                        if (col.visible !== setVisible) {
                            col.visible = setVisible
                            attr_col.visible = !isEmpty
                            attr_col.hide_beacose_empty = isEmpty
                            isChange = true
                        }
                    } else if (attr_col.hide_beacose_empty) {
                        col.visible = !isGroupDescriptions
                        attr_col.visible = true
                        attr_col.hide_beacose_empty = false
                        isChange = true
                    } else {
                        col.visible = !isGroupDescriptions
                    }
                }

                if (_esPass) this._emptyScanCache = emptyScan_end(_esPass)   // IE 2026 10 29 / ODOO-5800 (webscm #114418: долгая задача 0,86 с после Shift+F3 — скан пустых колонок соседнего грида)
                if (isChange) {
                    // merge данных посчитан по старому составу видимых колонок —
                    // сбросить только merge-поля кэша (стили/классы не трогаем)
                    for (const _c of this.cache_data_cells.values()) {
                        delete _c.merge_calc; delete _c.merge_col; delete _c.merge_col2
                    }
                    this.flexRefresh()
                }
            }
            if (recheck_tab) this.check_attrTab(this.data000)
        },
        // IE 2026 09 10 / ODOO-… (замечание Игоря): ключ регистрации грида в WIDGET.applys_CHIPS. У полос многоколоночного
        // AttrTabGrid (AttrTabGridLanes) attr.id намеренно undefined — все полосы писались под одним ключом "undefined" и затирали
        // друг друга: глаз «непустые» (store.set_nonEmptyWidget) перефильтровывал только одну полосу (вторая показывала пустые
        // строки при включённом фильтре), счётчик скрытых считал одну полосу. Ключ: id → html_id (у полосы свой …_laneN) → attr_id → uid;
        // снятие регистрации — store.attr_deregister по _applysKey
        applysCHIPS_register() {
            const key = this.attr?.id ?? this.attr?.html_id ?? this.attr_id ?? `uid${this.$?.uid}`
            this._applysKey = key
            this.WIDGET.applys_CHIPS[key] = this
        },
        // IE 2026 10 29 / ODOO-5800 (webscm #114418: долгая задача 0,86 с после Shift+F3 — скан пустых колонок соседнего грида): ключ кэша вердиктов «колонка пуста» — всё, от чего вердикт
        // зависит, кроме словарей: правки данных (_esDataVer), массив строк и его длина, строки / колонки грида, описания колонок,
        // группировка и дерево чипсов (строки-группы), свёртка групп колонок (агрегат представителя), итоги по отбору, стеки отмены, тумблер All
        emptyScan_key(groupDescriptions) {
            const fold = []
            try { for (const gs of this.foldAgg_groups().values()) for (const g of gs) fold.push(g.isCollapsed ? 1 : 0) } catch (e) { fold.push('x') }
            return [
                this._esDataVer || 0, this.data000, this.data000?.length, this.flex?.rows?.length, this.flex?.columns?.length, this.attr_by_binding,
                (groupDescriptions || []).join('\u241F'), (this.applied_chipTree || []).join('\u241F'), fold.join(''), this._ftMap || null,
                this.undoStack?.length || 0, this.redoStack?.length || 0, !!this.aggAll_showAll,
            ]
        },
        _hide_empty() {
            const hide_empty = this.attr_nonEmptyWidget?.active && !this.attr_nonEmptyWidget?.hide && !this.attr.showEmpty
            return hide_empty
        },
        // IE 2026 09 30 / ODOO-5800 (Igor: «предлагаю добавить как опцию в отчете по которой показывать все колонки всегда (даже если они пустые)»):
        // опция записи отчёта doc.params.show_all_columns («Always show all columns», форма — бэк config_widgets) — таблица данных
        // (dataSheet / _doc.data) не прячет пустые колонки при глазе «Hide empty rows, columns, tabs»; пустые строки и вкладки прячутся
        // как раньше. Читает только фронт (как selection_frame, group_totals_repeat, influence_highlight, fold_*_level); смена значения
        // в памяти (галочка на вкладке настроек, без Save) — вотчер 'WIDGET.record.doc.params.show_all_columns'. Свёртку групп колонок
        // (fold_cols_level / isCollapsed) не трогает
        showAllColumns_on() {
            return this.selFrame_isDataGrid() && !!this.store.get_value(this.WIDGET?.record, 'doc.params.show_all_columns')
        },
        // в режиме «только заполненные» строка выключена, если снят её собственный
        // use ИЛИ выключены ВСЕ её дети (рекурсивно) — иначе в дереве настроек
        // остаются заголовки без единой включённой строки. countUseRows тут не
        // годится: он считает строки, а не живое поддерево. Кэш живёт один проход
        // фильтра — без него проверка родителя обходит поддерево на каждой строке
        _use_off(dataItem) {
            if (!dataItem || this.attr.nonEmpty_ignore_use) return false
            if (dataItem.use === false) return true
            const child = this.attr.childItemsPath
            const childs = child ? dataItem[child] : null
            if (!childs?.length) return false
            let off = this._use_off_cache?.get(dataItem)
            if (off === undefined) {
                off = childs.every(row => this._use_off(row))
                // «родитель, у которого выключены ВСЕ дети, уходит» — правило для
                // ЗАГОЛОВКОВ-обёрток. Строка с СОБСТВЕННЫМ содержимым (Fields/Values/
                // прочие колонки) содержательна сама по себе: use=true + выключенные
                // дети-группы не должны прятать её (ожидание: Grid→Rows→Object видимы)
                if (off && this._row_hasOwnContent(dataItem)) off = false
                this._use_off_cache?.set(dataItem, off)
            }
            return off
        },
        _row_hasOwnContent(dataItem) {
            const skip = new Set(['use', 'selector', 'title', 'name', 'id'])
            for (const attr_col of this.columns()) {
                const b = attr_col.binding
                if (!b || skip.has(b) || b === this.attr.childItemsPath) continue
                const v = this.store.get_value(dataItem, b)
                if (!this.store.isEmpty(v)) return true
            }
            return false
        },
        check_attrTab(data) {
            // родитель: при tabs_noId — структурно от рендерящей вкладки (parentAttr);
            // иначе parent_attr мог устареть после пересборки view — резолвим заново
            // (кроме initialAttr-копий: их attr_id указывает на чужой оригинал)
            if (this.store.tabs_noId && this.parentAttr) {
                this.parent_attr = this.parentAttr
            } else if (!this.initialAttr && this.attr_id != null) {
                const found = this.store.widget_attr(this.WIDGET, this.attr_id)
                if (found) { this.parent_attr = found.parent }
            }
            const parent_attr = this.parent_attr
            if (!parent_attr || (parent_attr.attr_type !== 'AttrTab' && parent_attr.attr_type !== 'AttrTabRow')) {
                return // hide управляет только видимостью вкладок
            }
            parent_attr._hideChecked = true   // IE 2026 09 06 / ODOO-336330: вердикт по факту — предварительная проверка панели (tabsPrecheck) его не трогает
            if (parent_attr.showEmpty) return // showEmptyTab
            if (parent_attr.attrs?.length === 1) {
                if ((data?.length||0) <= 0 && this._hide_empty() && !(this.WIDGET?.audit_diff && this.auditDiff_keepTab())) {   // IE 2026 10 31 / ODOO-349799: вкладка ТЧ с изменениями не прячется
                    parent_attr.hide = true
                    this.count_empty_tab = 1
                } else {
                    parent_attr.hide = false
                    this.count_empty_tab = 0
                }
            } else if (parent_attr.hide) {
                // вкладка больше не одиночная — прятать её некому, снимаем залипший hide
                parent_attr.hide = false
                this.count_empty_tab = 0
            }
        },
        CHIPS_saveToWHERE() {
            const TODO = false
            if (TODO && this.attrWHERE_vueObj) {
                let CHIPS = this.CHIPS
                let WHERE = this.WIDGET.record?.params?.WHERE || [],
                rowWHERE_chips = WHERE.find(rowWHERE => rowWHERE.leftValue?.value === '#chips')
                if (!rowWHERE_chips) {
                    rowWHERE_chips = {
                        use: true,
                        leftValue: '#chips',
                        condition: '',
                        rightValue: '',
                        attrs: [],
                    }
                    WHERE.push(rowWHERE_chips)
                }
                
                rowWHERE_chips.use = CHIPS.length > 0
                rowWHERE_chips.attrs = []

                for (let i = 0; i < CHIPS.length; i++) {
                    rowWHERE_chips.attrs.push({
                        use: true,
                        leftValue: '#any_field',
                        condition: 'like',
                        rightValue: CHIPS[i].trim(),
                    })
                }

    
                if (this.attrWHERE_vueObj_refresh_timeout) { clearTimeout(this.attrWHERE_vueObj_refresh_timeout) }
                this.attrWHERE_vueObj_refresh_timeout = window.$cg.setTimeout(this, "AttrGrid.CHIPS_saveToWHERE", () => {
                    // this.attrWHERE_vueObj?.refresh?.(null, true)
                    this.attrWHERE_vueObj?.prepare_AttrMulti_all()
                }, 100)
            }
        },
        filterFields_saveToWHERE(filter) {
            const TODO = false
            if (TODO && this.attrWHERE_vueObj) {
                let WHERE = this.WIDGET.record?.params?.WHERE || [],
                rowWHERE_fields = WHERE.find(rowWHERE => rowWHERE.leftValue.value === '#fields')
                if (!rowWHERE_fields) {
                    rowWHERE_fields = {
                        use: true,
                        leftValue: '#fields',
                        condition: '',
                        rightValue: '',
                        attrs: [],
                    }
                    WHERE.push(rowWHERE_fields)
                }
                
                // flexgrid.collectionView.refreshOnEdit = false;

                let filterDefinition = JSON.parse(filter.filterDefinition)

                rowWHERE_fields.use = filterDefinition.filters.length > 0
                rowWHERE_fields.attrs = []

                for (let i = 0; i < filterDefinition.filters.length; i++) {
                    let row_filter = filterDefinition.filters[i],
                    showValues = row_filter.showValues,
                    keys = Object.keys(showValues).filter(key => showValues[key]),
                    showValues_text = keys.slice(0, 5).join(', ');
                    if (keys.length > 5) {
                        showValues_text += '...';
                    }

                    rowWHERE_fields.attrs.push({
                        use: true,
                        leftValue: row_filter.binding,
                        condition: 'in',
                        rightValue: showValues_text,
                    })
                }

                if (this.attrWHERE_vueObj_refresh_timeout) { clearTimeout(this.attrWHERE_vueObj_refresh_timeout) }
                this.attrWHERE_vueObj_refresh_timeout = window.$cg.setTimeout(this, "AttrGrid.filterFields_saveToWHERE", () => {
                    // this.attrWHERE_vueObj?.refresh?.(null, true)
                    this.attrWHERE_vueObj?.prepare_AttrMulti_all()
                }, 100)
            }
        },
        // hits (массив длиной CHIPS): аккумулятор совпадений ПО СТРОКЕ — hits[i]=true,
        // когда чипс i совпал хоть в одной ячейке. С hits промах чипса в ячейке не
        // обрывает проверку остальных чипсов этой ячейки (AND собирается на уровне
        // строки в apply_CHIPS); возврат по-прежнему «эта ячейка удовлетворяет всем».
        // IE 2026 09 19 / ODOO-5800 (пункт 3 Игоря: чипсы таблицы на входе выборки): место действия чипса грида данных; выключатель fe.ux.chipPlace
        chipPlace_on() { return this.attr?.name === 'dataSheet' && this.store.setting('fe.ux.chipPlace', true) !== false },
        // условия чипса-фильтра, которые умеет фронтовый вычислитель (between, «in selector» и прочее знает только бэк): неизвестное
        // условие строку не прячет — оно просто не участвует; выключенные строки и пустые группы отбрасываются
        chipWhere_known(rows) {
            const KNOWN = new Set(['=', '!=', '<', '>', '<=', '>=', 'like', '!like', 'in', '!in', 'set', '!set'])
            const walk = (list) => (list || []).filter(w => w && w.use !== false).map(w => {
                if (cfWhereIsGroup(w)) { const a = walk(w.attrs); return a.length ? { ...w, attrs: a } : null }
                return KNOWN.has(w.condition) ? w : null
            }).filter(Boolean)
            return walk(rows)
        },
        check_CHIPS(dataItem, title, CHIPS, attr_col, hits = null) {
            let check = false
            let check2 = false
            let all = true
            for (let ifilter = 0; ifilter < CHIPS.length; ifilter++) {
                if (CHIPS[ifilter]._format) {
                    // IE 2026 09 20 / ODOO-5800 (Igor: колонка Selector и статистика грида Conditional format, чипс условного оформления CHIP-Format): решение по строке целиком — по отметкам правил оформления
                    if (formatChip_matchRow(dataItem, CHIPS[ifilter]._format)) {
                        check = true
                        if (hits) hits[ifilter] = true
                    } else if (hits) {
                        all = false
                    } else {
                        return false
                    }
                } else if (CHIPS[ifilter]._metric) {
                    // IE 2026 09 18 / ODOO-5800 (заказ Игоря «чипс-метрик»): решение по строке целиком — по её отметкам правил-метрик
                    if (metricChip_matchRow(dataItem, CHIPS[ifilter]._metric)) {
                        check = true
                        if (hits) hits[ifilter] = true
                    } else if (hits) {
                        all = false
                    } else {
                        return false
                    }
                } else if (CHIPS[ifilter]._where) {
                    // IE 2026 09 19 / ODOO-5800 (пункт 3 Игоря: чипсы таблицы на входе выборки): чипс-фильтр с местом Table — решение по строке целиком, тем же вычислителем
                    // условий, что у правил оформления (utils/cfEval — паритет с бэком)
                    if (this.cf_checkWHERE({ WHERE: CHIPS[ifilter]._where }, dataItem, '', null)) {
                        check = true
                        if (hits) hits[ifilter] = true
                    } else if (hits) {
                        all = false
                    } else {
                        return false
                    }
                } else if (CHIPS[ifilter]._style) {
                    // IE 2026 09 18 / ODOO-… (заказ Игоря): отбор по стилям — решение по строке целиком (любая её ячейка)
                    const set = this.styleKeys_rowSet(dataItem)
                    if (set && CHIPS[ifilter]._style.some(k => set.has(k))) {
                        check = true
                        if (hits) hits[ifilter] = true
                    } else if (hits) {
                        all = false
                    } else {
                        return false
                    }
                } else if (CHIPS[ifilter].title.startsWith('=')) {
                    try {
                        let evaluated_value = CHIPS[ifilter].title.substring(1);
                        let row = dataItem
                        let restrictedEval = new Function('row', 'dataItem', `return ${evaluated_value};`);

                        if (restrictedEval(row, row)) {
                            check = true
                            if (hits) hits[ifilter] = true
                        } else if (hits) {
                            all = false
                        } else {
                            return false
                        }
                    } catch (error) {
                        // console.error("error eval:", error);
                        // this.store.show_notification({ text: err.message, status: 'error' })
                    }
                } else if (CHIPS[ifilter].title === 'non-empty') {
                    if (attr_col?.skip_empty_check) {
                        check2 = true
                        // continue
                    } else if (title !== '' && title !== 'null' && (dataItem.use !== false || this.attr.nonEmpty_ignore_use)) {
                        check = true
                        if (hits) hits[ifilter] = true
                    } else if (hits) {
                        this.count_empty_rows++
                        all = false
                    } else {
                        this.count_empty_rows++
                        return false
                    }
                } else if (CHIPS[ifilter]._phrase ? !!phraseFind(title, CHIPS[ifilter]._phrase) : (CHIPS[ifilter]._fuzzy ? !!fuzzyFindTier(title, CHIPS[ifilter].title, CHIPS[ifilter]._fuzzy) : title.indexOf(CHIPS[ifilter].title) >= 0)) {   // IE 2026 09 12 / ODOO-…: ступень опечаток
                    check = true
                    if (hits) hits[ifilter] = true
                } else if (hits) {
                    all = false
                } else {
                    return false
                }
            }
            return check && all
        },

        filterInitialized(filter) {
            this.filter = filter
            // value-фильтр в tree-гриде (childItemsPath): wijmo собирает uniqueValues
            // только по корневым items коллекции — значения дочерних уровней в список
            // не попадают. Обходим ВСЁ дерево и отдаём uniqueValues сами (сырые значения:
            // dataMap колонки сам мапит их в отображаемые тайтлы). Плоские гриды не трогаем.
            filter.editingFilter.addHandler((s, e) => {
                const childPath = this.attr.childItemsPath
                if (!childPath) return
                const col = s.grid?.columns?.[e.col]
                if (!col?.binding) return
                const cf = s.getColumnFilter(col)
                if (!cf?.valueFilter) return
                const seen = new Set(), values = []
                const walk = (items) => {
                    if (!Array.isArray(items)) return
                    for (const item of items) {
                        const v = this.store.get_value(item, col.binding)
                        if (v !== null && v !== undefined && v !== '') {
                            const k = (typeof v === 'object') ? JSON.stringify(v) : v
                            if (!seen.has(k)) { seen.add(k); values.push(v) }
                        }
                        walk(item?.[childPath])
                    }
                }
                walk(this.flex?.itemsSource?.sourceCollection || this.data)
                if (!values.length) return
                // AttrLink: сырые значения — id. Тайтлы резолвим через itemsSource:
                // uniqueValues отдаём ТАЙТЛАМИ (wijmo при заданных uniqueValues рисует
                // их как есть, dataMap к ним не применяя), а valueFilter.dataMap
                // (id→title) нужен для apply(): значение строки мапится в тот же тайтл.
                const attr_col = this.attr_by_binding[col.binding]
                if (attr_col?.attr_type === 'AttrLink') {
                    const itemsSource = this.store.get_itemsSource(this, {}, attr_col, {fetchMode: 'justGet'})
                    if (itemsSource?.ids) {
                        const pairs = values.map(id => ({id, title: itemsSource.ids[id]?.title ?? `${id}`}))
                        cf.valueFilter.dataMap = new wjGrid.DataMap(pairs, 'id', 'title')
                        cf.valueFilter.sortValues = true
                        cf.valueFilter.uniqueValues = [...new Set(pairs.map(p => p.title))]
                        return
                    }
                }
                cf.valueFilter.sortValues = true
                cf.valueFilter.uniqueValues = values
            })
            filter.editingFilter.addHandler(() => {
                const fsEl = overlayRoot()   // IE 2026 09 23 / ODOO-… (замечание Игоря: панели-меню в Full screen): полноэкран всего документа — панель фильтра остаётся в body
                if (fsEl === document.body) return
                requestAnimationFrame(() => {
                    // find the newly shown panel — skip ones hidden by closeEditor (display:none)
                    const panel = [...document.querySelectorAll('.wj-dropdown-panel')]
                        .find(el => el.style.display !== 'none')
                    if (panel && !fsEl.contains(panel)) fsEl.appendChild(panel)
                    // CSS :fullscreen .wj-dropdown-panel handles position:fixed / z-index
                })
            })
        },
        filterChanged(filter, e) {
            this.$refs.chips?.setChipGridFilter(this, filter)
            // this.filterFields_saveToWHERE(filter)
            this.apply_CHIPS() // наложение tree-фильтра — внутри (treeFilter_overlay)
        },
        // value/condition-фильтр колонок в TREE-гриде (childItemsPath): wijmo
        // фильтрует collectionView, где живут только КОРНИ дерева — отбор по
        // значению подчинённых строк давал ПУСТОЙ грид (в списке фильтра значения
        // детей уже есть — их отдаёт editingFilter-обход, а применение ломалось).
        // Гасим CV-фильтр и применяем видимость сами, семантика дерева:
        // совпавшая строка + все её ПРЕДКИ (контекст) + все её потомки.
        // IE 2026 09 22 / ODOO-… (замечание Игоря по скрину Purchase Balance с чипсом «Беларусь»): полоса-заголовок «Tab row (flat stripe)»
        // (row_type 'tabrow') в дереве грида — строка без детей, строки её блока идут следом на том же уровне до следующей полосы того же
        // уровня или конца родителя; общее правило «предок видимой строки виден» её не касается, и под чипсом полосы PO / + / − / Sales / =
        // пропадали. Полоса видна ⇔ в её блоке есть видимая строка. Зовётся после цикла видимости (и колоночного фильтра дерева) только при
        // прячущих чипсах; без чипсов видимость полос — как пришла. Выключатель fe.ux.gridBandRowsFollow
        bandRows_follow(rows, topRow = 0, bottomRow = 0) {
            if (this.store.setting('fe.ux.gridBandRowsFollow', true) === false) return
            if (!rows || !rows.length) return
            const last = Math.min(bottomRow || rows.length - 1, rows.length - 1)
            // IE 2026 10 06 / ODOO-5800: ИЗВЕСТНОЕ ОГРАНИЧЕНИЕ — вложенная плоская полоса (полоса раздела и её под-полоса лежат подряд на одном уровне): блок внешней
            // пуст, она прячется, под-полоса остаётся без заголовка раздела. Правило «пустой блок наследует видимость следующей полосы» было сделано (9f132c200) и
            // снято: по плоскому списку вложенную полосу не отличить от обычной полосы без строк (сверка 06.10, 1fxa_001, 5 объектов: 7 таких полос — стали бы
            // показанными пустые заголовки). То же у бэка: data_layout2.compare_diff_filter; нужна глубина полосы в _DLRow — отдельная задача
            for (let i = topRow; i <= last; i++) {
                const row = rows[i], d = row.dataItem
                if (!d || d._DLRow?.row_type !== 'tabrow') continue
                if (d._DLRow.hide || d._ogHide) continue   // спрятана раскладкой / выключенной группой — не трогаем
                const lvl = row.level
                let any = false
                for (let j = i + 1; j <= last; j++) {
                    const r2 = rows[j], d2 = r2.dataItem
                    if (r2.level < lvl) break
                    if (r2.level === lvl && d2?._DLRow?.row_type === 'tabrow') break
                    if (r2.visible !== false) { any = true; break }
                }
                if (row.visible !== any) row.visible = any
                if (!d._fe) d._fe = { key: ++this.cache_index }
                if (d._fe.visible !== any) d._fe.visible = any
            }
        },
        // IE 2026 10 05 / ODOO-5800 (fe-86): действует ли фильтр колонок (значения / условия) — он прячет строки поверх чипсов (treeFilter_overlay); не узнать — считаем, что действует
        treeFilter_isActive() {
            const filter = this.filter, flex = this.flex
            if (!filter || !flex) return false
            try { for (const col of flex.columns) { const cf = filter.getColumnFilter(col, false); if (cf && cf.isActive) return true } } catch (e) { return true }
            return false
        },
        treeFilter_overlay() {
            const filter = this.filter, flex = this.flex
            // ⚠ без flex.rows.length в гарде: wijmo мог опустошить коллекцию своим
            // CV-фильтром — нейтрализация ниже её возвращает
            if (!filter || !flex || !this.attr.childItemsPath) return
            const active = []
            for (const col of flex.columns) {
                const cf = filter.getColumnFilter(col, false)
                if (cf && cf.isActive) active.push(cf)
            }
            const cv = flex.collectionView
            // wijmo переустанавливает cv.filter на каждом apply() — нейтрализуем сам
            // предикат: корни проходят ВСЕГДА, видимость строк делает маска ниже
            if (!filter.__treeNeutralized) {
                filter.__treeNeutralized = true
                filter._filter = () => true // будущие apply() биндят уже нейтральный
            }
            if (cv && cv.filter) cv.filter = null // текущий бинд снять; сеттер сам refresh-ит
            if (!active.length) return // фильтр снят — видимость от чипсов остаётся как есть
            const rows = flex.rows, n = rows.length
            const self = new Array(n).fill(false)
            for (let i = 0; i < n; i++) {
                const di = rows[i].dataItem
                // compare-строки (≡ prev / Δ / Δ% / ≡ LBE) сами не матчатся — фильтр
                // ведёт к основным строкам; ошибка предиката = НЕ матч
                self[i] = !!di && !di._variant
                    && active.every(cf => { try { return !!cf.apply(di) } catch (e2) { return false } })
            }
            const mask = new Array(n).fill(false)
            // вниз: потомки совпавшего видимы
            const pathMatch = []
            for (let i = 0; i < n; i++) {
                const lvl = rows[i].level ?? 0
                pathMatch.length = lvl
                mask[i] = self[i] || pathMatch.some(Boolean)
                pathMatch[lvl] = self[i]
            }
            // вверх: предки видимой строки видимы (контекст ветки) — учитываем ТОЛЬКО
            // строки, живые после чипсов (row.visible), чтобы скрытое не оживлять
            const anc = []
            for (let i = 0; i < n; i++) {
                const lvl = rows[i].level ?? 0
                anc.length = lvl + 1
                anc[lvl] = i
                if (mask[i] && rows[i].visible !== false) for (let l = 0; l < lvl; l++) if (anc[l] != null) mask[anc[l]] = true
            }
            // сужение: фильтр только ПРЯЧЕТ поверх текущей видимости
            for (let i = 0; i < n; i++) {
                const row = rows[i], di = row.dataItem
                if (!di || mask[i]) continue
                if (row.visible !== false) row.visible = false
                if (!di._fe) di._fe = { key: ++this.cache_index }
                if (di._fe.visible !== false) di._fe.visible = false
            }
        },
        // -----------------------------------------------------
        aggregateFooters() {
            // АН 2026 08 08: идемпотентно — Σ и подвал переустанавливаются при каждом
            // вызове: после переоткрытия отчёта пересоздание колонок/данных стирало
            // значок Σ и агрегаты, хотя строка подвала оставалась
            if (this.attr.aggregateFooters) {
                if (!this.flex.columnFooters.rows.length) {
                    this.flex.columnFooters.rows.push(new wjGrid.GroupRow())
                }
                this.flex.bottomLeftCells.setCellData(0, 0, 'Σ')
                // подпись Total: в первой видимой колонке, если она не несёт агрегат
                // (не числовая), с мерджем до первой значимой (несущей агрегат).
                // Диапазон читают CustomMergeManager (columnFooters) и formatItem
                this.footerTotalRange = null
                const cols = this.flex.columns
                const isAgg = c => cols[c].visible && cols[c].aggregate
                let c1 = 0
                while (c1 < cols.length && !cols[c1].visible) c1++
                if (c1 < cols.length && !isAgg(c1)) {
                    let c2 = c1
                    while (c2 + 1 < cols.length && !isAgg(c2 + 1)) c2++
                    this.footerTotalRange = { c1, c2 }
                }
            } else if (this.flex.columnFooters.rows.length) {
                this.flex.columnFooters.rows.clear()
                this.footerTotalRange = null
            }
        },
        _hasAttrNumber(attrs) {
            return attrs.some(a => a.attr_type === 'AttrNumber' || (a.attrs && a.attr_type !== 'AttrGrid' && this._hasAttrNumber(a.attrs)))
        },
        dataColumns_nonEmpty(attrs) {
            // колонки шапки строки (merge-область, как в getMergedRange) — не данные:
            // level/measure и т.п. не должны делать строку непустой
            const mergeColumns2 = Math.max(this.mergeColumnBlocksTotal || 0, this.mergeColumns || 0)
            const cache = this._dataColumns_nonEmpty_cache
            if (cache && cache.attrs0 === attrs && cache.mergeColumns2 === mergeColumns2) {
                return cache.attrs
            }
            let result = attrs
            if (mergeColumns2 > 0 && this.flex?.columns?.length) {
                const skipBindings = new Set()
                for (let icol = 0; icol < mergeColumns2 && icol < this.flex.columns.length; icol++) {
                    const binding = this.flex.columns[icol].binding
                    if (binding) skipBindings.add(binding)
                }
                if (skipBindings.size) {
                    // ресурсные колонки (AttrNumber) НЕ исключаем, даже если они во
                    // frozen/merge-области: пустота строки судится по ресурсам, а не по
                    // измерениям (напр. Quantity в BOM — числовой ресурс во frozen-области,
                    // заполнен → строка не пуста; иначе строки компонентов скрывались, задача 10)
                    result = attrs.filter(attr_col => !skipBindings.has(attr_col.binding) || attr_col.attr_type === 'AttrNumber')
                }
            }
            this._dataColumns_nonEmpty_cache = {attrs0: attrs, mergeColumns2, attrs: result}
            return result
        },
        // Множество строк, выключенных сами или через предка (use=false
        // наследуется вниз по дереву attrs). Кэш сбрасывается в apply_CHIPS —
        // пересчёт один на проход скрытия
        isUnused_byUse(dataItem) {
            if (!this._unusedByUse || this._unusedByUse.data !== this.data) {
                const set = new WeakSet()
                const walk = (rows, parentUnused) => {
                    for (const row of rows || []) {
                        if (!row || typeof row !== 'object') continue
                        const unused = parentUnused || row.use === false
                        if (unused) set.add(row)
                        if (Array.isArray(row.attrs) && row.attrs.length) walk(row.attrs, unused)
                    }
                }
                walk(this.data, false)
                this._unusedByUse = { data: this.data, set }
            }
            return this._unusedByUse.set.has(dataItem)
        },
        // IE 2026 09 20 / ODOO-5800 (Igor: «в карточках элементов правил … те же условные оформления их [форм списков]»): поле карточки (строка AttrTabGrid),
        // оформленное правилом условного оформления (attr.cf_rules кладёт бэк, record_cf.py), фильтр «непустые» не прячет: правила заполненности
        // («Lead time is not set») красят именно ПУСТОЕ поле. Выключатель fe.ux.cardCfKeepEmpty (по умолчанию вкл)
        cardCf_keepRow(dataItem) {
            return this.attr.attr_type === 'AttrTabGrid' && Array.isArray(dataItem?.attr?.cf_rules) && dataItem.attr.cf_rules.length > 0
                && this.store.setting('fe.ux.cardCfKeepEmpty', true) !== false
        },
        // R21 / R22 (IE 2026 09 20 / ODOO-…): состояние ОДНОГО прохода (отрисовка либо apply_CHIPS) — память «строка пуста» по строкам и план колонок. Живёт до конца
        // текущей синхронной задачи (микрозадача снимает) и сбрасывается в начале каждого прохода (updatingView, apply_CHIPS): между проходами данные и
        // колонки могли измениться, внутри прохода — не могут
        rowEmpty_passState() {
            let pass = this._rowEmptyPass
            if (!pass) {
                pass = this._rowEmptyPass = { rows: new WeakMap(), plan: null, planFor: null }
                Promise.resolve().then(() => { if (this._rowEmptyPass === pass) this._rowEmptyPass = null })
            }
            return pass
        },
        // R21 (fastEntry.rowEmptyPass): «строка пуста» для класса cell-empty — один расчёт на строку за проход отрисовки. Раньше formatItem звал
        // isEmpty(строка, все колонки) на КАЖДОЙ ячейке: экран отчёта — ~1,7 тыс. ячеек × ~1,6 мс. Выкл: window.fastEntry.set('rowEmptyPass', false);
        // счётчики window._rowEmpty {calls, hits}
        rowEmpty_pass(dataItem) {
            if (!dataItem || typeof dataItem !== 'object' || this.store.fastEntry.rowEmptyPass === false) return this.isEmpty(dataItem, this.columns())
            const rows = this.rowEmpty_passState().rows, key = toRaw(dataItem), st = (window._rowEmpty = window._rowEmpty || { calls: 0, hits: 0 })
            st.calls++
            let empty = rows.get(key)
            if (empty === undefined) { empty = !!this.isEmpty(dataItem, this.columns()); rows.set(key, empty) } else st.hits++
            return empty
        },
        // R22 (fastEntry.rowEmptyPlan): план колонок прохода — по тому же списку колонок, что обходит isEmpty (после dataColumns_nonEmpty)
        rowEmpty_plan(attrs) {
            const pass = this.rowEmpty_passState()
            if (!pass.plan || pass.planFor !== attrs) {
                pass.plan = rowEmpty_buildPlan(attrs, { ignoreUse: !!this.attr.nonEmpty_ignore_use, dataGrid: this.attr.binding == '_doc.data', parse: (b) => this.store._parse_binding(b) })
                pass.planFor = attrs
            }
            return pass.plan
        },
        isEmpty(dataItem, attrs, binding_parent='') {
            // IE 2026 09 10 / ODOO-335246 (Igor): список ХРАНИМОГО сегмента — строка-запись не бывает «пустой» (проверка «по
            // ресурсам» — для источников данных и отчётов; здесь числовая колонка Meta прятала все строки). Флаг ставит бэк
            if (!binding_parent && this.attr.nonEmpty_keepRows) {
                return false
            }
            // IE 2026 10 31 / ODOO-349799 (заказ Игоря: переход ‹ › по изменениям аудита): пока активно сравнение версий (WIDGET.audit_diff), строка с изменением —
            // поле формы (AttrTabGrid) или строка ТЧ — пустой не считается: режим «Hide empty rows, columns, tabs» её не прячет, иначе переход до неё не доходит
            if (!binding_parent && this.WIDGET?.audit_diff && this.auditDiff_keepRow(dataItem)) {
                return false
            }
            // АН 2026 08 08 / #54: итоговая строка (Totals) не скрывается nonEmpty-фильтром
            if (dataItem?._DLRow?.row_type === 'Total') {
                return false
            }
            // IE 2026 09 03 / ODOO-336283: полосы-заголовки (tab / tabrow) — структурные строки без значений
            if (dataItem?._DLRow?.row_type === 'tab' || dataItem?._DLRow?.row_type === 'tabrow') {
                return false
            }
            // IE 2026 08 26 / ODOO-5800 (замечание Игоря «при set_nonEmptyWidget скрылась строка ≡ prev»):
            // compare-подстроки (≡ prev / Δ / Δ%) — производные от видимой основной строки и несут только
            // отличия (текст/AttrLink/AttrDays), которые проверка «по ресурсам» не считает данными.
            // Фильтр «непустые» их не судит — видимость решает основная строка
            if (dataItem?._variant) {
                return false
            }
            if (dataItem?._DLRow?.cmp_prev_only) {   // IE 2026 10 30 / ODOO-5800 (compare: prev-only ghost rows)
                return false   // IE 2026 10 30 / ODOO-5800 (compare: prev-only ghost rows): строка-призрак (есть только в сравниваемой модели) — нулевые текущие значения не делают её пустой
            }
            // Общее правило (Igor): у строки с полем use пустота определяется самим
            // use — use=true → строка НЕ пустая (значения колонок не проверяются),
            // use=false у неё самой или у любого предка → пустая (включённая строка
            // под выключенным родителем всё равно не работает). Явный отказ грида —
            // nonEmpty_ignore_use (ит.2 §4)
            if (!binding_parent && !this.attr.nonEmpty_ignore_use
                    && dataItem && typeof dataItem === 'object' && 'use' in dataItem) {
                return this.isUnused_byUse(dataItem)
            }
            if (this.attr.attr_type === 'AttrTabGrid' && !binding_parent) {
                // IE 2026 09 20 / ODOO-5800 (Igor: «в карточках элементов правил … те же условные оформления их [форм списков]»): поле карточки, оформленное
                // правилом (attr.cf_rules кладёт бэк, record_cf.py — «Lead time is not set» красит именно ПУСТОЕ поле), фильтр «непустые» не прячет —
                // иначе оформление незаполненных реквизитов в карточке не увидеть. Выключатель fe.ux.cardCfKeepEmpty (по умолчанию вкл)
                if (this.cardCf_keepRow(dataItem)) {
                    return false
                }
                // IE 2026 10 06 / ODOO-341407 (заказ Игоря п.2): строка перевода «<поле> (uk)» пустой не прячется — это поле ввода перевода
                if (dataItem?.attr?._i18nOf) {
                    return false
                }
                // IE 2026 10 07 / ODOO-341407 (решение Игоря «2а»): основная строка поля со строками переводов (опция «Show translation fields» включена) — тоже
                if (dataItem?._i18nBase) {
                    return false
                }
                // IE 2026 10 28 / ODOO-349799 (живая проверка D1): строка карточки с признаком бэка nonEmpty_keepRow (галка «Predefined (custom)» —
                // значение False/нет) не прячется как пустая, иначе её нечем включить; аналог грид-признака nonEmpty_keepRows (attrs.py info_predefined_attrs)
                if (dataItem?.attr?.nonEmpty_keepRow) {
                    return false
                }
                return this.store.isEmpty(this.store.get_value(dataItem, 'attr.value'))
            }
            if (!binding_parent) {
                attrs = this.dataColumns_nonEmpty(attrs)
                if (!attrs.length) { // нет колонок данных за шапкой — не скрываем всё подряд
                    return false
                }
            }
            if (!binding_parent && this.attr.binding == "_doc.data" && !this._hasAttrNumber(attrs)) {
                return false
            }
            // R22 (IE 2026 09 20 / ODOO-…, fastEntry.rowEmptyPlan): тот же цикл по колонкам, но по ПЛАНУ — сырые описания колонок с разобранным путём (собраны один раз
            // за проход) и прямое чтение сырой строки; правила пустоты значения и чтения пути — копии store.isEmpty / store.get_value (utils/rowEmpty.js,
            // юнит сверяет с эталонным циклом). Выкл: window.fastEntry.set('rowEmptyPlan', false) — ниже прежний цикл
            if (!binding_parent && dataItem && typeof dataItem === 'object' && this.store.fastEntry.rowEmptyPlan !== false) {
                return rowEmpty_byPlan(toRaw(dataItem), this.rowEmpty_plan(attrs))
            }
            for (let attr_col of attrs) {
                if (this.attr.nonEmpty_ignore_use && attr_col.binding === 'use') {
                    continue // ит.2 §4: значение колонки use не участвует в проверке пустоты строки
                }
                let value = this.store.get_value(dataItem, attr_col.binding)
                if (!this.store.isEmpty(value) && (attr_col.attr_type === 'AttrNumber' || attr_col.attr_type === 'AttrTime' || this.attr.binding != "_doc.data")) { // `${binding_parent}${attr_col.binding}`
                    // TODO "_doc.data" - проверка только по ресурсам, не включая измерения, сейчас косвенно по AttrNumber;
                    // AttrTime тоже данные: строки только с offset/duration (напр. секция DOS) — не пустые
                    return false
                } else if (attr_col.attrs && attr_col.attr_type !== 'AttrGrid' && !this.isEmpty(dataItem, attr_col.attrs, `${binding_parent}${attr_col.binding}.`)) {
                    return false
                }
            }
            return true
        },
        handleVisibility(isVisible) {
            const vueObj = this,
            dropdown = vueObj.store.dropdown
            if (vueObj.isVisible === isVisible) {
                return
            }
            vueObj.isVisible = isVisible
            if (isVisible) {
                // if (vueObj.attr.getSelectionWorkspace_date){ LOOK in vueObj.getSelectionWorkspace_date()
                    vueObj.WIDGET.getSelectionWorkspace_date = vueObj.getSelectionWorkspace_date
                    vueObj.getSelectionWorkspace_date()

                    if (this.attr.attr_type === 'AttrTabGrid') {
                        this.prepare_AttrMulti_all()
                    }
                    const _gdrRebuilt = !!this.need_content_Changed_afterTimeout   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: правка на графе схемы — обновление гридов): данные пересобираются — сверка строк не нужна
                    if (this.need_content_Changed_afterTimeout) {
                        this._i18nRebuildOnShow = false   // IE 2026 10 06 / ODOO-341407: данные и так пересобираются (их смена сбрасывает состояние правки законно)
                        this.content_Changed_afterTimeout()
                    } else if (this._i18nRebuildOnShow) {
                        // IE 2026 10 06 / ODOO-341407 (ревью U9): опция «Show translation fields» переключена, пока грид был скрыт, — колонки переводов
                        // пересобираются с сохранением удалённых строк, истории отмены и признака «изменено»
                        this._i18nRebuildOnShow = false
                        this.i18nFields_listRebuild()
                    }
                    this.gdr_onShow(_gdrRebuilt)   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: правка на графе схемы — обновление гридов): отложенный refresh / строки, изменённые мимо грида
                    if (this.need_flexRefresh_afterTimeout) {
                        this.flexRefresh_afterTimeout()
                    }
                    if (this._isv_need_position) {
                        // позиционирование вкладки-реестра, отложенное до первого показа
                        this.$nextTick(() => this.itemsSourcesView_position())
                    }
                    if (this.need_attrResize_afterTimeout) {
                        this.attrResize_afterTimeout()
                    }
                    if (this.need_autoSizeColumns) {
                        this.autoSizeColumns()
                    }
    
                    // this.attr_loadPyodide()
                // }
                // vueObj.dropdown_showForActiveCell()
            } else {
                vueObj.gdr_onHide()   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: правка на графе схемы — обновление гридов): снимок строк на момент скрытия
                if (dropdown.vueObj === vueObj) {
                    dropdown.hide()
                }
                // грид скрыт переключением вкладки (display:none, а не скроллом за экран) —
                // закрыть его Row-попап (любой: строка/ячейка/view-настройки): попапы
                // позиционируются fixed поверх страницы и сами с вкладкой не прячутся
                const el = vueObj.$refs.attr_container
                if (el && el.offsetParent === null) {
                    const WRow = vueObj.store.get_childrenWidget(vueObj.WIDGET, 'widget-row')
                    if (WRow && !WRow._softClosed && WRow.record?._meta?.binding === vueObj.attr.binding) {
                        vueObj.store.widget_close(WRow.id)
                    }
                }
            }
        },
        // IE 2026 09 24 / ODOO-341407 (смена языка без reload): подписи шапки колонок заново из attr_col.title (уже в новом языке) —
        // живые ColumnGroup грида (flex.getColumnGroups) в паре с описаниями (flex.columnGroups — тот же массив, что отдан гриду;
        // у описания ссылка _attr_col), плоский грид — по attr_by_binding; данные/ширины/выделение не трогаются. Возвращает число замен
        // IE 2026 09 24 / ODOO-341407 (второй обход dev02: статусы «Done» строк doc.data_tasks после живого переключения): справочники
        // itemsSource перечитаны под новым языком (relocalize, phase 'data'; get_dataMap(force) даёт НОВЫЙ DataMap) — вотчер
        // itemsSource_change_index перепривязывает dataMap только у AttrLink-колонок, у прочих колонок со ссылкой (AttrStr + relation_segment)
        // оставался прежний объект со старыми подписями. Перепривязка тем же get_itemsSource(justGet), что и у вотчера
        i18n_rebindDataMaps() {
            if (!this.flex) return 0
            let n = 0
            for (const col of this.flex.columns) {
                const attr_col = this.attr_by_binding?.[col.binding]
                if (!attr_col?.relation_segment || !col.dataMap) continue
                const is = this.store.itemsSource?.[attr_col.relation_segment]
                if (!is?.dataMap || col.dataMap === is.dataMap) continue
                try { this.store.get_itemsSource(this, col, attr_col, { fetchMode: 'justGet' }); n++ } catch (e) { /* без справочника */ }
            }
            return n
        },
        i18n_relabelColumns() {
            const flex = this.flex
            if (!flex || !flex.columns) return 0
            let n = 0
            const setHeader = (col, attr_col) => {
                if (!col || !attr_col || col.header === '↑') return
                // схлопнутая группа (месяц с единственной видимой колонкой): подпись — title ГРУППЫ (_collapsedGroup, перелокализована в view),
                // _groupTitle — снимок на момент сборки колонок (проба dev02: «July» оставался английским под ru)
                const grp = attr_col._collapsedGroup
                if (grp && typeof grp.title === 'string' && grp.title && attr_col._groupTitle !== grp.title) attr_col._groupTitle = grp.title
                const h = attr_col._groupTitle || attr_col.title
                if (typeof h === 'string' && col.header !== h) { col.header = h; n++ }
            }
            const zip = (groups, defs) => {
                for (let i = 0; i < groups.length; i++) {
                    const g = groups[i], d = Array.isArray(defs) ? defs[i] : null
                    const a = (d && d._attr_col) || (g.binding ? this.attr_by_binding?.[g.binding] : null)
                    setHeader(g, a)
                    const kids = g.columnGroups
                    if (kids && kids.length) zip(kids, d && d.columns)
                }
            }
            let live = null
            try { live = typeof flex.getColumnGroups === 'function' ? flex.getColumnGroups() : null } catch (e) { live = null }
            if (live && live.length) zip(live, flex.columnGroups)
            else for (const col of flex.columns) setHeader(col, this.attr_by_binding?.[col.binding])
            return n
        },
        flexRefresh(reason = null) {   // IE 2026 10 29 / ODOO-5800 (webscm #114418: долгая задача 0,86 с после Shift+F3 — скан пустых колонок соседнего грида): reason 'dict' — только приезд словаря (вотчер itemsSource_change_index)
            if (reason === 'dict') { if (!this.need_flexRefresh_afterTimeout) this._esDictOnly = true } else this._esDictOnly = false   // IE 2026 10 29 / ODOO-5800 (webscm #114418: долгая задача 0,86 с после Shift+F3 — скан пустых колонок соседнего грида)
            this.need_flexRefresh_afterTimeout = true
            if (!this.isVisible) {
                return
            }
            if (this.flexRefresh_timeout) { clearTimeout(this.flexRefresh_timeout) }
            this.flexRefresh_timeout = window.$cg.setTimeout(this, "AttrGrid.flexRefresh", () => {
                this.flexRefresh_afterTimeout()
            }, this.isVisible ? 3 : 600)
        },
        flexRefresh_afterTimeout() {
            if (!this.need_flexRefresh_afterTimeout) {
                return
            }
            if (!this.flex?.hostElement) return // грид уже disposed (таймер пережил unmount)
            this.need_flexRefresh_afterTimeout = false
            const _esReuse = this._esDictOnly === true; this._esDictOnly = false   // IE 2026 10 29 / ODOO-5800 (webscm #114418: долгая задача 0,86 с после Shift+F3 — скан пустых колонок соседнего грида)
            this.apply_CHIPS(null, {fast:true, emptyScanReuse: _esReuse}) // need for correct re-order rows, after 'store.itemsSource_change_index' 2025-09-09; IE 2026 10 29 / ODOO-5800 (webscm #114418: долгая задача 0,86 с после Shift+F3 — скан пустых колонок соседнего грида)
            this.flex.refresh()
        },
        refresh(items=null, modified=true, check_WHERE=true) {
            this.need_refresh_afterTimeout = true
            if (!this.isVisible) {
                // IE 2026 10 25 / ODOO-348925 (заказ Игоря: правка на графе схемы — обновление гридов): скрытый грид (вкладка не активна / прокручен за экран) — обновление
                // откладывается до показа (gdr_onShow), бейдж вкладки — сразу; выключатель fe.ux.gridDeferredRefresh выкл — как было (ничего)
                if (this.gdr_on()) { this._gdrPending = gdrMerge(this._gdrPending, items, modified, check_WHERE); gdrCount('deferred'); this.set_AttrTabPanel_countItems() }
                return
            }
            this._gdrPending = null   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: правка на графе схемы — обновление гридов): видимый — обновляется сейчас
            // if (this.refresh_timeout) { clearTimeout(this.refresh_timeout) }
            // this.refresh_timeout = window.$cg.setTimeout(this, "AttrGrid.refresh", () => {
                this.refresh_afterTimeout(items, modified, check_WHERE)
            // }, this.isVisible ? 1 : 600)
        },
        refresh_afterTimeout(items=null, modified=true, check_WHERE=true, opts=null) {   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: правка на графе схемы — обновление гридов): opts.onShow — отложенное при показе
            this.need_refresh_afterTimeout = false
            this._esDataVer = (this._esDataVer || 0) + 1   // IE 2026 10 29 / ODOO-5800 (webscm #114418: долгая задача 0,86 с после Shift+F3 — скан пустых колонок соседнего грида): строки / данные обновлены
            if (check_WHERE) {
                this.check_WHERE()
            }

            if (this.flex) {
                if (items) {
                    for (let dataItem of items) {
                        delete dataItem['$cutMarker']
                    }
                }
                // IE 2026 09 16 (замечание Игоря: окно строки открывалось на чужую строку): маркер вырезания $cutMarker живёт только между
                // cut и paste (вырезанные строки в данных не лежат) — оставшийся на строке в данных маркер устарел: он уезжал в сохранённую
                // запись и потом резал строку при первой вставке; снимаем на каждом обновлении данных
                this.cutMarker_stripStale(this.data000 || this.data)
                this.assignHierarchicalNumbers(this.data)


                this.$nextTick(() => {
                    if (opts?.onShow) this._gdrApplying = false   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: правка на графе схемы — обновление гридов): строки перечитываются сейчас
                    // секции печати пересоздаются реактивно (write-back/новое
                    // превью) — nextTick мог пережить dispose грида
                    if (!this.flex?.hostElement?.isConnected) return
                    this.flex.collectionView.refresh()
                    this.flex_check_isReadOnly()
                    this.apply_CHIPS(null, {check_nonEmptyWidget: false, recheck_tab: false})

                    if (modified) {
                        this.setModified()
                    }
    
                    // this.$nextTick(() => { 2025-07-12 optimization
                    //     this.flex.refreshCells()
                    //     this.apply_CHIPS()
                    // })

                    if (items) {
                        this.$nextTick(() => {
                            this.selected_items(items)
                        })
                    }
                    if (!opts?.onShow) this.$nextTick(() => {   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: правка на графе схемы — обновление гридов): показ грида — не действие в нём, фокус не переносится
                        // activity-theft-guard: программный возврат DOM-фокуса гриду
                        // (нужен для стрелок/hotkeys после обновления данных) НЕ должен
                        // переносить визуальную активность — иначе виджет-источник
                        // крадёт её у окна, открытого Alt+кликом/кнопкой open за миг
                        // до этого. См. парный guard в Widget.vue::onFocusIn.
                        this.store._suppressFocusActivate = true
                        try {
                            this.flex.hostElement?.focus()
                        } finally {
                            setTimeout(() => { this.store._suppressFocusActivate = false }, 0)
                        }
                    })
                })
            }
        },
        // ---------- IE 2026 10 25 / ODOO-348925 (заказ Игоря: правка на графе схемы — обновление гридов) ----------
        // refresh() скрытого грида раньше только ставил need_refresh_afterTimeout, которого никто не читал: строки, добавленные / удалённые в записи, пока грид скрыт (граф схемы,
        // шахматка, refreshAttr_AfterChange), не показывались и после открытия вкладки, бейдж вкладки оставался старым. Теперь отложенное (аргументы слиты) применяется при показе;
        // refresh не звали, но табличную часть поменяли мимо грида — сверка снимком строк (скрытие ↔ показ) и refresh без пометки «изменено». Выключатель fe.ux.gridDeferredRefresh
        // (§8, дефолт ВКЛ, без пересборки); выкл — как было. Счётчики — window.__gdrStats
        gdr_on() { return gdrOn((k, d) => this.store.setting(k, d)) },
        gca_on() { return gcaOn((k, d) => this.store.setting(k, d)) },   // IE 2026 10 25 / ODOO-348878 (заказ Игоря: высота строк после «свернуть все»)
        // IE 2026 10 25 / ODOO-348878 (заказ Игоря: высота строк после «свернуть все»): пересчёт после массовой свёртки — как groupCollapsedChanged у одиночной
        // (высоты начал секций + сброс кэша ячеек); грид пересоздан / выключен collapseOnePass — ничего. Счётчик — _collapseOnePass.bulk
        collapseBulk_run(flex) {
            if (!flex || this.flex !== flex || !flex.hostElement || this.store?.fastEntry?.collapseOnePass === false) return
            const t0 = performance.now()
            const changed = this.sectionHeights_sync(flex)
            this.refreshing()
            const st = this._collapseOnePass || (this._collapseOnePass = { calls: 0, heightsChanged: 0, ms: 0 })
            st.bulk = (st.bulk || 0) + 1; st.heightsChanged += changed; st.ms += performance.now() - t0
        },
        gdr_busy() { return !!(this._gdrPending || this._gdrApplying) },   // строки грида старые: обновление отложено до показа или идёт сейчас (граф / шахматка ждут с выбором строки)
        gdr_snap() { return gdrSnap(this.data000 || this.data, this.attr?.childItemsPath, gridSave_toRaw) },
        gdr_onHide() {
            this._gdrSnap = this.gdr_on() && this.flex?.hostElement ? this.gdr_snap() : null
        },
        gdr_onShow(rebuilt=false) {
            const pending = this._gdrPending, snap = this._gdrSnap
            this._gdrPending = null; this._gdrSnap = null
            if (!this.gdr_on() || !this.flex?.hostElement) return ''
            const plan = gdrShowPlan(pending, snap, () => this.gdr_snap(), rebuilt)
            if (!plan) return ''
            gdrCount(plan.why)
            this._gdrApplying = true
            this.refresh_afterTimeout(plan.items, plan.modified, plan.check_WHERE, { onShow: true })
            this.set_AttrTabPanel_countItems()
            return plan.why
        },
        prepare_AttrMulti_all(attrs=this.columns()) {
            let t =12
            for (let attr_col of attrs) {
                if (attr_col.attr_type === 'AttrMulti') { //  && this.attr.attr_type !== 'AttrTabGrid'
                    this.flex.rows.forEach((item, irow) => {
                        if (item.dataItem) {
                            let parentsList = this.get_parentsList(irow, attr_col)
                            this.store.prepare_AttrMulti(this, attr_col, item.dataItem, parentsList)
                        }
                    })
                }
                if (attr_col.attrs && attr_col.attr_type !== 'AttrGrid') {
                    this.prepare_AttrMulti_all(attr_col.attrs)
                }
            }
        },

        // ------------- drag&drop ----------------------------------------
        wjRow_mousedown (e) {
            if (this.set_selectedRanges_BEFORE_timerId) { clearTimeout(this.set_selectedRanges_BEFORE_timerId) }
            this.set_selectedRanges_BEFORE_timerId = window.$cg.setTimeout(this, "AttrGrid.wjRow_mousedown", () => {
                // IE 2026 08 20 / ODOO-5512: грид мог быть размонтирован до
                // срабатывания таймера (закрытие дропдауна настроек по клику)
                if (!this.flex?.hostElement) return
                this.selectedRanges_BEFORE = this.selBefore_snap(this.flex.selectedRanges)   // IE 2026 09 27 / ODOO-5800: снимок с binding колонок
            }, 100)
        },
        dragStart (e) {
            if ((this.isMac && e.metaKey) || (!this.isMac && e.ctrlKey)) {
                let dragStart_rule = {}, dragOver_rule = {}
                
                this.store.dropdown.hide()

                // IE 2026 09 23 / ODOO-341407: i18n (titleStr — подписи; title — выражения, не трогаем)
                if (this.attr.name === 'fields-target-source') {
                    dragStart_rule = {
                        'rows >>> move': {'titleStr':t('Fields rule'), 'valueStr':'target_field.valueStr >>> source_field.valueStr'},
                        'cells >>> cells': {'title':'attr_col.title'},
                    }
                    dragOver_rule = {
                        '>>> cells.fields': true, // check itemsSource_segment, use
                        '>>> insert.cells.fields': true, // check itemsSource_segment, use
                    }
                } else if (this.attr.name === 'data_tasks') {
                    dragStart_rule = {
                        'rows >>> move': {'titleStr':t('Task'), 'valueStr':'title'},
                        'rows >>> cells': {'titleStr':t('Task'), 'valueStr':'title', 'value':'widget', 'field_doc':{'title': t('Task'), 'binding':'widget', 'attr_type':'AttrLink', 'relation_segment':'TASKS'}},
                    }
                    dragOver_rule = {
                        '>>> cells': true, // title, widget, use
                    }
                } else if (this.attr.name === 'selection-list' && !this.WIDGET.is_fieldsList) {
                    dragStart_rule = {
                        'rows >>> move': {'title':'_widget.title', 'valueStr':'title'},
                        'rows >>> cells': {'title':'_widget.title', 'valueStr':'title', 'value':'id', 'field':'_widget.attr'},
                    }
                } else if (this.attr.name === 'selection-list' && this.WIDGET.is_fieldsList) {
                    dragStart_rule = {
                        'rows >>> move': {'title':'_widget.title', 'valueStr':'title'},
                        'rows >>> fields': {'titleStr':t('Field'), 'valueStr':'title', 'value':'id', 'field':'..dataItem'},
                    }
                } else if (this.attr.name === 'fields' || this.attr.name === 'viewList' || this.attr.name === 'view') {
                    dragStart_rule = {
                        'rows >>> move': {'titleStr':t('Field'), 'valueStr':'title'},
                        'rows >>> cells.filds': {'titleStr':t('Field'), 'valueStr':'title', 'value':'binding', 'field':'..dataItem'},
                        'rows >>> insert.rows.fields': {'titleStr':t('Field'), 'valueStr':'title', 'value':'..dataItem'},
                    }
                    dragOver_rule = {
                        '>>> insert.rows.fields': true,
                    }
                } else if (this.attr.name === 'viewWHERE')  {
                    dragStart_rule = {
                        'rows >>> move': {'titleStr':t('Filter rule'), 'valueStr':'leftValue.valueStr >>> rightValue.valueStr'},
                    }
                    dragOver_rule = {
                        '>>> cells': true,
                        '>>> insert.cells': true,
                    }
                } else if (this.attr.attr_type === 'AttrTabGrid') {
                    dragStart_rule = {
                        'rows >>> move': {'title':'attr.title', 'valueStr':'attr.valueStr'},
                        'rows >>> cells': {'title':'attr.title', 'valueStr':'attr.valueStr', 'value':'attr.value', 'field':'attr'},
                        'rows >>> filds': {'title':'attr.title', 'field':'attr'},
                    }
                    dragOver_rule = {
                        '>>> cells': true, // check V.attr_type
                    }
                } else if (this.WIDGET.widget_class === 'widget_LIST')  {
                    dragStart_rule = {
                        'rows >>> move': {'title':'_widget.title', 'valueStr':'title'},
                        'rows': {'title':'_widget.title', 'valueStr':'title', 'value':'id', 'field_doc':{'title': '_widget.title', 'binding':'...', 'attr_type':'AttrLink', 'relation_segment':'_widget.record.doc.params.segment'}},
                        'cols >>> fields': {'titleStr':t('Field'), 'valueStr':'attr_col.title', 'value':'attr_col.binding', 'field':'attr'},
                    }
                } else  {
                    dragStart_rule = {
                        'rows >>> move': {'title':'GRID.title || tooltip', 'valueStr':'.firstColValue'},
                        'cells >>> cells': {'title':'attr_col.title'},
                    }
                }
    
                this.drag_checkSelectedRanges(e)
                let pSource = this.store.params_dragSource = {
                    type: 'row',
                    ...this.get_paramsCell(e.target),
                    
                    // node
                    join: 'center',
                    
                    header:'',
                    textList:[],
                    
                    // field,
                    // itemsSource_segment,
    
                    // dataItems,
                    // attr_cols,
                    // cells,
                }
    
                for (let child of pSource.row_div.children) {
                    if (child.textContent) {
                        pSource.textList.push(child.textContent)
                        break
                    }
                }
    
                if (pSource.attr.name === 'selection-list') {
                    // pSource.type = 'grid-row-field'
                    // pSource.header = `${pSource.WIDGET.itemsSource_segment_title}: `
    
                } else if (pSource.WIDGET.widget_class === 'widget_LIST')  {
                    pSource.textList = []
                    pSource.textList.push(`${pSource.cell_div.textContent}`)
                    pSource.header = `${pSource.field.title}: `
    
    
    
                } else if (pSource.WIDGET.widget === 'widget-record' || pSource.WIDGET.widget === 'widget-row')  {
                    pSource.textList = []
                    pSource.textList.push(`${pSource.cell_div.textContent}`)
                    pSource.header = `${pSource.V.title || pSource.attr_col.title}: `
                // } else if (this.attr.name === 'fields-target-source') {
                //     pSource.itemsSource_segment = 'TASKS'
                    
                //     pSource.textList.push(`${pSource.dataItem.title}`)
                }
    
                wjcCore.addClass(pSource.row_div, 'drag-source')
                
                e.dataTransfer.setData('text/plain', pSource.textList.join('\t'))
                e.dataTransfer.setDragImage(this.get_dragImage(pSource), 10, 40)
    
                e.dataTransfer.effectAllowed = 'copyMove'
                e.stopPropagation()
                
            } else {
                e.preventDefault(); // отмена драга, если нет нужной клавиши
            }
        },
        drag_checkSelectedRanges(e) {
            if (!this.selectedRanges_BEFORE) {
                return
            }
            let pCell = this.get_paramsCell(e.target),
            {topRow:r1, bottomRow:r2, leftCol:c1, rightCol:c2} = this.selectedRanges_BEFORE[0],
            r0 = pCell.cell.row,
            c0 = pCell.cell.col,
            target_in_selectedRanges = (r1 <= r0 && r0 <= r2 && c1 <= c0 && c0 <= c2)

            if (target_in_selectedRanges) {
                this.flex.selectedRanges = this.selectedRanges_BEFORE
            } else {
                this.flex.selectedRanges = [new wjGrid.CellRange(r0, c0, r0, c0)]
            }
        },
        get_dragImage(pSource) {
            const dragImage = pSource.dragImage = document.createElement('div')
            dragImage.className = 'drag-box'

            dragImage.innerHTML = `
                <b class='drag-header'>${pSource.header}</b> 
                <b class='drag-text'> ${pSource.textList.join(', ')}</b>`

            document.body.appendChild(dragImage)

            return dragImage
        },
        get_paramsCell (target_div, isTarget=false) {
            let row_div = wjcCore.closest(target_div, '.wj-row'),
            cell_div = wjcCore.closest(target_div, '.wj-cell'),
            cell = cell_div.data_cell,
            dataItem = this.flex.rows[ cell.row ].dataItem,
            V,
            field,
            field_parent,
            field_mapping_segment,
            itemsSource_segment,
            attr_col = V = this.attr_by_binding[cell.col_binding]
            if (attr_col.attr_type === 'AttrMulti' && dataItem) {
                V = this.store.get_value(dataItem, attr_col.binding) || {}
            }

            field_parent = this.WIDGET._meta?.parent_binding || '' // TODO
            if (this.attr.attr_type === 'AttrGrid') {
                field_parent += this.attr.binding
            }

            field_mapping_segment = this.WIDGET.record.segment
            if (this.attr.attr_type === 'AttrTabGrid') {
                field = {...dataItem.attr, id:dataItem.attr.binding}
                itemsSource_segment = field.source_segment

            } else if (this.attr.name === 'selection-list') {
                field = dataItem
                itemsSource_segment = this.WIDGET.itemsSource_segment

            } else if (this.WIDGET.widget_class === 'widget_LIST')  {
                field = {...V, id:V.binding}
                itemsSource_segment = this.WIDGET.record.doc.params?.segment

            } else {
                field = {...V, id:V.binding}
                itemsSource_segment = this.WIDGET.record.segment
            }

            return {
                div: target_div,
                WIDGET: this.WIDGET,
                attr: this.attr,
                vueObj: this,
                row_div, cell_div, cell, dataItem, V, attr_col, field, field_parent, field_mapping_segment, itemsSource_segment,
            }
        },
        
        dragOver (e) {
            let pSource = this.store.params_dragSource

            // attrGridField DnD
            if (pSource?.type === 'attrGridField') {
                const pOver = this.get_paramsCell(e.target, true)
                if (pOver?.cell_div) {
                    const attr_col = this.attr_by_binding[pOver.cell?.col_binding]
                    if (attr_col?.attr_type === 'AttrGrid') {
                        e.preventDefault()
                        e.dataTransfer.dropEffect = 'move'
                        const pTarget = this.store.params_dragTarget || {}
                        this.removeClass_dragOver(pTarget, '', pOver.cell_div)
                        this.addClass_dragOver(pTarget, '', pOver.cell_div)
                        this.store.params_dragTarget = { ...pOver, type: 'cell', type2: 'attrGridField' }
                    }
                }
                return
            }

            if (!(pSource?.type === 'row')) {
                return
            }

            let pOver = {
                join: 'center',
                ...this.get_paramsCell(e.target, true),
            },
            pTarget = this.store.params_dragTarget || {}

            if (!this.store.hide_console) console.log('pOver: ')
            if (!this.store.hide_console) console.log(pOver.row_div)
            if (!this.store.hide_console) console.log(pTarget)

            pOver.type = ''
            pOver.insert = e.shiftKey || e.ctrlKey || e.altKey || e.metaKey

            let source_column = pSource.WIDGET.attr_isMappedWidget?.check_binding || null,
            target_column = pOver.WIDGET.attr_isMappedWidget?.check_binding || null,
            canBeMapped = source_column && target_column && source_column !== target_column

            if (pOver.row_div && pSource.vueObj === this) {
                pOver.type = 'row'
                pOver.join = 'bottom'

            } else if (pOver.cell_div) {
                if (this.attr.name === 'fields-target-source') {
                    // if (pSource.field_mapping_segment === this.get_itemsSource_segment(pOver.attr_col, pOver.V)) {
                    //     pOver.type = 'cell'
                    // } else {
                        for (let child_div of pOver.row_div.children) {
                            Object.assign(pOver, this.get_paramsCell(child_div))
                            if (pSource.field_mapping_segment === this.get_itemsSource_segment(pOver.attr_col, pOver.V)) {
                                pOver.type = 'cell'
                                pOver.type2 = 'drop_in_mapping'
                                break
                            }
                        }
                    // }

                } else {
                    if (canBeMapped) {
                        pOver.type = 'cell'
                        pOver.type2 = 'create_mapping'
                    } else if (pOver.attr_col.binding === 'attr' && pSource.itemsSource_segment && pSource.itemsSource_segment === pOver.V.relation_segment) {
                        pOver.type = 'cell'
                    }
                }
            }

            e.preventDefault()
            e.dataTransfer.dropEffect = 'move'
            
            if (pOver.type === 'row' && pOver.row_div) {
                this.removeClass_dragOver(pTarget, pOver.row_div)
                if (pSource.row_div !== pOver.row_div && pTarget.row_div !== pOver.row_div) {
                    this.addClass_dragOver(pTarget, pOver.row_div)
                }
            } else if (pOver.type === 'cell' && pOver.cell_div) {
                if (pOver.insert) {
                    e.dataTransfer.dropEffect = 'copy'
                    pOver.join = 'bottom'
                    this.removeClass_dragOver(pTarget, pOver.row_div, pOver.cell_div)
                    if (pSource.row_div !== pOver.cell_div) {
                        this.addClass_dragOver(pTarget, pOver.row_div, pOver.cell_div)
                    }
                } else {
                    this.removeClass_dragOver(pTarget, '', pOver.cell_div)
                    if (pSource.row_div !== pOver.cell_div) {
                        this.addClass_dragOver(pTarget, '', pOver.cell_div)
                    }
                }
            } else {
                pOver.type = ''
            }

            if (pOver.type) {
                this.store.params_dragTarget = {
                    ...pOver,
                    row_div: pOver.row_div,
                    cell_div: pOver.cell_div,
                }
                if (pSource.div && pTarget.div) {
                    this.PAGE.vueObj?.showEdge_svg_afterTimeout(pSource, pSource, pOver)
                }

            } else {
                this.store.params_dragTarget = {}
                this.removeClass_dragOver(pOver)
            }
        },
        addClass_dragOver (pTarget, row_div='', cell_div='') {
            if (row_div && pTarget.row_div !== row_div) {
                for (let child of row_div.children) {
                    if (!this.store.hide_console) console.log(`add drag-over-row`)
                    wjcCore.addClass(child, 'drag-over-row')
                }
                pTarget.row_div = row_div
            }

            if (cell_div && pTarget.cell_div !== cell_div) {
                if (!this.store.hide_console) console.log(`add drag-over-cell`)
                wjcCore.addClass(cell_div, 'drag-over-cell')
                pTarget.cell_div = cell_div
            }
        },
        removeClass_dragOver (pTarget, row_div='', cell_div='') {
            if (pTarget.row_div && row_div && pTarget.row_div !== row_div) {
                for (let child of pTarget.row_div.children) {
                    if (!this.store.hide_console) console.log(`remove drag-over-row`)
                    wjcCore.removeClass(child, 'drag-over-row')
                }
                pTarget.row_div = ''
            }

            if (pTarget.cell_div && cell_div && pTarget.cell_div !== cell_div) {
                if (!this.store.hide_console) console.log(`remove drag-over-cell`)
                wjcCore.removeClass(pTarget.cell_div, 'drag-over-cell')
                pTarget.cell_div = ''
            }
        },
        
        dragDrop (e) {
            let pSource = this.store.params_dragSource

            // attrGridField DnD
            if (pSource?.type === 'attrGridField') {
                const pTarget = this.store.params_dragTarget
                if (pTarget?.type2 === 'attrGridField') {
                    const attr_col = this.attr_by_binding[pTarget.cell?.col_binding]
                    if (attr_col?.binding && pTarget.dataItem && pTarget.dataItem[attr_col.binding] == null) {
                        this.store.set_value(pTarget.dataItem, attr_col.binding, [])
                    }
                    const targetValue = pTarget.dataItem?.[attr_col?.binding]
                    if (Array.isArray(targetValue)) {
                        const idx = pSource.sourceValue.indexOf(pSource.field)
                        if (idx !== -1) pSource.sourceValue.splice(idx, 1)
                        targetValue.push(pSource.field)
                        this.useCount_cellApply(pTarget.dataItem, attr_col)
                        // источник переноса — своя строка-владелец (возможно, в другом гриде)
                        const src_vueObj = pSource.vueObj,
                        src_col = src_vueObj?.attr_by_binding?.[pSource.sourceCell?.col_binding]
                        if (src_col && src_vueObj.useCount_cellApply) {
                            let src_dataItem = src_vueObj.flex?.rows?.[pSource.sourceCell.irow]?.dataItem
                            if (src_vueObj.store.get_value(src_dataItem || {}, src_col.binding) !== pSource.sourceValue) {
                                src_dataItem = null
                                for (const r of src_vueObj.flex?.rows || []) {
                                    if (src_vueObj.store.get_value(r.dataItem || {}, src_col.binding) === pSource.sourceValue) {
                                        src_dataItem = r.dataItem
                                        break
                                    }
                                }
                            }
                            src_vueObj.useCount_cellApply(src_dataItem, src_col)
                        }
                        this.refresh()
                        pSource.vueObj?.refresh?.()
                    }
                }
                this.store.params_dragSource = null
                this.store.params_dragTarget = null
                return
            }

            if (!(pSource?.type === 'row')) {
                return
            }

            let pTarget = this.store.params_dragTarget || {}

            if (pTarget.type === 'row' && pTarget.row_div) {
                pSource.irow = this.rows_indexOf(pSource.dataItem)
                pSource.parentItems = this.get_parentItems(pSource.irow)
                
                pTarget.irow = this.rows_indexOf(pTarget.dataItem)
                pTarget.parentItems = this.get_parentItems(pTarget.irow)
                pTarget.irowItem = pTarget.parentItems.indexOf(pTarget.dataItem)

                pSource.dataItem['$cutMarker'] = 1
                let movedItems = this.cut_byMarker()

                let addI = 0
                if (pSource.parentItems !== pTarget.parentItems || pSource.irow > pTarget.irow) {
                    addI = 1
                }

                pTarget.parentItems.splice(pTarget.irowItem + addI, 0, ...movedItems)
                this.refresh(movedItems)
                this.attr_set()
                this.run_attr_action_afterChange()

            } else if (pTarget.type === 'cell' && pTarget.cell_div) {
                let dataItem
                if (pTarget.type2 === 'create_mapping') {
                    this.create_mapping(pTarget, pSource)
                } else {
                    if (pTarget.type2 === 'drop_in_mapping') { // this.attr.name === 'fields-target-source'
                        dataItem = pSource.field
                    } else if (pSource.attr.name === 'selection-list') {
                        dataItem = pSource.dataItem
                    } else {
                        dataItem = pSource.dataItem[pSource.attr_col.binding]
                    }

                    if (pTarget.insert) {
                        this.new_Click(e, false, pTarget.cell.row++)
                        this.drop_dataItem (pTarget.cell, dataItem)
                    } else {
                        this.drop_dataItem (pTarget.cell, dataItem)
                    }
                }

                // isMapped
                if (pSource.vueObj.isMappedWidget_rows || pSource.vueObj.isMappedWidget_cols) {
                    this.store.set_isMappedWidgets(pSource.WIDGET)
                }
            }
        },
        drop_dataItem (cell, chosenItem) {
            let attr_col = this.attr_by_binding[cell.col_binding]
            this.choiceFinish({attr_col2:attr_col, cell:cell}, chosenItem)
        },
        create_mapping_fields(fields, source_column, target_column, source_binding, target_binding) {
            let field
            fields = fields.filter(field0 => {
                if (field0[source_column]?.value === source_binding ||
                    field0[target_column]?.value === target_binding) {
                    if (!field) {
                        field = field0 // keep first
                        return true
                    }
                    return false
                }
                return true
            })

            if (!field) {
                field = {}
                fields.push(field)
            }
            field.use = true
            field[ source_column ] = source_binding
            field[ target_column ] = target_binding

            return {fields, field}
        },
        create_mapping(pTarget, pSource) {
            let fields = this.PAGE.WIDGET_transfer.record.doc.params?.fields,
            source_column = pSource.WIDGET.attr_isMappedWidget.check_binding,
            target_column = pTarget.WIDGET.attr_isMappedWidget.check_binding

            if (!pTarget.field_parent) {
                const { fields: updatedFields } = this.create_mapping_fields(fields, source_column, target_column, pSource.field.binding, pTarget.field.binding)
                fields = updatedFields

            } else {
                const { fields: parentFields, field: parentField } = this.create_mapping_fields(fields, source_column, target_column, pSource.field_parent, pTarget.field_parent)
                fields = parentFields

                parentField.attrs = parentField.attrs || []
                const { fields: childFields } = this.create_mapping_fields(parentField.attrs, source_column, target_column, pSource.field.binding, pTarget.field.binding)
                parentField.attrs = childFields
            }

            this.PAGE.WIDGET_transfer.record.doc.params.fields = fields

            this.PAGE.WIDGET_transfer.record._meta = this.PAGE.WIDGET_transfer.record._meta || {}
            this.PAGE.WIDGET_transfer.record._meta.modified = true
            this.PAGE.WIDGET_transfer.record._meta.calced = false
            let attr_vueObj = this.PAGE.WIDGET_transfer.vueObj.get_vueObj('fields-target-source')
            attr_vueObj.content_Changed()
        },
        
        dragEnd(e) {
            let pSource = this.store.params_dragSource
            if (!(pSource?.type === 'row')) {
                return
            }

            let pTarget = this.store.params_dragTarget || {}
            
            document.body.removeChild(pSource.dragImage)
            if (pSource.svg) {
                this.PAGE.vueObj?.hideEdge_svg(pSource)
            }
            this.removeClass_dragOver(pTarget)
            this.store.params_dragSource = {}
            this.store.params_dragTarget = {}
        },
        scrollPositionChanged() {
            try { this.groupHeaderOverflow_sync(this.flex) } catch { /* грид мог перестраиваться */ }   // IE 2026 10 12 / ODOO-335099 (RP1): прокрутка 0 / не 0 — до перерисовки кадра
            try { this.sigPrefetch_cancel() } catch { /* очереди нет */ }
            try { this.stk_cancel() } catch { /* очереди нет */ }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: виды ячеек запаса под ключ — Z5 по умолчанию; BE ie-dm7 stock_cells_batch): прокрутка — отложенная порция снята, новый экран — после обновления вида   // IE 2026 11 03 / ODOO-350449 (Игорь: предзагрузка цепочек сигналов; BE ie-dm7 #1009): прокрутка — очередь прежнего экрана снята (новый соберёт updatedView)
            // IE 2026 08 18: прокрутка — навигация: снимает свежесть вспышки, а
            // переиспользованные ячейки теряют право на подсветку связи
            if (this._flashBatch && Date.now() - this._flashBatch.ts > 400) this.flash_end()
            if (this._traceGrp) this.trace_clear()
            if (this.isVisible) {
                const flex = this.flex

                // IE 2026 08 16: рамки карточек следуют за прокруткой — сразу и
                // догоном (wijmo двигает ячейки уже после события прокрутки,
                // иначе рамки «отвязываются» от карточек при hscroll)
                try { this.cards_overlay_sync() } catch { /* грид мог перестраиваться */ }
                requestAnimationFrame(() => { try { this.cards_overlay_sync() } catch { /* ok */ } })
                clearTimeout(this._cardsSyncT)
                this._cardsSyncT = setTimeout(() => { try { this.cards_overlay_sync() } catch { /* ok */ } }, 160)

                this.PAGE.vueObj?.refreshe_svg(0)
                if (!this.ignore_selectionChanged) {
                    this.isScrollingDown = flex.scrollPosition.y < (this.scrollPosition?.y || 0)
                    this.isScrollingUp = flex.scrollPosition.y > (this.scrollPosition?.y || 0)
                    this.isScrollingRight = flex.scrollPosition.x > (this.scrollPosition?.x || 0)
                    this.isScrollingLeft = flex.scrollPosition.x < (this.scrollPosition?.x || 0)
                    this.scrollPosition = flex.scrollPosition

                    // sticky-полоса группы: пересчёт при ЛЮБОМ движении скролла,
                    // в т.ч. горизонтальном. ⚠ НЕ возвращать условие
                    // isScrollingDown/Up: после перестройки грида (Refresh виджета,
                    // фильтр, смена данных) строка sticky пересоздаётся СКРЫТОЙ, и
                    // если пользователь дальше крутит только горизонтально (даты
                    // отчёта) — полоса группы не вернётся никогда (рецидив
                    // 2026-07-28: «нет липкого заголовка группы»). Вызов дёшев:
                    // внутри debounce 210мс.
                    this.set_stickyRows()

                    // sticky-headers-left
                    const stickyHeaders = true
                    if (stickyHeaders && (this.isScrollingRight || this.isScrollingLeft)) {
                        this.set_stickyColumns()
                    }
                }
            }
        },
        set_breakGapMasks() {
            // разрыв колонок (break_before): ячейки строк сдвигаются вправо, но
            // объединённая ячейка ВЕРХНЕГО ряда шапки перекрывает зазор целиком —
            // её topline/фон видны в промежутке. Маскируем зазор по всей высоте
            // шапки (фон страницы); позиции зазоров пишет formatItem при сдвиге
            // (break_before может стоять на группе, а не на leaf-колонке).
            const flex = this.flex
            const ch = flex?.hostElement?.querySelector('[wj-part="chcells"]')
            if (!ch) return
            ch.querySelectorAll('.break-gap-mask').forEach(el => el.remove())
            // только стилевые схемы: маски разрывают их cs-topline; в классике
            // topline нет — белые полосы масок сами становились артефактом
            // IE 2026 09 29 / ODOO-343343 (заказ Игоря: начало плана штриховкой): маска «начала плана» (штриховка + флажок) нужна и в классике
            const styled_ = document.body.className.includes('cscheme-style')
            const hdrH = flex.columnHeaders?.height || 0
            if (!hdrH) return
            const add = (left, width, plan) => {
                const d = document.createElement('div')
                d.className = plan ? 'break-gap-mask break-gap-plan ps-cap ps-cap-top' : 'break-gap-mask'
                d.style.left = `${left}px`
                d.style.width = `${width}px`
                d.style.height = `${hdrH}px`   // bottom:0 в панели схлопывался (высота 0)
                if (plan) { const f = document.createElement('div'); f.className = 'break-plan-flag ps-flag'; const i = document.createElement('i'); i.className = 'pi pi-flag-fill'; f.appendChild(i); d.appendChild(f) }
                ch.appendChild(d)
            }
            if (this.attr.use_delivery && this.break_width && this._breakGaps?.size) {
                for (const [left, width] of this._breakGaps) {
                    const plan_ = !!(this._breakPlanGaps && this._breakPlanGaps.has(left)) && this.planStartOn()
                    if (styled_ || plan_) add(left, width, plan_)
                }
            }
            // IE 2026 09 30 / ODOO-343343 (заказ Игоря: начало плана штриховкой — объяснение по Alt у флажков): контейнер ячеек шапки и панель шапки (ch) — источник Alt-объяснения «по точке» для маски начала плана (altTooltip._find: __altTipAt; data-alt-tip-at — пересчёт при движении внутри одной ячейки)
            for (const _h of new Set([ch, ch.closest('[wj-part="ch"]') || ch])) {
                if (ch.querySelector(':scope > .break-gap-plan')) { _h.setAttribute('data-alt-tip-at', ''); _h.__altTipAt = (x, y) => this.planStart_headerTip(_h, x, y) }
                else { _h.removeAttribute('data-alt-tip-at'); _h.__altTipAt = null }
            }
            if (!styled_) return
            // хвост за последней колонкой: растянутая colgroup-ячейка (cs-topline)
            // рисовала паразитный верхний бордюр там, где колонок уже нет
            let totalW = 0
            for (const c of flex.columns) {
                if (c.visible) totalW = Math.max(totalW, c.pos + (c.renderWidth || c.width || 0))
            }
            if (totalW > 0) add(totalW, 100000)
        },
        set_stickyColumns() {
            // if (this.set_stickyColumns_timeout) { clearTimeout(this.set_stickyColumns_timeout); this.count_set_stickyColumns = (this.count_set_stickyColumns||0) + 1 }
            // this.set_stickyColumns_timeout = window.$cg.setTimeout(this, "AttrGrid.set_stickyColumns", () => {
                this.set_stickyColumns_afterTimeout()
            // }, 1)
        },
        set_stickyColumns_afterTimeout() {
            const flex = this.flex

            // 1. frozenWidth
            let frozenWidth = 0
            if (flex.frozenColumns) {
                for (let i = 0; i < flex.frozenColumns; i++) {
                    const col2 = flex.columns[i]
                    if (col2?.visible) {
                        // renderWidth: у авто-колонок width меньше фактической
                        // (напр. 4 vs 25) — недобор смещал paddingLeft и
                        // «съедал» первый символ липкой метки
                        frozenWidth += col2.renderWidth || col2.width || 0
                    }
                }
            }

            const calc_paddingLeft = (flex_col) => {
                // flex.columnHeaders.cellType === 2
                const cell = this.divCells.get(`${2}-${flex_col?._rng?.row}-${flex_col?._rng?.col}`)
                if (cell) {
                    let left = parseFloat(cell.style.left) || 0;
                    let width = parseFloat(cell.style.width) || 0;
                    let paddingLeft = -(left + flex.scrollPosition.x - frozenWidth)

                    return {cell, left, width, paddingLeft}
                }
                return {cell, left: 0, width: 0, paddingLeft: 0}
            }

            // 2. ищем первую видимую ячейку шапки. Старт — с первой НЕзамороженной
            // колонки: в гридах с frozen (Object/Subject/...) viewRange.col указывает
            // на замороженную, её parentGroup-цепочка не содержит date-группы →
            // 2026/Q1/March не получали paddingLeft и «съедались» слева
            let col = Math.max(flex.viewRange.col, flex.frozenColumns || 0)
            while (col < flex.viewRange.col2 && flex.columns[col] && !flex.columns[col].visible) col++
            let {cell, left, width, paddingLeft} = calc_paddingLeft(flex.columns[col])
            while (!(paddingLeft < width) && col < flex.viewRange.col2) {
                col++;
                ( {cell, left, width, paddingLeft} = calc_paddingLeft(flex.columns[col]) )
            }

            // 3. собираем и обрабатываем все родительские группы
            const appliedCells = new Set()
            let parentGroup = flex.columns[col]?.parentGroup
            while (parentGroup !== null && parentGroup !== undefined) {
                ( {cell, left, width, paddingLeft} = calc_paddingLeft(parentGroup) )
                if (cell && paddingLeft > 0 && !cell.classList.contains('cg-hdr-al')) {   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: заголовок группы колонок по align): группа с align center / right не липнет
                    // сдвиг до края вьюпорта + РОДНОЙ padding ячейки: инлайн-значение
                    // перетирает CSS-паддинг, без добавки текст начинался ровно на
                    // границе и первый символ подрезался («2026» → «026»)
                    cell.style.paddingLeft = ''
                    const basePad = parseFloat(getComputedStyle(cell).paddingLeft) || 0
                    // метка должна помещаться в ячейку: фиксированный clamp
                    // (width-150) урезал сдвиг и «съедал» первый символ; scrollWidth
                    // тоже врёт (глиф/спейсер) — берём фактическую ширину контента
                    let labelW = 0
                    try {
                        const rng = document.createRange()
                        rng.selectNodeContents(cell)
                        labelW = Math.ceil(rng.getBoundingClientRect().width)
                    } catch { labelW = 150 }
                    let pad = paddingLeft + basePad
                    const maxPad = width - labelW - 4
                    if (pad > maxPad) pad = Math.max(basePad, maxPad)
                    cell.style.paddingLeft = `${pad}px`
                    appliedCells.add(cell)
                }
                parentGroup = parentGroup.parentGroup
            }

            // 4. сброс устаревшего сдвига: инлайн padding-left в шапке ставит только
            // эта функция; при пересоздании/переиспользовании ячеек (виртуализация,
            // кэш cssText) он оставался от прежней позиции скролла — текст группы
            // «съедался» слева или висел сдвинутым после возврата влево
            const chcells = flex.hostElement?.querySelector('[wj-part="chcells"]')
            if (chcells) {
                for (const c of chcells.querySelectorAll('.wj-cell')) {
                    if (!appliedCells.has(c) && c.style.paddingLeft) c.style.paddingLeft = ''
                }
            }
        },
        set_stickyRows() {
            if (this.set_stickyRows_timeout) { clearTimeout(this.set_stickyRows_timeout); this.count_set_stickyRows = (this.count_set_stickyRows||0) + 1 }
            this.set_stickyRows_timeout = window.$cg.setTimeout(this, "AttrGrid.set_stickyRows", () => {
                this.set_stickyRows_afterTimeout()
                this.set_stickyRows_afterTimeout_ = 10
            }, this.set_stickyRows_afterTimeout_ || 210)
        },
        set_stickyRows_afterTimeout() {
            // ══ КАРТА МЕХАНИЗМА STICKY-ПОЛОСЫ ГРУППЫ (куски связаны — не удалять по одному) ══
            // 1. create_stickyRows: служебная строка columnHeaders[stickyScrollStart], создаётся СКРЫТОЙ
            // 2. formatItem (e_row === stickyScrollStart): класс .sticky-scroll + ЧИСТКА ячейки
            // 3. здесь: цепочка групп stickyScrollRows по viewRange + ЗАЩЁЛКА видимости строки
            // 4. set_stickyRowsTitle_afterTimeout: тайтл — в НЕПОДВИЖНОМ оверлее .sticky-scroll-title
            //    (в ячейках НИКОГДА: они скроллятся по X — текст дёргался; переиспользование
            //    wijmo-ячеек оставляло «призраки»)
            // 5. scrollPositionChanged: БЕЗУСЛОВНЫЙ вызов set_stickyRows (и при горизонтальном скролле)
            // 6. getSelectionWorkspace_date: явный вызов после восстановления скролла при перестройке
            // История регрессий: 47fabc1ed39 (призрак тайтла в переиспользованной ячейке),
            // 4c459afa9dd (подложка строк при toggle высоты шапки → защёлка; тайтл в одну из
            // нескольких ячеек), 2026-07-28 (полоса пропадала после перестройки грида — пп. 5-6).
            // Любое упрощение проверять сценариями: скролл вверх до нуля, Refresh виджета в глубине,
            // горизонтальная прокрутка дат после Refresh, фильтр со скрытыми строками.
            const useStickyScroll = !this.get_viewParam('hideStickyScroll')
            if (useStickyScroll && this.stickyScrollStart) {
                const flex = this.flex
                if (!flex?.rows) return; // !flex?._g
                const rows = flex.rows;

                let vp;
                try { vp = flex.viewRange } catch { return }
                let startScan = vp.row;
                if (!vp || startScan === -1) return;

                // скрытые строки (фильтр/«скрывать незаполненные») имеют pos предыдущей
                // видимой — viewRange.row может указать на СКРЫТУЮ строку чужой ветки
                // выше, и deep/цепочка собрались бы от неё (тайтл соседней группы).
                // Сдвигаемся к первой видимой.
                while (startScan < rows.length && rows[startScan] && !rows[startScan].visible) startScan++
                if (startScan >= rows.length) return;

                // const offset = Math.round( - (flex.scrollPosition.y % flex.rows.defaultSize) / flex.rows.defaultSize * 100) / 100
                // if (offset > 0.5 && startScan + 1 < vp.row2) {
                //     startScan++;
                // }
                // if (offset !== 0 && this.isScrollingDown && startScan + 1 < vp.row2) {
                //     if (rows[startScan + 1].level > rows[startScan].level) {
                //         // Если уровень больше 0, то начинаем сканировать со следующей строки
                //         startScan++;
                //     }
                // }

                let deep = null
                const row = rows[startScan];
                if (row) deep = row.level;

                if (!this.attr.childItemsPath) {
                    for (let r = startScan; r >= 0; r--) {
                        const row = rows[r];
                        if (!row || !row.visible) continue;

                        if (row instanceof wjGrid.GroupRow) {
                            deep = row.level + 1;
                            break;
                        }
                    }
                }

                const stickyRowsTitle_raw_old = this.stickyScrollRows.join('  /  ')
                if (deep) {
                    this.stickyScrollRows.length = 0;
                    for (let r = startScan, deep0 = deep - 1; r >= 0 && deep0 >= 0; r--) {
                        const row = rows[r];
                        if (!row) continue;
                        // скрытая строка (hide-empty/фильтр) — не предок видимой:
                        // её тайтл в полосе — «чужой» заголовок (dev02, chain=[0,1]
                        // при start=55 — взяты невидимые строки другой ветки)
                        if (!row.visible) continue;

                        if (row.level === deep0) {
                            this.stickyScrollRows.unshift(r);
                            deep0--
                        }
                    }
                    // IE 2026 11 02 / ODOO-349799 (sticky-group) (замечание Игоря по dev02, «Конфігурація», группы «Вид, Підсистема»): viewRange.row —
                    // сама строка группы, пока она видна (прокрутки нет) — цепочка несла её же тайтл в полосу над ней. Оставляем только уровни,
                    // чья строка-заголовок ушла за верхний край (row.pos < −scrollPosition.y; закреплённые строки не прокручиваются); цепочка —
                    // префикс (предок выше потомка). Защёлка видимости строки-полосы ниже не меняется: наверху полоса пустая, как прежде
                    if (this.stickyScrollRows.length && stickyGroupScrolled_on((k, d) => this.fmtSetting(k, d))) {
                        const _st = -(flex.scrollPosition?.y || 0), _frz = flex.rows.frozen || 0
                        const _kept = stickyGroup_scrolledChain(this.stickyScrollRows.map((r) => ({ row: r, top: rows[r]?.pos, frozen: r < _frz })), _st)
                        if (_kept.length !== this.stickyScrollRows.length) { this.stickyScrollRows.length = 0; this.stickyScrollRows.push(..._kept) }
                    }
                } else {
                    this.stickyScrollRows.length = 0;
                }

                // защёлка: sticky-строка шапки, раз показавшись, ОСТАЁТСЯ видимой —
                // toggle её видимости при прокрутке дёргает высоту шапки, и в полосе
                // просвечивают строки прокручиваемой области («подложка»). Наверху
                // (заголовок группы сам виден) полоса остаётся ПУСТОЙ: тайтл чистит
                // set_stickyRowsTitle (перепоиск живой ячейки — исходный «призрак»
                // был именно из-за незаписи тайтла в переиспользованную ячейку)
                const columnRow = flex.columnHeaders.rows[this.stickyScrollStart],
                visible = this.stickyScrollRows.length > 0 || columnRow?.visible
                if (columnRow && columnRow.visible !== visible) {
                    columnRow.visible = visible
                    // wijmo может НЕ перерисовать chcells при смене видимости строки
                    // шапки: ячейки полосы отсутствовали целиком (dev02, sticky-diag
                    // cellsAtRow=[]) — ни класса, ни зачистки, ни якоря оверлея.
                    // Смена видимости — редкое событие, лёгкий invalidate дёшев
                    try { flex.invalidate() } catch (e) { /* грид занят — след. тик */ }
                }

                this.firstColumnIsVisible = 0
                while (this.firstColumnIsVisible < flex.columns.length && !flex.columns[this.firstColumnIsVisible].visible) {
                    this.firstColumnIsVisible++;
                }

                // flex.collectionView.deferUpdate(() => {
                //     for (let i = 0; i < useStickyScroll; i++) {
                //         const show = i < this.stickyScrollRows.length;
                //         const row = flex.columnHeaders.rows[this.stickyScrollStart + i];
                //         if (row.visible !== show && show) {
                //             row.visible = show;
                //         }
                //     }

                //     // heightChange = this.stickyScrollRows.length - heightChange
                //     // if (heightChange) {
                //     //     heightChange *= flex.rows.defaultSize
                //     //     this.scrollPosition = flex.scrollPosition = {
                //     //         x: flex.scrollPosition.x,
                //     //         y: flex.scrollPosition.y - heightChange
                //     //     };
                //     // }
                // })

                const stickyRowsTitle_raw_new = this.stickyScrollRows.join('  /  '),
                setNow = stickyRowsTitle_raw_old !== stickyRowsTitle_raw_new
                this.set_stickyRowsTitle(setNow)

            } else {
                this.stickyScrollRows.length = 0;
            }
        },
        set_stickyRowsTitle(setNow=false) {
            if (this.set_stickyRowsTitle_timeout) { clearTimeout(this.set_stickyRowsTitle_timeout); this.count_set_stickyRowsT = (this.count_set_stickyRowsT||0) + 1 }
            if (setNow) {
                this.set_stickyRowsTitle_afterTimeout()
                return
            }
            this.set_stickyRowsTitle_timeout = window.$cg.setTimeout(this, "AttrGrid.set_stickyRowsTitle", () => {
                this.set_stickyRowsTitle_afterTimeout()
            }, 100)
        },
        set_stickyRowsTitle_afterTimeout() {
            const flex = this.flex
            if (!flex?.hostElement?.isConnected) return
            let innerText = []
            // IE 2026 09 09 / ODOO-… (замечание Игоря): группы списка (поле перетащено на чипсы → wijmo GroupRow) в полосе —
            // ТЕМ ЖЕ заголовком, что и строка группы (getGroupHeader: «Склад: <b>TC Galaxy</b> (9 елементи)»), как HTML.
            // getCellData первой видимой колонки отдаёт для GroupRow этот же HTML, а оверлей писался через textContent —
            // в полосе стояли сырые «-&gt;» и «<b>». Остальные куски (строки дерева, AttrLink) — текст, экранируем
            let innerHtml = []
            if (this.stickyScrollRows.length) {
                let stickyRowsColumns = this.firstColumnIsVisible + 1
                if (this.attr.childItemsPath && this.attr.stickyRowsColumns) {
                    stickyRowsColumns = this.attr.stickyRowsColumns
                }

                for (let i = 0; i < this.stickyScrollRows.length; i++) {
                    const row0 = this.stickyScrollRows[i]

                    // IE 2026 09 09 / ODOO-…: строка группы wijmo — заголовок группы целиком (имя поля, значение, счётчик), как в гриде
                    const grpRow = !this.attr.childItemsPath && flex.rows[row0] instanceof wjGrid.GroupRow ? flex.rows[row0] : null
                    if (grpRow) {
                        let html = ''
                        try { html = grpRow.getGroupHeader() || '' } catch (e) { html = '' }
                        if (html) {
                            innerHtml.push(`<span class="sticky-scroll-group">${html}</span>`)
                            innerText.push(wjcCore.toPlainText(html))
                            continue
                        }
                    }

                    for (let icol = this.firstColumnIsVisible; icol < flex.columns.length && icol <  stickyRowsColumns; icol++) {
                        const col = flex.columns[icol]
                        if (!col.visible) continue

                        let attr_col = this.attr_by_binding[col.binding]

                        let text  = flex.getCellData(row0, icol)

                        if (attr_col?.attr_type === 'AttrLink') {
                            const V = { value: text }
                            this.store.get_valueStr(this, V, attr_col)
                            text = V.valueStr
                        }

                        if (text && text !== 'undefined' && text !== 'null') {
                            innerText.push( text )
                            innerHtml.push(wjcCore.escapeHtml(String(text)))   // IE 2026 09 09 / ODOO-…
                        }
                    }
                }
            }
            const stickyRowsTitle = innerText.join(' / ')
            const stickyRowsHtml = innerHtml.join(' / ')   // IE 2026 09 09 / ODOO-…: разметка полосы (текст — для проверки пустоты и диагностики)
            this.stickyRowsTitle = stickyRowsTitle

            // ⚠ Тайтл рисуется ОВЕРЛЕЕМ поверх полосы, НЕ в ячейках. Ячейки полосы
            // скроллятся по X вместе с колонками — прежняя компенсация paddingLeft
            // на каждый чанк скролла дёргала текст («уходит влево и прыгает
            // назад», жалоба 2026-07-28), а запись в переиспользуемые wijmo-ячейки
            // оставляла «призраки» устаревшего тайтла. Оверлей неподвижен по
            // построению — НЕ возвращать текст в ячейки.
            const cells = flex.hostElement.querySelectorAll('[wj-part="chcells"] .wj-cell.sticky-scroll')
            for (const c of cells) {
                // чистим и содержимое от старых версий/переиспользования, и паддинг-хак
                if (c.firstChild) c.textContent = ''
                if (c.style.paddingLeft) c.style.paddingLeft = ''
            }
            let ov = this._stickyTitleOverlay
            if (!ov || !ov.isConnected) {
                ov = this._stickyTitleOverlay = document.createElement('div')
                ov.className = 'sticky-scroll-title'
                this._stickyTitleHtml = null   // IE 2026 09 09 / ODOO-…: новый оверлей — разметку записать заново
                if (getComputedStyle(flex.hostElement).position === 'static') {
                    flex.hostElement.style.position = 'relative'
                }
                flex.hostElement.appendChild(ov)
            }
            // ЯКОРЬ — геометрия строки-полосы, НЕ ячейки: в части цветовых схем
            // (style2o) wijmo не создаёт ячейки строки в chcells вовсе (cellsAtRow=[],
            // «сквозь полосу светит чужой текст»), а иногда рисует их со смещением
            // (STRIP NOT AT HEADER BOTTOM). Оверлей сам является полосой: фон+рамка
            // на всю ширину, ячейки под ним (когда есть) лишь дублируют тот же фон.
            const _stripRow = flex.columnHeaders.rows[this.stickyScrollStart]
            const _stripOk = !!(_stripRow && _stripRow.visible && _stripRow.renderHeight)
            // IE 2026 10 06 / ODOO-5800: защёлка держит строку-полосу видимой и при ПУСТОЙ цепочке
            // групп (наверху) — тогда оверлей остаётся пустой полосой, а не прячется: в style2o
            // ячеек у строки нет, и сквозь прозрачную полосу светила строка 0 (её незамороженная
            // копия едет с hscroll → «…закупівель» поверх данных)
            if (!_stripOk) { // IE 2026 10 06 / ODOO-5800
                if (ov.style.display !== 'none') ov.style.display = 'none'
                return
            }
            const hostRect = flex.hostElement.getBoundingClientRect(),
            _chEl = flex.hostElement.querySelector('[wj-part="ch"]'),
            _chTop = _chEl ? _chEl.getBoundingClientRect().top : hostRect.top,
            top = `${Math.round(_chTop - hostRect.top + _stripRow.pos)}px`,
            height = `${Math.round(_stripRow.renderHeight)}px`,
            // IE 2026 10 06 / ODOO-5800 (ревью R2): левый край данных — как у wijmo (_updateLayout): ширина rowHeaders,
            // только когда они видимы; при headersVisibility = Column прежний фолбэк «|| 30» оставлял прозрачную щель
            left = `${Math.round((flex.headersVisibility & wjGrid.HeadersVisibility.Row) ? (flex.rowHeaders?.width || 0) : 0)}px` // IE 2026 10 06 / ODOO-5800
            if (ov.style.display) ov.style.display = ''
            if (ov.style.top !== top) ov.style.top = top
            if (ov.style.height !== height) ov.style.height = height
            if (ov.style.left !== left) ov.style.left = left
            if (ov.style.right !== '0px') ov.style.right = '0px'
            // IE 2026 09 09 / ODOO-…: разметка (группы — HTML wijmo, остальное экранировано); сравнение по своей копии —
            // innerHTML после записи браузер нормализует
            if (this._stickyTitleHtml !== stickyRowsHtml) { ov.innerHTML = stickyRowsHtml; this._stickyTitleHtml = stickyRowsHtml }
        },
        create_stickyRows() {
            const flex = this.flex

            // 2025-08-03
            this.set_viewParam('useColumnNumberRow', this.useColumnNumberRow, true, false)
            if (this.get_viewParam('useColumnNumberRow')) {
                let newRow = new wjGrid.Row();
                // newRow.allowMerging = true;
                flex.columnHeaders.rows.push(newRow);
                this.columnNumberRow = flex.columnHeaders.rows.length - 1
            }

            // mapped
            this.isMappedWidget_rows = (this.attr.attr_type !== 'AttrTabGrid' && this.columns() && this.attr_isMappedWidget && !this.attr_isMappedWidget.hide && !this.attr.noMapped && this.WIDGET.record?.segment !== 'TASKS-transform') ? flex.columnHeaders.rows.length : 0
            if (this.isMappedWidget_rows) {
                let newRow = new wjGrid.Row();
                flex.columnHeaders.rows.push(newRow);
                             
                // let dataItem = {'##isMapped_row':true, cssClass:'mapped-cels'}
                // if (this.data.length && this.data[0]['##isMapped_row']) {
                //     dataItem = this.data[0]
                // } else {
                //     this.data.unshift(dataItem)
                //     this.attr.frozenRows = (this.attr.frozenRows || 0) + 1
                // }
            }

            const useStickyScroll = !this.get_viewParam('hideStickyScroll')
            if (useStickyScroll) {
                this.stickyScrollStart = flex.columnHeaders.rows.length

                // ⚠ Строка создаётся СКРЫТОЙ и включается только пересчётом
                // set_stickyRows (карта механизма — в set_stickyRows_afterTimeout).
                // При каждой перестройке грида она пересоздаётся заново скрытой —
                // поэтому после перестройки пересчёт ОБЯЗАН быть вызван (билд ниже
                // + восстановление скролла в getSelectionWorkspace_date), иначе
                // полоса группы «пропадает» до первого вертикального скролла.
                let newRow = new wjGrid.Row();
                newRow.visible = false;
                flex.columnHeaders.rows.push(newRow);

                // template for wj-elem-filter
                newRow = new wjGrid.Row();
                newRow.visible = false;
                flex.columnHeaders.rows.push(newRow);
            } else {
                this.stickyScrollStart = null
            }
            this.flex_check_isReadOnly()
        },
        updatingLayout(flex, e) {
            12
        },
        updatedLayout(flex, e) {
            // if (!this.store.hide_console) console.log('updatedLayout')
            this.attrResize()
            this.tabGrid_wrapMulti(false)   // IE 2026 09 28 / ODOO-342342 (приёмка Д5): ширина колонки значений поменялась — высота перенесённых строк заново
            // if (this.isVisible) {
            //     this.PAGE.vueObj?.refreshe_svg()
            // }
        },
        // IE 2026 09 28 / ODOO-342342 (приёмка ie-growth7 Д5): форма записи (AttrTabGrid) — строка с многострочным текстом (AttrStrMulti: «What you will see»,
        // «Goal», заметки) переносится по словам, высота строки — по тексту (не выше 8 строк; дальше — подсказка / редактор). Раньше такая строка шла в одну
        // строку и обрезалась. Высоты пересчитываются при смене ширины колонки значений (updatedLayout). Выключатель: window.feSettings.set('fe.grid.tabGridWrapMulti', false)
        tabGrid_wrapMulti(force = false) {
            const flex = this.flex
            if (!gridText_tabGridD5(this.attr) || !flex?.rows || !flex.columns) return   // IE 2026 09 29 / ODOO-342342 (ревью ie-dm7 п.2): только форма кейса (About), прочие AttrTabGrid — как на main
            if (this.store.setting('fe.grid.tabGridWrapMulti', true) === false) return
            const icol = flex.columns.findIndex(c => c.binding === 'attr.valueStr')
            if (icol < 0) return
            const w = Math.round(flex.columns[icol].renderWidth || 0)
            if (!force && w === this._wrapMultiW) return
            this._wrapMultiW = w
            if (this._wrapMultiBusy) return
            const rows = flex.rows, idx = []
            for (let i = 0; i < rows.length; i++) {
                const A = rows[i].dataItem?.attr
                const wrap = !!A && A.attr_type === 'AttrStrMulti' && String(A.valueStr ?? '').trim().length > 0
                if (rows[i].wordWrap !== wrap) rows[i].wordWrap = wrap
                if (wrap) idx.push(i)
                else if (rows[i]._wrapH && rows[i].height === rows[i]._wrapH) { rows[i].height = null; rows[i]._wrapH = 0 }
            }
            if (!idx.length) return
            this._wrapMultiBusy = true
            try {
                const base = rows.defaultSize || 22, max = base * 8
                for (const i of idx) {
                    flex.autoSizeRow(i)
                    let h = rows[i].height
                    if (!(h > base)) h = null
                    else if (h > max) h = max
                    if (rows[i].height !== h) rows[i].height = h
                    rows[i]._wrapH = h || 0
                }
                this.store._tabGridWrapStats = this.store._tabGridWrapStats || { calls: 0, rows: 0 }
                this.store._tabGridWrapStats.calls++
                this.store._tabGridWrapStats.rows += idx.length
            } catch (e) { /* высота — как была */ } finally { this._wrapMultiBusy = false }
        },
        // -----------------------------------------------------

        initMenu(menu) {
            this[menu.hostElement.id] = menu
        },
        // IE 2026 09 22 / ODOO-… (предложение Игоря, шаг 2): пункт панели функций ≡ таблицы — то же действие, что у пункта wj-menu (menuNodeClicked); target — кнопка ≡
        // (методы, встающие по кнопке: onFillColor / onRowStyleColor)
        menuPanelPick(item, ev) {
            if (!item || item.disabled) return
            this.store.executeStoreMethod(this.WIDGET.vueObj, item, this.attr, null, { target: (ev && ev.target) || this.$el })
        },
        // IE 2026 09 28 / ODOO-342342 (заказ Игоря: «"меню" — прижато вправо»): ⚙ / ≡ строки грида прижаты к правому краю (флаг fe.ux.menuPanelEverywhere; мобильный профиль — как было)
        menuPushRight() { return menuPanelHost_on(this.store) },
        // IE 2026 09 24 / ODOO-… (заказ Игоря: заголовок панелей-меню): подзаголовок ≡ таблицы — заголовок виджета (· заголовок грида, если непуст и отличается);
        // зовётся из шаблона — пересчитывается с перерисовкой (WIDGET.title / attr.title реактивны)
        menuPanelSubtitle() {
            const w = String((this.WIDGET && this.WIDGET.title) || ''), a = String((this.attr && this.attr.title) || '')
            return (a && a !== w) ? (w ? w + ' · ' + a : a) : w
        },
        // IE 2026 09 22 / ODOO-… (заказ Игоря, п.4): избранные команды ≡ таблицы — личные, ключ 'grid:<сегмент записи виджета>'
        menuFavKind() { return 'grid:' + String(this.WIDGET?.record?.segment || this.WIDGET?.widget_class || '') },
        menuFavOf(raw) { return (raw && !raw.attrs?.length) ? this.store.menuFav_has(this.menuFavKind(), raw) : null },
        menuFav(raw, on) { this.store.menuFav_toggle(this.menuFavKind(), raw, on) },
        menuNodeClicked(menu) {
            let actionMenu = menu.itemsSource[menu.selectedIndex]
            if (actionMenu?.disabled) return // задача 17: неактивные пункты не выполняем
            if (actionMenu?.inactive) return   // IE 2026 10 13 / ODOO-5800: enabled_when — в выделении нет подходящих строк (кнопка панели грида в меню переполнения / actionMenu)
            let vueObj = this.WIDGET.vueObj
            // event с target=хост меню — для методов, позиционирующихся по кнопке (onFillColor/onRowStyleColor)
            this.store.executeStoreMethod(vueObj, actionMenu, this.attr, null, { target: menu.hostElement })
        },
        tooltip() {
            return this.store.tooltip_attr(this)
        },
        set_AttrTabPanel_countItems() {
            if (this.set_AttrTabPanel_countItems_timerId) { clearTimeout(this.set_AttrTabPanel_countItems_timerId) }
            this.set_AttrTabPanel_countItems_timerId = window.$cg.setTimeout(this, "AttrGrid.set_AttrTabPanel_countItems", () => {
                this.set_AttrTabPanel_countItems_afterTimeout()
                this.set_AttrTabPanel_countItems_timerId = null
            }, 100)
        },
        set_AttrTabPanel_countItems_afterTimeout() { // badge
            if (this.attr['can-set_AttrTabPanel_countItems']) {
                // let countItems = (this.flex?.rows.length || 0) - (this.flex.rows[this.flex.rows.length-1]?.dataItem ? 0 : 1) // this.data000.length
                let countItems = this.data?.length || 0
                if (countItems < 0) {
                    countItems = 0
                }
                if (countItems < 50 ) {
                    countItems = 0
                    this.data.forEach((dataItem) => {
                        if (dataItem && this.store.isinstance_dict(dataItem) && (!('use' in dataItem) || dataItem.use)) {
                            countItems++
                        }
                    })
                }
                if (this.parent_attr.countItems !== countItems) {
                    this.parent_attr.countItems = countItems
                }
            }
        },
        
        // ------------- resize ----------------------------------------
        goto_dl2_row() {
            // «Go to DL»: из списка колонок отчёта (⚙ View params) — к строке
            // data_layout2, породившей выбранную колонку. Активируется вкладка
            // Layout родительского отчёта, выделяется строка-узел и открывается
            // её карточка (Row-попап) на таблице fields/values с выделенным полем.
            const vueObj = this
            const store = vueObj.store
            const warn = (t) => store.show_notification({ text: t, status: 'warning' })   // IE 2026 09 23 / ODOO-341407: i18n (тексты warn ниже)
            const sel = vueObj.flex?.selectedRanges?.[0]
            const di = sel && sel.row >= 0 ? vueObj.flex.rows[sel.row]?.dataItem : null
            const a0 = di?.attr || di
            const row_id = a0?.row_id
            if (!row_id) {
                return warn(t('Go to DL: the selected column carries no layout row reference (row_id)'))
            }
            const parentWIDGET = store.findWidget(vueObj.WIDGET.parentWIDGET?.id)?.WIDGET
            const dl2 = parentWIDGET ? store.get_value(parentWIDGET.record, 'doc.params.data_layout2') : null
            if (!Array.isArray(dl2)) {
                return warn(t('Go to DL: parent widget has no data layout'))
            }
            // узел дерева, породивший колонку: сам узел ИЛИ строка его fields/values
            let found = null
            const walk = (nodes) => {
                for (const node of nodes || []) {
                    if (!node || typeof node !== 'object') continue
                    if (node.row_id === row_id) { found = { node, table: null, index: -1 }; return }
                    for (const tbl of ['fields', 'values']) {
                        const idx = (node[tbl] || []).findIndex(r => r?.row_id === row_id)
                        if (idx >= 0) { found = { node, table: tbl, index: idx }; return }
                    }
                    walk(node.attrs)
                    if (found) return
                }
            }
            walk(dl2)
            if (!found) {
                return warn(t("Go to DL: layout row for '{title}' not found", { title: a0.title || a0.binding || '' }))
            }
            // вкладка Layout отчёта — грид doc.params.data_layout2
            store.set_activeAttr(parentWIDGET.view, { binding: 'doc.params.data_layout2' }, parentWIDGET)
            // дождаться грида (вкладка могла только что смонтироваться), выделить
            // узел и открыть его карточку с активной таблицей и строкой поля
            const t0 = Date.now()
            const tryOpen = () => {
                const layoutObj = Object.values(parentWIDGET.attrs_vueObj || {})
                    .find(v => v?.attr?.binding === 'doc.params.data_layout2' && v.flex?.hostElement && v.flex.rows?.length)
                if (!layoutObj) {
                    if (Date.now() - t0 < 8000) setTimeout(tryOpen, 200)
                    else warn(t('Go to DL: layout grid did not mount'))
                    return
                }
                const lflex = layoutObj.flex
                let irow = -1
                for (let i = 0; i < lflex.rows.length; i++) {
                    if (lflex.rows[i].dataItem === found.node) { irow = i; break }
                }
                if (irow < 0) {
                    return warn(t('Go to DL: layout row is not in the grid (filtered out?)'))
                }
                // раскрыть свёрнутых предков — иначе select уйдёт в невидимую строку
                for (let i = irow - 1, lvl = lflex.rows[irow].level ?? 0; i >= 0 && lvl > 0; i--) {
                    const r = lflex.rows[i]
                    if ((r.level ?? 0) < lvl) {
                        if (r.isCollapsed) r.isCollapsed = false
                        lvl = r.level ?? 0
                    }
                }
                layoutObj._skipSelectionWidgetOpen = true
                lflex.select(new wjGrid.CellRange(irow, 0), true)
                layoutObj._skipSelectionWidgetOpen = false
                // карточка строки: как «Open line», плюс активная таблица и строка
                const actionMenu = {   // IE 2026 09 23 / ODOO-341407: i18n
                    'tooltip': t('Open line'), command: 'widget_open', 'widget': 'widget-row',
                    '_activate': true, 'get_currentRow': true, 'get_Parent': true,
                    'open_in_children_widget': true,
                    'binding': layoutObj.attr.binding, attrs: layoutObj.attr.attrs,
                }
                if (found.table) {
                    actionMenu.activeAttr = { binding: found.table, rowIndex: found.index, rowIndex2: found.index }
                }
                store.executeStoreMethod(parentWIDGET.vueObj, actionMenu, layoutObj.attr)
                if (found.table) {
                    // штатное применение activeAttr идёт до монтирования вкладок
                    // карточки — дожимаем после прихода её view (вкладка + строка)
                    const t1 = Date.now()
                    const applyTab = () => {
                        const WRow = store.get_childrenWidget(parentWIDGET, 'widget-row')
                        const hasGrid = WRow && !WRow._softClosed
                            && (WRow.record?._meta?.binding === layoutObj.attr.binding)
                            && store.findFieldBranches?.(WRow.view || [], found.table)
                        if (!hasGrid) {
                            if (Date.now() - t1 < 10000) setTimeout(applyTab, 250)
                            return
                        }
                        store.set_activeAttr(WRow.view, actionMenu.activeAttr, WRow)
                        WRow.vueObj?.content_Changed?.()
                    }
                    setTimeout(applyTab, 250)
                }
            }
            tryOpen()
        },
        onToggle_gridSettings() {
            const vueObj = this
            const WRow = vueObj.store.get_childrenWidget(vueObj.WIDGET, 'widget-row')
            if (WRow && !WRow._softClosed && WRow.parentAction?.type === 'widget-row-viewParams' && WRow.record?._meta?.binding === this.attr.binding) {
                vueObj.store.widget_close(WRow.id)
                // vueObj.store.widget_activate(WRow, 'AttrGrid', true, true)
                // const selCol = vueObj.flex?.selectedRanges?.[0]
                // if (selCol) vueObj.sync_attrsTableSelection(WRow, vueObj.get_attr_col(selCol.col)?.binding, vueObj.get_attr_col(selCol.col2)?.binding)
                return
            }
            const cogEl = this.$refs.cogButton
            const widgetEl = document.getElementById('WIDGET' + vueObj.WIDGET.id)
            let x, y
            if (cogEl && widgetEl) {
                const cr = cogEl.getBoundingClientRect()
                const wr = widgetEl.getBoundingClientRect()
                x = cr.left - wr.left + cr.width / 2
                y = cr.top - wr.top + cr.height / 2
            }
            const selCol = vueObj.flex?.selectedRanges?.[0]
            let activeColBinding, activeColBinding2
            if (vueObj.attr.attr_type === 'AttrTabGrid') {
                const sdi1 = selCol && selCol.row >= 0 ? vueObj.flex.rows[selCol.row]?.dataItem : null
                const sdi2 = selCol && selCol.row2 >= 0 ? vueObj.flex.rows[selCol.row2]?.dataItem : null
                activeColBinding = sdi1?.attr?.binding || sdi1?.binding
                activeColBinding2 = sdi2?.attr?.binding || sdi2?.binding
            } else {
                activeColBinding = selCol ? vueObj.get_attr_col(selCol.col)?.binding : null
                activeColBinding2 = selCol ? vueObj.get_attr_col(selCol.col2)?.binding : null
            }
            const activeAttrsIndex = activeColBinding ? vueObj.get_attrsIndex(activeColBinding) : -1
            const activeAttrsIndex2 = activeColBinding2 ? vueObj.get_attrsIndex(activeColBinding2) : -1
            const actionMenu = {
                command:'widget_open',
                'widget':'widget-row',
                'type': 'widget-row-viewParams',
                'source_attr_type': 'AttrGrid',
                '_activate': true,
                'binding': vueObj.attr.binding,
                'source_name': vueObj.attr.name,

                'get_Parent':true,
                'open_in_children_widget':true,
                'widgetRow_params': {
                    'top_pct': 0.2,
                    'left_pct': 0.2,
                    'width_pct': 0.8,
                    'height_pct': 0.8,
                },

                selectedCog: {
                    x,
                    y,
                },

                ...(activeAttrsIndex >= 0 ? { activeAttr: { binding: 'attrs', rowIndex: activeAttrsIndex, rowIndex2: activeAttrsIndex2 >= 0 ? activeAttrsIndex2 : activeAttrsIndex } } : {}),
            }
            this.show_commandPanel_topLeft = false
            vueObj.store.executeStoreMethod(vueObj.WIDGET.vueObj, actionMenu, vueObj.attr)
            // IE 2026 09 10 / ODOO-… (замечание Игоря): список колонок сразу встаёт на строку колонки выбранной ячейки — selectRow из
            // activeAttr применяется к view до прихода данных списка и теряется; синхронизируем по факту построения
            // грида списка тем же sync_attrsTableSelection, что и при переходе между ячейками
            if (activeColBinding) {
                let gearSync_tries = 0
                const gearSync_tick = () => {
                    const WRow = vueObj.store.get_childrenWidget(vueObj.WIDGET, 'widget-row')
                    if (!WRow || WRow._softClosed || WRow.close) return
                    const g = WRow.vueObj?.get_vueObj?.('attrs')
                    if (g?.flex?.rows?.length) { try { vueObj.sync_attrsTableSelection(WRow, activeColBinding, activeColBinding2) } catch (e) { /* список ещё строится */ } return }
                    if (++gearSync_tries < 40) setTimeout(gearSync_tick, 150)
                }
                setTimeout(gearSync_tick, 150)
            }
        },
        onShow_commandPanel_topLeft(event) {
            // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5 (накат 28.09): при зажатом Alt наведение на ⚙ панель быстрых настроек не открывает — показывается объяснение ⚙ (как у кнопок-триггеров
            // панелей-меню); открытая панель остаётся открытой, наведение без Alt — как раньше
            if (altTooltip.held && !this.show_commandPanel_topLeft) return
            if (this.timerId_onShow_commandPanel_topLeft) {
                clearTimeout(this.timerId_onShow_commandPanel_topLeft)
            }
            this.timerId_onShow_commandPanel_topLeft = setTimeout(() => {
                if (altTooltip.held && !this.show_commandPanel_topLeft) return   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5 (накат 28.09): Alt зажат, пока шла пауза наведения
                const WRow = this.store.get_childrenWidget(this.WIDGET, 'widget-row')
                if (WRow && !WRow._softClosed && WRow.parentAction?.type === 'widget-row-viewParams' &&  WRow.record?._meta?.binding === this.attr.binding) {
                    return
                } 
                if (this.store.mouse_isInside(event.target)) {
                    this.set_commandsActive()
                    const containerEl = this.$refs.attr_container
                    this.commandPanel_topLeft_maxHeight = containerEl ? Math.max(80, containerEl.offsetHeight - 24) : null
                    this.show_commandPanel_topLeft = true
                }
            }, 700)
        },
        onClose_commandPanel_topLeft(event) {
            if (this.timerId_onShow_commandPanel_topLeft) {
                clearTimeout(this.timerId_onShow_commandPanel_topLeft)
            }
            this.timerId_onShow_commandPanel_topLeft = setTimeout(() => {
                this.show_commandPanel_topLeft = false
            }, 200)
        },
        // IE 2026 11 04 / ODOO-350449 (заказ Игоря: форма ⚙ по наведению — в стиле вкладки Display): форма ⚙ — выключатель, раскладка и отправка команды (та же, что у кнопки старой формы: AttrButton.onClick)
        gearForm_on() { return gearForm_on(this.store) },
        gearForm_items(it) { return gearForm_items(it) },   // IE 2026 11 04 / ODOO-350449 (поправка Игоря: булевы в форме ⚙ — снова кнопкой-тумблером, перечисления — группой)
        gearForm_value(it) { return gearForm_value(it) },
        gearForm_param(cmd) { return gearForm_param(cmd) },
        gearForm_params(it) { return gearForm_params(it) },   // IE 2026 11 04 / ODOO-350449 (поправка Игоря: булевы в форме ⚙ — снова кнопкой-тумблером, перечисления — группой)
        gearForm_pick(it, key, ev) {
            const cmd = gearForm_pickCommand(it, key)
            if (cmd) this.gearForm_run(cmd, ev)
        },
        gearForm_run(cmd, ev) {
            const vueObj = this.WIDGET?.vueObj || this.WIDGET?.vueObj_cmdHost
            if (!vueObj) return
            editCommit_pending(this.WIDGET, this.store, 'button:' + (cmd.method || cmd.command || ''))
            vueObj.store.executeStoreMethod(vueObj, cmd, null, null, ev)
        },
        set_commandsActive() {
            if (!this.commandPanel_topLeft.length) {
                this.commandPanel_topLeft = [
                    [
                        // {'binding':`doc.viewParams.${this.attr.name}.allowDragging`, checkValue:true, default:false, 'title': 'Allow dragging rows',command:'set_viewParam', 'cssClass':'pi pi-arrows-alt p-button-white p-button-text0 mr-1' },
                        
                        // {'binding':`doc.viewParams.${this.attr.name}.hideCommandPanel`, checkValue:true, default:false, 'showCommandTitle':true, 'title': 'Hide panel', 'tooltip': 'Show editing command panel',command:'set_viewParam', 'cssClass':'pi p-button-white mr-1'},
                        // IE 2026 09 23 / ODOO-341407: i18n (title / tooltip параметров вида — до конца списка)
                        {'binding':`doc.viewParams.${this.attr.name}.hideCHIPS`, checkValue:true, default:false, 'showCommandTitle':true, 'title': t('Hide filter <b>chips</b>'),command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', uiHelp: 'grid.viewParams.hideCHIPS'},
                        {'binding':`doc.viewParams.${this.attr.name}.showGridSummaryLine`, checkValue:true, default:false, 'showCommandTitle':true, 'title': t('Grid <b>summary</b> line'), 'tooltip': t('Show grid summary line'),command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},

                        // {'binding':`doc.viewParams.${this.attr.name}.showGroupPanel`, checkValue:true, default:false, 'showCommandTitle':true, 'title': 'Group panel',command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                    ],
                    // лёгкий вид грида полей — только для гридов с флагом
                    // lightView (декларация бэка); текущее значение —
                    // viewParam с фолбэком на флаг (store.get_viewParam)
                    ...(this.lightView_enabled() ? [[
                        {'attr_type':'AttrLabel', title:t('View:'), cssClass:'mr-2'},
                        {'binding':`doc.viewParams.${this.attr.name}.lightView`, checkValue:'light', default:'full', 'showCommandTitle':true, 'title': t('Light'), 'tooltip':t('Title column only (tree)'), command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', uiHelp: 'grid.cmd.lightView', uiHelpState: 'light'},
                        {'binding':`doc.viewParams.${this.attr.name}.lightView`, checkValue:'full', default:'light', 'showCommandTitle':true, 'title': t('Full'), 'tooltip':t('All columns'), command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', uiHelp: 'grid.cmd.lightView', uiHelpState: 'full'},
                    ]] : []),
                    [
                        // value: None, All
                        {'attr_type':'AttrLabel', title:t('Headers:'), cssClass:'mr-2'},
                        // {'binding':`doc.viewParams.${this.attr.name}.headersVisibility`, checkValue:'None', default:'All', 'showCommandTitle':true, 'title': 'None',command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                        {'binding':`doc.viewParams.${this.attr.name}.headersVisibility`, checkValue:'All', default:'None', defaultValue:'All', 'showCommandTitle':true, 'title': t('All'),command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', uiHelp: 'grid.viewParams.more', uiHelpState: 'headersVisibility'},
                        {'binding':`doc.viewParams.${this.attr.name}.headersVisibility`, checkValue:'Column', default:'None', 'showCommandTitle':true, 'title': t('Column'),command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', uiHelp: 'grid.viewParams.more', uiHelpState: 'headersVisibility'},
                        {'binding':`doc.viewParams.${this.attr.name}.headersVisibility`, checkValue:'Row', default:'None', 'showCommandTitle':true, 'title': t('Row'),command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', uiHelp: 'grid.viewParams.more', uiHelpState: 'headersVisibility'},
                    ],
                    // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106094: шахматка — вид слайда, центрирование, группы без фона) (p051): грид шахматки с cell_look (gridAttr.cg_matrix + cg_slide_default) — кнопка «Slide look» отдельным рядом после «Заголовки»; прочие гриды — без ряда
                    ...cgSlideRow(this.attr, t),
                    [
                        {'attr_type':'AttrLabel', title:t('Sorting:'), cssClass:'mr-2'},
                        // {'binding':`doc.viewParams.${this.attr.name}.allowSorting`, checkValue:'None', default:'None', 'showCommandTitle':true, 'title': 'None', 'tooltip':'Determine whether users should be able to sort the grid by clicking the column header cells',command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', 'itemsSource': [
                        //     {'id':'None', 'title': ''},
                        //     {'id':'SingleColumn', 'title': 'Single column'},
                        //     {'id':'MultiColumn', 'title': 'Multi column'},
                        // ]},
                        {'binding':`doc.viewParams.${this.attr.name}.allowSorting`, checkValue:'SingleColumn', default:'None', defaultValue:'SingleColumn', 'showCommandTitle':true, 'title': t('Single column'), 'tooltip':t('Determine whether users should be able to sort the grid by clicking the column header cells'),command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', uiHelp: 'grid.viewParams.sorting', uiHelpState: 'single'},
                        {'binding':`doc.viewParams.${this.attr.name}.allowSorting`, checkValue:'MultiColumn', default:'None', 'showCommandTitle':true, 'title': t('Multi column'), 'tooltip':t('Determine whether users should be able to sort the grid by clicking the column header cells'),command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', uiHelp: 'grid.viewParams.sorting', uiHelpState: 'multi'},
                    ],[
                        {'binding':`doc.viewParams.${this.attr.name}.allowPinning`, checkValue:'Both', default:'None', 'showCommandTitle':true, 'title': t('Pinning'), 'tooltip':t('To pin columns to the left-hand side of the grid so they remain visible as the user scrolls the grid horizontally'),command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', uiHelp: 'grid.viewParams.more', uiHelpState: 'allowPinning', 'itemsSource': [
                            {'id':'None', 'title': ''},
                            {'id':'Both', 'title': t('Both')},
                            // # {'id':'ColumnRange', 'title': 'Column range'},
                            // # {'id':'SingleColumn', 'title': 'Single column'},
                        ]},
                            
                        // {'binding':`doc.viewParams.${this.attr.name}.showFilterIcons`, checkValue:true, default:false, 'showCommandTitle':true, 'title': 'Show filter icons', 'cssClass':'pi p-button-white p-button-border mr-1'},
                        {'binding':`doc.viewParams.${this.attr.name}.showFilter`, checkValue:true, default:false, 'showCommandTitle':true, 'title':t('Filter'), 'tooltip':t('Show filter icons in columns'),command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', uiHelp: 'grid.viewParams.showFilter'},
                        // IE 2026 09 05 / ODOO-336330: у формы настроек (showEmptyAlways) пустые строки видны всегда — переключателя нет
                        // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5 [ДЕФЕКТ, defects-found.md]: подсказка была «Show rows && columns columns»
                        // (двойное «columns», «&&» вместо «and») — исправлен текст
                        ...(this.attr.showEmptyAlways ? [] : [{'binding':`doc.viewParams.${this.attr.name}.showEmpty`, checkValue:true, default:false, 'showCommandTitle':true, 'title':t('Show empty'), 'tooltip':t('Show empty rows and columns'),command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', uiHelp: 'grid.viewParams.showEmpty'}]),
                    ],[
                    
                        // {'binding':`doc.viewParams.${this.attr.name}.childItemsPath`, 'showCommandTitle':true, 'title':'Child items path', 'attr_type':'AttrStr',command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                        // {'binding':`doc.viewParams.${this.attr.name}.column_childItemsPath`, 'showCommandTitle':true, 'title':'Column child items path', 'attr_type':'AttrStr',command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                    // ],[
                        {'binding':`doc.viewParams.${this.attr.name}.frozenColumns`, 'showCommandTitle':true, 'title': t('Frozen columns'), 'attr_type':'AttrNumber',command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', uiHelp: 'grid.viewParams.frozen'},
                        {'binding':`doc.viewParams.${this.attr.name}.frozenRows`, 'showCommandTitle':true, 'title': t('Frozen rows'), 'attr_type':'AttrNumber',command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', uiHelp: 'grid.viewParams.frozen'},
                    ],[
                    
                        // {'binding':`doc.viewParams.${this.attr.name}.childItemsPath`, 'showCommandTitle':true, 'title':'Child items path', 'attr_type':'AttrStr',command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                        // {'binding':`doc.viewParams.${this.attr.name}.column_childItemsPath`, 'showCommandTitle':true, 'title':'Column child items path', 'attr_type':'AttrStr',command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                    // ],[
                        {'binding':`doc.viewParams.${this.attr.name}.rowsHeight`, 'showCommandTitle':true, 'title': t('Rows height (1 - 7)'), 'attr_type':'AttrNumber',command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', uiHelp: 'grid.viewParams.more', uiHelpState: 'rowsHeight'},
                    ],[
                    
                        {'binding':`doc.viewParams.${this.attr.name}.collapseGroupsToLevel`, 'showCommandTitle':true, 'title': t('Collapse rows to level'), 'attr_type':'AttrNumber',command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', uiHelp: 'grid.viewParams.more', uiHelpState: 'collapseGroupsToLevel'},
                        {'binding':`doc.viewParams.${this.attr.name}.hideEmptyRows`, checkValue:true, default:false, 'showCommandTitle':true, 'title': t('Hide <b>empty</b> rows'),command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', uiHelp: 'grid.viewParams.hideEmptyRows'},
                    
                        {'binding':`doc.viewParams.${this.attr.name}.aggregateFooters`, checkValue:true, default:false, 'showCommandTitle':true, 'title': t('Aggregate <b>footers</b>'),command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', uiHelp: 'grid.viewParams.more', uiHelpState: 'aggregateFooters'},
                        
                    ],[
                        {'binding':`doc.viewParams.${this.attr.name}.show_performance`, checkValue:true, default:false, 'showCommandTitle':true, 'title': '<b>' + t('Performance') + '</b>' /* IE 2026 09 23 / ODOO-341407: ревью i18n — теги вне ключа */,command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', uiHelp: 'grid.viewParams.more', uiHelpState: 'service'},
                        {'binding':`doc.viewParams.${this.attr.name}.use_customCellFactory`, checkValue:true, default:false, 'showCommandTitle':true, 'title': t('Cell factory'),command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', uiHelp: 'grid.viewParams.more', uiHelpState: 'service'},
                        {'binding':`doc.viewParams.${this.attr.name}.allow_formatItem`, checkValue:true, default:false, 'showCommandTitle':true, 'title': t('Format'),command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', uiHelp: 'grid.viewParams.more', uiHelpState: 'service'},
                        {'binding':`doc.viewParams.${this.attr.name}.use_delivery`, checkValue:true, default:false, 'showCommandTitle':true, 'title': t('Breaks') /* IE 2026 09 24 / ODOO-341407: use_delivery — режим разрывов (зазор и пунктир перед колонками с break_before, зазор в начале секций дерева), к поставкам отношения не имеет; подпись «Delivery» вводила в заблуждение */,command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', uiHelp: 'grid.viewParams.more', uiHelpState: 'use_delivery'},
                        // IE 2026 08 27 / ODOO-5800 (заказ Игоря): линии дерева — выкл (по умолчанию) = плавная рамка, вкл = прежний пунктир.
                        // Только чекбокс: текстовый AttrStr в командной панели не поддерживается (created без attr → 33 ошибки, грид отчёта не показывался)
                        {'binding':`doc.viewParams.${this.attr.name}.tree_lines_dotted`, checkValue:true, default:false, 'showCommandTitle':true, 'title': t('Dotted tree lines'), 'tooltip': t('Legacy dotted tree lines with section gaps (off = frame lines)'), command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', uiHelp: 'grid.viewParams.more', uiHelpState: 'tree_lines_dotted'},
                    ],[
                        {'binding':`doc.viewParams.${this.attr.name}.virtualizationThreshold_rows`, 'showCommandTitle':true, 'title': t('Cache rows'), 'attr_type':'AttrNumber',command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', uiHelp: 'grid.viewParams.more', uiHelpState: 'service'},
                        {'binding':`doc.viewParams.${this.attr.name}.virtualizationThreshold_cols`, 'showCommandTitle':true, 'title': t('Cache cols'), 'attr_type':'AttrNumber',command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', uiHelp: 'grid.viewParams.more', uiHelpState: 'service'},
                        
                    // ],[ // Admin params !!!
                    //     {'binding':`doc.viewParams.${this.attr.name}.allowAddNew`, checkValue:true, default:false, 'showCommandTitle':true, 'title': 'Allow add new',command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                    //     {'binding':`doc.viewParams.${this.attr.name}.readOnlyRows`, checkValue:true, default:false, 'showCommandTitle':true, 'title': 'Read only rows',command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                    //     {'binding':`doc.viewParams.${this.attr.name}.isReadOnly`, checkValue:true, default:false, 'showCommandTitle':true, 'title': 'Is read only',command:'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                    ]
                ]
            }

            this.commandPanel_topLeft.forEach((panel, index) => {
                panel.forEach((command, index) => {
                    this.store.set_commandActive(this, command)
                })
          
                this.store.prepare_attrs(panel, `commandPanel${this.WIDGET.id}_${this.attr_id}_${index}`)
            })
        },
        get_dblclick_action(get_openline_action=true) {
            let action = this.store.get_dblclick_action(this.WIDGET.vueObj, this.attr, false)
            if (action) {
                return action
            }
            if (this.gridEditMode_openOffered()) return gridEditMode_openAction({ sourceName: this.attr.name, binding: this.attr.binding, t })   // IE 2026 10 14 / ODOO-5800: динамический список — карандаш заголовка строки / Alt F2 открывают запись строки
            if (get_openline_action) {
                return this.get_openline_action()
            }
            return null
        },
        get_openline_action() {
            // IE 2026 09 23 / ODOO-341407: i18n (tooltip)
            if (this.attr.attr_type !== 'AttrTabGrid') {
                
                if (this.attr.relation_segment) {
                    return {'tooltip': t('Open line doc, for relation segment'), 'action_name':'action-front-openLine-2024-11-30-relation_segment',command:'widget_open', 'widget':'widget-record', 'get_currentRow_with_meta':true, 'get_Parent':true, 'open_in_children_widget':true, 'cssClass':'pi p-button-white pi-arrow-right', source_name:this.attr.name, 'binding':this.attr.binding, attrs:this.attr.attrs }
                } else {
                    // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): архивная ПМ — строка открывается только для просмотра: ✎ → 👁 и подсказка «Open line (read-only)» (правку грида режет beginningEdit)
                    if (this.archiveRo?.()) return { 'tooltip': t('Open line (read-only)'), 'hotKey': 'Alt F2', 'action_name':'action-front-openLine-2024-11-30',command:'widget_open', 'widget':'widget-row', '_activate':true, 'get_currentRow':true, 'get_Parent':true, 'open_in_children_widget':true, 'cssClass':'pi p-button-white pi-eye', source_name:this.attr.name, 'binding':this.attr.binding, attrs:this.attr.attrs }
                    return { 'tooltip': t('Open line'), 'hotKey': 'Alt F2', 'action_name':'action-front-openLine-2024-11-30',command:'widget_open', 'widget':'widget-row', '_activate':true, 'get_currentRow':true, 'get_Parent':true, 'open_in_children_widget':true, 'cssClass':'pi p-button-white pi-pencil', source_name:this.attr.name, 'binding':this.attr.binding, attrs:this.attr.attrs }
                    // 'template!':'B_openLine',
                }
            }
            return null
        },
        // IE 2026 08 27 (Igor): есть ли несохранённые изменения данных (для активности кнопки Save)
        hasChangesForSave() {
            return !!this.modified || Object.keys(this.changesStack || {}).length > 0
        },
        setModified(dataItem=null, new_=false) {
            if (this._apprPartialCache) this.approvalPartial_invalidate(-1, dataItem, null)   // IE 2026 10 14 / ODOO-5800 (Igor): живой итог флага — пересчёт после правки (app7 #84309: по строке — только её итоги-предки; без строки — целиком)
            // IE 2026 08 27 (Igor): запомнить isReadOnly до первой правки — при возврате всех ячеек к исходному
            // (noop_unmark) панель возвращается к виду «без правок» (жёлтый Save гаснет)
            if (!this._roCaptured && !Object.keys(this.changesStack || {}).length) {
                // сырое значение из viewParams записи: не задан → после отката ключ удаляется (панель считает
                // незаданный isReadOnly как true — Save скрыт, как до правок)
                const _vp = this.WIDGET?.record?.doc?.viewParams?.[this.attr?.name]
                this._roBefore = (_vp && typeof _vp === 'object') ? _vp.isReadOnly : undefined
                this._roCaptured = true
            }
            this.set_viewParam('isReadOnly', false)
            const _wasOff = !this.modified
            this.modified = true
            if (_wasOff) this.set_commandPanel()   // Save становится активной и жёлтой

            const touch = (dataItem) => {
                if (!dataItem || typeof dataItem !== 'object') return;

                if (Array.isArray(dataItem)) {
                    dataItem.forEach(touch);
                } else if (typeof dataItem === 'object') {
                    dataItem._meta = dataItem._meta || {}
                    dataItem._meta.modified = true
                    dataItem._meta.calced = false
                    if (new_) {
                        dataItem._meta.new = true
                    }

                    if (Array.isArray(dataItem.attrs) && dataItem.attrs.length) {
                        touch(dataItem.attrs)
                    }
                }
            }
            touch(dataItem)

            this.WIDGET.record._meta = this.WIDGET.record._meta || {}
            if (!this.attr.binding.startsWith('_')) {
                this.WIDGET.record._meta.modified = true
                this.WIDGET.record._meta.calced = false
            //     this.set_commandPanel()
            }
            // каскад widget-row: строка Row шарит объект с записью РОДИТЕЛЬСКОГО
            // виджета — правка вложенного грида (напр. FIELDS строки
            // doc.params.data_layout2) должна помечать modified и владельца,
            // иначе отчёт не показывал признак сохранения. Эфемерные биндинги
            // (_doc.*) владельца не помечают
            // гейт — служебность пути СТРОКИ Row (meta.binding): правки гридов
            // Row-виджета (в т.ч. AttrTabGrid с эфемерным _doc.*-биндингом)
            // пишут в реальную строку владельца; эфемерные строки Row
            // (_doc.printTemplate и т.п.) владельца не помечают
            {
                let _W = this.WIDGET, _i = 0
                while (_W?.widget === 'widget-row' && _W.parentWIDGET?.id !== undefined && _i++ < 5) {
                    const _mb = String(_W.record?._meta?.binding || '')
                    const _parent = this.store.findWidget(_W.parentWIDGET.id)?.WIDGET
                    if (!_parent?.record || !_mb || this.store.is_serviceBinding(_mb)) break
                    _parent.record._meta = _parent.record._meta || {}
                    _parent.record._meta.modified = true
                    _parent.record._meta.calced = false
                    _W = _parent
                }
            }
            if (this.attr.name === 'fields-target-source') {
                this.store.set_isMappedWidgets(this.WIDGET)
            }
            if (this.WIDGET.parentAction?.type === 'widget-row-cell' && this.WIDGET.parentWIDGET?.id) {
                const parentWIDGET_ = this.store.findWidget(this.WIDGET.parentWIDGET.id)?.WIDGET
                const outerGrid_ = Object.values(parentWIDGET_?.attrs_vueObj || {})
                    .find(av => av?.attr?.binding === this.WIDGET.parentAction.binding && av?.flex)
                outerGrid_?.flex?.invalidate()
            }
            // эфемерный редактор шаблона печати: мутация строк (ввод, вставка,
            // перенос ячейки, 👁 write-back) → write-back в канон
            this.printTpl_afterChange()
            this.gridSave_schedule()   // IE 2026 10 13 / ODOO-5800: правка строк — пересчитать полосу Save ленивого грида
        },
        // IE 2026 10 13 / ODOO-5800 (Igor: «я ожидаю, что смогу менять такие динамические списки с возникновением кнопки сохранить над ними»): грид ленивой вкладки
        // (AttrTab lazyMethod / lazyBinding → record._doc.<binding>; _doc бэку не уходит) с saveMethod (свой attr.saveMethod или вкладки — gridSave_method).
        // Правки считаются по снимку последней загрузки (WIDGET._gridSave[binding].base — тождество строк + чистый JSON): changesStack не годится
        // (ключ irow:col, только отчётные корректировки, чистится на каждом load_data), признак записи _meta.modified не ставится для _-привязок
        // (setModified: !binding.startsWith('_')). Флаг fe.ux.gridSaveBar (дефолт ВКЛ); выкл — как было
        gridSave_on() {
            return gridSaveBar_on((k, d) => this.store?.setting?.(k, d))
        },
        // ---- IE 2026 10 14 / ODOO-5800 (Igor: правка строк динамических списков однотипна с виджетом списка — utils/gridEditMode, флаг fe.ux.gridEditMode) ----
        gridEditMode_on() {   // IE 2026 10 14 / ODOO-5800
            return gridEditMode_on((k, d) => this.store?.setting?.(k, d))
        },
        // число правок строк против снимка — СЕЙЧАС (gridSave_count обновляется с задержкой gridSave_schedule)
        gridSave_countNow() {   // IE 2026 10 14 / ODOO-5800
            if (!this.gridSave_saveMethod) return 0
            const st = this.gridSave_stateOf(false)
            if (!st?.base) return 0
            try { return gridSave_diff(this.gridSave_rows(), st.base, { raw: gridSave_toRaw, keyField: st.keyField }).count } catch (e) { return this.gridSave_count }
        },
        gridEditMode_dirty() {   // IE 2026 10 14 / ODOO-5800: есть несохранённые правки строк — Save активна, режим не снимается (saveState_sync / pushStack)
            return this.gridEditMode_applies && this.gridSave_countNow() > 0
        },
        gridEditMode_setReadOnly(on, rebuild = true) {   // IE 2026 10 14 / ODOO-5800: режим явно (запись не помечается изменённой), захват _roBefore снят
            this._roCaptured = false
            this.set_viewParam('isReadOnly', !!on, true, false)
            // IE 2026 10 14 / ODOO-5800 (бот dev02, п.3: Cancel без правок — панель не перестраивалась 90+ с): set_viewParam с justSet выходит ДО set_commandPanel —
            // панель (и ew_update кнопок) перестраиваем здесь явно; rebuild=false — вызывающий перестроит сам (gridSave_resetView)
            if (rebuild) this.set_commandPanel?.()
        },
        gridEditMode_cancel() {   // IE 2026 10 14 / ODOO-5800: Cancel панели — откат правок (строки снимка) и обратно в read-only
            if (this.gridSave_saving) return
            // IE 2026 10 14 / ODOO-5800: есть правки — Discard стора → gridSave_rebase → gridSave_resetView (read-only + панель) сам; без правок — режим и панель здесь
            if (this.gridSave_countNow() > 0 && this.gridSave_stateOf(false)) { this.store.gridSave_discardOne(this.WIDGET, this.gridSave_key()); return }
            this.gridEditMode_setReadOnly(true)
        },
        gridEditMode_openOffered() {   // IE 2026 10 14 / ODOO-5800: у строк есть запись для открытия (сегмент грида или segment / _link строк)
            return this.gridEditMode_applies && gridEditMode_openPossible(this.attr, this.gridSave_rows())
        },
        // «Open record» панели / карандаш заголовка строки: карточка записи текущей строки — widget_open widget-record с item {id, segment} (как Open списка записей сегмента, cellLink_open)
        gridEditMode_openRecord() {   // IE 2026 10 14 / ODOO-5800
            const flex = this.flex
            const row = flex?.selection && flex.selection.row >= 0 ? flex.rows?.[flex.selection.row]?.dataItem : null
            const action = gridEditMode_openItemAction(gridEditMode_rowLink(row, this.attr))
            if (!action) { this.store.show_notification({ text: t('Select a row with a record to open'), status: 'info' }); return }
            this.store.executeStoreMethod(this.WIDGET?.vueObj || this, action, this.attr)
        },
        gridSave_key() {
            return this.attr?.binding || ''
        },
        gridSave_rows() {
            try { const v = this.store.attr_get(this.WIDGET, this.attr); return Array.isArray(v) ? v : [] } catch (e) { return [] }
        },
        gridSave_stateOf(create = false) {
            const W = this.WIDGET, key = this.gridSave_key()
            if (!W || !key || !this.gridSave_saveMethod) return null
            const st = create ? this.store.gridSave_state(W, key, this.attr, this.gridSave_saveMethod) : W._gridSave?.[key]
            if (st) { st.vm = this; st.saveMethod = this.gridSave_saveMethod }
            return st || null
        },
        // IE 2026 10 13 / ODOO-5800 (бот prod ie-dm-app7 ev21: «Confirm» панели ответил updateDoc со свежими строками — массив _doc.<binding> заменён, gridSave_baselineIfNew принял его за
        // новую загрузку, снимок пересобран, правка и полоса Save пропали молча): живой массив строк грида, null — привязка не массив (строк не прислали)
        gridSave_rowsArray() {
            try { const v = this.store.attr_get(this.WIDGET, this.attr); return Array.isArray(v) ? v : null } catch (e) { return null }
        },
        // IE 2026 10 14 / ODOO-5800: массив строк привязки — тот же, из которого грид собран в последний load_data (фоновый ответ бэка строки не заменил)
        editKeep_sameRows() {
            try { return editKeep_sameRows(gridSave_toRaw(this.store.attr_get(this.WIDGET, this.attr)), this._editKeepRowsRef, editKeep_flagOn((k, d) => this.store?.setting?.(k, d))) } catch (e) { return false }
        },
        gridSave_guardOn() {
            return gridSaveGuard_on((k, d) => this.store?.setting?.(k, d))
        },
        // load_data: строки заменены другим путём (опрос, каскад, ответ чужого метода), а правки грида (st.pend — строки на момент последнего пересчёта полосы и их снимок) остались несохранёнными —
        // правки возвращаются поверх свежих строк, снимок = свежие строки ДО правок; привязку убрали совсем — прежний массив возвращается. Save / Discard стора сами сбрасывают st.pend
        gridSave_keepPending() {
            try {
                if (!this.gridSave_saveMethod || !this.gridSave_guardOn()) return
                const st = this.gridSave_stateOf(false)
                if (!st || !st.pend || st.saving || st.pend.base !== st.base) return
                const fresh = this.gridSave_rowsArray()
                if (fresh === null) {
                    const old = st.pend.rows, pend = st.pend
                    this.$nextTick(() => { if (st.pend === pend && this.gridSave_rowsArray() === null) st.setRows(old) })
                    return
                }
                if (gridSave_toRaw(fresh) === st.pend.rows) return
                const r = gridSave_reapply(st.pend.rows, st.base, fresh, { raw: gridSave_toRaw, keyField: st.keyField })
                if (!r.applied) return
                st.base = r.base
                st.pend = null
                if (r.dropped) this.store.show_notification({ text: tn(r.dropped, '{n} unsaved row change was dropped: the row no longer exists in the refreshed list', '{n} unsaved row changes were dropped: the rows no longer exist in the refreshed list'), status: 'warning' })
            } catch (e) { console.warn('gridSave_keepPending', e) }
        },
        gridSave_baselineIfNew() {
            if (!this.gridSave_saveMethod) return
            const st = this.gridSave_stateOf(true)
            if (!st) return
            const raw = gridSave_toRaw(this.gridSave_rows())
            if (!st.base || st.base.src !== raw) st.base = gridSave_baseline(raw, gridSave_toRaw)
            this.gridSave_refresh()
            if (this.gridEditMode_applies && !this.dblclick_action?._openRecord && this.gridEditMode_openOffered()) {   // IE 2026 10 14 / ODOO-5800: строки пришли после сборки грида — действие открытия записи и стрелка заголовка строки
                this.dblclick_action = this.get_dblclick_action()
                try { this.flex?.invalidate?.() } catch (e) { /* перерисуется следующим действием */ }
                this.set_commandPanel?.()
            }
        },
        gridSave_schedule() {
            if (!this.gridSave_saveMethod) return
            if (this._gridSaveT) return
            this._gridSaveT = setTimeout(() => { this._gridSaveT = null; this.gridSave_refresh() }, 30)
        },
        gridSave_refresh() {
            const st = this.gridSave_saveMethod ? this.gridSave_stateOf(false) : null
            const d = st?.base ? gridSave_diff(this.gridSave_rows(), st.base, { raw: gridSave_toRaw, keyField: st.keyField }) : null
            const n = d ? d.count : 0
            { const _arr = this.gridSave_rowsArray(); if (st && _arr) st.pend = n ? { rows: gridSave_toRaw(_arr), base: st.base } : null }   // IE 2026 10 13 / ODOO-5800: строки с правками — для возврата поверх свежих (gridSave_keepPending)
            const wasShown = this.gridSave_showBar
            const _nChanged = this.gridSave_count !== n   // IE 2026 10 14 / ODOO-5800
            if (_nChanged) this.gridSave_count = n
            if (_nChanged && this.gridEditMode_applies) this.set_commandPanel?.()   // IE 2026 10 14 / ODOO-5800: Save панели — жёлтая, с бейджем числа правок
            if (wasShown !== this.gridSave_showBar) this.$nextTick(() => this.store.widgetResize?.(this, 0))
        },
        // Save / Discard — store.gridSave_saveOne / gridSave_discardOne (тот же путь у гарда несохранённого: Save & refresh / Save & close)
        gridSave_save() {
            if (this.gridSave_saving || !this.gridSave_stateOf(false)) return
            this.store.gridSave_saveOne(this.WIDGET, this.gridSave_key())
        },
        gridSave_discard() {
            if (this.gridSave_saving || !this.gridSave_stateOf(false)) return
            this.store.gridSave_discardOne(this.WIDGET, this.gridSave_key())
        },
        // строки грида заменены сохранённым / загруженным состоянием (снимок уже снят стором): сброс истории и признаков правок грида, перерисовка
        gridSave_resetView() {
            this.undoStack.length = 0
            this.redoStack.length = 0
            this.changesStack = {}
            this.deletedItems = []
            this.modified = false
            // IE 2026 10 14 / ODOO-5800 (бот dev02, п.6: после Save грид оставался в режиме правки): Save / Cancel завершают сеанс правки — грид read-only («Edit in a grid» в панели) НЕЗАВИСИМО от
            // _roBefore (режим, включённый кнопкой, давал _roBefore=false и оставлял панель правки); _roBefore остаётся для noop_unmodified (все ячейки вернулись к исходному). Панель — set_commandPanel ниже
            if (this.gridEditMode_applies) this.gridEditMode_setReadOnly(true, false)   // IE 2026 10 14 / ODOO-5800
            this.corrChip_schedule()   // IE 2026 10 14 / ODOO-5800: чипс Corrections — снять
            this.content_Changed()
            this.gridSave_refresh()
            this.set_commandPanel?.()
        },
        draggingColumn(flex, e) {
            let col = this.flex.columns[e.col],
            attr_col = this.attr_by_binding[col.binding]
            
            this.store.dataTransfer = {
                type: 'grid-column',
                widget: this.WIDGET,
                attr: this.attr,
                attr_col,
            }
        },
        calc_aggregateFooters_basis(attr_col, rows) {
            const binding = attr_col.binding,
            aggregateFooters_basis = attr_col.aggregateFooters_basis,
            format = attr_col.format

            let sum = 0,
                weight = 0
            for (let row of rows) {
                const weight_ = this.store.get_value(row, aggregateFooters_basis) || 0
                const value_ = this.store.get_value(row, binding) || 0
                if (weight_) {
                    weight += weight_
                    if (value_) {
                        sum += weight_ * value_
                    }
                }
            }
            if (weight) {
                // const result = this.store.formatCount(Math.round(sum / weight * 1e4) / 1e4)
                const result = sum / weight
                return wjcCore.Globalize.format(result, format||'f0')
            }
            return ''
        },

        get_dataItem2(rows=null, irow) {
            let dataItem
            if (rows) {
                while (rows.length <= irow) {
                    rows.push({ _cells:{} })
                }
                dataItem = rows[irow]
            } else {
                rows = this.flex.rows
                const row = rows[irow]
                dataItem = row?.dataItem
            }

            return dataItem
        },
        set_value2(rows=null, irow, icol, value, field, isHeader=false, _cells=null) {
            const dataItem = this.get_dataItem2(rows, irow)
            const attr_col = this.get_attr_col(icol)

            this.store.set_value(dataItem, attr_col.binding, value) // 2026-01-15
            // this.setModified(dataItem)

            if (_cells === null) {
                _cells = this.get_cells(rows, irow, icol, {}) 
            } else {
                this.set_overrides(rows, irow, icol, _cells) 
            }

            // if (isHeader) {
            //     // _cells.cssClass = field.cssClass_columnHeader || ''
            // } else {
            //     if (field.attr_type === 'AttrLink') {
            //         // let valueMulti = this.store.get_valueMulti_byStr(this, newVal, V, attr_col, oldVal, parentsList)
            //         const V = { value: value }
            //         this.store.get_valueStr(this, V, field)
                    
            //         _cells.valueStr = V.valueStr
            //     }
             
            //     // _cells.cssClass = field.cssClass || ''
            // }
        },
        get_cells(rows=null, irow, icol, default_=null) {
            const dataItem = this.get_dataItem2(rows, irow)

            const attr_col = this.get_attr_col(icol)
            const raw_binding = (attr_col?.binding || '').replace('data::', '')

            let _cells = dataItem?._cells?.[raw_binding]

            if (!_cells && default_) {
                _cells = dataItem._cells[raw_binding] = default_
            }

            return _cells
        },
        set_overrides(rows=null, irow, icol, _cells) {
            const dataItem = this.get_dataItem2(rows, irow)

            const attr_col = this.get_attr_col(icol)
            if (!attr_col) return null
            const raw_binding = (attr_col?.binding || '').replace('data::', '')

            dataItem._cells = dataItem._cells || {}
            dataItem._cells[raw_binding] = _cells
            return _cells
        },
    },
    computed: {
        // IE 2026 11 01 / ODOO-350449 (заказ Игоря: форма Стовпчики та Запас площею — T15): кнопки переключателя формы — грид с колонками-датами, активный вид ячеек, доступно ≥ 2 форм; активна — выбор пользователя или shape опции
        cellShape_ui() {
            const W = this.WIDGET
            if (!W || !Object.keys(this.attr_by_binding || {}).some(k => cellPie_bindingOf(k))) return null
            void W._cellShape
            const view = this.cellView_active()
            if (!view) return null
            const avail = cellShape_available(cellShape_flags((k, d) => this.fmtSetting(k, d)))
            if (avail.length < 2) return null
            const cur = cellShape_panelOf(W._cellShape, this.cellShape_optionList(view))
            const tips = { circle: t('Cells of the view are drawn as circles'), bars: t('Cells of the view are drawn as bars, one bar per layer'), area: t('Stock rows are drawn as a filled area under the stock curve') }   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p189 єдиний вигляд полос перемикачів — заголовки, відступи, Alt-підказки пунктів)
            return avail.map(k => ({ key: k, title: t(CELL_SHAPE_TITLES[k]), active: k === cur, on: k === cur, tip: tips[k] || '' }))   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p189 єдиний вигляд полос перемикачів — заголовки, відступи, Alt-підказки пунктів): on / tip — для SegSwitch
        },
        // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p183: перемикач «Рядки: Компактні / Високі» у таблиці REPORT2, як у Heatmap (grid)): кнопки «Рядки: Компактні / Високі» (null — переключателя нет); активна — WIDGET._gridRows
        gridRows_ui() {
            const W = this.WIDGET
            if (!W) return null
            void W._gridRows; void this.store._settingsEpoch
            if (!this.gridRows_avail()) return null
            const cur = gridRows_norm(W._gridRows)
            const tall = cur === 'tall'   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p189 — «Рядки» одной квадратной кнопкой: нажата = високі, отжата = компактні): один пункт-иконка для кнопки-переключателя; заголовок и подсказка — по состоянию
            return [{ key: 'tall', icon: 'pi pi-arrows-v', aria: t('Tall rows'), title: tall ? t('Tall rows') : t('Compact rows'), on: tall,
                tip: tall ? t('Rows are tall. Click — make them compact') : t('Rows are compact. Click — make them tall') }]   // IE 2026 11 02 / ODOO-350449 (сводна перевірка main на dev02: p199 — якір при scroll 0, повернення висоти рядків, перемалювання колонок «Всього», Alt-підказка «Рядки»): в REPORT2 вкладки «Теплова карта» нет — текст без неё
        },
        gridRows_tall() {   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p183: перемикач «Рядки: Компактні / Високі» у таблиці REPORT2, як у Heatmap (grid)): класс контейнера grid-rows-tall — центрирование текста высоких строк (CSS)
            return !!this.gridRows_ui && gridRows_norm(this.WIDGET?._gridRows) === 'tall'
        },
        // IE 2026 10 13 / ODOO-5800: метод сохранения грида ленивой вкладки ('' — полосы нет): свой attr.saveMethod или вкладки (parent_attr от widget_attr_set / parentAttr от AttrTab)
        gridSave_saveMethod() {
            if (!this.attr || !this.gridSave_on()) return ''
            return gridSave_method(this.attr, this.parent_attr || this.parentAttr)
        },
        gridSave_showBar() {
            return gridSave_barVisible({ flagOn: !this.gridEditMode_applies, saveMethod: this.gridSave_saveMethod, count: this.gridSave_count, saving: this.gridSave_saving })   // IE 2026 10 14 / ODOO-5800: в режиме редактирования списка полосы нет — Save / Cancel в панели
        },
        gridEditMode_applies() {   // IE 2026 10 14 / ODOO-5800: режим редактирования динамического списка — флаг fe.ux.gridEditMode и метод сохранения грида (utils/gridEditMode)
            return gridEditMode_applies({ flagOn: this.gridEditMode_on(), saveMethod: this.gridSave_saveMethod })
        },
        gearForm_sections() { return gearForm_layout(this.commandPanel_topLeft) },   // IE 2026 11 04 / ODOO-350449 (заказ Игоря: форма ⚙ по наведению — в стиле вкладки Display)
        commandPanel_topLeft_scrollStyle() {
            const maxH = this.commandPanel_topLeft_maxHeight
            return {
                maxHeight: maxH ? (maxH + 'px') : '60vh',
                overflowY: 'auto',
            }
        },
        // IE 2026 09 19 / ODOO-5800 (заказ Игоря «глобальный чипс-метрик»: приём чипса отчётом): отпечаток отбора глобального чипса, который этот грид принимает как чипс над таблицей ('' — не принимает)
        metricMirror_sig() {
            if (!this.WIDGET?.workspace) return ''
            if (this.store.metricChipG_accept(this.WIDGET) === 'input') return ''
            const doc = this.store.metricChipG_docActive(this.WIDGET.workspace)
            return doc ? metricChip_sig(doc) : ''
        },
        CHIPS: {
            get() {
                if (!this.WIDGET?.record || !this.attr?.name) return []
                return this.store.get_value(this.WIDGET.record, `doc.viewParams.${this.attr.name}.CHIPS`) || []
            },
            set(value) {
                if (this.WIDGET?.record && this.attr?.name) {
                    this.store.set_value(this.WIDGET.record, `doc.viewParams.${this.attr.name}.CHIPS`, chips_dropLive(value))   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска): живой чипс в запись / стол не пишется
                }
            }
        },
        // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска): чипсы для поиска (отбор, подсветка, счётчик, шапка, номера строк) — сохранённые + живой, пока в полосе набран текст.
        // Всё, что пишет или мутирует набор (filter_checkedRows, «>> », setChipOrder, метрики / оформление), работает с CHIPS — живого там нет
        CHIPS_view() {   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска)
            return chips_withLive(this.CHIPS, this.store.setting('fe.ux.gridLiveSearch', true) !== false ? this.liveChip : null)
        },
        gridClass() {
            const rowsHeight = this.get_viewParam('rowsHeight') || 2
            // условное оформление (conditional_format): безусловные правила отчёта бэк
            // сворачивает на view-поле dataSheet (attr._DLRow.cssClasses — массив имён,
            // уже резолвнутых через CSS-CLASS) — классы на контейнер грида
            const cf_classes = Array.isArray(this.attr?._DLRow?.cssClasses) ? this.attr._DLRow.cssClasses.join(' ') : ''
            return ['attr-grid ' + (this.attr?.cssClass||'') + (cf_classes ? ' ' + cf_classes : ''), {
                'attr-grid-50': !this.attr.noResize,
                // IE 2026 08 20 (заказ Игоря): свойство таблицы Borders=None —
                // без линий между строками (пунктирные рамки групп остаются)
                'grid-borders-none': this.attr?.borders === 'None',
                'cellform-tagbtn': this.cellFormTag_show(),   // IE 2026 09 29 / ODOO-343342 (заказ Игоря: форма ячейки по 🏷): шеврон в ячейках скрыт, форма — по кнопке 🏷
                [`grid-p${rowsHeight}`]: true,
                // «кочерыжка»: у wijmo нет ни одной видимой колонки — вместо серых
                // угловых ячеек прячем сам грид (панель над ним остаётся видимой);
                // таблица с колонками и нулём строк — показывается
                'grid-no-columns': this.grid_isEmpty,
                // IE 2026 09 23 / ODOO-… (заказ Игоря): рамка выделения ячеек грида данных — вариант записи / настройки базы (selFrame)
                [`sel-frame-${this.selFrame}`]: !!this.selFrame,
                'grid-rows-tall': this.gridRows_tall,   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p183: перемикач «Рядки: Компактні / Високі» у таблиці REPORT2, як у Heatmap (grid))
            }]
        },
        // IE 2026 09 23 / ODOO-… (заказ Игоря «сделай все три варианта и в нашем отчёте настрой A»): рамка выделения ячеек ГРИДА ДАННЫХ —
        // вариант из записи виджета (doc.params.selection_frame: classic | halo | dark | double; пусто → настройка базы
        // fe.ux.gridSelectionFrame, по умолчанию classic). Класс sel-frame-<вариант> ставится на контейнер грида (:class="gridClass"),
        // НЕ на хост wijmo (реактивные классы на хосте wijmo стирают его собственные); формы (attrs-tab-grid) и прочие гриды форм —
        // без класса, у них своя рамка. Смена значения в памяти (record.doc.params.selection_frame) перекрашивает рамку сразу,
        // без перечитывания. Classic — пустой класс (правило .wj-marquee как раньше).
        selFrame() {
            if (!this.selFrame_isDataGrid()) return ''
            let v = this.WIDGET?.record?.doc?.params?.selection_frame
            if (v === undefined || v === null || v === '') v = this.store.setting('fe.ux.gridSelectionFrame', 'classic')
            v = String(v || '').trim().toLowerCase()
            return (v === 'halo' || v === 'dark' || v === 'double') ? v : ''
        },
        cf_gridStyle() {
            // conditional_format: attr._DLRow.cssStyle отчёта — инлайн-стили контейнера
            // грида. Объект (не строка): патч по свойствам, не затирает императивный
            // height авто-высоты (elementFlex.style.height в resize-цикле)
            return this.store.normalizeStyle(this.attr?._DLRow?.cssStyle)
        },
        // IE 2026 09 23 / ODOO-… (слово Игоря по обыгрышу A: «давай максимально приглушим цифры… достаточно чтобы зрительно было видно, что цифры там есть,
        // а при наведении на них ты так их красиво показываешь, как если бы не приглушали»): прозрачность повтора итога группы (gt-dup-dim) —
        // CSS-переменная --gt-dup-dim на КОНТЕЙНЕРЕ грида (не на хосте wijmo: реактивные :class / :style на нём стирают его собственные),
        // значение — настройка базы fe.ux.gridGroupTotalsDimOpacity (0.02…0.9, кодовый дефолт 0.12 — след цифр; пусто / 0 / не число = дефолт);
        // наведение на строку → 1 (правило CSS .gt-dup-dim.wj-row-hover). Стиль контейнера остаётся ОБЪЕКТОМ поверх cf_gridStyle: патч по
        // свойствам, императивный height авто-высоты не трогается. _settingsEpoch — пересчёт при приходе настроек базы / override сеанса
        gridStyle() {
            const s = Object.assign({}, this.cf_gridStyle || {})
            s['--gt-dup-dim'] = String(this.groupDup_dimOpacity)
            if (this.gridRows_tall) s['--grid-row-h'] = GRID_TALL_ROW_H + 'px'   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p183: перемикач «Рядки: Компактні / Високі» у таблиці REPORT2, як у Heatmap (grid))
            s['--gt-dup-fade'] = this.groupDup_dimInstant ? '0s' : '.15s'   // IE 2026 09 24 / ODOO-5800: приглушение при отрисовке — без перехода (см. CSS .gt-dup-dim)
            return s
        },
        groupDup_dimOpacity() {
            void this.store._settingsEpoch
            let v = Number(this.store.setting('fe.ux.gridGroupTotalsDimOpacity', 0.12))
            if (!Number.isFinite(v) || v <= 0) v = 0.12
            return Math.min(0.9, Math.max(0.02, v))
        },
        // IE 2026 09 24 / ODOO-5800 (Игорь: «при прокрутке по горизонтали моргание ячейки 361:56 … formatItem не сразу подставляет правильный стиль»):
        // стиль ставится синхронно, «не сразу» — CSS-переход opacity .15s на переиспользованном wijmo элементе ячейки (см. правило .gt-dup-dim).
        // Выключатель fe.ux.gridGroupTotalsDimInstant (по умолчанию ВКЛ): приглушение при отрисовке мгновенно, плавно — только проявление
        // по наведению; false — прежнее поведение (переход и при отрисовке) для сравнения. Замер: handoff-tools/2026-09-24/cell_flicker
        groupDup_dimInstant() {
            void this.store._settingsEpoch
            return this.store.setting('fe.ux.gridGroupTotalsDimInstant', true) !== false
        },
        isMac() {
            return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
        },
        dragKeyName() {
            return this.isMac ? t('Command (⌘)') : t('Ctrl');   // IE 2026 09 23 / ODOO-341407: i18n
        },
        commandPanelOverflow() {
            if (this.commandPanelMaxVisible >= this.commandPanel.length) return []
            return this.commandPanel
                .slice(this.commandPanelMaxVisible)
                .filter(item => item.attr_type !== 'AttrSeparator' && item.visible !== false)
        },
        // IE 2026 10 06 / ODOO-341407 (заказ Игоря п.2): личная опция виджета «Show translation fields» (store.i18nFields_on — реактивно по карте стора,
        // одно состояние у всех гридов сегмента данных); формы (AttrTabGrid) — строки переводов, таблица данных списка — колонки переводов (IE 2026 10 06 / ODOO-341407).
        // Остальные гриды не читают
        i18nFieldsOn() {
            if (!this.WIDGET) return false
            if (this.attr?.attr_type !== 'AttrTabGrid' && !(this.attr?.binding === '_doc.data' && this.i18nFields_isListGrid())) return false   // IE 2026 10 06 / ODOO-341407: + таблица данных списка — колонки переводов
            return !!this.store.i18nFields_on(this.WIDGET)
        },
    },
    watch: {
        'store.legend_goto_field': function (v) {
            if (v) this.$nextTick(() => this.legendGotoField())
        },
        // Флаг «Show tooltips» переключили — тултипы навешиваются в formatItem,
        // то есть только на ПЕРЕРИСОВАННЫХ ячейках. Без инвалидации подсказки
        // появлялись лишь после переключения вкладок/скролла (замечание Андрея).
        'store.showTooltip'() {
            if (!this.flex) return
            this.flex.invalidate(true)
            this.flex.refresh(true)
        },
        // IE 2026 09 20 / ODOO-5800 (Igor: колонка Selector и статистика грида Conditional format, чипс условного оформления CHIP-Format): пришла статистика правил (cf_stats) — сводный грид в режиме «All» подмешивает цифры вложенным правилам
        'attr.format_rules'() { try { this.formatAuto_apply() } catch (e) { /* грид ещё не готов */ } },   // IE 2026 09 20 / ODOO-5800 (Igor 20.09: Selector правила и флажок правила в форме ячейки создают чипс оформления)
        'WIDGET.record._doc.cf_stats'() { try { if (this.aggAll_showAll && this.formatSel_grid()) this.aggAll_scheduleRebuild() } catch (e) { /* грид ещё не готов */ } },
        // IE 2026 09 30 / ODOO-5800: галочка «Always show all columns» (doc.params.show_all_columns) переключена в памяти записи — перефильтровать
        // таблицу данных без переоткрытия: apply_CHIPS → apply_CHIPS_columns вернёт / спрячет пустые колонки и пересчитает бейдж глаза
        'WIDGET.record.doc.params.show_all_columns'() { try { if (this.flex && this.selFrame_isDataGrid() && !this.attr.showEmpty) this.apply_CHIPS() } catch (e) { /* грид ещё не готов */ } },   // IE 2026 09 30 / ODOO-5800
        metricMirror_sig: { handler() { this.metricMirror_sync() }, immediate: true },   // IE 2026 09 19 / ODOO-5800 (заказ Игоря «глобальный чипс-метрик»: приём чипса отчётом)
        // IE 2026 10 06 / ODOO-341407 (заказ Игоря п.2): опция «Show translation fields» переключена — строки формы / колонки списка пересобираются из памяти (без запроса
        // к бэку; запись виджета не трогается). IE 2026 10 06 / ODOO-341407: + колонки списка (i18nFields_listRebuild)
        i18nFieldsOn(v, old) { if (!!v !== !!old) { if (this.attr?.attr_type === 'AttrTabGrid') this.i18nFields_formRebuild(); else this.i18nFields_listRebuild() } },
        'CHIPS'(newVal, oldVal) {
            const CHIPS = this.get_viewParam('CHIPS', [])
            if (JSON.stringify(newVal) !== JSON.stringify(CHIPS)) {
                this.set_viewParam('CHIPS', newVal)
            }
        },
        'store.cssClasses_change_index'() {
            this._styleSample = null   // IE 2026 09 18 / ODOO-…: образцы стилей (вкладка Styles, чипс отбора) — заново
            this._alertClsColor = null
            this._ruleFillCache = null   // IE 2026 09 18 / ODOO-…: «стиль с фоном главнее тепловой заливки» — ответы по именам заново
            if (this.flex && this.hslGroups && Object.keys(this.hslGroups).length) {
                for (const _cache of this.cache_data_cells.values()) _cache.className = ''
                this.flexRefresh()
                return
            }
            // реестр CSS-CLASS получен: перерисовать с резолвнутыми именами классов;
            // кэш className ячеек мог сохранить классы по id (uuid) — сбросить его,
            // чтобы полный форматтер собрал классы заново
            if (!this.flex) return
            const used = attr_col => Array.isArray(attr_col?.cssClasses) || Array.isArray(attr_col?.cssClasses_columnHeader)
            // AttrTabGrid: классы задаются на полях-строках (dataItem.attr), а не на колонках
            const used_rows = this.attr.attr_type === 'AttrTabGrid' && this.flex.rows.some(row => used(row.dataItem?.attr))
            if (!used_rows && !this.flex.columns.some(col => used(this.attr_by_binding[col.binding]))) return
            for (const _cache of this.cache_data_cells.values()) {
                _cache.className = ''
            }
            this.flexRefresh()
        },
        'store.itemsSource_change_index'(newVal, oldVal) {
            // за один тик может измениться несколько сегментов (Vue батчит вотчеры) —
            // change_type хранит только последний, поэтому сверяемся с журналом изменений
            const changedSet = this.store.get_itemsSource_changedSet(newVal, oldVal)
            const is_changed = segment => !!segment && (changedSet === null || changedSet.has(segment))
            // R1: словари приехали — вычеркнуть их из удержания первого кадра;
            // все дождались → снять скелетон (в этом же флаше wijmo получает dataMap,
            // так что первый видимый кадр — сразу с тайтлами)
            if (this.titles_pending) {
                if (changedSet === null) this.titles_pending.clear()
                else for (const seg of changedSet) this.titles_pending.delete(seg)
                if (!this.titles_pending.size) this.titles_release('applied')
            }
            if (this.flex && (changedSet === null || changedSet.size)) {
                let changed, icol = 0
                for (let col of this.flex.columns) {
                    let attr_col = this.attr_by_binding[col.binding]
                    if (attr_col?.attr_type === 'AttrLink-2025' && is_changed(attr_col.relation_segment)) {
                        this.itemsSource_by_binding[col.binding] = this.store.get_itemsSource(this, {}, attr_col, { fetchMode: 'justGet' })
                        changed = true

                        if (!attr_col.width) {
                            col.width = this.autoSizeColumn(attr_col, icol? 0 : 5, col)
                        }
                    } else if (attr_col?.attr_type === 'AttrLink' && attr_col.relation_segment_binding && !attr_col.relation_segment
                        && this._segBinding_segments && (changedSet === null || [...this._segBinding_segments].some(seg => changedSet.has(seg)))) {
                        changed = true // IE 2026 08 28 / ODOO-5800: словарь сегмента строк приехал — ячейки перерисует linkSegBinding_paint
                    } else if (attr_col?.attr_type === 'AttrLink' && !attr_col.relation_segment && (mtl_segments(attr_col, this.store) || []).some(is_changed)) {
                        changed = true   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди): словарь сегмента колонки составного типа приехал — ячейки перерисует mtl_paint
                    } else if (attr_col?.attr_type === 'AttrLink' && is_changed(attr_col.relation_segment)) {
                        // if (!this.store.hide_console) console.log(`watchSheet ${change_type} ${newVal}`)
                        // R20 (fastEntry.dictIdsGuard): в словарь долили id, которых в этой колонке нет (их спросил другой виджет /
                        // фоновая вкладка формы) — заголовки колонки не изменились, перерисовка и пересортировка не нужны
                        if (this.store.fastEntry?.dictIdsGuard !== false) {
                            const came = this.store.get_itemsSource_changedIds(newVal, oldVal, attr_col.relation_segment)
                            if (came && !this.linkIds_uses(col.binding, came)) { (window._dictGuard = window._dictGuard || { skipped: 0, refreshed: 0 }).skipped++; icol++; continue }
                        }

                        this.store.get_itemsSource(this, col, attr_col, { fetchMode: 'justGet' })
                        changed = true // need for correct re-order rows, after 'store.itemsSource_change_index' 2025-09-09

                        const width0 = this.viewParam_attrs?.[attr_col.binding]?.width
                        if (width0) {
                            col.width = width0
                        } else if (!attr_col.width) {
                            col.width = this.autoSizeColumn(attr_col, icol? 0 : 5, col)
                        }
                    } else if ((attr_col?.attr_type === 'AttrTags' && is_changed(tagIds_segment(attr_col)))
                        || (this._tagIds_segments && [...this._tagIds_segments].some(seg => is_changed(seg)))) {
                        changed = true   // IE 2026 10 05 / ODOO-5800 (fe-80): названия записей списка id приехали — перерисовать ячейки (колонка списка / строка формы)
                    } else if (attr_col?.attr_type === 'AttrGrid'
                        && (attr_col.attrs || []).some(a => a?.attr_type === 'AttrLink' && is_changed(a.relation_segment))) {
                        // ячейка-chips: подписи чипсов резолвятся из itemsSource Link-колонки
                        // табличной части (например cssClasses → CSS-CLASS) — перерисовать
                        changed = true
                    } else if (attr_col?.attr_type === 'AttrMulti') {
                        this.flex.rows.forEach((item, irow) => {
                            if (item.dataItem) {
                                let V = this.store.get_value(item.dataItem, attr_col.binding)
                                if (V?.value && V.attr_type === 'AttrLink' && (is_changed(V.relation_segment) || is_changed(attr_col.relation_segment))) {
                                    const valueStr = V.valueStr,
                                    parentsList = this.get_parentsList(irow, attr_col),
                                    founded = this.store.get_valueStr(this, V, V, attr_col, parentsList)
                                    if (attr_col.customValueWarning) {
                                        if (founded && V.is_customValueWarning) {
                                            delete V.is_customValueWarning
                                            changed = true
                                        } else if (!founded && !V.is_customValueWarning && V.value) {
                                            V.is_customValueWarning = true
                                            changed = true
                                        }
                                    }
                                    if (valueStr !== V.valueStr) {
                                        changed = true
                                    }
                                }
                            }
                        })
                    }
                    icol++
                }
                if (changed) {
                    (window._dictGuard = window._dictGuard || { skipped: 0, refreshed: 0 }).refreshed++
                    this.need_set_itemsSource = true
                    this.flexRefresh('dict')   // IE 2026 10 29 / ODOO-5800 (webscm #114418: долгая задача 0,86 с после Shift+F3 — скан пустых колонок соседнего грида): проход только из-за словаря — вердикт пустых колонок из кэша
                }
            }
        },
    },
}
</script>

<style>
/* IE 2026 11 04 / ODOO-350449 (заказ Игоря: форма ⚙ по наведению — в стиле вкладки Display): вид формы быстрых настроек ⚙ — как DisplayOptionsTab
   (те же классы do-group / do-group-title / do-row и значения: заголовок группы капсом серым с линией, подпись 600 слева, сегменты SegSwitch справа с переносом).
   Флаг-класс .gear-form-v2 — только через :where() (вес не растёт: инцидент .ui-font-unify button перебил .pi). Наведение меняет только фон (SegSwitch), ширина кнопок не меняется */
:where(.gear-form-v2) { padding: 6px 10px 8px; display: flex; flex-direction: column; gap: 10px; min-width: 340px; max-width: 460px; box-sizing: border-box; }
:where(.gear-form-v2) .do-group { display: flex; flex-direction: column; gap: 6px; }
:where(.gear-form-v2) .do-group-title { font-weight: 600; font-size: 0.85rem; opacity: 0.75; text-transform: uppercase; letter-spacing: 0.03em; border-bottom: 1px solid var(--surface-border); padding-bottom: 2px; }
:where(.gear-form-v2) .do-row { display: flex; align-items: center; min-height: 26px; gap: 6px; }
:where(.gear-form-v2) .do-row .seg-set { flex-wrap: wrap; row-gap: 4px; }
:where(.gear-form-v2) .do-row .seg-set .seg-label, :where(.gear-form-v2) .do-row .gf-label { flex: 0 0 170px; width: 170px; white-space: normal; overflow-wrap: anywhere; }
:where(.gear-form-v2) .do-row .gf-label { font-size: 12px; font-weight: 600; line-height: 16px; color: var(--text-color, #1f2430); }
:where(.gear-form-v2) .gf-num .wj-labeled-input { padding: 0; margin: 0; width: 5.5rem; }
:where(.gear-form-v2) .gf-num .wj-labeled-input > label { display: none; }
:where(.gear-form-v2) .gf-num .wj-labeled-input .wj-control.wj-content { border: 1px solid var(--surface-border, #e1e4ec); border-radius: 6px; background: var(--surface-card, #fff); font-size: 12px; }
:where(.gear-form-v2) .gf-num .wj-labeled-input .wj-control.wj-content input.wj-form-control { padding: 1px 6px; height: 22px; font-size: 12px; }
:where(.gear-form-v2) .gf-other .commandPanel-buttons { margin: 0; }
/* IE 2026 11 04 / ODOO-350449 (поправка Игоря: булевы в форме ⚙ — снова кнопкой-тумблером, перечисления — группой): тумблеры группы — прежние кнопки в ряд с переносом, зазор 6 px; вид кнопок (нажатая, жирные части подписи) — общие правила
   AttrButton / App.vue, меняют только цвета, ширина при наведении и переключении прежняя. Сегменты — SegSwitch .seg-seg-one: скругление только по внешним краям */
:where(.gear-form-v2) .do-row.gf-toggles { flex-wrap: wrap; gap: 6px; }
:where(.gear-form-v2) .gf-toggles .commandPanel-buttons { margin: 0; flex: 0 0 auto; }
/* IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N): фон ячеек с учётом соседей (AttrGrid.cfr_paint, fe.ux.cellFillRound) — слои поверх собственной заливки ячейки.
   :where() — специфичность одного .wj-flexgrid .wj-cell: любое правило фичи со своим background-image (поиск, влияние, уголки) остаётся главнее */
/* IE 2026 11 03 / ODOO-350449 (заказ Игоря: виды ячеек запаса под ключ — Z5 по умолчанию; BE ie-dm7 stock_cells_batch): слой ячейки запаса — SVG data-URI фоном в нижней части ячейки (AttrGrid.stockCell_after), без узлов DOM; размеры ячейки не меняются */
.wj-flexgrid .wj-cells .wj-cell:where(.stk) { background-image: var(--stk-img); background-repeat: no-repeat; background-position: left bottom; background-size: 100% var(--stk-h, 9px); text-shadow: 0 0 2px #fff, 0 0 1px #fff; }
/* IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р6/Р7): строка-итог / группа (серая плашка) — белый ореол бледнил цифры: без ореола, цвет цифр обычный; слой тише (stockCells STOCK_QUIET_OP) */
.wj-flexgrid .wj-cells .wj-cell:where(.stk.stk-g) { text-shadow: none; }
.wj-flexgrid .wj-cell:where(.cfr) { background-image: var(--cfr-img); background-size: var(--cfr-size); background-position: var(--cfr-pos); background-repeat: no-repeat; background-origin: border-box; }   /* IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N) */
.wj-flexgrid .wj-cell:where(.cfr-f) { border-right-color: transparent !important; border-bottom-color: transparent !important; }   /* IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N): линию сетки залитой ячейки рисует слой (ширина рамки та же — размеры без изменений) */
/* IE 2026 11 03 / ODOO-350449 (проба p252: фон ячеек — слои поверх cell-lt/cell-rc, соседи через скрытые колонки): .wj-cell.cell-lt / .cell-rc (и их монохром .ux-mono) задают фон шорткатом background: … !important — он сбрасывает и background-image / -size / -position
   в none с !important, слои .cfr стирались (16 голубых и 9 оранжевых ячеек прямоугольные, а cfr-f при этом прятал линию сетки). Цвет заливки остаётся их (background-color),
   поверх — только слои: :is() даёт 0,4,0 > 0,3,0 у правил монохрома (ux-mono) и 0,2,0 у базовых; приглушённый итог года (.yt-muted, 0,6,0) по-прежнему без слоёв. !important — только на эти два класса */
.wj-flexgrid .wj-cell.cfr:is(.cell-lt, .cell-rc) { background-image: var(--cfr-img) !important; background-size: var(--cfr-size) !important; background-position: var(--cfr-pos) !important; background-repeat: no-repeat !important; background-origin: border-box !important; }   /* IE 2026 11 03 / ODOO-350449 (проба p252: фон ячеек — слои поверх cell-lt/cell-rc, соседи через скрытые колонки) */
/* IE 2026 11 02 / ODOO-350449 (дополнение Игоря к p217, вариант 1: развёрнутый год — приглушённый итог, свёрнутый — остаток на начало года): ячейка итога развёрнутого года — приглушённая: без заливки, мелкий серый курсив, тонкие серые разделители года; запас — «—» по центру; «Непокрито» — красным */
.wj-flexgrid .wj-cells .wj-cell.yt-muted:not(.wj-state-selected):not(.wj-state-multi-selected) { background: transparent !important; background-image: none !important; }
.wj-flexgrid .wj-cells .wj-cell.yt-muted { font-size: 0.85em; font-style: italic; color: #8a8f98 !important; border-left: 1px solid #c3c7cd !important; border-right: 1px solid #c3c7cd !important; box-shadow: none !important; }
.wj-flexgrid .wj-cells .wj-cell.yt-muted.yt-muted-stock { text-align: center; }
.wj-flexgrid .wj-cells .wj-cell.yt-muted.yt-muted-unc { color: #c62828 !important; }
/* IE 2026 11 01 / ODOO-350449 (заказ Игоря: кругові діаграми за статусами у клітинках REPORT2, опції зрізу і їх розміщення): пирог статусов в ячейке-дате —
   кружок слева, число справа; узкая колонка — только пирог по центру (число — в подсказке). Подсказка — стиль hm-tip вкладки Heatmap (её стили живут
   в отдельном чанке AttrHeatmap, поэтому продублированы здесь под .cell-pie-tip) */
/* IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T1): круг вида ячеек (cellRing) — слот слева шириной макс. диаметра
   (--cell-ring-pad ставит грид), диаметр / фон / кольцо — inline-стилем span; узкая колонка — только круг по центру (число — в подсказке) */
.wj-cell.has-cell-ring { padding-left: var(--cell-ring-pad, 21px) !important; }
.wj-cell > .cell-ring { position: absolute; left: 10px; top: 50%; width: 13px; height: 13px; transform: translate(-50%, -50%); border-radius: 50%;
    outline: 1px solid rgba(0, 0, 0, .14); outline-offset: -1px; pointer-events: none; }
.wj-cell.has-cell-ring.cell-ring-only { padding-left: 0 !important; color: transparent !important; }
.wj-cell.cell-ring-only > :not(.cell-ring) { visibility: hidden; }
.wj-cell.cell-ring-only > .cell-ring { left: 50% !important; }
/* IE 2026 11 01 / ODOO-350449 (заказ Игоря: форма Стовпчики та Запас площею — T15): форма «Стовпчики» — слот слева (--cell-bars-pad), столбик на слой снизу, полоса сигнала сверху;
   «Запас — площею» — кусок площади во всю ячейку поверх фона (полупрозрачный, число читается); переключатель формы в строке команд грида */
.wj-cell.has-cell-bars { padding-left: var(--cell-bars-pad, 20px) !important; }
.wj-cell > .cell-bars { position: absolute; left: 4px; top: 50%; transform: translateY(-50%); pointer-events: none; }
.wj-cell > .cell-bars > i { position: absolute; bottom: 0; display: block; border-radius: 1px 1px 0 0; }
.wj-cell > .cell-bars > b.cell-bars-band { position: absolute; top: 0; left: 0; right: 0; display: block; border-radius: 1px; }
.wj-cell.has-cell-bars.cell-bars-only { padding-left: 0 !important; color: transparent !important; }
.wj-cell.cell-bars-only > :not(.cell-bars) { visibility: hidden; }
.wj-cell.cell-bars-only > .cell-bars { left: 50% !important; transform: translate(-50%, -50%); }
.wj-cell > .cell-area { position: absolute; left: 0; top: 0; right: 0; bottom: 0; display: block; pointer-events: none; }
.wj-cell > .cell-area > svg { display: block; width: 100%; height: 100%; }
.cell-shape-switch.seg-set { margin: 0 6px; }   /* IE 2026 11 02 / ODOO-350449 (заказ Игоря: p189 єдиний вигляд полос перемикачів — заголовки, відступи, Alt-підказки пунктів): вид — общий SegSwitch (size sm); прежние .cell-shape-label / .cell-shape-btn сняты */
/* IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p183: перемикач «Рядки: Компактні / Високі» у таблиці REPORT2, як у Heatmap (grid)): высокие строки (grid-rows-tall на контейнере грида) — текст ячеек данных и заголовков строк по центру по вертикали:
   line-height = высота строки − нижняя рамка, без вертикальных отступов. Не flex: text-align (wj-align-right) и многоточие сохраняются; шапка колонок — как была;
   круги / столбики (absolute, top 50 %) не затронуты; компактные строки — без изменений (класса нет) */
.attr-grid.grid-rows-tall .wj-flexgrid .wj-cells .wj-cell, .attr-grid.grid-rows-tall .wj-flexgrid .wj-rowheaders .wj-cell {
    padding-top: 0; padding-bottom: 0; line-height: calc(var(--grid-row-h, 34px) - 1px); }
.wj-tooltip .cell-pie-tip.hm-tip-g { display: block; min-width: 180px; max-width: 360px; font-size: 12px; line-height: 1.35; }
.wj-tooltip .cell-pie-tip .hm-tip-head { padding-bottom: 4px; }
.wj-tooltip .cell-pie-tip .hm-tip-title { font-weight: 600; }
.wj-tooltip .cell-pie-tip .hm-tip-sub { opacity: .7; font-size: 11px; }
.wj-tooltip .cell-pie-tip .hm-tip-sec { display: grid; grid-template-columns: minmax(0, 1fr) auto; column-gap: 14px; row-gap: 1px; padding: 5px 0 4px; border-top: 1px solid rgba(127, 127, 127, .28); }
.wj-tooltip .cell-pie-tip .hm-tip-cap { grid-column: 1 / -1; margin-bottom: 2px; font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: .06em; opacity: .6; }
/* IE 2026 11 03 / ODOO-350449 (заказ Игоря: p231 підказка по сигналу — проблема як у формі комірки): строки проблем в подсказке над сигналом — разметка и классы строки PROBLEMS формы
   (бейджи / заголовки — стили CellStory.vue), строка на всю ширину раздела */
.wj-tooltip .cell-pie-tip .sig-tip-sec > .sig-tip-prow { grid-column: 1 / -1; padding: 1px 0; }
.wj-tooltip .cell-pie-tip .sig-tip-sec > .sig-tip-loading { grid-column: 1 / -1; }
.wj-tooltip .cell-pie-tip.sig-tip { max-width: 420px; }
.wj-tooltip .cell-pie-tip .sig-tip-click { padding-top: 3px; opacity: .7; }
/* IE 2026 11 03 / ODOO-350449 (заказ Игоря: агрегат сигналов кругом в кнопке; проблемы подсказки в одну строку, клик — форма ячейки): проблемы подсказки — одна строка, «…», полный текст по наведению только у обрезанной (sig-tip-prow-full), строка кликабельна;
   диаграмма-агрегат в кнопке «Сигнали» (место — padding кнопки, пока режим активен) и её подсказка (таблица видов: цвет, название, число, доля) */
.wj-tooltip .cell-pie-tip.sig-tip-1l .sig-tip-sec > .sig-tip-prow { display: block; min-width: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; cursor: pointer; border-radius: 4px; }
.wj-tooltip .cell-pie-tip.sig-tip-1l .sig-tip-sec > .sig-tip-prow > * { display: inline; vertical-align: baseline; white-space: nowrap; overflow-wrap: normal; }   /* IE 2026 11 03 / ODOO-350449 (заказ Игоря: проблемы подсказки в одну строку — и строки story): .dropdown-story-seg-title формы (CellStory.vue) сам ставит white-space: normal + overflow-wrap: break-word — без этого длинные звенья story переносились (50 / 34 px), «…» не было */
.wj-tooltip .cell-pie-tip.sig-tip-1l .sig-tip-sec > .sig-tip-prow > .dropdown-story-badge { display: inline-block; margin-right: 4px; }
.wj-tooltip .cell-pie-tip.sig-tip-1l .sig-tip-sec > .sig-tip-prow > .dropdown-story-arrow { margin: 0 4px; }
.wj-tooltip .cell-pie-tip.sig-tip-1l .sig-tip-sec > .sig-tip-prow:hover { background: var(--surface-hover, rgba(127, 127, 127, .12)); }
.wj-tooltip .cell-pie-tip.sig-tip-1l .sig-tip-sec > .sig-tip-prow.sig-tip-prow-full { white-space: normal; overflow: visible; }
/* IE 2026 11 03 / ODOO-350449 (замечание Игоря: мгновенная подсказка сигнала явно говорит о подгрузке проблем): пока story в пути — предварительные строки сигналов приглушены, под ними строка состояния (спиннер pi-spin pi-spinner) */
.wj-tooltip .cell-pie-tip.sig-tip.sig-tip-pending .sig-tip-sec > .sig-tip-srow { opacity: .6; }
.wj-tooltip .cell-pie-tip .sig-tip-sec > .sig-tip-note { grid-column: 1 / -1; display: flex; align-items: center; gap: 6px; padding-top: 2px; }
.wj-tooltip .cell-pie-tip .sig-tip-sec > .sig-tip-note > .pi { font-size: 11px; }
.wj-tooltip .cell-pie-tip.sig-tip-1l .sig-tip-sec > .sig-tip-prow.sig-tip-prow-full > .dropdown-story-seg-title { white-space: normal; overflow-wrap: break-word; }   /* IE 2026 11 03 / ODOO-350449 (заказ Игоря: проблемы подсказки в одну строку — и строки story) */
.wj-tooltip .cell-pie-tip.sig-pie-tip .hm-tip-sec { grid-template-columns: minmax(0, 1fr) auto auto; }
.wj-tooltip .cell-pie-tip.sig-pie-tip .hm-tip-cap { grid-column: auto; }
.wj-tooltip .cell-pie-tip.sig-pie-tip .sig-pie-cap { text-align: right; }
.wj-tooltip .cell-pie-tip.sig-pie-tip .sig-pie-dot { flex: 0 0 auto; width: 10px; height: 10px; border-radius: 50%; }
.wj-tooltip .cell-pie-tip.sig-pie-tip .sig-pie-total { border-top: 1px solid rgba(127, 127, 127, .28); padding-top: 2px; font-weight: 600; }
.cp-item-wrap.sig-pie-slot { position: relative; }
.commandPanel-menu .cp-item-wrap.sig-pie-slot .commandPanel-buttons { padding-right: 28px !important; }
.cp-item-wrap.sig-pie-slot > .sig-pie { position: absolute; right: 9px; top: 50%; width: 14px; height: 14px; margin-top: -7px; border-radius: 50%; z-index: 2; cursor: pointer;
    box-shadow: 0 0 0 1px var(--surface-card, #fff); }
.wj-tooltip .cell-pie-tip .hm-tip-k { display: flex; align-items: center; gap: 6px; min-width: 0; }
.wj-tooltip .cell-pie-tip .hm-tip-kt { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.wj-tooltip .cell-pie-tip .hm-tip-v { text-align: right; white-space: nowrap; font-variant-numeric: tabular-nums; font-weight: 600; }
.wj-tooltip .cell-pie-tip .hm-tip-vs { margin-left: 6px; font-size: 10px; font-weight: 400; opacity: .65; }
.wj-tooltip .cell-pie-tip .hm-tip-sw { display: inline-block; flex: 0 0 10px; width: 10px; height: 10px; border-radius: 2px; }
/* IE 2026 10 25 / ODOO-348925 (заказ Игоря: цвета как на слайде — редактор цвета ColorPicker): образец цвета в ячейке и всплывающая палитра; наведение не меняет размеров */
.wj-cell .cell-color-sw {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-right: 6px;
    border-radius: 3px;
    vertical-align: -2px;
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.12);
    flex: 0 0 auto;
}
.wj-cell .cell-color-sw.is-light {
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.35);
}
.grid-color-pop {
    position: fixed;
    z-index: 10000;
    padding: 8px;
    background: var(--surface-card, #fff);
    color: var(--text-color, #333);
    border: 1px solid var(--surface-border, #d7d7d7);
    border-radius: 6px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
    user-select: none;
    font-size: 12px;
}
.grid-color-pop .p-colorpicker {
    display: block;
}
.grid-color-pop-bar {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 6px;
    min-height: 18px;
}
.grid-color-pop-sw {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 3px;
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.12);
}
.grid-color-pop-sw.is-light {
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.35);
}
.grid-color-pop-sw.is-empty {
    background: repeating-linear-gradient(45deg, transparent 0 3px, rgba(0, 0, 0, 0.18) 3px 4px);
}
.grid-color-pop-hex {
    font-family: monospace;
}
.grid-color-pop-hex.is-invalid {
    color: var(--red-600, #c62828);
    font-family: inherit;
}
.grid-color-pop-btns {
    display: flex;
    justify-content: flex-end;
    gap: 6px;
    margin-top: 6px;
}
.grid-color-pop-btn {
    padding: 3px 10px;
    font-size: 12px;
    line-height: 16px;
    border: 1px solid var(--surface-border, #cfcfcf);
    border-radius: 4px;
    background: var(--surface-card, #fff);
    color: var(--text-color, #333);
    cursor: pointer;
}
.grid-color-pop-btn:hover {
    background: var(--surface-hover, #f1f1f1);
}
.grid-color-pop-btn.is-main {
    background: var(--primary-color, #2f6da3);
    border-color: var(--primary-color, #2f6da3);
    color: var(--primary-color-text, #fff);
}
.grid-color-pop-btn.is-main:hover {
    filter: brightness(0.95);
}
/* IE 2026 10 25 / ODOO-348925: AttrRowLink — ключа нет в источнике («Not found: …»); без смены размеров */
.wj-cell.rl-not-found {
    font-style: italic;
}
/* АН 2026 08 15 / ODOO-4997: строки, чьи измерения выделены в графе
   Supply Chain Flow — рыжий обвод, как у выделенной ячейки/узла графа */
.wj-cell.dim-highlight {
    box-shadow: inset 0 2px 0 rgb(255, 150, 30), inset 0 -2px 0 rgb(255, 150, 30);
}

/* бейджи уровней группировки (ховер верхнего левого угла) — вид как у
   бейджей-счётчиков (--cs-badge-bg), в строку под углом */
.fold-badges {
    /* панель вне грида (overflow:hidden обрезал бы бейджи на кромке) — координаты вьюпорта */
    position: fixed;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    z-index: 1000;
    padding: 0;
    /* ИЕ 2026-08-14: прямоугольник панели (до 84x128) накрывал чекбокс «выбрать
       всё» и съедал по нему клик. Кликабельны ТОЛЬКО сами кружки — промежутки
       и пустая часть полосы пропускают мышь в грид насквозь */
    pointer-events: none;
}
.fold-badges-h, .fold-badges-v { pointer-events: none; }
.fold-badges-h {
    display: flex;
    gap: 4px;
    /* угол пустой: полоса колонок начинается правее слота вертикальной полосы */
    margin-left: 22px;
}
.fold-badges-v {
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.fold-badge {
    pointer-events: auto; /* сама кнопка — кликабельна (панель вокруг прозрачна) */
    min-width: 18px;
    height: 18px;
    padding: 0 4px;
    border-radius: 12px;
    background-color: var(--cs-badge-bg, #714B67);
    color: var(--cs-badge-fg, #ffffff);
    font-size: 11px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(0,0,0,.25);
}
.fold-badge:hover {
    filter: brightness(1.15);
    transform: scale(1.1);
}

.my-grid {
    position: relative;
}
/* IE 2026 10 13 / ODOO-5800: полоса Save / Discard над гридом ленивой вкладки */
.grid-save-bar {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    padding: 3px 8px;
    margin: 0 0 3px 0;
    border: 1px solid #e0b84a;
    border-radius: 4px;
    background: #fff6d6;
    color: #5a4300;
    font-size: 12px;
}
.grid-save-bar .gsb-text { flex: 1 1 auto; min-width: 0; }
.grid-save-bar .gsb-btn {
    border: 1px solid #c9a43a;
    border-radius: 4px;
    background: #fff;
    color: inherit;
    padding: 2px 10px;
    font-size: 12px;
    cursor: pointer;
}
.grid-save-bar .gsb-save { background: #f2c94c; font-weight: 600; }
.grid-save-bar .gsb-btn:disabled { opacity: .6; cursor: default; }
.label-grid {
    font-size: 0.875rem;
    text-transform: uppercase;
    font-weight: bold;
    top: 4px;
    color: #3f51b5;
    /*margin: 20px;*/
    margin: 5px 28px
}
.attr-grid {
    position: relative;
    overflow: hidden;
    width:-webkit-fill-available !important;
    border-radius: 0.5rem;
}
.attr-grid.grid-no-columns {
    /* пустой грид (ни одной колонки) — вместо серых угловых ячеек wijmo пусто;
       visibility (не display) — layout и замеры размеров работают */
    visibility: hidden;
}
.attr-grid-50 {
    height: 50px;
}
.attr-grid-input {
    width:-webkit-fill-available !important;
    /* margin: 5px !important; */
}
.wj-header-row  {
    text-align: center !important;
    border-right: 1px solid rgba(255, 255, 255, 0.5);
    border-bottom: 1px solid rgba(255, 255, 255, 0.5);
}
.wj-header-number-row  {
    text-align: center !important;
    border-right: 1px solid white !important;
    border-left: none !important;
    border-bottom: 3px solid white !important;
    padding-top: 0px !important;
}
/* задача 16: номерная строка — последняя видимая строка шапки; рыжая индикация
   выделенных колонок должна побеждать её белый border-bottom !important выше */
/* IE 2026 09 17 / ODOO-… (заказ Игоря): значение объединения «назад» — текст в корне объединения рядом со значком группы */
.wj-header-number-row.wj-state-multi-selected {
    border-bottom: 3px solid rgba(255,150,30,.75) !important;
    /* белый правый разделитель number-row на ВЫДЕЛЕННОМ заголовке торчал артефактом
       (стиль разделителя строк-заголовков не для этого случая) — гасим */
    border-right-color: transparent !important;
}
.grid-group1-row  {
    background-color: #f7f7f7;
    font-weight: bold;
}
.grid-group2-row  {
    background-color: lightgray;
    /* color: white; */
    font-weight: bold;
}
.grid-total-row  {
    background-color: lightgray;
    color: white;
    font-weight: bolder;
}
.cell-sum {
    color: green;
}
.wj-cell .attr-doc {
    display: flex;
    position: absolute; 
    left: 0px;
    width: 100%; 
    border-radius: 0px;
    margin: -5px 0 0px 0;
}
.wj-cell .attr-doc-input {
    width: 100%;
}
.wj-cell .cell-has-doc {
    background-color: burlywood;
}
.wj-cell .cell-has-doc:hover:after {
    opacity: 1;
}
.attr-column-button-group {
    position: absolute;
    left: 0px;
    top: 0px;
    color: white !important;
    background: transparent;
}
.attr-row-button-group {
    position: absolute;
    left: 0px;
    top: 0px;
    color: lightslategray !important;
    background: transparent;
}
.attr-row-button-group .pi {
    color: lightslategray;
    font-size: 0.75rem;
}
.attr-doc-button-group .pi {
    color: lightslategray;
    font-size: 0.75rem;
}
.attr-doc .attr-doc-button-group {
    position: absolute;
    right: 0px;
    top: 1px;
    transition: all 250ms;
    color: lightslategray !important;
    background: transparent;
}
.attr-doc .wj-input-group-btn {
    opacity: 0;
}
.attr-doc:hover .wj-input-group-btn {
    opacity: 0.9;
}
.cell-value .cell-value-show {
    opacity: 0.9;
}
/* IE 2026 10 23 / ODOO-5800 (заказ Игоря, скрин 1): ярлык «список сегмента» в ячейке Segment грида Sources — приглушён, на наведении ячейки — полный */
.wj-cell .seg-list-link { position: absolute; right: 2px; top: 0; bottom: 0; display: flex; align-items: center; opacity: 0.55; }   /* у правого края ячейки, вне потока — высота строки не меняется */
/* IE 2026 10 23 / ODOO-348700 (заказ Игоря): ярлык В ПОТОКЕ слева от названия сегмента (перекрывает absolute-правило выше) */
.wj-cell .seg-list-link { position: static; display: inline-flex; align-items: center; vertical-align: middle; margin-right: 4px; opacity: 0.55; }
.wj-cell:hover .seg-list-link, .wj-cell .seg-list-link:hover { opacity: 1; }
.wj-cell .seg-list-link .attr-doc-button { cursor: pointer; padding: 0 3px; line-height: 1; height: auto; }
/* IE 2026 10 24 / ODOO-348700 (заказ Игоря: ярлык не пропадает при вводе, текст на месте): ярлык ВНЕ потока слева (вертикаль не зависит от пути отрисовки и от поля ввода), ячейке — padding-left под ярлык (2 + 30 + 4): текст и поле ввода начинаются в одной точке */
.wj-flexgrid .wj-cell.seg-link-cell { padding-left: 36px !important; }   /* IE 2026 10 24 / ODOO-348700: перекрывает .grid-p2.attr-grid .wj-cell { padding: 1px 2px } */
.wj-flexgrid .wj-cell.seg-link-cell .seg-list-link { position: absolute; left: 2px; top: 0; bottom: 0; right: auto; display: flex; align-items: center; vertical-align: baseline; margin: 0; }   /* IE 2026 10 24 / ODOO-348700 */
/*.wj-flexgrid .cell-value .wj-grid-editor {
    text-align: left;
}*/
.attr-KPI-group {
    display: flex;
    position: absolute;
    top: 3px;
}
.attr-KPI .attr-KPI-selector {
    transition: all 250ms;
    opacity: 0;
    color: lightslategray !important;
    background: transparent;
}
.attr-KPI .attr-KPI-selector-on {
    opacity: 0.9;
}
.attr-KPI:hover .attr-KPI-selector {
    opacity: 1;
}
.attr-KPI .attr-KPI-button {
    transition: all 250ms;
    opacity: 0;
    background: transparent;
}
.attr-KPI:hover .attr-KPI-button {
    opacity: 1;
    background: transparent;
}
.wj-glyph-down {
    opacity: 0.2 !important;
}
.attr-doc2:hover .wj-glyph-down {
    opacity: 0.5 !important;
}
.attr-element:hover .wj-glyph-down {
    opacity: 0.5 !important;
}
.attr-selector .attr-doc-button-group {
    position: absolute;
    right: 0px;
    top: 2px;
    transition: all 250ms;
    /* display: none; */
    opacity: 0;
    color: lightslategray !important;
    /* display: flex; */
    /* align-items: center; */
}
.attr-selector:hover .attr-doc-button-group {
    /* display: block; */
    opacity: 0.9;
}

.wj-header.new {
    background-color: #a2f3c780 !important;
    color: lightslategray !important;
}
.wj-header.modified {
    background: lightgoldenrodyellow !important;
    color: lightslategray !important;
}

/* IE 2026 08 19 / ODOO-5512 (заказ Игоря): ручная корректировка — НЕ жёлтый фон
   (фон принадлежит условному оформлению), а треугольник в левом верхнем углу,
   как у косвенно изменённых, но своего цвета: СИНИЙ (#1e63c9) — финансовая
   конвенция «синее = введено руками, чёрное = формула»; не спорит ни с красным/
   зелёным дельты, ни с рыжим выделения. Классы: wj-has-stack (несохранённая
   правка), wj-has-override / wj-has-cell-data (сохранённая корректировка _cells) */
/* IE 2026 08 19 / ODOO-5512 (заказ Игоря): фон у помеченных ячеек НЕ трогаем
   вовсе — `background: none` сбрасывал штатный серый фон групповых строк и
   ячейка с уголком (28/9 в M03) становилась белой; жёлтых правил, которые он
   гасил, больше нет */
.wj-cell.wj-has-stack::before,
.wj-cell.wj-has-override::before,
.wj-cell.wj-has-cell-data::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 6px 6px 0 0;
    border-color: #1e63c9 transparent transparent transparent;
    pointer-events: none;
}
/* у той же ячейки есть дельта — свёрнутый уголок дельты тоже синий (не красный/
   зелёный), развёрнутая таблетка по наведению сохраняет цвет направления */
.wj-cell.wj-has-stack.chg-badge-up::after,
.wj-cell.wj-has-stack.chg-badge-down::after,
.wj-cell.wj-has-cell-data.chg-badge-up::after,
.wj-cell.wj-has-cell-data.chg-badge-down::after { border-top-color: #1e63c9; }
.wj-cell.wj-has-stack-error {
    background-color: #ffdfdf !important;
    color: white !important;
}
/* IE 2026 08 18 / ODOO-4997 (заказ Игоря п.1): косвенная правка НЕ трогает фон
   и цвет текста — они принадлежат условному оформлению. Постоянная метка —
   угловой бейдж с дельтой отклонения, цвет бейджа по направлению */
/* (.wj-cell.wj-has-stack-indirect — фон не трогаем, см. выше) */
.wj-cell[data-chg-delta]::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    width: 0;
    height: 0;
    padding: 0;
    border-style: solid;
    border-width: 6px 6px 0 0;
    border-color: transparent;
    pointer-events: none;
}
.wj-cell.chg-badge-up::after   { border-top-color: #2e7d32; }
.wj-cell.chg-badge-down::after { border-top-color: #c62828; }
/* IE 2026 08 24 / ODOO-5884 (заказ Игоря): веточный дифф-бейдж поля (Branch copy vs рабочая версия) —
   индиго, чтобы отличаться от красно-зелёных бейджей ТЕКУЩИХ правок; при наличии текущей правки
   (data-chg-delta) веточный не рисуется */
.wj-cell.cow-diff-badge:not([data-chg-delta])::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    width: 0;
    height: 0;
    padding: 0;
    border-style: solid;
    border-width: 6px 6px 0 0;
    border-color: transparent;
    border-top-color: #4f46e5;
    pointer-events: none;
}
.wj-cell.cow-diff-badge:not([data-chg-delta]):hover { overflow: visible; }
.wj-cell.cmp-cell-badge:not([data-chg-delta])::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    width: 0;
    height: 0;
    padding: 0;
    border-style: solid;
    border-width: 6px 6px 0 0;
    border-color: transparent;
    border-top-color: #4f46e5;
    pointer-events: none;
}
.wj-cell.cmp-cell-badge:not([data-chg-delta]):hover { overflow: visible; }
/* IE 2026 09 21 / ODOO-5800 (Igor: под чипсом-фильтром строк итоги групп — по видимым строкам): ячейка с итогом ПО ОТБОРУ — курсив с пунктирным подчёркиванием
   (псевдоэлементы ячейки заняты метками правок и сравнения); подсказка «Total of the rows that match the filter» */
.wj-cell.ft-total { font-style: italic; text-decoration: underline dotted rgba(0, 0, 0, .3); text-underline-offset: 2px; }
/* итог затронутой отбором группы, который фронт воспроизвести не может (WAvg без весов, accuracy %, годовой итог остатков) — остаётся итог бэка по всем строкам, приглушён */
.wj-cell.ft-stale { opacity: .45; }
/* IE 2026 08 24 / ODOO-5884 (замечание Игоря): у верхнего края грида таблетка разворачивается ВНИЗ,
   иначе её перекрывает шапка таблицы */
.wj-cell.badge-pill-flip.cmp-cell-badge:not([data-chg-delta]):hover::after,
.wj-cell.badge-pill-flip.audit-diff-badge:not([data-chg-delta]):hover::after,
.wj-cell.badge-pill-flip.cow-diff-badge:not([data-chg-delta]):hover::after {
    top: auto !important;
    bottom: 0 !important;
    transform: translateY(72%) !important;
}
/* IE 2026 08 25 / ODOO-5884 (скрин Игоря, хендовер): таблетку резало «рамками
   ячейки» — ячейки СЛЕДУЮЩЕЙ строки (позже в DOM) рисовались поверх ::after-
   пилюли; особенно заметно у вниз-развёрнутой таблетки первой видимой строки.
   На время показа поднимаем саму hover-ячейку над соседними строками: 3 — выше
   обычных ячеек, ниже рамки выделения (.wj-marquee: 5) и шапки колонок (5);
   !important — на случай inline z-index замороженных колонок wijmo. */
.wj-cell.cmp-cell-badge:not([data-chg-delta]):hover,
.wj-cell.audit-diff-badge:not([data-chg-delta]):hover,
.wj-cell.cow-diff-badge:not([data-chg-delta]):hover {
    z-index: 3 !important;
}
/* IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: подсветка изменений записи из аудита): изменённое поле / ячейка формы «Audit restore» —
   индиго-уголок, по наведению пилюля «+20 / +7d / ≠»; строка, которой нет в другой версии, — непрозрачный фон (frozen-клон) */
.wj-cell.audit-diff-badge:not([data-chg-delta])::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    width: 0;
    height: 0;
    padding: 0;
    border-style: solid;
    border-width: 6px 6px 0 0;
    border-color: transparent;
    border-top-color: #4f46e5;
    pointer-events: none;
}
.wj-cell.audit-diff-badge:not([data-chg-delta]):hover { overflow: visible; }
.wj-cell.audit-diff-badge:not([data-chg-delta]):hover::after {
    content: attr(data-adf-delta);
    z-index: 7;
    left: 2px;
    top: 0;
    transform: translateY(-72%);
    width: auto;
    height: auto;
    border: none;
    padding: 0 4px;
    border-radius: 6px;
    font-size: 9px;
    line-height: 11px;
    font-weight: 600;
    color: #fff;
    white-space: nowrap;
    background-color: #4f46e5;
    box-shadow: 0 0 0 1px rgba(255, 255, 255, .85);
}
.wj-cell.audit-row-added:not(.wj-state-selected):not(.wj-state-multi-selected) { background-color: #eef2ff; }
.wj-cell.audit-row-removed:not(.wj-state-selected):not(.wj-state-multi-selected) { background-color: #fdf2f2; }
.wj-cell.cmp-cell-badge:not([data-chg-delta]):hover::after {
    content: attr(data-cmp-delta);
    z-index: 7;
    left: 2px;
    top: 0;
    transform: translateY(-72%);
    width: auto;
    height: auto;
    border: none;
    padding: 0 4px;
    border-radius: 6px;
    font-size: 9px;
    line-height: 11px;
    font-weight: 600;
    color: #fff;
    white-space: nowrap;
    background-color: #4f46e5;
    box-shadow: 0 0 0 1px rgba(255, 255, 255, .85);
}
.wj-cell.cow-diff-badge:not([data-chg-delta]):hover::after {
    content: attr(data-cow-delta);
    z-index: 7;
    left: 2px;
    top: 0;
    transform: translateY(-72%);
    width: auto;
    height: auto;
    border: none;
    padding: 0 4px;
    border-radius: 6px;
    font-size: 9px;
    line-height: 11px;
    font-weight: 600;
    color: #fff;
    white-space: nowrap;
    background-color: #4f46e5;
    box-shadow: 0 0 0 1px rgba(255, 255, 255, .85);
}
/* IE 2026 08 18 / ODOO-5512 (заказ Игоря): дельта разворачивается ТОЛЬКО по
   наведению — на саму ячейку или на связанную с ней ячейку группы (раньше ещё и
   на вспышке: класс .wj-cell-flash переживал анимацию, и бейдж висел развёрнутым
   без мыши). Развёрнутый бейдж — таблетка, центр по ВЕРХНЕЙ границе ячейки;
   на время показа ячейка отпускает overflow, иначе верхняя половина срезается */
.wj-cell[data-chg-delta]:hover,
.wj-cell[data-chg-delta].wj-chg-linked,
.wj-cell[data-chg-delta].wj-chg-hovered {
    overflow: visible;
    /* z-index ячейке НЕ ставим: без своего stacking context её ::after ниже
       участвует в контексте грида и может лечь ПОВЕРХ рамки выделения (.wj-marquee
       z-index 5) — заказ Игоря 18.08; сама ячейка при этом рамку не перекрывает */
}
.wj-cell[data-chg-delta]:hover::after,
.wj-cell[data-chg-delta].wj-chg-linked::after,
.wj-cell[data-chg-delta].wj-chg-hovered::after {
    content: attr(data-chg-delta);
    z-index: 7; /* поверх рамки выделения текущих ячеек (.wj-marquee: 5) */
    left: 2px;
    top: 0;
    /* центр чуть ВЫШЕ верхней границы (Игорь 18.08): цифры своей ячейки читаются */
    transform: translateY(-72%);
    width: auto;
    height: auto;
    border: none;
    padding: 0 4px;
    border-radius: 6px;
    font-size: 9px;
    line-height: 11px;
    font-weight: 600;
    color: #fff;
    white-space: nowrap;
    box-shadow: 0 0 0 1px rgba(255, 255, 255, .85);
}
.wj-cell.chg-badge-up:hover::after,
.wj-cell.chg-badge-up.wj-chg-linked::after,
.wj-cell.chg-badge-up.wj-chg-hovered::after { background-color: #2e7d32; }
.wj-cell.chg-badge-down:hover::after,
.wj-cell.chg-badge-down.wj-chg-linked::after,
.wj-cell.chg-badge-down.wj-chg-hovered::after { background-color: #c62828; }
/* IE 2026 08 18 (заказ Игоря п.3): вспышка — один импульс поверх фона:
   90 мс нарастание, 400 мс удержание, 910 мс затухание */
.wj-cell.wj-cell-flash {
    animation: wjCellFlash 1400ms linear forwards;
}
@keyframes wjCellFlash {
    0%    { box-shadow: inset 0 0 0 999px rgba(255, 224, 138, 0); }
    6.5%  { box-shadow: inset 0 0 0 999px rgba(255, 224, 138, .85); }
    35%   { box-shadow: inset 0 0 0 999px rgba(255, 224, 138, .85); }
    100%  { box-shadow: inset 0 0 0 999px rgba(255, 224, 138, 0); }
}
/* IE 2026 09 02 / ODOO-11316 (заказ Игоря): ячейка Value в таблице фильтров, чьё
   значение отчёт подставляет сам (in selector / вычисляемый Source без manual) —
   спокойный сине-фиолетовый тинт + курсив: правка тут не имеет смысла */
.wj-cell.wj-cell-autovalue {
    box-shadow: inset 0 0 0 999px rgba(100, 126, 239, .18);
    font-style: italic;
}

/* IE 2026 09 02 / ODOO-11316 (заказ Игоря): ячейка, перебитая пересчётом, —
   красный импульс подольше: 90 мс нарастание, 900 мс удержание, затухание к 2.4 с */
.wj-cell.wj-cell-flash-override {
    animation: wjCellFlashOverride 2400ms linear forwards;
}
@keyframes wjCellFlashOverride {
    0%    { box-shadow: inset 0 0 0 999px rgba(229, 72, 72, 0); }
    4%    { box-shadow: inset 0 0 0 999px rgba(229, 72, 72, .8); }
    41%   { box-shadow: inset 0 0 0 999px rgba(229, 72, 72, .8); }
    100%  { box-shadow: inset 0 0 0 999px rgba(229, 72, 72, 0); }
}
@media (prefers-reduced-motion: reduce) {
    /* движение заменяем, а не выключаем: статичная пометка до след. действия */
    .wj-cell.wj-cell-flash {
        animation: none;
        box-shadow: inset 0 0 0 999px rgba(255, 224, 138, .35);
    }
    .wj-cell.wj-cell-flash-override {
        animation: none;
        box-shadow: inset 0 0 0 999px rgba(229, 72, 72, .3);
    }
}
/* IE 2026 08 18 / ODOO-4997 (заказ Игоря): трассировка связи агрегат <-> детали —
   БЕЗ рамок ячеек (были inset box-shadow 1px #2e5aac / 2px #c98a00): по наведению
   у связанных ячеек группы только разворачивается бейдж дельты (правила
   .wj-chg-linked/.wj-chg-hovered на ::after выше) */
/* IE 2026 08 18 (заказ Игоря п.7): сводка вместо сотни вспышек */
.wj-flexgrid .wj-chg-summary {
    position: absolute;
    right: 14px;
    bottom: 12px;
    z-index: 5;
    opacity: 0;
    padding: 4px 10px;
    border-radius: 4px;
    background: rgba(33, 43, 54, .92);
    color: #fff;
    font-size: 12px;
    pointer-events: none;
}
.wj-flexgrid .wj-chg-summary.show { animation: wjChgSummary 4s ease-out forwards; }
@keyframes wjChgSummary {
    0%   { opacity: 0; }
    6%   { opacity: 1; }
    75%  { opacity: 1; }
    100% { opacity: 0; }
}
.wj-cell.cell-zero {
    color: transparent !important;
}
/* IE 2026 09 20 / ODOO-5828 (замечание Игоря: «выделения нулей — в ячейках, в которых они были скрыты как пустые значения»): именованный стиль
   (.wj-cell.<имя>×4 { color: … !important }, его варианты по схемам body.cscheme-… — ещё сильнее) перебивал прозрачный цвет спрятанного
   нуля: ноль на заливке Grade · Bad читался белым. Спрятанный ноль остаётся спрятанным при любом оформлении ячейки (0,8,0) */
.wj-cell.cell-zero.cell-zero.cell-zero.cell-zero.cell-zero.cell-zero.cell-zero {
    color: transparent !important;
}
.wj-cell.cell-zero .wj-grid-editor {
    color: black !important;
}
/* IE 2026 09 23 / ODOO-… (заказ Игоря: итог группы = единственный потомок): ячейка раскрытой строки-группы, повторяющая единственного видимого потомка
   (AttrGrid.groupDup_paint). A dim — вся ячейка на 12 % (IE 2026 09 23 / ODOO-…, слово Игоря «максимально приглушим цифры»: след цифр, не читаются;
   было 38 % по макету; значение — настройка базы fe.ux.gridGroupTotalsDimOpacity через переменную --gt-dup-dim контейнера, AttrGrid.gridStyle),
   по наведению на строку — целиком, как без приглушения; цифры на месте, копируются; B hover — текст
   прозрачный через -webkit-text-fill-color (цвет текста не трогаем: его ставят именованные стили с !important, по наведению на строку
   возвращается currentcolor); C arrow — вместо числа тихая «↓» у правого края (::before, свой цвет), по наведению — число. Наведение —
   класс .wj-row-hover (ставит JS на всю строку, включая клон замороженных) и :hover строки */
/* IE 2026 09 24 / ODOO-5800 (Игорь: «при прокрутке по горизонтали моргание ячейки 361:56»): класс gt-dup-dim formatItem ставит синхронно,
   но wijmo при горизонтальной прокрутке ПЕРЕИСПОЛЬЗУЕТ DOM-элемент ячейки (GridPanel._renderCell: e.children[r]) — элемент приходит с
   opacity 1 от прежней ячейки, и transition .15s 10 кадров плавно гасил его до .12 (замер cell_flicker: 316 переходов opacity за 63 шага
   прокрутки при неизменном классе). Длительность перехода при отрисовке — переменная --gt-dup-fade контейнера (AttrGrid.gridStyle):
   0s при fe.ux.gridGroupTotalsDimInstant (по умолчанию вкл), .15s — прежнее поведение; плавность остаётся у проявления по наведению */
.wj-cell.gt-dup-dim { opacity: var(--gt-dup-dim, .12); transition: opacity var(--gt-dup-fade, 0s); }
.wj-cell.gt-dup-dim.wj-row-hover, .wj-cells .wj-row:hover .wj-cell.gt-dup-dim { opacity: 1; transition: opacity .15s; }   /* IE 2026 09 24 / ODOO-5800 */
.wj-cell.gt-dup-hover, .wj-cell.gt-dup-arrow { -webkit-text-fill-color: transparent; }
.wj-cell.gt-dup-hover.wj-row-hover, .wj-cells .wj-row:hover .wj-cell.gt-dup-hover { -webkit-text-fill-color: currentcolor; opacity: .55; }
.wj-cell.gt-dup-arrow::before { content: '\2193'; position: absolute; right: 6px; top: 50%; transform: translateY(-50%); color: #6b6f76; -webkit-text-fill-color: #6b6f76; opacity: .45; font-size: 11px; line-height: 1; pointer-events: none; }
.wj-cell.gt-dup-arrow.wj-row-hover, .wj-cells .wj-row:hover .wj-cell.gt-dup-arrow { -webkit-text-fill-color: currentcolor; opacity: .9; }
.wj-cell.gt-dup-arrow.wj-row-hover::before, .wj-cells .wj-row:hover .wj-cell.gt-dup-arrow::before { content: none; }
.wj-cell.cell-empty {
    background-color: #f2f5f5;
    color: lightslategray;
}
/* IE 2026 09 05 / ODOO-336330: кодовый дефолт пустого поля формы настроек (attr.placeholder) */
.wj-cell .cell-placeholder {
    color: #98a2b3;
    font-style: italic;
    pointer-events: none;
}
/* IE 2026 10 06 / ODOO-341407 (заказ Игоря п.2): строка перевода формы «… (uk)» со словарным переводом предопределённой записи (meta._i18n_auto) — в записи не сохранён */
.wj-cell.i18n-auto {
    color: #98a2b3;
    font-style: italic;
}
/* IE 2026 10 06 / ODOO-341407 (ревью U9): подпись строки перевода формы «Назва (uk)» — в узкой колонке подписей режется имя поля, язык виден всегда */
.wj-cell .i18n-label { display: inline-flex; max-width: 100%; min-width: 0; vertical-align: top; }
.wj-cell .i18n-label-name { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.wj-cell .i18n-label-lang { flex: none; white-space: pre; }
/* IE 2026 10 06 / ODOO-341407 (проверка round 3: подписи «Попереднє джерело (uk)/(ru)» пустые): в ячейке с переносом (wordWrap колонки подписей —
   white-space: normal) обёртка уходила на вторую строку клипа ячейки и срезалась его overflow — узел подписи без переноса */
.wj-cell:has(> .i18n-label), .wj-cell > .cell-text-clip:has(> .i18n-label) { white-space: nowrap !important; }
/* строка-секция мульти-вертикальной таблицы печати */
.wj-cell.print-section-row {
    background-color: #eef1f6;
    color: #4a5568;
    font-weight: 600;
    border-bottom: 1px solid #d7dce5;
}
/* spill: текст печати поверх пустых ячеек справа (printTextSpill) */
.wj-cell.print-spill {
    overflow: visible !important;
    white-space: nowrap;
    z-index: 1;
}
/* «продолжение» обрезанного титула узкого заголовка / ячейки (ховер): оформление слоя — .clip-overlay в App.vue
   (IE 2026 09 18: фон, цвет и шрифт — самой ячейки, src/utils/clipOverlay.js) */
/* активная кнопка режима склейки мульти-вертикальной таблицы */
button.mvt-mode-on, .mvt-mode-on.p-button {
    background-color: #f6e7b3 !important;
    border-radius: 4px;
}
/* drag ячейки шаблона печати */
.print-cell-ghost {
    position: fixed; z-index: 99999; pointer-events: none;
    background: #fff; border: 1px solid #7a8bd0; border-radius: 3px;
    padding: 2px 8px; font-size: 12px; opacity: .92;
    box-shadow: 0 2px 8px rgba(0,0,0,.25);
}
.wj-cell.print-drag-target {
    outline: 2px dashed #7a8bd0;
    outline-offset: -2px;
}
.wj-grouppanel {
    min-height: 3.5em;
    padding: 5px;
    width:-webkit-fill-available !important;
}
.wj-flexgrid .wj-cell {
    border-right: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    /* padding: 0.35rem 1rem;
    font-size: 0.8125rem; */
}
.wj-flexgrid .wj-cell.wj-cell-maker.wj-radio-map.custom-rating label {
    /* width: .25em; */
    color: green;
}
.wj-flexgrid .wj-cell.wj-cell-maker.wj-radio-map.custom-rating label:after {
    transform: scale(12);
    content: '\2b24';
}
.grid-p1.attr-grid .wj-cell {
    padding: 0px 2px;
}
.grid-p2.attr-grid .wj-cell {
    padding: 1px 2px;
}
.grid-p3.attr-grid .wj-cell {
    padding: 2px 2px;
}
.grid-p4.attr-grid .wj-cell {
    padding: 3px 2px;
}
.grid-p5.attr-grid .wj-cell {
    padding: 4px 2px;
}
.grid-p6.attr-grid .wj-cell {
    padding: 5px 2px;
}
.grid-p7.attr-grid .wj-cell {
    padding: 6px 2px;
}

.attr-grid .cell-title {
    color: #3f51b5;
    padding: 0.35rem 0rem 0.35rem 3rem;
}
.column-actual {
    border-left: medium solid rgba(0, 0, 0, 0.1);
    background: aliceblue;
}
.column-score {
    background: aliceblue;
}
.column-summary {
    background: aliceblue;
}
.column-past {
    background-color: #f2f5f5;
}
.column-lead-time {
    background: aliceblue;
}
.column-replenishment-cycle {
    background: rgb(253 221 156 / 50%);
}
.column-info {
    background-color: #F2F5F5 !important; 
}
.column-raw_object {
    background: aliceblue;
    font-style: italic;
}
.column-fact {
    border-left: medium solid white !important; 
    border-right: medium solid white !important; 
    background: aliceblue !important; 
}
.column-notWork {
    background-color: #F2F5F5; 
}

.measure-forecast {
    background-color: #88bde6; 
    color: white
}
.measure-baseLine {
    background: darkgray;
    color: white;
}
.measure-in {
    background-color: #99CC99; 
    color: white
}
.measure-out {
    background-color: #CC9966; 
    color: white
}


.gantt-container {
    width: 100%;
    height: 30px;
    position: relative;
}
.gantt-bar-gray {
    height: 60%;
    position: absolute;
    border-radius: 5px;
}
/* IE 2026 08 16 / ODOO-4997 (заказ Игоря): Row style 'Cards' на строке колонок
   лэйаута — колонка данных как ЦЕЛЬНАЯ карточка сравнения: светлая заливка,
   рамка по бокам, синяя скруглённая шапка из заголовка (как Highest Score /
   Current norms), пунктирные break-разделители внутри карточек скрыты.
   Фоны условного оформления (inline) остаются поверх заливки. */
.wj-cell.card-col {
    background: #f2f6fc;
}
/* пунктирные разделители (вертикальные break-линии и горизонтальные линии
   групп строк) внутри карточных колонок скрыты — ревью Игоря 16.08 */
.wj-cell.card-col .cell-delivery-left-border,
.wj-cell.card-col .cell-delivery-top-border,
.wj-cell.card-col-head .cell-delivery-left-border,
.wj-cell.card-col-head-top .cell-delivery-left-border {
    display: none;
}
/* ячейки шапки карточных колонок прозрачны — шапку целиком рисует оверлей
   (подпись меры и номер колонки скрыты под ним, «объединение» ячеек) */
.wj-cell.card-col-head.card-col-head.card-col-head,
.wj-cell.card-col-head-top.card-col-head-top.card-col-head-top {
    background: transparent !important;
    color: transparent !important;
    border: none !important;
    box-shadow: none !important;
}
/* рамка карточки — отдельный оверлей с паддингом от ячеек (ревью Игоря):
   в шапке — карточный заголовок со скруглённым верхом, в данных —
   продолжение рамки без верхней грани */
/* слой рамок карточек — над панелями грида, вне их DOM (иначе wijmo
   переиспользует наши div как ячейки) */
.cards-layer,
.cards-layer-frozen { /* IE 2026 10 06 / ODOO-5800: второй слой — карточки внутри замороженных колонок */
    position: absolute;
    inset: 0;
    overflow: hidden;
    pointer-events: none;
    z-index: 5;
}
.card-overlay {
    position: absolute;
    border: 1px solid #c9d2dd;
    pointer-events: none;
}
.card-overlay-head {
    border-bottom: none;
    border-radius: 8px 8px 0 0;
    background: #fff;
    /* текст от ВЕРХА (не центр): низкая шапка с переносом в 3 строки
       показывала средний кусок текста («blenishme») при центрировании */
    display: flex;
    align-items: flex-start;
    justify-content: center;
    text-align: center;
    white-space: normal;
    overflow: hidden;
    overflow-wrap: anywhere;
    padding: 2px 4px;
    font-weight: 600;
    font-size: 0.8em;
    color: #223;
    line-height: 1.2;
    /* поверх ВСЕХ слоёв шапки: sticky-клип рисовал куски старых подписей
       поверх оверлея (ревью Игоря «стало ещё страшнее») */
    z-index: 30;
}
.card-overlay-head.card-overlay-current {
    background: #2f5eaa;
    color: #fff;
}
.card-overlay-body {
    border-top: none;
    /* закрытый низ карточки со скруглением (заказ Игоря 17.08) */
    border-radius: 0 0 8px 8px;
}
/* спил-ячейки (мерженные заголовки вложенных групп), текущие через карточные
   колонки: их пунктирные break-линии в зоне карточек не рисуем */
.wj-cell.card-spill .cell-delivery-left-border,
.wj-cell.card-spill .cell-delivery-top-border {
    display: none;
}
/* серый фон строк-групп внутри карточных колонок ровняем под карточную
   заливку — «обрубки» серых полос между зазорами карточек */
.wj-cell.card-col.wj-group {
    background: #f2f6fc;
}
/* IE 2026 08 16 / ODOO-4997 (заказ Игоря): Hide title — пустая строка подписи
   меры сливается с ячейкой даты выше (границы между ними не рисуем) */
.wj-colheaders .wj-cell.hdr-title-hidden {
    border-top: none !important;
    border-bottom: none !important;
}

.gantt-bar {
    opacity: 0.3;
    transition: all 250ms;
}
/* IE 2026 08 16 / ODOO-4997: гант занятости РЦ — малые интервалы (46min в
   недельной колонке) давали полосу <2px, «интервалов не видно» */
.gantt-bar-busy {
    min-width: 5px;
}
.gantt-bar:hover {
    transform: scale(1.2);
    opacity: 0.7;
}
/* IE 2026 09 22 / ODOO-… (заказ Игоря): полосы-интервалы дат — у нижнего бордюра ячейки, за текстом (цвет текста с малой
   непрозрачностью), ненавязчиво; пара «с / по» — одна линия времени через две ячейки (стык = текущая дата), у продолжения
   в соседнюю ячейку углы не скруглены, открытый конец затухает; одиночная дата — «колонка гистограммы» в точке даты;
   по наведению на строку (.wj-row-hover) полоса чуть выше и заметнее. Геометрию считает AttrGrid.dateBar_paint. */
.wj-cell > .cell-date-bar { position: absolute; left: 0; bottom: 0; height: 3px; display: block; margin: 0; padding: 0; font-size: 0; line-height: 0;
    pointer-events: none; background: currentColor; opacity: .16; border-radius: 2px; transition: height .15s ease, opacity .15s ease; }
.wj-cell > .cell-date-bar.is-cont-r { border-top-right-radius: 0; border-bottom-right-radius: 0; }
.wj-cell > .cell-date-bar.is-cont-l { border-top-left-radius: 0; border-bottom-left-radius: 0; }
.wj-cell > .cell-date-bar.is-open-r { background: linear-gradient(to right, currentColor 55%, transparent); }
.wj-cell > .cell-date-bar.is-open-l { background: linear-gradient(to left, currentColor 55%, transparent); }
.wj-cell > .cell-date-bar.is-tick { height: 5px; opacity: .42; border-radius: 1px 1px 0 0; }
.wj-cell > .cell-date-bar.is-bar { opacity: .12; }
.wj-cell.wj-row-hover > .cell-date-bar { height: 6px; opacity: .3; }
.wj-cell.wj-row-hover > .cell-date-bar.is-tick { height: 9px; opacity: .65; }
.in-bar-gray {
    background-color:gray;
}
.in-bar-green {
    background-color:#4CAF50;
}
.in-bar-blue {
    background-color:blue;
}
.in-bar {
    position: absolute;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
    height: 80%;
    top:20%;
    width:25%;
    left:10%;
    opacity: 0.3;
    transition: all 250ms;
}
.in-bar:hover {
    transform: scale(1.2);
    opacity: 0.7;
}
.first-bar {
    top: 40%;
    width: 10%;
    background-color: blue;
}
.second-bar {
    top: 30%;
    width: 40%;
    left: 15%;
    background-color: yellow;
    background-image: repeating-linear-gradient(
        -45deg,
        rgba(0,0,0,0.3),
        rgba(0,0,0,0.1) 2px,
        transparent 2px,
        transparent 5px
    );
}
.third-bar {
    top: 20%;
    width: 30%;
    left: 60%;
    background-color: green;
}

.cell-border-bottom-grey::before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 1px;
    width: 100%;
    height: 3px; 
    background-color: rgba(0, 0, 0, 0.25);
}
.cell-border-bottom-green::before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 1px;
    width: 100%;
    height: 3px; 
    background-color: rgba(0, 128, 0, 0.25);
}
/* IE 2026 10 01 / ODOO-5800 (сверхнормативная зона): рамка LS 6 (выше порога excess правила) — cssStyle-CONDITIONS-DOS-border-bottom бэка; синих рамок не было */
.cell-border-bottom-blue::before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 1px;
    width: 100%;
    height: 3px;
    background-color: var(--stock-excess-edge, rgba(30, 136, 229, 0.45));
}
/* IE 2026 08 31 / ODOO-5884 (заказ Игоря): ШАПКА колонки заливается цветом серии графика
   Work center load, текст белый — глаз связывает столбик графика с колонкой таблицы.
   Канал cssClass_columnHeader принимает только ИМЯ КЛАССА (произвольный цвет им не задать),
   поэтому три класса заведены здесь. Цвета — из cssStyleChart тех же мер:
   busy #4e79a7, free #9bbf85, overload #e15759; зелёный и красный ФОНА чуть притемнены
   ради контраста с белым текстом (сами серии графика не менялись — легенда сходится). */
/* специфичность обязана перебить `.wj-cell.wj-header-top { background-color:#A3B6BE !important }`
   (два класса) — поэтому селектор из трёх классов */
.wj-cell.wj-header-top.cell-header-busy,
.wj-cell.wj-header-top.cell-header-free,
.wj-cell.wj-header-top.cell-header-overload,
.wj-cell.wj-header.cell-header-busy,
.wj-cell.wj-header.cell-header-free,
.wj-cell.wj-header.cell-header-overload {
    color: #fff !important;
    font-weight: 600;
}
.wj-cell.wj-header-top.cell-header-busy,
.wj-cell.wj-header.cell-header-busy { background-color: #4e79a7 !important; }
.wj-cell.wj-header-top.cell-header-free,
.wj-cell.wj-header.cell-header-free { background-color: #7fa864 !important; }
.wj-cell.wj-header-top.cell-header-overload,
.wj-cell.wj-header.cell-header-overload { background-color: #d3494b !important; }
.cell-border-bottom-yellow::before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 1px;
    width: 100%;
    height: 3px; 
    background-color: rgb(253 221 156 / 80%);
}
.cell-border-bottom-red-after::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 1px;
    width: 100%;
    height: 1px; 
    background-color: rgba(255, 0, 0, 0.3);
}
.cell-border-bottom-red::before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 1px;
    width: 100%;
    height: 3px; 
    background-color: rgba(255, 0, 0, 0.3);
}
.cell-border-bottom-red-fat::before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 1px;
    width: 100%;
    height: 3px; 
    background-color: rgba(255, 0, 0, 0.3);
}
.cell-border-bottom-orange::before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 1px;
    width: 100%;
    height: 3px; 
    background-color: #ffdedebb;
}

.cell-border-right-grey::before {
    content: '';
    position: absolute;
    right: 1px;
    top: 0;
    bottom: 0;
    width: 5px;
    background-color: rgba(0, 0, 0, 0.1);
}
.cell-border-right-grey-cell::before {
    content: '';
    position: absolute;
    right: 1px;
    top: 0;
    bottom: 0;
    width: 1px;
    background-color: rgba(0, 0, 0, 0.1);
}
.cell-border-right-green::before {
    content: '';
    position: absolute;
    right: 1px;
    top: 0;
    bottom: 0;
    width: 5px;
    background-color: rgba(0, 128, 0, 0.15);
}
/* IE 2026 10 01 / ODOO-5800 (сверхнормативная зона): рамка LS 6 — cssStyle-CONDITIONS-DOS-border-right бэка */
.cell-border-right-blue::before {
    content: '';
    position: absolute;
    right: 1px;
    top: 0;
    bottom: 0;
    width: 5px;
    background-color: var(--stock-excess-edge, rgba(30, 136, 229, 0.45));
}
.cell-border-right-yellow::before {
    content: '';
    position: absolute;
    right: 1px;
    top: 0;
    bottom: 0;
    width: 5px;
    background-color: rgb(253 221 156 / 50%);
}
.cell-border-right-red::before {
    content: '';
    position: absolute;
    right: 1px;
    top: 0;
    bottom: 0;
    width: 5px;
    background-color: rgba(255, 0, 0, 0.3);
}
.cell-border-right-red-fat::before {
    content: '';
    position: absolute;
    right: 1px;
    top: 0;
    bottom: 0;
    width: 10px;
    background-color: rgba(255, 0, 0, 0.3);
}
.cell-border-right-orange::before {
    content: '';
    position: absolute;
    right: 1px;
    top: 0;
    bottom: 0;
    width: 5px;
    background-color: #ffdedebb;
}

.cell-background-green {
    background-color: #dfedde !important;
    color: inherit !important;
}
/* IE 2026 09 16 / ODOO-5800 (Igor): категория запаса ok — светло-голубой (max остаётся зелёным) */
/* IE 2026 10 01 / ODOO-5800 (Igor 01.10): синяя шкала сверхнормативного запаса — «холодно = лишнее», а не красное (красный = OOS / непокрыто):
   запас > max — светло-синий фон и тёмно-синий текст; > 2×max (категория excess, метрики stock::excess / stock::excess_lots) — насыщеннее и жирно.
   Именованные стили правил — stock-over-max / stock-excess (CSS-CLASS бэка; до пересева их нет в реестре — ниже тот же стиль по имени класса),
   прежние классы-двойники — cell-background-blue / cell-background-blue-strong */
/* IE 2026 10 01 / ODOO-5800 (Igor 01.10, вслед: сверхнормативная зона в правилах запасов — design-excess-zone-2026-10-01 §3.1): зона max (max…порог excess)
   снова зелёная — stock-max / cell-background-green; синий — только выше порога excess правила: категория excess (LS 6, причина stock::above_excess) —
   stock-excess / cell-background-blue-strong; порог пуст — зоны нет, потолок — зелёная max. stock-over-max правилами категорий больше не используется (стиль
   остаётся в реестре). Цвета сверхнорматива — токены --stock-excess-* (одна точка: заливка, текст, рамки LS 6). Тёмная тема — инверсия всего приложения
   (App.vue: .dark-theme { filter: invert(1) }), отдельных значений у неё нет — как у остальных категорий запаса и у зон графика формы ячейки */
:root {
    --stock-excess-bg: #a0c4ff;
    --stock-excess-fg: #0f2d66;
    --stock-excess-edge: rgba(30, 136, 229, 0.45);
}
.cell-background-blue {
    background-color: #d6e4ff !important;
    color: #1b3f80 !important;
}
.cell-background-blue-strong {
    background-color: var(--stock-excess-bg, #a0c4ff) !important;
    color: var(--stock-excess-fg, #0f2d66) !important;
    font-weight: 700 !important;
}
.wj-cell.cell-info.cell-background-blue,
body[class*="cscheme-style"] .wj-cell.cell-info.cell-background-blue {
    background-color: #d6e4ff !important;
    color: #1b3f80 !important;
}
.wj-cell.cell-info.cell-background-blue-strong,
body[class*="cscheme-style"] .wj-cell.cell-info.cell-background-blue-strong {
    background-color: var(--stock-excess-bg, #a0c4ff) !important;
    color: var(--stock-excess-fg, #0f2d66) !important;
    font-weight: 700 !important;
}
.stock-over-max, .wj-cell.cell-info.stock-over-max,
body[class*="cscheme-style"] .wj-cell.cell-info.stock-over-max {
    background-color: #d6e4ff !important;
    color: #1b3f80 !important;
}
.stock-excess, .wj-cell.cell-info.stock-excess,
body[class*="cscheme-style"] .wj-cell.cell-info.stock-excess {
    background-color: var(--stock-excess-bg, #a0c4ff) !important;
    color: var(--stock-excess-fg, #0f2d66) !important;
    font-weight: 700 !important;
}
.cell-background-yellow {
    background-color: #fff2de !important; 
    color: inherit !important;
}
.cell-background-orange {
    background-color: #ffdede !important; 
    color: inherit !important;
}
/* IE 2026 11 01 / ODOO-349799 (group-colours): заголовок группы колонок с cssClass_columnHeader с бэка (страница Addon records / вкладка Addons:
   группы Addon records / Modified / Local цветами статусов аддона). `.wj-cell.wj-header-top { background-color:#A3B6BE !important }` — два класса,
   одноклассовый .cell-background-* его не перебивает (Demo 6 u35: заголовки серые) — поэтому три класса, как у cell-header-busy выше */
.wj-cell.wj-header-top.cell-background-blue, .wj-cell.wj-header.cell-background-blue { background-color: #d6e4ff !important; color: #1b3f80 !important; }
.wj-cell.wj-header-top.cell-background-orange, .wj-cell.wj-header.cell-background-orange { background-color: #ffdede !important; }
.wj-cell.wj-header-top.cell-background-green, .wj-cell.wj-header.cell-background-green { background-color: #dfedde !important; }
/* IE 2026 09 08 / ODOO-335246 (Igor): строка списка / отчёта, узел которой грязный в каскаде расчётов
   (_DLRow.cssClasses с бэка: row-cascade-dirty) — жёлтая; пробивает тон cell-info / cscheme как cell-background-* */
.wj-cell.row-cascade-dirty,
.wj-cell.cell-info.row-cascade-dirty,
body[class*="cscheme-style"] .wj-cell.row-cascade-dirty,
body[class*="cscheme-style"] .wj-cell.cell-info.row-cascade-dirty {
    background-color: #fff3b0 !important;
    color: inherit !important;
}
.cell-background-red {
    background-color: #ff8a8a !important; 
    color: white !important;
}
/* грейд-раскраска Δ%-ячеек сравнения ОБЯЗАНА пробивать приглушённый тон
   compare/meta-строк: .wj-cell.cell-info и его cscheme-вариант держат фон с
   !important и большей специфичностью — без этих правил -23% оставался серым */
.wj-cell.cell-info.cell-background-yellow,
body[class*="cscheme-style"] .wj-cell.cell-info.cell-background-yellow {
    background-color: #fff2de !important;
    color: inherit !important;
}
.wj-cell.cell-info.cell-background-red,
body[class*="cscheme-style"] .wj-cell.cell-info.cell-background-red {
    background-color: #ff8a8a !important;
    color: white !important;
}
/* IE 2026 10 03 / ODOO-5800 (заказ Игоря: «Показать критич ош если небьется расчетный запас с фактич»): ячейка со строкой метрики оценки critical
   (расхождение расчётного и фактического запаса — причина stock_mismatch) — насыщенный красный, жирный белый текст и жёлтый уголок слева внизу:
   строже и отличимо от bad (cell-background-red, #ff8a8a). Уголок рисуется фоном — псевдоэлементы ячейки заняты бейджами правок / заметок, верхние
   углы — ими же (комментарий, заметка, дельта). Класс ставит AttrGrid (METRIC_CRIT_CLASS: metricFill_cellTasks / cf_compute / metricCell_list).
   Имя класса повторено: вид критической ошибки обязан пробивать и приглушённый тон .wj-cell.cell-info (варианты по гаммам), и именованные стили
   реестра CSS-CLASS (.wj-cell.<имя>×4, с гаммой — 0,6,1; вне сетки .<имя>×2, с гаммой — 0,3,1; их <style> стоит в конце <head>). Первый селектор —
   образец вне сетки (чипсы и превью блока METRICS формы ячейки). Выключатель fe.cellForm.stockMismatchCritical (выкл — класс не ставится) */
.cell-metric-critical.cell-metric-critical.cell-metric-critical.cell-metric-critical,
.wj-cell.cell-metric-critical.cell-metric-critical.cell-metric-critical.cell-metric-critical.cell-metric-critical.cell-metric-critical {
    background-color: #b91c1c !important;
    background-image: linear-gradient(45deg, #ffd54f 0, #ffd54f 6px, transparent 6px) !important;
    background-repeat: no-repeat !important;
    color: #fff !important;
    font-weight: 700 !important;
}
/* Непрозрачный тон, как у остальных cell-background-*: полупрозрачный rgba
   складывался слоями на переиспользованных DOM-ячейках при прокрутке (грид
   применяет классы поверх кэша) — строки «темнели» полосами. */
.cell-background-grey {
    background-color: #e6e8ea !important;
    color: #55636b !important;
}
.wj-cell.cell-info.cell-background-grey,
body[class*="cscheme-style"] .wj-cell.cell-info.cell-background-grey {
    background-color: #e6e8ea !important;
    color: #55636b !important;
}
/* IE 2026 11 03 / ODOO-350610 (status colors): тёмно-серый — отменённые / аннулированные статусы (STATUS-plan cancel / cancelled), отличим от серого черновика */
.cell-background-grey-dark,
.wj-cell.cell-info.cell-background-grey-dark,
body[class*="cscheme-style"] .wj-cell.cell-info.cell-background-grey-dark {
    background-color: #c9ced3 !important;
    color: #363e44 !important;
}

/* AttrLinkChips: статус как скруглённая пилюля (стиль как в Odoo).
   Фон задаёт cssClass элемента справочника (.cell-background-* с !important);
   без cssClass — нейтральный серый чипс. */
.status-chip {
    display: inline-block;
    max-width: 100%;
    height: 16px;
    padding: 0 9px;
    border-radius: 8px;
    font-size: 12px;
    line-height: 16px;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
    background-color: #eceff1;
    color: #55636b;
    /* сжимаем пилюлю до 90% (как мини-ячейка Preview): воздух сверху/снизу,
       соседние чипсы по вертикали не слипаются */
    transform: scale(0.9);
}
/* центрируем пилюлю по высоте строки: чипс ниже строки → соседние не слипаются */
.wj-cell.has-status-chip {
    display: flex;
    align-items: center;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}

/* Согласованная палитра ФОНА чипсов (только .status-chip, не трогает условную
   подсветку ячеек .cell-background-*). Единый мягкий пастельный тон + читаемый
   цветной текст в тон hue (Odoo-стиль). Семантика цветов сохранена:
   green=успех, yellow=внимание/прервано, orange=ошибка-мягкая, red=критично. */
.status-chip.cell-background-green {
    background-color: #dcefe0 !important;
    color: #2f6b3a !important;
}
.status-chip.cell-background-blue {
    background-color: #dbe8f8 !important;
    color: #2b5b8c !important;
}
/* IE 2026 10 01 / ODOO-5800: пилюля насыщенного синего (сверхнорматив > 2×max) */
.status-chip.cell-background-blue-strong, .status-chip.stock-excess {
    background-color: #b9d4ff !important;
    color: #1b3f80 !important;
}
.status-chip.cell-background-yellow {
    background-color: #fbeecb !important;
    color: #7a5b12 !important;
}
.status-chip.cell-background-orange {
    background-color: #fbe0d0 !important;
    color: #8a4b1e !important;
}
.status-chip.cell-background-red {
    background-color: #f8d5d8 !important;
    color: #8a2a30 !important;
}
.status-chip.cell-background-grey {
    background-color: #e6e8ea !important;
    color: #55636b !important;
}
.status-chip.cell-background-grey-dark {   /* IE 2026 11 03 / ODOO-350610 (status colors) */
    background-color: #c9ced3 !important;
    color: #363e44 !important;
}

.cell-color-green {
    color: #dfedde !important;
}
.cell-color-yellow {
    color: #fff2de !important; 
}
.cell-color-orange {
    color: #ffdede !important; 
}
.cell-color-red {
    color: #ff8a8a !important; 
}
.cell-color-grey {
    color: rgba(0, 0, 0, 0.1) !important; 
}

.cell-transform::before {
    transition: all 250ms;
}
.cell-transform:hover::before {
    transform: scale(1.5);
}

/* IE 2026 09 12 / ODOO-… (заказ Игоря): приближённое совпадение поиска (опечатки) — особая подсветка, отличимая от точной */
.wj-state-match-fuzzy { background: #fde68a; border-bottom: 1px dashed #b45309; border-radius: 2px; }
/* IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок): текущая остановка ‹ › чипса поиска в ШАПКЕ (ячейку шапки выбрать нельзя — рамка в тон выделения вместо выбора) */
.wj-colheaders .wj-cell.wj-state-match-cur { box-shadow: inset 0 0 0 2px #2563eb; }
/* IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки): текущая остановка ‹ › по номеру строки — рамка на номере в заголовке строки */
.wj-rowheaders .wj-cell.wj-state-match-cur { box-shadow: inset 0 0 0 2px #2563eb; }   /* IE 2026 10 24 / ODOO-348831 */
/* IE 2026 09 25 / ODOO-… (замечание Игоря: поиск в таблице по названиям на других языках): ячейка-ссылка, найденная по названию записи на другом языке — показанный текст не совпал, подсвечивать в нём нечего:
   пунктирная рамка и лёгкий фон тона приближённого совпадения; фон — слоем поверх заливки правил (background-image, не background-color) */
.wj-cell.search-alt-hit { outline: 1px dashed #b45309; outline-offset: -2px; background-image: linear-gradient(rgba(253, 230, 138, .45), rgba(253, 230, 138, .45)); }
.chart-zone-selected {
    fill: transparent;
    opacity: .9;
    stroke: rgba(255, 150, 30, 0.75);
    stroke-width: 3px;
}
.red-zone {
    fill: #ff8a8a;
    stroke-width: 1;
}
.orange-zone {
    fill: red;
    opacity: .15;
    stroke-width: 0;
}
.yellow-zone {
    fill: orange;
    opacity: .15;
    stroke-width: 0;
}
.green-zone {
    fill: green;
    opacity: .15;
    stroke-width: 0;
}
.aliceblue-zone {
    fill: aliceblue;
    /* opacity: .15; */
    stroke-width: 0;
}

.wj-cell.wj-header {
    color: #A3B6BE;
    border-right: 1px solid rgba(0, 0, 0, 0.1);
    /*font-stretch: ultra-condensed;*/
    accent-color: #eeeeee;
}
.merged-rows {
    white-space: normal;
    overflow-wrap: anywhere;
    flex-direction: column;
    justify-content: flex-start !important;
}
/* IE 2026 09 04 / ODOO-336283 (заказ Игоря): заголовок группы колонок, объединённый по строкам шапки
   (flex-direction: column), — горизонталь задаёт align-items: при wj-align-left прижимаем влево,
   как у групп в одну строку («Grid style» ≡ «Chart style») */
.wj-flexgrid .wj-colheaders .wj-cell.wj-header.merged-rows.wj-align-left {
    align-items: flex-start;
}
/* IE 2026 10 25 / ODOO-348925 (заказ Игоря: заголовок группы колонок по align): группа с align right, объединённая по строкам шапки (flex-direction: column) — горизонталь задаёт align-items */
.wj-flexgrid .wj-colheaders .wj-cell.wj-header.merged-rows.cg-hdr-al.wj-align-right {   /* IE 2026 10 25 / ODOO-348925 (заказ Игоря: заголовок группы колонок по align) */
    align-items: flex-end;   /* IE 2026 10 25 / ODOO-348925 (заказ Игоря: заголовок группы колонок по align) */
}   /* IE 2026 10 25 / ODOO-348925 (заказ Игоря: заголовок группы колонок по align) */
.wj-cell.wj-header.wj-state-multi-selected {
    color: var(--cs-accent, #647eff);
    background: white;
}
.wj-cell.wj-header-top {
    background-color: #A3B6BE !important;
	color: white;
    font-size: 0.875rem;
    font-weight: normal;
    border-right: 1px solid rgba(255, 255, 255, 0.5);
    border-bottom: 1px solid rgba(255, 255, 255, 0.5);
}
.wj-cell.wj-header-top.wj-state-multi-selected {
    color: white;
}

/* ==== Цветовые гаммы: оформление заголовков таблиц ==========================
   5 схем из COLOR_SCHEMES (mainStore.js). Класс на body: cscheme-<id>.
   Здесь — только ЗАГОЛОВКИ таблиц (шапки колонок и строк). Оформление топбара и
   фона страницы — в глобальном <style> App.vue (по классу body.cscheme-<id>).
   'classic' переопределений не имеет (дефолтный вид) и здесь отсутствует.

   !important обязателен — базовые правила шапки тоже с !important; селектор с
   body строго специфичнее, поэтому при равном !important побеждает гамма.
   Сознательно НЕ трогаем ни в одной схеме: рыжую индикацию выделения
   (.wj-state-multi-selected, .wj-marquee*), условное оформление (.cell-background-*,
   .cell-border-right-*, .cell-transform), чипсы (.chip-hidden, .status-chip). Поэтому
   бордеры/фон шапки идут через :not(.wj-state-multi-selected), а фон отдельных
   колонок — через :not(.header-*):not(.cell-background-header), чтобы сохранить
   смысловую подсветку колонок (past, lead-time и т.п.). */

/* Единый источник цветов — переменные --cs-* в App.vue (body.cscheme-<id>).
   Здесь один набор правил на var(--cs-*), общий для всех гамм (кроме classic).
   Текст-шапки: у светлых схем он тёмный, у тёмных (Kinaxis) — светлый; это несёт
   переменная --cs-header-fg, поэтому отдельные блоки на схему больше не нужны.

   !important обязателен — базовые правила шапки тоже с !important; селектор с
   body строго специфичнее, поэтому при равном !important побеждает гамма.
   Сознательно НЕ трогаем: рыжую индикацию выделения (.wj-state-multi-selected,
   .wj-marquee*), условное оформление (.cell-background-*, .cell-border-right-*,
   .cell-transform), чипсы. Поэтому фон/бордеры шапки идут через
   :not(.wj-state-multi-selected), а фон колонок — через :not(.header-*), чтобы
   сохранить смысловую подсветку колонок (past, lead-time и т.п.). */

/* текст шапки (тёмный/светлый — по --cs-header-fg) */
body[class*="cscheme-style"] .wj-cell.wj-header:not(.wj-state-multi-selected),
body[class*="cscheme-style"] .wj-cell.wj-header-top:not(.wj-state-multi-selected) {
    color: var(--cs-header-fg) !important;
    font-weight: 600;
}
/* выделенная колонка верхней шапки: базовое color:white читалось бы не на всех фонах */
body[class*="cscheme-style"] .wj-cell.wj-header-top.wj-state-multi-selected {
    color: var(--cs-header-fg) !important;
}
/* фон шапки */
body[class*="cscheme-style"] .wj-cell.wj-header {
    background-color: var(--cs-header-bg);
}
/* :not(...) сохраняет смысловую подсветку отдельных колонок */
body[class*="cscheme-style"] .wj-cell.wj-header-top:not(.header-replenishment-cycle):not(.header-lead-time):not(.header-past):not(.header-quantity):not(.header-summary):not(.header-raw_object):not(.header-green):not(.header-blue):not(.header-red):not(.cell-background-header) {
    background-color: var(--cs-header-bg) !important;
    color: var(--cs-header-fg) !important;
}
/* разделители внутри шапки */
body[class*="cscheme-style"] .wj-cell.wj-header:not(.wj-state-multi-selected),
body[class*="cscheme-style"] .wj-header-row:not(.wj-state-multi-selected) {
    border-right: 1px solid var(--cs-header-border) !important;
    border-bottom: 1px solid var(--cs-header-border) !important;
}
/* линия-акцент под шапкой */
body[class*="cscheme-style"] .wj-header-number-row:not(.wj-state-multi-selected) {
    border-right: 1px solid var(--cs-header-border) !important;
    border-bottom: 2px solid var(--cs-header-accent) !important;
}
body[class*="cscheme-style"] .wj-flexgrid .wj-colheaders {
    border-bottom: 2px solid var(--cs-header-accent);
}
/* линия начала таблицы — на ячейках верхнего ряда (класс cs-topline из formatItem)
   и над угловой панелью; НЕ на контейнере .wj-colheaders — иначе тянулась через
   пустой break-gap серым сегментом и обрывалась в верхнем левом углу */
body[class*="cscheme-style"] .wj-flexgrid .wj-colheaders .cs-topline,
body[class*="cscheme-style"] .wj-flexgrid .wj-topleft {
    border-top: 1px solid var(--cs-header-border);
}
/* узкий заголовок колонки: видно начало текста, а не «серединку» */
.wj-flexgrid .wj-colheaders .wj-cell.hdr-clip-start {
    text-align: left !important;
    text-overflow: ellipsis;
}
/* края break-зазора в шапке: без смежных бордюров (как у полос мульти-таблицы);
   !important — базовые правила number-row (border-right: white !important) и
   схемные (var(--cs-header-border) !important) иначе перебивают */
.wj-flexgrid .wj-colheaders .wj-cell.cs-break-prev {
    border-right-color: transparent !important;
}
/* а правый блок после разрыва закрываем слева собственным бордюром */
.wj-flexgrid .wj-colheaders .wj-cell.cs-break-right {
    border-left: 1px solid var(--cs-header-border, #e0e0e0) !important;
}
/* маска зазора break_before в шапке: перекрывает topline/фон объединённых
   ячеек верхнего ряда, «висевших» над разрывом (см. set_breakGapMasks) */
.wj-colheaders .break-gap-mask {
    position: absolute;
    top: 0;
    /* высота инлайном из set_breakGapMasks (bottom:0 в панели схлопывался);
       фон = фон виджета (белый), как у зазора в области данных */
    background-color: #ffffff;   /* IE 2026 09 30 / ODOO-343343: не shorthand — иначе сбрасывает штрихи капсулы (.ps-cap) */
    z-index: 3;
    pointer-events: none;
}
.wj-colheaders .break-gap-mask.break-gap-plan { background-color: var(--plan-start-ground, #fff); }   /* IE 2026 10 02 / ODOO-343343 (заказ Игоря: фон белый, штриховка и флаг — цветом бордюра): подложка маски капсулы — токен --plan-start-ground (сейчас белый во всех гаммах), единая точка переключения */
/* IE 2026 09 12 / ODOO-… (замечание Игоря): маска зазора едет вместе с прокруткой и ложилась ПОВЕРХ замороженных ячеек
   шапки (у wijmo они с инлайновым z-index 1, у маски 3) — белая полоса закрывала «Supplier code». Замороженные ячейки
   шапки — выше масок; !important — из-за инлайнового z-index wijmo */
.wj-flexgrid .wj-colheaders .wj-cell.wj-frozen-col,
.wj-flexgrid .wj-colheaders .wj-cell.wj-frozen-col-left,
.wj-flexgrid .wj-colheaders .wj-cell.wj-frozen { z-index: 4 !important; }
/* верхний левый угол: пустые ячейки угловой панели не рисуют горизонтальных
   линий — их ряды не совпадают по высоте с рядами шапки колонок и слева от
   номерного ряда виден «перелом» линии */
body[class*="cscheme-style"] .wj-flexgrid .wj-topleft .wj-cell:not(.wj-header-number-row) {
    border-bottom-color: transparent !important;
}
/* при этом сплошные разделители на самой угловой панели: вертикаль слева от
   «1» (правый край) и линия-акцент над номерами строк (низ, в тон шапке) */
body[class*="cscheme-style"] .wj-flexgrid .wj-topleft {
    border-right: 1px solid var(--cs-header-border);
    border-bottom: 2px solid var(--cs-header-accent);
}
/* уголки бордюра таблицы: ПРЯМЫЕ, без штрихов-дуг (убраны по ревью) — верхнюю
   линию рисуют только ячейки (cs-topline) и угловая панель; контейнер грида
   в схемах не скругляет верх (фон шапки обрезался полукругом) */
body[class*="cscheme-style"] .attr-grid {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
/* приглушённая сетка данных + мягкая зебра */
body[class*="cscheme-style"] .wj-flexgrid .wj-cells .wj-cell {
    border-bottom-color: var(--cs-cell-border);
}
body[class*="cscheme-style"] .wj-flexgrid .wj-cells .wj-cell.wj-alt {
    background-color: var(--cs-zebra-bg);
}
/* групп-строки — согласованы по всем схемам */
body[class*="cscheme-style"] .grid-group1-row {
    background-color: var(--cs-group1-bg);
}
body[class*="cscheme-style"] .grid-group2-row {
    background-color: var(--cs-group2-bg);
    color: var(--cs-group2-fg);
}
/* мягкие границы виджета и групп-панели */
body[class*="cscheme-style"] .wj-flexgrid {
    border-color: var(--cs-grid-border);
}
body[class*="cscheme-style"] .wj-grouppanel {
    border-color: var(--cs-grid-border);
}
/* ==== /Цветовые гаммы ======================================================= */

.wj-cell.header-replenishment-cycle {
    color: lightslategray !important;
    background: rgb(253 221 156 / 50%) !important;
}
.wj-cell.header-lead-time {
    color: lightslategray !important;
    background: aliceblue !important;
}
.wj-cell.header-past {
    color: lightslategray !important;
    background-color: #f2f5f5 !important;
}
.wj-cell.header-quantity {
    color: lightslategray !important;
    background: white !important; 
}
.wj-cell.header-summary {
    color: lightslategray !important;
    background: aliceblue !important;
}
.wj-cell.header-raw_object {
    color: lightslategray !important;
    background: aliceblue !important;
}
.wj-cell.header-green {
    background: seagreen !important;
}
.wj-cell.header-blue {
    background: cadetblue !important;
}
.wj-cell.header-red {
    background: #ff8a8a !important;
}

.wj-flexgrid .wj-colheaders .wj-header.wj-state-multi-selected {
    border-bottom: 3px solid rgba(255,150,30,.75);
}
.wj-flexgrid .wj-rowheaders .wj-header.wj-state-multi-selected {
    border-right: 3px solid rgba(255,150,30,.75);
}
.wj-cells .wj-cell.wj-state-multi-selected {
    /* задача 19: выделение НЕ перекрашивает ячейки — пользовательские классы/стили
       (CF, hsl и т.п.) остаются видимыми; индикация выделения — рыжая рамка marquee */
    background-color: inherit;
    color: inherit;
}
/* IE 2026 08 19 / ODOO-5512 (заказ Игоря): нейтрализатор выше имеет
   специфичность 0,3,0 (обязан перебить тему Wijmo .wj-cells .wj-cell.wj-state-
   multi-selected) и потому гасил классовое оформление 0,2,0 без !important —
   в M03 внутри выделенного диапазона пропадал персиковый фон .editable из
   пользовательского кода. Формат ячеек внутри выделения меняться НЕ должен —
   возвращаем классовые фон/цвет той же специфичностью (0,4,0); CF-краски
   cell-background-* с !important по-прежнему старше */
.wj-cells .wj-cell.wj-state-multi-selected.editable { background-color: #FFEAD4; }
.wj-cells .wj-cell.wj-state-multi-selected.color-red { color: red; }
.attrs-tab-grid-old .wj-cells .wj-cell.wj-state-multi-selected {
    background: inherit;
    color: inherit;
}
/* frozen-часть: фон выделения inherit делает ячейки ПРОЗРАЧНЫМИ — при
   горизонтальной прокрутке сквозь выделение просвечивали проезжающие
   scrollable-ячейки. Frozen обязан оставаться непрозрачным; CF-краски
   (cell-background-*) не перебиваем */
.wj-cells .wj-cell.wj-frozen.wj-state-multi-selected:not([class*="cell-background"]) {
    background-color: var(--surface-card, #fff);
}
/* IE 2026 10 08 / ODOO-5800 (Igor 08.10: «заполнять пропуски прямоугольником с белым фоном»): непрозрачная подложка клона замороженных колонок —
   зазоры между ячейками клона (секции, колонки, растянутые строки) больше не показывают то, что лежит под клоном. Размер — frozenFill_sync */
.wj-frozen-clone.fz-fill::before {   /* IE 2026 10 08 / ODOO-5800 */
    content: '';   /* IE 2026 10 08 / ODOO-5800 */
    position: absolute;   /* IE 2026 10 08 / ODOO-5800 */
    left: 0;   /* IE 2026 10 08 / ODOO-5800 */
    top: 0;   /* IE 2026 10 08 / ODOO-5800 */
    width: var(--fz-fill-w, 0);   /* IE 2026 10 08 / ODOO-5800 */
    height: var(--fz-fill-h, 0);   /* IE 2026 10 08 / ODOO-5800 */
    background-color: var(--surface-card, #fff);   /* IE 2026 10 08 / ODOO-5800: фон ячеек грида (.wj-cell в AppTopbar.vue), меняется с темой */
    pointer-events: none;   /* IE 2026 10 08 / ODOO-5800 */
    z-index: 1;   /* IE 2026 10 08 / ODOO-5800: ячейки .wj-frozen несут инлайн z-index 1 (wijmo) — тот же слой; порядок в дереве: основные экземпляры (раньше) под подложкой, ячейки клона (позже) над ней */
}   /* IE 2026 10 08 / ODOO-5800 */

/* wj-flexgrid .wj-colheaders .wj-header.wj-colgroup.wj-align-center {
    justify-content: unset;
}
.wj-flexgrid .wj-colheaders .wj-header.wj-colgroup.wj-align-right {
    justify-content: unset;
}*/
/* .wj-cell.wj-group:not(.wj-state-selected):not(.wj-state-multi-selected) {
    background-color: white;
} */

.plan-group-1 {
    color: white !important; 
    background-color: #C0CCCC !important; 
    font-weight: bold !important;
}
.plan-group-col-border-1 {
    border-left: thick solid #CCCCCC;
}
.cell-quantity {
    background-color: #f2f5f5 !important;
    color: lightslategray !important;
}
.cell-merge0 {
    border-bottom-color: white !important;
}
.cell-merge1 {
    background: white !important;
    color: white !important;
    border-bottom-color: white !important;
}
.wj-cell.cell-info {
    background-color: #eeeeee !important;
    color: lightslategray !important;
}
.wj-cell.cell-info-2 {
    color: #77889980 !important;
}
/* compare-строки (≡ prev / Δ / Δ%) — приглушённый тон как cell-info;
   грейд-раскраска Δ%-ячеек (cell-background-*) идёт inline-классами поверх */
.wj-cell.row-compare {
    background-color: #eeeeee;
    color: lightslategray !important;
}
/* заголовок compare-строки в rowHeaders (колонка Type) */
.wj-cell.row-compare-header {
    background-color: #eeeeee !important;
    color: #778899 !important;
    font-weight: 600;
    font-size: smaller;
}
/* IE 2026 10 30 / ODOO-5800 (compare: prev-only ghost rows): строка есть только в сравниваемой модели — приглушённый тон; под-строки сравнения (row-compare) и
   бейдж отклонения (cmp-cell-badge) остаются как есть. Ячейку названия отличить от остальных нечем — зачёркивания нет */
.wj-cell.row-compare-prev-only:not(.row-compare) {   /* IE 2026 10 30 / ODOO-5800 (compare: prev-only ghost rows) */
    color: #6b7280 !important;   /* IE 2026 10 30 / ODOO-5800 (compare: prev-only ghost rows) */
    font-style: italic;   /* IE 2026 10 30 / ODOO-5800 (compare: prev-only ghost rows) */
}   /* IE 2026 10 30 / ODOO-5800 (compare: prev-only ghost rows) */
/* IE 2026 10 30 / ODOO-5800 (compare: ghost cell shows prev value): значение сравниваемой модели в пустой ячейке призрака — зачёркнуто, чтобы не читалось текущим */
.wj-cell.row-compare-prev-only .cmp-prev-only-value {   /* IE 2026 10 30 / ODOO-5800 (compare: ghost cell shows prev value) */
    text-decoration: line-through;   /* IE 2026 10 30 / ODOO-5800 (compare: ghost cell shows prev value) */
    text-decoration-color: rgba(107, 114, 128, .55);   /* IE 2026 10 30 / ODOO-5800 (compare: ghost cell shows prev value) */
}   /* IE 2026 10 30 / ODOO-5800 (compare: ghost cell shows prev value) */
/* АН 2026 08 08 / #54: итоговая строка (Totals) */
.wj-cell.row-totals {
    font-weight: 600;
}
/* IE 2026 09 23 / ODOO-5800: memo-строка отчёта («· of which uncovered / expired») — курсив, приглушённый текст,
   без заливки alert-строки (alert_isRow её не красит); фон ячейки от условного оформления остаётся */
.wj-cell.row-dl-memo {
    font-style: italic;
    color: #6b7280 !important;
}
/* IE 2026 09 03 / ODOO-336283: полосы-заголовки строк лэйаута (AttrTab / AttrTabRow)
   и колонка-группа (AttrTabCol); Style строки лэйаута (inline) перекрывает */
/* IE 2026 11 02 / ODOO-350449 (заказ Игоря: p205 заголовки рядків блоку «Непокрито» без червоної заливки — менше сигналів): текст полосы-заголовка блока «Непокрито» — бордовый (полоса остаётся) */
.wj-cell.row-dl-tab.unc-block-title {
    color: #8b1e2d !important;
}
.wj-cell.row-dl-tab {
    font-weight: 600;
    /* IE 2026 09 04 / ODOO-336283 (заказ Игоря): класс даёт только нейтральный фон; вид полосы задаёт
       поле Style строки лэйаута (inline; бэк подставляет дефолт «зелёная нижняя половина», если пусто) */
    background-color: #f1f5f9;
}
/* IE 2026 09 19 / ODOO-336283 (замечание Игоря: «нестыковка цветовых полос на стыке фиксированных колонок и колонок
   с данными»): градиент полосы («нижние 50 %») отсчитывался от padding-box, а он разной высоты по обе стороны границы
   замороженной области — у ячейки дерева нижняя граница снята inline (линию рисует оверлей .border-bottom), у ячейки
   данных она 1px: переход цвета вставал на 0,5px (1 физический пиксель Retina) выше, а под самой границей шёл уже
   ПОВТОР градиента — его прозрачный верх, светлая линия вместо затемнённой полосы. От border-box обе половины строки
   считают одинаково. Класс band-* — полоса с именованным стилем на строке без row_type tab */
.wj-cell.row-dl-tab,
.wj-cell[class*=" band-"] {
    background-origin: border-box !important;
}
.wj-cell.row-dl-tabcol {
    font-weight: 600;
    background-color: #f1f5f9;
}
/* IE 2026 09 17 (замечание Игоря): ручка ширины колонки-группы шапки строк — курсор на правом крае её ячеек */
.wj-flexgrid.rh-col-resize, .wj-flexgrid.rh-col-resize .wj-cell { cursor: col-resize !important; }
/* IE 2026 09 05 / ODOO-336283 (заказ Игоря): титул группы AttrTabHeader в панели заголовков строк */
.wj-rowheaders .wj-cell.row-dl-tabhdr {
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: normal;
    text-align: center;
}
.wj-cell.cell-grid {
    filter: none;
    border-top: 2px solid rgba(0, 0, 0, 0.5);
    border-bottom: none;
}
.wj-cell.cell-grid-node {
    filter: none;
    border-bottom: none;
}
.wj-cell.cell-analysis {
    background-color: #fef6d5 !important;
    color: lightslategray !important;
}
.wj-cell.cell-set {
    background-color: rgba(34, 197, 94, 0.1) !important;
}
.wj-cell.cell-comment {
    background: linear-gradient(225deg, rgba(245, 158, 11, 0.75) 6px, transparent 6px) top right / 7px 7px no-repeat;
}
.wj-cell.cell-lt {
    /* lead time: был aliceblue — почти неотличим от белого; голубой в тон
       cell-rc (янтарному), холодный оттенок отделяет lead time от repl. cycle.
       !important — иначе нейтрализация фона выделения (.wj-state-multi-selected,
       специфичность 0,3,0) гасила классовый фон внутри выделенной области (з.19) */
    background: rgba(59, 130, 246, 0.28) !important;
}
.wj-cell.cell-rc {
    font-weight: bolder;
    background: rgba(245, 158, 11, 0.75) !important;
}
/* IE 2026 09 25 / ODOO-5800 (D1): оценка автоплана превью симуляции — виртуальный документ (не сохраняется): пунктирная рамка, курсив */
.wj-cell.cell-sim-virtual {
    box-shadow: inset 0 0 0 1px rgba(30, 99, 201, 0.85);
    font-style: italic;
}
.wj-cell.cell-header {
    font-weight: bold;
    background-color: #c9d4d8 !important;
}
.wj-cell.wj-row2-header {
    background-color: white !important;
}
.wj-cell.wj-row2-top {
    border-top: 1px double #CCCCCC !important;
    border-bottom: none !important;
}
.wj-cell.wj-row2 {
    border-bottom: none !important;
}
.wj-cell.wj-row2-foot {
    border-bottom: 1px double #CCCCCC !important;
}

.group-row-level-2-start {
    color: black;
}
.group-row-level-1-start {
    color: black;
}
.group-row-level-0-start {
    font-weight: bold;
    color: black;
}
.group-row-level-0 {
    /*border-bottom: 4px double rgba(0, 0, 0, 0.5) !important;*/
    font-weight: bold !important;
    filter: brightness(88%);
}
.group-row-level-1 {
    /*border-bottom: 2px solid rgba(0, 0, 0, 0.5) !important;*/
    font-weight: bold !important;
    filter: brightness(94%);
}
.group-row-level-2 {
    /*border-bottom: 1px solid rgba(0, 0, 0, 0.5) !important;*/
    font-weight: bold !important;
    filter: brightness(98%);
}
/* // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p206 рядок Data Layout без оформлення рівня — білий фон у розкритого рядка об'єкта, опція): раскрытая строка-группа без оформления уровня — белый фон, как у свёрнутой (жирность остаётся) */
.wj-cell.row-plain-level[class*="group-row-level-"] { filter: none !important; }
/* (живой промер dev02 -106: после снятия фильтра ячейки строки объекта оставались #f2f5f5 — класс пустой строки cell-empty, строка без итогов
   пуста по построению; у строки без оформления уровня — фон карточки, белый) */
.wj-cells .wj-cell.row-plain-level.cell-empty:not(.wj-state-selected):not(.wj-state-multi-selected) { background-color: var(--surface-card, #fff); }
/* IE 2026 11 02 / ODOO-349799 (group-levels): строки-группы сгруппированного списка (wijmo GroupRow) по уровню — нулевой темнее и жирнее, первый и глубже светлее;
   фон уровня (grp-level-bg-N) ставится только без своей заливки (правило cssClass / именованный стиль / cell-background-* / hslGroup), см.
   utils/gridGroupLevels.groupLevelClass; полупрозрачный серый — работает и на цветовых схемах; выделение wijmo главнее. Направляющие слева —
   те же классы, что у дерева (cell-frame-left / cell-divider-left ниже), отступ текста — treeIndent wijmo */
.wj-cells .wj-cell.grp-level-bg-0:not(.wj-state-selected):not(.wj-state-multi-selected) { background-color: rgba(60, 72, 90, .17); }
.wj-cells .wj-cell.grp-level-bg-1:not(.wj-state-selected):not(.wj-state-multi-selected) { background-color: rgba(60, 72, 90, .08); }
.wj-cells .wj-cell.grp-level-bg-2:not(.wj-state-selected):not(.wj-state-multi-selected) { background-color: rgba(60, 72, 90, .04); }
.wj-cells .wj-cell.grp-level-0 { font-weight: 700; }
.wj-cells .wj-cell.grp-level-1, .wj-cells .wj-cell.grp-level-2 { font-weight: 500; }
/* IE 2026 11 02 / ODOO-349799 (group-collapsed): свёрнутая группа — grp-level-collapsed без grp-level-N / grp-level-bg-N (как свёрнутый узел дерева без group-row-level-N) */
.wj-cells .wj-cell.grp-level-collapsed { font-weight: inherit; }
/* IE 2026 11 02 / ODOO-349799 (group-collapsed): фон свёрнутой группы — как у строки данных (дерево REPORT2 снимает wj-group у свёрнутого узла: removeClass(e_cell, 'wj-group');
   у ячейки данных wijmo `.wj-flexgrid .wj-cell { background: inherit; color: inherit }`). Зебра (wj-alt), карточные колонки (card-col, своя заливка) и выделение wijmo не трогаем; иконка / отступ / направляющие — не затронуты */
/* IE 2026 11 02 / ODOO-349799 (group-collapsed): у ячейки свёрнутой группы formatItem снимает wj-group (класс: wj-cell cell-empty grp-level grp-level-collapsed), поэтому селектор без .wj-group;
   серый фон давало `.wj-cell.cell-empty { background-color: #f2f5f5 }` (специфичность 0,2,0) — новое правило (0,3,0 + :not) его перебивает */
.wj-flexgrid .wj-cells .wj-cell.grp-level-collapsed:not(.wj-alt):not(.card-col):not(.wj-state-selected):not(.wj-state-multi-selected) { background: inherit; color: inherit; }
.wj-cell > i.grp-guides { position: static; }
/* IE 2026 11 03 / ODOO-350449 (group row pill) (замечание Игоря, скрины Segments / «Конфігурація» / REPORT2): раскрытая строка-группа — закруглённая плашка
   на всю строку (i.grp-pill-band в каждой видимой ячейке; начало — у треугольника своего уровня, конец — у последней видимой колонки), под содержимым
   (z-index -1 в своём контексте ячейки); фон уровня ячейкой (grp-level-bg-N) и filter: brightness() узла дерева (group-row-level-N) снимаются — маска
   слева (cell-delivery-left-0) больше не темнеет и не наезжает на линии родителя. Классы ставит AttrGrid.groupPill_after (fe.ux.groupRowPill, выкл — прежний вид).
   Тёмная тема — общий invert(1) приложения: отдельных значений не нужно */
.grp-pill-on { --grid-tree-line: rgba(119, 136, 153, .4); }   /* цвет треугольника: color ячейки (slate) × opacity .4 кнопки wj-btn-glyph */
.grp-pill-on .wj-cells .cell-frame-left, .grp-pill-on .wj-cells .cell-frame-corner, .grp-pill-on .wj-cells .cell-frame-bottom { border-color: var(--grid-tree-line); }
.wj-cells .wj-cell.grp-pill { z-index: 0; }
.wj-cells .wj-cell.grp-pill > i.grp-pill-band { position: absolute; top: 1px; bottom: 1px; left: 0; right: 0; z-index: -1; pointer-events: none; background: var(--grp-pill-bg, rgba(60, 72, 90, .05)); }
.wj-cells .wj-cell.grp-pill.grp-pill-start > i.grp-pill-band { border-top-left-radius: 3.5px; border-bottom-left-radius: 3.5px; }   /* IE 2026 11 03 / ODOO-350449 (заказ Игоря: мягче радиус, линия без ступеньки, фон по всей строке): радиус вдвое мягче (был 7px — почти полукруг на строке 17 px) */
/* IE 2026 11 03 / ODOO-350449 (заказ Игоря: мягче радиус, линия без ступеньки, фон по всей строке) (скрины 374 / 378): замер dev02 fe-2026-11-03-198 — 1) ячейки данных строки-группы несут border-bottom 1px rgba(0,0,0,.1), ячейка дерева — 0:
   плашка (bottom: 1px от padding-box) кончалась на 1 px выше в ячейках данных (низ 672 против 673 px у дерева; линия-разделитель — y 673…674 по всей строке:
   у дерева оверлей div.border-bottom, у данных border-bottom) — на стыке ступенька фона и белый зазор над линией только в ячейках данных, а справа линия торчала
   за скруглённым концом плашки (right: 2px). Теперь плашка в ячейке с рамкой доходит до padding-box: низ = 673 во всех колонках, линия прилегает к фону ровно;
   конец справа — без скругления и без отступа: скругление только у первой ячейки слева.
   2) теплокарта-таблица (AttrHeatmapGrid) прячет всех детей ячейки .hmg-bcell (visibility: hidden, специфичность 0,5,0) — плашка была видна только в колонках 1–2
   (290 из 904 px строки «— Усі країни —»); плашке видимость возвращается (0,5,1). Всё — только на ячейках grp-pill, то есть под fe.ux.groupRowPill */
.wj-cells .wj-cell.grp-pill.grp-pill-end > i.grp-pill-band { right: 0; }   /* IE 2026 11 03 / ODOO-350449 (заказ Игоря: мягче радиус, линия без ступеньки, фон по всей строке) */
.wj-cells .wj-cell.grp-pill:not(.tree-cell) > i.grp-pill-band { bottom: 0; }   /* IE 2026 11 03 / ODOO-350449 (заказ Игоря: мягче радиус, линия без ступеньки, фон по всей строке): ячейка с border-bottom 1px — низ плашки вровень с ячейкой дерева */
.wj-cells .wj-cell.grp-pill.hmg-bcell > i.grp-pill-band { visibility: visible; }   /* IE 2026 11 03 / ODOO-350449 (заказ Игоря: мягче радиус, линия без ступеньки, фон по всей строке): теплокарта-таблица прятала плашку в ячейках периодов */
.wj-cells .wj-cell.grp-pill.wj-state-selected > i.grp-pill-band, .wj-cells .wj-cell.grp-pill.wj-state-multi-selected > i.grp-pill-band { display: none; }
.wj-cell.grp-pill.grp-level-bg-0 { --grp-pill-bg: rgba(60, 72, 90, .17); }
.wj-cell.grp-pill.grp-level-bg-1 { --grp-pill-bg: rgba(60, 72, 90, .08); }
.wj-cell.grp-pill.grp-level-bg-2 { --grp-pill-bg: rgba(60, 72, 90, .04); }
.wj-flexgrid .wj-cells .wj-cell.grp-pill[class*="grp-level-bg-"]:not(.wj-state-selected):not(.wj-state-multi-selected) { background-color: transparent; }
.wj-cell.grp-pill[class*="group-row-level-"] { --grp-pill-bg: rgba(60, 72, 90, .06); }
.wj-cell.grp-pill.group-row-level-0 { --grp-pill-bg: rgba(60, 72, 90, .22); }
.wj-cell.grp-pill.group-row-level-1 { --grp-pill-bg: rgba(60, 72, 90, .14); }
.wj-cell.grp-pill.group-row-level-2 { --grp-pill-bg: rgba(60, 72, 90, .09); }
.wj-cells .wj-cell.grp-pill[class*="group-row-level-"] { filter: none; }
.wj-flexgrid .wj-cells .wj-cell.grp-pill[class*="group-row-level-"].cell-empty:not(.wj-alt):not(.card-col):not(.wj-state-selected):not(.wj-state-multi-selected) { background: inherit; }
/* итог группы = единственный потомок (gt-dup-dim: opacity .12 всей ячейки) гасил бы и плашку — в строке-плашке приглушается только текст */
.wj-cells .wj-cell.grp-pill.gt-dup-dim:not(.wj-row-hover) { opacity: 1; -webkit-text-fill-color: color-mix(in srgb, currentColor calc(var(--gt-dup-dim, .12) * 100%), transparent); }
/* IE 2026 11 03 / ODOO-350449 (заказ Игоря: стили уровней дерева — опции A/B/C/E/F): fe.ux.treeLevelStyle (guides / depth / rail / card / focus) и fe.ux.treeSubtreeHover.
   Класс режима — на корне грида (tls-on + tls-<режим>, tls-hover), флаг-часть селектора — только в :where() (не перебивает чужие правила своей специфичностью).
   Слои ячейки и маски отступа ставит AttrGrid.tls_paint inline (background-image), здесь — токены, снятие заливки уровня и классы фокуса / поддерева.
   Тёмная тема — filter: invert(1) на всё приложение (App.vue): полупрозрачные тона инвертируются сами, цвета полос — заранее инвертированные значения */
:where(.tls-on), :where(.tls-hover) {
    --tls-guide: rgba(60, 72, 90, .24); --tls-guide-on: rgba(60, 72, 90, .66);
    --tls-tone-1: rgba(60, 72, 90, .10); --tls-tone-2: rgba(60, 72, 90, .06); --tls-tone-3: rgba(60, 72, 90, .035);
    --tls-rail-0: #7b68b0; --tls-rail-1: #4f9a4a; --tls-rail-2: #b07a5f; --tls-rail-3: #c4484f; --tls-rail-4: #3f7fbf; --tls-rail-5: #a8842a;
    --tls-card-b: rgba(60, 72, 90, .24); --tls-card-sh: rgba(60, 72, 90, .42);
    --tls-cur-bg: rgba(122, 78, 168, .10); --tls-dim-veil: rgba(255, 255, 255, .55);
    --tls-sub: rgba(122, 78, 168, .08); --tls-sub-b: rgba(155, 124, 196, .9);
}
.dark-theme :where(.tls-on) { --tls-rail-0: #5a6b23; --tls-rail-1: #833d89; --tls-rail-2: #2c607b; --tls-rail-3: #19857f; --tls-rail-4: #a56b23; --tls-rail-5: #3b6cc4; }
/* режимы A/B/C/E/F: у раскрытого узла дерева нет серой заливки уровня (плашку снимает groupPill_after, filter — здесь); наведение строки остаётся */
:where(.tls-on) .wj-cells .wj-cell[class*="group-row-level-"]:not(.wj-row-hover) { filter: none; }
/* A: прежние линии дерева (рамка / пунктир) уступают направляющим */
:where(.tls-guides) .wj-cells .cell-frame-left, :where(.tls-guides) .wj-cells .cell-frame-corner, :where(.tls-guides) .wj-cells .cell-frame-bottom,
:where(.tls-guides) .wj-cells .cell-frame-top-corner, :where(.tls-guides) .wj-cells .cell-divider-left, :where(.tls-guides) .wj-cells .cell-divider-left-0 { visibility: hidden; }
/* F: корень фокуса — лёгкий тон, вне поддерева — приглушённый текст и непрозрачная вуаль (клон замороженных лежит поверх прокрученного: opacity нельзя) */
:where(.tls-focus) .wj-cells .wj-cell.tls-froot:not(.wj-state-selected):not(.wj-state-multi-selected) { background-image: linear-gradient(var(--tls-cur-bg), var(--tls-cur-bg)); }
:where(.tls-focus) .wj-cells .wj-cell.tls-dim:not(.tls-sub):not(.wj-state-selected):not(.wj-state-multi-selected) { -webkit-text-fill-color: color-mix(in srgb, currentColor 40%, transparent); box-shadow: inset 0 0 0 100vmax var(--tls-dim-veil); }
:where(.tls-focus) .wj-cells .wj-cell.tls-dim > i > .cell-delivery-left-0 { box-shadow: inset 0 0 0 100vmax var(--tls-dim-veil); }
/* D (подсветка поддерева): раскрытая группа под курсором и её потомки — тон поверх фона, у колонки дерева — полоса слева */
:where(.tls-hover) .wj-cells .wj-cell.tls-sub:not(.wj-state-selected):not(.wj-state-multi-selected) { box-shadow: inset 0 0 0 100vmax var(--tls-sub); }
:where(.tls-hover) .wj-cells .wj-cell.tls-sub.tree-cell:not(.wj-state-selected):not(.wj-state-multi-selected) { box-shadow: inset 3px 0 0 var(--tls-sub-b), inset 0 0 0 100vmax var(--tls-sub); }
:where(.tls-hover) .wj-cells .wj-cell.tls-sub > i > .cell-delivery-left-0 { box-shadow: inset 0 0 0 100vmax var(--tls-sub); }
.row-label-title {
    font-size: 0.875rem;
    text-transform: uppercase;
    font-weight: bold;
}
.row-label {
    top: 4px;
    color: #3f51b5;
    border-bottom: none !important;
}
/* background-color: #d6d6d6; */
/* box-shadow: inset 0px -2px 0px 0px #6c757d; */
/* .group-row-level-1-end::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    border-bottom: 2px solid rgba(0, 0, 0, 0.2);
    width: 100%;
} */

.row-child0 {
    border-bottom: none !important;
}
.row-child2-start {
    border-top: 2px solid rgba(0, 0, 0, 0.2) !important;
}
.row-child1-start {
    border-top: 2px solid rgba(0, 0, 0, 0.5) !important;
}
.row-child0-start {
    border-top: 4px double rgba(0, 0, 0, 0.5) !important;
}
/* .group-row-level-2 {
    background-color: #ebebeb;
} */

.wj-flexgrid .group-col-level-1-end {
    border-right: 1px solid rgba(0,0,0,.2);
}
.wj-flexgrid .group-col-level-0-start {
    border-left: 1px solid rgba(0, 0, 0, 0.2);
}
.wj-flexgrid .group-col-level-0-end {
    border-right: 1px solid rgba(0, 0, 0, 0.2);
}

.cell-bold {
    font-weight: bold;
}
.grid-summary-line{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 8px;
    height: 20px;
}
.grid-top-line{
    position: relative;
    display: flex;
    width: -webkit-fill-available;
    padding-bottom: 1px;
    align-items: center;
}
/* IE 2026 10 12 / ODOO-335099 (заказ Андрея через dm #72941, RP1): при прокрутке 0 (атрибут хоста data-gho-x0) заголовок строки-группы выходит за границу закреплённых колонок
   поверх пустых ячеек справа; правая граница — clip-path по --gho-r (groupHeaderOverflow_paint). Рисует ОДИН экземпляр: клон замороженных (.wj-frozen-clone,
   лежит поверх), а пока клона нет (data-gho-clone у хоста не стоит — до первой горизонтальной прокрутки) — основной в панели cells; иначе на границе шов
   (подложка клона fz-fill) и двойной текст. При прокрутке атрибута data-gho-x0 нет — прежние maxWidth / overflow / ellipsis */
.wj-flexgrid[data-gho-x0]:not([data-gho-clone]) [wj-part="cells"] .wj-cell[data-gho="1"],   /* IE 2026 10 12 / ODOO-335099 */
.wj-flexgrid[data-gho-x0] .wj-frozen-clone .wj-cell[data-gho="1"] {   /* IE 2026 10 12 / ODOO-335099 */
    max-width: none !important;   /* IE 2026 10 12 / ODOO-335099 */
    overflow: visible !important;   /* IE 2026 10 12 / ODOO-335099 */
    text-overflow: clip !important;   /* IE 2026 10 12 / ODOO-335099 */
    clip-path: inset(-500px var(--gho-r, 0px) -500px -2000px);   /* IE 2026 10 12 / ODOO-335099: сверху / снизу / слева — оверлеи линий дерева не режутся */
}   /* IE 2026 10 12 / ODOO-335099 */
.wj-flexgrid[data-gho-x0]:not([data-gho-clone]) [wj-part="cells"] .wj-cell[data-gho="1"] > .cell-text-clip,   /* IE 2026 10 12 / ODOO-335099 */
.wj-flexgrid[data-gho-x0] .wj-frozen-clone .wj-cell[data-gho="1"] > .cell-text-clip {   /* IE 2026 10 12 / ODOO-335099 */
    overflow: visible !important;   /* IE 2026 10 12 / ODOO-335099 */
    text-overflow: clip !important;   /* IE 2026 10 12 / ODOO-335099 */
}   /* IE 2026 10 12 / ODOO-335099 */
.wj-cell.spill {
    overflow: visible;
    z-index: 2 !important;
}
.wj-cell.spill_data {
    z-index: 2 !important;
}

.wj-row.drag-over {
    filter: drop-shadow(0px 5px 1px #ffcc66);
    border: 2px dashed #000;
    z-index: 10;
    transition: all 250ms;
}
.wj-cell.drag-over-row {
    z-index: 10 !important;
    transition: all 250ms;

    box-shadow: 0 3px 0 0 #ffcc66, inset 0 -2px 0 0 #ffcc66 !important;
}
.wj-cell.drag-over-cell {
    z-index: 10 !important;
    transition: all 250ms;

    box-shadow: 0 0 0 0px #ffcc66, inset 0 0 0 5px #ffcc66 !important;
    border-radius: 3px;
}
.wj-row.drag-source-1 {
    opacity: 0.3;
    transition: all 250ms;
    padding: 5px;
}

.drag-box {
    position: absolute;
    padding: 10px;
    border: 5px dashed #ffcc66;
    border-radius: 3px;
    background-color: #dfedde;
    top: -9999px;

    display: flex;
    align-items: center;
}
.drag-header {
    color: var(--cs-accent, #647eff);
    font-weight: bolder;
}
.drag-text {
    font-weight: normal;
}

/* IE 2026 08 19 / ODOO-5512 (заказ Игоря): панель тегов под командной панелью */
.grid-tags-panel {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
    padding: 2px 6px;
}
.grid-tags-panel-icon { font-size: 11px; color: #94a3b8; margin-right: 2px; }
.grid-tag {
    padding: 1px 8px;
    border: 1px solid #d5dbe3;
    border-radius: 10px;
    font-size: 11px;
    line-height: 15px;
    color: #475569;
    cursor: pointer;
    user-select: none;
}
.grid-tag:hover { border-color: #94a3b8; background: rgba(0,0,0,.03); }
.grid-tag-active {
    background: var(--cs-accent, #647eff);
    border-color: var(--cs-accent, #647eff);
    color: #fff;
}
.wj-marquee {
    box-shadow: 0 0 0 2px rgba(255,150,30,.75), inset 0 0 0 1px rgba(255,150,30,.75) !important;
    border-radius: 3px;
    z-index: 5;
}
/* IE 2026 09 23 / ODOO-… (заказ Игоря «сделай все три варианта и в нашем отчёте настрой A»): рамка выделения ГРИДА ДАННЫХ по варианту
   записи / настройки базы — класс sel-frame-<вариант> на контейнере грида (AttrGrid selFrame); цепочка до маркиза СВОЕГО грида
   (хост wijmo > main-container > root > marquee; вторая ветка — wijmo без main-container), чтобы вложенные гриды ячеек рамку не
   наследовали. Слои box-shadow: первый — сверху. A halo: рыжая линия 3px (2 снаружи + 1 внутри) НЕПРОЗРАЧНАЯ, белая окантовка 1px
   снаружи и внутри — читается на любой заливке (замечание: классическая полупрозрачная тонула на красной заливке uncovered);
   B dark: то же, окантовка графит; C double: тонкая рыжая снаружи, белый зазор, тонкая рыжая внутри. Без класса — Classic (выше). */
.attr-grid.sel-frame-halo > .wj-flexgrid > [wj-part="main-container"] > [wj-part="root"] > .wj-marquee,
.attr-grid.sel-frame-halo > .wj-flexgrid > [wj-part="root"] > .wj-marquee {
    box-shadow: 0 0 0 2px rgb(255,150,30), 0 0 0 3px #fff, inset 0 0 0 1px rgb(255,150,30), inset 0 0 0 2px #fff !important;
}
.attr-grid.sel-frame-dark > .wj-flexgrid > [wj-part="main-container"] > [wj-part="root"] > .wj-marquee,
.attr-grid.sel-frame-dark > .wj-flexgrid > [wj-part="root"] > .wj-marquee {
    box-shadow: 0 0 0 2px rgb(255,150,30), 0 0 0 3px #333, inset 0 0 0 1px rgb(255,150,30), inset 0 0 0 2px #333 !important;
}
.attr-grid.sel-frame-double > .wj-flexgrid > [wj-part="main-container"] > [wj-part="root"] > .wj-marquee,
.attr-grid.sel-frame-double > .wj-flexgrid > [wj-part="root"] > .wj-marquee {
    box-shadow: 0 0 0 1px rgb(255,150,30), inset 0 0 0 1px #fff, inset 0 0 0 2px rgb(255,150,30) !important;
}
/* задача 19b: приглушённая рыжая линия по нижней строке выделения ВО ВСЮ ширину
   грида. IE 2026 09 02 / ODOO-4997 (замечание Игоря): БЫЛ ::after у marquee на
   ±100000px — абсолютный бокс УЧАСТВУЕТ в scrollWidth, и форм-гриды (ACCESS стола)
   получали фантомную прокрутку ~100k px (крошечный «гиперреактивный» ползунок при
   полностью видимом содержимом). Теперь полоса — оверлей в host (marqueeBand_sync),
   top синхронизируется с marquee на каждом updatedView; исключения (attrs-грид,
   одна строка) — в самом синке */
.wj-flexgrid > .wj-marquee-band {
    position: absolute;
    left: 0;
    right: 0;
    height: 2px;
    background: rgba(255, 150, 30, 0.35);
    pointer-events: none;
    z-index: 5;
}

.attrs-tab-grid .wj-marquee {
    box-shadow: 0 0 0 0 rgba(255,150,30,.75), inset 0 -1px 0 0 rgba(255,150,30,.75) !important;
    border-radius: 0px;
    z-index: 5;
}
.attrs-tab-grid:hover .wj-marquee {
    box-shadow: 0 2px 0 0 rgba(255,150,30,.75), inset 0 -1px 0 0 rgba(255,150,30,.75) !important;
    border-radius: 0px;
    z-index: 5;
}

.wj-cells .head-row {
    filter: brightness(94%);
}
/* IE 2026 09 04 / ODOO-336291 (mobile UX): P-25 — подсветка строки только устройствам с курсором: на таче :hover (и synthetic mousemove
   → .wj-row-hover) залипал на тапнутой строке, filter создавал stacking context на каждой её ячейке */
@media (hover: hover) {
.wj-cells .wj-row:hover .wj-cell:not(.wj-state-selected):not(.wj-state-multi-selected) {
    filter: brightness(96%);
}
/* hover всей строки, включая замороженные колонки и их клон-панель — класс
   .wj-row-hover ставит JS (initialized) по data-gr, т.к. CSS :hover не достаёт клон */
.wj-cell.wj-row-hover:not(.wj-state-selected):not(.wj-state-multi-selected) {
    filter: brightness(96%);
}
}
/* IE 2026 08 19 / ODOO-5512 (заказ Игоря): filter у ячейки создаёт свой stacking
   context — бейдж дельты (::after, z-index 7) запирается внутри ячейки (z auto)
   и рисуется ПОД рамкой выделения (.wj-marquee, z 5): так было в Purchase, где
   активная ячейка (.wj-state-active) попадает под hover-подсветку строки, и не
   было в M03 при выделении диапазона (.wj-state-multi-selected исключён из
   правила). У ячеек с дельтой подсветку hover-строки даём не фильтром, а
   inset-тенью того же тона — контекст не создаётся, бейдж остаётся поверх рамки */
.wj-cells .wj-row:hover .wj-cell[data-chg-delta]:not(.wj-state-selected):not(.wj-state-multi-selected),
.wj-cell.wj-row-hover[data-chg-delta]:not(.wj-state-selected):not(.wj-state-multi-selected) {
    filter: none;
    box-shadow: inset 0 0 0 999px rgba(0, 0, 0, .04);
}
/* крест-подсветка заголовков строки/колонки при hover ячейки данных (см. data-ghr/data-ghc):
   по аналогии с индикацией выделения (marquee-бордер); нейтральная тёмная
   полупрозрачная линия — видна и на белых, и на цветных шапках (белая линия
   на белых заголовках терялась) и не путается с оранжевым выделением.
   Колонка-заголовок → линия снизу, строка-заголовок → линия справа. */
.wj-flexgrid .wj-colheaders .wj-cell.wj-hover-header:not(.wj-state-multi-selected) {
    box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.35);
    filter: brightness(96%);   /* + фон, как у hover-строки (.wj-row-hover) */
}
.wj-flexgrid .wj-rowheaders .wj-cell.wj-hover-header:not(.wj-state-multi-selected) {
    box-shadow: inset -3px 0 0 0 rgba(0, 0, 0, 0.35);
    filter: brightness(96%);
}
.p-chips .p-chips-multiple-container .p-chips-input-token {
    padding: 1px;
}
.p-chips .p-chips-multiple-container {
    padding: 1px;
}
.p-chips .p-chips-multiple-container .p-chips-token {
    border-radius: 3px;
}

.i-chips-container {
    display: flex;
    align-items: center;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 18px;   /* мягкое скругление блока чипсов (шапка грида), в тон иконкам пейджев */
    padding: 5px 10px;
}
.i-chips2-container {
    display: flex;
    align-items: center;
}
.i-chip {
    display: inline-flex;
    align-items: center;
    margin-right: 10px;
    background-color: #eee;
    border-radius: 3px;
    padding: 5px 10px;
}
.i-chip2 {
    display: inline-flex;
    align-items: center;
    margin-right: 4px;
    border-radius: 3px;
}
.i-chip3 {
    display: inline-flex;
    align-items: center;
    margin-right: 2px;
    background-color: #eee;
    border-radius: 3px;
}
.i-chip-content {
    margin-right: 10px;
    cursor: pointer;
}
.i-separator {
    color: #0375ff;
}
.i-chip2-content {
    cursor: pointer;
}
.i-chip-delete-btn {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 7px;
}
.i-chip-filter {
    border: none;
    outline: none;
    flex-grow: 1;
}
body .wj-popup {
    display: flex;
    flex-direction: column;    
    min-width: 150px;
    min-height: 200px;
}
body .wj-popup .wj-dialog-body {
    flex-grow: 1;
}
body .wj-popup .wj-dialog-footer {
    margin-top: 0;
}
.iclose {
    float: right;
    font-size: 21px;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    filter: alpha(opacity = 20);
    opacity: .2;
}
.wj-popup .idialog-header {
    font-size: 1.5rem;
    font-weight: 500;
    color: var(--cs-accent, #647eff);
    padding: 0.5rem;
    opacity: 0.75;
}
.my-input-2 {
    background-color: #f2f5f5;
}
.my-input-2 .wj-control {
    background-color: #f2f5f5;
}

.rowHeaders-level-1 {
    border-left: 5px solid;
}
.rowHeaders-level-2 {
    border-left: 10px solid;
}
.rowHeaders-level-3 {
    border-left: 15px solid;
}
.rowHeaders-level-4 {
    border-left: 20px solid;
}
.rowHeaders-level-5 {
    border-left: 25px solid;
}
.rowHeaders-level {
    border-left-color:#d7dbe0;
}

.row-bottom-group::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 3px;
    background-image: radial-gradient(circle, #878787 1px, transparent 1px);
    background-size: 3px 3px;
}
.row-bottom-group2 {
    top: -3px !important;
}
.row-top-left-group {
    border-top-left-radius: 0.5rem;
}
.row-bottom-left-group {
    border-bottom-left-radius: 0.5rem;
}
.wj-flexgrid .wj-cell.wj-filter-on .wj-elem-filter {
    opacity: 1;
    color: rgba(255,150,30,.75);    
}
.custom-value-warning::before {
    content: '';
    position: absolute;
    left: 5%;
    bottom: 2px;
    width: 90%;
    height: 3px; 
    border-bottom: 2px dashed rgba(255, 0, 0, 0.3);
}
.grid-top-line {
    opacity: 0;
}
.commandPanel-area {
    display: flex;
    align-items: center;
    flex: 1 1 0;
    min-width: 0;
}
.commandPanel-menu {
    display: flex;
    align-items: center;
    padding: 0 6px;
    overflow: hidden;
    flex: 1 1 0;
    min-width: 0;
}
.cp-item-wrap {
    display: inline-flex;
    align-items: center;
}
/* IE 2026 11 02 / ODOO-350449 (заказ Игоря: p191 — опції виглядів однією склеєною групою кнопок, як «Міра» теплокарти): подряд идущие кнопки одной группы
   (segment) — один блок как HeatmapSwitches .hm-seg: размеры / цвета .hm-btn, скругление 6 px только у краёв, разделитель 1 px (рамки соседей внахлёст) */
.cp-item-wrap.cp-seg .commandPanel-buttons {
    font-size: 12px; line-height: 18px; padding: 3px 10px !important; margin-right: 0 !important; border-radius: 0;
    border: 1px solid var(--hm-line, var(--surface-border, #e1e4ec)); background: var(--hm-bg, var(--surface-card, #fff)); color: var(--text-color, #1f2430);
}
.cp-item-wrap.cp-seg:not(.cp-seg-first) { margin-left: -1px; }
.cp-item-wrap.cp-seg.cp-seg-first .commandPanel-buttons { border-radius: 6px 0 0 6px; }
.cp-item-wrap.cp-seg.cp-seg-last .commandPanel-buttons { border-radius: 0 6px 6px 0; }
.cp-item-wrap.cp-seg.cp-seg-last { margin-right: 0.25rem; }
.cp-item-wrap.cp-seg .commandPanel-buttons:enabled:hover { background: var(--surface-hover, #f3f4f8); }
.cp-item-wrap.cp-seg .commandPanel-buttons.p-button-active,
.cp-item-wrap.cp-seg .commandPanel-buttons.p-button-active:enabled:hover {
    background: var(--hm-sel-bg, var(--highlight-bg, #e3e7f6)) !important; border-color: var(--primary-color, #3949ab); position: relative; z-index: 1;
}
.commandPanel-overflow-menu {
    cursor: pointer;
}
.commandPanel-overflow-menu.wj-control .wj-template {
    display: none;
}
.WIDGET:hover .grid-top-line {
    opacity: 1;
}
.WIDGET .grid-top-line {
    opacity: 1;
}
.attr-grid .node-cell-0-HIDE {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    border-radius: 0.5rem;
    padding-top: 5px !important;
    margin-top: 2px;
    font-weight: bold !important;
    font-size: 1rem;
    color: white;
    background-color: #96abb4;
    text-indent: 10px;
}
.attr-grid .node-cell-HIDE {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    border-radius: 0.5rem;
    padding-top: 2px;
    margin-top: 2px;
    font-weight: bold;
    background-color: #ecf0f3;
}
.wj-flexgrid.grid-node-cell-HIDE .wj-cell{
    padding-top: 8px;
    padding-bottom: 16px;
}
.use-false {
    text-decoration: line-through;
}
.scale70 {
    zoom: 0.7;
}
.chip {
    display: inline-flex;
    align-items: center;
    background: rgb(222 226 230 / 75%);
    color: var(--text-color);
    border-radius: 3px;
    font-size: 14px;
    white-space: nowrap;
    cursor: grab;
    user-select: none;
    margin-bottom: 1px;
}
/* Скрытое поле: чипс приглушён и обведён пунктиром.
   outline вместо border — рамка не меняет размер чипса и не съезжает раскладка. */
.chip.chip-hidden {
    background: rgb(222 226 230 / 35%);
    outline: 1px dashed rgba(119, 136, 153, 0.7);
    outline-offset: -1px;
}
.chip.chip-hidden .chip-icon {
    background: rgba(119, 136, 153, 0.35);
}
.chip.chip-hidden .chip-text {
    opacity: 0.6;
    font-style: italic;
}
/* IE 2026 10 10 / ODOO-341407 (Andrey via core #74338: sort chips in the layout list): чипс сортировки строки раскладки — только показ: светлее, пунктирная рамка (outline, размер не меняется), не тянется и не удаляется */
.chip.chip-sort {
    background: rgb(100 126 255 / 8%);
    outline: 1px dashed rgba(100, 126, 255, 0.6);
    outline-offset: -1px;
    cursor: default;
}
.chip.chip-sort .chip-icon {
    background: rgba(100, 126, 255, 0.55);
    cursor: default;
}
.chip-icon {
    background: rgba(119, 136, 153, 0.8);
    padding: 4px;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    color: white;
    cursor: pointer;
}
.chip-text {
    margin-left: 4px;
}
.chip-remove {
    background: transparent;
    border: none;
    cursor: pointer;
    margin: 4px;
    opacity: 0.6;
}
.chip-remove:hover {
    color: #d32f2f;
}
.chip-selected {
    /* IE 2026 08 19 (заказ Игоря): выделенный тег (Del удаляет) */
    outline: 2px solid var(--cs-accent, #647eff);
    outline-offset: 1px;
}
.chip-overflow-badge {
    position: absolute;
    right: 2px;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(100, 120, 140, 0.85);
    color: white;
    border-radius: 10px;
    padding: 1px 6px;
    font-size: 11px;
    font-weight: 600;
    pointer-events: none;
    align-items: center;
    z-index: 1;
}
.chip-input-cell {
    border: none;
    outline: none;
    font-size: 14px;
    flex-grow: 1;
    min-width: 40px;
    background: transparent;
    color: var(--text-color);
    padding: 1px 2px;
}
.chip-selection-menu {
    position: fixed;
    z-index: 10000;
    max-height: 320px;
    min-width: 160px;
    overflow-y: auto;
    background: var(--surface-overlay, #fff);
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 3px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
    font-size: 13px;
}
.chip-selection-menu-group {
    padding: 5px 10px 2px;
    font-weight: 600;
    font-size: 11px;
    text-transform: uppercase;
    opacity: 0.6;
    color: var(--text-color);
}
.chip-selection-menu-item {
    padding: 4px 10px 4px 16px;
    cursor: pointer;
    white-space: nowrap;
    color: var(--text-color);
}
.chip-selection-menu-item:hover,
.chip-selection-menu-item.active {
    background: rgba(74, 124, 138, 0.15);
}
.selector-all {
    /* IE 2026 09 10 / ODOO-… (замечание Игоря «use в заголовке и в строках разных размеров»): размер как у чекбоксов
       строк (wj-cell-check — нативный, 13px), явные 16px убраны */
    cursor: pointer;
    accent-color: #4a7c8a;
}
.selector-all:indeterminate {
    accent-color: #ff8a00;
}
/* IE 2026 11 03 / ODOO-350449 (заказ Игоря: чекбокс заголовка колонки выбора строк — в линию с чекбоксами строк): выключатель fe.ux.gridHeaderCheckAlign
   (класс .grid-hdrchk-align на layout-wrapper, дефолт ВКЛ; ВЫКЛ — как до p240). Было: ячейка заголовка — flex по центру (inline-стиль), флажок с родными полями
   3px 3px 3px 4px сжимался flex-ом и стоял не по центру строк, у строк — обычный поток от левого поля ячейки. Стало: у обеих ячеек одна раскладка (flex по центру,
   без боковых полей), у флажков — без полей и без сжатия, одинаковый размер 13 px; заголовок выделен рамкой цвета шапки (outline — размер не меняет). */
:where(.grid-hdrchk-align) .wj-flexgrid .wj-topleft .wj-cell.wj-header-number-row:has(> input.selector-all, > input.fe-selected-check),   /* IE 2026 11 03 / ODOO-350449 */
:where(.grid-hdrchk-align) .wj-flexgrid .wj-rowheaders .wj-cell:has(> input.wj-cell-check:only-child, > input.fe-selected-check:only-child) {   /* IE 2026 11 03 / ODOO-350449 */
    display: flex !important;   /* IE 2026 11 03 / ODOO-350449 */
    justify-content: center !important;   /* IE 2026 11 03 / ODOO-350449 */
    align-items: center !important;   /* IE 2026 11 03 / ODOO-350449 */
    padding-left: 0 !important;   /* IE 2026 11 03 / ODOO-350449 */
    padding-right: 0 !important;   /* IE 2026 11 03 / ODOO-350449 */
}
:where(.grid-hdrchk-align) .wj-flexgrid .wj-topleft .wj-cell > :where(input).selector-all,   /* IE 2026 11 03 / ODOO-350449 */
:where(.grid-hdrchk-align) .wj-flexgrid .wj-rowheaders .wj-cell > :where(input).wj-cell-check:only-child {   /* IE 2026 11 03 / ODOO-350449 */
    flex: none;   /* IE 2026 11 03 / ODOO-350449 */
    width: 13px;   /* IE 2026 11 03 / ODOO-350449 */
    height: 13px;   /* IE 2026 11 03 / ODOO-350449 */
    margin: 0;   /* IE 2026 11 03 / ODOO-350449 */
}
:where(.grid-hdrchk-align) .wj-flexgrid .wj-topleft .wj-cell > :where(input).fe-selected-check,   /* IE 2026 11 03 / ODOO-350449 */
:where(.grid-hdrchk-align) .wj-flexgrid .wj-rowheaders .wj-cell > :where(input).fe-selected-check:only-child {   /* IE 2026 11 03 / ODOO-350449 */
    flex: none;   /* IE 2026 11 03 / ODOO-350449 */
    margin: 0;   /* IE 2026 11 03 / ODOO-350449 */
}
:where(.grid-hdrchk-align) .wj-flexgrid .wj-topleft .wj-cell > :where(input).selector-all {   /* IE 2026 11 03 / ODOO-350449: заголовок — рамка цвета текста шапки: --cs-header-fg схемы, classic — #A3B6BE (.wj-cell.wj-header) */
    outline: 1px solid var(--cs-header-fg, #A3B6BE);   /* IE 2026 11 03 / ODOO-350449: цвет текста самого input — чёрный, не цвет шапки; 1.5px Chrome округляет до 1px (замер p240 dev02) */
    outline-offset: -1px;   /* IE 2026 11 03 / ODOO-350449 */
    border-radius: 2px;   /* IE 2026 11 03 / ODOO-350449 */
}
/* IE 2026 11 03 / ODOO-350449 (заказ Игоря: чекбокс заголовка — в центре ячейки строки номеров): контент-бокс ячейки поднимали нижняя рамка (classic 3px, cscheme-style* 1px)
   и padding-bottom 1px — флажок стоял на 2px выше центра; верхнее поле = нижней рамке, нижнего нет; флажок 13px выходит на 1px в рамку — overflow: visible */
:where(.grid-hdrchk-align) .wj-flexgrid .wj-topleft .wj-cell.wj-header-number-row:has(> input.selector-all, > input.fe-selected-check) {   /* IE 2026 11 03 / ODOO-350449 */
    padding-top: 3px !important;   /* IE 2026 11 03 / ODOO-350449 */
    padding-bottom: 0 !important;   /* IE 2026 11 03 / ODOO-350449 */
    overflow: visible !important;   /* IE 2026 11 03 / ODOO-350449 */
}
body[class*="cscheme-style"] :where(.grid-hdrchk-align) .wj-flexgrid .wj-topleft .wj-cell.wj-header-number-row:has(> input.selector-all, > input.fe-selected-check) {   /* IE 2026 11 03 / ODOO-350449 */
    padding-top: 1px !important;   /* IE 2026 11 03 / ODOO-350449 */
}
.selector-all-menu {
    position: fixed;
    z-index: 10000;
    background: var(--surface-overlay, #fff);
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 3px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
    font-size: 13px;
}
.selector-all-menu-item {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 5px 10px;
    cursor: pointer;
    white-space: nowrap;
    color: var(--text-color);
}
.selector-all-menu-item:hover {
    background: rgba(74, 124, 138, 0.15);
}
/* IE 2026 09 26 / ODOO-… (заказ Игоря: doc.use в заголовках строк): заблокированная строка флажка в заголовке строки (у языков — en) —
   флажок виден без блёклости disabled, не переключается */
.wj-cell.rh-locked,
.wj-cell.rh-locked .wj-cell-check {
    cursor: not-allowed;
}
.mapped-cels {
    background-color: #d7e4ea !important;
    font-weight: 700;
    border: 1px solid rgba(255, 255, 255, 0.5);
}
.no-mapped-cels {
    background-color: rgba(200, 200, 200, 0.4) !important;
    background-image: repeating-linear-gradient(-45deg, white, white 10px, #d7e4ea 10px, #d7e4ea 20px) !important;
}
.left-2 {
    position: absolute;
    left: 2px;
}
.left-5 {
    position: absolute;
    left: 5px;
}
.top-2 {
    position: absolute;
    top: 2px;
}
.my-collapse::before{
    content: "";
    position: relative;
    display: inline-block;
    border-top: .5em solid;
    border-right: .45em solid transparent;
    border-left: .45em solid transparent;
    top: -1px;
    margin-right: 4px;
    opacity: .75;
}

.crossing-out {
    position: relative;
    display: inline-block;
}
.crossing-out::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 2px;
    background: red;
    transform: translateY(-50%) rotate(-20deg);
}
.grid-chips{
    flex: 1 1 130px;
    min-width: 130px;
    padding-right: 8px;
    padding-left: 1px;
}
/* дропдаун-кнопка чипсов не выталкивается за контейнер (наезжала на ⚙):
   жёсткий width:fill-available у .input-container занимал всю ширину
   контейнера — как ранее исправлено для чипсов топбара */
.grid-chips .input-container {
    width: auto;
    flex: 1 1 auto;
    min-width: 0;
}
/* IE 2026 09 04 / ODOO-336331 (заказ Игоря): бейдж в ячейке (title.badge) — «Current» у открытой настройки,
   палитра как у бейджа «Branch copy» (Widget.vue .cow-badge-copy) */
.cell-badge { display: inline-flex; align-items: center; margin: 0 6px 0 0; padding: 0 6px; border-radius: 10px;
    font-size: 10px; font-weight: 600; letter-spacing: .2px; line-height: 14px; vertical-align: middle; white-space: nowrap; }
.cell-badge-current { background: #e3f1ff; color: #1d5fa8; border: 1px solid #9cc5f0; }
.cell-link {
    cursor: pointer;
}
.cell-link:hover {
    -webkit-text-stroke: 0.028em currentColor; /* IE 2026 09 29 / ODOO-… (заказ Игоря: ширина кнопки при наведении): вместо font-weight: bolder — ширина та же */
    color: rgba(255, 150, 30, .75);
}
/* сводная таблица правил: колонки Source — переход к источнику (source_link) */
.wj-cell.agg-source-link {
    cursor: pointer;
    text-decoration: underline dotted;
}
.wj-cell.agg-source-link:hover {
    color: rgba(255, 150, 30, .75);
}
.wj-flexgrid .wj-grid-editor {
    font-family: inherit;
}
.wj-flexgrid .wj-grid-editor.attrmulti-attrlink {
    width: 90%;
}
/* обрезанный текст в ЛЮБОЙ ячейке заканчивается «…» — восстановлен дефолт wijmo
   (.wj-cell:not(.wj-hasdropdown){text-overflow:ellipsis}); раньше здесь стоял
   оверрайд text-overflow:inherit (коммит 4cb59872), из-за него многоточие
   оставалось только у frozen-колонок с их инлайновым ellipsis из formatItem */
.ghost-text {
    position: absolute;
    width: 100%;
    left: 0px;
    opacity: 0.5;
    pointer-events: none;
    font-family: inherit;
    font-size: inherit;
}
.cell-dropdown-toggle {
    position: absolute;
    bottom: 1px;
    right: 2px;
    width: 16px;
    height: 16px;
    padding: 0;
    border: none;
    background: transparent;
    opacity: 0;
    transition: opacity 0.15s;
    cursor: pointer;
    z-index: 2;
    font-size: 9px;
    color: rgba(255, 150, 30, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
    line-height: 1;
}
.wj-cell:hover .cell-dropdown-toggle.in-selection {
    opacity: 0.6;
}
.wj-cell:hover .cell-dropdown-toggle.in-selection:hover {
    opacity: 1;
    background: rgba(255, 150, 30, 0.12);
}
/* IE 2026 09 21 / ODOO-… (замечание Игоря: стрелка формы ячейки на выбранной ячейке, F4 — без входа в правку): на выбранной ячейке стрелка видна сразу, без наведения —
   в гриде С ФОКУСОМ (пользователь встал на ячейку); выбранная ячейка есть у каждого грида страницы — в гридах без фокуса стрелка видна по наведению */
.wj-flexgrid.wj-state-focused .cell-dropdown-toggle.at-active,
.wj-cell:hover .cell-dropdown-toggle.at-active {
    opacity: 0.6;
}
.wj-flexgrid.wj-state-focused .cell-dropdown-toggle.at-active:hover,
.wj-cell:hover .cell-dropdown-toggle.at-active:hover {
    opacity: 1;
    background: rgba(255, 150, 30, 0.12);
}
/* IE 2026 09 27 / ODOO-… (дефект p203: стрелки при открытой форме ячейки): заглушка на месте кнопки у ячейки с показанной формой — не видна ни в каком состоянии (выбор, наведение, мобильный профиль); клик в угол ячейки
   не начинает правку и не закрывает форму (закрывает ✕ формы) */
.cell-dropdown-toggle.cell-form-here,
.wj-cell:hover .cell-dropdown-toggle.cell-form-here,
.wj-flexgrid.wj-state-focused .cell-dropdown-toggle.cell-form-here,
body.mobile-ui.mob-gridglyph .cell-dropdown-toggle.cell-form-here {
    opacity: 0 !important;
    background: transparent !important;
    cursor: default;
}
/* правка ячейки: редактор занимает ячейку — заглушка клики не перехватывает (курсор в тексте ставится и у правого края) */
.wj-cell:has(.wj-grid-editor) > .cell-dropdown-toggle.cell-form-here {
    pointer-events: none;
}
/* когда dropdown открыт на ячейке — кнопка закрытия видна постоянно */
.cell-dropdown-toggle.open {
    opacity: 0.9;
}
.cell-dropdown-toggle.open:hover {
    opacity: 1;
    background: rgba(255, 150, 30, 0.12);
}
/* IE 2026 09 29 / ODOO-343342 (заказ Игоря: форма ячейки по 🏷): шеврон формы ячейки скрыт, форма открывается кнопкой 🏷 строки команд; невидимая заглушка p203 (cell-form-here) остаётся */
.attr-grid.cellform-tagbtn .cell-dropdown-toggle:not(.cell-form-here) { display: none !important; }
.grid-top-line > .grid-cellform-island { position: static; flex: none; align-self: center; margin-left: 4px; }
/* IE 2026 09 30 / ODOO-343342 (заказ Игоря: 🏷 слева в группе кнопок, как на графике): 🏷 — первый в группе, прижатие вправо (margin-left: auto) — на нём (у ⚙ / ≡ класс снят) */
.grid-top-line > .grid-cellform-island.menu-push-right { margin-left: auto; }
.cellform-tag-btn { cursor: pointer; }
.cellform-tag-btn-on { border-radius: 4px; }   /* IE 2026 10 12 / ODOO-343342 (заказ Игоря: форма ячейки по 🏷): заливка нажатой — общий класс p-button-active (App.vue), был серый rgba(47, 59, 82, .12) */
.cellform-tag-btn-off { opacity: 0.4; cursor: default; }
/* IE 2026 09 07 / ODOO-5512: чекбокс-ячейка — шеврон виден при наведении (открыть историю правки / оформление) */
.wj-cell.checkbox:hover .cell-dropdown-toggle.on-bool {
    opacity: 0.6;
}
.wj-cell.checkbox:hover .cell-dropdown-toggle.on-bool:hover {
    opacity: 1;
    background: rgba(255, 150, 30, 0.12);
}
/* при выравнивании значения вправо кнопку смещаем влево */
.cell-dropdown-toggle.align-left {
    left: 2px;
    right: auto;
}
.wj-cell.attr-doc .cell-dropdown-toggle,
.wj-cell.attr-doc2 .cell-dropdown-toggle {
    opacity: 0.7;
}
.row-prefix {
    opacity: 0.5;
    font-stretch: ultra-condensed;
}

.custom-text {
    font-size: 14px;
    color: #555;
    transition: color 0.3s ease;
}
.custom-text:hover {
    color: #007bff;
    cursor: text;
}

/* .no-top-border {
    outline: 1px solid #96abb4;
}*/

.eval-text {
    color: #555;
    transition: color 0.3s ease;
}
.eval-field {
    padding: 2px 4px;
    margin-inline: 1px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #f8f8f8;
    font-stretch: ultra-condensed;
    color: #333;
    transition: all 0.2s ease-in-out;
}
.eval-field:hover {
    border-color: #007bff;
    background-color: #e9f5ff;
    color: #007bff;
    box-shadow: 0px 0px 5px rgba(0, 123, 255, 0.5);
}

.wj-cell.error {
    background: red !important; 
    color: white !important;
}
.wj-cell.color-red { color: red; }
.wj-cell.editable {
    cursor: pointer;
    background-color: #FFEAD4;
}
.wj-cell.bold {
    font-weight: bold;
}
.wj-cell.italic {
    font-style: italic;
}
input[type="checkbox" i] {
  margin: 0px 2px;
}

.cell-background-header {
    background-color: #96abb4 !important;
    filter: none;
    color: white;
}

.hide-collapse .wj-elem-collapse {
    display: none !important;
}
/* дерево в правовыровненной колонке: кнопка свёртки у левого края ячейки,
   значение остаётся справа (ИЕ 2026-08-11: «уехал треугольник») */
.tree-cell.wj-align-right > .wj-elem-collapse,
.tree-cell.wj-align-right > .wj-elem-collapse-space,
.tree-cell.wj-align-right > .cell-text-clip > .wj-elem-collapse,
.tree-cell.wj-align-right > .cell-text-clip > .wj-elem-collapse-space {
    float: left;
}
/* подпись строки-группы дерева прижата влево, к треугольнику: в правовыровненной
   колонке она уезжала к дальнему краю объединённой ячейки (ИЕ 2026-08-12) */
.tree-group-cell.wj-align-right,
.tree-group-cell.wj-align-right > .cell-text-clip {
    text-align: left;
}
.visibility-hidden {
    visibility: hidden;
}
.link-expand-cell .wj-elem-collapse:not(.link-expand),
.link-expand-cell .wj-elem-collapse-space:not(.link-expand-space) {
    /* нативная скрытая пара «кнопка+спейсер» листа (wijmo вставляет её после
       formatItem, visibility:hidden занимает место) — вместо неё кнопка link-expand */
    display: none !important;
}
.link-expand {
    cursor: pointer;
}
.link-expand .wj-glyph-right,
.link-expand .pi {
    color: #0066FF;
    opacity: 1; /* глифы wijmo приглушены (opacity .75) — кнопка Link-поля должна выделяться */
}
.link-expand:hover .wj-glyph-right {
    color: #0047B3;
}
/* декоративный индикатор ссылочного поля (не кликабелен) —
   контурный треугольник без заливки, hover ничего не меняет */
.link-expand.link-expand-static,
.link-expand.link-expand-static .wj-glyph-right {
    cursor: default;
}
.wj-flexgrid .wj-cell .wj-btn.wj-btn-glyph.link-expand-static,
.wj-flexgrid .wj-cell .wj-btn.wj-btn-glyph.link-expand-static:hover,
.wj-flexgrid .wj-cell .wj-btn.wj-btn-glyph.link-expand-static:focus {
    opacity: .4; /* покой обычной кнопки wijmo (.4 → 1 на hover) — фиксируем, hover не подсвечивает */
}
.link-expand.link-expand-static .wj-glyph-right {
    /* вместо залитого border-треугольника wijmo — контур того же габарита (.5em × .8em);
       цвет/прозрачность = как у обычной кнопки раскрытия (currentColor через mask),
       сброс синего и opacity:1 от .link-expand */
    border: none;
    width: .5em;
    height: .8em;
    color: inherit;
    opacity: .75;
    background-color: currentColor;
    -webkit-mask: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 16'%3E%3Cpath d='M1.5 2 L8 8 L1.5 14 Z' fill='none' stroke='%23000' stroke-width='1.6' stroke-linejoin='round'/%3E%3C/svg%3E") no-repeat center / contain;
    mask: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 16'%3E%3Cpath d='M1.5 2 L8 8 L1.5 14 Z' fill='none' stroke='%23000' stroke-width='1.6' stroke-linejoin='round'/%3E%3C/svg%3E") no-repeat center / contain;
}
/* lightView: чистое дерево — без горизонтальных линий строк */
.attr-grid-lightview [wj-part=cells] .wj-cell,
.attr-grid-lightview [wj-part=rh] .wj-cell {
    border-bottom-color: transparent;
}
.indent {
    color: #a1a3a5;
    transform: translateX(1px);
}
.indent-last-v {
    color: #a1a3a5;
    transform: translateX(1px) translateY(-4px);
}
.indent-last-h {
    position: absolute;
    color: #a1a3a5;
    transform: translateX(-9px) translateY(2px);
}
.indent-collapse {
    position: absolute;
    color: #a1a3a5;
    transform: translateX(1px) translateY(12px);
}
.cell-input {
    display: flex;
}
.cell-wrapper {
    position: relative;
    width: 100%;
}
.cell-divider-left-0 {
    content: '';
    position: absolute;
    height: 6px;
    bottom: 0px;
    left: 3px;
    width: 3px;
    background-image: radial-gradient(circle, #a1a3a5 1px, transparent 1px);
    background-size: 3px 3px;
}
.cell-text-clip {
    overflow: hidden;
    max-height: 100%;
    /* текст, не влезший в ячейку, заканчивается «…» — как в ссылочных ячейках.
       Ячейка с оверлеями живёт с overflow:visible, обрезка идёт здесь, и без
       text-overflow текст просто уходил под соседнюю колонку без признака */
    text-overflow: ellipsis;
}
/* IE 2026 08 20 / ODOO-5512 (заказ Игоря): tree_frame='L' — Г-образная рамка
   группы подчинённых (сплошная вертикаль + скруглённый угол + горизонталь под
   последней строкой, как окантовка карточек) вместо пунктирных вертикалей */
/* IE 2026 08 27 / ODOO-5800 (Igor): треугольник свёртки — ПОВЕРХ линий рамки дерева (выше z-order),
   линии-оверлеи — под ним */
/* IE 2026 08 28 / ODOO-5828 (скрин Игоря: «+» группы колонок поверх замороженных колонок при
   h-скролле): правило было на ЛЮБУЮ .wj-cell — глиф свёртки ГРУППЫ КОЛОНОК в шапке (z:2) вылезал
   над frozen-ячейкой шапки (у wijmo z:1), когда частично прокрученная широкая группа заезжала под
   замороженную зону. Замысел (глиф поверх линий рамки ДЕРЕВА) касается только tree-ячеек данных —
   сужаем; глиф шапки групп возвращается к штатному z-порядку wijmo (под frozen). */
.wj-cell.tree-cell .wj-elem-collapse, .wj-cell.tree-cell .wj-elem-collapse-space { position: relative; z-index: 2; } /* IE 2026 08 27: глиф может быть вложен — потомок, не прямой ребёнок */
/* IE 2026 08 27 / ODOO-5800 (Igor: клик по треугольнику попадал в оверлей линии и открывал редактор):
   линии-оверлеи — чисто декоративные, мышь сквозь них проходит к глифу/ячейке */
.cell-frame-left, .cell-frame-left-start, .cell-frame-top-corner, .cell-frame-corner, .cell-frame-bottom,
.cell-divider-left, .cell-divider-left-0, .cell-delivery-top-border, .cell-delivery-top,
.cell-delivery-left-border, .cell-delivery-left { pointer-events: none; }
.cell-frame-left, .cell-frame-left-start, .cell-frame-top-corner, .cell-frame-corner, .cell-frame-bottom { z-index: 1; }
.cell-frame-left {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 0;
    border-left: 1px solid var(--surface-border, #d7d7e0);
}
.cell-frame-left-start {
    /* IE 2026 08 27 / ODOO-5800: верх — inline (низ дуги под треугольником), низ — край строки */
    top: auto;
    bottom: 0;
}
/* IE 2026 08 27 / ODOO-5800 (заказ Игоря): дуга стыка «треугольник → ствол»:
   верх+лево со скруглением, размер и радиус — inline по промеру глифа */
.cell-frame-top-corner {
    position: absolute;
    border-left: 1px solid var(--surface-border, #d7d7e0);
    border-top: 1px solid var(--surface-border, #d7d7e0);
}
.cell-frame-corner {
    position: absolute;
    bottom: 0;
    width: 7px;
    height: 7px;
    border-left: 1px solid var(--surface-border, #d7d7e0);
    border-bottom: 1px solid var(--surface-border, #d7d7e0);
    border-bottom-left-radius: 7px;
}
.cell-frame-bottom {
    position: absolute;
    bottom: 0;
    right: 2px;
    height: 0;
    border-bottom: 1px solid var(--surface-border, #d7d7e0);
}
.cell-divider-left {
    content: '';
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 3px;
    width: 3px;
    background-image: radial-gradient(circle, #a1a3a5 1px, transparent 1px);
    background-size: 3px 3px;
}
.border-bottom {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0px;
    right: 0;
    height: 1px;
    background-color: rgba(0, 0, 0, 0.1);
}
/* IE 2026 08 20 (заказ Игоря): свойство таблицы Borders=None — убирает нижние
   бордюры ячеек и линии-оверлеи строк дерева; пунктирные рамки групп
   подчинённых (cell-divider-left и секционные пунктиры) сохраняются */
.grid-borders-none .wj-cells .wj-cell,
.grid-borders-none .wj-rowheaders .wj-cell {
    border-bottom: none;
}
.grid-borders-none .wj-cell .border-bottom {
    display: none;
}
.cell-text-wrapper {
    display: block;
    white-space: nowrap;
    overflow: hidden;
}

.code-text {
    white-space: pre;
    font-family: monospace;
    border-bottom: none !important;
    border-left: 1px solid rgba(0, 0, 0, 0.1) !important;
}

.wj-flexgrid .wj-cell .wj-btn.wj-btn-glyph:not(.wj-elem-collapse) {
    display: none;
}

/* IE 2026 09 17 / ODOO-… (заказ Игоря): вариант разрыва со стрелкой — знак направления в самом
   зазоре, на каждой строке (виден рядом со значениями, шапку читать не нужно) */
.break-arrow {
    position: absolute;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    line-height: 1;
    color: var(--text-color-secondary, #6c757d);
    opacity: .75;
    pointer-events: none;
    user-select: none;
}
/* IE 2026 09 29 / ODOO-343343 (заказ Игоря: начало плана штриховкой): штриховка плана — рисунок штриховки серий графика (шаг 7, штрих 2, подложка 10 %), цвет — токен --plan-start-color (App.vue) */
/* IE 2026 09 30 / ODOO-343343 (заказ Игоря: штриховка начала плана — одним элементом): в теле — одна полоса на грид (planStart_band), фон-градиент тот же, что у маски шапки */
/* IE 2026 09 30 / ODOO-343343 (заказ Игоря: штриховка начала плана — белый фон, одна капсула с рамкой): полоса — нижняя часть КАПСУЛЫ (верх — маска шапки с флажком): ровный белый фон, рамка 1 px (приглушённый --plan-start-color), скругление 4 px,
   внутренний отступ 2 px до штрихов; штрихи — слой с clip content-box, белая подложка — padding-box, начало рисунка — border-box (общее с маской шапки) */
.plan-start-band-el {   /* IE 2026 09 30 / ODOO-343343 (заказ Игоря: элемент Plan start одинаковый во всех формах): вид (рамка, скругление, отступ, фон) — общие классы .ps-cap / .ps-cap-bottom в App.vue */
    position: absolute;
    z-index: 1;
    pointer-events: none;
}
.plan-start-band-el[data-frozen="1"] { z-index: 2; }   /* зазор внутри замороженных колонок — поверх клона замороженных */
/* IE 2026 09 30 / ODOO-343343 (заказ Игоря: элемент Plan start одинаковый во всех формах): маска шапки — верх капсулы, вид — общие классы .ps-cap / .ps-cap-top / .ps-flag в App.vue */
/* IE 2026 09 17 (замечание Игоря): знак — псевдоэлементом, чтобы не попадать в текст ячейки */
.break-arrow::before { content: '\2192'; }
.break-arrow.break-arrow-l::before { content: '\2190'; }
.break-arrow.break-arrow-b::before { content: '\2194'; }
/* IE 2026 09 20 / ODOO-5800 (Igor 20.09: «показывай двойную стрелку вправо перед полем sales_country … с разделителем перед колонкой и двойной стрелочкой перед ним в списках правил и в формах их элементов») */
.break-arrow.break-arrow-d::before { content: '\21D2'; font-size: 14px; }
.wj-cell.break-arrow-cell .cell-delivery-left-border { display: none; }
.cell-delivery-left-border {
    content: '';
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 3px;
    width: 3px;
    background-image: radial-gradient(circle, #eeeeee 1px, transparent 1px);
    background-size: 3px 3px;
}
.cell-delivery-top {
    background: white;
    position: absolute;
    left: 0;
    right: 0px;
}
.cell-delivery-left-0 {
    background: white;
    position: absolute;
    top: 0;
    bottom: 0;
}
.cell-delivery-left {
    background: white;
    position: absolute;
    top: 0;
    bottom: 0;
}
.cell-delivery-top-border {
    content: '';
    position: absolute;
    top: -9px;
    left: 0px;
    right: 0px;
    height: 3px;
    background-image: radial-gradient(circle, #a1a3a5 1px, transparent 1px);
    background-size: 3px 3px;
}
.grid-mask-left {
    position: absolute;
    top: 0;
    left: 0;
    width: 120px;
    height: 100%;
    background: white;
    pointer-events: none;
    z-index: 0;
}
.color-transparent {
    color: transparent !important;
}
.sticky-scroll {
    font-weight: bold;
}
/* липкая строка-заголовок групп при прокрутке: красим серым как строку номеров
   колонок (var --cs-header-bg / дефолтный header-grey) и убираем ложную оранжевую
   индикацию «строка выделена» (border-bottom/box-shadow от wj-state-multi-selected).
   brightness(94%) — схемонезависимый контраст: в схемах, где --cs-header-bg белый
   (style2o и т.п.), полоса рисовалась белым-по-белому и визуально исчезала;
   приглушение как у .head-row отличает полосу от ячеек при ЛЮБОЙ схеме */
.wj-cell.sticky-scroll,
.wj-cell.sticky-scroll.wj-state-multi-selected {
    background: var(--cs-header-bg, #f2f2f2) !important;
    filter: brightness(94%);
    border-bottom: 1px solid var(--cs-header-border, rgba(0,0,0,0.12)) !important;
    box-shadow: none !important;
    text-decoration: none !important;
}
/* тайтл липкой полосы группы: неподвижный оверлей поверх ячеек полосы —
   ячейки скроллятся по X, текст в них дёргался (не переносить текст назад
   в ячейки; см. set_stickyRowsTitle_afterTimeout) */
.sticky-scroll-title {
    position: absolute;
    z-index: 6;
    pointer-events: none;
    display: flex;
    align-items: center;
    /* текст полосы — СЛЕВА, как у групповых строк грида; сам оверлей неподвижен
       (заякорен на хост), горизонтальный скролл его не трогает — не дёргается */
    justify-content: flex-start;
    padding-left: 20px;
    padding-right: 8px;
    overflow: hidden;
    white-space: nowrap;
    font-weight: bold;
    color: var(--primary-color, #5a67d8);
    /* оверлей — сам полоса: не зависит от того, создала ли схема ячейки строки
       (style2o: cellsAtRow=[] — без фона тут сквозила «абракадабра» сырых ячеек) */
    background: var(--cs-header-bg, #f2f2f2);
    filter: brightness(94%);
    border-bottom: 1px solid var(--cs-header-border, rgba(0,0,0,0.12));
}
/* IE 2026 09 09 / ODOO-…: заголовок группы списка в полосе — как в строке группы wijmo: имя поля обычным,
   значение жирным (<b> из groupHeaderFormat) */
.sticky-scroll-title .sticky-scroll-group { font-weight: normal; }
.sticky-scroll-title .sticky-scroll-group b { font-weight: bold; }
/* IE 2026 09 09 / ODOO-… (заказ Игоря): перетаскивание строк при зажатом Alt — подсветка места падения (rowDrag_render):
   рамка группы-приёмника (родитель + потомки, как выделенная группа в списке), линия вставки между строками,
   призрак с перечнем строк и подсказкой у курсора */
body.row-drag-active, body.row-drag-active * { cursor: grabbing !important; user-select: none !important; }
.row-drag-group {
    position: absolute;
    z-index: 7;
    pointer-events: none;
    box-sizing: border-box;
    border: 2px solid var(--cs-accent, #6477ef);
    border-radius: 8px;
    background: rgba(100, 118, 239, .07);
}
.row-drag-group.row-drag-into { background: rgba(100, 118, 239, .14); }
.row-drag-line {
    position: absolute;
    z-index: 8;
    pointer-events: none;
    height: 2px;
    background: var(--cs-accent, #6477ef);
    border-radius: 1px;
}
.row-drag-line::before {
    content: '';
    position: absolute;
    left: -5px;
    top: -3px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: inherit;
}
.row-drag-group.row-drag-invalid { border-color: #e24c4c; background: rgba(226, 76, 76, .08); }
.row-drag-line.row-drag-invalid { background: #e24c4c; }
.row-drag-ghost {
    position: fixed;
    z-index: 3000;
    pointer-events: none;
    max-width: 380px;
    padding: 6px 10px;
    border-radius: 8px;
    background: var(--surface-card, #fff);
    color: var(--text-color, #212529);
    border: 1px solid var(--cs-accent, #6477ef);
    box-shadow: 0 6px 22px rgba(0, 0, 0, .22);
    font-size: .85rem;
    line-height: 1.3;
}
.row-drag-ghost .rdg-rows > div { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.row-drag-ghost .rdg-more { color: var(--text-color-secondary, #6c757d); }
.row-drag-ghost .rdg-hint {
    margin-top: 4px;
    padding-top: 4px;
    border-top: 1px solid rgba(100, 118, 239, .3);
    color: var(--cs-accent, #6477ef);
    font-weight: 600;
    white-space: nowrap;
}
.row-drag-ghost.rdg-invalid .rdg-hint { color: #e24c4c; }

.wj-colheaders .wj-glyph-filter {
    opacity: 0;
    transition: opacity 0.2s ease;
}
.wj-colheaders:hover .wj-glyph-filter {
    opacity: 1;
}

.wj-cell.wj-has-notes:after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    border-width: 0 10px 10px 0;
    border-style: solid;
    border-color: transparent #f39c12 transparent transparent;
    opacity: 0.5;
}

.wj-cell.wj-has-notes:hover:after {
    opacity: 1;
}

.wj-cell.checkbox {
    justify-content: center;
}
/* IE 2026 10 14 / ODOO-5800 (Igor; бот dev02 ui_partial_flag: в замороженной колонке «Затверджено ПМ» полузаполненный чекбокс не виден — видимый слой там клон wijmo
   .wj-frozen-clone, а на recycle-обновлениях (_updateFrozenCells) wijmo копирует в клон ТОЛЬКО className, содержимое ячейки не трогает; cloneNode к тому же не несёт
   свойство indeterminate): состояние «частично» рисует CSS по классу ячейки approval-partial (ставит approvalFlagPartial_apply, в клон попадает всегда) — квадрат
   13 px как у нативного чекбокса строк (wj-cell-check), левая половина залита, по центру ячейки; сам input (если есть) прозрачен, клик и клавиатура — как раньше.
   Тёмная тема — filter: invert(1) на всё приложение, отдельных цветов не нужно. Подсказка «Approved partially: N of M» — cellTooltip_html, как была */
.wj-cell.approval-partial::before {   /* IE 2026 10 14 / ODOO-5800 */
    content: '';   /* IE 2026 10 14 / ODOO-5800 */
    position: absolute;   /* IE 2026 10 14 / ODOO-5800 */
    left: 50%;   /* IE 2026 10 14 / ODOO-5800 */
    top: 50%;   /* IE 2026 10 14 / ODOO-5800 */
    width: 13px;   /* IE 2026 10 14 / ODOO-5800 */
    height: 13px;   /* IE 2026 10 14 / ODOO-5800 */
    box-sizing: border-box;   /* IE 2026 10 14 / ODOO-5800 */
    transform: translate(-50%, -50%);   /* IE 2026 10 14 / ODOO-5800 */
    border: 1px solid #767676;   /* IE 2026 10 14 / ODOO-5800: рамка нативного чекбокса Chrome */
    border-radius: 2px;   /* IE 2026 10 14 / ODOO-5800 */
    background: linear-gradient(to right, var(--approval-partial-fill, #1a73e8) 0, var(--approval-partial-fill, #1a73e8) 50%, var(--surface-card, #fff) 50%);   /* IE 2026 10 14 / ODOO-5800: левая половина залита */
    pointer-events: none;   /* IE 2026 10 14 / ODOO-5800 */
    z-index: 1;   /* IE 2026 10 14 / ODOO-5800 */
}   /* IE 2026 10 14 / ODOO-5800 */
.wj-cell.approval-partial input[type=checkbox] {   /* IE 2026 10 14 / ODOO-5800: нативный input остаётся для клика / клавиатуры, рисует CSS выше */
    opacity: 0;   /* IE 2026 10 14 / ODOO-5800 */
}   /* IE 2026 10 14 / ODOO-5800 */
.wj-flexgrid .wj-cell label input[type=checkbox] {
    margin: 0;
}

.border-top-double {
    border-top-width: 2px !important;
    border-top-style: double !important;
    border-top-color: #96abb4 !important;
}
.border-bottom-double {
    border-bottom-width: 2px !important;
    border-bottom-style: double !important;
    border-bottom-color: #96abb4 !important;
}

.change-up:after {
    color: #00800080;
    content: '\25b2';
}
.change-down:after {
    color: #ff000080;
    content: '\25bc';
}
.align-center {
    display: flex;
    align-items: center;
    justify-content: center;
}
.wj-flexgrid.no-style .wj-cell {
  border: unset;
}
/* IE 2026 08 30 / ODOO-5800 (заказ Игоря): подсветка заголовков колонок-ресурсов.
   Общие cell-background-* в шапке не работают — её собственный фон перебивает их
   по специфичности, поэтому у подсветки заголовка свои классы и свои правила. */
.wj-cell.wj-header.hdr-tint-runs { background-color: #efe3c3 !important; }
.wj-cell.wj-header.hdr-tint-rows { background-color: #d6e8d5 !important; }

.wj-cell .num-inner {
  display: inline-block;
  min-width: 70px;  /* фиксированная зона для числа */
  text-align: right;
  font-variant-numeric: tabular-nums;
}

/* Blocked supply — диагональная штриховка */
.cell-blocked {
    background: repeating-linear-gradient(
        -45deg,
        transparent,
        transparent 4px,
        rgba(220, 38, 38, 0.12) 4px,
        rgba(220, 38, 38, 0.12) 8px
    );
}

/* Вариант с точечным паттерном — менее агрессивный */
.cell-blocked-dots {
    background-image: radial-gradient(circle, rgba(220, 38, 38, 0.2) 2px, transparent 2px);
    background-size: 8px 8px;
}

/* AttrJSON / AttrCSS cell badge & preview */
.cell-code-badge {
    display: inline-block;
    font-size: 9px;
    padding: 1px 4px;
    border-radius: 2px;
    font-weight: 700;
    letter-spacing: 0.03em;
    vertical-align: middle;
    margin-right: 4px;
    line-height: 14px;
}
.cell-code-badge-json { background: #dbeafe; color: #1d4ed8; }
.cell-code-badge-css  { background: #fef3c7; color: #92400e; }
/* IE 2026 10 18 / ODOO-347310: ссылка в систему-источник и миниатюра изображения в ячейке */
.wj-cell a.cell-source-link { display: inline-flex; align-items: center; gap: 4px; color: var(--primary-color, #2563eb); text-decoration: none; max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.wj-cell a.cell-source-link:hover { text-decoration: underline; }
.wj-cell a.cell-source-link .pi { font-size: 0.8em; }
.wj-cell img.cell-thumb { height: calc(100% - 2px); max-height: 64px; max-width: 100%; object-fit: contain; vertical-align: middle; cursor: zoom-in; border-radius: 3px; }
/* колонка-превью оформления (formatPreview): образец значения в ячейке */
/* мини-ячейка: воспроизводит ячейку рабочей таблицы (бордюр как линия сетки,
   внутренний паддинг — текст не касается бордюра); к ней применяются cssClass/style */
.format-preview-box {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;       /* надёжный вертикальный центр одной строки образца */
    padding: 1px 5px;          /* + чуть вертикального воздуха, текст не касается рамки */
    border: 1px solid #d6d6d6;
    border-radius: 2px;
    overflow: hidden;
    background-clip: padding-box;
    /* пропорционально уменьшаем мини-ячейку до 90% (центр) — отступ от границ
       грид-ячейки со всех сторон, образец не упирается в них */
    transform: scale(0.9);
}
.format-preview-sample {
    display: block;
    width: 100%;
    max-width: 100%;
    line-height: 1.15;         /* плотная строка — образец не вылезает снизу за рамку */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.cell-code-preview {
    color: #555;
    font-size: 11px;
    font-family: monospace;
    vertical-align: middle;
}
/* задача 17: неактивный пункт actionMenu (например Restore default sizes без изменений) */
.menu-item-disabled {
    opacity: 0.45;
    cursor: default;
    pointer-events: none;
}
.fe-selected-check {
    appearance: none;
    -webkit-appearance: none;
    width: 7px;
    height: 14px;
    border: 1.5px solid rgba(0, 0, 0, 0.22);
    border-radius: 2px;
    cursor: pointer;
    margin: 0;
    flex-shrink: 0;
    transition: background-color 0.1s, border-color 0.1s;
}
.fe-selected-check:checked {
    background-color: #ff8a00;
    border-color: #ff8a00;
}
.fe-selected-check:indeterminate {
    background-color: #ff8a00;
    border-color: #ff8a00;
    opacity: 0.5;
}
/* история Undo/Redo (выпадающий список последних действий) */
.history-menu-overlay {
    position: fixed;
    inset: 0;
    z-index: 1299;
    background: transparent;
}
.history-menu {
    position: fixed;
    z-index: 1300;
    min-width: 240px;
    max-width: 420px;
    background: #fff;
    border: 1px solid #ccd;
    border-radius: 6px;
    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.22);
    padding: 4px 0;
    font-size: 12px;
    max-height: 60vh;
    overflow-y: auto;
}
.history-menu-title {
    font-weight: 600;
    padding: 4px 12px 6px;
    color: #445;
    border-bottom: 1px solid #eef;
}
.history-menu-item {
    display: flex;
    align-items: baseline;
    gap: 8px;
    padding: 4px 12px;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
}
.history-menu-item-hl {
    background: #e8f0fe;
}
.history-menu-num {
    color: #99a;
    font-size: 10px;
    min-width: 14px;
    text-align: right;
}
.history-menu-label {
    overflow: hidden;
    text-overflow: ellipsis;
}
.history-menu-hint {
    padding: 5px 12px 3px;
    color: #778;
    font-size: 11px;
    border-top: 1px solid #eef;
}
.cp-item-wrap .history-caret {
    font-size: 9px;
    padding-left: 0;
    margin-left: -6px;
}
/* IE 2026 08 15 / ODOO-4997: отрицательные значения датных ячеек — красный
   шрифт. IE 2026 08 19 / ODOO-5512: и внутри выделения тоже — фон выделения
   нейтральный (задача 19), контраст не страдает, а формат внутри рамки
   выделения меняться не должен (заказ Игоря) */
.wj-cell.cell-neg-value {
    color: #c62828 !important;
}
/* IE 2026 09 14 / ODOO-5800 (заказ Игоря): ячейки, влияющие на выбранную — база (синий), прибавляемые (зелёный, «+»),
   вычитаемые (красный, «−»); формула под ячейкой */
/* IE 2026 09 17 / ODOO-… (заказ Игоря): значение занимает пустые колонки слева — текст выводится влево на их ширину */
/* IE 2026 09 17 / ODOO-… (заказ Игоря, merge «назад»): значение объединения в его корне — span (mergeBack_apply) */
.wj-cell > .merge-back-value, .wj-cell > .cell-text-clip > .merge-back-value { margin-left: 2px; }
/* IE 2026 09 18 / ODOO-5800: значение объединения — пилюля (STATUS* / GRADE): по центру строки, высоту строки не меняет */
.wj-cell .merge-back-value.status-chip { vertical-align: middle; margin-left: 0; transform-origin: left center; flex: 0 1 auto; min-width: 0; padding: 0 6px; }
.wj-cell.merge-back-chip > .cell-text-clip { display: flex; align-items: center; }
/* IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — FE1-gcss FE1: ссылки на людей в списках единиц */
.appr-user-link { color: #3558c7; cursor: pointer; }
/* IE 2026 10 10 / ODOO-345618: колонка Responsible — основной ответственный ссылкой, «+N» */
.resp-user-link { color: #3558c7; cursor: pointer; }
.resp-user-link:hover { text-decoration: underline; }
.resp-user-more { color: #6b7a86; }
.appr-user-link:hover { text-decoration: underline; }
.appr-user-more { color: #6b7a86; }
/* IE 2026 10 09 / ODOO-345618 (заказ Игоря: согласование на сегменте): пилюля статуса согласования и счётчик «утверждено / всего» после заголовка строки-группы (approvalPill_apply).
   Пилюля — штатная .status-chip (цвет — cell-background-*), ширина у надписей не меняется ни при наведении, ни при фокусе */
.wj-cell .appr-pill { vertical-align: middle; margin-left: 6px; transform-origin: left center; flex: 0 1 auto; min-width: 0; padding: 0 7px; cursor: default; }
.wj-cell .appr-count { vertical-align: middle; margin-left: 4px; font-size: 11px; line-height: 16px; color: #6b7a86; white-space: nowrap; font-variant-numeric: tabular-nums; }
.wj-cell .appr-count.is-done { color: #2f6b3a; }
/* IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — M2-1: ячейка, закрытая согласованием (approvalClosed_paint): серая заливка вместо персиковой «редактируемой» (.wj-cell.editable, python-хук отчёта)
   и обычный курсор. Специфичность выше .editable (0,2,0) и его варианта в выделенном диапазоне (0,4,0); без !important — заливка правил условного оформления (cell-background-* с !important) остаётся главнее */
.wj-cell.appr-closed.appr-closed { background-color: #e6e8ea; cursor: default; }
.wj-cells .wj-cell.wj-state-multi-selected.appr-closed.appr-closed { background-color: #e6e8ea; }
/* IE 2026 10 18 / ODOO-5800 (Igor, п. 5: отчёты планов по уровням; палитра Игоря): классы ячеек по мете плана (utils/planLevels.js, AttrGrid.planCell_paint) — ставятся классом, потому видны
   и в клоне замороженных колонок wijmo (.wj-frozen-clone копирует className), как approval-partial выше. plan-manual — синий треугольник в правом верхнем углу (ручная корректировка);
   заливки статуса единицы: к утверждению — светло-янтарный, утверждено — светло-зелёный, возвращено / аннулировано — янтарный с оранжевой рамкой, заморожено — серый; вне окна — без фона.
   Двойной класс — приоритет над раскраской строк / условным оформлением, как у appr-closed. Тёмная тема — filter: invert(1) на всё приложение */
.wj-cell.plan-manual::after {   /* IE 2026 10 18 / ODOO-5800 */
    content: '';   /* IE 2026 10 18 / ODOO-5800 */
    position: absolute;   /* IE 2026 10 18 / ODOO-5800 */
    right: 0;   /* IE 2026 10 18 / ODOO-5800 */
    top: 0;   /* IE 2026 10 18 / ODOO-5800 */
    width: 0;   /* IE 2026 10 18 / ODOO-5800 */
    height: 0;   /* IE 2026 10 18 / ODOO-5800 */
    border-style: solid;   /* IE 2026 10 18 / ODOO-5800 */
    border-width: 0 9px 9px 0;   /* IE 2026 10 18 / ODOO-5800 */
    border-color: transparent #2a5db0 transparent transparent;   /* IE 2026 10 18 / ODOO-5800: синий маркер ручной корректировки */
    pointer-events: none;   /* IE 2026 10 18 / ODOO-5800 */
    z-index: 1;   /* IE 2026 10 18 / ODOO-5800 */
}   /* IE 2026 10 18 / ODOO-5800 */
.wj-cell.plan-draft.plan-draft { background-color: #FFF4D6; }   /* IE 2026 10 18 / ODOO-5800: к утверждению */
.wj-cell.plan-approved.plan-approved { background-color: #E6F4EC; }   /* IE 2026 10 18 / ODOO-5800: утверждено */
.wj-cell.plan-returned.plan-returned { background-color: #FFE8C2; box-shadow: inset 0 0 0 1px #E8842A; }   /* IE 2026 10 18 / ODOO-5800: возвращено / аннулировано — янтарный с оранжевой рамкой */
.wj-cell.plan-locked.plan-locked { background-color: #F3F4F7; }   /* IE 2026 10 18 / ODOO-5800: заморожено */
/* IE 2026 10 19 / ODOO-5800 (Igor 19.10, уровень КАМ): база строки пересеяна после правки КАМ (plan-base-changed, planLevels.js) — оранжевая пунктирная рамка, подсказка «Base changed after your adjustment» (title ячейки) */
.wj-cell.plan-base-changed.plan-base-changed { box-shadow: inset 0 0 0 2px #E8842A; }   /* IE 2026 10 19 / ODOO-5800 */
.wj-cell.plan-base-changed.plan-base-changed::before { content: ''; position: absolute; left: 0; bottom: 0; width: 0; height: 0; border-style: solid; border-width: 9px 0 0 9px; border-color: transparent transparent transparent #E8842A; pointer-events: none; z-index: 1; }   /* IE 2026 10 19 / ODOO-5800: оранжевый уголок слева внизу */
/* IE 2026 10 18 / ODOO-5800: полоса горизонта вверху заголовка колонки (AttrGrid.planHeader_paint): тактический — синяя, стратегический — сиреневая */
.wj-cell.wj-header.plan-horizon-tactical::before, .wj-cell.wj-header.plan-horizon-strategic::before {   /* IE 2026 10 18 / ODOO-5800 */
    content: '';   /* IE 2026 10 18 / ODOO-5800 */
    position: absolute;   /* IE 2026 10 18 / ODOO-5800 */
    left: 0;   /* IE 2026 10 18 / ODOO-5800 */
    right: 0;   /* IE 2026 10 18 / ODOO-5800 */
    top: 0;   /* IE 2026 10 18 / ODOO-5800 */
    height: 3px;   /* IE 2026 10 18 / ODOO-5800 */
    pointer-events: none;   /* IE 2026 10 18 / ODOO-5800 */
}   /* IE 2026 10 18 / ODOO-5800 */
.wj-cell.wj-header.plan-horizon-tactical::before { background: #2a5db0; }   /* IE 2026 10 18 / ODOO-5800 */
.wj-cell.wj-header.plan-horizon-strategic::before { background: #8e6cc7; }   /* IE 2026 10 18 / ODOO-5800 */
/* IE 2026 10 18 / ODOO-5800: чипы статуса по горизонтам в заголовке строки (AttrGrid.planChips_apply; _DLRow.status_chips) — после текста, перед кнопкой формы ячейки */
.wj-cell .plan-chips { display: inline-flex; gap: 3px; margin-left: 6px; vertical-align: middle; }   /* IE 2026 10 18 / ODOO-5800 */
/* IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B): пилюля решения строки плана ЗП / DO и цвет кнопки «Plan approval» шапки (тон — худший state сводки) */
.wj-cell .pa-pill { vertical-align: middle; margin-left: 6px; padding: 0 7px; font-size: 11px; line-height: 16px; border-radius: 8px; cursor: default; white-space: nowrap; }
/* IE 2026 11 03 / ODOO-5800 (ie-dm7 #128579: согласование правил MAP-*, этап C): пилюля статуса правила (ra-pill) и кнопка сводки «Approval» (ra-btn): тона по статусам statusRule-* */
.wj-cell .ra-pill { vertical-align: middle; margin-right: 6px; padding: 0 7px; font-size: 11px; line-height: 16px; border-radius: 8px; cursor: default; white-space: nowrap; }   /* IE 2026 11 03 / ODOO-5800 (ie-dm7 #128579: согласование правил MAP-*, этап C — правки пробы p246): пилюля перед текстом — отступ справа */
.ra-pill .ra-changed { font-size: 10px; margin-right: 3px; }
.ra-pill.ra-tone-pending, .ra-cnt.ra-tone-pending { background: color-mix(in srgb, #8a8f98 16%, var(--surface-card, #fff)); color: color-mix(in srgb, #5b6069 90%, var(--text-color, #000)); }
.ra-pill.ra-tone-approved, .ra-cnt.ra-tone-approved { background: color-mix(in srgb, #22a04b 14%, var(--surface-card, #fff)); color: color-mix(in srgb, #22a04b 75%, var(--text-color, #000)); }
.ra-pill.ra-tone-changed, .ra-cnt.ra-tone-changed { background: color-mix(in srgb, #e09a00 16%, var(--surface-card, #fff)); color: color-mix(in srgb, #b06f00 85%, var(--text-color, #000)); }
.ra-pill.ra-tone-rejected, .ra-cnt.ra-tone-rejected { background: color-mix(in srgb, #d23b3b 14%, var(--surface-card, #fff)); color: color-mix(in srgb, #d23b3b 80%, var(--text-color, #000)); }
.ra-hdr { display: inline-flex; align-items: center; gap: 4px; white-space: nowrap; }
.ra-hdr .ra-cnt { display: inline-block; min-width: 16px; padding: 0 5px; border-radius: 8px; font-size: 11px; line-height: 16px; text-align: center; }
.ra-hdr .ra-hdr-caret { font-size: 10px; }
.p-button.ra-btn.ra-tone-approved { color: #22a04b; }
.p-button.ra-btn.ra-tone-changed { color: #b06f00; }
.p-button.ra-btn.ra-tone-rejected { color: #d23b3b; }
.wj-cell .pa-pill .pa-lock { font-size: 10px; margin-right: 3px; }
.pa-pill.pa-tone-processed, .p-button.pa-btn.pa-tone-processed { background: color-mix(in srgb, var(--cs-pa-processed, #3f5bd8) 14%, var(--surface-card, #fff)); color: var(--cs-pa-processed-fg, color-mix(in srgb, var(--cs-pa-processed, #3f5bd8) 80%, var(--text-color, #000))); border-color: var(--cs-pa-processed-border, color-mix(in srgb, var(--cs-pa-processed, #3f5bd8) 40%, transparent)); }   /* IE 2026 11 03 / ODOO-5800 (заказ Игоря 03.11: «Сделай более лаконичный заголовок или иконку. Для формы меню утверждения»): цвета пилюли / кнопки — токенами с запасом: подложка смешивается с фоном карточки (в тёмной теме не белая) */
.pa-pill.pa-tone-approved, .p-button.pa-btn.pa-tone-approved { background: color-mix(in srgb, var(--cs-pa-approved, #22a04b) 14%, var(--surface-card, #fff)); color: var(--cs-pa-approved-fg, color-mix(in srgb, var(--cs-pa-approved, #22a04b) 80%, var(--text-color, #000))); border-color: var(--cs-pa-approved-border, color-mix(in srgb, var(--cs-pa-approved, #22a04b) 40%, transparent)); }
.pa-pill.pa-tone-changed, .p-button.pa-btn.pa-tone-changed { background: color-mix(in srgb, var(--cs-pa-changed, #e09a00) 14%, var(--surface-card, #fff)); color: var(--cs-pa-changed-fg, color-mix(in srgb, var(--cs-pa-changed, #e09a00) 80%, var(--text-color, #000))); border-color: var(--cs-pa-changed-border, color-mix(in srgb, var(--cs-pa-changed, #e09a00) 40%, transparent)); }
.pa-pill.pa-tone-withdrawn, .p-button.pa-btn.pa-tone-withdrawn { background: color-mix(in srgb, var(--cs-pa-withdrawn, #d23b3b) 14%, var(--surface-card, #fff)); color: var(--cs-pa-withdrawn-fg, color-mix(in srgb, var(--cs-pa-withdrawn, #d23b3b) 80%, var(--text-color, #000))); border-color: var(--cs-pa-withdrawn-border, color-mix(in srgb, var(--cs-pa-withdrawn, #d23b3b) 40%, transparent)); }
.wj-cell .plan-chip.status-chip { display: inline-block; height: 15px; line-height: 15px; font-size: 10px; padding: 0 6px; border-radius: 8px; background: #eef0f3; color: #3a3f47; border: 1px solid #d5d9e0; white-space: nowrap; transform: none; }   /* IE 2026 10 18 / ODOO-5800 */
.wj-cell .plan-chip.plan-chip-approved { background: #E6F4EC; border-color: #9fd3b4; }   /* IE 2026 10 18 / ODOO-5800 */
.wj-cell .plan-chip.plan-chip-draft { background: #FFF4D6; border-color: #e8c76b; }   /* IE 2026 10 18 / ODOO-5800 */
.wj-cell .plan-chip.plan-chip-returned { background: #FFE8C2; border-color: #E8842A; }   /* IE 2026 10 18 / ODOO-5800 */
.wj-cell .plan-chip.plan-chip-locked { background: #F3F4F7; border-color: #c9ccd3; color: #6b7280; }   /* IE 2026 10 18 / ODOO-5800 */
/* IE 2026 09 18 / ODOO-5800: пилюля в ячейке ДЕРЕВА (оценка — сама колонка дерева, Balance Pipeline): значок свёртки и пилюля —
   на одной линии по центру строки (значок уезжал к нижней кромке) */
.wj-cell.has-status-chip.tree-cell > .cell-text-clip { display: flex; align-items: center; }
/* IE 2026 09 17 / ODOO-… (замечания Игоря): подчинённые строки строки-алерта (Uncovered, Expired, …) — той же
   краской, что сама строка, но слабее: шапка строки заметнее, значения мягче. Цвет считает фронт
   (alertChild_paint) и кладёт в --alert-child-bg НЕПРОЗРАЧНЫМ — полупрозрачный фон на замороженных
   колонках просвечивает клон (cloneFrozenCells) и текст двоится после горизонтальной прокрутки */
.wj-cell.cell-alert-child { background-color: var(--alert-child-bg, rgb(255, 191, 191)) !important; }
/* IE 2026 09 17 / ODOO-… (заказ Игоря): у ячеек с тем же текстом, что у выбранной, подсвечивается ТЕКСТ —
   ::highlight(cell-match) (App.vue), класс здесь только помечает такие ячейки для сборки диапазонов */
/* IE 2026 09 22 / ODOO-5800 (Igor): ячейки, чьи данные из тех же документов, что и выделенная (спутник doc_ids хвоста doc_links) */
.wj-cell.cell-same-doc-same { box-shadow: inset 0 0 0 2px #7b1fa2; background-color: rgba(123, 31, 162, 0.13) !important; }
.wj-cell.cell-same-doc-anchor { box-shadow: inset 0 0 0 2px #7b1fa2; }
.wj-cell.cell-same-doc-same::after { content: '⧉'; position: absolute; right: 2px; top: 0; font-size: 9px; line-height: 12px; color: #7b1fa2; pointer-events: none; }
/* IE 2026 09 25 / ODOO-5800 (Igor: переходы ‹ › по ячейкам тех же документов из формы ячейки, «не делая их выбранными»): текущая остановка — вспышка
   янтарной рамкой с заливкой поверх фиолетовой рамки «тех же документов»: 90 мс нарастание, ~900 мс удержание, затухание к 1,8 с (SAMEDOC_CUR_MS).
   Фазу задаёт отрицательный animationDelay из sameDocNav_paint — ячейка, перерисованная прокруткой, продолжает, а не мигает заново; transition на
   классе НЕ вешать (wijmo переиспользует элементы ячеек — моргание, см. gt-dup-dim) */
.wj-cell.cell-same-doc-cur { animation: cellSameDocCur 1800ms linear forwards; }
@keyframes cellSameDocCur {
    0%   { box-shadow: inset 0 0 0 3px rgba(255, 111, 0, 0), inset 0 0 0 999px rgba(255, 171, 64, 0); }
    5%   { box-shadow: inset 0 0 0 3px rgba(255, 111, 0, 1), inset 0 0 0 999px rgba(255, 171, 64, .55); }
    55%  { box-shadow: inset 0 0 0 3px rgba(255, 111, 0, 1), inset 0 0 0 999px rgba(255, 171, 64, .55); }
    100% { box-shadow: inset 0 0 0 3px rgba(255, 111, 0, 0), inset 0 0 0 999px rgba(255, 171, 64, 0); }
}
@media (prefers-reduced-motion: reduce) {
    .wj-cell.cell-same-doc-cur { animation: none; box-shadow: inset 0 0 0 3px #ff6f00, inset 0 0 0 999px rgba(255, 171, 64, .35); }
}
.wj-cell.cell-infl-base { box-shadow: inset 0 0 0 2px #1e88e5; background-color: rgba(30, 136, 229, 0.14) !important; }
/* IE 2026 09 18 / ODOO-5800 (Igor): стрелка направления перед значением поля строки (опция Direction поля раскладки):
   ← «от неё» (приход), → «в неё» (расход, запасы); цвет наследуется — строки с заливкой (Uncovered) остаются читаемыми */
.wj-cell.cell-dir-from:not([data-infl])::before { content: '\2190'; position: static; margin-right: 4px; opacity: 0.6; font-weight: 600; }
.wj-cell.cell-dir-to:not([data-infl])::before { content: '\2192'; position: static; margin-right: 4px; opacity: 0.6; font-weight: 600; }
/* IE 2026 09 20 / ODOO-5800 (Igor 20.09: «показывай двойную стрелку вправо перед полем sales_country … с разделителем перед колонкой и двойной стрелочкой перед ним в списках правил и в формах их элементов»):
   ⇒ «куда это можно продать» (возможная страна продажи) — отличается от → «куда едет»; ↔ — для разрыва «в обе стороны» у поля карточки;
   card-break-before — разделитель НАД строкой поля карточки (вариант разрыва break_before поля), высоту строки не меняет */
.wj-cell.cell-dir-to-double:not([data-infl])::before { content: '\21D2'; position: static; margin-right: 4px; opacity: 0.7; font-weight: 600; font-size: 1.1em; }
.wj-cell.cell-dir-both:not([data-infl])::before { content: '\2194'; position: static; margin-right: 4px; opacity: 0.6; font-weight: 600; }
.wj-cell.card-break-before { box-shadow: inset 0 2px 0 0 var(--surface-400, #ced4da); }
/* IE 2026 09 20 / ODOO-5800 (замечание Игоря: «из-за переноса на другую строку, но у ячеек нет двух строк — и текст срезался в область между ячейками»):
   у ячейки с оверлеями (рамка группы — последняя строка группы) содержимое завёрнуто в БЛОЧНЫЙ .cell-text-clip, и блок после строчной стрелки ::before
   уходил на вторую строку — текст вылезал под ячейку (у неё overflow: visible) в зазор между строками. Стрелка такой ячейки рисуется ВНУТРИ обёртки —
   одной строкой со значением (обрезка с «…» как была); у дерева — перед значением, после значка свёртки */
.wj-cell[class*="cell-dir-"]:not([data-infl]):has(> .cell-text-clip)::before { content: none; }
.wj-cell.cell-dir-from:not([data-infl]) > .cell-text-clip::before { content: '\2190'; margin-right: 4px; opacity: 0.6; font-weight: 600; }
.wj-cell.cell-dir-to:not([data-infl]) > .cell-text-clip::before { content: '\2192'; margin-right: 4px; opacity: 0.6; font-weight: 600; }
.wj-cell.cell-dir-to-double:not([data-infl]) > .cell-text-clip::before { content: '\21D2'; margin-right: 4px; opacity: 0.7; font-weight: 600; font-size: 1.1em; }
.wj-cell.cell-dir-both:not([data-infl]) > .cell-text-clip::before { content: '\2194'; margin-right: 4px; opacity: 0.6; font-weight: 600; }
.wj-cell[class*="cell-dir-"]:not([data-infl]) > .cell-text-clip:has(> .wj-elem-collapse, > .wj-elem-collapse-space)::before { content: none; }
.wj-cell.cell-dir-from:not([data-infl]) > .cell-text-clip:has(> .wj-elem-collapse, > .wj-elem-collapse-space) > .merge-back-value::before { content: '\2190'; margin-right: 4px; opacity: 0.6; font-weight: 600; }
.wj-cell.cell-dir-to:not([data-infl]) > .cell-text-clip:has(> .wj-elem-collapse, > .wj-elem-collapse-space) > .merge-back-value::before { content: '\2192'; margin-right: 4px; opacity: 0.6; font-weight: 600; }
/* ::before у .wj-cell делят метки влияния [data-infl] (absolute) — на ячейке с меткой стрелку не рисуем (замечание ie-webscm7) */
.wj-cell.cell-infl-plus { box-shadow: inset 0 0 0 2px #2e7d32; background-color: rgba(46, 125, 50, 0.16) !important; }
.wj-cell.cell-infl-minus { box-shadow: inset 0 0 0 2px #c62828; background-color: rgba(198, 40, 40, 0.16) !important; }
.wj-cell[data-infl]::before { content: attr(data-infl); position: absolute; left: 3px; top: -1px; font-size: 10px; font-weight: 700; opacity: 0.85; }
.wj-cell.cell-infl-plus::before { color: #2e7d32; }
.wj-cell.cell-infl-minus::before { color: #c62828; }
.wj-cell.cell-infl-base::before { color: #1e88e5; }
/* IE 2026 09 16 (замечание Игоря): непокрытый объём — штриховка своего цвета и знак ⊘ (списать / получить нужно, операция невозможна) */
.wj-cell.cell-infl-plus-unc { box-shadow: inset 0 0 0 2px #2e7d32; background-image: repeating-linear-gradient(135deg, rgba(46, 125, 50, 0.22) 0 3px, rgba(46, 125, 50, 0.04) 3px 7px) !important; }
.wj-cell.cell-infl-minus-unc { box-shadow: inset 0 0 0 2px #c62828; background-image: repeating-linear-gradient(135deg, rgba(198, 40, 40, 0.22) 0 3px, rgba(198, 40, 40, 0.04) 3px 7px) !important; }
.wj-cell.cell-infl-plus-unc::before { color: #2e7d32; font-size: 11px; }
.wj-cell.cell-infl-minus-unc::before { color: #c62828; font-size: 11px; }
.infl-formula { position: absolute; z-index: 30; background: #fffbe6; border: 1px solid #f9a825; border-radius: 6px; padding: 2px 8px; font-size: 12px;
    white-space: nowrap; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15); pointer-events: none; color: #37474f; }
.infl-formula.is-critical { background: #fef2f2; border-color: #b91c1c; color: #991b1b; }   /* IE 2026 10 03 / ODOO-5800: расчётный остаток не бьётся с фактическим на границе факта — критическая ошибка (как блок FORMULA формы ячейки) */
/* IE 2026 08 15 / ODOO-4997: столбик Data columns — одинаковая ширина
   (~один символ), слева с отступом 2px, закруглённый верх */
.wj-cell .rs-col-bar {
    position: absolute;
    left: 2px;
    bottom: 0;
    width: 7px;
    border-radius: 3px 3px 0 0;
    pointer-events: none;
}
/* IE 2026 11 03 / ODOO-350449 (заказ Игоря: мягкие разделители разделов и монохром — опции): строки-разделы по fe.ux.sectionStyle (AttrGrid.sec_paint, utils/sectionStyle.js).
   Токены — одна точка (те же значения — SEC_TOKENS); тёмная тема — инверсия всего приложения (App.vue .dark-theme), отдельных значений нет.
   Классы ячеек — под :where(): специфичность одного .wj-flexgrid .wj-cell; слои фона — !important поверх именованного стиля полосы (band-* — 0,5,0) и inline-градиента
   лэйаута; цвет фона ячейки не трогается (непрозрачный фон закреплённой ячейки — inline, см. formatItem). Высота строки не меняется: шрифт подписи — внутри своей строки */
:root {
    --sec-sep: #d3d8de; --sec-sep2: #b8bfc8; --sec-pill: #eef0f3; --sec-pillInk: #4b525d; --sec-tintPlus: hsl(200, 10%, 68%); --sec-tintMinus: hsl(24, 10%, 68%);
    --sec-attn: #d3303e; --sec-attnSoft: #fbe4e6; --sec-attnLine: rgba(211, 48, 62, 0.55); --sec-surface: #ffffff; --sec-ink2: #545b66; --sec-ink3: #878e99;
}
.wj-flexgrid .wj-cell:where(.sec-on) { background-image: var(--sec-img) !important; background-size: var(--sec-size) !important; background-position: var(--sec-pos) !important; background-repeat: no-repeat !important; background-origin: border-box !important; }
.wj-flexgrid .wj-cell:where(.sec-t-hairline, .sec-t-rail) { font-variant-caps: all-small-caps; letter-spacing: .06em; color: var(--sec-ink3) !important; }
.wj-flexgrid .wj-cell:where(.sec-t-pill) { color: var(--sec-pillInk) !important; }
.wj-flexgrid .wj-cell:where(.sec-t-wedge, .sec-t-wave, .sec-t-sign, .sec-t-wave_sign) { color: var(--sec-ink2) !important; }
.wj-flexgrid .wj-cell:where(.sec-k-sign) { font-size: 1.4em; font-weight: 300 !important; }
.wj-flexgrid .wj-cell.wj-cell.wj-cell:where(.sec-k-unc) { color: var(--sec-attn) !important; }   /* 0,4,0 — главнее бордового .row-dl-tab.unc-block-title */
/* IE 2026 11 03 / ODOO-350449 (заказ Игоря: мягкие разделители разделов и монохром — опции): монохром (fe.ux.monochrome, дефолт ВЫКЛ) — «цвет = просьба посмотреть»,
   эскиз separators/sep.html пп. 1–6; флаг-класс ux-mono на хосте грида (sec_tick), в селекторе — только :where(). Порог запаса (п. 4) фронту не известен — заливка зон запаса не меняется */
:root { --sec-ink: #1d2127; --mono-zone: rgba(60, 72, 90, 0.07); --mono-amber: rgba(245, 158, 11, 0.3); }
.wj-flexgrid:where(.ux-mono) .wj-cell.cell-lt { background: var(--mono-zone) !important; }   /* п. 1: голубой lead time → серый тон */
.wj-flexgrid:where(.ux-mono) .wj-cell.cell-rc { background: var(--mono-amber) !important; }   /* п. 2: янтарь repl. cycle бледнее */
.wj-flexgrid:where(.ux-mono) .wj-cell.cell-rc:empty { background: transparent !important; }   /* п. 2: пустая — без заливки */
.wj-flexgrid:where(.ux-mono) .wj-cell > .cell-ring { transform: translate(-50%, -50%) scale(0.7) !important; box-shadow: none !important; outline: none !important; }   /* п. 3: точки мельче, без кольца */
.wj-flexgrid:where(.ux-mono) .wj-marquee.wj-marquee.wj-marquee.wj-marquee.wj-marquee { box-shadow: 0 0 0 1.5px var(--cs-accent, #647eff) !important; }   /* п. 5: рамка — акцент панели; 0,6,0 — главнее sel-frame-* */
.wj-flexgrid:where(.ux-mono) > .wj-marquee-band { display: none !important; }   /* п. 5: линия под строкой выделения — убрана */
.wj-flexgrid .wj-cell.wj-cell.wj-cell:where(.sec-k-pm) { color: var(--sec-ink) !important; }   /* п. 6: «+» / «−» — нейтральные */
</style>
